var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import require$$0$1, { forwardRef, cloneElement, useState, useLayoutEffect, useEffect, useRef, useCallback, useMemo } from "react";
import PropTypes, { oneOfType, string, array, func, bool } from "prop-types";
import axios from "axios";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n2) {
  if (n2.__esModule)
    return n2;
  var a = Object.defineProperty({}, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k) {
    var d3 = Object.getOwnPropertyDescriptor(n2, k);
    Object.defineProperty(a, k, d3.get ? d3 : {
      enumerable: true,
      get: function() {
        return n2[k];
      }
    });
  });
  return a;
}
var lib$1 = { exports: {} };
var Modal$1 = {};
var reactDom = { exports: {} };
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function(target, source) {
  var from3;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from3 = Object(arguments[s]);
    for (var key in from3) {
      if (hasOwnProperty$1.call(from3, key)) {
        to[key] = from3[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from3);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from3, symbols[i])) {
          to[symbols[i]] = from3[symbols[i]];
        }
      }
    }
  }
  return to;
};
var scheduler = { exports: {} };
var scheduler_production_min = {};
/** @license React v0.15.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function(exports) {
  Object.defineProperty(exports, "__esModule", { value: true });
  var d3 = void 0, e = void 0, g2 = void 0, m2 = void 0, n2 = void 0;
  exports.unstable_now = void 0;
  exports.unstable_forceFrameRate = void 0;
  if (typeof window === "undefined" || typeof MessageChannel !== "function") {
    var p2 = null, q2 = null, r2 = function() {
      if (p2 !== null)
        try {
          var a = exports.unstable_now();
          p2(true, a);
          p2 = null;
        } catch (b) {
          throw setTimeout(r2, 0), b;
        }
    };
    exports.unstable_now = function() {
      return Date.now();
    };
    d3 = function(a) {
      p2 !== null ? setTimeout(d3, 0, a) : (p2 = a, setTimeout(r2, 0));
    };
    e = function(a, b) {
      q2 = setTimeout(a, b);
    };
    g2 = function() {
      clearTimeout(q2);
    };
    m2 = function() {
      return false;
    };
    n2 = exports.unstable_forceFrameRate = function() {
    };
  } else {
    var t3 = window.performance, u = window.Date, v = window.setTimeout, w2 = window.clearTimeout, x = window.requestAnimationFrame, y2 = window.cancelAnimationFrame;
    typeof console !== "undefined" && (typeof x !== "function" && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"), typeof y2 !== "function" && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));
    exports.unstable_now = typeof t3 === "object" && typeof t3.now === "function" ? function() {
      return t3.now();
    } : function() {
      return u.now();
    };
    var z = false, A = null, B2 = -1, C = -1, D2 = 33.33, E = -1, F2 = -1, G2 = 0, H2 = false;
    m2 = function() {
      return exports.unstable_now() >= G2;
    };
    n2 = function() {
    };
    exports.unstable_forceFrameRate = function(a) {
      0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : 0 < a ? (D2 = Math.floor(1e3 / a), H2 = true) : (D2 = 33.33, H2 = false);
    };
    var J2 = function() {
      if (A !== null) {
        var a = exports.unstable_now(), b = 0 < G2 - a;
        try {
          A(b, a) || (A = null);
        } catch (c) {
          throw I.postMessage(null), c;
        }
      }
    }, K = new MessageChannel(), I = K.port2;
    K.port1.onmessage = J2;
    var L2 = function(a) {
      if (A === null)
        F2 = E = -1, z = false;
      else {
        z = true;
        x(function(a2) {
          w2(B2);
          L2(a2);
        });
        var b = function() {
          G2 = exports.unstable_now() + D2 / 2;
          J2();
          B2 = v(b, 3 * D2);
        };
        B2 = v(b, 3 * D2);
        if (E !== -1 && 0.1 < a - E) {
          var c = a - E;
          !H2 && F2 !== -1 && c < D2 && F2 < D2 && (D2 = c < F2 ? F2 : c, 8.33 > D2 && (D2 = 8.33));
          F2 = c;
        }
        E = a;
        G2 = a + D2;
        I.postMessage(null);
      }
    };
    d3 = function(a) {
      A = a;
      z || (z = true, x(function(a2) {
        L2(a2);
      }));
    };
    e = function(a, b) {
      C = v(function() {
        a(exports.unstable_now());
      }, b);
    };
    g2 = function() {
      w2(C);
      C = -1;
    };
  }
  var M2 = null, N2 = null, O2 = null, P2 = 3, Q2 = false, R2 = false, S2 = false;
  function T2(a, b) {
    var c = a.next;
    if (c === a)
      M2 = null;
    else {
      a === M2 && (M2 = c);
      var f2 = a.previous;
      f2.next = c;
      c.previous = f2;
    }
    a.next = a.previous = null;
    c = a.callback;
    f2 = P2;
    var l = O2;
    P2 = a.priorityLevel;
    O2 = a;
    try {
      var h = a.expirationTime <= b;
      switch (P2) {
        case 1:
          var k = c(h);
          break;
        case 2:
          k = c(h);
          break;
        case 3:
          k = c(h);
          break;
        case 4:
          k = c(h);
          break;
        case 5:
          k = c(h);
      }
    } catch (Z2) {
      throw Z2;
    } finally {
      P2 = f2, O2 = l;
    }
    if (typeof k === "function")
      if (b = a.expirationTime, a.callback = k, M2 === null)
        M2 = a.next = a.previous = a;
      else {
        k = null;
        h = M2;
        do {
          if (b <= h.expirationTime) {
            k = h;
            break;
          }
          h = h.next;
        } while (h !== M2);
        k === null ? k = M2 : k === M2 && (M2 = a);
        b = k.previous;
        b.next = k.previous = a;
        a.next = k;
        a.previous = b;
      }
  }
  function U2(a) {
    if (N2 !== null && N2.startTime <= a) {
      do {
        var b = N2, c = b.next;
        if (b === c)
          N2 = null;
        else {
          N2 = c;
          var f2 = b.previous;
          f2.next = c;
          c.previous = f2;
        }
        b.next = b.previous = null;
        V2(b, b.expirationTime);
      } while (N2 !== null && N2.startTime <= a);
    }
  }
  function W2(a) {
    S2 = false;
    U2(a);
    R2 || (M2 !== null ? (R2 = true, d3(X2)) : N2 !== null && e(W2, N2.startTime - a));
  }
  function X2(a, b) {
    R2 = false;
    S2 && (S2 = false, g2());
    U2(b);
    Q2 = true;
    try {
      if (!a)
        for (; M2 !== null && M2.expirationTime <= b; )
          T2(M2, b), b = exports.unstable_now(), U2(b);
      else if (M2 !== null) {
        do
          T2(M2, b), b = exports.unstable_now(), U2(b);
        while (M2 !== null && !m2());
      }
      if (M2 !== null)
        return true;
      N2 !== null && e(W2, N2.startTime - b);
      return false;
    } finally {
      Q2 = false;
    }
  }
  function Y2(a) {
    switch (a) {
      case 1:
        return -1;
      case 2:
        return 250;
      case 5:
        return 1073741823;
      case 4:
        return 1e4;
      default:
        return 5e3;
    }
  }
  function V2(a, b) {
    if (M2 === null)
      M2 = a.next = a.previous = a;
    else {
      var c = null, f2 = M2;
      do {
        if (b < f2.expirationTime) {
          c = f2;
          break;
        }
        f2 = f2.next;
      } while (f2 !== M2);
      c === null ? c = M2 : c === M2 && (M2 = a);
      b = c.previous;
      b.next = c.previous = a;
      a.next = c;
      a.previous = b;
    }
  }
  var aa2 = n2;
  exports.unstable_ImmediatePriority = 1;
  exports.unstable_UserBlockingPriority = 2;
  exports.unstable_NormalPriority = 3;
  exports.unstable_IdlePriority = 5;
  exports.unstable_LowPriority = 4;
  exports.unstable_runWithPriority = function(a, b) {
    switch (a) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
        break;
      default:
        a = 3;
    }
    var c = P2;
    P2 = a;
    try {
      return b();
    } finally {
      P2 = c;
    }
  };
  exports.unstable_next = function(a) {
    switch (P2) {
      case 1:
      case 2:
      case 3:
        var b = 3;
        break;
      default:
        b = P2;
    }
    var c = P2;
    P2 = b;
    try {
      return a();
    } finally {
      P2 = c;
    }
  };
  exports.unstable_scheduleCallback = function(a, b, c) {
    var f2 = exports.unstable_now();
    if (typeof c === "object" && c !== null) {
      var l = c.delay;
      l = typeof l === "number" && 0 < l ? f2 + l : f2;
      c = typeof c.timeout === "number" ? c.timeout : Y2(a);
    } else
      c = Y2(a), l = f2;
    c = l + c;
    a = { callback: b, priorityLevel: a, startTime: l, expirationTime: c, next: null, previous: null };
    if (l > f2) {
      c = l;
      if (N2 === null)
        N2 = a.next = a.previous = a;
      else {
        b = null;
        var h = N2;
        do {
          if (c < h.startTime) {
            b = h;
            break;
          }
          h = h.next;
        } while (h !== N2);
        b === null ? b = N2 : b === N2 && (N2 = a);
        c = b.previous;
        c.next = b.previous = a;
        a.next = b;
        a.previous = c;
      }
      M2 === null && N2 === a && (S2 ? g2() : S2 = true, e(W2, l - f2));
    } else
      V2(a, c), R2 || Q2 || (R2 = true, d3(X2));
    return a;
  };
  exports.unstable_cancelCallback = function(a) {
    var b = a.next;
    if (b !== null) {
      if (a === b)
        a === M2 ? M2 = null : a === N2 && (N2 = null);
      else {
        a === M2 ? M2 = b : a === N2 && (N2 = b);
        var c = a.previous;
        c.next = b;
        b.previous = c;
      }
      a.next = a.previous = null;
    }
  };
  exports.unstable_wrapCallback = function(a) {
    var b = P2;
    return function() {
      var c = P2;
      P2 = b;
      try {
        return a.apply(this, arguments);
      } finally {
        P2 = c;
      }
    };
  };
  exports.unstable_getCurrentPriorityLevel = function() {
    return P2;
  };
  exports.unstable_shouldYield = function() {
    var a = exports.unstable_now();
    U2(a);
    return O2 !== null && M2 !== null && M2.startTime <= a && M2.expirationTime < O2.expirationTime || m2();
  };
  exports.unstable_requestPaint = aa2;
  exports.unstable_continueExecution = function() {
    R2 || Q2 || (R2 = true, d3(X2));
  };
  exports.unstable_pauseExecution = function() {
  };
  exports.unstable_getFirstCallbackNode = function() {
    return M2;
  };
})(scheduler_production_min);
{
  scheduler.exports = scheduler_production_min;
}
/** @license React v16.9.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa = require$$0$1, m$1 = objectAssign, q$1 = scheduler.exports;
function t(a) {
  for (var b = a.message, c = "https://reactjs.org/docs/error-decoder.html?invariant=" + b, d3 = 1; d3 < arguments.length; d3++)
    c += "&args[]=" + encodeURIComponent(arguments[d3]);
  a.message = "Minified React error #" + b + "; visit " + c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";
  return a;
}
if (!aa)
  throw t(Error(227));
var ba = null, ca = {};
function da() {
  if (ba)
    for (var a in ca) {
      var b = ca[a], c = ba.indexOf(a);
      if (!(-1 < c))
        throw t(Error(96), a);
      if (!ea[c]) {
        if (!b.extractEvents)
          throw t(Error(97), a);
        ea[c] = b;
        c = b.eventTypes;
        for (var d3 in c) {
          var e = void 0;
          var f2 = c[d3], h = b, g2 = d3;
          if (fa.hasOwnProperty(g2))
            throw t(Error(99), g2);
          fa[g2] = f2;
          var k = f2.phasedRegistrationNames;
          if (k) {
            for (e in k)
              k.hasOwnProperty(e) && ha(k[e], h, g2);
            e = true;
          } else
            f2.registrationName ? (ha(f2.registrationName, h, g2), e = true) : e = false;
          if (!e)
            throw t(Error(98), d3, a);
        }
      }
    }
}
function ha(a, b, c) {
  if (ia[a])
    throw t(Error(100), a);
  ia[a] = b;
  ja[a] = b.eventTypes[c].dependencies;
}
var ea = [], fa = {}, ia = {}, ja = {};
function ka(a, b, c, d3, e, f2, h, g2, k) {
  var l = Array.prototype.slice.call(arguments, 3);
  try {
    b.apply(c, l);
  } catch (n2) {
    this.onError(n2);
  }
}
var la = false, ma = null, na = false, oa = null, pa = { onError: function(a) {
  la = true;
  ma = a;
} };
function qa(a, b, c, d3, e, f2, h, g2, k) {
  la = false;
  ma = null;
  ka.apply(pa, arguments);
}
function ra(a, b, c, d3, e, f2, h, g2, k) {
  qa.apply(this, arguments);
  if (la) {
    if (la) {
      var l = ma;
      la = false;
      ma = null;
    } else
      throw t(Error(198));
    na || (na = true, oa = l);
  }
}
var sa = null, ta = null, va = null;
function wa(a, b, c) {
  var d3 = a.type || "unknown-event";
  a.currentTarget = va(c);
  ra(d3, b, void 0, a);
  a.currentTarget = null;
}
function xa(a, b) {
  if (b == null)
    throw t(Error(30));
  if (a == null)
    return b;
  if (Array.isArray(a)) {
    if (Array.isArray(b))
      return a.push.apply(a, b), a;
    a.push(b);
    return a;
  }
  return Array.isArray(b) ? [a].concat(b) : [a, b];
}
function ya(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var za = null;
function Aa(a) {
  if (a) {
    var b = a._dispatchListeners, c = a._dispatchInstances;
    if (Array.isArray(b))
      for (var d3 = 0; d3 < b.length && !a.isPropagationStopped(); d3++)
        wa(a, b[d3], c[d3]);
    else
      b && wa(a, b, c);
    a._dispatchListeners = null;
    a._dispatchInstances = null;
    a.isPersistent() || a.constructor.release(a);
  }
}
function Ba(a) {
  a !== null && (za = xa(za, a));
  a = za;
  za = null;
  if (a) {
    ya(a, Aa);
    if (za)
      throw t(Error(95));
    if (na)
      throw a = oa, na = false, oa = null, a;
  }
}
var Ca = { injectEventPluginOrder: function(a) {
  if (ba)
    throw t(Error(101));
  ba = Array.prototype.slice.call(a);
  da();
}, injectEventPluginsByName: function(a) {
  var b = false, c;
  for (c in a)
    if (a.hasOwnProperty(c)) {
      var d3 = a[c];
      if (!ca.hasOwnProperty(c) || ca[c] !== d3) {
        if (ca[c])
          throw t(Error(102), c);
        ca[c] = d3;
        b = true;
      }
    }
  b && da();
} };
function Da(a, b) {
  var c = a.stateNode;
  if (!c)
    return null;
  var d3 = sa(c);
  if (!d3)
    return null;
  c = d3[b];
  a:
    switch (b) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
        (d3 = !d3.disabled) || (a = a.type, d3 = !(a === "button" || a === "input" || a === "select" || a === "textarea"));
        a = !d3;
        break a;
      default:
        a = false;
    }
  if (a)
    return null;
  if (c && typeof c !== "function")
    throw t(Error(231), b, typeof c);
  return c;
}
var Ea = Math.random().toString(36).slice(2), Fa = "__reactInternalInstance$" + Ea, Ga = "__reactEventHandlers$" + Ea;
function Ha(a) {
  if (a[Fa])
    return a[Fa];
  for (; !a[Fa]; )
    if (a.parentNode)
      a = a.parentNode;
    else
      return null;
  a = a[Fa];
  return a.tag === 5 || a.tag === 6 ? a : null;
}
function Ia(a) {
  a = a[Fa];
  return !a || a.tag !== 5 && a.tag !== 6 ? null : a;
}
function Ja(a) {
  if (a.tag === 5 || a.tag === 6)
    return a.stateNode;
  throw t(Error(33));
}
function Ka(a) {
  return a[Ga] || null;
}
function La(a) {
  do
    a = a.return;
  while (a && a.tag !== 5);
  return a ? a : null;
}
function Ma(a, b, c) {
  if (b = Da(a, c.dispatchConfig.phasedRegistrationNames[b]))
    c._dispatchListeners = xa(c._dispatchListeners, b), c._dispatchInstances = xa(c._dispatchInstances, a);
}
function Na(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    for (var b = a._targetInst, c = []; b; )
      c.push(b), b = La(b);
    for (b = c.length; 0 < b--; )
      Ma(c[b], "captured", a);
    for (b = 0; b < c.length; b++)
      Ma(c[b], "bubbled", a);
  }
}
function Oa(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Da(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = xa(c._dispatchListeners, b), c._dispatchInstances = xa(c._dispatchInstances, a));
}
function Pa(a) {
  a && a.dispatchConfig.registrationName && Oa(a._targetInst, null, a);
}
function Qa(a) {
  ya(a, Na);
}
var Ra = !(typeof window === "undefined" || typeof window.document === "undefined" || typeof window.document.createElement === "undefined");
function Sa(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}
var Ta = { animationend: Sa("Animation", "AnimationEnd"), animationiteration: Sa("Animation", "AnimationIteration"), animationstart: Sa("Animation", "AnimationStart"), transitionend: Sa("Transition", "TransitionEnd") }, Ua = {}, Va = {};
Ra && (Va = document.createElement("div").style, "AnimationEvent" in window || (delete Ta.animationend.animation, delete Ta.animationiteration.animation, delete Ta.animationstart.animation), "TransitionEvent" in window || delete Ta.transitionend.transition);
function Wa(a) {
  if (Ua[a])
    return Ua[a];
  if (!Ta[a])
    return a;
  var b = Ta[a], c;
  for (c in b)
    if (b.hasOwnProperty(c) && c in Va)
      return Ua[a] = b[c];
  return a;
}
var Xa = Wa("animationend"), Ya = Wa("animationiteration"), Za = Wa("animationstart"), ab = Wa("transitionend"), bb = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), cb = null, db = null, eb = null;
function fb() {
  if (eb)
    return eb;
  var a, b = db, c = b.length, d3, e = "value" in cb ? cb.value : cb.textContent, f2 = e.length;
  for (a = 0; a < c && b[a] === e[a]; a++)
    ;
  var h = c - a;
  for (d3 = 1; d3 <= h && b[c - d3] === e[f2 - d3]; d3++)
    ;
  return eb = e.slice(a, 1 < d3 ? 1 - d3 : void 0);
}
function gb() {
  return true;
}
function hb() {
  return false;
}
function y(a, b, c, d3) {
  this.dispatchConfig = a;
  this._targetInst = b;
  this.nativeEvent = c;
  a = this.constructor.Interface;
  for (var e in a)
    a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : e === "target" ? this.target = d3 : this[e] = c[e]);
  this.isDefaultPrevented = (c.defaultPrevented != null ? c.defaultPrevented : c.returnValue === false) ? gb : hb;
  this.isPropagationStopped = hb;
  return this;
}
m$1(y.prototype, { preventDefault: function() {
  this.defaultPrevented = true;
  var a = this.nativeEvent;
  a && (a.preventDefault ? a.preventDefault() : typeof a.returnValue !== "unknown" && (a.returnValue = false), this.isDefaultPrevented = gb);
}, stopPropagation: function() {
  var a = this.nativeEvent;
  a && (a.stopPropagation ? a.stopPropagation() : typeof a.cancelBubble !== "unknown" && (a.cancelBubble = true), this.isPropagationStopped = gb);
}, persist: function() {
  this.isPersistent = gb;
}, isPersistent: hb, destructor: function() {
  var a = this.constructor.Interface, b;
  for (b in a)
    this[b] = null;
  this.nativeEvent = this._targetInst = this.dispatchConfig = null;
  this.isPropagationStopped = this.isDefaultPrevented = hb;
  this._dispatchInstances = this._dispatchListeners = null;
} });
y.Interface = { type: null, target: null, currentTarget: function() {
  return null;
}, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function(a) {
  return a.timeStamp || Date.now();
}, defaultPrevented: null, isTrusted: null };
y.extend = function(a) {
  function b() {
  }
  function c() {
    return d3.apply(this, arguments);
  }
  var d3 = this;
  b.prototype = d3.prototype;
  var e = new b();
  m$1(e, c.prototype);
  c.prototype = e;
  c.prototype.constructor = c;
  c.Interface = m$1({}, d3.Interface, a);
  c.extend = d3.extend;
  ib(c);
  return c;
};
ib(y);
function jb(a, b, c, d3) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();
    this.call(e, a, b, c, d3);
    return e;
  }
  return new this(a, b, c, d3);
}
function kb(a) {
  if (!(a instanceof this))
    throw t(Error(279));
  a.destructor();
  10 > this.eventPool.length && this.eventPool.push(a);
}
function ib(a) {
  a.eventPool = [];
  a.getPooled = jb;
  a.release = kb;
}
var lb = y.extend({ data: null }), mb = y.extend({ data: null }), nb = [9, 13, 27, 32], ob = Ra && "CompositionEvent" in window, pb = null;
Ra && "documentMode" in document && (pb = document.documentMode);
var qb = Ra && "TextEvent" in window && !pb, sb = Ra && (!ob || pb && 8 < pb && 11 >= pb), tb = String.fromCharCode(32), ub = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["compositionend", "keypress", "textInput", "paste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ") }, compositionStart: { phasedRegistrationNames: {
  bubbled: "onCompositionStart",
  captured: "onCompositionStartCapture"
}, dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ") } }, vb = false;
function wb(a, b) {
  switch (a) {
    case "keyup":
      return nb.indexOf(b.keyCode) !== -1;
    case "keydown":
      return b.keyCode !== 229;
    case "keypress":
    case "mousedown":
    case "blur":
      return true;
    default:
      return false;
  }
}
function xb(a) {
  a = a.detail;
  return typeof a === "object" && "data" in a ? a.data : null;
}
var yb = false;
function Ab(a, b) {
  switch (a) {
    case "compositionend":
      return xb(b);
    case "keypress":
      if (b.which !== 32)
        return null;
      vb = true;
      return tb;
    case "textInput":
      return a = b.data, a === tb && vb ? null : a;
    default:
      return null;
  }
}
function Bb(a, b) {
  if (yb)
    return a === "compositionend" || !ob && wb(a, b) ? (a = fb(), eb = db = cb = null, yb = false, a) : null;
  switch (a) {
    case "paste":
      return null;
    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length)
          return b.char;
        if (b.which)
          return String.fromCharCode(b.which);
      }
      return null;
    case "compositionend":
      return sb && b.locale !== "ko" ? null : b.data;
    default:
      return null;
  }
}
var Cb = { eventTypes: ub, extractEvents: function(a, b, c, d3) {
  var e = void 0;
  var f2 = void 0;
  if (ob)
    b: {
      switch (a) {
        case "compositionstart":
          e = ub.compositionStart;
          break b;
        case "compositionend":
          e = ub.compositionEnd;
          break b;
        case "compositionupdate":
          e = ub.compositionUpdate;
          break b;
      }
      e = void 0;
    }
  else
    yb ? wb(a, c) && (e = ub.compositionEnd) : a === "keydown" && c.keyCode === 229 && (e = ub.compositionStart);
  e ? (sb && c.locale !== "ko" && (yb || e !== ub.compositionStart ? e === ub.compositionEnd && yb && (f2 = fb()) : (cb = d3, db = "value" in cb ? cb.value : cb.textContent, yb = true)), e = lb.getPooled(e, b, c, d3), f2 ? e.data = f2 : (f2 = xb(c), f2 !== null && (e.data = f2)), Qa(e), f2 = e) : f2 = null;
  (a = qb ? Ab(a, c) : Bb(a, c)) ? (b = mb.getPooled(ub.beforeInput, b, c, d3), b.data = a, Qa(b)) : b = null;
  return f2 === null ? b : b === null ? f2 : [f2, b];
} }, Db = null, Eb = null, Fb = null;
function Gb(a) {
  if (a = ta(a)) {
    if (typeof Db !== "function")
      throw t(Error(280));
    var b = sa(a.stateNode);
    Db(a.stateNode, a.type, b);
  }
}
function Hb(a) {
  Eb ? Fb ? Fb.push(a) : Fb = [a] : Eb = a;
}
function Ib() {
  if (Eb) {
    var a = Eb, b = Fb;
    Fb = Eb = null;
    Gb(a);
    if (b)
      for (a = 0; a < b.length; a++)
        Gb(b[a]);
  }
}
function Jb(a, b) {
  return a(b);
}
function Kb(a, b, c, d3) {
  return a(b, c, d3);
}
function Lb() {
}
var Mb = Jb, Nb = false;
function Ob() {
  if (Eb !== null || Fb !== null)
    Lb(), Ib();
}
var Pb = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
function Qb(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b === "input" ? !!Pb[a.type] : b === "textarea" ? true : false;
}
function Rb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return a.nodeType === 3 ? a.parentNode : a;
}
function Sb(a) {
  if (!Ra)
    return false;
  a = "on" + a;
  var b = a in document;
  b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = typeof b[a] === "function");
  return b;
}
function Tb(a) {
  var b = a.type;
  return (a = a.nodeName) && a.toLowerCase() === "input" && (b === "checkbox" || b === "radio");
}
function Ub(a) {
  var b = Tb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d3 = "" + a[b];
  if (!a.hasOwnProperty(b) && typeof c !== "undefined" && typeof c.get === "function" && typeof c.set === "function") {
    var e = c.get, f2 = c.set;
    Object.defineProperty(a, b, { configurable: true, get: function() {
      return e.call(this);
    }, set: function(a2) {
      d3 = "" + a2;
      f2.call(this, a2);
    } });
    Object.defineProperty(a, b, { enumerable: c.enumerable });
    return { getValue: function() {
      return d3;
    }, setValue: function(a2) {
      d3 = "" + a2;
    }, stopTracking: function() {
      a._valueTracker = null;
      delete a[b];
    } };
  }
}
function Vb(a) {
  a._valueTracker || (a._valueTracker = Ub(a));
}
function Wb(a) {
  if (!a)
    return false;
  var b = a._valueTracker;
  if (!b)
    return true;
  var c = b.getValue();
  var d3 = "";
  a && (d3 = Tb(a) ? a.checked ? "true" : "false" : a.value);
  a = d3;
  return a !== c ? (b.setValue(a), true) : false;
}
var Xb = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Xb.hasOwnProperty("ReactCurrentDispatcher") || (Xb.ReactCurrentDispatcher = { current: null });
Xb.hasOwnProperty("ReactCurrentBatchConfig") || (Xb.ReactCurrentBatchConfig = { suspense: null });
var Yb = /^(.*)[\\\/]/, B = typeof Symbol === "function" && Symbol.for, Zb = B ? Symbol.for("react.element") : 60103, $b = B ? Symbol.for("react.portal") : 60106, ac = B ? Symbol.for("react.fragment") : 60107, bc = B ? Symbol.for("react.strict_mode") : 60108, cc = B ? Symbol.for("react.profiler") : 60114, dc = B ? Symbol.for("react.provider") : 60109, ec = B ? Symbol.for("react.context") : 60110, fc = B ? Symbol.for("react.concurrent_mode") : 60111, gc = B ? Symbol.for("react.forward_ref") : 60112, hc = B ? Symbol.for("react.suspense") : 60113, ic = B ? Symbol.for("react.suspense_list") : 60120, jc = B ? Symbol.for("react.memo") : 60115, kc = B ? Symbol.for("react.lazy") : 60116;
var lc = typeof Symbol === "function" && Symbol.iterator;
function mc(a) {
  if (a === null || typeof a !== "object")
    return null;
  a = lc && a[lc] || a["@@iterator"];
  return typeof a === "function" ? a : null;
}
function oc(a) {
  if (a == null)
    return null;
  if (typeof a === "function")
    return a.displayName || a.name || null;
  if (typeof a === "string")
    return a;
  switch (a) {
    case ac:
      return "Fragment";
    case $b:
      return "Portal";
    case cc:
      return "Profiler";
    case bc:
      return "StrictMode";
    case hc:
      return "Suspense";
    case ic:
      return "SuspenseList";
  }
  if (typeof a === "object")
    switch (a.$$typeof) {
      case ec:
        return "Context.Consumer";
      case dc:
        return "Context.Provider";
      case gc:
        var b = a.render;
        b = b.displayName || b.name || "";
        return a.displayName || (b !== "" ? "ForwardRef(" + b + ")" : "ForwardRef");
      case jc:
        return oc(a.type);
      case kc:
        if (a = a._status === 1 ? a._result : null)
          return oc(a);
    }
  return null;
}
function pc(a) {
  var b = "";
  do {
    a:
      switch (a.tag) {
        case 3:
        case 4:
        case 6:
        case 7:
        case 10:
        case 9:
          var c = "";
          break a;
        default:
          var d3 = a._debugOwner, e = a._debugSource, f2 = oc(a.type);
          c = null;
          d3 && (c = oc(d3.type));
          d3 = f2;
          f2 = "";
          e ? f2 = " (at " + e.fileName.replace(Yb, "") + ":" + e.lineNumber + ")" : c && (f2 = " (created by " + c + ")");
          c = "\n    in " + (d3 || "Unknown") + f2;
      }
    b += c;
    a = a.return;
  } while (a);
  return b;
}
var qc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, rc = Object.prototype.hasOwnProperty, sc = {}, tc = {};
function uc(a) {
  if (rc.call(tc, a))
    return true;
  if (rc.call(sc, a))
    return false;
  if (qc.test(a))
    return tc[a] = true;
  sc[a] = true;
  return false;
}
function vc(a, b, c, d3) {
  if (c !== null && c.type === 0)
    return false;
  switch (typeof b) {
    case "function":
    case "symbol":
      return true;
    case "boolean":
      if (d3)
        return false;
      if (c !== null)
        return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return a !== "data-" && a !== "aria-";
    default:
      return false;
  }
}
function wc(a, b, c, d3) {
  if (b === null || typeof b === "undefined" || vc(a, b, c, d3))
    return true;
  if (d3)
    return false;
  if (c !== null)
    switch (c.type) {
      case 3:
        return !b;
      case 4:
        return b === false;
      case 5:
        return isNaN(b);
      case 6:
        return isNaN(b) || 1 > b;
    }
  return false;
}
function D(a, b, c, d3, e, f2) {
  this.acceptsBooleans = b === 2 || b === 3 || b === 4;
  this.attributeName = d3;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f2;
}
var F = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
  F[a] = new D(a, 0, false, a, null, false);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
  var b = a[0];
  F[b] = new D(b, 1, false, a[1], null, false);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
  F[a] = new D(a, 2, false, a.toLowerCase(), null, false);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
  F[a] = new D(a, 2, false, a, null, false);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
  F[a] = new D(a, 3, false, a.toLowerCase(), null, false);
});
["checked", "multiple", "muted", "selected"].forEach(function(a) {
  F[a] = new D(a, 3, true, a, null, false);
});
["capture", "download"].forEach(function(a) {
  F[a] = new D(a, 4, false, a, null, false);
});
["cols", "rows", "size", "span"].forEach(function(a) {
  F[a] = new D(a, 6, false, a, null, false);
});
["rowSpan", "start"].forEach(function(a) {
  F[a] = new D(a, 5, false, a.toLowerCase(), null, false);
});
var xc = /[\-:]([a-z])/g;
function yc(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
  var b = a.replace(xc, yc);
  F[b] = new D(b, 1, false, a, null, false);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
  var b = a.replace(xc, yc);
  F[b] = new D(b, 1, false, a, "http://www.w3.org/1999/xlink", false);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
  var b = a.replace(xc, yc);
  F[b] = new D(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false);
});
["tabIndex", "crossOrigin"].forEach(function(a) {
  F[a] = new D(a, 1, false, a.toLowerCase(), null, false);
});
F.xlinkHref = new D("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true);
["src", "href", "action", "formAction"].forEach(function(a) {
  F[a] = new D(a, 1, false, a.toLowerCase(), null, true);
});
function zc(a, b, c, d3) {
  var e = F.hasOwnProperty(b) ? F[b] : null;
  var f2 = e !== null ? e.type === 0 : d3 ? false : !(2 < b.length) || b[0] !== "o" && b[0] !== "O" || b[1] !== "n" && b[1] !== "N" ? false : true;
  f2 || (wc(b, c, e, d3) && (c = null), d3 || e === null ? uc(b) && (c === null ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = c === null ? e.type === 3 ? false : "" : c : (b = e.attributeName, d3 = e.attributeNamespace, c === null ? a.removeAttribute(b) : (e = e.type, c = e === 3 || e === 4 && c === true ? "" : "" + c, d3 ? a.setAttributeNS(d3, b, c) : a.setAttribute(b, c))));
}
function Ac(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a;
    default:
      return "";
  }
}
function Bc(a, b) {
  var c = b.checked;
  return m$1({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: c != null ? c : a._wrapperState.initialChecked });
}
function Cc(a, b) {
  var c = b.defaultValue == null ? "" : b.defaultValue, d3 = b.checked != null ? b.checked : b.defaultChecked;
  c = Ac(b.value != null ? b.value : c);
  a._wrapperState = { initialChecked: d3, initialValue: c, controlled: b.type === "checkbox" || b.type === "radio" ? b.checked != null : b.value != null };
}
function Dc(a, b) {
  b = b.checked;
  b != null && zc(a, "checked", b, false);
}
function Ec(a, b) {
  Dc(a, b);
  var c = Ac(b.value), d3 = b.type;
  if (c != null)
    if (d3 === "number") {
      if (c === 0 && a.value === "" || a.value != c)
        a.value = "" + c;
    } else
      a.value !== "" + c && (a.value = "" + c);
  else if (d3 === "submit" || d3 === "reset") {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? Fc(a, b.type, c) : b.hasOwnProperty("defaultValue") && Fc(a, b.type, Ac(b.defaultValue));
  b.checked == null && b.defaultChecked != null && (a.defaultChecked = !!b.defaultChecked);
}
function Gc(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d3 = b.type;
    if (!(d3 !== "submit" && d3 !== "reset" || b.value !== void 0 && b.value !== null))
      return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }
  c = a.name;
  c !== "" && (a.name = "");
  a.defaultChecked = !a.defaultChecked;
  a.defaultChecked = !!a._wrapperState.initialChecked;
  c !== "" && (a.name = c);
}
function Fc(a, b, c) {
  if (b !== "number" || a.ownerDocument.activeElement !== a)
    c == null ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var Hc = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "blur change click focus input keydown keyup selectionchange".split(" ") } };
function Ic(a, b, c) {
  a = y.getPooled(Hc.change, a, b, c);
  a.type = "change";
  Hb(c);
  Qa(a);
  return a;
}
var Jc = null, Kc = null;
function Lc(a) {
  Ba(a);
}
function Mc(a) {
  var b = Ja(a);
  if (Wb(b))
    return a;
}
function Nc(a, b) {
  if (a === "change")
    return b;
}
var Oc = false;
Ra && (Oc = Sb("input") && (!document.documentMode || 9 < document.documentMode));
function Pc() {
  Jc && (Jc.detachEvent("onpropertychange", Qc), Kc = Jc = null);
}
function Qc(a) {
  if (a.propertyName === "value" && Mc(Kc))
    if (a = Ic(Kc, a, Rb(a)), Nb)
      Ba(a);
    else {
      Nb = true;
      try {
        Jb(Lc, a);
      } finally {
        Nb = false, Ob();
      }
    }
}
function Rc(a, b, c) {
  a === "focus" ? (Pc(), Jc = b, Kc = c, Jc.attachEvent("onpropertychange", Qc)) : a === "blur" && Pc();
}
function Sc(a) {
  if (a === "selectionchange" || a === "keyup" || a === "keydown")
    return Mc(Kc);
}
function Tc(a, b) {
  if (a === "click")
    return Mc(b);
}
function Uc(a, b) {
  if (a === "input" || a === "change")
    return Mc(b);
}
var Vc = { eventTypes: Hc, _isInputEventSupported: Oc, extractEvents: function(a, b, c, d3) {
  var e = b ? Ja(b) : window, f2 = void 0, h = void 0, g2 = e.nodeName && e.nodeName.toLowerCase();
  g2 === "select" || g2 === "input" && e.type === "file" ? f2 = Nc : Qb(e) ? Oc ? f2 = Uc : (f2 = Sc, h = Rc) : (g2 = e.nodeName) && g2.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio") && (f2 = Tc);
  if (f2 && (f2 = f2(a, b)))
    return Ic(f2, c, d3);
  h && h(a, e, b);
  a === "blur" && (a = e._wrapperState) && a.controlled && e.type === "number" && Fc(e, "number", e.value);
} }, Wc = y.extend({ view: null, detail: null }), Xc = {
  Alt: "altKey",
  Control: "ctrlKey",
  Meta: "metaKey",
  Shift: "shiftKey"
};
function Yc(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Xc[a]) ? !!b[a] : false;
}
function Zc() {
  return Yc;
}
var $c = 0, ad = 0, bd = false, cd = false, dd = Wc.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: Zc, button: null, buttons: null, relatedTarget: function(a) {
  return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
}, movementX: function(a) {
  if ("movementX" in a)
    return a.movementX;
  var b = $c;
  $c = a.screenX;
  return bd ? a.type === "mousemove" ? a.screenX - b : 0 : (bd = true, 0);
}, movementY: function(a) {
  if ("movementY" in a)
    return a.movementY;
  var b = ad;
  ad = a.screenY;
  return cd ? a.type === "mousemove" ? a.screenY - b : 0 : (cd = true, 0);
} }), ed = dd.extend({ pointerId: null, width: null, height: null, pressure: null, tangentialPressure: null, tiltX: null, tiltY: null, twist: null, pointerType: null, isPrimary: null }), fd = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["mouseout", "mouseover"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["mouseout", "mouseover"] }, pointerEnter: { registrationName: "onPointerEnter", dependencies: ["pointerout", "pointerover"] }, pointerLeave: {
  registrationName: "onPointerLeave",
  dependencies: ["pointerout", "pointerover"]
} }, gd = { eventTypes: fd, extractEvents: function(a, b, c, d3) {
  var e = a === "mouseover" || a === "pointerover", f2 = a === "mouseout" || a === "pointerout";
  if (e && (c.relatedTarget || c.fromElement) || !f2 && !e)
    return null;
  e = d3.window === d3 ? d3 : (e = d3.ownerDocument) ? e.defaultView || e.parentWindow : window;
  f2 ? (f2 = b, b = (b = c.relatedTarget || c.toElement) ? Ha(b) : null) : f2 = null;
  if (f2 === b)
    return null;
  var h = void 0, g2 = void 0, k = void 0, l = void 0;
  if (a === "mouseout" || a === "mouseover")
    h = dd, g2 = fd.mouseLeave, k = fd.mouseEnter, l = "mouse";
  else if (a === "pointerout" || a === "pointerover")
    h = ed, g2 = fd.pointerLeave, k = fd.pointerEnter, l = "pointer";
  var n2 = f2 == null ? e : Ja(f2);
  e = b == null ? e : Ja(b);
  a = h.getPooled(g2, f2, c, d3);
  a.type = l + "leave";
  a.target = n2;
  a.relatedTarget = e;
  c = h.getPooled(k, b, c, d3);
  c.type = l + "enter";
  c.target = e;
  c.relatedTarget = n2;
  d3 = b;
  if (f2 && d3)
    a: {
      b = f2;
      e = d3;
      l = 0;
      for (h = b; h; h = La(h))
        l++;
      h = 0;
      for (k = e; k; k = La(k))
        h++;
      for (; 0 < l - h; )
        b = La(b), l--;
      for (; 0 < h - l; )
        e = La(e), h--;
      for (; l--; ) {
        if (b === e || b === e.alternate)
          break a;
        b = La(b);
        e = La(e);
      }
      b = null;
    }
  else
    b = null;
  e = b;
  for (b = []; f2 && f2 !== e; ) {
    l = f2.alternate;
    if (l !== null && l === e)
      break;
    b.push(f2);
    f2 = La(f2);
  }
  for (f2 = []; d3 && d3 !== e; ) {
    l = d3.alternate;
    if (l !== null && l === e)
      break;
    f2.push(d3);
    d3 = La(d3);
  }
  for (d3 = 0; d3 < b.length; d3++)
    Oa(b[d3], "bubbled", a);
  for (d3 = f2.length; 0 < d3--; )
    Oa(f2[d3], "captured", c);
  return [a, c];
} };
function hd(a, b) {
  return a === b && (a !== 0 || 1 / a === 1 / b) || a !== a && b !== b;
}
var id = Object.prototype.hasOwnProperty;
function jd(a, b) {
  if (hd(a, b))
    return true;
  if (typeof a !== "object" || a === null || typeof b !== "object" || b === null)
    return false;
  var c = Object.keys(a), d3 = Object.keys(b);
  if (c.length !== d3.length)
    return false;
  for (d3 = 0; d3 < c.length; d3++)
    if (!id.call(b, c[d3]) || !hd(a[c[d3]], b[c[d3]]))
      return false;
  return true;
}
function kd(a, b) {
  return { responder: a, props: b };
}
function ld(a) {
  var b = a;
  if (a.alternate)
    for (; b.return; )
      b = b.return;
  else {
    if ((b.effectTag & 2) !== 0)
      return 1;
    for (; b.return; )
      if (b = b.return, (b.effectTag & 2) !== 0)
        return 1;
  }
  return b.tag === 3 ? 2 : 3;
}
function od(a) {
  if (ld(a) !== 2)
    throw t(Error(188));
}
function pd(a) {
  var b = a.alternate;
  if (!b) {
    b = ld(a);
    if (b === 3)
      throw t(Error(188));
    return b === 1 ? null : a;
  }
  for (var c = a, d3 = b; ; ) {
    var e = c.return;
    if (e === null)
      break;
    var f2 = e.alternate;
    if (f2 === null) {
      d3 = e.return;
      if (d3 !== null) {
        c = d3;
        continue;
      }
      break;
    }
    if (e.child === f2.child) {
      for (f2 = e.child; f2; ) {
        if (f2 === c)
          return od(e), a;
        if (f2 === d3)
          return od(e), b;
        f2 = f2.sibling;
      }
      throw t(Error(188));
    }
    if (c.return !== d3.return)
      c = e, d3 = f2;
    else {
      for (var h = false, g2 = e.child; g2; ) {
        if (g2 === c) {
          h = true;
          c = e;
          d3 = f2;
          break;
        }
        if (g2 === d3) {
          h = true;
          d3 = e;
          c = f2;
          break;
        }
        g2 = g2.sibling;
      }
      if (!h) {
        for (g2 = f2.child; g2; ) {
          if (g2 === c) {
            h = true;
            c = f2;
            d3 = e;
            break;
          }
          if (g2 === d3) {
            h = true;
            d3 = f2;
            c = e;
            break;
          }
          g2 = g2.sibling;
        }
        if (!h)
          throw t(Error(189));
      }
    }
    if (c.alternate !== d3)
      throw t(Error(190));
  }
  if (c.tag !== 3)
    throw t(Error(188));
  return c.stateNode.current === c ? a : b;
}
function qd(a) {
  a = pd(a);
  if (!a)
    return null;
  for (var b = a; ; ) {
    if (b.tag === 5 || b.tag === 6)
      return b;
    if (b.child)
      b.child.return = b, b = b.child;
    else {
      if (b === a)
        break;
      for (; !b.sibling; ) {
        if (!b.return || b.return === a)
          return null;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
  }
  return null;
}
var rd = y.extend({ animationName: null, elapsedTime: null, pseudoElement: null }), sd = y.extend({ clipboardData: function(a) {
  return "clipboardData" in a ? a.clipboardData : window.clipboardData;
} }), td = Wc.extend({ relatedTarget: null });
function ud(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, a === 0 && b === 13 && (a = 13)) : a = b;
  a === 10 && (a = 13);
  return 32 <= a || a === 13 ? a : 0;
}
var vd = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, wd = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, xd = Wc.extend({ key: function(a) {
  if (a.key) {
    var b = vd[a.key] || a.key;
    if (b !== "Unidentified")
      return b;
  }
  return a.type === "keypress" ? (a = ud(a), a === 13 ? "Enter" : String.fromCharCode(a)) : a.type === "keydown" || a.type === "keyup" ? wd[a.keyCode] || "Unidentified" : "";
}, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: Zc, charCode: function(a) {
  return a.type === "keypress" ? ud(a) : 0;
}, keyCode: function(a) {
  return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
}, which: function(a) {
  return a.type === "keypress" ? ud(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
} }), yd = dd.extend({ dataTransfer: null }), zd = Wc.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: Zc }), Ad = y.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }), Bd = dd.extend({ deltaX: function(a) {
  return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
}, deltaY: function(a) {
  return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
}, deltaZ: null, deltaMode: null }), Cd = [
  ["blur", "blur", 0],
  ["cancel", "cancel", 0],
  ["click", "click", 0],
  ["close", "close", 0],
  ["contextmenu", "contextMenu", 0],
  ["copy", "copy", 0],
  ["cut", "cut", 0],
  ["auxclick", "auxClick", 0],
  ["dblclick", "doubleClick", 0],
  ["dragend", "dragEnd", 0],
  ["dragstart", "dragStart", 0],
  ["drop", "drop", 0],
  ["focus", "focus", 0],
  ["input", "input", 0],
  ["invalid", "invalid", 0],
  ["keydown", "keyDown", 0],
  ["keypress", "keyPress", 0],
  ["keyup", "keyUp", 0],
  ["mousedown", "mouseDown", 0],
  ["mouseup", "mouseUp", 0],
  ["paste", "paste", 0],
  ["pause", "pause", 0],
  ["play", "play", 0],
  ["pointercancel", "pointerCancel", 0],
  ["pointerdown", "pointerDown", 0],
  ["pointerup", "pointerUp", 0],
  ["ratechange", "rateChange", 0],
  ["reset", "reset", 0],
  ["seeked", "seeked", 0],
  ["submit", "submit", 0],
  ["touchcancel", "touchCancel", 0],
  ["touchend", "touchEnd", 0],
  ["touchstart", "touchStart", 0],
  ["volumechange", "volumeChange", 0],
  [
    "drag",
    "drag",
    1
  ],
  ["dragenter", "dragEnter", 1],
  ["dragexit", "dragExit", 1],
  ["dragleave", "dragLeave", 1],
  ["dragover", "dragOver", 1],
  ["mousemove", "mouseMove", 1],
  ["mouseout", "mouseOut", 1],
  ["mouseover", "mouseOver", 1],
  ["pointermove", "pointerMove", 1],
  ["pointerout", "pointerOut", 1],
  ["pointerover", "pointerOver", 1],
  ["scroll", "scroll", 1],
  ["toggle", "toggle", 1],
  ["touchmove", "touchMove", 1],
  ["wheel", "wheel", 1],
  ["abort", "abort", 2],
  [Xa, "animationEnd", 2],
  [Ya, "animationIteration", 2],
  [Za, "animationStart", 2],
  ["canplay", "canPlay", 2],
  [
    "canplaythrough",
    "canPlayThrough",
    2
  ],
  ["durationchange", "durationChange", 2],
  ["emptied", "emptied", 2],
  ["encrypted", "encrypted", 2],
  ["ended", "ended", 2],
  ["error", "error", 2],
  ["gotpointercapture", "gotPointerCapture", 2],
  ["load", "load", 2],
  ["loadeddata", "loadedData", 2],
  ["loadedmetadata", "loadedMetadata", 2],
  ["loadstart", "loadStart", 2],
  ["lostpointercapture", "lostPointerCapture", 2],
  ["playing", "playing", 2],
  ["progress", "progress", 2],
  ["seeking", "seeking", 2],
  ["stalled", "stalled", 2],
  ["suspend", "suspend", 2],
  [
    "timeupdate",
    "timeUpdate",
    2
  ],
  [ab, "transitionEnd", 2],
  ["waiting", "waiting", 2]
], Dd = {}, Ed = {}, Fd = 0;
for (; Fd < Cd.length; Fd++) {
  var Gd = Cd[Fd], Hd = Gd[0], Id = Gd[1], Jd = Gd[2], Kd = "on" + (Id[0].toUpperCase() + Id.slice(1)), Ld = { phasedRegistrationNames: { bubbled: Kd, captured: Kd + "Capture" }, dependencies: [Hd], eventPriority: Jd };
  Dd[Id] = Ld;
  Ed[Hd] = Ld;
}
var Md = { eventTypes: Dd, getEventPriority: function(a) {
  a = Ed[a];
  return a !== void 0 ? a.eventPriority : 2;
}, extractEvents: function(a, b, c, d3) {
  var e = Ed[a];
  if (!e)
    return null;
  switch (a) {
    case "keypress":
      if (ud(c) === 0)
        return null;
    case "keydown":
    case "keyup":
      a = xd;
      break;
    case "blur":
    case "focus":
      a = td;
      break;
    case "click":
      if (c.button === 2)
        return null;
    case "auxclick":
    case "dblclick":
    case "mousedown":
    case "mousemove":
    case "mouseup":
    case "mouseout":
    case "mouseover":
    case "contextmenu":
      a = dd;
      break;
    case "drag":
    case "dragend":
    case "dragenter":
    case "dragexit":
    case "dragleave":
    case "dragover":
    case "dragstart":
    case "drop":
      a = yd;
      break;
    case "touchcancel":
    case "touchend":
    case "touchmove":
    case "touchstart":
      a = zd;
      break;
    case Xa:
    case Ya:
    case Za:
      a = rd;
      break;
    case ab:
      a = Ad;
      break;
    case "scroll":
      a = Wc;
      break;
    case "wheel":
      a = Bd;
      break;
    case "copy":
    case "cut":
    case "paste":
      a = sd;
      break;
    case "gotpointercapture":
    case "lostpointercapture":
    case "pointercancel":
    case "pointerdown":
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "pointerup":
      a = ed;
      break;
    default:
      a = y;
  }
  b = a.getPooled(e, b, c, d3);
  Qa(b);
  return b;
} }, Nd = Md.getEventPriority, Od = [];
function Pd(a) {
  var b = a.targetInst, c = b;
  do {
    if (!c) {
      a.ancestors.push(c);
      break;
    }
    var d3;
    for (d3 = c; d3.return; )
      d3 = d3.return;
    d3 = d3.tag !== 3 ? null : d3.stateNode.containerInfo;
    if (!d3)
      break;
    a.ancestors.push(c);
    c = Ha(d3);
  } while (c);
  for (c = 0; c < a.ancestors.length; c++) {
    b = a.ancestors[c];
    var e = Rb(a.nativeEvent);
    d3 = a.topLevelType;
    for (var f2 = a.nativeEvent, h = null, g2 = 0; g2 < ea.length; g2++) {
      var k = ea[g2];
      k && (k = k.extractEvents(d3, b, f2, e)) && (h = xa(h, k));
    }
    Ba(h);
  }
}
var Qd = true;
function G(a, b) {
  Rd(b, a, false);
}
function Rd(a, b, c) {
  switch (Nd(b)) {
    case 0:
      var d3 = Sd.bind(null, b, 1);
      break;
    case 1:
      d3 = Td.bind(null, b, 1);
      break;
    default:
      d3 = Ud.bind(null, b, 1);
  }
  c ? a.addEventListener(b, d3, true) : a.addEventListener(b, d3, false);
}
function Sd(a, b, c) {
  Nb || Lb();
  var d3 = Ud, e = Nb;
  Nb = true;
  try {
    Kb(d3, a, b, c);
  } finally {
    (Nb = e) || Ob();
  }
}
function Td(a, b, c) {
  Ud(a, b, c);
}
function Ud(a, b, c) {
  if (Qd) {
    b = Rb(c);
    b = Ha(b);
    b === null || typeof b.tag !== "number" || ld(b) === 2 || (b = null);
    if (Od.length) {
      var d3 = Od.pop();
      d3.topLevelType = a;
      d3.nativeEvent = c;
      d3.targetInst = b;
      a = d3;
    } else
      a = { topLevelType: a, nativeEvent: c, targetInst: b, ancestors: [] };
    try {
      if (c = a, Nb)
        Pd(c, void 0);
      else {
        Nb = true;
        try {
          Mb(Pd, c, void 0);
        } finally {
          Nb = false, Ob();
        }
      }
    } finally {
      a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Od.length && Od.push(a);
    }
  }
}
var Vd = new (typeof WeakMap === "function" ? WeakMap : Map)();
function Wd(a) {
  var b = Vd.get(a);
  b === void 0 && (b = /* @__PURE__ */ new Set(), Vd.set(a, b));
  return b;
}
function Xd(a) {
  a = a || (typeof document !== "undefined" ? document : void 0);
  if (typeof a === "undefined")
    return null;
  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}
function Yd(a) {
  for (; a && a.firstChild; )
    a = a.firstChild;
  return a;
}
function Zd(a, b) {
  var c = Yd(a);
  a = 0;
  for (var d3; c; ) {
    if (c.nodeType === 3) {
      d3 = a + c.textContent.length;
      if (a <= b && d3 >= b)
        return { node: c, offset: b - a };
      a = d3;
    }
    a: {
      for (; c; ) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }
        c = c.parentNode;
      }
      c = void 0;
    }
    c = Yd(c);
  }
}
function $d(a, b) {
  return a && b ? a === b ? true : a && a.nodeType === 3 ? false : b && b.nodeType === 3 ? $d(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : false : false;
}
function ae() {
  for (var a = window, b = Xd(); b instanceof a.HTMLIFrameElement; ) {
    try {
      var c = typeof b.contentWindow.location.href === "string";
    } catch (d3) {
      c = false;
    }
    if (c)
      a = b.contentWindow;
    else
      break;
    b = Xd(a.document);
  }
  return b;
}
function be(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && (b === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || b === "textarea" || a.contentEditable === "true");
}
var ce = Ra && "documentMode" in document && 11 >= document.documentMode, de = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ") } }, ee = null, fe = null, ge = null, he = false;
function ie(a, b) {
  var c = b.window === b ? b.document : b.nodeType === 9 ? b : b.ownerDocument;
  if (he || ee == null || ee !== Xd(c))
    return null;
  c = ee;
  "selectionStart" in c && be(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset });
  return ge && jd(ge, c) ? null : (ge = c, a = y.getPooled(de.select, fe, a, b), a.type = "select", a.target = ee, Qa(a), a);
}
var je = { eventTypes: de, extractEvents: function(a, b, c, d3) {
  var e = d3.window === d3 ? d3.document : d3.nodeType === 9 ? d3 : d3.ownerDocument, f2;
  if (!(f2 = !e)) {
    a: {
      e = Wd(e);
      f2 = ja.onSelect;
      for (var h = 0; h < f2.length; h++)
        if (!e.has(f2[h])) {
          e = false;
          break a;
        }
      e = true;
    }
    f2 = !e;
  }
  if (f2)
    return null;
  e = b ? Ja(b) : window;
  switch (a) {
    case "focus":
      if (Qb(e) || e.contentEditable === "true")
        ee = e, fe = b, ge = null;
      break;
    case "blur":
      ge = fe = ee = null;
      break;
    case "mousedown":
      he = true;
      break;
    case "contextmenu":
    case "mouseup":
    case "dragend":
      return he = false, ie(c, d3);
    case "selectionchange":
      if (ce)
        break;
    case "keydown":
    case "keyup":
      return ie(c, d3);
  }
  return null;
} };
Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
sa = Ka;
ta = Ia;
va = Ja;
Ca.injectEventPluginsByName({ SimpleEventPlugin: Md, EnterLeaveEventPlugin: gd, ChangeEventPlugin: Vc, SelectEventPlugin: je, BeforeInputEventPlugin: Cb });
function ke(a) {
  var b = "";
  aa.Children.forEach(a, function(a2) {
    a2 != null && (b += a2);
  });
  return b;
}
function le(a, b) {
  a = m$1({ children: void 0 }, b);
  if (b = ke(b.children))
    a.children = b;
  return a;
}
function me(a, b, c, d3) {
  a = a.options;
  if (b) {
    b = {};
    for (var e = 0; e < c.length; e++)
      b["$" + c[e]] = true;
    for (c = 0; c < a.length; c++)
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d3 && (a[c].defaultSelected = true);
  } else {
    c = "" + Ac(c);
    b = null;
    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = true;
        d3 && (a[e].defaultSelected = true);
        return;
      }
      b !== null || a[e].disabled || (b = a[e]);
    }
    b !== null && (b.selected = true);
  }
}
function ne(a, b) {
  if (b.dangerouslySetInnerHTML != null)
    throw t(Error(91));
  return m$1({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}
function oe(a, b) {
  var c = b.value;
  if (c == null) {
    c = b.defaultValue;
    b = b.children;
    if (b != null) {
      if (c != null)
        throw t(Error(92));
      if (Array.isArray(b)) {
        if (!(1 >= b.length))
          throw t(Error(93));
        b = b[0];
      }
      c = b;
    }
    c == null && (c = "");
  }
  a._wrapperState = { initialValue: Ac(c) };
}
function pe(a, b) {
  var c = Ac(b.value), d3 = Ac(b.defaultValue);
  c != null && (c = "" + c, c !== a.value && (a.value = c), b.defaultValue == null && a.defaultValue !== c && (a.defaultValue = c));
  d3 != null && (a.defaultValue = "" + d3);
}
function qe(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && (a.value = b);
}
var re = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function se(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function te(a, b) {
  return a == null || a === "http://www.w3.org/1999/xhtml" ? se(b) : a === "http://www.w3.org/2000/svg" && b === "foreignObject" ? "http://www.w3.org/1999/xhtml" : a;
}
var ue = void 0, ve = function(a) {
  return typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction ? function(b, c, d3, e) {
    MSApp.execUnsafeLocalFunction(function() {
      return a(b, c, d3, e);
    });
  } : a;
}(function(a, b) {
  if (a.namespaceURI !== re.svg || "innerHTML" in a)
    a.innerHTML = b;
  else {
    ue = ue || document.createElement("div");
    ue.innerHTML = "<svg>" + b + "</svg>";
    for (b = ue.firstChild; a.firstChild; )
      a.removeChild(a.firstChild);
    for (; b.firstChild; )
      a.appendChild(b.firstChild);
  }
});
function we(a, b) {
  if (b) {
    var c = a.firstChild;
    if (c && c === a.lastChild && c.nodeType === 3) {
      c.nodeValue = b;
      return;
    }
  }
  a.textContent = b;
}
var xe = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
}, ye = ["Webkit", "ms", "Moz", "O"];
Object.keys(xe).forEach(function(a) {
  ye.forEach(function(b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    xe[b] = xe[a];
  });
});
function ze(a, b, c) {
  return b == null || typeof b === "boolean" || b === "" ? "" : c || typeof b !== "number" || b === 0 || xe.hasOwnProperty(a) && xe[a] ? ("" + b).trim() : b + "px";
}
function Ae(a, b) {
  a = a.style;
  for (var c in b)
    if (b.hasOwnProperty(c)) {
      var d3 = c.indexOf("--") === 0, e = ze(c, b[c], d3);
      c === "float" && (c = "cssFloat");
      d3 ? a.setProperty(c, e) : a[c] = e;
    }
}
var Ce = m$1({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
function De(a, b) {
  if (b) {
    if (Ce[a] && (b.children != null || b.dangerouslySetInnerHTML != null))
      throw t(Error(137), a, "");
    if (b.dangerouslySetInnerHTML != null) {
      if (b.children != null)
        throw t(Error(60));
      if (!(typeof b.dangerouslySetInnerHTML === "object" && "__html" in b.dangerouslySetInnerHTML))
        throw t(Error(61));
    }
    if (b.style != null && typeof b.style !== "object")
      throw t(Error(62), "");
  }
}
function Ee(a, b) {
  if (a.indexOf("-") === -1)
    return typeof b.is === "string";
  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return false;
    default:
      return true;
  }
}
function Fe(a, b) {
  a = a.nodeType === 9 || a.nodeType === 11 ? a : a.ownerDocument;
  var c = Wd(a);
  b = ja[b];
  for (var d3 = 0; d3 < b.length; d3++) {
    var e = b[d3];
    if (!c.has(e)) {
      switch (e) {
        case "scroll":
          Rd(a, "scroll", true);
          break;
        case "focus":
        case "blur":
          Rd(a, "focus", true);
          Rd(a, "blur", true);
          c.add("blur");
          c.add("focus");
          break;
        case "cancel":
        case "close":
          Sb(e) && Rd(a, e, true);
          break;
        case "invalid":
        case "submit":
        case "reset":
          break;
        default:
          bb.indexOf(e) === -1 && G(e, a);
      }
      c.add(e);
    }
  }
}
function Ge() {
}
var He = null, Ie = null;
function Je(a, b) {
  switch (a) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!b.autoFocus;
  }
  return false;
}
function Ke(a, b) {
  return a === "textarea" || a === "option" || a === "noscript" || typeof b.children === "string" || typeof b.children === "number" || typeof b.dangerouslySetInnerHTML === "object" && b.dangerouslySetInnerHTML !== null && b.dangerouslySetInnerHTML.__html != null;
}
var Le = typeof setTimeout === "function" ? setTimeout : void 0, Me = typeof clearTimeout === "function" ? clearTimeout : void 0;
function Ne(a) {
  for (; a != null; a = a.nextSibling) {
    var b = a.nodeType;
    if (b === 1 || b === 3)
      break;
  }
  return a;
}
var Oe = [], Pe = -1;
function H(a) {
  0 > Pe || (a.current = Oe[Pe], Oe[Pe] = null, Pe--);
}
function J(a, b) {
  Pe++;
  Oe[Pe] = a.current;
  a.current = b;
}
var Qe = {}, L = { current: Qe }, M = { current: false }, Re = Qe;
function Se(a, b) {
  var c = a.type.contextTypes;
  if (!c)
    return Qe;
  var d3 = a.stateNode;
  if (d3 && d3.__reactInternalMemoizedUnmaskedChildContext === b)
    return d3.__reactInternalMemoizedMaskedChildContext;
  var e = {}, f2;
  for (f2 in c)
    e[f2] = b[f2];
  d3 && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}
function N(a) {
  a = a.childContextTypes;
  return a !== null && a !== void 0;
}
function Te(a) {
  H(M);
  H(L);
}
function Ue(a) {
  H(M);
  H(L);
}
function Ve(a, b, c) {
  if (L.current !== Qe)
    throw t(Error(168));
  J(L, b);
  J(M, c);
}
function We(a, b, c) {
  var d3 = a.stateNode;
  a = b.childContextTypes;
  if (typeof d3.getChildContext !== "function")
    return c;
  d3 = d3.getChildContext();
  for (var e in d3)
    if (!(e in a))
      throw t(Error(108), oc(b) || "Unknown", e);
  return m$1({}, c, d3);
}
function Xe(a) {
  var b = a.stateNode;
  b = b && b.__reactInternalMemoizedMergedChildContext || Qe;
  Re = L.current;
  J(L, b);
  J(M, M.current);
  return true;
}
function Ye(a, b, c) {
  var d3 = a.stateNode;
  if (!d3)
    throw t(Error(169));
  c ? (b = We(a, b, Re), d3.__reactInternalMemoizedMergedChildContext = b, H(M), H(L), J(L, b)) : H(M);
  J(M, c);
}
var Ze = q$1.unstable_runWithPriority, $e = q$1.unstable_scheduleCallback, af = q$1.unstable_cancelCallback, bf = q$1.unstable_shouldYield, cf = q$1.unstable_requestPaint, df = q$1.unstable_now, ef = q$1.unstable_getCurrentPriorityLevel, ff = q$1.unstable_ImmediatePriority, hf = q$1.unstable_UserBlockingPriority, jf = q$1.unstable_NormalPriority, kf = q$1.unstable_LowPriority, lf = q$1.unstable_IdlePriority, mf = {}, nf = cf !== void 0 ? cf : function() {
}, of = null, pf = null, qf = false, rf = df(), sf = 1e4 > rf ? df : function() {
  return df() - rf;
};
function tf() {
  switch (ef()) {
    case ff:
      return 99;
    case hf:
      return 98;
    case jf:
      return 97;
    case kf:
      return 96;
    case lf:
      return 95;
    default:
      throw t(Error(332));
  }
}
function uf(a) {
  switch (a) {
    case 99:
      return ff;
    case 98:
      return hf;
    case 97:
      return jf;
    case 96:
      return kf;
    case 95:
      return lf;
    default:
      throw t(Error(332));
  }
}
function vf(a, b) {
  a = uf(a);
  return Ze(a, b);
}
function wf(a, b, c) {
  a = uf(a);
  return $e(a, b, c);
}
function xf(a) {
  of === null ? (of = [a], pf = $e(ff, yf)) : of.push(a);
  return mf;
}
function O() {
  pf !== null && af(pf);
  yf();
}
function yf() {
  if (!qf && of !== null) {
    qf = true;
    var a = 0;
    try {
      var b = of;
      vf(99, function() {
        for (; a < b.length; a++) {
          var c = b[a];
          do
            c = c(true);
          while (c !== null);
        }
      });
      of = null;
    } catch (c) {
      throw of !== null && (of = of.slice(a + 1)), $e(ff, O), c;
    } finally {
      qf = false;
    }
  }
}
function zf(a, b) {
  if (b === 1073741823)
    return 99;
  if (b === 1)
    return 95;
  a = 10 * (1073741821 - b) - 10 * (1073741821 - a);
  return 0 >= a ? 99 : 250 >= a ? 98 : 5250 >= a ? 97 : 95;
}
function Af(a, b) {
  if (a && a.defaultProps) {
    b = m$1({}, b);
    a = a.defaultProps;
    for (var c in a)
      b[c] === void 0 && (b[c] = a[c]);
  }
  return b;
}
function Bf(a) {
  var b = a._result;
  switch (a._status) {
    case 1:
      return b;
    case 2:
      throw b;
    case 0:
      throw b;
    default:
      a._status = 0;
      b = a._ctor;
      b = b();
      b.then(function(b2) {
        a._status === 0 && (b2 = b2.default, a._status = 1, a._result = b2);
      }, function(b2) {
        a._status === 0 && (a._status = 2, a._result = b2);
      });
      switch (a._status) {
        case 1:
          return a._result;
        case 2:
          throw a._result;
      }
      a._result = b;
      throw b;
  }
}
var Cf = { current: null }, Df = null, Ef = null, Ff = null;
function Gf() {
  Ff = Ef = Df = null;
}
function Hf(a, b) {
  var c = a.type._context;
  J(Cf, c._currentValue);
  c._currentValue = b;
}
function If(a) {
  var b = Cf.current;
  H(Cf);
  a.type._context._currentValue = b;
}
function Jf(a, b) {
  for (; a !== null; ) {
    var c = a.alternate;
    if (a.childExpirationTime < b)
      a.childExpirationTime = b, c !== null && c.childExpirationTime < b && (c.childExpirationTime = b);
    else if (c !== null && c.childExpirationTime < b)
      c.childExpirationTime = b;
    else
      break;
    a = a.return;
  }
}
function Kf(a, b) {
  Df = a;
  Ff = Ef = null;
  a = a.dependencies;
  a !== null && a.firstContext !== null && (a.expirationTime >= b && (Lf = true), a.firstContext = null);
}
function Mf(a, b) {
  if (Ff !== a && b !== false && b !== 0) {
    if (typeof b !== "number" || b === 1073741823)
      Ff = a, b = 1073741823;
    b = { context: a, observedBits: b, next: null };
    if (Ef === null) {
      if (Df === null)
        throw t(Error(308));
      Ef = b;
      Df.dependencies = { expirationTime: 0, firstContext: b, responders: null };
    } else
      Ef = Ef.next = b;
  }
  return a._currentValue;
}
var Nf = false;
function Of(a) {
  return { baseState: a, firstUpdate: null, lastUpdate: null, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
}
function Pf(a) {
  return { baseState: a.baseState, firstUpdate: a.firstUpdate, lastUpdate: a.lastUpdate, firstCapturedUpdate: null, lastCapturedUpdate: null, firstEffect: null, lastEffect: null, firstCapturedEffect: null, lastCapturedEffect: null };
}
function Qf(a, b) {
  return { expirationTime: a, suspenseConfig: b, tag: 0, payload: null, callback: null, next: null, nextEffect: null };
}
function Rf(a, b) {
  a.lastUpdate === null ? a.firstUpdate = a.lastUpdate = b : (a.lastUpdate.next = b, a.lastUpdate = b);
}
function Sf(a, b) {
  var c = a.alternate;
  if (c === null) {
    var d3 = a.updateQueue;
    var e = null;
    d3 === null && (d3 = a.updateQueue = Of(a.memoizedState));
  } else
    d3 = a.updateQueue, e = c.updateQueue, d3 === null ? e === null ? (d3 = a.updateQueue = Of(a.memoizedState), e = c.updateQueue = Of(c.memoizedState)) : d3 = a.updateQueue = Pf(e) : e === null && (e = c.updateQueue = Pf(d3));
  e === null || d3 === e ? Rf(d3, b) : d3.lastUpdate === null || e.lastUpdate === null ? (Rf(d3, b), Rf(e, b)) : (Rf(d3, b), e.lastUpdate = b);
}
function Tf(a, b) {
  var c = a.updateQueue;
  c = c === null ? a.updateQueue = Of(a.memoizedState) : Uf(a, c);
  c.lastCapturedUpdate === null ? c.firstCapturedUpdate = c.lastCapturedUpdate = b : (c.lastCapturedUpdate.next = b, c.lastCapturedUpdate = b);
}
function Uf(a, b) {
  var c = a.alternate;
  c !== null && b === c.updateQueue && (b = a.updateQueue = Pf(b));
  return b;
}
function Vf(a, b, c, d3, e, f2) {
  switch (c.tag) {
    case 1:
      return a = c.payload, typeof a === "function" ? a.call(f2, d3, e) : a;
    case 3:
      a.effectTag = a.effectTag & -2049 | 64;
    case 0:
      a = c.payload;
      e = typeof a === "function" ? a.call(f2, d3, e) : a;
      if (e === null || e === void 0)
        break;
      return m$1({}, d3, e);
    case 2:
      Nf = true;
  }
  return d3;
}
function Wf(a, b, c, d3, e) {
  Nf = false;
  b = Uf(a, b);
  for (var f2 = b.baseState, h = null, g2 = 0, k = b.firstUpdate, l = f2; k !== null; ) {
    var n2 = k.expirationTime;
    n2 < e ? (h === null && (h = k, f2 = l), g2 < n2 && (g2 = n2)) : (Xf(n2, k.suspenseConfig), l = Vf(a, b, k, l, c, d3), k.callback !== null && (a.effectTag |= 32, k.nextEffect = null, b.lastEffect === null ? b.firstEffect = b.lastEffect = k : (b.lastEffect.nextEffect = k, b.lastEffect = k)));
    k = k.next;
  }
  n2 = null;
  for (k = b.firstCapturedUpdate; k !== null; ) {
    var z = k.expirationTime;
    z < e ? (n2 === null && (n2 = k, h === null && (f2 = l)), g2 < z && (g2 = z)) : (l = Vf(a, b, k, l, c, d3), k.callback !== null && (a.effectTag |= 32, k.nextEffect = null, b.lastCapturedEffect === null ? b.firstCapturedEffect = b.lastCapturedEffect = k : (b.lastCapturedEffect.nextEffect = k, b.lastCapturedEffect = k)));
    k = k.next;
  }
  h === null && (b.lastUpdate = null);
  n2 === null ? b.lastCapturedUpdate = null : a.effectTag |= 32;
  h === null && n2 === null && (f2 = l);
  b.baseState = f2;
  b.firstUpdate = h;
  b.firstCapturedUpdate = n2;
  a.expirationTime = g2;
  a.memoizedState = l;
}
function Yf(a, b, c) {
  b.firstCapturedUpdate !== null && (b.lastUpdate !== null && (b.lastUpdate.next = b.firstCapturedUpdate, b.lastUpdate = b.lastCapturedUpdate), b.firstCapturedUpdate = b.lastCapturedUpdate = null);
  Zf(b.firstEffect, c);
  b.firstEffect = b.lastEffect = null;
  Zf(b.firstCapturedEffect, c);
  b.firstCapturedEffect = b.lastCapturedEffect = null;
}
function Zf(a, b) {
  for (; a !== null; ) {
    var c = a.callback;
    if (c !== null) {
      a.callback = null;
      var d3 = b;
      if (typeof c !== "function")
        throw t(Error(191), c);
      c.call(d3);
    }
    a = a.nextEffect;
  }
}
var $f = Xb.ReactCurrentBatchConfig, ag = new aa.Component().refs;
function bg(a, b, c, d3) {
  b = a.memoizedState;
  c = c(d3, b);
  c = c === null || c === void 0 ? b : m$1({}, b, c);
  a.memoizedState = c;
  d3 = a.updateQueue;
  d3 !== null && a.expirationTime === 0 && (d3.baseState = c);
}
var fg = { isMounted: function(a) {
  return (a = a._reactInternalFiber) ? ld(a) === 2 : false;
}, enqueueSetState: function(a, b, c) {
  a = a._reactInternalFiber;
  var d3 = cg(), e = $f.suspense;
  d3 = dg(d3, a, e);
  e = Qf(d3, e);
  e.payload = b;
  c !== void 0 && c !== null && (e.callback = c);
  Sf(a, e);
  eg(a, d3);
}, enqueueReplaceState: function(a, b, c) {
  a = a._reactInternalFiber;
  var d3 = cg(), e = $f.suspense;
  d3 = dg(d3, a, e);
  e = Qf(d3, e);
  e.tag = 1;
  e.payload = b;
  c !== void 0 && c !== null && (e.callback = c);
  Sf(a, e);
  eg(a, d3);
}, enqueueForceUpdate: function(a, b) {
  a = a._reactInternalFiber;
  var c = cg(), d3 = $f.suspense;
  c = dg(c, a, d3);
  d3 = Qf(c, d3);
  d3.tag = 2;
  b !== void 0 && b !== null && (d3.callback = b);
  Sf(a, d3);
  eg(a, c);
} };
function gg(a, b, c, d3, e, f2, h) {
  a = a.stateNode;
  return typeof a.shouldComponentUpdate === "function" ? a.shouldComponentUpdate(d3, f2, h) : b.prototype && b.prototype.isPureReactComponent ? !jd(c, d3) || !jd(e, f2) : true;
}
function hg(a, b, c) {
  var d3 = false, e = Qe;
  var f2 = b.contextType;
  typeof f2 === "object" && f2 !== null ? f2 = Mf(f2) : (e = N(b) ? Re : L.current, d3 = b.contextTypes, f2 = (d3 = d3 !== null && d3 !== void 0) ? Se(a, e) : Qe);
  b = new b(c, f2);
  a.memoizedState = b.state !== null && b.state !== void 0 ? b.state : null;
  b.updater = fg;
  a.stateNode = b;
  b._reactInternalFiber = a;
  d3 && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f2);
  return b;
}
function ig(a, b, c, d3) {
  a = b.state;
  typeof b.componentWillReceiveProps === "function" && b.componentWillReceiveProps(c, d3);
  typeof b.UNSAFE_componentWillReceiveProps === "function" && b.UNSAFE_componentWillReceiveProps(c, d3);
  b.state !== a && fg.enqueueReplaceState(b, b.state, null);
}
function jg(a, b, c, d3) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = ag;
  var f2 = b.contextType;
  typeof f2 === "object" && f2 !== null ? e.context = Mf(f2) : (f2 = N(b) ? Re : L.current, e.context = Se(a, f2));
  f2 = a.updateQueue;
  f2 !== null && (Wf(a, f2, c, e, d3), e.state = a.memoizedState);
  f2 = b.getDerivedStateFromProps;
  typeof f2 === "function" && (bg(a, b, f2, c), e.state = a.memoizedState);
  typeof b.getDerivedStateFromProps === "function" || typeof e.getSnapshotBeforeUpdate === "function" || typeof e.UNSAFE_componentWillMount !== "function" && typeof e.componentWillMount !== "function" || (b = e.state, typeof e.componentWillMount === "function" && e.componentWillMount(), typeof e.UNSAFE_componentWillMount === "function" && e.UNSAFE_componentWillMount(), b !== e.state && fg.enqueueReplaceState(e, e.state, null), f2 = a.updateQueue, f2 !== null && (Wf(a, f2, c, e, d3), e.state = a.memoizedState));
  typeof e.componentDidMount === "function" && (a.effectTag |= 4);
}
var kg = Array.isArray;
function lg(a, b, c) {
  a = c.ref;
  if (a !== null && typeof a !== "function" && typeof a !== "object") {
    if (c._owner) {
      c = c._owner;
      var d3 = void 0;
      if (c) {
        if (c.tag !== 1)
          throw t(Error(309));
        d3 = c.stateNode;
      }
      if (!d3)
        throw t(Error(147), a);
      var e = "" + a;
      if (b !== null && b.ref !== null && typeof b.ref === "function" && b.ref._stringRef === e)
        return b.ref;
      b = function(a2) {
        var b2 = d3.refs;
        b2 === ag && (b2 = d3.refs = {});
        a2 === null ? delete b2[e] : b2[e] = a2;
      };
      b._stringRef = e;
      return b;
    }
    if (typeof a !== "string")
      throw t(Error(284));
    if (!c._owner)
      throw t(Error(290), a);
  }
  return a;
}
function mg(a, b) {
  if (a.type !== "textarea")
    throw t(Error(31), Object.prototype.toString.call(b) === "[object Object]" ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function ng(a) {
  function b(b2, c2) {
    if (a) {
      var d4 = b2.lastEffect;
      d4 !== null ? (d4.nextEffect = c2, b2.lastEffect = c2) : b2.firstEffect = b2.lastEffect = c2;
      c2.nextEffect = null;
      c2.effectTag = 8;
    }
  }
  function c(c2, d4) {
    if (!a)
      return null;
    for (; d4 !== null; )
      b(c2, d4), d4 = d4.sibling;
    return null;
  }
  function d3(a2, b2) {
    for (a2 = /* @__PURE__ */ new Map(); b2 !== null; )
      b2.key !== null ? a2.set(b2.key, b2) : a2.set(b2.index, b2), b2 = b2.sibling;
    return a2;
  }
  function e(a2, b2, c2) {
    a2 = og(a2, b2);
    a2.index = 0;
    a2.sibling = null;
    return a2;
  }
  function f2(b2, c2, d4) {
    b2.index = d4;
    if (!a)
      return c2;
    d4 = b2.alternate;
    if (d4 !== null)
      return d4 = d4.index, d4 < c2 ? (b2.effectTag = 2, c2) : d4;
    b2.effectTag = 2;
    return c2;
  }
  function h(b2) {
    a && b2.alternate === null && (b2.effectTag = 2);
    return b2;
  }
  function g2(a2, b2, c2, d4) {
    if (b2 === null || b2.tag !== 6)
      return b2 = pg(c2, a2.mode, d4), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function k(a2, b2, c2, d4) {
    if (b2 !== null && b2.elementType === c2.type)
      return d4 = e(b2, c2.props), d4.ref = lg(a2, b2, c2), d4.return = a2, d4;
    d4 = qg(c2.type, c2.key, c2.props, null, a2.mode, d4);
    d4.ref = lg(a2, b2, c2);
    d4.return = a2;
    return d4;
  }
  function l(a2, b2, c2, d4) {
    if (b2 === null || b2.tag !== 4 || b2.stateNode.containerInfo !== c2.containerInfo || b2.stateNode.implementation !== c2.implementation)
      return b2 = rg(c2, a2.mode, d4), b2.return = a2, b2;
    b2 = e(b2, c2.children || []);
    b2.return = a2;
    return b2;
  }
  function n2(a2, b2, c2, d4, f3) {
    if (b2 === null || b2.tag !== 7)
      return b2 = sg(c2, a2.mode, d4, f3), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function z(a2, b2, c2) {
    if (typeof b2 === "string" || typeof b2 === "number")
      return b2 = pg("" + b2, a2.mode, c2), b2.return = a2, b2;
    if (typeof b2 === "object" && b2 !== null) {
      switch (b2.$$typeof) {
        case Zb:
          return c2 = qg(b2.type, b2.key, b2.props, null, a2.mode, c2), c2.ref = lg(a2, null, b2), c2.return = a2, c2;
        case $b:
          return b2 = rg(b2, a2.mode, c2), b2.return = a2, b2;
      }
      if (kg(b2) || mc(b2))
        return b2 = sg(b2, a2.mode, c2, null), b2.return = a2, b2;
      mg(a2, b2);
    }
    return null;
  }
  function x(a2, b2, c2, d4) {
    var e2 = b2 !== null ? b2.key : null;
    if (typeof c2 === "string" || typeof c2 === "number")
      return e2 !== null ? null : g2(a2, b2, "" + c2, d4);
    if (typeof c2 === "object" && c2 !== null) {
      switch (c2.$$typeof) {
        case Zb:
          return c2.key === e2 ? c2.type === ac ? n2(a2, b2, c2.props.children, d4, e2) : k(a2, b2, c2, d4) : null;
        case $b:
          return c2.key === e2 ? l(a2, b2, c2, d4) : null;
      }
      if (kg(c2) || mc(c2))
        return e2 !== null ? null : n2(a2, b2, c2, d4, null);
      mg(a2, c2);
    }
    return null;
  }
  function v(a2, b2, c2, d4, e2) {
    if (typeof d4 === "string" || typeof d4 === "number")
      return a2 = a2.get(c2) || null, g2(b2, a2, "" + d4, e2);
    if (typeof d4 === "object" && d4 !== null) {
      switch (d4.$$typeof) {
        case Zb:
          return a2 = a2.get(d4.key === null ? c2 : d4.key) || null, d4.type === ac ? n2(b2, a2, d4.props.children, e2, d4.key) : k(b2, a2, d4, e2);
        case $b:
          return a2 = a2.get(d4.key === null ? c2 : d4.key) || null, l(b2, a2, d4, e2);
      }
      if (kg(d4) || mc(d4))
        return a2 = a2.get(c2) || null, n2(b2, a2, d4, e2, null);
      mg(b2, d4);
    }
    return null;
  }
  function rb(e2, h2, g3, k2) {
    for (var l2 = null, u = null, n3 = h2, w2 = h2 = 0, C = null; n3 !== null && w2 < g3.length; w2++) {
      n3.index > w2 ? (C = n3, n3 = null) : C = n3.sibling;
      var p2 = x(e2, n3, g3[w2], k2);
      if (p2 === null) {
        n3 === null && (n3 = C);
        break;
      }
      a && n3 && p2.alternate === null && b(e2, n3);
      h2 = f2(p2, h2, w2);
      u === null ? l2 = p2 : u.sibling = p2;
      u = p2;
      n3 = C;
    }
    if (w2 === g3.length)
      return c(e2, n3), l2;
    if (n3 === null) {
      for (; w2 < g3.length; w2++)
        n3 = z(e2, g3[w2], k2), n3 !== null && (h2 = f2(n3, h2, w2), u === null ? l2 = n3 : u.sibling = n3, u = n3);
      return l2;
    }
    for (n3 = d3(e2, n3); w2 < g3.length; w2++)
      C = v(n3, e2, w2, g3[w2], k2), C !== null && (a && C.alternate !== null && n3.delete(C.key === null ? w2 : C.key), h2 = f2(C, h2, w2), u === null ? l2 = C : u.sibling = C, u = C);
    a && n3.forEach(function(a2) {
      return b(e2, a2);
    });
    return l2;
  }
  function Be(e2, h2, g3, k2) {
    var l2 = mc(g3);
    if (typeof l2 !== "function")
      throw t(Error(150));
    g3 = l2.call(g3);
    if (g3 == null)
      throw t(Error(151));
    for (var n3 = l2 = null, u = h2, w2 = h2 = 0, C = null, p2 = g3.next(); u !== null && !p2.done; w2++, p2 = g3.next()) {
      u.index > w2 ? (C = u, u = null) : C = u.sibling;
      var r2 = x(e2, u, p2.value, k2);
      if (r2 === null) {
        u === null && (u = C);
        break;
      }
      a && u && r2.alternate === null && b(e2, u);
      h2 = f2(r2, h2, w2);
      n3 === null ? l2 = r2 : n3.sibling = r2;
      n3 = r2;
      u = C;
    }
    if (p2.done)
      return c(e2, u), l2;
    if (u === null) {
      for (; !p2.done; w2++, p2 = g3.next())
        p2 = z(e2, p2.value, k2), p2 !== null && (h2 = f2(p2, h2, w2), n3 === null ? l2 = p2 : n3.sibling = p2, n3 = p2);
      return l2;
    }
    for (u = d3(e2, u); !p2.done; w2++, p2 = g3.next())
      p2 = v(u, e2, w2, p2.value, k2), p2 !== null && (a && p2.alternate !== null && u.delete(p2.key === null ? w2 : p2.key), h2 = f2(p2, h2, w2), n3 === null ? l2 = p2 : n3.sibling = p2, n3 = p2);
    a && u.forEach(function(a2) {
      return b(e2, a2);
    });
    return l2;
  }
  return function(a2, d4, f3, g3) {
    var k2 = typeof f3 === "object" && f3 !== null && f3.type === ac && f3.key === null;
    k2 && (f3 = f3.props.children);
    var l2 = typeof f3 === "object" && f3 !== null;
    if (l2)
      switch (f3.$$typeof) {
        case Zb:
          a: {
            l2 = f3.key;
            for (k2 = d4; k2 !== null; ) {
              if (k2.key === l2) {
                if (k2.tag === 7 ? f3.type === ac : k2.elementType === f3.type) {
                  c(a2, k2.sibling);
                  d4 = e(k2, f3.type === ac ? f3.props.children : f3.props);
                  d4.ref = lg(a2, k2, f3);
                  d4.return = a2;
                  a2 = d4;
                  break a;
                }
                c(a2, k2);
                break;
              } else
                b(a2, k2);
              k2 = k2.sibling;
            }
            f3.type === ac ? (d4 = sg(f3.props.children, a2.mode, g3, f3.key), d4.return = a2, a2 = d4) : (g3 = qg(f3.type, f3.key, f3.props, null, a2.mode, g3), g3.ref = lg(a2, d4, f3), g3.return = a2, a2 = g3);
          }
          return h(a2);
        case $b:
          a: {
            for (k2 = f3.key; d4 !== null; ) {
              if (d4.key === k2) {
                if (d4.tag === 4 && d4.stateNode.containerInfo === f3.containerInfo && d4.stateNode.implementation === f3.implementation) {
                  c(a2, d4.sibling);
                  d4 = e(d4, f3.children || []);
                  d4.return = a2;
                  a2 = d4;
                  break a;
                }
                c(a2, d4);
                break;
              } else
                b(a2, d4);
              d4 = d4.sibling;
            }
            d4 = rg(f3, a2.mode, g3);
            d4.return = a2;
            a2 = d4;
          }
          return h(a2);
      }
    if (typeof f3 === "string" || typeof f3 === "number")
      return f3 = "" + f3, d4 !== null && d4.tag === 6 ? (c(a2, d4.sibling), d4 = e(d4, f3), d4.return = a2, a2 = d4) : (c(a2, d4), d4 = pg(f3, a2.mode, g3), d4.return = a2, a2 = d4), h(a2);
    if (kg(f3))
      return rb(a2, d4, f3, g3);
    if (mc(f3))
      return Be(a2, d4, f3, g3);
    l2 && mg(a2, f3);
    if (typeof f3 === "undefined" && !k2)
      switch (a2.tag) {
        case 1:
        case 0:
          throw a2 = a2.type, t(Error(152), a2.displayName || a2.name || "Component");
      }
    return c(a2, d4);
  };
}
var tg = ng(true), ug = ng(false), vg = {}, wg = { current: vg }, xg = { current: vg }, yg = { current: vg };
function zg(a) {
  if (a === vg)
    throw t(Error(174));
  return a;
}
function Ag(a, b) {
  J(yg, b);
  J(xg, a);
  J(wg, vg);
  var c = b.nodeType;
  switch (c) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : te(null, "");
      break;
    default:
      c = c === 8 ? b.parentNode : b, b = c.namespaceURI || null, c = c.tagName, b = te(b, c);
  }
  H(wg);
  J(wg, b);
}
function Bg(a) {
  H(wg);
  H(xg);
  H(yg);
}
function Cg(a) {
  zg(yg.current);
  var b = zg(wg.current);
  var c = te(b, a.type);
  b !== c && (J(xg, a), J(wg, c));
}
function Dg(a) {
  xg.current === a && (H(wg), H(xg));
}
var Eg = 1, Fg = 1, Gg = 2, P = { current: 0 };
function Hg(a) {
  for (var b = a; b !== null; ) {
    if (b.tag === 13) {
      if (b.memoizedState !== null)
        return b;
    } else if (b.tag === 19 && b.memoizedProps.revealOrder !== void 0) {
      if ((b.effectTag & 64) !== 0)
        return b;
    } else if (b.child !== null) {
      b.child.return = b;
      b = b.child;
      continue;
    }
    if (b === a)
      break;
    for (; b.sibling === null; ) {
      if (b.return === null || b.return === a)
        return null;
      b = b.return;
    }
    b.sibling.return = b.return;
    b = b.sibling;
  }
  return null;
}
var Ig = 0, Jg = 2, Kg = 4, Lg = 8, Mg = 16, Ng = 32, Og = 64, Pg = 128, Qg = Xb.ReactCurrentDispatcher, Rg = 0, Sg = null, Q = null, Tg = null, Ug = null, R = null, Vg = null, Wg = 0, Xg = null, Yg = 0, Zg = false, $g = null, ah = 0;
function bh() {
  throw t(Error(321));
}
function ch(a, b) {
  if (b === null)
    return false;
  for (var c = 0; c < b.length && c < a.length; c++)
    if (!hd(a[c], b[c]))
      return false;
  return true;
}
function dh(a, b, c, d3, e, f2) {
  Rg = f2;
  Sg = b;
  Tg = a !== null ? a.memoizedState : null;
  Qg.current = Tg === null ? eh : fh;
  b = c(d3, e);
  if (Zg) {
    do
      Zg = false, ah += 1, Tg = a !== null ? a.memoizedState : null, Vg = Ug, Xg = R = Q = null, Qg.current = fh, b = c(d3, e);
    while (Zg);
    $g = null;
    ah = 0;
  }
  Qg.current = hh;
  a = Sg;
  a.memoizedState = Ug;
  a.expirationTime = Wg;
  a.updateQueue = Xg;
  a.effectTag |= Yg;
  a = Q !== null && Q.next !== null;
  Rg = 0;
  Vg = R = Ug = Tg = Q = Sg = null;
  Wg = 0;
  Xg = null;
  Yg = 0;
  if (a)
    throw t(Error(300));
  return b;
}
function ih() {
  Qg.current = hh;
  Rg = 0;
  Vg = R = Ug = Tg = Q = Sg = null;
  Wg = 0;
  Xg = null;
  Yg = 0;
  Zg = false;
  $g = null;
  ah = 0;
}
function jh() {
  var a = { memoizedState: null, baseState: null, queue: null, baseUpdate: null, next: null };
  R === null ? Ug = R = a : R = R.next = a;
  return R;
}
function kh() {
  if (Vg !== null)
    R = Vg, Vg = R.next, Q = Tg, Tg = Q !== null ? Q.next : null;
  else {
    if (Tg === null)
      throw t(Error(310));
    Q = Tg;
    var a = { memoizedState: Q.memoizedState, baseState: Q.baseState, queue: Q.queue, baseUpdate: Q.baseUpdate, next: null };
    R = R === null ? Ug = a : R.next = a;
    Tg = Q.next;
  }
  return R;
}
function lh(a, b) {
  return typeof b === "function" ? b(a) : b;
}
function mh(a) {
  var b = kh(), c = b.queue;
  if (c === null)
    throw t(Error(311));
  c.lastRenderedReducer = a;
  if (0 < ah) {
    var d3 = c.dispatch;
    if ($g !== null) {
      var e = $g.get(c);
      if (e !== void 0) {
        $g.delete(c);
        var f2 = b.memoizedState;
        do
          f2 = a(f2, e.action), e = e.next;
        while (e !== null);
        hd(f2, b.memoizedState) || (Lf = true);
        b.memoizedState = f2;
        b.baseUpdate === c.last && (b.baseState = f2);
        c.lastRenderedState = f2;
        return [f2, d3];
      }
    }
    return [b.memoizedState, d3];
  }
  d3 = c.last;
  var h = b.baseUpdate;
  f2 = b.baseState;
  h !== null ? (d3 !== null && (d3.next = null), d3 = h.next) : d3 = d3 !== null ? d3.next : null;
  if (d3 !== null) {
    var g2 = e = null, k = d3, l = false;
    do {
      var n2 = k.expirationTime;
      n2 < Rg ? (l || (l = true, g2 = h, e = f2), n2 > Wg && (Wg = n2)) : (Xf(n2, k.suspenseConfig), f2 = k.eagerReducer === a ? k.eagerState : a(f2, k.action));
      h = k;
      k = k.next;
    } while (k !== null && k !== d3);
    l || (g2 = h, e = f2);
    hd(f2, b.memoizedState) || (Lf = true);
    b.memoizedState = f2;
    b.baseUpdate = g2;
    b.baseState = e;
    c.lastRenderedState = f2;
  }
  return [b.memoizedState, c.dispatch];
}
function nh(a, b, c, d3) {
  a = { tag: a, create: b, destroy: c, deps: d3, next: null };
  Xg === null ? (Xg = { lastEffect: null }, Xg.lastEffect = a.next = a) : (b = Xg.lastEffect, b === null ? Xg.lastEffect = a.next = a : (c = b.next, b.next = a, a.next = c, Xg.lastEffect = a));
  return a;
}
function oh(a, b, c, d3) {
  var e = jh();
  Yg |= a;
  e.memoizedState = nh(b, c, void 0, d3 === void 0 ? null : d3);
}
function ph(a, b, c, d3) {
  var e = kh();
  d3 = d3 === void 0 ? null : d3;
  var f2 = void 0;
  if (Q !== null) {
    var h = Q.memoizedState;
    f2 = h.destroy;
    if (d3 !== null && ch(d3, h.deps)) {
      nh(Ig, c, f2, d3);
      return;
    }
  }
  Yg |= a;
  e.memoizedState = nh(b, c, f2, d3);
}
function qh(a, b) {
  if (typeof b === "function")
    return a = a(), b(a), function() {
      b(null);
    };
  if (b !== null && b !== void 0)
    return a = a(), b.current = a, function() {
      b.current = null;
    };
}
function rh() {
}
function sh(a, b, c) {
  if (!(25 > ah))
    throw t(Error(301));
  var d3 = a.alternate;
  if (a === Sg || d3 !== null && d3 === Sg)
    if (Zg = true, a = { expirationTime: Rg, suspenseConfig: null, action: c, eagerReducer: null, eagerState: null, next: null }, $g === null && ($g = /* @__PURE__ */ new Map()), c = $g.get(b), c === void 0)
      $g.set(b, a);
    else {
      for (b = c; b.next !== null; )
        b = b.next;
      b.next = a;
    }
  else {
    var e = cg(), f2 = $f.suspense;
    e = dg(e, a, f2);
    f2 = { expirationTime: e, suspenseConfig: f2, action: c, eagerReducer: null, eagerState: null, next: null };
    var h = b.last;
    if (h === null)
      f2.next = f2;
    else {
      var g2 = h.next;
      g2 !== null && (f2.next = g2);
      h.next = f2;
    }
    b.last = f2;
    if (a.expirationTime === 0 && (d3 === null || d3.expirationTime === 0) && (d3 = b.lastRenderedReducer, d3 !== null))
      try {
        var k = b.lastRenderedState, l = d3(k, c);
        f2.eagerReducer = d3;
        f2.eagerState = l;
        if (hd(l, k))
          return;
      } catch (n2) {
      } finally {
      }
    eg(a, e);
  }
}
var hh = { readContext: Mf, useCallback: bh, useContext: bh, useEffect: bh, useImperativeHandle: bh, useLayoutEffect: bh, useMemo: bh, useReducer: bh, useRef: bh, useState: bh, useDebugValue: bh, useResponder: bh }, eh = { readContext: Mf, useCallback: function(a, b) {
  jh().memoizedState = [a, b === void 0 ? null : b];
  return a;
}, useContext: Mf, useEffect: function(a, b) {
  return oh(516, Pg | Og, a, b);
}, useImperativeHandle: function(a, b, c) {
  c = c !== null && c !== void 0 ? c.concat([a]) : null;
  return oh(4, Kg | Ng, qh.bind(null, b, a), c);
}, useLayoutEffect: function(a, b) {
  return oh(4, Kg | Ng, a, b);
}, useMemo: function(a, b) {
  var c = jh();
  b = b === void 0 ? null : b;
  a = a();
  c.memoizedState = [a, b];
  return a;
}, useReducer: function(a, b, c) {
  var d3 = jh();
  b = c !== void 0 ? c(b) : b;
  d3.memoizedState = d3.baseState = b;
  a = d3.queue = { last: null, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };
  a = a.dispatch = sh.bind(null, Sg, a);
  return [d3.memoizedState, a];
}, useRef: function(a) {
  var b = jh();
  a = { current: a };
  return b.memoizedState = a;
}, useState: function(a) {
  var b = jh();
  typeof a === "function" && (a = a());
  b.memoizedState = b.baseState = a;
  a = b.queue = { last: null, dispatch: null, lastRenderedReducer: lh, lastRenderedState: a };
  a = a.dispatch = sh.bind(null, Sg, a);
  return [b.memoizedState, a];
}, useDebugValue: rh, useResponder: kd }, fh = { readContext: Mf, useCallback: function(a, b) {
  var c = kh();
  b = b === void 0 ? null : b;
  var d3 = c.memoizedState;
  if (d3 !== null && b !== null && ch(b, d3[1]))
    return d3[0];
  c.memoizedState = [a, b];
  return a;
}, useContext: Mf, useEffect: function(a, b) {
  return ph(516, Pg | Og, a, b);
}, useImperativeHandle: function(a, b, c) {
  c = c !== null && c !== void 0 ? c.concat([a]) : null;
  return ph(4, Kg | Ng, qh.bind(null, b, a), c);
}, useLayoutEffect: function(a, b) {
  return ph(4, Kg | Ng, a, b);
}, useMemo: function(a, b) {
  var c = kh();
  b = b === void 0 ? null : b;
  var d3 = c.memoizedState;
  if (d3 !== null && b !== null && ch(b, d3[1]))
    return d3[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}, useReducer: mh, useRef: function() {
  return kh().memoizedState;
}, useState: function(a) {
  return mh(lh);
}, useDebugValue: rh, useResponder: kd }, th = null, uh = null, vh = false;
function wh(a, b) {
  var c = xh(5, null, null, 0);
  c.elementType = "DELETED";
  c.type = "DELETED";
  c.stateNode = b;
  c.return = a;
  c.effectTag = 8;
  a.lastEffect !== null ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function yh(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = b.nodeType !== 1 || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return b !== null ? (a.stateNode = b, true) : false;
    case 6:
      return b = a.pendingProps === "" || b.nodeType !== 3 ? null : b, b !== null ? (a.stateNode = b, true) : false;
    case 13:
      return false;
    default:
      return false;
  }
}
function zh(a) {
  if (vh) {
    var b = uh;
    if (b) {
      var c = b;
      if (!yh(a, b)) {
        b = Ne(c.nextSibling);
        if (!b || !yh(a, b)) {
          a.effectTag |= 2;
          vh = false;
          th = a;
          return;
        }
        wh(th, c);
      }
      th = a;
      uh = Ne(b.firstChild);
    } else
      a.effectTag |= 2, vh = false, th = a;
  }
}
function Ah(a) {
  for (a = a.return; a !== null && a.tag !== 5 && a.tag !== 3 && a.tag !== 18; )
    a = a.return;
  th = a;
}
function Bh(a) {
  if (a !== th)
    return false;
  if (!vh)
    return Ah(a), vh = true, false;
  var b = a.type;
  if (a.tag !== 5 || b !== "head" && b !== "body" && !Ke(b, a.memoizedProps))
    for (b = uh; b; )
      wh(a, b), b = Ne(b.nextSibling);
  Ah(a);
  uh = th ? Ne(a.stateNode.nextSibling) : null;
  return true;
}
function Ch() {
  uh = th = null;
  vh = false;
}
var Dh = Xb.ReactCurrentOwner, Lf = false;
function S(a, b, c, d3) {
  b.child = a === null ? ug(b, null, c, d3) : tg(b, a.child, c, d3);
}
function Eh(a, b, c, d3, e) {
  c = c.render;
  var f2 = b.ref;
  Kf(b, e);
  d3 = dh(a, b, c, d3, f2, e);
  if (a !== null && !Lf)
    return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), Fh(a, b, e);
  b.effectTag |= 1;
  S(a, b, d3, e);
  return b.child;
}
function Gh(a, b, c, d3, e, f2) {
  if (a === null) {
    var h = c.type;
    if (typeof h === "function" && !Hh(h) && h.defaultProps === void 0 && c.compare === null && c.defaultProps === void 0)
      return b.tag = 15, b.type = h, Ih(a, b, h, d3, e, f2);
    a = qg(c.type, null, d3, null, b.mode, f2);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  h = a.child;
  if (e < f2 && (e = h.memoizedProps, c = c.compare, c = c !== null ? c : jd, c(e, d3) && a.ref === b.ref))
    return Fh(a, b, f2);
  b.effectTag |= 1;
  a = og(h, d3);
  a.ref = b.ref;
  a.return = b;
  return b.child = a;
}
function Ih(a, b, c, d3, e, f2) {
  return a !== null && jd(a.memoizedProps, d3) && a.ref === b.ref && (Lf = false, e < f2) ? Fh(a, b, f2) : Jh(a, b, c, d3, f2);
}
function Kh(a, b) {
  var c = b.ref;
  if (a === null && c !== null || a !== null && a.ref !== c)
    b.effectTag |= 128;
}
function Jh(a, b, c, d3, e) {
  var f2 = N(c) ? Re : L.current;
  f2 = Se(b, f2);
  Kf(b, e);
  c = dh(a, b, c, d3, f2, e);
  if (a !== null && !Lf)
    return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), Fh(a, b, e);
  b.effectTag |= 1;
  S(a, b, c, e);
  return b.child;
}
function Lh(a, b, c, d3, e) {
  if (N(c)) {
    var f2 = true;
    Xe(b);
  } else
    f2 = false;
  Kf(b, e);
  if (b.stateNode === null)
    a !== null && (a.alternate = null, b.alternate = null, b.effectTag |= 2), hg(b, c, d3), jg(b, c, d3, e), d3 = true;
  else if (a === null) {
    var h = b.stateNode, g2 = b.memoizedProps;
    h.props = g2;
    var k = h.context, l = c.contextType;
    typeof l === "object" && l !== null ? l = Mf(l) : (l = N(c) ? Re : L.current, l = Se(b, l));
    var n2 = c.getDerivedStateFromProps, z = typeof n2 === "function" || typeof h.getSnapshotBeforeUpdate === "function";
    z || typeof h.UNSAFE_componentWillReceiveProps !== "function" && typeof h.componentWillReceiveProps !== "function" || (g2 !== d3 || k !== l) && ig(b, h, d3, l);
    Nf = false;
    var x = b.memoizedState;
    k = h.state = x;
    var v = b.updateQueue;
    v !== null && (Wf(b, v, d3, h, e), k = b.memoizedState);
    g2 !== d3 || x !== k || M.current || Nf ? (typeof n2 === "function" && (bg(b, c, n2, d3), k = b.memoizedState), (g2 = Nf || gg(b, c, g2, d3, x, k, l)) ? (z || typeof h.UNSAFE_componentWillMount !== "function" && typeof h.componentWillMount !== "function" || (typeof h.componentWillMount === "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount === "function" && h.UNSAFE_componentWillMount()), typeof h.componentDidMount === "function" && (b.effectTag |= 4)) : (typeof h.componentDidMount === "function" && (b.effectTag |= 4), b.memoizedProps = d3, b.memoizedState = k), h.props = d3, h.state = k, h.context = l, d3 = g2) : (typeof h.componentDidMount === "function" && (b.effectTag |= 4), d3 = false);
  } else
    h = b.stateNode, g2 = b.memoizedProps, h.props = b.type === b.elementType ? g2 : Af(b.type, g2), k = h.context, l = c.contextType, typeof l === "object" && l !== null ? l = Mf(l) : (l = N(c) ? Re : L.current, l = Se(b, l)), n2 = c.getDerivedStateFromProps, (z = typeof n2 === "function" || typeof h.getSnapshotBeforeUpdate === "function") || typeof h.UNSAFE_componentWillReceiveProps !== "function" && typeof h.componentWillReceiveProps !== "function" || (g2 !== d3 || k !== l) && ig(b, h, d3, l), Nf = false, k = b.memoizedState, x = h.state = k, v = b.updateQueue, v !== null && (Wf(b, v, d3, h, e), x = b.memoizedState), g2 !== d3 || k !== x || M.current || Nf ? (typeof n2 === "function" && (bg(b, c, n2, d3), x = b.memoizedState), (n2 = Nf || gg(b, c, g2, d3, k, x, l)) ? (z || typeof h.UNSAFE_componentWillUpdate !== "function" && typeof h.componentWillUpdate !== "function" || (typeof h.componentWillUpdate === "function" && h.componentWillUpdate(d3, x, l), typeof h.UNSAFE_componentWillUpdate === "function" && h.UNSAFE_componentWillUpdate(d3, x, l)), typeof h.componentDidUpdate === "function" && (b.effectTag |= 4), typeof h.getSnapshotBeforeUpdate === "function" && (b.effectTag |= 256)) : (typeof h.componentDidUpdate !== "function" || g2 === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), typeof h.getSnapshotBeforeUpdate !== "function" || g2 === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d3, b.memoizedState = x), h.props = d3, h.state = x, h.context = l, d3 = n2) : (typeof h.componentDidUpdate !== "function" || g2 === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), typeof h.getSnapshotBeforeUpdate !== "function" || g2 === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d3 = false);
  return Mh(a, b, c, d3, f2, e);
}
function Mh(a, b, c, d3, e, f2) {
  Kh(a, b);
  var h = (b.effectTag & 64) !== 0;
  if (!d3 && !h)
    return e && Ye(b, c, false), Fh(a, b, f2);
  d3 = b.stateNode;
  Dh.current = b;
  var g2 = h && typeof c.getDerivedStateFromError !== "function" ? null : d3.render();
  b.effectTag |= 1;
  a !== null && h ? (b.child = tg(b, a.child, null, f2), b.child = tg(b, null, g2, f2)) : S(a, b, g2, f2);
  b.memoizedState = d3.state;
  e && Ye(b, c, true);
  return b.child;
}
function Nh(a) {
  var b = a.stateNode;
  b.pendingContext ? Ve(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ve(a, b.context, false);
  Ag(a, b.containerInfo);
}
var Oh = {};
function Ph(a, b, c) {
  var d3 = b.mode, e = b.pendingProps, f2 = P.current, h = null, g2 = false, k;
  (k = (b.effectTag & 64) !== 0) || (k = (f2 & Gg) !== 0 && (a === null || a.memoizedState !== null));
  k ? (h = Oh, g2 = true, b.effectTag &= -65) : a !== null && a.memoizedState === null || e.fallback === void 0 || e.unstable_avoidThisFallback === true || (f2 |= Fg);
  f2 &= Eg;
  J(P, f2);
  if (a === null)
    if (g2) {
      e = e.fallback;
      a = sg(null, d3, 0, null);
      a.return = b;
      if ((b.mode & 2) === 0)
        for (g2 = b.memoizedState !== null ? b.child.child : b.child, a.child = g2; g2 !== null; )
          g2.return = a, g2 = g2.sibling;
      c = sg(e, d3, c, null);
      c.return = b;
      a.sibling = c;
      d3 = a;
    } else
      d3 = c = ug(b, null, e.children, c);
  else {
    if (a.memoizedState !== null)
      if (f2 = a.child, d3 = f2.sibling, g2) {
        e = e.fallback;
        c = og(f2, f2.pendingProps);
        c.return = b;
        if ((b.mode & 2) === 0 && (g2 = b.memoizedState !== null ? b.child.child : b.child, g2 !== f2.child))
          for (c.child = g2; g2 !== null; )
            g2.return = c, g2 = g2.sibling;
        e = og(d3, e, d3.expirationTime);
        e.return = b;
        c.sibling = e;
        d3 = c;
        c.childExpirationTime = 0;
        c = e;
      } else
        d3 = c = tg(b, f2.child, e.children, c);
    else if (f2 = a.child, g2) {
      g2 = e.fallback;
      e = sg(null, d3, 0, null);
      e.return = b;
      e.child = f2;
      f2 !== null && (f2.return = e);
      if ((b.mode & 2) === 0)
        for (f2 = b.memoizedState !== null ? b.child.child : b.child, e.child = f2; f2 !== null; )
          f2.return = e, f2 = f2.sibling;
      c = sg(g2, d3, c, null);
      c.return = b;
      e.sibling = c;
      c.effectTag |= 2;
      d3 = e;
      e.childExpirationTime = 0;
    } else
      c = d3 = tg(b, f2, e.children, c);
    b.stateNode = a.stateNode;
  }
  b.memoizedState = h;
  b.child = d3;
  return c;
}
function Qh(a, b, c, d3, e) {
  var f2 = a.memoizedState;
  f2 === null ? a.memoizedState = { isBackwards: b, rendering: null, last: d3, tail: c, tailExpiration: 0, tailMode: e } : (f2.isBackwards = b, f2.rendering = null, f2.last = d3, f2.tail = c, f2.tailExpiration = 0, f2.tailMode = e);
}
function Rh(a, b, c) {
  var d3 = b.pendingProps, e = d3.revealOrder, f2 = d3.tail;
  S(a, b, d3.children, c);
  d3 = P.current;
  if ((d3 & Gg) !== 0)
    d3 = d3 & Eg | Gg, b.effectTag |= 64;
  else {
    if (a !== null && (a.effectTag & 64) !== 0)
      a:
        for (a = b.child; a !== null; ) {
          if (a.tag === 13) {
            if (a.memoizedState !== null) {
              a.expirationTime < c && (a.expirationTime = c);
              var h = a.alternate;
              h !== null && h.expirationTime < c && (h.expirationTime = c);
              Jf(a.return, c);
            }
          } else if (a.child !== null) {
            a.child.return = a;
            a = a.child;
            continue;
          }
          if (a === b)
            break a;
          for (; a.sibling === null; ) {
            if (a.return === null || a.return === b)
              break a;
            a = a.return;
          }
          a.sibling.return = a.return;
          a = a.sibling;
        }
    d3 &= Eg;
  }
  J(P, d3);
  if ((b.mode & 2) === 0)
    b.memoizedState = null;
  else
    switch (e) {
      case "forwards":
        c = b.child;
        for (e = null; c !== null; )
          d3 = c.alternate, d3 !== null && Hg(d3) === null && (e = c), c = c.sibling;
        c = e;
        c === null ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
        Qh(b, false, e, c, f2);
        break;
      case "backwards":
        c = null;
        e = b.child;
        for (b.child = null; e !== null; ) {
          d3 = e.alternate;
          if (d3 !== null && Hg(d3) === null) {
            b.child = e;
            break;
          }
          d3 = e.sibling;
          e.sibling = c;
          c = e;
          e = d3;
        }
        Qh(b, true, c, null, f2);
        break;
      case "together":
        Qh(b, false, null, null, void 0);
        break;
      default:
        b.memoizedState = null;
    }
  return b.child;
}
function Fh(a, b, c) {
  a !== null && (b.dependencies = a.dependencies);
  if (b.childExpirationTime < c)
    return null;
  if (a !== null && b.child !== a.child)
    throw t(Error(153));
  if (b.child !== null) {
    a = b.child;
    c = og(a, a.pendingProps, a.expirationTime);
    b.child = c;
    for (c.return = b; a.sibling !== null; )
      a = a.sibling, c = c.sibling = og(a, a.pendingProps, a.expirationTime), c.return = b;
    c.sibling = null;
  }
  return b.child;
}
function Sh(a) {
  a.effectTag |= 4;
}
var Th = void 0, Uh = void 0, Vh = void 0, Wh = void 0;
Th = function(a, b) {
  for (var c = b.child; c !== null; ) {
    if (c.tag === 5 || c.tag === 6)
      a.appendChild(c.stateNode);
    else if (c.tag === 20)
      a.appendChild(c.stateNode.instance);
    else if (c.tag !== 4 && c.child !== null) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === b)
      break;
    for (; c.sibling === null; ) {
      if (c.return === null || c.return === b)
        return;
      c = c.return;
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
};
Uh = function() {
};
Vh = function(a, b, c, d3, e) {
  var f2 = a.memoizedProps;
  if (f2 !== d3) {
    var h = b.stateNode;
    zg(wg.current);
    a = null;
    switch (c) {
      case "input":
        f2 = Bc(h, f2);
        d3 = Bc(h, d3);
        a = [];
        break;
      case "option":
        f2 = le(h, f2);
        d3 = le(h, d3);
        a = [];
        break;
      case "select":
        f2 = m$1({}, f2, { value: void 0 });
        d3 = m$1({}, d3, { value: void 0 });
        a = [];
        break;
      case "textarea":
        f2 = ne(h, f2);
        d3 = ne(h, d3);
        a = [];
        break;
      default:
        typeof f2.onClick !== "function" && typeof d3.onClick === "function" && (h.onclick = Ge);
    }
    De(c, d3);
    h = c = void 0;
    var g2 = null;
    for (c in f2)
      if (!d3.hasOwnProperty(c) && f2.hasOwnProperty(c) && f2[c] != null)
        if (c === "style") {
          var k = f2[c];
          for (h in k)
            k.hasOwnProperty(h) && (g2 || (g2 = {}), g2[h] = "");
        } else
          c !== "dangerouslySetInnerHTML" && c !== "children" && c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && c !== "autoFocus" && (ia.hasOwnProperty(c) ? a || (a = []) : (a = a || []).push(c, null));
    for (c in d3) {
      var l = d3[c];
      k = f2 != null ? f2[c] : void 0;
      if (d3.hasOwnProperty(c) && l !== k && (l != null || k != null))
        if (c === "style")
          if (k) {
            for (h in k)
              !k.hasOwnProperty(h) || l && l.hasOwnProperty(h) || (g2 || (g2 = {}), g2[h] = "");
            for (h in l)
              l.hasOwnProperty(h) && k[h] !== l[h] && (g2 || (g2 = {}), g2[h] = l[h]);
          } else
            g2 || (a || (a = []), a.push(c, g2)), g2 = l;
        else
          c === "dangerouslySetInnerHTML" ? (l = l ? l.__html : void 0, k = k ? k.__html : void 0, l != null && k !== l && (a = a || []).push(c, "" + l)) : c === "children" ? k === l || typeof l !== "string" && typeof l !== "number" || (a = a || []).push(c, "" + l) : c !== "suppressContentEditableWarning" && c !== "suppressHydrationWarning" && (ia.hasOwnProperty(c) ? (l != null && Fe(e, c), a || k === l || (a = [])) : (a = a || []).push(c, l));
    }
    g2 && (a = a || []).push("style", g2);
    e = a;
    (b.updateQueue = e) && Sh(b);
  }
};
Wh = function(a, b, c, d3) {
  c !== d3 && Sh(b);
};
function $h(a, b) {
  switch (a.tailMode) {
    case "hidden":
      b = a.tail;
      for (var c = null; b !== null; )
        b.alternate !== null && (c = b), b = b.sibling;
      c === null ? a.tail = null : c.sibling = null;
      break;
    case "collapsed":
      c = a.tail;
      for (var d3 = null; c !== null; )
        c.alternate !== null && (d3 = c), c = c.sibling;
      d3 === null ? b || a.tail === null ? a.tail = null : a.tail.sibling = null : d3.sibling = null;
  }
}
function ai(a) {
  switch (a.tag) {
    case 1:
      N(a.type) && Te();
      var b = a.effectTag;
      return b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
    case 3:
      Bg();
      Ue();
      b = a.effectTag;
      if ((b & 64) !== 0)
        throw t(Error(285));
      a.effectTag = b & -2049 | 64;
      return a;
    case 5:
      return Dg(a), null;
    case 13:
      return H(P), b = a.effectTag, b & 2048 ? (a.effectTag = b & -2049 | 64, a) : null;
    case 18:
      return null;
    case 19:
      return H(P), null;
    case 4:
      return Bg(), null;
    case 10:
      return If(a), null;
    default:
      return null;
  }
}
function bi(a, b) {
  return { value: a, source: b, stack: pc(b) };
}
var ci = typeof WeakSet === "function" ? WeakSet : Set;
function di(a, b) {
  var c = b.source, d3 = b.stack;
  d3 === null && c !== null && (d3 = pc(c));
  c !== null && oc(c.type);
  b = b.value;
  a !== null && a.tag === 1 && oc(a.type);
  try {
    console.error(b);
  } catch (e) {
    setTimeout(function() {
      throw e;
    });
  }
}
function ei(a, b) {
  try {
    b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
  } catch (c) {
    fi(a, c);
  }
}
function gi(a) {
  var b = a.ref;
  if (b !== null)
    if (typeof b === "function")
      try {
        b(null);
      } catch (c) {
        fi(a, c);
      }
    else
      b.current = null;
}
function hi(a, b, c) {
  c = c.updateQueue;
  c = c !== null ? c.lastEffect : null;
  if (c !== null) {
    var d3 = c = c.next;
    do {
      if ((d3.tag & a) !== Ig) {
        var e = d3.destroy;
        d3.destroy = void 0;
        e !== void 0 && e();
      }
      (d3.tag & b) !== Ig && (e = d3.create, d3.destroy = e());
      d3 = d3.next;
    } while (d3 !== c);
  }
}
function ii(a, b) {
  typeof ji === "function" && ji(a);
  switch (a.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      var c = a.updateQueue;
      if (c !== null && (c = c.lastEffect, c !== null)) {
        var d3 = c.next;
        vf(97 < b ? 97 : b, function() {
          var b2 = d3;
          do {
            var c2 = b2.destroy;
            if (c2 !== void 0) {
              var h = a;
              try {
                c2();
              } catch (g2) {
                fi(h, g2);
              }
            }
            b2 = b2.next;
          } while (b2 !== d3);
        });
      }
      break;
    case 1:
      gi(a);
      b = a.stateNode;
      typeof b.componentWillUnmount === "function" && ei(a, b);
      break;
    case 5:
      gi(a);
      break;
    case 4:
      ki(a, b);
  }
}
function li(a, b) {
  for (var c = a; ; )
    if (ii(c, b), c.child !== null && c.tag !== 4)
      c.child.return = c, c = c.child;
    else {
      if (c === a)
        break;
      for (; c.sibling === null; ) {
        if (c.return === null || c.return === a)
          return;
        c = c.return;
      }
      c.sibling.return = c.return;
      c = c.sibling;
    }
}
function mi(a) {
  return a.tag === 5 || a.tag === 3 || a.tag === 4;
}
function ni(a) {
  a: {
    for (var b = a.return; b !== null; ) {
      if (mi(b)) {
        var c = b;
        break a;
      }
      b = b.return;
    }
    throw t(Error(160));
  }
  b = c.stateNode;
  switch (c.tag) {
    case 5:
      var d3 = false;
      break;
    case 3:
      b = b.containerInfo;
      d3 = true;
      break;
    case 4:
      b = b.containerInfo;
      d3 = true;
      break;
    default:
      throw t(Error(161));
  }
  c.effectTag & 16 && (we(b, ""), c.effectTag &= -17);
  a:
    b:
      for (c = a; ; ) {
        for (; c.sibling === null; ) {
          if (c.return === null || mi(c.return)) {
            c = null;
            break a;
          }
          c = c.return;
        }
        c.sibling.return = c.return;
        for (c = c.sibling; c.tag !== 5 && c.tag !== 6 && c.tag !== 18; ) {
          if (c.effectTag & 2)
            continue b;
          if (c.child === null || c.tag === 4)
            continue b;
          else
            c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
          c = c.stateNode;
          break a;
        }
      }
  for (var e = a; ; ) {
    var f2 = e.tag === 5 || e.tag === 6;
    if (f2 || e.tag === 20) {
      var h = f2 ? e.stateNode : e.stateNode.instance;
      if (c)
        if (d3) {
          f2 = b;
          var g2 = h;
          h = c;
          f2.nodeType === 8 ? f2.parentNode.insertBefore(g2, h) : f2.insertBefore(g2, h);
        } else
          b.insertBefore(h, c);
      else
        d3 ? (g2 = b, g2.nodeType === 8 ? (f2 = g2.parentNode, f2.insertBefore(h, g2)) : (f2 = g2, f2.appendChild(h)), g2 = g2._reactRootContainer, g2 !== null && g2 !== void 0 || f2.onclick !== null || (f2.onclick = Ge)) : b.appendChild(h);
    } else if (e.tag !== 4 && e.child !== null) {
      e.child.return = e;
      e = e.child;
      continue;
    }
    if (e === a)
      break;
    for (; e.sibling === null; ) {
      if (e.return === null || e.return === a)
        return;
      e = e.return;
    }
    e.sibling.return = e.return;
    e = e.sibling;
  }
}
function ki(a, b) {
  for (var c = a, d3 = false, e = void 0, f2 = void 0; ; ) {
    if (!d3) {
      d3 = c.return;
      a:
        for (; ; ) {
          if (d3 === null)
            throw t(Error(160));
          e = d3.stateNode;
          switch (d3.tag) {
            case 5:
              f2 = false;
              break a;
            case 3:
              e = e.containerInfo;
              f2 = true;
              break a;
            case 4:
              e = e.containerInfo;
              f2 = true;
              break a;
          }
          d3 = d3.return;
        }
      d3 = true;
    }
    if (c.tag === 5 || c.tag === 6)
      if (li(c, b), f2) {
        var h = e, g2 = c.stateNode;
        h.nodeType === 8 ? h.parentNode.removeChild(g2) : h.removeChild(g2);
      } else
        e.removeChild(c.stateNode);
    else if (c.tag === 20)
      g2 = c.stateNode.instance, li(c, b), f2 ? (h = e, h.nodeType === 8 ? h.parentNode.removeChild(g2) : h.removeChild(g2)) : e.removeChild(g2);
    else if (c.tag === 4) {
      if (c.child !== null) {
        e = c.stateNode.containerInfo;
        f2 = true;
        c.child.return = c;
        c = c.child;
        continue;
      }
    } else if (ii(c, b), c.child !== null) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === a)
      break;
    for (; c.sibling === null; ) {
      if (c.return === null || c.return === a)
        return;
      c = c.return;
      c.tag === 4 && (d3 = false);
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
}
function oi(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
      hi(Kg, Lg, b);
      break;
    case 1:
      break;
    case 5:
      var c = b.stateNode;
      if (c != null) {
        var d3 = b.memoizedProps, e = a !== null ? a.memoizedProps : d3;
        a = b.type;
        var f2 = b.updateQueue;
        b.updateQueue = null;
        if (f2 !== null) {
          c[Ga] = d3;
          a === "input" && d3.type === "radio" && d3.name != null && Dc(c, d3);
          Ee(a, e);
          b = Ee(a, d3);
          for (e = 0; e < f2.length; e += 2) {
            var h = f2[e], g2 = f2[e + 1];
            h === "style" ? Ae(c, g2) : h === "dangerouslySetInnerHTML" ? ve(c, g2) : h === "children" ? we(c, g2) : zc(c, h, g2, b);
          }
          switch (a) {
            case "input":
              Ec(c, d3);
              break;
            case "textarea":
              pe(c, d3);
              break;
            case "select":
              b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d3.multiple, a = d3.value, a != null ? me(c, !!d3.multiple, a, false) : b !== !!d3.multiple && (d3.defaultValue != null ? me(c, !!d3.multiple, d3.defaultValue, true) : me(c, !!d3.multiple, d3.multiple ? [] : "", false));
          }
        }
      }
      break;
    case 6:
      if (b.stateNode === null)
        throw t(Error(162));
      b.stateNode.nodeValue = b.memoizedProps;
      break;
    case 3:
      break;
    case 12:
      break;
    case 13:
      c = b;
      b.memoizedState === null ? d3 = false : (d3 = true, c = b.child, pi = sf());
      if (c !== null)
        a:
          for (a = c; ; ) {
            if (a.tag === 5)
              f2 = a.stateNode, d3 ? (f2 = f2.style, typeof f2.setProperty === "function" ? f2.setProperty("display", "none", "important") : f2.display = "none") : (f2 = a.stateNode, e = a.memoizedProps.style, e = e !== void 0 && e !== null && e.hasOwnProperty("display") ? e.display : null, f2.style.display = ze("display", e));
            else if (a.tag === 6)
              a.stateNode.nodeValue = d3 ? "" : a.memoizedProps;
            else if (a.tag === 13 && a.memoizedState !== null) {
              f2 = a.child.sibling;
              f2.return = a;
              a = f2;
              continue;
            } else if (a.child !== null) {
              a.child.return = a;
              a = a.child;
              continue;
            }
            if (a === c)
              break a;
            for (; a.sibling === null; ) {
              if (a.return === null || a.return === c)
                break a;
              a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
          }
      qi(b);
      break;
    case 19:
      qi(b);
      break;
    case 17:
      break;
    case 20:
      break;
    default:
      throw t(Error(163));
  }
}
function qi(a) {
  var b = a.updateQueue;
  if (b !== null) {
    a.updateQueue = null;
    var c = a.stateNode;
    c === null && (c = a.stateNode = new ci());
    b.forEach(function(b2) {
      var d3 = ri.bind(null, a, b2);
      c.has(b2) || (c.add(b2), b2.then(d3, d3));
    });
  }
}
var si = typeof WeakMap === "function" ? WeakMap : Map;
function ti(a, b, c) {
  c = Qf(c, null);
  c.tag = 3;
  c.payload = { element: null };
  var d3 = b.value;
  c.callback = function() {
    ui || (ui = true, vi = d3);
    di(a, b);
  };
  return c;
}
function wi(a, b, c) {
  c = Qf(c, null);
  c.tag = 3;
  var d3 = a.type.getDerivedStateFromError;
  if (typeof d3 === "function") {
    var e = b.value;
    c.payload = function() {
      di(a, b);
      return d3(e);
    };
  }
  var f2 = a.stateNode;
  f2 !== null && typeof f2.componentDidCatch === "function" && (c.callback = function() {
    typeof d3 !== "function" && (xi === null ? xi = /* @__PURE__ */ new Set([this]) : xi.add(this), di(a, b));
    var c2 = b.stack;
    this.componentDidCatch(b.value, { componentStack: c2 !== null ? c2 : "" });
  });
  return c;
}
var yi = Math.ceil, zi = Xb.ReactCurrentDispatcher, Ai = Xb.ReactCurrentOwner, T = 0, Bi = 8, Ci = 16, Di = 32, Ei = 0, Fi = 1, Gi = 2, Hi = 3, Ii = 4, U = T, Ji = null, V = null, W = 0, X = Ei, Ki = 1073741823, Li = 1073741823, Mi = null, Ni = false, pi = 0, Oi = 500, Y = null, ui = false, vi = null, xi = null, Pi = false, Qi = null, Ri = 90, Si = 0, Ti = null, Ui = 0, Vi = null, Wi = 0;
function cg() {
  return (U & (Ci | Di)) !== T ? 1073741821 - (sf() / 10 | 0) : Wi !== 0 ? Wi : Wi = 1073741821 - (sf() / 10 | 0);
}
function dg(a, b, c) {
  b = b.mode;
  if ((b & 2) === 0)
    return 1073741823;
  var d3 = tf();
  if ((b & 4) === 0)
    return d3 === 99 ? 1073741823 : 1073741822;
  if ((U & Ci) !== T)
    return W;
  if (c !== null)
    a = 1073741821 - 25 * (((1073741821 - a + (c.timeoutMs | 0 || 5e3) / 10) / 25 | 0) + 1);
  else
    switch (d3) {
      case 99:
        a = 1073741823;
        break;
      case 98:
        a = 1073741821 - 10 * (((1073741821 - a + 15) / 10 | 0) + 1);
        break;
      case 97:
      case 96:
        a = 1073741821 - 25 * (((1073741821 - a + 500) / 25 | 0) + 1);
        break;
      case 95:
        a = 1;
        break;
      default:
        throw t(Error(326));
    }
  Ji !== null && a === W && --a;
  return a;
}
var Xi = 0;
function eg(a, b) {
  if (50 < Ui)
    throw Ui = 0, Vi = null, t(Error(185));
  a = Yi(a, b);
  if (a !== null) {
    a.pingTime = 0;
    var c = tf();
    if (b === 1073741823)
      if ((U & Bi) !== T && (U & (Ci | Di)) === T)
        for (var d3 = Z(a, 1073741823, true); d3 !== null; )
          d3 = d3(true);
      else
        Zi(a, 99, 1073741823), U === T && O();
    else
      Zi(a, c, b);
    (U & 4) === T || c !== 98 && c !== 99 || (Ti === null ? Ti = /* @__PURE__ */ new Map([[a, b]]) : (c = Ti.get(a), (c === void 0 || c > b) && Ti.set(a, b)));
  }
}
function Yi(a, b) {
  a.expirationTime < b && (a.expirationTime = b);
  var c = a.alternate;
  c !== null && c.expirationTime < b && (c.expirationTime = b);
  var d3 = a.return, e = null;
  if (d3 === null && a.tag === 3)
    e = a.stateNode;
  else
    for (; d3 !== null; ) {
      c = d3.alternate;
      d3.childExpirationTime < b && (d3.childExpirationTime = b);
      c !== null && c.childExpirationTime < b && (c.childExpirationTime = b);
      if (d3.return === null && d3.tag === 3) {
        e = d3.stateNode;
        break;
      }
      d3 = d3.return;
    }
  e !== null && (b > e.firstPendingTime && (e.firstPendingTime = b), a = e.lastPendingTime, a === 0 || b < a) && (e.lastPendingTime = b);
  return e;
}
function Zi(a, b, c) {
  if (a.callbackExpirationTime < c) {
    var d3 = a.callbackNode;
    d3 !== null && d3 !== mf && af(d3);
    a.callbackExpirationTime = c;
    c === 1073741823 ? a.callbackNode = xf($i.bind(null, a, Z.bind(null, a, c))) : (d3 = null, c !== 1 && (d3 = { timeout: 10 * (1073741821 - c) - sf() }), a.callbackNode = wf(b, $i.bind(null, a, Z.bind(null, a, c)), d3));
  }
}
function $i(a, b, c) {
  var d3 = a.callbackNode, e = null;
  try {
    return e = b(c), e !== null ? $i.bind(null, a, e) : null;
  } finally {
    e === null && d3 === a.callbackNode && (a.callbackNode = null, a.callbackExpirationTime = 0);
  }
}
function aj() {
  (U & (1 | Ci | Di)) === T && (bj(), cj());
}
function dj(a, b) {
  var c = a.firstBatch;
  return c !== null && c._defer && c._expirationTime >= b ? (wf(97, function() {
    c._onComplete();
    return null;
  }), true) : false;
}
function bj() {
  if (Ti !== null) {
    var a = Ti;
    Ti = null;
    a.forEach(function(a2, c) {
      xf(Z.bind(null, c, a2));
    });
    O();
  }
}
function ej(a, b) {
  var c = U;
  U |= 1;
  try {
    return a(b);
  } finally {
    U = c, U === T && O();
  }
}
function fj(a, b, c, d3) {
  var e = U;
  U |= 4;
  try {
    return vf(98, a.bind(null, b, c, d3));
  } finally {
    U = e, U === T && O();
  }
}
function gj(a, b) {
  var c = U;
  U &= -2;
  U |= Bi;
  try {
    return a(b);
  } finally {
    U = c, U === T && O();
  }
}
function hj(a, b) {
  a.finishedWork = null;
  a.finishedExpirationTime = 0;
  var c = a.timeoutHandle;
  c !== -1 && (a.timeoutHandle = -1, Me(c));
  if (V !== null)
    for (c = V.return; c !== null; ) {
      var d3 = c;
      switch (d3.tag) {
        case 1:
          var e = d3.type.childContextTypes;
          e !== null && e !== void 0 && Te();
          break;
        case 3:
          Bg();
          Ue();
          break;
        case 5:
          Dg(d3);
          break;
        case 4:
          Bg();
          break;
        case 13:
          H(P);
          break;
        case 19:
          H(P);
          break;
        case 10:
          If(d3);
      }
      c = c.return;
    }
  Ji = a;
  V = og(a.current, null);
  W = b;
  X = Ei;
  Li = Ki = 1073741823;
  Mi = null;
  Ni = false;
}
function Z(a, b, c) {
  if ((U & (Ci | Di)) !== T)
    throw t(Error(327));
  if (a.firstPendingTime < b)
    return null;
  if (c && a.finishedExpirationTime === b)
    return ij.bind(null, a);
  cj();
  if (a !== Ji || b !== W)
    hj(a, b);
  else if (X === Hi)
    if (Ni)
      hj(a, b);
    else {
      var d3 = a.lastPendingTime;
      if (d3 < b)
        return Z.bind(null, a, d3);
    }
  if (V !== null) {
    d3 = U;
    U |= Ci;
    var e = zi.current;
    e === null && (e = hh);
    zi.current = hh;
    if (c) {
      if (b !== 1073741823) {
        var f2 = cg();
        if (f2 < b)
          return U = d3, Gf(), zi.current = e, Z.bind(null, a, f2);
      }
    } else
      Wi = 0;
    do
      try {
        if (c)
          for (; V !== null; )
            V = jj(V);
        else
          for (; V !== null && !bf(); )
            V = jj(V);
        break;
      } catch (rb) {
        Gf();
        ih();
        f2 = V;
        if (f2 === null || f2.return === null)
          throw hj(a, b), U = d3, rb;
        a: {
          var h = a, g2 = f2.return, k = f2, l = rb, n2 = W;
          k.effectTag |= 1024;
          k.firstEffect = k.lastEffect = null;
          if (l !== null && typeof l === "object" && typeof l.then === "function") {
            var z = l, x = (P.current & Fg) !== 0;
            l = g2;
            do {
              var v;
              if (v = l.tag === 13)
                l.memoizedState !== null ? v = false : (v = l.memoizedProps, v = v.fallback === void 0 ? false : v.unstable_avoidThisFallback !== true ? true : x ? false : true);
              if (v) {
                g2 = l.updateQueue;
                g2 === null ? (g2 = /* @__PURE__ */ new Set(), g2.add(z), l.updateQueue = g2) : g2.add(z);
                if ((l.mode & 2) === 0) {
                  l.effectTag |= 64;
                  k.effectTag &= -1957;
                  k.tag === 1 && (k.alternate === null ? k.tag = 17 : (n2 = Qf(1073741823, null), n2.tag = 2, Sf(k, n2)));
                  k.expirationTime = 1073741823;
                  break a;
                }
                k = h;
                h = n2;
                x = k.pingCache;
                x === null ? (x = k.pingCache = new si(), g2 = /* @__PURE__ */ new Set(), x.set(z, g2)) : (g2 = x.get(z), g2 === void 0 && (g2 = /* @__PURE__ */ new Set(), x.set(z, g2)));
                g2.has(h) || (g2.add(h), k = kj.bind(null, k, z, h), z.then(k, k));
                l.effectTag |= 2048;
                l.expirationTime = n2;
                break a;
              }
              l = l.return;
            } while (l !== null);
            l = Error((oc(k.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + pc(k));
          }
          X !== Ii && (X = Fi);
          l = bi(l, k);
          k = g2;
          do {
            switch (k.tag) {
              case 3:
                k.effectTag |= 2048;
                k.expirationTime = n2;
                n2 = ti(k, l, n2);
                Tf(k, n2);
                break a;
              case 1:
                if (z = l, h = k.type, g2 = k.stateNode, (k.effectTag & 64) === 0 && (typeof h.getDerivedStateFromError === "function" || g2 !== null && typeof g2.componentDidCatch === "function" && (xi === null || !xi.has(g2)))) {
                  k.effectTag |= 2048;
                  k.expirationTime = n2;
                  n2 = wi(k, z, n2);
                  Tf(k, n2);
                  break a;
                }
            }
            k = k.return;
          } while (k !== null);
        }
        V = lj(f2);
      }
    while (1);
    U = d3;
    Gf();
    zi.current = e;
    if (V !== null)
      return Z.bind(null, a, b);
  }
  a.finishedWork = a.current.alternate;
  a.finishedExpirationTime = b;
  if (dj(a, b))
    return null;
  Ji = null;
  switch (X) {
    case Ei:
      throw t(Error(328));
    case Fi:
      return d3 = a.lastPendingTime, d3 < b ? Z.bind(null, a, d3) : c ? ij.bind(null, a) : (hj(a, b), xf(Z.bind(null, a, b)), null);
    case Gi:
      if (Ki === 1073741823 && !c && (c = pi + Oi - sf(), 10 < c)) {
        if (Ni)
          return hj(a, b), Z.bind(null, a, b);
        d3 = a.lastPendingTime;
        if (d3 < b)
          return Z.bind(null, a, d3);
        a.timeoutHandle = Le(ij.bind(null, a), c);
        return null;
      }
      return ij.bind(null, a);
    case Hi:
      if (!c) {
        if (Ni)
          return hj(a, b), Z.bind(null, a, b);
        c = a.lastPendingTime;
        if (c < b)
          return Z.bind(null, a, c);
        Li !== 1073741823 ? c = 10 * (1073741821 - Li) - sf() : Ki === 1073741823 ? c = 0 : (c = 10 * (1073741821 - Ki) - 5e3, d3 = sf(), b = 10 * (1073741821 - b) - d3, c = d3 - c, 0 > c && (c = 0), c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3e3 > c ? 3e3 : 4320 > c ? 4320 : 1960 * yi(c / 1960)) - c, b < c && (c = b));
        if (10 < c)
          return a.timeoutHandle = Le(ij.bind(null, a), c), null;
      }
      return ij.bind(null, a);
    case Ii:
      return !c && Ki !== 1073741823 && Mi !== null && (d3 = Ki, e = Mi, b = e.busyMinDurationMs | 0, 0 >= b ? b = 0 : (c = e.busyDelayMs | 0, d3 = sf() - (10 * (1073741821 - d3) - (e.timeoutMs | 0 || 5e3)), b = d3 <= c ? 0 : c + b - d3), 10 < b) ? (a.timeoutHandle = Le(ij.bind(null, a), b), null) : ij.bind(null, a);
    default:
      throw t(Error(329));
  }
}
function Xf(a, b) {
  a < Ki && 1 < a && (Ki = a);
  b !== null && a < Li && 1 < a && (Li = a, Mi = b);
}
function jj(a) {
  var b = mj(a.alternate, a, W);
  a.memoizedProps = a.pendingProps;
  b === null && (b = lj(a));
  Ai.current = null;
  return b;
}
function lj(a) {
  V = a;
  do {
    var b = V.alternate;
    a = V.return;
    if ((V.effectTag & 1024) === 0) {
      a: {
        var c = b;
        b = V;
        var d3 = W, e = b.pendingProps;
        switch (b.tag) {
          case 2:
            break;
          case 16:
            break;
          case 15:
          case 0:
            break;
          case 1:
            N(b.type) && Te();
            break;
          case 3:
            Bg();
            Ue();
            d3 = b.stateNode;
            d3.pendingContext && (d3.context = d3.pendingContext, d3.pendingContext = null);
            if (c === null || c.child === null)
              Bh(b), b.effectTag &= -3;
            Uh(b);
            break;
          case 5:
            Dg(b);
            d3 = zg(yg.current);
            var f2 = b.type;
            if (c !== null && b.stateNode != null)
              Vh(c, b, f2, e, d3), c.ref !== b.ref && (b.effectTag |= 128);
            else if (e) {
              var h = zg(wg.current);
              if (Bh(b)) {
                c = b;
                e = void 0;
                f2 = c.stateNode;
                var g2 = c.type, k = c.memoizedProps;
                f2[Fa] = c;
                f2[Ga] = k;
                switch (g2) {
                  case "iframe":
                  case "object":
                  case "embed":
                    G("load", f2);
                    break;
                  case "video":
                  case "audio":
                    for (var l = 0; l < bb.length; l++)
                      G(bb[l], f2);
                    break;
                  case "source":
                    G("error", f2);
                    break;
                  case "img":
                  case "image":
                  case "link":
                    G("error", f2);
                    G("load", f2);
                    break;
                  case "form":
                    G("reset", f2);
                    G("submit", f2);
                    break;
                  case "details":
                    G("toggle", f2);
                    break;
                  case "input":
                    Cc(f2, k);
                    G("invalid", f2);
                    Fe(d3, "onChange");
                    break;
                  case "select":
                    f2._wrapperState = { wasMultiple: !!k.multiple };
                    G("invalid", f2);
                    Fe(d3, "onChange");
                    break;
                  case "textarea":
                    oe(f2, k), G("invalid", f2), Fe(d3, "onChange");
                }
                De(g2, k);
                l = null;
                for (e in k)
                  k.hasOwnProperty(e) && (h = k[e], e === "children" ? typeof h === "string" ? f2.textContent !== h && (l = ["children", h]) : typeof h === "number" && f2.textContent !== "" + h && (l = ["children", "" + h]) : ia.hasOwnProperty(e) && h != null && Fe(d3, e));
                switch (g2) {
                  case "input":
                    Vb(f2);
                    Gc(f2, k, true);
                    break;
                  case "textarea":
                    Vb(f2);
                    qe(f2);
                    break;
                  case "select":
                  case "option":
                    break;
                  default:
                    typeof k.onClick === "function" && (f2.onclick = Ge);
                }
                d3 = l;
                c.updateQueue = d3;
                d3 !== null && Sh(b);
              } else {
                k = f2;
                c = e;
                g2 = b;
                l = d3.nodeType === 9 ? d3 : d3.ownerDocument;
                h === re.html && (h = se(k));
                h === re.html ? k === "script" ? (k = l.createElement("div"), k.innerHTML = "<script><\/script>", l = k.removeChild(k.firstChild)) : typeof c.is === "string" ? l = l.createElement(k, { is: c.is }) : (l = l.createElement(k), k === "select" && (k = l, c.multiple ? k.multiple = true : c.size && (k.size = c.size))) : l = l.createElementNS(h, k);
                k = l;
                k[Fa] = g2;
                k[Ga] = c;
                c = k;
                Th(c, b, false, false);
                g2 = c;
                var n2 = d3, z = Ee(f2, e);
                switch (f2) {
                  case "iframe":
                  case "object":
                  case "embed":
                    G("load", g2);
                    d3 = e;
                    break;
                  case "video":
                  case "audio":
                    for (d3 = 0; d3 < bb.length; d3++)
                      G(bb[d3], g2);
                    d3 = e;
                    break;
                  case "source":
                    G("error", g2);
                    d3 = e;
                    break;
                  case "img":
                  case "image":
                  case "link":
                    G("error", g2);
                    G("load", g2);
                    d3 = e;
                    break;
                  case "form":
                    G("reset", g2);
                    G("submit", g2);
                    d3 = e;
                    break;
                  case "details":
                    G("toggle", g2);
                    d3 = e;
                    break;
                  case "input":
                    Cc(g2, e);
                    d3 = Bc(g2, e);
                    G("invalid", g2);
                    Fe(n2, "onChange");
                    break;
                  case "option":
                    d3 = le(g2, e);
                    break;
                  case "select":
                    g2._wrapperState = { wasMultiple: !!e.multiple };
                    d3 = m$1({}, e, { value: void 0 });
                    G("invalid", g2);
                    Fe(n2, "onChange");
                    break;
                  case "textarea":
                    oe(g2, e);
                    d3 = ne(g2, e);
                    G("invalid", g2);
                    Fe(n2, "onChange");
                    break;
                  default:
                    d3 = e;
                }
                De(f2, d3);
                k = void 0;
                l = f2;
                h = g2;
                var x = d3;
                for (k in x)
                  if (x.hasOwnProperty(k)) {
                    var v = x[k];
                    k === "style" ? Ae(h, v) : k === "dangerouslySetInnerHTML" ? (v = v ? v.__html : void 0, v != null && ve(h, v)) : k === "children" ? typeof v === "string" ? (l !== "textarea" || v !== "") && we(h, v) : typeof v === "number" && we(h, "" + v) : k !== "suppressContentEditableWarning" && k !== "suppressHydrationWarning" && k !== "autoFocus" && (ia.hasOwnProperty(k) ? v != null && Fe(n2, k) : v != null && zc(h, k, v, z));
                  }
                switch (f2) {
                  case "input":
                    Vb(g2);
                    Gc(g2, e, false);
                    break;
                  case "textarea":
                    Vb(g2);
                    qe(g2);
                    break;
                  case "option":
                    e.value != null && g2.setAttribute("value", "" + Ac(e.value));
                    break;
                  case "select":
                    d3 = g2;
                    g2 = e;
                    d3.multiple = !!g2.multiple;
                    k = g2.value;
                    k != null ? me(d3, !!g2.multiple, k, false) : g2.defaultValue != null && me(d3, !!g2.multiple, g2.defaultValue, true);
                    break;
                  default:
                    typeof d3.onClick === "function" && (g2.onclick = Ge);
                }
                Je(f2, e) && Sh(b);
                b.stateNode = c;
              }
              b.ref !== null && (b.effectTag |= 128);
            } else if (b.stateNode === null)
              throw t(Error(166));
            break;
          case 6:
            if (c && b.stateNode != null)
              Wh(c, b, c.memoizedProps, e);
            else {
              if (typeof e !== "string" && b.stateNode === null)
                throw t(Error(166));
              c = zg(yg.current);
              zg(wg.current);
              Bh(b) ? (d3 = b.stateNode, c = b.memoizedProps, d3[Fa] = b, d3.nodeValue !== c && Sh(b)) : (d3 = b, c = (c.nodeType === 9 ? c : c.ownerDocument).createTextNode(e), c[Fa] = b, d3.stateNode = c);
            }
            break;
          case 11:
            break;
          case 13:
            H(P);
            e = b.memoizedState;
            if ((b.effectTag & 64) !== 0) {
              b.expirationTime = d3;
              break a;
            }
            d3 = e !== null;
            e = false;
            c === null ? Bh(b) : (f2 = c.memoizedState, e = f2 !== null, d3 || f2 === null || (f2 = c.child.sibling, f2 !== null && (g2 = b.firstEffect, g2 !== null ? (b.firstEffect = f2, f2.nextEffect = g2) : (b.firstEffect = b.lastEffect = f2, f2.nextEffect = null), f2.effectTag = 8)));
            if (d3 && !e && (b.mode & 2) !== 0) {
              if (c === null && b.memoizedProps.unstable_avoidThisFallback !== true || (P.current & Fg) !== 0)
                X === Ei && (X = Gi);
              else if (X === Ei || X === Gi)
                X = Hi;
            }
            if (d3 || e)
              b.effectTag |= 4;
            break;
          case 7:
            break;
          case 8:
            break;
          case 12:
            break;
          case 4:
            Bg();
            Uh(b);
            break;
          case 10:
            If(b);
            break;
          case 9:
            break;
          case 14:
            break;
          case 17:
            N(b.type) && Te();
            break;
          case 18:
            break;
          case 19:
            H(P);
            e = b.memoizedState;
            if (e === null)
              break;
            f2 = (b.effectTag & 64) !== 0;
            g2 = e.rendering;
            if (g2 === null)
              if (f2)
                $h(e, false);
              else {
                if (X !== Ei || c !== null && (c.effectTag & 64) !== 0)
                  for (c = b.child; c !== null; ) {
                    g2 = Hg(c);
                    if (g2 !== null) {
                      b.effectTag |= 64;
                      $h(e, false);
                      c = g2.updateQueue;
                      c !== null && (b.updateQueue = c, b.effectTag |= 4);
                      b.firstEffect = b.lastEffect = null;
                      for (c = b.child; c !== null; )
                        e = c, f2 = d3, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, g2 = e.alternate, g2 === null ? (e.childExpirationTime = 0, e.expirationTime = f2, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = g2.childExpirationTime, e.expirationTime = g2.expirationTime, e.child = g2.child, e.memoizedProps = g2.memoizedProps, e.memoizedState = g2.memoizedState, e.updateQueue = g2.updateQueue, f2 = g2.dependencies, e.dependencies = f2 === null ? null : { expirationTime: f2.expirationTime, firstContext: f2.firstContext, responders: f2.responders }), c = c.sibling;
                      J(P, P.current & Eg | Gg);
                      b = b.child;
                      break a;
                    }
                    c = c.sibling;
                  }
              }
            else {
              if (!f2)
                if (c = Hg(g2), c !== null) {
                  if (b.effectTag |= 64, f2 = true, $h(e, true), e.tail === null && e.tailMode === "hidden") {
                    d3 = c.updateQueue;
                    d3 !== null && (b.updateQueue = d3, b.effectTag |= 4);
                    b = b.lastEffect = e.lastEffect;
                    b !== null && (b.nextEffect = null);
                    break;
                  }
                } else
                  sf() > e.tailExpiration && 1 < d3 && (b.effectTag |= 64, f2 = true, $h(e, false), b.expirationTime = b.childExpirationTime = d3 - 1);
              e.isBackwards ? (g2.sibling = b.child, b.child = g2) : (d3 = e.last, d3 !== null ? d3.sibling = g2 : b.child = g2, e.last = g2);
            }
            if (e.tail !== null) {
              e.tailExpiration === 0 && (e.tailExpiration = sf() + 500);
              d3 = e.tail;
              e.rendering = d3;
              e.tail = d3.sibling;
              e.lastEffect = b.lastEffect;
              d3.sibling = null;
              c = P.current;
              c = f2 ? c & Eg | Gg : c & Eg;
              J(P, c);
              b = d3;
              break a;
            }
            break;
          case 20:
            break;
          default:
            throw t(Error(156));
        }
        b = null;
      }
      d3 = V;
      if (W === 1 || d3.childExpirationTime !== 1) {
        c = 0;
        for (e = d3.child; e !== null; )
          f2 = e.expirationTime, g2 = e.childExpirationTime, f2 > c && (c = f2), g2 > c && (c = g2), e = e.sibling;
        d3.childExpirationTime = c;
      }
      if (b !== null)
        return b;
      a !== null && (a.effectTag & 1024) === 0 && (a.firstEffect === null && (a.firstEffect = V.firstEffect), V.lastEffect !== null && (a.lastEffect !== null && (a.lastEffect.nextEffect = V.firstEffect), a.lastEffect = V.lastEffect), 1 < V.effectTag && (a.lastEffect !== null ? a.lastEffect.nextEffect = V : a.firstEffect = V, a.lastEffect = V));
    } else {
      b = ai(V);
      if (b !== null)
        return b.effectTag &= 1023, b;
      a !== null && (a.firstEffect = a.lastEffect = null, a.effectTag |= 1024);
    }
    b = V.sibling;
    if (b !== null)
      return b;
    V = a;
  } while (V !== null);
  X === Ei && (X = Ii);
  return null;
}
function ij(a) {
  var b = tf();
  vf(99, nj.bind(null, a, b));
  Qi !== null && wf(97, function() {
    cj();
    return null;
  });
  return null;
}
function nj(a, b) {
  cj();
  if ((U & (Ci | Di)) !== T)
    throw t(Error(327));
  var c = a.finishedWork, d3 = a.finishedExpirationTime;
  if (c === null)
    return null;
  a.finishedWork = null;
  a.finishedExpirationTime = 0;
  if (c === a.current)
    throw t(Error(177));
  a.callbackNode = null;
  a.callbackExpirationTime = 0;
  var e = c.expirationTime, f2 = c.childExpirationTime;
  e = f2 > e ? f2 : e;
  a.firstPendingTime = e;
  e < a.lastPendingTime && (a.lastPendingTime = e);
  a === Ji && (V = Ji = null, W = 0);
  1 < c.effectTag ? c.lastEffect !== null ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
  if (e !== null) {
    f2 = U;
    U |= Di;
    Ai.current = null;
    He = Qd;
    var h = ae();
    if (be(h)) {
      if ("selectionStart" in h)
        var g2 = { start: h.selectionStart, end: h.selectionEnd };
      else
        a: {
          g2 = (g2 = h.ownerDocument) && g2.defaultView || window;
          var k = g2.getSelection && g2.getSelection();
          if (k && k.rangeCount !== 0) {
            g2 = k.anchorNode;
            var l = k.anchorOffset, n2 = k.focusNode;
            k = k.focusOffset;
            try {
              g2.nodeType, n2.nodeType;
            } catch (zb) {
              g2 = null;
              break a;
            }
            var z = 0, x = -1, v = -1, rb = 0, Be = 0, u = h, w2 = null;
            b:
              for (; ; ) {
                for (var C; ; ) {
                  u !== g2 || l !== 0 && u.nodeType !== 3 || (x = z + l);
                  u !== n2 || k !== 0 && u.nodeType !== 3 || (v = z + k);
                  u.nodeType === 3 && (z += u.nodeValue.length);
                  if ((C = u.firstChild) === null)
                    break;
                  w2 = u;
                  u = C;
                }
                for (; ; ) {
                  if (u === h)
                    break b;
                  w2 === g2 && ++rb === l && (x = z);
                  w2 === n2 && ++Be === k && (v = z);
                  if ((C = u.nextSibling) !== null)
                    break;
                  u = w2;
                  w2 = u.parentNode;
                }
                u = C;
              }
            g2 = x === -1 || v === -1 ? null : { start: x, end: v };
          } else
            g2 = null;
        }
      g2 = g2 || { start: 0, end: 0 };
    } else
      g2 = null;
    Ie = { focusedElem: h, selectionRange: g2 };
    Qd = false;
    Y = e;
    do
      try {
        for (; Y !== null; ) {
          if ((Y.effectTag & 256) !== 0) {
            var I = Y.alternate;
            h = Y;
            switch (h.tag) {
              case 0:
              case 11:
              case 15:
                hi(Jg, Ig, h);
                break;
              case 1:
                if (h.effectTag & 256 && I !== null) {
                  var E = I.memoizedProps, ua2 = I.memoizedState, gh = h.stateNode, oj = gh.getSnapshotBeforeUpdate(h.elementType === h.type ? E : Af(h.type, E), ua2);
                  gh.__reactInternalSnapshotBeforeUpdate = oj;
                }
                break;
              case 3:
              case 5:
              case 6:
              case 4:
              case 17:
                break;
              default:
                throw t(Error(163));
            }
          }
          Y = Y.nextEffect;
        }
      } catch (zb) {
        if (Y === null)
          throw t(Error(330));
        fi(Y, zb);
        Y = Y.nextEffect;
      }
    while (Y !== null);
    Y = e;
    do
      try {
        for (I = b; Y !== null; ) {
          var A = Y.effectTag;
          A & 16 && we(Y.stateNode, "");
          if (A & 128) {
            var p2 = Y.alternate;
            if (p2 !== null) {
              var r2 = p2.ref;
              r2 !== null && (typeof r2 === "function" ? r2(null) : r2.current = null);
            }
          }
          switch (A & 14) {
            case 2:
              ni(Y);
              Y.effectTag &= -3;
              break;
            case 6:
              ni(Y);
              Y.effectTag &= -3;
              oi(Y.alternate, Y);
              break;
            case 4:
              oi(Y.alternate, Y);
              break;
            case 8:
              E = Y;
              ki(E, I);
              E.return = null;
              E.child = null;
              E.memoizedState = null;
              E.updateQueue = null;
              E.dependencies = null;
              var K = E.alternate;
              K !== null && (K.return = null, K.child = null, K.memoizedState = null, K.updateQueue = null, K.dependencies = null);
          }
          Y = Y.nextEffect;
        }
      } catch (zb) {
        if (Y === null)
          throw t(Error(330));
        fi(Y, zb);
        Y = Y.nextEffect;
      }
    while (Y !== null);
    r2 = Ie;
    p2 = ae();
    A = r2.focusedElem;
    I = r2.selectionRange;
    if (p2 !== A && A && A.ownerDocument && $d(A.ownerDocument.documentElement, A)) {
      I !== null && be(A) && (p2 = I.start, r2 = I.end, r2 === void 0 && (r2 = p2), "selectionStart" in A ? (A.selectionStart = p2, A.selectionEnd = Math.min(r2, A.value.length)) : (r2 = (p2 = A.ownerDocument || document) && p2.defaultView || window, r2.getSelection && (r2 = r2.getSelection(), E = A.textContent.length, K = Math.min(I.start, E), I = I.end === void 0 ? K : Math.min(I.end, E), !r2.extend && K > I && (E = I, I = K, K = E), E = Zd(A, K), ua2 = Zd(A, I), E && ua2 && (r2.rangeCount !== 1 || r2.anchorNode !== E.node || r2.anchorOffset !== E.offset || r2.focusNode !== ua2.node || r2.focusOffset !== ua2.offset) && (p2 = p2.createRange(), p2.setStart(E.node, E.offset), r2.removeAllRanges(), K > I ? (r2.addRange(p2), r2.extend(ua2.node, ua2.offset)) : (p2.setEnd(ua2.node, ua2.offset), r2.addRange(p2))))));
      p2 = [];
      for (r2 = A; r2 = r2.parentNode; )
        r2.nodeType === 1 && p2.push({ element: r2, left: r2.scrollLeft, top: r2.scrollTop });
      typeof A.focus === "function" && A.focus();
      for (A = 0; A < p2.length; A++)
        r2 = p2[A], r2.element.scrollLeft = r2.left, r2.element.scrollTop = r2.top;
    }
    Ie = null;
    Qd = !!He;
    He = null;
    a.current = c;
    Y = e;
    do
      try {
        for (A = d3; Y !== null; ) {
          var $a = Y.effectTag;
          if ($a & 36) {
            var nc = Y.alternate;
            p2 = Y;
            r2 = A;
            switch (p2.tag) {
              case 0:
              case 11:
              case 15:
                hi(Mg, Ng, p2);
                break;
              case 1:
                var md = p2.stateNode;
                if (p2.effectTag & 4)
                  if (nc === null)
                    md.componentDidMount();
                  else {
                    var Fj = p2.elementType === p2.type ? nc.memoizedProps : Af(p2.type, nc.memoizedProps);
                    md.componentDidUpdate(Fj, nc.memoizedState, md.__reactInternalSnapshotBeforeUpdate);
                  }
                var Xh = p2.updateQueue;
                Xh !== null && Yf(p2, Xh, md, r2);
                break;
              case 3:
                var Yh = p2.updateQueue;
                if (Yh !== null) {
                  K = null;
                  if (p2.child !== null)
                    switch (p2.child.tag) {
                      case 5:
                        K = p2.child.stateNode;
                        break;
                      case 1:
                        K = p2.child.stateNode;
                    }
                  Yf(p2, Yh, K, r2);
                }
                break;
              case 5:
                var Gj = p2.stateNode;
                nc === null && p2.effectTag & 4 && (r2 = Gj, Je(p2.type, p2.memoizedProps) && r2.focus());
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
              case 19:
              case 17:
              case 20:
                break;
              default:
                throw t(Error(163));
            }
          }
          if ($a & 128) {
            var nd = Y.ref;
            if (nd !== null) {
              var Zh = Y.stateNode;
              switch (Y.tag) {
                case 5:
                  var gf = Zh;
                  break;
                default:
                  gf = Zh;
              }
              typeof nd === "function" ? nd(gf) : nd.current = gf;
            }
          }
          $a & 512 && (Pi = true);
          Y = Y.nextEffect;
        }
      } catch (zb) {
        if (Y === null)
          throw t(Error(330));
        fi(Y, zb);
        Y = Y.nextEffect;
      }
    while (Y !== null);
    Y = null;
    nf();
    U = f2;
  } else
    a.current = c;
  if (Pi)
    Pi = false, Qi = a, Si = d3, Ri = b;
  else
    for (Y = e; Y !== null; )
      b = Y.nextEffect, Y.nextEffect = null, Y = b;
  b = a.firstPendingTime;
  b !== 0 ? ($a = cg(), $a = zf($a, b), Zi(a, $a, b)) : xi = null;
  typeof pj === "function" && pj(c.stateNode, d3);
  b === 1073741823 ? a === Vi ? Ui++ : (Ui = 0, Vi = a) : Ui = 0;
  if (ui)
    throw ui = false, a = vi, vi = null, a;
  if ((U & Bi) !== T)
    return null;
  O();
  return null;
}
function cj() {
  if (Qi === null)
    return false;
  var a = Qi, b = Si, c = Ri;
  Qi = null;
  Si = 0;
  Ri = 90;
  return vf(97 < c ? 97 : c, qj.bind(null, a, b));
}
function qj(a) {
  if ((U & (Ci | Di)) !== T)
    throw t(Error(331));
  var b = U;
  U |= Di;
  for (a = a.current.firstEffect; a !== null; ) {
    try {
      var c = a;
      if ((c.effectTag & 512) !== 0)
        switch (c.tag) {
          case 0:
          case 11:
          case 15:
            hi(Pg, Ig, c), hi(Ig, Og, c);
        }
    } catch (d3) {
      if (a === null)
        throw t(Error(330));
      fi(a, d3);
    }
    c = a.nextEffect;
    a.nextEffect = null;
    a = c;
  }
  U = b;
  O();
  return true;
}
function rj(a, b, c) {
  b = bi(c, b);
  b = ti(a, b, 1073741823);
  Sf(a, b);
  a = Yi(a, 1073741823);
  a !== null && Zi(a, 99, 1073741823);
}
function fi(a, b) {
  if (a.tag === 3)
    rj(a, a, b);
  else
    for (var c = a.return; c !== null; ) {
      if (c.tag === 3) {
        rj(c, a, b);
        break;
      } else if (c.tag === 1) {
        var d3 = c.stateNode;
        if (typeof c.type.getDerivedStateFromError === "function" || typeof d3.componentDidCatch === "function" && (xi === null || !xi.has(d3))) {
          a = bi(b, a);
          a = wi(c, a, 1073741823);
          Sf(c, a);
          c = Yi(c, 1073741823);
          c !== null && Zi(c, 99, 1073741823);
          break;
        }
      }
      c = c.return;
    }
}
function kj(a, b, c) {
  var d3 = a.pingCache;
  d3 !== null && d3.delete(b);
  Ji === a && W === c ? X === Hi || X === Gi && Ki === 1073741823 && sf() - pi < Oi ? hj(a, W) : Ni = true : a.lastPendingTime < c || (b = a.pingTime, b !== 0 && b < c || (a.pingTime = c, a.finishedExpirationTime === c && (a.finishedExpirationTime = 0, a.finishedWork = null), b = cg(), b = zf(b, c), Zi(a, b, c)));
}
function ri(a, b) {
  var c = a.stateNode;
  c !== null && c.delete(b);
  c = cg();
  b = dg(c, a, null);
  c = zf(c, b);
  a = Yi(a, b);
  a !== null && Zi(a, c, b);
}
var mj = void 0;
mj = function(a, b, c) {
  var d3 = b.expirationTime;
  if (a !== null) {
    var e = b.pendingProps;
    if (a.memoizedProps !== e || M.current)
      Lf = true;
    else if (d3 < c) {
      Lf = false;
      switch (b.tag) {
        case 3:
          Nh(b);
          Ch();
          break;
        case 5:
          Cg(b);
          if (b.mode & 4 && c !== 1 && e.hidden)
            return b.expirationTime = b.childExpirationTime = 1, null;
          break;
        case 1:
          N(b.type) && Xe(b);
          break;
        case 4:
          Ag(b, b.stateNode.containerInfo);
          break;
        case 10:
          Hf(b, b.memoizedProps.value);
          break;
        case 13:
          if (b.memoizedState !== null) {
            d3 = b.child.childExpirationTime;
            if (d3 !== 0 && d3 >= c)
              return Ph(a, b, c);
            J(P, P.current & Eg);
            b = Fh(a, b, c);
            return b !== null ? b.sibling : null;
          }
          J(P, P.current & Eg);
          break;
        case 19:
          d3 = b.childExpirationTime >= c;
          if ((a.effectTag & 64) !== 0) {
            if (d3)
              return Rh(a, b, c);
            b.effectTag |= 64;
          }
          e = b.memoizedState;
          e !== null && (e.rendering = null, e.tail = null);
          J(P, P.current);
          if (!d3)
            return null;
      }
      return Fh(a, b, c);
    }
  } else
    Lf = false;
  b.expirationTime = 0;
  switch (b.tag) {
    case 2:
      d3 = b.type;
      a !== null && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
      a = b.pendingProps;
      e = Se(b, L.current);
      Kf(b, c);
      e = dh(null, b, d3, a, e, c);
      b.effectTag |= 1;
      if (typeof e === "object" && e !== null && typeof e.render === "function" && e.$$typeof === void 0) {
        b.tag = 1;
        ih();
        if (N(d3)) {
          var f2 = true;
          Xe(b);
        } else
          f2 = false;
        b.memoizedState = e.state !== null && e.state !== void 0 ? e.state : null;
        var h = d3.getDerivedStateFromProps;
        typeof h === "function" && bg(b, d3, h, a);
        e.updater = fg;
        b.stateNode = e;
        e._reactInternalFiber = b;
        jg(b, d3, a, c);
        b = Mh(null, b, d3, true, f2, c);
      } else
        b.tag = 0, S(null, b, e, c), b = b.child;
      return b;
    case 16:
      e = b.elementType;
      a !== null && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
      a = b.pendingProps;
      e = Bf(e);
      b.type = e;
      f2 = b.tag = sj(e);
      a = Af(e, a);
      switch (f2) {
        case 0:
          b = Jh(null, b, e, a, c);
          break;
        case 1:
          b = Lh(null, b, e, a, c);
          break;
        case 11:
          b = Eh(null, b, e, a, c);
          break;
        case 14:
          b = Gh(null, b, e, Af(e.type, a), d3, c);
          break;
        default:
          throw t(Error(306), e, "");
      }
      return b;
    case 0:
      return d3 = b.type, e = b.pendingProps, e = b.elementType === d3 ? e : Af(d3, e), Jh(a, b, d3, e, c);
    case 1:
      return d3 = b.type, e = b.pendingProps, e = b.elementType === d3 ? e : Af(d3, e), Lh(a, b, d3, e, c);
    case 3:
      Nh(b);
      d3 = b.updateQueue;
      if (d3 === null)
        throw t(Error(282));
      e = b.memoizedState;
      e = e !== null ? e.element : null;
      Wf(b, d3, b.pendingProps, null, c);
      d3 = b.memoizedState.element;
      if (d3 === e)
        Ch(), b = Fh(a, b, c);
      else {
        e = b.stateNode;
        if (e = (a === null || a.child === null) && e.hydrate)
          uh = Ne(b.stateNode.containerInfo.firstChild), th = b, e = vh = true;
        e ? (b.effectTag |= 2, b.child = ug(b, null, d3, c)) : (S(a, b, d3, c), Ch());
        b = b.child;
      }
      return b;
    case 5:
      return Cg(b), a === null && zh(b), d3 = b.type, e = b.pendingProps, f2 = a !== null ? a.memoizedProps : null, h = e.children, Ke(d3, e) ? h = null : f2 !== null && Ke(d3, f2) && (b.effectTag |= 16), Kh(a, b), b.mode & 4 && c !== 1 && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (S(a, b, h, c), b = b.child), b;
    case 6:
      return a === null && zh(b), null;
    case 13:
      return Ph(a, b, c);
    case 4:
      return Ag(b, b.stateNode.containerInfo), d3 = b.pendingProps, a === null ? b.child = tg(b, null, d3, c) : S(a, b, d3, c), b.child;
    case 11:
      return d3 = b.type, e = b.pendingProps, e = b.elementType === d3 ? e : Af(d3, e), Eh(a, b, d3, e, c);
    case 7:
      return S(a, b, b.pendingProps, c), b.child;
    case 8:
      return S(a, b, b.pendingProps.children, c), b.child;
    case 12:
      return S(a, b, b.pendingProps.children, c), b.child;
    case 10:
      a: {
        d3 = b.type._context;
        e = b.pendingProps;
        h = b.memoizedProps;
        f2 = e.value;
        Hf(b, f2);
        if (h !== null) {
          var g2 = h.value;
          f2 = hd(g2, f2) ? 0 : (typeof d3._calculateChangedBits === "function" ? d3._calculateChangedBits(g2, f2) : 1073741823) | 0;
          if (f2 === 0) {
            if (h.children === e.children && !M.current) {
              b = Fh(a, b, c);
              break a;
            }
          } else
            for (g2 = b.child, g2 !== null && (g2.return = b); g2 !== null; ) {
              var k = g2.dependencies;
              if (k !== null) {
                h = g2.child;
                for (var l = k.firstContext; l !== null; ) {
                  if (l.context === d3 && (l.observedBits & f2) !== 0) {
                    g2.tag === 1 && (l = Qf(c, null), l.tag = 2, Sf(g2, l));
                    g2.expirationTime < c && (g2.expirationTime = c);
                    l = g2.alternate;
                    l !== null && l.expirationTime < c && (l.expirationTime = c);
                    Jf(g2.return, c);
                    k.expirationTime < c && (k.expirationTime = c);
                    break;
                  }
                  l = l.next;
                }
              } else
                h = g2.tag === 10 ? g2.type === b.type ? null : g2.child : g2.child;
              if (h !== null)
                h.return = g2;
              else
                for (h = g2; h !== null; ) {
                  if (h === b) {
                    h = null;
                    break;
                  }
                  g2 = h.sibling;
                  if (g2 !== null) {
                    g2.return = h.return;
                    h = g2;
                    break;
                  }
                  h = h.return;
                }
              g2 = h;
            }
        }
        S(a, b, e.children, c);
        b = b.child;
      }
      return b;
    case 9:
      return e = b.type, f2 = b.pendingProps, d3 = f2.children, Kf(b, c), e = Mf(e, f2.unstable_observedBits), d3 = d3(e), b.effectTag |= 1, S(a, b, d3, c), b.child;
    case 14:
      return e = b.type, f2 = Af(e, b.pendingProps), f2 = Af(e.type, f2), Gh(a, b, e, f2, d3, c);
    case 15:
      return Ih(a, b, b.type, b.pendingProps, d3, c);
    case 17:
      return d3 = b.type, e = b.pendingProps, e = b.elementType === d3 ? e : Af(d3, e), a !== null && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, N(d3) ? (a = true, Xe(b)) : a = false, Kf(b, c), hg(b, d3, e), jg(b, d3, e, c), Mh(null, b, d3, true, a, c);
    case 19:
      return Rh(a, b, c);
  }
  throw t(Error(156));
};
var pj = null, ji = null;
function tj(a) {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined")
    return false;
  var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (b.isDisabled || !b.supportsFiber)
    return true;
  try {
    var c = b.inject(a);
    pj = function(a2) {
      try {
        b.onCommitFiberRoot(c, a2, void 0, (a2.current.effectTag & 64) === 64);
      } catch (e) {
      }
    };
    ji = function(a2) {
      try {
        b.onCommitFiberUnmount(c, a2);
      } catch (e) {
      }
    };
  } catch (d3) {
  }
  return true;
}
function uj(a, b, c, d3) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d3;
  this.effectTag = 0;
  this.lastEffect = this.firstEffect = this.nextEffect = null;
  this.childExpirationTime = this.expirationTime = 0;
  this.alternate = null;
}
function xh(a, b, c, d3) {
  return new uj(a, b, c, d3);
}
function Hh(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}
function sj(a) {
  if (typeof a === "function")
    return Hh(a) ? 1 : 0;
  if (a !== void 0 && a !== null) {
    a = a.$$typeof;
    if (a === gc)
      return 11;
    if (a === jc)
      return 14;
  }
  return 2;
}
function og(a, b) {
  var c = a.alternate;
  c === null ? (c = xh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
  c.childExpirationTime = a.childExpirationTime;
  c.expirationTime = a.expirationTime;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = b === null ? null : {
    expirationTime: b.expirationTime,
    firstContext: b.firstContext,
    responders: b.responders
  };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}
function qg(a, b, c, d3, e, f2) {
  var h = 2;
  d3 = a;
  if (typeof a === "function")
    Hh(a) && (h = 1);
  else if (typeof a === "string")
    h = 5;
  else
    a:
      switch (a) {
        case ac:
          return sg(c.children, e, f2, b);
        case fc:
          h = 8;
          e |= 7;
          break;
        case bc:
          h = 8;
          e |= 1;
          break;
        case cc:
          return a = xh(12, c, b, e | 8), a.elementType = cc, a.type = cc, a.expirationTime = f2, a;
        case hc:
          return a = xh(13, c, b, e), a.type = hc, a.elementType = hc, a.expirationTime = f2, a;
        case ic:
          return a = xh(19, c, b, e), a.elementType = ic, a.expirationTime = f2, a;
        default:
          if (typeof a === "object" && a !== null)
            switch (a.$$typeof) {
              case dc:
                h = 10;
                break a;
              case ec:
                h = 9;
                break a;
              case gc:
                h = 11;
                break a;
              case jc:
                h = 14;
                break a;
              case kc:
                h = 16;
                d3 = null;
                break a;
            }
          throw t(Error(130), a == null ? a : typeof a, "");
      }
  b = xh(h, c, b, e);
  b.elementType = a;
  b.type = d3;
  b.expirationTime = f2;
  return b;
}
function sg(a, b, c, d3) {
  a = xh(7, a, d3, b);
  a.expirationTime = c;
  return a;
}
function pg(a, b, c) {
  a = xh(6, a, null, b);
  a.expirationTime = c;
  return a;
}
function rg(a, b, c) {
  b = xh(4, a.children !== null ? a.children : [], a.key, b);
  b.expirationTime = c;
  b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
  return b;
}
function vj(a, b, c) {
  this.tag = b;
  this.current = null;
  this.containerInfo = a;
  this.pingCache = this.pendingChildren = null;
  this.finishedExpirationTime = 0;
  this.finishedWork = null;
  this.timeoutHandle = -1;
  this.pendingContext = this.context = null;
  this.hydrate = c;
  this.callbackNode = this.firstBatch = null;
  this.pingTime = this.lastPendingTime = this.firstPendingTime = this.callbackExpirationTime = 0;
}
function wj(a, b, c) {
  a = new vj(a, b, c);
  b = xh(3, null, null, b === 2 ? 7 : b === 1 ? 3 : 0);
  a.current = b;
  return b.stateNode = a;
}
function xj(a, b, c, d3, e, f2) {
  var h = b.current;
  a:
    if (c) {
      c = c._reactInternalFiber;
      b: {
        if (ld(c) !== 2 || c.tag !== 1)
          throw t(Error(170));
        var g2 = c;
        do {
          switch (g2.tag) {
            case 3:
              g2 = g2.stateNode.context;
              break b;
            case 1:
              if (N(g2.type)) {
                g2 = g2.stateNode.__reactInternalMemoizedMergedChildContext;
                break b;
              }
          }
          g2 = g2.return;
        } while (g2 !== null);
        throw t(Error(171));
      }
      if (c.tag === 1) {
        var k = c.type;
        if (N(k)) {
          c = We(c, k, g2);
          break a;
        }
      }
      c = g2;
    } else
      c = Qe;
  b.context === null ? b.context = c : b.pendingContext = c;
  b = f2;
  e = Qf(d3, e);
  e.payload = { element: a };
  b = b === void 0 ? null : b;
  b !== null && (e.callback = b);
  Sf(h, e);
  eg(h, d3);
  return d3;
}
function yj(a, b, c, d3) {
  var e = b.current, f2 = cg(), h = $f.suspense;
  e = dg(f2, e, h);
  return xj(a, b, c, e, h, d3);
}
function zj(a) {
  a = a.current;
  if (!a.child)
    return null;
  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;
    default:
      return a.child.stateNode;
  }
}
function Aj(a, b, c) {
  var d3 = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
  return { $$typeof: $b, key: d3 == null ? null : "" + d3, children: a, containerInfo: b, implementation: c };
}
Db = function(a, b, c) {
  switch (b) {
    case "input":
      Ec(a, c);
      b = c.name;
      if (c.type === "radio" && b != null) {
        for (c = a; c.parentNode; )
          c = c.parentNode;
        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
        for (b = 0; b < c.length; b++) {
          var d3 = c[b];
          if (d3 !== a && d3.form === a.form) {
            var e = Ka(d3);
            if (!e)
              throw t(Error(90));
            Wb(d3);
            Ec(d3, e);
          }
        }
      }
      break;
    case "textarea":
      pe(a, c);
      break;
    case "select":
      b = c.value, b != null && me(a, !!c.multiple, b, false);
  }
};
function Bj(a) {
  var b = 1073741821 - 25 * (((1073741821 - cg() + 500) / 25 | 0) + 1);
  b <= Xi && --b;
  this._expirationTime = Xi = b;
  this._root = a;
  this._callbacks = this._next = null;
  this._hasChildren = this._didComplete = false;
  this._children = null;
  this._defer = true;
}
Bj.prototype.render = function(a) {
  if (!this._defer)
    throw t(Error(250));
  this._hasChildren = true;
  this._children = a;
  var b = this._root._internalRoot, c = this._expirationTime, d3 = new Cj();
  xj(a, b, null, c, null, d3._onCommit);
  return d3;
};
Bj.prototype.then = function(a) {
  if (this._didComplete)
    a();
  else {
    var b = this._callbacks;
    b === null && (b = this._callbacks = []);
    b.push(a);
  }
};
Bj.prototype.commit = function() {
  var a = this._root._internalRoot, b = a.firstBatch;
  if (!this._defer || b === null)
    throw t(Error(251));
  if (this._hasChildren) {
    var c = this._expirationTime;
    if (b !== this) {
      this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));
      for (var d3 = null, e = b; e !== this; )
        d3 = e, e = e._next;
      if (d3 === null)
        throw t(Error(251));
      d3._next = e._next;
      this._next = b;
      a.firstBatch = this;
    }
    this._defer = false;
    b = c;
    if ((U & (Ci | Di)) !== T)
      throw t(Error(253));
    xf(Z.bind(null, a, b));
    O();
    b = this._next;
    this._next = null;
    b = a.firstBatch = b;
    b !== null && b._hasChildren && b.render(b._children);
  } else
    this._next = null, this._defer = false;
};
Bj.prototype._onComplete = function() {
  if (!this._didComplete) {
    this._didComplete = true;
    var a = this._callbacks;
    if (a !== null)
      for (var b = 0; b < a.length; b++)
        (0, a[b])();
  }
};
function Cj() {
  this._callbacks = null;
  this._didCommit = false;
  this._onCommit = this._onCommit.bind(this);
}
Cj.prototype.then = function(a) {
  if (this._didCommit)
    a();
  else {
    var b = this._callbacks;
    b === null && (b = this._callbacks = []);
    b.push(a);
  }
};
Cj.prototype._onCommit = function() {
  if (!this._didCommit) {
    this._didCommit = true;
    var a = this._callbacks;
    if (a !== null)
      for (var b = 0; b < a.length; b++) {
        var c = a[b];
        if (typeof c !== "function")
          throw t(Error(191), c);
        c();
      }
  }
};
function Dj(a, b, c) {
  this._internalRoot = wj(a, b, c);
}
function Ej(a, b) {
  this._internalRoot = wj(a, 2, b);
}
Ej.prototype.render = Dj.prototype.render = function(a, b) {
  var c = this._internalRoot, d3 = new Cj();
  b = b === void 0 ? null : b;
  b !== null && d3.then(b);
  yj(a, c, null, d3._onCommit);
  return d3;
};
Ej.prototype.unmount = Dj.prototype.unmount = function(a) {
  var b = this._internalRoot, c = new Cj();
  a = a === void 0 ? null : a;
  a !== null && c.then(a);
  yj(null, b, null, c._onCommit);
  return c;
};
Ej.prototype.createBatch = function() {
  var a = new Bj(this), b = a._expirationTime, c = this._internalRoot, d3 = c.firstBatch;
  if (d3 === null)
    c.firstBatch = a, a._next = null;
  else {
    for (c = null; d3 !== null && d3._expirationTime >= b; )
      c = d3, d3 = d3._next;
    a._next = d3;
    c !== null && (c._next = a);
  }
  return a;
};
function Hj(a) {
  return !(!a || a.nodeType !== 1 && a.nodeType !== 9 && a.nodeType !== 11 && (a.nodeType !== 8 || a.nodeValue !== " react-mount-point-unstable "));
}
Jb = ej;
Kb = fj;
Lb = aj;
Mb = function(a, b) {
  var c = U;
  U |= 2;
  try {
    return a(b);
  } finally {
    U = c, U === T && O();
  }
};
function Ij(a, b) {
  b || (b = a ? a.nodeType === 9 ? a.documentElement : a.firstChild : null, b = !(!b || b.nodeType !== 1 || !b.hasAttribute("data-reactroot")));
  if (!b)
    for (var c; c = a.lastChild; )
      a.removeChild(c);
  return new Dj(a, 0, b);
}
function Jj(a, b, c, d3, e) {
  var f2 = c._reactRootContainer, h = void 0;
  if (f2) {
    h = f2._internalRoot;
    if (typeof e === "function") {
      var g2 = e;
      e = function() {
        var a2 = zj(h);
        g2.call(a2);
      };
    }
    yj(b, h, a, e);
  } else {
    f2 = c._reactRootContainer = Ij(c, d3);
    h = f2._internalRoot;
    if (typeof e === "function") {
      var k = e;
      e = function() {
        var a2 = zj(h);
        k.call(a2);
      };
    }
    gj(function() {
      yj(b, h, a, e);
    });
  }
  return zj(h);
}
function Kj(a, b) {
  var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
  if (!Hj(b))
    throw t(Error(200));
  return Aj(a, b, null, c);
}
var Nj = { createPortal: Kj, findDOMNode: function(a) {
  if (a == null)
    a = null;
  else if (a.nodeType !== 1) {
    var b = a._reactInternalFiber;
    if (b === void 0) {
      if (typeof a.render === "function")
        throw t(Error(188));
      throw t(Error(268), Object.keys(a));
    }
    a = qd(b);
    a = a === null ? null : a.stateNode;
  }
  return a;
}, hydrate: function(a, b, c) {
  if (!Hj(b))
    throw t(Error(200));
  return Jj(null, a, b, true, c);
}, render: function(a, b, c) {
  if (!Hj(b))
    throw t(Error(200));
  return Jj(null, a, b, false, c);
}, unstable_renderSubtreeIntoContainer: function(a, b, c, d3) {
  if (!Hj(c))
    throw t(Error(200));
  if (a == null || a._reactInternalFiber === void 0)
    throw t(Error(38));
  return Jj(a, b, c, false, d3);
}, unmountComponentAtNode: function(a) {
  if (!Hj(a))
    throw t(Error(40));
  return a._reactRootContainer ? (gj(function() {
    Jj(null, null, a, false, function() {
      a._reactRootContainer = null;
    });
  }), true) : false;
}, unstable_createPortal: function() {
  return Kj.apply(void 0, arguments);
}, unstable_batchedUpdates: ej, unstable_interactiveUpdates: function(a, b, c, d3) {
  aj();
  return fj(a, b, c, d3);
}, unstable_discreteUpdates: fj, unstable_flushDiscreteUpdates: aj, flushSync: function(a, b) {
  if ((U & (Ci | Di)) !== T)
    throw t(Error(187));
  var c = U;
  U |= 1;
  try {
    return vf(99, a.bind(null, b));
  } finally {
    U = c, O();
  }
}, unstable_createRoot: Lj, unstable_createSyncRoot: Mj, unstable_flushControlled: function(a) {
  var b = U;
  U |= 1;
  try {
    vf(99, a);
  } finally {
    U = b, U === T && O();
  }
}, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { Events: [Ia, Ja, Ka, Ca.injectEventPluginsByName, fa, Qa, function(a) {
  ya(a, Pa);
}, Hb, Ib, Ud, Ba, cj, { current: false }] } };
function Lj(a, b) {
  if (!Hj(a))
    throw t(Error(299), "unstable_createRoot");
  return new Ej(a, b != null && b.hydrate === true);
}
function Mj(a, b) {
  if (!Hj(a))
    throw t(Error(299), "unstable_createRoot");
  return new Dj(a, 1, b != null && b.hydrate === true);
}
(function(a) {
  var b = a.findFiberByHostInstance;
  return tj(m$1({}, a, { overrideHookState: null, overrideProps: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: Xb.ReactCurrentDispatcher, findHostInstanceByFiber: function(a2) {
    a2 = qd(a2);
    return a2 === null ? null : a2.stateNode;
  }, findFiberByHostInstance: function(a2) {
    return b ? b(a2) : null;
  }, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null }));
})({
  findFiberByHostInstance: Ha,
  bundleType: 0,
  version: "16.9.0",
  rendererPackageName: "react-dom"
});
var Oj = { default: Nj }, Pj = Oj && Nj || Oj;
var reactDom_production_min = Pj.default || Pj;
function checkDCE() {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
    return;
  }
  try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    console.error(err);
  }
}
{
  checkDCE();
  reactDom.exports = reactDom_production_min;
}
var ReactDOM = reactDom.exports;
var ModalPortal = { exports: {} };
var focusManager = {};
var tabbable = { exports: {} };
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = findTabbableDescendants;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var tabbableNode = /input|select|textarea|button|object|iframe/;
  function hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    if (zeroSize && !element.innerHTML)
      return true;
    try {
      var style = window.getComputedStyle(element);
      return zeroSize ? style.getPropertyValue("overflow") !== "visible" || element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
      console.warn("Failed to inspect element style");
      return false;
    }
  }
  function visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while (parentElement) {
      if (parentElement === document.body)
        break;
      if (rootNode && parentElement === rootNode)
        parentElement = rootNode.host.parentNode;
      if (hidesContents(parentElement))
        return false;
      parentElement = parentElement.parentNode;
    }
    return true;
  }
  function focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && visible(element);
  }
  function tabbable2(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null)
      tabIndex = void 0;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
  }
  function findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
      return finished.concat(!el.shadowRoot ? [el] : findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter(tabbable2);
  }
  module.exports = exports["default"];
})(tabbable, tabbable.exports);
Object.defineProperty(focusManager, "__esModule", {
  value: true
});
focusManager.resetState = resetState$4;
focusManager.log = log$7;
focusManager.handleBlur = handleBlur;
focusManager.handleFocus = handleFocus;
focusManager.markForFocusLater = markForFocusLater;
focusManager.returnFocus = returnFocus;
focusManager.popWithoutFocus = popWithoutFocus;
focusManager.setupScopedFocus = setupScopedFocus;
focusManager.teardownScopedFocus = teardownScopedFocus;
var _tabbable = tabbable.exports;
var _tabbable2 = _interopRequireDefault$4(_tabbable);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;
function resetState$4() {
  focusLaterElements = [];
}
function log$7() {
}
function handleBlur() {
  needToFocus = true;
}
function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    setTimeout(function() {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}
function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}
function returnFocus() {
  var preventScroll = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus({ preventScroll });
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}
function setupScopedFocus(element) {
  modalElement = element;
  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}
function teardownScopedFocus() {
  modalElement = null;
  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}
var scopeTab = { exports: {} };
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = scopeTab2;
  var _tabbable3 = tabbable.exports;
  var _tabbable22 = _interopRequireDefault2(_tabbable3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return el.activeElement.shadowRoot ? getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
  }
  function scopeTab2(node, event) {
    var tabbable2 = (0, _tabbable22.default)(node);
    if (!tabbable2.length) {
      event.preventDefault();
      return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable2[0];
    var tail = tabbable2[tabbable2.length - 1];
    var activeElement = getActiveElement();
    if (node === activeElement) {
      if (!shiftKey)
        return;
      target = tail;
    }
    if (tail === activeElement && !shiftKey) {
      target = head;
    }
    if (head === activeElement && shiftKey) {
      target = tail;
    }
    if (target) {
      event.preventDefault();
      target.focus();
      return;
    }
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (!isSafariDesktop)
      return;
    var x = tabbable2.indexOf(activeElement);
    if (x > -1) {
      x += shiftKey ? -1 : 1;
    }
    target = tabbable2[x];
    if (typeof target === "undefined") {
      event.preventDefault();
      target = shiftKey ? tail : head;
      target.focus();
      return;
    }
    event.preventDefault();
    target.focus();
  }
  module.exports = exports["default"];
})(scopeTab, scopeTab.exports);
var ariaAppHider$1 = {};
var warning$1 = function() {
};
var warning_1 = warning$1;
var safeHTMLElement = {};
var exenv = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(module) {
  (function() {
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
      canUseDOM,
      canUseWorkers: typeof Worker !== "undefined",
      canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
      canUseViewport: canUseDOM && !!window.screen
    };
    if (module.exports) {
      module.exports = ExecutionEnvironment;
    } else {
      window.ExecutionEnvironment = ExecutionEnvironment;
    }
  })();
})(exenv);
Object.defineProperty(safeHTMLElement, "__esModule", {
  value: true
});
safeHTMLElement.canUseDOM = safeHTMLElement.SafeNodeList = safeHTMLElement.SafeHTMLCollection = void 0;
var _exenv = exenv.exports;
var _exenv2 = _interopRequireDefault$3(_exenv);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var EE = _exenv2.default;
var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
safeHTMLElement.SafeHTMLCollection = EE.canUseDOM ? window.HTMLCollection : {};
safeHTMLElement.SafeNodeList = EE.canUseDOM ? window.NodeList : {};
safeHTMLElement.canUseDOM = EE.canUseDOM;
safeHTMLElement.default = SafeHTMLElement;
Object.defineProperty(ariaAppHider$1, "__esModule", {
  value: true
});
ariaAppHider$1.resetState = resetState$3;
ariaAppHider$1.log = log$6;
ariaAppHider$1.assertNodeList = assertNodeList;
ariaAppHider$1.setElement = setElement;
ariaAppHider$1.validateElement = validateElement;
ariaAppHider$1.hide = hide$1;
ariaAppHider$1.show = show;
ariaAppHider$1.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
var _warning = warning_1;
var _warning2 = _interopRequireDefault$2(_warning);
var _safeHTMLElement$1 = safeHTMLElement;
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var globalElement = null;
function resetState$3() {
  if (globalElement) {
    if (globalElement.removeAttribute) {
      globalElement.removeAttribute("aria-hidden");
    } else if (globalElement.length != null) {
      globalElement.forEach(function(element) {
        return element.removeAttribute("aria-hidden");
      });
    } else {
      document.querySelectorAll(globalElement).forEach(function(element) {
        return element.removeAttribute("aria-hidden");
      });
    }
  }
  globalElement = null;
}
function log$6() {
}
function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}
function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement$1.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}
function validateElement(appElement) {
  var el = appElement || globalElement;
  if (el) {
    return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [el];
  } else {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
    return [];
  }
}
function hide$1(appElement) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = void 0;
  try {
    for (var _iterator = validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var el = _step.value;
      el.setAttribute("aria-hidden", "true");
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}
function show(appElement) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = void 0;
  try {
    for (var _iterator2 = validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var el = _step2.value;
      el.removeAttribute("aria-hidden");
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}
function documentNotReadyOrSSRTesting() {
  globalElement = null;
}
var classList$1 = {};
Object.defineProperty(classList$1, "__esModule", {
  value: true
});
classList$1.resetState = resetState$2;
classList$1.log = log$5;
var htmlClassList = {};
var docBodyClassList = {};
function removeClass$1(at, cls) {
  at.classList.remove(cls);
}
function resetState$2() {
  var htmlElement = document.getElementsByTagName("html")[0];
  for (var cls in htmlClassList) {
    removeClass$1(htmlElement, htmlClassList[cls]);
  }
  var body = document.body;
  for (var _cls in docBodyClassList) {
    removeClass$1(body, docBodyClassList[_cls]);
  }
  htmlClassList = {};
  docBodyClassList = {};
}
function log$5() {
}
var incrementReference = function incrementReference2(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};
var decrementReference = function decrementReference2(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};
var trackClass = function trackClass2(classListRef, poll, classes) {
  classes.forEach(function(className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};
var untrackClass = function untrackClass2(classListRef, poll, classes) {
  classes.forEach(function(className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};
classList$1.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
classList$1.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};
var portalOpenInstances$1 = {};
Object.defineProperty(portalOpenInstances$1, "__esModule", {
  value: true
});
portalOpenInstances$1.log = log$4;
portalOpenInstances$1.resetState = resetState$1;
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var PortalOpenInstances = function PortalOpenInstances2() {
  var _this = this;
  _classCallCheck$2(this, PortalOpenInstances2);
  this.register = function(openInstance) {
    if (_this.openInstances.indexOf(openInstance) !== -1) {
      return;
    }
    _this.openInstances.push(openInstance);
    _this.emit("register");
  };
  this.deregister = function(openInstance) {
    var index = _this.openInstances.indexOf(openInstance);
    if (index === -1) {
      return;
    }
    _this.openInstances.splice(index, 1);
    _this.emit("deregister");
  };
  this.subscribe = function(callback2) {
    _this.subscribers.push(callback2);
  };
  this.emit = function(eventType) {
    _this.subscribers.forEach(function(subscriber) {
      return subscriber(eventType, _this.openInstances.slice());
    });
  };
  this.openInstances = [];
  this.subscribers = [];
};
var portalOpenInstances = new PortalOpenInstances();
function log$4() {
  console.log("portalOpenInstances ----------");
  console.log(portalOpenInstances.openInstances.length);
  portalOpenInstances.openInstances.forEach(function(p2) {
    return console.log(p2);
  });
  console.log("end portalOpenInstances ----------");
}
function resetState$1() {
  portalOpenInstances = new PortalOpenInstances();
}
portalOpenInstances$1.default = portalOpenInstances;
var bodyTrap$1 = {};
Object.defineProperty(bodyTrap$1, "__esModule", {
  value: true
});
bodyTrap$1.resetState = resetState;
bodyTrap$1.log = log$3;
var _portalOpenInstances = portalOpenInstances$1;
var _portalOpenInstances2 = _interopRequireDefault$1(_portalOpenInstances);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var before = void 0, after = void 0, instances = [];
function resetState() {
  var _arr = [before, after];
  for (var _i = 0; _i < _arr.length; _i++) {
    var item = _arr[_i];
    if (!item)
      continue;
    item.parentNode && item.parentNode.removeChild(item);
  }
  before = after = null;
  instances = [];
}
function log$3() {
  console.log("bodyTrap ----------");
  console.log(instances.length);
  var _arr2 = [before, after];
  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var item = _arr2[_i2];
    var check = item || {};
    console.log(check.nodeName, check.className, check.id);
  }
  console.log("edn bodyTrap ----------");
}
function focusContent() {
  if (instances.length === 0) {
    return;
  }
  instances[instances.length - 1].focusContent();
}
function bodyTrap(eventType, openInstances) {
  if (!before && !after) {
    before = document.createElement("div");
    before.setAttribute("data-react-modal-body-trap", "");
    before.style.position = "absolute";
    before.style.opacity = "0";
    before.setAttribute("tabindex", "0");
    before.addEventListener("focus", focusContent);
    after = before.cloneNode();
    after.addEventListener("focus", focusContent);
  }
  instances = openInstances;
  if (instances.length > 0) {
    if (document.body.firstChild !== before) {
      document.body.insertBefore(before, document.body.firstChild);
    }
    if (document.body.lastChild !== after) {
      document.body.appendChild(after);
    }
  } else {
    if (before.parentElement) {
      before.parentElement.removeChild(before);
    }
    if (after.parentElement) {
      after.parentElement.removeChild(after);
    }
  }
}
_portalOpenInstances2.default.subscribe(bodyTrap);
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
  } : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };
  var _createClass2 = function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  var _react3 = require$$0$1;
  var _propTypes3 = PropTypes;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var _focusManager = focusManager;
  var focusManager$1 = _interopRequireWildcard2(_focusManager);
  var _scopeTab = scopeTab.exports;
  var _scopeTab2 = _interopRequireDefault2(_scopeTab);
  var _ariaAppHider2 = ariaAppHider$1;
  var ariaAppHider2 = _interopRequireWildcard2(_ariaAppHider2);
  var _classList = classList$1;
  var classList2 = _interopRequireWildcard2(_classList);
  var _safeHTMLElement3 = safeHTMLElement;
  var _safeHTMLElement22 = _interopRequireDefault2(_safeHTMLElement3);
  var _portalOpenInstances3 = portalOpenInstances$1;
  var _portalOpenInstances22 = _interopRequireDefault2(_portalOpenInstances3);
  function _interopRequireWildcard2(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key))
            newObj[key] = obj[key];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  };
  var TAB_KEY = 9;
  var ESC_KEY = 27;
  var ariaHiddenInstances = 0;
  var ModalPortal2 = function(_Component) {
    _inherits2(ModalPortal3, _Component);
    function ModalPortal3(props) {
      _classCallCheck2(this, ModalPortal3);
      var _this = _possibleConstructorReturn2(this, (ModalPortal3.__proto__ || Object.getPrototypeOf(ModalPortal3)).call(this, props));
      _this.setOverlayRef = function(overlay) {
        _this.overlay = overlay;
        _this.props.overlayRef && _this.props.overlayRef(overlay);
      };
      _this.setContentRef = function(content2) {
        _this.content = content2;
        _this.props.contentRef && _this.props.contentRef(content2);
      };
      _this.afterClose = function() {
        var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName2 = _this$props.bodyOpenClassName;
        bodyOpenClassName2 && classList2.remove(document.body, bodyOpenClassName2);
        htmlOpenClassName && classList2.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
        if (ariaHideApp && ariaHiddenInstances > 0) {
          ariaHiddenInstances -= 1;
          if (ariaHiddenInstances === 0) {
            ariaAppHider2.show(appElement);
          }
        }
        if (_this.props.shouldFocusAfterRender) {
          if (_this.props.shouldReturnFocusAfterClose) {
            focusManager$1.returnFocus(_this.props.preventScroll);
            focusManager$1.teardownScopedFocus();
          } else {
            focusManager$1.popWithoutFocus();
          }
        }
        if (_this.props.onAfterClose) {
          _this.props.onAfterClose();
        }
        _portalOpenInstances22.default.deregister(_this);
      };
      _this.open = function() {
        _this.beforeOpen();
        if (_this.state.afterOpen && _this.state.beforeClose) {
          clearTimeout(_this.closeTimer);
          _this.setState({ beforeClose: false });
        } else {
          if (_this.props.shouldFocusAfterRender) {
            focusManager$1.setupScopedFocus(_this.node);
            focusManager$1.markForFocusLater();
          }
          _this.setState({ isOpen: true }, function() {
            _this.openAnimationFrame = requestAnimationFrame(function() {
              _this.setState({ afterOpen: true });
              if (_this.props.isOpen && _this.props.onAfterOpen) {
                _this.props.onAfterOpen({
                  overlayEl: _this.overlay,
                  contentEl: _this.content
                });
              }
            });
          });
        }
      };
      _this.close = function() {
        if (_this.props.closeTimeoutMS > 0) {
          _this.closeWithTimeout();
        } else {
          _this.closeWithoutTimeout();
        }
      };
      _this.focusContent = function() {
        return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
      };
      _this.closeWithTimeout = function() {
        var closesAt = Date.now() + _this.props.closeTimeoutMS;
        _this.setState({ beforeClose: true, closesAt }, function() {
          _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
        });
      };
      _this.closeWithoutTimeout = function() {
        _this.setState({
          beforeClose: false,
          isOpen: false,
          afterOpen: false,
          closesAt: null
        }, _this.afterClose);
      };
      _this.handleKeyDown = function(event) {
        if (event.keyCode === TAB_KEY) {
          (0, _scopeTab2.default)(_this.content, event);
        }
        if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
          event.stopPropagation();
          _this.requestClose(event);
        }
      };
      _this.handleOverlayOnClick = function(event) {
        if (_this.shouldClose === null) {
          _this.shouldClose = true;
        }
        if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
          if (_this.ownerHandlesClose()) {
            _this.requestClose(event);
          } else {
            _this.focusContent();
          }
        }
        _this.shouldClose = null;
      };
      _this.handleContentOnMouseUp = function() {
        _this.shouldClose = false;
      };
      _this.handleOverlayOnMouseDown = function(event) {
        if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
          event.preventDefault();
        }
      };
      _this.handleContentOnClick = function() {
        _this.shouldClose = false;
      };
      _this.handleContentOnMouseDown = function() {
        _this.shouldClose = false;
      };
      _this.requestClose = function(event) {
        return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
      };
      _this.ownerHandlesClose = function() {
        return _this.props.onRequestClose;
      };
      _this.shouldBeClosed = function() {
        return !_this.state.isOpen && !_this.state.beforeClose;
      };
      _this.contentHasFocus = function() {
        return document.activeElement === _this.content || _this.content.contains(document.activeElement);
      };
      _this.buildClassName = function(which, additional) {
        var classNames = (typeof additional === "undefined" ? "undefined" : _typeof2(additional)) === "object" ? additional : {
          base: CLASS_NAMES[which],
          afterOpen: CLASS_NAMES[which] + "--after-open",
          beforeClose: CLASS_NAMES[which] + "--before-close"
        };
        var className = classNames.base;
        if (_this.state.afterOpen) {
          className = className + " " + classNames.afterOpen;
        }
        if (_this.state.beforeClose) {
          className = className + " " + classNames.beforeClose;
        }
        return typeof additional === "string" && additional ? className + " " + additional : className;
      };
      _this.attributesFromObject = function(prefix, items) {
        return Object.keys(items).reduce(function(acc, name) {
          acc[prefix + "-" + name] = items[name];
          return acc;
        }, {});
      };
      _this.state = {
        afterOpen: false,
        beforeClose: false
      };
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
      return _this;
    }
    _createClass2(ModalPortal3, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.isOpen) {
          this.open();
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen && !prevProps.isOpen) {
          this.open();
        } else if (!this.props.isOpen && prevProps.isOpen) {
          this.close();
        }
        if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
          this.focusContent();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.state.isOpen) {
          this.afterClose();
        }
        clearTimeout(this.closeTimer);
        cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function beforeOpen() {
        var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName2 = _props.bodyOpenClassName;
        bodyOpenClassName2 && classList2.add(document.body, bodyOpenClassName2);
        htmlOpenClassName && classList2.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
        if (ariaHideApp) {
          ariaHiddenInstances += 1;
          ariaAppHider2.hide(appElement);
        }
        _portalOpenInstances22.default.register(this);
      }
    }, {
      key: "render",
      value: function render3() {
        var _props2 = this.props, id2 = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
        var contentStyles = className ? {} : defaultStyles.content;
        var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
        if (this.shouldBeClosed()) {
          return null;
        }
        var overlayProps = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends2({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        };
        var contentProps = _extends2({
          id: id2,
          ref: this.setContentRef,
          style: _extends2({}, contentStyles, this.props.style.content),
          className: this.buildClassName("content", className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", _extends2({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        });
        var contentElement2 = this.props.contentElement(contentProps, children);
        return this.props.overlayElement(overlayProps, contentElement2);
      }
    }]);
    return ModalPortal3;
  }(_react3.Component);
  ModalPortal2.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  };
  ModalPortal2.propTypes = {
    isOpen: _propTypes22.default.bool.isRequired,
    defaultStyles: _propTypes22.default.shape({
      content: _propTypes22.default.object,
      overlay: _propTypes22.default.object
    }),
    style: _propTypes22.default.shape({
      content: _propTypes22.default.object,
      overlay: _propTypes22.default.object
    }),
    className: _propTypes22.default.oneOfType([_propTypes22.default.string, _propTypes22.default.object]),
    overlayClassName: _propTypes22.default.oneOfType([_propTypes22.default.string, _propTypes22.default.object]),
    bodyOpenClassName: _propTypes22.default.string,
    htmlOpenClassName: _propTypes22.default.string,
    ariaHideApp: _propTypes22.default.bool,
    appElement: _propTypes22.default.oneOfType([_propTypes22.default.instanceOf(_safeHTMLElement22.default), _propTypes22.default.instanceOf(_safeHTMLElement3.SafeHTMLCollection), _propTypes22.default.instanceOf(_safeHTMLElement3.SafeNodeList), _propTypes22.default.arrayOf(_propTypes22.default.instanceOf(_safeHTMLElement22.default))]),
    onAfterOpen: _propTypes22.default.func,
    onAfterClose: _propTypes22.default.func,
    onRequestClose: _propTypes22.default.func,
    closeTimeoutMS: _propTypes22.default.number,
    shouldFocusAfterRender: _propTypes22.default.bool,
    shouldCloseOnOverlayClick: _propTypes22.default.bool,
    shouldReturnFocusAfterClose: _propTypes22.default.bool,
    preventScroll: _propTypes22.default.bool,
    role: _propTypes22.default.string,
    contentLabel: _propTypes22.default.string,
    aria: _propTypes22.default.object,
    data: _propTypes22.default.object,
    children: _propTypes22.default.node,
    shouldCloseOnEsc: _propTypes22.default.bool,
    overlayRef: _propTypes22.default.func,
    contentRef: _propTypes22.default.func,
    id: _propTypes22.default.string,
    overlayElement: _propTypes22.default.func,
    contentElement: _propTypes22.default.func,
    testId: _propTypes22.default.string
  };
  exports.default = ModalPortal2;
  module.exports = exports["default"];
})(ModalPortal, ModalPortal.exports);
function componentWillMount() {
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== void 0) {
    this.setState(state);
  }
}
function componentWillReceiveProps(nextProps) {
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== void 0 ? state : null;
  }
  this.setState(updater.bind(this));
}
function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;
function polyfill(Component2) {
  var prototype = Component2.prototype;
  if (!prototype || !prototype.isReactComponent) {
    throw new Error("Can only polyfill class components");
  }
  if (typeof Component2.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") {
    return Component2;
  }
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === "function") {
    foundWillMountName = "componentWillMount";
  } else if (typeof prototype.UNSAFE_componentWillMount === "function") {
    foundWillMountName = "UNSAFE_componentWillMount";
  }
  if (typeof prototype.componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "componentWillReceiveProps";
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") {
    foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
  }
  if (typeof prototype.componentWillUpdate === "function") {
    foundWillUpdateName = "componentWillUpdate";
  } else if (typeof prototype.UNSAFE_componentWillUpdate === "function") {
    foundWillUpdateName = "UNSAFE_componentWillUpdate";
  }
  if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
    var componentName = Component2.displayName || Component2.name;
    var newApiName = typeof Component2.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks");
  }
  if (typeof Component2.getDerivedStateFromProps === "function") {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }
  if (typeof prototype.getSnapshotBeforeUpdate === "function") {
    if (typeof prototype.componentDidUpdate !== "function") {
      throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
    }
    prototype.componentWillUpdate = componentWillUpdate;
    var componentDidUpdate = prototype.componentDidUpdate;
    prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
      var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }
  return Component2;
}
var reactLifecyclesCompat_es = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill
}, Symbol.toStringTag, { value: "Module" }));
var require$$6 = /* @__PURE__ */ getAugmentedNamespace(reactLifecyclesCompat_es);
Object.defineProperty(Modal$1, "__esModule", {
  value: true
});
Modal$1.bodyOpenClassName = Modal$1.portalClassName = void 0;
var _extends$7 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass$1 = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require$$0$1;
var _react2 = _interopRequireDefault(_react);
var _reactDom = reactDom.exports;
var _reactDom2 = _interopRequireDefault(_reactDom);
var _propTypes = PropTypes;
var _propTypes2 = _interopRequireDefault(_propTypes);
var _ModalPortal = ModalPortal.exports;
var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
var _ariaAppHider = ariaAppHider$1;
var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
var _safeHTMLElement = safeHTMLElement;
var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
var _reactLifecyclesCompat = require$$6;
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key))
          newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var portalClassName = Modal$1.portalClassName = "ReactModalPortal";
var bodyOpenClassName = Modal$1.bodyOpenClassName = "ReactModal__Body--open";
var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== void 0;
var createHTMLElement = function createHTMLElement2(name) {
  return document.createElement(name);
};
var getCreatePortal = function getCreatePortal2() {
  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function getParentElement(parentSelector2) {
  return parentSelector2();
}
var Modal = function(_Component) {
  _inherits$1(Modal2, _Component);
  function Modal2() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck$1(this, Modal2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Modal2.__proto__ || Object.getPrototypeOf(Modal2)).call.apply(_ref2, [this].concat(args))), _this), _this.removePortal = function() {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      if (parent && parent.contains(_this.node)) {
        parent.removeChild(_this.node);
      } else {
        console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
      }
    }, _this.portalRef = function(ref) {
      _this.portal = ref;
    }, _this.renderPortal = function(props) {
      var createPortal = getCreatePortal();
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends$7({ defaultStyles: Modal2.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass$1(Modal2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM)
        return;
      if (!isReact16) {
        this.node = createHTMLElement("div");
      }
      this.node.className = this.props.portalClassName;
      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent, nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM)
        return;
      var _props = this.props, isOpen = _props.isOpen, portalClassName2 = _props.portalClassName;
      if (prevProps.portalClassName !== portalClassName2) {
        this.node.className = portalClassName2;
      }
      var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }
      if (!prevProps.isOpen && !isOpen)
        return;
      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal)
        return;
      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }
        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render3() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }
      if (!this.node && isReact16) {
        this.node = createHTMLElement("div");
      }
      var createPortal = getCreatePortal();
      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends$7({
        ref: this.portalRef,
        defaultStyles: Modal2.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }
  }]);
  return Modal2;
}(_react.Component);
Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_safeHTMLElement2.default), _propTypes2.default.instanceOf(_safeHTMLElement.SafeHTMLCollection), _propTypes2.default.instanceOf(_safeHTMLElement.SafeNodeList), _propTypes2.default.arrayOf(_propTypes2.default.instanceOf(_safeHTMLElement2.default))]),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  preventScroll: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  data: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  id: _propTypes2.default.string,
  overlayElement: _propTypes2.default.func,
  contentElement: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName,
  bodyOpenClassName,
  role: "dialog",
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  preventScroll: false,
  parentSelector: function parentSelector() {
    return document.body;
  },
  overlayElement: function overlayElement(props, contentEl) {
    return _react2.default.createElement("div", props, contentEl);
  },
  contentElement: function contentElement(props, children) {
    return _react2.default.createElement("div", props, children);
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, _reactLifecyclesCompat.polyfill)(Modal);
Modal$1.default = Modal;
(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _Modal = Modal$1;
  var _Modal2 = _interopRequireDefault2(_Modal);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  exports.default = _Modal2.default;
  module.exports = exports["default"];
})(lib$1, lib$1.exports);
var ReactModal = /* @__PURE__ */ getDefaultExportFromCjs(lib$1.exports);
const ENDPOINT = "/api/v2";
let userInfo = {};
axios.get(`${ENDPOINT}/me`).then((res) => {
  userInfo = res.data;
});
const initialFilters$2 = {
  included_in: [],
  category: [],
  status: [{
    label: "Published",
    value: "published",
    checked: false
  }, {
    label: "Unpublished",
    value: "unpublished",
    checked: false
  }],
  keyword: "",
  page: 1,
  per_page: 24
};
const hideIncludedIns = ["Assessment", "Slide", "Investigation", "Video Activity"];
let filterCancelToken$2;
const getFilteredVideos = (filters, programId) => {
  var _a, _b;
  if (filterCancelToken$2 !== void 0) {
    filterCancelToken$2.cancel("Operation canceled due to new request.");
  }
  filterCancelToken$2 = axios.CancelToken.source();
  const params = {
    "search[program_id_eq]": programId,
    "search[lesson_ids_in]": [],
    "search[tag_ids_in]": [],
    "search[title_en_cont]": filters.keyword.length ? filters.keyword : void 0,
    page: filters.page,
    per_page: filters.per_page,
    column: "title_en",
    order: "asc"
  };
  (_a = filters.unit) == null ? void 0 : _a.forEach((unitFilers) => {
    const checkedLessons = unitFilers.lessons.filter((lessonFilter) => lessonFilter.checked).map((lessonFilter) => lessonFilter.value);
    params["search[lesson_ids_in]"].push(...checkedLessons);
  });
  (_b = filters.lesson) == null ? void 0 : _b.forEach((lessonFilter) => {
    if (lessonFilter.checked) {
      params["search[lesson_ids_in]"].push(lessonFilter.value);
    }
  });
  filters.included_in.forEach((includedFilter) => {
    if (includedFilter.checked) {
      params[`search[${includedFilter.value}]`] = true;
    }
  });
  filters.category.filter((categoryFilter) => categoryFilter.checked).forEach((categoryFilter) => {
    params["search[tag_ids_in]"].push(categoryFilter.value);
  });
  if (userInfo.student) {
    params["search[published_eq]"] = true;
  } else {
    if (filters.status.some((statusFilter) => statusFilter.checked && statusFilter.value === "published")) {
      params["search[published_eq]"] = true;
    }
    if (filters.status.some((statusFilter) => statusFilter.checked && statusFilter.value === "unpublished")) {
      if (params["search[published_eq]"] === true) {
        params["search[published_eq]"] = void 0;
      } else {
        params["search[published_eq]"] = false;
      }
    }
  }
  return axios({
    method: "get",
    url: `${ENDPOINT}/videos`,
    params,
    cancelToken: filterCancelToken$2.token
  }).then((res) => ({
    data: res.data.data,
    count: res.data.meta.count
  }));
};
const getFilters$2 = (programId) => {
  const sortFilter = (filterA, filterB) => {
    return filterA.label.toLowerCase().localeCompare(filterB.label.toLocaleLowerCase());
  };
  return axios.get(`${ENDPOINT}/videos/filter_categories?program_id=${programId}`).then((res) => {
    var _a, _b, _c;
    const filters = {
      ...initialFilters$2
    };
    const savedFilters = JSON.parse((_a = localStorage.getItem("video-filters")) != null ? _a : JSON.stringify(initialFilters$2));
    filters.unit = (_b = res.data.unit) == null ? void 0 : _b.map((unit) => {
      const label = Object.keys(unit)[0];
      const lessons = Object.values(unit)[0].map((lessonFilter) => {
        var _a2;
        const checked = (_a2 = savedFilters.unit) == null ? void 0 : _a2.some((unitFilter) => unitFilter.lessons.find((savedLesson) => savedLesson.value === lessonFilter.value && savedLesson.checked));
        return {
          ...lessonFilter,
          checked
        };
      });
      return {
        label,
        lessons
      };
    });
    filters.lesson = (_c = res.data.lesson) == null ? void 0 : _c.map((lessonFilter) => {
      var _a2;
      lessonFilter.checked = (_a2 = savedFilters.lesson) == null ? void 0 : _a2.some((savedLesson) => savedLesson.value === lessonFilter.value && savedLesson.checked);
      return lessonFilter;
    });
    filters.included_in = res.data.included_in.filter((includedFilter) => !hideIncludedIns.includes(includedFilter.label)).map((includedFilter) => {
      const checked = savedFilters.included_in.some((savedIncluded) => savedIncluded.value === includedFilter.value && savedIncluded.checked);
      return {
        ...includedFilter,
        checked
      };
    }).sort(sortFilter);
    filters.status = filters.status.map((statusFilter) => {
      const checked = savedFilters.status.some((savedStatus) => savedStatus.value === statusFilter.value && savedStatus.checked);
      return {
        ...statusFilter,
        checked
      };
    });
    return filters;
  });
};
const publishVideo = (videoId) => {
  return axios.post(`${ENDPOINT}/videos/${videoId}/publish`);
};
const unpublishVideo = (videoId) => {
  return axios.post(`${ENDPOINT}/videos/${videoId}/unpublish`);
};
const getVideoDisplayProps = (videoId) => {
  return axios.get(`${ENDPOINT}/videos/${videoId}?only[]=id&extra_attributes[]=display_props`);
};
const page = "_page_1l9py_1";
const loading$5 = "_loading_1l9py_6";
const topPagination = "_topPagination_1l9py_13";
const container$4 = "_container_1l9py_19";
const description$2 = "_description_1l9py_23";
const cardContainer$1 = "_cardContainer_1l9py_28";
const paginationWrapper$1 = "_paginationWrapper_1l9py_37";
const bottomPagination$1 = "_bottomPagination_1l9py_44";
const noResult$2 = "_noResult_1l9py_48";
const noResultTitle$2 = "_noResultTitle_1l9py_52";
const noResultDescription$2 = "_noResultDescription_1l9py_60";
var styles$j = {
  page,
  loading: loading$5,
  topPagination,
  container: container$4,
  description: description$2,
  cardContainer: cardContainer$1,
  paginationWrapper: paginationWrapper$1,
  bottomPagination: bottomPagination$1,
  noResult: noResult$2,
  noResultTitle: noResultTitle$2,
  noResultDescription: noResultDescription$2
};
const videoCard = "_videoCard_6g4xw_1";
const cardImg$1 = "_cardImg_6g4xw_11";
const blackImg$1 = "_blackImg_6g4xw_21";
const playButton = "_playButton_6g4xw_29";
const videoLength = "_videoLength_6g4xw_45";
const cardTitle$1 = "_cardTitle_6g4xw_53";
const cardContent$1 = "_cardContent_6g4xw_65";
const cardSubtitle$1 = "_cardSubtitle_6g4xw_72";
const included_in = "_included_in_6g4xw_82";
const publishButton = "_publishButton_6g4xw_91";
var style$1 = {
  videoCard,
  cardImg: cardImg$1,
  blackImg: blackImg$1,
  playButton,
  videoLength,
  cardTitle: cardTitle$1,
  cardContent: cardContent$1,
  cardSubtitle: cardSubtitle$1,
  included_in,
  publishButton
};
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser$2 = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var timeoutDuration = function() {
  var longerTimeoutBrowsers = ["Edge", "Trident", "Firefox"];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser$2 && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();
function microtaskDebounce(fn) {
  var called = false;
  return function() {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function() {
      called = false;
      fn();
    });
  };
}
function taskDebounce(fn) {
  var scheduled = false;
  return function() {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function() {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}
var supportsMicroTasks = isBrowser$2 && window.Promise;
var debounce$2 = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction$2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  var window2 = element.ownerDocument.defaultView;
  var css2 = window2.getComputedStyle(element, null);
  return property ? css2[property] : css2;
}
function getParentNode(element) {
  if (element.nodeName === "HTML") {
    return element;
  }
  return element.parentNode || element.host;
}
function getScrollParent(element) {
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case "HTML":
    case "BODY":
      return element.ownerDocument.body;
    case "#document":
      return element.body;
  }
  var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser$2 && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser$2 && /MSIE 10/.test(navigator.userAgent);
function isIE$1(version2) {
  if (version2 === 11) {
    return isIE11;
  }
  if (version2 === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }
  var noOffsetParent = isIE$1(10) ? document.body : null;
  var offsetParent = element.offsetParent || null;
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }
  var nodeName = offsetParent && offsetParent.nodeName;
  if (!nodeName || nodeName === "BODY" || nodeName === "HTML") {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }
  if (["TH", "TD", "TABLE"].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, "position") === "static") {
    return getOffsetParent(offsetParent);
  }
  return offsetParent;
}
function isOffsetContainer(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY") {
    return false;
  }
  return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
}
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }
  return node;
}
function findCommonOffsetParent(element1, element2) {
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start2 = order ? element1 : element2;
  var end3 = order ? element2 : element1;
  var range3 = document.createRange();
  range3.setStart(start2, 0);
  range3.setEnd(end3, 0);
  var commonAncestorContainer = range3.commonAncestorContainer;
  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start2.contains(end3)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }
    return getOffsetParent(commonAncestorContainer);
  }
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top";
  var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }
  return element[upperSide];
}
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var scrollTop = getScroll(element, "top");
  var scrollLeft = getScroll(element, "left");
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
function getBordersSize(styles2, axis) {
  var sideA = axis === "x" ? "Left" : "Top";
  var sideB = sideA === "Left" ? "Right" : "Bottom";
  return parseFloat(styles2["border" + sideA + "Width"]) + parseFloat(styles2["border" + sideB + "Width"]);
}
function getSize(axis, body, html, computedStyle2) {
  return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], isIE$1(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle2["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle2["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(document2) {
  var body = document2.body;
  var html = document2.documentElement;
  var computedStyle2 = isIE$1(10) && getComputedStyle(html);
  return {
    height: getSize("Height", body, html, computedStyle2),
    width: getSize("Width", body, html, computedStyle2)
  };
}
var classCallCheck = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var defineProperty = function(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends$6 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function getClientRect(offsets) {
  return _extends$6({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
function getBoundingClientRect$1(element) {
  var rect = {};
  try {
    if (isIE$1(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, "top");
      var scrollLeft = getScroll(element, "left");
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {
  }
  var result2 = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
  var sizes = element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
  var width2 = sizes.width || element.clientWidth || result2.width;
  var height2 = sizes.height || element.clientHeight || result2.height;
  var horizScrollbar = element.offsetWidth - width2;
  var vertScrollbar = element.offsetHeight - height2;
  if (horizScrollbar || vertScrollbar) {
    var styles2 = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles2, "x");
    vertScrollbar -= getBordersSize(styles2, "y");
    result2.width -= horizScrollbar;
    result2.height -= vertScrollbar;
  }
  return getClientRect(result2);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var isIE102 = isIE$1(10);
  var isHTML = parent.nodeName === "HTML";
  var childrenRect = getBoundingClientRect$1(children);
  var parentRect = getBoundingClientRect$1(parent);
  var scrollParent = getScrollParent(children);
  var styles2 = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles2.borderTopWidth);
  var borderLeftWidth = parseFloat(styles2.borderLeftWidth);
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;
  if (!isIE102 && isHTML) {
    var marginTop = parseFloat(styles2.marginTop);
    var marginLeft = parseFloat(styles2.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }
  if (isIE102 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") {
    offsets = includeScroll(offsets, parent);
  }
  return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width2 = Math.max(html.clientWidth, window.innerWidth || 0);
  var height2 = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
  var offset2 = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width2,
    height: height2
  };
  return getClientRect(offset2);
}
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    return false;
  }
  if (getStyleComputedProperty(element, "position") === "fixed") {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}
function getFixedPositionOffsetParent(element) {
  if (!element || !element.parentElement || isIE$1()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, "transform") === "none") {
    el = el.parentElement;
  }
  return el || document.documentElement;
}
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  if (boundariesElement === "viewport") {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    var boundariesNode = void 0;
    if (boundariesElement === "scrollParent") {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === "BODY") {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === "window") {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }
    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
    if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument), height2 = _getWindowSizes.height, width2 = _getWindowSizes.width;
      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height2 + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width2 + offsets.left;
    } else {
      boundaries = offsets;
    }
  }
  padding = padding || 0;
  var isPaddingNumber = typeof padding === "number";
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}
function getArea(_ref2) {
  var width2 = _ref2.width, height2 = _ref2.height;
  return width2 * height2;
}
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (placement.indexOf("auto") === -1) {
    return placement;
  }
  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function(key) {
    return _extends$6({
      key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function(a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function(_ref2) {
    var width2 = _ref2.width, height2 = _ref2.height;
    return width2 >= popper.clientWidth && height2 >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split("-")[1];
  return computedPlacement + (variation ? "-" + variation : "");
}
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
function getOuterSizes(element) {
  var window2 = element.ownerDocument.defaultView;
  var styles2 = window2.getComputedStyle(element);
  var x = parseFloat(styles2.marginTop || 0) + parseFloat(styles2.marginBottom || 0);
  var y2 = parseFloat(styles2.marginLeft || 0) + parseFloat(styles2.marginRight || 0);
  var result2 = {
    width: element.offsetWidth + y2,
    height: element.offsetHeight + x
  };
  return result2;
}
function getOppositePlacement(placement) {
  var hash = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash[matched];
  });
}
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split("-")[0];
  var popperRect = getOuterSizes(popper);
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };
  var isHoriz = ["right", "left"].indexOf(placement) !== -1;
  var mainSide = isHoriz ? "top" : "left";
  var secondarySide = isHoriz ? "left" : "top";
  var measurement = isHoriz ? "height" : "width";
  var secondaryMeasurement = !isHoriz ? "height" : "width";
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }
  return popperOffsets;
}
function find$2(arr, check) {
  if (Array.prototype.find) {
    return arr.find(check);
  }
  return arr.filter(check)[0];
}
function findIndex$1(arr, prop, value) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(function(cur) {
      return cur[prop] === value;
    });
  }
  var match = find$2(arr, function(obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}
function runModifiers(modifiers2, data, ends) {
  var modifiersToRun = ends === void 0 ? modifiers2 : modifiers2.slice(0, findIndex$1(modifiers2, "name", ends));
  modifiersToRun.forEach(function(modifier) {
    if (modifier["function"]) {
      console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    }
    var fn = modifier["function"] || modifier.fn;
    if (modifier.enabled && isFunction$2(fn)) {
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}
function update() {
  if (this.state.isDestroyed) {
    return;
  }
  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed;
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
  data = runModifiers(this.modifiers, data);
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
function isModifierEnabled(modifiers2, modifierName) {
  return modifiers2.some(function(_ref2) {
    var name = _ref2.name, enabled = _ref2.enabled;
    return enabled && name === modifierName;
  });
}
function getSupportedPropertyName(property) {
  var prefixes = [false, "ms", "Webkit", "Moz", "O"];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? "" + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== "undefined") {
      return toCheck;
    }
  }
  return null;
}
function destroy() {
  this.state.isDestroyed = true;
  if (isModifierEnabled(this.modifiers, "applyStyle")) {
    this.popper.removeAttribute("x-placement");
    this.popper.style.position = "";
    this.popper.style.top = "";
    this.popper.style.left = "";
    this.popper.style.right = "";
    this.popper.style.bottom = "";
    this.popper.style.willChange = "";
    this.popper.style[getSupportedPropertyName("transform")] = "";
  }
  this.disableEventListeners();
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback2, scrollParents) {
  var isBody = scrollParent.nodeName === "BODY";
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback2, { passive: true });
  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback2, scrollParents);
  }
  scrollParents.push(target);
}
function setupEventListeners(reference, options, state, updateBound) {
  state.updateBound = updateBound;
  getWindow(reference).addEventListener("resize", state.updateBound, { passive: true });
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
function removeEventListeners(reference, state) {
  getWindow(reference).removeEventListener("resize", state.updateBound);
  state.scrollParents.forEach(function(target) {
    target.removeEventListener("scroll", state.updateBound);
  });
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
function isNumeric(n2) {
  return n2 !== "" && !isNaN(parseFloat(n2)) && isFinite(n2);
}
function setStyles(element, styles2) {
  Object.keys(styles2).forEach(function(prop) {
    var unit = "";
    if (["width", "height", "top", "right", "bottom", "left"].indexOf(prop) !== -1 && isNumeric(styles2[prop])) {
      unit = "px";
    }
    element.style[prop] = styles2[prop] + unit;
  });
}
function setAttributes$1(element, attributes) {
  Object.keys(attributes).forEach(function(prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
function applyStyle(data) {
  setStyles(data.instance.popper, data.styles);
  setAttributes$1(data.instance.popper, data.attributes);
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }
  return data;
}
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute("x-placement", placement);
  setStyles(popper, { position: options.positionFixed ? "fixed" : "absolute" });
  return options;
}
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var round = Math.round, floor = Math.floor;
  var noRound = function noRound2(v) {
    return v;
  };
  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ["left", "right"].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf("-") !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}
var isFirefox = isBrowser$2 && /Firefox/i.test(navigator.userAgent);
function computeStyle(data, options) {
  var x = options.x, y2 = options.y;
  var popper = data.offsets.popper;
  var legacyGpuAccelerationOption = find$2(data.instance.modifiers, function(modifier) {
    return modifier.name === "applyStyle";
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== void 0) {
    console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== void 0 ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect$1(offsetParent);
  var styles2 = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === "bottom" ? "top" : "bottom";
  var sideB = y2 === "right" ? "left" : "right";
  var prefixedProperty = getSupportedPropertyName("transform");
  var left = void 0, top = void 0;
  if (sideA === "bottom") {
    if (offsetParent.nodeName === "HTML") {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === "right") {
    if (offsetParent.nodeName === "HTML") {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles2[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
    styles2[sideA] = 0;
    styles2[sideB] = 0;
    styles2.willChange = "transform";
  } else {
    var invertTop = sideA === "bottom" ? -1 : 1;
    var invertLeft = sideB === "right" ? -1 : 1;
    styles2[sideA] = top * invertTop;
    styles2[sideB] = left * invertLeft;
    styles2.willChange = sideA + ", " + sideB;
  }
  var attributes = {
    "x-placement": data.placement
  };
  data.attributes = _extends$6({}, attributes, data.attributes);
  data.styles = _extends$6({}, styles2, data.styles);
  data.arrowStyles = _extends$6({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
function isModifierRequired(modifiers2, requestingName, requestedName) {
  var requesting = find$2(modifiers2, function(_ref2) {
    var name = _ref2.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers2.some(function(modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });
  if (!isRequired) {
    var _requesting = "`" + requestingName + "`";
    var requested = "`" + requestedName + "`";
    console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
  }
  return isRequired;
}
function arrow(data, options) {
  var _data$offsets$arrow;
  if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) {
    return data;
  }
  var arrowElement = options.element;
  if (typeof arrowElement === "string") {
    arrowElement = data.instance.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return data;
    }
  } else {
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn("WARNING: `arrow.element` must be child of its popper element!");
      return data;
    }
  }
  var placement = data.placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isVertical = ["left", "right"].indexOf(placement) !== -1;
  var len = isVertical ? "height" : "width";
  var sideCapitalized = isVertical ? "Top" : "Left";
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? "left" : "top";
  var opSide = isVertical ? "bottom" : "right";
  var arrowElementSize = getOuterSizes(arrowElement)[len];
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
  var css2 = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css2["margin" + sideCapitalized]);
  var popperBorderSide = parseFloat(css2["border" + sideCapitalized + "Width"]);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
  return data;
}
function getOppositeVariation(variation) {
  if (variation === "end") {
    return "start";
  } else if (variation === "start") {
    return "end";
  }
  return variation;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"];
var validPlacements = placements.slice(3);
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip(data, options) {
  if (isModifierEnabled(data.instance.modifiers, "inner")) {
    return data;
  }
  if (data.flipped && data.placement === data.originalPlacement) {
    return data;
  }
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split("-")[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split("-")[1] || "";
  var flipOrder = [];
  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }
  flipOrder.forEach(function(step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }
    placement = data.placement.split("-")[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;
    var floor = Math.floor;
    var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
    var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      data.flipped = true;
      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }
      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }
      data.placement = placement + (variation ? "-" + variation : "");
      data.offsets.popper = _extends$6({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, "flip");
    }
  });
  return data;
}
function keepTogether(data) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var placement = data.placement.split("-")[0];
  var floor = Math.floor;
  var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
  var side = isVertical ? "right" : "bottom";
  var opSide = isVertical ? "left" : "top";
  var measurement = isVertical ? "width" : "height";
  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }
  return data;
}
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  var split2 = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split2[1];
  var unit = split2[2];
  if (!value) {
    return str;
  }
  if (unit.indexOf("%") === 0) {
    var element = void 0;
    switch (unit) {
      case "%p":
        element = popperOffsets;
        break;
      case "%":
      case "%r":
      default:
        element = referenceOffsets;
    }
    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === "vh" || unit === "vw") {
    var size = void 0;
    if (unit === "vh") {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    return value;
  }
}
function parseOffset(offset2, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];
  var useHeight = ["right", "left"].indexOf(basePlacement) !== -1;
  var fragments = offset2.split(/(\+|\-)/).map(function(frag) {
    return frag.trim();
  });
  var divider2 = fragments.indexOf(find$2(fragments, function(frag) {
    return frag.search(/,|\s/) !== -1;
  }));
  if (fragments[divider2] && fragments[divider2].indexOf(",") === -1) {
    console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  }
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider2 !== -1 ? [fragments.slice(0, divider2).concat([fragments[divider2].split(splitRegex)[0]]), [fragments[divider2].split(splitRegex)[1]].concat(fragments.slice(divider2 + 1))] : [fragments];
  ops = ops.map(function(op, index) {
    var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
    var mergeWithPrevious = false;
    return op.reduce(function(a, b) {
      if (a[a.length - 1] === "" && ["+", "-"].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, []).map(function(str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });
  ops.forEach(function(op, index) {
    op.forEach(function(frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
      }
    });
  });
  return offsets;
}
function offset(data, _ref2) {
  var offset2 = _ref2.offset;
  var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var basePlacement = placement.split("-")[0];
  var offsets = void 0;
  if (isNumeric(+offset2)) {
    offsets = [+offset2, 0];
  } else {
    offsets = parseOffset(offset2, popper, reference, basePlacement);
  }
  if (basePlacement === "left") {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === "right") {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === "top") {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === "bottom") {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }
  data.popper = popper;
  return data;
}
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }
  var transformProp = getSupportedPropertyName("transform");
  var popperStyles = data.instance.popper.style;
  var top = popperStyles.top, left = popperStyles.left, transform3 = popperStyles[transformProp];
  popperStyles.top = "";
  popperStyles.left = "";
  popperStyles[transformProp] = "";
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform3;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === "right" ? "left" : "top";
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };
  order.forEach(function(placement) {
    var side = ["left", "top"].indexOf(placement) !== -1 ? "primary" : "secondary";
    popper = _extends$6({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var shiftvariation = placement.split("-")[1];
  if (shiftvariation) {
    var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
    var isVertical = ["bottom", "top"].indexOf(basePlacement) !== -1;
    var side = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends$6({}, popper, shiftOffsets[shiftvariation]);
  }
  return data;
}
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) {
    return data;
  }
  var refRect = data.offsets.reference;
  var bound = find$2(data.instance.modifiers, function(modifier) {
    return modifier.name === "preventOverflow";
  }).boundaries;
  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    if (data.hide === true) {
      return data;
    }
    data.hide = true;
    data.attributes["x-out-of-boundaries"] = "";
  } else {
    if (data.hide === false) {
      return data;
    }
    data.hide = false;
    data.attributes["x-out-of-boundaries"] = false;
  }
  return data;
}
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isHoriz = ["left", "right"].indexOf(basePlacement) !== -1;
  var subtractLength = ["top", "left"].indexOf(basePlacement) === -1;
  popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}
var modifiers = {
  shift: {
    order: 100,
    enabled: true,
    fn: shift
  },
  offset: {
    order: 200,
    enabled: true,
    fn: offset,
    offset: 0
  },
  preventOverflow: {
    order: 300,
    enabled: true,
    fn: preventOverflow,
    priority: ["left", "right", "top", "bottom"],
    padding: 5,
    boundariesElement: "scrollParent"
  },
  keepTogether: {
    order: 400,
    enabled: true,
    fn: keepTogether
  },
  arrow: {
    order: 500,
    enabled: true,
    fn: arrow,
    element: "[x-arrow]"
  },
  flip: {
    order: 600,
    enabled: true,
    fn: flip,
    behavior: "flip",
    padding: 5,
    boundariesElement: "viewport",
    flipVariations: false,
    flipVariationsByContent: false
  },
  inner: {
    order: 700,
    enabled: false,
    fn: inner
  },
  hide: {
    order: 800,
    enabled: true,
    fn: hide
  },
  computeStyle: {
    order: 850,
    enabled: true,
    fn: computeStyle,
    gpuAcceleration: true,
    x: "bottom",
    y: "right"
  },
  applyStyle: {
    order: 900,
    enabled: true,
    fn: applyStyle,
    onLoad: applyStyleOnLoad,
    gpuAcceleration: void 0
  }
};
var Defaults = {
  placement: "bottom",
  positionFixed: false,
  eventsEnabled: true,
  removeOnDestroy: false,
  onCreate: function onCreate() {
  },
  onUpdate: function onUpdate() {
  },
  modifiers
};
var Popper = function() {
  function Popper2(reference, popper) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, Popper2);
    this.scheduleUpdate = function() {
      return requestAnimationFrame(_this.update);
    };
    this.update = debounce$2(this.update.bind(this));
    this.options = _extends$6({}, Popper2.Defaults, options);
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;
    this.options.modifiers = {};
    Object.keys(_extends$6({}, Popper2.Defaults.modifiers, options.modifiers)).forEach(function(name) {
      _this.options.modifiers[name] = _extends$6({}, Popper2.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });
    this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
      return _extends$6({
        name
      }, _this.options.modifiers[name]);
    }).sort(function(a, b) {
      return a.order - b.order;
    });
    this.modifiers.forEach(function(modifierOptions) {
      if (modifierOptions.enabled && isFunction$2(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });
    this.update();
    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      this.enableEventListeners();
    }
    this.state.eventsEnabled = eventsEnabled;
  }
  createClass(Popper2, [{
    key: "update",
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: "destroy",
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
  }]);
  return Popper2;
}();
Popper.Utils = (typeof window !== "undefined" ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
var Popper$1 = Popper;
function _extends$5() {
  _extends$5 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$5.apply(this, arguments);
}
var version$6 = "5.2.1";
function reflow(element) {
  void element.offsetHeight;
}
function setInnerHTML(element, html) {
  element[innerHTML()] = html;
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }
  if (isNodeList(value)) {
    return arrayFrom(value);
  }
  if (Array.isArray(value)) {
    return value;
  }
  return arrayFrom(document.querySelectorAll(value));
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }
  return value;
}
function getModifier(obj, key) {
  return obj && obj.modifiers && obj.modifiers[key];
}
function isType(value, type2) {
  var str = {}.toString.call(value);
  return str.indexOf("[object") === 0 && str.indexOf(type2 + "]") > -1;
}
function isElement(value) {
  return isType(value, "Element");
}
function isNodeList(value) {
  return isType(value, "NodeList");
}
function isMouseEvent(value) {
  return isType(value, "MouseEvent");
}
function innerHTML() {
  return "innerHTML";
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === "function" ? value.apply(void 0, args) : value;
}
function setModifierValue(modifiers2, name, property, value) {
  modifiers2.filter(function(m2) {
    return m2.name === name;
  })[0][property] = value;
}
function div() {
  return document.createElement("div");
}
function setTransitionDuration(els, value) {
  els.forEach(function(el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function(el) {
    if (el) {
      el.setAttribute("data-state", state);
    }
  });
}
function debounce$1(fn, ms) {
  if (ms === 0) {
    return fn;
  }
  var timeout;
  return function(arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      fn(arg);
    }, ms);
  };
}
function preserveInvocation(originalFn, currentFn, args) {
  if (originalFn && originalFn !== currentFn) {
    originalFn.apply(void 0, args);
  }
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function closestCallback(element, callback2) {
  while (element) {
    if (callback2(element)) {
      return element;
    }
    element = element.parentElement;
  }
  return null;
}
function includes(a, b) {
  return a.indexOf(b) > -1;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function useIfDefined(nextValue, currentValue) {
  return nextValue !== void 0 ? nextValue : currentValue;
}
function normalizeToArray(value) {
  return [].concat(value);
}
function getOwnerDocument(elementOrElements) {
  var _normalizeToArray = normalizeToArray(elementOrElements), element = _normalizeToArray[0];
  return element ? element.ownerDocument || document : document;
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function appendPxIfNumber(value) {
  return typeof value === "number" ? value + "px" : value;
}
function unique(arr) {
  return arr.filter(function(item, index) {
    return arr.indexOf(item) === index;
  });
}
function getNumber(value) {
  return typeof value === "number" ? value : parseFloat(value);
}
function getUnitsInPx(doc, value) {
  var isRem = typeof value === "string" && includes(value, "rem");
  var html = doc.documentElement;
  var rootFontSize = 16;
  if (html && isRem) {
    return parseFloat(getComputedStyle(html).fontSize || String(rootFontSize)) * getNumber(value);
  }
  return getNumber(value);
}
function getComputedPadding(basePlacement, padding, distancePx) {
  if (padding === void 0) {
    padding = 5;
  }
  var freshPaddingObject = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  var keys3 = Object.keys(freshPaddingObject);
  return keys3.reduce(function(obj, key) {
    obj[key] = typeof padding === "number" ? padding : padding[key];
    if (basePlacement === key) {
      obj[key] = typeof padding === "number" ? padding + distancePx : padding[basePlacement] + distancePx;
    }
    return obj;
  }, freshPaddingObject);
}
var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var defaultProps$2 = _extends$5({
  allowHTML: true,
  animation: "fade",
  appendTo: function appendTo() {
    return document.body;
  },
  aria: "describedby",
  arrow: true,
  boundary: "scrollParent",
  content: "",
  delay: 0,
  distance: 10,
  duration: [300, 250],
  flip: true,
  flipBehavior: "flip",
  flipOnUpdate: false,
  hideOnClick: true,
  ignoreAttributes: false,
  inertia: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  lazy: true,
  maxWidth: 350,
  multiple: false,
  offset: 0,
  onAfterUpdate: function onAfterUpdate() {
  },
  onBeforeUpdate: function onBeforeUpdate() {
  },
  onCreate: function onCreate2() {
  },
  onDestroy: function onDestroy() {
  },
  onHidden: function onHidden() {
  },
  onHide: function onHide() {
  },
  onMount: function onMount() {
  },
  onShow: function onShow() {
  },
  onShown: function onShown() {
  },
  onTrigger: function onTrigger() {
  },
  onUntrigger: function onUntrigger() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  role: "tooltip",
  showOnCreate: false,
  theme: "",
  touch: true,
  trigger: "mouseenter focus",
  triggerTarget: null,
  updateDuration: 0,
  zIndex: 9999
}, pluginProps);
var defaultKeys = Object.keys(defaultProps$2);
var POPPER_INSTANCE_DEPENDENCIES = ["arrow", "boundary", "distance", "flip", "flipBehavior", "flipOnUpdate", "offset", "placement", "popperOptions"];
var setDefaultProps = function setDefaultProps2(partialProps) {
  var keys3 = Object.keys(partialProps);
  keys3.forEach(function(key) {
    defaultProps$2[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins2 = passedProps.plugins || [];
  var pluginProps2 = plugins2.reduce(function(acc, plugin) {
    var name = plugin.name, defaultValue = plugin.defaultValue;
    if (name) {
      acc[name] = passedProps[name] !== void 0 ? passedProps[name] : defaultValue;
    }
    return acc;
  }, {});
  return _extends$5({}, passedProps, {}, pluginProps2);
}
function getDataAttributeProps(reference, plugins2) {
  var propKeys = plugins2 ? Object.keys(getExtendedPassedProps(_extends$5({}, defaultProps$2, {
    plugins: plugins2
  }))) : defaultKeys;
  var props = propKeys.reduce(function(acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || "").trim();
    if (!valueAsString) {
      return acc;
    }
    if (key === "content") {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }
    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = _extends$5({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  if (out.interactive) {
    out.aria = null;
  }
  return out;
}
var PASSIVE = {
  passive: true
};
var IOS_CLASS = "tippy-iOS";
var POPPER_CLASS = "tippy-popper";
var TOOLTIP_CLASS = "tippy-tooltip";
var CONTENT_CLASS = "tippy-content";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var POPPER_SELECTOR = "." + POPPER_CLASS;
var TOOLTIP_SELECTOR = "." + TOOLTIP_CLASS;
var CONTENT_SELECTOR = "." + CONTENT_CLASS;
var ARROW_SELECTOR = "." + ARROW_CLASS;
var SVG_ARROW_SELECTOR = "." + SVG_ARROW_CLASS;
var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }
  currentInput.isTouch = true;
  if (window.performance) {
    document.addEventListener("mousemove", onDocumentMouseMove);
  }
}
function onDocumentMouseMove() {
  var now = performance.now();
  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener("mousemove", onDocumentMouseMove);
  }
  lastMouseMoveTime = now;
}
function onWindowBlur() {
  var activeElement = document.activeElement;
  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;
    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener("touchstart", onDocumentTouchStart, _extends$5({}, PASSIVE, {
    capture: true
  }));
  window.addEventListener("blur", onWindowBlur);
}
var isBrowser$1 = typeof window !== "undefined" && typeof document !== "undefined";
var ua = isBrowser$1 ? navigator.userAgent : "";
var isIE = /MSIE |Trident\//.test(ua);
var isIOS = isBrowser$1 && /iPhone|iPad|iPod/.test(navigator.platform);
function updateIOSClass(isAdd) {
  var shouldAdd = isAdd && isIOS && currentInput.isTouch;
  document.body.classList[shouldAdd ? "add" : "remove"](IOS_CLASS);
}
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
function addInertia(tooltip) {
  tooltip.setAttribute("data-inertia", "");
}
function removeInertia(tooltip) {
  tooltip.removeAttribute("data-inertia");
}
function addInteractive(tooltip) {
  tooltip.setAttribute("data-interactive", "");
}
function removeInteractive(tooltip) {
  tooltip.removeAttribute("data-interactive");
}
function setContent(contentEl, props) {
  if (isElement(props.content)) {
    setInnerHTML(contentEl, "");
    contentEl.appendChild(props.content);
  } else if (typeof props.content !== "function") {
    var key = props.allowHTML ? "innerHTML" : "textContent";
    contentEl[key] = props.content;
  }
}
function getChildren(popper) {
  return {
    tooltip: popper.querySelector(TOOLTIP_SELECTOR),
    content: popper.querySelector(CONTENT_SELECTOR),
    arrow: popper.querySelector(ARROW_SELECTOR) || popper.querySelector(SVG_ARROW_SELECTOR)
  };
}
function createArrowElement(arrow2) {
  var arrowElement = div();
  if (arrow2 === true) {
    arrowElement.className = ARROW_CLASS;
  } else {
    arrowElement.className = SVG_ARROW_CLASS;
    if (isElement(arrow2)) {
      arrowElement.appendChild(arrow2);
    } else {
      setInnerHTML(arrowElement, arrow2);
    }
  }
  return arrowElement;
}
function createPopperElement(id2, props) {
  var popper = div();
  popper.className = POPPER_CLASS;
  popper.style.position = "absolute";
  popper.style.top = "0";
  popper.style.left = "0";
  var tooltip = div();
  tooltip.className = TOOLTIP_CLASS;
  tooltip.id = "tippy-" + id2;
  tooltip.setAttribute("data-state", "hidden");
  tooltip.setAttribute("tabindex", "-1");
  updateTheme(tooltip, "add", props.theme);
  var content2 = div();
  content2.className = CONTENT_CLASS;
  content2.setAttribute("data-state", "hidden");
  if (props.interactive) {
    addInteractive(tooltip);
  }
  if (props.arrow) {
    tooltip.setAttribute("data-arrow", "");
    tooltip.appendChild(createArrowElement(props.arrow));
  }
  if (props.inertia) {
    addInertia(tooltip);
  }
  setContent(content2, props);
  tooltip.appendChild(content2);
  popper.appendChild(tooltip);
  updatePopperElement(popper, props, props);
  return popper;
}
function updatePopperElement(popper, prevProps, nextProps) {
  var _getChildren = getChildren(popper), tooltip = _getChildren.tooltip, content2 = _getChildren.content, arrow2 = _getChildren.arrow;
  popper.style.zIndex = "" + nextProps.zIndex;
  tooltip.setAttribute("data-animation", nextProps.animation);
  tooltip.style.maxWidth = appendPxIfNumber(nextProps.maxWidth);
  if (nextProps.role) {
    tooltip.setAttribute("role", nextProps.role);
  } else {
    tooltip.removeAttribute("role");
  }
  if (prevProps.content !== nextProps.content) {
    setContent(content2, nextProps);
  }
  if (!prevProps.arrow && nextProps.arrow) {
    tooltip.appendChild(createArrowElement(nextProps.arrow));
    tooltip.setAttribute("data-arrow", "");
  } else if (prevProps.arrow && !nextProps.arrow) {
    tooltip.removeChild(arrow2);
    tooltip.removeAttribute("data-arrow");
  } else if (prevProps.arrow !== nextProps.arrow) {
    tooltip.removeChild(arrow2);
    tooltip.appendChild(createArrowElement(nextProps.arrow));
  }
  if (!prevProps.interactive && nextProps.interactive) {
    addInteractive(tooltip);
  } else if (prevProps.interactive && !nextProps.interactive) {
    removeInteractive(tooltip);
  }
  if (!prevProps.inertia && nextProps.inertia) {
    addInertia(tooltip);
  } else if (prevProps.inertia && !nextProps.inertia) {
    removeInertia(tooltip);
  }
  if (prevProps.theme !== nextProps.theme) {
    updateTheme(tooltip, "remove", prevProps.theme);
    updateTheme(tooltip, "add", nextProps.theme);
  }
}
function updateTransitionEndListener(tooltip, action, listener3) {
  ["transitionend", "webkitTransitionEnd"].forEach(function(event) {
    tooltip[action + "EventListener"](event, listener3);
  });
}
function updateTheme(tooltip, action, theme) {
  splitBySpaces(theme).forEach(function(name) {
    tooltip.classList[action](name + "-theme");
  });
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX, clientY = event.clientY;
  return popperTreeData.every(function(_ref2) {
    var popperRect = _ref2.popperRect, tooltipRect = _ref2.tooltipRect, interactiveBorder = _ref2.interactiveBorder;
    var mergedRect = {
      top: Math.min(popperRect.top, tooltipRect.top),
      right: Math.max(popperRect.right, tooltipRect.right),
      bottom: Math.max(popperRect.bottom, tooltipRect.bottom),
      left: Math.min(popperRect.left, tooltipRect.left)
    };
    var exceedsTop = mergedRect.top - clientY > interactiveBorder;
    var exceedsBottom = clientY - mergedRect.bottom > interactiveBorder;
    var exceedsLeft = mergedRect.left - clientX > interactiveBorder;
    var exceedsRight = clientX - mergedRect.right > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
var idCounter = 1;
var mouseMoveListeners = [];
var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, _extends$5({}, defaultProps$2, {}, getExtendedPassedProps(passedProps)));
  if (!props.multiple && reference._tippy) {
    return null;
  }
  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isBeingDestroyed = false;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var popperUpdates = 0;
  var lastTriggerEvent;
  var currentMountCallback;
  var currentTransitionEndListener;
  var listeners = [];
  var debouncedOnMouseMove = debounce$1(onMouseMove, props.interactiveDebounce);
  var currentTarget;
  var doc = getOwnerDocument(props.triggerTarget || reference);
  var id2 = idCounter++;
  var popper = createPopperElement(id2, props);
  var popperChildren = getChildren(popper);
  var popperInstance = null;
  var plugins2 = unique(props.plugins);
  var tooltip = popperChildren.tooltip, content2 = popperChildren.content;
  var transitionableElements = [tooltip, content2];
  var state = {
    currentPlacement: null,
    isEnabled: true,
    isVisible: false,
    isDestroyed: false,
    isMounted: false,
    isShown: false
  };
  var instance = {
    id: id2,
    reference,
    popper,
    popperChildren,
    popperInstance,
    props,
    state,
    plugins: plugins2,
    clearDelayTimeouts,
    setProps,
    setContent: setContent2,
    show: show2,
    hide: hide2,
    enable,
    disable,
    destroy: destroy2
  };
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins2.map(function(plugin) {
    return plugin.fn(instance);
  });
  var hadAriaExpandedAttributeOnCreate = reference.hasAttribute("aria-expanded");
  addListenersToTriggerTarget();
  handleAriaExpandedAttribute();
  if (!props.lazy) {
    createPopperInstance();
  }
  invokeHook("onCreate", [instance]);
  if (props.showOnCreate) {
    scheduleShow();
  }
  popper.addEventListener("mouseenter", function() {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener("mouseleave", function(event) {
    if (instance.props.interactive && includes(instance.props.trigger, "mouseenter")) {
      debouncedOnMouseMove(event);
      doc.addEventListener("mousemove", debouncedOnMouseMove);
    }
  });
  return instance;
  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }
  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === "hold";
  }
  function getCurrentTarget() {
    return currentTarget || reference;
  }
  function getDelay(isShow) {
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === "focus") {
      return 0;
    }
    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps$2.delay);
  }
  function invokeHook(hook3, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }
    pluginsHooks.forEach(function(pluginHooks) {
      if (hasOwnProperty(pluginHooks, hook3)) {
        pluginHooks[hook3].apply(pluginHooks, args);
      }
    });
    if (shouldInvokePropsHook) {
      var _instance$props;
      (_instance$props = instance.props)[hook3].apply(_instance$props, args);
    }
  }
  function handleAriaDescribedByAttribute() {
    var aria = instance.props.aria;
    if (!aria) {
      return;
    }
    var attr = "aria-" + aria;
    var id3 = tooltip.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function(node) {
      var currentValue = node.getAttribute(attr);
      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id3 : id3);
      } else {
        var nextValue = currentValue && currentValue.replace(id3, "").trim();
        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }
  function handleAriaExpandedAttribute() {
    if (hadAriaExpandedAttributeOnCreate) {
      return;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function(node) {
      if (instance.props.interactive) {
        node.setAttribute("aria-expanded", instance.state.isVisible && node === getCurrentTarget() ? "true" : "false");
      } else {
        node.removeAttribute("aria-expanded");
      }
    });
  }
  function cleanupInteractiveMouseListeners() {
    doc.body.removeEventListener("mouseleave", scheduleHide);
    doc.removeEventListener("mousemove", debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function(listener3) {
      return listener3 !== debouncedOnMouseMove;
    });
  }
  function onDocumentMouseDown(event) {
    if (instance.props.interactive && popper.contains(event.target)) {
      return;
    }
    if (getCurrentTarget().contains(event.target)) {
      if (currentInput.isTouch) {
        return;
      }
      if (instance.state.isVisible && includes(instance.props.trigger, "click")) {
        return;
      }
    }
    if (instance.props.hideOnClick === true) {
      isVisibleFromClick = false;
      instance.clearDelayTimeouts();
      instance.hide();
      didHideDueToDocumentMouseDown = true;
      setTimeout(function() {
        didHideDueToDocumentMouseDown = false;
      });
      if (!instance.state.isMounted) {
        removeDocumentMouseDownListener();
      }
    }
  }
  function addDocumentMouseDownListener() {
    doc.addEventListener("mousedown", onDocumentMouseDown, true);
  }
  function removeDocumentMouseDownListener() {
    doc.removeEventListener("mousedown", onDocumentMouseDown, true);
  }
  function onTransitionedOut(duration5, callback2) {
    onTransitionEnd(duration5, function() {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback2();
      }
    });
  }
  function onTransitionedIn(duration5, callback2) {
    onTransitionEnd(duration5, callback2);
  }
  function onTransitionEnd(duration5, callback2) {
    function listener3(event) {
      if (event.target === tooltip) {
        updateTransitionEndListener(tooltip, "remove", listener3);
        callback2();
      }
    }
    if (duration5 === 0) {
      return callback2();
    }
    updateTransitionEndListener(tooltip, "remove", currentTransitionEndListener);
    updateTransitionEndListener(tooltip, "add", listener3);
    currentTransitionEndListener = listener3;
  }
  function on3(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function(node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node,
        eventType,
        handler,
        options
      });
    });
  }
  function addListenersToTriggerTarget() {
    if (getIsCustomTouchBehavior()) {
      on3("touchstart", onTrigger2, PASSIVE);
      on3("touchend", onMouseLeave, PASSIVE);
    }
    splitBySpaces(instance.props.trigger).forEach(function(eventType) {
      if (eventType === "manual") {
        return;
      }
      on3(eventType, onTrigger2);
      switch (eventType) {
        case "mouseenter":
          on3("mouseleave", onMouseLeave);
          break;
        case "focus":
          on3(isIE ? "focusout" : "blur", onBlurOrFocusOut);
          break;
        case "focusin":
          on3("focusout", onBlurOrFocusOut);
          break;
      }
    });
  }
  function removeListenersFromTriggerTarget() {
    listeners.forEach(function(_ref2) {
      var node = _ref2.node, eventType = _ref2.eventType, handler = _ref2.handler, options = _ref2.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }
  function onTrigger2(event) {
    var shouldScheduleClickHide = false;
    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();
    if (!instance.state.isVisible && isMouseEvent(event)) {
      mouseMoveListeners.forEach(function(listener3) {
        return listener3(event);
      });
    }
    if (event.type === "click" && (!includes(instance.props.trigger, "mouseenter") || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      var _getNormalizedTouchSe = getNormalizedTouchSettings(), value = _getNormalizedTouchSe[0], duration5 = _getNormalizedTouchSe[1];
      if (currentInput.isTouch && value === "hold" && duration5) {
        showTimeout = setTimeout(function() {
          scheduleShow(event);
        }, duration5);
      } else {
        scheduleShow(event);
      }
    }
    if (event.type === "click") {
      isVisibleFromClick = !shouldScheduleClickHide;
    }
    if (shouldScheduleClickHide) {
      scheduleHide(event);
    }
  }
  function onMouseMove(event) {
    var isCursorOverReferenceOrPopper = closestCallback(event.target, function(el) {
      return el === reference || el === popper;
    });
    if (event.type === "mousemove" && isCursorOverReferenceOrPopper) {
      return;
    }
    var popperTreeData = arrayFrom(popper.querySelectorAll(POPPER_SELECTOR)).concat(popper).map(function(popper2) {
      var instance2 = popper2._tippy;
      var tooltip2 = instance2.popperChildren.tooltip;
      var interactiveBorder = instance2.props.interactiveBorder;
      return {
        popperRect: popper2.getBoundingClientRect(),
        tooltipRect: tooltip2.getBoundingClientRect(),
        interactiveBorder
      };
    });
    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }
  function onMouseLeave(event) {
    if (isEventListenerStopped(event)) {
      return;
    }
    if (includes(instance.props.trigger, "click") && isVisibleFromClick) {
      return;
    }
    if (instance.props.interactive) {
      doc.body.addEventListener("mouseleave", scheduleHide);
      doc.addEventListener("mousemove", debouncedOnMouseMove);
      pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
      debouncedOnMouseMove(event);
      return;
    }
    scheduleHide(event);
  }
  function onBlurOrFocusOut(event) {
    if (!includes(instance.props.trigger, "focusin") && event.target !== getCurrentTarget()) {
      return;
    }
    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }
    scheduleHide(event);
  }
  function isEventListenerStopped(event) {
    var supportsTouch = "ontouchstart" in window;
    var isTouchEvent = includes(event.type, "touch");
    var isCustomTouch = getIsCustomTouchBehavior();
    return supportsTouch && currentInput.isTouch && isCustomTouch && !isTouchEvent || currentInput.isTouch && !isCustomTouch && isTouchEvent;
  }
  function createPopperInstance() {
    var popperOptions = instance.props.popperOptions;
    var arrow2 = instance.popperChildren.arrow;
    var flipModifier = getModifier(popperOptions, "flip");
    var preventOverflowModifier = getModifier(popperOptions, "preventOverflow");
    var distancePx;
    function applyMutations(data) {
      var prevPlacement = instance.state.currentPlacement;
      instance.state.currentPlacement = data.placement;
      if (instance.props.flip && !instance.props.flipOnUpdate) {
        if (data.flipped) {
          instance.popperInstance.options.placement = data.placement;
        }
        setModifierValue(instance.popperInstance.modifiers, "flip", "enabled", false);
      }
      tooltip.setAttribute("data-placement", data.placement);
      if (data.attributes["x-out-of-boundaries"] !== false) {
        tooltip.setAttribute("data-out-of-boundaries", "");
      } else {
        tooltip.removeAttribute("data-out-of-boundaries");
      }
      var basePlacement = getBasePlacement(data.placement);
      var isVerticalPlacement = includes(["top", "bottom"], basePlacement);
      var isSecondaryPlacement = includes(["bottom", "right"], basePlacement);
      tooltip.style.top = "0";
      tooltip.style.left = "0";
      tooltip.style[isVerticalPlacement ? "top" : "left"] = (isSecondaryPlacement ? 1 : -1) * distancePx + "px";
      if (prevPlacement && prevPlacement !== data.placement) {
        instance.popperInstance.update();
      }
    }
    var config2 = _extends$5({
      eventsEnabled: false,
      placement: instance.props.placement
    }, popperOptions, {
      modifiers: _extends$5({}, popperOptions && popperOptions.modifiers, {
        tippyDistance: {
          enabled: true,
          order: 0,
          fn: function fn(data) {
            distancePx = getUnitsInPx(doc, instance.props.distance);
            var basePlacement = getBasePlacement(data.placement);
            var computedPreventOverflowPadding = getComputedPadding(basePlacement, preventOverflowModifier && preventOverflowModifier.padding, distancePx);
            var computedFlipPadding = getComputedPadding(basePlacement, flipModifier && flipModifier.padding, distancePx);
            var instanceModifiers = instance.popperInstance.modifiers;
            setModifierValue(instanceModifiers, "preventOverflow", "padding", computedPreventOverflowPadding);
            setModifierValue(instanceModifiers, "flip", "padding", computedFlipPadding);
            return data;
          }
        },
        preventOverflow: _extends$5({
          boundariesElement: instance.props.boundary
        }, preventOverflowModifier),
        flip: _extends$5({
          enabled: instance.props.flip,
          behavior: instance.props.flipBehavior
        }, flipModifier),
        arrow: _extends$5({
          element: arrow2,
          enabled: !!arrow2
        }, getModifier(popperOptions, "arrow")),
        offset: _extends$5({
          offset: instance.props.offset
        }, getModifier(popperOptions, "offset"))
      }),
      onCreate: function onCreate3(data) {
        applyMutations(data);
        preserveInvocation(popperOptions && popperOptions.onCreate, config2.onCreate, [data]);
        runMountCallback();
      },
      onUpdate: function onUpdate2(data) {
        applyMutations(data);
        preserveInvocation(popperOptions && popperOptions.onUpdate, config2.onUpdate, [data]);
        runMountCallback();
      }
    });
    instance.popperInstance = new Popper$1(reference, popper, config2);
  }
  function runMountCallback() {
    if (popperUpdates === 0) {
      popperUpdates++;
      instance.popperInstance.update();
    } else if (currentMountCallback && popperUpdates === 1) {
      popperUpdates++;
      reflow(popper);
      currentMountCallback();
    }
  }
  function mount() {
    popperUpdates = 0;
    var appendTo2 = instance.props.appendTo;
    var parentNode;
    var node = getCurrentTarget();
    if (instance.props.interactive && appendTo2 === defaultProps$2.appendTo || appendTo2 === "parent") {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo2, [node]);
    }
    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }
    setModifierValue(instance.popperInstance.modifiers, "flip", "enabled", instance.props.flip);
    instance.popperInstance.enableEventListeners();
    instance.popperInstance.update();
  }
  function scheduleShow(event) {
    instance.clearDelayTimeouts();
    if (!instance.popperInstance) {
      createPopperInstance();
    }
    if (event) {
      invokeHook("onTrigger", [instance, event]);
    }
    addDocumentMouseDownListener();
    var delay = getDelay(true);
    if (delay) {
      showTimeout = setTimeout(function() {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }
  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook("onUntrigger", [instance, event]);
    if (!instance.state.isVisible) {
      removeDocumentMouseDownListener();
      return;
    }
    if (includes(instance.props.trigger, "mouseenter") && includes(instance.props.trigger, "click") && includes(["mouseleave", "mousemove"], event.type) && isVisibleFromClick) {
      return;
    }
    var delay = getDelay(false);
    if (delay) {
      hideTimeout = setTimeout(function() {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      scheduleHideAnimationFrame = requestAnimationFrame(function() {
        instance.hide();
      });
    }
  }
  function enable() {
    instance.state.isEnabled = true;
  }
  function disable() {
    instance.hide();
    instance.state.isEnabled = false;
  }
  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }
  function setProps(partialProps) {
    if (instance.state.isDestroyed) {
      return;
    }
    invokeHook("onBeforeUpdate", [instance, partialProps]);
    removeListenersFromTriggerTarget();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, _extends$5({}, instance.props, {}, partialProps, {
      ignoreAttributes: true
    }));
    nextProps.ignoreAttributes = useIfDefined(partialProps.ignoreAttributes, prevProps.ignoreAttributes);
    instance.props = nextProps;
    addListenersToTriggerTarget();
    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce$1(onMouseMove, nextProps.interactiveDebounce);
    }
    updatePopperElement(popper, prevProps, nextProps);
    instance.popperChildren = getChildren(popper);
    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
        node.removeAttribute("aria-expanded");
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute("aria-expanded");
    }
    handleAriaExpandedAttribute();
    if (instance.popperInstance) {
      if (POPPER_INSTANCE_DEPENDENCIES.some(function(prop) {
        return hasOwnProperty(partialProps, prop) && partialProps[prop] !== prevProps[prop];
      })) {
        var currentReference = instance.popperInstance.reference;
        instance.popperInstance.destroy();
        createPopperInstance();
        instance.popperInstance.reference = currentReference;
        if (instance.state.isVisible) {
          instance.popperInstance.enableEventListeners();
        }
      } else {
        instance.popperInstance.update();
      }
    }
    invokeHook("onAfterUpdate", [instance, partialProps]);
  }
  function setContent2(content3) {
    instance.setProps({
      content: content3
    });
  }
  function show2(duration5) {
    if (duration5 === void 0) {
      duration5 = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps$2.duration);
    }
    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled3 = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    if (isAlreadyVisible || isDestroyed || isDisabled3 || isTouchAndTouchDisabled) {
      return;
    }
    if (getCurrentTarget().hasAttribute("disabled")) {
      return;
    }
    if (!instance.popperInstance) {
      createPopperInstance();
    }
    invokeHook("onShow", [instance], false);
    if (instance.props.onShow(instance) === false) {
      return;
    }
    addDocumentMouseDownListener();
    popper.style.visibility = "visible";
    instance.state.isVisible = true;
    if (!instance.state.isMounted) {
      setTransitionDuration(transitionableElements.concat(popper), 0);
    }
    currentMountCallback = function currentMountCallback2() {
      if (!instance.state.isVisible) {
        return;
      }
      setTransitionDuration([popper], instance.props.updateDuration);
      setTransitionDuration(transitionableElements, duration5);
      setVisibilityState(transitionableElements, "visible");
      handleAriaDescribedByAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance);
      updateIOSClass(true);
      instance.state.isMounted = true;
      invokeHook("onMount", [instance]);
      onTransitionedIn(duration5, function() {
        instance.state.isShown = true;
        invokeHook("onShown", [instance]);
      });
    };
    mount();
  }
  function hide2(duration5) {
    if (duration5 === void 0) {
      duration5 = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps$2.duration);
    }
    var isAlreadyHidden = !instance.state.isVisible && !isBeingDestroyed;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled3 = !instance.state.isEnabled && !isBeingDestroyed;
    if (isAlreadyHidden || isDestroyed || isDisabled3) {
      return;
    }
    invokeHook("onHide", [instance], false);
    if (instance.props.onHide(instance) === false && !isBeingDestroyed) {
      return;
    }
    removeDocumentMouseDownListener();
    popper.style.visibility = "hidden";
    instance.state.isVisible = false;
    instance.state.isShown = false;
    setTransitionDuration(transitionableElements, duration5);
    setVisibilityState(transitionableElements, "hidden");
    handleAriaDescribedByAttribute();
    handleAriaExpandedAttribute();
    onTransitionedOut(duration5, function() {
      instance.popperInstance.disableEventListeners();
      instance.popperInstance.options.placement = instance.props.placement;
      popper.parentNode.removeChild(popper);
      mountedInstances = mountedInstances.filter(function(i) {
        return i !== instance;
      });
      if (mountedInstances.length === 0) {
        updateIOSClass(false);
      }
      instance.state.isMounted = false;
      invokeHook("onHidden", [instance]);
    });
  }
  function destroy2() {
    if (instance.state.isDestroyed) {
      return;
    }
    isBeingDestroyed = true;
    instance.clearDelayTimeouts();
    instance.hide(0);
    removeListenersFromTriggerTarget();
    delete reference._tippy;
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
    }
    isBeingDestroyed = false;
    instance.state.isDestroyed = true;
    invokeHook("onDestroy", [instance]);
  }
}
function tippy$1(targets, optionalProps, plugins2) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }
  if (plugins2 === void 0) {
    plugins2 = [];
  }
  plugins2 = defaultProps$2.plugins.concat(optionalProps.plugins || plugins2);
  bindGlobalEventListeners();
  var passedProps = _extends$5({}, optionalProps, {
    plugins: plugins2
  });
  var elements = getArrayOfElements(targets);
  var instances2 = elements.reduce(function(acc, reference) {
    var instance = reference && createTippy(reference, passedProps);
    if (instance) {
      acc.push(instance);
    }
    return acc;
  }, []);
  return isElement(targets) ? instances2[0] : instances2;
}
tippy$1.version = version$6;
tippy$1.defaultProps = defaultProps$2;
tippy$1.setDefaultProps = setDefaultProps;
tippy$1.currentInput = currentInput;
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0$1, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p$1 = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d3 = {}, e = null, l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p$1.hasOwnProperty(b) && (d3[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d3[b] === void 0 && (d3[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d3, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
function _extends$4() {
  _extends$4 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined";
function preserveRef(ref, node) {
  if (ref) {
    if (typeof ref === "function") {
      ref(node);
    }
    if ({}.hasOwnProperty.call(ref, "current")) {
      ref.current = node;
    }
  }
}
function ssrSafeCreateDiv() {
  return isBrowser && document.createElement("div");
}
function updateClassName(tooltip, action, classNames) {
  classNames.split(/\s+/).forEach(function(name) {
    if (name) {
      tooltip.classList[action](name);
    }
  });
}
var useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
function useUpdateClassName(component, className, deps) {
  useIsomorphicLayoutEffect(function() {
    var tooltip = component.instance.popperChildren.tooltip;
    if (className) {
      updateClassName(tooltip, "add", className);
      return function() {
        updateClassName(tooltip, "remove", className);
      };
    }
  }, [className].concat(deps));
}
function useInstance(initialValue) {
  var ref = useRef();
  if (!ref.current) {
    ref.current = typeof initialValue === "function" ? initialValue() : initialValue;
  }
  return ref.current;
}
function Tippy(_ref2) {
  var children = _ref2.children, content2 = _ref2.content, className = _ref2.className, visible = _ref2.visible, singleton = _ref2.singleton, _ref$enabled = _ref2.enabled, enabled = _ref$enabled === void 0 ? true : _ref$enabled, _ref$multiple = _ref2.multiple, multiple = _ref$multiple === void 0 ? true : _ref$multiple, _ref$ignoreAttributes = _ref2.ignoreAttributes, ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes;
  _ref2.__source;
  _ref2.__self;
  var restOfNativeProps = _objectWithoutPropertiesLoose$1(_ref2, ["children", "content", "className", "visible", "singleton", "enabled", "multiple", "ignoreAttributes", "__source", "__self"]);
  var isControlledMode = visible !== void 0;
  var isSingletonMode = singleton !== void 0;
  var _useState = useState(false), mounted = _useState[0], setMounted = _useState[1];
  var component = useInstance(function() {
    return {
      container: ssrSafeCreateDiv(),
      renders: 1
    };
  });
  var props = _extends$4({
    ignoreAttributes,
    multiple
  }, restOfNativeProps, {
    content: component.container
  });
  if (isControlledMode) {
    props.trigger = "manual";
  }
  if (isSingletonMode) {
    enabled = false;
  }
  var deps = [children.type];
  useIsomorphicLayoutEffect(function() {
    var instance = tippy$1(component.ref, props);
    component.instance = instance;
    if (!enabled) {
      instance.disable();
    }
    if (visible) {
      instance.show();
    }
    if (isSingletonMode) {
      singleton(instance);
    }
    setMounted(true);
    return function() {
      instance.destroy();
    };
  }, deps);
  useIsomorphicLayoutEffect(function() {
    if (component.renders === 1) {
      component.renders++;
      return;
    }
    var instance = component.instance;
    instance.setProps(props);
    if (enabled) {
      instance.enable();
    } else {
      instance.disable();
    }
    if (isControlledMode) {
      if (visible) {
        instance.show();
      } else {
        instance.hide();
      }
    }
  });
  useUpdateClassName(component, className, deps);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [cloneElement(children, {
      ref: function ref(node) {
        component.ref = node;
        preserveRef(children.ref, node);
      }
    }), mounted && reactDom.exports.createPortal(content2, component.container)]
  });
}
var Tippy$1 = forwardRef(function TippyWrapper(_ref2, _ref3) {
  var children = _ref2.children, props = _objectWithoutPropertiesLoose$1(_ref2, ["children"]);
  return /* @__PURE__ */ jsx(Tippy, {
    ...props,
    children: cloneElement(children, {
      ref: function ref(node) {
        preserveRef(_ref3, node);
        preserveRef(children.ref, node);
      }
    })
  });
});
var Tippy$2 = Tippy$1;
var tippy = /* @__PURE__ */ (() => ".tippy-tooltip[data-animation=fade][data-state=hidden]{opacity:0}.tippy-iOS{cursor:pointer!important;-webkit-tap-highlight-color:transparent}.tippy-popper{pointer-events:none;max-width:calc(100vw - 10px);transition-timing-function:cubic-bezier(.165,.84,.44,1);transition-property:transform}.tippy-tooltip{position:relative;color:#fff;border-radius:4px;font-size:14px;line-height:1.4;background-color:#333;transition-property:visibility,opacity,transform;outline:0}.tippy-tooltip[data-placement^=top]>.tippy-arrow{border-width:8px 8px 0;border-top-color:#333;margin:0 3px;transform-origin:50% 0;bottom:-7px}.tippy-tooltip[data-placement^=bottom]>.tippy-arrow{border-width:0 8px 8px;border-bottom-color:#333;margin:0 3px;transform-origin:50% 7px;top:-7px}.tippy-tooltip[data-placement^=left]>.tippy-arrow{border-width:8px 0 8px 8px;border-left-color:#333;margin:3px 0;transform-origin:0 50%;right:-7px}.tippy-tooltip[data-placement^=right]>.tippy-arrow{border-width:8px 8px 8px 0;border-right-color:#333;margin:3px 0;transform-origin:7px 50%;left:-7px}.tippy-tooltip[data-interactive][data-state=visible]{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.54,1.5,.38,1.11)}.tippy-arrow{position:absolute;border-color:transparent;border-style:solid}.tippy-content{padding:5px 9px}\n")();
const Tooltip = ({
  children,
  shouldDisplay,
  theme = "white",
  ...props
}) => {
  if (shouldDisplay) {
    return /* @__PURE__ */ jsx(Tippy$2, {
      theme,
      ...props,
      children
    });
  }
  return children;
};
const status = "_status_1k367_1";
var styles$i = {
  status
};
var Color = /* @__PURE__ */ ((Color2) => {
  Color2["RED"] = "red";
  Color2["ORANGE"] = "orange";
  Color2["GREEN"] = "green";
  Color2["BLUE"] = "blue";
  Color2["PURPLE"] = "purple";
  Color2["WHITE"] = "white";
  Color2["LIGHT_GREY"] = "light-grey";
  Color2["MED_GREY"] = "med-grey";
  Color2["DARK_GREY"] = "dark-grey";
  Color2["VERY_DARK_GREY"] = "very-dark-grey";
  Color2["DARK"] = "dark";
  Color2["BLACK"] = "black";
  return Color2;
})(Color || {});
const Status = ({
  checked,
  borderColor = Color.PURPLE
}) => {
  const handleClick = (e) => {
    e.preventDefault();
  };
  return /* @__PURE__ */ jsx("input", {
    type: "checkbox",
    className: `${styles$i.status} border-${borderColor}`,
    checked,
    onClick: handleClick
  });
};
const isEllipsisActive = (e) => {
  return e.offsetWidth < e.scrollWidth;
};
const compareObjects = (obj1, obj2) => {
  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    return false;
  }
  const isDifferent = Object.keys(obj1).some((key) => {
    const objKey = key;
    if (typeof obj1[objKey] !== typeof obj2[objKey]) {
      return true;
    }
    if (typeof obj1[objKey] === "object") {
      if (!compareObjects(obj1[objKey], obj2[objKey])) {
        return true;
      }
    } else if (obj1[objKey] !== obj2[objKey]) {
      return true;
    }
    return false;
  });
  return !isDifferent;
};
function truncate(string2, length) {
  return string2.length > length ? `${string2.substring(0, length)}\u2026` : string2;
}
var PlayIcon = "data:image/png;base64,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";
var FullscreenIcon = "data:image/svg+xml;base64,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";
const Card = ({
  data,
  onPlayVideo,
  showPublish,
  onPublish,
  onUnpublish
}) => {
  const unitRef = useRef(null);
  const lessonRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState({
    unit: false,
    lesson: false
  });
  const isStudent = !userInfo.staffer;
  useEffect(() => {
    setShowTooltip({
      unit: unitRef.current ? isEllipsisActive(unitRef.current) : false,
      lesson: lessonRef.current ? isEllipsisActive(lessonRef.current) : false
    });
  }, [unitRef, lessonRef]);
  const handlePlayVideo = () => {
    onPlayVideo(data);
  };
  const handlePublishClick = () => {
    if (data.published) {
      onUnpublish(data.id, data.title);
    } else {
      onPublish(data.id, data.title);
    }
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `card ${style$1.videoCard}`,
    children: [/* @__PURE__ */ jsxs("div", {
      className: style$1.cardImg + (!data.poster_url ? ` ${style$1.blackImg}` : ""),
      onClick: handlePlayVideo,
      children: [/* @__PURE__ */ jsx("img", {
        src: data.poster_url
      }), /* @__PURE__ */ jsx("div", {
        className: style$1.playButton,
        children: /* @__PURE__ */ jsx("img", {
          src: PlayIcon
        })
      }), data.video_duration && /* @__PURE__ */ jsx("div", {
        className: `${style$1.videoLength} pos_bottom_right`,
        children: data.video_duration
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: style$1.cardContent,
      children: [/* @__PURE__ */ jsx("p", {
        className: style$1.cardTitle,
        onClick: handlePlayVideo,
        children: data.title
      }), /* @__PURE__ */ jsxs("div", {
        className: "mb10",
        children: [data.unit_title && /* @__PURE__ */ jsx(Tooltip, {
          content: data.unit_title,
          shouldDisplay: showTooltip.unit,
          children: /* @__PURE__ */ jsx("div", {
            ref: unitRef,
            className: style$1.cardSubtitle,
            children: data.unit_title
          })
        }, `${data.id}-${btoa(data.unit_title)}`), data.lesson_title && /* @__PURE__ */ jsx(Tooltip, {
          content: data.lesson_title,
          shouldDisplay: showTooltip.lesson,
          children: /* @__PURE__ */ jsx("div", {
            ref: lessonRef,
            className: style$1.cardSubtitle,
            children: data.lesson_title
          })
        }, `${data.id}-${btoa(data.lesson_title)}`)]
      }), !isStudent && data.included_in && !hideIncludedIns.includes(data.included_in) && /* @__PURE__ */ jsxs("div", {
        className: style$1.included_in,
        children: ["Go to\xA0", data.included_in_link ? /* @__PURE__ */ jsxs("a", {
          href: data.included_in_link,
          className: "bold",
          target: "_blank",
          rel: "noreferrer",
          children: [data.included_in, "\xA0\xA0", /* @__PURE__ */ jsx("img", {
            src: FullscreenIcon,
            alt: "Link"
          })]
        }) : data.included_in]
      }), showPublish && /* @__PURE__ */ jsx("button", {
        className: `btn btn--outline-purple ${style$1.publishButton}`,
        onClick: handlePublishClick,
        children: data.published ? /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx(Status, {
            borderColor: Color.GREEN,
            checked: true
          }), " Published"]
        }) : /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx(Status, {}), " Publish"]
        })
      })]
    })]
  });
};
var win;
if (typeof window !== "undefined") {
  win = window;
} else if (typeof commonjsGlobal !== "undefined") {
  win = commonjsGlobal;
} else if (typeof self !== "undefined") {
  win = self;
} else {
  win = {};
}
var window_1 = win;
var __viteBrowserExternal = {};
var __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
var require$$0 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
var topLevel = typeof commonjsGlobal !== "undefined" ? commonjsGlobal : typeof window !== "undefined" ? window : {};
var minDoc = require$$0;
var doccy;
if (typeof document !== "undefined") {
  doccy = document;
} else {
  doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"];
  if (!doccy) {
    doccy = topLevel["__GLOBAL_DOCUMENT_CACHE@4"] = minDoc;
  }
}
var document_1 = doccy;
function _extends$2() {
  _extends$2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
var _extends$3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  "default": _extends$2
}, Symbol.toStringTag, { value: "Module" }));
var keycode$1 = { exports: {} };
(function(module, exports) {
  function keyCode(searchInput) {
    if (searchInput && typeof searchInput === "object") {
      var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
      if (hasKeyCode)
        searchInput = hasKeyCode;
    }
    if (typeof searchInput === "number")
      return names[searchInput];
    var search = String(searchInput);
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey)
      return foundNamedKey;
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey)
      return foundNamedKey;
    if (search.length === 1)
      return search.charCodeAt(0);
    return void 0;
  }
  keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && typeof event === "object") {
      var keyCode2 = event.which || event.keyCode || event.charCode;
      if (keyCode2 === null || keyCode2 === void 0) {
        return false;
      }
      if (typeof nameOrCode === "string") {
        var foundNamedKey = codes[nameOrCode.toLowerCase()];
        if (foundNamedKey) {
          return foundNamedKey === keyCode2;
        }
        var foundNamedKey = aliases[nameOrCode.toLowerCase()];
        if (foundNamedKey) {
          return foundNamedKey === keyCode2;
        }
      } else if (typeof nameOrCode === "number") {
        return nameOrCode === keyCode2;
      }
      return false;
    }
  };
  exports = module.exports = keyCode;
  var codes = exports.code = exports.codes = {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "shift": 16,
    "ctrl": 17,
    "alt": 18,
    "pause/break": 19,
    "caps lock": 20,
    "esc": 27,
    "space": 32,
    "page up": 33,
    "page down": 34,
    "end": 35,
    "home": 36,
    "left": 37,
    "up": 38,
    "right": 39,
    "down": 40,
    "insert": 45,
    "delete": 46,
    "command": 91,
    "left command": 91,
    "right command": 93,
    "numpad *": 106,
    "numpad +": 107,
    "numpad -": 109,
    "numpad .": 110,
    "numpad /": 111,
    "num lock": 144,
    "scroll lock": 145,
    "my computer": 182,
    "my calculator": 183,
    ";": 186,
    "=": 187,
    ",": 188,
    "-": 189,
    ".": 190,
    "/": 191,
    "`": 192,
    "[": 219,
    "\\": 220,
    "]": 221,
    "'": 222
  };
  var aliases = exports.aliases = {
    "windows": 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    "ctl": 17,
    "control": 17,
    "option": 18,
    "pause": 19,
    "break": 19,
    "caps": 20,
    "return": 13,
    "escape": 27,
    "spc": 32,
    "spacebar": 32,
    "pgup": 33,
    "pgdn": 34,
    "ins": 45,
    "del": 46,
    "cmd": 91
  };
  /*!
   * Programatically add the following
   */
  for (i = 97; i < 123; i++)
    codes[String.fromCharCode(i)] = i - 32;
  for (var i = 48; i < 58; i++)
    codes[i - 48] = i;
  for (i = 1; i < 13; i++)
    codes["f" + i] = i + 111;
  for (i = 0; i < 10; i++)
    codes["numpad " + i] = i + 96;
  var names = exports.names = exports.title = {};
  for (i in codes)
    names[codes[i]] = i;
  for (var alias in aliases) {
    codes[alias] = aliases[alias];
  }
})(keycode$1, keycode$1.exports);
var keycode = keycode$1.exports;
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _setPrototypeOf(o, p2) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p3) {
    o2.__proto__ = p3;
    return o2;
  };
  return _setPrototypeOf(o, p2);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
var tuple = SafeParseTuple;
function SafeParseTuple(obj, reviver) {
  var json;
  var error2 = null;
  try {
    json = JSON.parse(obj, reviver);
  } catch (err) {
    error2 = err;
  }
  return [error2, json];
}
var lib = { exports: {} };
var require$$1 = /* @__PURE__ */ getAugmentedNamespace(_extends$3);
var isFunction_1 = isFunction$1;
var toString$1 = Object.prototype.toString;
function isFunction$1(fn) {
  if (!fn) {
    return false;
  }
  var string2 = toString$1.call(fn);
  return string2 === "[object Function]" || typeof fn === "function" && string2 !== "[object RegExp]" || typeof window !== "undefined" && (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}
var window$3 = window_1;
var httpResponseHandler = function httpResponseHandler2(callback2, decodeResponseBody) {
  if (decodeResponseBody === void 0) {
    decodeResponseBody = false;
  }
  return function(err, response, responseBody) {
    if (err) {
      callback2(err);
      return;
    }
    if (response.statusCode >= 400 && response.statusCode <= 599) {
      var cause = responseBody;
      if (decodeResponseBody) {
        if (window$3.TextDecoder) {
          var charset = getCharset(response.headers && response.headers["content-type"]);
          try {
            cause = new TextDecoder(charset).decode(responseBody);
          } catch (e) {
          }
        } else {
          cause = String.fromCharCode.apply(null, new Uint8Array(responseBody));
        }
      }
      callback2({
        cause
      });
      return;
    }
    callback2(null, responseBody);
  };
};
function getCharset(contentTypeHeader) {
  if (contentTypeHeader === void 0) {
    contentTypeHeader = "";
  }
  return contentTypeHeader.toLowerCase().split(";").reduce(function(charset, contentType) {
    var _contentType$split = contentType.split("="), type2 = _contentType$split[0], value = _contentType$split[1];
    if (type2.trim() === "charset") {
      return value.trim();
    }
    return charset;
  }, "utf-8");
}
var httpHandler = httpResponseHandler;
var window$2 = window_1;
var _extends$1 = require$$1;
var isFunction = isFunction_1;
createXHR.httpHandler = httpHandler;
/**
 * @license
 * slighly modified parse-headers 2.0.2 <https://github.com/kesla/parse-headers/>
 * Copyright (c) 2014 David Björklund
 * Available under the MIT license
 * <https://github.com/kesla/parse-headers/blob/master/LICENCE>
 */
var parseHeaders = function parseHeaders2(headers) {
  var result2 = {};
  if (!headers) {
    return result2;
  }
  headers.trim().split("\n").forEach(function(row) {
    var index = row.indexOf(":");
    var key = row.slice(0, index).trim().toLowerCase();
    var value = row.slice(index + 1).trim();
    if (typeof result2[key] === "undefined") {
      result2[key] = value;
    } else if (Array.isArray(result2[key])) {
      result2[key].push(value);
    } else {
      result2[key] = [result2[key], value];
    }
  });
  return result2;
};
lib.exports = createXHR;
lib.exports.default = createXHR;
createXHR.XMLHttpRequest = window$2.XMLHttpRequest || noop$4;
createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window$2.XDomainRequest;
forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
  createXHR[method === "delete" ? "del" : method] = function(uri, options, callback2) {
    options = initParams(uri, options, callback2);
    options.method = method.toUpperCase();
    return _createXHR(options);
  };
});
function forEachArray(array2, iterator) {
  for (var i = 0; i < array2.length; i++) {
    iterator(array2[i]);
  }
}
function isEmpty(obj) {
  for (var i in obj) {
    if (obj.hasOwnProperty(i))
      return false;
  }
  return true;
}
function initParams(uri, options, callback2) {
  var params = uri;
  if (isFunction(options)) {
    callback2 = options;
    if (typeof uri === "string") {
      params = {
        uri
      };
    }
  } else {
    params = _extends$1({}, options, {
      uri
    });
  }
  params.callback = callback2;
  return params;
}
function createXHR(uri, options, callback2) {
  options = initParams(uri, options, callback2);
  return _createXHR(options);
}
function _createXHR(options) {
  if (typeof options.callback === "undefined") {
    throw new Error("callback argument missing");
  }
  var called = false;
  var callback2 = function cbOnce(err, response, body2) {
    if (!called) {
      called = true;
      options.callback(err, response, body2);
    }
  };
  function readystatechange() {
    if (xhr.readyState === 4) {
      setTimeout(loadFunc, 0);
    }
  }
  function getBody() {
    var body2 = void 0;
    if (xhr.response) {
      body2 = xhr.response;
    } else {
      body2 = xhr.responseText || getXml(xhr);
    }
    if (isJson) {
      try {
        body2 = JSON.parse(body2);
      } catch (e) {
      }
    }
    return body2;
  }
  function errorFunc(evt) {
    clearTimeout(timeoutTimer);
    if (!(evt instanceof Error)) {
      evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
    }
    evt.statusCode = 0;
    return callback2(evt, failureResponse);
  }
  function loadFunc() {
    if (aborted)
      return;
    var status2;
    clearTimeout(timeoutTimer);
    if (options.useXDR && xhr.status === void 0) {
      status2 = 200;
    } else {
      status2 = xhr.status === 1223 ? 204 : xhr.status;
    }
    var response = failureResponse;
    var err = null;
    if (status2 !== 0) {
      response = {
        body: getBody(),
        statusCode: status2,
        method,
        headers: {},
        url: uri,
        rawRequest: xhr
      };
      if (xhr.getAllResponseHeaders) {
        response.headers = parseHeaders(xhr.getAllResponseHeaders());
      }
    } else {
      err = new Error("Internal XMLHttpRequest Error");
    }
    return callback2(err, response, response.body);
  }
  var xhr = options.xhr || null;
  if (!xhr) {
    if (options.cors || options.useXDR) {
      xhr = new createXHR.XDomainRequest();
    } else {
      xhr = new createXHR.XMLHttpRequest();
    }
  }
  var key;
  var aborted;
  var uri = xhr.url = options.uri || options.url;
  var method = xhr.method = options.method || "GET";
  var body = options.body || options.data;
  var headers = xhr.headers = options.headers || {};
  var sync = !!options.sync;
  var isJson = false;
  var timeoutTimer;
  var failureResponse = {
    body: void 0,
    headers: {},
    statusCode: 0,
    method,
    url: uri,
    rawRequest: xhr
  };
  if ("json" in options && options.json !== false) {
    isJson = true;
    headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json");
    if (method !== "GET" && method !== "HEAD") {
      headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json");
      body = JSON.stringify(options.json === true ? body : options.json);
    }
  }
  xhr.onreadystatechange = readystatechange;
  xhr.onload = loadFunc;
  xhr.onerror = errorFunc;
  xhr.onprogress = function() {
  };
  xhr.onabort = function() {
    aborted = true;
  };
  xhr.ontimeout = errorFunc;
  xhr.open(method, uri, !sync, options.username, options.password);
  if (!sync) {
    xhr.withCredentials = !!options.withCredentials;
  }
  if (!sync && options.timeout > 0) {
    timeoutTimer = setTimeout(function() {
      if (aborted)
        return;
      aborted = true;
      xhr.abort("timeout");
      var e = new Error("XMLHttpRequest timeout");
      e.code = "ETIMEDOUT";
      errorFunc(e);
    }, options.timeout);
  }
  if (xhr.setRequestHeader) {
    for (key in headers) {
      if (headers.hasOwnProperty(key)) {
        xhr.setRequestHeader(key, headers[key]);
      }
    }
  } else if (options.headers && !isEmpty(options.headers)) {
    throw new Error("Headers cannot be set on an XDomainRequest object");
  }
  if ("responseType" in options) {
    xhr.responseType = options.responseType;
  }
  if ("beforeSend" in options && typeof options.beforeSend === "function") {
    options.beforeSend(xhr);
  }
  xhr.send(body || null);
  return xhr;
}
function getXml(xhr) {
  try {
    if (xhr.responseType === "document") {
      return xhr.responseXML;
    }
    var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
      return xhr.responseXML;
    }
  } catch (e) {
  }
  return null;
}
function noop$4() {
}
var XHR = lib.exports;
var browserIndex = { exports: {} };
var document$1 = document_1;
var _objCreate = Object.create || function() {
  function F2() {
  }
  return function(o) {
    if (arguments.length !== 1) {
      throw new Error("Object.create shim only accepts one parameter.");
    }
    F2.prototype = o;
    return new F2();
  };
}();
function ParsingError(errorData, message) {
  this.name = "ParsingError";
  this.code = errorData.code;
  this.message = message || errorData.message;
}
ParsingError.prototype = _objCreate(Error.prototype);
ParsingError.prototype.constructor = ParsingError;
ParsingError.Errors = {
  BadSignature: {
    code: 0,
    message: "Malformed WebVTT signature."
  },
  BadTimeStamp: {
    code: 1,
    message: "Malformed time stamp."
  }
};
function parseTimeStamp(input) {
  function computeSeconds(h, m3, s, f2) {
    return (h | 0) * 3600 + (m3 | 0) * 60 + (s | 0) + (f2 | 0) / 1e3;
  }
  var m2 = input.match(/^(\d+):(\d{1,2})(:\d{1,2})?\.(\d{3})/);
  if (!m2) {
    return null;
  }
  if (m2[3]) {
    return computeSeconds(m2[1], m2[2], m2[3].replace(":", ""), m2[4]);
  } else if (m2[1] > 59) {
    return computeSeconds(m2[1], m2[2], 0, m2[4]);
  } else {
    return computeSeconds(0, m2[1], m2[2], m2[4]);
  }
}
function Settings() {
  this.values = _objCreate(null);
}
Settings.prototype = {
  set: function(k, v) {
    if (!this.get(k) && v !== "") {
      this.values[k] = v;
    }
  },
  get: function(k, dflt, defaultKey) {
    if (defaultKey) {
      return this.has(k) ? this.values[k] : dflt[defaultKey];
    }
    return this.has(k) ? this.values[k] : dflt;
  },
  has: function(k) {
    return k in this.values;
  },
  alt: function(k, v, a) {
    for (var n2 = 0; n2 < a.length; ++n2) {
      if (v === a[n2]) {
        this.set(k, v);
        break;
      }
    }
  },
  integer: function(k, v) {
    if (/^-?\d+$/.test(v)) {
      this.set(k, parseInt(v, 10));
    }
  },
  percent: function(k, v) {
    if (v.match(/^([\d]{1,3})(\.[\d]*)?%$/)) {
      v = parseFloat(v);
      if (v >= 0 && v <= 100) {
        this.set(k, v);
        return true;
      }
    }
    return false;
  }
};
function parseOptions(input, callback2, keyValueDelim, groupDelim) {
  var groups = groupDelim ? input.split(groupDelim) : [input];
  for (var i in groups) {
    if (typeof groups[i] !== "string") {
      continue;
    }
    var kv = groups[i].split(keyValueDelim);
    if (kv.length !== 2) {
      continue;
    }
    var k = kv[0].trim();
    var v = kv[1].trim();
    callback2(k, v);
  }
}
function parseCue(input, cue, regionList) {
  var oInput = input;
  function consumeTimeStamp() {
    var ts2 = parseTimeStamp(input);
    if (ts2 === null) {
      throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed timestamp: " + oInput);
    }
    input = input.replace(/^[^\sa-zA-Z-]+/, "");
    return ts2;
  }
  function consumeCueSettings(input2, cue2) {
    var settings = new Settings();
    parseOptions(input2, function(k, v) {
      switch (k) {
        case "region":
          for (var i = regionList.length - 1; i >= 0; i--) {
            if (regionList[i].id === v) {
              settings.set(k, regionList[i].region);
              break;
            }
          }
          break;
        case "vertical":
          settings.alt(k, v, ["rl", "lr"]);
          break;
        case "line":
          var vals = v.split(","), vals0 = vals[0];
          settings.integer(k, vals0);
          settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
          settings.alt(k, vals0, ["auto"]);
          if (vals.length === 2) {
            settings.alt("lineAlign", vals[1], ["start", "center", "end"]);
          }
          break;
        case "position":
          vals = v.split(",");
          settings.percent(k, vals[0]);
          if (vals.length === 2) {
            settings.alt("positionAlign", vals[1], ["start", "center", "end"]);
          }
          break;
        case "size":
          settings.percent(k, v);
          break;
        case "align":
          settings.alt(k, v, ["start", "center", "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/);
    cue2.region = settings.get("region", null);
    cue2.vertical = settings.get("vertical", "");
    try {
      cue2.line = settings.get("line", "auto");
    } catch (e) {
    }
    cue2.lineAlign = settings.get("lineAlign", "start");
    cue2.snapToLines = settings.get("snapToLines", true);
    cue2.size = settings.get("size", 100);
    try {
      cue2.align = settings.get("align", "center");
    } catch (e) {
      cue2.align = settings.get("align", "middle");
    }
    try {
      cue2.position = settings.get("position", "auto");
    } catch (e) {
      cue2.position = settings.get("position", {
        start: 0,
        left: 0,
        center: 50,
        middle: 50,
        end: 100,
        right: 100
      }, cue2.align);
    }
    cue2.positionAlign = settings.get("positionAlign", {
      start: "start",
      left: "start",
      center: "center",
      middle: "center",
      end: "end",
      right: "end"
    }, cue2.align);
  }
  function skipWhitespace() {
    input = input.replace(/^\s+/, "");
  }
  skipWhitespace();
  cue.startTime = consumeTimeStamp();
  skipWhitespace();
  if (input.substr(0, 3) !== "-->") {
    throw new ParsingError(ParsingError.Errors.BadTimeStamp, "Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
  }
  input = input.substr(3);
  skipWhitespace();
  cue.endTime = consumeTimeStamp();
  skipWhitespace();
  consumeCueSettings(input, cue);
}
var TEXTAREA_ELEMENT = document$1.createElement && document$1.createElement("textarea");
var TAG_NAME = {
  c: "span",
  i: "i",
  b: "b",
  u: "u",
  ruby: "ruby",
  rt: "rt",
  v: "span",
  lang: "span"
};
var DEFAULT_COLOR_CLASS = {
  white: "rgba(255,255,255,1)",
  lime: "rgba(0,255,0,1)",
  cyan: "rgba(0,255,255,1)",
  red: "rgba(255,0,0,1)",
  yellow: "rgba(255,255,0,1)",
  magenta: "rgba(255,0,255,1)",
  blue: "rgba(0,0,255,1)",
  black: "rgba(0,0,0,1)"
};
var TAG_ANNOTATION = {
  v: "title",
  lang: "lang"
};
var NEEDS_PARENT = {
  rt: "ruby"
};
function parseContent(window2, input) {
  function nextToken() {
    if (!input) {
      return null;
    }
    function consume(result2) {
      input = input.substr(result2.length);
      return result2;
    }
    var m3 = input.match(/^([^<]*)(<[^>]*>?)?/);
    return consume(m3[1] ? m3[1] : m3[2]);
  }
  function unescape2(s) {
    TEXTAREA_ELEMENT.innerHTML = s;
    s = TEXTAREA_ELEMENT.textContent;
    TEXTAREA_ELEMENT.textContent = "";
    return s;
  }
  function shouldAdd(current2, element) {
    return !NEEDS_PARENT[element.localName] || NEEDS_PARENT[element.localName] === current2.localName;
  }
  function createElement2(type2, annotation) {
    var tagName = TAG_NAME[type2];
    if (!tagName) {
      return null;
    }
    var element = window2.document.createElement(tagName);
    var name = TAG_ANNOTATION[type2];
    if (name && annotation) {
      element[name] = annotation.trim();
    }
    return element;
  }
  var rootDiv = window2.document.createElement("div"), current = rootDiv, t3, tagStack = [];
  while ((t3 = nextToken()) !== null) {
    if (t3[0] === "<") {
      if (t3[1] === "/") {
        if (tagStack.length && tagStack[tagStack.length - 1] === t3.substr(2).replace(">", "")) {
          tagStack.pop();
          current = current.parentNode;
        }
        continue;
      }
      var ts2 = parseTimeStamp(t3.substr(1, t3.length - 2));
      var node;
      if (ts2) {
        node = window2.document.createProcessingInstruction("timestamp", ts2);
        current.appendChild(node);
        continue;
      }
      var m2 = t3.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
      if (!m2) {
        continue;
      }
      node = createElement2(m2[1], m2[3]);
      if (!node) {
        continue;
      }
      if (!shouldAdd(current, node)) {
        continue;
      }
      if (m2[2]) {
        var classes = m2[2].split(".");
        classes.forEach(function(cl) {
          var bgColor = /^bg_/.test(cl);
          var colorName = bgColor ? cl.slice(3) : cl;
          if (DEFAULT_COLOR_CLASS.hasOwnProperty(colorName)) {
            var propName = bgColor ? "background-color" : "color";
            var propValue = DEFAULT_COLOR_CLASS[colorName];
            node.style[propName] = propValue;
          }
        });
        node.className = classes.join(" ");
      }
      tagStack.push(m2[1]);
      current.appendChild(node);
      current = node;
      continue;
    }
    current.appendChild(window2.document.createTextNode(unescape2(t3)));
  }
  return rootDiv;
}
var strongRTLRanges = [
  [1470, 1470],
  [1472, 1472],
  [1475, 1475],
  [1478, 1478],
  [1488, 1514],
  [1520, 1524],
  [1544, 1544],
  [1547, 1547],
  [1549, 1549],
  [1563, 1563],
  [1566, 1610],
  [1645, 1647],
  [1649, 1749],
  [1765, 1766],
  [1774, 1775],
  [1786, 1805],
  [1807, 1808],
  [1810, 1839],
  [1869, 1957],
  [1969, 1969],
  [1984, 2026],
  [2036, 2037],
  [2042, 2042],
  [2048, 2069],
  [2074, 2074],
  [2084, 2084],
  [2088, 2088],
  [2096, 2110],
  [2112, 2136],
  [2142, 2142],
  [2208, 2208],
  [2210, 2220],
  [8207, 8207],
  [64285, 64285],
  [64287, 64296],
  [64298, 64310],
  [64312, 64316],
  [64318, 64318],
  [64320, 64321],
  [64323, 64324],
  [64326, 64449],
  [64467, 64829],
  [64848, 64911],
  [64914, 64967],
  [65008, 65020],
  [65136, 65140],
  [65142, 65276],
  [67584, 67589],
  [67592, 67592],
  [67594, 67637],
  [67639, 67640],
  [67644, 67644],
  [67647, 67669],
  [67671, 67679],
  [67840, 67867],
  [67872, 67897],
  [67903, 67903],
  [67968, 68023],
  [68030, 68031],
  [68096, 68096],
  [68112, 68115],
  [68117, 68119],
  [68121, 68147],
  [68160, 68167],
  [68176, 68184],
  [68192, 68223],
  [68352, 68405],
  [68416, 68437],
  [68440, 68466],
  [68472, 68479],
  [68608, 68680],
  [126464, 126467],
  [126469, 126495],
  [126497, 126498],
  [126500, 126500],
  [126503, 126503],
  [126505, 126514],
  [126516, 126519],
  [126521, 126521],
  [126523, 126523],
  [126530, 126530],
  [126535, 126535],
  [126537, 126537],
  [126539, 126539],
  [126541, 126543],
  [126545, 126546],
  [126548, 126548],
  [126551, 126551],
  [126553, 126553],
  [126555, 126555],
  [126557, 126557],
  [126559, 126559],
  [126561, 126562],
  [126564, 126564],
  [126567, 126570],
  [126572, 126578],
  [126580, 126583],
  [126585, 126588],
  [126590, 126590],
  [126592, 126601],
  [126603, 126619],
  [126625, 126627],
  [126629, 126633],
  [126635, 126651],
  [1114109, 1114109]
];
function isStrongRTLChar(charCode) {
  for (var i = 0; i < strongRTLRanges.length; i++) {
    var currentRange = strongRTLRanges[i];
    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
      return true;
    }
  }
  return false;
}
function determineBidi(cueDiv) {
  var nodeStack = [], text = "", charCode;
  if (!cueDiv || !cueDiv.childNodes) {
    return "ltr";
  }
  function pushNodes(nodeStack2, node) {
    for (var i2 = node.childNodes.length - 1; i2 >= 0; i2--) {
      nodeStack2.push(node.childNodes[i2]);
    }
  }
  function nextTextNode(nodeStack2) {
    if (!nodeStack2 || !nodeStack2.length) {
      return null;
    }
    var node = nodeStack2.pop(), text2 = node.textContent || node.innerText;
    if (text2) {
      var m2 = text2.match(/^.*(\n|\r)/);
      if (m2) {
        nodeStack2.length = 0;
        return m2[0];
      }
      return text2;
    }
    if (node.tagName === "ruby") {
      return nextTextNode(nodeStack2);
    }
    if (node.childNodes) {
      pushNodes(nodeStack2, node);
      return nextTextNode(nodeStack2);
    }
  }
  pushNodes(nodeStack, cueDiv);
  while (text = nextTextNode(nodeStack)) {
    for (var i = 0; i < text.length; i++) {
      charCode = text.charCodeAt(i);
      if (isStrongRTLChar(charCode)) {
        return "rtl";
      }
    }
  }
  return "ltr";
}
function computeLinePos(cue) {
  if (typeof cue.line === "number" && (cue.snapToLines || cue.line >= 0 && cue.line <= 100)) {
    return cue.line;
  }
  if (!cue.track || !cue.track.textTrackList || !cue.track.textTrackList.mediaElement) {
    return -1;
  }
  var track = cue.track, trackList = track.textTrackList, count = 0;
  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
    if (trackList[i].mode === "showing") {
      count++;
    }
  }
  return ++count * -1;
}
function StyleBox() {
}
StyleBox.prototype.applyStyles = function(styles2, div2) {
  div2 = div2 || this.div;
  for (var prop in styles2) {
    if (styles2.hasOwnProperty(prop)) {
      div2.style[prop] = styles2[prop];
    }
  }
};
StyleBox.prototype.formatStyle = function(val, unit) {
  return val === 0 ? 0 : val + unit;
};
function CueStyleBox(window2, cue, styleOptions) {
  StyleBox.call(this);
  this.cue = cue;
  this.cueDiv = parseContent(window2, cue.text);
  var styles2 = {
    color: "rgba(255, 255, 255, 1)",
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    position: "relative",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    display: "inline",
    writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext"
  };
  this.applyStyles(styles2, this.cueDiv);
  this.div = window2.document.createElement("div");
  styles2 = {
    direction: determineBidi(this.cueDiv),
    writingMode: cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl",
    unicodeBidi: "plaintext",
    textAlign: cue.align === "middle" ? "center" : cue.align,
    font: styleOptions.font,
    whiteSpace: "pre-line",
    position: "absolute"
  };
  this.applyStyles(styles2);
  this.div.appendChild(this.cueDiv);
  var textPos = 0;
  switch (cue.positionAlign) {
    case "start":
    case "line-left":
      textPos = cue.position;
      break;
    case "center":
      textPos = cue.position - cue.size / 2;
      break;
    case "end":
    case "line-right":
      textPos = cue.position - cue.size;
      break;
  }
  if (cue.vertical === "") {
    this.applyStyles({
      left: this.formatStyle(textPos, "%"),
      width: this.formatStyle(cue.size, "%")
    });
  } else {
    this.applyStyles({
      top: this.formatStyle(textPos, "%"),
      height: this.formatStyle(cue.size, "%")
    });
  }
  this.move = function(box) {
    this.applyStyles({
      top: this.formatStyle(box.top, "px"),
      bottom: this.formatStyle(box.bottom, "px"),
      left: this.formatStyle(box.left, "px"),
      right: this.formatStyle(box.right, "px"),
      height: this.formatStyle(box.height, "px"),
      width: this.formatStyle(box.width, "px")
    });
  };
}
CueStyleBox.prototype = _objCreate(StyleBox.prototype);
CueStyleBox.prototype.constructor = CueStyleBox;
function BoxPosition(obj) {
  var lh2, height2, width2, top;
  if (obj.div) {
    height2 = obj.div.offsetHeight;
    width2 = obj.div.offsetWidth;
    top = obj.div.offsetTop;
    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) && rects.getClientRects && rects.getClientRects();
    obj = obj.div.getBoundingClientRect();
    lh2 = rects ? Math.max(rects[0] && rects[0].height || 0, obj.height / rects.length) : 0;
  }
  this.left = obj.left;
  this.right = obj.right;
  this.top = obj.top || top;
  this.height = obj.height || height2;
  this.bottom = obj.bottom || top + (obj.height || height2);
  this.width = obj.width || width2;
  this.lineHeight = lh2 !== void 0 ? lh2 : obj.lineHeight;
}
BoxPosition.prototype.move = function(axis, toMove) {
  toMove = toMove !== void 0 ? toMove : this.lineHeight;
  switch (axis) {
    case "+x":
      this.left += toMove;
      this.right += toMove;
      break;
    case "-x":
      this.left -= toMove;
      this.right -= toMove;
      break;
    case "+y":
      this.top += toMove;
      this.bottom += toMove;
      break;
    case "-y":
      this.top -= toMove;
      this.bottom -= toMove;
      break;
  }
};
BoxPosition.prototype.overlaps = function(b2) {
  return this.left < b2.right && this.right > b2.left && this.top < b2.bottom && this.bottom > b2.top;
};
BoxPosition.prototype.overlapsAny = function(boxes) {
  for (var i = 0; i < boxes.length; i++) {
    if (this.overlaps(boxes[i])) {
      return true;
    }
  }
  return false;
};
BoxPosition.prototype.within = function(container2) {
  return this.top >= container2.top && this.bottom <= container2.bottom && this.left >= container2.left && this.right <= container2.right;
};
BoxPosition.prototype.overlapsOppositeAxis = function(container2, axis) {
  switch (axis) {
    case "+x":
      return this.left < container2.left;
    case "-x":
      return this.right > container2.right;
    case "+y":
      return this.top < container2.top;
    case "-y":
      return this.bottom > container2.bottom;
  }
};
BoxPosition.prototype.intersectPercentage = function(b2) {
  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)), y2 = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)), intersectArea = x * y2;
  return intersectArea / (this.height * this.width);
};
BoxPosition.prototype.toCSSCompatValues = function(reference) {
  return {
    top: this.top - reference.top,
    bottom: reference.bottom - this.bottom,
    left: this.left - reference.left,
    right: reference.right - this.right,
    height: this.height,
    width: this.width
  };
};
BoxPosition.getSimpleBoxPosition = function(obj) {
  var height2 = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
  var width2 = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
  obj = obj.div ? obj.div.getBoundingClientRect() : obj.tagName ? obj.getBoundingClientRect() : obj;
  var ret = {
    left: obj.left,
    right: obj.right,
    top: obj.top || top,
    height: obj.height || height2,
    bottom: obj.bottom || top + (obj.height || height2),
    width: obj.width || width2
  };
  return ret;
};
function moveBoxToLinePosition(window2, styleBox, containerBox, boxPositions) {
  function findBestPosition(b, axis2) {
    var bestPosition2, specifiedPosition = new BoxPosition(b), percentage = 1;
    for (var i = 0; i < axis2.length; i++) {
      while (b.overlapsOppositeAxis(containerBox, axis2[i]) || b.within(containerBox) && b.overlapsAny(boxPositions)) {
        b.move(axis2[i]);
      }
      if (b.within(containerBox)) {
        return b;
      }
      var p2 = b.intersectPercentage(containerBox);
      if (percentage > p2) {
        bestPosition2 = new BoxPosition(b);
        percentage = p2;
      }
      b = new BoxPosition(specifiedPosition);
    }
    return bestPosition2 || specifiedPosition;
  }
  var boxPosition = new BoxPosition(styleBox), cue = styleBox.cue, linePos = computeLinePos(cue), axis = [];
  if (cue.snapToLines) {
    var size;
    switch (cue.vertical) {
      case "":
        axis = ["+y", "-y"];
        size = "height";
        break;
      case "rl":
        axis = ["+x", "-x"];
        size = "width";
        break;
      case "lr":
        axis = ["-x", "+x"];
        size = "width";
        break;
    }
    var step = boxPosition.lineHeight, position2 = step * Math.round(linePos), maxPosition = containerBox[size] + step, initialAxis = axis[0];
    if (Math.abs(position2) > maxPosition) {
      position2 = position2 < 0 ? -1 : 1;
      position2 *= Math.ceil(maxPosition / step) * step;
    }
    if (linePos < 0) {
      position2 += cue.vertical === "" ? containerBox.height : containerBox.width;
      axis = axis.reverse();
    }
    boxPosition.move(initialAxis, position2);
  } else {
    var calculatedPercentage = boxPosition.lineHeight / containerBox.height * 100;
    switch (cue.lineAlign) {
      case "center":
        linePos -= calculatedPercentage / 2;
        break;
      case "end":
        linePos -= calculatedPercentage;
        break;
    }
    switch (cue.vertical) {
      case "":
        styleBox.applyStyles({
          top: styleBox.formatStyle(linePos, "%")
        });
        break;
      case "rl":
        styleBox.applyStyles({
          left: styleBox.formatStyle(linePos, "%")
        });
        break;
      case "lr":
        styleBox.applyStyles({
          right: styleBox.formatStyle(linePos, "%")
        });
        break;
    }
    axis = ["+y", "-x", "+x", "-y"];
    boxPosition = new BoxPosition(styleBox);
  }
  var bestPosition = findBestPosition(boxPosition, axis);
  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
}
function WebVTT$1() {
}
WebVTT$1.StringDecoder = function() {
  return {
    decode: function(data) {
      if (!data) {
        return "";
      }
      if (typeof data !== "string") {
        throw new Error("Error - expected string data.");
      }
      return decodeURIComponent(encodeURIComponent(data));
    }
  };
};
WebVTT$1.convertCueToDOMTree = function(window2, cuetext) {
  if (!window2 || !cuetext) {
    return null;
  }
  return parseContent(window2, cuetext);
};
var FONT_SIZE_PERCENT = 0.05;
var FONT_STYLE = "sans-serif";
var CUE_BACKGROUND_PADDING = "1.5%";
WebVTT$1.processCues = function(window2, cues, overlay) {
  if (!window2 || !cues || !overlay) {
    return null;
  }
  while (overlay.firstChild) {
    overlay.removeChild(overlay.firstChild);
  }
  var paddedOverlay = window2.document.createElement("div");
  paddedOverlay.style.position = "absolute";
  paddedOverlay.style.left = "0";
  paddedOverlay.style.right = "0";
  paddedOverlay.style.top = "0";
  paddedOverlay.style.bottom = "0";
  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
  overlay.appendChild(paddedOverlay);
  function shouldCompute(cues2) {
    for (var i2 = 0; i2 < cues2.length; i2++) {
      if (cues2[i2].hasBeenReset || !cues2[i2].displayState) {
        return true;
      }
    }
    return false;
  }
  if (!shouldCompute(cues)) {
    for (var i = 0; i < cues.length; i++) {
      paddedOverlay.appendChild(cues[i].displayState);
    }
    return;
  }
  var boxPositions = [], containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay), fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
  var styleOptions = {
    font: fontSize + "px " + FONT_STYLE
  };
  (function() {
    var styleBox, cue;
    for (var i2 = 0; i2 < cues.length; i2++) {
      cue = cues[i2];
      styleBox = new CueStyleBox(window2, cue, styleOptions);
      paddedOverlay.appendChild(styleBox.div);
      moveBoxToLinePosition(window2, styleBox, containerBox, boxPositions);
      cue.displayState = styleBox.div;
      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
    }
  })();
};
WebVTT$1.Parser = function(window2, vttjs2, decoder) {
  if (!decoder) {
    decoder = vttjs2;
    vttjs2 = {};
  }
  if (!vttjs2) {
    vttjs2 = {};
  }
  this.window = window2;
  this.vttjs = vttjs2;
  this.state = "INITIAL";
  this.buffer = "";
  this.decoder = decoder || new TextDecoder("utf8");
  this.regionList = [];
};
WebVTT$1.Parser.prototype = {
  reportOrThrowError: function(e) {
    if (e instanceof ParsingError) {
      this.onparsingerror && this.onparsingerror(e);
    } else {
      throw e;
    }
  },
  parse: function(data) {
    var self2 = this;
    if (data) {
      self2.buffer += self2.decoder.decode(data, { stream: true });
    }
    function collectNextLine() {
      var buffer = self2.buffer;
      var pos = 0;
      while (pos < buffer.length && buffer[pos] !== "\r" && buffer[pos] !== "\n") {
        ++pos;
      }
      var line2 = buffer.substr(0, pos);
      if (buffer[pos] === "\r") {
        ++pos;
      }
      if (buffer[pos] === "\n") {
        ++pos;
      }
      self2.buffer = buffer.substr(pos);
      return line2;
    }
    function parseRegion(input) {
      var settings = new Settings();
      parseOptions(input, function(k, v) {
        switch (k) {
          case "id":
            settings.set(k, v);
            break;
          case "width":
            settings.percent(k, v);
            break;
          case "lines":
            settings.integer(k, v);
            break;
          case "regionanchor":
          case "viewportanchor":
            var xy = v.split(",");
            if (xy.length !== 2) {
              break;
            }
            var anchor = new Settings();
            anchor.percent("x", xy[0]);
            anchor.percent("y", xy[1]);
            if (!anchor.has("x") || !anchor.has("y")) {
              break;
            }
            settings.set(k + "X", anchor.get("x"));
            settings.set(k + "Y", anchor.get("y"));
            break;
          case "scroll":
            settings.alt(k, v, ["up"]);
            break;
        }
      }, /=/, /\s/);
      if (settings.has("id")) {
        var region = new (self2.vttjs.VTTRegion || self2.window.VTTRegion)();
        region.width = settings.get("width", 100);
        region.lines = settings.get("lines", 3);
        region.regionAnchorX = settings.get("regionanchorX", 0);
        region.regionAnchorY = settings.get("regionanchorY", 100);
        region.viewportAnchorX = settings.get("viewportanchorX", 0);
        region.viewportAnchorY = settings.get("viewportanchorY", 100);
        region.scroll = settings.get("scroll", "");
        self2.onregion && self2.onregion(region);
        self2.regionList.push({
          id: settings.get("id"),
          region
        });
      }
    }
    function parseTimestampMap(input) {
      var settings = new Settings();
      parseOptions(input, function(k, v) {
        switch (k) {
          case "MPEGT":
            settings.integer(k + "S", v);
            break;
          case "LOCA":
            settings.set(k + "L", parseTimeStamp(v));
            break;
        }
      }, /[^\d]:/, /,/);
      self2.ontimestampmap && self2.ontimestampmap({
        "MPEGTS": settings.get("MPEGTS"),
        "LOCAL": settings.get("LOCAL")
      });
    }
    function parseHeader(input) {
      if (input.match(/X-TIMESTAMP-MAP/)) {
        parseOptions(input, function(k, v) {
          switch (k) {
            case "X-TIMESTAMP-MAP":
              parseTimestampMap(v);
              break;
          }
        }, /=/);
      } else {
        parseOptions(input, function(k, v) {
          switch (k) {
            case "Region":
              parseRegion(v);
              break;
          }
        }, /:/);
      }
    }
    try {
      var line;
      if (self2.state === "INITIAL") {
        if (!/\r\n|\n/.test(self2.buffer)) {
          return this;
        }
        line = collectNextLine();
        var m2 = line.match(/^WEBVTT([ \t].*)?$/);
        if (!m2 || !m2[0]) {
          throw new ParsingError(ParsingError.Errors.BadSignature);
        }
        self2.state = "HEADER";
      }
      var alreadyCollectedLine = false;
      while (self2.buffer) {
        if (!/\r\n|\n/.test(self2.buffer)) {
          return this;
        }
        if (!alreadyCollectedLine) {
          line = collectNextLine();
        } else {
          alreadyCollectedLine = false;
        }
        switch (self2.state) {
          case "HEADER":
            if (/:/.test(line)) {
              parseHeader(line);
            } else if (!line) {
              self2.state = "ID";
            }
            continue;
          case "NOTE":
            if (!line) {
              self2.state = "ID";
            }
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(line)) {
              self2.state = "NOTE";
              break;
            }
            if (!line) {
              continue;
            }
            self2.cue = new (self2.vttjs.VTTCue || self2.window.VTTCue)(0, 0, "");
            try {
              self2.cue.align = "center";
            } catch (e) {
              self2.cue.align = "middle";
            }
            self2.state = "CUE";
            if (line.indexOf("-->") === -1) {
              self2.cue.id = line;
              continue;
            }
          case "CUE":
            try {
              parseCue(line, self2.cue, self2.regionList);
            } catch (e) {
              self2.reportOrThrowError(e);
              self2.cue = null;
              self2.state = "BADCUE";
              continue;
            }
            self2.state = "CUETEXT";
            continue;
          case "CUETEXT":
            var hasSubstring = line.indexOf("-->") !== -1;
            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
              self2.oncue && self2.oncue(self2.cue);
              self2.cue = null;
              self2.state = "ID";
              continue;
            }
            if (self2.cue.text) {
              self2.cue.text += "\n";
            }
            self2.cue.text += line.replace(/\u2028/g, "\n").replace(/u2029/g, "\n");
            continue;
          case "BADCUE":
            if (!line) {
              self2.state = "ID";
            }
            continue;
        }
      }
    } catch (e) {
      self2.reportOrThrowError(e);
      if (self2.state === "CUETEXT" && self2.cue && self2.oncue) {
        self2.oncue(self2.cue);
      }
      self2.cue = null;
      self2.state = self2.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  },
  flush: function() {
    var self2 = this;
    try {
      self2.buffer += self2.decoder.decode();
      if (self2.cue || self2.state === "HEADER") {
        self2.buffer += "\n\n";
        self2.parse();
      }
      if (self2.state === "INITIAL") {
        throw new ParsingError(ParsingError.Errors.BadSignature);
      }
    } catch (e) {
      self2.reportOrThrowError(e);
    }
    self2.onflush && self2.onflush();
    return this;
  }
};
var vtt$1 = WebVTT$1;
var autoKeyword = "auto";
var directionSetting = {
  "": 1,
  "lr": 1,
  "rl": 1
};
var alignSetting = {
  "start": 1,
  "center": 1,
  "end": 1,
  "left": 1,
  "right": 1,
  "auto": 1,
  "line-left": 1,
  "line-right": 1
};
function findDirectionSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var dir = directionSetting[value.toLowerCase()];
  return dir ? value.toLowerCase() : false;
}
function findAlignSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var align = alignSetting[value.toLowerCase()];
  return align ? value.toLowerCase() : false;
}
function VTTCue(startTime, endTime, text) {
  this.hasBeenReset = false;
  var _id = "";
  var _pauseOnExit = false;
  var _startTime = startTime;
  var _endTime = endTime;
  var _text = text;
  var _region = null;
  var _vertical = "";
  var _snapToLines = true;
  var _line = "auto";
  var _lineAlign = "start";
  var _position = "auto";
  var _positionAlign = "auto";
  var _size = 100;
  var _align = "center";
  Object.defineProperties(this, {
    "id": {
      enumerable: true,
      get: function() {
        return _id;
      },
      set: function(value) {
        _id = "" + value;
      }
    },
    "pauseOnExit": {
      enumerable: true,
      get: function() {
        return _pauseOnExit;
      },
      set: function(value) {
        _pauseOnExit = !!value;
      }
    },
    "startTime": {
      enumerable: true,
      get: function() {
        return _startTime;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("Start time must be set to a number.");
        }
        _startTime = value;
        this.hasBeenReset = true;
      }
    },
    "endTime": {
      enumerable: true,
      get: function() {
        return _endTime;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("End time must be set to a number.");
        }
        _endTime = value;
        this.hasBeenReset = true;
      }
    },
    "text": {
      enumerable: true,
      get: function() {
        return _text;
      },
      set: function(value) {
        _text = "" + value;
        this.hasBeenReset = true;
      }
    },
    "region": {
      enumerable: true,
      get: function() {
        return _region;
      },
      set: function(value) {
        _region = value;
        this.hasBeenReset = true;
      }
    },
    "vertical": {
      enumerable: true,
      get: function() {
        return _vertical;
      },
      set: function(value) {
        var setting = findDirectionSetting(value);
        if (setting === false) {
          throw new SyntaxError("Vertical: an invalid or illegal direction string was specified.");
        }
        _vertical = setting;
        this.hasBeenReset = true;
      }
    },
    "snapToLines": {
      enumerable: true,
      get: function() {
        return _snapToLines;
      },
      set: function(value) {
        _snapToLines = !!value;
        this.hasBeenReset = true;
      }
    },
    "line": {
      enumerable: true,
      get: function() {
        return _line;
      },
      set: function(value) {
        if (typeof value !== "number" && value !== autoKeyword) {
          throw new SyntaxError("Line: an invalid number or illegal string was specified.");
        }
        _line = value;
        this.hasBeenReset = true;
      }
    },
    "lineAlign": {
      enumerable: true,
      get: function() {
        return _lineAlign;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("lineAlign: an invalid or illegal string was specified.");
        } else {
          _lineAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },
    "position": {
      enumerable: true,
      get: function() {
        return _position;
      },
      set: function(value) {
        if (value < 0 || value > 100) {
          throw new Error("Position must be between 0 and 100.");
        }
        _position = value;
        this.hasBeenReset = true;
      }
    },
    "positionAlign": {
      enumerable: true,
      get: function() {
        return _positionAlign;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          console.warn("positionAlign: an invalid or illegal string was specified.");
        } else {
          _positionAlign = setting;
          this.hasBeenReset = true;
        }
      }
    },
    "size": {
      enumerable: true,
      get: function() {
        return _size;
      },
      set: function(value) {
        if (value < 0 || value > 100) {
          throw new Error("Size must be between 0 and 100.");
        }
        _size = value;
        this.hasBeenReset = true;
      }
    },
    "align": {
      enumerable: true,
      get: function() {
        return _align;
      },
      set: function(value) {
        var setting = findAlignSetting(value);
        if (!setting) {
          throw new SyntaxError("align: an invalid or illegal alignment string was specified.");
        }
        _align = setting;
        this.hasBeenReset = true;
      }
    }
  });
  this.displayState = void 0;
}
VTTCue.prototype.getCueAsHTML = function() {
  return WebVTT.convertCueToDOMTree(window, this.text);
};
var vttcue = VTTCue;
var scrollSetting = {
  "": true,
  "up": true
};
function findScrollSetting(value) {
  if (typeof value !== "string") {
    return false;
  }
  var scroll = scrollSetting[value.toLowerCase()];
  return scroll ? value.toLowerCase() : false;
}
function isValidPercentValue(value) {
  return typeof value === "number" && (value >= 0 && value <= 100);
}
function VTTRegion() {
  var _width = 100;
  var _lines = 3;
  var _regionAnchorX = 0;
  var _regionAnchorY = 100;
  var _viewportAnchorX = 0;
  var _viewportAnchorY = 100;
  var _scroll = "";
  Object.defineProperties(this, {
    "width": {
      enumerable: true,
      get: function() {
        return _width;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("Width must be between 0 and 100.");
        }
        _width = value;
      }
    },
    "lines": {
      enumerable: true,
      get: function() {
        return _lines;
      },
      set: function(value) {
        if (typeof value !== "number") {
          throw new TypeError("Lines must be set to a number.");
        }
        _lines = value;
      }
    },
    "regionAnchorY": {
      enumerable: true,
      get: function() {
        return _regionAnchorY;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorX must be between 0 and 100.");
        }
        _regionAnchorY = value;
      }
    },
    "regionAnchorX": {
      enumerable: true,
      get: function() {
        return _regionAnchorX;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("RegionAnchorY must be between 0 and 100.");
        }
        _regionAnchorX = value;
      }
    },
    "viewportAnchorY": {
      enumerable: true,
      get: function() {
        return _viewportAnchorY;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorY must be between 0 and 100.");
        }
        _viewportAnchorY = value;
      }
    },
    "viewportAnchorX": {
      enumerable: true,
      get: function() {
        return _viewportAnchorX;
      },
      set: function(value) {
        if (!isValidPercentValue(value)) {
          throw new Error("ViewportAnchorX must be between 0 and 100.");
        }
        _viewportAnchorX = value;
      }
    },
    "scroll": {
      enumerable: true,
      get: function() {
        return _scroll;
      },
      set: function(value) {
        var setting = findScrollSetting(value);
        if (setting === false) {
          console.warn("Scroll: an invalid or illegal string was specified.");
        } else {
          _scroll = setting;
        }
      }
    }
  });
}
var vttregion = VTTRegion;
var window$1 = window_1;
var vttjs = browserIndex.exports = {
  WebVTT: vtt$1,
  VTTCue: vttcue,
  VTTRegion: vttregion
};
window$1.vttjs = vttjs;
window$1.WebVTT = vttjs.WebVTT;
var cueShim = vttjs.VTTCue;
var regionShim = vttjs.VTTRegion;
var nativeVTTCue = window$1.VTTCue;
var nativeVTTRegion = window$1.VTTRegion;
vttjs.shim = function() {
  window$1.VTTCue = cueShim;
  window$1.VTTRegion = regionShim;
};
vttjs.restore = function() {
  window$1.VTTCue = nativeVTTCue;
  window$1.VTTRegion = nativeVTTRegion;
};
if (!window$1.VTTCue) {
  vttjs.shim();
}
var vtt = browserIndex.exports;
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
var urlToolkit = { exports: {} };
(function(module, exports) {
  (function(root) {
    var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
    var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
    var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
    var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
    var URLToolkit2 = {
      buildAbsoluteURL: function(baseURL, relativeURL, opts) {
        opts = opts || {};
        baseURL = baseURL.trim();
        relativeURL = relativeURL.trim();
        if (!relativeURL) {
          if (!opts.alwaysNormalize) {
            return baseURL;
          }
          var basePartsForNormalise = URLToolkit2.parseURL(baseURL);
          if (!basePartsForNormalise) {
            throw new Error("Error trying to parse base URL.");
          }
          basePartsForNormalise.path = URLToolkit2.normalizePath(basePartsForNormalise.path);
          return URLToolkit2.buildURLFromParts(basePartsForNormalise);
        }
        var relativeParts = URLToolkit2.parseURL(relativeURL);
        if (!relativeParts) {
          throw new Error("Error trying to parse relative URL.");
        }
        if (relativeParts.scheme) {
          if (!opts.alwaysNormalize) {
            return relativeURL;
          }
          relativeParts.path = URLToolkit2.normalizePath(relativeParts.path);
          return URLToolkit2.buildURLFromParts(relativeParts);
        }
        var baseParts = URLToolkit2.parseURL(baseURL);
        if (!baseParts) {
          throw new Error("Error trying to parse base URL.");
        }
        if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== "/") {
          var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
          baseParts.netLoc = pathParts[1];
          baseParts.path = pathParts[2];
        }
        if (baseParts.netLoc && !baseParts.path) {
          baseParts.path = "/";
        }
        var builtParts = {
          scheme: baseParts.scheme,
          netLoc: relativeParts.netLoc,
          path: null,
          params: relativeParts.params,
          query: relativeParts.query,
          fragment: relativeParts.fragment
        };
        if (!relativeParts.netLoc) {
          builtParts.netLoc = baseParts.netLoc;
          if (relativeParts.path[0] !== "/") {
            if (!relativeParts.path) {
              builtParts.path = baseParts.path;
              if (!relativeParts.params) {
                builtParts.params = baseParts.params;
                if (!relativeParts.query) {
                  builtParts.query = baseParts.query;
                }
              }
            } else {
              var baseURLPath = baseParts.path;
              var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf("/") + 1) + relativeParts.path;
              builtParts.path = URLToolkit2.normalizePath(newPath);
            }
          }
        }
        if (builtParts.path === null) {
          builtParts.path = opts.alwaysNormalize ? URLToolkit2.normalizePath(relativeParts.path) : relativeParts.path;
        }
        return URLToolkit2.buildURLFromParts(builtParts);
      },
      parseURL: function(url) {
        var parts = URL_REGEX.exec(url);
        if (!parts) {
          return null;
        }
        return {
          scheme: parts[1] || "",
          netLoc: parts[2] || "",
          path: parts[3] || "",
          params: parts[4] || "",
          query: parts[5] || "",
          fragment: parts[6] || ""
        };
      },
      normalizePath: function(path) {
        path = path.split("").reverse().join("").replace(SLASH_DOT_REGEX, "");
        while (path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, "")).length) {
        }
        return path.split("").reverse().join("");
      },
      buildURLFromParts: function(parts) {
        return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
      }
    };
    module.exports = URLToolkit2;
  })();
})(urlToolkit);
var URLToolkit = urlToolkit.exports;
var DEFAULT_LOCATION = "http://example.com";
var resolveUrl$1 = function resolveUrl(baseUrl, relativeUrl) {
  if (/^[a-z]+:/i.test(relativeUrl)) {
    return relativeUrl;
  }
  if (/^data:/.test(baseUrl)) {
    baseUrl = window_1.location && window_1.location.href || "";
  }
  var nativeURL = typeof window_1.URL === "function";
  var protocolLess = /^\/\//.test(baseUrl);
  var removeLocation = !window_1.location && !/\/\//i.test(baseUrl);
  if (nativeURL) {
    baseUrl = new window_1.URL(baseUrl, window_1.location || DEFAULT_LOCATION);
  } else if (!/\/\//i.test(baseUrl)) {
    baseUrl = URLToolkit.buildAbsoluteURL(window_1.location && window_1.location.href || "", baseUrl);
  }
  if (nativeURL) {
    var newUrl = new URL(relativeUrl, baseUrl);
    if (removeLocation) {
      return newUrl.href.slice(DEFAULT_LOCATION.length);
    } else if (protocolLess) {
      return newUrl.href.slice(newUrl.protocol.length);
    }
    return newUrl.href;
  }
  return URLToolkit.buildAbsoluteURL(baseUrl, relativeUrl);
};
var Stream = /* @__PURE__ */ function() {
  function Stream2() {
    this.listeners = {};
  }
  var _proto = Stream2.prototype;
  _proto.on = function on3(type2, listener3) {
    if (!this.listeners[type2]) {
      this.listeners[type2] = [];
    }
    this.listeners[type2].push(listener3);
  };
  _proto.off = function off2(type2, listener3) {
    if (!this.listeners[type2]) {
      return false;
    }
    var index = this.listeners[type2].indexOf(listener3);
    this.listeners[type2] = this.listeners[type2].slice(0);
    this.listeners[type2].splice(index, 1);
    return index > -1;
  };
  _proto.trigger = function trigger2(type2) {
    var callbacks = this.listeners[type2];
    if (!callbacks) {
      return;
    }
    if (arguments.length === 2) {
      var length = callbacks.length;
      for (var i = 0; i < length; ++i) {
        callbacks[i].call(this, arguments[1]);
      }
    } else {
      var args = Array.prototype.slice.call(arguments, 1);
      var _length = callbacks.length;
      for (var _i = 0; _i < _length; ++_i) {
        callbacks[_i].apply(this, args);
      }
    }
  };
  _proto.dispose = function dispose() {
    this.listeners = {};
  };
  _proto.pipe = function pipe(destination) {
    this.on("data", function(data) {
      destination.push(data);
    });
  };
  return Stream2;
}();
var atob = function atob2(s) {
  return window_1.atob ? window_1.atob(s) : Buffer.from(s, "base64").toString("binary");
};
function decodeB64ToUint8Array(b64Text) {
  var decodedString = atob(b64Text);
  var array2 = new Uint8Array(decodedString.length);
  for (var i = 0; i < decodedString.length; i++) {
    array2[i] = decodedString.charCodeAt(i);
  }
  return array2;
}
/*! @name m3u8-parser @version 4.8.0 @license Apache-2.0 */
var LineStream = /* @__PURE__ */ function(_Stream) {
  _inheritsLoose(LineStream2, _Stream);
  function LineStream2() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.buffer = "";
    return _this;
  }
  var _proto = LineStream2.prototype;
  _proto.push = function push(data) {
    var nextNewline;
    this.buffer += data;
    nextNewline = this.buffer.indexOf("\n");
    for (; nextNewline > -1; nextNewline = this.buffer.indexOf("\n")) {
      this.trigger("data", this.buffer.substring(0, nextNewline));
      this.buffer = this.buffer.substring(nextNewline + 1);
    }
  };
  return LineStream2;
}(Stream);
var TAB = String.fromCharCode(9);
var parseByterange = function parseByterange2(byterangeString) {
  var match = /([0-9.]*)?@?([0-9.]*)?/.exec(byterangeString || "");
  var result2 = {};
  if (match[1]) {
    result2.length = parseInt(match[1], 10);
  }
  if (match[2]) {
    result2.offset = parseInt(match[2], 10);
  }
  return result2;
};
var attributeSeparator = function attributeSeparator2() {
  var key = "[^=]*";
  var value = '"[^"]*"|[^,]*';
  var keyvalue = "(?:" + key + ")=(?:" + value + ")";
  return new RegExp("(?:^|,)(" + keyvalue + ")");
};
var parseAttributes$1 = function parseAttributes(attributes) {
  var attrs = attributes.split(attributeSeparator());
  var result2 = {};
  var i = attrs.length;
  var attr;
  while (i--) {
    if (attrs[i] === "") {
      continue;
    }
    attr = /([^=]*)=(.*)/.exec(attrs[i]).slice(1);
    attr[0] = attr[0].replace(/^\s+|\s+$/g, "");
    attr[1] = attr[1].replace(/^\s+|\s+$/g, "");
    attr[1] = attr[1].replace(/^['"](.*)['"]$/g, "$1");
    result2[attr[0]] = attr[1];
  }
  return result2;
};
var ParseStream = /* @__PURE__ */ function(_Stream) {
  _inheritsLoose(ParseStream2, _Stream);
  function ParseStream2() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.customParsers = [];
    _this.tagMappers = [];
    return _this;
  }
  var _proto = ParseStream2.prototype;
  _proto.push = function push(line) {
    var _this2 = this;
    var match;
    var event;
    line = line.trim();
    if (line.length === 0) {
      return;
    }
    if (line[0] !== "#") {
      this.trigger("data", {
        type: "uri",
        uri: line
      });
      return;
    }
    var newLines = this.tagMappers.reduce(function(acc, mapper) {
      var mappedLine = mapper(line);
      if (mappedLine === line) {
        return acc;
      }
      return acc.concat([mappedLine]);
    }, [line]);
    newLines.forEach(function(newLine) {
      for (var i = 0; i < _this2.customParsers.length; i++) {
        if (_this2.customParsers[i].call(_this2, newLine)) {
          return;
        }
      }
      if (newLine.indexOf("#EXT") !== 0) {
        _this2.trigger("data", {
          type: "comment",
          text: newLine.slice(1)
        });
        return;
      }
      newLine = newLine.replace("\r", "");
      match = /^#EXTM3U/.exec(newLine);
      if (match) {
        _this2.trigger("data", {
          type: "tag",
          tagType: "m3u"
        });
        return;
      }
      match = /^#EXTINF:?([0-9\.]*)?,?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "inf"
        };
        if (match[1]) {
          event.duration = parseFloat(match[1]);
        }
        if (match[2]) {
          event.title = match[2];
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-TARGETDURATION:?([0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "targetduration"
        };
        if (match[1]) {
          event.duration = parseInt(match[1], 10);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-VERSION:?([0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "version"
        };
        if (match[1]) {
          event.version = parseInt(match[1], 10);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-MEDIA-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "media-sequence"
        };
        if (match[1]) {
          event.number = parseInt(match[1], 10);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-DISCONTINUITY-SEQUENCE:?(\-?[0-9.]*)?/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "discontinuity-sequence"
        };
        if (match[1]) {
          event.number = parseInt(match[1], 10);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-PLAYLIST-TYPE:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "playlist-type"
        };
        if (match[1]) {
          event.playlistType = match[1];
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-BYTERANGE:?(.*)?$/.exec(newLine);
      if (match) {
        event = _extends$2(parseByterange(match[1]), {
          type: "tag",
          tagType: "byterange"
        });
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-ALLOW-CACHE:?(YES|NO)?/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "allow-cache"
        };
        if (match[1]) {
          event.allowed = !/NO/.test(match[1]);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-MAP:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "map"
        };
        if (match[1]) {
          var attributes = parseAttributes$1(match[1]);
          if (attributes.URI) {
            event.uri = attributes.URI;
          }
          if (attributes.BYTERANGE) {
            event.byterange = parseByterange(attributes.BYTERANGE);
          }
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-STREAM-INF:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "stream-inf"
        };
        if (match[1]) {
          event.attributes = parseAttributes$1(match[1]);
          if (event.attributes.RESOLUTION) {
            var split2 = event.attributes.RESOLUTION.split("x");
            var resolution = {};
            if (split2[0]) {
              resolution.width = parseInt(split2[0], 10);
            }
            if (split2[1]) {
              resolution.height = parseInt(split2[1], 10);
            }
            event.attributes.RESOLUTION = resolution;
          }
          if (event.attributes.BANDWIDTH) {
            event.attributes.BANDWIDTH = parseInt(event.attributes.BANDWIDTH, 10);
          }
          if (event.attributes["FRAME-RATE"]) {
            event.attributes["FRAME-RATE"] = parseFloat(event.attributes["FRAME-RATE"]);
          }
          if (event.attributes["PROGRAM-ID"]) {
            event.attributes["PROGRAM-ID"] = parseInt(event.attributes["PROGRAM-ID"], 10);
          }
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-MEDIA:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "media"
        };
        if (match[1]) {
          event.attributes = parseAttributes$1(match[1]);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-ENDLIST/.exec(newLine);
      if (match) {
        _this2.trigger("data", {
          type: "tag",
          tagType: "endlist"
        });
        return;
      }
      match = /^#EXT-X-DISCONTINUITY/.exec(newLine);
      if (match) {
        _this2.trigger("data", {
          type: "tag",
          tagType: "discontinuity"
        });
        return;
      }
      match = /^#EXT-X-PROGRAM-DATE-TIME:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "program-date-time"
        };
        if (match[1]) {
          event.dateTimeString = match[1];
          event.dateTimeObject = new Date(match[1]);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-KEY:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "key"
        };
        if (match[1]) {
          event.attributes = parseAttributes$1(match[1]);
          if (event.attributes.IV) {
            if (event.attributes.IV.substring(0, 2).toLowerCase() === "0x") {
              event.attributes.IV = event.attributes.IV.substring(2);
            }
            event.attributes.IV = event.attributes.IV.match(/.{8}/g);
            event.attributes.IV[0] = parseInt(event.attributes.IV[0], 16);
            event.attributes.IV[1] = parseInt(event.attributes.IV[1], 16);
            event.attributes.IV[2] = parseInt(event.attributes.IV[2], 16);
            event.attributes.IV[3] = parseInt(event.attributes.IV[3], 16);
            event.attributes.IV = new Uint32Array(event.attributes.IV);
          }
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-START:?(.*)$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "start"
        };
        if (match[1]) {
          event.attributes = parseAttributes$1(match[1]);
          event.attributes["TIME-OFFSET"] = parseFloat(event.attributes["TIME-OFFSET"]);
          event.attributes.PRECISE = /YES/.test(event.attributes.PRECISE);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-CUE-OUT-CONT:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "cue-out-cont"
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = "";
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-CUE-OUT:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "cue-out"
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = "";
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-CUE-IN:?(.*)?$/.exec(newLine);
      if (match) {
        event = {
          type: "tag",
          tagType: "cue-in"
        };
        if (match[1]) {
          event.data = match[1];
        } else {
          event.data = "";
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-SKIP:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: "tag",
          tagType: "skip"
        };
        event.attributes = parseAttributes$1(match[1]);
        if (event.attributes.hasOwnProperty("SKIPPED-SEGMENTS")) {
          event.attributes["SKIPPED-SEGMENTS"] = parseInt(event.attributes["SKIPPED-SEGMENTS"], 10);
        }
        if (event.attributes.hasOwnProperty("RECENTLY-REMOVED-DATERANGES")) {
          event.attributes["RECENTLY-REMOVED-DATERANGES"] = event.attributes["RECENTLY-REMOVED-DATERANGES"].split(TAB);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-PART:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: "tag",
          tagType: "part"
        };
        event.attributes = parseAttributes$1(match[1]);
        ["DURATION"].forEach(function(key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        ["INDEPENDENT", "GAP"].forEach(function(key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = /YES/.test(event.attributes[key]);
          }
        });
        if (event.attributes.hasOwnProperty("BYTERANGE")) {
          event.attributes.byterange = parseByterange(event.attributes.BYTERANGE);
        }
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-SERVER-CONTROL:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: "tag",
          tagType: "server-control"
        };
        event.attributes = parseAttributes$1(match[1]);
        ["CAN-SKIP-UNTIL", "PART-HOLD-BACK", "HOLD-BACK"].forEach(function(key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        ["CAN-SKIP-DATERANGES", "CAN-BLOCK-RELOAD"].forEach(function(key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = /YES/.test(event.attributes[key]);
          }
        });
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-PART-INF:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: "tag",
          tagType: "part-inf"
        };
        event.attributes = parseAttributes$1(match[1]);
        ["PART-TARGET"].forEach(function(key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseFloat(event.attributes[key]);
          }
        });
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-PRELOAD-HINT:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: "tag",
          tagType: "preload-hint"
        };
        event.attributes = parseAttributes$1(match[1]);
        ["BYTERANGE-START", "BYTERANGE-LENGTH"].forEach(function(key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseInt(event.attributes[key], 10);
            var subkey = key === "BYTERANGE-LENGTH" ? "length" : "offset";
            event.attributes.byterange = event.attributes.byterange || {};
            event.attributes.byterange[subkey] = event.attributes[key];
            delete event.attributes[key];
          }
        });
        _this2.trigger("data", event);
        return;
      }
      match = /^#EXT-X-RENDITION-REPORT:(.*)$/.exec(newLine);
      if (match && match[1]) {
        event = {
          type: "tag",
          tagType: "rendition-report"
        };
        event.attributes = parseAttributes$1(match[1]);
        ["LAST-MSN", "LAST-PART"].forEach(function(key) {
          if (event.attributes.hasOwnProperty(key)) {
            event.attributes[key] = parseInt(event.attributes[key], 10);
          }
        });
        _this2.trigger("data", event);
        return;
      }
      _this2.trigger("data", {
        type: "tag",
        data: newLine.slice(4)
      });
    });
  };
  _proto.addParser = function addParser(_ref2) {
    var _this3 = this;
    var expression = _ref2.expression, customType = _ref2.customType, dataParser = _ref2.dataParser, segment = _ref2.segment;
    if (typeof dataParser !== "function") {
      dataParser = function dataParser2(line) {
        return line;
      };
    }
    this.customParsers.push(function(line) {
      var match = expression.exec(line);
      if (match) {
        _this3.trigger("data", {
          type: "custom",
          data: dataParser(line),
          customType,
          segment
        });
        return true;
      }
    });
  };
  _proto.addTagMapper = function addTagMapper(_ref2) {
    var expression = _ref2.expression, map = _ref2.map;
    var mapFn = function mapFn2(line) {
      if (expression.test(line)) {
        return map(line);
      }
      return line;
    };
    this.tagMappers.push(mapFn);
  };
  return ParseStream2;
}(Stream);
var camelCase = function camelCase2(str) {
  return str.toLowerCase().replace(/-(\w)/g, function(a) {
    return a[1].toUpperCase();
  });
};
var camelCaseKeys = function camelCaseKeys2(attributes) {
  var result2 = {};
  Object.keys(attributes).forEach(function(key) {
    result2[camelCase(key)] = attributes[key];
  });
  return result2;
};
var setHoldBack = function setHoldBack2(manifest) {
  var serverControl = manifest.serverControl, targetDuration = manifest.targetDuration, partTargetDuration = manifest.partTargetDuration;
  if (!serverControl) {
    return;
  }
  var tag = "#EXT-X-SERVER-CONTROL";
  var hb2 = "holdBack";
  var phb = "partHoldBack";
  var minTargetDuration = targetDuration && targetDuration * 3;
  var minPartDuration = partTargetDuration && partTargetDuration * 2;
  if (targetDuration && !serverControl.hasOwnProperty(hb2)) {
    serverControl[hb2] = minTargetDuration;
    this.trigger("info", {
      message: tag + " defaulting HOLD-BACK to targetDuration * 3 (" + minTargetDuration + ")."
    });
  }
  if (minTargetDuration && serverControl[hb2] < minTargetDuration) {
    this.trigger("warn", {
      message: tag + " clamping HOLD-BACK (" + serverControl[hb2] + ") to targetDuration * 3 (" + minTargetDuration + ")"
    });
    serverControl[hb2] = minTargetDuration;
  }
  if (partTargetDuration && !serverControl.hasOwnProperty(phb)) {
    serverControl[phb] = partTargetDuration * 3;
    this.trigger("info", {
      message: tag + " defaulting PART-HOLD-BACK to partTargetDuration * 3 (" + serverControl[phb] + ")."
    });
  }
  if (partTargetDuration && serverControl[phb] < minPartDuration) {
    this.trigger("warn", {
      message: tag + " clamping PART-HOLD-BACK (" + serverControl[phb] + ") to partTargetDuration * 2 (" + minPartDuration + ")."
    });
    serverControl[phb] = minPartDuration;
  }
};
var Parser = /* @__PURE__ */ function(_Stream) {
  _inheritsLoose(Parser2, _Stream);
  function Parser2() {
    var _this;
    _this = _Stream.call(this) || this;
    _this.lineStream = new LineStream();
    _this.parseStream = new ParseStream();
    _this.lineStream.pipe(_this.parseStream);
    var self2 = _assertThisInitialized(_this);
    var uris = [];
    var currentUri = {};
    var currentMap;
    var _key;
    var hasParts = false;
    var noop5 = function noop6() {
    };
    var defaultMediaGroups = {
      "AUDIO": {},
      "VIDEO": {},
      "CLOSED-CAPTIONS": {},
      "SUBTITLES": {}
    };
    var widevineUuid = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed";
    var currentTimeline = 0;
    _this.manifest = {
      allowCache: true,
      discontinuityStarts: [],
      segments: []
    };
    var lastByterangeEnd = 0;
    var lastPartByterangeEnd = 0;
    _this.on("end", function() {
      if (currentUri.uri || !currentUri.parts && !currentUri.preloadHints) {
        return;
      }
      if (!currentUri.map && currentMap) {
        currentUri.map = currentMap;
      }
      if (!currentUri.key && _key) {
        currentUri.key = _key;
      }
      if (!currentUri.timeline && typeof currentTimeline === "number") {
        currentUri.timeline = currentTimeline;
      }
      _this.manifest.preloadSegment = currentUri;
    });
    _this.parseStream.on("data", function(entry) {
      var mediaGroup;
      var rendition;
      ({
        tag: function tag() {
          ({
            version: function version2() {
              if (entry.version) {
                this.manifest.version = entry.version;
              }
            },
            "allow-cache": function allowCache() {
              this.manifest.allowCache = entry.allowed;
              if (!("allowed" in entry)) {
                this.trigger("info", {
                  message: "defaulting allowCache to YES"
                });
                this.manifest.allowCache = true;
              }
            },
            byterange: function byterange() {
              var byterange2 = {};
              if ("length" in entry) {
                currentUri.byterange = byterange2;
                byterange2.length = entry.length;
                if (!("offset" in entry)) {
                  entry.offset = lastByterangeEnd;
                }
              }
              if ("offset" in entry) {
                currentUri.byterange = byterange2;
                byterange2.offset = entry.offset;
              }
              lastByterangeEnd = byterange2.offset + byterange2.length;
            },
            endlist: function endlist() {
              this.manifest.endList = true;
            },
            inf: function inf() {
              if (!("mediaSequence" in this.manifest)) {
                this.manifest.mediaSequence = 0;
                this.trigger("info", {
                  message: "defaulting media sequence to zero"
                });
              }
              if (!("discontinuitySequence" in this.manifest)) {
                this.manifest.discontinuitySequence = 0;
                this.trigger("info", {
                  message: "defaulting discontinuity sequence to zero"
                });
              }
              if (entry.duration > 0) {
                currentUri.duration = entry.duration;
              }
              if (entry.duration === 0) {
                currentUri.duration = 0.01;
                this.trigger("info", {
                  message: "updating zero segment duration to a small value"
                });
              }
              this.manifest.segments = uris;
            },
            key: function key() {
              if (!entry.attributes) {
                this.trigger("warn", {
                  message: "ignoring key declaration without attribute list"
                });
                return;
              }
              if (entry.attributes.METHOD === "NONE") {
                _key = null;
                return;
              }
              if (!entry.attributes.URI) {
                this.trigger("warn", {
                  message: "ignoring key declaration without URI"
                });
                return;
              }
              if (entry.attributes.KEYFORMAT === "com.apple.streamingkeydelivery") {
                this.manifest.contentProtection = this.manifest.contentProtection || {};
                this.manifest.contentProtection["com.apple.fps.1_0"] = {
                  attributes: entry.attributes
                };
                return;
              }
              if (entry.attributes.KEYFORMAT === "com.microsoft.playready") {
                this.manifest.contentProtection = this.manifest.contentProtection || {};
                this.manifest.contentProtection["com.microsoft.playready"] = {
                  uri: entry.attributes.URI
                };
                return;
              }
              if (entry.attributes.KEYFORMAT === widevineUuid) {
                var VALID_METHODS = ["SAMPLE-AES", "SAMPLE-AES-CTR", "SAMPLE-AES-CENC"];
                if (VALID_METHODS.indexOf(entry.attributes.METHOD) === -1) {
                  this.trigger("warn", {
                    message: "invalid key method provided for Widevine"
                  });
                  return;
                }
                if (entry.attributes.METHOD === "SAMPLE-AES-CENC") {
                  this.trigger("warn", {
                    message: "SAMPLE-AES-CENC is deprecated, please use SAMPLE-AES-CTR instead"
                  });
                }
                if (entry.attributes.URI.substring(0, 23) !== "data:text/plain;base64,") {
                  this.trigger("warn", {
                    message: "invalid key URI provided for Widevine"
                  });
                  return;
                }
                if (!(entry.attributes.KEYID && entry.attributes.KEYID.substring(0, 2) === "0x")) {
                  this.trigger("warn", {
                    message: "invalid key ID provided for Widevine"
                  });
                  return;
                }
                this.manifest.contentProtection = this.manifest.contentProtection || {};
                this.manifest.contentProtection["com.widevine.alpha"] = {
                  attributes: {
                    schemeIdUri: entry.attributes.KEYFORMAT,
                    keyId: entry.attributes.KEYID.substring(2)
                  },
                  pssh: decodeB64ToUint8Array(entry.attributes.URI.split(",")[1])
                };
                return;
              }
              if (!entry.attributes.METHOD) {
                this.trigger("warn", {
                  message: "defaulting key method to AES-128"
                });
              }
              _key = {
                method: entry.attributes.METHOD || "AES-128",
                uri: entry.attributes.URI
              };
              if (typeof entry.attributes.IV !== "undefined") {
                _key.iv = entry.attributes.IV;
              }
            },
            "media-sequence": function mediaSequence() {
              if (!isFinite(entry.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid media sequence: " + entry.number
                });
                return;
              }
              this.manifest.mediaSequence = entry.number;
            },
            "discontinuity-sequence": function discontinuitySequence() {
              if (!isFinite(entry.number)) {
                this.trigger("warn", {
                  message: "ignoring invalid discontinuity sequence: " + entry.number
                });
                return;
              }
              this.manifest.discontinuitySequence = entry.number;
              currentTimeline = entry.number;
            },
            "playlist-type": function playlistType() {
              if (!/VOD|EVENT/.test(entry.playlistType)) {
                this.trigger("warn", {
                  message: "ignoring unknown playlist type: " + entry.playlist
                });
                return;
              }
              this.manifest.playlistType = entry.playlistType;
            },
            map: function map() {
              currentMap = {};
              if (entry.uri) {
                currentMap.uri = entry.uri;
              }
              if (entry.byterange) {
                currentMap.byterange = entry.byterange;
              }
              if (_key) {
                currentMap.key = _key;
              }
            },
            "stream-inf": function streamInf() {
              this.manifest.playlists = uris;
              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
              if (!entry.attributes) {
                this.trigger("warn", {
                  message: "ignoring empty stream-inf attributes"
                });
                return;
              }
              if (!currentUri.attributes) {
                currentUri.attributes = {};
              }
              _extends$2(currentUri.attributes, entry.attributes);
            },
            media: function media() {
              this.manifest.mediaGroups = this.manifest.mediaGroups || defaultMediaGroups;
              if (!(entry.attributes && entry.attributes.TYPE && entry.attributes["GROUP-ID"] && entry.attributes.NAME)) {
                this.trigger("warn", {
                  message: "ignoring incomplete or missing media group"
                });
                return;
              }
              var mediaGroupType = this.manifest.mediaGroups[entry.attributes.TYPE];
              mediaGroupType[entry.attributes["GROUP-ID"]] = mediaGroupType[entry.attributes["GROUP-ID"]] || {};
              mediaGroup = mediaGroupType[entry.attributes["GROUP-ID"]];
              rendition = {
                default: /yes/i.test(entry.attributes.DEFAULT)
              };
              if (rendition.default) {
                rendition.autoselect = true;
              } else {
                rendition.autoselect = /yes/i.test(entry.attributes.AUTOSELECT);
              }
              if (entry.attributes.LANGUAGE) {
                rendition.language = entry.attributes.LANGUAGE;
              }
              if (entry.attributes.URI) {
                rendition.uri = entry.attributes.URI;
              }
              if (entry.attributes["INSTREAM-ID"]) {
                rendition.instreamId = entry.attributes["INSTREAM-ID"];
              }
              if (entry.attributes.CHARACTERISTICS) {
                rendition.characteristics = entry.attributes.CHARACTERISTICS;
              }
              if (entry.attributes.FORCED) {
                rendition.forced = /yes/i.test(entry.attributes.FORCED);
              }
              mediaGroup[entry.attributes.NAME] = rendition;
            },
            discontinuity: function discontinuity() {
              currentTimeline += 1;
              currentUri.discontinuity = true;
              this.manifest.discontinuityStarts.push(uris.length);
            },
            "program-date-time": function programDateTime() {
              if (typeof this.manifest.dateTimeString === "undefined") {
                this.manifest.dateTimeString = entry.dateTimeString;
                this.manifest.dateTimeObject = entry.dateTimeObject;
              }
              currentUri.dateTimeString = entry.dateTimeString;
              currentUri.dateTimeObject = entry.dateTimeObject;
            },
            targetduration: function targetduration() {
              if (!isFinite(entry.duration) || entry.duration < 0) {
                this.trigger("warn", {
                  message: "ignoring invalid target duration: " + entry.duration
                });
                return;
              }
              this.manifest.targetDuration = entry.duration;
              setHoldBack.call(this, this.manifest);
            },
            start: function start2() {
              if (!entry.attributes || isNaN(entry.attributes["TIME-OFFSET"])) {
                this.trigger("warn", {
                  message: "ignoring start declaration without appropriate attribute list"
                });
                return;
              }
              this.manifest.start = {
                timeOffset: entry.attributes["TIME-OFFSET"],
                precise: entry.attributes.PRECISE
              };
            },
            "cue-out": function cueOut() {
              currentUri.cueOut = entry.data;
            },
            "cue-out-cont": function cueOutCont() {
              currentUri.cueOutCont = entry.data;
            },
            "cue-in": function cueIn() {
              currentUri.cueIn = entry.data;
            },
            "skip": function skip() {
              this.manifest.skip = camelCaseKeys(entry.attributes);
              this.warnOnMissingAttributes_("#EXT-X-SKIP", entry.attributes, ["SKIPPED-SEGMENTS"]);
            },
            "part": function part() {
              var _this2 = this;
              hasParts = true;
              var segmentIndex = this.manifest.segments.length;
              var part2 = camelCaseKeys(entry.attributes);
              currentUri.parts = currentUri.parts || [];
              currentUri.parts.push(part2);
              if (part2.byterange) {
                if (!part2.byterange.hasOwnProperty("offset")) {
                  part2.byterange.offset = lastPartByterangeEnd;
                }
                lastPartByterangeEnd = part2.byterange.offset + part2.byterange.length;
              }
              var partIndex = currentUri.parts.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PART #" + partIndex + " for segment #" + segmentIndex, entry.attributes, ["URI", "DURATION"]);
              if (this.manifest.renditionReports) {
                this.manifest.renditionReports.forEach(function(r2, i) {
                  if (!r2.hasOwnProperty("lastPart")) {
                    _this2.trigger("warn", {
                      message: "#EXT-X-RENDITION-REPORT #" + i + " lacks required attribute(s): LAST-PART"
                    });
                  }
                });
              }
            },
            "server-control": function serverControl() {
              var attrs = this.manifest.serverControl = camelCaseKeys(entry.attributes);
              if (!attrs.hasOwnProperty("canBlockReload")) {
                attrs.canBlockReload = false;
                this.trigger("info", {
                  message: "#EXT-X-SERVER-CONTROL defaulting CAN-BLOCK-RELOAD to false"
                });
              }
              setHoldBack.call(this, this.manifest);
              if (attrs.canSkipDateranges && !attrs.hasOwnProperty("canSkipUntil")) {
                this.trigger("warn", {
                  message: "#EXT-X-SERVER-CONTROL lacks required attribute CAN-SKIP-UNTIL which is required when CAN-SKIP-DATERANGES is set"
                });
              }
            },
            "preload-hint": function preloadHint() {
              var segmentIndex = this.manifest.segments.length;
              var hint = camelCaseKeys(entry.attributes);
              var isPart = hint.type && hint.type === "PART";
              currentUri.preloadHints = currentUri.preloadHints || [];
              currentUri.preloadHints.push(hint);
              if (hint.byterange) {
                if (!hint.byterange.hasOwnProperty("offset")) {
                  hint.byterange.offset = isPart ? lastPartByterangeEnd : 0;
                  if (isPart) {
                    lastPartByterangeEnd = hint.byterange.offset + hint.byterange.length;
                  }
                }
              }
              var index = currentUri.preloadHints.length - 1;
              this.warnOnMissingAttributes_("#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex, entry.attributes, ["TYPE", "URI"]);
              if (!hint.type) {
                return;
              }
              for (var i = 0; i < currentUri.preloadHints.length - 1; i++) {
                var otherHint = currentUri.preloadHints[i];
                if (!otherHint.type) {
                  continue;
                }
                if (otherHint.type === hint.type) {
                  this.trigger("warn", {
                    message: "#EXT-X-PRELOAD-HINT #" + index + " for segment #" + segmentIndex + " has the same TYPE " + hint.type + " as preload hint #" + i
                  });
                }
              }
            },
            "rendition-report": function renditionReport() {
              var report = camelCaseKeys(entry.attributes);
              this.manifest.renditionReports = this.manifest.renditionReports || [];
              this.manifest.renditionReports.push(report);
              var index = this.manifest.renditionReports.length - 1;
              var required = ["LAST-MSN", "URI"];
              if (hasParts) {
                required.push("LAST-PART");
              }
              this.warnOnMissingAttributes_("#EXT-X-RENDITION-REPORT #" + index, entry.attributes, required);
            },
            "part-inf": function partInf() {
              this.manifest.partInf = camelCaseKeys(entry.attributes);
              this.warnOnMissingAttributes_("#EXT-X-PART-INF", entry.attributes, ["PART-TARGET"]);
              if (this.manifest.partInf.partTarget) {
                this.manifest.partTargetDuration = this.manifest.partInf.partTarget;
              }
              setHoldBack.call(this, this.manifest);
            }
          }[entry.tagType] || noop5).call(self2);
        },
        uri: function uri() {
          currentUri.uri = entry.uri;
          uris.push(currentUri);
          if (this.manifest.targetDuration && !("duration" in currentUri)) {
            this.trigger("warn", {
              message: "defaulting segment duration to the target duration"
            });
            currentUri.duration = this.manifest.targetDuration;
          }
          if (_key) {
            currentUri.key = _key;
          }
          currentUri.timeline = currentTimeline;
          if (currentMap) {
            currentUri.map = currentMap;
          }
          lastPartByterangeEnd = 0;
          currentUri = {};
        },
        comment: function comment() {
        },
        custom: function custom() {
          if (entry.segment) {
            currentUri.custom = currentUri.custom || {};
            currentUri.custom[entry.customType] = entry.data;
          } else {
            this.manifest.custom = this.manifest.custom || {};
            this.manifest.custom[entry.customType] = entry.data;
          }
        }
      })[entry.type].call(self2);
    });
    return _this;
  }
  var _proto = Parser2.prototype;
  _proto.warnOnMissingAttributes_ = function warnOnMissingAttributes_(identifier, attributes, required) {
    var missing = [];
    required.forEach(function(key) {
      if (!attributes.hasOwnProperty(key)) {
        missing.push(key);
      }
    });
    if (missing.length) {
      this.trigger("warn", {
        message: identifier + " lacks required attribute(s): " + missing.join(", ")
      });
    }
  };
  _proto.push = function push(chunk) {
    this.lineStream.push(chunk);
  };
  _proto.end = function end3() {
    this.lineStream.push("\n");
    this.trigger("end");
  };
  _proto.addParser = function addParser(options) {
    this.parseStream.addParser(options);
  };
  _proto.addTagMapper = function addTagMapper(options) {
    this.parseStream.addTagMapper(options);
  };
  return Parser2;
}(Stream);
var regexs = {
  mp4: /^(av0?1|avc0?[1234]|vp0?9|flac|opus|mp3|mp4a|mp4v|stpp.ttml.im1t)/,
  webm: /^(vp0?[89]|av0?1|opus|vorbis)/,
  ogg: /^(vp0?[89]|theora|flac|opus|vorbis)/,
  video: /^(av0?1|avc0?[1234]|vp0?[89]|hvc1|hev1|theora|mp4v)/,
  audio: /^(mp4a|flac|vorbis|opus|ac-[34]|ec-3|alac|mp3|speex|aac)/,
  text: /^(stpp.ttml.im1t)/,
  muxerVideo: /^(avc0?1)/,
  muxerAudio: /^(mp4a)/,
  muxerText: /a^/
};
var mediaTypes = ["video", "audio", "text"];
var upperMediaTypes = ["Video", "Audio", "Text"];
var translateLegacyCodec = function translateLegacyCodec2(codec) {
  if (!codec) {
    return codec;
  }
  return codec.replace(/avc1\.(\d+)\.(\d+)/i, function(orig, profile, avcLevel) {
    var profileHex = ("00" + Number(profile).toString(16)).slice(-2);
    var avcLevelHex = ("00" + Number(avcLevel).toString(16)).slice(-2);
    return "avc1." + profileHex + "00" + avcLevelHex;
  });
};
var parseCodecs = function parseCodecs2(codecString) {
  if (codecString === void 0) {
    codecString = "";
  }
  var codecs = codecString.split(",");
  var result2 = [];
  codecs.forEach(function(codec) {
    codec = codec.trim();
    var codecType;
    mediaTypes.forEach(function(name) {
      var match = regexs[name].exec(codec.toLowerCase());
      if (!match || match.length <= 1) {
        return;
      }
      codecType = name;
      var type2 = codec.substring(0, match[1].length);
      var details = codec.replace(type2, "");
      result2.push({
        type: type2,
        details,
        mediaType: name
      });
    });
    if (!codecType) {
      result2.push({
        type: codec,
        details: "",
        mediaType: "unknown"
      });
    }
  });
  return result2;
};
var codecsFromDefault = function codecsFromDefault2(master, audioGroupId) {
  if (!master.mediaGroups.AUDIO || !audioGroupId) {
    return null;
  }
  var audioGroup = master.mediaGroups.AUDIO[audioGroupId];
  if (!audioGroup) {
    return null;
  }
  for (var name in audioGroup) {
    var audioType = audioGroup[name];
    if (audioType.default && audioType.playlists) {
      return parseCodecs(audioType.playlists[0].attributes.CODECS);
    }
  }
  return null;
};
var isAudioCodec = function isAudioCodec2(codec) {
  if (codec === void 0) {
    codec = "";
  }
  return regexs.audio.test(codec.trim().toLowerCase());
};
var isTextCodec = function isTextCodec2(codec) {
  if (codec === void 0) {
    codec = "";
  }
  return regexs.text.test(codec.trim().toLowerCase());
};
var getMimeForCodec = function getMimeForCodec2(codecString) {
  if (!codecString || typeof codecString !== "string") {
    return;
  }
  var codecs = codecString.toLowerCase().split(",").map(function(c) {
    return translateLegacyCodec(c.trim());
  });
  var type2 = "video";
  if (codecs.length === 1 && isAudioCodec(codecs[0])) {
    type2 = "audio";
  } else if (codecs.length === 1 && isTextCodec(codecs[0])) {
    type2 = "application";
  }
  var container2 = "mp4";
  if (codecs.every(function(c) {
    return regexs.mp4.test(c);
  })) {
    container2 = "mp4";
  } else if (codecs.every(function(c) {
    return regexs.webm.test(c);
  })) {
    container2 = "webm";
  } else if (codecs.every(function(c) {
    return regexs.ogg.test(c);
  })) {
    container2 = "ogg";
  }
  return type2 + "/" + container2 + ';codecs="' + codecString + '"';
};
var browserSupportsCodec = function browserSupportsCodec2(codecString) {
  if (codecString === void 0) {
    codecString = "";
  }
  return window_1.MediaSource && window_1.MediaSource.isTypeSupported && window_1.MediaSource.isTypeSupported(getMimeForCodec(codecString)) || false;
};
var muxerSupportsCodec = function muxerSupportsCodec2(codecString) {
  if (codecString === void 0) {
    codecString = "";
  }
  return codecString.toLowerCase().split(",").every(function(codec) {
    codec = codec.trim();
    for (var i = 0; i < upperMediaTypes.length; i++) {
      var type2 = upperMediaTypes[i];
      if (regexs["muxer" + type2].test(codec)) {
        return true;
      }
    }
    return false;
  });
};
var DEFAULT_AUDIO_CODEC = "mp4a.40.2";
var DEFAULT_VIDEO_CODEC = "avc1.4d400d";
var MPEGURL_REGEX = /^(audio|video|application)\/(x-|vnd\.apple\.)?mpegurl/i;
var DASH_REGEX = /^application\/dash\+xml/i;
var simpleTypeFromSourceType = function simpleTypeFromSourceType2(type2) {
  if (MPEGURL_REGEX.test(type2)) {
    return "hls";
  }
  if (DASH_REGEX.test(type2)) {
    return "dash";
  }
  if (type2 === "application/vnd.videojs.vhs+json") {
    return "vhs-json";
  }
  return null;
};
var countBits = function countBits2(x) {
  return x.toString(2).length;
};
var countBytes = function countBytes2(x) {
  return Math.ceil(countBits(x) / 8);
};
var isArrayBufferView = function isArrayBufferView2(obj) {
  if (ArrayBuffer.isView === "function") {
    return ArrayBuffer.isView(obj);
  }
  return obj && obj.buffer instanceof ArrayBuffer;
};
var isTypedArray = function isTypedArray2(obj) {
  return isArrayBufferView(obj);
};
var toUint8 = function toUint82(bytes) {
  if (bytes instanceof Uint8Array) {
    return bytes;
  }
  if (!Array.isArray(bytes) && !isTypedArray(bytes) && !(bytes instanceof ArrayBuffer)) {
    if (typeof bytes !== "number" || typeof bytes === "number" && bytes !== bytes) {
      bytes = 0;
    } else {
      bytes = [bytes];
    }
  }
  return new Uint8Array(bytes && bytes.buffer || bytes, bytes && bytes.byteOffset || 0, bytes && bytes.byteLength || 0);
};
var BigInt = window_1.BigInt || Number;
var BYTE_TABLE = [BigInt("0x1"), BigInt("0x100"), BigInt("0x10000"), BigInt("0x1000000"), BigInt("0x100000000"), BigInt("0x10000000000"), BigInt("0x1000000000000"), BigInt("0x100000000000000"), BigInt("0x10000000000000000")];
(function() {
  var a = new Uint16Array([65484]);
  var b = new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
  if (b[0] === 255) {
    return "big";
  }
  if (b[0] === 204) {
    return "little";
  }
  return "unknown";
})();
var bytesToNumber = function bytesToNumber2(bytes, _temp) {
  var _ref2 = _temp === void 0 ? {} : _temp, _ref$signed = _ref2.signed, signed = _ref$signed === void 0 ? false : _ref$signed, _ref$le = _ref2.le, le2 = _ref$le === void 0 ? false : _ref$le;
  bytes = toUint8(bytes);
  var fn = le2 ? "reduce" : "reduceRight";
  var obj = bytes[fn] ? bytes[fn] : Array.prototype[fn];
  var number = obj.call(bytes, function(total, byte, i) {
    var exponent = le2 ? i : Math.abs(i + 1 - bytes.length);
    return total + BigInt(byte) * BYTE_TABLE[exponent];
  }, BigInt(0));
  if (signed) {
    var max = BYTE_TABLE[bytes.length] / BigInt(2) - BigInt(1);
    number = BigInt(number);
    if (number > max) {
      number -= max;
      number -= max;
      number -= BigInt(2);
    }
  }
  return Number(number);
};
var numberToBytes = function numberToBytes2(number, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$le = _ref2.le, le2 = _ref2$le === void 0 ? false : _ref2$le;
  if (typeof number !== "bigint" && typeof number !== "number" || typeof number === "number" && number !== number) {
    number = 0;
  }
  number = BigInt(number);
  var byteCount = countBytes(number);
  var bytes = new Uint8Array(new ArrayBuffer(byteCount));
  for (var i = 0; i < byteCount; i++) {
    var byteIndex = le2 ? i : Math.abs(i + 1 - bytes.length);
    bytes[byteIndex] = Number(number / BYTE_TABLE[i] & BigInt(255));
    if (number < 0) {
      bytes[byteIndex] = Math.abs(~bytes[byteIndex]);
      bytes[byteIndex] -= i === 0 ? 1 : 2;
    }
  }
  return bytes;
};
var stringToBytes = function stringToBytes2(string2, stringIsBytes) {
  if (typeof string2 !== "string" && string2 && typeof string2.toString === "function") {
    string2 = string2.toString();
  }
  if (typeof string2 !== "string") {
    return new Uint8Array();
  }
  if (!stringIsBytes) {
    string2 = unescape(encodeURIComponent(string2));
  }
  var view = new Uint8Array(string2.length);
  for (var i = 0; i < string2.length; i++) {
    view[i] = string2.charCodeAt(i);
  }
  return view;
};
var concatTypedArrays = function concatTypedArrays2() {
  for (var _len = arguments.length, buffers = new Array(_len), _key = 0; _key < _len; _key++) {
    buffers[_key] = arguments[_key];
  }
  buffers = buffers.filter(function(b) {
    return b && (b.byteLength || b.length) && typeof b !== "string";
  });
  if (buffers.length <= 1) {
    return toUint8(buffers[0]);
  }
  var totalLen = buffers.reduce(function(total, buf, i) {
    return total + (buf.byteLength || buf.length);
  }, 0);
  var tempBuffer = new Uint8Array(totalLen);
  var offset2 = 0;
  buffers.forEach(function(buf) {
    buf = toUint8(buf);
    tempBuffer.set(buf, offset2);
    offset2 += buf.byteLength;
  });
  return tempBuffer;
};
var bytesMatch = function bytesMatch2(a, b, _temp3) {
  var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$offset = _ref3.offset, offset2 = _ref3$offset === void 0 ? 0 : _ref3$offset, _ref3$mask = _ref3.mask, mask = _ref3$mask === void 0 ? [] : _ref3$mask;
  a = toUint8(a);
  b = toUint8(b);
  var fn = b.every ? b.every : Array.prototype.every;
  return b.length && a.length - offset2 >= b.length && fn.call(b, function(bByte, i) {
    var aByte = mask[i] ? mask[i] & a[offset2 + i] : a[offset2 + i];
    return bByte === aByte;
  });
};
var forEachMediaGroup$1 = function forEachMediaGroup(master, groups, callback2) {
  groups.forEach(function(mediaType) {
    for (var groupKey in master.mediaGroups[mediaType]) {
      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
        callback2(mediaProperties, mediaType, groupKey, labelKey);
      }
    }
  });
};
var dom$2 = {};
var conventions$2 = {};
function find$1(list, predicate, ac2) {
  if (ac2 === void 0) {
    ac2 = Array.prototype;
  }
  if (list && typeof ac2.find === "function") {
    return ac2.find.call(list, predicate);
  }
  for (var i = 0; i < list.length; i++) {
    if (Object.prototype.hasOwnProperty.call(list, i)) {
      var item = list[i];
      if (predicate.call(void 0, item, i, list)) {
        return item;
      }
    }
  }
}
function freeze(object, oc2) {
  if (oc2 === void 0) {
    oc2 = Object;
  }
  return oc2 && typeof oc2.freeze === "function" ? oc2.freeze(object) : object;
}
function assign$1(target, source) {
  if (target === null || typeof target !== "object") {
    throw new TypeError("target is not an object");
  }
  for (var key in source) {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      target[key] = source[key];
    }
  }
  return target;
}
var MIME_TYPE = freeze({
  HTML: "text/html",
  isHTML: function(value) {
    return value === MIME_TYPE.HTML;
  },
  XML_APPLICATION: "application/xml",
  XML_TEXT: "text/xml",
  XML_XHTML_APPLICATION: "application/xhtml+xml",
  XML_SVG_IMAGE: "image/svg+xml"
});
var NAMESPACE$3 = freeze({
  HTML: "http://www.w3.org/1999/xhtml",
  isHTML: function(uri) {
    return uri === NAMESPACE$3.HTML;
  },
  SVG: "http://www.w3.org/2000/svg",
  XML: "http://www.w3.org/XML/1998/namespace",
  XMLNS: "http://www.w3.org/2000/xmlns/"
});
conventions$2.assign = assign$1;
conventions$2.find = find$1;
conventions$2.freeze = freeze;
conventions$2.MIME_TYPE = MIME_TYPE;
conventions$2.NAMESPACE = NAMESPACE$3;
var conventions$1 = conventions$2;
var find = conventions$1.find;
var NAMESPACE$2 = conventions$1.NAMESPACE;
function notEmptyString(input) {
  return input !== "";
}
function splitOnASCIIWhitespace(input) {
  return input ? input.split(/[\t\n\f\r ]+/).filter(notEmptyString) : [];
}
function orderedSetReducer(current, element) {
  if (!current.hasOwnProperty(element)) {
    current[element] = true;
  }
  return current;
}
function toOrderedSet(input) {
  if (!input)
    return [];
  var list = splitOnASCIIWhitespace(input);
  return Object.keys(list.reduce(orderedSetReducer, {}));
}
function arrayIncludes(list) {
  return function(element) {
    return list && list.indexOf(element) !== -1;
  };
}
function copy(src, dest) {
  for (var p2 in src) {
    if (Object.prototype.hasOwnProperty.call(src, p2)) {
      dest[p2] = src[p2];
    }
  }
}
function _extends(Class, Super) {
  var pt = Class.prototype;
  if (!(pt instanceof Super)) {
    let t3 = function() {
    };
    t3.prototype = Super.prototype;
    t3 = new t3();
    copy(pt, t3);
    Class.prototype = pt = t3;
  }
  if (pt.constructor != Class) {
    if (typeof Class != "function") {
      console.error("unknown Class:" + Class);
    }
    pt.constructor = Class;
  }
}
var NodeType = {};
var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
var TEXT_NODE = NodeType.TEXT_NODE = 3;
var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
var NOTATION_NODE = NodeType.NOTATION_NODE = 12;
var ExceptionCode = {};
var ExceptionMessage = {};
ExceptionCode.INDEX_SIZE_ERR = (ExceptionMessage[1] = "Index size error", 1);
ExceptionCode.DOMSTRING_SIZE_ERR = (ExceptionMessage[2] = "DOMString size error", 2);
var HIERARCHY_REQUEST_ERR = ExceptionCode.HIERARCHY_REQUEST_ERR = (ExceptionMessage[3] = "Hierarchy request error", 3);
ExceptionCode.WRONG_DOCUMENT_ERR = (ExceptionMessage[4] = "Wrong document", 4);
ExceptionCode.INVALID_CHARACTER_ERR = (ExceptionMessage[5] = "Invalid character", 5);
ExceptionCode.NO_DATA_ALLOWED_ERR = (ExceptionMessage[6] = "No data allowed", 6);
ExceptionCode.NO_MODIFICATION_ALLOWED_ERR = (ExceptionMessage[7] = "No modification allowed", 7);
var NOT_FOUND_ERR = ExceptionCode.NOT_FOUND_ERR = (ExceptionMessage[8] = "Not found", 8);
ExceptionCode.NOT_SUPPORTED_ERR = (ExceptionMessage[9] = "Not supported", 9);
var INUSE_ATTRIBUTE_ERR = ExceptionCode.INUSE_ATTRIBUTE_ERR = (ExceptionMessage[10] = "Attribute in use", 10);
ExceptionCode.INVALID_STATE_ERR = (ExceptionMessage[11] = "Invalid state", 11);
ExceptionCode.SYNTAX_ERR = (ExceptionMessage[12] = "Syntax error", 12);
ExceptionCode.INVALID_MODIFICATION_ERR = (ExceptionMessage[13] = "Invalid modification", 13);
ExceptionCode.NAMESPACE_ERR = (ExceptionMessage[14] = "Invalid namespace", 14);
ExceptionCode.INVALID_ACCESS_ERR = (ExceptionMessage[15] = "Invalid access", 15);
function DOMException(code, message) {
  if (message instanceof Error) {
    var error2 = message;
  } else {
    error2 = this;
    Error.call(this, ExceptionMessage[code]);
    this.message = ExceptionMessage[code];
    if (Error.captureStackTrace)
      Error.captureStackTrace(this, DOMException);
  }
  error2.code = code;
  if (message)
    this.message = this.message + ": " + message;
  return error2;
}
DOMException.prototype = Error.prototype;
copy(ExceptionCode, DOMException);
function NodeList$1() {
}
NodeList$1.prototype = {
  length: 0,
  item: function(index) {
    return index >= 0 && index < this.length ? this[index] : null;
  },
  toString: function(isHTML, nodeFilter) {
    for (var buf = [], i = 0; i < this.length; i++) {
      serializeToString(this[i], buf, isHTML, nodeFilter);
    }
    return buf.join("");
  },
  filter: function(predicate) {
    return Array.prototype.filter.call(this, predicate);
  },
  indexOf: function(item) {
    return Array.prototype.indexOf.call(this, item);
  }
};
function LiveNodeList(node, refresh) {
  this._node = node;
  this._refresh = refresh;
  _updateLiveList(this);
}
function _updateLiveList(list) {
  var inc = list._node._inc || list._node.ownerDocument._inc;
  if (list._inc !== inc) {
    var ls = list._refresh(list._node);
    __set__(list, "length", ls.length);
    if (!list.$$length || ls.length < list.$$length) {
      for (var i = ls.length; i in list; i++) {
        if (Object.prototype.hasOwnProperty.call(list, i)) {
          delete list[i];
        }
      }
    }
    copy(ls, list);
    list._inc = inc;
  }
}
LiveNodeList.prototype.item = function(i) {
  _updateLiveList(this);
  return this[i] || null;
};
_extends(LiveNodeList, NodeList$1);
function NamedNodeMap() {
}
function _findNodeIndex(list, node) {
  var i = list.length;
  while (i--) {
    if (list[i] === node) {
      return i;
    }
  }
}
function _addNamedNode(el, list, newAttr, oldAttr) {
  if (oldAttr) {
    list[_findNodeIndex(list, oldAttr)] = newAttr;
  } else {
    list[list.length++] = newAttr;
  }
  if (el) {
    newAttr.ownerElement = el;
    var doc = el.ownerDocument;
    if (doc) {
      oldAttr && _onRemoveAttribute(doc, el, oldAttr);
      _onAddAttribute(doc, el, newAttr);
    }
  }
}
function _removeNamedNode(el, list, attr) {
  var i = _findNodeIndex(list, attr);
  if (i >= 0) {
    var lastIndex = list.length - 1;
    while (i < lastIndex) {
      list[i] = list[++i];
    }
    list.length = lastIndex;
    if (el) {
      var doc = el.ownerDocument;
      if (doc) {
        _onRemoveAttribute(doc, el, attr);
        attr.ownerElement = null;
      }
    }
  } else {
    throw new DOMException(NOT_FOUND_ERR, new Error(el.tagName + "@" + attr));
  }
}
NamedNodeMap.prototype = {
  length: 0,
  item: NodeList$1.prototype.item,
  getNamedItem: function(key) {
    var i = this.length;
    while (i--) {
      var attr = this[i];
      if (attr.nodeName == key) {
        return attr;
      }
    }
  },
  setNamedItem: function(attr) {
    var el = attr.ownerElement;
    if (el && el != this._ownerElement) {
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    }
    var oldAttr = this.getNamedItem(attr.nodeName);
    _addNamedNode(this._ownerElement, this, attr, oldAttr);
    return oldAttr;
  },
  setNamedItemNS: function(attr) {
    var el = attr.ownerElement, oldAttr;
    if (el && el != this._ownerElement) {
      throw new DOMException(INUSE_ATTRIBUTE_ERR);
    }
    oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
    _addNamedNode(this._ownerElement, this, attr, oldAttr);
    return oldAttr;
  },
  removeNamedItem: function(key) {
    var attr = this.getNamedItem(key);
    _removeNamedNode(this._ownerElement, this, attr);
    return attr;
  },
  removeNamedItemNS: function(namespaceURI, localName) {
    var attr = this.getNamedItemNS(namespaceURI, localName);
    _removeNamedNode(this._ownerElement, this, attr);
    return attr;
  },
  getNamedItemNS: function(namespaceURI, localName) {
    var i = this.length;
    while (i--) {
      var node = this[i];
      if (node.localName == localName && node.namespaceURI == namespaceURI) {
        return node;
      }
    }
    return null;
  }
};
function DOMImplementation$1() {
}
DOMImplementation$1.prototype = {
  hasFeature: function(feature, version2) {
    return true;
  },
  createDocument: function(namespaceURI, qualifiedName, doctype) {
    var doc = new Document();
    doc.implementation = this;
    doc.childNodes = new NodeList$1();
    doc.doctype = doctype || null;
    if (doctype) {
      doc.appendChild(doctype);
    }
    if (qualifiedName) {
      var root = doc.createElementNS(namespaceURI, qualifiedName);
      doc.appendChild(root);
    }
    return doc;
  },
  createDocumentType: function(qualifiedName, publicId, systemId) {
    var node = new DocumentType();
    node.name = qualifiedName;
    node.nodeName = qualifiedName;
    node.publicId = publicId || "";
    node.systemId = systemId || "";
    return node;
  }
};
function Node$1() {
}
Node$1.prototype = {
  firstChild: null,
  lastChild: null,
  previousSibling: null,
  nextSibling: null,
  attributes: null,
  parentNode: null,
  childNodes: null,
  ownerDocument: null,
  nodeValue: null,
  namespaceURI: null,
  prefix: null,
  localName: null,
  insertBefore: function(newChild, refChild) {
    return _insertBefore(this, newChild, refChild);
  },
  replaceChild: function(newChild, oldChild) {
    _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
    if (oldChild) {
      this.removeChild(oldChild);
    }
  },
  removeChild: function(oldChild) {
    return _removeChild(this, oldChild);
  },
  appendChild: function(newChild) {
    return this.insertBefore(newChild, null);
  },
  hasChildNodes: function() {
    return this.firstChild != null;
  },
  cloneNode: function(deep) {
    return cloneNode(this.ownerDocument || this, this, deep);
  },
  normalize: function() {
    var child = this.firstChild;
    while (child) {
      var next = child.nextSibling;
      if (next && next.nodeType == TEXT_NODE && child.nodeType == TEXT_NODE) {
        this.removeChild(next);
        child.appendData(next.data);
      } else {
        child.normalize();
        child = next;
      }
    }
  },
  isSupported: function(feature, version2) {
    return this.ownerDocument.implementation.hasFeature(feature, version2);
  },
  hasAttributes: function() {
    return this.attributes.length > 0;
  },
  lookupPrefix: function(namespaceURI) {
    var el = this;
    while (el) {
      var map = el._nsMap;
      if (map) {
        for (var n2 in map) {
          if (Object.prototype.hasOwnProperty.call(map, n2) && map[n2] === namespaceURI) {
            return n2;
          }
        }
      }
      el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
    }
    return null;
  },
  lookupNamespaceURI: function(prefix) {
    var el = this;
    while (el) {
      var map = el._nsMap;
      if (map) {
        if (Object.prototype.hasOwnProperty.call(map, prefix)) {
          return map[prefix];
        }
      }
      el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
    }
    return null;
  },
  isDefaultNamespace: function(namespaceURI) {
    var prefix = this.lookupPrefix(namespaceURI);
    return prefix == null;
  }
};
function _xmlEncoder(c) {
  return c == "<" && "&lt;" || c == ">" && "&gt;" || c == "&" && "&amp;" || c == '"' && "&quot;" || "&#" + c.charCodeAt() + ";";
}
copy(NodeType, Node$1);
copy(NodeType, Node$1.prototype);
function _visitNode(node, callback2) {
  if (callback2(node)) {
    return true;
  }
  if (node = node.firstChild) {
    do {
      if (_visitNode(node, callback2)) {
        return true;
      }
    } while (node = node.nextSibling);
  }
}
function Document() {
  this.ownerDocument = this;
}
function _onAddAttribute(doc, el, newAttr) {
  doc && doc._inc++;
  var ns = newAttr.namespaceURI;
  if (ns === NAMESPACE$2.XMLNS) {
    el._nsMap[newAttr.prefix ? newAttr.localName : ""] = newAttr.value;
  }
}
function _onRemoveAttribute(doc, el, newAttr, remove3) {
  doc && doc._inc++;
  var ns = newAttr.namespaceURI;
  if (ns === NAMESPACE$2.XMLNS) {
    delete el._nsMap[newAttr.prefix ? newAttr.localName : ""];
  }
}
function _onUpdateChild(doc, el, newChild) {
  if (doc && doc._inc) {
    doc._inc++;
    var cs = el.childNodes;
    if (newChild) {
      cs[cs.length++] = newChild;
    } else {
      var child = el.firstChild;
      var i = 0;
      while (child) {
        cs[i++] = child;
        child = child.nextSibling;
      }
      cs.length = i;
      delete cs[cs.length];
    }
  }
}
function _removeChild(parentNode, child) {
  var previous = child.previousSibling;
  var next = child.nextSibling;
  if (previous) {
    previous.nextSibling = next;
  } else {
    parentNode.firstChild = next;
  }
  if (next) {
    next.previousSibling = previous;
  } else {
    parentNode.lastChild = previous;
  }
  child.parentNode = null;
  child.previousSibling = null;
  child.nextSibling = null;
  _onUpdateChild(parentNode.ownerDocument, parentNode);
  return child;
}
function hasValidParentNodeType(node) {
  return node && (node.nodeType === Node$1.DOCUMENT_NODE || node.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node$1.ELEMENT_NODE);
}
function hasInsertableNodeType(node) {
  return node && (isElementNode(node) || isTextNode$1(node) || isDocTypeNode(node) || node.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE || node.nodeType === Node$1.COMMENT_NODE || node.nodeType === Node$1.PROCESSING_INSTRUCTION_NODE);
}
function isDocTypeNode(node) {
  return node && node.nodeType === Node$1.DOCUMENT_TYPE_NODE;
}
function isElementNode(node) {
  return node && node.nodeType === Node$1.ELEMENT_NODE;
}
function isTextNode$1(node) {
  return node && node.nodeType === Node$1.TEXT_NODE;
}
function isElementInsertionPossible(doc, child) {
  var parentChildNodes = doc.childNodes || [];
  if (find(parentChildNodes, isElementNode) || isDocTypeNode(child)) {
    return false;
  }
  var docTypeNode = find(parentChildNodes, isDocTypeNode);
  return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
function isElementReplacementPossible(doc, child) {
  var parentChildNodes = doc.childNodes || [];
  function hasElementChildThatIsNotChild(node) {
    return isElementNode(node) && node !== child;
  }
  if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
    return false;
  }
  var docTypeNode = find(parentChildNodes, isDocTypeNode);
  return !(child && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child));
}
function assertPreInsertionValidity1to5(parent, node, child) {
  if (!hasValidParentNodeType(parent)) {
    throw new DOMException(HIERARCHY_REQUEST_ERR, "Unexpected parent node type " + parent.nodeType);
  }
  if (child && child.parentNode !== parent) {
    throw new DOMException(NOT_FOUND_ERR, "child not in parent");
  }
  if (!hasInsertableNodeType(node) || isDocTypeNode(node) && parent.nodeType !== Node$1.DOCUMENT_NODE) {
    throw new DOMException(HIERARCHY_REQUEST_ERR, "Unexpected node type " + node.nodeType + " for parent node type " + parent.nodeType);
  }
}
function assertPreInsertionValidityInDocument(parent, node, child) {
  var parentChildNodes = parent.childNodes || [];
  var nodeChildNodes = node.childNodes || [];
  if (node.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE) {
    var nodeChildElements = nodeChildNodes.filter(isElementNode);
    if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode$1)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
    }
    if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
  }
  if (isElementNode(node)) {
    if (!isElementInsertionPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
  }
  if (isDocTypeNode(node)) {
    if (find(parentChildNodes, isDocTypeNode)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
    }
    var parentElementChild = find(parentChildNodes, isElementNode);
    if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
    }
    if (!child && parentElementChild) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can not be appended since element is present");
    }
  }
}
function assertPreReplacementValidityInDocument(parent, node, child) {
  var parentChildNodes = parent.childNodes || [];
  var nodeChildNodes = node.childNodes || [];
  if (node.nodeType === Node$1.DOCUMENT_FRAGMENT_NODE) {
    var nodeChildElements = nodeChildNodes.filter(isElementNode);
    if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode$1)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
    }
    if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
    }
  }
  if (isElementNode(node)) {
    if (!isElementReplacementPossible(parent, child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
    }
  }
  if (isDocTypeNode(node)) {
    let hasDoctypeChildThatIsNotChild = function(node2) {
      return isDocTypeNode(node2) && node2 !== child;
    };
    if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
    }
    var parentElementChild = find(parentChildNodes, isElementNode);
    if (child && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child)) {
      throw new DOMException(HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
    }
  }
}
function _insertBefore(parent, node, child, _inDocumentAssertion) {
  assertPreInsertionValidity1to5(parent, node, child);
  if (parent.nodeType === Node$1.DOCUMENT_NODE) {
    (_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent, node, child);
  }
  var cp = node.parentNode;
  if (cp) {
    cp.removeChild(node);
  }
  if (node.nodeType === DOCUMENT_FRAGMENT_NODE) {
    var newFirst = node.firstChild;
    if (newFirst == null) {
      return node;
    }
    var newLast = node.lastChild;
  } else {
    newFirst = newLast = node;
  }
  var pre = child ? child.previousSibling : parent.lastChild;
  newFirst.previousSibling = pre;
  newLast.nextSibling = child;
  if (pre) {
    pre.nextSibling = newFirst;
  } else {
    parent.firstChild = newFirst;
  }
  if (child == null) {
    parent.lastChild = newLast;
  } else {
    child.previousSibling = newLast;
  }
  do {
    newFirst.parentNode = parent;
  } while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
  _onUpdateChild(parent.ownerDocument || parent, parent);
  if (node.nodeType == DOCUMENT_FRAGMENT_NODE) {
    node.firstChild = node.lastChild = null;
  }
  return node;
}
function _appendSingleChild(parentNode, newChild) {
  if (newChild.parentNode) {
    newChild.parentNode.removeChild(newChild);
  }
  newChild.parentNode = parentNode;
  newChild.previousSibling = parentNode.lastChild;
  newChild.nextSibling = null;
  if (newChild.previousSibling) {
    newChild.previousSibling.nextSibling = newChild;
  } else {
    parentNode.firstChild = newChild;
  }
  parentNode.lastChild = newChild;
  _onUpdateChild(parentNode.ownerDocument, parentNode, newChild);
  return newChild;
}
Document.prototype = {
  nodeName: "#document",
  nodeType: DOCUMENT_NODE,
  doctype: null,
  documentElement: null,
  _inc: 1,
  insertBefore: function(newChild, refChild) {
    if (newChild.nodeType == DOCUMENT_FRAGMENT_NODE) {
      var child = newChild.firstChild;
      while (child) {
        var next = child.nextSibling;
        this.insertBefore(child, refChild);
        child = next;
      }
      return newChild;
    }
    _insertBefore(this, newChild, refChild);
    newChild.ownerDocument = this;
    if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
      this.documentElement = newChild;
    }
    return newChild;
  },
  removeChild: function(oldChild) {
    if (this.documentElement == oldChild) {
      this.documentElement = null;
    }
    return _removeChild(this, oldChild);
  },
  replaceChild: function(newChild, oldChild) {
    _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
    newChild.ownerDocument = this;
    if (oldChild) {
      this.removeChild(oldChild);
    }
    if (isElementNode(newChild)) {
      this.documentElement = newChild;
    }
  },
  importNode: function(importedNode, deep) {
    return importNode(this, importedNode, deep);
  },
  getElementById: function(id2) {
    var rtv = null;
    _visitNode(this.documentElement, function(node) {
      if (node.nodeType == ELEMENT_NODE) {
        if (node.getAttribute("id") == id2) {
          rtv = node;
          return true;
        }
      }
    });
    return rtv;
  },
  getElementsByClassName: function(classNames) {
    var classNamesSet = toOrderedSet(classNames);
    return new LiveNodeList(this, function(base) {
      var ls = [];
      if (classNamesSet.length > 0) {
        _visitNode(base.documentElement, function(node) {
          if (node !== base && node.nodeType === ELEMENT_NODE) {
            var nodeClassNames = node.getAttribute("class");
            if (nodeClassNames) {
              var matches = classNames === nodeClassNames;
              if (!matches) {
                var nodeClassNamesSet = toOrderedSet(nodeClassNames);
                matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet));
              }
              if (matches) {
                ls.push(node);
              }
            }
          }
        });
      }
      return ls;
    });
  },
  createElement: function(tagName) {
    var node = new Element();
    node.ownerDocument = this;
    node.nodeName = tagName;
    node.tagName = tagName;
    node.localName = tagName;
    node.childNodes = new NodeList$1();
    var attrs = node.attributes = new NamedNodeMap();
    attrs._ownerElement = node;
    return node;
  },
  createDocumentFragment: function() {
    var node = new DocumentFragment();
    node.ownerDocument = this;
    node.childNodes = new NodeList$1();
    return node;
  },
  createTextNode: function(data) {
    var node = new Text();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createComment: function(data) {
    var node = new Comment();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createCDATASection: function(data) {
    var node = new CDATASection();
    node.ownerDocument = this;
    node.appendData(data);
    return node;
  },
  createProcessingInstruction: function(target, data) {
    var node = new ProcessingInstruction();
    node.ownerDocument = this;
    node.tagName = node.nodeName = node.target = target;
    node.nodeValue = node.data = data;
    return node;
  },
  createAttribute: function(name) {
    var node = new Attr();
    node.ownerDocument = this;
    node.name = name;
    node.nodeName = name;
    node.localName = name;
    node.specified = true;
    return node;
  },
  createEntityReference: function(name) {
    var node = new EntityReference();
    node.ownerDocument = this;
    node.nodeName = name;
    return node;
  },
  createElementNS: function(namespaceURI, qualifiedName) {
    var node = new Element();
    var pl = qualifiedName.split(":");
    var attrs = node.attributes = new NamedNodeMap();
    node.childNodes = new NodeList$1();
    node.ownerDocument = this;
    node.nodeName = qualifiedName;
    node.tagName = qualifiedName;
    node.namespaceURI = namespaceURI;
    if (pl.length == 2) {
      node.prefix = pl[0];
      node.localName = pl[1];
    } else {
      node.localName = qualifiedName;
    }
    attrs._ownerElement = node;
    return node;
  },
  createAttributeNS: function(namespaceURI, qualifiedName) {
    var node = new Attr();
    var pl = qualifiedName.split(":");
    node.ownerDocument = this;
    node.nodeName = qualifiedName;
    node.name = qualifiedName;
    node.namespaceURI = namespaceURI;
    node.specified = true;
    if (pl.length == 2) {
      node.prefix = pl[0];
      node.localName = pl[1];
    } else {
      node.localName = qualifiedName;
    }
    return node;
  }
};
_extends(Document, Node$1);
function Element() {
  this._nsMap = {};
}
Element.prototype = {
  nodeType: ELEMENT_NODE,
  hasAttribute: function(name) {
    return this.getAttributeNode(name) != null;
  },
  getAttribute: function(name) {
    var attr = this.getAttributeNode(name);
    return attr && attr.value || "";
  },
  getAttributeNode: function(name) {
    return this.attributes.getNamedItem(name);
  },
  setAttribute: function(name, value) {
    var attr = this.ownerDocument.createAttribute(name);
    attr.value = attr.nodeValue = "" + value;
    this.setAttributeNode(attr);
  },
  removeAttribute: function(name) {
    var attr = this.getAttributeNode(name);
    attr && this.removeAttributeNode(attr);
  },
  appendChild: function(newChild) {
    if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
      return this.insertBefore(newChild, null);
    } else {
      return _appendSingleChild(this, newChild);
    }
  },
  setAttributeNode: function(newAttr) {
    return this.attributes.setNamedItem(newAttr);
  },
  setAttributeNodeNS: function(newAttr) {
    return this.attributes.setNamedItemNS(newAttr);
  },
  removeAttributeNode: function(oldAttr) {
    return this.attributes.removeNamedItem(oldAttr.nodeName);
  },
  removeAttributeNS: function(namespaceURI, localName) {
    var old = this.getAttributeNodeNS(namespaceURI, localName);
    old && this.removeAttributeNode(old);
  },
  hasAttributeNS: function(namespaceURI, localName) {
    return this.getAttributeNodeNS(namespaceURI, localName) != null;
  },
  getAttributeNS: function(namespaceURI, localName) {
    var attr = this.getAttributeNodeNS(namespaceURI, localName);
    return attr && attr.value || "";
  },
  setAttributeNS: function(namespaceURI, qualifiedName, value) {
    var attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
    attr.value = attr.nodeValue = "" + value;
    this.setAttributeNode(attr);
  },
  getAttributeNodeNS: function(namespaceURI, localName) {
    return this.attributes.getNamedItemNS(namespaceURI, localName);
  },
  getElementsByTagName: function(tagName) {
    return new LiveNodeList(this, function(base) {
      var ls = [];
      _visitNode(base, function(node) {
        if (node !== base && node.nodeType == ELEMENT_NODE && (tagName === "*" || node.tagName == tagName)) {
          ls.push(node);
        }
      });
      return ls;
    });
  },
  getElementsByTagNameNS: function(namespaceURI, localName) {
    return new LiveNodeList(this, function(base) {
      var ls = [];
      _visitNode(base, function(node) {
        if (node !== base && node.nodeType === ELEMENT_NODE && (namespaceURI === "*" || node.namespaceURI === namespaceURI) && (localName === "*" || node.localName == localName)) {
          ls.push(node);
        }
      });
      return ls;
    });
  }
};
Document.prototype.getElementsByTagName = Element.prototype.getElementsByTagName;
Document.prototype.getElementsByTagNameNS = Element.prototype.getElementsByTagNameNS;
_extends(Element, Node$1);
function Attr() {
}
Attr.prototype.nodeType = ATTRIBUTE_NODE;
_extends(Attr, Node$1);
function CharacterData() {
}
CharacterData.prototype = {
  data: "",
  substringData: function(offset2, count) {
    return this.data.substring(offset2, offset2 + count);
  },
  appendData: function(text) {
    text = this.data + text;
    this.nodeValue = this.data = text;
    this.length = text.length;
  },
  insertData: function(offset2, text) {
    this.replaceData(offset2, 0, text);
  },
  appendChild: function(newChild) {
    throw new Error(ExceptionMessage[HIERARCHY_REQUEST_ERR]);
  },
  deleteData: function(offset2, count) {
    this.replaceData(offset2, count, "");
  },
  replaceData: function(offset2, count, text) {
    var start2 = this.data.substring(0, offset2);
    var end3 = this.data.substring(offset2 + count);
    text = start2 + text + end3;
    this.nodeValue = this.data = text;
    this.length = text.length;
  }
};
_extends(CharacterData, Node$1);
function Text() {
}
Text.prototype = {
  nodeName: "#text",
  nodeType: TEXT_NODE,
  splitText: function(offset2) {
    var text = this.data;
    var newText = text.substring(offset2);
    text = text.substring(0, offset2);
    this.data = this.nodeValue = text;
    this.length = text.length;
    var newNode = this.ownerDocument.createTextNode(newText);
    if (this.parentNode) {
      this.parentNode.insertBefore(newNode, this.nextSibling);
    }
    return newNode;
  }
};
_extends(Text, CharacterData);
function Comment() {
}
Comment.prototype = {
  nodeName: "#comment",
  nodeType: COMMENT_NODE
};
_extends(Comment, CharacterData);
function CDATASection() {
}
CDATASection.prototype = {
  nodeName: "#cdata-section",
  nodeType: CDATA_SECTION_NODE
};
_extends(CDATASection, CharacterData);
function DocumentType() {
}
DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
_extends(DocumentType, Node$1);
function Notation() {
}
Notation.prototype.nodeType = NOTATION_NODE;
_extends(Notation, Node$1);
function Entity() {
}
Entity.prototype.nodeType = ENTITY_NODE;
_extends(Entity, Node$1);
function EntityReference() {
}
EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
_extends(EntityReference, Node$1);
function DocumentFragment() {
}
DocumentFragment.prototype.nodeName = "#document-fragment";
DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
_extends(DocumentFragment, Node$1);
function ProcessingInstruction() {
}
ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
_extends(ProcessingInstruction, Node$1);
function XMLSerializer() {
}
XMLSerializer.prototype.serializeToString = function(node, isHtml, nodeFilter) {
  return nodeSerializeToString.call(node, isHtml, nodeFilter);
};
Node$1.prototype.toString = nodeSerializeToString;
function nodeSerializeToString(isHtml, nodeFilter) {
  var buf = [];
  var refNode = this.nodeType == 9 && this.documentElement || this;
  var prefix = refNode.prefix;
  var uri = refNode.namespaceURI;
  if (uri && prefix == null) {
    var prefix = refNode.lookupPrefix(uri);
    if (prefix == null) {
      var visibleNamespaces = [
        { namespace: uri, prefix: null }
      ];
    }
  }
  serializeToString(this, buf, isHtml, nodeFilter, visibleNamespaces);
  return buf.join("");
}
function needNamespaceDefine(node, isHTML, visibleNamespaces) {
  var prefix = node.prefix || "";
  var uri = node.namespaceURI;
  if (!uri) {
    return false;
  }
  if (prefix === "xml" && uri === NAMESPACE$2.XML || uri === NAMESPACE$2.XMLNS) {
    return false;
  }
  var i = visibleNamespaces.length;
  while (i--) {
    var ns = visibleNamespaces[i];
    if (ns.prefix === prefix) {
      return ns.namespace !== uri;
    }
  }
  return true;
}
function addSerializedAttribute(buf, qualifiedName, value) {
  buf.push(" ", qualifiedName, '="', value.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"');
}
function serializeToString(node, buf, isHTML, nodeFilter, visibleNamespaces) {
  if (!visibleNamespaces) {
    visibleNamespaces = [];
  }
  if (nodeFilter) {
    node = nodeFilter(node);
    if (node) {
      if (typeof node == "string") {
        buf.push(node);
        return;
      }
    } else {
      return;
    }
  }
  switch (node.nodeType) {
    case ELEMENT_NODE:
      var attrs = node.attributes;
      var len = attrs.length;
      var child = node.firstChild;
      var nodeName = node.tagName;
      isHTML = NAMESPACE$2.isHTML(node.namespaceURI) || isHTML;
      var prefixedNodeName = nodeName;
      if (!isHTML && !node.prefix && node.namespaceURI) {
        var defaultNS;
        for (var ai2 = 0; ai2 < attrs.length; ai2++) {
          if (attrs.item(ai2).name === "xmlns") {
            defaultNS = attrs.item(ai2).value;
            break;
          }
        }
        if (!defaultNS) {
          for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
            var namespace2 = visibleNamespaces[nsi];
            if (namespace2.prefix === "" && namespace2.namespace === node.namespaceURI) {
              defaultNS = namespace2.namespace;
              break;
            }
          }
        }
        if (defaultNS !== node.namespaceURI) {
          for (var nsi = visibleNamespaces.length - 1; nsi >= 0; nsi--) {
            var namespace2 = visibleNamespaces[nsi];
            if (namespace2.namespace === node.namespaceURI) {
              if (namespace2.prefix) {
                prefixedNodeName = namespace2.prefix + ":" + nodeName;
              }
              break;
            }
          }
        }
      }
      buf.push("<", prefixedNodeName);
      for (var i = 0; i < len; i++) {
        var attr = attrs.item(i);
        if (attr.prefix == "xmlns") {
          visibleNamespaces.push({ prefix: attr.localName, namespace: attr.value });
        } else if (attr.nodeName == "xmlns") {
          visibleNamespaces.push({ prefix: "", namespace: attr.value });
        }
      }
      for (var i = 0; i < len; i++) {
        var attr = attrs.item(i);
        if (needNamespaceDefine(attr, isHTML, visibleNamespaces)) {
          var prefix = attr.prefix || "";
          var uri = attr.namespaceURI;
          addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
          visibleNamespaces.push({ prefix, namespace: uri });
        }
        serializeToString(attr, buf, isHTML, nodeFilter, visibleNamespaces);
      }
      if (nodeName === prefixedNodeName && needNamespaceDefine(node, isHTML, visibleNamespaces)) {
        var prefix = node.prefix || "";
        var uri = node.namespaceURI;
        addSerializedAttribute(buf, prefix ? "xmlns:" + prefix : "xmlns", uri);
        visibleNamespaces.push({ prefix, namespace: uri });
      }
      if (child || isHTML && !/^(?:meta|link|img|br|hr|input)$/i.test(nodeName)) {
        buf.push(">");
        if (isHTML && /^script$/i.test(nodeName)) {
          while (child) {
            if (child.data) {
              buf.push(child.data);
            } else {
              serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
            }
            child = child.nextSibling;
          }
        } else {
          while (child) {
            serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
            child = child.nextSibling;
          }
        }
        buf.push("</", prefixedNodeName, ">");
      } else {
        buf.push("/>");
      }
      return;
    case DOCUMENT_NODE:
    case DOCUMENT_FRAGMENT_NODE:
      var child = node.firstChild;
      while (child) {
        serializeToString(child, buf, isHTML, nodeFilter, visibleNamespaces.slice());
        child = child.nextSibling;
      }
      return;
    case ATTRIBUTE_NODE:
      return addSerializedAttribute(buf, node.name, node.value);
    case TEXT_NODE:
      return buf.push(node.data.replace(/[<&>]/g, _xmlEncoder));
    case CDATA_SECTION_NODE:
      return buf.push("<![CDATA[", node.data, "]]>");
    case COMMENT_NODE:
      return buf.push("<!--", node.data, "-->");
    case DOCUMENT_TYPE_NODE:
      var pubid = node.publicId;
      var sysid = node.systemId;
      buf.push("<!DOCTYPE ", node.name);
      if (pubid) {
        buf.push(" PUBLIC ", pubid);
        if (sysid && sysid != ".") {
          buf.push(" ", sysid);
        }
        buf.push(">");
      } else if (sysid && sysid != ".") {
        buf.push(" SYSTEM ", sysid, ">");
      } else {
        var sub = node.internalSubset;
        if (sub) {
          buf.push(" [", sub, "]");
        }
        buf.push(">");
      }
      return;
    case PROCESSING_INSTRUCTION_NODE:
      return buf.push("<?", node.target, " ", node.data, "?>");
    case ENTITY_REFERENCE_NODE:
      return buf.push("&", node.nodeName, ";");
    default:
      buf.push("??", node.nodeName);
  }
}
function importNode(doc, node, deep) {
  var node2;
  switch (node.nodeType) {
    case ELEMENT_NODE:
      node2 = node.cloneNode(false);
      node2.ownerDocument = doc;
    case DOCUMENT_FRAGMENT_NODE:
      break;
    case ATTRIBUTE_NODE:
      deep = true;
      break;
  }
  if (!node2) {
    node2 = node.cloneNode(false);
  }
  node2.ownerDocument = doc;
  node2.parentNode = null;
  if (deep) {
    var child = node.firstChild;
    while (child) {
      node2.appendChild(importNode(doc, child, deep));
      child = child.nextSibling;
    }
  }
  return node2;
}
function cloneNode(doc, node, deep) {
  var node2 = new node.constructor();
  for (var n2 in node) {
    if (Object.prototype.hasOwnProperty.call(node, n2)) {
      var v = node[n2];
      if (typeof v != "object") {
        if (v != node2[n2]) {
          node2[n2] = v;
        }
      }
    }
  }
  if (node.childNodes) {
    node2.childNodes = new NodeList$1();
  }
  node2.ownerDocument = doc;
  switch (node2.nodeType) {
    case ELEMENT_NODE:
      var attrs = node.attributes;
      var attrs2 = node2.attributes = new NamedNodeMap();
      var len = attrs.length;
      attrs2._ownerElement = node2;
      for (var i = 0; i < len; i++) {
        node2.setAttributeNode(cloneNode(doc, attrs.item(i), true));
      }
      break;
    case ATTRIBUTE_NODE:
      deep = true;
  }
  if (deep) {
    var child = node.firstChild;
    while (child) {
      node2.appendChild(cloneNode(doc, child, deep));
      child = child.nextSibling;
    }
  }
  return node2;
}
function __set__(object, key, value) {
  object[key] = value;
}
try {
  if (Object.defineProperty) {
    let getTextContent = function(node) {
      switch (node.nodeType) {
        case ELEMENT_NODE:
        case DOCUMENT_FRAGMENT_NODE:
          var buf = [];
          node = node.firstChild;
          while (node) {
            if (node.nodeType !== 7 && node.nodeType !== 8) {
              buf.push(getTextContent(node));
            }
            node = node.nextSibling;
          }
          return buf.join("");
        default:
          return node.nodeValue;
      }
    };
    Object.defineProperty(LiveNodeList.prototype, "length", {
      get: function() {
        _updateLiveList(this);
        return this.$$length;
      }
    });
    Object.defineProperty(Node$1.prototype, "textContent", {
      get: function() {
        return getTextContent(this);
      },
      set: function(data) {
        switch (this.nodeType) {
          case ELEMENT_NODE:
          case DOCUMENT_FRAGMENT_NODE:
            while (this.firstChild) {
              this.removeChild(this.firstChild);
            }
            if (data || String(data)) {
              this.appendChild(this.ownerDocument.createTextNode(data));
            }
            break;
          default:
            this.data = data;
            this.value = data;
            this.nodeValue = data;
        }
      }
    });
    __set__ = function(object, key, value) {
      object["$$" + key] = value;
    };
  }
} catch (e) {
}
dom$2.DocumentType = DocumentType;
dom$2.DOMException = DOMException;
dom$2.DOMImplementation = DOMImplementation$1;
dom$2.Element = Element;
dom$2.Node = Node$1;
dom$2.NodeList = NodeList$1;
dom$2.XMLSerializer = XMLSerializer;
var domParser = {};
var entities$1 = {};
(function(exports) {
  var freeze2 = conventions$2.freeze;
  exports.XML_ENTITIES = freeze2({
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    quot: '"'
  });
  exports.HTML_ENTITIES = freeze2({
    Aacute: "\xC1",
    aacute: "\xE1",
    Abreve: "\u0102",
    abreve: "\u0103",
    ac: "\u223E",
    acd: "\u223F",
    acE: "\u223E\u0333",
    Acirc: "\xC2",
    acirc: "\xE2",
    acute: "\xB4",
    Acy: "\u0410",
    acy: "\u0430",
    AElig: "\xC6",
    aelig: "\xE6",
    af: "\u2061",
    Afr: "\u{1D504}",
    afr: "\u{1D51E}",
    Agrave: "\xC0",
    agrave: "\xE0",
    alefsym: "\u2135",
    aleph: "\u2135",
    Alpha: "\u0391",
    alpha: "\u03B1",
    Amacr: "\u0100",
    amacr: "\u0101",
    amalg: "\u2A3F",
    AMP: "&",
    amp: "&",
    And: "\u2A53",
    and: "\u2227",
    andand: "\u2A55",
    andd: "\u2A5C",
    andslope: "\u2A58",
    andv: "\u2A5A",
    ang: "\u2220",
    ange: "\u29A4",
    angle: "\u2220",
    angmsd: "\u2221",
    angmsdaa: "\u29A8",
    angmsdab: "\u29A9",
    angmsdac: "\u29AA",
    angmsdad: "\u29AB",
    angmsdae: "\u29AC",
    angmsdaf: "\u29AD",
    angmsdag: "\u29AE",
    angmsdah: "\u29AF",
    angrt: "\u221F",
    angrtvb: "\u22BE",
    angrtvbd: "\u299D",
    angsph: "\u2222",
    angst: "\xC5",
    angzarr: "\u237C",
    Aogon: "\u0104",
    aogon: "\u0105",
    Aopf: "\u{1D538}",
    aopf: "\u{1D552}",
    ap: "\u2248",
    apacir: "\u2A6F",
    apE: "\u2A70",
    ape: "\u224A",
    apid: "\u224B",
    apos: "'",
    ApplyFunction: "\u2061",
    approx: "\u2248",
    approxeq: "\u224A",
    Aring: "\xC5",
    aring: "\xE5",
    Ascr: "\u{1D49C}",
    ascr: "\u{1D4B6}",
    Assign: "\u2254",
    ast: "*",
    asymp: "\u2248",
    asympeq: "\u224D",
    Atilde: "\xC3",
    atilde: "\xE3",
    Auml: "\xC4",
    auml: "\xE4",
    awconint: "\u2233",
    awint: "\u2A11",
    backcong: "\u224C",
    backepsilon: "\u03F6",
    backprime: "\u2035",
    backsim: "\u223D",
    backsimeq: "\u22CD",
    Backslash: "\u2216",
    Barv: "\u2AE7",
    barvee: "\u22BD",
    Barwed: "\u2306",
    barwed: "\u2305",
    barwedge: "\u2305",
    bbrk: "\u23B5",
    bbrktbrk: "\u23B6",
    bcong: "\u224C",
    Bcy: "\u0411",
    bcy: "\u0431",
    bdquo: "\u201E",
    becaus: "\u2235",
    Because: "\u2235",
    because: "\u2235",
    bemptyv: "\u29B0",
    bepsi: "\u03F6",
    bernou: "\u212C",
    Bernoullis: "\u212C",
    Beta: "\u0392",
    beta: "\u03B2",
    beth: "\u2136",
    between: "\u226C",
    Bfr: "\u{1D505}",
    bfr: "\u{1D51F}",
    bigcap: "\u22C2",
    bigcirc: "\u25EF",
    bigcup: "\u22C3",
    bigodot: "\u2A00",
    bigoplus: "\u2A01",
    bigotimes: "\u2A02",
    bigsqcup: "\u2A06",
    bigstar: "\u2605",
    bigtriangledown: "\u25BD",
    bigtriangleup: "\u25B3",
    biguplus: "\u2A04",
    bigvee: "\u22C1",
    bigwedge: "\u22C0",
    bkarow: "\u290D",
    blacklozenge: "\u29EB",
    blacksquare: "\u25AA",
    blacktriangle: "\u25B4",
    blacktriangledown: "\u25BE",
    blacktriangleleft: "\u25C2",
    blacktriangleright: "\u25B8",
    blank: "\u2423",
    blk12: "\u2592",
    blk14: "\u2591",
    blk34: "\u2593",
    block: "\u2588",
    bne: "=\u20E5",
    bnequiv: "\u2261\u20E5",
    bNot: "\u2AED",
    bnot: "\u2310",
    Bopf: "\u{1D539}",
    bopf: "\u{1D553}",
    bot: "\u22A5",
    bottom: "\u22A5",
    bowtie: "\u22C8",
    boxbox: "\u29C9",
    boxDL: "\u2557",
    boxDl: "\u2556",
    boxdL: "\u2555",
    boxdl: "\u2510",
    boxDR: "\u2554",
    boxDr: "\u2553",
    boxdR: "\u2552",
    boxdr: "\u250C",
    boxH: "\u2550",
    boxh: "\u2500",
    boxHD: "\u2566",
    boxHd: "\u2564",
    boxhD: "\u2565",
    boxhd: "\u252C",
    boxHU: "\u2569",
    boxHu: "\u2567",
    boxhU: "\u2568",
    boxhu: "\u2534",
    boxminus: "\u229F",
    boxplus: "\u229E",
    boxtimes: "\u22A0",
    boxUL: "\u255D",
    boxUl: "\u255C",
    boxuL: "\u255B",
    boxul: "\u2518",
    boxUR: "\u255A",
    boxUr: "\u2559",
    boxuR: "\u2558",
    boxur: "\u2514",
    boxV: "\u2551",
    boxv: "\u2502",
    boxVH: "\u256C",
    boxVh: "\u256B",
    boxvH: "\u256A",
    boxvh: "\u253C",
    boxVL: "\u2563",
    boxVl: "\u2562",
    boxvL: "\u2561",
    boxvl: "\u2524",
    boxVR: "\u2560",
    boxVr: "\u255F",
    boxvR: "\u255E",
    boxvr: "\u251C",
    bprime: "\u2035",
    Breve: "\u02D8",
    breve: "\u02D8",
    brvbar: "\xA6",
    Bscr: "\u212C",
    bscr: "\u{1D4B7}",
    bsemi: "\u204F",
    bsim: "\u223D",
    bsime: "\u22CD",
    bsol: "\\",
    bsolb: "\u29C5",
    bsolhsub: "\u27C8",
    bull: "\u2022",
    bullet: "\u2022",
    bump: "\u224E",
    bumpE: "\u2AAE",
    bumpe: "\u224F",
    Bumpeq: "\u224E",
    bumpeq: "\u224F",
    Cacute: "\u0106",
    cacute: "\u0107",
    Cap: "\u22D2",
    cap: "\u2229",
    capand: "\u2A44",
    capbrcup: "\u2A49",
    capcap: "\u2A4B",
    capcup: "\u2A47",
    capdot: "\u2A40",
    CapitalDifferentialD: "\u2145",
    caps: "\u2229\uFE00",
    caret: "\u2041",
    caron: "\u02C7",
    Cayleys: "\u212D",
    ccaps: "\u2A4D",
    Ccaron: "\u010C",
    ccaron: "\u010D",
    Ccedil: "\xC7",
    ccedil: "\xE7",
    Ccirc: "\u0108",
    ccirc: "\u0109",
    Cconint: "\u2230",
    ccups: "\u2A4C",
    ccupssm: "\u2A50",
    Cdot: "\u010A",
    cdot: "\u010B",
    cedil: "\xB8",
    Cedilla: "\xB8",
    cemptyv: "\u29B2",
    cent: "\xA2",
    CenterDot: "\xB7",
    centerdot: "\xB7",
    Cfr: "\u212D",
    cfr: "\u{1D520}",
    CHcy: "\u0427",
    chcy: "\u0447",
    check: "\u2713",
    checkmark: "\u2713",
    Chi: "\u03A7",
    chi: "\u03C7",
    cir: "\u25CB",
    circ: "\u02C6",
    circeq: "\u2257",
    circlearrowleft: "\u21BA",
    circlearrowright: "\u21BB",
    circledast: "\u229B",
    circledcirc: "\u229A",
    circleddash: "\u229D",
    CircleDot: "\u2299",
    circledR: "\xAE",
    circledS: "\u24C8",
    CircleMinus: "\u2296",
    CirclePlus: "\u2295",
    CircleTimes: "\u2297",
    cirE: "\u29C3",
    cire: "\u2257",
    cirfnint: "\u2A10",
    cirmid: "\u2AEF",
    cirscir: "\u29C2",
    ClockwiseContourIntegral: "\u2232",
    CloseCurlyDoubleQuote: "\u201D",
    CloseCurlyQuote: "\u2019",
    clubs: "\u2663",
    clubsuit: "\u2663",
    Colon: "\u2237",
    colon: ":",
    Colone: "\u2A74",
    colone: "\u2254",
    coloneq: "\u2254",
    comma: ",",
    commat: "@",
    comp: "\u2201",
    compfn: "\u2218",
    complement: "\u2201",
    complexes: "\u2102",
    cong: "\u2245",
    congdot: "\u2A6D",
    Congruent: "\u2261",
    Conint: "\u222F",
    conint: "\u222E",
    ContourIntegral: "\u222E",
    Copf: "\u2102",
    copf: "\u{1D554}",
    coprod: "\u2210",
    Coproduct: "\u2210",
    COPY: "\xA9",
    copy: "\xA9",
    copysr: "\u2117",
    CounterClockwiseContourIntegral: "\u2233",
    crarr: "\u21B5",
    Cross: "\u2A2F",
    cross: "\u2717",
    Cscr: "\u{1D49E}",
    cscr: "\u{1D4B8}",
    csub: "\u2ACF",
    csube: "\u2AD1",
    csup: "\u2AD0",
    csupe: "\u2AD2",
    ctdot: "\u22EF",
    cudarrl: "\u2938",
    cudarrr: "\u2935",
    cuepr: "\u22DE",
    cuesc: "\u22DF",
    cularr: "\u21B6",
    cularrp: "\u293D",
    Cup: "\u22D3",
    cup: "\u222A",
    cupbrcap: "\u2A48",
    CupCap: "\u224D",
    cupcap: "\u2A46",
    cupcup: "\u2A4A",
    cupdot: "\u228D",
    cupor: "\u2A45",
    cups: "\u222A\uFE00",
    curarr: "\u21B7",
    curarrm: "\u293C",
    curlyeqprec: "\u22DE",
    curlyeqsucc: "\u22DF",
    curlyvee: "\u22CE",
    curlywedge: "\u22CF",
    curren: "\xA4",
    curvearrowleft: "\u21B6",
    curvearrowright: "\u21B7",
    cuvee: "\u22CE",
    cuwed: "\u22CF",
    cwconint: "\u2232",
    cwint: "\u2231",
    cylcty: "\u232D",
    Dagger: "\u2021",
    dagger: "\u2020",
    daleth: "\u2138",
    Darr: "\u21A1",
    dArr: "\u21D3",
    darr: "\u2193",
    dash: "\u2010",
    Dashv: "\u2AE4",
    dashv: "\u22A3",
    dbkarow: "\u290F",
    dblac: "\u02DD",
    Dcaron: "\u010E",
    dcaron: "\u010F",
    Dcy: "\u0414",
    dcy: "\u0434",
    DD: "\u2145",
    dd: "\u2146",
    ddagger: "\u2021",
    ddarr: "\u21CA",
    DDotrahd: "\u2911",
    ddotseq: "\u2A77",
    deg: "\xB0",
    Del: "\u2207",
    Delta: "\u0394",
    delta: "\u03B4",
    demptyv: "\u29B1",
    dfisht: "\u297F",
    Dfr: "\u{1D507}",
    dfr: "\u{1D521}",
    dHar: "\u2965",
    dharl: "\u21C3",
    dharr: "\u21C2",
    DiacriticalAcute: "\xB4",
    DiacriticalDot: "\u02D9",
    DiacriticalDoubleAcute: "\u02DD",
    DiacriticalGrave: "`",
    DiacriticalTilde: "\u02DC",
    diam: "\u22C4",
    Diamond: "\u22C4",
    diamond: "\u22C4",
    diamondsuit: "\u2666",
    diams: "\u2666",
    die: "\xA8",
    DifferentialD: "\u2146",
    digamma: "\u03DD",
    disin: "\u22F2",
    div: "\xF7",
    divide: "\xF7",
    divideontimes: "\u22C7",
    divonx: "\u22C7",
    DJcy: "\u0402",
    djcy: "\u0452",
    dlcorn: "\u231E",
    dlcrop: "\u230D",
    dollar: "$",
    Dopf: "\u{1D53B}",
    dopf: "\u{1D555}",
    Dot: "\xA8",
    dot: "\u02D9",
    DotDot: "\u20DC",
    doteq: "\u2250",
    doteqdot: "\u2251",
    DotEqual: "\u2250",
    dotminus: "\u2238",
    dotplus: "\u2214",
    dotsquare: "\u22A1",
    doublebarwedge: "\u2306",
    DoubleContourIntegral: "\u222F",
    DoubleDot: "\xA8",
    DoubleDownArrow: "\u21D3",
    DoubleLeftArrow: "\u21D0",
    DoubleLeftRightArrow: "\u21D4",
    DoubleLeftTee: "\u2AE4",
    DoubleLongLeftArrow: "\u27F8",
    DoubleLongLeftRightArrow: "\u27FA",
    DoubleLongRightArrow: "\u27F9",
    DoubleRightArrow: "\u21D2",
    DoubleRightTee: "\u22A8",
    DoubleUpArrow: "\u21D1",
    DoubleUpDownArrow: "\u21D5",
    DoubleVerticalBar: "\u2225",
    DownArrow: "\u2193",
    Downarrow: "\u21D3",
    downarrow: "\u2193",
    DownArrowBar: "\u2913",
    DownArrowUpArrow: "\u21F5",
    DownBreve: "\u0311",
    downdownarrows: "\u21CA",
    downharpoonleft: "\u21C3",
    downharpoonright: "\u21C2",
    DownLeftRightVector: "\u2950",
    DownLeftTeeVector: "\u295E",
    DownLeftVector: "\u21BD",
    DownLeftVectorBar: "\u2956",
    DownRightTeeVector: "\u295F",
    DownRightVector: "\u21C1",
    DownRightVectorBar: "\u2957",
    DownTee: "\u22A4",
    DownTeeArrow: "\u21A7",
    drbkarow: "\u2910",
    drcorn: "\u231F",
    drcrop: "\u230C",
    Dscr: "\u{1D49F}",
    dscr: "\u{1D4B9}",
    DScy: "\u0405",
    dscy: "\u0455",
    dsol: "\u29F6",
    Dstrok: "\u0110",
    dstrok: "\u0111",
    dtdot: "\u22F1",
    dtri: "\u25BF",
    dtrif: "\u25BE",
    duarr: "\u21F5",
    duhar: "\u296F",
    dwangle: "\u29A6",
    DZcy: "\u040F",
    dzcy: "\u045F",
    dzigrarr: "\u27FF",
    Eacute: "\xC9",
    eacute: "\xE9",
    easter: "\u2A6E",
    Ecaron: "\u011A",
    ecaron: "\u011B",
    ecir: "\u2256",
    Ecirc: "\xCA",
    ecirc: "\xEA",
    ecolon: "\u2255",
    Ecy: "\u042D",
    ecy: "\u044D",
    eDDot: "\u2A77",
    Edot: "\u0116",
    eDot: "\u2251",
    edot: "\u0117",
    ee: "\u2147",
    efDot: "\u2252",
    Efr: "\u{1D508}",
    efr: "\u{1D522}",
    eg: "\u2A9A",
    Egrave: "\xC8",
    egrave: "\xE8",
    egs: "\u2A96",
    egsdot: "\u2A98",
    el: "\u2A99",
    Element: "\u2208",
    elinters: "\u23E7",
    ell: "\u2113",
    els: "\u2A95",
    elsdot: "\u2A97",
    Emacr: "\u0112",
    emacr: "\u0113",
    empty: "\u2205",
    emptyset: "\u2205",
    EmptySmallSquare: "\u25FB",
    emptyv: "\u2205",
    EmptyVerySmallSquare: "\u25AB",
    emsp: "\u2003",
    emsp13: "\u2004",
    emsp14: "\u2005",
    ENG: "\u014A",
    eng: "\u014B",
    ensp: "\u2002",
    Eogon: "\u0118",
    eogon: "\u0119",
    Eopf: "\u{1D53C}",
    eopf: "\u{1D556}",
    epar: "\u22D5",
    eparsl: "\u29E3",
    eplus: "\u2A71",
    epsi: "\u03B5",
    Epsilon: "\u0395",
    epsilon: "\u03B5",
    epsiv: "\u03F5",
    eqcirc: "\u2256",
    eqcolon: "\u2255",
    eqsim: "\u2242",
    eqslantgtr: "\u2A96",
    eqslantless: "\u2A95",
    Equal: "\u2A75",
    equals: "=",
    EqualTilde: "\u2242",
    equest: "\u225F",
    Equilibrium: "\u21CC",
    equiv: "\u2261",
    equivDD: "\u2A78",
    eqvparsl: "\u29E5",
    erarr: "\u2971",
    erDot: "\u2253",
    Escr: "\u2130",
    escr: "\u212F",
    esdot: "\u2250",
    Esim: "\u2A73",
    esim: "\u2242",
    Eta: "\u0397",
    eta: "\u03B7",
    ETH: "\xD0",
    eth: "\xF0",
    Euml: "\xCB",
    euml: "\xEB",
    euro: "\u20AC",
    excl: "!",
    exist: "\u2203",
    Exists: "\u2203",
    expectation: "\u2130",
    ExponentialE: "\u2147",
    exponentiale: "\u2147",
    fallingdotseq: "\u2252",
    Fcy: "\u0424",
    fcy: "\u0444",
    female: "\u2640",
    ffilig: "\uFB03",
    fflig: "\uFB00",
    ffllig: "\uFB04",
    Ffr: "\u{1D509}",
    ffr: "\u{1D523}",
    filig: "\uFB01",
    FilledSmallSquare: "\u25FC",
    FilledVerySmallSquare: "\u25AA",
    fjlig: "fj",
    flat: "\u266D",
    fllig: "\uFB02",
    fltns: "\u25B1",
    fnof: "\u0192",
    Fopf: "\u{1D53D}",
    fopf: "\u{1D557}",
    ForAll: "\u2200",
    forall: "\u2200",
    fork: "\u22D4",
    forkv: "\u2AD9",
    Fouriertrf: "\u2131",
    fpartint: "\u2A0D",
    frac12: "\xBD",
    frac13: "\u2153",
    frac14: "\xBC",
    frac15: "\u2155",
    frac16: "\u2159",
    frac18: "\u215B",
    frac23: "\u2154",
    frac25: "\u2156",
    frac34: "\xBE",
    frac35: "\u2157",
    frac38: "\u215C",
    frac45: "\u2158",
    frac56: "\u215A",
    frac58: "\u215D",
    frac78: "\u215E",
    frasl: "\u2044",
    frown: "\u2322",
    Fscr: "\u2131",
    fscr: "\u{1D4BB}",
    gacute: "\u01F5",
    Gamma: "\u0393",
    gamma: "\u03B3",
    Gammad: "\u03DC",
    gammad: "\u03DD",
    gap: "\u2A86",
    Gbreve: "\u011E",
    gbreve: "\u011F",
    Gcedil: "\u0122",
    Gcirc: "\u011C",
    gcirc: "\u011D",
    Gcy: "\u0413",
    gcy: "\u0433",
    Gdot: "\u0120",
    gdot: "\u0121",
    gE: "\u2267",
    ge: "\u2265",
    gEl: "\u2A8C",
    gel: "\u22DB",
    geq: "\u2265",
    geqq: "\u2267",
    geqslant: "\u2A7E",
    ges: "\u2A7E",
    gescc: "\u2AA9",
    gesdot: "\u2A80",
    gesdoto: "\u2A82",
    gesdotol: "\u2A84",
    gesl: "\u22DB\uFE00",
    gesles: "\u2A94",
    Gfr: "\u{1D50A}",
    gfr: "\u{1D524}",
    Gg: "\u22D9",
    gg: "\u226B",
    ggg: "\u22D9",
    gimel: "\u2137",
    GJcy: "\u0403",
    gjcy: "\u0453",
    gl: "\u2277",
    gla: "\u2AA5",
    glE: "\u2A92",
    glj: "\u2AA4",
    gnap: "\u2A8A",
    gnapprox: "\u2A8A",
    gnE: "\u2269",
    gne: "\u2A88",
    gneq: "\u2A88",
    gneqq: "\u2269",
    gnsim: "\u22E7",
    Gopf: "\u{1D53E}",
    gopf: "\u{1D558}",
    grave: "`",
    GreaterEqual: "\u2265",
    GreaterEqualLess: "\u22DB",
    GreaterFullEqual: "\u2267",
    GreaterGreater: "\u2AA2",
    GreaterLess: "\u2277",
    GreaterSlantEqual: "\u2A7E",
    GreaterTilde: "\u2273",
    Gscr: "\u{1D4A2}",
    gscr: "\u210A",
    gsim: "\u2273",
    gsime: "\u2A8E",
    gsiml: "\u2A90",
    Gt: "\u226B",
    GT: ">",
    gt: ">",
    gtcc: "\u2AA7",
    gtcir: "\u2A7A",
    gtdot: "\u22D7",
    gtlPar: "\u2995",
    gtquest: "\u2A7C",
    gtrapprox: "\u2A86",
    gtrarr: "\u2978",
    gtrdot: "\u22D7",
    gtreqless: "\u22DB",
    gtreqqless: "\u2A8C",
    gtrless: "\u2277",
    gtrsim: "\u2273",
    gvertneqq: "\u2269\uFE00",
    gvnE: "\u2269\uFE00",
    Hacek: "\u02C7",
    hairsp: "\u200A",
    half: "\xBD",
    hamilt: "\u210B",
    HARDcy: "\u042A",
    hardcy: "\u044A",
    hArr: "\u21D4",
    harr: "\u2194",
    harrcir: "\u2948",
    harrw: "\u21AD",
    Hat: "^",
    hbar: "\u210F",
    Hcirc: "\u0124",
    hcirc: "\u0125",
    hearts: "\u2665",
    heartsuit: "\u2665",
    hellip: "\u2026",
    hercon: "\u22B9",
    Hfr: "\u210C",
    hfr: "\u{1D525}",
    HilbertSpace: "\u210B",
    hksearow: "\u2925",
    hkswarow: "\u2926",
    hoarr: "\u21FF",
    homtht: "\u223B",
    hookleftarrow: "\u21A9",
    hookrightarrow: "\u21AA",
    Hopf: "\u210D",
    hopf: "\u{1D559}",
    horbar: "\u2015",
    HorizontalLine: "\u2500",
    Hscr: "\u210B",
    hscr: "\u{1D4BD}",
    hslash: "\u210F",
    Hstrok: "\u0126",
    hstrok: "\u0127",
    HumpDownHump: "\u224E",
    HumpEqual: "\u224F",
    hybull: "\u2043",
    hyphen: "\u2010",
    Iacute: "\xCD",
    iacute: "\xED",
    ic: "\u2063",
    Icirc: "\xCE",
    icirc: "\xEE",
    Icy: "\u0418",
    icy: "\u0438",
    Idot: "\u0130",
    IEcy: "\u0415",
    iecy: "\u0435",
    iexcl: "\xA1",
    iff: "\u21D4",
    Ifr: "\u2111",
    ifr: "\u{1D526}",
    Igrave: "\xCC",
    igrave: "\xEC",
    ii: "\u2148",
    iiiint: "\u2A0C",
    iiint: "\u222D",
    iinfin: "\u29DC",
    iiota: "\u2129",
    IJlig: "\u0132",
    ijlig: "\u0133",
    Im: "\u2111",
    Imacr: "\u012A",
    imacr: "\u012B",
    image: "\u2111",
    ImaginaryI: "\u2148",
    imagline: "\u2110",
    imagpart: "\u2111",
    imath: "\u0131",
    imof: "\u22B7",
    imped: "\u01B5",
    Implies: "\u21D2",
    in: "\u2208",
    incare: "\u2105",
    infin: "\u221E",
    infintie: "\u29DD",
    inodot: "\u0131",
    Int: "\u222C",
    int: "\u222B",
    intcal: "\u22BA",
    integers: "\u2124",
    Integral: "\u222B",
    intercal: "\u22BA",
    Intersection: "\u22C2",
    intlarhk: "\u2A17",
    intprod: "\u2A3C",
    InvisibleComma: "\u2063",
    InvisibleTimes: "\u2062",
    IOcy: "\u0401",
    iocy: "\u0451",
    Iogon: "\u012E",
    iogon: "\u012F",
    Iopf: "\u{1D540}",
    iopf: "\u{1D55A}",
    Iota: "\u0399",
    iota: "\u03B9",
    iprod: "\u2A3C",
    iquest: "\xBF",
    Iscr: "\u2110",
    iscr: "\u{1D4BE}",
    isin: "\u2208",
    isindot: "\u22F5",
    isinE: "\u22F9",
    isins: "\u22F4",
    isinsv: "\u22F3",
    isinv: "\u2208",
    it: "\u2062",
    Itilde: "\u0128",
    itilde: "\u0129",
    Iukcy: "\u0406",
    iukcy: "\u0456",
    Iuml: "\xCF",
    iuml: "\xEF",
    Jcirc: "\u0134",
    jcirc: "\u0135",
    Jcy: "\u0419",
    jcy: "\u0439",
    Jfr: "\u{1D50D}",
    jfr: "\u{1D527}",
    jmath: "\u0237",
    Jopf: "\u{1D541}",
    jopf: "\u{1D55B}",
    Jscr: "\u{1D4A5}",
    jscr: "\u{1D4BF}",
    Jsercy: "\u0408",
    jsercy: "\u0458",
    Jukcy: "\u0404",
    jukcy: "\u0454",
    Kappa: "\u039A",
    kappa: "\u03BA",
    kappav: "\u03F0",
    Kcedil: "\u0136",
    kcedil: "\u0137",
    Kcy: "\u041A",
    kcy: "\u043A",
    Kfr: "\u{1D50E}",
    kfr: "\u{1D528}",
    kgreen: "\u0138",
    KHcy: "\u0425",
    khcy: "\u0445",
    KJcy: "\u040C",
    kjcy: "\u045C",
    Kopf: "\u{1D542}",
    kopf: "\u{1D55C}",
    Kscr: "\u{1D4A6}",
    kscr: "\u{1D4C0}",
    lAarr: "\u21DA",
    Lacute: "\u0139",
    lacute: "\u013A",
    laemptyv: "\u29B4",
    lagran: "\u2112",
    Lambda: "\u039B",
    lambda: "\u03BB",
    Lang: "\u27EA",
    lang: "\u27E8",
    langd: "\u2991",
    langle: "\u27E8",
    lap: "\u2A85",
    Laplacetrf: "\u2112",
    laquo: "\xAB",
    Larr: "\u219E",
    lArr: "\u21D0",
    larr: "\u2190",
    larrb: "\u21E4",
    larrbfs: "\u291F",
    larrfs: "\u291D",
    larrhk: "\u21A9",
    larrlp: "\u21AB",
    larrpl: "\u2939",
    larrsim: "\u2973",
    larrtl: "\u21A2",
    lat: "\u2AAB",
    lAtail: "\u291B",
    latail: "\u2919",
    late: "\u2AAD",
    lates: "\u2AAD\uFE00",
    lBarr: "\u290E",
    lbarr: "\u290C",
    lbbrk: "\u2772",
    lbrace: "{",
    lbrack: "[",
    lbrke: "\u298B",
    lbrksld: "\u298F",
    lbrkslu: "\u298D",
    Lcaron: "\u013D",
    lcaron: "\u013E",
    Lcedil: "\u013B",
    lcedil: "\u013C",
    lceil: "\u2308",
    lcub: "{",
    Lcy: "\u041B",
    lcy: "\u043B",
    ldca: "\u2936",
    ldquo: "\u201C",
    ldquor: "\u201E",
    ldrdhar: "\u2967",
    ldrushar: "\u294B",
    ldsh: "\u21B2",
    lE: "\u2266",
    le: "\u2264",
    LeftAngleBracket: "\u27E8",
    LeftArrow: "\u2190",
    Leftarrow: "\u21D0",
    leftarrow: "\u2190",
    LeftArrowBar: "\u21E4",
    LeftArrowRightArrow: "\u21C6",
    leftarrowtail: "\u21A2",
    LeftCeiling: "\u2308",
    LeftDoubleBracket: "\u27E6",
    LeftDownTeeVector: "\u2961",
    LeftDownVector: "\u21C3",
    LeftDownVectorBar: "\u2959",
    LeftFloor: "\u230A",
    leftharpoondown: "\u21BD",
    leftharpoonup: "\u21BC",
    leftleftarrows: "\u21C7",
    LeftRightArrow: "\u2194",
    Leftrightarrow: "\u21D4",
    leftrightarrow: "\u2194",
    leftrightarrows: "\u21C6",
    leftrightharpoons: "\u21CB",
    leftrightsquigarrow: "\u21AD",
    LeftRightVector: "\u294E",
    LeftTee: "\u22A3",
    LeftTeeArrow: "\u21A4",
    LeftTeeVector: "\u295A",
    leftthreetimes: "\u22CB",
    LeftTriangle: "\u22B2",
    LeftTriangleBar: "\u29CF",
    LeftTriangleEqual: "\u22B4",
    LeftUpDownVector: "\u2951",
    LeftUpTeeVector: "\u2960",
    LeftUpVector: "\u21BF",
    LeftUpVectorBar: "\u2958",
    LeftVector: "\u21BC",
    LeftVectorBar: "\u2952",
    lEg: "\u2A8B",
    leg: "\u22DA",
    leq: "\u2264",
    leqq: "\u2266",
    leqslant: "\u2A7D",
    les: "\u2A7D",
    lescc: "\u2AA8",
    lesdot: "\u2A7F",
    lesdoto: "\u2A81",
    lesdotor: "\u2A83",
    lesg: "\u22DA\uFE00",
    lesges: "\u2A93",
    lessapprox: "\u2A85",
    lessdot: "\u22D6",
    lesseqgtr: "\u22DA",
    lesseqqgtr: "\u2A8B",
    LessEqualGreater: "\u22DA",
    LessFullEqual: "\u2266",
    LessGreater: "\u2276",
    lessgtr: "\u2276",
    LessLess: "\u2AA1",
    lesssim: "\u2272",
    LessSlantEqual: "\u2A7D",
    LessTilde: "\u2272",
    lfisht: "\u297C",
    lfloor: "\u230A",
    Lfr: "\u{1D50F}",
    lfr: "\u{1D529}",
    lg: "\u2276",
    lgE: "\u2A91",
    lHar: "\u2962",
    lhard: "\u21BD",
    lharu: "\u21BC",
    lharul: "\u296A",
    lhblk: "\u2584",
    LJcy: "\u0409",
    ljcy: "\u0459",
    Ll: "\u22D8",
    ll: "\u226A",
    llarr: "\u21C7",
    llcorner: "\u231E",
    Lleftarrow: "\u21DA",
    llhard: "\u296B",
    lltri: "\u25FA",
    Lmidot: "\u013F",
    lmidot: "\u0140",
    lmoust: "\u23B0",
    lmoustache: "\u23B0",
    lnap: "\u2A89",
    lnapprox: "\u2A89",
    lnE: "\u2268",
    lne: "\u2A87",
    lneq: "\u2A87",
    lneqq: "\u2268",
    lnsim: "\u22E6",
    loang: "\u27EC",
    loarr: "\u21FD",
    lobrk: "\u27E6",
    LongLeftArrow: "\u27F5",
    Longleftarrow: "\u27F8",
    longleftarrow: "\u27F5",
    LongLeftRightArrow: "\u27F7",
    Longleftrightarrow: "\u27FA",
    longleftrightarrow: "\u27F7",
    longmapsto: "\u27FC",
    LongRightArrow: "\u27F6",
    Longrightarrow: "\u27F9",
    longrightarrow: "\u27F6",
    looparrowleft: "\u21AB",
    looparrowright: "\u21AC",
    lopar: "\u2985",
    Lopf: "\u{1D543}",
    lopf: "\u{1D55D}",
    loplus: "\u2A2D",
    lotimes: "\u2A34",
    lowast: "\u2217",
    lowbar: "_",
    LowerLeftArrow: "\u2199",
    LowerRightArrow: "\u2198",
    loz: "\u25CA",
    lozenge: "\u25CA",
    lozf: "\u29EB",
    lpar: "(",
    lparlt: "\u2993",
    lrarr: "\u21C6",
    lrcorner: "\u231F",
    lrhar: "\u21CB",
    lrhard: "\u296D",
    lrm: "\u200E",
    lrtri: "\u22BF",
    lsaquo: "\u2039",
    Lscr: "\u2112",
    lscr: "\u{1D4C1}",
    Lsh: "\u21B0",
    lsh: "\u21B0",
    lsim: "\u2272",
    lsime: "\u2A8D",
    lsimg: "\u2A8F",
    lsqb: "[",
    lsquo: "\u2018",
    lsquor: "\u201A",
    Lstrok: "\u0141",
    lstrok: "\u0142",
    Lt: "\u226A",
    LT: "<",
    lt: "<",
    ltcc: "\u2AA6",
    ltcir: "\u2A79",
    ltdot: "\u22D6",
    lthree: "\u22CB",
    ltimes: "\u22C9",
    ltlarr: "\u2976",
    ltquest: "\u2A7B",
    ltri: "\u25C3",
    ltrie: "\u22B4",
    ltrif: "\u25C2",
    ltrPar: "\u2996",
    lurdshar: "\u294A",
    luruhar: "\u2966",
    lvertneqq: "\u2268\uFE00",
    lvnE: "\u2268\uFE00",
    macr: "\xAF",
    male: "\u2642",
    malt: "\u2720",
    maltese: "\u2720",
    Map: "\u2905",
    map: "\u21A6",
    mapsto: "\u21A6",
    mapstodown: "\u21A7",
    mapstoleft: "\u21A4",
    mapstoup: "\u21A5",
    marker: "\u25AE",
    mcomma: "\u2A29",
    Mcy: "\u041C",
    mcy: "\u043C",
    mdash: "\u2014",
    mDDot: "\u223A",
    measuredangle: "\u2221",
    MediumSpace: "\u205F",
    Mellintrf: "\u2133",
    Mfr: "\u{1D510}",
    mfr: "\u{1D52A}",
    mho: "\u2127",
    micro: "\xB5",
    mid: "\u2223",
    midast: "*",
    midcir: "\u2AF0",
    middot: "\xB7",
    minus: "\u2212",
    minusb: "\u229F",
    minusd: "\u2238",
    minusdu: "\u2A2A",
    MinusPlus: "\u2213",
    mlcp: "\u2ADB",
    mldr: "\u2026",
    mnplus: "\u2213",
    models: "\u22A7",
    Mopf: "\u{1D544}",
    mopf: "\u{1D55E}",
    mp: "\u2213",
    Mscr: "\u2133",
    mscr: "\u{1D4C2}",
    mstpos: "\u223E",
    Mu: "\u039C",
    mu: "\u03BC",
    multimap: "\u22B8",
    mumap: "\u22B8",
    nabla: "\u2207",
    Nacute: "\u0143",
    nacute: "\u0144",
    nang: "\u2220\u20D2",
    nap: "\u2249",
    napE: "\u2A70\u0338",
    napid: "\u224B\u0338",
    napos: "\u0149",
    napprox: "\u2249",
    natur: "\u266E",
    natural: "\u266E",
    naturals: "\u2115",
    nbsp: "\xA0",
    nbump: "\u224E\u0338",
    nbumpe: "\u224F\u0338",
    ncap: "\u2A43",
    Ncaron: "\u0147",
    ncaron: "\u0148",
    Ncedil: "\u0145",
    ncedil: "\u0146",
    ncong: "\u2247",
    ncongdot: "\u2A6D\u0338",
    ncup: "\u2A42",
    Ncy: "\u041D",
    ncy: "\u043D",
    ndash: "\u2013",
    ne: "\u2260",
    nearhk: "\u2924",
    neArr: "\u21D7",
    nearr: "\u2197",
    nearrow: "\u2197",
    nedot: "\u2250\u0338",
    NegativeMediumSpace: "\u200B",
    NegativeThickSpace: "\u200B",
    NegativeThinSpace: "\u200B",
    NegativeVeryThinSpace: "\u200B",
    nequiv: "\u2262",
    nesear: "\u2928",
    nesim: "\u2242\u0338",
    NestedGreaterGreater: "\u226B",
    NestedLessLess: "\u226A",
    NewLine: "\n",
    nexist: "\u2204",
    nexists: "\u2204",
    Nfr: "\u{1D511}",
    nfr: "\u{1D52B}",
    ngE: "\u2267\u0338",
    nge: "\u2271",
    ngeq: "\u2271",
    ngeqq: "\u2267\u0338",
    ngeqslant: "\u2A7E\u0338",
    nges: "\u2A7E\u0338",
    nGg: "\u22D9\u0338",
    ngsim: "\u2275",
    nGt: "\u226B\u20D2",
    ngt: "\u226F",
    ngtr: "\u226F",
    nGtv: "\u226B\u0338",
    nhArr: "\u21CE",
    nharr: "\u21AE",
    nhpar: "\u2AF2",
    ni: "\u220B",
    nis: "\u22FC",
    nisd: "\u22FA",
    niv: "\u220B",
    NJcy: "\u040A",
    njcy: "\u045A",
    nlArr: "\u21CD",
    nlarr: "\u219A",
    nldr: "\u2025",
    nlE: "\u2266\u0338",
    nle: "\u2270",
    nLeftarrow: "\u21CD",
    nleftarrow: "\u219A",
    nLeftrightarrow: "\u21CE",
    nleftrightarrow: "\u21AE",
    nleq: "\u2270",
    nleqq: "\u2266\u0338",
    nleqslant: "\u2A7D\u0338",
    nles: "\u2A7D\u0338",
    nless: "\u226E",
    nLl: "\u22D8\u0338",
    nlsim: "\u2274",
    nLt: "\u226A\u20D2",
    nlt: "\u226E",
    nltri: "\u22EA",
    nltrie: "\u22EC",
    nLtv: "\u226A\u0338",
    nmid: "\u2224",
    NoBreak: "\u2060",
    NonBreakingSpace: "\xA0",
    Nopf: "\u2115",
    nopf: "\u{1D55F}",
    Not: "\u2AEC",
    not: "\xAC",
    NotCongruent: "\u2262",
    NotCupCap: "\u226D",
    NotDoubleVerticalBar: "\u2226",
    NotElement: "\u2209",
    NotEqual: "\u2260",
    NotEqualTilde: "\u2242\u0338",
    NotExists: "\u2204",
    NotGreater: "\u226F",
    NotGreaterEqual: "\u2271",
    NotGreaterFullEqual: "\u2267\u0338",
    NotGreaterGreater: "\u226B\u0338",
    NotGreaterLess: "\u2279",
    NotGreaterSlantEqual: "\u2A7E\u0338",
    NotGreaterTilde: "\u2275",
    NotHumpDownHump: "\u224E\u0338",
    NotHumpEqual: "\u224F\u0338",
    notin: "\u2209",
    notindot: "\u22F5\u0338",
    notinE: "\u22F9\u0338",
    notinva: "\u2209",
    notinvb: "\u22F7",
    notinvc: "\u22F6",
    NotLeftTriangle: "\u22EA",
    NotLeftTriangleBar: "\u29CF\u0338",
    NotLeftTriangleEqual: "\u22EC",
    NotLess: "\u226E",
    NotLessEqual: "\u2270",
    NotLessGreater: "\u2278",
    NotLessLess: "\u226A\u0338",
    NotLessSlantEqual: "\u2A7D\u0338",
    NotLessTilde: "\u2274",
    NotNestedGreaterGreater: "\u2AA2\u0338",
    NotNestedLessLess: "\u2AA1\u0338",
    notni: "\u220C",
    notniva: "\u220C",
    notnivb: "\u22FE",
    notnivc: "\u22FD",
    NotPrecedes: "\u2280",
    NotPrecedesEqual: "\u2AAF\u0338",
    NotPrecedesSlantEqual: "\u22E0",
    NotReverseElement: "\u220C",
    NotRightTriangle: "\u22EB",
    NotRightTriangleBar: "\u29D0\u0338",
    NotRightTriangleEqual: "\u22ED",
    NotSquareSubset: "\u228F\u0338",
    NotSquareSubsetEqual: "\u22E2",
    NotSquareSuperset: "\u2290\u0338",
    NotSquareSupersetEqual: "\u22E3",
    NotSubset: "\u2282\u20D2",
    NotSubsetEqual: "\u2288",
    NotSucceeds: "\u2281",
    NotSucceedsEqual: "\u2AB0\u0338",
    NotSucceedsSlantEqual: "\u22E1",
    NotSucceedsTilde: "\u227F\u0338",
    NotSuperset: "\u2283\u20D2",
    NotSupersetEqual: "\u2289",
    NotTilde: "\u2241",
    NotTildeEqual: "\u2244",
    NotTildeFullEqual: "\u2247",
    NotTildeTilde: "\u2249",
    NotVerticalBar: "\u2224",
    npar: "\u2226",
    nparallel: "\u2226",
    nparsl: "\u2AFD\u20E5",
    npart: "\u2202\u0338",
    npolint: "\u2A14",
    npr: "\u2280",
    nprcue: "\u22E0",
    npre: "\u2AAF\u0338",
    nprec: "\u2280",
    npreceq: "\u2AAF\u0338",
    nrArr: "\u21CF",
    nrarr: "\u219B",
    nrarrc: "\u2933\u0338",
    nrarrw: "\u219D\u0338",
    nRightarrow: "\u21CF",
    nrightarrow: "\u219B",
    nrtri: "\u22EB",
    nrtrie: "\u22ED",
    nsc: "\u2281",
    nsccue: "\u22E1",
    nsce: "\u2AB0\u0338",
    Nscr: "\u{1D4A9}",
    nscr: "\u{1D4C3}",
    nshortmid: "\u2224",
    nshortparallel: "\u2226",
    nsim: "\u2241",
    nsime: "\u2244",
    nsimeq: "\u2244",
    nsmid: "\u2224",
    nspar: "\u2226",
    nsqsube: "\u22E2",
    nsqsupe: "\u22E3",
    nsub: "\u2284",
    nsubE: "\u2AC5\u0338",
    nsube: "\u2288",
    nsubset: "\u2282\u20D2",
    nsubseteq: "\u2288",
    nsubseteqq: "\u2AC5\u0338",
    nsucc: "\u2281",
    nsucceq: "\u2AB0\u0338",
    nsup: "\u2285",
    nsupE: "\u2AC6\u0338",
    nsupe: "\u2289",
    nsupset: "\u2283\u20D2",
    nsupseteq: "\u2289",
    nsupseteqq: "\u2AC6\u0338",
    ntgl: "\u2279",
    Ntilde: "\xD1",
    ntilde: "\xF1",
    ntlg: "\u2278",
    ntriangleleft: "\u22EA",
    ntrianglelefteq: "\u22EC",
    ntriangleright: "\u22EB",
    ntrianglerighteq: "\u22ED",
    Nu: "\u039D",
    nu: "\u03BD",
    num: "#",
    numero: "\u2116",
    numsp: "\u2007",
    nvap: "\u224D\u20D2",
    nVDash: "\u22AF",
    nVdash: "\u22AE",
    nvDash: "\u22AD",
    nvdash: "\u22AC",
    nvge: "\u2265\u20D2",
    nvgt: ">\u20D2",
    nvHarr: "\u2904",
    nvinfin: "\u29DE",
    nvlArr: "\u2902",
    nvle: "\u2264\u20D2",
    nvlt: "<\u20D2",
    nvltrie: "\u22B4\u20D2",
    nvrArr: "\u2903",
    nvrtrie: "\u22B5\u20D2",
    nvsim: "\u223C\u20D2",
    nwarhk: "\u2923",
    nwArr: "\u21D6",
    nwarr: "\u2196",
    nwarrow: "\u2196",
    nwnear: "\u2927",
    Oacute: "\xD3",
    oacute: "\xF3",
    oast: "\u229B",
    ocir: "\u229A",
    Ocirc: "\xD4",
    ocirc: "\xF4",
    Ocy: "\u041E",
    ocy: "\u043E",
    odash: "\u229D",
    Odblac: "\u0150",
    odblac: "\u0151",
    odiv: "\u2A38",
    odot: "\u2299",
    odsold: "\u29BC",
    OElig: "\u0152",
    oelig: "\u0153",
    ofcir: "\u29BF",
    Ofr: "\u{1D512}",
    ofr: "\u{1D52C}",
    ogon: "\u02DB",
    Ograve: "\xD2",
    ograve: "\xF2",
    ogt: "\u29C1",
    ohbar: "\u29B5",
    ohm: "\u03A9",
    oint: "\u222E",
    olarr: "\u21BA",
    olcir: "\u29BE",
    olcross: "\u29BB",
    oline: "\u203E",
    olt: "\u29C0",
    Omacr: "\u014C",
    omacr: "\u014D",
    Omega: "\u03A9",
    omega: "\u03C9",
    Omicron: "\u039F",
    omicron: "\u03BF",
    omid: "\u29B6",
    ominus: "\u2296",
    Oopf: "\u{1D546}",
    oopf: "\u{1D560}",
    opar: "\u29B7",
    OpenCurlyDoubleQuote: "\u201C",
    OpenCurlyQuote: "\u2018",
    operp: "\u29B9",
    oplus: "\u2295",
    Or: "\u2A54",
    or: "\u2228",
    orarr: "\u21BB",
    ord: "\u2A5D",
    order: "\u2134",
    orderof: "\u2134",
    ordf: "\xAA",
    ordm: "\xBA",
    origof: "\u22B6",
    oror: "\u2A56",
    orslope: "\u2A57",
    orv: "\u2A5B",
    oS: "\u24C8",
    Oscr: "\u{1D4AA}",
    oscr: "\u2134",
    Oslash: "\xD8",
    oslash: "\xF8",
    osol: "\u2298",
    Otilde: "\xD5",
    otilde: "\xF5",
    Otimes: "\u2A37",
    otimes: "\u2297",
    otimesas: "\u2A36",
    Ouml: "\xD6",
    ouml: "\xF6",
    ovbar: "\u233D",
    OverBar: "\u203E",
    OverBrace: "\u23DE",
    OverBracket: "\u23B4",
    OverParenthesis: "\u23DC",
    par: "\u2225",
    para: "\xB6",
    parallel: "\u2225",
    parsim: "\u2AF3",
    parsl: "\u2AFD",
    part: "\u2202",
    PartialD: "\u2202",
    Pcy: "\u041F",
    pcy: "\u043F",
    percnt: "%",
    period: ".",
    permil: "\u2030",
    perp: "\u22A5",
    pertenk: "\u2031",
    Pfr: "\u{1D513}",
    pfr: "\u{1D52D}",
    Phi: "\u03A6",
    phi: "\u03C6",
    phiv: "\u03D5",
    phmmat: "\u2133",
    phone: "\u260E",
    Pi: "\u03A0",
    pi: "\u03C0",
    pitchfork: "\u22D4",
    piv: "\u03D6",
    planck: "\u210F",
    planckh: "\u210E",
    plankv: "\u210F",
    plus: "+",
    plusacir: "\u2A23",
    plusb: "\u229E",
    pluscir: "\u2A22",
    plusdo: "\u2214",
    plusdu: "\u2A25",
    pluse: "\u2A72",
    PlusMinus: "\xB1",
    plusmn: "\xB1",
    plussim: "\u2A26",
    plustwo: "\u2A27",
    pm: "\xB1",
    Poincareplane: "\u210C",
    pointint: "\u2A15",
    Popf: "\u2119",
    popf: "\u{1D561}",
    pound: "\xA3",
    Pr: "\u2ABB",
    pr: "\u227A",
    prap: "\u2AB7",
    prcue: "\u227C",
    prE: "\u2AB3",
    pre: "\u2AAF",
    prec: "\u227A",
    precapprox: "\u2AB7",
    preccurlyeq: "\u227C",
    Precedes: "\u227A",
    PrecedesEqual: "\u2AAF",
    PrecedesSlantEqual: "\u227C",
    PrecedesTilde: "\u227E",
    preceq: "\u2AAF",
    precnapprox: "\u2AB9",
    precneqq: "\u2AB5",
    precnsim: "\u22E8",
    precsim: "\u227E",
    Prime: "\u2033",
    prime: "\u2032",
    primes: "\u2119",
    prnap: "\u2AB9",
    prnE: "\u2AB5",
    prnsim: "\u22E8",
    prod: "\u220F",
    Product: "\u220F",
    profalar: "\u232E",
    profline: "\u2312",
    profsurf: "\u2313",
    prop: "\u221D",
    Proportion: "\u2237",
    Proportional: "\u221D",
    propto: "\u221D",
    prsim: "\u227E",
    prurel: "\u22B0",
    Pscr: "\u{1D4AB}",
    pscr: "\u{1D4C5}",
    Psi: "\u03A8",
    psi: "\u03C8",
    puncsp: "\u2008",
    Qfr: "\u{1D514}",
    qfr: "\u{1D52E}",
    qint: "\u2A0C",
    Qopf: "\u211A",
    qopf: "\u{1D562}",
    qprime: "\u2057",
    Qscr: "\u{1D4AC}",
    qscr: "\u{1D4C6}",
    quaternions: "\u210D",
    quatint: "\u2A16",
    quest: "?",
    questeq: "\u225F",
    QUOT: '"',
    quot: '"',
    rAarr: "\u21DB",
    race: "\u223D\u0331",
    Racute: "\u0154",
    racute: "\u0155",
    radic: "\u221A",
    raemptyv: "\u29B3",
    Rang: "\u27EB",
    rang: "\u27E9",
    rangd: "\u2992",
    range: "\u29A5",
    rangle: "\u27E9",
    raquo: "\xBB",
    Rarr: "\u21A0",
    rArr: "\u21D2",
    rarr: "\u2192",
    rarrap: "\u2975",
    rarrb: "\u21E5",
    rarrbfs: "\u2920",
    rarrc: "\u2933",
    rarrfs: "\u291E",
    rarrhk: "\u21AA",
    rarrlp: "\u21AC",
    rarrpl: "\u2945",
    rarrsim: "\u2974",
    Rarrtl: "\u2916",
    rarrtl: "\u21A3",
    rarrw: "\u219D",
    rAtail: "\u291C",
    ratail: "\u291A",
    ratio: "\u2236",
    rationals: "\u211A",
    RBarr: "\u2910",
    rBarr: "\u290F",
    rbarr: "\u290D",
    rbbrk: "\u2773",
    rbrace: "}",
    rbrack: "]",
    rbrke: "\u298C",
    rbrksld: "\u298E",
    rbrkslu: "\u2990",
    Rcaron: "\u0158",
    rcaron: "\u0159",
    Rcedil: "\u0156",
    rcedil: "\u0157",
    rceil: "\u2309",
    rcub: "}",
    Rcy: "\u0420",
    rcy: "\u0440",
    rdca: "\u2937",
    rdldhar: "\u2969",
    rdquo: "\u201D",
    rdquor: "\u201D",
    rdsh: "\u21B3",
    Re: "\u211C",
    real: "\u211C",
    realine: "\u211B",
    realpart: "\u211C",
    reals: "\u211D",
    rect: "\u25AD",
    REG: "\xAE",
    reg: "\xAE",
    ReverseElement: "\u220B",
    ReverseEquilibrium: "\u21CB",
    ReverseUpEquilibrium: "\u296F",
    rfisht: "\u297D",
    rfloor: "\u230B",
    Rfr: "\u211C",
    rfr: "\u{1D52F}",
    rHar: "\u2964",
    rhard: "\u21C1",
    rharu: "\u21C0",
    rharul: "\u296C",
    Rho: "\u03A1",
    rho: "\u03C1",
    rhov: "\u03F1",
    RightAngleBracket: "\u27E9",
    RightArrow: "\u2192",
    Rightarrow: "\u21D2",
    rightarrow: "\u2192",
    RightArrowBar: "\u21E5",
    RightArrowLeftArrow: "\u21C4",
    rightarrowtail: "\u21A3",
    RightCeiling: "\u2309",
    RightDoubleBracket: "\u27E7",
    RightDownTeeVector: "\u295D",
    RightDownVector: "\u21C2",
    RightDownVectorBar: "\u2955",
    RightFloor: "\u230B",
    rightharpoondown: "\u21C1",
    rightharpoonup: "\u21C0",
    rightleftarrows: "\u21C4",
    rightleftharpoons: "\u21CC",
    rightrightarrows: "\u21C9",
    rightsquigarrow: "\u219D",
    RightTee: "\u22A2",
    RightTeeArrow: "\u21A6",
    RightTeeVector: "\u295B",
    rightthreetimes: "\u22CC",
    RightTriangle: "\u22B3",
    RightTriangleBar: "\u29D0",
    RightTriangleEqual: "\u22B5",
    RightUpDownVector: "\u294F",
    RightUpTeeVector: "\u295C",
    RightUpVector: "\u21BE",
    RightUpVectorBar: "\u2954",
    RightVector: "\u21C0",
    RightVectorBar: "\u2953",
    ring: "\u02DA",
    risingdotseq: "\u2253",
    rlarr: "\u21C4",
    rlhar: "\u21CC",
    rlm: "\u200F",
    rmoust: "\u23B1",
    rmoustache: "\u23B1",
    rnmid: "\u2AEE",
    roang: "\u27ED",
    roarr: "\u21FE",
    robrk: "\u27E7",
    ropar: "\u2986",
    Ropf: "\u211D",
    ropf: "\u{1D563}",
    roplus: "\u2A2E",
    rotimes: "\u2A35",
    RoundImplies: "\u2970",
    rpar: ")",
    rpargt: "\u2994",
    rppolint: "\u2A12",
    rrarr: "\u21C9",
    Rrightarrow: "\u21DB",
    rsaquo: "\u203A",
    Rscr: "\u211B",
    rscr: "\u{1D4C7}",
    Rsh: "\u21B1",
    rsh: "\u21B1",
    rsqb: "]",
    rsquo: "\u2019",
    rsquor: "\u2019",
    rthree: "\u22CC",
    rtimes: "\u22CA",
    rtri: "\u25B9",
    rtrie: "\u22B5",
    rtrif: "\u25B8",
    rtriltri: "\u29CE",
    RuleDelayed: "\u29F4",
    ruluhar: "\u2968",
    rx: "\u211E",
    Sacute: "\u015A",
    sacute: "\u015B",
    sbquo: "\u201A",
    Sc: "\u2ABC",
    sc: "\u227B",
    scap: "\u2AB8",
    Scaron: "\u0160",
    scaron: "\u0161",
    sccue: "\u227D",
    scE: "\u2AB4",
    sce: "\u2AB0",
    Scedil: "\u015E",
    scedil: "\u015F",
    Scirc: "\u015C",
    scirc: "\u015D",
    scnap: "\u2ABA",
    scnE: "\u2AB6",
    scnsim: "\u22E9",
    scpolint: "\u2A13",
    scsim: "\u227F",
    Scy: "\u0421",
    scy: "\u0441",
    sdot: "\u22C5",
    sdotb: "\u22A1",
    sdote: "\u2A66",
    searhk: "\u2925",
    seArr: "\u21D8",
    searr: "\u2198",
    searrow: "\u2198",
    sect: "\xA7",
    semi: ";",
    seswar: "\u2929",
    setminus: "\u2216",
    setmn: "\u2216",
    sext: "\u2736",
    Sfr: "\u{1D516}",
    sfr: "\u{1D530}",
    sfrown: "\u2322",
    sharp: "\u266F",
    SHCHcy: "\u0429",
    shchcy: "\u0449",
    SHcy: "\u0428",
    shcy: "\u0448",
    ShortDownArrow: "\u2193",
    ShortLeftArrow: "\u2190",
    shortmid: "\u2223",
    shortparallel: "\u2225",
    ShortRightArrow: "\u2192",
    ShortUpArrow: "\u2191",
    shy: "\xAD",
    Sigma: "\u03A3",
    sigma: "\u03C3",
    sigmaf: "\u03C2",
    sigmav: "\u03C2",
    sim: "\u223C",
    simdot: "\u2A6A",
    sime: "\u2243",
    simeq: "\u2243",
    simg: "\u2A9E",
    simgE: "\u2AA0",
    siml: "\u2A9D",
    simlE: "\u2A9F",
    simne: "\u2246",
    simplus: "\u2A24",
    simrarr: "\u2972",
    slarr: "\u2190",
    SmallCircle: "\u2218",
    smallsetminus: "\u2216",
    smashp: "\u2A33",
    smeparsl: "\u29E4",
    smid: "\u2223",
    smile: "\u2323",
    smt: "\u2AAA",
    smte: "\u2AAC",
    smtes: "\u2AAC\uFE00",
    SOFTcy: "\u042C",
    softcy: "\u044C",
    sol: "/",
    solb: "\u29C4",
    solbar: "\u233F",
    Sopf: "\u{1D54A}",
    sopf: "\u{1D564}",
    spades: "\u2660",
    spadesuit: "\u2660",
    spar: "\u2225",
    sqcap: "\u2293",
    sqcaps: "\u2293\uFE00",
    sqcup: "\u2294",
    sqcups: "\u2294\uFE00",
    Sqrt: "\u221A",
    sqsub: "\u228F",
    sqsube: "\u2291",
    sqsubset: "\u228F",
    sqsubseteq: "\u2291",
    sqsup: "\u2290",
    sqsupe: "\u2292",
    sqsupset: "\u2290",
    sqsupseteq: "\u2292",
    squ: "\u25A1",
    Square: "\u25A1",
    square: "\u25A1",
    SquareIntersection: "\u2293",
    SquareSubset: "\u228F",
    SquareSubsetEqual: "\u2291",
    SquareSuperset: "\u2290",
    SquareSupersetEqual: "\u2292",
    SquareUnion: "\u2294",
    squarf: "\u25AA",
    squf: "\u25AA",
    srarr: "\u2192",
    Sscr: "\u{1D4AE}",
    sscr: "\u{1D4C8}",
    ssetmn: "\u2216",
    ssmile: "\u2323",
    sstarf: "\u22C6",
    Star: "\u22C6",
    star: "\u2606",
    starf: "\u2605",
    straightepsilon: "\u03F5",
    straightphi: "\u03D5",
    strns: "\xAF",
    Sub: "\u22D0",
    sub: "\u2282",
    subdot: "\u2ABD",
    subE: "\u2AC5",
    sube: "\u2286",
    subedot: "\u2AC3",
    submult: "\u2AC1",
    subnE: "\u2ACB",
    subne: "\u228A",
    subplus: "\u2ABF",
    subrarr: "\u2979",
    Subset: "\u22D0",
    subset: "\u2282",
    subseteq: "\u2286",
    subseteqq: "\u2AC5",
    SubsetEqual: "\u2286",
    subsetneq: "\u228A",
    subsetneqq: "\u2ACB",
    subsim: "\u2AC7",
    subsub: "\u2AD5",
    subsup: "\u2AD3",
    succ: "\u227B",
    succapprox: "\u2AB8",
    succcurlyeq: "\u227D",
    Succeeds: "\u227B",
    SucceedsEqual: "\u2AB0",
    SucceedsSlantEqual: "\u227D",
    SucceedsTilde: "\u227F",
    succeq: "\u2AB0",
    succnapprox: "\u2ABA",
    succneqq: "\u2AB6",
    succnsim: "\u22E9",
    succsim: "\u227F",
    SuchThat: "\u220B",
    Sum: "\u2211",
    sum: "\u2211",
    sung: "\u266A",
    Sup: "\u22D1",
    sup: "\u2283",
    sup1: "\xB9",
    sup2: "\xB2",
    sup3: "\xB3",
    supdot: "\u2ABE",
    supdsub: "\u2AD8",
    supE: "\u2AC6",
    supe: "\u2287",
    supedot: "\u2AC4",
    Superset: "\u2283",
    SupersetEqual: "\u2287",
    suphsol: "\u27C9",
    suphsub: "\u2AD7",
    suplarr: "\u297B",
    supmult: "\u2AC2",
    supnE: "\u2ACC",
    supne: "\u228B",
    supplus: "\u2AC0",
    Supset: "\u22D1",
    supset: "\u2283",
    supseteq: "\u2287",
    supseteqq: "\u2AC6",
    supsetneq: "\u228B",
    supsetneqq: "\u2ACC",
    supsim: "\u2AC8",
    supsub: "\u2AD4",
    supsup: "\u2AD6",
    swarhk: "\u2926",
    swArr: "\u21D9",
    swarr: "\u2199",
    swarrow: "\u2199",
    swnwar: "\u292A",
    szlig: "\xDF",
    Tab: "	",
    target: "\u2316",
    Tau: "\u03A4",
    tau: "\u03C4",
    tbrk: "\u23B4",
    Tcaron: "\u0164",
    tcaron: "\u0165",
    Tcedil: "\u0162",
    tcedil: "\u0163",
    Tcy: "\u0422",
    tcy: "\u0442",
    tdot: "\u20DB",
    telrec: "\u2315",
    Tfr: "\u{1D517}",
    tfr: "\u{1D531}",
    there4: "\u2234",
    Therefore: "\u2234",
    therefore: "\u2234",
    Theta: "\u0398",
    theta: "\u03B8",
    thetasym: "\u03D1",
    thetav: "\u03D1",
    thickapprox: "\u2248",
    thicksim: "\u223C",
    ThickSpace: "\u205F\u200A",
    thinsp: "\u2009",
    ThinSpace: "\u2009",
    thkap: "\u2248",
    thksim: "\u223C",
    THORN: "\xDE",
    thorn: "\xFE",
    Tilde: "\u223C",
    tilde: "\u02DC",
    TildeEqual: "\u2243",
    TildeFullEqual: "\u2245",
    TildeTilde: "\u2248",
    times: "\xD7",
    timesb: "\u22A0",
    timesbar: "\u2A31",
    timesd: "\u2A30",
    tint: "\u222D",
    toea: "\u2928",
    top: "\u22A4",
    topbot: "\u2336",
    topcir: "\u2AF1",
    Topf: "\u{1D54B}",
    topf: "\u{1D565}",
    topfork: "\u2ADA",
    tosa: "\u2929",
    tprime: "\u2034",
    TRADE: "\u2122",
    trade: "\u2122",
    triangle: "\u25B5",
    triangledown: "\u25BF",
    triangleleft: "\u25C3",
    trianglelefteq: "\u22B4",
    triangleq: "\u225C",
    triangleright: "\u25B9",
    trianglerighteq: "\u22B5",
    tridot: "\u25EC",
    trie: "\u225C",
    triminus: "\u2A3A",
    TripleDot: "\u20DB",
    triplus: "\u2A39",
    trisb: "\u29CD",
    tritime: "\u2A3B",
    trpezium: "\u23E2",
    Tscr: "\u{1D4AF}",
    tscr: "\u{1D4C9}",
    TScy: "\u0426",
    tscy: "\u0446",
    TSHcy: "\u040B",
    tshcy: "\u045B",
    Tstrok: "\u0166",
    tstrok: "\u0167",
    twixt: "\u226C",
    twoheadleftarrow: "\u219E",
    twoheadrightarrow: "\u21A0",
    Uacute: "\xDA",
    uacute: "\xFA",
    Uarr: "\u219F",
    uArr: "\u21D1",
    uarr: "\u2191",
    Uarrocir: "\u2949",
    Ubrcy: "\u040E",
    ubrcy: "\u045E",
    Ubreve: "\u016C",
    ubreve: "\u016D",
    Ucirc: "\xDB",
    ucirc: "\xFB",
    Ucy: "\u0423",
    ucy: "\u0443",
    udarr: "\u21C5",
    Udblac: "\u0170",
    udblac: "\u0171",
    udhar: "\u296E",
    ufisht: "\u297E",
    Ufr: "\u{1D518}",
    ufr: "\u{1D532}",
    Ugrave: "\xD9",
    ugrave: "\xF9",
    uHar: "\u2963",
    uharl: "\u21BF",
    uharr: "\u21BE",
    uhblk: "\u2580",
    ulcorn: "\u231C",
    ulcorner: "\u231C",
    ulcrop: "\u230F",
    ultri: "\u25F8",
    Umacr: "\u016A",
    umacr: "\u016B",
    uml: "\xA8",
    UnderBar: "_",
    UnderBrace: "\u23DF",
    UnderBracket: "\u23B5",
    UnderParenthesis: "\u23DD",
    Union: "\u22C3",
    UnionPlus: "\u228E",
    Uogon: "\u0172",
    uogon: "\u0173",
    Uopf: "\u{1D54C}",
    uopf: "\u{1D566}",
    UpArrow: "\u2191",
    Uparrow: "\u21D1",
    uparrow: "\u2191",
    UpArrowBar: "\u2912",
    UpArrowDownArrow: "\u21C5",
    UpDownArrow: "\u2195",
    Updownarrow: "\u21D5",
    updownarrow: "\u2195",
    UpEquilibrium: "\u296E",
    upharpoonleft: "\u21BF",
    upharpoonright: "\u21BE",
    uplus: "\u228E",
    UpperLeftArrow: "\u2196",
    UpperRightArrow: "\u2197",
    Upsi: "\u03D2",
    upsi: "\u03C5",
    upsih: "\u03D2",
    Upsilon: "\u03A5",
    upsilon: "\u03C5",
    UpTee: "\u22A5",
    UpTeeArrow: "\u21A5",
    upuparrows: "\u21C8",
    urcorn: "\u231D",
    urcorner: "\u231D",
    urcrop: "\u230E",
    Uring: "\u016E",
    uring: "\u016F",
    urtri: "\u25F9",
    Uscr: "\u{1D4B0}",
    uscr: "\u{1D4CA}",
    utdot: "\u22F0",
    Utilde: "\u0168",
    utilde: "\u0169",
    utri: "\u25B5",
    utrif: "\u25B4",
    uuarr: "\u21C8",
    Uuml: "\xDC",
    uuml: "\xFC",
    uwangle: "\u29A7",
    vangrt: "\u299C",
    varepsilon: "\u03F5",
    varkappa: "\u03F0",
    varnothing: "\u2205",
    varphi: "\u03D5",
    varpi: "\u03D6",
    varpropto: "\u221D",
    vArr: "\u21D5",
    varr: "\u2195",
    varrho: "\u03F1",
    varsigma: "\u03C2",
    varsubsetneq: "\u228A\uFE00",
    varsubsetneqq: "\u2ACB\uFE00",
    varsupsetneq: "\u228B\uFE00",
    varsupsetneqq: "\u2ACC\uFE00",
    vartheta: "\u03D1",
    vartriangleleft: "\u22B2",
    vartriangleright: "\u22B3",
    Vbar: "\u2AEB",
    vBar: "\u2AE8",
    vBarv: "\u2AE9",
    Vcy: "\u0412",
    vcy: "\u0432",
    VDash: "\u22AB",
    Vdash: "\u22A9",
    vDash: "\u22A8",
    vdash: "\u22A2",
    Vdashl: "\u2AE6",
    Vee: "\u22C1",
    vee: "\u2228",
    veebar: "\u22BB",
    veeeq: "\u225A",
    vellip: "\u22EE",
    Verbar: "\u2016",
    verbar: "|",
    Vert: "\u2016",
    vert: "|",
    VerticalBar: "\u2223",
    VerticalLine: "|",
    VerticalSeparator: "\u2758",
    VerticalTilde: "\u2240",
    VeryThinSpace: "\u200A",
    Vfr: "\u{1D519}",
    vfr: "\u{1D533}",
    vltri: "\u22B2",
    vnsub: "\u2282\u20D2",
    vnsup: "\u2283\u20D2",
    Vopf: "\u{1D54D}",
    vopf: "\u{1D567}",
    vprop: "\u221D",
    vrtri: "\u22B3",
    Vscr: "\u{1D4B1}",
    vscr: "\u{1D4CB}",
    vsubnE: "\u2ACB\uFE00",
    vsubne: "\u228A\uFE00",
    vsupnE: "\u2ACC\uFE00",
    vsupne: "\u228B\uFE00",
    Vvdash: "\u22AA",
    vzigzag: "\u299A",
    Wcirc: "\u0174",
    wcirc: "\u0175",
    wedbar: "\u2A5F",
    Wedge: "\u22C0",
    wedge: "\u2227",
    wedgeq: "\u2259",
    weierp: "\u2118",
    Wfr: "\u{1D51A}",
    wfr: "\u{1D534}",
    Wopf: "\u{1D54E}",
    wopf: "\u{1D568}",
    wp: "\u2118",
    wr: "\u2240",
    wreath: "\u2240",
    Wscr: "\u{1D4B2}",
    wscr: "\u{1D4CC}",
    xcap: "\u22C2",
    xcirc: "\u25EF",
    xcup: "\u22C3",
    xdtri: "\u25BD",
    Xfr: "\u{1D51B}",
    xfr: "\u{1D535}",
    xhArr: "\u27FA",
    xharr: "\u27F7",
    Xi: "\u039E",
    xi: "\u03BE",
    xlArr: "\u27F8",
    xlarr: "\u27F5",
    xmap: "\u27FC",
    xnis: "\u22FB",
    xodot: "\u2A00",
    Xopf: "\u{1D54F}",
    xopf: "\u{1D569}",
    xoplus: "\u2A01",
    xotime: "\u2A02",
    xrArr: "\u27F9",
    xrarr: "\u27F6",
    Xscr: "\u{1D4B3}",
    xscr: "\u{1D4CD}",
    xsqcup: "\u2A06",
    xuplus: "\u2A04",
    xutri: "\u25B3",
    xvee: "\u22C1",
    xwedge: "\u22C0",
    Yacute: "\xDD",
    yacute: "\xFD",
    YAcy: "\u042F",
    yacy: "\u044F",
    Ycirc: "\u0176",
    ycirc: "\u0177",
    Ycy: "\u042B",
    ycy: "\u044B",
    yen: "\xA5",
    Yfr: "\u{1D51C}",
    yfr: "\u{1D536}",
    YIcy: "\u0407",
    yicy: "\u0457",
    Yopf: "\u{1D550}",
    yopf: "\u{1D56A}",
    Yscr: "\u{1D4B4}",
    yscr: "\u{1D4CE}",
    YUcy: "\u042E",
    yucy: "\u044E",
    Yuml: "\u0178",
    yuml: "\xFF",
    Zacute: "\u0179",
    zacute: "\u017A",
    Zcaron: "\u017D",
    zcaron: "\u017E",
    Zcy: "\u0417",
    zcy: "\u0437",
    Zdot: "\u017B",
    zdot: "\u017C",
    zeetrf: "\u2128",
    ZeroWidthSpace: "\u200B",
    Zeta: "\u0396",
    zeta: "\u03B6",
    Zfr: "\u2128",
    zfr: "\u{1D537}",
    ZHcy: "\u0416",
    zhcy: "\u0436",
    zigrarr: "\u21DD",
    Zopf: "\u2124",
    zopf: "\u{1D56B}",
    Zscr: "\u{1D4B5}",
    zscr: "\u{1D4CF}",
    zwj: "\u200D",
    zwnj: "\u200C"
  });
  exports.entityMap = exports.HTML_ENTITIES;
})(entities$1);
var sax$1 = {};
var NAMESPACE$1 = conventions$2.NAMESPACE;
var nameStartChar = /[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
var nameChar = new RegExp("[\\-\\.0-9" + nameStartChar.source.slice(1, -1) + "\\u00B7\\u0300-\\u036F\\u203F-\\u2040]");
var tagNamePattern = new RegExp("^" + nameStartChar.source + nameChar.source + "*(?::" + nameStartChar.source + nameChar.source + "*)?$");
var S_TAG = 0;
var S_ATTR = 1;
var S_ATTR_SPACE = 2;
var S_EQ = 3;
var S_ATTR_NOQUOT_VALUE = 4;
var S_ATTR_END = 5;
var S_TAG_SPACE = 6;
var S_TAG_CLOSE = 7;
function ParseError$1(message, locator) {
  this.message = message;
  this.locator = locator;
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ParseError$1);
}
ParseError$1.prototype = new Error();
ParseError$1.prototype.name = ParseError$1.name;
function XMLReader$1() {
}
XMLReader$1.prototype = {
  parse: function(source, defaultNSMap, entityMap) {
    var domBuilder = this.domBuilder;
    domBuilder.startDocument();
    _copy(defaultNSMap, defaultNSMap = {});
    parse$3(source, defaultNSMap, entityMap, domBuilder, this.errorHandler);
    domBuilder.endDocument();
  }
};
function parse$3(source, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
  function fixedFromCharCode(code) {
    if (code > 65535) {
      code -= 65536;
      var surrogate1 = 55296 + (code >> 10), surrogate2 = 56320 + (code & 1023);
      return String.fromCharCode(surrogate1, surrogate2);
    } else {
      return String.fromCharCode(code);
    }
  }
  function entityReplacer(a2) {
    var k = a2.slice(1, -1);
    if (Object.hasOwnProperty.call(entityMap, k)) {
      return entityMap[k];
    } else if (k.charAt(0) === "#") {
      return fixedFromCharCode(parseInt(k.substr(1).replace("x", "0x")));
    } else {
      errorHandler.error("entity not found:" + a2);
      return a2;
    }
  }
  function appendText(end4) {
    if (end4 > start2) {
      var xt = source.substring(start2, end4).replace(/&#?\w+;/g, entityReplacer);
      locator && position2(start2);
      domBuilder.characters(xt, 0, end4 - start2);
      start2 = end4;
    }
  }
  function position2(p2, m2) {
    while (p2 >= lineEnd && (m2 = linePattern.exec(source))) {
      lineStart = m2.index;
      lineEnd = lineStart + m2[0].length;
      locator.lineNumber++;
    }
    locator.columnNumber = p2 - lineStart + 1;
  }
  var lineStart = 0;
  var lineEnd = 0;
  var linePattern = /.*(?:\r\n?|\n)|.*$/g;
  var locator = domBuilder.locator;
  var parseStack = [{ currentNSMap: defaultNSMapCopy }];
  var closeMap = {};
  var start2 = 0;
  while (true) {
    try {
      var tagStart = source.indexOf("<", start2);
      if (tagStart < 0) {
        if (!source.substr(start2).match(/^\s*$/)) {
          var doc = domBuilder.doc;
          var text = doc.createTextNode(source.substr(start2));
          doc.appendChild(text);
          domBuilder.currentElement = text;
        }
        return;
      }
      if (tagStart > start2) {
        appendText(tagStart);
      }
      switch (source.charAt(tagStart + 1)) {
        case "/":
          var end3 = source.indexOf(">", tagStart + 3);
          var tagName = source.substring(tagStart + 2, end3).replace(/[ \t\n\r]+$/g, "");
          var config2 = parseStack.pop();
          if (end3 < 0) {
            tagName = source.substring(tagStart + 2).replace(/[\s<].*/, "");
            errorHandler.error("end tag name: " + tagName + " is not complete:" + config2.tagName);
            end3 = tagStart + 1 + tagName.length;
          } else if (tagName.match(/\s</)) {
            tagName = tagName.replace(/[\s<].*/, "");
            errorHandler.error("end tag name: " + tagName + " maybe not complete");
            end3 = tagStart + 1 + tagName.length;
          }
          var localNSMap = config2.localNSMap;
          var endMatch = config2.tagName == tagName;
          var endIgnoreCaseMach = endMatch || config2.tagName && config2.tagName.toLowerCase() == tagName.toLowerCase();
          if (endIgnoreCaseMach) {
            domBuilder.endElement(config2.uri, config2.localName, tagName);
            if (localNSMap) {
              for (var prefix in localNSMap) {
                if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
                  domBuilder.endPrefixMapping(prefix);
                }
              }
            }
            if (!endMatch) {
              errorHandler.fatalError("end tag name: " + tagName + " is not match the current start tagName:" + config2.tagName);
            }
          } else {
            parseStack.push(config2);
          }
          end3++;
          break;
        case "?":
          locator && position2(tagStart);
          end3 = parseInstruction(source, tagStart, domBuilder);
          break;
        case "!":
          locator && position2(tagStart);
          end3 = parseDCC(source, tagStart, domBuilder, errorHandler);
          break;
        default:
          locator && position2(tagStart);
          var el = new ElementAttributes();
          var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
          var end3 = parseElementStartPart(source, tagStart, el, currentNSMap, entityReplacer, errorHandler);
          var len = el.length;
          if (!el.closed && fixSelfClosed(source, end3, el.tagName, closeMap)) {
            el.closed = true;
            if (!entityMap.nbsp) {
              errorHandler.warning("unclosed xml attribute");
            }
          }
          if (locator && len) {
            var locator2 = copyLocator(locator, {});
            for (var i = 0; i < len; i++) {
              var a = el[i];
              position2(a.offset);
              a.locator = copyLocator(locator, {});
            }
            domBuilder.locator = locator2;
            if (appendElement$1(el, domBuilder, currentNSMap)) {
              parseStack.push(el);
            }
            domBuilder.locator = locator;
          } else {
            if (appendElement$1(el, domBuilder, currentNSMap)) {
              parseStack.push(el);
            }
          }
          if (NAMESPACE$1.isHTML(el.uri) && !el.closed) {
            end3 = parseHtmlSpecialContent(source, end3, el.tagName, entityReplacer, domBuilder);
          } else {
            end3++;
          }
      }
    } catch (e) {
      if (e instanceof ParseError$1) {
        throw e;
      }
      errorHandler.error("element parse error: " + e);
      end3 = -1;
    }
    if (end3 > start2) {
      start2 = end3;
    } else {
      appendText(Math.max(tagStart, start2) + 1);
    }
  }
}
function copyLocator(f2, t3) {
  t3.lineNumber = f2.lineNumber;
  t3.columnNumber = f2.columnNumber;
  return t3;
}
function parseElementStartPart(source, start2, el, currentNSMap, entityReplacer, errorHandler) {
  function addAttribute(qname, value2, startIndex) {
    if (el.attributeNames.hasOwnProperty(qname)) {
      errorHandler.fatalError("Attribute " + qname + " redefined");
    }
    el.addValue(qname, value2.replace(/[\t\n\r]/g, " ").replace(/&#?\w+;/g, entityReplacer), startIndex);
  }
  var attrName;
  var value;
  var p2 = ++start2;
  var s = S_TAG;
  while (true) {
    var c = source.charAt(p2);
    switch (c) {
      case "=":
        if (s === S_ATTR) {
          attrName = source.slice(start2, p2);
          s = S_EQ;
        } else if (s === S_ATTR_SPACE) {
          s = S_EQ;
        } else {
          throw new Error("attribute equal must after attrName");
        }
        break;
      case "'":
      case '"':
        if (s === S_EQ || s === S_ATTR) {
          if (s === S_ATTR) {
            errorHandler.warning('attribute value must after "="');
            attrName = source.slice(start2, p2);
          }
          start2 = p2 + 1;
          p2 = source.indexOf(c, start2);
          if (p2 > 0) {
            value = source.slice(start2, p2);
            addAttribute(attrName, value, start2 - 1);
            s = S_ATTR_END;
          } else {
            throw new Error("attribute value no end '" + c + "' match");
          }
        } else if (s == S_ATTR_NOQUOT_VALUE) {
          value = source.slice(start2, p2);
          addAttribute(attrName, value, start2);
          errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ")!!");
          start2 = p2 + 1;
          s = S_ATTR_END;
        } else {
          throw new Error('attribute value must after "="');
        }
        break;
      case "/":
        switch (s) {
          case S_TAG:
            el.setTagName(source.slice(start2, p2));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            s = S_TAG_CLOSE;
            el.closed = true;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
            break;
          case S_ATTR_SPACE:
            el.closed = true;
            break;
          default:
            throw new Error("attribute invalid close char('/')");
        }
        break;
      case "":
        errorHandler.error("unexpected end of input");
        if (s == S_TAG) {
          el.setTagName(source.slice(start2, p2));
        }
        return p2;
      case ">":
        switch (s) {
          case S_TAG:
            el.setTagName(source.slice(start2, p2));
          case S_ATTR_END:
          case S_TAG_SPACE:
          case S_TAG_CLOSE:
            break;
          case S_ATTR_NOQUOT_VALUE:
          case S_ATTR:
            value = source.slice(start2, p2);
            if (value.slice(-1) === "/") {
              el.closed = true;
              value = value.slice(0, -1);
            }
          case S_ATTR_SPACE:
            if (s === S_ATTR_SPACE) {
              value = attrName;
            }
            if (s == S_ATTR_NOQUOT_VALUE) {
              errorHandler.warning('attribute "' + value + '" missed quot(")!');
              addAttribute(attrName, value, start2);
            } else {
              if (!NAMESPACE$1.isHTML(currentNSMap[""]) || !value.match(/^(?:disabled|checked|selected)$/i)) {
                errorHandler.warning('attribute "' + value + '" missed value!! "' + value + '" instead!!');
              }
              addAttribute(value, value, start2);
            }
            break;
          case S_EQ:
            throw new Error("attribute value missed!!");
        }
        return p2;
      case "\x80":
        c = " ";
      default:
        if (c <= " ") {
          switch (s) {
            case S_TAG:
              el.setTagName(source.slice(start2, p2));
              s = S_TAG_SPACE;
              break;
            case S_ATTR:
              attrName = source.slice(start2, p2);
              s = S_ATTR_SPACE;
              break;
            case S_ATTR_NOQUOT_VALUE:
              var value = source.slice(start2, p2);
              errorHandler.warning('attribute "' + value + '" missed quot(")!!');
              addAttribute(attrName, value, start2);
            case S_ATTR_END:
              s = S_TAG_SPACE;
              break;
          }
        } else {
          switch (s) {
            case S_ATTR_SPACE:
              el.tagName;
              if (!NAMESPACE$1.isHTML(currentNSMap[""]) || !attrName.match(/^(?:disabled|checked|selected)$/i)) {
                errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
              }
              addAttribute(attrName, attrName, start2);
              start2 = p2;
              s = S_ATTR;
              break;
            case S_ATTR_END:
              errorHandler.warning('attribute space is required"' + attrName + '"!!');
            case S_TAG_SPACE:
              s = S_ATTR;
              start2 = p2;
              break;
            case S_EQ:
              s = S_ATTR_NOQUOT_VALUE;
              start2 = p2;
              break;
            case S_TAG_CLOSE:
              throw new Error("elements closed character '/' and '>' must be connected to");
          }
        }
    }
    p2++;
  }
}
function appendElement$1(el, domBuilder, currentNSMap) {
  var tagName = el.tagName;
  var localNSMap = null;
  var i = el.length;
  while (i--) {
    var a = el[i];
    var qName = a.qName;
    var value = a.value;
    var nsp = qName.indexOf(":");
    if (nsp > 0) {
      var prefix = a.prefix = qName.slice(0, nsp);
      var localName = qName.slice(nsp + 1);
      var nsPrefix = prefix === "xmlns" && localName;
    } else {
      localName = qName;
      prefix = null;
      nsPrefix = qName === "xmlns" && "";
    }
    a.localName = localName;
    if (nsPrefix !== false) {
      if (localNSMap == null) {
        localNSMap = {};
        _copy(currentNSMap, currentNSMap = {});
      }
      currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value;
      a.uri = NAMESPACE$1.XMLNS;
      domBuilder.startPrefixMapping(nsPrefix, value);
    }
  }
  var i = el.length;
  while (i--) {
    a = el[i];
    var prefix = a.prefix;
    if (prefix) {
      if (prefix === "xml") {
        a.uri = NAMESPACE$1.XML;
      }
      if (prefix !== "xmlns") {
        a.uri = currentNSMap[prefix || ""];
      }
    }
  }
  var nsp = tagName.indexOf(":");
  if (nsp > 0) {
    prefix = el.prefix = tagName.slice(0, nsp);
    localName = el.localName = tagName.slice(nsp + 1);
  } else {
    prefix = null;
    localName = el.localName = tagName;
  }
  var ns = el.uri = currentNSMap[prefix || ""];
  domBuilder.startElement(ns, localName, tagName, el);
  if (el.closed) {
    domBuilder.endElement(ns, localName, tagName);
    if (localNSMap) {
      for (prefix in localNSMap) {
        if (Object.prototype.hasOwnProperty.call(localNSMap, prefix)) {
          domBuilder.endPrefixMapping(prefix);
        }
      }
    }
  } else {
    el.currentNSMap = currentNSMap;
    el.localNSMap = localNSMap;
    return true;
  }
}
function parseHtmlSpecialContent(source, elStartEnd, tagName, entityReplacer, domBuilder) {
  if (/^(?:script|textarea)$/i.test(tagName)) {
    var elEndStart = source.indexOf("</" + tagName + ">", elStartEnd);
    var text = source.substring(elStartEnd + 1, elEndStart);
    if (/[&<]/.test(text)) {
      if (/^script$/i.test(tagName)) {
        domBuilder.characters(text, 0, text.length);
        return elEndStart;
      }
      text = text.replace(/&#?\w+;/g, entityReplacer);
      domBuilder.characters(text, 0, text.length);
      return elEndStart;
    }
  }
  return elStartEnd + 1;
}
function fixSelfClosed(source, elStartEnd, tagName, closeMap) {
  var pos = closeMap[tagName];
  if (pos == null) {
    pos = source.lastIndexOf("</" + tagName + ">");
    if (pos < elStartEnd) {
      pos = source.lastIndexOf("</" + tagName);
    }
    closeMap[tagName] = pos;
  }
  return pos < elStartEnd;
}
function _copy(source, target) {
  for (var n2 in source) {
    if (Object.prototype.hasOwnProperty.call(source, n2)) {
      target[n2] = source[n2];
    }
  }
}
function parseDCC(source, start2, domBuilder, errorHandler) {
  var next = source.charAt(start2 + 2);
  switch (next) {
    case "-":
      if (source.charAt(start2 + 3) === "-") {
        var end3 = source.indexOf("-->", start2 + 4);
        if (end3 > start2) {
          domBuilder.comment(source, start2 + 4, end3 - start2 - 4);
          return end3 + 3;
        } else {
          errorHandler.error("Unclosed comment");
          return -1;
        }
      } else {
        return -1;
      }
    default:
      if (source.substr(start2 + 3, 6) == "CDATA[") {
        var end3 = source.indexOf("]]>", start2 + 9);
        domBuilder.startCDATA();
        domBuilder.characters(source, start2 + 9, end3 - start2 - 9);
        domBuilder.endCDATA();
        return end3 + 3;
      }
      var matchs = split(source, start2);
      var len = matchs.length;
      if (len > 1 && /!doctype/i.test(matchs[0][0])) {
        var name = matchs[1][0];
        var pubid = false;
        var sysid = false;
        if (len > 3) {
          if (/^public$/i.test(matchs[2][0])) {
            pubid = matchs[3][0];
            sysid = len > 4 && matchs[4][0];
          } else if (/^system$/i.test(matchs[2][0])) {
            sysid = matchs[3][0];
          }
        }
        var lastMatch = matchs[len - 1];
        domBuilder.startDTD(name, pubid, sysid);
        domBuilder.endDTD();
        return lastMatch.index + lastMatch[0].length;
      }
  }
  return -1;
}
function parseInstruction(source, start2, domBuilder) {
  var end3 = source.indexOf("?>", start2);
  if (end3) {
    var match = source.substring(start2, end3).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);
    if (match) {
      match[0].length;
      domBuilder.processingInstruction(match[1], match[2]);
      return end3 + 2;
    } else {
      return -1;
    }
  }
  return -1;
}
function ElementAttributes() {
  this.attributeNames = {};
}
ElementAttributes.prototype = {
  setTagName: function(tagName) {
    if (!tagNamePattern.test(tagName)) {
      throw new Error("invalid tagName:" + tagName);
    }
    this.tagName = tagName;
  },
  addValue: function(qName, value, offset2) {
    if (!tagNamePattern.test(qName)) {
      throw new Error("invalid attribute:" + qName);
    }
    this.attributeNames[qName] = this.length;
    this[this.length++] = { qName, value, offset: offset2 };
  },
  length: 0,
  getLocalName: function(i) {
    return this[i].localName;
  },
  getLocator: function(i) {
    return this[i].locator;
  },
  getQName: function(i) {
    return this[i].qName;
  },
  getURI: function(i) {
    return this[i].uri;
  },
  getValue: function(i) {
    return this[i].value;
  }
};
function split(source, start2) {
  var match;
  var buf = [];
  var reg = /'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;
  reg.lastIndex = start2;
  reg.exec(source);
  while (match = reg.exec(source)) {
    buf.push(match);
    if (match[1])
      return buf;
  }
}
sax$1.XMLReader = XMLReader$1;
sax$1.ParseError = ParseError$1;
var conventions = conventions$2;
var dom$1 = dom$2;
var entities = entities$1;
var sax = sax$1;
var DOMImplementation = dom$1.DOMImplementation;
var NAMESPACE = conventions.NAMESPACE;
var ParseError = sax.ParseError;
var XMLReader = sax.XMLReader;
function normalizeLineEndings(input) {
  return input.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028]/g, "\n");
}
function DOMParser$1(options) {
  this.options = options || { locator: {} };
}
DOMParser$1.prototype.parseFromString = function(source, mimeType) {
  var options = this.options;
  var sax2 = new XMLReader();
  var domBuilder = options.domBuilder || new DOMHandler();
  var errorHandler = options.errorHandler;
  var locator = options.locator;
  var defaultNSMap = options.xmlns || {};
  var isHTML = /\/x?html?$/.test(mimeType);
  var entityMap = isHTML ? entities.HTML_ENTITIES : entities.XML_ENTITIES;
  if (locator) {
    domBuilder.setDocumentLocator(locator);
  }
  sax2.errorHandler = buildErrorHandler(errorHandler, domBuilder, locator);
  sax2.domBuilder = options.domBuilder || domBuilder;
  if (isHTML) {
    defaultNSMap[""] = NAMESPACE.HTML;
  }
  defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
  var normalize = options.normalizeLineEndings || normalizeLineEndings;
  if (source && typeof source === "string") {
    sax2.parse(normalize(source), defaultNSMap, entityMap);
  } else {
    sax2.errorHandler.error("invalid doc source");
  }
  return domBuilder.doc;
};
function buildErrorHandler(errorImpl, domBuilder, locator) {
  if (!errorImpl) {
    if (domBuilder instanceof DOMHandler) {
      return domBuilder;
    }
    errorImpl = domBuilder;
  }
  var errorHandler = {};
  var isCallback = errorImpl instanceof Function;
  locator = locator || {};
  function build3(key) {
    var fn = errorImpl[key];
    if (!fn && isCallback) {
      fn = errorImpl.length == 2 ? function(msg) {
        errorImpl(key, msg);
      } : errorImpl;
    }
    errorHandler[key] = fn && function(msg) {
      fn("[xmldom " + key + "]	" + msg + _locator(locator));
    } || function() {
    };
  }
  build3("warning");
  build3("error");
  build3("fatalError");
  return errorHandler;
}
function DOMHandler() {
  this.cdata = false;
}
function position(locator, node) {
  node.lineNumber = locator.lineNumber;
  node.columnNumber = locator.columnNumber;
}
DOMHandler.prototype = {
  startDocument: function() {
    this.doc = new DOMImplementation().createDocument(null, null, null);
    if (this.locator) {
      this.doc.documentURI = this.locator.systemId;
    }
  },
  startElement: function(namespaceURI, localName, qName, attrs) {
    var doc = this.doc;
    var el = doc.createElementNS(namespaceURI, qName || localName);
    var len = attrs.length;
    appendElement(this, el);
    this.currentElement = el;
    this.locator && position(this.locator, el);
    for (var i = 0; i < len; i++) {
      var namespaceURI = attrs.getURI(i);
      var value = attrs.getValue(i);
      var qName = attrs.getQName(i);
      var attr = doc.createAttributeNS(namespaceURI, qName);
      this.locator && position(attrs.getLocator(i), attr);
      attr.value = attr.nodeValue = value;
      el.setAttributeNode(attr);
    }
  },
  endElement: function(namespaceURI, localName, qName) {
    var current = this.currentElement;
    current.tagName;
    this.currentElement = current.parentNode;
  },
  startPrefixMapping: function(prefix, uri) {
  },
  endPrefixMapping: function(prefix) {
  },
  processingInstruction: function(target, data) {
    var ins = this.doc.createProcessingInstruction(target, data);
    this.locator && position(this.locator, ins);
    appendElement(this, ins);
  },
  ignorableWhitespace: function(ch2, start2, length) {
  },
  characters: function(chars, start2, length) {
    chars = _toString.apply(this, arguments);
    if (chars) {
      if (this.cdata) {
        var charNode = this.doc.createCDATASection(chars);
      } else {
        var charNode = this.doc.createTextNode(chars);
      }
      if (this.currentElement) {
        this.currentElement.appendChild(charNode);
      } else if (/^\s*$/.test(chars)) {
        this.doc.appendChild(charNode);
      }
      this.locator && position(this.locator, charNode);
    }
  },
  skippedEntity: function(name) {
  },
  endDocument: function() {
    this.doc.normalize();
  },
  setDocumentLocator: function(locator) {
    if (this.locator = locator) {
      locator.lineNumber = 0;
    }
  },
  comment: function(chars, start2, length) {
    chars = _toString.apply(this, arguments);
    var comm = this.doc.createComment(chars);
    this.locator && position(this.locator, comm);
    appendElement(this, comm);
  },
  startCDATA: function() {
    this.cdata = true;
  },
  endCDATA: function() {
    this.cdata = false;
  },
  startDTD: function(name, publicId, systemId) {
    var impl = this.doc.implementation;
    if (impl && impl.createDocumentType) {
      var dt = impl.createDocumentType(name, publicId, systemId);
      this.locator && position(this.locator, dt);
      appendElement(this, dt);
      this.doc.doctype = dt;
    }
  },
  warning: function(error2) {
    console.warn("[xmldom warning]	" + error2, _locator(this.locator));
  },
  error: function(error2) {
    console.error("[xmldom error]	" + error2, _locator(this.locator));
  },
  fatalError: function(error2) {
    throw new ParseError(error2, this.locator);
  }
};
function _locator(l) {
  if (l) {
    return "\n@" + (l.systemId || "") + "#[line:" + l.lineNumber + ",col:" + l.columnNumber + "]";
  }
}
function _toString(chars, start2, length) {
  if (typeof chars == "string") {
    return chars.substr(start2, length);
  } else {
    if (chars.length >= start2 + length || start2) {
      return new java.lang.String(chars, start2, length) + "";
    }
    return chars;
  }
}
"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g, function(key) {
  DOMHandler.prototype[key] = function() {
    return null;
  };
});
function appendElement(hander, node) {
  if (!hander.currentElement) {
    hander.doc.appendChild(node);
  } else {
    hander.currentElement.appendChild(node);
  }
}
domParser.__DOMHandler = DOMHandler;
domParser.normalizeLineEndings = normalizeLineEndings;
domParser.DOMParser = DOMParser$1;
var DOMParser = domParser.DOMParser;
/*! @name mpd-parser @version 0.22.1 @license Apache-2.0 */
var isObject$1 = function isObject(obj) {
  return !!obj && typeof obj === "object";
};
var merge = function merge2() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return objects.reduce(function(result2, source) {
    if (typeof source !== "object") {
      return result2;
    }
    Object.keys(source).forEach(function(key) {
      if (Array.isArray(result2[key]) && Array.isArray(source[key])) {
        result2[key] = result2[key].concat(source[key]);
      } else if (isObject$1(result2[key]) && isObject$1(source[key])) {
        result2[key] = merge2(result2[key], source[key]);
      } else {
        result2[key] = source[key];
      }
    });
    return result2;
  }, {});
};
var values = function values2(o) {
  return Object.keys(o).map(function(k) {
    return o[k];
  });
};
var range$1 = function range(start2, end3) {
  var result2 = [];
  for (var i = start2; i < end3; i++) {
    result2.push(i);
  }
  return result2;
};
var flatten = function flatten2(lists) {
  return lists.reduce(function(x, y2) {
    return x.concat(y2);
  }, []);
};
var from = function from2(list) {
  if (!list.length) {
    return [];
  }
  var result2 = [];
  for (var i = 0; i < list.length; i++) {
    result2.push(list[i]);
  }
  return result2;
};
var findIndexes = function findIndexes2(l, key) {
  return l.reduce(function(a, e, i) {
    if (e[key]) {
      a.push(i);
    }
    return a;
  }, []);
};
var findIndex = function findIndex2(list, matchingFunction) {
  for (var i = 0; i < list.length; i++) {
    if (matchingFunction(list[i])) {
      return i;
    }
  }
  return -1;
};
var union = function union2(lists, keyFunction) {
  return values(lists.reduce(function(acc, list) {
    list.forEach(function(el) {
      acc[keyFunction(el)] = el;
    });
    return acc;
  }, {}));
};
var errors = {
  INVALID_NUMBER_OF_PERIOD: "INVALID_NUMBER_OF_PERIOD",
  DASH_EMPTY_MANIFEST: "DASH_EMPTY_MANIFEST",
  DASH_INVALID_XML: "DASH_INVALID_XML",
  NO_BASE_URL: "NO_BASE_URL",
  MISSING_SEGMENT_INFORMATION: "MISSING_SEGMENT_INFORMATION",
  SEGMENT_TIME_UNSPECIFIED: "SEGMENT_TIME_UNSPECIFIED",
  UNSUPPORTED_UTC_TIMING_SCHEME: "UNSUPPORTED_UTC_TIMING_SCHEME"
};
var urlTypeToSegment = function urlTypeToSegment2(_ref2) {
  var _ref$baseUrl = _ref2.baseUrl, baseUrl = _ref$baseUrl === void 0 ? "" : _ref$baseUrl, _ref$source = _ref2.source, source = _ref$source === void 0 ? "" : _ref$source, _ref$range = _ref2.range, range3 = _ref$range === void 0 ? "" : _ref$range, _ref$indexRange = _ref2.indexRange, indexRange = _ref$indexRange === void 0 ? "" : _ref$indexRange;
  var segment = {
    uri: source,
    resolvedUri: resolveUrl$1(baseUrl || "", source)
  };
  if (range3 || indexRange) {
    var rangeStr = range3 ? range3 : indexRange;
    var ranges = rangeStr.split("-");
    var startRange = window_1.BigInt ? window_1.BigInt(ranges[0]) : parseInt(ranges[0], 10);
    var endRange = window_1.BigInt ? window_1.BigInt(ranges[1]) : parseInt(ranges[1], 10);
    if (startRange < Number.MAX_SAFE_INTEGER && typeof startRange === "bigint") {
      startRange = Number(startRange);
    }
    if (endRange < Number.MAX_SAFE_INTEGER && typeof endRange === "bigint") {
      endRange = Number(endRange);
    }
    var length;
    if (typeof endRange === "bigint" || typeof startRange === "bigint") {
      length = window_1.BigInt(endRange) - window_1.BigInt(startRange) + window_1.BigInt(1);
    } else {
      length = endRange - startRange + 1;
    }
    if (typeof length === "bigint" && length < Number.MAX_SAFE_INTEGER) {
      length = Number(length);
    }
    segment.byterange = {
      length,
      offset: startRange
    };
  }
  return segment;
};
var byteRangeToString = function byteRangeToString2(byterange) {
  var endRange;
  if (typeof byterange.offset === "bigint" || typeof byterange.length === "bigint") {
    endRange = window_1.BigInt(byterange.offset) + window_1.BigInt(byterange.length) - window_1.BigInt(1);
  } else {
    endRange = byterange.offset + byterange.length - 1;
  }
  return byterange.offset + "-" + endRange;
};
var parseEndNumber = function parseEndNumber2(endNumber) {
  if (endNumber && typeof endNumber !== "number") {
    endNumber = parseInt(endNumber, 10);
  }
  if (isNaN(endNumber)) {
    return null;
  }
  return endNumber;
};
var segmentRange = {
  static: function _static(attributes) {
    var duration5 = attributes.duration, _attributes$timescale = attributes.timescale, timescale2 = _attributes$timescale === void 0 ? 1 : _attributes$timescale, sourceDuration = attributes.sourceDuration, periodDuration = attributes.periodDuration;
    var endNumber = parseEndNumber(attributes.endNumber);
    var segmentDuration = duration5 / timescale2;
    if (typeof endNumber === "number") {
      return {
        start: 0,
        end: endNumber
      };
    }
    if (typeof periodDuration === "number") {
      return {
        start: 0,
        end: periodDuration / segmentDuration
      };
    }
    return {
      start: 0,
      end: sourceDuration / segmentDuration
    };
  },
  dynamic: function dynamic(attributes) {
    var NOW = attributes.NOW, clientOffset = attributes.clientOffset, availabilityStartTime2 = attributes.availabilityStartTime, _attributes$timescale2 = attributes.timescale, timescale2 = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2, duration5 = attributes.duration, _attributes$periodSta = attributes.periodStart, periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta, _attributes$minimumUp = attributes.minimumUpdatePeriod, minimumUpdatePeriod2 = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp, _attributes$timeShift = attributes.timeShiftBufferDepth, timeShiftBufferDepth2 = _attributes$timeShift === void 0 ? Infinity : _attributes$timeShift;
    var endNumber = parseEndNumber(attributes.endNumber);
    var now = (NOW + clientOffset) / 1e3;
    var periodStartWC = availabilityStartTime2 + periodStart;
    var periodEndWC = now + minimumUpdatePeriod2;
    var periodDuration = periodEndWC - periodStartWC;
    var segmentCount = Math.ceil(periodDuration * timescale2 / duration5);
    var availableStart = Math.floor((now - periodStartWC - timeShiftBufferDepth2) * timescale2 / duration5);
    var availableEnd = Math.floor((now - periodStartWC) * timescale2 / duration5);
    return {
      start: Math.max(0, availableStart),
      end: typeof endNumber === "number" ? endNumber : Math.min(segmentCount, availableEnd)
    };
  }
};
var toSegments = function toSegments2(attributes) {
  return function(number) {
    var duration5 = attributes.duration, _attributes$timescale3 = attributes.timescale, timescale2 = _attributes$timescale3 === void 0 ? 1 : _attributes$timescale3, periodStart = attributes.periodStart, _attributes$startNumb = attributes.startNumber, startNumber2 = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb;
    return {
      number: startNumber2 + number,
      duration: duration5 / timescale2,
      timeline: periodStart,
      time: number * duration5
    };
  };
};
var parseByDuration = function parseByDuration2(attributes) {
  var type2 = attributes.type, duration5 = attributes.duration, _attributes$timescale4 = attributes.timescale, timescale2 = _attributes$timescale4 === void 0 ? 1 : _attributes$timescale4, periodDuration = attributes.periodDuration, sourceDuration = attributes.sourceDuration;
  var _segmentRange$type = segmentRange[type2](attributes), start2 = _segmentRange$type.start, end3 = _segmentRange$type.end;
  var segments = range$1(start2, end3).map(toSegments(attributes));
  if (type2 === "static") {
    var index = segments.length - 1;
    var sectionDuration = typeof periodDuration === "number" ? periodDuration : sourceDuration;
    segments[index].duration = sectionDuration - duration5 / timescale2 * index;
  }
  return segments;
};
var segmentsFromBase = function segmentsFromBase2(attributes) {
  var baseUrl = attributes.baseUrl, _attributes$initializ = attributes.initialization, initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ, sourceDuration = attributes.sourceDuration, _attributes$indexRang = attributes.indexRange, indexRange = _attributes$indexRang === void 0 ? "" : _attributes$indexRang, periodStart = attributes.periodStart, presentationTime = attributes.presentationTime, _attributes$number = attributes.number, number = _attributes$number === void 0 ? 0 : _attributes$number, duration5 = attributes.duration;
  if (!baseUrl) {
    throw new Error(errors.NO_BASE_URL);
  }
  var initSegment = urlTypeToSegment({
    baseUrl,
    source: initialization.sourceURL,
    range: initialization.range
  });
  var segment = urlTypeToSegment({
    baseUrl,
    source: baseUrl,
    indexRange
  });
  segment.map = initSegment;
  if (duration5) {
    var segmentTimeInfo = parseByDuration(attributes);
    if (segmentTimeInfo.length) {
      segment.duration = segmentTimeInfo[0].duration;
      segment.timeline = segmentTimeInfo[0].timeline;
    }
  } else if (sourceDuration) {
    segment.duration = sourceDuration;
    segment.timeline = periodStart;
  }
  segment.presentationTime = presentationTime || periodStart;
  segment.number = number;
  return [segment];
};
var addSidxSegmentsToPlaylist$1 = function addSidxSegmentsToPlaylist(playlist, sidx, baseUrl) {
  var initSegment = playlist.sidx.map ? playlist.sidx.map : null;
  var sourceDuration = playlist.sidx.duration;
  var timeline = playlist.timeline || 0;
  var sidxByteRange = playlist.sidx.byterange;
  var sidxEnd = sidxByteRange.offset + sidxByteRange.length;
  var timescale2 = sidx.timescale;
  var mediaReferences = sidx.references.filter(function(r2) {
    return r2.referenceType !== 1;
  });
  var segments = [];
  var type2 = playlist.endList ? "static" : "dynamic";
  var periodStart = playlist.sidx.timeline;
  var presentationTime = periodStart;
  var number = playlist.mediaSequence || 0;
  var startIndex;
  if (typeof sidx.firstOffset === "bigint") {
    startIndex = window_1.BigInt(sidxEnd) + sidx.firstOffset;
  } else {
    startIndex = sidxEnd + sidx.firstOffset;
  }
  for (var i = 0; i < mediaReferences.length; i++) {
    var reference = sidx.references[i];
    var size = reference.referencedSize;
    var duration5 = reference.subsegmentDuration;
    var endIndex = void 0;
    if (typeof startIndex === "bigint") {
      endIndex = startIndex + window_1.BigInt(size) - window_1.BigInt(1);
    } else {
      endIndex = startIndex + size - 1;
    }
    var indexRange = startIndex + "-" + endIndex;
    var attributes = {
      baseUrl,
      timescale: timescale2,
      timeline,
      periodStart,
      presentationTime,
      number,
      duration: duration5,
      sourceDuration,
      indexRange,
      type: type2
    };
    var segment = segmentsFromBase(attributes)[0];
    if (initSegment) {
      segment.map = initSegment;
    }
    segments.push(segment);
    if (typeof startIndex === "bigint") {
      startIndex += window_1.BigInt(size);
    } else {
      startIndex += size;
    }
    presentationTime += duration5 / timescale2;
    number++;
  }
  playlist.segments = segments;
  return playlist;
};
var SUPPORTED_MEDIA_TYPES = ["AUDIO", "SUBTITLES"];
var TIME_FUDGE = 1 / 60;
var getUniqueTimelineStarts = function getUniqueTimelineStarts2(timelineStarts) {
  return union(timelineStarts, function(_ref2) {
    var timeline = _ref2.timeline;
    return timeline;
  }).sort(function(a, b) {
    return a.timeline > b.timeline ? 1 : -1;
  });
};
var findPlaylistWithName = function findPlaylistWithName2(playlists, name) {
  for (var i = 0; i < playlists.length; i++) {
    if (playlists[i].attributes.NAME === name) {
      return playlists[i];
    }
  }
  return null;
};
var getMediaGroupPlaylists = function getMediaGroupPlaylists2(manifest) {
  var mediaGroupPlaylists = [];
  forEachMediaGroup$1(manifest, SUPPORTED_MEDIA_TYPES, function(properties, type2, group, label) {
    mediaGroupPlaylists = mediaGroupPlaylists.concat(properties.playlists || []);
  });
  return mediaGroupPlaylists;
};
var updateMediaSequenceForPlaylist = function updateMediaSequenceForPlaylist2(_ref2) {
  var playlist = _ref2.playlist, mediaSequence = _ref2.mediaSequence;
  playlist.mediaSequence = mediaSequence;
  playlist.segments.forEach(function(segment, index) {
    segment.number = playlist.mediaSequence + index;
  });
};
var updateSequenceNumbers = function updateSequenceNumbers2(_ref3) {
  var oldPlaylists = _ref3.oldPlaylists, newPlaylists = _ref3.newPlaylists, timelineStarts = _ref3.timelineStarts;
  newPlaylists.forEach(function(playlist) {
    playlist.discontinuitySequence = findIndex(timelineStarts, function(_ref4) {
      var timeline = _ref4.timeline;
      return timeline === playlist.timeline;
    });
    var oldPlaylist = findPlaylistWithName(oldPlaylists, playlist.attributes.NAME);
    if (!oldPlaylist) {
      return;
    }
    if (playlist.sidx) {
      return;
    }
    var firstNewSegment = playlist.segments[0];
    var oldMatchingSegmentIndex = findIndex(oldPlaylist.segments, function(oldSegment) {
      return Math.abs(oldSegment.presentationTime - firstNewSegment.presentationTime) < TIME_FUDGE;
    });
    if (oldMatchingSegmentIndex === -1) {
      updateMediaSequenceForPlaylist({
        playlist,
        mediaSequence: oldPlaylist.mediaSequence + oldPlaylist.segments.length
      });
      playlist.segments[0].discontinuity = true;
      playlist.discontinuityStarts.unshift(0);
      if (!oldPlaylist.segments.length && playlist.timeline > oldPlaylist.timeline || oldPlaylist.segments.length && playlist.timeline > oldPlaylist.segments[oldPlaylist.segments.length - 1].timeline) {
        playlist.discontinuitySequence--;
      }
      return;
    }
    var oldMatchingSegment = oldPlaylist.segments[oldMatchingSegmentIndex];
    if (oldMatchingSegment.discontinuity && !firstNewSegment.discontinuity) {
      firstNewSegment.discontinuity = true;
      playlist.discontinuityStarts.unshift(0);
      playlist.discontinuitySequence--;
    }
    updateMediaSequenceForPlaylist({
      playlist,
      mediaSequence: oldPlaylist.segments[oldMatchingSegmentIndex].number
    });
  });
};
var positionManifestOnTimeline = function positionManifestOnTimeline2(_ref5) {
  var oldManifest = _ref5.oldManifest, newManifest = _ref5.newManifest;
  var oldPlaylists = oldManifest.playlists.concat(getMediaGroupPlaylists(oldManifest));
  var newPlaylists = newManifest.playlists.concat(getMediaGroupPlaylists(newManifest));
  newManifest.timelineStarts = getUniqueTimelineStarts([oldManifest.timelineStarts, newManifest.timelineStarts]);
  updateSequenceNumbers({
    oldPlaylists,
    newPlaylists,
    timelineStarts: newManifest.timelineStarts
  });
  return newManifest;
};
var generateSidxKey = function generateSidxKey2(sidx) {
  return sidx && sidx.uri + "-" + byteRangeToString(sidx.byterange);
};
var mergeDiscontiguousPlaylists = function mergeDiscontiguousPlaylists2(playlists) {
  var mergedPlaylists = values(playlists.reduce(function(acc, playlist) {
    var name = playlist.attributes.id + (playlist.attributes.lang || "");
    if (!acc[name]) {
      acc[name] = playlist;
      acc[name].attributes.timelineStarts = [];
    } else {
      if (playlist.segments) {
        var _acc$name$segments;
        if (playlist.segments[0]) {
          playlist.segments[0].discontinuity = true;
        }
        (_acc$name$segments = acc[name].segments).push.apply(_acc$name$segments, playlist.segments);
      }
      if (playlist.attributes.contentProtection) {
        acc[name].attributes.contentProtection = playlist.attributes.contentProtection;
      }
    }
    acc[name].attributes.timelineStarts.push({
      start: playlist.attributes.periodStart,
      timeline: playlist.attributes.periodStart
    });
    return acc;
  }, {}));
  return mergedPlaylists.map(function(playlist) {
    playlist.discontinuityStarts = findIndexes(playlist.segments || [], "discontinuity");
    return playlist;
  });
};
var addSidxSegmentsToPlaylist2 = function addSidxSegmentsToPlaylist3(playlist, sidxMapping) {
  var sidxKey = generateSidxKey(playlist.sidx);
  var sidxMatch = sidxKey && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx;
  if (sidxMatch) {
    addSidxSegmentsToPlaylist$1(playlist, sidxMatch, playlist.sidx.resolvedUri);
  }
  return playlist;
};
var addSidxSegmentsToPlaylists = function addSidxSegmentsToPlaylists2(playlists, sidxMapping) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  if (!Object.keys(sidxMapping).length) {
    return playlists;
  }
  for (var i in playlists) {
    playlists[i] = addSidxSegmentsToPlaylist2(playlists[i], sidxMapping);
  }
  return playlists;
};
var formatAudioPlaylist = function formatAudioPlaylist2(_ref2, isAudioOnly3) {
  var _attributes;
  var attributes = _ref2.attributes, segments = _ref2.segments, sidx = _ref2.sidx, mediaSequence = _ref2.mediaSequence, discontinuitySequence = _ref2.discontinuitySequence, discontinuityStarts = _ref2.discontinuityStarts;
  var playlist = {
    attributes: (_attributes = {
      NAME: attributes.id,
      BANDWIDTH: attributes.bandwidth,
      CODECS: attributes.codecs
    }, _attributes["PROGRAM-ID"] = 1, _attributes),
    uri: "",
    endList: attributes.type === "static",
    timeline: attributes.periodStart,
    resolvedUri: "",
    targetDuration: attributes.duration,
    discontinuitySequence,
    discontinuityStarts,
    timelineStarts: attributes.timelineStarts,
    mediaSequence,
    segments
  };
  if (attributes.contentProtection) {
    playlist.contentProtection = attributes.contentProtection;
  }
  if (sidx) {
    playlist.sidx = sidx;
  }
  if (isAudioOnly3) {
    playlist.attributes.AUDIO = "audio";
    playlist.attributes.SUBTITLES = "subs";
  }
  return playlist;
};
var formatVttPlaylist = function formatVttPlaylist2(_ref2) {
  var _m3u8Attributes;
  var attributes = _ref2.attributes, segments = _ref2.segments, mediaSequence = _ref2.mediaSequence, discontinuityStarts = _ref2.discontinuityStarts, discontinuitySequence = _ref2.discontinuitySequence;
  if (typeof segments === "undefined") {
    segments = [{
      uri: attributes.baseUrl,
      timeline: attributes.periodStart,
      resolvedUri: attributes.baseUrl || "",
      duration: attributes.sourceDuration,
      number: 0
    }];
    attributes.duration = attributes.sourceDuration;
  }
  var m3u8Attributes = (_m3u8Attributes = {
    NAME: attributes.id,
    BANDWIDTH: attributes.bandwidth
  }, _m3u8Attributes["PROGRAM-ID"] = 1, _m3u8Attributes);
  if (attributes.codecs) {
    m3u8Attributes.CODECS = attributes.codecs;
  }
  return {
    attributes: m3u8Attributes,
    uri: "",
    endList: attributes.type === "static",
    timeline: attributes.periodStart,
    resolvedUri: attributes.baseUrl || "",
    targetDuration: attributes.duration,
    timelineStarts: attributes.timelineStarts,
    discontinuityStarts,
    discontinuitySequence,
    mediaSequence,
    segments
  };
};
var organizeAudioPlaylists = function organizeAudioPlaylists2(playlists, sidxMapping, isAudioOnly3) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  if (isAudioOnly3 === void 0) {
    isAudioOnly3 = false;
  }
  var mainPlaylist;
  var formattedPlaylists = playlists.reduce(function(a, playlist) {
    var role = playlist.attributes.role && playlist.attributes.role.value || "";
    var language = playlist.attributes.lang || "";
    var label = playlist.attributes.label || "main";
    if (language && !playlist.attributes.label) {
      var roleLabel = role ? " (" + role + ")" : "";
      label = "" + playlist.attributes.lang + roleLabel;
    }
    if (!a[label]) {
      a[label] = {
        language,
        autoselect: true,
        default: role === "main",
        playlists: [],
        uri: ""
      };
    }
    var formatted = addSidxSegmentsToPlaylist2(formatAudioPlaylist(playlist, isAudioOnly3), sidxMapping);
    a[label].playlists.push(formatted);
    if (typeof mainPlaylist === "undefined" && role === "main") {
      mainPlaylist = playlist;
      mainPlaylist.default = true;
    }
    return a;
  }, {});
  if (!mainPlaylist) {
    var firstLabel = Object.keys(formattedPlaylists)[0];
    formattedPlaylists[firstLabel].default = true;
  }
  return formattedPlaylists;
};
var organizeVttPlaylists = function organizeVttPlaylists2(playlists, sidxMapping) {
  if (sidxMapping === void 0) {
    sidxMapping = {};
  }
  return playlists.reduce(function(a, playlist) {
    var label = playlist.attributes.lang || "text";
    if (!a[label]) {
      a[label] = {
        language: label,
        default: false,
        autoselect: false,
        playlists: [],
        uri: ""
      };
    }
    a[label].playlists.push(addSidxSegmentsToPlaylist2(formatVttPlaylist(playlist), sidxMapping));
    return a;
  }, {});
};
var organizeCaptionServices = function organizeCaptionServices2(captionServices) {
  return captionServices.reduce(function(svcObj, svc) {
    if (!svc) {
      return svcObj;
    }
    svc.forEach(function(service) {
      var channel = service.channel, language = service.language;
      svcObj[language] = {
        autoselect: false,
        default: false,
        instreamId: channel,
        language
      };
      if (service.hasOwnProperty("aspectRatio")) {
        svcObj[language].aspectRatio = service.aspectRatio;
      }
      if (service.hasOwnProperty("easyReader")) {
        svcObj[language].easyReader = service.easyReader;
      }
      if (service.hasOwnProperty("3D")) {
        svcObj[language]["3D"] = service["3D"];
      }
    });
    return svcObj;
  }, {});
};
var formatVideoPlaylist = function formatVideoPlaylist2(_ref3) {
  var _attributes2;
  var attributes = _ref3.attributes, segments = _ref3.segments, sidx = _ref3.sidx, discontinuityStarts = _ref3.discontinuityStarts;
  var playlist = {
    attributes: (_attributes2 = {
      NAME: attributes.id,
      AUDIO: "audio",
      SUBTITLES: "subs",
      RESOLUTION: {
        width: attributes.width,
        height: attributes.height
      },
      CODECS: attributes.codecs,
      BANDWIDTH: attributes.bandwidth
    }, _attributes2["PROGRAM-ID"] = 1, _attributes2),
    uri: "",
    endList: attributes.type === "static",
    timeline: attributes.periodStart,
    resolvedUri: "",
    targetDuration: attributes.duration,
    discontinuityStarts,
    timelineStarts: attributes.timelineStarts,
    segments
  };
  if (attributes.frameRate) {
    playlist.attributes["FRAME-RATE"] = attributes.frameRate;
  }
  if (attributes.contentProtection) {
    playlist.contentProtection = attributes.contentProtection;
  }
  if (sidx) {
    playlist.sidx = sidx;
  }
  return playlist;
};
var videoOnly = function videoOnly2(_ref4) {
  var attributes = _ref4.attributes;
  return attributes.mimeType === "video/mp4" || attributes.mimeType === "video/webm" || attributes.contentType === "video";
};
var audioOnly = function audioOnly2(_ref5) {
  var attributes = _ref5.attributes;
  return attributes.mimeType === "audio/mp4" || attributes.mimeType === "audio/webm" || attributes.contentType === "audio";
};
var vttOnly = function vttOnly2(_ref6) {
  var attributes = _ref6.attributes;
  return attributes.mimeType === "text/vtt" || attributes.contentType === "text";
};
var addMediaSequenceValues = function addMediaSequenceValues2(playlists, timelineStarts) {
  playlists.forEach(function(playlist) {
    playlist.mediaSequence = 0;
    playlist.discontinuitySequence = findIndex(timelineStarts, function(_ref7) {
      var timeline = _ref7.timeline;
      return timeline === playlist.timeline;
    });
    if (!playlist.segments) {
      return;
    }
    playlist.segments.forEach(function(segment, index) {
      segment.number = index;
    });
  });
};
var flattenMediaGroupPlaylists = function flattenMediaGroupPlaylists2(mediaGroupObject) {
  if (!mediaGroupObject) {
    return [];
  }
  return Object.keys(mediaGroupObject).reduce(function(acc, label) {
    var labelContents = mediaGroupObject[label];
    return acc.concat(labelContents.playlists);
  }, []);
};
var toM3u8 = function toM3u82(_ref8) {
  var _mediaGroups;
  var dashPlaylists = _ref8.dashPlaylists, locations = _ref8.locations, _ref8$sidxMapping = _ref8.sidxMapping, sidxMapping = _ref8$sidxMapping === void 0 ? {} : _ref8$sidxMapping, previousManifest = _ref8.previousManifest;
  if (!dashPlaylists.length) {
    return {};
  }
  var _dashPlaylists$0$attr = dashPlaylists[0].attributes, duration5 = _dashPlaylists$0$attr.sourceDuration, type2 = _dashPlaylists$0$attr.type, suggestedPresentationDelay2 = _dashPlaylists$0$attr.suggestedPresentationDelay, minimumUpdatePeriod2 = _dashPlaylists$0$attr.minimumUpdatePeriod;
  var videoPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(videoOnly)).map(formatVideoPlaylist);
  var audioPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(audioOnly));
  var vttPlaylists = mergeDiscontiguousPlaylists(dashPlaylists.filter(vttOnly));
  var captions = dashPlaylists.map(function(playlist) {
    return playlist.attributes.captionServices;
  }).filter(Boolean);
  var manifest = {
    allowCache: true,
    discontinuityStarts: [],
    segments: [],
    endList: true,
    mediaGroups: (_mediaGroups = {
      AUDIO: {},
      VIDEO: {}
    }, _mediaGroups["CLOSED-CAPTIONS"] = {}, _mediaGroups.SUBTITLES = {}, _mediaGroups),
    uri: "",
    duration: duration5,
    playlists: addSidxSegmentsToPlaylists(videoPlaylists, sidxMapping)
  };
  if (minimumUpdatePeriod2 >= 0) {
    manifest.minimumUpdatePeriod = minimumUpdatePeriod2 * 1e3;
  }
  if (locations) {
    manifest.locations = locations;
  }
  if (type2 === "dynamic") {
    manifest.suggestedPresentationDelay = suggestedPresentationDelay2;
  }
  var isAudioOnly3 = manifest.playlists.length === 0;
  var organizedAudioGroup = audioPlaylists.length ? organizeAudioPlaylists(audioPlaylists, sidxMapping, isAudioOnly3) : null;
  var organizedVttGroup = vttPlaylists.length ? organizeVttPlaylists(vttPlaylists, sidxMapping) : null;
  var formattedPlaylists = videoPlaylists.concat(flattenMediaGroupPlaylists(organizedAudioGroup), flattenMediaGroupPlaylists(organizedVttGroup));
  var playlistTimelineStarts = formattedPlaylists.map(function(_ref9) {
    var timelineStarts = _ref9.timelineStarts;
    return timelineStarts;
  });
  manifest.timelineStarts = getUniqueTimelineStarts(playlistTimelineStarts);
  addMediaSequenceValues(formattedPlaylists, manifest.timelineStarts);
  if (organizedAudioGroup) {
    manifest.mediaGroups.AUDIO.audio = organizedAudioGroup;
  }
  if (organizedVttGroup) {
    manifest.mediaGroups.SUBTITLES.subs = organizedVttGroup;
  }
  if (captions.length) {
    manifest.mediaGroups["CLOSED-CAPTIONS"].cc = organizeCaptionServices(captions);
  }
  if (previousManifest) {
    return positionManifestOnTimeline({
      oldManifest: previousManifest,
      newManifest: manifest
    });
  }
  return manifest;
};
var getLiveRValue = function getLiveRValue2(attributes, time, duration5) {
  var NOW = attributes.NOW, clientOffset = attributes.clientOffset, availabilityStartTime2 = attributes.availabilityStartTime, _attributes$timescale = attributes.timescale, timescale2 = _attributes$timescale === void 0 ? 1 : _attributes$timescale, _attributes$periodSta = attributes.periodStart, periodStart = _attributes$periodSta === void 0 ? 0 : _attributes$periodSta, _attributes$minimumUp = attributes.minimumUpdatePeriod, minimumUpdatePeriod2 = _attributes$minimumUp === void 0 ? 0 : _attributes$minimumUp;
  var now = (NOW + clientOffset) / 1e3;
  var periodStartWC = availabilityStartTime2 + periodStart;
  var periodEndWC = now + minimumUpdatePeriod2;
  var periodDuration = periodEndWC - periodStartWC;
  return Math.ceil((periodDuration * timescale2 - time) / duration5);
};
var parseByTimeline = function parseByTimeline2(attributes, segmentTimeline) {
  var type2 = attributes.type, _attributes$minimumUp2 = attributes.minimumUpdatePeriod, minimumUpdatePeriod2 = _attributes$minimumUp2 === void 0 ? 0 : _attributes$minimumUp2, _attributes$media = attributes.media, media = _attributes$media === void 0 ? "" : _attributes$media, sourceDuration = attributes.sourceDuration, _attributes$timescale2 = attributes.timescale, timescale2 = _attributes$timescale2 === void 0 ? 1 : _attributes$timescale2, _attributes$startNumb = attributes.startNumber, startNumber2 = _attributes$startNumb === void 0 ? 1 : _attributes$startNumb, timeline = attributes.periodStart;
  var segments = [];
  var time = -1;
  for (var sIndex = 0; sIndex < segmentTimeline.length; sIndex++) {
    var S2 = segmentTimeline[sIndex];
    var duration5 = S2.d;
    var repeat = S2.r || 0;
    var segmentTime = S2.t || 0;
    if (time < 0) {
      time = segmentTime;
    }
    if (segmentTime && segmentTime > time) {
      time = segmentTime;
    }
    var count = void 0;
    if (repeat < 0) {
      var nextS = sIndex + 1;
      if (nextS === segmentTimeline.length) {
        if (type2 === "dynamic" && minimumUpdatePeriod2 > 0 && media.indexOf("$Number$") > 0) {
          count = getLiveRValue(attributes, time, duration5);
        } else {
          count = (sourceDuration * timescale2 - time) / duration5;
        }
      } else {
        count = (segmentTimeline[nextS].t - time) / duration5;
      }
    } else {
      count = repeat + 1;
    }
    var end3 = startNumber2 + segments.length + count;
    var number = startNumber2 + segments.length;
    while (number < end3) {
      segments.push({
        number,
        duration: duration5 / timescale2,
        time,
        timeline
      });
      time += duration5;
      number++;
    }
  }
  return segments;
};
var identifierPattern = /\$([A-z]*)(?:(%0)([0-9]+)d)?\$/g;
var identifierReplacement = function identifierReplacement2(values3) {
  return function(match, identifier, format, width2) {
    if (match === "$$") {
      return "$";
    }
    if (typeof values3[identifier] === "undefined") {
      return match;
    }
    var value = "" + values3[identifier];
    if (identifier === "RepresentationID") {
      return value;
    }
    if (!format) {
      width2 = 1;
    } else {
      width2 = parseInt(width2, 10);
    }
    if (value.length >= width2) {
      return value;
    }
    return "" + new Array(width2 - value.length + 1).join("0") + value;
  };
};
var constructTemplateUrl = function constructTemplateUrl2(url, values3) {
  return url.replace(identifierPattern, identifierReplacement(values3));
};
var parseTemplateInfo = function parseTemplateInfo2(attributes, segmentTimeline) {
  if (!attributes.duration && !segmentTimeline) {
    return [{
      number: attributes.startNumber || 1,
      duration: attributes.sourceDuration,
      time: 0,
      timeline: attributes.periodStart
    }];
  }
  if (attributes.duration) {
    return parseByDuration(attributes);
  }
  return parseByTimeline(attributes, segmentTimeline);
};
var segmentsFromTemplate = function segmentsFromTemplate2(attributes, segmentTimeline) {
  var templateValues = {
    RepresentationID: attributes.id,
    Bandwidth: attributes.bandwidth || 0
  };
  var _attributes$initializ = attributes.initialization, initialization = _attributes$initializ === void 0 ? {
    sourceURL: "",
    range: ""
  } : _attributes$initializ;
  var mapSegment = urlTypeToSegment({
    baseUrl: attributes.baseUrl,
    source: constructTemplateUrl(initialization.sourceURL, templateValues),
    range: initialization.range
  });
  var segments = parseTemplateInfo(attributes, segmentTimeline);
  return segments.map(function(segment) {
    templateValues.Number = segment.number;
    templateValues.Time = segment.time;
    var uri = constructTemplateUrl(attributes.media || "", templateValues);
    var timescale2 = attributes.timescale || 1;
    var presentationTimeOffset2 = attributes.presentationTimeOffset || 0;
    var presentationTime = attributes.periodStart + (segment.time - presentationTimeOffset2) / timescale2;
    var map = {
      uri,
      timeline: segment.timeline,
      duration: segment.duration,
      resolvedUri: resolveUrl$1(attributes.baseUrl || "", uri),
      map: mapSegment,
      number: segment.number,
      presentationTime
    };
    return map;
  });
};
var SegmentURLToSegmentObject = function SegmentURLToSegmentObject2(attributes, segmentUrl) {
  var baseUrl = attributes.baseUrl, _attributes$initializ = attributes.initialization, initialization = _attributes$initializ === void 0 ? {} : _attributes$initializ;
  var initSegment = urlTypeToSegment({
    baseUrl,
    source: initialization.sourceURL,
    range: initialization.range
  });
  var segment = urlTypeToSegment({
    baseUrl,
    source: segmentUrl.media,
    range: segmentUrl.mediaRange
  });
  segment.map = initSegment;
  return segment;
};
var segmentsFromList = function segmentsFromList2(attributes, segmentTimeline) {
  var duration5 = attributes.duration, _attributes$segmentUr = attributes.segmentUrls, segmentUrls = _attributes$segmentUr === void 0 ? [] : _attributes$segmentUr, periodStart = attributes.periodStart;
  if (!duration5 && !segmentTimeline || duration5 && segmentTimeline) {
    throw new Error(errors.SEGMENT_TIME_UNSPECIFIED);
  }
  var segmentUrlMap = segmentUrls.map(function(segmentUrlObject) {
    return SegmentURLToSegmentObject(attributes, segmentUrlObject);
  });
  var segmentTimeInfo;
  if (duration5) {
    segmentTimeInfo = parseByDuration(attributes);
  }
  if (segmentTimeline) {
    segmentTimeInfo = parseByTimeline(attributes, segmentTimeline);
  }
  var segments = segmentTimeInfo.map(function(segmentTime, index) {
    if (segmentUrlMap[index]) {
      var segment = segmentUrlMap[index];
      var timescale2 = attributes.timescale || 1;
      var presentationTimeOffset2 = attributes.presentationTimeOffset || 0;
      segment.timeline = segmentTime.timeline;
      segment.duration = segmentTime.duration;
      segment.number = segmentTime.number;
      segment.presentationTime = periodStart + (segmentTime.time - presentationTimeOffset2) / timescale2;
      return segment;
    }
  }).filter(function(segment) {
    return segment;
  });
  return segments;
};
var generateSegments = function generateSegments2(_ref2) {
  var attributes = _ref2.attributes, segmentInfo = _ref2.segmentInfo;
  var segmentAttributes;
  var segmentsFn;
  if (segmentInfo.template) {
    segmentsFn = segmentsFromTemplate;
    segmentAttributes = merge(attributes, segmentInfo.template);
  } else if (segmentInfo.base) {
    segmentsFn = segmentsFromBase;
    segmentAttributes = merge(attributes, segmentInfo.base);
  } else if (segmentInfo.list) {
    segmentsFn = segmentsFromList;
    segmentAttributes = merge(attributes, segmentInfo.list);
  }
  var segmentsInfo = {
    attributes
  };
  if (!segmentsFn) {
    return segmentsInfo;
  }
  var segments = segmentsFn(segmentAttributes, segmentInfo.segmentTimeline);
  if (segmentAttributes.duration) {
    var _segmentAttributes = segmentAttributes, duration5 = _segmentAttributes.duration, _segmentAttributes$ti = _segmentAttributes.timescale, timescale2 = _segmentAttributes$ti === void 0 ? 1 : _segmentAttributes$ti;
    segmentAttributes.duration = duration5 / timescale2;
  } else if (segments.length) {
    segmentAttributes.duration = segments.reduce(function(max, segment) {
      return Math.max(max, Math.ceil(segment.duration));
    }, 0);
  } else {
    segmentAttributes.duration = 0;
  }
  segmentsInfo.attributes = segmentAttributes;
  segmentsInfo.segments = segments;
  if (segmentInfo.base && segmentAttributes.indexRange) {
    segmentsInfo.sidx = segments[0];
    segmentsInfo.segments = [];
  }
  return segmentsInfo;
};
var toPlaylists = function toPlaylists2(representations) {
  return representations.map(generateSegments);
};
var findChildren = function findChildren2(element, name) {
  return from(element.childNodes).filter(function(_ref2) {
    var tagName = _ref2.tagName;
    return tagName === name;
  });
};
var getContent = function getContent2(element) {
  return element.textContent.trim();
};
var parseDivisionValue = function parseDivisionValue2(value) {
  return parseFloat(value.split("/").reduce(function(prev, current) {
    return prev / current;
  }));
};
var parseDuration = function parseDuration2(str) {
  var SECONDS_IN_YEAR = 365 * 24 * 60 * 60;
  var SECONDS_IN_MONTH = 30 * 24 * 60 * 60;
  var SECONDS_IN_DAY = 24 * 60 * 60;
  var SECONDS_IN_HOUR = 60 * 60;
  var SECONDS_IN_MIN = 60;
  var durationRegex = /P(?:(\d*)Y)?(?:(\d*)M)?(?:(\d*)D)?(?:T(?:(\d*)H)?(?:(\d*)M)?(?:([\d.]*)S)?)?/;
  var match = durationRegex.exec(str);
  if (!match) {
    return 0;
  }
  var _match$slice = match.slice(1), year = _match$slice[0], month = _match$slice[1], day = _match$slice[2], hour = _match$slice[3], minute = _match$slice[4], second = _match$slice[5];
  return parseFloat(year || 0) * SECONDS_IN_YEAR + parseFloat(month || 0) * SECONDS_IN_MONTH + parseFloat(day || 0) * SECONDS_IN_DAY + parseFloat(hour || 0) * SECONDS_IN_HOUR + parseFloat(minute || 0) * SECONDS_IN_MIN + parseFloat(second || 0);
};
var parseDate = function parseDate2(str) {
  var dateRegex = /^\d+-\d+-\d+T\d+:\d+:\d+(\.\d+)?$/;
  if (dateRegex.test(str)) {
    str += "Z";
  }
  return Date.parse(str);
};
var parsers = {
  mediaPresentationDuration: function mediaPresentationDuration(value) {
    return parseDuration(value);
  },
  availabilityStartTime: function availabilityStartTime(value) {
    return parseDate(value) / 1e3;
  },
  minimumUpdatePeriod: function minimumUpdatePeriod(value) {
    return parseDuration(value);
  },
  suggestedPresentationDelay: function suggestedPresentationDelay(value) {
    return parseDuration(value);
  },
  type: function type(value) {
    return value;
  },
  timeShiftBufferDepth: function timeShiftBufferDepth(value) {
    return parseDuration(value);
  },
  start: function start(value) {
    return parseDuration(value);
  },
  width: function width(value) {
    return parseInt(value, 10);
  },
  height: function height(value) {
    return parseInt(value, 10);
  },
  bandwidth: function bandwidth(value) {
    return parseInt(value, 10);
  },
  frameRate: function frameRate(value) {
    return parseDivisionValue(value);
  },
  startNumber: function startNumber(value) {
    return parseInt(value, 10);
  },
  timescale: function timescale(value) {
    return parseInt(value, 10);
  },
  presentationTimeOffset: function presentationTimeOffset(value) {
    return parseInt(value, 10);
  },
  duration: function duration(value) {
    var parsedValue = parseInt(value, 10);
    if (isNaN(parsedValue)) {
      return parseDuration(value);
    }
    return parsedValue;
  },
  d: function d(value) {
    return parseInt(value, 10);
  },
  t: function t2(value) {
    return parseInt(value, 10);
  },
  r: function r(value) {
    return parseInt(value, 10);
  },
  DEFAULT: function DEFAULT(value) {
    return value;
  }
};
var parseAttributes2 = function parseAttributes3(el) {
  if (!(el && el.attributes)) {
    return {};
  }
  return from(el.attributes).reduce(function(a, e) {
    var parseFn = parsers[e.name] || parsers.DEFAULT;
    a[e.name] = parseFn(e.value);
    return a;
  }, {});
};
var keySystemsMap = {
  "urn:uuid:1077efec-c0b2-4d02-ace3-3c1e52e2fb4b": "org.w3.clearkey",
  "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed": "com.widevine.alpha",
  "urn:uuid:9a04f079-9840-4286-ab92-e65be0885f95": "com.microsoft.playready",
  "urn:uuid:f239e769-efa3-4850-9c16-a903c6932efb": "com.adobe.primetime"
};
var buildBaseUrls = function buildBaseUrls2(referenceUrls, baseUrlElements) {
  if (!baseUrlElements.length) {
    return referenceUrls;
  }
  return flatten(referenceUrls.map(function(reference) {
    return baseUrlElements.map(function(baseUrlElement) {
      return resolveUrl$1(reference, getContent(baseUrlElement));
    });
  }));
};
var getSegmentInformation = function getSegmentInformation2(adaptationSet) {
  var segmentTemplate = findChildren(adaptationSet, "SegmentTemplate")[0];
  var segmentList = findChildren(adaptationSet, "SegmentList")[0];
  var segmentUrls = segmentList && findChildren(segmentList, "SegmentURL").map(function(s) {
    return merge({
      tag: "SegmentURL"
    }, parseAttributes2(s));
  });
  var segmentBase = findChildren(adaptationSet, "SegmentBase")[0];
  var segmentTimelineParentNode = segmentList || segmentTemplate;
  var segmentTimeline = segmentTimelineParentNode && findChildren(segmentTimelineParentNode, "SegmentTimeline")[0];
  var segmentInitializationParentNode = segmentList || segmentBase || segmentTemplate;
  var segmentInitialization = segmentInitializationParentNode && findChildren(segmentInitializationParentNode, "Initialization")[0];
  var template = segmentTemplate && parseAttributes2(segmentTemplate);
  if (template && segmentInitialization) {
    template.initialization = segmentInitialization && parseAttributes2(segmentInitialization);
  } else if (template && template.initialization) {
    template.initialization = {
      sourceURL: template.initialization
    };
  }
  var segmentInfo = {
    template,
    segmentTimeline: segmentTimeline && findChildren(segmentTimeline, "S").map(function(s) {
      return parseAttributes2(s);
    }),
    list: segmentList && merge(parseAttributes2(segmentList), {
      segmentUrls,
      initialization: parseAttributes2(segmentInitialization)
    }),
    base: segmentBase && merge(parseAttributes2(segmentBase), {
      initialization: parseAttributes2(segmentInitialization)
    })
  };
  Object.keys(segmentInfo).forEach(function(key) {
    if (!segmentInfo[key]) {
      delete segmentInfo[key];
    }
  });
  return segmentInfo;
};
var inheritBaseUrls = function inheritBaseUrls2(adaptationSetAttributes, adaptationSetBaseUrls, adaptationSetSegmentInfo) {
  return function(representation) {
    var repBaseUrlElements = findChildren(representation, "BaseURL");
    var repBaseUrls = buildBaseUrls(adaptationSetBaseUrls, repBaseUrlElements);
    var attributes = merge(adaptationSetAttributes, parseAttributes2(representation));
    var representationSegmentInfo = getSegmentInformation(representation);
    return repBaseUrls.map(function(baseUrl) {
      return {
        segmentInfo: merge(adaptationSetSegmentInfo, representationSegmentInfo),
        attributes: merge(attributes, {
          baseUrl
        })
      };
    });
  };
};
var generateKeySystemInformation = function generateKeySystemInformation2(contentProtectionNodes) {
  return contentProtectionNodes.reduce(function(acc, node) {
    var attributes = parseAttributes2(node);
    if (attributes.schemeIdUri) {
      attributes.schemeIdUri = attributes.schemeIdUri.toLowerCase();
    }
    var keySystem = keySystemsMap[attributes.schemeIdUri];
    if (keySystem) {
      acc[keySystem] = {
        attributes
      };
      var psshNode = findChildren(node, "cenc:pssh")[0];
      if (psshNode) {
        var pssh = getContent(psshNode);
        acc[keySystem].pssh = pssh && decodeB64ToUint8Array(pssh);
      }
    }
    return acc;
  }, {});
};
var parseCaptionServiceMetadata = function parseCaptionServiceMetadata2(service) {
  if (service.schemeIdUri === "urn:scte:dash:cc:cea-608:2015") {
    var values3 = typeof service.value !== "string" ? [] : service.value.split(";");
    return values3.map(function(value) {
      var channel;
      var language;
      language = value;
      if (/^CC\d=/.test(value)) {
        var _value$split = value.split("=");
        channel = _value$split[0];
        language = _value$split[1];
      } else if (/^CC\d$/.test(value)) {
        channel = value;
      }
      return {
        channel,
        language
      };
    });
  } else if (service.schemeIdUri === "urn:scte:dash:cc:cea-708:2015") {
    var _values = typeof service.value !== "string" ? [] : service.value.split(";");
    return _values.map(function(value) {
      var flags = {
        "channel": void 0,
        "language": void 0,
        "aspectRatio": 1,
        "easyReader": 0,
        "3D": 0
      };
      if (/=/.test(value)) {
        var _value$split2 = value.split("="), channel = _value$split2[0], _value$split2$ = _value$split2[1], opts = _value$split2$ === void 0 ? "" : _value$split2$;
        flags.channel = channel;
        flags.language = value;
        opts.split(",").forEach(function(opt) {
          var _opt$split = opt.split(":"), name = _opt$split[0], val = _opt$split[1];
          if (name === "lang") {
            flags.language = val;
          } else if (name === "er") {
            flags.easyReader = Number(val);
          } else if (name === "war") {
            flags.aspectRatio = Number(val);
          } else if (name === "3D") {
            flags["3D"] = Number(val);
          }
        });
      } else {
        flags.language = value;
      }
      if (flags.channel) {
        flags.channel = "SERVICE" + flags.channel;
      }
      return flags;
    });
  }
};
var toRepresentations = function toRepresentations2(periodAttributes, periodBaseUrls, periodSegmentInfo) {
  return function(adaptationSet) {
    var adaptationSetAttributes = parseAttributes2(adaptationSet);
    var adaptationSetBaseUrls = buildBaseUrls(periodBaseUrls, findChildren(adaptationSet, "BaseURL"));
    var role = findChildren(adaptationSet, "Role")[0];
    var roleAttributes = {
      role: parseAttributes2(role)
    };
    var attrs = merge(periodAttributes, adaptationSetAttributes, roleAttributes);
    var accessibility = findChildren(adaptationSet, "Accessibility")[0];
    var captionServices = parseCaptionServiceMetadata(parseAttributes2(accessibility));
    if (captionServices) {
      attrs = merge(attrs, {
        captionServices
      });
    }
    var label = findChildren(adaptationSet, "Label")[0];
    if (label && label.childNodes.length) {
      var labelVal = label.childNodes[0].nodeValue.trim();
      attrs = merge(attrs, {
        label: labelVal
      });
    }
    var contentProtection = generateKeySystemInformation(findChildren(adaptationSet, "ContentProtection"));
    if (Object.keys(contentProtection).length) {
      attrs = merge(attrs, {
        contentProtection
      });
    }
    var segmentInfo = getSegmentInformation(adaptationSet);
    var representations = findChildren(adaptationSet, "Representation");
    var adaptationSetSegmentInfo = merge(periodSegmentInfo, segmentInfo);
    return flatten(representations.map(inheritBaseUrls(attrs, adaptationSetBaseUrls, adaptationSetSegmentInfo)));
  };
};
var toAdaptationSets = function toAdaptationSets2(mpdAttributes, mpdBaseUrls) {
  return function(period, index) {
    var periodBaseUrls = buildBaseUrls(mpdBaseUrls, findChildren(period.node, "BaseURL"));
    var periodAttributes = merge(mpdAttributes, {
      periodStart: period.attributes.start
    });
    if (typeof period.attributes.duration === "number") {
      periodAttributes.periodDuration = period.attributes.duration;
    }
    var adaptationSets = findChildren(period.node, "AdaptationSet");
    var periodSegmentInfo = getSegmentInformation(period.node);
    return flatten(adaptationSets.map(toRepresentations(periodAttributes, periodBaseUrls, periodSegmentInfo)));
  };
};
var getPeriodStart = function getPeriodStart2(_ref2) {
  var attributes = _ref2.attributes, priorPeriodAttributes = _ref2.priorPeriodAttributes, mpdType = _ref2.mpdType;
  if (typeof attributes.start === "number") {
    return attributes.start;
  }
  if (priorPeriodAttributes && typeof priorPeriodAttributes.start === "number" && typeof priorPeriodAttributes.duration === "number") {
    return priorPeriodAttributes.start + priorPeriodAttributes.duration;
  }
  if (!priorPeriodAttributes && mpdType === "static") {
    return 0;
  }
  return null;
};
var inheritAttributes = function inheritAttributes2(mpd, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$manifestUri = _options.manifestUri, manifestUri = _options$manifestUri === void 0 ? "" : _options$manifestUri, _options$NOW = _options.NOW, NOW = _options$NOW === void 0 ? Date.now() : _options$NOW, _options$clientOffset = _options.clientOffset, clientOffset = _options$clientOffset === void 0 ? 0 : _options$clientOffset;
  var periodNodes = findChildren(mpd, "Period");
  if (!periodNodes.length) {
    throw new Error(errors.INVALID_NUMBER_OF_PERIOD);
  }
  var locations = findChildren(mpd, "Location");
  var mpdAttributes = parseAttributes2(mpd);
  var mpdBaseUrls = buildBaseUrls([manifestUri], findChildren(mpd, "BaseURL"));
  mpdAttributes.type = mpdAttributes.type || "static";
  mpdAttributes.sourceDuration = mpdAttributes.mediaPresentationDuration || 0;
  mpdAttributes.NOW = NOW;
  mpdAttributes.clientOffset = clientOffset;
  if (locations.length) {
    mpdAttributes.locations = locations.map(getContent);
  }
  var periods = [];
  periodNodes.forEach(function(node, index) {
    var attributes = parseAttributes2(node);
    var priorPeriod = periods[index - 1];
    attributes.start = getPeriodStart({
      attributes,
      priorPeriodAttributes: priorPeriod ? priorPeriod.attributes : null,
      mpdType: mpdAttributes.type
    });
    periods.push({
      node,
      attributes
    });
  });
  return {
    locations: mpdAttributes.locations,
    representationInfo: flatten(periods.map(toAdaptationSets(mpdAttributes, mpdBaseUrls)))
  };
};
var stringToMpdXml = function stringToMpdXml2(manifestString) {
  if (manifestString === "") {
    throw new Error(errors.DASH_EMPTY_MANIFEST);
  }
  var parser2 = new DOMParser();
  var xml;
  var mpd;
  try {
    xml = parser2.parseFromString(manifestString, "application/xml");
    mpd = xml && xml.documentElement.tagName === "MPD" ? xml.documentElement : null;
  } catch (e) {
  }
  if (!mpd || mpd && mpd.getElementsByTagName("parsererror").length > 0) {
    throw new Error(errors.DASH_INVALID_XML);
  }
  return mpd;
};
var parseUTCTimingScheme = function parseUTCTimingScheme2(mpd) {
  var UTCTimingNode = findChildren(mpd, "UTCTiming")[0];
  if (!UTCTimingNode) {
    return null;
  }
  var attributes = parseAttributes2(UTCTimingNode);
  switch (attributes.schemeIdUri) {
    case "urn:mpeg:dash:utc:http-head:2014":
    case "urn:mpeg:dash:utc:http-head:2012":
      attributes.method = "HEAD";
      break;
    case "urn:mpeg:dash:utc:http-xsdate:2014":
    case "urn:mpeg:dash:utc:http-iso:2014":
    case "urn:mpeg:dash:utc:http-xsdate:2012":
    case "urn:mpeg:dash:utc:http-iso:2012":
      attributes.method = "GET";
      break;
    case "urn:mpeg:dash:utc:direct:2014":
    case "urn:mpeg:dash:utc:direct:2012":
      attributes.method = "DIRECT";
      attributes.value = Date.parse(attributes.value);
      break;
    case "urn:mpeg:dash:utc:http-ntp:2014":
    case "urn:mpeg:dash:utc:ntp:2014":
    case "urn:mpeg:dash:utc:sntp:2014":
    default:
      throw new Error(errors.UNSUPPORTED_UTC_TIMING_SCHEME);
  }
  return attributes;
};
var parse$2 = function parse(manifestString, options) {
  if (options === void 0) {
    options = {};
  }
  var parsedManifestInfo = inheritAttributes(stringToMpdXml(manifestString), options);
  var playlists = toPlaylists(parsedManifestInfo.representationInfo);
  return toM3u8({
    dashPlaylists: playlists,
    locations: parsedManifestInfo.locations,
    sidxMapping: options.sidxMapping,
    previousManifest: options.previousManifest
  });
};
var parseUTCTiming = function parseUTCTiming2(manifestString) {
  return parseUTCTimingScheme(stringToMpdXml(manifestString));
};
var MAX_UINT32 = Math.pow(2, 32);
var getUint64$1 = function(uint8) {
  var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
  var value;
  if (dv.getBigUint64) {
    value = dv.getBigUint64(0);
    if (value < Number.MAX_SAFE_INTEGER) {
      return Number(value);
    }
    return value;
  }
  return dv.getUint32(0) * MAX_UINT32 + dv.getUint32(4);
};
var numbers = {
  getUint64: getUint64$1,
  MAX_UINT32
};
var getUint64 = numbers.getUint64;
var parseSidx = function(data) {
  var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result2 = {
    version: data[0],
    flags: new Uint8Array(data.subarray(1, 4)),
    references: [],
    referenceId: view.getUint32(4),
    timescale: view.getUint32(8)
  }, i = 12;
  if (result2.version === 0) {
    result2.earliestPresentationTime = view.getUint32(i);
    result2.firstOffset = view.getUint32(i + 4);
    i += 8;
  } else {
    result2.earliestPresentationTime = getUint64(data.subarray(i));
    result2.firstOffset = getUint64(data.subarray(i + 8));
    i += 16;
  }
  i += 2;
  var referenceCount = view.getUint16(i);
  i += 2;
  for (; referenceCount > 0; i += 12, referenceCount--) {
    result2.references.push({
      referenceType: (data[i] & 128) >>> 7,
      referencedSize: view.getUint32(i) & 2147483647,
      subsegmentDuration: view.getUint32(i + 4),
      startsWithSap: !!(data[i + 8] & 128),
      sapType: (data[i + 8] & 112) >>> 4,
      sapDeltaTime: view.getUint32(i + 8) & 268435455
    });
  }
  return result2;
};
var parseSidx_1 = parseSidx;
var ID3 = toUint8([73, 68, 51]);
var getId3Size = function getId3Size2(bytes, offset2) {
  if (offset2 === void 0) {
    offset2 = 0;
  }
  bytes = toUint8(bytes);
  var flags = bytes[offset2 + 5];
  var returnSize = bytes[offset2 + 6] << 21 | bytes[offset2 + 7] << 14 | bytes[offset2 + 8] << 7 | bytes[offset2 + 9];
  var footerPresent = (flags & 16) >> 4;
  if (footerPresent) {
    return returnSize + 20;
  }
  return returnSize + 10;
};
var getId3Offset = function getId3Offset2(bytes, offset2) {
  if (offset2 === void 0) {
    offset2 = 0;
  }
  bytes = toUint8(bytes);
  if (bytes.length - offset2 < 10 || !bytesMatch(bytes, ID3, {
    offset: offset2
  })) {
    return offset2;
  }
  offset2 += getId3Size(bytes, offset2);
  return getId3Offset2(bytes, offset2);
};
var normalizePath$1 = function normalizePath(path) {
  if (typeof path === "string") {
    return stringToBytes(path);
  }
  if (typeof path === "number") {
    return path;
  }
  return path;
};
var normalizePaths$1 = function normalizePaths(paths) {
  if (!Array.isArray(paths)) {
    return [normalizePath$1(paths)];
  }
  return paths.map(function(p2) {
    return normalizePath$1(p2);
  });
};
var findBox = function findBox2(bytes, paths, complete) {
  if (complete === void 0) {
    complete = false;
  }
  paths = normalizePaths$1(paths);
  bytes = toUint8(bytes);
  var results = [];
  if (!paths.length) {
    return results;
  }
  var i = 0;
  while (i < bytes.length) {
    var size = (bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]) >>> 0;
    var type2 = bytes.subarray(i + 4, i + 8);
    if (size === 0) {
      break;
    }
    var end3 = i + size;
    if (end3 > bytes.length) {
      if (complete) {
        break;
      }
      end3 = bytes.length;
    }
    var data = bytes.subarray(i + 8, end3);
    if (bytesMatch(type2, paths[0])) {
      if (paths.length === 1) {
        results.push(data);
      } else {
        results.push.apply(results, findBox2(data, paths.slice(1), complete));
      }
    }
    i = end3;
  }
  return results;
};
var EBML_TAGS = {
  EBML: toUint8([26, 69, 223, 163]),
  DocType: toUint8([66, 130]),
  Segment: toUint8([24, 83, 128, 103]),
  SegmentInfo: toUint8([21, 73, 169, 102]),
  Tracks: toUint8([22, 84, 174, 107]),
  Track: toUint8([174]),
  TrackNumber: toUint8([215]),
  DefaultDuration: toUint8([35, 227, 131]),
  TrackEntry: toUint8([174]),
  TrackType: toUint8([131]),
  FlagDefault: toUint8([136]),
  CodecID: toUint8([134]),
  CodecPrivate: toUint8([99, 162]),
  VideoTrack: toUint8([224]),
  AudioTrack: toUint8([225]),
  Cluster: toUint8([31, 67, 182, 117]),
  Timestamp: toUint8([231]),
  TimestampScale: toUint8([42, 215, 177]),
  BlockGroup: toUint8([160]),
  BlockDuration: toUint8([155]),
  Block: toUint8([161]),
  SimpleBlock: toUint8([163])
};
var LENGTH_TABLE = [128, 64, 32, 16, 8, 4, 2, 1];
var getLength = function getLength2(byte) {
  var len = 1;
  for (var i = 0; i < LENGTH_TABLE.length; i++) {
    if (byte & LENGTH_TABLE[i]) {
      break;
    }
    len++;
  }
  return len;
};
var getvint = function getvint2(bytes, offset2, removeLength, signed) {
  if (removeLength === void 0) {
    removeLength = true;
  }
  if (signed === void 0) {
    signed = false;
  }
  var length = getLength(bytes[offset2]);
  var valueBytes = bytes.subarray(offset2, offset2 + length);
  if (removeLength) {
    valueBytes = Array.prototype.slice.call(bytes, offset2, offset2 + length);
    valueBytes[0] ^= LENGTH_TABLE[length - 1];
  }
  return {
    length,
    value: bytesToNumber(valueBytes, {
      signed
    }),
    bytes: valueBytes
  };
};
var normalizePath2 = function normalizePath3(path) {
  if (typeof path === "string") {
    return path.match(/.{1,2}/g).map(function(p2) {
      return normalizePath3(p2);
    });
  }
  if (typeof path === "number") {
    return numberToBytes(path);
  }
  return path;
};
var normalizePaths2 = function normalizePaths3(paths) {
  if (!Array.isArray(paths)) {
    return [normalizePath2(paths)];
  }
  return paths.map(function(p2) {
    return normalizePath2(p2);
  });
};
var getInfinityDataSize = function getInfinityDataSize2(id2, bytes, offset2) {
  if (offset2 >= bytes.length) {
    return bytes.length;
  }
  var innerid = getvint(bytes, offset2, false);
  if (bytesMatch(id2.bytes, innerid.bytes)) {
    return offset2;
  }
  var dataHeader = getvint(bytes, offset2 + innerid.length);
  return getInfinityDataSize2(id2, bytes, offset2 + dataHeader.length + dataHeader.value + innerid.length);
};
var findEbml = function findEbml2(bytes, paths) {
  paths = normalizePaths2(paths);
  bytes = toUint8(bytes);
  var results = [];
  if (!paths.length) {
    return results;
  }
  var i = 0;
  while (i < bytes.length) {
    var id2 = getvint(bytes, i, false);
    var dataHeader = getvint(bytes, i + id2.length);
    var dataStart = i + id2.length + dataHeader.length;
    if (dataHeader.value === 127) {
      dataHeader.value = getInfinityDataSize(id2, bytes, dataStart);
      if (dataHeader.value !== bytes.length) {
        dataHeader.value -= dataStart;
      }
    }
    var dataEnd = dataStart + dataHeader.value > bytes.length ? bytes.length : dataStart + dataHeader.value;
    var data = bytes.subarray(dataStart, dataEnd);
    if (bytesMatch(paths[0], id2.bytes)) {
      if (paths.length === 1) {
        results.push(data);
      } else {
        results = results.concat(findEbml2(data, paths.slice(1)));
      }
    }
    var totalLength = id2.length + dataHeader.length + data.length;
    i += totalLength;
  }
  return results;
};
var NAL_TYPE_ONE = toUint8([0, 0, 0, 1]);
var NAL_TYPE_TWO = toUint8([0, 0, 1]);
var EMULATION_PREVENTION = toUint8([0, 0, 3]);
var discardEmulationPreventionBytes = function discardEmulationPreventionBytes2(bytes) {
  var positions = [];
  var i = 1;
  while (i < bytes.length - 2) {
    if (bytesMatch(bytes.subarray(i, i + 3), EMULATION_PREVENTION)) {
      positions.push(i + 2);
      i++;
    }
    i++;
  }
  if (positions.length === 0) {
    return bytes;
  }
  var newLength = bytes.length - positions.length;
  var newData = new Uint8Array(newLength);
  var sourceIndex = 0;
  for (i = 0; i < newLength; sourceIndex++, i++) {
    if (sourceIndex === positions[0]) {
      sourceIndex++;
      positions.shift();
    }
    newData[i] = bytes[sourceIndex];
  }
  return newData;
};
var findNal = function findNal2(bytes, dataType, types, nalLimit) {
  if (nalLimit === void 0) {
    nalLimit = Infinity;
  }
  bytes = toUint8(bytes);
  types = [].concat(types);
  var i = 0;
  var nalStart;
  var nalsFound = 0;
  while (i < bytes.length && (nalsFound < nalLimit || nalStart)) {
    var nalOffset = void 0;
    if (bytesMatch(bytes.subarray(i), NAL_TYPE_ONE)) {
      nalOffset = 4;
    } else if (bytesMatch(bytes.subarray(i), NAL_TYPE_TWO)) {
      nalOffset = 3;
    }
    if (!nalOffset) {
      i++;
      continue;
    }
    nalsFound++;
    if (nalStart) {
      return discardEmulationPreventionBytes(bytes.subarray(nalStart, i));
    }
    var nalType = void 0;
    if (dataType === "h264") {
      nalType = bytes[i + nalOffset] & 31;
    } else if (dataType === "h265") {
      nalType = bytes[i + nalOffset] >> 1 & 63;
    }
    if (types.indexOf(nalType) !== -1) {
      nalStart = i + nalOffset;
    }
    i += nalOffset + (dataType === "h264" ? 1 : 2);
  }
  return bytes.subarray(0, 0);
};
var findH264Nal = function findH264Nal2(bytes, type2, nalLimit) {
  return findNal(bytes, "h264", type2, nalLimit);
};
var findH265Nal = function findH265Nal2(bytes, type2, nalLimit) {
  return findNal(bytes, "h265", type2, nalLimit);
};
var CONSTANTS = {
  "webm": toUint8([119, 101, 98, 109]),
  "matroska": toUint8([109, 97, 116, 114, 111, 115, 107, 97]),
  "flac": toUint8([102, 76, 97, 67]),
  "ogg": toUint8([79, 103, 103, 83]),
  "ac3": toUint8([11, 119]),
  "riff": toUint8([82, 73, 70, 70]),
  "avi": toUint8([65, 86, 73]),
  "wav": toUint8([87, 65, 86, 69]),
  "3gp": toUint8([102, 116, 121, 112, 51, 103]),
  "mp4": toUint8([102, 116, 121, 112]),
  "fmp4": toUint8([115, 116, 121, 112]),
  "mov": toUint8([102, 116, 121, 112, 113, 116]),
  "moov": toUint8([109, 111, 111, 118]),
  "moof": toUint8([109, 111, 111, 102])
};
var _isLikely = {
  aac: function aac(bytes) {
    var offset2 = getId3Offset(bytes);
    return bytesMatch(bytes, [255, 16], {
      offset: offset2,
      mask: [255, 22]
    });
  },
  mp3: function mp3(bytes) {
    var offset2 = getId3Offset(bytes);
    return bytesMatch(bytes, [255, 2], {
      offset: offset2,
      mask: [255, 6]
    });
  },
  webm: function webm(bytes) {
    var docType = findEbml(bytes, [EBML_TAGS.EBML, EBML_TAGS.DocType])[0];
    return bytesMatch(docType, CONSTANTS.webm);
  },
  mkv: function mkv(bytes) {
    var docType = findEbml(bytes, [EBML_TAGS.EBML, EBML_TAGS.DocType])[0];
    return bytesMatch(docType, CONSTANTS.matroska);
  },
  mp4: function mp4(bytes) {
    if (_isLikely["3gp"](bytes) || _isLikely.mov(bytes)) {
      return false;
    }
    if (bytesMatch(bytes, CONSTANTS.mp4, {
      offset: 4
    }) || bytesMatch(bytes, CONSTANTS.fmp4, {
      offset: 4
    })) {
      return true;
    }
    if (bytesMatch(bytes, CONSTANTS.moof, {
      offset: 4
    }) || bytesMatch(bytes, CONSTANTS.moov, {
      offset: 4
    })) {
      return true;
    }
  },
  mov: function mov(bytes) {
    return bytesMatch(bytes, CONSTANTS.mov, {
      offset: 4
    });
  },
  "3gp": function gp(bytes) {
    return bytesMatch(bytes, CONSTANTS["3gp"], {
      offset: 4
    });
  },
  ac3: function ac3(bytes) {
    var offset2 = getId3Offset(bytes);
    return bytesMatch(bytes, CONSTANTS.ac3, {
      offset: offset2
    });
  },
  ts: function ts(bytes) {
    if (bytes.length < 189 && bytes.length >= 1) {
      return bytes[0] === 71;
    }
    var i = 0;
    while (i + 188 < bytes.length && i < 188) {
      if (bytes[i] === 71 && bytes[i + 188] === 71) {
        return true;
      }
      i += 1;
    }
    return false;
  },
  flac: function flac(bytes) {
    var offset2 = getId3Offset(bytes);
    return bytesMatch(bytes, CONSTANTS.flac, {
      offset: offset2
    });
  },
  ogg: function ogg(bytes) {
    return bytesMatch(bytes, CONSTANTS.ogg);
  },
  avi: function avi(bytes) {
    return bytesMatch(bytes, CONSTANTS.riff) && bytesMatch(bytes, CONSTANTS.avi, {
      offset: 8
    });
  },
  wav: function wav(bytes) {
    return bytesMatch(bytes, CONSTANTS.riff) && bytesMatch(bytes, CONSTANTS.wav, {
      offset: 8
    });
  },
  "h264": function h264(bytes) {
    return findH264Nal(bytes, 7, 3).length;
  },
  "h265": function h265(bytes) {
    return findH265Nal(bytes, [32, 33], 3).length;
  }
};
var isLikelyTypes = Object.keys(_isLikely).filter(function(t3) {
  return t3 !== "ts" && t3 !== "h264" && t3 !== "h265";
}).concat(["ts", "h264", "h265"]);
isLikelyTypes.forEach(function(type2) {
  var isLikelyFn = _isLikely[type2];
  _isLikely[type2] = function(bytes) {
    return isLikelyFn(toUint8(bytes));
  };
});
var isLikely = _isLikely;
var detectContainerForBytes = function detectContainerForBytes2(bytes) {
  bytes = toUint8(bytes);
  for (var i = 0; i < isLikelyTypes.length; i++) {
    var type2 = isLikelyTypes[i];
    if (isLikely[type2](bytes)) {
      return type2;
    }
  }
  return "";
};
var isLikelyFmp4MediaSegment = function isLikelyFmp4MediaSegment2(bytes) {
  return findBox(bytes, ["moof"]).length > 0;
};
var ONE_SECOND_IN_TS = 9e4, secondsToVideoTs, secondsToAudioTs, videoTsToSeconds, audioTsToSeconds, audioTsToVideoTs, videoTsToAudioTs, metadataTsToSeconds;
secondsToVideoTs = function(seconds) {
  return seconds * ONE_SECOND_IN_TS;
};
secondsToAudioTs = function(seconds, sampleRate) {
  return seconds * sampleRate;
};
videoTsToSeconds = function(timestamp) {
  return timestamp / ONE_SECOND_IN_TS;
};
audioTsToSeconds = function(timestamp, sampleRate) {
  return timestamp / sampleRate;
};
audioTsToVideoTs = function(timestamp, sampleRate) {
  return secondsToVideoTs(audioTsToSeconds(timestamp, sampleRate));
};
videoTsToAudioTs = function(timestamp, sampleRate) {
  return secondsToAudioTs(videoTsToSeconds(timestamp), sampleRate);
};
metadataTsToSeconds = function(timestamp, timelineStartPts, keepOriginalTimestamps) {
  return videoTsToSeconds(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
};
var clock = {
  ONE_SECOND_IN_TS,
  secondsToVideoTs,
  secondsToAudioTs,
  videoTsToSeconds,
  audioTsToSeconds,
  audioTsToVideoTs,
  videoTsToAudioTs,
  metadataTsToSeconds
};
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
/**
 * @license
 * Video.js 7.21.5 <http://videojs.com/>
 * Copyright Brightcove, Inc. <https://www.brightcove.com/>
 * Available under Apache License Version 2.0
 * <https://github.com/videojs/video.js/blob/main/LICENSE>
 *
 * Includes vtt.js <https://github.com/mozilla/vtt.js>
 * Available under Apache License Version 2.0
 * <https://github.com/mozilla/vtt.js/blob/main/LICENSE>
 */
var version$5 = "7.21.5";
var hooks_ = {};
var hooks = function hooks2(type2, fn) {
  hooks_[type2] = hooks_[type2] || [];
  if (fn) {
    hooks_[type2] = hooks_[type2].concat(fn);
  }
  return hooks_[type2];
};
var hook = function hook2(type2, fn) {
  hooks(type2, fn);
};
var removeHook = function removeHook2(type2, fn) {
  var index = hooks(type2).indexOf(fn);
  if (index <= -1) {
    return false;
  }
  hooks_[type2] = hooks_[type2].slice();
  hooks_[type2].splice(index, 1);
  return true;
};
var hookOnce = function hookOnce2(type2, fn) {
  hooks(type2, [].concat(fn).map(function(original) {
    var wrapper2 = function wrapper3() {
      removeHook(type2, wrapper3);
      return original.apply(void 0, arguments);
    };
    return wrapper2;
  }));
};
var FullscreenApi = {
  prefixed: true
};
var apiMap = [
  ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror", "fullscreen"],
  ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror", "-webkit-full-screen"],
  ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror", "-moz-full-screen"],
  ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError", "-ms-fullscreen"]
];
var specApi = apiMap[0];
var browserApi;
for (var i = 0; i < apiMap.length; i++) {
  if (apiMap[i][1] in document_1) {
    browserApi = apiMap[i];
    break;
  }
}
if (browserApi) {
  for (var _i = 0; _i < browserApi.length; _i++) {
    FullscreenApi[specApi[_i]] = browserApi[_i];
  }
  FullscreenApi.prefixed = browserApi[0] !== specApi[0];
}
var history = [];
var LogByTypeFactory = function LogByTypeFactory2(name, log2) {
  return function(type2, level, args) {
    var lvl = log2.levels[level];
    var lvlRegExp = new RegExp("^(" + lvl + ")$");
    if (type2 !== "log") {
      args.unshift(type2.toUpperCase() + ":");
    }
    args.unshift(name + ":");
    if (history) {
      history.push([].concat(args));
      var splice = history.length - 1e3;
      history.splice(0, splice > 0 ? splice : 0);
    }
    if (!window_1.console) {
      return;
    }
    var fn = window_1.console[type2];
    if (!fn && type2 === "debug") {
      fn = window_1.console.info || window_1.console.log;
    }
    if (!fn || !lvl || !lvlRegExp.test(type2)) {
      return;
    }
    fn[Array.isArray(args) ? "apply" : "call"](window_1.console, args);
  };
};
function createLogger$1(name) {
  var level = "info";
  var logByType;
  var log2 = function log3() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    logByType("log", level, args);
  };
  logByType = LogByTypeFactory(name, log2);
  log2.createLogger = function(subname) {
    return createLogger$1(name + ": " + subname);
  };
  log2.levels = {
    all: "debug|log|warn|error",
    off: "",
    debug: "debug|log|warn|error",
    info: "log|warn|error",
    warn: "warn|error",
    error: "error",
    DEFAULT: level
  };
  log2.level = function(lvl) {
    if (typeof lvl === "string") {
      if (!log2.levels.hasOwnProperty(lvl)) {
        throw new Error('"' + lvl + '" in not a valid log level');
      }
      level = lvl;
    }
    return level;
  };
  log2.history = function() {
    return history ? [].concat(history) : [];
  };
  log2.history.filter = function(fname) {
    return (history || []).filter(function(historyItem) {
      return new RegExp(".*" + fname + ".*").test(historyItem[0]);
    });
  };
  log2.history.clear = function() {
    if (history) {
      history.length = 0;
    }
  };
  log2.history.disable = function() {
    if (history !== null) {
      history.length = 0;
      history = null;
    }
  };
  log2.history.enable = function() {
    if (history === null) {
      history = [];
    }
  };
  log2.error = function() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return logByType("error", level, args);
  };
  log2.warn = function() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return logByType("warn", level, args);
  };
  log2.debug = function() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return logByType("debug", level, args);
  };
  return log2;
}
var log$1 = createLogger$1("VIDEOJS");
var createLogger = log$1.createLogger;
var toString = Object.prototype.toString;
var keys = function keys2(object) {
  return isObject2(object) ? Object.keys(object) : [];
};
function each(object, fn) {
  keys(object).forEach(function(key) {
    return fn(object[key], key);
  });
}
function reduce$1(object, fn, initial2) {
  if (initial2 === void 0) {
    initial2 = 0;
  }
  return keys(object).reduce(function(accum, key) {
    return fn(accum, object[key], key);
  }, initial2);
}
function assign(target) {
  for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    sources[_key - 1] = arguments[_key];
  }
  if (Object.assign) {
    return _extends$2.apply(void 0, [target].concat(sources));
  }
  sources.forEach(function(source) {
    if (!source) {
      return;
    }
    each(source, function(value, key) {
      target[key] = value;
    });
  });
  return target;
}
function isObject2(value) {
  return !!value && typeof value === "object";
}
function isPlain(value) {
  return isObject2(value) && toString.call(value) === "[object Object]" && value.constructor === Object;
}
function computedStyle(el, prop) {
  if (!el || !prop) {
    return "";
  }
  if (typeof window_1.getComputedStyle === "function") {
    var computedStyleValue;
    try {
      computedStyleValue = window_1.getComputedStyle(el);
    } catch (e) {
      return "";
    }
    return computedStyleValue ? computedStyleValue.getPropertyValue(prop) || computedStyleValue[prop] : "";
  }
  return "";
}
var USER_AGENT = window_1.navigator && window_1.navigator.userAgent || "";
var webkitVersionMap = /AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);
var appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
var IS_IPOD = /iPod/i.test(USER_AGENT);
var IOS_VERSION = function() {
  var match = USER_AGENT.match(/OS (\d+)_/i);
  if (match && match[1]) {
    return match[1];
  }
  return null;
}();
var IS_ANDROID = /Android/i.test(USER_AGENT);
var ANDROID_VERSION = function() {
  var match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
  if (!match) {
    return null;
  }
  var major = match[1] && parseFloat(match[1]);
  var minor = match[2] && parseFloat(match[2]);
  if (major && minor) {
    return parseFloat(match[1] + "." + match[2]);
  } else if (major) {
    return major;
  }
  return null;
}();
var IS_NATIVE_ANDROID = IS_ANDROID && ANDROID_VERSION < 5 && appleWebkitVersion < 537;
var IS_FIREFOX = /Firefox/i.test(USER_AGENT);
var IS_EDGE = /Edg/i.test(USER_AGENT);
var IS_CHROME = !IS_EDGE && (/Chrome/i.test(USER_AGENT) || /CriOS/i.test(USER_AGENT));
var CHROME_VERSION = function() {
  var match = USER_AGENT.match(/(Chrome|CriOS)\/(\d+)/);
  if (match && match[2]) {
    return parseFloat(match[2]);
  }
  return null;
}();
var IE_VERSION = function() {
  var result2 = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
  var version2 = result2 && parseFloat(result2[1]);
  if (!version2 && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) {
    version2 = 11;
  }
  return version2;
}();
var IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE;
var IS_WINDOWS = /Windows/i.test(USER_AGENT);
var TOUCH_ENABLED = Boolean(isReal() && ("ontouchstart" in window_1 || window_1.navigator.maxTouchPoints || window_1.DocumentTouch && window_1.document instanceof window_1.DocumentTouch));
var IS_IPAD = /iPad/i.test(USER_AGENT) || IS_SAFARI && TOUCH_ENABLED && !/iPhone/i.test(USER_AGENT);
var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
var IS_ANY_SAFARI = (IS_SAFARI || IS_IOS) && !IS_CHROME;
var browser = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  IS_IPOD,
  IOS_VERSION,
  IS_ANDROID,
  ANDROID_VERSION,
  IS_NATIVE_ANDROID,
  IS_FIREFOX,
  IS_EDGE,
  IS_CHROME,
  CHROME_VERSION,
  IE_VERSION,
  IS_SAFARI,
  IS_WINDOWS,
  TOUCH_ENABLED,
  IS_IPAD,
  IS_IPHONE,
  IS_IOS,
  IS_ANY_SAFARI
});
function isNonBlankString(str) {
  return typeof str === "string" && Boolean(str.trim());
}
function throwIfWhitespace(str) {
  if (str.indexOf(" ") >= 0) {
    throw new Error("class has illegal whitespace characters");
  }
}
function classRegExp(className) {
  return new RegExp("(^|\\s)" + className + "($|\\s)");
}
function isReal() {
  return document_1 === window_1.document;
}
function isEl(value) {
  return isObject2(value) && value.nodeType === 1;
}
function isInFrame() {
  try {
    return window_1.parent !== window_1.self;
  } catch (x) {
    return true;
  }
}
function createQuerier(method) {
  return function(selector, context) {
    if (!isNonBlankString(selector)) {
      return document_1[method](null);
    }
    if (isNonBlankString(context)) {
      context = document_1.querySelector(context);
    }
    var ctx = isEl(context) ? context : document_1;
    return ctx[method] && ctx[method](selector);
  };
}
function createEl(tagName, properties, attributes, content2) {
  if (tagName === void 0) {
    tagName = "div";
  }
  if (properties === void 0) {
    properties = {};
  }
  if (attributes === void 0) {
    attributes = {};
  }
  var el = document_1.createElement(tagName);
  Object.getOwnPropertyNames(properties).forEach(function(propName) {
    var val = properties[propName];
    if (propName.indexOf("aria-") !== -1 || propName === "role" || propName === "type") {
      log$1.warn("Setting attributes in the second argument of createEl()\nhas been deprecated. Use the third argument instead.\n" + ("createEl(type, properties, attributes). Attempting to set " + propName + " to " + val + "."));
      el.setAttribute(propName, val);
    } else if (propName === "textContent") {
      textContent(el, val);
    } else if (el[propName] !== val || propName === "tabIndex") {
      el[propName] = val;
    }
  });
  Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
    el.setAttribute(attrName, attributes[attrName]);
  });
  if (content2) {
    appendContent(el, content2);
  }
  return el;
}
function textContent(el, text) {
  if (typeof el.textContent === "undefined") {
    el.innerText = text;
  } else {
    el.textContent = text;
  }
  return el;
}
function prependTo(child, parent) {
  if (parent.firstChild) {
    parent.insertBefore(child, parent.firstChild);
  } else {
    parent.appendChild(child);
  }
}
function hasClass(element, classToCheck) {
  throwIfWhitespace(classToCheck);
  if (element.classList) {
    return element.classList.contains(classToCheck);
  }
  return classRegExp(classToCheck).test(element.className);
}
function addClass(element, classToAdd) {
  if (element.classList) {
    element.classList.add(classToAdd);
  } else if (!hasClass(element, classToAdd)) {
    element.className = (element.className + " " + classToAdd).trim();
  }
  return element;
}
function removeClass(element, classToRemove) {
  if (!element) {
    log$1.warn("removeClass was called with an element that doesn't exist");
    return null;
  }
  if (element.classList) {
    element.classList.remove(classToRemove);
  } else {
    throwIfWhitespace(classToRemove);
    element.className = element.className.split(/\s+/).filter(function(c) {
      return c !== classToRemove;
    }).join(" ");
  }
  return element;
}
function toggleClass(element, classToToggle, predicate) {
  var has = hasClass(element, classToToggle);
  if (typeof predicate === "function") {
    predicate = predicate(element, classToToggle);
  }
  if (typeof predicate !== "boolean") {
    predicate = !has;
  }
  if (predicate === has) {
    return;
  }
  if (predicate) {
    addClass(element, classToToggle);
  } else {
    removeClass(element, classToToggle);
  }
  return element;
}
function setAttributes(el, attributes) {
  Object.getOwnPropertyNames(attributes).forEach(function(attrName) {
    var attrValue = attributes[attrName];
    if (attrValue === null || typeof attrValue === "undefined" || attrValue === false) {
      el.removeAttribute(attrName);
    } else {
      el.setAttribute(attrName, attrValue === true ? "" : attrValue);
    }
  });
}
function getAttributes(tag) {
  var obj = {};
  var knownBooleans = ",autoplay,controls,playsinline,loop,muted,default,defaultMuted,";
  if (tag && tag.attributes && tag.attributes.length > 0) {
    var attrs = tag.attributes;
    for (var i = attrs.length - 1; i >= 0; i--) {
      var attrName = attrs[i].name;
      var attrVal = attrs[i].value;
      if (typeof tag[attrName] === "boolean" || knownBooleans.indexOf("," + attrName + ",") !== -1) {
        attrVal = attrVal !== null ? true : false;
      }
      obj[attrName] = attrVal;
    }
  }
  return obj;
}
function getAttribute(el, attribute) {
  return el.getAttribute(attribute);
}
function setAttribute(el, attribute, value) {
  el.setAttribute(attribute, value);
}
function removeAttribute(el, attribute) {
  el.removeAttribute(attribute);
}
function blockTextSelection() {
  document_1.body.focus();
  document_1.onselectstart = function() {
    return false;
  };
}
function unblockTextSelection() {
  document_1.onselectstart = function() {
    return true;
  };
}
function getBoundingClientRect(el) {
  if (el && el.getBoundingClientRect && el.parentNode) {
    var rect = el.getBoundingClientRect();
    var result2 = {};
    ["bottom", "height", "left", "right", "top", "width"].forEach(function(k) {
      if (rect[k] !== void 0) {
        result2[k] = rect[k];
      }
    });
    if (!result2.height) {
      result2.height = parseFloat(computedStyle(el, "height"));
    }
    if (!result2.width) {
      result2.width = parseFloat(computedStyle(el, "width"));
    }
    return result2;
  }
}
function findPosition(el) {
  if (!el || el && !el.offsetParent) {
    return {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    };
  }
  var width2 = el.offsetWidth;
  var height2 = el.offsetHeight;
  var left = 0;
  var top = 0;
  while (el.offsetParent && el !== document_1[FullscreenApi.fullscreenElement]) {
    left += el.offsetLeft;
    top += el.offsetTop;
    el = el.offsetParent;
  }
  return {
    left,
    top,
    width: width2,
    height: height2
  };
}
function getPointerPosition(el, event) {
  var translated = {
    x: 0,
    y: 0
  };
  if (IS_IOS) {
    var item = el;
    while (item && item.nodeName.toLowerCase() !== "html") {
      var transform3 = computedStyle(item, "transform");
      if (/^matrix/.test(transform3)) {
        var values3 = transform3.slice(7, -1).split(/,\s/).map(Number);
        translated.x += values3[4];
        translated.y += values3[5];
      } else if (/^matrix3d/.test(transform3)) {
        var _values = transform3.slice(9, -1).split(/,\s/).map(Number);
        translated.x += _values[12];
        translated.y += _values[13];
      }
      item = item.parentNode;
    }
  }
  var position2 = {};
  var boxTarget = findPosition(event.target);
  var box = findPosition(el);
  var boxW = box.width;
  var boxH = box.height;
  var offsetY = event.offsetY - (box.top - boxTarget.top);
  var offsetX = event.offsetX - (box.left - boxTarget.left);
  if (event.changedTouches) {
    offsetX = event.changedTouches[0].pageX - box.left;
    offsetY = event.changedTouches[0].pageY + box.top;
    if (IS_IOS) {
      offsetX -= translated.x;
      offsetY -= translated.y;
    }
  }
  position2.y = 1 - Math.max(0, Math.min(1, offsetY / boxH));
  position2.x = Math.max(0, Math.min(1, offsetX / boxW));
  return position2;
}
function isTextNode(value) {
  return isObject2(value) && value.nodeType === 3;
}
function emptyEl(el) {
  while (el.firstChild) {
    el.removeChild(el.firstChild);
  }
  return el;
}
function normalizeContent(content2) {
  if (typeof content2 === "function") {
    content2 = content2();
  }
  return (Array.isArray(content2) ? content2 : [content2]).map(function(value) {
    if (typeof value === "function") {
      value = value();
    }
    if (isEl(value) || isTextNode(value)) {
      return value;
    }
    if (typeof value === "string" && /\S/.test(value)) {
      return document_1.createTextNode(value);
    }
  }).filter(function(value) {
    return value;
  });
}
function appendContent(el, content2) {
  normalizeContent(content2).forEach(function(node) {
    return el.appendChild(node);
  });
  return el;
}
function insertContent(el, content2) {
  return appendContent(emptyEl(el), content2);
}
function isSingleLeftClick(event) {
  if (event.button === void 0 && event.buttons === void 0) {
    return true;
  }
  if (event.button === 0 && event.buttons === void 0) {
    return true;
  }
  if (event.type === "mouseup" && event.button === 0 && event.buttons === 0) {
    return true;
  }
  if (event.button !== 0 || event.buttons !== 1) {
    return false;
  }
  return true;
}
var $ = createQuerier("querySelector");
var $$ = createQuerier("querySelectorAll");
var Dom = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  isReal,
  isEl,
  isInFrame,
  createEl,
  textContent,
  prependTo,
  hasClass,
  addClass,
  removeClass,
  toggleClass,
  setAttributes,
  getAttributes,
  getAttribute,
  setAttribute,
  removeAttribute,
  blockTextSelection,
  unblockTextSelection,
  getBoundingClientRect,
  findPosition,
  getPointerPosition,
  isTextNode,
  emptyEl,
  normalizeContent,
  appendContent,
  insertContent,
  isSingleLeftClick,
  $,
  $$
});
var _windowLoaded = false;
var videojs$1;
var autoSetup = function autoSetup2() {
  if (videojs$1.options.autoSetup === false) {
    return;
  }
  var vids = Array.prototype.slice.call(document_1.getElementsByTagName("video"));
  var audios = Array.prototype.slice.call(document_1.getElementsByTagName("audio"));
  var divs = Array.prototype.slice.call(document_1.getElementsByTagName("video-js"));
  var mediaEls = vids.concat(audios, divs);
  if (mediaEls && mediaEls.length > 0) {
    for (var i = 0, e = mediaEls.length; i < e; i++) {
      var mediaEl = mediaEls[i];
      if (mediaEl && mediaEl.getAttribute) {
        if (mediaEl.player === void 0) {
          var options = mediaEl.getAttribute("data-setup");
          if (options !== null) {
            videojs$1(mediaEl);
          }
        }
      } else {
        autoSetupTimeout(1);
        break;
      }
    }
  } else if (!_windowLoaded) {
    autoSetupTimeout(1);
  }
};
function autoSetupTimeout(wait, vjs) {
  if (!isReal()) {
    return;
  }
  if (vjs) {
    videojs$1 = vjs;
  }
  window_1.setTimeout(autoSetup, wait);
}
function setWindowLoaded() {
  _windowLoaded = true;
  window_1.removeEventListener("load", setWindowLoaded);
}
if (isReal()) {
  if (document_1.readyState === "complete") {
    setWindowLoaded();
  } else {
    window_1.addEventListener("load", setWindowLoaded);
  }
}
var createStyleElement = function createStyleElement2(className) {
  var style = document_1.createElement("style");
  style.className = className;
  return style;
};
var setTextContent = function setTextContent2(el, content2) {
  if (el.styleSheet) {
    el.styleSheet.cssText = content2;
  } else {
    el.textContent = content2;
  }
};
var _initialGuid = 3;
var _guid = _initialGuid;
function newGUID() {
  return _guid++;
}
var FakeWeakMap;
if (!window_1.WeakMap) {
  FakeWeakMap = /* @__PURE__ */ function() {
    function FakeWeakMap2() {
      this.vdata = "vdata" + Math.floor(window_1.performance && window_1.performance.now() || Date.now());
      this.data = {};
    }
    var _proto = FakeWeakMap2.prototype;
    _proto.set = function set4(key, value) {
      var access = key[this.vdata] || newGUID();
      if (!key[this.vdata]) {
        key[this.vdata] = access;
      }
      this.data[access] = value;
      return this;
    };
    _proto.get = function get7(key) {
      var access = key[this.vdata];
      if (access) {
        return this.data[access];
      }
      log$1("We have no data for this element", key);
      return void 0;
    };
    _proto.has = function has(key) {
      var access = key[this.vdata];
      return access in this.data;
    };
    _proto["delete"] = function _delete(key) {
      var access = key[this.vdata];
      if (access) {
        delete this.data[access];
        delete key[this.vdata];
      }
    };
    return FakeWeakMap2;
  }();
}
var DomData = window_1.WeakMap ? /* @__PURE__ */ new WeakMap() : new FakeWeakMap();
function _cleanUpEvents(elem, type2) {
  if (!DomData.has(elem)) {
    return;
  }
  var data = DomData.get(elem);
  if (data.handlers[type2].length === 0) {
    delete data.handlers[type2];
    if (elem.removeEventListener) {
      elem.removeEventListener(type2, data.dispatcher, false);
    } else if (elem.detachEvent) {
      elem.detachEvent("on" + type2, data.dispatcher);
    }
  }
  if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
    delete data.handlers;
    delete data.dispatcher;
    delete data.disabled;
  }
  if (Object.getOwnPropertyNames(data).length === 0) {
    DomData["delete"](elem);
  }
}
function _handleMultipleEvents(fn, elem, types, callback2) {
  types.forEach(function(type2) {
    fn(elem, type2, callback2);
  });
}
function fixEvent(event) {
  if (event.fixed_) {
    return event;
  }
  function returnTrue() {
    return true;
  }
  function returnFalse() {
    return false;
  }
  if (!event || !event.isPropagationStopped || !event.isImmediatePropagationStopped) {
    var old = event || window_1.event;
    event = {};
    for (var key in old) {
      if (key !== "layerX" && key !== "layerY" && key !== "keyLocation" && key !== "webkitMovementX" && key !== "webkitMovementY" && key !== "path") {
        if (!(key === "returnValue" && old.preventDefault)) {
          event[key] = old[key];
        }
      }
    }
    if (!event.target) {
      event.target = event.srcElement || document_1;
    }
    if (!event.relatedTarget) {
      event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
    }
    event.preventDefault = function() {
      if (old.preventDefault) {
        old.preventDefault();
      }
      event.returnValue = false;
      old.returnValue = false;
      event.defaultPrevented = true;
    };
    event.defaultPrevented = false;
    event.stopPropagation = function() {
      if (old.stopPropagation) {
        old.stopPropagation();
      }
      event.cancelBubble = true;
      old.cancelBubble = true;
      event.isPropagationStopped = returnTrue;
    };
    event.isPropagationStopped = returnFalse;
    event.stopImmediatePropagation = function() {
      if (old.stopImmediatePropagation) {
        old.stopImmediatePropagation();
      }
      event.isImmediatePropagationStopped = returnTrue;
      event.stopPropagation();
    };
    event.isImmediatePropagationStopped = returnFalse;
    if (event.clientX !== null && event.clientX !== void 0) {
      var doc = document_1.documentElement;
      var body = document_1.body;
      event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }
    event.which = event.charCode || event.keyCode;
    if (event.button !== null && event.button !== void 0) {
      event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
    }
  }
  event.fixed_ = true;
  return event;
}
var _supportsPassive;
var supportsPassive = function supportsPassive2() {
  if (typeof _supportsPassive !== "boolean") {
    _supportsPassive = false;
    try {
      var opts = Object.defineProperty({}, "passive", {
        get: function get7() {
          _supportsPassive = true;
        }
      });
      window_1.addEventListener("test", null, opts);
      window_1.removeEventListener("test", null, opts);
    } catch (e) {
    }
  }
  return _supportsPassive;
};
var passiveEvents = ["touchstart", "touchmove"];
function on(elem, type2, fn) {
  if (Array.isArray(type2)) {
    return _handleMultipleEvents(on, elem, type2, fn);
  }
  if (!DomData.has(elem)) {
    DomData.set(elem, {});
  }
  var data = DomData.get(elem);
  if (!data.handlers) {
    data.handlers = {};
  }
  if (!data.handlers[type2]) {
    data.handlers[type2] = [];
  }
  if (!fn.guid) {
    fn.guid = newGUID();
  }
  data.handlers[type2].push(fn);
  if (!data.dispatcher) {
    data.disabled = false;
    data.dispatcher = function(event, hash) {
      if (data.disabled) {
        return;
      }
      event = fixEvent(event);
      var handlers = data.handlers[event.type];
      if (handlers) {
        var handlersCopy = handlers.slice(0);
        for (var m2 = 0, n2 = handlersCopy.length; m2 < n2; m2++) {
          if (event.isImmediatePropagationStopped()) {
            break;
          } else {
            try {
              handlersCopy[m2].call(elem, event, hash);
            } catch (e) {
              log$1.error(e);
            }
          }
        }
      }
    };
  }
  if (data.handlers[type2].length === 1) {
    if (elem.addEventListener) {
      var options = false;
      if (supportsPassive() && passiveEvents.indexOf(type2) > -1) {
        options = {
          passive: true
        };
      }
      elem.addEventListener(type2, data.dispatcher, options);
    } else if (elem.attachEvent) {
      elem.attachEvent("on" + type2, data.dispatcher);
    }
  }
}
function off(elem, type2, fn) {
  if (!DomData.has(elem)) {
    return;
  }
  var data = DomData.get(elem);
  if (!data.handlers) {
    return;
  }
  if (Array.isArray(type2)) {
    return _handleMultipleEvents(off, elem, type2, fn);
  }
  var removeType = function removeType2(el, t4) {
    data.handlers[t4] = [];
    _cleanUpEvents(el, t4);
  };
  if (type2 === void 0) {
    for (var t3 in data.handlers) {
      if (Object.prototype.hasOwnProperty.call(data.handlers || {}, t3)) {
        removeType(elem, t3);
      }
    }
    return;
  }
  var handlers = data.handlers[type2];
  if (!handlers) {
    return;
  }
  if (!fn) {
    removeType(elem, type2);
    return;
  }
  if (fn.guid) {
    for (var n2 = 0; n2 < handlers.length; n2++) {
      if (handlers[n2].guid === fn.guid) {
        handlers.splice(n2--, 1);
      }
    }
  }
  _cleanUpEvents(elem, type2);
}
function trigger(elem, event, hash) {
  var elemData = DomData.has(elem) ? DomData.get(elem) : {};
  var parent = elem.parentNode || elem.ownerDocument;
  if (typeof event === "string") {
    event = {
      type: event,
      target: elem
    };
  } else if (!event.target) {
    event.target = elem;
  }
  event = fixEvent(event);
  if (elemData.dispatcher) {
    elemData.dispatcher.call(elem, event, hash);
  }
  if (parent && !event.isPropagationStopped() && event.bubbles === true) {
    trigger.call(null, parent, event, hash);
  } else if (!parent && !event.defaultPrevented && event.target && event.target[event.type]) {
    if (!DomData.has(event.target)) {
      DomData.set(event.target, {});
    }
    var targetData = DomData.get(event.target);
    if (event.target[event.type]) {
      targetData.disabled = true;
      if (typeof event.target[event.type] === "function") {
        event.target[event.type]();
      }
      targetData.disabled = false;
    }
  }
  return !event.defaultPrevented;
}
function one(elem, type2, fn) {
  if (Array.isArray(type2)) {
    return _handleMultipleEvents(one, elem, type2, fn);
  }
  var func2 = function func3() {
    off(elem, type2, func3);
    fn.apply(this, arguments);
  };
  func2.guid = fn.guid = fn.guid || newGUID();
  on(elem, type2, func2);
}
function any(elem, type2, fn) {
  var func2 = function func3() {
    off(elem, type2, func3);
    fn.apply(this, arguments);
  };
  func2.guid = fn.guid = fn.guid || newGUID();
  on(elem, type2, func2);
}
var Events = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  fixEvent,
  on,
  off,
  trigger,
  one,
  any
});
var UPDATE_REFRESH_INTERVAL = 30;
var bind = function bind2(context, fn, uid) {
  if (!fn.guid) {
    fn.guid = newGUID();
  }
  var bound = fn.bind(context);
  bound.guid = uid ? uid + "_" + fn.guid : fn.guid;
  return bound;
};
var throttle = function throttle2(fn, wait) {
  var last = window_1.performance.now();
  var throttled = function throttled2() {
    var now = window_1.performance.now();
    if (now - last >= wait) {
      fn.apply(void 0, arguments);
      last = now;
    }
  };
  return throttled;
};
var debounce = function debounce2(func2, wait, immediate, context) {
  if (context === void 0) {
    context = window_1;
  }
  var timeout;
  var cancel = function cancel2() {
    context.clearTimeout(timeout);
    timeout = null;
  };
  var debounced = function debounced2() {
    var self2 = this;
    var args = arguments;
    var _later = function later() {
      timeout = null;
      _later = null;
      if (!immediate) {
        func2.apply(self2, args);
      }
    };
    if (!timeout && immediate) {
      func2.apply(self2, args);
    }
    context.clearTimeout(timeout);
    timeout = context.setTimeout(_later, wait);
  };
  debounced.cancel = cancel;
  return debounced;
};
var EventTarget$2 = function EventTarget() {
};
EventTarget$2.prototype.allowedEvents_ = {};
EventTarget$2.prototype.on = function(type2, fn) {
  var ael = this.addEventListener;
  this.addEventListener = function() {
  };
  on(this, type2, fn);
  this.addEventListener = ael;
};
EventTarget$2.prototype.addEventListener = EventTarget$2.prototype.on;
EventTarget$2.prototype.off = function(type2, fn) {
  off(this, type2, fn);
};
EventTarget$2.prototype.removeEventListener = EventTarget$2.prototype.off;
EventTarget$2.prototype.one = function(type2, fn) {
  var ael = this.addEventListener;
  this.addEventListener = function() {
  };
  one(this, type2, fn);
  this.addEventListener = ael;
};
EventTarget$2.prototype.any = function(type2, fn) {
  var ael = this.addEventListener;
  this.addEventListener = function() {
  };
  any(this, type2, fn);
  this.addEventListener = ael;
};
EventTarget$2.prototype.trigger = function(event) {
  var type2 = event.type || event;
  if (typeof event === "string") {
    event = {
      type: type2
    };
  }
  event = fixEvent(event);
  if (this.allowedEvents_[type2] && this["on" + type2]) {
    this["on" + type2](event);
  }
  trigger(this, event);
};
EventTarget$2.prototype.dispatchEvent = EventTarget$2.prototype.trigger;
var EVENT_MAP;
EventTarget$2.prototype.queueTrigger = function(event) {
  var _this = this;
  if (!EVENT_MAP) {
    EVENT_MAP = /* @__PURE__ */ new Map();
  }
  var type2 = event.type || event;
  var map = EVENT_MAP.get(this);
  if (!map) {
    map = /* @__PURE__ */ new Map();
    EVENT_MAP.set(this, map);
  }
  var oldTimeout = map.get(type2);
  map["delete"](type2);
  window_1.clearTimeout(oldTimeout);
  var timeout = window_1.setTimeout(function() {
    map["delete"](type2);
    if (map.size === 0) {
      map = null;
      EVENT_MAP["delete"](_this);
    }
    _this.trigger(event);
  }, 0);
  map.set(type2, timeout);
};
var objName = function objName2(obj) {
  if (typeof obj.name === "function") {
    return obj.name();
  }
  if (typeof obj.name === "string") {
    return obj.name;
  }
  if (obj.name_) {
    return obj.name_;
  }
  if (obj.constructor && obj.constructor.name) {
    return obj.constructor.name;
  }
  return typeof obj;
};
var isEvented = function isEvented2(object) {
  return object instanceof EventTarget$2 || !!object.eventBusEl_ && ["on", "one", "off", "trigger"].every(function(k) {
    return typeof object[k] === "function";
  });
};
var addEventedCallback = function addEventedCallback2(target, callback2) {
  if (isEvented(target)) {
    callback2();
  } else {
    if (!target.eventedCallbacks) {
      target.eventedCallbacks = [];
    }
    target.eventedCallbacks.push(callback2);
  }
};
var isValidEventType = function isValidEventType2(type2) {
  return typeof type2 === "string" && /\S/.test(type2) || Array.isArray(type2) && !!type2.length;
};
var validateTarget = function validateTarget2(target, obj, fnName) {
  if (!target || !target.nodeName && !isEvented(target)) {
    throw new Error("Invalid target for " + objName(obj) + "#" + fnName + "; must be a DOM node or evented object.");
  }
};
var validateEventType = function validateEventType2(type2, obj, fnName) {
  if (!isValidEventType(type2)) {
    throw new Error("Invalid event type for " + objName(obj) + "#" + fnName + "; must be a non-empty string or array.");
  }
};
var validateListener = function validateListener2(listener3, obj, fnName) {
  if (typeof listener3 !== "function") {
    throw new Error("Invalid listener for " + objName(obj) + "#" + fnName + "; must be a function.");
  }
};
var normalizeListenArgs = function normalizeListenArgs2(self2, args, fnName) {
  var isTargetingSelf = args.length < 3 || args[0] === self2 || args[0] === self2.eventBusEl_;
  var target;
  var type2;
  var listener3;
  if (isTargetingSelf) {
    target = self2.eventBusEl_;
    if (args.length >= 3) {
      args.shift();
    }
    type2 = args[0];
    listener3 = args[1];
  } else {
    target = args[0];
    type2 = args[1];
    listener3 = args[2];
  }
  validateTarget(target, self2, fnName);
  validateEventType(type2, self2, fnName);
  validateListener(listener3, self2, fnName);
  listener3 = bind(self2, listener3);
  return {
    isTargetingSelf,
    target,
    type: type2,
    listener: listener3
  };
};
var listen = function listen2(target, method, type2, listener3) {
  validateTarget(target, target, method);
  if (target.nodeName) {
    Events[method](target, type2, listener3);
  } else {
    target[method](type2, listener3);
  }
};
var EventedMixin = {
  on: function on2() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var _normalizeListenArgs = normalizeListenArgs(this, args, "on"), isTargetingSelf = _normalizeListenArgs.isTargetingSelf, target = _normalizeListenArgs.target, type2 = _normalizeListenArgs.type, listener3 = _normalizeListenArgs.listener;
    listen(target, "on", type2, listener3);
    if (!isTargetingSelf) {
      var removeListenerOnDispose = function removeListenerOnDispose2() {
        return _this.off(target, type2, listener3);
      };
      removeListenerOnDispose.guid = listener3.guid;
      var removeRemoverOnTargetDispose = function removeRemoverOnTargetDispose2() {
        return _this.off("dispose", removeListenerOnDispose);
      };
      removeRemoverOnTargetDispose.guid = listener3.guid;
      listen(this, "on", "dispose", removeListenerOnDispose);
      listen(target, "on", "dispose", removeRemoverOnTargetDispose);
    }
  },
  one: function one2() {
    var _this2 = this;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var _normalizeListenArgs2 = normalizeListenArgs(this, args, "one"), isTargetingSelf = _normalizeListenArgs2.isTargetingSelf, target = _normalizeListenArgs2.target, type2 = _normalizeListenArgs2.type, listener3 = _normalizeListenArgs2.listener;
    if (isTargetingSelf) {
      listen(target, "one", type2, listener3);
    } else {
      var wrapper2 = function wrapper3() {
        _this2.off(target, type2, wrapper3);
        for (var _len3 = arguments.length, largs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          largs[_key3] = arguments[_key3];
        }
        listener3.apply(null, largs);
      };
      wrapper2.guid = listener3.guid;
      listen(target, "one", type2, wrapper2);
    }
  },
  any: function any2() {
    var _this3 = this;
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    var _normalizeListenArgs3 = normalizeListenArgs(this, args, "any"), isTargetingSelf = _normalizeListenArgs3.isTargetingSelf, target = _normalizeListenArgs3.target, type2 = _normalizeListenArgs3.type, listener3 = _normalizeListenArgs3.listener;
    if (isTargetingSelf) {
      listen(target, "any", type2, listener3);
    } else {
      var wrapper2 = function wrapper3() {
        _this3.off(target, type2, wrapper3);
        for (var _len5 = arguments.length, largs = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          largs[_key5] = arguments[_key5];
        }
        listener3.apply(null, largs);
      };
      wrapper2.guid = listener3.guid;
      listen(target, "any", type2, wrapper2);
    }
  },
  off: function off$1(targetOrType, typeOrListener, listener3) {
    if (!targetOrType || isValidEventType(targetOrType)) {
      off(this.eventBusEl_, targetOrType, typeOrListener);
    } else {
      var target = targetOrType;
      var type2 = typeOrListener;
      validateTarget(target, this, "off");
      validateEventType(type2, this, "off");
      validateListener(listener3, this, "off");
      listener3 = bind(this, listener3);
      this.off("dispose", listener3);
      if (target.nodeName) {
        off(target, type2, listener3);
        off(target, "dispose", listener3);
      } else if (isEvented(target)) {
        target.off(type2, listener3);
        target.off("dispose", listener3);
      }
    }
  },
  trigger: function trigger$1(event, hash) {
    validateTarget(this.eventBusEl_, this, "trigger");
    var type2 = event && typeof event !== "string" ? event.type : event;
    if (!isValidEventType(type2)) {
      var error2 = "Invalid event type for " + objName(this) + "#trigger; must be a non-empty string or object with a type key that has a non-empty value.";
      if (event) {
        (this.log || log$1).error(error2);
      } else {
        throw new Error(error2);
      }
    }
    return trigger(this.eventBusEl_, event, hash);
  }
};
function evented(target, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, eventBusKey = _options.eventBusKey;
  if (eventBusKey) {
    if (!target[eventBusKey].nodeName) {
      throw new Error('The eventBusKey "' + eventBusKey + '" does not refer to an element.');
    }
    target.eventBusEl_ = target[eventBusKey];
  } else {
    target.eventBusEl_ = createEl("span", {
      className: "vjs-event-bus"
    });
  }
  assign(target, EventedMixin);
  if (target.eventedCallbacks) {
    target.eventedCallbacks.forEach(function(callback2) {
      callback2();
    });
  }
  target.on("dispose", function() {
    target.off();
    [target, target.el_, target.eventBusEl_].forEach(function(val) {
      if (val && DomData.has(val)) {
        DomData["delete"](val);
      }
    });
    window_1.setTimeout(function() {
      target.eventBusEl_ = null;
    }, 0);
  });
  return target;
}
var StatefulMixin = {
  state: {},
  setState: function setState(stateUpdates) {
    var _this = this;
    if (typeof stateUpdates === "function") {
      stateUpdates = stateUpdates();
    }
    var changes;
    each(stateUpdates, function(value, key) {
      if (_this.state[key] !== value) {
        changes = changes || {};
        changes[key] = {
          from: _this.state[key],
          to: value
        };
      }
      _this.state[key] = value;
    });
    if (changes && isEvented(this)) {
      this.trigger({
        changes,
        type: "statechanged"
      });
    }
    return changes;
  }
};
function stateful(target, defaultState) {
  assign(target, StatefulMixin);
  target.state = assign({}, target.state, defaultState);
  if (typeof target.handleStateChanged === "function" && isEvented(target)) {
    target.on("statechanged", target.handleStateChanged);
  }
  return target;
}
var toLowerCase = function toLowerCase2(string2) {
  if (typeof string2 !== "string") {
    return string2;
  }
  return string2.replace(/./, function(w2) {
    return w2.toLowerCase();
  });
};
var toTitleCase$1 = function toTitleCase(string2) {
  if (typeof string2 !== "string") {
    return string2;
  }
  return string2.replace(/./, function(w2) {
    return w2.toUpperCase();
  });
};
var titleCaseEquals = function titleCaseEquals2(str1, str2) {
  return toTitleCase$1(str1) === toTitleCase$1(str2);
};
function mergeOptions$3() {
  var result2 = {};
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  sources.forEach(function(source) {
    if (!source) {
      return;
    }
    each(source, function(value, key) {
      if (!isPlain(value)) {
        result2[key] = value;
        return;
      }
      if (!isPlain(result2[key])) {
        result2[key] = {};
      }
      result2[key] = mergeOptions$3(result2[key], value);
    });
  });
  return result2;
}
var MapSham = /* @__PURE__ */ function() {
  function MapSham2() {
    this.map_ = {};
  }
  var _proto = MapSham2.prototype;
  _proto.has = function has(key) {
    return key in this.map_;
  };
  _proto["delete"] = function _delete(key) {
    var has = this.has(key);
    delete this.map_[key];
    return has;
  };
  _proto.set = function set4(key, value) {
    this.map_[key] = value;
    return this;
  };
  _proto.forEach = function forEach(callback2, thisArg) {
    for (var key in this.map_) {
      callback2.call(thisArg, this.map_[key], key, this);
    }
  };
  return MapSham2;
}();
var Map$1 = window_1.Map ? window_1.Map : MapSham;
var SetSham = /* @__PURE__ */ function() {
  function SetSham2() {
    this.set_ = {};
  }
  var _proto = SetSham2.prototype;
  _proto.has = function has(key) {
    return key in this.set_;
  };
  _proto["delete"] = function _delete(key) {
    var has = this.has(key);
    delete this.set_[key];
    return has;
  };
  _proto.add = function add2(key) {
    this.set_[key] = 1;
    return this;
  };
  _proto.forEach = function forEach(callback2, thisArg) {
    for (var key in this.set_) {
      callback2.call(thisArg, key, key, this);
    }
  };
  return SetSham2;
}();
var Set$1 = window_1.Set ? window_1.Set : SetSham;
var Component$1 = /* @__PURE__ */ function() {
  function Component2(player, options, ready) {
    var _this = this;
    if (!player && this.play) {
      this.player_ = player = this;
    } else {
      this.player_ = player;
    }
    this.isDisposed_ = false;
    this.parentComponent_ = null;
    this.options_ = mergeOptions$3({}, this.options_);
    options = this.options_ = mergeOptions$3(this.options_, options);
    this.id_ = options.id || options.el && options.el.id;
    if (!this.id_) {
      var id2 = player && player.id && player.id() || "no_player";
      this.id_ = id2 + "_component_" + newGUID();
    }
    this.name_ = options.name || null;
    if (options.el) {
      this.el_ = options.el;
    } else if (options.createEl !== false) {
      this.el_ = this.createEl();
    }
    if (options.className && this.el_) {
      options.className.split(" ").forEach(function(c) {
        return _this.addClass(c);
      });
    }
    if (options.evented !== false) {
      evented(this, {
        eventBusKey: this.el_ ? "el_" : null
      });
      this.handleLanguagechange = this.handleLanguagechange.bind(this);
      this.on(this.player_, "languagechange", this.handleLanguagechange);
    }
    stateful(this, this.constructor.defaultState);
    this.children_ = [];
    this.childIndex_ = {};
    this.childNameIndex_ = {};
    this.setTimeoutIds_ = new Set$1();
    this.setIntervalIds_ = new Set$1();
    this.rafIds_ = new Set$1();
    this.namedRafs_ = new Map$1();
    this.clearingTimersOnDispose_ = false;
    if (options.initChildren !== false) {
      this.initChildren();
    }
    this.ready(ready);
    if (options.reportTouchActivity !== false) {
      this.enableTouchActivity();
    }
  }
  var _proto = Component2.prototype;
  _proto.dispose = function dispose(options) {
    if (options === void 0) {
      options = {};
    }
    if (this.isDisposed_) {
      return;
    }
    if (this.readyQueue_) {
      this.readyQueue_.length = 0;
    }
    this.trigger({
      type: "dispose",
      bubbles: false
    });
    this.isDisposed_ = true;
    if (this.children_) {
      for (var i = this.children_.length - 1; i >= 0; i--) {
        if (this.children_[i].dispose) {
          this.children_[i].dispose();
        }
      }
    }
    this.children_ = null;
    this.childIndex_ = null;
    this.childNameIndex_ = null;
    this.parentComponent_ = null;
    if (this.el_) {
      if (this.el_.parentNode) {
        if (options.restoreEl) {
          this.el_.parentNode.replaceChild(options.restoreEl, this.el_);
        } else {
          this.el_.parentNode.removeChild(this.el_);
        }
      }
      this.el_ = null;
    }
    this.player_ = null;
  };
  _proto.isDisposed = function isDisposed() {
    return Boolean(this.isDisposed_);
  };
  _proto.player = function player() {
    return this.player_;
  };
  _proto.options = function options(obj) {
    if (!obj) {
      return this.options_;
    }
    this.options_ = mergeOptions$3(this.options_, obj);
    return this.options_;
  };
  _proto.el = function el() {
    return this.el_;
  };
  _proto.createEl = function createEl$1(tagName, properties, attributes) {
    return createEl(tagName, properties, attributes);
  };
  _proto.localize = function localize(string2, tokens, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = string2;
    }
    var code = this.player_.language && this.player_.language();
    var languages = this.player_.languages && this.player_.languages();
    var language = languages && languages[code];
    var primaryCode = code && code.split("-")[0];
    var primaryLang = languages && languages[primaryCode];
    var localizedString = defaultValue;
    if (language && language[string2]) {
      localizedString = language[string2];
    } else if (primaryLang && primaryLang[string2]) {
      localizedString = primaryLang[string2];
    }
    if (tokens) {
      localizedString = localizedString.replace(/\{(\d+)\}/g, function(match, index) {
        var value = tokens[index - 1];
        var ret = value;
        if (typeof value === "undefined") {
          ret = match;
        }
        return ret;
      });
    }
    return localizedString;
  };
  _proto.handleLanguagechange = function handleLanguagechange() {
  };
  _proto.contentEl = function contentEl() {
    return this.contentEl_ || this.el_;
  };
  _proto.id = function id2() {
    return this.id_;
  };
  _proto.name = function name() {
    return this.name_;
  };
  _proto.children = function children() {
    return this.children_;
  };
  _proto.getChildById = function getChildById(id2) {
    return this.childIndex_[id2];
  };
  _proto.getChild = function getChild(name) {
    if (!name) {
      return;
    }
    return this.childNameIndex_[name];
  };
  _proto.getDescendant = function getDescendant() {
    for (var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++) {
      names[_key] = arguments[_key];
    }
    names = names.reduce(function(acc, n2) {
      return acc.concat(n2);
    }, []);
    var currentChild = this;
    for (var i = 0; i < names.length; i++) {
      currentChild = currentChild.getChild(names[i]);
      if (!currentChild || !currentChild.getChild) {
        return;
      }
    }
    return currentChild;
  };
  _proto.addChild = function addChild(child, options, index) {
    if (options === void 0) {
      options = {};
    }
    if (index === void 0) {
      index = this.children_.length;
    }
    var component;
    var componentName;
    if (typeof child === "string") {
      componentName = toTitleCase$1(child);
      var componentClassName = options.componentClass || componentName;
      options.name = componentName;
      var ComponentClass = Component2.getComponent(componentClassName);
      if (!ComponentClass) {
        throw new Error("Component " + componentClassName + " does not exist");
      }
      if (typeof ComponentClass !== "function") {
        return null;
      }
      component = new ComponentClass(this.player_ || this, options);
    } else {
      component = child;
    }
    if (component.parentComponent_) {
      component.parentComponent_.removeChild(component);
    }
    this.children_.splice(index, 0, component);
    component.parentComponent_ = this;
    if (typeof component.id === "function") {
      this.childIndex_[component.id()] = component;
    }
    componentName = componentName || component.name && toTitleCase$1(component.name());
    if (componentName) {
      this.childNameIndex_[componentName] = component;
      this.childNameIndex_[toLowerCase(componentName)] = component;
    }
    if (typeof component.el === "function" && component.el()) {
      var refNode = null;
      if (this.children_[index + 1]) {
        if (this.children_[index + 1].el_) {
          refNode = this.children_[index + 1].el_;
        } else if (isEl(this.children_[index + 1])) {
          refNode = this.children_[index + 1];
        }
      }
      this.contentEl().insertBefore(component.el(), refNode);
    }
    return component;
  };
  _proto.removeChild = function removeChild(component) {
    if (typeof component === "string") {
      component = this.getChild(component);
    }
    if (!component || !this.children_) {
      return;
    }
    var childFound = false;
    for (var i = this.children_.length - 1; i >= 0; i--) {
      if (this.children_[i] === component) {
        childFound = true;
        this.children_.splice(i, 1);
        break;
      }
    }
    if (!childFound) {
      return;
    }
    component.parentComponent_ = null;
    this.childIndex_[component.id()] = null;
    this.childNameIndex_[toTitleCase$1(component.name())] = null;
    this.childNameIndex_[toLowerCase(component.name())] = null;
    var compEl = component.el();
    if (compEl && compEl.parentNode === this.contentEl()) {
      this.contentEl().removeChild(component.el());
    }
  };
  _proto.initChildren = function initChildren() {
    var _this2 = this;
    var children = this.options_.children;
    if (children) {
      var parentOptions = this.options_;
      var handleAdd = function handleAdd2(child) {
        var name = child.name;
        var opts = child.opts;
        if (parentOptions[name] !== void 0) {
          opts = parentOptions[name];
        }
        if (opts === false) {
          return;
        }
        if (opts === true) {
          opts = {};
        }
        opts.playerOptions = _this2.options_.playerOptions;
        var newChild = _this2.addChild(name, opts);
        if (newChild) {
          _this2[name] = newChild;
        }
      };
      var workingChildren;
      var Tech2 = Component2.getComponent("Tech");
      if (Array.isArray(children)) {
        workingChildren = children;
      } else {
        workingChildren = Object.keys(children);
      }
      workingChildren.concat(Object.keys(this.options_).filter(function(child) {
        return !workingChildren.some(function(wchild) {
          if (typeof wchild === "string") {
            return child === wchild;
          }
          return child === wchild.name;
        });
      })).map(function(child) {
        var name;
        var opts;
        if (typeof child === "string") {
          name = child;
          opts = children[name] || _this2.options_[name] || {};
        } else {
          name = child.name;
          opts = child;
        }
        return {
          name,
          opts
        };
      }).filter(function(child) {
        var c = Component2.getComponent(child.opts.componentClass || toTitleCase$1(child.name));
        return c && !Tech2.isTech(c);
      }).forEach(handleAdd);
    }
  };
  _proto.buildCSSClass = function buildCSSClass() {
    return "";
  };
  _proto.ready = function ready(fn, sync) {
    if (sync === void 0) {
      sync = false;
    }
    if (!fn) {
      return;
    }
    if (!this.isReady_) {
      this.readyQueue_ = this.readyQueue_ || [];
      this.readyQueue_.push(fn);
      return;
    }
    if (sync) {
      fn.call(this);
    } else {
      this.setTimeout(fn, 1);
    }
  };
  _proto.triggerReady = function triggerReady() {
    this.isReady_ = true;
    this.setTimeout(function() {
      var readyQueue = this.readyQueue_;
      this.readyQueue_ = [];
      if (readyQueue && readyQueue.length > 0) {
        readyQueue.forEach(function(fn) {
          fn.call(this);
        }, this);
      }
      this.trigger("ready");
    }, 1);
  };
  _proto.$ = function $$1(selector, context) {
    return $(selector, context || this.contentEl());
  };
  _proto.$$ = function $$$1(selector, context) {
    return $$(selector, context || this.contentEl());
  };
  _proto.hasClass = function hasClass$1(classToCheck) {
    return hasClass(this.el_, classToCheck);
  };
  _proto.addClass = function addClass$1(classToAdd) {
    addClass(this.el_, classToAdd);
  };
  _proto.removeClass = function removeClass$12(classToRemove) {
    removeClass(this.el_, classToRemove);
  };
  _proto.toggleClass = function toggleClass$1(classToToggle, predicate) {
    toggleClass(this.el_, classToToggle, predicate);
  };
  _proto.show = function show2() {
    this.removeClass("vjs-hidden");
  };
  _proto.hide = function hide2() {
    this.addClass("vjs-hidden");
  };
  _proto.lockShowing = function lockShowing() {
    this.addClass("vjs-lock-showing");
  };
  _proto.unlockShowing = function unlockShowing() {
    this.removeClass("vjs-lock-showing");
  };
  _proto.getAttribute = function getAttribute$1(attribute) {
    return getAttribute(this.el_, attribute);
  };
  _proto.setAttribute = function setAttribute$1(attribute, value) {
    setAttribute(this.el_, attribute, value);
  };
  _proto.removeAttribute = function removeAttribute$1(attribute) {
    removeAttribute(this.el_, attribute);
  };
  _proto.width = function width2(num, skipListeners) {
    return this.dimension("width", num, skipListeners);
  };
  _proto.height = function height2(num, skipListeners) {
    return this.dimension("height", num, skipListeners);
  };
  _proto.dimensions = function dimensions(width2, height2) {
    this.width(width2, true);
    this.height(height2);
  };
  _proto.dimension = function dimension(widthOrHeight, num, skipListeners) {
    if (num !== void 0) {
      if (num === null || num !== num) {
        num = 0;
      }
      if (("" + num).indexOf("%") !== -1 || ("" + num).indexOf("px") !== -1) {
        this.el_.style[widthOrHeight] = num;
      } else if (num === "auto") {
        this.el_.style[widthOrHeight] = "";
      } else {
        this.el_.style[widthOrHeight] = num + "px";
      }
      if (!skipListeners) {
        this.trigger("componentresize");
      }
      return;
    }
    if (!this.el_) {
      return 0;
    }
    var val = this.el_.style[widthOrHeight];
    var pxIndex = val.indexOf("px");
    if (pxIndex !== -1) {
      return parseInt(val.slice(0, pxIndex), 10);
    }
    return parseInt(this.el_["offset" + toTitleCase$1(widthOrHeight)], 10);
  };
  _proto.currentDimension = function currentDimension(widthOrHeight) {
    var computedWidthOrHeight = 0;
    if (widthOrHeight !== "width" && widthOrHeight !== "height") {
      throw new Error("currentDimension only accepts width or height value");
    }
    computedWidthOrHeight = computedStyle(this.el_, widthOrHeight);
    computedWidthOrHeight = parseFloat(computedWidthOrHeight);
    if (computedWidthOrHeight === 0 || isNaN(computedWidthOrHeight)) {
      var rule = "offset" + toTitleCase$1(widthOrHeight);
      computedWidthOrHeight = this.el_[rule];
    }
    return computedWidthOrHeight;
  };
  _proto.currentDimensions = function currentDimensions() {
    return {
      width: this.currentDimension("width"),
      height: this.currentDimension("height")
    };
  };
  _proto.currentWidth = function currentWidth() {
    return this.currentDimension("width");
  };
  _proto.currentHeight = function currentHeight() {
    return this.currentDimension("height");
  };
  _proto.focus = function focus() {
    this.el_.focus();
  };
  _proto.blur = function blur() {
    this.el_.blur();
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (this.player_) {
      if (!keycode.isEventKey(event, "Tab")) {
        event.stopPropagation();
      }
      this.player_.handleKeyDown(event);
    }
  };
  _proto.handleKeyPress = function handleKeyPress(event) {
    this.handleKeyDown(event);
  };
  _proto.emitTapEvents = function emitTapEvents() {
    var touchStart = 0;
    var firstTouch = null;
    var tapMovementThreshold = 10;
    var touchTimeThreshold = 200;
    var couldBeTap;
    this.on("touchstart", function(event) {
      if (event.touches.length === 1) {
        firstTouch = {
          pageX: event.touches[0].pageX,
          pageY: event.touches[0].pageY
        };
        touchStart = window_1.performance.now();
        couldBeTap = true;
      }
    });
    this.on("touchmove", function(event) {
      if (event.touches.length > 1) {
        couldBeTap = false;
      } else if (firstTouch) {
        var xdiff = event.touches[0].pageX - firstTouch.pageX;
        var ydiff = event.touches[0].pageY - firstTouch.pageY;
        var touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
        if (touchDistance > tapMovementThreshold) {
          couldBeTap = false;
        }
      }
    });
    var noTap = function noTap2() {
      couldBeTap = false;
    };
    this.on("touchleave", noTap);
    this.on("touchcancel", noTap);
    this.on("touchend", function(event) {
      firstTouch = null;
      if (couldBeTap === true) {
        var touchTime = window_1.performance.now() - touchStart;
        if (touchTime < touchTimeThreshold) {
          event.preventDefault();
          this.trigger("tap");
        }
      }
    });
  };
  _proto.enableTouchActivity = function enableTouchActivity() {
    if (!this.player() || !this.player().reportUserActivity) {
      return;
    }
    var report = bind(this.player(), this.player().reportUserActivity);
    var touchHolding;
    this.on("touchstart", function() {
      report();
      this.clearInterval(touchHolding);
      touchHolding = this.setInterval(report, 250);
    });
    var touchEnd = function touchEnd2(event) {
      report();
      this.clearInterval(touchHolding);
    };
    this.on("touchmove", report);
    this.on("touchend", touchEnd);
    this.on("touchcancel", touchEnd);
  };
  _proto.setTimeout = function setTimeout2(fn, timeout) {
    var _this3 = this;
    var timeoutId;
    fn = bind(this, fn);
    this.clearTimersOnDispose_();
    timeoutId = window_1.setTimeout(function() {
      if (_this3.setTimeoutIds_.has(timeoutId)) {
        _this3.setTimeoutIds_["delete"](timeoutId);
      }
      fn();
    }, timeout);
    this.setTimeoutIds_.add(timeoutId);
    return timeoutId;
  };
  _proto.clearTimeout = function clearTimeout2(timeoutId) {
    if (this.setTimeoutIds_.has(timeoutId)) {
      this.setTimeoutIds_["delete"](timeoutId);
      window_1.clearTimeout(timeoutId);
    }
    return timeoutId;
  };
  _proto.setInterval = function setInterval(fn, interval) {
    fn = bind(this, fn);
    this.clearTimersOnDispose_();
    var intervalId = window_1.setInterval(fn, interval);
    this.setIntervalIds_.add(intervalId);
    return intervalId;
  };
  _proto.clearInterval = function clearInterval(intervalId) {
    if (this.setIntervalIds_.has(intervalId)) {
      this.setIntervalIds_["delete"](intervalId);
      window_1.clearInterval(intervalId);
    }
    return intervalId;
  };
  _proto.requestAnimationFrame = function requestAnimationFrame2(fn) {
    var _this4 = this;
    if (!this.supportsRaf_) {
      return this.setTimeout(fn, 1e3 / 60);
    }
    this.clearTimersOnDispose_();
    var id2;
    fn = bind(this, fn);
    id2 = window_1.requestAnimationFrame(function() {
      if (_this4.rafIds_.has(id2)) {
        _this4.rafIds_["delete"](id2);
      }
      fn();
    });
    this.rafIds_.add(id2);
    return id2;
  };
  _proto.requestNamedAnimationFrame = function requestNamedAnimationFrame(name, fn) {
    var _this5 = this;
    if (this.namedRafs_.has(name)) {
      return;
    }
    this.clearTimersOnDispose_();
    fn = bind(this, fn);
    var id2 = this.requestAnimationFrame(function() {
      fn();
      if (_this5.namedRafs_.has(name)) {
        _this5.namedRafs_["delete"](name);
      }
    });
    this.namedRafs_.set(name, id2);
    return name;
  };
  _proto.cancelNamedAnimationFrame = function cancelNamedAnimationFrame(name) {
    if (!this.namedRafs_.has(name)) {
      return;
    }
    this.cancelAnimationFrame(this.namedRafs_.get(name));
    this.namedRafs_["delete"](name);
  };
  _proto.cancelAnimationFrame = function cancelAnimationFrame2(id2) {
    if (!this.supportsRaf_) {
      return this.clearTimeout(id2);
    }
    if (this.rafIds_.has(id2)) {
      this.rafIds_["delete"](id2);
      window_1.cancelAnimationFrame(id2);
    }
    return id2;
  };
  _proto.clearTimersOnDispose_ = function clearTimersOnDispose_() {
    var _this6 = this;
    if (this.clearingTimersOnDispose_) {
      return;
    }
    this.clearingTimersOnDispose_ = true;
    this.one("dispose", function() {
      [["namedRafs_", "cancelNamedAnimationFrame"], ["rafIds_", "cancelAnimationFrame"], ["setTimeoutIds_", "clearTimeout"], ["setIntervalIds_", "clearInterval"]].forEach(function(_ref2) {
        var idName = _ref2[0], cancelName = _ref2[1];
        _this6[idName].forEach(function(val, key) {
          return _this6[cancelName](key);
        });
      });
      _this6.clearingTimersOnDispose_ = false;
    });
  };
  Component2.registerComponent = function registerComponent(name, ComponentToRegister) {
    if (typeof name !== "string" || !name) {
      throw new Error('Illegal component name, "' + name + '"; must be a non-empty string.');
    }
    var Tech2 = Component2.getComponent("Tech");
    var isTech = Tech2 && Tech2.isTech(ComponentToRegister);
    var isComp = Component2 === ComponentToRegister || Component2.prototype.isPrototypeOf(ComponentToRegister.prototype);
    if (isTech || !isComp) {
      var reason;
      if (isTech) {
        reason = "techs must be registered using Tech.registerTech()";
      } else {
        reason = "must be a Component subclass";
      }
      throw new Error('Illegal component, "' + name + '"; ' + reason + ".");
    }
    name = toTitleCase$1(name);
    if (!Component2.components_) {
      Component2.components_ = {};
    }
    var Player2 = Component2.getComponent("Player");
    if (name === "Player" && Player2 && Player2.players) {
      var players = Player2.players;
      var playerNames = Object.keys(players);
      if (players && playerNames.length > 0 && playerNames.map(function(pname) {
        return players[pname];
      }).every(Boolean)) {
        throw new Error("Can not register Player component after player has been created.");
      }
    }
    Component2.components_[name] = ComponentToRegister;
    Component2.components_[toLowerCase(name)] = ComponentToRegister;
    return ComponentToRegister;
  };
  Component2.getComponent = function getComponent(name) {
    if (!name || !Component2.components_) {
      return;
    }
    return Component2.components_[name];
  };
  return Component2;
}();
Component$1.prototype.supportsRaf_ = typeof window_1.requestAnimationFrame === "function" && typeof window_1.cancelAnimationFrame === "function";
Component$1.registerComponent("Component", Component$1);
function rangeCheck(fnName, index, maxIndex) {
  if (typeof index !== "number" || index < 0 || index > maxIndex) {
    throw new Error("Failed to execute '" + fnName + "' on 'TimeRanges': The index provided (" + index + ") is non-numeric or out of bounds (0-" + maxIndex + ").");
  }
}
function getRange(fnName, valueIndex, ranges, rangeIndex) {
  rangeCheck(fnName, rangeIndex, ranges.length - 1);
  return ranges[rangeIndex][valueIndex];
}
function createTimeRangesObj(ranges) {
  var timeRangesObj;
  if (ranges === void 0 || ranges.length === 0) {
    timeRangesObj = {
      length: 0,
      start: function start2() {
        throw new Error("This TimeRanges object is empty");
      },
      end: function end3() {
        throw new Error("This TimeRanges object is empty");
      }
    };
  } else {
    timeRangesObj = {
      length: ranges.length,
      start: getRange.bind(null, "start", 0, ranges),
      end: getRange.bind(null, "end", 1, ranges)
    };
  }
  if (window_1.Symbol && window_1.Symbol.iterator) {
    timeRangesObj[window_1.Symbol.iterator] = function() {
      return (ranges || []).values();
    };
  }
  return timeRangesObj;
}
function createTimeRanges(start2, end3) {
  if (Array.isArray(start2)) {
    return createTimeRangesObj(start2);
  } else if (start2 === void 0 || end3 === void 0) {
    return createTimeRangesObj();
  }
  return createTimeRangesObj([[start2, end3]]);
}
function bufferedPercent(buffered, duration5) {
  var bufferedDuration = 0;
  var start2;
  var end3;
  if (!duration5) {
    return 0;
  }
  if (!buffered || !buffered.length) {
    buffered = createTimeRanges(0, 0);
  }
  for (var i = 0; i < buffered.length; i++) {
    start2 = buffered.start(i);
    end3 = buffered.end(i);
    if (end3 > duration5) {
      end3 = duration5;
    }
    bufferedDuration += end3 - start2;
  }
  return bufferedDuration / duration5;
}
function MediaError(value) {
  if (value instanceof MediaError) {
    return value;
  }
  if (typeof value === "number") {
    this.code = value;
  } else if (typeof value === "string") {
    this.message = value;
  } else if (isObject2(value)) {
    if (typeof value.code === "number") {
      this.code = value.code;
    }
    assign(this, value);
  }
  if (!this.message) {
    this.message = MediaError.defaultMessages[this.code] || "";
  }
}
MediaError.prototype.code = 0;
MediaError.prototype.message = "";
MediaError.prototype.status = null;
MediaError.errorTypes = ["MEDIA_ERR_CUSTOM", "MEDIA_ERR_ABORTED", "MEDIA_ERR_NETWORK", "MEDIA_ERR_DECODE", "MEDIA_ERR_SRC_NOT_SUPPORTED", "MEDIA_ERR_ENCRYPTED"];
MediaError.defaultMessages = {
  1: "You aborted the media playback",
  2: "A network error caused the media download to fail part-way.",
  3: "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.",
  4: "The media could not be loaded, either because the server or network failed or because the format is not supported.",
  5: "The media is encrypted and we do not have the keys to decrypt it."
};
for (var errNum = 0; errNum < MediaError.errorTypes.length; errNum++) {
  MediaError[MediaError.errorTypes[errNum]] = errNum;
  MediaError.prototype[MediaError.errorTypes[errNum]] = errNum;
}
function isPromise(value) {
  return value !== void 0 && value !== null && typeof value.then === "function";
}
function silencePromise(value) {
  if (isPromise(value)) {
    value.then(null, function(e) {
    });
  }
}
var trackToJson_ = function trackToJson_2(track) {
  var ret = ["kind", "label", "language", "id", "inBandMetadataTrackDispatchType", "mode", "src"].reduce(function(acc, prop, i) {
    if (track[prop]) {
      acc[prop] = track[prop];
    }
    return acc;
  }, {
    cues: track.cues && Array.prototype.map.call(track.cues, function(cue) {
      return {
        startTime: cue.startTime,
        endTime: cue.endTime,
        text: cue.text,
        id: cue.id
      };
    })
  });
  return ret;
};
var textTracksToJson = function textTracksToJson2(tech) {
  var trackEls = tech.$$("track");
  var trackObjs = Array.prototype.map.call(trackEls, function(t3) {
    return t3.track;
  });
  var tracks = Array.prototype.map.call(trackEls, function(trackEl) {
    var json = trackToJson_(trackEl.track);
    if (trackEl.src) {
      json.src = trackEl.src;
    }
    return json;
  });
  return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function(track) {
    return trackObjs.indexOf(track) === -1;
  }).map(trackToJson_));
};
var jsonToTextTracks = function jsonToTextTracks2(json, tech) {
  json.forEach(function(track) {
    var addedTrack = tech.addRemoteTextTrack(track).track;
    if (!track.src && track.cues) {
      track.cues.forEach(function(cue) {
        return addedTrack.addCue(cue);
      });
    }
  });
  return tech.textTracks();
};
var textTrackConverter = {
  textTracksToJson,
  jsonToTextTracks,
  trackToJson_
};
var MODAL_CLASS_NAME = "vjs-modal-dialog";
var ModalDialog = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(ModalDialog2, _Component);
  function ModalDialog2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.handleKeyDown_ = function(e) {
      return _this.handleKeyDown(e);
    };
    _this.close_ = function(e) {
      return _this.close(e);
    };
    _this.opened_ = _this.hasBeenOpened_ = _this.hasBeenFilled_ = false;
    _this.closeable(!_this.options_.uncloseable);
    _this.content(_this.options_.content);
    _this.contentEl_ = createEl("div", {
      className: MODAL_CLASS_NAME + "-content"
    }, {
      role: "document"
    });
    _this.descEl_ = createEl("p", {
      className: MODAL_CLASS_NAME + "-description vjs-control-text",
      id: _this.el().getAttribute("aria-describedby")
    });
    textContent(_this.descEl_, _this.description());
    _this.el_.appendChild(_this.descEl_);
    _this.el_.appendChild(_this.contentEl_);
    return _this;
  }
  var _proto = ModalDialog2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass(),
      tabIndex: -1
    }, {
      "aria-describedby": this.id() + "_description",
      "aria-hidden": "true",
      "aria-label": this.label(),
      "role": "dialog"
    });
  };
  _proto.dispose = function dispose() {
    this.contentEl_ = null;
    this.descEl_ = null;
    this.previouslyActiveEl_ = null;
    _Component.prototype.dispose.call(this);
  };
  _proto.buildCSSClass = function buildCSSClass() {
    return MODAL_CLASS_NAME + " vjs-hidden " + _Component.prototype.buildCSSClass.call(this);
  };
  _proto.label = function label() {
    return this.localize(this.options_.label || "Modal Window");
  };
  _proto.description = function description2() {
    var desc = this.options_.description || this.localize("This is a modal window.");
    if (this.closeable()) {
      desc += " " + this.localize("This modal can be closed by pressing the Escape key or activating the close button.");
    }
    return desc;
  };
  _proto.open = function open() {
    if (!this.opened_) {
      var player = this.player();
      this.trigger("beforemodalopen");
      this.opened_ = true;
      if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) {
        this.fill();
      }
      this.wasPlaying_ = !player.paused();
      if (this.options_.pauseOnOpen && this.wasPlaying_) {
        player.pause();
      }
      this.on("keydown", this.handleKeyDown_);
      this.hadControls_ = player.controls();
      player.controls(false);
      this.show();
      this.conditionalFocus_();
      this.el().setAttribute("aria-hidden", "false");
      this.trigger("modalopen");
      this.hasBeenOpened_ = true;
    }
  };
  _proto.opened = function opened(value) {
    if (typeof value === "boolean") {
      this[value ? "open" : "close"]();
    }
    return this.opened_;
  };
  _proto.close = function close() {
    if (!this.opened_) {
      return;
    }
    var player = this.player();
    this.trigger("beforemodalclose");
    this.opened_ = false;
    if (this.wasPlaying_ && this.options_.pauseOnOpen) {
      player.play();
    }
    this.off("keydown", this.handleKeyDown_);
    if (this.hadControls_) {
      player.controls(true);
    }
    this.hide();
    this.el().setAttribute("aria-hidden", "true");
    this.trigger("modalclose");
    this.conditionalBlur_();
    if (this.options_.temporary) {
      this.dispose();
    }
  };
  _proto.closeable = function closeable(value) {
    if (typeof value === "boolean") {
      var closeable2 = this.closeable_ = !!value;
      var close = this.getChild("closeButton");
      if (closeable2 && !close) {
        var temp = this.contentEl_;
        this.contentEl_ = this.el_;
        close = this.addChild("closeButton", {
          controlText: "Close Modal Dialog"
        });
        this.contentEl_ = temp;
        this.on(close, "close", this.close_);
      }
      if (!closeable2 && close) {
        this.off(close, "close", this.close_);
        this.removeChild(close);
        close.dispose();
      }
    }
    return this.closeable_;
  };
  _proto.fill = function fill() {
    this.fillWith(this.content());
  };
  _proto.fillWith = function fillWith(content2) {
    var contentEl = this.contentEl();
    var parentEl = contentEl.parentNode;
    var nextSiblingEl = contentEl.nextSibling;
    this.trigger("beforemodalfill");
    this.hasBeenFilled_ = true;
    parentEl.removeChild(contentEl);
    this.empty();
    insertContent(contentEl, content2);
    this.trigger("modalfill");
    if (nextSiblingEl) {
      parentEl.insertBefore(contentEl, nextSiblingEl);
    } else {
      parentEl.appendChild(contentEl);
    }
    var closeButton2 = this.getChild("closeButton");
    if (closeButton2) {
      parentEl.appendChild(closeButton2.el_);
    }
  };
  _proto.empty = function empty() {
    this.trigger("beforemodalempty");
    emptyEl(this.contentEl());
    this.trigger("modalempty");
  };
  _proto.content = function content2(value) {
    if (typeof value !== "undefined") {
      this.content_ = value;
    }
    return this.content_;
  };
  _proto.conditionalFocus_ = function conditionalFocus_() {
    var activeEl = document_1.activeElement;
    var playerEl = this.player_.el_;
    this.previouslyActiveEl_ = null;
    if (playerEl.contains(activeEl) || playerEl === activeEl) {
      this.previouslyActiveEl_ = activeEl;
      this.focus();
    }
  };
  _proto.conditionalBlur_ = function conditionalBlur_() {
    if (this.previouslyActiveEl_) {
      this.previouslyActiveEl_.focus();
      this.previouslyActiveEl_ = null;
    }
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    event.stopPropagation();
    if (keycode.isEventKey(event, "Escape") && this.closeable()) {
      event.preventDefault();
      this.close();
      return;
    }
    if (!keycode.isEventKey(event, "Tab")) {
      return;
    }
    var focusableEls = this.focusableEls_();
    var activeEl = this.el_.querySelector(":focus");
    var focusIndex;
    for (var i = 0; i < focusableEls.length; i++) {
      if (activeEl === focusableEls[i]) {
        focusIndex = i;
        break;
      }
    }
    if (document_1.activeElement === this.el_) {
      focusIndex = 0;
    }
    if (event.shiftKey && focusIndex === 0) {
      focusableEls[focusableEls.length - 1].focus();
      event.preventDefault();
    } else if (!event.shiftKey && focusIndex === focusableEls.length - 1) {
      focusableEls[0].focus();
      event.preventDefault();
    }
  };
  _proto.focusableEls_ = function focusableEls_() {
    var allChildren = this.el_.querySelectorAll("*");
    return Array.prototype.filter.call(allChildren, function(child) {
      return (child instanceof window_1.HTMLAnchorElement || child instanceof window_1.HTMLAreaElement) && child.hasAttribute("href") || (child instanceof window_1.HTMLInputElement || child instanceof window_1.HTMLSelectElement || child instanceof window_1.HTMLTextAreaElement || child instanceof window_1.HTMLButtonElement) && !child.hasAttribute("disabled") || child instanceof window_1.HTMLIFrameElement || child instanceof window_1.HTMLObjectElement || child instanceof window_1.HTMLEmbedElement || child.hasAttribute("tabindex") && child.getAttribute("tabindex") !== -1 || child.hasAttribute("contenteditable");
    });
  };
  return ModalDialog2;
}(Component$1);
ModalDialog.prototype.options_ = {
  pauseOnOpen: true,
  temporary: true
};
Component$1.registerComponent("ModalDialog", ModalDialog);
var TrackList = /* @__PURE__ */ function(_EventTarget) {
  _inheritsLoose(TrackList2, _EventTarget);
  function TrackList2(tracks) {
    var _this;
    if (tracks === void 0) {
      tracks = [];
    }
    _this = _EventTarget.call(this) || this;
    _this.tracks_ = [];
    Object.defineProperty(_assertThisInitialized(_this), "length", {
      get: function get7() {
        return this.tracks_.length;
      }
    });
    for (var i = 0; i < tracks.length; i++) {
      _this.addTrack(tracks[i]);
    }
    return _this;
  }
  var _proto = TrackList2.prototype;
  _proto.addTrack = function addTrack(track) {
    var _this2 = this;
    var index = this.tracks_.length;
    if (!("" + index in this)) {
      Object.defineProperty(this, index, {
        get: function get7() {
          return this.tracks_[index];
        }
      });
    }
    if (this.tracks_.indexOf(track) === -1) {
      this.tracks_.push(track);
      this.trigger({
        track,
        type: "addtrack",
        target: this
      });
    }
    track.labelchange_ = function() {
      _this2.trigger({
        track,
        type: "labelchange",
        target: _this2
      });
    };
    if (isEvented(track)) {
      track.addEventListener("labelchange", track.labelchange_);
    }
  };
  _proto.removeTrack = function removeTrack(rtrack) {
    var track;
    for (var i = 0, l = this.length; i < l; i++) {
      if (this[i] === rtrack) {
        track = this[i];
        if (track.off) {
          track.off();
        }
        this.tracks_.splice(i, 1);
        break;
      }
    }
    if (!track) {
      return;
    }
    this.trigger({
      track,
      type: "removetrack",
      target: this
    });
  };
  _proto.getTrackById = function getTrackById(id2) {
    var result2 = null;
    for (var i = 0, l = this.length; i < l; i++) {
      var track = this[i];
      if (track.id === id2) {
        result2 = track;
        break;
      }
    }
    return result2;
  };
  return TrackList2;
}(EventTarget$2);
TrackList.prototype.allowedEvents_ = {
  change: "change",
  addtrack: "addtrack",
  removetrack: "removetrack",
  labelchange: "labelchange"
};
for (var event in TrackList.prototype.allowedEvents_) {
  TrackList.prototype["on" + event] = null;
}
var disableOthers$1 = function disableOthers(list, track) {
  for (var i = 0; i < list.length; i++) {
    if (!Object.keys(list[i]).length || track.id === list[i].id) {
      continue;
    }
    list[i].enabled = false;
  }
};
var AudioTrackList = /* @__PURE__ */ function(_TrackList) {
  _inheritsLoose(AudioTrackList2, _TrackList);
  function AudioTrackList2(tracks) {
    var _this;
    if (tracks === void 0) {
      tracks = [];
    }
    for (var i = tracks.length - 1; i >= 0; i--) {
      if (tracks[i].enabled) {
        disableOthers$1(tracks, tracks[i]);
        break;
      }
    }
    _this = _TrackList.call(this, tracks) || this;
    _this.changing_ = false;
    return _this;
  }
  var _proto = AudioTrackList2.prototype;
  _proto.addTrack = function addTrack(track) {
    var _this2 = this;
    if (track.enabled) {
      disableOthers$1(this, track);
    }
    _TrackList.prototype.addTrack.call(this, track);
    if (!track.addEventListener) {
      return;
    }
    track.enabledChange_ = function() {
      if (_this2.changing_) {
        return;
      }
      _this2.changing_ = true;
      disableOthers$1(_this2, track);
      _this2.changing_ = false;
      _this2.trigger("change");
    };
    track.addEventListener("enabledchange", track.enabledChange_);
  };
  _proto.removeTrack = function removeTrack(rtrack) {
    _TrackList.prototype.removeTrack.call(this, rtrack);
    if (rtrack.removeEventListener && rtrack.enabledChange_) {
      rtrack.removeEventListener("enabledchange", rtrack.enabledChange_);
      rtrack.enabledChange_ = null;
    }
  };
  return AudioTrackList2;
}(TrackList);
var disableOthers2 = function disableOthers3(list, track) {
  for (var i = 0; i < list.length; i++) {
    if (!Object.keys(list[i]).length || track.id === list[i].id) {
      continue;
    }
    list[i].selected = false;
  }
};
var VideoTrackList = /* @__PURE__ */ function(_TrackList) {
  _inheritsLoose(VideoTrackList2, _TrackList);
  function VideoTrackList2(tracks) {
    var _this;
    if (tracks === void 0) {
      tracks = [];
    }
    for (var i = tracks.length - 1; i >= 0; i--) {
      if (tracks[i].selected) {
        disableOthers2(tracks, tracks[i]);
        break;
      }
    }
    _this = _TrackList.call(this, tracks) || this;
    _this.changing_ = false;
    Object.defineProperty(_assertThisInitialized(_this), "selectedIndex", {
      get: function get7() {
        for (var _i = 0; _i < this.length; _i++) {
          if (this[_i].selected) {
            return _i;
          }
        }
        return -1;
      },
      set: function set4() {
      }
    });
    return _this;
  }
  var _proto = VideoTrackList2.prototype;
  _proto.addTrack = function addTrack(track) {
    var _this2 = this;
    if (track.selected) {
      disableOthers2(this, track);
    }
    _TrackList.prototype.addTrack.call(this, track);
    if (!track.addEventListener) {
      return;
    }
    track.selectedChange_ = function() {
      if (_this2.changing_) {
        return;
      }
      _this2.changing_ = true;
      disableOthers2(_this2, track);
      _this2.changing_ = false;
      _this2.trigger("change");
    };
    track.addEventListener("selectedchange", track.selectedChange_);
  };
  _proto.removeTrack = function removeTrack(rtrack) {
    _TrackList.prototype.removeTrack.call(this, rtrack);
    if (rtrack.removeEventListener && rtrack.selectedChange_) {
      rtrack.removeEventListener("selectedchange", rtrack.selectedChange_);
      rtrack.selectedChange_ = null;
    }
  };
  return VideoTrackList2;
}(TrackList);
var TextTrackList = /* @__PURE__ */ function(_TrackList) {
  _inheritsLoose(TextTrackList2, _TrackList);
  function TextTrackList2() {
    return _TrackList.apply(this, arguments) || this;
  }
  var _proto = TextTrackList2.prototype;
  _proto.addTrack = function addTrack(track) {
    var _this = this;
    _TrackList.prototype.addTrack.call(this, track);
    if (!this.queueChange_) {
      this.queueChange_ = function() {
        return _this.queueTrigger("change");
      };
    }
    if (!this.triggerSelectedlanguagechange) {
      this.triggerSelectedlanguagechange_ = function() {
        return _this.trigger("selectedlanguagechange");
      };
    }
    track.addEventListener("modechange", this.queueChange_);
    var nonLanguageTextTrackKind = ["metadata", "chapters"];
    if (nonLanguageTextTrackKind.indexOf(track.kind) === -1) {
      track.addEventListener("modechange", this.triggerSelectedlanguagechange_);
    }
  };
  _proto.removeTrack = function removeTrack(rtrack) {
    _TrackList.prototype.removeTrack.call(this, rtrack);
    if (rtrack.removeEventListener) {
      if (this.queueChange_) {
        rtrack.removeEventListener("modechange", this.queueChange_);
      }
      if (this.selectedlanguagechange_) {
        rtrack.removeEventListener("modechange", this.triggerSelectedlanguagechange_);
      }
    }
  };
  return TextTrackList2;
}(TrackList);
var HtmlTrackElementList = /* @__PURE__ */ function() {
  function HtmlTrackElementList2(trackElements) {
    if (trackElements === void 0) {
      trackElements = [];
    }
    this.trackElements_ = [];
    Object.defineProperty(this, "length", {
      get: function get7() {
        return this.trackElements_.length;
      }
    });
    for (var i = 0, length = trackElements.length; i < length; i++) {
      this.addTrackElement_(trackElements[i]);
    }
  }
  var _proto = HtmlTrackElementList2.prototype;
  _proto.addTrackElement_ = function addTrackElement_(trackElement) {
    var index = this.trackElements_.length;
    if (!("" + index in this)) {
      Object.defineProperty(this, index, {
        get: function get7() {
          return this.trackElements_[index];
        }
      });
    }
    if (this.trackElements_.indexOf(trackElement) === -1) {
      this.trackElements_.push(trackElement);
    }
  };
  _proto.getTrackElementByTrack_ = function getTrackElementByTrack_(track) {
    var trackElement_;
    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
      if (track === this.trackElements_[i].track) {
        trackElement_ = this.trackElements_[i];
        break;
      }
    }
    return trackElement_;
  };
  _proto.removeTrackElement_ = function removeTrackElement_(trackElement) {
    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
      if (trackElement === this.trackElements_[i]) {
        if (this.trackElements_[i].track && typeof this.trackElements_[i].track.off === "function") {
          this.trackElements_[i].track.off();
        }
        if (typeof this.trackElements_[i].off === "function") {
          this.trackElements_[i].off();
        }
        this.trackElements_.splice(i, 1);
        break;
      }
    }
  };
  return HtmlTrackElementList2;
}();
var TextTrackCueList = /* @__PURE__ */ function() {
  function TextTrackCueList2(cues) {
    TextTrackCueList2.prototype.setCues_.call(this, cues);
    Object.defineProperty(this, "length", {
      get: function get7() {
        return this.length_;
      }
    });
  }
  var _proto = TextTrackCueList2.prototype;
  _proto.setCues_ = function setCues_(cues) {
    var oldLength = this.length || 0;
    var i = 0;
    var l = cues.length;
    this.cues_ = cues;
    this.length_ = cues.length;
    var defineProp = function defineProp2(index) {
      if (!("" + index in this)) {
        Object.defineProperty(this, "" + index, {
          get: function get7() {
            return this.cues_[index];
          }
        });
      }
    };
    if (oldLength < l) {
      i = oldLength;
      for (; i < l; i++) {
        defineProp.call(this, i);
      }
    }
  };
  _proto.getCueById = function getCueById(id2) {
    var result2 = null;
    for (var i = 0, l = this.length; i < l; i++) {
      var cue = this[i];
      if (cue.id === id2) {
        result2 = cue;
        break;
      }
    }
    return result2;
  };
  return TextTrackCueList2;
}();
var VideoTrackKind = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
};
var AudioTrackKind = {
  "alternative": "alternative",
  "descriptions": "descriptions",
  "main": "main",
  "main-desc": "main-desc",
  "translation": "translation",
  "commentary": "commentary"
};
var TextTrackKind = {
  subtitles: "subtitles",
  captions: "captions",
  descriptions: "descriptions",
  chapters: "chapters",
  metadata: "metadata"
};
var TextTrackMode = {
  disabled: "disabled",
  hidden: "hidden",
  showing: "showing"
};
var Track = /* @__PURE__ */ function(_EventTarget) {
  _inheritsLoose(Track2, _EventTarget);
  function Track2(options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _EventTarget.call(this) || this;
    var trackProps = {
      id: options.id || "vjs_track_" + newGUID(),
      kind: options.kind || "",
      language: options.language || ""
    };
    var label = options.label || "";
    var _loop = function _loop2(key2) {
      Object.defineProperty(_assertThisInitialized(_this), key2, {
        get: function get7() {
          return trackProps[key2];
        },
        set: function set4() {
        }
      });
    };
    for (var key in trackProps) {
      _loop(key);
    }
    Object.defineProperty(_assertThisInitialized(_this), "label", {
      get: function get7() {
        return label;
      },
      set: function set4(newLabel) {
        if (newLabel !== label) {
          label = newLabel;
          this.trigger("labelchange");
        }
      }
    });
    return _this;
  }
  return Track2;
}(EventTarget$2);
var parseUrl = function parseUrl2(url) {
  var props = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"];
  var a = document_1.createElement("a");
  a.href = url;
  var details = {};
  for (var i = 0; i < props.length; i++) {
    details[props[i]] = a[props[i]];
  }
  if (details.protocol === "http:") {
    details.host = details.host.replace(/:80$/, "");
  }
  if (details.protocol === "https:") {
    details.host = details.host.replace(/:443$/, "");
  }
  if (!details.protocol) {
    details.protocol = window_1.location.protocol;
  }
  if (!details.host) {
    details.host = window_1.location.host;
  }
  return details;
};
var getAbsoluteURL = function getAbsoluteURL2(url) {
  if (!url.match(/^https?:\/\//)) {
    var a = document_1.createElement("a");
    a.href = url;
    url = a.href;
  }
  return url;
};
var getFileExtension = function getFileExtension2(path) {
  if (typeof path === "string") {
    var splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/;
    var pathParts = splitPathRe.exec(path);
    if (pathParts) {
      return pathParts.pop().toLowerCase();
    }
  }
  return "";
};
var isCrossOrigin = function isCrossOrigin2(url, winLoc) {
  if (winLoc === void 0) {
    winLoc = window_1.location;
  }
  var urlInfo = parseUrl(url);
  var srcProtocol = urlInfo.protocol === ":" ? winLoc.protocol : urlInfo.protocol;
  var crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;
  return crossOrigin;
};
var Url = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  parseUrl,
  getAbsoluteURL,
  getFileExtension,
  isCrossOrigin
});
var parseCues = function parseCues2(srcContent, track) {
  var parser2 = new window_1.WebVTT.Parser(window_1, window_1.vttjs, window_1.WebVTT.StringDecoder());
  var errors2 = [];
  parser2.oncue = function(cue) {
    track.addCue(cue);
  };
  parser2.onparsingerror = function(error2) {
    errors2.push(error2);
  };
  parser2.onflush = function() {
    track.trigger({
      type: "loadeddata",
      target: track
    });
  };
  parser2.parse(srcContent);
  if (errors2.length > 0) {
    if (window_1.console && window_1.console.groupCollapsed) {
      window_1.console.groupCollapsed("Text Track parsing errors for " + track.src);
    }
    errors2.forEach(function(error2) {
      return log$1.error(error2);
    });
    if (window_1.console && window_1.console.groupEnd) {
      window_1.console.groupEnd();
    }
  }
  parser2.flush();
};
var loadTrack = function loadTrack2(src, track) {
  var opts = {
    uri: src
  };
  var crossOrigin = isCrossOrigin(src);
  if (crossOrigin) {
    opts.cors = crossOrigin;
  }
  var withCredentials = track.tech_.crossOrigin() === "use-credentials";
  if (withCredentials) {
    opts.withCredentials = withCredentials;
  }
  XHR(opts, bind(this, function(err, response, responseBody) {
    if (err) {
      return log$1.error(err, response);
    }
    track.loaded_ = true;
    if (typeof window_1.WebVTT !== "function") {
      if (track.tech_) {
        track.tech_.any(["vttjsloaded", "vttjserror"], function(event) {
          if (event.type === "vttjserror") {
            log$1.error("vttjs failed to load, stopping trying to process " + track.src);
            return;
          }
          return parseCues(responseBody, track);
        });
      }
    } else {
      parseCues(responseBody, track);
    }
  }));
};
var TextTrack = /* @__PURE__ */ function(_Track) {
  _inheritsLoose(TextTrack2, _Track);
  function TextTrack2(options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    if (!options.tech) {
      throw new Error("A tech was not provided.");
    }
    var settings = mergeOptions$3(options, {
      kind: TextTrackKind[options.kind] || "subtitles",
      language: options.language || options.srclang || ""
    });
    var mode = TextTrackMode[settings.mode] || "disabled";
    var default_ = settings["default"];
    if (settings.kind === "metadata" || settings.kind === "chapters") {
      mode = "hidden";
    }
    _this = _Track.call(this, settings) || this;
    _this.tech_ = settings.tech;
    _this.cues_ = [];
    _this.activeCues_ = [];
    _this.preload_ = _this.tech_.preloadTextTracks !== false;
    var cues = new TextTrackCueList(_this.cues_);
    var activeCues = new TextTrackCueList(_this.activeCues_);
    var changed = false;
    _this.timeupdateHandler = bind(_assertThisInitialized(_this), function(event) {
      if (event === void 0) {
        event = {};
      }
      if (this.tech_.isDisposed()) {
        return;
      }
      if (!this.tech_.isReady_) {
        if (event.type !== "timeupdate") {
          this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
        }
        return;
      }
      this.activeCues = this.activeCues;
      if (changed) {
        this.trigger("cuechange");
        changed = false;
      }
      if (event.type !== "timeupdate") {
        this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
      }
    });
    var disposeHandler = function disposeHandler2() {
      _this.stopTracking();
    };
    _this.tech_.one("dispose", disposeHandler);
    if (mode !== "disabled") {
      _this.startTracking();
    }
    Object.defineProperties(_assertThisInitialized(_this), {
      "default": {
        get: function get7() {
          return default_;
        },
        set: function set4() {
        }
      },
      mode: {
        get: function get7() {
          return mode;
        },
        set: function set4(newMode) {
          if (!TextTrackMode[newMode]) {
            return;
          }
          if (mode === newMode) {
            return;
          }
          mode = newMode;
          if (!this.preload_ && mode !== "disabled" && this.cues.length === 0) {
            loadTrack(this.src, this);
          }
          this.stopTracking();
          if (mode !== "disabled") {
            this.startTracking();
          }
          this.trigger("modechange");
        }
      },
      cues: {
        get: function get7() {
          if (!this.loaded_) {
            return null;
          }
          return cues;
        },
        set: function set4() {
        }
      },
      activeCues: {
        get: function get7() {
          if (!this.loaded_) {
            return null;
          }
          if (this.cues.length === 0) {
            return activeCues;
          }
          var ct = this.tech_.currentTime();
          var active2 = [];
          for (var i = 0, l = this.cues.length; i < l; i++) {
            var cue = this.cues[i];
            if (cue.startTime <= ct && cue.endTime >= ct) {
              active2.push(cue);
            } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
              active2.push(cue);
            }
          }
          changed = false;
          if (active2.length !== this.activeCues_.length) {
            changed = true;
          } else {
            for (var _i = 0; _i < active2.length; _i++) {
              if (this.activeCues_.indexOf(active2[_i]) === -1) {
                changed = true;
              }
            }
          }
          this.activeCues_ = active2;
          activeCues.setCues_(this.activeCues_);
          return activeCues;
        },
        set: function set4() {
        }
      }
    });
    if (settings.src) {
      _this.src = settings.src;
      if (!_this.preload_) {
        _this.loaded_ = true;
      }
      if (_this.preload_ || settings.kind !== "subtitles" && settings.kind !== "captions") {
        loadTrack(_this.src, _assertThisInitialized(_this));
      }
    } else {
      _this.loaded_ = true;
    }
    return _this;
  }
  var _proto = TextTrack2.prototype;
  _proto.startTracking = function startTracking() {
    this.rvf_ = this.tech_.requestVideoFrameCallback(this.timeupdateHandler);
    this.tech_.on("timeupdate", this.timeupdateHandler);
  };
  _proto.stopTracking = function stopTracking() {
    if (this.rvf_) {
      this.tech_.cancelVideoFrameCallback(this.rvf_);
      this.rvf_ = void 0;
    }
    this.tech_.off("timeupdate", this.timeupdateHandler);
  };
  _proto.addCue = function addCue(originalCue) {
    var cue = originalCue;
    if (cue.constructor && cue.constructor.name !== "VTTCue") {
      cue = new window_1.vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
      for (var prop in originalCue) {
        if (!(prop in cue)) {
          cue[prop] = originalCue[prop];
        }
      }
      cue.id = originalCue.id;
      cue.originalCue_ = originalCue;
    }
    var tracks = this.tech_.textTracks();
    for (var i = 0; i < tracks.length; i++) {
      if (tracks[i] !== this) {
        tracks[i].removeCue(cue);
      }
    }
    this.cues_.push(cue);
    this.cues.setCues_(this.cues_);
  };
  _proto.removeCue = function removeCue(_removeCue) {
    var i = this.cues_.length;
    while (i--) {
      var cue = this.cues_[i];
      if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
        this.cues_.splice(i, 1);
        this.cues.setCues_(this.cues_);
        break;
      }
    }
  };
  return TextTrack2;
}(Track);
TextTrack.prototype.allowedEvents_ = {
  cuechange: "cuechange"
};
var AudioTrack = /* @__PURE__ */ function(_Track) {
  _inheritsLoose(AudioTrack2, _Track);
  function AudioTrack2(options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    var settings = mergeOptions$3(options, {
      kind: AudioTrackKind[options.kind] || ""
    });
    _this = _Track.call(this, settings) || this;
    var enabled = false;
    Object.defineProperty(_assertThisInitialized(_this), "enabled", {
      get: function get7() {
        return enabled;
      },
      set: function set4(newEnabled) {
        if (typeof newEnabled !== "boolean" || newEnabled === enabled) {
          return;
        }
        enabled = newEnabled;
        this.trigger("enabledchange");
      }
    });
    if (settings.enabled) {
      _this.enabled = settings.enabled;
    }
    _this.loaded_ = true;
    return _this;
  }
  return AudioTrack2;
}(Track);
var VideoTrack = /* @__PURE__ */ function(_Track) {
  _inheritsLoose(VideoTrack2, _Track);
  function VideoTrack2(options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    var settings = mergeOptions$3(options, {
      kind: VideoTrackKind[options.kind] || ""
    });
    _this = _Track.call(this, settings) || this;
    var selected = false;
    Object.defineProperty(_assertThisInitialized(_this), "selected", {
      get: function get7() {
        return selected;
      },
      set: function set4(newSelected) {
        if (typeof newSelected !== "boolean" || newSelected === selected) {
          return;
        }
        selected = newSelected;
        this.trigger("selectedchange");
      }
    });
    if (settings.selected) {
      _this.selected = settings.selected;
    }
    return _this;
  }
  return VideoTrack2;
}(Track);
var NONE = 0;
var LOADING = 1;
var LOADED = 2;
var ERROR = 3;
var HTMLTrackElement = /* @__PURE__ */ function(_EventTarget) {
  _inheritsLoose(HTMLTrackElement2, _EventTarget);
  function HTMLTrackElement2(options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _EventTarget.call(this) || this;
    var readyState;
    var track = new TextTrack(options);
    _this.kind = track.kind;
    _this.src = track.src;
    _this.srclang = track.language;
    _this.label = track.label;
    _this["default"] = track["default"];
    Object.defineProperties(_assertThisInitialized(_this), {
      readyState: {
        get: function get7() {
          return readyState;
        }
      },
      track: {
        get: function get7() {
          return track;
        }
      }
    });
    readyState = NONE;
    track.addEventListener("loadeddata", function() {
      readyState = LOADED;
      _this.trigger({
        type: "load",
        target: _assertThisInitialized(_this)
      });
    });
    return _this;
  }
  return HTMLTrackElement2;
}(EventTarget$2);
HTMLTrackElement.prototype.allowedEvents_ = {
  load: "load"
};
HTMLTrackElement.NONE = NONE;
HTMLTrackElement.LOADING = LOADING;
HTMLTrackElement.LOADED = LOADED;
HTMLTrackElement.ERROR = ERROR;
var NORMAL = {
  audio: {
    ListClass: AudioTrackList,
    TrackClass: AudioTrack,
    capitalName: "Audio"
  },
  video: {
    ListClass: VideoTrackList,
    TrackClass: VideoTrack,
    capitalName: "Video"
  },
  text: {
    ListClass: TextTrackList,
    TrackClass: TextTrack,
    capitalName: "Text"
  }
};
Object.keys(NORMAL).forEach(function(type2) {
  NORMAL[type2].getterName = type2 + "Tracks";
  NORMAL[type2].privateName = type2 + "Tracks_";
});
var REMOTE = {
  remoteText: {
    ListClass: TextTrackList,
    TrackClass: TextTrack,
    capitalName: "RemoteText",
    getterName: "remoteTextTracks",
    privateName: "remoteTextTracks_"
  },
  remoteTextEl: {
    ListClass: HtmlTrackElementList,
    TrackClass: HTMLTrackElement,
    capitalName: "RemoteTextTrackEls",
    getterName: "remoteTextTrackEls",
    privateName: "remoteTextTrackEls_"
  }
};
var ALL = _extends$2({}, NORMAL, REMOTE);
REMOTE.names = Object.keys(REMOTE);
NORMAL.names = Object.keys(NORMAL);
ALL.names = [].concat(REMOTE.names).concat(NORMAL.names);
function createTrackHelper(self2, kind, label, language, options) {
  if (options === void 0) {
    options = {};
  }
  var tracks = self2.textTracks();
  options.kind = kind;
  if (label) {
    options.label = label;
  }
  if (language) {
    options.language = language;
  }
  options.tech = self2;
  var track = new ALL.text.TrackClass(options);
  tracks.addTrack(track);
  return track;
}
var Tech = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(Tech2, _Component);
  function Tech2(options, ready) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    if (ready === void 0) {
      ready = function ready2() {
      };
    }
    options.reportTouchActivity = false;
    _this = _Component.call(this, null, options, ready) || this;
    _this.onDurationChange_ = function(e) {
      return _this.onDurationChange(e);
    };
    _this.trackProgress_ = function(e) {
      return _this.trackProgress(e);
    };
    _this.trackCurrentTime_ = function(e) {
      return _this.trackCurrentTime(e);
    };
    _this.stopTrackingCurrentTime_ = function(e) {
      return _this.stopTrackingCurrentTime(e);
    };
    _this.disposeSourceHandler_ = function(e) {
      return _this.disposeSourceHandler(e);
    };
    _this.queuedHanders_ = /* @__PURE__ */ new Set();
    _this.hasStarted_ = false;
    _this.on("playing", function() {
      this.hasStarted_ = true;
    });
    _this.on("loadstart", function() {
      this.hasStarted_ = false;
    });
    ALL.names.forEach(function(name) {
      var props = ALL[name];
      if (options && options[props.getterName]) {
        _this[props.privateName] = options[props.getterName];
      }
    });
    if (!_this.featuresProgressEvents) {
      _this.manualProgressOn();
    }
    if (!_this.featuresTimeupdateEvents) {
      _this.manualTimeUpdatesOn();
    }
    ["Text", "Audio", "Video"].forEach(function(track) {
      if (options["native" + track + "Tracks"] === false) {
        _this["featuresNative" + track + "Tracks"] = false;
      }
    });
    if (options.nativeCaptions === false || options.nativeTextTracks === false) {
      _this.featuresNativeTextTracks = false;
    } else if (options.nativeCaptions === true || options.nativeTextTracks === true) {
      _this.featuresNativeTextTracks = true;
    }
    if (!_this.featuresNativeTextTracks) {
      _this.emulateTextTracks();
    }
    _this.preloadTextTracks = options.preloadTextTracks !== false;
    _this.autoRemoteTextTracks_ = new ALL.text.ListClass();
    _this.initTrackListeners();
    if (!options.nativeControlsForTouch) {
      _this.emitTapEvents();
    }
    if (_this.constructor) {
      _this.name_ = _this.constructor.name || "Unknown Tech";
    }
    return _this;
  }
  var _proto = Tech2.prototype;
  _proto.triggerSourceset = function triggerSourceset(src) {
    var _this2 = this;
    if (!this.isReady_) {
      this.one("ready", function() {
        return _this2.setTimeout(function() {
          return _this2.triggerSourceset(src);
        }, 1);
      });
    }
    this.trigger({
      src,
      type: "sourceset"
    });
  };
  _proto.manualProgressOn = function manualProgressOn() {
    this.on("durationchange", this.onDurationChange_);
    this.manualProgress = true;
    this.one("ready", this.trackProgress_);
  };
  _proto.manualProgressOff = function manualProgressOff() {
    this.manualProgress = false;
    this.stopTrackingProgress();
    this.off("durationchange", this.onDurationChange_);
  };
  _proto.trackProgress = function trackProgress(event) {
    this.stopTrackingProgress();
    this.progressInterval = this.setInterval(bind(this, function() {
      var numBufferedPercent = this.bufferedPercent();
      if (this.bufferedPercent_ !== numBufferedPercent) {
        this.trigger("progress");
      }
      this.bufferedPercent_ = numBufferedPercent;
      if (numBufferedPercent === 1) {
        this.stopTrackingProgress();
      }
    }), 500);
  };
  _proto.onDurationChange = function onDurationChange(event) {
    this.duration_ = this.duration();
  };
  _proto.buffered = function buffered() {
    return createTimeRanges(0, 0);
  };
  _proto.bufferedPercent = function bufferedPercent$1() {
    return bufferedPercent(this.buffered(), this.duration_);
  };
  _proto.stopTrackingProgress = function stopTrackingProgress() {
    this.clearInterval(this.progressInterval);
  };
  _proto.manualTimeUpdatesOn = function manualTimeUpdatesOn() {
    this.manualTimeUpdates = true;
    this.on("play", this.trackCurrentTime_);
    this.on("pause", this.stopTrackingCurrentTime_);
  };
  _proto.manualTimeUpdatesOff = function manualTimeUpdatesOff() {
    this.manualTimeUpdates = false;
    this.stopTrackingCurrentTime();
    this.off("play", this.trackCurrentTime_);
    this.off("pause", this.stopTrackingCurrentTime_);
  };
  _proto.trackCurrentTime = function trackCurrentTime() {
    if (this.currentTimeInterval) {
      this.stopTrackingCurrentTime();
    }
    this.currentTimeInterval = this.setInterval(function() {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: true
      });
    }, 250);
  };
  _proto.stopTrackingCurrentTime = function stopTrackingCurrentTime() {
    this.clearInterval(this.currentTimeInterval);
    this.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: true
    });
  };
  _proto.dispose = function dispose() {
    this.clearTracks(NORMAL.names);
    if (this.manualProgress) {
      this.manualProgressOff();
    }
    if (this.manualTimeUpdates) {
      this.manualTimeUpdatesOff();
    }
    _Component.prototype.dispose.call(this);
  };
  _proto.clearTracks = function clearTracks(types) {
    var _this3 = this;
    types = [].concat(types);
    types.forEach(function(type2) {
      var list = _this3[type2 + "Tracks"]() || [];
      var i = list.length;
      while (i--) {
        var track = list[i];
        if (type2 === "text") {
          _this3.removeRemoteTextTrack(track);
        }
        list.removeTrack(track);
      }
    });
  };
  _proto.cleanupAutoTextTracks = function cleanupAutoTextTracks() {
    var list = this.autoRemoteTextTracks_ || [];
    var i = list.length;
    while (i--) {
      var track = list[i];
      this.removeRemoteTextTrack(track);
    }
  };
  _proto.reset = function reset3() {
  };
  _proto.crossOrigin = function crossOrigin() {
  };
  _proto.setCrossOrigin = function setCrossOrigin() {
  };
  _proto.error = function error2(err) {
    if (err !== void 0) {
      this.error_ = new MediaError(err);
      this.trigger("error");
    }
    return this.error_;
  };
  _proto.played = function played() {
    if (this.hasStarted_) {
      return createTimeRanges(0, 0);
    }
    return createTimeRanges();
  };
  _proto.play = function play() {
  };
  _proto.setScrubbing = function setScrubbing() {
  };
  _proto.scrubbing = function scrubbing() {
  };
  _proto.setCurrentTime = function setCurrentTime() {
    if (this.manualTimeUpdates) {
      this.trigger({
        type: "timeupdate",
        target: this,
        manuallyTriggered: true
      });
    }
  };
  _proto.initTrackListeners = function initTrackListeners() {
    var _this4 = this;
    NORMAL.names.forEach(function(name) {
      var props = NORMAL[name];
      var trackListChanges = function trackListChanges2() {
        _this4.trigger(name + "trackchange");
      };
      var tracks = _this4[props.getterName]();
      tracks.addEventListener("removetrack", trackListChanges);
      tracks.addEventListener("addtrack", trackListChanges);
      _this4.on("dispose", function() {
        tracks.removeEventListener("removetrack", trackListChanges);
        tracks.removeEventListener("addtrack", trackListChanges);
      });
    });
  };
  _proto.addWebVttScript_ = function addWebVttScript_() {
    var _this5 = this;
    if (window_1.WebVTT) {
      return;
    }
    if (document_1.body.contains(this.el())) {
      if (!this.options_["vtt.js"] && isPlain(vtt) && Object.keys(vtt).length > 0) {
        this.trigger("vttjsloaded");
        return;
      }
      var script = document_1.createElement("script");
      script.src = this.options_["vtt.js"] || "https://vjs.zencdn.net/vttjs/0.14.1/vtt.min.js";
      script.onload = function() {
        _this5.trigger("vttjsloaded");
      };
      script.onerror = function() {
        _this5.trigger("vttjserror");
      };
      this.on("dispose", function() {
        script.onload = null;
        script.onerror = null;
      });
      window_1.WebVTT = true;
      this.el().parentNode.appendChild(script);
    } else {
      this.ready(this.addWebVttScript_);
    }
  };
  _proto.emulateTextTracks = function emulateTextTracks() {
    var _this6 = this;
    var tracks = this.textTracks();
    var remoteTracks = this.remoteTextTracks();
    var handleAddTrack = function handleAddTrack2(e) {
      return tracks.addTrack(e.track);
    };
    var handleRemoveTrack = function handleRemoveTrack2(e) {
      return tracks.removeTrack(e.track);
    };
    remoteTracks.on("addtrack", handleAddTrack);
    remoteTracks.on("removetrack", handleRemoveTrack);
    this.addWebVttScript_();
    var updateDisplay = function updateDisplay2() {
      return _this6.trigger("texttrackchange");
    };
    var textTracksChanges = function textTracksChanges2() {
      updateDisplay();
      for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];
        track.removeEventListener("cuechange", updateDisplay);
        if (track.mode === "showing") {
          track.addEventListener("cuechange", updateDisplay);
        }
      }
    };
    textTracksChanges();
    tracks.addEventListener("change", textTracksChanges);
    tracks.addEventListener("addtrack", textTracksChanges);
    tracks.addEventListener("removetrack", textTracksChanges);
    this.on("dispose", function() {
      remoteTracks.off("addtrack", handleAddTrack);
      remoteTracks.off("removetrack", handleRemoveTrack);
      tracks.removeEventListener("change", textTracksChanges);
      tracks.removeEventListener("addtrack", textTracksChanges);
      tracks.removeEventListener("removetrack", textTracksChanges);
      for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];
        track.removeEventListener("cuechange", updateDisplay);
      }
    });
  };
  _proto.addTextTrack = function addTextTrack(kind, label, language) {
    if (!kind) {
      throw new Error("TextTrack kind is required but was not provided");
    }
    return createTrackHelper(this, kind, label, language);
  };
  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
    var track = mergeOptions$3(options, {
      tech: this
    });
    return new REMOTE.remoteTextEl.TrackClass(track);
  };
  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
    var _this7 = this;
    if (options === void 0) {
      options = {};
    }
    var htmlTrackElement = this.createRemoteTextTrack(options);
    if (manualCleanup !== true && manualCleanup !== false) {
      log$1.warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');
      manualCleanup = true;
    }
    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
    this.remoteTextTracks().addTrack(htmlTrackElement.track);
    if (manualCleanup !== true) {
      this.ready(function() {
        return _this7.autoRemoteTextTracks_.addTrack(htmlTrackElement.track);
      });
    }
    return htmlTrackElement;
  };
  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
    this.remoteTextTrackEls().removeTrackElement_(trackElement);
    this.remoteTextTracks().removeTrack(track);
    this.autoRemoteTextTracks_.removeTrack(track);
  };
  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
    return {};
  };
  _proto.requestPictureInPicture = function requestPictureInPicture() {
    var PromiseClass = this.options_.Promise || window_1.Promise;
    if (PromiseClass) {
      return PromiseClass.reject();
    }
  };
  _proto.disablePictureInPicture = function disablePictureInPicture() {
    return true;
  };
  _proto.setDisablePictureInPicture = function setDisablePictureInPicture() {
  };
  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb2) {
    var _this8 = this;
    var id2 = newGUID();
    if (!this.isReady_ || this.paused()) {
      this.queuedHanders_.add(id2);
      this.one("playing", function() {
        if (_this8.queuedHanders_.has(id2)) {
          _this8.queuedHanders_["delete"](id2);
          cb2();
        }
      });
    } else {
      this.requestNamedAnimationFrame(id2, cb2);
    }
    return id2;
  };
  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id2) {
    if (this.queuedHanders_.has(id2)) {
      this.queuedHanders_["delete"](id2);
    } else {
      this.cancelNamedAnimationFrame(id2);
    }
  };
  _proto.setPoster = function setPoster() {
  };
  _proto.playsinline = function playsinline() {
  };
  _proto.setPlaysinline = function setPlaysinline() {
  };
  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks() {
  };
  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks() {
  };
  _proto.canPlayType = function canPlayType3() {
    return "";
  };
  Tech2.canPlayType = function canPlayType3() {
    return "";
  };
  Tech2.canPlaySource = function canPlaySource(srcObj, options) {
    return Tech2.canPlayType(srcObj.type);
  };
  Tech2.isTech = function isTech(component) {
    return component.prototype instanceof Tech2 || component instanceof Tech2 || component === Tech2;
  };
  Tech2.registerTech = function registerTech(name, tech) {
    if (!Tech2.techs_) {
      Tech2.techs_ = {};
    }
    if (!Tech2.isTech(tech)) {
      throw new Error("Tech " + name + " must be a Tech");
    }
    if (!Tech2.canPlayType) {
      throw new Error("Techs must have a static canPlayType method on them");
    }
    if (!Tech2.canPlaySource) {
      throw new Error("Techs must have a static canPlaySource method on them");
    }
    name = toTitleCase$1(name);
    Tech2.techs_[name] = tech;
    Tech2.techs_[toLowerCase(name)] = tech;
    if (name !== "Tech") {
      Tech2.defaultTechOrder_.push(name);
    }
    return tech;
  };
  Tech2.getTech = function getTech(name) {
    if (!name) {
      return;
    }
    if (Tech2.techs_ && Tech2.techs_[name]) {
      return Tech2.techs_[name];
    }
    name = toTitleCase$1(name);
    if (window_1 && window_1.videojs && window_1.videojs[name]) {
      log$1.warn("The " + name + " tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)");
      return window_1.videojs[name];
    }
  };
  return Tech2;
}(Component$1);
ALL.names.forEach(function(name) {
  var props = ALL[name];
  Tech.prototype[props.getterName] = function() {
    this[props.privateName] = this[props.privateName] || new props.ListClass();
    return this[props.privateName];
  };
});
Tech.prototype.featuresVolumeControl = true;
Tech.prototype.featuresMuteControl = true;
Tech.prototype.featuresFullscreenResize = false;
Tech.prototype.featuresPlaybackRate = false;
Tech.prototype.featuresProgressEvents = false;
Tech.prototype.featuresSourceset = false;
Tech.prototype.featuresTimeupdateEvents = false;
Tech.prototype.featuresNativeTextTracks = false;
Tech.prototype.featuresVideoFrameCallback = false;
Tech.withSourceHandlers = function(_Tech) {
  _Tech.registerSourceHandler = function(handler, index) {
    var handlers = _Tech.sourceHandlers;
    if (!handlers) {
      handlers = _Tech.sourceHandlers = [];
    }
    if (index === void 0) {
      index = handlers.length;
    }
    handlers.splice(index, 0, handler);
  };
  _Tech.canPlayType = function(type2) {
    var handlers = _Tech.sourceHandlers || [];
    var can;
    for (var i = 0; i < handlers.length; i++) {
      can = handlers[i].canPlayType(type2);
      if (can) {
        return can;
      }
    }
    return "";
  };
  _Tech.selectSourceHandler = function(source, options) {
    var handlers = _Tech.sourceHandlers || [];
    var can;
    for (var i = 0; i < handlers.length; i++) {
      can = handlers[i].canHandleSource(source, options);
      if (can) {
        return handlers[i];
      }
    }
    return null;
  };
  _Tech.canPlaySource = function(srcObj, options) {
    var sh2 = _Tech.selectSourceHandler(srcObj, options);
    if (sh2) {
      return sh2.canHandleSource(srcObj, options);
    }
    return "";
  };
  var deferrable = ["seekable", "seeking", "duration"];
  deferrable.forEach(function(fnName) {
    var originalFn = this[fnName];
    if (typeof originalFn !== "function") {
      return;
    }
    this[fnName] = function() {
      if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
        return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
      }
      return originalFn.apply(this, arguments);
    };
  }, _Tech.prototype);
  _Tech.prototype.setSource = function(source) {
    var sh2 = _Tech.selectSourceHandler(source, this.options_);
    if (!sh2) {
      if (_Tech.nativeSourceHandler) {
        sh2 = _Tech.nativeSourceHandler;
      } else {
        log$1.error("No source handler found for the current source.");
      }
    }
    this.disposeSourceHandler();
    this.off("dispose", this.disposeSourceHandler_);
    if (sh2 !== _Tech.nativeSourceHandler) {
      this.currentSource_ = source;
    }
    this.sourceHandler_ = sh2.handleSource(source, this, this.options_);
    this.one("dispose", this.disposeSourceHandler_);
  };
  _Tech.prototype.disposeSourceHandler = function() {
    if (this.currentSource_) {
      this.clearTracks(["audio", "video"]);
      this.currentSource_ = null;
    }
    this.cleanupAutoTextTracks();
    if (this.sourceHandler_) {
      if (this.sourceHandler_.dispose) {
        this.sourceHandler_.dispose();
      }
      this.sourceHandler_ = null;
    }
  };
};
Component$1.registerComponent("Tech", Tech);
Tech.registerTech("Tech", Tech);
Tech.defaultTechOrder_ = [];
var middlewares = {};
var middlewareInstances = {};
var TERMINATOR = {};
function use(type2, middleware) {
  middlewares[type2] = middlewares[type2] || [];
  middlewares[type2].push(middleware);
}
function setSource(player, src, next) {
  player.setTimeout(function() {
    return setSourceHelper(src, middlewares[src.type], next, player);
  }, 1);
}
function setTech(middleware, tech) {
  middleware.forEach(function(mw) {
    return mw.setTech && mw.setTech(tech);
  });
}
function get(middleware, tech, method) {
  return middleware.reduceRight(middlewareIterator(method), tech[method]());
}
function set(middleware, tech, method, arg) {
  return tech[method](middleware.reduce(middlewareIterator(method), arg));
}
function mediate(middleware, tech, method, arg) {
  if (arg === void 0) {
    arg = null;
  }
  var callMethod = "call" + toTitleCase$1(method);
  var middlewareValue = middleware.reduce(middlewareIterator(callMethod), arg);
  var terminated = middlewareValue === TERMINATOR;
  var returnValue = terminated ? null : tech[method](middlewareValue);
  executeRight(middleware, method, returnValue, terminated);
  return returnValue;
}
var allowedGetters = {
  buffered: 1,
  currentTime: 1,
  duration: 1,
  muted: 1,
  played: 1,
  paused: 1,
  seekable: 1,
  volume: 1,
  ended: 1
};
var allowedSetters = {
  setCurrentTime: 1,
  setMuted: 1,
  setVolume: 1
};
var allowedMediators = {
  play: 1,
  pause: 1
};
function middlewareIterator(method) {
  return function(value, mw) {
    if (value === TERMINATOR) {
      return TERMINATOR;
    }
    if (mw[method]) {
      return mw[method](value);
    }
    return value;
  };
}
function executeRight(mws, method, value, terminated) {
  for (var i = mws.length - 1; i >= 0; i--) {
    var mw = mws[i];
    if (mw[method]) {
      mw[method](terminated, value);
    }
  }
}
function clearCacheForPlayer(player) {
  middlewareInstances[player.id()] = null;
}
function getOrCreateFactory(player, mwFactory) {
  var mws = middlewareInstances[player.id()];
  var mw = null;
  if (mws === void 0 || mws === null) {
    mw = mwFactory(player);
    middlewareInstances[player.id()] = [[mwFactory, mw]];
    return mw;
  }
  for (var i = 0; i < mws.length; i++) {
    var _mws$i = mws[i], mwf = _mws$i[0], mwi = _mws$i[1];
    if (mwf !== mwFactory) {
      continue;
    }
    mw = mwi;
  }
  if (mw === null) {
    mw = mwFactory(player);
    mws.push([mwFactory, mw]);
  }
  return mw;
}
function setSourceHelper(src, middleware, next, player, acc, lastRun) {
  if (src === void 0) {
    src = {};
  }
  if (middleware === void 0) {
    middleware = [];
  }
  if (acc === void 0) {
    acc = [];
  }
  if (lastRun === void 0) {
    lastRun = false;
  }
  var _middleware = middleware, mwFactory = _middleware[0], mwrest = _middleware.slice(1);
  if (typeof mwFactory === "string") {
    setSourceHelper(src, middlewares[mwFactory], next, player, acc, lastRun);
  } else if (mwFactory) {
    var mw = getOrCreateFactory(player, mwFactory);
    if (!mw.setSource) {
      acc.push(mw);
      return setSourceHelper(src, mwrest, next, player, acc, lastRun);
    }
    mw.setSource(assign({}, src), function(err, _src) {
      if (err) {
        return setSourceHelper(src, mwrest, next, player, acc, lastRun);
      }
      acc.push(mw);
      setSourceHelper(_src, src.type === _src.type ? mwrest : middlewares[_src.type], next, player, acc, lastRun);
    });
  } else if (mwrest.length) {
    setSourceHelper(src, mwrest, next, player, acc, lastRun);
  } else if (lastRun) {
    next(src, acc);
  } else {
    setSourceHelper(src, middlewares["*"], next, player, acc, true);
  }
}
var MimetypesKind = {
  opus: "video/ogg",
  ogv: "video/ogg",
  mp4: "video/mp4",
  mov: "video/mp4",
  m4v: "video/mp4",
  mkv: "video/x-matroska",
  m4a: "audio/mp4",
  mp3: "audio/mpeg",
  aac: "audio/aac",
  caf: "audio/x-caf",
  flac: "audio/flac",
  oga: "audio/ogg",
  wav: "audio/wav",
  m3u8: "application/x-mpegURL",
  mpd: "application/dash+xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  png: "image/png",
  svg: "image/svg+xml",
  webp: "image/webp"
};
var getMimetype = function getMimetype2(src) {
  if (src === void 0) {
    src = "";
  }
  var ext = getFileExtension(src);
  var mimetype = MimetypesKind[ext.toLowerCase()];
  return mimetype || "";
};
var findMimetype = function findMimetype2(player, src) {
  if (!src) {
    return "";
  }
  if (player.cache_.source.src === src && player.cache_.source.type) {
    return player.cache_.source.type;
  }
  var matchingSources = player.cache_.sources.filter(function(s2) {
    return s2.src === src;
  });
  if (matchingSources.length) {
    return matchingSources[0].type;
  }
  var sources = player.$$("source");
  for (var i = 0; i < sources.length; i++) {
    var s = sources[i];
    if (s.type && s.src && s.src === src) {
      return s.type;
    }
  }
  return getMimetype(src);
};
var filterSource = function filterSource2(src) {
  if (Array.isArray(src)) {
    var newsrc = [];
    src.forEach(function(srcobj) {
      srcobj = filterSource2(srcobj);
      if (Array.isArray(srcobj)) {
        newsrc = newsrc.concat(srcobj);
      } else if (isObject2(srcobj)) {
        newsrc.push(srcobj);
      }
    });
    src = newsrc;
  } else if (typeof src === "string" && src.trim()) {
    src = [fixSource({
      src
    })];
  } else if (isObject2(src) && typeof src.src === "string" && src.src && src.src.trim()) {
    src = [fixSource(src)];
  } else {
    src = [];
  }
  return src;
};
function fixSource(src) {
  if (!src.type) {
    var mimetype = getMimetype(src.src);
    if (mimetype) {
      src.type = mimetype;
    }
  }
  return src;
}
var MediaLoader = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(MediaLoader2, _Component);
  function MediaLoader2(player, options, ready) {
    var _this;
    var options_ = mergeOptions$3({
      createEl: false
    }, options);
    _this = _Component.call(this, player, options_, ready) || this;
    if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
      for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
        var techName = toTitleCase$1(j[i]);
        var tech = Tech.getTech(techName);
        if (!techName) {
          tech = Component$1.getComponent(techName);
        }
        if (tech && tech.isSupported()) {
          player.loadTech_(techName);
          break;
        }
      }
    } else {
      player.src(options.playerOptions.sources);
    }
    return _this;
  }
  return MediaLoader2;
}(Component$1);
Component$1.registerComponent("MediaLoader", MediaLoader);
var ClickableComponent = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(ClickableComponent2, _Component);
  function ClickableComponent2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    if (_this.options_.controlText) {
      _this.controlText(_this.options_.controlText);
    }
    _this.handleMouseOver_ = function(e) {
      return _this.handleMouseOver(e);
    };
    _this.handleMouseOut_ = function(e) {
      return _this.handleMouseOut(e);
    };
    _this.handleClick_ = function(e) {
      return _this.handleClick(e);
    };
    _this.handleKeyDown_ = function(e) {
      return _this.handleKeyDown(e);
    };
    _this.emitTapEvents();
    _this.enable();
    return _this;
  }
  var _proto = ClickableComponent2.prototype;
  _proto.createEl = function createEl$1(tag, props, attributes) {
    if (tag === void 0) {
      tag = "div";
    }
    if (props === void 0) {
      props = {};
    }
    if (attributes === void 0) {
      attributes = {};
    }
    props = assign({
      className: this.buildCSSClass(),
      tabIndex: 0
    }, props);
    if (tag === "button") {
      log$1.error("Creating a ClickableComponent with an HTML element of " + tag + " is not supported; use a Button instead.");
    }
    attributes = assign({
      role: "button"
    }, attributes);
    this.tabIndex_ = props.tabIndex;
    var el = createEl(tag, props, attributes);
    el.appendChild(createEl("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": true
    }));
    this.createControlTextEl(el);
    return el;
  };
  _proto.dispose = function dispose() {
    this.controlTextEl_ = null;
    _Component.prototype.dispose.call(this);
  };
  _proto.createControlTextEl = function createControlTextEl(el) {
    this.controlTextEl_ = createEl("span", {
      className: "vjs-control-text"
    }, {
      "aria-live": "polite"
    });
    if (el) {
      el.appendChild(this.controlTextEl_);
    }
    this.controlText(this.controlText_, el);
    return this.controlTextEl_;
  };
  _proto.controlText = function controlText(text, el) {
    if (el === void 0) {
      el = this.el();
    }
    if (text === void 0) {
      return this.controlText_ || "Need Text";
    }
    var localizedText = this.localize(text);
    this.controlText_ = text;
    textContent(this.controlTextEl_, localizedText);
    if (!this.nonIconControl && !this.player_.options_.noUITitleAttributes) {
      el.setAttribute("title", localizedText);
    }
  };
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-control vjs-button " + _Component.prototype.buildCSSClass.call(this);
  };
  _proto.enable = function enable() {
    if (!this.enabled_) {
      this.enabled_ = true;
      this.removeClass("vjs-disabled");
      this.el_.setAttribute("aria-disabled", "false");
      if (typeof this.tabIndex_ !== "undefined") {
        this.el_.setAttribute("tabIndex", this.tabIndex_);
      }
      this.on(["tap", "click"], this.handleClick_);
      this.on("keydown", this.handleKeyDown_);
    }
  };
  _proto.disable = function disable() {
    this.enabled_ = false;
    this.addClass("vjs-disabled");
    this.el_.setAttribute("aria-disabled", "true");
    if (typeof this.tabIndex_ !== "undefined") {
      this.el_.removeAttribute("tabIndex");
    }
    this.off("mouseover", this.handleMouseOver_);
    this.off("mouseout", this.handleMouseOut_);
    this.off(["tap", "click"], this.handleClick_);
    this.off("keydown", this.handleKeyDown_);
  };
  _proto.handleLanguagechange = function handleLanguagechange() {
    this.controlText(this.controlText_);
  };
  _proto.handleClick = function handleClick(event) {
    if (this.options_.clickHandler) {
      this.options_.clickHandler.call(this, arguments);
    }
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (keycode.isEventKey(event, "Space") || keycode.isEventKey(event, "Enter")) {
      event.preventDefault();
      event.stopPropagation();
      this.trigger("click");
    } else {
      _Component.prototype.handleKeyDown.call(this, event);
    }
  };
  return ClickableComponent2;
}(Component$1);
Component$1.registerComponent("ClickableComponent", ClickableComponent);
var PosterImage = /* @__PURE__ */ function(_ClickableComponent) {
  _inheritsLoose(PosterImage2, _ClickableComponent);
  function PosterImage2(player, options) {
    var _this;
    _this = _ClickableComponent.call(this, player, options) || this;
    _this.update();
    _this.update_ = function(e) {
      return _this.update(e);
    };
    player.on("posterchange", _this.update_);
    return _this;
  }
  var _proto = PosterImage2.prototype;
  _proto.dispose = function dispose() {
    this.player().off("posterchange", this.update_);
    _ClickableComponent.prototype.dispose.call(this);
  };
  _proto.createEl = function createEl$1() {
    var el = createEl("div", {
      className: "vjs-poster",
      tabIndex: -1
    });
    return el;
  };
  _proto.update = function update2(event) {
    var url = this.player().poster();
    this.setSrc(url);
    if (url) {
      this.show();
    } else {
      this.hide();
    }
  };
  _proto.setSrc = function setSrc(url) {
    var backgroundImage = "";
    if (url) {
      backgroundImage = 'url("' + url + '")';
    }
    this.el_.style.backgroundImage = backgroundImage;
  };
  _proto.handleClick = function handleClick(event) {
    if (!this.player_.controls()) {
      return;
    }
    var sourceIsEncrypted = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
    if (this.player_.tech(true) && !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
      this.player_.tech(true).focus();
    }
    if (this.player_.paused()) {
      silencePromise(this.player_.play());
    } else {
      this.player_.pause();
    }
  };
  return PosterImage2;
}(ClickableComponent);
Component$1.registerComponent("PosterImage", PosterImage);
var darkGray = "#222";
var lightGray = "#ccc";
var fontMap = {
  monospace: "monospace",
  sansSerif: "sans-serif",
  serif: "serif",
  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
  monospaceSerif: '"Courier New", monospace',
  proportionalSansSerif: "sans-serif",
  proportionalSerif: "serif",
  casual: '"Comic Sans MS", Impact, fantasy',
  script: '"Monotype Corsiva", cursive',
  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
};
function constructColor(color, opacity) {
  var hex;
  if (color.length === 4) {
    hex = color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
  } else if (color.length === 7) {
    hex = color.slice(1);
  } else {
    throw new Error("Invalid color code provided, " + color + "; must be formatted as e.g. #f0e or #f604e2.");
  }
  return "rgba(" + parseInt(hex.slice(0, 2), 16) + "," + parseInt(hex.slice(2, 4), 16) + "," + parseInt(hex.slice(4, 6), 16) + "," + opacity + ")";
}
function tryUpdateStyle(el, style, rule) {
  try {
    el.style[style] = rule;
  } catch (e) {
    return;
  }
}
var TextTrackDisplay = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(TextTrackDisplay2, _Component);
  function TextTrackDisplay2(player, options, ready) {
    var _this;
    _this = _Component.call(this, player, options, ready) || this;
    var updateDisplayHandler = function updateDisplayHandler2(e) {
      return _this.updateDisplay(e);
    };
    player.on("loadstart", function(e) {
      return _this.toggleDisplay(e);
    });
    player.on("texttrackchange", updateDisplayHandler);
    player.on("loadedmetadata", function(e) {
      return _this.preselectTrack(e);
    });
    player.ready(bind(_assertThisInitialized(_this), function() {
      if (player.tech_ && player.tech_.featuresNativeTextTracks) {
        this.hide();
        return;
      }
      player.on("fullscreenchange", updateDisplayHandler);
      player.on("playerresize", updateDisplayHandler);
      window_1.addEventListener("orientationchange", updateDisplayHandler);
      player.on("dispose", function() {
        return window_1.removeEventListener("orientationchange", updateDisplayHandler);
      });
      var tracks = this.options_.playerOptions.tracks || [];
      for (var i = 0; i < tracks.length; i++) {
        this.player_.addRemoteTextTrack(tracks[i], true);
      }
      this.preselectTrack();
    }));
    return _this;
  }
  var _proto = TextTrackDisplay2.prototype;
  _proto.preselectTrack = function preselectTrack() {
    var modes = {
      captions: 1,
      subtitles: 1
    };
    var trackList = this.player_.textTracks();
    var userPref = this.player_.cache_.selectedLanguage;
    var firstDesc;
    var firstCaptions;
    var preferredTrack;
    for (var i = 0; i < trackList.length; i++) {
      var track = trackList[i];
      if (userPref && userPref.enabled && userPref.language && userPref.language === track.language && track.kind in modes) {
        if (track.kind === userPref.kind) {
          preferredTrack = track;
        } else if (!preferredTrack) {
          preferredTrack = track;
        }
      } else if (userPref && !userPref.enabled) {
        preferredTrack = null;
        firstDesc = null;
        firstCaptions = null;
      } else if (track["default"]) {
        if (track.kind === "descriptions" && !firstDesc) {
          firstDesc = track;
        } else if (track.kind in modes && !firstCaptions) {
          firstCaptions = track;
        }
      }
    }
    if (preferredTrack) {
      preferredTrack.mode = "showing";
    } else if (firstCaptions) {
      firstCaptions.mode = "showing";
    } else if (firstDesc) {
      firstDesc.mode = "showing";
    }
  };
  _proto.toggleDisplay = function toggleDisplay() {
    if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) {
      this.hide();
    } else {
      this.show();
    }
  };
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-text-track-display"
    }, {
      "translate": "yes",
      "aria-live": "off",
      "aria-atomic": "true"
    });
  };
  _proto.clearDisplay = function clearDisplay() {
    if (typeof window_1.WebVTT === "function") {
      window_1.WebVTT.processCues(window_1, [], this.el_);
    }
  };
  _proto.updateDisplay = function updateDisplay() {
    var tracks = this.player_.textTracks();
    var allowMultipleShowingTracks = this.options_.allowMultipleShowingTracks;
    this.clearDisplay();
    if (allowMultipleShowingTracks) {
      var showingTracks = [];
      for (var _i = 0; _i < tracks.length; ++_i) {
        var track = tracks[_i];
        if (track.mode !== "showing") {
          continue;
        }
        showingTracks.push(track);
      }
      this.updateForTrack(showingTracks);
      return;
    }
    var descriptionsTrack = null;
    var captionsSubtitlesTrack = null;
    var i = tracks.length;
    while (i--) {
      var _track = tracks[i];
      if (_track.mode === "showing") {
        if (_track.kind === "descriptions") {
          descriptionsTrack = _track;
        } else {
          captionsSubtitlesTrack = _track;
        }
      }
    }
    if (captionsSubtitlesTrack) {
      if (this.getAttribute("aria-live") !== "off") {
        this.setAttribute("aria-live", "off");
      }
      this.updateForTrack(captionsSubtitlesTrack);
    } else if (descriptionsTrack) {
      if (this.getAttribute("aria-live") !== "assertive") {
        this.setAttribute("aria-live", "assertive");
      }
      this.updateForTrack(descriptionsTrack);
    }
  };
  _proto.updateDisplayState = function updateDisplayState(track) {
    var overrides = this.player_.textTrackSettings.getValues();
    var cues = track.activeCues;
    var i = cues.length;
    while (i--) {
      var cue = cues[i];
      if (!cue) {
        continue;
      }
      var cueDiv = cue.displayState;
      if (overrides.color) {
        cueDiv.firstChild.style.color = overrides.color;
      }
      if (overrides.textOpacity) {
        tryUpdateStyle(cueDiv.firstChild, "color", constructColor(overrides.color || "#fff", overrides.textOpacity));
      }
      if (overrides.backgroundColor) {
        cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
      }
      if (overrides.backgroundOpacity) {
        tryUpdateStyle(cueDiv.firstChild, "backgroundColor", constructColor(overrides.backgroundColor || "#000", overrides.backgroundOpacity));
      }
      if (overrides.windowColor) {
        if (overrides.windowOpacity) {
          tryUpdateStyle(cueDiv, "backgroundColor", constructColor(overrides.windowColor, overrides.windowOpacity));
        } else {
          cueDiv.style.backgroundColor = overrides.windowColor;
        }
      }
      if (overrides.edgeStyle) {
        if (overrides.edgeStyle === "dropshadow") {
          cueDiv.firstChild.style.textShadow = "2px 2px 3px " + darkGray + ", 2px 2px 4px " + darkGray + ", 2px 2px 5px " + darkGray;
        } else if (overrides.edgeStyle === "raised") {
          cueDiv.firstChild.style.textShadow = "1px 1px " + darkGray + ", 2px 2px " + darkGray + ", 3px 3px " + darkGray;
        } else if (overrides.edgeStyle === "depressed") {
          cueDiv.firstChild.style.textShadow = "1px 1px " + lightGray + ", 0 1px " + lightGray + ", -1px -1px " + darkGray + ", 0 -1px " + darkGray;
        } else if (overrides.edgeStyle === "uniform") {
          cueDiv.firstChild.style.textShadow = "0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray + ", 0 0 4px " + darkGray;
        }
      }
      if (overrides.fontPercent && overrides.fontPercent !== 1) {
        var fontSize = window_1.parseFloat(cueDiv.style.fontSize);
        cueDiv.style.fontSize = fontSize * overrides.fontPercent + "px";
        cueDiv.style.height = "auto";
        cueDiv.style.top = "auto";
      }
      if (overrides.fontFamily && overrides.fontFamily !== "default") {
        if (overrides.fontFamily === "small-caps") {
          cueDiv.firstChild.style.fontVariant = "small-caps";
        } else {
          cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
        }
      }
    }
  };
  _proto.updateForTrack = function updateForTrack(tracks) {
    if (!Array.isArray(tracks)) {
      tracks = [tracks];
    }
    if (typeof window_1.WebVTT !== "function" || tracks.every(function(track2) {
      return !track2.activeCues;
    })) {
      return;
    }
    var cues = [];
    for (var i = 0; i < tracks.length; ++i) {
      var track = tracks[i];
      for (var j = 0; j < track.activeCues.length; ++j) {
        cues.push(track.activeCues[j]);
      }
    }
    window_1.WebVTT.processCues(window_1, cues, this.el_);
    for (var _i2 = 0; _i2 < tracks.length; ++_i2) {
      var _track2 = tracks[_i2];
      for (var _j = 0; _j < _track2.activeCues.length; ++_j) {
        var cueEl = _track2.activeCues[_j].displayState;
        addClass(cueEl, "vjs-text-track-cue");
        addClass(cueEl, "vjs-text-track-cue-" + (_track2.language ? _track2.language : _i2));
        if (_track2.language) {
          setAttribute(cueEl, "lang", _track2.language);
        }
      }
      if (this.player_.textTrackSettings) {
        this.updateDisplayState(_track2);
      }
    }
  };
  return TextTrackDisplay2;
}(Component$1);
Component$1.registerComponent("TextTrackDisplay", TextTrackDisplay);
var LoadingSpinner = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(LoadingSpinner2, _Component);
  function LoadingSpinner2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = LoadingSpinner2.prototype;
  _proto.createEl = function createEl$1() {
    var isAudio = this.player_.isAudio();
    var playerType = this.localize(isAudio ? "Audio Player" : "Video Player");
    var controlText = createEl("span", {
      className: "vjs-control-text",
      textContent: this.localize("{1} is loading.", [playerType])
    });
    var el = _Component.prototype.createEl.call(this, "div", {
      className: "vjs-loading-spinner",
      dir: "ltr"
    });
    el.appendChild(controlText);
    return el;
  };
  return LoadingSpinner2;
}(Component$1);
Component$1.registerComponent("LoadingSpinner", LoadingSpinner);
var Button = /* @__PURE__ */ function(_ClickableComponent) {
  _inheritsLoose(Button2, _ClickableComponent);
  function Button2() {
    return _ClickableComponent.apply(this, arguments) || this;
  }
  var _proto = Button2.prototype;
  _proto.createEl = function createEl$1(tag, props, attributes) {
    if (props === void 0) {
      props = {};
    }
    if (attributes === void 0) {
      attributes = {};
    }
    tag = "button";
    props = assign({
      className: this.buildCSSClass()
    }, props);
    attributes = assign({
      type: "button"
    }, attributes);
    var el = createEl(tag, props, attributes);
    el.appendChild(createEl("span", {
      className: "vjs-icon-placeholder"
    }, {
      "aria-hidden": true
    }));
    this.createControlTextEl(el);
    return el;
  };
  _proto.addChild = function addChild(child, options) {
    if (options === void 0) {
      options = {};
    }
    var className = this.constructor.name;
    log$1.warn("Adding an actionable (user controllable) child to a Button (" + className + ") is not supported; use a ClickableComponent instead.");
    return Component$1.prototype.addChild.call(this, child, options);
  };
  _proto.enable = function enable() {
    _ClickableComponent.prototype.enable.call(this);
    this.el_.removeAttribute("disabled");
  };
  _proto.disable = function disable() {
    _ClickableComponent.prototype.disable.call(this);
    this.el_.setAttribute("disabled", "disabled");
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (keycode.isEventKey(event, "Space") || keycode.isEventKey(event, "Enter")) {
      event.stopPropagation();
      return;
    }
    _ClickableComponent.prototype.handleKeyDown.call(this, event);
  };
  return Button2;
}(ClickableComponent);
Component$1.registerComponent("Button", Button);
var BigPlayButton = /* @__PURE__ */ function(_Button) {
  _inheritsLoose(BigPlayButton2, _Button);
  function BigPlayButton2(player, options) {
    var _this;
    _this = _Button.call(this, player, options) || this;
    _this.mouseused_ = false;
    _this.on("mousedown", function(e) {
      return _this.handleMouseDown(e);
    });
    return _this;
  }
  var _proto = BigPlayButton2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-big-play-button";
  };
  _proto.handleClick = function handleClick(event) {
    var playPromise = this.player_.play();
    if (this.mouseused_ && event.clientX && event.clientY) {
      var sourceIsEncrypted = this.player_.usingPlugin("eme") && this.player_.eme.sessions && this.player_.eme.sessions.length > 0;
      silencePromise(playPromise);
      if (this.player_.tech(true) && !((IE_VERSION || IS_EDGE) && sourceIsEncrypted)) {
        this.player_.tech(true).focus();
      }
      return;
    }
    var cb2 = this.player_.getChild("controlBar");
    var playToggle = cb2 && cb2.getChild("playToggle");
    if (!playToggle) {
      this.player_.tech(true).focus();
      return;
    }
    var playFocus = function playFocus2() {
      return playToggle.focus();
    };
    if (isPromise(playPromise)) {
      playPromise.then(playFocus, function() {
      });
    } else {
      this.setTimeout(playFocus, 1);
    }
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    this.mouseused_ = false;
    _Button.prototype.handleKeyDown.call(this, event);
  };
  _proto.handleMouseDown = function handleMouseDown(event) {
    this.mouseused_ = true;
  };
  return BigPlayButton2;
}(Button);
BigPlayButton.prototype.controlText_ = "Play Video";
Component$1.registerComponent("BigPlayButton", BigPlayButton);
var CloseButton = /* @__PURE__ */ function(_Button) {
  _inheritsLoose(CloseButton2, _Button);
  function CloseButton2(player, options) {
    var _this;
    _this = _Button.call(this, player, options) || this;
    _this.controlText(options && options.controlText || _this.localize("Close"));
    return _this;
  }
  var _proto = CloseButton2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-close-button " + _Button.prototype.buildCSSClass.call(this);
  };
  _proto.handleClick = function handleClick(event) {
    this.trigger({
      type: "close",
      bubbles: false
    });
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (keycode.isEventKey(event, "Esc")) {
      event.preventDefault();
      event.stopPropagation();
      this.trigger("click");
    } else {
      _Button.prototype.handleKeyDown.call(this, event);
    }
  };
  return CloseButton2;
}(Button);
Component$1.registerComponent("CloseButton", CloseButton);
var PlayToggle = /* @__PURE__ */ function(_Button) {
  _inheritsLoose(PlayToggle2, _Button);
  function PlayToggle2(player, options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _Button.call(this, player, options) || this;
    options.replay = options.replay === void 0 || options.replay;
    _this.on(player, "play", function(e) {
      return _this.handlePlay(e);
    });
    _this.on(player, "pause", function(e) {
      return _this.handlePause(e);
    });
    if (options.replay) {
      _this.on(player, "ended", function(e) {
        return _this.handleEnded(e);
      });
    }
    return _this;
  }
  var _proto = PlayToggle2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-play-control " + _Button.prototype.buildCSSClass.call(this);
  };
  _proto.handleClick = function handleClick(event) {
    if (this.player_.paused()) {
      silencePromise(this.player_.play());
    } else {
      this.player_.pause();
    }
  };
  _proto.handleSeeked = function handleSeeked(event) {
    this.removeClass("vjs-ended");
    if (this.player_.paused()) {
      this.handlePause(event);
    } else {
      this.handlePlay(event);
    }
  };
  _proto.handlePlay = function handlePlay(event) {
    this.removeClass("vjs-ended");
    this.removeClass("vjs-paused");
    this.addClass("vjs-playing");
    this.controlText("Pause");
  };
  _proto.handlePause = function handlePause(event) {
    this.removeClass("vjs-playing");
    this.addClass("vjs-paused");
    this.controlText("Play");
  };
  _proto.handleEnded = function handleEnded(event) {
    var _this2 = this;
    this.removeClass("vjs-playing");
    this.addClass("vjs-ended");
    this.controlText("Replay");
    this.one(this.player_, "seeked", function(e) {
      return _this2.handleSeeked(e);
    });
  };
  return PlayToggle2;
}(Button);
PlayToggle.prototype.controlText_ = "Play";
Component$1.registerComponent("PlayToggle", PlayToggle);
var defaultImplementation = function defaultImplementation2(seconds, guide) {
  seconds = seconds < 0 ? 0 : seconds;
  var s = Math.floor(seconds % 60);
  var m2 = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600);
  if (isNaN(seconds) || seconds === Infinity) {
    h = m2 = s = "-";
  }
  h = h > 0 || gh > 0 ? h + ":" : "";
  m2 = ((h || gm >= 10) && m2 < 10 ? "0" + m2 : m2) + ":";
  s = s < 10 ? "0" + s : s;
  return h + m2 + s;
};
var implementation = defaultImplementation;
function setFormatTime(customImplementation) {
  implementation = customImplementation;
}
function resetFormatTime() {
  implementation = defaultImplementation;
}
function formatTime(seconds, guide) {
  if (guide === void 0) {
    guide = seconds;
  }
  return implementation(seconds, guide);
}
var TimeDisplay = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(TimeDisplay2, _Component);
  function TimeDisplay2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.on(player, ["timeupdate", "ended"], function(e) {
      return _this.updateContent(e);
    });
    _this.updateTextNode_();
    return _this;
  }
  var _proto = TimeDisplay2.prototype;
  _proto.createEl = function createEl$1() {
    var className = this.buildCSSClass();
    var el = _Component.prototype.createEl.call(this, "div", {
      className: className + " vjs-time-control vjs-control"
    });
    var span = createEl("span", {
      className: "vjs-control-text",
      textContent: this.localize(this.labelText_) + "\xA0"
    }, {
      role: "presentation"
    });
    el.appendChild(span);
    this.contentEl_ = createEl("span", {
      className: className + "-display"
    }, {
      "aria-live": "off",
      "role": "presentation"
    });
    el.appendChild(this.contentEl_);
    return el;
  };
  _proto.dispose = function dispose() {
    this.contentEl_ = null;
    this.textNode_ = null;
    _Component.prototype.dispose.call(this);
  };
  _proto.updateTextNode_ = function updateTextNode_(time) {
    var _this2 = this;
    if (time === void 0) {
      time = 0;
    }
    time = formatTime(time);
    if (this.formattedTime_ === time) {
      return;
    }
    this.formattedTime_ = time;
    this.requestNamedAnimationFrame("TimeDisplay#updateTextNode_", function() {
      if (!_this2.contentEl_) {
        return;
      }
      var oldNode = _this2.textNode_;
      if (oldNode && _this2.contentEl_.firstChild !== oldNode) {
        oldNode = null;
        log$1.warn("TimeDisplay#updateTextnode_: Prevented replacement of text node element since it was no longer a child of this node. Appending a new node instead.");
      }
      _this2.textNode_ = document_1.createTextNode(_this2.formattedTime_);
      if (!_this2.textNode_) {
        return;
      }
      if (oldNode) {
        _this2.contentEl_.replaceChild(_this2.textNode_, oldNode);
      } else {
        _this2.contentEl_.appendChild(_this2.textNode_);
      }
    });
  };
  _proto.updateContent = function updateContent(event) {
  };
  return TimeDisplay2;
}(Component$1);
TimeDisplay.prototype.labelText_ = "Time";
TimeDisplay.prototype.controlText_ = "Time";
Component$1.registerComponent("TimeDisplay", TimeDisplay);
var CurrentTimeDisplay = /* @__PURE__ */ function(_TimeDisplay) {
  _inheritsLoose(CurrentTimeDisplay2, _TimeDisplay);
  function CurrentTimeDisplay2() {
    return _TimeDisplay.apply(this, arguments) || this;
  }
  var _proto = CurrentTimeDisplay2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-current-time";
  };
  _proto.updateContent = function updateContent(event) {
    var time;
    if (this.player_.ended()) {
      time = this.player_.duration();
    } else {
      time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    }
    this.updateTextNode_(time);
  };
  return CurrentTimeDisplay2;
}(TimeDisplay);
CurrentTimeDisplay.prototype.labelText_ = "Current Time";
CurrentTimeDisplay.prototype.controlText_ = "Current Time";
Component$1.registerComponent("CurrentTimeDisplay", CurrentTimeDisplay);
var DurationDisplay = /* @__PURE__ */ function(_TimeDisplay) {
  _inheritsLoose(DurationDisplay2, _TimeDisplay);
  function DurationDisplay2(player, options) {
    var _this;
    _this = _TimeDisplay.call(this, player, options) || this;
    var updateContent = function updateContent2(e) {
      return _this.updateContent(e);
    };
    _this.on(player, "durationchange", updateContent);
    _this.on(player, "loadstart", updateContent);
    _this.on(player, "loadedmetadata", updateContent);
    return _this;
  }
  var _proto = DurationDisplay2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-duration";
  };
  _proto.updateContent = function updateContent(event) {
    var duration5 = this.player_.duration();
    this.updateTextNode_(duration5);
  };
  return DurationDisplay2;
}(TimeDisplay);
DurationDisplay.prototype.labelText_ = "Duration";
DurationDisplay.prototype.controlText_ = "Duration";
Component$1.registerComponent("DurationDisplay", DurationDisplay);
var TimeDivider = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(TimeDivider2, _Component);
  function TimeDivider2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = TimeDivider2.prototype;
  _proto.createEl = function createEl2() {
    var el = _Component.prototype.createEl.call(this, "div", {
      className: "vjs-time-control vjs-time-divider"
    }, {
      "aria-hidden": true
    });
    var div2 = _Component.prototype.createEl.call(this, "div");
    var span = _Component.prototype.createEl.call(this, "span", {
      textContent: "/"
    });
    div2.appendChild(span);
    el.appendChild(div2);
    return el;
  };
  return TimeDivider2;
}(Component$1);
Component$1.registerComponent("TimeDivider", TimeDivider);
var RemainingTimeDisplay = /* @__PURE__ */ function(_TimeDisplay) {
  _inheritsLoose(RemainingTimeDisplay2, _TimeDisplay);
  function RemainingTimeDisplay2(player, options) {
    var _this;
    _this = _TimeDisplay.call(this, player, options) || this;
    _this.on(player, "durationchange", function(e) {
      return _this.updateContent(e);
    });
    return _this;
  }
  var _proto = RemainingTimeDisplay2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-remaining-time";
  };
  _proto.createEl = function createEl$1() {
    var el = _TimeDisplay.prototype.createEl.call(this);
    if (this.options_.displayNegative !== false) {
      el.insertBefore(createEl("span", {}, {
        "aria-hidden": true
      }, "-"), this.contentEl_);
    }
    return el;
  };
  _proto.updateContent = function updateContent(event) {
    if (typeof this.player_.duration() !== "number") {
      return;
    }
    var time;
    if (this.player_.ended()) {
      time = 0;
    } else if (this.player_.remainingTimeDisplay) {
      time = this.player_.remainingTimeDisplay();
    } else {
      time = this.player_.remainingTime();
    }
    this.updateTextNode_(time);
  };
  return RemainingTimeDisplay2;
}(TimeDisplay);
RemainingTimeDisplay.prototype.labelText_ = "Remaining Time";
RemainingTimeDisplay.prototype.controlText_ = "Remaining Time";
Component$1.registerComponent("RemainingTimeDisplay", RemainingTimeDisplay);
var LiveDisplay = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(LiveDisplay2, _Component);
  function LiveDisplay2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.updateShowing();
    _this.on(_this.player(), "durationchange", function(e) {
      return _this.updateShowing(e);
    });
    return _this;
  }
  var _proto = LiveDisplay2.prototype;
  _proto.createEl = function createEl$1() {
    var el = _Component.prototype.createEl.call(this, "div", {
      className: "vjs-live-control vjs-control"
    });
    this.contentEl_ = createEl("div", {
      className: "vjs-live-display"
    }, {
      "aria-live": "off"
    });
    this.contentEl_.appendChild(createEl("span", {
      className: "vjs-control-text",
      textContent: this.localize("Stream Type") + "\xA0"
    }));
    this.contentEl_.appendChild(document_1.createTextNode(this.localize("LIVE")));
    el.appendChild(this.contentEl_);
    return el;
  };
  _proto.dispose = function dispose() {
    this.contentEl_ = null;
    _Component.prototype.dispose.call(this);
  };
  _proto.updateShowing = function updateShowing(event) {
    if (this.player().duration() === Infinity) {
      this.show();
    } else {
      this.hide();
    }
  };
  return LiveDisplay2;
}(Component$1);
Component$1.registerComponent("LiveDisplay", LiveDisplay);
var SeekToLive = /* @__PURE__ */ function(_Button) {
  _inheritsLoose(SeekToLive2, _Button);
  function SeekToLive2(player, options) {
    var _this;
    _this = _Button.call(this, player, options) || this;
    _this.updateLiveEdgeStatus();
    if (_this.player_.liveTracker) {
      _this.updateLiveEdgeStatusHandler_ = function(e) {
        return _this.updateLiveEdgeStatus(e);
      };
      _this.on(_this.player_.liveTracker, "liveedgechange", _this.updateLiveEdgeStatusHandler_);
    }
    return _this;
  }
  var _proto = SeekToLive2.prototype;
  _proto.createEl = function createEl$1() {
    var el = _Button.prototype.createEl.call(this, "button", {
      className: "vjs-seek-to-live-control vjs-control"
    });
    this.textEl_ = createEl("span", {
      className: "vjs-seek-to-live-text",
      textContent: this.localize("LIVE")
    }, {
      "aria-hidden": "true"
    });
    el.appendChild(this.textEl_);
    return el;
  };
  _proto.updateLiveEdgeStatus = function updateLiveEdgeStatus() {
    if (!this.player_.liveTracker || this.player_.liveTracker.atLiveEdge()) {
      this.setAttribute("aria-disabled", true);
      this.addClass("vjs-at-live-edge");
      this.controlText("Seek to live, currently playing live");
    } else {
      this.setAttribute("aria-disabled", false);
      this.removeClass("vjs-at-live-edge");
      this.controlText("Seek to live, currently behind live");
    }
  };
  _proto.handleClick = function handleClick() {
    this.player_.liveTracker.seekToLiveEdge();
  };
  _proto.dispose = function dispose() {
    if (this.player_.liveTracker) {
      this.off(this.player_.liveTracker, "liveedgechange", this.updateLiveEdgeStatusHandler_);
    }
    this.textEl_ = null;
    _Button.prototype.dispose.call(this);
  };
  return SeekToLive2;
}(Button);
SeekToLive.prototype.controlText_ = "Seek to live, currently playing live";
Component$1.registerComponent("SeekToLive", SeekToLive);
var clamp = function clamp2(number, min, max) {
  number = Number(number);
  return Math.min(max, Math.max(min, isNaN(number) ? min : number));
};
var Slider = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(Slider2, _Component);
  function Slider2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.handleMouseDown_ = function(e) {
      return _this.handleMouseDown(e);
    };
    _this.handleMouseUp_ = function(e) {
      return _this.handleMouseUp(e);
    };
    _this.handleKeyDown_ = function(e) {
      return _this.handleKeyDown(e);
    };
    _this.handleClick_ = function(e) {
      return _this.handleClick(e);
    };
    _this.handleMouseMove_ = function(e) {
      return _this.handleMouseMove(e);
    };
    _this.update_ = function(e) {
      return _this.update(e);
    };
    _this.bar = _this.getChild(_this.options_.barName);
    _this.vertical(!!_this.options_.vertical);
    _this.enable();
    return _this;
  }
  var _proto = Slider2.prototype;
  _proto.enabled = function enabled() {
    return this.enabled_;
  };
  _proto.enable = function enable() {
    if (this.enabled()) {
      return;
    }
    this.on("mousedown", this.handleMouseDown_);
    this.on("touchstart", this.handleMouseDown_);
    this.on("keydown", this.handleKeyDown_);
    this.on("click", this.handleClick_);
    this.on(this.player_, "controlsvisible", this.update);
    if (this.playerEvent) {
      this.on(this.player_, this.playerEvent, this.update);
    }
    this.removeClass("disabled");
    this.setAttribute("tabindex", 0);
    this.enabled_ = true;
  };
  _proto.disable = function disable() {
    if (!this.enabled()) {
      return;
    }
    var doc = this.bar.el_.ownerDocument;
    this.off("mousedown", this.handleMouseDown_);
    this.off("touchstart", this.handleMouseDown_);
    this.off("keydown", this.handleKeyDown_);
    this.off("click", this.handleClick_);
    this.off(this.player_, "controlsvisible", this.update_);
    this.off(doc, "mousemove", this.handleMouseMove_);
    this.off(doc, "mouseup", this.handleMouseUp_);
    this.off(doc, "touchmove", this.handleMouseMove_);
    this.off(doc, "touchend", this.handleMouseUp_);
    this.removeAttribute("tabindex");
    this.addClass("disabled");
    if (this.playerEvent) {
      this.off(this.player_, this.playerEvent, this.update);
    }
    this.enabled_ = false;
  };
  _proto.createEl = function createEl2(type2, props, attributes) {
    if (props === void 0) {
      props = {};
    }
    if (attributes === void 0) {
      attributes = {};
    }
    props.className = props.className + " vjs-slider";
    props = assign({
      tabIndex: 0
    }, props);
    attributes = assign({
      "role": "slider",
      "aria-valuenow": 0,
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "tabIndex": 0
    }, attributes);
    return _Component.prototype.createEl.call(this, type2, props, attributes);
  };
  _proto.handleMouseDown = function handleMouseDown(event) {
    var doc = this.bar.el_.ownerDocument;
    if (event.type === "mousedown") {
      event.preventDefault();
    }
    if (event.type === "touchstart" && !IS_CHROME) {
      event.preventDefault();
    }
    blockTextSelection();
    this.addClass("vjs-sliding");
    this.trigger("slideractive");
    this.on(doc, "mousemove", this.handleMouseMove_);
    this.on(doc, "mouseup", this.handleMouseUp_);
    this.on(doc, "touchmove", this.handleMouseMove_);
    this.on(doc, "touchend", this.handleMouseUp_);
    this.handleMouseMove(event, true);
  };
  _proto.handleMouseMove = function handleMouseMove(event) {
  };
  _proto.handleMouseUp = function handleMouseUp() {
    var doc = this.bar.el_.ownerDocument;
    unblockTextSelection();
    this.removeClass("vjs-sliding");
    this.trigger("sliderinactive");
    this.off(doc, "mousemove", this.handleMouseMove_);
    this.off(doc, "mouseup", this.handleMouseUp_);
    this.off(doc, "touchmove", this.handleMouseMove_);
    this.off(doc, "touchend", this.handleMouseUp_);
    this.update();
  };
  _proto.update = function update2() {
    var _this2 = this;
    if (!this.el_ || !this.bar) {
      return;
    }
    var progress = this.getProgress();
    if (progress === this.progress_) {
      return progress;
    }
    this.progress_ = progress;
    this.requestNamedAnimationFrame("Slider#update", function() {
      var sizeKey = _this2.vertical() ? "height" : "width";
      _this2.bar.el().style[sizeKey] = (progress * 100).toFixed(2) + "%";
    });
    return progress;
  };
  _proto.getProgress = function getProgress() {
    return Number(clamp(this.getPercent(), 0, 1).toFixed(4));
  };
  _proto.calculateDistance = function calculateDistance(event) {
    var position2 = getPointerPosition(this.el_, event);
    if (this.vertical()) {
      return position2.y;
    }
    return position2.x;
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (keycode.isEventKey(event, "Left") || keycode.isEventKey(event, "Down")) {
      event.preventDefault();
      event.stopPropagation();
      this.stepBack();
    } else if (keycode.isEventKey(event, "Right") || keycode.isEventKey(event, "Up")) {
      event.preventDefault();
      event.stopPropagation();
      this.stepForward();
    } else {
      _Component.prototype.handleKeyDown.call(this, event);
    }
  };
  _proto.handleClick = function handleClick(event) {
    event.stopPropagation();
    event.preventDefault();
  };
  _proto.vertical = function vertical(bool2) {
    if (bool2 === void 0) {
      return this.vertical_ || false;
    }
    this.vertical_ = !!bool2;
    if (this.vertical_) {
      this.addClass("vjs-slider-vertical");
    } else {
      this.addClass("vjs-slider-horizontal");
    }
  };
  return Slider2;
}(Component$1);
Component$1.registerComponent("Slider", Slider);
var percentify = function percentify2(time, end3) {
  return clamp(time / end3 * 100, 0, 100).toFixed(2) + "%";
};
var LoadProgressBar = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(LoadProgressBar2, _Component);
  function LoadProgressBar2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.partEls_ = [];
    _this.on(player, "progress", function(e) {
      return _this.update(e);
    });
    return _this;
  }
  var _proto = LoadProgressBar2.prototype;
  _proto.createEl = function createEl$1() {
    var el = _Component.prototype.createEl.call(this, "div", {
      className: "vjs-load-progress"
    });
    var wrapper2 = createEl("span", {
      className: "vjs-control-text"
    });
    var loadedText = createEl("span", {
      textContent: this.localize("Loaded")
    });
    var separator = document_1.createTextNode(": ");
    this.percentageEl_ = createEl("span", {
      className: "vjs-control-text-loaded-percentage",
      textContent: "0%"
    });
    el.appendChild(wrapper2);
    wrapper2.appendChild(loadedText);
    wrapper2.appendChild(separator);
    wrapper2.appendChild(this.percentageEl_);
    return el;
  };
  _proto.dispose = function dispose() {
    this.partEls_ = null;
    this.percentageEl_ = null;
    _Component.prototype.dispose.call(this);
  };
  _proto.update = function update2(event) {
    var _this2 = this;
    this.requestNamedAnimationFrame("LoadProgressBar#update", function() {
      var liveTracker = _this2.player_.liveTracker;
      var buffered = _this2.player_.buffered();
      var duration5 = liveTracker && liveTracker.isLive() ? liveTracker.seekableEnd() : _this2.player_.duration();
      var bufferedEnd = _this2.player_.bufferedEnd();
      var children = _this2.partEls_;
      var percent = percentify(bufferedEnd, duration5);
      if (_this2.percent_ !== percent) {
        _this2.el_.style.width = percent;
        textContent(_this2.percentageEl_, percent);
        _this2.percent_ = percent;
      }
      for (var i = 0; i < buffered.length; i++) {
        var start2 = buffered.start(i);
        var end3 = buffered.end(i);
        var part = children[i];
        if (!part) {
          part = _this2.el_.appendChild(createEl());
          children[i] = part;
        }
        if (part.dataset.start === start2 && part.dataset.end === end3) {
          continue;
        }
        part.dataset.start = start2;
        part.dataset.end = end3;
        part.style.left = percentify(start2, bufferedEnd);
        part.style.width = percentify(end3 - start2, bufferedEnd);
      }
      for (var _i = children.length; _i > buffered.length; _i--) {
        _this2.el_.removeChild(children[_i - 1]);
      }
      children.length = buffered.length;
    });
  };
  return LoadProgressBar2;
}(Component$1);
Component$1.registerComponent("LoadProgressBar", LoadProgressBar);
var TimeTooltip = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(TimeTooltip2, _Component);
  function TimeTooltip2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.update = throttle(bind(_assertThisInitialized(_this), _this.update), UPDATE_REFRESH_INTERVAL);
    return _this;
  }
  var _proto = TimeTooltip2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-time-tooltip"
    }, {
      "aria-hidden": "true"
    });
  };
  _proto.update = function update2(seekBarRect, seekBarPoint, content2) {
    var tooltipRect = findPosition(this.el_);
    var playerRect = getBoundingClientRect(this.player_.el());
    var seekBarPointPx = seekBarRect.width * seekBarPoint;
    if (!playerRect || !tooltipRect) {
      return;
    }
    var spaceLeftOfPoint = seekBarRect.left - playerRect.left + seekBarPointPx;
    var spaceRightOfPoint = seekBarRect.width - seekBarPointPx + (playerRect.right - seekBarRect.right);
    var pullTooltipBy = tooltipRect.width / 2;
    if (spaceLeftOfPoint < pullTooltipBy) {
      pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
    } else if (spaceRightOfPoint < pullTooltipBy) {
      pullTooltipBy = spaceRightOfPoint;
    }
    if (pullTooltipBy < 0) {
      pullTooltipBy = 0;
    } else if (pullTooltipBy > tooltipRect.width) {
      pullTooltipBy = tooltipRect.width;
    }
    pullTooltipBy = Math.round(pullTooltipBy);
    this.el_.style.right = "-" + pullTooltipBy + "px";
    this.write(content2);
  };
  _proto.write = function write(content2) {
    textContent(this.el_, content2);
  };
  _proto.updateTime = function updateTime(seekBarRect, seekBarPoint, time, cb2) {
    var _this2 = this;
    this.requestNamedAnimationFrame("TimeTooltip#updateTime", function() {
      var content2;
      var duration5 = _this2.player_.duration();
      if (_this2.player_.liveTracker && _this2.player_.liveTracker.isLive()) {
        var liveWindow = _this2.player_.liveTracker.liveWindow();
        var secondsBehind = liveWindow - seekBarPoint * liveWindow;
        content2 = (secondsBehind < 1 ? "" : "-") + formatTime(secondsBehind, liveWindow);
      } else {
        content2 = formatTime(time, duration5);
      }
      _this2.update(seekBarRect, seekBarPoint, content2);
      if (cb2) {
        cb2();
      }
    });
  };
  return TimeTooltip2;
}(Component$1);
Component$1.registerComponent("TimeTooltip", TimeTooltip);
var PlayProgressBar = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(PlayProgressBar2, _Component);
  function PlayProgressBar2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.update = throttle(bind(_assertThisInitialized(_this), _this.update), UPDATE_REFRESH_INTERVAL);
    return _this;
  }
  var _proto = PlayProgressBar2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-play-progress vjs-slider-bar"
    }, {
      "aria-hidden": "true"
    });
  };
  _proto.update = function update2(seekBarRect, seekBarPoint) {
    var timeTooltip = this.getChild("timeTooltip");
    if (!timeTooltip) {
      return;
    }
    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
    timeTooltip.updateTime(seekBarRect, seekBarPoint, time);
  };
  return PlayProgressBar2;
}(Component$1);
PlayProgressBar.prototype.options_ = {
  children: []
};
if (!IS_IOS && !IS_ANDROID) {
  PlayProgressBar.prototype.options_.children.push("timeTooltip");
}
Component$1.registerComponent("PlayProgressBar", PlayProgressBar);
var MouseTimeDisplay = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(MouseTimeDisplay2, _Component);
  function MouseTimeDisplay2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.update = throttle(bind(_assertThisInitialized(_this), _this.update), UPDATE_REFRESH_INTERVAL);
    return _this;
  }
  var _proto = MouseTimeDisplay2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-mouse-display"
    });
  };
  _proto.update = function update2(seekBarRect, seekBarPoint) {
    var _this2 = this;
    var time = seekBarPoint * this.player_.duration();
    this.getChild("timeTooltip").updateTime(seekBarRect, seekBarPoint, time, function() {
      _this2.el_.style.left = seekBarRect.width * seekBarPoint + "px";
    });
  };
  return MouseTimeDisplay2;
}(Component$1);
MouseTimeDisplay.prototype.options_ = {
  children: ["timeTooltip"]
};
Component$1.registerComponent("MouseTimeDisplay", MouseTimeDisplay);
var STEP_SECONDS = 5;
var PAGE_KEY_MULTIPLIER = 12;
var SeekBar = /* @__PURE__ */ function(_Slider) {
  _inheritsLoose(SeekBar2, _Slider);
  function SeekBar2(player, options) {
    var _this;
    _this = _Slider.call(this, player, options) || this;
    _this.setEventHandlers_();
    return _this;
  }
  var _proto = SeekBar2.prototype;
  _proto.setEventHandlers_ = function setEventHandlers_() {
    var _this2 = this;
    this.update_ = bind(this, this.update);
    this.update = throttle(this.update_, UPDATE_REFRESH_INTERVAL);
    this.on(this.player_, ["ended", "durationchange", "timeupdate"], this.update);
    if (this.player_.liveTracker) {
      this.on(this.player_.liveTracker, "liveedgechange", this.update);
    }
    this.updateInterval = null;
    this.enableIntervalHandler_ = function(e) {
      return _this2.enableInterval_(e);
    };
    this.disableIntervalHandler_ = function(e) {
      return _this2.disableInterval_(e);
    };
    this.on(this.player_, ["playing"], this.enableIntervalHandler_);
    this.on(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_);
    if ("hidden" in document_1 && "visibilityState" in document_1) {
      this.on(document_1, "visibilitychange", this.toggleVisibility_);
    }
  };
  _proto.toggleVisibility_ = function toggleVisibility_(e) {
    if (document_1.visibilityState === "hidden") {
      this.cancelNamedAnimationFrame("SeekBar#update");
      this.cancelNamedAnimationFrame("Slider#update");
      this.disableInterval_(e);
    } else {
      if (!this.player_.ended() && !this.player_.paused()) {
        this.enableInterval_();
      }
      this.update();
    }
  };
  _proto.enableInterval_ = function enableInterval_() {
    if (this.updateInterval) {
      return;
    }
    this.updateInterval = this.setInterval(this.update, UPDATE_REFRESH_INTERVAL);
  };
  _proto.disableInterval_ = function disableInterval_(e) {
    if (this.player_.liveTracker && this.player_.liveTracker.isLive() && e && e.type !== "ended") {
      return;
    }
    if (!this.updateInterval) {
      return;
    }
    this.clearInterval(this.updateInterval);
    this.updateInterval = null;
  };
  _proto.createEl = function createEl2() {
    return _Slider.prototype.createEl.call(this, "div", {
      className: "vjs-progress-holder"
    }, {
      "aria-label": this.localize("Progress Bar")
    });
  };
  _proto.update = function update2(event) {
    var _this3 = this;
    if (document_1.visibilityState === "hidden") {
      return;
    }
    var percent = _Slider.prototype.update.call(this);
    this.requestNamedAnimationFrame("SeekBar#update", function() {
      var currentTime = _this3.player_.ended() ? _this3.player_.duration() : _this3.getCurrentTime_();
      var liveTracker = _this3.player_.liveTracker;
      var duration5 = _this3.player_.duration();
      if (liveTracker && liveTracker.isLive()) {
        duration5 = _this3.player_.liveTracker.liveCurrentTime();
      }
      if (_this3.percent_ !== percent) {
        _this3.el_.setAttribute("aria-valuenow", (percent * 100).toFixed(2));
        _this3.percent_ = percent;
      }
      if (_this3.currentTime_ !== currentTime || _this3.duration_ !== duration5) {
        _this3.el_.setAttribute("aria-valuetext", _this3.localize("progress bar timing: currentTime={1} duration={2}", [formatTime(currentTime, duration5), formatTime(duration5, duration5)], "{1} of {2}"));
        _this3.currentTime_ = currentTime;
        _this3.duration_ = duration5;
      }
      if (_this3.bar) {
        _this3.bar.update(getBoundingClientRect(_this3.el()), _this3.getProgress());
      }
    });
    return percent;
  };
  _proto.userSeek_ = function userSeek_(ct) {
    if (this.player_.liveTracker && this.player_.liveTracker.isLive()) {
      this.player_.liveTracker.nextSeekedFromUser();
    }
    this.player_.currentTime(ct);
  };
  _proto.getCurrentTime_ = function getCurrentTime_() {
    return this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
  };
  _proto.getPercent = function getPercent() {
    var currentTime = this.getCurrentTime_();
    var percent;
    var liveTracker = this.player_.liveTracker;
    if (liveTracker && liveTracker.isLive()) {
      percent = (currentTime - liveTracker.seekableStart()) / liveTracker.liveWindow();
      if (liveTracker.atLiveEdge()) {
        percent = 1;
      }
    } else {
      percent = currentTime / this.player_.duration();
    }
    return percent;
  };
  _proto.handleMouseDown = function handleMouseDown(event) {
    if (!isSingleLeftClick(event)) {
      return;
    }
    event.stopPropagation();
    this.videoWasPlaying = !this.player_.paused();
    this.player_.pause();
    _Slider.prototype.handleMouseDown.call(this, event);
  };
  _proto.handleMouseMove = function handleMouseMove(event, mouseDown) {
    if (mouseDown === void 0) {
      mouseDown = false;
    }
    if (!isSingleLeftClick(event)) {
      return;
    }
    if (!mouseDown && !this.player_.scrubbing()) {
      this.player_.scrubbing(true);
    }
    var newTime;
    var distance = this.calculateDistance(event);
    var liveTracker = this.player_.liveTracker;
    if (!liveTracker || !liveTracker.isLive()) {
      newTime = distance * this.player_.duration();
      if (newTime === this.player_.duration()) {
        newTime = newTime - 0.1;
      }
    } else {
      if (distance >= 0.99) {
        liveTracker.seekToLiveEdge();
        return;
      }
      var seekableStart = liveTracker.seekableStart();
      var seekableEnd = liveTracker.liveCurrentTime();
      newTime = seekableStart + distance * liveTracker.liveWindow();
      if (newTime >= seekableEnd) {
        newTime = seekableEnd;
      }
      if (newTime <= seekableStart) {
        newTime = seekableStart + 0.1;
      }
      if (newTime === Infinity) {
        return;
      }
    }
    this.userSeek_(newTime);
  };
  _proto.enable = function enable() {
    _Slider.prototype.enable.call(this);
    var mouseTimeDisplay = this.getChild("mouseTimeDisplay");
    if (!mouseTimeDisplay) {
      return;
    }
    mouseTimeDisplay.show();
  };
  _proto.disable = function disable() {
    _Slider.prototype.disable.call(this);
    var mouseTimeDisplay = this.getChild("mouseTimeDisplay");
    if (!mouseTimeDisplay) {
      return;
    }
    mouseTimeDisplay.hide();
  };
  _proto.handleMouseUp = function handleMouseUp(event) {
    _Slider.prototype.handleMouseUp.call(this, event);
    if (event) {
      event.stopPropagation();
    }
    this.player_.scrubbing(false);
    this.player_.trigger({
      type: "timeupdate",
      target: this,
      manuallyTriggered: true
    });
    if (this.videoWasPlaying) {
      silencePromise(this.player_.play());
    } else {
      this.update_();
    }
  };
  _proto.stepForward = function stepForward() {
    this.userSeek_(this.player_.currentTime() + STEP_SECONDS);
  };
  _proto.stepBack = function stepBack() {
    this.userSeek_(this.player_.currentTime() - STEP_SECONDS);
  };
  _proto.handleAction = function handleAction(event) {
    if (this.player_.paused()) {
      this.player_.play();
    } else {
      this.player_.pause();
    }
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    var liveTracker = this.player_.liveTracker;
    if (keycode.isEventKey(event, "Space") || keycode.isEventKey(event, "Enter")) {
      event.preventDefault();
      event.stopPropagation();
      this.handleAction(event);
    } else if (keycode.isEventKey(event, "Home")) {
      event.preventDefault();
      event.stopPropagation();
      this.userSeek_(0);
    } else if (keycode.isEventKey(event, "End")) {
      event.preventDefault();
      event.stopPropagation();
      if (liveTracker && liveTracker.isLive()) {
        this.userSeek_(liveTracker.liveCurrentTime());
      } else {
        this.userSeek_(this.player_.duration());
      }
    } else if (/^[0-9]$/.test(keycode(event))) {
      event.preventDefault();
      event.stopPropagation();
      var gotoFraction = (keycode.codes[keycode(event)] - keycode.codes["0"]) * 10 / 100;
      if (liveTracker && liveTracker.isLive()) {
        this.userSeek_(liveTracker.seekableStart() + liveTracker.liveWindow() * gotoFraction);
      } else {
        this.userSeek_(this.player_.duration() * gotoFraction);
      }
    } else if (keycode.isEventKey(event, "PgDn")) {
      event.preventDefault();
      event.stopPropagation();
      this.userSeek_(this.player_.currentTime() - STEP_SECONDS * PAGE_KEY_MULTIPLIER);
    } else if (keycode.isEventKey(event, "PgUp")) {
      event.preventDefault();
      event.stopPropagation();
      this.userSeek_(this.player_.currentTime() + STEP_SECONDS * PAGE_KEY_MULTIPLIER);
    } else {
      _Slider.prototype.handleKeyDown.call(this, event);
    }
  };
  _proto.dispose = function dispose() {
    this.disableInterval_();
    this.off(this.player_, ["ended", "durationchange", "timeupdate"], this.update);
    if (this.player_.liveTracker) {
      this.off(this.player_.liveTracker, "liveedgechange", this.update);
    }
    this.off(this.player_, ["playing"], this.enableIntervalHandler_);
    this.off(this.player_, ["ended", "pause", "waiting"], this.disableIntervalHandler_);
    if ("hidden" in document_1 && "visibilityState" in document_1) {
      this.off(document_1, "visibilitychange", this.toggleVisibility_);
    }
    _Slider.prototype.dispose.call(this);
  };
  return SeekBar2;
}(Slider);
SeekBar.prototype.options_ = {
  children: ["loadProgressBar", "playProgressBar"],
  barName: "playProgressBar"
};
if (!IS_IOS && !IS_ANDROID) {
  SeekBar.prototype.options_.children.splice(1, 0, "mouseTimeDisplay");
}
Component$1.registerComponent("SeekBar", SeekBar);
var ProgressControl = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(ProgressControl2, _Component);
  function ProgressControl2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.handleMouseMove = throttle(bind(_assertThisInitialized(_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
    _this.throttledHandleMouseSeek = throttle(bind(_assertThisInitialized(_this), _this.handleMouseSeek), UPDATE_REFRESH_INTERVAL);
    _this.handleMouseUpHandler_ = function(e) {
      return _this.handleMouseUp(e);
    };
    _this.handleMouseDownHandler_ = function(e) {
      return _this.handleMouseDown(e);
    };
    _this.enable();
    return _this;
  }
  var _proto = ProgressControl2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-progress-control vjs-control"
    });
  };
  _proto.handleMouseMove = function handleMouseMove(event) {
    var seekBar = this.getChild("seekBar");
    if (!seekBar) {
      return;
    }
    var playProgressBar = seekBar.getChild("playProgressBar");
    var mouseTimeDisplay = seekBar.getChild("mouseTimeDisplay");
    if (!playProgressBar && !mouseTimeDisplay) {
      return;
    }
    var seekBarEl = seekBar.el();
    var seekBarRect = findPosition(seekBarEl);
    var seekBarPoint = getPointerPosition(seekBarEl, event).x;
    seekBarPoint = clamp(seekBarPoint, 0, 1);
    if (mouseTimeDisplay) {
      mouseTimeDisplay.update(seekBarRect, seekBarPoint);
    }
    if (playProgressBar) {
      playProgressBar.update(seekBarRect, seekBar.getProgress());
    }
  };
  _proto.handleMouseSeek = function handleMouseSeek(event) {
    var seekBar = this.getChild("seekBar");
    if (seekBar) {
      seekBar.handleMouseMove(event);
    }
  };
  _proto.enabled = function enabled() {
    return this.enabled_;
  };
  _proto.disable = function disable() {
    this.children().forEach(function(child) {
      return child.disable && child.disable();
    });
    if (!this.enabled()) {
      return;
    }
    this.off(["mousedown", "touchstart"], this.handleMouseDownHandler_);
    this.off(this.el_, "mousemove", this.handleMouseMove);
    this.removeListenersAddedOnMousedownAndTouchstart();
    this.addClass("disabled");
    this.enabled_ = false;
    if (this.player_.scrubbing()) {
      var seekBar = this.getChild("seekBar");
      this.player_.scrubbing(false);
      if (seekBar.videoWasPlaying) {
        silencePromise(this.player_.play());
      }
    }
  };
  _proto.enable = function enable() {
    this.children().forEach(function(child) {
      return child.enable && child.enable();
    });
    if (this.enabled()) {
      return;
    }
    this.on(["mousedown", "touchstart"], this.handleMouseDownHandler_);
    this.on(this.el_, "mousemove", this.handleMouseMove);
    this.removeClass("disabled");
    this.enabled_ = true;
  };
  _proto.removeListenersAddedOnMousedownAndTouchstart = function removeListenersAddedOnMousedownAndTouchstart() {
    var doc = this.el_.ownerDocument;
    this.off(doc, "mousemove", this.throttledHandleMouseSeek);
    this.off(doc, "touchmove", this.throttledHandleMouseSeek);
    this.off(doc, "mouseup", this.handleMouseUpHandler_);
    this.off(doc, "touchend", this.handleMouseUpHandler_);
  };
  _proto.handleMouseDown = function handleMouseDown(event) {
    var doc = this.el_.ownerDocument;
    var seekBar = this.getChild("seekBar");
    if (seekBar) {
      seekBar.handleMouseDown(event);
    }
    this.on(doc, "mousemove", this.throttledHandleMouseSeek);
    this.on(doc, "touchmove", this.throttledHandleMouseSeek);
    this.on(doc, "mouseup", this.handleMouseUpHandler_);
    this.on(doc, "touchend", this.handleMouseUpHandler_);
  };
  _proto.handleMouseUp = function handleMouseUp(event) {
    var seekBar = this.getChild("seekBar");
    if (seekBar) {
      seekBar.handleMouseUp(event);
    }
    this.removeListenersAddedOnMousedownAndTouchstart();
  };
  return ProgressControl2;
}(Component$1);
ProgressControl.prototype.options_ = {
  children: ["seekBar"]
};
Component$1.registerComponent("ProgressControl", ProgressControl);
var PictureInPictureToggle = /* @__PURE__ */ function(_Button) {
  _inheritsLoose(PictureInPictureToggle2, _Button);
  function PictureInPictureToggle2(player, options) {
    var _this;
    _this = _Button.call(this, player, options) || this;
    _this.on(player, ["enterpictureinpicture", "leavepictureinpicture"], function(e) {
      return _this.handlePictureInPictureChange(e);
    });
    _this.on(player, ["disablepictureinpicturechanged", "loadedmetadata"], function(e) {
      return _this.handlePictureInPictureEnabledChange(e);
    });
    _this.on(player, ["loadedmetadata", "audioonlymodechange", "audiopostermodechange"], function() {
      var isSourceAudio = player.currentType().substring(0, 5) === "audio";
      if (isSourceAudio || player.audioPosterMode() || player.audioOnlyMode()) {
        if (player.isInPictureInPicture()) {
          player.exitPictureInPicture();
        }
        _this.hide();
      } else {
        _this.show();
      }
    });
    _this.disable();
    return _this;
  }
  var _proto = PictureInPictureToggle2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-picture-in-picture-control " + _Button.prototype.buildCSSClass.call(this);
  };
  _proto.handlePictureInPictureEnabledChange = function handlePictureInPictureEnabledChange() {
    if (document_1.pictureInPictureEnabled && this.player_.disablePictureInPicture() === false) {
      this.enable();
    } else {
      this.disable();
    }
  };
  _proto.handlePictureInPictureChange = function handlePictureInPictureChange(event) {
    if (this.player_.isInPictureInPicture()) {
      this.controlText("Exit Picture-in-Picture");
    } else {
      this.controlText("Picture-in-Picture");
    }
    this.handlePictureInPictureEnabledChange();
  };
  _proto.handleClick = function handleClick(event) {
    if (!this.player_.isInPictureInPicture()) {
      this.player_.requestPictureInPicture();
    } else {
      this.player_.exitPictureInPicture();
    }
  };
  return PictureInPictureToggle2;
}(Button);
PictureInPictureToggle.prototype.controlText_ = "Picture-in-Picture";
Component$1.registerComponent("PictureInPictureToggle", PictureInPictureToggle);
var FullscreenToggle = /* @__PURE__ */ function(_Button) {
  _inheritsLoose(FullscreenToggle2, _Button);
  function FullscreenToggle2(player, options) {
    var _this;
    _this = _Button.call(this, player, options) || this;
    _this.on(player, "fullscreenchange", function(e) {
      return _this.handleFullscreenChange(e);
    });
    if (document_1[player.fsApi_.fullscreenEnabled] === false) {
      _this.disable();
    }
    return _this;
  }
  var _proto = FullscreenToggle2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-fullscreen-control " + _Button.prototype.buildCSSClass.call(this);
  };
  _proto.handleFullscreenChange = function handleFullscreenChange(event) {
    if (this.player_.isFullscreen()) {
      this.controlText("Non-Fullscreen");
    } else {
      this.controlText("Fullscreen");
    }
  };
  _proto.handleClick = function handleClick(event) {
    if (!this.player_.isFullscreen()) {
      this.player_.requestFullscreen();
    } else {
      this.player_.exitFullscreen();
    }
  };
  return FullscreenToggle2;
}(Button);
FullscreenToggle.prototype.controlText_ = "Fullscreen";
Component$1.registerComponent("FullscreenToggle", FullscreenToggle);
var checkVolumeSupport = function checkVolumeSupport2(self2, player) {
  if (player.tech_ && !player.tech_.featuresVolumeControl) {
    self2.addClass("vjs-hidden");
  }
  self2.on(player, "loadstart", function() {
    if (!player.tech_.featuresVolumeControl) {
      self2.addClass("vjs-hidden");
    } else {
      self2.removeClass("vjs-hidden");
    }
  });
};
var VolumeLevel = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(VolumeLevel2, _Component);
  function VolumeLevel2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = VolumeLevel2.prototype;
  _proto.createEl = function createEl2() {
    var el = _Component.prototype.createEl.call(this, "div", {
      className: "vjs-volume-level"
    });
    el.appendChild(_Component.prototype.createEl.call(this, "span", {
      className: "vjs-control-text"
    }));
    return el;
  };
  return VolumeLevel2;
}(Component$1);
Component$1.registerComponent("VolumeLevel", VolumeLevel);
var VolumeLevelTooltip = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(VolumeLevelTooltip2, _Component);
  function VolumeLevelTooltip2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.update = throttle(bind(_assertThisInitialized(_this), _this.update), UPDATE_REFRESH_INTERVAL);
    return _this;
  }
  var _proto = VolumeLevelTooltip2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-volume-tooltip"
    }, {
      "aria-hidden": "true"
    });
  };
  _proto.update = function update2(rangeBarRect, rangeBarPoint, vertical, content2) {
    if (!vertical) {
      var tooltipRect = getBoundingClientRect(this.el_);
      var playerRect = getBoundingClientRect(this.player_.el());
      var volumeBarPointPx = rangeBarRect.width * rangeBarPoint;
      if (!playerRect || !tooltipRect) {
        return;
      }
      var spaceLeftOfPoint = rangeBarRect.left - playerRect.left + volumeBarPointPx;
      var spaceRightOfPoint = rangeBarRect.width - volumeBarPointPx + (playerRect.right - rangeBarRect.right);
      var pullTooltipBy = tooltipRect.width / 2;
      if (spaceLeftOfPoint < pullTooltipBy) {
        pullTooltipBy += pullTooltipBy - spaceLeftOfPoint;
      } else if (spaceRightOfPoint < pullTooltipBy) {
        pullTooltipBy = spaceRightOfPoint;
      }
      if (pullTooltipBy < 0) {
        pullTooltipBy = 0;
      } else if (pullTooltipBy > tooltipRect.width) {
        pullTooltipBy = tooltipRect.width;
      }
      this.el_.style.right = "-" + pullTooltipBy + "px";
    }
    this.write(content2 + "%");
  };
  _proto.write = function write(content2) {
    textContent(this.el_, content2);
  };
  _proto.updateVolume = function updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, cb2) {
    var _this2 = this;
    this.requestNamedAnimationFrame("VolumeLevelTooltip#updateVolume", function() {
      _this2.update(rangeBarRect, rangeBarPoint, vertical, volume.toFixed(0));
      if (cb2) {
        cb2();
      }
    });
  };
  return VolumeLevelTooltip2;
}(Component$1);
Component$1.registerComponent("VolumeLevelTooltip", VolumeLevelTooltip);
var MouseVolumeLevelDisplay = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(MouseVolumeLevelDisplay2, _Component);
  function MouseVolumeLevelDisplay2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    _this.update = throttle(bind(_assertThisInitialized(_this), _this.update), UPDATE_REFRESH_INTERVAL);
    return _this;
  }
  var _proto = MouseVolumeLevelDisplay2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-mouse-display"
    });
  };
  _proto.update = function update2(rangeBarRect, rangeBarPoint, vertical) {
    var _this2 = this;
    var volume = 100 * rangeBarPoint;
    this.getChild("volumeLevelTooltip").updateVolume(rangeBarRect, rangeBarPoint, vertical, volume, function() {
      if (vertical) {
        _this2.el_.style.bottom = rangeBarRect.height * rangeBarPoint + "px";
      } else {
        _this2.el_.style.left = rangeBarRect.width * rangeBarPoint + "px";
      }
    });
  };
  return MouseVolumeLevelDisplay2;
}(Component$1);
MouseVolumeLevelDisplay.prototype.options_ = {
  children: ["volumeLevelTooltip"]
};
Component$1.registerComponent("MouseVolumeLevelDisplay", MouseVolumeLevelDisplay);
var VolumeBar = /* @__PURE__ */ function(_Slider) {
  _inheritsLoose(VolumeBar2, _Slider);
  function VolumeBar2(player, options) {
    var _this;
    _this = _Slider.call(this, player, options) || this;
    _this.on("slideractive", function(e) {
      return _this.updateLastVolume_(e);
    });
    _this.on(player, "volumechange", function(e) {
      return _this.updateARIAAttributes(e);
    });
    player.ready(function() {
      return _this.updateARIAAttributes();
    });
    return _this;
  }
  var _proto = VolumeBar2.prototype;
  _proto.createEl = function createEl2() {
    return _Slider.prototype.createEl.call(this, "div", {
      className: "vjs-volume-bar vjs-slider-bar"
    }, {
      "aria-label": this.localize("Volume Level"),
      "aria-live": "polite"
    });
  };
  _proto.handleMouseDown = function handleMouseDown(event) {
    if (!isSingleLeftClick(event)) {
      return;
    }
    _Slider.prototype.handleMouseDown.call(this, event);
  };
  _proto.handleMouseMove = function handleMouseMove(event) {
    var mouseVolumeLevelDisplay = this.getChild("mouseVolumeLevelDisplay");
    if (mouseVolumeLevelDisplay) {
      var volumeBarEl = this.el();
      var volumeBarRect = getBoundingClientRect(volumeBarEl);
      var vertical = this.vertical();
      var volumeBarPoint = getPointerPosition(volumeBarEl, event);
      volumeBarPoint = vertical ? volumeBarPoint.y : volumeBarPoint.x;
      volumeBarPoint = clamp(volumeBarPoint, 0, 1);
      mouseVolumeLevelDisplay.update(volumeBarRect, volumeBarPoint, vertical);
    }
    if (!isSingleLeftClick(event)) {
      return;
    }
    this.checkMuted();
    this.player_.volume(this.calculateDistance(event));
  };
  _proto.checkMuted = function checkMuted() {
    if (this.player_.muted()) {
      this.player_.muted(false);
    }
  };
  _proto.getPercent = function getPercent() {
    if (this.player_.muted()) {
      return 0;
    }
    return this.player_.volume();
  };
  _proto.stepForward = function stepForward() {
    this.checkMuted();
    this.player_.volume(this.player_.volume() + 0.1);
  };
  _proto.stepBack = function stepBack() {
    this.checkMuted();
    this.player_.volume(this.player_.volume() - 0.1);
  };
  _proto.updateARIAAttributes = function updateARIAAttributes(event) {
    var ariaValue = this.player_.muted() ? 0 : this.volumeAsPercentage_();
    this.el_.setAttribute("aria-valuenow", ariaValue);
    this.el_.setAttribute("aria-valuetext", ariaValue + "%");
  };
  _proto.volumeAsPercentage_ = function volumeAsPercentage_() {
    return Math.round(this.player_.volume() * 100);
  };
  _proto.updateLastVolume_ = function updateLastVolume_() {
    var _this2 = this;
    var volumeBeforeDrag = this.player_.volume();
    this.one("sliderinactive", function() {
      if (_this2.player_.volume() === 0) {
        _this2.player_.lastVolume_(volumeBeforeDrag);
      }
    });
  };
  return VolumeBar2;
}(Slider);
VolumeBar.prototype.options_ = {
  children: ["volumeLevel"],
  barName: "volumeLevel"
};
if (!IS_IOS && !IS_ANDROID) {
  VolumeBar.prototype.options_.children.splice(0, 0, "mouseVolumeLevelDisplay");
}
VolumeBar.prototype.playerEvent = "volumechange";
Component$1.registerComponent("VolumeBar", VolumeBar);
var VolumeControl = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(VolumeControl2, _Component);
  function VolumeControl2(player, options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    options.vertical = options.vertical || false;
    if (typeof options.volumeBar === "undefined" || isPlain(options.volumeBar)) {
      options.volumeBar = options.volumeBar || {};
      options.volumeBar.vertical = options.vertical;
    }
    _this = _Component.call(this, player, options) || this;
    checkVolumeSupport(_assertThisInitialized(_this), player);
    _this.throttledHandleMouseMove = throttle(bind(_assertThisInitialized(_this), _this.handleMouseMove), UPDATE_REFRESH_INTERVAL);
    _this.handleMouseUpHandler_ = function(e) {
      return _this.handleMouseUp(e);
    };
    _this.on("mousedown", function(e) {
      return _this.handleMouseDown(e);
    });
    _this.on("touchstart", function(e) {
      return _this.handleMouseDown(e);
    });
    _this.on("mousemove", function(e) {
      return _this.handleMouseMove(e);
    });
    _this.on(_this.volumeBar, ["focus", "slideractive"], function() {
      _this.volumeBar.addClass("vjs-slider-active");
      _this.addClass("vjs-slider-active");
      _this.trigger("slideractive");
    });
    _this.on(_this.volumeBar, ["blur", "sliderinactive"], function() {
      _this.volumeBar.removeClass("vjs-slider-active");
      _this.removeClass("vjs-slider-active");
      _this.trigger("sliderinactive");
    });
    return _this;
  }
  var _proto = VolumeControl2.prototype;
  _proto.createEl = function createEl2() {
    var orientationClass = "vjs-volume-horizontal";
    if (this.options_.vertical) {
      orientationClass = "vjs-volume-vertical";
    }
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-volume-control vjs-control " + orientationClass
    });
  };
  _proto.handleMouseDown = function handleMouseDown(event) {
    var doc = this.el_.ownerDocument;
    this.on(doc, "mousemove", this.throttledHandleMouseMove);
    this.on(doc, "touchmove", this.throttledHandleMouseMove);
    this.on(doc, "mouseup", this.handleMouseUpHandler_);
    this.on(doc, "touchend", this.handleMouseUpHandler_);
  };
  _proto.handleMouseUp = function handleMouseUp(event) {
    var doc = this.el_.ownerDocument;
    this.off(doc, "mousemove", this.throttledHandleMouseMove);
    this.off(doc, "touchmove", this.throttledHandleMouseMove);
    this.off(doc, "mouseup", this.handleMouseUpHandler_);
    this.off(doc, "touchend", this.handleMouseUpHandler_);
  };
  _proto.handleMouseMove = function handleMouseMove(event) {
    this.volumeBar.handleMouseMove(event);
  };
  return VolumeControl2;
}(Component$1);
VolumeControl.prototype.options_ = {
  children: ["volumeBar"]
};
Component$1.registerComponent("VolumeControl", VolumeControl);
var checkMuteSupport = function checkMuteSupport2(self2, player) {
  if (player.tech_ && !player.tech_.featuresMuteControl) {
    self2.addClass("vjs-hidden");
  }
  self2.on(player, "loadstart", function() {
    if (!player.tech_.featuresMuteControl) {
      self2.addClass("vjs-hidden");
    } else {
      self2.removeClass("vjs-hidden");
    }
  });
};
var MuteToggle = /* @__PURE__ */ function(_Button) {
  _inheritsLoose(MuteToggle2, _Button);
  function MuteToggle2(player, options) {
    var _this;
    _this = _Button.call(this, player, options) || this;
    checkMuteSupport(_assertThisInitialized(_this), player);
    _this.on(player, ["loadstart", "volumechange"], function(e) {
      return _this.update(e);
    });
    return _this;
  }
  var _proto = MuteToggle2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-mute-control " + _Button.prototype.buildCSSClass.call(this);
  };
  _proto.handleClick = function handleClick(event) {
    var vol = this.player_.volume();
    var lastVolume = this.player_.lastVolume_();
    if (vol === 0) {
      var volumeToSet = lastVolume < 0.1 ? 0.1 : lastVolume;
      this.player_.volume(volumeToSet);
      this.player_.muted(false);
    } else {
      this.player_.muted(this.player_.muted() ? false : true);
    }
  };
  _proto.update = function update2(event) {
    this.updateIcon_();
    this.updateControlText_();
  };
  _proto.updateIcon_ = function updateIcon_() {
    var vol = this.player_.volume();
    var level = 3;
    if (IS_IOS && this.player_.tech_ && this.player_.tech_.el_) {
      this.player_.muted(this.player_.tech_.el_.muted);
    }
    if (vol === 0 || this.player_.muted()) {
      level = 0;
    } else if (vol < 0.33) {
      level = 1;
    } else if (vol < 0.67) {
      level = 2;
    }
    for (var i = 0; i < 4; i++) {
      removeClass(this.el_, "vjs-vol-" + i);
    }
    addClass(this.el_, "vjs-vol-" + level);
  };
  _proto.updateControlText_ = function updateControlText_() {
    var soundOff = this.player_.muted() || this.player_.volume() === 0;
    var text = soundOff ? "Unmute" : "Mute";
    if (this.controlText() !== text) {
      this.controlText(text);
    }
  };
  return MuteToggle2;
}(Button);
MuteToggle.prototype.controlText_ = "Mute";
Component$1.registerComponent("MuteToggle", MuteToggle);
var VolumePanel = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(VolumePanel2, _Component);
  function VolumePanel2(player, options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    if (typeof options.inline !== "undefined") {
      options.inline = options.inline;
    } else {
      options.inline = true;
    }
    if (typeof options.volumeControl === "undefined" || isPlain(options.volumeControl)) {
      options.volumeControl = options.volumeControl || {};
      options.volumeControl.vertical = !options.inline;
    }
    _this = _Component.call(this, player, options) || this;
    _this.handleKeyPressHandler_ = function(e) {
      return _this.handleKeyPress(e);
    };
    _this.on(player, ["loadstart"], function(e) {
      return _this.volumePanelState_(e);
    });
    _this.on(_this.muteToggle, "keyup", function(e) {
      return _this.handleKeyPress(e);
    });
    _this.on(_this.volumeControl, "keyup", function(e) {
      return _this.handleVolumeControlKeyUp(e);
    });
    _this.on("keydown", function(e) {
      return _this.handleKeyPress(e);
    });
    _this.on("mouseover", function(e) {
      return _this.handleMouseOver(e);
    });
    _this.on("mouseout", function(e) {
      return _this.handleMouseOut(e);
    });
    _this.on(_this.volumeControl, ["slideractive"], _this.sliderActive_);
    _this.on(_this.volumeControl, ["sliderinactive"], _this.sliderInactive_);
    return _this;
  }
  var _proto = VolumePanel2.prototype;
  _proto.sliderActive_ = function sliderActive_() {
    this.addClass("vjs-slider-active");
  };
  _proto.sliderInactive_ = function sliderInactive_() {
    this.removeClass("vjs-slider-active");
  };
  _proto.volumePanelState_ = function volumePanelState_() {
    if (this.volumeControl.hasClass("vjs-hidden") && this.muteToggle.hasClass("vjs-hidden")) {
      this.addClass("vjs-hidden");
    }
    if (this.volumeControl.hasClass("vjs-hidden") && !this.muteToggle.hasClass("vjs-hidden")) {
      this.addClass("vjs-mute-toggle-only");
    }
  };
  _proto.createEl = function createEl2() {
    var orientationClass = "vjs-volume-panel-horizontal";
    if (!this.options_.inline) {
      orientationClass = "vjs-volume-panel-vertical";
    }
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-volume-panel vjs-control " + orientationClass
    });
  };
  _proto.dispose = function dispose() {
    this.handleMouseOut();
    _Component.prototype.dispose.call(this);
  };
  _proto.handleVolumeControlKeyUp = function handleVolumeControlKeyUp(event) {
    if (keycode.isEventKey(event, "Esc")) {
      this.muteToggle.focus();
    }
  };
  _proto.handleMouseOver = function handleMouseOver(event) {
    this.addClass("vjs-hover");
    on(document_1, "keyup", this.handleKeyPressHandler_);
  };
  _proto.handleMouseOut = function handleMouseOut(event) {
    this.removeClass("vjs-hover");
    off(document_1, "keyup", this.handleKeyPressHandler_);
  };
  _proto.handleKeyPress = function handleKeyPress(event) {
    if (keycode.isEventKey(event, "Esc")) {
      this.handleMouseOut();
    }
  };
  return VolumePanel2;
}(Component$1);
VolumePanel.prototype.options_ = {
  children: ["muteToggle", "volumeControl"]
};
Component$1.registerComponent("VolumePanel", VolumePanel);
var Menu = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(Menu2, _Component);
  function Menu2(player, options) {
    var _this;
    _this = _Component.call(this, player, options) || this;
    if (options) {
      _this.menuButton_ = options.menuButton;
    }
    _this.focusedChild_ = -1;
    _this.on("keydown", function(e) {
      return _this.handleKeyDown(e);
    });
    _this.boundHandleBlur_ = function(e) {
      return _this.handleBlur(e);
    };
    _this.boundHandleTapClick_ = function(e) {
      return _this.handleTapClick(e);
    };
    return _this;
  }
  var _proto = Menu2.prototype;
  _proto.addEventListenerForItem = function addEventListenerForItem(component) {
    if (!(component instanceof Component$1)) {
      return;
    }
    this.on(component, "blur", this.boundHandleBlur_);
    this.on(component, ["tap", "click"], this.boundHandleTapClick_);
  };
  _proto.removeEventListenerForItem = function removeEventListenerForItem(component) {
    if (!(component instanceof Component$1)) {
      return;
    }
    this.off(component, "blur", this.boundHandleBlur_);
    this.off(component, ["tap", "click"], this.boundHandleTapClick_);
  };
  _proto.removeChild = function removeChild(component) {
    if (typeof component === "string") {
      component = this.getChild(component);
    }
    this.removeEventListenerForItem(component);
    _Component.prototype.removeChild.call(this, component);
  };
  _proto.addItem = function addItem(component) {
    var childComponent = this.addChild(component);
    if (childComponent) {
      this.addEventListenerForItem(childComponent);
    }
  };
  _proto.createEl = function createEl$1() {
    var contentElType = this.options_.contentElType || "ul";
    this.contentEl_ = createEl(contentElType, {
      className: "vjs-menu-content"
    });
    this.contentEl_.setAttribute("role", "menu");
    var el = _Component.prototype.createEl.call(this, "div", {
      append: this.contentEl_,
      className: "vjs-menu"
    });
    el.appendChild(this.contentEl_);
    on(el, "click", function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
    });
    return el;
  };
  _proto.dispose = function dispose() {
    this.contentEl_ = null;
    this.boundHandleBlur_ = null;
    this.boundHandleTapClick_ = null;
    _Component.prototype.dispose.call(this);
  };
  _proto.handleBlur = function handleBlur2(event) {
    var relatedTarget = event.relatedTarget || document_1.activeElement;
    if (!this.children().some(function(element) {
      return element.el() === relatedTarget;
    })) {
      var btn = this.menuButton_;
      if (btn && btn.buttonPressed_ && relatedTarget !== btn.el().firstChild) {
        btn.unpressButton();
      }
    }
  };
  _proto.handleTapClick = function handleTapClick(event) {
    if (this.menuButton_) {
      this.menuButton_.unpressButton();
      var childComponents = this.children();
      if (!Array.isArray(childComponents)) {
        return;
      }
      var foundComponent = childComponents.filter(function(component) {
        return component.el() === event.target;
      })[0];
      if (!foundComponent) {
        return;
      }
      if (foundComponent.name() !== "CaptionSettingsMenuItem") {
        this.menuButton_.focus();
      }
    }
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (keycode.isEventKey(event, "Left") || keycode.isEventKey(event, "Down")) {
      event.preventDefault();
      event.stopPropagation();
      this.stepForward();
    } else if (keycode.isEventKey(event, "Right") || keycode.isEventKey(event, "Up")) {
      event.preventDefault();
      event.stopPropagation();
      this.stepBack();
    }
  };
  _proto.stepForward = function stepForward() {
    var stepChild = 0;
    if (this.focusedChild_ !== void 0) {
      stepChild = this.focusedChild_ + 1;
    }
    this.focus(stepChild);
  };
  _proto.stepBack = function stepBack() {
    var stepChild = 0;
    if (this.focusedChild_ !== void 0) {
      stepChild = this.focusedChild_ - 1;
    }
    this.focus(stepChild);
  };
  _proto.focus = function focus(item) {
    if (item === void 0) {
      item = 0;
    }
    var children = this.children().slice();
    var haveTitle = children.length && children[0].hasClass("vjs-menu-title");
    if (haveTitle) {
      children.shift();
    }
    if (children.length > 0) {
      if (item < 0) {
        item = 0;
      } else if (item >= children.length) {
        item = children.length - 1;
      }
      this.focusedChild_ = item;
      children[item].el_.focus();
    }
  };
  return Menu2;
}(Component$1);
Component$1.registerComponent("Menu", Menu);
var MenuButton = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(MenuButton2, _Component);
  function MenuButton2(player, options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _Component.call(this, player, options) || this;
    _this.menuButton_ = new Button(player, options);
    _this.menuButton_.controlText(_this.controlText_);
    _this.menuButton_.el_.setAttribute("aria-haspopup", "true");
    var buttonClass = Button.prototype.buildCSSClass();
    _this.menuButton_.el_.className = _this.buildCSSClass() + " " + buttonClass;
    _this.menuButton_.removeClass("vjs-control");
    _this.addChild(_this.menuButton_);
    _this.update();
    _this.enabled_ = true;
    var handleClick = function handleClick2(e) {
      return _this.handleClick(e);
    };
    _this.handleMenuKeyUp_ = function(e) {
      return _this.handleMenuKeyUp(e);
    };
    _this.on(_this.menuButton_, "tap", handleClick);
    _this.on(_this.menuButton_, "click", handleClick);
    _this.on(_this.menuButton_, "keydown", function(e) {
      return _this.handleKeyDown(e);
    });
    _this.on(_this.menuButton_, "mouseenter", function() {
      _this.addClass("vjs-hover");
      _this.menu.show();
      on(document_1, "keyup", _this.handleMenuKeyUp_);
    });
    _this.on("mouseleave", function(e) {
      return _this.handleMouseLeave(e);
    });
    _this.on("keydown", function(e) {
      return _this.handleSubmenuKeyDown(e);
    });
    return _this;
  }
  var _proto = MenuButton2.prototype;
  _proto.update = function update2() {
    var menu = this.createMenu();
    if (this.menu) {
      this.menu.dispose();
      this.removeChild(this.menu);
    }
    this.menu = menu;
    this.addChild(menu);
    this.buttonPressed_ = false;
    this.menuButton_.el_.setAttribute("aria-expanded", "false");
    if (this.items && this.items.length <= this.hideThreshold_) {
      this.hide();
      this.menu.contentEl_.removeAttribute("role");
    } else {
      this.show();
      this.menu.contentEl_.setAttribute("role", "menu");
    }
  };
  _proto.createMenu = function createMenu() {
    var menu = new Menu(this.player_, {
      menuButton: this
    });
    this.hideThreshold_ = 0;
    if (this.options_.title) {
      var titleEl = createEl("li", {
        className: "vjs-menu-title",
        textContent: toTitleCase$1(this.options_.title),
        tabIndex: -1
      });
      var titleComponent = new Component$1(this.player_, {
        el: titleEl
      });
      menu.addItem(titleComponent);
    }
    this.items = this.createItems();
    if (this.items) {
      for (var i = 0; i < this.items.length; i++) {
        menu.addItem(this.items[i]);
      }
    }
    return menu;
  };
  _proto.createItems = function createItems() {
  };
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: this.buildWrapperCSSClass()
    }, {});
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    var menuButtonClass = "vjs-menu-button";
    if (this.options_.inline === true) {
      menuButtonClass += "-inline";
    } else {
      menuButtonClass += "-popup";
    }
    var buttonClass = Button.prototype.buildCSSClass();
    return "vjs-menu-button " + menuButtonClass + " " + buttonClass + " " + _Component.prototype.buildCSSClass.call(this);
  };
  _proto.buildCSSClass = function buildCSSClass() {
    var menuButtonClass = "vjs-menu-button";
    if (this.options_.inline === true) {
      menuButtonClass += "-inline";
    } else {
      menuButtonClass += "-popup";
    }
    return "vjs-menu-button " + menuButtonClass + " " + _Component.prototype.buildCSSClass.call(this);
  };
  _proto.controlText = function controlText(text, el) {
    if (el === void 0) {
      el = this.menuButton_.el();
    }
    return this.menuButton_.controlText(text, el);
  };
  _proto.dispose = function dispose() {
    this.handleMouseLeave();
    _Component.prototype.dispose.call(this);
  };
  _proto.handleClick = function handleClick(event) {
    if (this.buttonPressed_) {
      this.unpressButton();
    } else {
      this.pressButton();
    }
  };
  _proto.handleMouseLeave = function handleMouseLeave(event) {
    this.removeClass("vjs-hover");
    off(document_1, "keyup", this.handleMenuKeyUp_);
  };
  _proto.focus = function focus() {
    this.menuButton_.focus();
  };
  _proto.blur = function blur() {
    this.menuButton_.blur();
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (keycode.isEventKey(event, "Esc") || keycode.isEventKey(event, "Tab")) {
      if (this.buttonPressed_) {
        this.unpressButton();
      }
      if (!keycode.isEventKey(event, "Tab")) {
        event.preventDefault();
        this.menuButton_.focus();
      }
    } else if (keycode.isEventKey(event, "Up") || keycode.isEventKey(event, "Down")) {
      if (!this.buttonPressed_) {
        event.preventDefault();
        this.pressButton();
      }
    }
  };
  _proto.handleMenuKeyUp = function handleMenuKeyUp(event) {
    if (keycode.isEventKey(event, "Esc") || keycode.isEventKey(event, "Tab")) {
      this.removeClass("vjs-hover");
    }
  };
  _proto.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {
    this.handleSubmenuKeyDown(event);
  };
  _proto.handleSubmenuKeyDown = function handleSubmenuKeyDown(event) {
    if (keycode.isEventKey(event, "Esc") || keycode.isEventKey(event, "Tab")) {
      if (this.buttonPressed_) {
        this.unpressButton();
      }
      if (!keycode.isEventKey(event, "Tab")) {
        event.preventDefault();
        this.menuButton_.focus();
      }
    }
  };
  _proto.pressButton = function pressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = true;
      this.menu.show();
      this.menu.lockShowing();
      this.menuButton_.el_.setAttribute("aria-expanded", "true");
      if (IS_IOS && isInFrame()) {
        return;
      }
      this.menu.focus();
    }
  };
  _proto.unpressButton = function unpressButton() {
    if (this.enabled_) {
      this.buttonPressed_ = false;
      this.menu.unlockShowing();
      this.menu.hide();
      this.menuButton_.el_.setAttribute("aria-expanded", "false");
    }
  };
  _proto.disable = function disable() {
    this.unpressButton();
    this.enabled_ = false;
    this.addClass("vjs-disabled");
    this.menuButton_.disable();
  };
  _proto.enable = function enable() {
    this.enabled_ = true;
    this.removeClass("vjs-disabled");
    this.menuButton_.enable();
  };
  return MenuButton2;
}(Component$1);
Component$1.registerComponent("MenuButton", MenuButton);
var TrackButton = /* @__PURE__ */ function(_MenuButton) {
  _inheritsLoose(TrackButton2, _MenuButton);
  function TrackButton2(player, options) {
    var _this;
    var tracks = options.tracks;
    _this = _MenuButton.call(this, player, options) || this;
    if (_this.items.length <= 1) {
      _this.hide();
    }
    if (!tracks) {
      return _assertThisInitialized(_this);
    }
    var updateHandler = bind(_assertThisInitialized(_this), _this.update);
    tracks.addEventListener("removetrack", updateHandler);
    tracks.addEventListener("addtrack", updateHandler);
    tracks.addEventListener("labelchange", updateHandler);
    _this.player_.on("ready", updateHandler);
    _this.player_.on("dispose", function() {
      tracks.removeEventListener("removetrack", updateHandler);
      tracks.removeEventListener("addtrack", updateHandler);
      tracks.removeEventListener("labelchange", updateHandler);
    });
    return _this;
  }
  return TrackButton2;
}(MenuButton);
Component$1.registerComponent("TrackButton", TrackButton);
var MenuKeys = ["Tab", "Esc", "Up", "Down", "Right", "Left"];
var MenuItem = /* @__PURE__ */ function(_ClickableComponent) {
  _inheritsLoose(MenuItem2, _ClickableComponent);
  function MenuItem2(player, options) {
    var _this;
    _this = _ClickableComponent.call(this, player, options) || this;
    _this.selectable = options.selectable;
    _this.isSelected_ = options.selected || false;
    _this.multiSelectable = options.multiSelectable;
    _this.selected(_this.isSelected_);
    if (_this.selectable) {
      if (_this.multiSelectable) {
        _this.el_.setAttribute("role", "menuitemcheckbox");
      } else {
        _this.el_.setAttribute("role", "menuitemradio");
      }
    } else {
      _this.el_.setAttribute("role", "menuitem");
    }
    return _this;
  }
  var _proto = MenuItem2.prototype;
  _proto.createEl = function createEl$1(type2, props, attrs) {
    this.nonIconControl = true;
    var el = _ClickableComponent.prototype.createEl.call(this, "li", assign({
      className: "vjs-menu-item",
      tabIndex: -1
    }, props), attrs);
    el.replaceChild(createEl("span", {
      className: "vjs-menu-item-text",
      textContent: this.localize(this.options_.label)
    }), el.querySelector(".vjs-icon-placeholder"));
    return el;
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    if (!MenuKeys.some(function(key) {
      return keycode.isEventKey(event, key);
    })) {
      _ClickableComponent.prototype.handleKeyDown.call(this, event);
    }
  };
  _proto.handleClick = function handleClick(event) {
    this.selected(true);
  };
  _proto.selected = function selected(_selected) {
    if (this.selectable) {
      if (_selected) {
        this.addClass("vjs-selected");
        this.el_.setAttribute("aria-checked", "true");
        this.controlText(", selected");
        this.isSelected_ = true;
      } else {
        this.removeClass("vjs-selected");
        this.el_.setAttribute("aria-checked", "false");
        this.controlText("");
        this.isSelected_ = false;
      }
    }
  };
  return MenuItem2;
}(ClickableComponent);
Component$1.registerComponent("MenuItem", MenuItem);
var TextTrackMenuItem = /* @__PURE__ */ function(_MenuItem) {
  _inheritsLoose(TextTrackMenuItem2, _MenuItem);
  function TextTrackMenuItem2(player, options) {
    var _this;
    var track = options.track;
    var tracks = player.textTracks();
    options.label = track.label || track.language || "Unknown";
    options.selected = track.mode === "showing";
    _this = _MenuItem.call(this, player, options) || this;
    _this.track = track;
    _this.kinds = (options.kinds || [options.kind || _this.track.kind]).filter(Boolean);
    var changeHandler = function changeHandler2() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this.handleTracksChange.apply(_assertThisInitialized(_this), args);
    };
    var selectedLanguageChangeHandler = function selectedLanguageChangeHandler2() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this.handleSelectedLanguageChange.apply(_assertThisInitialized(_this), args);
    };
    player.on(["loadstart", "texttrackchange"], changeHandler);
    tracks.addEventListener("change", changeHandler);
    tracks.addEventListener("selectedlanguagechange", selectedLanguageChangeHandler);
    _this.on("dispose", function() {
      player.off(["loadstart", "texttrackchange"], changeHandler);
      tracks.removeEventListener("change", changeHandler);
      tracks.removeEventListener("selectedlanguagechange", selectedLanguageChangeHandler);
    });
    if (tracks.onchange === void 0) {
      var event;
      _this.on(["tap", "click"], function() {
        if (typeof window_1.Event !== "object") {
          try {
            event = new window_1.Event("change");
          } catch (err) {
          }
        }
        if (!event) {
          event = document_1.createEvent("Event");
          event.initEvent("change", true, true);
        }
        tracks.dispatchEvent(event);
      });
    }
    _this.handleTracksChange();
    return _this;
  }
  var _proto = TextTrackMenuItem2.prototype;
  _proto.handleClick = function handleClick(event) {
    var referenceTrack = this.track;
    var tracks = this.player_.textTracks();
    _MenuItem.prototype.handleClick.call(this, event);
    if (!tracks) {
      return;
    }
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      if (this.kinds.indexOf(track.kind) === -1) {
        continue;
      }
      if (track === referenceTrack) {
        if (track.mode !== "showing") {
          track.mode = "showing";
        }
      } else if (track.mode !== "disabled") {
        track.mode = "disabled";
      }
    }
  };
  _proto.handleTracksChange = function handleTracksChange(event) {
    var shouldBeSelected = this.track.mode === "showing";
    if (shouldBeSelected !== this.isSelected_) {
      this.selected(shouldBeSelected);
    }
  };
  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
    if (this.track.mode === "showing") {
      var selectedLanguage = this.player_.cache_.selectedLanguage;
      if (selectedLanguage && selectedLanguage.enabled && selectedLanguage.language === this.track.language && selectedLanguage.kind !== this.track.kind) {
        return;
      }
      this.player_.cache_.selectedLanguage = {
        enabled: true,
        language: this.track.language,
        kind: this.track.kind
      };
    }
  };
  _proto.dispose = function dispose() {
    this.track = null;
    _MenuItem.prototype.dispose.call(this);
  };
  return TextTrackMenuItem2;
}(MenuItem);
Component$1.registerComponent("TextTrackMenuItem", TextTrackMenuItem);
var OffTextTrackMenuItem = /* @__PURE__ */ function(_TextTrackMenuItem) {
  _inheritsLoose(OffTextTrackMenuItem2, _TextTrackMenuItem);
  function OffTextTrackMenuItem2(player, options) {
    options.track = {
      player,
      kind: options.kind,
      kinds: options.kinds,
      "default": false,
      mode: "disabled"
    };
    if (!options.kinds) {
      options.kinds = [options.kind];
    }
    if (options.label) {
      options.track.label = options.label;
    } else {
      options.track.label = options.kinds.join(" and ") + " off";
    }
    options.selectable = true;
    options.multiSelectable = false;
    return _TextTrackMenuItem.call(this, player, options) || this;
  }
  var _proto = OffTextTrackMenuItem2.prototype;
  _proto.handleTracksChange = function handleTracksChange(event) {
    var tracks = this.player().textTracks();
    var shouldBeSelected = true;
    for (var i = 0, l = tracks.length; i < l; i++) {
      var track = tracks[i];
      if (this.options_.kinds.indexOf(track.kind) > -1 && track.mode === "showing") {
        shouldBeSelected = false;
        break;
      }
    }
    if (shouldBeSelected !== this.isSelected_) {
      this.selected(shouldBeSelected);
    }
  };
  _proto.handleSelectedLanguageChange = function handleSelectedLanguageChange(event) {
    var tracks = this.player().textTracks();
    var allHidden = true;
    for (var i = 0, l = tracks.length; i < l; i++) {
      var track = tracks[i];
      if (["captions", "descriptions", "subtitles"].indexOf(track.kind) > -1 && track.mode === "showing") {
        allHidden = false;
        break;
      }
    }
    if (allHidden) {
      this.player_.cache_.selectedLanguage = {
        enabled: false
      };
    }
  };
  return OffTextTrackMenuItem2;
}(TextTrackMenuItem);
Component$1.registerComponent("OffTextTrackMenuItem", OffTextTrackMenuItem);
var TextTrackButton = /* @__PURE__ */ function(_TrackButton) {
  _inheritsLoose(TextTrackButton2, _TrackButton);
  function TextTrackButton2(player, options) {
    if (options === void 0) {
      options = {};
    }
    options.tracks = player.textTracks();
    return _TrackButton.call(this, player, options) || this;
  }
  var _proto = TextTrackButton2.prototype;
  _proto.createItems = function createItems(items, TrackMenuItem) {
    if (items === void 0) {
      items = [];
    }
    if (TrackMenuItem === void 0) {
      TrackMenuItem = TextTrackMenuItem;
    }
    var label;
    if (this.label_) {
      label = this.label_ + " off";
    }
    items.push(new OffTextTrackMenuItem(this.player_, {
      kinds: this.kinds_,
      kind: this.kind_,
      label
    }));
    this.hideThreshold_ += 1;
    var tracks = this.player_.textTracks();
    if (!Array.isArray(this.kinds_)) {
      this.kinds_ = [this.kind_];
    }
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      if (this.kinds_.indexOf(track.kind) > -1) {
        var item = new TrackMenuItem(this.player_, {
          track,
          kinds: this.kinds_,
          kind: this.kind_,
          selectable: true,
          multiSelectable: false
        });
        item.addClass("vjs-" + track.kind + "-menu-item");
        items.push(item);
      }
    }
    return items;
  };
  return TextTrackButton2;
}(TrackButton);
Component$1.registerComponent("TextTrackButton", TextTrackButton);
var ChaptersTrackMenuItem = /* @__PURE__ */ function(_MenuItem) {
  _inheritsLoose(ChaptersTrackMenuItem2, _MenuItem);
  function ChaptersTrackMenuItem2(player, options) {
    var _this;
    var track = options.track;
    var cue = options.cue;
    var currentTime = player.currentTime();
    options.selectable = true;
    options.multiSelectable = false;
    options.label = cue.text;
    options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
    _this = _MenuItem.call(this, player, options) || this;
    _this.track = track;
    _this.cue = cue;
    return _this;
  }
  var _proto = ChaptersTrackMenuItem2.prototype;
  _proto.handleClick = function handleClick(event) {
    _MenuItem.prototype.handleClick.call(this);
    this.player_.currentTime(this.cue.startTime);
  };
  return ChaptersTrackMenuItem2;
}(MenuItem);
Component$1.registerComponent("ChaptersTrackMenuItem", ChaptersTrackMenuItem);
var ChaptersButton = /* @__PURE__ */ function(_TextTrackButton) {
  _inheritsLoose(ChaptersButton2, _TextTrackButton);
  function ChaptersButton2(player, options, ready) {
    var _this;
    _this = _TextTrackButton.call(this, player, options, ready) || this;
    _this.selectCurrentItem_ = function() {
      _this.items.forEach(function(item) {
        item.selected(_this.track_.activeCues[0] === item.cue);
      });
    };
    return _this;
  }
  var _proto = ChaptersButton2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-chapters-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-chapters-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };
  _proto.update = function update2(event) {
    if (event && event.track && event.track.kind !== "chapters") {
      return;
    }
    var track = this.findChaptersTrack();
    if (track !== this.track_) {
      this.setTrack(track);
      _TextTrackButton.prototype.update.call(this);
    } else if (!this.items || track && track.cues && track.cues.length !== this.items.length) {
      _TextTrackButton.prototype.update.call(this);
    }
  };
  _proto.setTrack = function setTrack(track) {
    if (this.track_ === track) {
      return;
    }
    if (!this.updateHandler_) {
      this.updateHandler_ = this.update.bind(this);
    }
    if (this.track_) {
      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
      if (remoteTextTrackEl) {
        remoteTextTrackEl.removeEventListener("load", this.updateHandler_);
      }
      this.track_.removeEventListener("cuechange", this.selectCurrentItem_);
      this.track_ = null;
    }
    this.track_ = track;
    if (this.track_) {
      this.track_.mode = "hidden";
      var _remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
      if (_remoteTextTrackEl) {
        _remoteTextTrackEl.addEventListener("load", this.updateHandler_);
      }
      this.track_.addEventListener("cuechange", this.selectCurrentItem_);
    }
  };
  _proto.findChaptersTrack = function findChaptersTrack() {
    var tracks = this.player_.textTracks() || [];
    for (var i = tracks.length - 1; i >= 0; i--) {
      var track = tracks[i];
      if (track.kind === this.kind_) {
        return track;
      }
    }
  };
  _proto.getMenuCaption = function getMenuCaption() {
    if (this.track_ && this.track_.label) {
      return this.track_.label;
    }
    return this.localize(toTitleCase$1(this.kind_));
  };
  _proto.createMenu = function createMenu() {
    this.options_.title = this.getMenuCaption();
    return _TextTrackButton.prototype.createMenu.call(this);
  };
  _proto.createItems = function createItems() {
    var items = [];
    if (!this.track_) {
      return items;
    }
    var cues = this.track_.cues;
    if (!cues) {
      return items;
    }
    for (var i = 0, l = cues.length; i < l; i++) {
      var cue = cues[i];
      var mi2 = new ChaptersTrackMenuItem(this.player_, {
        track: this.track_,
        cue
      });
      items.push(mi2);
    }
    return items;
  };
  return ChaptersButton2;
}(TextTrackButton);
ChaptersButton.prototype.kind_ = "chapters";
ChaptersButton.prototype.controlText_ = "Chapters";
Component$1.registerComponent("ChaptersButton", ChaptersButton);
var DescriptionsButton = /* @__PURE__ */ function(_TextTrackButton) {
  _inheritsLoose(DescriptionsButton2, _TextTrackButton);
  function DescriptionsButton2(player, options, ready) {
    var _this;
    _this = _TextTrackButton.call(this, player, options, ready) || this;
    var tracks = player.textTracks();
    var changeHandler = bind(_assertThisInitialized(_this), _this.handleTracksChange);
    tracks.addEventListener("change", changeHandler);
    _this.on("dispose", function() {
      tracks.removeEventListener("change", changeHandler);
    });
    return _this;
  }
  var _proto = DescriptionsButton2.prototype;
  _proto.handleTracksChange = function handleTracksChange(event) {
    var tracks = this.player().textTracks();
    var disabled2 = false;
    for (var i = 0, l = tracks.length; i < l; i++) {
      var track = tracks[i];
      if (track.kind !== this.kind_ && track.mode === "showing") {
        disabled2 = true;
        break;
      }
    }
    if (disabled2) {
      this.disable();
    } else {
      this.enable();
    }
  };
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-descriptions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };
  return DescriptionsButton2;
}(TextTrackButton);
DescriptionsButton.prototype.kind_ = "descriptions";
DescriptionsButton.prototype.controlText_ = "Descriptions";
Component$1.registerComponent("DescriptionsButton", DescriptionsButton);
var SubtitlesButton = /* @__PURE__ */ function(_TextTrackButton) {
  _inheritsLoose(SubtitlesButton2, _TextTrackButton);
  function SubtitlesButton2(player, options, ready) {
    return _TextTrackButton.call(this, player, options, ready) || this;
  }
  var _proto = SubtitlesButton2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-subtitles-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };
  return SubtitlesButton2;
}(TextTrackButton);
SubtitlesButton.prototype.kind_ = "subtitles";
SubtitlesButton.prototype.controlText_ = "Subtitles";
Component$1.registerComponent("SubtitlesButton", SubtitlesButton);
var CaptionSettingsMenuItem = /* @__PURE__ */ function(_TextTrackMenuItem) {
  _inheritsLoose(CaptionSettingsMenuItem2, _TextTrackMenuItem);
  function CaptionSettingsMenuItem2(player, options) {
    var _this;
    options.track = {
      player,
      kind: options.kind,
      label: options.kind + " settings",
      selectable: false,
      "default": false,
      mode: "disabled"
    };
    options.selectable = false;
    options.name = "CaptionSettingsMenuItem";
    _this = _TextTrackMenuItem.call(this, player, options) || this;
    _this.addClass("vjs-texttrack-settings");
    _this.controlText(", opens " + options.kind + " settings dialog");
    return _this;
  }
  var _proto = CaptionSettingsMenuItem2.prototype;
  _proto.handleClick = function handleClick(event) {
    this.player().getChild("textTrackSettings").open();
  };
  return CaptionSettingsMenuItem2;
}(TextTrackMenuItem);
Component$1.registerComponent("CaptionSettingsMenuItem", CaptionSettingsMenuItem);
var CaptionsButton = /* @__PURE__ */ function(_TextTrackButton) {
  _inheritsLoose(CaptionsButton2, _TextTrackButton);
  function CaptionsButton2(player, options, ready) {
    return _TextTrackButton.call(this, player, options, ready) || this;
  }
  var _proto = CaptionsButton2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-captions-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-captions-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };
  _proto.createItems = function createItems() {
    var items = [];
    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings")) {
      items.push(new CaptionSettingsMenuItem(this.player_, {
        kind: this.kind_
      }));
      this.hideThreshold_ += 1;
    }
    return _TextTrackButton.prototype.createItems.call(this, items);
  };
  return CaptionsButton2;
}(TextTrackButton);
CaptionsButton.prototype.kind_ = "captions";
CaptionsButton.prototype.controlText_ = "Captions";
Component$1.registerComponent("CaptionsButton", CaptionsButton);
var SubsCapsMenuItem = /* @__PURE__ */ function(_TextTrackMenuItem) {
  _inheritsLoose(SubsCapsMenuItem2, _TextTrackMenuItem);
  function SubsCapsMenuItem2() {
    return _TextTrackMenuItem.apply(this, arguments) || this;
  }
  var _proto = SubsCapsMenuItem2.prototype;
  _proto.createEl = function createEl$1(type2, props, attrs) {
    var el = _TextTrackMenuItem.prototype.createEl.call(this, type2, props, attrs);
    var parentSpan = el.querySelector(".vjs-menu-item-text");
    if (this.options_.track.kind === "captions") {
      parentSpan.appendChild(createEl("span", {
        className: "vjs-icon-placeholder"
      }, {
        "aria-hidden": true
      }));
      parentSpan.appendChild(createEl("span", {
        className: "vjs-control-text",
        textContent: " " + this.localize("Captions")
      }));
    }
    return el;
  };
  return SubsCapsMenuItem2;
}(TextTrackMenuItem);
Component$1.registerComponent("SubsCapsMenuItem", SubsCapsMenuItem);
var SubsCapsButton = /* @__PURE__ */ function(_TextTrackButton) {
  _inheritsLoose(SubsCapsButton2, _TextTrackButton);
  function SubsCapsButton2(player, options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _TextTrackButton.call(this, player, options) || this;
    _this.label_ = "subtitles";
    if (["en", "en-us", "en-ca", "fr-ca"].indexOf(_this.player_.language_) > -1) {
      _this.label_ = "captions";
    }
    _this.menuButton_.controlText(toTitleCase$1(_this.label_));
    return _this;
  }
  var _proto = SubsCapsButton2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildCSSClass.call(this);
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-subs-caps-button " + _TextTrackButton.prototype.buildWrapperCSSClass.call(this);
  };
  _proto.createItems = function createItems() {
    var items = [];
    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks) && this.player().getChild("textTrackSettings")) {
      items.push(new CaptionSettingsMenuItem(this.player_, {
        kind: this.label_
      }));
      this.hideThreshold_ += 1;
    }
    items = _TextTrackButton.prototype.createItems.call(this, items, SubsCapsMenuItem);
    return items;
  };
  return SubsCapsButton2;
}(TextTrackButton);
SubsCapsButton.prototype.kinds_ = ["captions", "subtitles"];
SubsCapsButton.prototype.controlText_ = "Subtitles";
Component$1.registerComponent("SubsCapsButton", SubsCapsButton);
var AudioTrackMenuItem = /* @__PURE__ */ function(_MenuItem) {
  _inheritsLoose(AudioTrackMenuItem2, _MenuItem);
  function AudioTrackMenuItem2(player, options) {
    var _this;
    var track = options.track;
    var tracks = player.audioTracks();
    options.label = track.label || track.language || "Unknown";
    options.selected = track.enabled;
    _this = _MenuItem.call(this, player, options) || this;
    _this.track = track;
    _this.addClass("vjs-" + track.kind + "-menu-item");
    var changeHandler = function changeHandler2() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this.handleTracksChange.apply(_assertThisInitialized(_this), args);
    };
    tracks.addEventListener("change", changeHandler);
    _this.on("dispose", function() {
      tracks.removeEventListener("change", changeHandler);
    });
    return _this;
  }
  var _proto = AudioTrackMenuItem2.prototype;
  _proto.createEl = function createEl$1(type2, props, attrs) {
    var el = _MenuItem.prototype.createEl.call(this, type2, props, attrs);
    var parentSpan = el.querySelector(".vjs-menu-item-text");
    if (this.options_.track.kind === "main-desc") {
      parentSpan.appendChild(createEl("span", {
        className: "vjs-icon-placeholder"
      }, {
        "aria-hidden": true
      }));
      parentSpan.appendChild(createEl("span", {
        className: "vjs-control-text",
        textContent: " " + this.localize("Descriptions")
      }));
    }
    return el;
  };
  _proto.handleClick = function handleClick(event) {
    _MenuItem.prototype.handleClick.call(this, event);
    this.track.enabled = true;
    if (this.player_.tech_.featuresNativeAudioTracks) {
      var tracks = this.player_.audioTracks();
      for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];
        if (track === this.track) {
          continue;
        }
        track.enabled = track === this.track;
      }
    }
  };
  _proto.handleTracksChange = function handleTracksChange(event) {
    this.selected(this.track.enabled);
  };
  return AudioTrackMenuItem2;
}(MenuItem);
Component$1.registerComponent("AudioTrackMenuItem", AudioTrackMenuItem);
var AudioTrackButton = /* @__PURE__ */ function(_TrackButton) {
  _inheritsLoose(AudioTrackButton2, _TrackButton);
  function AudioTrackButton2(player, options) {
    if (options === void 0) {
      options = {};
    }
    options.tracks = player.audioTracks();
    return _TrackButton.call(this, player, options) || this;
  }
  var _proto = AudioTrackButton2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-audio-button " + _TrackButton.prototype.buildCSSClass.call(this);
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-audio-button " + _TrackButton.prototype.buildWrapperCSSClass.call(this);
  };
  _proto.createItems = function createItems(items) {
    if (items === void 0) {
      items = [];
    }
    this.hideThreshold_ = 1;
    var tracks = this.player_.audioTracks();
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      items.push(new AudioTrackMenuItem(this.player_, {
        track,
        selectable: true,
        multiSelectable: false
      }));
    }
    return items;
  };
  return AudioTrackButton2;
}(TrackButton);
AudioTrackButton.prototype.controlText_ = "Audio Track";
Component$1.registerComponent("AudioTrackButton", AudioTrackButton);
var PlaybackRateMenuItem = /* @__PURE__ */ function(_MenuItem) {
  _inheritsLoose(PlaybackRateMenuItem2, _MenuItem);
  function PlaybackRateMenuItem2(player, options) {
    var _this;
    var label = options.rate;
    var rate = parseFloat(label, 10);
    options.label = label;
    options.selected = rate === player.playbackRate();
    options.selectable = true;
    options.multiSelectable = false;
    _this = _MenuItem.call(this, player, options) || this;
    _this.label = label;
    _this.rate = rate;
    _this.on(player, "ratechange", function(e) {
      return _this.update(e);
    });
    return _this;
  }
  var _proto = PlaybackRateMenuItem2.prototype;
  _proto.handleClick = function handleClick(event) {
    _MenuItem.prototype.handleClick.call(this);
    this.player().playbackRate(this.rate);
  };
  _proto.update = function update2(event) {
    this.selected(this.player().playbackRate() === this.rate);
  };
  return PlaybackRateMenuItem2;
}(MenuItem);
PlaybackRateMenuItem.prototype.contentElType = "button";
Component$1.registerComponent("PlaybackRateMenuItem", PlaybackRateMenuItem);
var PlaybackRateMenuButton = /* @__PURE__ */ function(_MenuButton) {
  _inheritsLoose(PlaybackRateMenuButton2, _MenuButton);
  function PlaybackRateMenuButton2(player, options) {
    var _this;
    _this = _MenuButton.call(this, player, options) || this;
    _this.menuButton_.el_.setAttribute("aria-describedby", _this.labelElId_);
    _this.updateVisibility();
    _this.updateLabel();
    _this.on(player, "loadstart", function(e) {
      return _this.updateVisibility(e);
    });
    _this.on(player, "ratechange", function(e) {
      return _this.updateLabel(e);
    });
    _this.on(player, "playbackrateschange", function(e) {
      return _this.handlePlaybackRateschange(e);
    });
    return _this;
  }
  var _proto = PlaybackRateMenuButton2.prototype;
  _proto.createEl = function createEl$1() {
    var el = _MenuButton.prototype.createEl.call(this);
    this.labelElId_ = "vjs-playback-rate-value-label-" + this.id_;
    this.labelEl_ = createEl("div", {
      className: "vjs-playback-rate-value",
      id: this.labelElId_,
      textContent: "1x"
    });
    el.appendChild(this.labelEl_);
    return el;
  };
  _proto.dispose = function dispose() {
    this.labelEl_ = null;
    _MenuButton.prototype.dispose.call(this);
  };
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-playback-rate " + _MenuButton.prototype.buildCSSClass.call(this);
  };
  _proto.buildWrapperCSSClass = function buildWrapperCSSClass() {
    return "vjs-playback-rate " + _MenuButton.prototype.buildWrapperCSSClass.call(this);
  };
  _proto.createItems = function createItems() {
    var rates = this.playbackRates();
    var items = [];
    for (var i = rates.length - 1; i >= 0; i--) {
      items.push(new PlaybackRateMenuItem(this.player(), {
        rate: rates[i] + "x"
      }));
    }
    return items;
  };
  _proto.updateARIAAttributes = function updateARIAAttributes() {
    this.el().setAttribute("aria-valuenow", this.player().playbackRate());
  };
  _proto.handleClick = function handleClick(event) {
    var currentRate = this.player().playbackRate();
    var rates = this.playbackRates();
    var currentIndex = rates.indexOf(currentRate);
    var newIndex = (currentIndex + 1) % rates.length;
    this.player().playbackRate(rates[newIndex]);
  };
  _proto.handlePlaybackRateschange = function handlePlaybackRateschange(event) {
    this.update();
  };
  _proto.playbackRates = function playbackRates() {
    var player = this.player();
    return player.playbackRates && player.playbackRates() || [];
  };
  _proto.playbackRateSupported = function playbackRateSupported() {
    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
  };
  _proto.updateVisibility = function updateVisibility(event) {
    if (this.playbackRateSupported()) {
      this.removeClass("vjs-hidden");
    } else {
      this.addClass("vjs-hidden");
    }
  };
  _proto.updateLabel = function updateLabel(event) {
    if (this.playbackRateSupported()) {
      this.labelEl_.textContent = this.player().playbackRate() + "x";
    }
  };
  return PlaybackRateMenuButton2;
}(MenuButton);
PlaybackRateMenuButton.prototype.controlText_ = "Playback Rate";
Component$1.registerComponent("PlaybackRateMenuButton", PlaybackRateMenuButton);
var Spacer = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(Spacer2, _Component);
  function Spacer2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Spacer2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-spacer " + _Component.prototype.buildCSSClass.call(this);
  };
  _proto.createEl = function createEl2(tag, props, attributes) {
    if (tag === void 0) {
      tag = "div";
    }
    if (props === void 0) {
      props = {};
    }
    if (attributes === void 0) {
      attributes = {};
    }
    if (!props.className) {
      props.className = this.buildCSSClass();
    }
    return _Component.prototype.createEl.call(this, tag, props, attributes);
  };
  return Spacer2;
}(Component$1);
Component$1.registerComponent("Spacer", Spacer);
var CustomControlSpacer = /* @__PURE__ */ function(_Spacer) {
  _inheritsLoose(CustomControlSpacer2, _Spacer);
  function CustomControlSpacer2() {
    return _Spacer.apply(this, arguments) || this;
  }
  var _proto = CustomControlSpacer2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-custom-control-spacer " + _Spacer.prototype.buildCSSClass.call(this);
  };
  _proto.createEl = function createEl2() {
    return _Spacer.prototype.createEl.call(this, "div", {
      className: this.buildCSSClass(),
      textContent: "\xA0"
    });
  };
  return CustomControlSpacer2;
}(Spacer);
Component$1.registerComponent("CustomControlSpacer", CustomControlSpacer);
var ControlBar = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(ControlBar2, _Component);
  function ControlBar2() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = ControlBar2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "div", {
      className: "vjs-control-bar",
      dir: "ltr"
    });
  };
  return ControlBar2;
}(Component$1);
ControlBar.prototype.options_ = {
  children: ["playToggle", "volumePanel", "currentTimeDisplay", "timeDivider", "durationDisplay", "progressControl", "liveDisplay", "seekToLive", "remainingTimeDisplay", "customControlSpacer", "playbackRateMenuButton", "chaptersButton", "descriptionsButton", "subsCapsButton", "audioTrackButton", "fullscreenToggle"]
};
if ("exitPictureInPicture" in document_1) {
  ControlBar.prototype.options_.children.splice(ControlBar.prototype.options_.children.length - 1, 0, "pictureInPictureToggle");
}
Component$1.registerComponent("ControlBar", ControlBar);
var ErrorDisplay = /* @__PURE__ */ function(_ModalDialog) {
  _inheritsLoose(ErrorDisplay2, _ModalDialog);
  function ErrorDisplay2(player, options) {
    var _this;
    _this = _ModalDialog.call(this, player, options) || this;
    _this.on(player, "error", function(e) {
      return _this.open(e);
    });
    return _this;
  }
  var _proto = ErrorDisplay2.prototype;
  _proto.buildCSSClass = function buildCSSClass() {
    return "vjs-error-display " + _ModalDialog.prototype.buildCSSClass.call(this);
  };
  _proto.content = function content2() {
    var error2 = this.player().error();
    return error2 ? this.localize(error2.message) : "";
  };
  return ErrorDisplay2;
}(ModalDialog);
ErrorDisplay.prototype.options_ = _extends$2({}, ModalDialog.prototype.options_, {
  pauseOnOpen: false,
  fillAlways: true,
  temporary: false,
  uncloseable: true
});
Component$1.registerComponent("ErrorDisplay", ErrorDisplay);
var LOCAL_STORAGE_KEY$1 = "vjs-text-track-settings";
var COLOR_BLACK = ["#000", "Black"];
var COLOR_BLUE = ["#00F", "Blue"];
var COLOR_CYAN = ["#0FF", "Cyan"];
var COLOR_GREEN = ["#0F0", "Green"];
var COLOR_MAGENTA = ["#F0F", "Magenta"];
var COLOR_RED = ["#F00", "Red"];
var COLOR_WHITE = ["#FFF", "White"];
var COLOR_YELLOW = ["#FF0", "Yellow"];
var OPACITY_OPAQUE = ["1", "Opaque"];
var OPACITY_SEMI = ["0.5", "Semi-Transparent"];
var OPACITY_TRANS = ["0", "Transparent"];
var selectConfigs = {
  backgroundColor: {
    selector: ".vjs-bg-color > select",
    id: "captions-background-color-%s",
    label: "Color",
    options: [COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
  },
  backgroundOpacity: {
    selector: ".vjs-bg-opacity > select",
    id: "captions-background-opacity-%s",
    label: "Transparency",
    options: [OPACITY_OPAQUE, OPACITY_SEMI, OPACITY_TRANS]
  },
  color: {
    selector: ".vjs-fg-color > select",
    id: "captions-foreground-color-%s",
    label: "Color",
    options: [COLOR_WHITE, COLOR_BLACK, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
  },
  edgeStyle: {
    selector: ".vjs-edge-style > select",
    id: "%s",
    label: "Text Edge Style",
    options: [["none", "None"], ["raised", "Raised"], ["depressed", "Depressed"], ["uniform", "Uniform"], ["dropshadow", "Dropshadow"]]
  },
  fontFamily: {
    selector: ".vjs-font-family > select",
    id: "captions-font-family-%s",
    label: "Font Family",
    options: [["proportionalSansSerif", "Proportional Sans-Serif"], ["monospaceSansSerif", "Monospace Sans-Serif"], ["proportionalSerif", "Proportional Serif"], ["monospaceSerif", "Monospace Serif"], ["casual", "Casual"], ["script", "Script"], ["small-caps", "Small Caps"]]
  },
  fontPercent: {
    selector: ".vjs-font-percent > select",
    id: "captions-font-size-%s",
    label: "Font Size",
    options: [["0.50", "50%"], ["0.75", "75%"], ["1.00", "100%"], ["1.25", "125%"], ["1.50", "150%"], ["1.75", "175%"], ["2.00", "200%"], ["3.00", "300%"], ["4.00", "400%"]],
    "default": 2,
    parser: function parser(v) {
      return v === "1.00" ? null : Number(v);
    }
  },
  textOpacity: {
    selector: ".vjs-text-opacity > select",
    id: "captions-foreground-opacity-%s",
    label: "Transparency",
    options: [OPACITY_OPAQUE, OPACITY_SEMI]
  },
  windowColor: {
    selector: ".vjs-window-color > select",
    id: "captions-window-color-%s",
    label: "Color"
  },
  windowOpacity: {
    selector: ".vjs-window-opacity > select",
    id: "captions-window-opacity-%s",
    label: "Transparency",
    options: [OPACITY_TRANS, OPACITY_SEMI, OPACITY_OPAQUE]
  }
};
selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;
function parseOptionValue(value, parser2) {
  if (parser2) {
    value = parser2(value);
  }
  if (value && value !== "none") {
    return value;
  }
}
function getSelectedOptionValue(el, parser2) {
  var value = el.options[el.options.selectedIndex].value;
  return parseOptionValue(value, parser2);
}
function setSelectedOption(el, value, parser2) {
  if (!value) {
    return;
  }
  for (var i = 0; i < el.options.length; i++) {
    if (parseOptionValue(el.options[i].value, parser2) === value) {
      el.selectedIndex = i;
      break;
    }
  }
}
var TextTrackSettings = /* @__PURE__ */ function(_ModalDialog) {
  _inheritsLoose(TextTrackSettings2, _ModalDialog);
  function TextTrackSettings2(player, options) {
    var _this;
    options.temporary = false;
    _this = _ModalDialog.call(this, player, options) || this;
    _this.updateDisplay = _this.updateDisplay.bind(_assertThisInitialized(_this));
    _this.fill();
    _this.hasBeenOpened_ = _this.hasBeenFilled_ = true;
    _this.endDialog = createEl("p", {
      className: "vjs-control-text",
      textContent: _this.localize("End of dialog window.")
    });
    _this.el().appendChild(_this.endDialog);
    _this.setDefaults();
    if (options.persistTextTrackSettings === void 0) {
      _this.options_.persistTextTrackSettings = _this.options_.playerOptions.persistTextTrackSettings;
    }
    _this.on(_this.$(".vjs-done-button"), "click", function() {
      _this.saveSettings();
      _this.close();
    });
    _this.on(_this.$(".vjs-default-button"), "click", function() {
      _this.setDefaults();
      _this.updateDisplay();
    });
    each(selectConfigs, function(config2) {
      _this.on(_this.$(config2.selector), "change", _this.updateDisplay);
    });
    if (_this.options_.persistTextTrackSettings) {
      _this.restoreSettings();
    }
    return _this;
  }
  var _proto = TextTrackSettings2.prototype;
  _proto.dispose = function dispose() {
    this.endDialog = null;
    _ModalDialog.prototype.dispose.call(this);
  };
  _proto.createElSelect_ = function createElSelect_(key, legendId, type2) {
    var _this2 = this;
    if (legendId === void 0) {
      legendId = "";
    }
    if (type2 === void 0) {
      type2 = "label";
    }
    var config2 = selectConfigs[key];
    var id2 = config2.id.replace("%s", this.id_);
    var selectLabelledbyIds = [legendId, id2].join(" ").trim();
    return ["<" + type2 + ' id="' + id2 + '" class="' + (type2 === "label" ? "vjs-label" : "") + '">', this.localize(config2.label), "</" + type2 + ">", '<select aria-labelledby="' + selectLabelledbyIds + '">'].concat(config2.options.map(function(o) {
      var optionId = id2 + "-" + o[1].replace(/\W+/g, "");
      return ['<option id="' + optionId + '" value="' + o[0] + '" ', 'aria-labelledby="' + selectLabelledbyIds + " " + optionId + '">', _this2.localize(o[1]), "</option>"].join("");
    })).concat("</select>").join("");
  };
  _proto.createElFgColor_ = function createElFgColor_() {
    var legendId = "captions-text-legend-" + this.id_;
    return ['<fieldset class="vjs-fg-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize("Text"), "</legend>", this.createElSelect_("color", legendId), '<span class="vjs-text-opacity vjs-opacity">', this.createElSelect_("textOpacity", legendId), "</span>", "</fieldset>"].join("");
  };
  _proto.createElBgColor_ = function createElBgColor_() {
    var legendId = "captions-background-" + this.id_;
    return ['<fieldset class="vjs-bg-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize("Background"), "</legend>", this.createElSelect_("backgroundColor", legendId), '<span class="vjs-bg-opacity vjs-opacity">', this.createElSelect_("backgroundOpacity", legendId), "</span>", "</fieldset>"].join("");
  };
  _proto.createElWinColor_ = function createElWinColor_() {
    var legendId = "captions-window-" + this.id_;
    return ['<fieldset class="vjs-window-color vjs-track-setting">', '<legend id="' + legendId + '">', this.localize("Window"), "</legend>", this.createElSelect_("windowColor", legendId), '<span class="vjs-window-opacity vjs-opacity">', this.createElSelect_("windowOpacity", legendId), "</span>", "</fieldset>"].join("");
  };
  _proto.createElColors_ = function createElColors_() {
    return createEl("div", {
      className: "vjs-track-settings-colors",
      innerHTML: [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()].join("")
    });
  };
  _proto.createElFont_ = function createElFont_() {
    return createEl("div", {
      className: "vjs-track-settings-font",
      innerHTML: ['<fieldset class="vjs-font-percent vjs-track-setting">', this.createElSelect_("fontPercent", "", "legend"), "</fieldset>", '<fieldset class="vjs-edge-style vjs-track-setting">', this.createElSelect_("edgeStyle", "", "legend"), "</fieldset>", '<fieldset class="vjs-font-family vjs-track-setting">', this.createElSelect_("fontFamily", "", "legend"), "</fieldset>"].join("")
    });
  };
  _proto.createElControls_ = function createElControls_() {
    var defaultsDescription = this.localize("restore all settings to the default values");
    return createEl("div", {
      className: "vjs-track-settings-controls",
      innerHTML: ['<button type="button" class="vjs-default-button" title="' + defaultsDescription + '">', this.localize("Reset"), '<span class="vjs-control-text"> ' + defaultsDescription + "</span>", "</button>", '<button type="button" class="vjs-done-button">' + this.localize("Done") + "</button>"].join("")
    });
  };
  _proto.content = function content2() {
    return [this.createElColors_(), this.createElFont_(), this.createElControls_()];
  };
  _proto.label = function label() {
    return this.localize("Caption Settings Dialog");
  };
  _proto.description = function description2() {
    return this.localize("Beginning of dialog window. Escape will cancel and close the window.");
  };
  _proto.buildCSSClass = function buildCSSClass() {
    return _ModalDialog.prototype.buildCSSClass.call(this) + " vjs-text-track-settings";
  };
  _proto.getValues = function getValues() {
    var _this3 = this;
    return reduce$1(selectConfigs, function(accum, config2, key) {
      var value = getSelectedOptionValue(_this3.$(config2.selector), config2.parser);
      if (value !== void 0) {
        accum[key] = value;
      }
      return accum;
    }, {});
  };
  _proto.setValues = function setValues(values3) {
    var _this4 = this;
    each(selectConfigs, function(config2, key) {
      setSelectedOption(_this4.$(config2.selector), values3[key], config2.parser);
    });
  };
  _proto.setDefaults = function setDefaults() {
    var _this5 = this;
    each(selectConfigs, function(config2) {
      var index = config2.hasOwnProperty("default") ? config2["default"] : 0;
      _this5.$(config2.selector).selectedIndex = index;
    });
  };
  _proto.restoreSettings = function restoreSettings() {
    var values3;
    try {
      values3 = JSON.parse(window_1.localStorage.getItem(LOCAL_STORAGE_KEY$1));
    } catch (err) {
      log$1.warn(err);
    }
    if (values3) {
      this.setValues(values3);
    }
  };
  _proto.saveSettings = function saveSettings() {
    if (!this.options_.persistTextTrackSettings) {
      return;
    }
    var values3 = this.getValues();
    try {
      if (Object.keys(values3).length) {
        window_1.localStorage.setItem(LOCAL_STORAGE_KEY$1, JSON.stringify(values3));
      } else {
        window_1.localStorage.removeItem(LOCAL_STORAGE_KEY$1);
      }
    } catch (err) {
      log$1.warn(err);
    }
  };
  _proto.updateDisplay = function updateDisplay() {
    var ttDisplay = this.player_.getChild("textTrackDisplay");
    if (ttDisplay) {
      ttDisplay.updateDisplay();
    }
  };
  _proto.conditionalBlur_ = function conditionalBlur_() {
    this.previouslyActiveEl_ = null;
    var cb2 = this.player_.controlBar;
    var subsCapsBtn = cb2 && cb2.subsCapsButton;
    var ccBtn = cb2 && cb2.captionsButton;
    if (subsCapsBtn) {
      subsCapsBtn.focus();
    } else if (ccBtn) {
      ccBtn.focus();
    }
  };
  return TextTrackSettings2;
}(ModalDialog);
Component$1.registerComponent("TextTrackSettings", TextTrackSettings);
var ResizeManager = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(ResizeManager2, _Component);
  function ResizeManager2(player, options) {
    var _this;
    var RESIZE_OBSERVER_AVAILABLE = options.ResizeObserver || window_1.ResizeObserver;
    if (options.ResizeObserver === null) {
      RESIZE_OBSERVER_AVAILABLE = false;
    }
    var options_ = mergeOptions$3({
      createEl: !RESIZE_OBSERVER_AVAILABLE,
      reportTouchActivity: false
    }, options);
    _this = _Component.call(this, player, options_) || this;
    _this.ResizeObserver = options.ResizeObserver || window_1.ResizeObserver;
    _this.loadListener_ = null;
    _this.resizeObserver_ = null;
    _this.debouncedHandler_ = debounce(function() {
      _this.resizeHandler();
    }, 100, false, _assertThisInitialized(_this));
    if (RESIZE_OBSERVER_AVAILABLE) {
      _this.resizeObserver_ = new _this.ResizeObserver(_this.debouncedHandler_);
      _this.resizeObserver_.observe(player.el());
    } else {
      _this.loadListener_ = function() {
        if (!_this.el_ || !_this.el_.contentWindow) {
          return;
        }
        var debouncedHandler_ = _this.debouncedHandler_;
        var unloadListener_ = _this.unloadListener_ = function() {
          off(this, "resize", debouncedHandler_);
          off(this, "unload", unloadListener_);
          unloadListener_ = null;
        };
        on(_this.el_.contentWindow, "unload", unloadListener_);
        on(_this.el_.contentWindow, "resize", debouncedHandler_);
      };
      _this.one("load", _this.loadListener_);
    }
    return _this;
  }
  var _proto = ResizeManager2.prototype;
  _proto.createEl = function createEl2() {
    return _Component.prototype.createEl.call(this, "iframe", {
      className: "vjs-resize-manager",
      tabIndex: -1,
      title: this.localize("No content")
    }, {
      "aria-hidden": "true"
    });
  };
  _proto.resizeHandler = function resizeHandler() {
    if (!this.player_ || !this.player_.trigger) {
      return;
    }
    this.player_.trigger("playerresize");
  };
  _proto.dispose = function dispose() {
    if (this.debouncedHandler_) {
      this.debouncedHandler_.cancel();
    }
    if (this.resizeObserver_) {
      if (this.player_.el()) {
        this.resizeObserver_.unobserve(this.player_.el());
      }
      this.resizeObserver_.disconnect();
    }
    if (this.loadListener_) {
      this.off("load", this.loadListener_);
    }
    if (this.el_ && this.el_.contentWindow && this.unloadListener_) {
      this.unloadListener_.call(this.el_.contentWindow);
    }
    this.ResizeObserver = null;
    this.resizeObserver = null;
    this.debouncedHandler_ = null;
    this.loadListener_ = null;
    _Component.prototype.dispose.call(this);
  };
  return ResizeManager2;
}(Component$1);
Component$1.registerComponent("ResizeManager", ResizeManager);
var defaults = {
  trackingThreshold: 20,
  liveTolerance: 15
};
var LiveTracker = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(LiveTracker2, _Component);
  function LiveTracker2(player, options) {
    var _this;
    var options_ = mergeOptions$3(defaults, options, {
      createEl: false
    });
    _this = _Component.call(this, player, options_) || this;
    _this.handleVisibilityChange_ = function(e) {
      return _this.handleVisibilityChange(e);
    };
    _this.trackLiveHandler_ = function() {
      return _this.trackLive_();
    };
    _this.handlePlay_ = function(e) {
      return _this.handlePlay(e);
    };
    _this.handleFirstTimeupdate_ = function(e) {
      return _this.handleFirstTimeupdate(e);
    };
    _this.handleSeeked_ = function(e) {
      return _this.handleSeeked(e);
    };
    _this.seekToLiveEdge_ = function(e) {
      return _this.seekToLiveEdge(e);
    };
    _this.reset_();
    _this.on(_this.player_, "durationchange", function(e) {
      return _this.handleDurationchange(e);
    });
    _this.on(_this.player_, "canplay", function() {
      return _this.toggleTracking();
    });
    if (IE_VERSION && "hidden" in document_1 && "visibilityState" in document_1) {
      _this.on(document_1, "visibilitychange", _this.handleVisibilityChange_);
    }
    return _this;
  }
  var _proto = LiveTracker2.prototype;
  _proto.handleVisibilityChange = function handleVisibilityChange() {
    if (this.player_.duration() !== Infinity) {
      return;
    }
    if (document_1.hidden) {
      this.stopTracking();
    } else {
      this.startTracking();
    }
  };
  _proto.trackLive_ = function trackLive_() {
    var seekable3 = this.player_.seekable();
    if (!seekable3 || !seekable3.length) {
      return;
    }
    var newTime = Number(window_1.performance.now().toFixed(4));
    var deltaTime = this.lastTime_ === -1 ? 0 : (newTime - this.lastTime_) / 1e3;
    this.lastTime_ = newTime;
    this.pastSeekEnd_ = this.pastSeekEnd() + deltaTime;
    var liveCurrentTime = this.liveCurrentTime();
    var currentTime = this.player_.currentTime();
    var isBehind = this.player_.paused() || this.seekedBehindLive_ || Math.abs(liveCurrentTime - currentTime) > this.options_.liveTolerance;
    if (!this.timeupdateSeen_ || liveCurrentTime === Infinity) {
      isBehind = false;
    }
    if (isBehind !== this.behindLiveEdge_) {
      this.behindLiveEdge_ = isBehind;
      this.trigger("liveedgechange");
    }
  };
  _proto.handleDurationchange = function handleDurationchange() {
    this.toggleTracking();
  };
  _proto.toggleTracking = function toggleTracking() {
    if (this.player_.duration() === Infinity && this.liveWindow() >= this.options_.trackingThreshold) {
      if (this.player_.options_.liveui) {
        this.player_.addClass("vjs-liveui");
      }
      this.startTracking();
    } else {
      this.player_.removeClass("vjs-liveui");
      this.stopTracking();
    }
  };
  _proto.startTracking = function startTracking() {
    if (this.isTracking()) {
      return;
    }
    if (!this.timeupdateSeen_) {
      this.timeupdateSeen_ = this.player_.hasStarted();
    }
    this.trackingInterval_ = this.setInterval(this.trackLiveHandler_, UPDATE_REFRESH_INTERVAL);
    this.trackLive_();
    this.on(this.player_, ["play", "pause"], this.trackLiveHandler_);
    if (!this.timeupdateSeen_) {
      this.one(this.player_, "play", this.handlePlay_);
      this.one(this.player_, "timeupdate", this.handleFirstTimeupdate_);
    } else {
      this.on(this.player_, "seeked", this.handleSeeked_);
    }
  };
  _proto.handleFirstTimeupdate = function handleFirstTimeupdate() {
    this.timeupdateSeen_ = true;
    this.on(this.player_, "seeked", this.handleSeeked_);
  };
  _proto.handleSeeked = function handleSeeked() {
    var timeDiff = Math.abs(this.liveCurrentTime() - this.player_.currentTime());
    this.seekedBehindLive_ = this.nextSeekedFromUser_ && timeDiff > 2;
    this.nextSeekedFromUser_ = false;
    this.trackLive_();
  };
  _proto.handlePlay = function handlePlay() {
    this.one(this.player_, "timeupdate", this.seekToLiveEdge_);
  };
  _proto.reset_ = function reset_() {
    this.lastTime_ = -1;
    this.pastSeekEnd_ = 0;
    this.lastSeekEnd_ = -1;
    this.behindLiveEdge_ = true;
    this.timeupdateSeen_ = false;
    this.seekedBehindLive_ = false;
    this.nextSeekedFromUser_ = false;
    this.clearInterval(this.trackingInterval_);
    this.trackingInterval_ = null;
    this.off(this.player_, ["play", "pause"], this.trackLiveHandler_);
    this.off(this.player_, "seeked", this.handleSeeked_);
    this.off(this.player_, "play", this.handlePlay_);
    this.off(this.player_, "timeupdate", this.handleFirstTimeupdate_);
    this.off(this.player_, "timeupdate", this.seekToLiveEdge_);
  };
  _proto.nextSeekedFromUser = function nextSeekedFromUser() {
    this.nextSeekedFromUser_ = true;
  };
  _proto.stopTracking = function stopTracking() {
    if (!this.isTracking()) {
      return;
    }
    this.reset_();
    this.trigger("liveedgechange");
  };
  _proto.seekableEnd = function seekableEnd() {
    var seekable3 = this.player_.seekable();
    var seekableEnds = [];
    var i = seekable3 ? seekable3.length : 0;
    while (i--) {
      seekableEnds.push(seekable3.end(i));
    }
    return seekableEnds.length ? seekableEnds.sort()[seekableEnds.length - 1] : Infinity;
  };
  _proto.seekableStart = function seekableStart() {
    var seekable3 = this.player_.seekable();
    var seekableStarts = [];
    var i = seekable3 ? seekable3.length : 0;
    while (i--) {
      seekableStarts.push(seekable3.start(i));
    }
    return seekableStarts.length ? seekableStarts.sort()[0] : 0;
  };
  _proto.liveWindow = function liveWindow() {
    var liveCurrentTime = this.liveCurrentTime();
    if (liveCurrentTime === Infinity) {
      return 0;
    }
    return liveCurrentTime - this.seekableStart();
  };
  _proto.isLive = function isLive() {
    return this.isTracking();
  };
  _proto.atLiveEdge = function atLiveEdge() {
    return !this.behindLiveEdge();
  };
  _proto.liveCurrentTime = function liveCurrentTime() {
    return this.pastSeekEnd() + this.seekableEnd();
  };
  _proto.pastSeekEnd = function pastSeekEnd() {
    var seekableEnd = this.seekableEnd();
    if (this.lastSeekEnd_ !== -1 && seekableEnd !== this.lastSeekEnd_) {
      this.pastSeekEnd_ = 0;
    }
    this.lastSeekEnd_ = seekableEnd;
    return this.pastSeekEnd_;
  };
  _proto.behindLiveEdge = function behindLiveEdge() {
    return this.behindLiveEdge_;
  };
  _proto.isTracking = function isTracking() {
    return typeof this.trackingInterval_ === "number";
  };
  _proto.seekToLiveEdge = function seekToLiveEdge() {
    this.seekedBehindLive_ = false;
    if (this.atLiveEdge()) {
      return;
    }
    this.nextSeekedFromUser_ = false;
    this.player_.currentTime(this.liveCurrentTime());
  };
  _proto.dispose = function dispose() {
    this.off(document_1, "visibilitychange", this.handleVisibilityChange_);
    this.stopTracking();
    _Component.prototype.dispose.call(this);
  };
  return LiveTracker2;
}(Component$1);
Component$1.registerComponent("LiveTracker", LiveTracker);
var sourcesetLoad = function sourcesetLoad2(tech) {
  var el = tech.el();
  if (el.hasAttribute("src")) {
    tech.triggerSourceset(el.src);
    return true;
  }
  var sources = tech.$$("source");
  var srcUrls = [];
  var src = "";
  if (!sources.length) {
    return false;
  }
  for (var i = 0; i < sources.length; i++) {
    var url = sources[i].src;
    if (url && srcUrls.indexOf(url) === -1) {
      srcUrls.push(url);
    }
  }
  if (!srcUrls.length) {
    return false;
  }
  if (srcUrls.length === 1) {
    src = srcUrls[0];
  }
  tech.triggerSourceset(src);
  return true;
};
var innerHTMLDescriptorPolyfill = Object.defineProperty({}, "innerHTML", {
  get: function get2() {
    return this.cloneNode(true).innerHTML;
  },
  set: function set2(v) {
    var dummy = document_1.createElement(this.nodeName.toLowerCase());
    dummy.innerHTML = v;
    var docFrag = document_1.createDocumentFragment();
    while (dummy.childNodes.length) {
      docFrag.appendChild(dummy.childNodes[0]);
    }
    this.innerText = "";
    window_1.Element.prototype.appendChild.call(this, docFrag);
    return this.innerHTML;
  }
});
var getDescriptor = function getDescriptor2(priority, prop) {
  var descriptor = {};
  for (var i = 0; i < priority.length; i++) {
    descriptor = Object.getOwnPropertyDescriptor(priority[i], prop);
    if (descriptor && descriptor.set && descriptor.get) {
      break;
    }
  }
  descriptor.enumerable = true;
  descriptor.configurable = true;
  return descriptor;
};
var getInnerHTMLDescriptor = function getInnerHTMLDescriptor2(tech) {
  return getDescriptor([tech.el(), window_1.HTMLMediaElement.prototype, window_1.Element.prototype, innerHTMLDescriptorPolyfill], "innerHTML");
};
var firstSourceWatch = function firstSourceWatch2(tech) {
  var el = tech.el();
  if (el.resetSourceWatch_) {
    return;
  }
  var old = {};
  var innerDescriptor = getInnerHTMLDescriptor(tech);
  var appendWrapper = function appendWrapper2(appendFn) {
    return function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var retval = appendFn.apply(el, args);
      sourcesetLoad(tech);
      return retval;
    };
  };
  ["append", "appendChild", "insertAdjacentHTML"].forEach(function(k) {
    if (!el[k]) {
      return;
    }
    old[k] = el[k];
    el[k] = appendWrapper(old[k]);
  });
  Object.defineProperty(el, "innerHTML", mergeOptions$3(innerDescriptor, {
    set: appendWrapper(innerDescriptor.set)
  }));
  el.resetSourceWatch_ = function() {
    el.resetSourceWatch_ = null;
    Object.keys(old).forEach(function(k) {
      el[k] = old[k];
    });
    Object.defineProperty(el, "innerHTML", innerDescriptor);
  };
  tech.one("sourceset", el.resetSourceWatch_);
};
var srcDescriptorPolyfill = Object.defineProperty({}, "src", {
  get: function get3() {
    if (this.hasAttribute("src")) {
      return getAbsoluteURL(window_1.Element.prototype.getAttribute.call(this, "src"));
    }
    return "";
  },
  set: function set3(v) {
    window_1.Element.prototype.setAttribute.call(this, "src", v);
    return v;
  }
});
var getSrcDescriptor = function getSrcDescriptor2(tech) {
  return getDescriptor([tech.el(), window_1.HTMLMediaElement.prototype, srcDescriptorPolyfill], "src");
};
var setupSourceset = function setupSourceset2(tech) {
  if (!tech.featuresSourceset) {
    return;
  }
  var el = tech.el();
  if (el.resetSourceset_) {
    return;
  }
  var srcDescriptor = getSrcDescriptor(tech);
  var oldSetAttribute = el.setAttribute;
  var oldLoad = el.load;
  Object.defineProperty(el, "src", mergeOptions$3(srcDescriptor, {
    set: function set4(v) {
      var retval = srcDescriptor.set.call(el, v);
      tech.triggerSourceset(el.src);
      return retval;
    }
  }));
  el.setAttribute = function(n2, v) {
    var retval = oldSetAttribute.call(el, n2, v);
    if (/src/i.test(n2)) {
      tech.triggerSourceset(el.src);
    }
    return retval;
  };
  el.load = function() {
    var retval = oldLoad.call(el);
    if (!sourcesetLoad(tech)) {
      tech.triggerSourceset("");
      firstSourceWatch(tech);
    }
    return retval;
  };
  if (el.currentSrc) {
    tech.triggerSourceset(el.currentSrc);
  } else if (!sourcesetLoad(tech)) {
    firstSourceWatch(tech);
  }
  el.resetSourceset_ = function() {
    el.resetSourceset_ = null;
    el.load = oldLoad;
    el.setAttribute = oldSetAttribute;
    Object.defineProperty(el, "src", srcDescriptor);
    if (el.resetSourceWatch_) {
      el.resetSourceWatch_();
    }
  };
};
var defineLazyProperty = function defineLazyProperty2(obj, key, getValue, setter) {
  if (setter === void 0) {
    setter = true;
  }
  var set4 = function set5(value) {
    return Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      writable: true
    });
  };
  var options = {
    configurable: true,
    enumerable: true,
    get: function get7() {
      var value = getValue();
      set4(value);
      return value;
    }
  };
  if (setter) {
    options.set = set4;
  }
  return Object.defineProperty(obj, key, options);
};
var Html5 = /* @__PURE__ */ function(_Tech) {
  _inheritsLoose(Html52, _Tech);
  function Html52(options, ready) {
    var _this;
    _this = _Tech.call(this, options, ready) || this;
    var source = options.source;
    var crossoriginTracks = false;
    _this.featuresVideoFrameCallback = _this.featuresVideoFrameCallback && _this.el_.tagName === "VIDEO";
    if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
      _this.setSource(source);
    } else {
      _this.handleLateInit_(_this.el_);
    }
    if (options.enableSourceset) {
      _this.setupSourcesetHandling_();
    }
    _this.isScrubbing_ = false;
    if (_this.el_.hasChildNodes()) {
      var nodes = _this.el_.childNodes;
      var nodesLength = nodes.length;
      var removeNodes = [];
      while (nodesLength--) {
        var node = nodes[nodesLength];
        var nodeName = node.nodeName.toLowerCase();
        if (nodeName === "track") {
          if (!_this.featuresNativeTextTracks) {
            removeNodes.push(node);
          } else {
            _this.remoteTextTrackEls().addTrackElement_(node);
            _this.remoteTextTracks().addTrack(node.track);
            _this.textTracks().addTrack(node.track);
            if (!crossoriginTracks && !_this.el_.hasAttribute("crossorigin") && isCrossOrigin(node.src)) {
              crossoriginTracks = true;
            }
          }
        }
      }
      for (var i = 0; i < removeNodes.length; i++) {
        _this.el_.removeChild(removeNodes[i]);
      }
    }
    _this.proxyNativeTracks_();
    if (_this.featuresNativeTextTracks && crossoriginTracks) {
      log$1.warn("Text Tracks are being loaded from another origin but the crossorigin attribute isn't used.\nThis may prevent text tracks from loading.");
    }
    _this.restoreMetadataTracksInIOSNativePlayer_();
    if ((TOUCH_ENABLED || IS_IPHONE || IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
      _this.setControls(true);
    }
    _this.proxyWebkitFullscreen_();
    _this.triggerReady();
    return _this;
  }
  var _proto = Html52.prototype;
  _proto.dispose = function dispose() {
    if (this.el_ && this.el_.resetSourceset_) {
      this.el_.resetSourceset_();
    }
    Html52.disposeMediaElement(this.el_);
    this.options_ = null;
    _Tech.prototype.dispose.call(this);
  };
  _proto.setupSourcesetHandling_ = function setupSourcesetHandling_() {
    setupSourceset(this);
  };
  _proto.restoreMetadataTracksInIOSNativePlayer_ = function restoreMetadataTracksInIOSNativePlayer_() {
    var textTracks = this.textTracks();
    var metadataTracksPreFullscreenState;
    var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot2() {
      metadataTracksPreFullscreenState = [];
      for (var i = 0; i < textTracks.length; i++) {
        var track = textTracks[i];
        if (track.kind === "metadata") {
          metadataTracksPreFullscreenState.push({
            track,
            storedMode: track.mode
          });
        }
      }
    };
    takeMetadataTrackSnapshot();
    textTracks.addEventListener("change", takeMetadataTrackSnapshot);
    this.on("dispose", function() {
      return textTracks.removeEventListener("change", takeMetadataTrackSnapshot);
    });
    var restoreTrackMode = function restoreTrackMode2() {
      for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
        var storedTrack = metadataTracksPreFullscreenState[i];
        if (storedTrack.track.mode === "disabled" && storedTrack.track.mode !== storedTrack.storedMode) {
          storedTrack.track.mode = storedTrack.storedMode;
        }
      }
      textTracks.removeEventListener("change", restoreTrackMode2);
    };
    this.on("webkitbeginfullscreen", function() {
      textTracks.removeEventListener("change", takeMetadataTrackSnapshot);
      textTracks.removeEventListener("change", restoreTrackMode);
      textTracks.addEventListener("change", restoreTrackMode);
    });
    this.on("webkitendfullscreen", function() {
      textTracks.removeEventListener("change", takeMetadataTrackSnapshot);
      textTracks.addEventListener("change", takeMetadataTrackSnapshot);
      textTracks.removeEventListener("change", restoreTrackMode);
    });
  };
  _proto.overrideNative_ = function overrideNative_(type2, override) {
    var _this2 = this;
    if (override !== this["featuresNative" + type2 + "Tracks"]) {
      return;
    }
    var lowerCaseType = type2.toLowerCase();
    if (this[lowerCaseType + "TracksListeners_"]) {
      Object.keys(this[lowerCaseType + "TracksListeners_"]).forEach(function(eventName) {
        var elTracks = _this2.el()[lowerCaseType + "Tracks"];
        elTracks.removeEventListener(eventName, _this2[lowerCaseType + "TracksListeners_"][eventName]);
      });
    }
    this["featuresNative" + type2 + "Tracks"] = !override;
    this[lowerCaseType + "TracksListeners_"] = null;
    this.proxyNativeTracksForType_(lowerCaseType);
  };
  _proto.overrideNativeAudioTracks = function overrideNativeAudioTracks(override) {
    this.overrideNative_("Audio", override);
  };
  _proto.overrideNativeVideoTracks = function overrideNativeVideoTracks(override) {
    this.overrideNative_("Video", override);
  };
  _proto.proxyNativeTracksForType_ = function proxyNativeTracksForType_(name) {
    var _this3 = this;
    var props = NORMAL[name];
    var elTracks = this.el()[props.getterName];
    var techTracks = this[props.getterName]();
    if (!this["featuresNative" + props.capitalName + "Tracks"] || !elTracks || !elTracks.addEventListener) {
      return;
    }
    var listeners = {
      change: function change(e) {
        var event = {
          type: "change",
          target: techTracks,
          currentTarget: techTracks,
          srcElement: techTracks
        };
        techTracks.trigger(event);
        if (name === "text") {
          _this3[REMOTE.remoteText.getterName]().trigger(event);
        }
      },
      addtrack: function addtrack(e) {
        techTracks.addTrack(e.track);
      },
      removetrack: function removetrack(e) {
        techTracks.removeTrack(e.track);
      }
    };
    var removeOldTracks = function removeOldTracks2() {
      var removeTracks = [];
      for (var i = 0; i < techTracks.length; i++) {
        var found = false;
        for (var j = 0; j < elTracks.length; j++) {
          if (elTracks[j] === techTracks[i]) {
            found = true;
            break;
          }
        }
        if (!found) {
          removeTracks.push(techTracks[i]);
        }
      }
      while (removeTracks.length) {
        techTracks.removeTrack(removeTracks.shift());
      }
    };
    this[props.getterName + "Listeners_"] = listeners;
    Object.keys(listeners).forEach(function(eventName) {
      var listener3 = listeners[eventName];
      elTracks.addEventListener(eventName, listener3);
      _this3.on("dispose", function(e) {
        return elTracks.removeEventListener(eventName, listener3);
      });
    });
    this.on("loadstart", removeOldTracks);
    this.on("dispose", function(e) {
      return _this3.off("loadstart", removeOldTracks);
    });
  };
  _proto.proxyNativeTracks_ = function proxyNativeTracks_() {
    var _this4 = this;
    NORMAL.names.forEach(function(name) {
      _this4.proxyNativeTracksForType_(name);
    });
  };
  _proto.createEl = function createEl2() {
    var el = this.options_.tag;
    if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
      if (el) {
        var clone = el.cloneNode(true);
        if (el.parentNode) {
          el.parentNode.insertBefore(clone, el);
        }
        Html52.disposeMediaElement(el);
        el = clone;
      } else {
        el = document_1.createElement("video");
        var tagAttributes = this.options_.tag && getAttributes(this.options_.tag);
        var attributes = mergeOptions$3({}, tagAttributes);
        if (!TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
          delete attributes.controls;
        }
        setAttributes(el, assign(attributes, {
          id: this.options_.techId,
          "class": "vjs-tech"
        }));
      }
      el.playerId = this.options_.playerId;
    }
    if (typeof this.options_.preload !== "undefined") {
      setAttribute(el, "preload", this.options_.preload);
    }
    if (this.options_.disablePictureInPicture !== void 0) {
      el.disablePictureInPicture = this.options_.disablePictureInPicture;
    }
    var settingsAttrs = ["loop", "muted", "playsinline", "autoplay"];
    for (var i = 0; i < settingsAttrs.length; i++) {
      var attr = settingsAttrs[i];
      var value = this.options_[attr];
      if (typeof value !== "undefined") {
        if (value) {
          setAttribute(el, attr, attr);
        } else {
          removeAttribute(el, attr);
        }
        el[attr] = value;
      }
    }
    return el;
  };
  _proto.handleLateInit_ = function handleLateInit_(el) {
    if (el.networkState === 0 || el.networkState === 3) {
      return;
    }
    if (el.readyState === 0) {
      var loadstartFired = false;
      var setLoadstartFired = function setLoadstartFired2() {
        loadstartFired = true;
      };
      this.on("loadstart", setLoadstartFired);
      var triggerLoadstart = function triggerLoadstart2() {
        if (!loadstartFired) {
          this.trigger("loadstart");
        }
      };
      this.on("loadedmetadata", triggerLoadstart);
      this.ready(function() {
        this.off("loadstart", setLoadstartFired);
        this.off("loadedmetadata", triggerLoadstart);
        if (!loadstartFired) {
          this.trigger("loadstart");
        }
      });
      return;
    }
    var eventsToTrigger = ["loadstart"];
    eventsToTrigger.push("loadedmetadata");
    if (el.readyState >= 2) {
      eventsToTrigger.push("loadeddata");
    }
    if (el.readyState >= 3) {
      eventsToTrigger.push("canplay");
    }
    if (el.readyState >= 4) {
      eventsToTrigger.push("canplaythrough");
    }
    this.ready(function() {
      eventsToTrigger.forEach(function(type2) {
        this.trigger(type2);
      }, this);
    });
  };
  _proto.setScrubbing = function setScrubbing(isScrubbing) {
    this.isScrubbing_ = isScrubbing;
  };
  _proto.scrubbing = function scrubbing() {
    return this.isScrubbing_;
  };
  _proto.setCurrentTime = function setCurrentTime(seconds) {
    try {
      if (this.isScrubbing_ && this.el_.fastSeek && IS_ANY_SAFARI) {
        this.el_.fastSeek(seconds);
      } else {
        this.el_.currentTime = seconds;
      }
    } catch (e) {
      log$1(e, "Video is not ready. (Video.js)");
    }
  };
  _proto.duration = function duration5() {
    var _this5 = this;
    if (this.el_.duration === Infinity && IS_ANDROID && IS_CHROME && this.el_.currentTime === 0) {
      var checkProgress = function checkProgress2() {
        if (_this5.el_.currentTime > 0) {
          if (_this5.el_.duration === Infinity) {
            _this5.trigger("durationchange");
          }
          _this5.off("timeupdate", checkProgress2);
        }
      };
      this.on("timeupdate", checkProgress);
      return NaN;
    }
    return this.el_.duration || NaN;
  };
  _proto.width = function width2() {
    return this.el_.offsetWidth;
  };
  _proto.height = function height2() {
    return this.el_.offsetHeight;
  };
  _proto.proxyWebkitFullscreen_ = function proxyWebkitFullscreen_() {
    var _this6 = this;
    if (!("webkitDisplayingFullscreen" in this.el_)) {
      return;
    }
    var endFn = function endFn2() {
      this.trigger("fullscreenchange", {
        isFullscreen: false
      });
      if (this.el_.controls && !this.options_.nativeControlsForTouch && this.controls()) {
        this.el_.controls = false;
      }
    };
    var beginFn = function beginFn2() {
      if ("webkitPresentationMode" in this.el_ && this.el_.webkitPresentationMode !== "picture-in-picture") {
        this.one("webkitendfullscreen", endFn);
        this.trigger("fullscreenchange", {
          isFullscreen: true,
          nativeIOSFullscreen: true
        });
      }
    };
    this.on("webkitbeginfullscreen", beginFn);
    this.on("dispose", function() {
      _this6.off("webkitbeginfullscreen", beginFn);
      _this6.off("webkitendfullscreen", endFn);
    });
  };
  _proto.supportsFullScreen = function supportsFullScreen() {
    if (typeof this.el_.webkitEnterFullScreen === "function") {
      var userAgent2 = window_1.navigator && window_1.navigator.userAgent || "";
      if (/Android/.test(userAgent2) || !/Chrome|Mac OS X 10.5/.test(userAgent2)) {
        return true;
      }
    }
    return false;
  };
  _proto.enterFullScreen = function enterFullScreen() {
    var video = this.el_;
    if (video.paused && video.networkState <= video.HAVE_METADATA) {
      silencePromise(this.el_.play());
      this.setTimeout(function() {
        video.pause();
        try {
          video.webkitEnterFullScreen();
        } catch (e) {
          this.trigger("fullscreenerror", e);
        }
      }, 0);
    } else {
      try {
        video.webkitEnterFullScreen();
      } catch (e) {
        this.trigger("fullscreenerror", e);
      }
    }
  };
  _proto.exitFullScreen = function exitFullScreen() {
    if (!this.el_.webkitDisplayingFullscreen) {
      this.trigger("fullscreenerror", new Error("The video is not fullscreen"));
      return;
    }
    this.el_.webkitExitFullScreen();
  };
  _proto.requestPictureInPicture = function requestPictureInPicture() {
    return this.el_.requestPictureInPicture();
  };
  _proto.requestVideoFrameCallback = function requestVideoFrameCallback(cb2) {
    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
      return this.el_.requestVideoFrameCallback(cb2);
    }
    return _Tech.prototype.requestVideoFrameCallback.call(this, cb2);
  };
  _proto.cancelVideoFrameCallback = function cancelVideoFrameCallback(id2) {
    if (this.featuresVideoFrameCallback && !this.el_.webkitKeys) {
      this.el_.cancelVideoFrameCallback(id2);
    } else {
      _Tech.prototype.cancelVideoFrameCallback.call(this, id2);
    }
  };
  _proto.src = function src(_src) {
    if (_src === void 0) {
      return this.el_.src;
    }
    this.setSrc(_src);
  };
  _proto.reset = function reset3() {
    Html52.resetMediaElement(this.el_);
  };
  _proto.currentSrc = function currentSrc() {
    if (this.currentSource_) {
      return this.currentSource_.src;
    }
    return this.el_.currentSrc;
  };
  _proto.setControls = function setControls(val) {
    this.el_.controls = !!val;
  };
  _proto.addTextTrack = function addTextTrack(kind, label, language) {
    if (!this.featuresNativeTextTracks) {
      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
    }
    return this.el_.addTextTrack(kind, label, language);
  };
  _proto.createRemoteTextTrack = function createRemoteTextTrack(options) {
    if (!this.featuresNativeTextTracks) {
      return _Tech.prototype.createRemoteTextTrack.call(this, options);
    }
    var htmlTrackElement = document_1.createElement("track");
    if (options.kind) {
      htmlTrackElement.kind = options.kind;
    }
    if (options.label) {
      htmlTrackElement.label = options.label;
    }
    if (options.language || options.srclang) {
      htmlTrackElement.srclang = options.language || options.srclang;
    }
    if (options["default"]) {
      htmlTrackElement["default"] = options["default"];
    }
    if (options.id) {
      htmlTrackElement.id = options.id;
    }
    if (options.src) {
      htmlTrackElement.src = options.src;
    }
    return htmlTrackElement;
  };
  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
    var htmlTrackElement = _Tech.prototype.addRemoteTextTrack.call(this, options, manualCleanup);
    if (this.featuresNativeTextTracks) {
      this.el().appendChild(htmlTrackElement);
    }
    return htmlTrackElement;
  };
  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
    _Tech.prototype.removeRemoteTextTrack.call(this, track);
    if (this.featuresNativeTextTracks) {
      var tracks = this.$$("track");
      var i = tracks.length;
      while (i--) {
        if (track === tracks[i] || track === tracks[i].track) {
          this.el().removeChild(tracks[i]);
        }
      }
    }
  };
  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
    if (typeof this.el().getVideoPlaybackQuality === "function") {
      return this.el().getVideoPlaybackQuality();
    }
    var videoPlaybackQuality = {};
    if (typeof this.el().webkitDroppedFrameCount !== "undefined" && typeof this.el().webkitDecodedFrameCount !== "undefined") {
      videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
      videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
    }
    if (window_1.performance && typeof window_1.performance.now === "function") {
      videoPlaybackQuality.creationTime = window_1.performance.now();
    } else if (window_1.performance && window_1.performance.timing && typeof window_1.performance.timing.navigationStart === "number") {
      videoPlaybackQuality.creationTime = window_1.Date.now() - window_1.performance.timing.navigationStart;
    }
    return videoPlaybackQuality;
  };
  return Html52;
}(Tech);
defineLazyProperty(Html5, "TEST_VID", function() {
  if (!isReal()) {
    return;
  }
  var video = document_1.createElement("video");
  var track = document_1.createElement("track");
  track.kind = "captions";
  track.srclang = "en";
  track.label = "English";
  video.appendChild(track);
  return video;
});
Html5.isSupported = function() {
  try {
    Html5.TEST_VID.volume = 0.5;
  } catch (e) {
    return false;
  }
  return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
};
Html5.canPlayType = function(type2) {
  return Html5.TEST_VID.canPlayType(type2);
};
Html5.canPlaySource = function(srcObj, options) {
  return Html5.canPlayType(srcObj.type);
};
Html5.canControlVolume = function() {
  try {
    var volume = Html5.TEST_VID.volume;
    Html5.TEST_VID.volume = volume / 2 + 0.1;
    var canControl = volume !== Html5.TEST_VID.volume;
    if (canControl && IS_IOS) {
      window_1.setTimeout(function() {
        if (Html5 && Html5.prototype) {
          Html5.prototype.featuresVolumeControl = volume !== Html5.TEST_VID.volume;
        }
      });
      return false;
    }
    return canControl;
  } catch (e) {
    return false;
  }
};
Html5.canMuteVolume = function() {
  try {
    var muted = Html5.TEST_VID.muted;
    Html5.TEST_VID.muted = !muted;
    if (Html5.TEST_VID.muted) {
      setAttribute(Html5.TEST_VID, "muted", "muted");
    } else {
      removeAttribute(Html5.TEST_VID, "muted", "muted");
    }
    return muted !== Html5.TEST_VID.muted;
  } catch (e) {
    return false;
  }
};
Html5.canControlPlaybackRate = function() {
  if (IS_ANDROID && IS_CHROME && CHROME_VERSION < 58) {
    return false;
  }
  try {
    var playbackRate = Html5.TEST_VID.playbackRate;
    Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
    return playbackRate !== Html5.TEST_VID.playbackRate;
  } catch (e) {
    return false;
  }
};
Html5.canOverrideAttributes = function() {
  try {
    var noop5 = function noop6() {
    };
    Object.defineProperty(document_1.createElement("video"), "src", {
      get: noop5,
      set: noop5
    });
    Object.defineProperty(document_1.createElement("audio"), "src", {
      get: noop5,
      set: noop5
    });
    Object.defineProperty(document_1.createElement("video"), "innerHTML", {
      get: noop5,
      set: noop5
    });
    Object.defineProperty(document_1.createElement("audio"), "innerHTML", {
      get: noop5,
      set: noop5
    });
  } catch (e) {
    return false;
  }
  return true;
};
Html5.supportsNativeTextTracks = function() {
  return IS_ANY_SAFARI || IS_IOS && IS_CHROME;
};
Html5.supportsNativeVideoTracks = function() {
  return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
};
Html5.supportsNativeAudioTracks = function() {
  return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
};
Html5.Events = ["loadstart", "suspend", "abort", "error", "emptied", "stalled", "loadedmetadata", "loadeddata", "canplay", "canplaythrough", "playing", "waiting", "seeking", "seeked", "ended", "durationchange", "timeupdate", "progress", "play", "pause", "ratechange", "resize", "volumechange"];
[["featuresMuteControl", "canMuteVolume"], ["featuresPlaybackRate", "canControlPlaybackRate"], ["featuresSourceset", "canOverrideAttributes"], ["featuresNativeTextTracks", "supportsNativeTextTracks"], ["featuresNativeVideoTracks", "supportsNativeVideoTracks"], ["featuresNativeAudioTracks", "supportsNativeAudioTracks"]].forEach(function(_ref2) {
  var key = _ref2[0], fn = _ref2[1];
  defineLazyProperty(Html5.prototype, key, function() {
    return Html5[fn]();
  }, true);
});
Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
Html5.prototype.movingMediaElementInDOM = !IS_IOS;
Html5.prototype.featuresFullscreenResize = true;
Html5.prototype.featuresProgressEvents = true;
Html5.prototype.featuresTimeupdateEvents = true;
Html5.prototype.featuresVideoFrameCallback = !!(Html5.TEST_VID && Html5.TEST_VID.requestVideoFrameCallback);
var canPlayType;
Html5.patchCanPlayType = function() {
  if (ANDROID_VERSION >= 4 && !IS_FIREFOX && !IS_CHROME) {
    canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
    Html5.TEST_VID.constructor.prototype.canPlayType = function(type2) {
      var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
      if (type2 && mpegurlRE.test(type2)) {
        return "maybe";
      }
      return canPlayType.call(this, type2);
    };
  }
};
Html5.unpatchCanPlayType = function() {
  var r2 = Html5.TEST_VID.constructor.prototype.canPlayType;
  if (canPlayType) {
    Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
  }
  return r2;
};
Html5.patchCanPlayType();
Html5.disposeMediaElement = function(el) {
  if (!el) {
    return;
  }
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
  while (el.hasChildNodes()) {
    el.removeChild(el.firstChild);
  }
  el.removeAttribute("src");
  if (typeof el.load === "function") {
    (function() {
      try {
        el.load();
      } catch (e) {
      }
    })();
  }
};
Html5.resetMediaElement = function(el) {
  if (!el) {
    return;
  }
  var sources = el.querySelectorAll("source");
  var i = sources.length;
  while (i--) {
    el.removeChild(sources[i]);
  }
  el.removeAttribute("src");
  if (typeof el.load === "function") {
    (function() {
      try {
        el.load();
      } catch (e) {
      }
    })();
  }
};
[
  "muted",
  "defaultMuted",
  "autoplay",
  "controls",
  "loop",
  "playsinline"
].forEach(function(prop) {
  Html5.prototype[prop] = function() {
    return this.el_[prop] || this.el_.hasAttribute(prop);
  };
});
[
  "muted",
  "defaultMuted",
  "autoplay",
  "loop",
  "playsinline"
].forEach(function(prop) {
  Html5.prototype["set" + toTitleCase$1(prop)] = function(v) {
    this.el_[prop] = v;
    if (v) {
      this.el_.setAttribute(prop, prop);
    } else {
      this.el_.removeAttribute(prop);
    }
  };
});
[
  "paused",
  "currentTime",
  "buffered",
  "volume",
  "poster",
  "preload",
  "error",
  "seeking",
  "seekable",
  "ended",
  "playbackRate",
  "defaultPlaybackRate",
  "disablePictureInPicture",
  "played",
  "networkState",
  "readyState",
  "videoWidth",
  "videoHeight",
  "crossOrigin"
].forEach(function(prop) {
  Html5.prototype[prop] = function() {
    return this.el_[prop];
  };
});
[
  "volume",
  "src",
  "poster",
  "preload",
  "playbackRate",
  "defaultPlaybackRate",
  "disablePictureInPicture",
  "crossOrigin"
].forEach(function(prop) {
  Html5.prototype["set" + toTitleCase$1(prop)] = function(v) {
    this.el_[prop] = v;
  };
});
[
  "pause",
  "load",
  "play"
].forEach(function(prop) {
  Html5.prototype[prop] = function() {
    return this.el_[prop]();
  };
});
Tech.withSourceHandlers(Html5);
Html5.nativeSourceHandler = {};
Html5.nativeSourceHandler.canPlayType = function(type2) {
  try {
    return Html5.TEST_VID.canPlayType(type2);
  } catch (e) {
    return "";
  }
};
Html5.nativeSourceHandler.canHandleSource = function(source, options) {
  if (source.type) {
    return Html5.nativeSourceHandler.canPlayType(source.type);
  } else if (source.src) {
    var ext = getFileExtension(source.src);
    return Html5.nativeSourceHandler.canPlayType("video/" + ext);
  }
  return "";
};
Html5.nativeSourceHandler.handleSource = function(source, tech, options) {
  tech.setSrc(source.src);
};
Html5.nativeSourceHandler.dispose = function() {
};
Html5.registerSourceHandler(Html5.nativeSourceHandler);
Tech.registerTech("Html5", Html5);
var TECH_EVENTS_RETRIGGER = [
  "progress",
  "abort",
  "suspend",
  "emptied",
  "stalled",
  "loadedmetadata",
  "loadeddata",
  "timeupdate",
  "resize",
  "volumechange",
  "texttrackchange"
];
var TECH_EVENTS_QUEUE = {
  canplay: "CanPlay",
  canplaythrough: "CanPlayThrough",
  playing: "Playing",
  seeked: "Seeked"
};
var BREAKPOINT_ORDER = ["tiny", "xsmall", "small", "medium", "large", "xlarge", "huge"];
var BREAKPOINT_CLASSES = {};
BREAKPOINT_ORDER.forEach(function(k) {
  var v = k.charAt(0) === "x" ? "x-" + k.substring(1) : k;
  BREAKPOINT_CLASSES[k] = "vjs-layout-" + v;
});
var DEFAULT_BREAKPOINTS = {
  tiny: 210,
  xsmall: 320,
  small: 425,
  medium: 768,
  large: 1440,
  xlarge: 2560,
  huge: Infinity
};
var Player = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(Player2, _Component);
  function Player2(tag, options, ready) {
    var _this;
    tag.id = tag.id || options.id || "vjs_video_" + newGUID();
    options = assign(Player2.getTagSettings(tag), options);
    options.initChildren = false;
    options.createEl = false;
    options.evented = false;
    options.reportTouchActivity = false;
    if (!options.language) {
      if (typeof tag.closest === "function") {
        var closest = tag.closest("[lang]");
        if (closest && closest.getAttribute) {
          options.language = closest.getAttribute("lang");
        }
      } else {
        var element = tag;
        while (element && element.nodeType === 1) {
          if (getAttributes(element).hasOwnProperty("lang")) {
            options.language = element.getAttribute("lang");
            break;
          }
          element = element.parentNode;
        }
      }
    }
    _this = _Component.call(this, null, options, ready) || this;
    _this.boundDocumentFullscreenChange_ = function(e) {
      return _this.documentFullscreenChange_(e);
    };
    _this.boundFullWindowOnEscKey_ = function(e) {
      return _this.fullWindowOnEscKey(e);
    };
    _this.boundUpdateStyleEl_ = function(e) {
      return _this.updateStyleEl_(e);
    };
    _this.boundApplyInitTime_ = function(e) {
      return _this.applyInitTime_(e);
    };
    _this.boundUpdateCurrentBreakpoint_ = function(e) {
      return _this.updateCurrentBreakpoint_(e);
    };
    _this.boundHandleTechClick_ = function(e) {
      return _this.handleTechClick_(e);
    };
    _this.boundHandleTechDoubleClick_ = function(e) {
      return _this.handleTechDoubleClick_(e);
    };
    _this.boundHandleTechTouchStart_ = function(e) {
      return _this.handleTechTouchStart_(e);
    };
    _this.boundHandleTechTouchMove_ = function(e) {
      return _this.handleTechTouchMove_(e);
    };
    _this.boundHandleTechTouchEnd_ = function(e) {
      return _this.handleTechTouchEnd_(e);
    };
    _this.boundHandleTechTap_ = function(e) {
      return _this.handleTechTap_(e);
    };
    _this.isFullscreen_ = false;
    _this.log = createLogger(_this.id_);
    _this.fsApi_ = FullscreenApi;
    _this.isPosterFromTech_ = false;
    _this.queuedCallbacks_ = [];
    _this.isReady_ = false;
    _this.hasStarted_ = false;
    _this.userActive_ = false;
    _this.debugEnabled_ = false;
    _this.audioOnlyMode_ = false;
    _this.audioPosterMode_ = false;
    _this.audioOnlyCache_ = {
      playerHeight: null,
      hiddenChildren: []
    };
    if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
      throw new Error("No techOrder specified. Did you overwrite videojs.options instead of just changing the properties you want to override?");
    }
    _this.tag = tag;
    _this.tagAttributes = tag && getAttributes(tag);
    _this.language(_this.options_.language);
    if (options.languages) {
      var languagesToLower = {};
      Object.getOwnPropertyNames(options.languages).forEach(function(name) {
        languagesToLower[name.toLowerCase()] = options.languages[name];
      });
      _this.languages_ = languagesToLower;
    } else {
      _this.languages_ = Player2.prototype.options_.languages;
    }
    _this.resetCache_();
    _this.poster_ = options.poster || "";
    _this.controls_ = !!options.controls;
    tag.controls = false;
    tag.removeAttribute("controls");
    _this.changingSrc_ = false;
    _this.playCallbacks_ = [];
    _this.playTerminatedQueue_ = [];
    if (tag.hasAttribute("autoplay")) {
      _this.autoplay(true);
    } else {
      _this.autoplay(_this.options_.autoplay);
    }
    if (options.plugins) {
      Object.keys(options.plugins).forEach(function(name) {
        if (typeof _this[name] !== "function") {
          throw new Error('plugin "' + name + '" does not exist');
        }
      });
    }
    _this.scrubbing_ = false;
    _this.el_ = _this.createEl();
    evented(_assertThisInitialized(_this), {
      eventBusKey: "el_"
    });
    if (_this.fsApi_.requestFullscreen) {
      on(document_1, _this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
      _this.on(_this.fsApi_.fullscreenchange, _this.boundDocumentFullscreenChange_);
    }
    if (_this.fluid_) {
      _this.on(["playerreset", "resize"], _this.boundUpdateStyleEl_);
    }
    var playerOptionsCopy = mergeOptions$3(_this.options_);
    if (options.plugins) {
      Object.keys(options.plugins).forEach(function(name) {
        _this[name](options.plugins[name]);
      });
    }
    if (options.debug) {
      _this.debug(true);
    }
    _this.options_.playerOptions = playerOptionsCopy;
    _this.middleware_ = [];
    _this.playbackRates(options.playbackRates);
    _this.initChildren();
    _this.isAudio(tag.nodeName.toLowerCase() === "audio");
    if (_this.controls()) {
      _this.addClass("vjs-controls-enabled");
    } else {
      _this.addClass("vjs-controls-disabled");
    }
    _this.el_.setAttribute("role", "region");
    if (_this.isAudio()) {
      _this.el_.setAttribute("aria-label", _this.localize("Audio Player"));
    } else {
      _this.el_.setAttribute("aria-label", _this.localize("Video Player"));
    }
    if (_this.isAudio()) {
      _this.addClass("vjs-audio");
    }
    if (_this.flexNotSupported_()) {
      _this.addClass("vjs-no-flex");
    }
    if (TOUCH_ENABLED) {
      _this.addClass("vjs-touch-enabled");
    }
    if (!IS_IOS) {
      _this.addClass("vjs-workinghover");
    }
    Player2.players[_this.id_] = _assertThisInitialized(_this);
    var majorVersion = version$5.split(".")[0];
    _this.addClass("vjs-v" + majorVersion);
    _this.userActive(true);
    _this.reportUserActivity();
    _this.one("play", function(e) {
      return _this.listenForUserActivity_(e);
    });
    _this.on("stageclick", function(e) {
      return _this.handleStageClick_(e);
    });
    _this.on("keydown", function(e) {
      return _this.handleKeyDown(e);
    });
    _this.on("languagechange", function(e) {
      return _this.handleLanguagechange(e);
    });
    _this.breakpoints(_this.options_.breakpoints);
    _this.responsive(_this.options_.responsive);
    _this.on("ready", function() {
      _this.audioPosterMode(_this.options_.audioPosterMode);
      _this.audioOnlyMode(_this.options_.audioOnlyMode);
    });
    return _this;
  }
  var _proto = Player2.prototype;
  _proto.dispose = function dispose() {
    var _this2 = this;
    this.trigger("dispose");
    this.off("dispose");
    off(document_1, this.fsApi_.fullscreenchange, this.boundDocumentFullscreenChange_);
    off(document_1, "keydown", this.boundFullWindowOnEscKey_);
    if (this.styleEl_ && this.styleEl_.parentNode) {
      this.styleEl_.parentNode.removeChild(this.styleEl_);
      this.styleEl_ = null;
    }
    Player2.players[this.id_] = null;
    if (this.tag && this.tag.player) {
      this.tag.player = null;
    }
    if (this.el_ && this.el_.player) {
      this.el_.player = null;
    }
    if (this.tech_) {
      this.tech_.dispose();
      this.isPosterFromTech_ = false;
      this.poster_ = "";
    }
    if (this.playerElIngest_) {
      this.playerElIngest_ = null;
    }
    if (this.tag) {
      this.tag = null;
    }
    clearCacheForPlayer(this);
    ALL.names.forEach(function(name) {
      var props = ALL[name];
      var list = _this2[props.getterName]();
      if (list && list.off) {
        list.off();
      }
    });
    _Component.prototype.dispose.call(this, {
      restoreEl: this.options_.restoreEl
    });
  };
  _proto.createEl = function createEl2() {
    var tag = this.tag;
    var el;
    var playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute("data-vjs-player");
    var divEmbed = this.tag.tagName.toLowerCase() === "video-js";
    if (playerElIngest) {
      el = this.el_ = tag.parentNode;
    } else if (!divEmbed) {
      el = this.el_ = _Component.prototype.createEl.call(this, "div");
    }
    var attrs = getAttributes(tag);
    if (divEmbed) {
      el = this.el_ = tag;
      tag = this.tag = document_1.createElement("video");
      while (el.children.length) {
        tag.appendChild(el.firstChild);
      }
      if (!hasClass(el, "video-js")) {
        addClass(el, "video-js");
      }
      el.appendChild(tag);
      playerElIngest = this.playerElIngest_ = el;
      Object.keys(el).forEach(function(k) {
        try {
          tag[k] = el[k];
        } catch (e) {
        }
      });
    }
    tag.setAttribute("tabindex", "-1");
    attrs.tabindex = "-1";
    if (IE_VERSION || IS_CHROME && IS_WINDOWS) {
      tag.setAttribute("role", "application");
      attrs.role = "application";
    }
    tag.removeAttribute("width");
    tag.removeAttribute("height");
    if ("width" in attrs) {
      delete attrs.width;
    }
    if ("height" in attrs) {
      delete attrs.height;
    }
    Object.getOwnPropertyNames(attrs).forEach(function(attr) {
      if (!(divEmbed && attr === "class")) {
        el.setAttribute(attr, attrs[attr]);
      }
      if (divEmbed) {
        tag.setAttribute(attr, attrs[attr]);
      }
    });
    tag.playerId = tag.id;
    tag.id += "_html5_api";
    tag.className = "vjs-tech";
    tag.player = el.player = this;
    this.addClass("vjs-paused");
    if (window_1.VIDEOJS_NO_DYNAMIC_STYLE !== true) {
      this.styleEl_ = createStyleElement("vjs-styles-dimensions");
      var defaultsStyleEl = $(".vjs-styles-defaults");
      var head = $("head");
      head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
    }
    this.fill_ = false;
    this.fluid_ = false;
    this.width(this.options_.width);
    this.height(this.options_.height);
    this.fill(this.options_.fill);
    this.fluid(this.options_.fluid);
    this.aspectRatio(this.options_.aspectRatio);
    this.crossOrigin(this.options_.crossOrigin || this.options_.crossorigin);
    var links = tag.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var linkEl = links.item(i);
      addClass(linkEl, "vjs-hidden");
      linkEl.setAttribute("hidden", "hidden");
    }
    tag.initNetworkState_ = tag.networkState;
    if (tag.parentNode && !playerElIngest) {
      tag.parentNode.insertBefore(el, tag);
    }
    prependTo(tag, el);
    this.children_.unshift(tag);
    this.el_.setAttribute("lang", this.language_);
    this.el_.setAttribute("translate", "no");
    this.el_ = el;
    return el;
  };
  _proto.crossOrigin = function crossOrigin(value) {
    if (!value) {
      return this.techGet_("crossOrigin");
    }
    if (value !== "anonymous" && value !== "use-credentials") {
      log$1.warn('crossOrigin must be "anonymous" or "use-credentials", given "' + value + '"');
      return;
    }
    this.techCall_("setCrossOrigin", value);
    return;
  };
  _proto.width = function width2(value) {
    return this.dimension("width", value);
  };
  _proto.height = function height2(value) {
    return this.dimension("height", value);
  };
  _proto.dimension = function dimension(_dimension, value) {
    var privDimension = _dimension + "_";
    if (value === void 0) {
      return this[privDimension] || 0;
    }
    if (value === "" || value === "auto") {
      this[privDimension] = void 0;
      this.updateStyleEl_();
      return;
    }
    var parsedVal = parseFloat(value);
    if (isNaN(parsedVal)) {
      log$1.error('Improper value "' + value + '" supplied for for ' + _dimension);
      return;
    }
    this[privDimension] = parsedVal;
    this.updateStyleEl_();
  };
  _proto.fluid = function fluid(bool2) {
    var _this3 = this;
    if (bool2 === void 0) {
      return !!this.fluid_;
    }
    this.fluid_ = !!bool2;
    if (isEvented(this)) {
      this.off(["playerreset", "resize"], this.boundUpdateStyleEl_);
    }
    if (bool2) {
      this.addClass("vjs-fluid");
      this.fill(false);
      addEventedCallback(this, function() {
        _this3.on(["playerreset", "resize"], _this3.boundUpdateStyleEl_);
      });
    } else {
      this.removeClass("vjs-fluid");
    }
    this.updateStyleEl_();
  };
  _proto.fill = function fill(bool2) {
    if (bool2 === void 0) {
      return !!this.fill_;
    }
    this.fill_ = !!bool2;
    if (bool2) {
      this.addClass("vjs-fill");
      this.fluid(false);
    } else {
      this.removeClass("vjs-fill");
    }
  };
  _proto.aspectRatio = function aspectRatio(ratio) {
    if (ratio === void 0) {
      return this.aspectRatio_;
    }
    if (!/^\d+\:\d+$/.test(ratio)) {
      throw new Error("Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.");
    }
    this.aspectRatio_ = ratio;
    this.fluid(true);
    this.updateStyleEl_();
  };
  _proto.updateStyleEl_ = function updateStyleEl_() {
    if (window_1.VIDEOJS_NO_DYNAMIC_STYLE === true) {
      var _width = typeof this.width_ === "number" ? this.width_ : this.options_.width;
      var _height = typeof this.height_ === "number" ? this.height_ : this.options_.height;
      var techEl = this.tech_ && this.tech_.el();
      if (techEl) {
        if (_width >= 0) {
          techEl.width = _width;
        }
        if (_height >= 0) {
          techEl.height = _height;
        }
      }
      return;
    }
    var width2;
    var height2;
    var aspectRatio;
    var idClass;
    if (this.aspectRatio_ !== void 0 && this.aspectRatio_ !== "auto") {
      aspectRatio = this.aspectRatio_;
    } else if (this.videoWidth() > 0) {
      aspectRatio = this.videoWidth() + ":" + this.videoHeight();
    } else {
      aspectRatio = "16:9";
    }
    var ratioParts = aspectRatio.split(":");
    var ratioMultiplier = ratioParts[1] / ratioParts[0];
    if (this.width_ !== void 0) {
      width2 = this.width_;
    } else if (this.height_ !== void 0) {
      width2 = this.height_ / ratioMultiplier;
    } else {
      width2 = this.videoWidth() || 300;
    }
    if (this.height_ !== void 0) {
      height2 = this.height_;
    } else {
      height2 = width2 * ratioMultiplier;
    }
    if (/^[^a-zA-Z]/.test(this.id())) {
      idClass = "dimensions-" + this.id();
    } else {
      idClass = this.id() + "-dimensions";
    }
    this.addClass(idClass);
    setTextContent(this.styleEl_, "\n      ." + idClass + " {\n        width: " + width2 + "px;\n        height: " + height2 + "px;\n      }\n\n      ." + idClass + ".vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: " + ratioMultiplier * 100 + "%;\n      }\n    ");
  };
  _proto.loadTech_ = function loadTech_(techName, source) {
    var _this4 = this;
    if (this.tech_) {
      this.unloadTech_();
    }
    var titleTechName = toTitleCase$1(techName);
    var camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);
    if (titleTechName !== "Html5" && this.tag) {
      Tech.getTech("Html5").disposeMediaElement(this.tag);
      this.tag.player = null;
      this.tag = null;
    }
    this.techName_ = titleTechName;
    this.isReady_ = false;
    var autoplay = this.autoplay();
    if (typeof this.autoplay() === "string" || this.autoplay() === true && this.options_.normalizeAutoplay) {
      autoplay = false;
    }
    var techOptions = {
      source,
      autoplay,
      "nativeControlsForTouch": this.options_.nativeControlsForTouch,
      "playerId": this.id(),
      "techId": this.id() + "_" + camelTechName + "_api",
      "playsinline": this.options_.playsinline,
      "preload": this.options_.preload,
      "loop": this.options_.loop,
      "disablePictureInPicture": this.options_.disablePictureInPicture,
      "muted": this.options_.muted,
      "poster": this.poster(),
      "language": this.language(),
      "playerElIngest": this.playerElIngest_ || false,
      "vtt.js": this.options_["vtt.js"],
      "canOverridePoster": !!this.options_.techCanOverridePoster,
      "enableSourceset": this.options_.enableSourceset,
      "Promise": this.options_.Promise
    };
    ALL.names.forEach(function(name) {
      var props = ALL[name];
      techOptions[props.getterName] = _this4[props.privateName];
    });
    assign(techOptions, this.options_[titleTechName]);
    assign(techOptions, this.options_[camelTechName]);
    assign(techOptions, this.options_[techName.toLowerCase()]);
    if (this.tag) {
      techOptions.tag = this.tag;
    }
    if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) {
      techOptions.startTime = this.cache_.currentTime;
    }
    var TechClass = Tech.getTech(techName);
    if (!TechClass) {
      throw new Error("No Tech named '" + titleTechName + "' exists! '" + titleTechName + "' should be registered using videojs.registerTech()'");
    }
    this.tech_ = new TechClass(techOptions);
    this.tech_.ready(bind(this, this.handleTechReady_), true);
    textTrackConverter.jsonToTextTracks(this.textTracksJson_ || [], this.tech_);
    TECH_EVENTS_RETRIGGER.forEach(function(event) {
      _this4.on(_this4.tech_, event, function(e) {
        return _this4["handleTech" + toTitleCase$1(event) + "_"](e);
      });
    });
    Object.keys(TECH_EVENTS_QUEUE).forEach(function(event) {
      _this4.on(_this4.tech_, event, function(eventObj) {
        if (_this4.tech_.playbackRate() === 0 && _this4.tech_.seeking()) {
          _this4.queuedCallbacks_.push({
            callback: _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"].bind(_this4),
            event: eventObj
          });
          return;
        }
        _this4["handleTech" + TECH_EVENTS_QUEUE[event] + "_"](eventObj);
      });
    });
    this.on(this.tech_, "loadstart", function(e) {
      return _this4.handleTechLoadStart_(e);
    });
    this.on(this.tech_, "sourceset", function(e) {
      return _this4.handleTechSourceset_(e);
    });
    this.on(this.tech_, "waiting", function(e) {
      return _this4.handleTechWaiting_(e);
    });
    this.on(this.tech_, "ended", function(e) {
      return _this4.handleTechEnded_(e);
    });
    this.on(this.tech_, "seeking", function(e) {
      return _this4.handleTechSeeking_(e);
    });
    this.on(this.tech_, "play", function(e) {
      return _this4.handleTechPlay_(e);
    });
    this.on(this.tech_, "firstplay", function(e) {
      return _this4.handleTechFirstPlay_(e);
    });
    this.on(this.tech_, "pause", function(e) {
      return _this4.handleTechPause_(e);
    });
    this.on(this.tech_, "durationchange", function(e) {
      return _this4.handleTechDurationChange_(e);
    });
    this.on(this.tech_, "fullscreenchange", function(e, data) {
      return _this4.handleTechFullscreenChange_(e, data);
    });
    this.on(this.tech_, "fullscreenerror", function(e, err) {
      return _this4.handleTechFullscreenError_(e, err);
    });
    this.on(this.tech_, "enterpictureinpicture", function(e) {
      return _this4.handleTechEnterPictureInPicture_(e);
    });
    this.on(this.tech_, "leavepictureinpicture", function(e) {
      return _this4.handleTechLeavePictureInPicture_(e);
    });
    this.on(this.tech_, "error", function(e) {
      return _this4.handleTechError_(e);
    });
    this.on(this.tech_, "posterchange", function(e) {
      return _this4.handleTechPosterChange_(e);
    });
    this.on(this.tech_, "textdata", function(e) {
      return _this4.handleTechTextData_(e);
    });
    this.on(this.tech_, "ratechange", function(e) {
      return _this4.handleTechRateChange_(e);
    });
    this.on(this.tech_, "loadedmetadata", this.boundUpdateStyleEl_);
    this.usingNativeControls(this.techGet_("controls"));
    if (this.controls() && !this.usingNativeControls()) {
      this.addTechControlsListeners_();
    }
    if (this.tech_.el().parentNode !== this.el() && (titleTechName !== "Html5" || !this.tag)) {
      prependTo(this.tech_.el(), this.el());
    }
    if (this.tag) {
      this.tag.player = null;
      this.tag = null;
    }
  };
  _proto.unloadTech_ = function unloadTech_() {
    var _this5 = this;
    ALL.names.forEach(function(name) {
      var props = ALL[name];
      _this5[props.privateName] = _this5[props.getterName]();
    });
    this.textTracksJson_ = textTrackConverter.textTracksToJson(this.tech_);
    this.isReady_ = false;
    this.tech_.dispose();
    this.tech_ = false;
    if (this.isPosterFromTech_) {
      this.poster_ = "";
      this.trigger("posterchange");
    }
    this.isPosterFromTech_ = false;
  };
  _proto.tech = function tech(safety) {
    if (safety === void 0) {
      log$1.warn("Using the tech directly can be dangerous. I hope you know what you're doing.\nSee https://github.com/videojs/video.js/issues/2617 for more info.\n");
    }
    return this.tech_;
  };
  _proto.addTechControlsListeners_ = function addTechControlsListeners_() {
    this.removeTechControlsListeners_();
    this.on(this.tech_, "click", this.boundHandleTechClick_);
    this.on(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
    this.on(this.tech_, "touchstart", this.boundHandleTechTouchStart_);
    this.on(this.tech_, "touchmove", this.boundHandleTechTouchMove_);
    this.on(this.tech_, "touchend", this.boundHandleTechTouchEnd_);
    this.on(this.tech_, "tap", this.boundHandleTechTap_);
  };
  _proto.removeTechControlsListeners_ = function removeTechControlsListeners_() {
    this.off(this.tech_, "tap", this.boundHandleTechTap_);
    this.off(this.tech_, "touchstart", this.boundHandleTechTouchStart_);
    this.off(this.tech_, "touchmove", this.boundHandleTechTouchMove_);
    this.off(this.tech_, "touchend", this.boundHandleTechTouchEnd_);
    this.off(this.tech_, "click", this.boundHandleTechClick_);
    this.off(this.tech_, "dblclick", this.boundHandleTechDoubleClick_);
  };
  _proto.handleTechReady_ = function handleTechReady_() {
    this.triggerReady();
    if (this.cache_.volume) {
      this.techCall_("setVolume", this.cache_.volume);
    }
    this.handleTechPosterChange_();
    this.handleTechDurationChange_();
  };
  _proto.handleTechLoadStart_ = function handleTechLoadStart_() {
    this.removeClass("vjs-ended");
    this.removeClass("vjs-seeking");
    this.error(null);
    this.handleTechDurationChange_();
    if (!this.paused()) {
      this.trigger("loadstart");
      this.trigger("firstplay");
    } else {
      this.hasStarted(false);
      this.trigger("loadstart");
    }
    this.manualAutoplay_(this.autoplay() === true && this.options_.normalizeAutoplay ? "play" : this.autoplay());
  };
  _proto.manualAutoplay_ = function manualAutoplay_(type2) {
    var _this6 = this;
    if (!this.tech_ || typeof type2 !== "string") {
      return;
    }
    var resolveMuted = function resolveMuted2() {
      var previouslyMuted = _this6.muted();
      _this6.muted(true);
      var restoreMuted = function restoreMuted2() {
        _this6.muted(previouslyMuted);
      };
      _this6.playTerminatedQueue_.push(restoreMuted);
      var mutedPromise = _this6.play();
      if (!isPromise(mutedPromise)) {
        return;
      }
      return mutedPromise["catch"](function(err) {
        restoreMuted();
        throw new Error("Rejection at manualAutoplay. Restoring muted value. " + (err ? err : ""));
      });
    };
    var promise;
    if (type2 === "any" && !this.muted()) {
      promise = this.play();
      if (isPromise(promise)) {
        promise = promise["catch"](resolveMuted);
      }
    } else if (type2 === "muted" && !this.muted()) {
      promise = resolveMuted();
    } else {
      promise = this.play();
    }
    if (!isPromise(promise)) {
      return;
    }
    return promise.then(function() {
      _this6.trigger({
        type: "autoplay-success",
        autoplay: type2
      });
    })["catch"](function() {
      _this6.trigger({
        type: "autoplay-failure",
        autoplay: type2
      });
    });
  };
  _proto.updateSourceCaches_ = function updateSourceCaches_(srcObj) {
    if (srcObj === void 0) {
      srcObj = "";
    }
    var src = srcObj;
    var type2 = "";
    if (typeof src !== "string") {
      src = srcObj.src;
      type2 = srcObj.type;
    }
    this.cache_.source = this.cache_.source || {};
    this.cache_.sources = this.cache_.sources || [];
    if (src && !type2) {
      type2 = findMimetype(this, src);
    }
    this.cache_.source = mergeOptions$3({}, srcObj, {
      src,
      type: type2
    });
    var matchingSources = this.cache_.sources.filter(function(s) {
      return s.src && s.src === src;
    });
    var sourceElSources = [];
    var sourceEls = this.$$("source");
    var matchingSourceEls = [];
    for (var i = 0; i < sourceEls.length; i++) {
      var sourceObj = getAttributes(sourceEls[i]);
      sourceElSources.push(sourceObj);
      if (sourceObj.src && sourceObj.src === src) {
        matchingSourceEls.push(sourceObj.src);
      }
    }
    if (matchingSourceEls.length && !matchingSources.length) {
      this.cache_.sources = sourceElSources;
    } else if (!matchingSources.length) {
      this.cache_.sources = [this.cache_.source];
    }
    this.cache_.src = src;
  };
  _proto.handleTechSourceset_ = function handleTechSourceset_(event) {
    var _this7 = this;
    if (!this.changingSrc_) {
      var updateSourceCaches = function updateSourceCaches2(src) {
        return _this7.updateSourceCaches_(src);
      };
      var playerSrc = this.currentSource().src;
      var eventSrc = event.src;
      if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) {
        if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) {
          updateSourceCaches = function updateSourceCaches2() {
          };
        }
      }
      updateSourceCaches(eventSrc);
      if (!event.src) {
        this.tech_.any(["sourceset", "loadstart"], function(e) {
          if (e.type === "sourceset") {
            return;
          }
          var techSrc = _this7.techGet("currentSrc");
          _this7.lastSource_.tech = techSrc;
          _this7.updateSourceCaches_(techSrc);
        });
      }
    }
    this.lastSource_ = {
      player: this.currentSource().src,
      tech: event.src
    };
    this.trigger({
      src: event.src,
      type: "sourceset"
    });
  };
  _proto.hasStarted = function hasStarted(request) {
    if (request === void 0) {
      return this.hasStarted_;
    }
    if (request === this.hasStarted_) {
      return;
    }
    this.hasStarted_ = request;
    if (this.hasStarted_) {
      this.addClass("vjs-has-started");
      this.trigger("firstplay");
    } else {
      this.removeClass("vjs-has-started");
    }
  };
  _proto.handleTechPlay_ = function handleTechPlay_() {
    this.removeClass("vjs-ended");
    this.removeClass("vjs-paused");
    this.addClass("vjs-playing");
    this.hasStarted(true);
    this.trigger("play");
  };
  _proto.handleTechRateChange_ = function handleTechRateChange_() {
    if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
      this.queuedCallbacks_.forEach(function(queued) {
        return queued.callback(queued.event);
      });
      this.queuedCallbacks_ = [];
    }
    this.cache_.lastPlaybackRate = this.tech_.playbackRate();
    this.trigger("ratechange");
  };
  _proto.handleTechWaiting_ = function handleTechWaiting_() {
    var _this8 = this;
    this.addClass("vjs-waiting");
    this.trigger("waiting");
    var timeWhenWaiting = this.currentTime();
    var timeUpdateListener = function timeUpdateListener2() {
      if (timeWhenWaiting !== _this8.currentTime()) {
        _this8.removeClass("vjs-waiting");
        _this8.off("timeupdate", timeUpdateListener2);
      }
    };
    this.on("timeupdate", timeUpdateListener);
  };
  _proto.handleTechCanPlay_ = function handleTechCanPlay_() {
    this.removeClass("vjs-waiting");
    this.trigger("canplay");
  };
  _proto.handleTechCanPlayThrough_ = function handleTechCanPlayThrough_() {
    this.removeClass("vjs-waiting");
    this.trigger("canplaythrough");
  };
  _proto.handleTechPlaying_ = function handleTechPlaying_() {
    this.removeClass("vjs-waiting");
    this.trigger("playing");
  };
  _proto.handleTechSeeking_ = function handleTechSeeking_() {
    this.addClass("vjs-seeking");
    this.trigger("seeking");
  };
  _proto.handleTechSeeked_ = function handleTechSeeked_() {
    this.removeClass("vjs-seeking");
    this.removeClass("vjs-ended");
    this.trigger("seeked");
  };
  _proto.handleTechFirstPlay_ = function handleTechFirstPlay_() {
    if (this.options_.starttime) {
      log$1.warn("Passing the `starttime` option to the player will be deprecated in 6.0");
      this.currentTime(this.options_.starttime);
    }
    this.addClass("vjs-has-started");
    this.trigger("firstplay");
  };
  _proto.handleTechPause_ = function handleTechPause_() {
    this.removeClass("vjs-playing");
    this.addClass("vjs-paused");
    this.trigger("pause");
  };
  _proto.handleTechEnded_ = function handleTechEnded_() {
    this.addClass("vjs-ended");
    this.removeClass("vjs-waiting");
    if (this.options_.loop) {
      this.currentTime(0);
      this.play();
    } else if (!this.paused()) {
      this.pause();
    }
    this.trigger("ended");
  };
  _proto.handleTechDurationChange_ = function handleTechDurationChange_() {
    this.duration(this.techGet_("duration"));
  };
  _proto.handleTechClick_ = function handleTechClick_(event) {
    if (!this.controls_) {
      return;
    }
    if (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.click === void 0 || this.options_.userActions.click !== false) {
      if (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.click === "function") {
        this.options_.userActions.click.call(this, event);
      } else if (this.paused()) {
        silencePromise(this.play());
      } else {
        this.pause();
      }
    }
  };
  _proto.handleTechDoubleClick_ = function handleTechDoubleClick_(event) {
    if (!this.controls_) {
      return;
    }
    var inAllowedEls = Array.prototype.some.call(this.$$(".vjs-control-bar, .vjs-modal-dialog"), function(el) {
      return el.contains(event.target);
    });
    if (!inAllowedEls) {
      if (this.options_ === void 0 || this.options_.userActions === void 0 || this.options_.userActions.doubleClick === void 0 || this.options_.userActions.doubleClick !== false) {
        if (this.options_ !== void 0 && this.options_.userActions !== void 0 && typeof this.options_.userActions.doubleClick === "function") {
          this.options_.userActions.doubleClick.call(this, event);
        } else if (this.isFullscreen()) {
          this.exitFullscreen();
        } else {
          this.requestFullscreen();
        }
      }
    }
  };
  _proto.handleTechTap_ = function handleTechTap_() {
    this.userActive(!this.userActive());
  };
  _proto.handleTechTouchStart_ = function handleTechTouchStart_() {
    this.userWasActive = this.userActive();
  };
  _proto.handleTechTouchMove_ = function handleTechTouchMove_() {
    if (this.userWasActive) {
      this.reportUserActivity();
    }
  };
  _proto.handleTechTouchEnd_ = function handleTechTouchEnd_(event) {
    if (event.cancelable) {
      event.preventDefault();
    }
  };
  _proto.handleStageClick_ = function handleStageClick_() {
    this.reportUserActivity();
  };
  _proto.toggleFullscreenClass_ = function toggleFullscreenClass_() {
    if (this.isFullscreen()) {
      this.addClass("vjs-fullscreen");
    } else {
      this.removeClass("vjs-fullscreen");
    }
  };
  _proto.documentFullscreenChange_ = function documentFullscreenChange_(e) {
    var targetPlayer = e.target.player;
    if (targetPlayer && targetPlayer !== this) {
      return;
    }
    var el = this.el();
    var isFs = document_1[this.fsApi_.fullscreenElement] === el;
    if (!isFs && el.matches) {
      isFs = el.matches(":" + this.fsApi_.fullscreen);
    } else if (!isFs && el.msMatchesSelector) {
      isFs = el.msMatchesSelector(":" + this.fsApi_.fullscreen);
    }
    this.isFullscreen(isFs);
  };
  _proto.handleTechFullscreenChange_ = function handleTechFullscreenChange_(event, data) {
    var _this9 = this;
    if (data) {
      if (data.nativeIOSFullscreen) {
        this.addClass("vjs-ios-native-fs");
        this.tech_.one("webkitendfullscreen", function() {
          _this9.removeClass("vjs-ios-native-fs");
        });
      }
      this.isFullscreen(data.isFullscreen);
    }
  };
  _proto.handleTechFullscreenError_ = function handleTechFullscreenError_(event, err) {
    this.trigger("fullscreenerror", err);
  };
  _proto.togglePictureInPictureClass_ = function togglePictureInPictureClass_() {
    if (this.isInPictureInPicture()) {
      this.addClass("vjs-picture-in-picture");
    } else {
      this.removeClass("vjs-picture-in-picture");
    }
  };
  _proto.handleTechEnterPictureInPicture_ = function handleTechEnterPictureInPicture_(event) {
    this.isInPictureInPicture(true);
  };
  _proto.handleTechLeavePictureInPicture_ = function handleTechLeavePictureInPicture_(event) {
    this.isInPictureInPicture(false);
  };
  _proto.handleTechError_ = function handleTechError_() {
    var error2 = this.tech_.error();
    this.error(error2);
  };
  _proto.handleTechTextData_ = function handleTechTextData_() {
    var data = null;
    if (arguments.length > 1) {
      data = arguments[1];
    }
    this.trigger("textdata", data);
  };
  _proto.getCache = function getCache() {
    return this.cache_;
  };
  _proto.resetCache_ = function resetCache_() {
    this.cache_ = {
      currentTime: 0,
      initTime: 0,
      inactivityTimeout: this.options_.inactivityTimeout,
      duration: NaN,
      lastVolume: 1,
      lastPlaybackRate: this.defaultPlaybackRate(),
      media: null,
      src: "",
      source: {},
      sources: [],
      playbackRates: [],
      volume: 1
    };
  };
  _proto.techCall_ = function techCall_(method, arg) {
    this.ready(function() {
      if (method in allowedSetters) {
        return set(this.middleware_, this.tech_, method, arg);
      } else if (method in allowedMediators) {
        return mediate(this.middleware_, this.tech_, method, arg);
      }
      try {
        if (this.tech_) {
          this.tech_[method](arg);
        }
      } catch (e) {
        log$1(e);
        throw e;
      }
    }, true);
  };
  _proto.techGet_ = function techGet_(method) {
    if (!this.tech_ || !this.tech_.isReady_) {
      return;
    }
    if (method in allowedGetters) {
      return get(this.middleware_, this.tech_, method);
    } else if (method in allowedMediators) {
      return mediate(this.middleware_, this.tech_, method);
    }
    try {
      return this.tech_[method]();
    } catch (e) {
      if (this.tech_[method] === void 0) {
        log$1("Video.js: " + method + " method not defined for " + this.techName_ + " playback technology.", e);
        throw e;
      }
      if (e.name === "TypeError") {
        log$1("Video.js: " + method + " unavailable on " + this.techName_ + " playback technology element.", e);
        this.tech_.isReady_ = false;
        throw e;
      }
      log$1(e);
      throw e;
    }
  };
  _proto.play = function play() {
    var _this10 = this;
    var PromiseClass = this.options_.Promise || window_1.Promise;
    if (PromiseClass) {
      return new PromiseClass(function(resolve) {
        _this10.play_(resolve);
      });
    }
    return this.play_();
  };
  _proto.play_ = function play_(callback2) {
    var _this11 = this;
    if (callback2 === void 0) {
      callback2 = silencePromise;
    }
    this.playCallbacks_.push(callback2);
    var isSrcReady = Boolean(!this.changingSrc_ && (this.src() || this.currentSrc()));
    var isSafariOrIOS = Boolean(IS_ANY_SAFARI || IS_IOS);
    if (this.waitToPlay_) {
      this.off(["ready", "loadstart"], this.waitToPlay_);
      this.waitToPlay_ = null;
    }
    if (!this.isReady_ || !isSrcReady) {
      this.waitToPlay_ = function(e) {
        _this11.play_();
      };
      this.one(["ready", "loadstart"], this.waitToPlay_);
      if (!isSrcReady && isSafariOrIOS) {
        this.load();
      }
      return;
    }
    var val = this.techGet_("play");
    var isNativeReplay = isSafariOrIOS && this.hasClass("vjs-ended");
    if (isNativeReplay) {
      this.resetProgressBar_();
    }
    if (val === null) {
      this.runPlayTerminatedQueue_();
    } else {
      this.runPlayCallbacks_(val);
    }
  };
  _proto.runPlayTerminatedQueue_ = function runPlayTerminatedQueue_() {
    var queue = this.playTerminatedQueue_.slice(0);
    this.playTerminatedQueue_ = [];
    queue.forEach(function(q2) {
      q2();
    });
  };
  _proto.runPlayCallbacks_ = function runPlayCallbacks_(val) {
    var callbacks = this.playCallbacks_.slice(0);
    this.playCallbacks_ = [];
    this.playTerminatedQueue_ = [];
    callbacks.forEach(function(cb2) {
      cb2(val);
    });
  };
  _proto.pause = function pause() {
    this.techCall_("pause");
  };
  _proto.paused = function paused() {
    return this.techGet_("paused") === false ? false : true;
  };
  _proto.played = function played() {
    return this.techGet_("played") || createTimeRanges(0, 0);
  };
  _proto.scrubbing = function scrubbing(isScrubbing) {
    if (typeof isScrubbing === "undefined") {
      return this.scrubbing_;
    }
    this.scrubbing_ = !!isScrubbing;
    this.techCall_("setScrubbing", this.scrubbing_);
    if (isScrubbing) {
      this.addClass("vjs-scrubbing");
    } else {
      this.removeClass("vjs-scrubbing");
    }
  };
  _proto.currentTime = function currentTime(seconds) {
    if (typeof seconds !== "undefined") {
      if (seconds < 0) {
        seconds = 0;
      }
      if (!this.isReady_ || this.changingSrc_ || !this.tech_ || !this.tech_.isReady_) {
        this.cache_.initTime = seconds;
        this.off("canplay", this.boundApplyInitTime_);
        this.one("canplay", this.boundApplyInitTime_);
        return;
      }
      this.techCall_("setCurrentTime", seconds);
      this.cache_.initTime = 0;
      return;
    }
    this.cache_.currentTime = this.techGet_("currentTime") || 0;
    return this.cache_.currentTime;
  };
  _proto.applyInitTime_ = function applyInitTime_() {
    this.currentTime(this.cache_.initTime);
  };
  _proto.duration = function duration5(seconds) {
    if (seconds === void 0) {
      return this.cache_.duration !== void 0 ? this.cache_.duration : NaN;
    }
    seconds = parseFloat(seconds);
    if (seconds < 0) {
      seconds = Infinity;
    }
    if (seconds !== this.cache_.duration) {
      this.cache_.duration = seconds;
      if (seconds === Infinity) {
        this.addClass("vjs-live");
      } else {
        this.removeClass("vjs-live");
      }
      if (!isNaN(seconds)) {
        this.trigger("durationchange");
      }
    }
  };
  _proto.remainingTime = function remainingTime() {
    return this.duration() - this.currentTime();
  };
  _proto.remainingTimeDisplay = function remainingTimeDisplay() {
    return Math.floor(this.duration()) - Math.floor(this.currentTime());
  };
  _proto.buffered = function buffered() {
    var buffered2 = this.techGet_("buffered");
    if (!buffered2 || !buffered2.length) {
      buffered2 = createTimeRanges(0, 0);
    }
    return buffered2;
  };
  _proto.bufferedPercent = function bufferedPercent$1() {
    return bufferedPercent(this.buffered(), this.duration());
  };
  _proto.bufferedEnd = function bufferedEnd() {
    var buffered = this.buffered();
    var duration5 = this.duration();
    var end3 = buffered.end(buffered.length - 1);
    if (end3 > duration5) {
      end3 = duration5;
    }
    return end3;
  };
  _proto.volume = function volume(percentAsDecimal) {
    var vol;
    if (percentAsDecimal !== void 0) {
      vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
      this.cache_.volume = vol;
      this.techCall_("setVolume", vol);
      if (vol > 0) {
        this.lastVolume_(vol);
      }
      return;
    }
    vol = parseFloat(this.techGet_("volume"));
    return isNaN(vol) ? 1 : vol;
  };
  _proto.muted = function muted(_muted) {
    if (_muted !== void 0) {
      this.techCall_("setMuted", _muted);
      return;
    }
    return this.techGet_("muted") || false;
  };
  _proto.defaultMuted = function defaultMuted(_defaultMuted) {
    if (_defaultMuted !== void 0) {
      return this.techCall_("setDefaultMuted", _defaultMuted);
    }
    return this.techGet_("defaultMuted") || false;
  };
  _proto.lastVolume_ = function lastVolume_(percentAsDecimal) {
    if (percentAsDecimal !== void 0 && percentAsDecimal !== 0) {
      this.cache_.lastVolume = percentAsDecimal;
      return;
    }
    return this.cache_.lastVolume;
  };
  _proto.supportsFullScreen = function supportsFullScreen() {
    return this.techGet_("supportsFullScreen") || false;
  };
  _proto.isFullscreen = function isFullscreen(isFS) {
    if (isFS !== void 0) {
      var oldValue = this.isFullscreen_;
      this.isFullscreen_ = Boolean(isFS);
      if (this.isFullscreen_ !== oldValue && this.fsApi_.prefixed) {
        this.trigger("fullscreenchange");
      }
      this.toggleFullscreenClass_();
      return;
    }
    return this.isFullscreen_;
  };
  _proto.requestFullscreen = function requestFullscreen(fullscreenOptions) {
    var PromiseClass = this.options_.Promise || window_1.Promise;
    if (PromiseClass) {
      var self2 = this;
      return new PromiseClass(function(resolve, reject) {
        function offHandler() {
          self2.off("fullscreenerror", errorHandler);
          self2.off("fullscreenchange", changeHandler);
        }
        function changeHandler() {
          offHandler();
          resolve();
        }
        function errorHandler(e, err) {
          offHandler();
          reject(err);
        }
        self2.one("fullscreenchange", changeHandler);
        self2.one("fullscreenerror", errorHandler);
        var promise = self2.requestFullscreenHelper_(fullscreenOptions);
        if (promise) {
          promise.then(offHandler, offHandler);
          promise.then(resolve, reject);
        }
      });
    }
    return this.requestFullscreenHelper_();
  };
  _proto.requestFullscreenHelper_ = function requestFullscreenHelper_(fullscreenOptions) {
    var _this12 = this;
    var fsOptions;
    if (!this.fsApi_.prefixed) {
      fsOptions = this.options_.fullscreen && this.options_.fullscreen.options || {};
      if (fullscreenOptions !== void 0) {
        fsOptions = fullscreenOptions;
      }
    }
    if (this.fsApi_.requestFullscreen) {
      var promise = this.el_[this.fsApi_.requestFullscreen](fsOptions);
      if (promise) {
        promise.then(function() {
          return _this12.isFullscreen(true);
        }, function() {
          return _this12.isFullscreen(false);
        });
      }
      return promise;
    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
      this.techCall_("enterFullScreen");
    } else {
      this.enterFullWindow();
    }
  };
  _proto.exitFullscreen = function exitFullscreen() {
    var PromiseClass = this.options_.Promise || window_1.Promise;
    if (PromiseClass) {
      var self2 = this;
      return new PromiseClass(function(resolve, reject) {
        function offHandler() {
          self2.off("fullscreenerror", errorHandler);
          self2.off("fullscreenchange", changeHandler);
        }
        function changeHandler() {
          offHandler();
          resolve();
        }
        function errorHandler(e, err) {
          offHandler();
          reject(err);
        }
        self2.one("fullscreenchange", changeHandler);
        self2.one("fullscreenerror", errorHandler);
        var promise = self2.exitFullscreenHelper_();
        if (promise) {
          promise.then(offHandler, offHandler);
          promise.then(resolve, reject);
        }
      });
    }
    return this.exitFullscreenHelper_();
  };
  _proto.exitFullscreenHelper_ = function exitFullscreenHelper_() {
    var _this13 = this;
    if (this.fsApi_.requestFullscreen) {
      var promise = document_1[this.fsApi_.exitFullscreen]();
      if (promise) {
        silencePromise(promise.then(function() {
          return _this13.isFullscreen(false);
        }));
      }
      return promise;
    } else if (this.tech_.supportsFullScreen() && !this.options_.preferFullWindow === true) {
      this.techCall_("exitFullScreen");
    } else {
      this.exitFullWindow();
    }
  };
  _proto.enterFullWindow = function enterFullWindow() {
    this.isFullscreen(true);
    this.isFullWindow = true;
    this.docOrigOverflow = document_1.documentElement.style.overflow;
    on(document_1, "keydown", this.boundFullWindowOnEscKey_);
    document_1.documentElement.style.overflow = "hidden";
    addClass(document_1.body, "vjs-full-window");
    this.trigger("enterFullWindow");
  };
  _proto.fullWindowOnEscKey = function fullWindowOnEscKey(event) {
    if (keycode.isEventKey(event, "Esc")) {
      if (this.isFullscreen() === true) {
        if (!this.isFullWindow) {
          this.exitFullscreen();
        } else {
          this.exitFullWindow();
        }
      }
    }
  };
  _proto.exitFullWindow = function exitFullWindow() {
    this.isFullscreen(false);
    this.isFullWindow = false;
    off(document_1, "keydown", this.boundFullWindowOnEscKey_);
    document_1.documentElement.style.overflow = this.docOrigOverflow;
    removeClass(document_1.body, "vjs-full-window");
    this.trigger("exitFullWindow");
  };
  _proto.disablePictureInPicture = function disablePictureInPicture(value) {
    if (value === void 0) {
      return this.techGet_("disablePictureInPicture");
    }
    this.techCall_("setDisablePictureInPicture", value);
    this.options_.disablePictureInPicture = value;
    this.trigger("disablepictureinpicturechanged");
  };
  _proto.isInPictureInPicture = function isInPictureInPicture(isPiP) {
    if (isPiP !== void 0) {
      this.isInPictureInPicture_ = !!isPiP;
      this.togglePictureInPictureClass_();
      return;
    }
    return !!this.isInPictureInPicture_;
  };
  _proto.requestPictureInPicture = function requestPictureInPicture() {
    if ("pictureInPictureEnabled" in document_1 && this.disablePictureInPicture() === false) {
      return this.techGet_("requestPictureInPicture");
    }
  };
  _proto.exitPictureInPicture = function exitPictureInPicture() {
    if ("pictureInPictureEnabled" in document_1) {
      return document_1.exitPictureInPicture();
    }
  };
  _proto.handleKeyDown = function handleKeyDown(event) {
    var userActions = this.options_.userActions;
    if (!userActions || !userActions.hotkeys) {
      return;
    }
    var excludeElement = function excludeElement2(el) {
      var tagName = el.tagName.toLowerCase();
      if (el.isContentEditable) {
        return true;
      }
      var allowedInputTypes = ["button", "checkbox", "hidden", "radio", "reset", "submit"];
      if (tagName === "input") {
        return allowedInputTypes.indexOf(el.type) === -1;
      }
      var excludedTags = ["textarea"];
      return excludedTags.indexOf(tagName) !== -1;
    };
    if (excludeElement(this.el_.ownerDocument.activeElement)) {
      return;
    }
    if (typeof userActions.hotkeys === "function") {
      userActions.hotkeys.call(this, event);
    } else {
      this.handleHotkeys(event);
    }
  };
  _proto.handleHotkeys = function handleHotkeys(event) {
    var hotkeys = this.options_.userActions ? this.options_.userActions.hotkeys : {};
    var _hotkeys$fullscreenKe = hotkeys.fullscreenKey, fullscreenKey = _hotkeys$fullscreenKe === void 0 ? function(keydownEvent) {
      return keycode.isEventKey(keydownEvent, "f");
    } : _hotkeys$fullscreenKe, _hotkeys$muteKey = hotkeys.muteKey, muteKey = _hotkeys$muteKey === void 0 ? function(keydownEvent) {
      return keycode.isEventKey(keydownEvent, "m");
    } : _hotkeys$muteKey, _hotkeys$playPauseKey = hotkeys.playPauseKey, playPauseKey = _hotkeys$playPauseKey === void 0 ? function(keydownEvent) {
      return keycode.isEventKey(keydownEvent, "k") || keycode.isEventKey(keydownEvent, "Space");
    } : _hotkeys$playPauseKey;
    if (fullscreenKey.call(this, event)) {
      event.preventDefault();
      event.stopPropagation();
      var FSToggle = Component$1.getComponent("FullscreenToggle");
      if (document_1[this.fsApi_.fullscreenEnabled] !== false) {
        FSToggle.prototype.handleClick.call(this, event);
      }
    } else if (muteKey.call(this, event)) {
      event.preventDefault();
      event.stopPropagation();
      var MuteToggle2 = Component$1.getComponent("MuteToggle");
      MuteToggle2.prototype.handleClick.call(this, event);
    } else if (playPauseKey.call(this, event)) {
      event.preventDefault();
      event.stopPropagation();
      var PlayToggle2 = Component$1.getComponent("PlayToggle");
      PlayToggle2.prototype.handleClick.call(this, event);
    }
  };
  _proto.canPlayType = function canPlayType3(type2) {
    var can;
    for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
      var techName = j[i];
      var tech = Tech.getTech(techName);
      if (!tech) {
        tech = Component$1.getComponent(techName);
      }
      if (!tech) {
        log$1.error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
        continue;
      }
      if (tech.isSupported()) {
        can = tech.canPlayType(type2);
        if (can) {
          return can;
        }
      }
    }
    return "";
  };
  _proto.selectSource = function selectSource(sources) {
    var _this14 = this;
    var techs = this.options_.techOrder.map(function(techName) {
      return [techName, Tech.getTech(techName)];
    }).filter(function(_ref2) {
      var techName = _ref2[0], tech = _ref2[1];
      if (tech) {
        return tech.isSupported();
      }
      log$1.error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
      return false;
    });
    var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair2(outerArray, innerArray, tester) {
      var found;
      outerArray.some(function(outerChoice) {
        return innerArray.some(function(innerChoice) {
          found = tester(outerChoice, innerChoice);
          if (found) {
            return true;
          }
        });
      });
      return found;
    };
    var foundSourceAndTech;
    var flip2 = function flip3(fn) {
      return function(a, b) {
        return fn(b, a);
      };
    };
    var finder = function finder2(_ref2, source) {
      var techName = _ref2[0], tech = _ref2[1];
      if (tech.canPlaySource(source, _this14.options_[techName.toLowerCase()])) {
        return {
          source,
          tech: techName
        };
      }
    };
    if (this.options_.sourceOrder) {
      foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip2(finder));
    } else {
      foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
    }
    return foundSourceAndTech || false;
  };
  _proto.handleSrc_ = function handleSrc_(source, isRetry) {
    var _this15 = this;
    if (typeof source === "undefined") {
      return this.cache_.src || "";
    }
    if (this.resetRetryOnError_) {
      this.resetRetryOnError_();
    }
    var sources = filterSource(source);
    if (!sources.length) {
      this.setTimeout(function() {
        this.error({
          code: 4,
          message: this.options_.notSupportedMessage
        });
      }, 0);
      return;
    }
    this.changingSrc_ = true;
    if (!isRetry) {
      this.cache_.sources = sources;
    }
    this.updateSourceCaches_(sources[0]);
    setSource(this, sources[0], function(middlewareSource, mws) {
      _this15.middleware_ = mws;
      if (!isRetry) {
        _this15.cache_.sources = sources;
      }
      _this15.updateSourceCaches_(middlewareSource);
      var err = _this15.src_(middlewareSource);
      if (err) {
        if (sources.length > 1) {
          return _this15.handleSrc_(sources.slice(1));
        }
        _this15.changingSrc_ = false;
        _this15.setTimeout(function() {
          this.error({
            code: 4,
            message: this.options_.notSupportedMessage
          });
        }, 0);
        _this15.triggerReady();
        return;
      }
      setTech(mws, _this15.tech_);
    });
    if (this.options_.retryOnError && sources.length > 1) {
      var retry = function retry2() {
        _this15.error(null);
        _this15.handleSrc_(sources.slice(1), true);
      };
      var stopListeningForErrors = function stopListeningForErrors2() {
        _this15.off("error", retry);
      };
      this.one("error", retry);
      this.one("playing", stopListeningForErrors);
      this.resetRetryOnError_ = function() {
        _this15.off("error", retry);
        _this15.off("playing", stopListeningForErrors);
      };
    }
  };
  _proto.src = function src(source) {
    return this.handleSrc_(source, false);
  };
  _proto.src_ = function src_(source) {
    var _this16 = this;
    var sourceTech = this.selectSource([source]);
    if (!sourceTech) {
      return true;
    }
    if (!titleCaseEquals(sourceTech.tech, this.techName_)) {
      this.changingSrc_ = true;
      this.loadTech_(sourceTech.tech, sourceTech.source);
      this.tech_.ready(function() {
        _this16.changingSrc_ = false;
      });
      return false;
    }
    this.ready(function() {
      if (this.tech_.constructor.prototype.hasOwnProperty("setSource")) {
        this.techCall_("setSource", source);
      } else {
        this.techCall_("src", source.src);
      }
      this.changingSrc_ = false;
    }, true);
    return false;
  };
  _proto.load = function load() {
    this.techCall_("load");
  };
  _proto.reset = function reset3() {
    var _this17 = this;
    var PromiseClass = this.options_.Promise || window_1.Promise;
    if (this.paused() || !PromiseClass) {
      this.doReset_();
    } else {
      var playPromise = this.play();
      silencePromise(playPromise.then(function() {
        return _this17.doReset_();
      }));
    }
  };
  _proto.doReset_ = function doReset_() {
    if (this.tech_) {
      this.tech_.clearTracks("text");
    }
    this.resetCache_();
    this.poster("");
    this.loadTech_(this.options_.techOrder[0], null);
    this.techCall_("reset");
    this.resetControlBarUI_();
    if (isEvented(this)) {
      this.trigger("playerreset");
    }
  };
  _proto.resetControlBarUI_ = function resetControlBarUI_() {
    this.resetProgressBar_();
    this.resetPlaybackRate_();
    this.resetVolumeBar_();
  };
  _proto.resetProgressBar_ = function resetProgressBar_() {
    this.currentTime(0);
    var _ref3 = this.controlBar || {}, durationDisplay = _ref3.durationDisplay, remainingTimeDisplay = _ref3.remainingTimeDisplay;
    if (durationDisplay) {
      durationDisplay.updateContent();
    }
    if (remainingTimeDisplay) {
      remainingTimeDisplay.updateContent();
    }
  };
  _proto.resetPlaybackRate_ = function resetPlaybackRate_() {
    this.playbackRate(this.defaultPlaybackRate());
    this.handleTechRateChange_();
  };
  _proto.resetVolumeBar_ = function resetVolumeBar_() {
    this.volume(1);
    this.trigger("volumechange");
  };
  _proto.currentSources = function currentSources() {
    var source = this.currentSource();
    var sources = [];
    if (Object.keys(source).length !== 0) {
      sources.push(source);
    }
    return this.cache_.sources || sources;
  };
  _proto.currentSource = function currentSource() {
    return this.cache_.source || {};
  };
  _proto.currentSrc = function currentSrc() {
    return this.currentSource() && this.currentSource().src || "";
  };
  _proto.currentType = function currentType() {
    return this.currentSource() && this.currentSource().type || "";
  };
  _proto.preload = function preload(value) {
    if (value !== void 0) {
      this.techCall_("setPreload", value);
      this.options_.preload = value;
      return;
    }
    return this.techGet_("preload");
  };
  _proto.autoplay = function autoplay(value) {
    if (value === void 0) {
      return this.options_.autoplay || false;
    }
    var techAutoplay;
    if (typeof value === "string" && /(any|play|muted)/.test(value) || value === true && this.options_.normalizeAutoplay) {
      this.options_.autoplay = value;
      this.manualAutoplay_(typeof value === "string" ? value : "play");
      techAutoplay = false;
    } else if (!value) {
      this.options_.autoplay = false;
    } else {
      this.options_.autoplay = true;
    }
    techAutoplay = typeof techAutoplay === "undefined" ? this.options_.autoplay : techAutoplay;
    if (this.tech_) {
      this.techCall_("setAutoplay", techAutoplay);
    }
  };
  _proto.playsinline = function playsinline(value) {
    if (value !== void 0) {
      this.techCall_("setPlaysinline", value);
      this.options_.playsinline = value;
      return this;
    }
    return this.techGet_("playsinline");
  };
  _proto.loop = function loop(value) {
    if (value !== void 0) {
      this.techCall_("setLoop", value);
      this.options_.loop = value;
      return;
    }
    return this.techGet_("loop");
  };
  _proto.poster = function poster(src) {
    if (src === void 0) {
      return this.poster_;
    }
    if (!src) {
      src = "";
    }
    if (src === this.poster_) {
      return;
    }
    this.poster_ = src;
    this.techCall_("setPoster", src);
    this.isPosterFromTech_ = false;
    this.trigger("posterchange");
  };
  _proto.handleTechPosterChange_ = function handleTechPosterChange_() {
    if ((!this.poster_ || this.options_.techCanOverridePoster) && this.tech_ && this.tech_.poster) {
      var newPoster = this.tech_.poster() || "";
      if (newPoster !== this.poster_) {
        this.poster_ = newPoster;
        this.isPosterFromTech_ = true;
        this.trigger("posterchange");
      }
    }
  };
  _proto.controls = function controls(bool2) {
    if (bool2 === void 0) {
      return !!this.controls_;
    }
    bool2 = !!bool2;
    if (this.controls_ === bool2) {
      return;
    }
    this.controls_ = bool2;
    if (this.usingNativeControls()) {
      this.techCall_("setControls", bool2);
    }
    if (this.controls_) {
      this.removeClass("vjs-controls-disabled");
      this.addClass("vjs-controls-enabled");
      this.trigger("controlsenabled");
      if (!this.usingNativeControls()) {
        this.addTechControlsListeners_();
      }
    } else {
      this.removeClass("vjs-controls-enabled");
      this.addClass("vjs-controls-disabled");
      this.trigger("controlsdisabled");
      if (!this.usingNativeControls()) {
        this.removeTechControlsListeners_();
      }
    }
  };
  _proto.usingNativeControls = function usingNativeControls(bool2) {
    if (bool2 === void 0) {
      return !!this.usingNativeControls_;
    }
    bool2 = !!bool2;
    if (this.usingNativeControls_ === bool2) {
      return;
    }
    this.usingNativeControls_ = bool2;
    if (this.usingNativeControls_) {
      this.addClass("vjs-using-native-controls");
      this.trigger("usingnativecontrols");
    } else {
      this.removeClass("vjs-using-native-controls");
      this.trigger("usingcustomcontrols");
    }
  };
  _proto.error = function error2(err) {
    var _this18 = this;
    if (err === void 0) {
      return this.error_ || null;
    }
    hooks("beforeerror").forEach(function(hookFunction) {
      var newErr = hookFunction(_this18, err);
      if (!(isObject2(newErr) && !Array.isArray(newErr) || typeof newErr === "string" || typeof newErr === "number" || newErr === null)) {
        _this18.log.error("please return a value that MediaError expects in beforeerror hooks");
        return;
      }
      err = newErr;
    });
    if (this.options_.suppressNotSupportedError && err && err.code === 4) {
      var triggerSuppressedError = function triggerSuppressedError2() {
        this.error(err);
      };
      this.options_.suppressNotSupportedError = false;
      this.any(["click", "touchstart"], triggerSuppressedError);
      this.one("loadstart", function() {
        this.off(["click", "touchstart"], triggerSuppressedError);
      });
      return;
    }
    if (err === null) {
      this.error_ = err;
      this.removeClass("vjs-error");
      if (this.errorDisplay) {
        this.errorDisplay.close();
      }
      return;
    }
    this.error_ = new MediaError(err);
    this.addClass("vjs-error");
    log$1.error("(CODE:" + this.error_.code + " " + MediaError.errorTypes[this.error_.code] + ")", this.error_.message, this.error_);
    this.trigger("error");
    hooks("error").forEach(function(hookFunction) {
      return hookFunction(_this18, _this18.error_);
    });
    return;
  };
  _proto.reportUserActivity = function reportUserActivity(event) {
    this.userActivity_ = true;
  };
  _proto.userActive = function userActive(bool2) {
    if (bool2 === void 0) {
      return this.userActive_;
    }
    bool2 = !!bool2;
    if (bool2 === this.userActive_) {
      return;
    }
    this.userActive_ = bool2;
    if (this.userActive_) {
      this.userActivity_ = true;
      this.removeClass("vjs-user-inactive");
      this.addClass("vjs-user-active");
      this.trigger("useractive");
      return;
    }
    if (this.tech_) {
      this.tech_.one("mousemove", function(e) {
        e.stopPropagation();
        e.preventDefault();
      });
    }
    this.userActivity_ = false;
    this.removeClass("vjs-user-active");
    this.addClass("vjs-user-inactive");
    this.trigger("userinactive");
  };
  _proto.listenForUserActivity_ = function listenForUserActivity_() {
    var mouseInProgress;
    var lastMoveX;
    var lastMoveY;
    var handleActivity = bind(this, this.reportUserActivity);
    var handleMouseMove = function handleMouseMove2(e) {
      if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
        lastMoveX = e.screenX;
        lastMoveY = e.screenY;
        handleActivity();
      }
    };
    var handleMouseDown = function handleMouseDown2() {
      handleActivity();
      this.clearInterval(mouseInProgress);
      mouseInProgress = this.setInterval(handleActivity, 250);
    };
    var handleMouseUpAndMouseLeave = function handleMouseUpAndMouseLeave2(event) {
      handleActivity();
      this.clearInterval(mouseInProgress);
    };
    this.on("mousedown", handleMouseDown);
    this.on("mousemove", handleMouseMove);
    this.on("mouseup", handleMouseUpAndMouseLeave);
    this.on("mouseleave", handleMouseUpAndMouseLeave);
    var controlBar = this.getChild("controlBar");
    if (controlBar && !IS_IOS && !IS_ANDROID) {
      controlBar.on("mouseenter", function(event) {
        if (this.player().options_.inactivityTimeout !== 0) {
          this.player().cache_.inactivityTimeout = this.player().options_.inactivityTimeout;
        }
        this.player().options_.inactivityTimeout = 0;
      });
      controlBar.on("mouseleave", function(event) {
        this.player().options_.inactivityTimeout = this.player().cache_.inactivityTimeout;
      });
    }
    this.on("keydown", handleActivity);
    this.on("keyup", handleActivity);
    var inactivityTimeout;
    this.setInterval(function() {
      if (!this.userActivity_) {
        return;
      }
      this.userActivity_ = false;
      this.userActive(true);
      this.clearTimeout(inactivityTimeout);
      var timeout = this.options_.inactivityTimeout;
      if (timeout <= 0) {
        return;
      }
      inactivityTimeout = this.setTimeout(function() {
        if (!this.userActivity_) {
          this.userActive(false);
        }
      }, timeout);
    }, 250);
  };
  _proto.playbackRate = function playbackRate(rate) {
    if (rate !== void 0) {
      this.techCall_("setPlaybackRate", rate);
      return;
    }
    if (this.tech_ && this.tech_.featuresPlaybackRate) {
      return this.cache_.lastPlaybackRate || this.techGet_("playbackRate");
    }
    return 1;
  };
  _proto.defaultPlaybackRate = function defaultPlaybackRate(rate) {
    if (rate !== void 0) {
      return this.techCall_("setDefaultPlaybackRate", rate);
    }
    if (this.tech_ && this.tech_.featuresPlaybackRate) {
      return this.techGet_("defaultPlaybackRate");
    }
    return 1;
  };
  _proto.isAudio = function isAudio(bool2) {
    if (bool2 !== void 0) {
      this.isAudio_ = !!bool2;
      return;
    }
    return !!this.isAudio_;
  };
  _proto.enableAudioOnlyUI_ = function enableAudioOnlyUI_() {
    var _this19 = this;
    this.addClass("vjs-audio-only-mode");
    var playerChildren = this.children();
    var controlBar = this.getChild("ControlBar");
    var controlBarHeight = controlBar && controlBar.currentHeight();
    playerChildren.forEach(function(child) {
      if (child === controlBar) {
        return;
      }
      if (child.el_ && !child.hasClass("vjs-hidden")) {
        child.hide();
        _this19.audioOnlyCache_.hiddenChildren.push(child);
      }
    });
    this.audioOnlyCache_.playerHeight = this.currentHeight();
    this.height(controlBarHeight);
    this.trigger("audioonlymodechange");
  };
  _proto.disableAudioOnlyUI_ = function disableAudioOnlyUI_() {
    this.removeClass("vjs-audio-only-mode");
    this.audioOnlyCache_.hiddenChildren.forEach(function(child) {
      return child.show();
    });
    this.height(this.audioOnlyCache_.playerHeight);
    this.trigger("audioonlymodechange");
  };
  _proto.audioOnlyMode = function audioOnlyMode(value) {
    var _this20 = this;
    if (typeof value !== "boolean" || value === this.audioOnlyMode_) {
      return this.audioOnlyMode_;
    }
    this.audioOnlyMode_ = value;
    var PromiseClass = this.options_.Promise || window_1.Promise;
    if (PromiseClass) {
      if (value) {
        var exitPromises = [];
        if (this.isInPictureInPicture()) {
          exitPromises.push(this.exitPictureInPicture());
        }
        if (this.isFullscreen()) {
          exitPromises.push(this.exitFullscreen());
        }
        if (this.audioPosterMode()) {
          exitPromises.push(this.audioPosterMode(false));
        }
        return PromiseClass.all(exitPromises).then(function() {
          return _this20.enableAudioOnlyUI_();
        });
      }
      return PromiseClass.resolve().then(function() {
        return _this20.disableAudioOnlyUI_();
      });
    }
    if (value) {
      if (this.isInPictureInPicture()) {
        this.exitPictureInPicture();
      }
      if (this.isFullscreen()) {
        this.exitFullscreen();
      }
      this.enableAudioOnlyUI_();
    } else {
      this.disableAudioOnlyUI_();
    }
  };
  _proto.enablePosterModeUI_ = function enablePosterModeUI_() {
    var tech = this.tech_ && this.tech_;
    tech.hide();
    this.addClass("vjs-audio-poster-mode");
    this.trigger("audiopostermodechange");
  };
  _proto.disablePosterModeUI_ = function disablePosterModeUI_() {
    var tech = this.tech_ && this.tech_;
    tech.show();
    this.removeClass("vjs-audio-poster-mode");
    this.trigger("audiopostermodechange");
  };
  _proto.audioPosterMode = function audioPosterMode(value) {
    var _this21 = this;
    if (typeof value !== "boolean" || value === this.audioPosterMode_) {
      return this.audioPosterMode_;
    }
    this.audioPosterMode_ = value;
    var PromiseClass = this.options_.Promise || window_1.Promise;
    if (PromiseClass) {
      if (value) {
        if (this.audioOnlyMode()) {
          var audioOnlyModePromise = this.audioOnlyMode(false);
          return audioOnlyModePromise.then(function() {
            _this21.enablePosterModeUI_();
          });
        }
        return PromiseClass.resolve().then(function() {
          _this21.enablePosterModeUI_();
        });
      }
      return PromiseClass.resolve().then(function() {
        _this21.disablePosterModeUI_();
      });
    }
    if (value) {
      if (this.audioOnlyMode()) {
        this.audioOnlyMode(false);
      }
      this.enablePosterModeUI_();
      return;
    }
    this.disablePosterModeUI_();
  };
  _proto.addTextTrack = function addTextTrack(kind, label, language) {
    if (this.tech_) {
      return this.tech_.addTextTrack(kind, label, language);
    }
  };
  _proto.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
    if (this.tech_) {
      return this.tech_.addRemoteTextTrack(options, manualCleanup);
    }
  };
  _proto.removeRemoteTextTrack = function removeRemoteTextTrack(obj) {
    if (obj === void 0) {
      obj = {};
    }
    var _obj = obj, track = _obj.track;
    if (!track) {
      track = obj;
    }
    if (this.tech_) {
      return this.tech_.removeRemoteTextTrack(track);
    }
  };
  _proto.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
    return this.techGet_("getVideoPlaybackQuality");
  };
  _proto.videoWidth = function videoWidth() {
    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
  };
  _proto.videoHeight = function videoHeight() {
    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
  };
  _proto.language = function language(code) {
    if (code === void 0) {
      return this.language_;
    }
    if (this.language_ !== String(code).toLowerCase()) {
      this.language_ = String(code).toLowerCase();
      if (isEvented(this)) {
        this.trigger("languagechange");
      }
    }
  };
  _proto.languages = function languages() {
    return mergeOptions$3(Player2.prototype.options_.languages, this.languages_);
  };
  _proto.toJSON = function toJSON() {
    var options = mergeOptions$3(this.options_);
    var tracks = options.tracks;
    options.tracks = [];
    for (var i = 0; i < tracks.length; i++) {
      var track = tracks[i];
      track = mergeOptions$3(track);
      track.player = void 0;
      options.tracks[i] = track;
    }
    return options;
  };
  _proto.createModal = function createModal(content2, options) {
    var _this22 = this;
    options = options || {};
    options.content = content2 || "";
    var modal = new ModalDialog(this, options);
    this.addChild(modal);
    modal.on("dispose", function() {
      _this22.removeChild(modal);
    });
    modal.open();
    return modal;
  };
  _proto.updateCurrentBreakpoint_ = function updateCurrentBreakpoint_() {
    if (!this.responsive()) {
      return;
    }
    var currentBreakpoint = this.currentBreakpoint();
    var currentWidth = this.currentWidth();
    for (var i = 0; i < BREAKPOINT_ORDER.length; i++) {
      var candidateBreakpoint = BREAKPOINT_ORDER[i];
      var maxWidth = this.breakpoints_[candidateBreakpoint];
      if (currentWidth <= maxWidth) {
        if (currentBreakpoint === candidateBreakpoint) {
          return;
        }
        if (currentBreakpoint) {
          this.removeClass(BREAKPOINT_CLASSES[currentBreakpoint]);
        }
        this.addClass(BREAKPOINT_CLASSES[candidateBreakpoint]);
        this.breakpoint_ = candidateBreakpoint;
        break;
      }
    }
  };
  _proto.removeCurrentBreakpoint_ = function removeCurrentBreakpoint_() {
    var className = this.currentBreakpointClass();
    this.breakpoint_ = "";
    if (className) {
      this.removeClass(className);
    }
  };
  _proto.breakpoints = function breakpoints(_breakpoints) {
    if (_breakpoints === void 0) {
      return assign(this.breakpoints_);
    }
    this.breakpoint_ = "";
    this.breakpoints_ = assign({}, DEFAULT_BREAKPOINTS, _breakpoints);
    this.updateCurrentBreakpoint_();
    return assign(this.breakpoints_);
  };
  _proto.responsive = function responsive(value) {
    if (value === void 0) {
      return this.responsive_;
    }
    value = Boolean(value);
    var current = this.responsive_;
    if (value === current) {
      return;
    }
    this.responsive_ = value;
    if (value) {
      this.on("playerresize", this.boundUpdateCurrentBreakpoint_);
      this.updateCurrentBreakpoint_();
    } else {
      this.off("playerresize", this.boundUpdateCurrentBreakpoint_);
      this.removeCurrentBreakpoint_();
    }
    return value;
  };
  _proto.currentBreakpoint = function currentBreakpoint() {
    return this.breakpoint_;
  };
  _proto.currentBreakpointClass = function currentBreakpointClass() {
    return BREAKPOINT_CLASSES[this.breakpoint_] || "";
  };
  _proto.loadMedia = function loadMedia(media, ready) {
    var _this23 = this;
    if (!media || typeof media !== "object") {
      return;
    }
    this.reset();
    this.cache_.media = mergeOptions$3(media);
    var _this$cache_$media = this.cache_.media, artwork = _this$cache_$media.artwork, poster = _this$cache_$media.poster, src = _this$cache_$media.src, textTracks = _this$cache_$media.textTracks;
    if (!artwork && poster) {
      this.cache_.media.artwork = [{
        src: poster,
        type: getMimetype(poster)
      }];
    }
    if (src) {
      this.src(src);
    }
    if (poster) {
      this.poster(poster);
    }
    if (Array.isArray(textTracks)) {
      textTracks.forEach(function(tt) {
        return _this23.addRemoteTextTrack(tt, false);
      });
    }
    this.ready(ready);
  };
  _proto.getMedia = function getMedia() {
    if (!this.cache_.media) {
      var poster = this.poster();
      var src = this.currentSources();
      var textTracks = Array.prototype.map.call(this.remoteTextTracks(), function(tt) {
        return {
          kind: tt.kind,
          label: tt.label,
          language: tt.language,
          src: tt.src
        };
      });
      var media = {
        src,
        textTracks
      };
      if (poster) {
        media.poster = poster;
        media.artwork = [{
          src: media.poster,
          type: getMimetype(media.poster)
        }];
      }
      return media;
    }
    return mergeOptions$3(this.cache_.media);
  };
  Player2.getTagSettings = function getTagSettings(tag) {
    var baseOptions = {
      sources: [],
      tracks: []
    };
    var tagOptions = getAttributes(tag);
    var dataSetup = tagOptions["data-setup"];
    if (hasClass(tag, "vjs-fill")) {
      tagOptions.fill = true;
    }
    if (hasClass(tag, "vjs-fluid")) {
      tagOptions.fluid = true;
    }
    if (dataSetup !== null) {
      var _safeParseTuple = tuple(dataSetup || "{}"), err = _safeParseTuple[0], data = _safeParseTuple[1];
      if (err) {
        log$1.error(err);
      }
      assign(tagOptions, data);
    }
    assign(baseOptions, tagOptions);
    if (tag.hasChildNodes()) {
      var children = tag.childNodes;
      for (var i = 0, j = children.length; i < j; i++) {
        var child = children[i];
        var childName = child.nodeName.toLowerCase();
        if (childName === "source") {
          baseOptions.sources.push(getAttributes(child));
        } else if (childName === "track") {
          baseOptions.tracks.push(getAttributes(child));
        }
      }
    }
    return baseOptions;
  };
  _proto.flexNotSupported_ = function flexNotSupported_() {
    var elem = document_1.createElement("i");
    return !("flexBasis" in elem.style || "webkitFlexBasis" in elem.style || "mozFlexBasis" in elem.style || "msFlexBasis" in elem.style || "msFlexOrder" in elem.style);
  };
  _proto.debug = function debug(enabled) {
    if (enabled === void 0) {
      return this.debugEnabled_;
    }
    if (enabled) {
      this.trigger("debugon");
      this.previousLogLevel_ = this.log.level;
      this.log.level("debug");
      this.debugEnabled_ = true;
    } else {
      this.trigger("debugoff");
      this.log.level(this.previousLogLevel_);
      this.previousLogLevel_ = void 0;
      this.debugEnabled_ = false;
    }
  };
  _proto.playbackRates = function playbackRates(newRates) {
    if (newRates === void 0) {
      return this.cache_.playbackRates;
    }
    if (!Array.isArray(newRates)) {
      return;
    }
    if (!newRates.every(function(rate) {
      return typeof rate === "number";
    })) {
      return;
    }
    this.cache_.playbackRates = newRates;
    this.trigger("playbackrateschange");
  };
  return Player2;
}(Component$1);
ALL.names.forEach(function(name) {
  var props = ALL[name];
  Player.prototype[props.getterName] = function() {
    if (this.tech_) {
      return this.tech_[props.getterName]();
    }
    this[props.privateName] = this[props.privateName] || new props.ListClass();
    return this[props.privateName];
  };
});
Player.prototype.crossorigin = Player.prototype.crossOrigin;
Player.players = {};
var navigator$1 = window_1.navigator;
Player.prototype.options_ = {
  techOrder: Tech.defaultTechOrder_,
  html5: {},
  inactivityTimeout: 2e3,
  playbackRates: [],
  liveui: false,
  children: ["mediaLoader", "posterImage", "textTrackDisplay", "loadingSpinner", "bigPlayButton", "liveTracker", "controlBar", "errorDisplay", "textTrackSettings", "resizeManager"],
  language: navigator$1 && (navigator$1.languages && navigator$1.languages[0] || navigator$1.userLanguage || navigator$1.language) || "en",
  languages: {},
  notSupportedMessage: "No compatible source was found for this media.",
  normalizeAutoplay: false,
  fullscreen: {
    options: {
      navigationUI: "hide"
    }
  },
  breakpoints: {},
  responsive: false,
  audioOnlyMode: false,
  audioPosterMode: false
};
[
  "ended",
  "seeking",
  "seekable",
  "networkState",
  "readyState"
].forEach(function(fn) {
  Player.prototype[fn] = function() {
    return this.techGet_(fn);
  };
});
TECH_EVENTS_RETRIGGER.forEach(function(event) {
  Player.prototype["handleTech" + toTitleCase$1(event) + "_"] = function() {
    return this.trigger(event);
  };
});
Component$1.registerComponent("Player", Player);
var BASE_PLUGIN_NAME = "plugin";
var PLUGIN_CACHE_KEY = "activePlugins_";
var pluginStorage = {};
var pluginExists = function pluginExists2(name) {
  return pluginStorage.hasOwnProperty(name);
};
var getPlugin = function getPlugin2(name) {
  return pluginExists(name) ? pluginStorage[name] : void 0;
};
var markPluginAsActive = function markPluginAsActive2(player, name) {
  player[PLUGIN_CACHE_KEY] = player[PLUGIN_CACHE_KEY] || {};
  player[PLUGIN_CACHE_KEY][name] = true;
};
var triggerSetupEvent = function triggerSetupEvent2(player, hash, before2) {
  var eventName = (before2 ? "before" : "") + "pluginsetup";
  player.trigger(eventName, hash);
  player.trigger(eventName + ":" + hash.name, hash);
};
var createBasicPlugin = function createBasicPlugin2(name, plugin) {
  var basicPluginWrapper = function basicPluginWrapper2() {
    triggerSetupEvent(this, {
      name,
      plugin,
      instance: null
    }, true);
    var instance = plugin.apply(this, arguments);
    markPluginAsActive(this, name);
    triggerSetupEvent(this, {
      name,
      plugin,
      instance
    });
    return instance;
  };
  Object.keys(plugin).forEach(function(prop) {
    basicPluginWrapper[prop] = plugin[prop];
  });
  return basicPluginWrapper;
};
var createPluginFactory = function createPluginFactory2(name, PluginSubClass) {
  PluginSubClass.prototype.name = name;
  return function() {
    triggerSetupEvent(this, {
      name,
      plugin: PluginSubClass,
      instance: null
    }, true);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var instance = _construct(PluginSubClass, [this].concat(args));
    this[name] = function() {
      return instance;
    };
    triggerSetupEvent(this, instance.getEventHash());
    return instance;
  };
};
var Plugin = /* @__PURE__ */ function() {
  function Plugin2(player) {
    if (this.constructor === Plugin2) {
      throw new Error("Plugin must be sub-classed; not directly instantiated.");
    }
    this.player = player;
    if (!this.log) {
      this.log = this.player.log.createLogger(this.name);
    }
    evented(this);
    delete this.trigger;
    stateful(this, this.constructor.defaultState);
    markPluginAsActive(player, this.name);
    this.dispose = this.dispose.bind(this);
    player.on("dispose", this.dispose);
  }
  var _proto = Plugin2.prototype;
  _proto.version = function version2() {
    return this.constructor.VERSION;
  };
  _proto.getEventHash = function getEventHash(hash) {
    if (hash === void 0) {
      hash = {};
    }
    hash.name = this.name;
    hash.plugin = this.constructor;
    hash.instance = this;
    return hash;
  };
  _proto.trigger = function trigger$12(event, hash) {
    if (hash === void 0) {
      hash = {};
    }
    return trigger(this.eventBusEl_, event, this.getEventHash(hash));
  };
  _proto.handleStateChanged = function handleStateChanged(e) {
  };
  _proto.dispose = function dispose() {
    var name = this.name, player = this.player;
    this.trigger("dispose");
    this.off();
    player.off("dispose", this.dispose);
    player[PLUGIN_CACHE_KEY][name] = false;
    this.player = this.state = null;
    player[name] = createPluginFactory(name, pluginStorage[name]);
  };
  Plugin2.isBasic = function isBasic(plugin) {
    var p2 = typeof plugin === "string" ? getPlugin(plugin) : plugin;
    return typeof p2 === "function" && !Plugin2.prototype.isPrototypeOf(p2.prototype);
  };
  Plugin2.registerPlugin = function registerPlugin(name, plugin) {
    if (typeof name !== "string") {
      throw new Error('Illegal plugin name, "' + name + '", must be a string, was ' + typeof name + ".");
    }
    if (pluginExists(name)) {
      log$1.warn('A plugin named "' + name + '" already exists. You may want to avoid re-registering plugins!');
    } else if (Player.prototype.hasOwnProperty(name)) {
      throw new Error('Illegal plugin name, "' + name + '", cannot share a name with an existing player method!');
    }
    if (typeof plugin !== "function") {
      throw new Error('Illegal plugin for "' + name + '", must be a function, was ' + typeof plugin + ".");
    }
    pluginStorage[name] = plugin;
    if (name !== BASE_PLUGIN_NAME) {
      if (Plugin2.isBasic(plugin)) {
        Player.prototype[name] = createBasicPlugin(name, plugin);
      } else {
        Player.prototype[name] = createPluginFactory(name, plugin);
      }
    }
    return plugin;
  };
  Plugin2.deregisterPlugin = function deregisterPlugin(name) {
    if (name === BASE_PLUGIN_NAME) {
      throw new Error("Cannot de-register base plugin.");
    }
    if (pluginExists(name)) {
      delete pluginStorage[name];
      delete Player.prototype[name];
    }
  };
  Plugin2.getPlugins = function getPlugins(names) {
    if (names === void 0) {
      names = Object.keys(pluginStorage);
    }
    var result2;
    names.forEach(function(name) {
      var plugin = getPlugin(name);
      if (plugin) {
        result2 = result2 || {};
        result2[name] = plugin;
      }
    });
    return result2;
  };
  Plugin2.getPluginVersion = function getPluginVersion(name) {
    var plugin = getPlugin(name);
    return plugin && plugin.VERSION || "";
  };
  return Plugin2;
}();
Plugin.getPlugin = getPlugin;
Plugin.BASE_PLUGIN_NAME = BASE_PLUGIN_NAME;
Plugin.registerPlugin(BASE_PLUGIN_NAME, Plugin);
Player.prototype.usingPlugin = function(name) {
  return !!this[PLUGIN_CACHE_KEY] && this[PLUGIN_CACHE_KEY][name] === true;
};
Player.prototype.hasPlugin = function(name) {
  return !!pluginExists(name);
};
var hasLogged = false;
var extend = function extend2(superClass, subClassMethods) {
  if (subClassMethods === void 0) {
    subClassMethods = {};
  }
  if (!hasLogged) {
    log$1.warn("videojs.extend is deprecated as of Video.js 7.22.0 and will be removed in Video.js 8.0.0");
    hasLogged = true;
  }
  var subClass = function subClass2() {
    superClass.apply(this, arguments);
  };
  var methods = {};
  if (typeof subClassMethods === "object") {
    if (subClassMethods.constructor !== Object.prototype.constructor) {
      subClass = subClassMethods.constructor;
    }
    methods = subClassMethods;
  } else if (typeof subClassMethods === "function") {
    subClass = subClassMethods;
  }
  _inherits(subClass, superClass);
  if (superClass) {
    subClass.super_ = superClass;
  }
  for (var name in methods) {
    if (methods.hasOwnProperty(name)) {
      subClass.prototype[name] = methods[name];
    }
  }
  return subClass;
};
var normalizeId = function normalizeId2(id2) {
  return id2.indexOf("#") === 0 ? id2.slice(1) : id2;
};
function videojs(id2, options, ready) {
  var player = videojs.getPlayer(id2);
  if (player) {
    if (options) {
      log$1.warn('Player "' + id2 + '" is already initialised. Options will not be applied.');
    }
    if (ready) {
      player.ready(ready);
    }
    return player;
  }
  var el = typeof id2 === "string" ? $("#" + normalizeId(id2)) : id2;
  if (!isEl(el)) {
    throw new TypeError("The element or ID supplied is not valid. (videojs)");
  }
  if (!el.ownerDocument.defaultView || !el.ownerDocument.body.contains(el)) {
    log$1.warn("The element supplied is not included in the DOM");
  }
  options = options || {};
  if (options.restoreEl === true) {
    options.restoreEl = (el.parentNode && el.parentNode.hasAttribute("data-vjs-player") ? el.parentNode : el).cloneNode(true);
  }
  hooks("beforesetup").forEach(function(hookFunction) {
    var opts = hookFunction(el, mergeOptions$3(options));
    if (!isObject2(opts) || Array.isArray(opts)) {
      log$1.error("please return an object in beforesetup hooks");
      return;
    }
    options = mergeOptions$3(options, opts);
  });
  var PlayerComponent = Component$1.getComponent("Player");
  player = new PlayerComponent(el, options, ready);
  hooks("setup").forEach(function(hookFunction) {
    return hookFunction(player);
  });
  return player;
}
videojs.hooks_ = hooks_;
videojs.hooks = hooks;
videojs.hook = hook;
videojs.hookOnce = hookOnce;
videojs.removeHook = removeHook;
if (window_1.VIDEOJS_NO_DYNAMIC_STYLE !== true && isReal()) {
  var style = $(".vjs-styles-defaults");
  if (!style) {
    style = createStyleElement("vjs-styles-defaults");
    var head = $("head");
    if (head) {
      head.insertBefore(style, head.firstChild);
    }
    setTextContent(style, "\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid:not(.vjs-audio-only-mode) {\n        padding-top: 56.25%\n      }\n    ");
  }
}
autoSetupTimeout(1, videojs);
videojs.VERSION = version$5;
videojs.options = Player.prototype.options_;
videojs.getPlayers = function() {
  return Player.players;
};
videojs.getPlayer = function(id2) {
  var players = Player.players;
  var tag;
  if (typeof id2 === "string") {
    var nId = normalizeId(id2);
    var player = players[nId];
    if (player) {
      return player;
    }
    tag = $("#" + nId);
  } else {
    tag = id2;
  }
  if (isEl(tag)) {
    var _tag = tag, _player = _tag.player, playerId = _tag.playerId;
    if (_player || players[playerId]) {
      return _player || players[playerId];
    }
  }
};
videojs.getAllPlayers = function() {
  return Object.keys(Player.players).map(function(k) {
    return Player.players[k];
  }).filter(Boolean);
};
videojs.players = Player.players;
videojs.getComponent = Component$1.getComponent;
videojs.registerComponent = function(name, comp) {
  if (Tech.isTech(comp)) {
    log$1.warn("The " + name + " tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)");
  }
  Component$1.registerComponent.call(Component$1, name, comp);
};
videojs.getTech = Tech.getTech;
videojs.registerTech = Tech.registerTech;
videojs.use = use;
Object.defineProperty(videojs, "middleware", {
  value: {},
  writeable: false,
  enumerable: true
});
Object.defineProperty(videojs.middleware, "TERMINATOR", {
  value: TERMINATOR,
  writeable: false,
  enumerable: true
});
videojs.browser = browser;
videojs.TOUCH_ENABLED = TOUCH_ENABLED;
videojs.extend = extend;
videojs.mergeOptions = mergeOptions$3;
videojs.bind = bind;
videojs.registerPlugin = Plugin.registerPlugin;
videojs.deregisterPlugin = Plugin.deregisterPlugin;
videojs.plugin = function(name, plugin) {
  log$1.warn("videojs.plugin() is deprecated; use videojs.registerPlugin() instead");
  return Plugin.registerPlugin(name, plugin);
};
videojs.getPlugins = Plugin.getPlugins;
videojs.getPlugin = Plugin.getPlugin;
videojs.getPluginVersion = Plugin.getPluginVersion;
videojs.addLanguage = function(code, data) {
  var _mergeOptions;
  code = ("" + code).toLowerCase();
  videojs.options.languages = mergeOptions$3(videojs.options.languages, (_mergeOptions = {}, _mergeOptions[code] = data, _mergeOptions));
  return videojs.options.languages[code];
};
videojs.log = log$1;
videojs.createLogger = createLogger;
videojs.createTimeRange = videojs.createTimeRanges = createTimeRanges;
videojs.formatTime = formatTime;
videojs.setFormatTime = setFormatTime;
videojs.resetFormatTime = resetFormatTime;
videojs.parseUrl = parseUrl;
videojs.isCrossOrigin = isCrossOrigin;
videojs.EventTarget = EventTarget$2;
videojs.on = on;
videojs.one = one;
videojs.off = off;
videojs.trigger = trigger;
videojs.xhr = XHR;
videojs.TextTrack = TextTrack;
videojs.AudioTrack = AudioTrack;
videojs.VideoTrack = VideoTrack;
["isEl", "isTextNode", "createEl", "hasClass", "addClass", "removeClass", "toggleClass", "setAttributes", "getAttributes", "emptyEl", "appendContent", "insertContent"].forEach(function(k) {
  videojs[k] = function() {
    log$1.warn("videojs." + k + "() is deprecated; use videojs.dom." + k + "() instead");
    return Dom[k].apply(null, arguments);
  };
});
videojs.computedStyle = computedStyle;
videojs.dom = Dom;
videojs.url = Url;
videojs.defineLazyProperty = defineLazyProperty;
videojs.addLanguage("en", {
  "Non-Fullscreen": "Exit Fullscreen"
});
/*! @name @videojs/http-streaming @version 2.16.2 @license Apache-2.0 */
var resolveUrl2 = resolveUrl$1;
var resolveManifestRedirect = function resolveManifestRedirect2(handleManifestRedirect, url, req) {
  if (handleManifestRedirect && req && req.responseURL && url !== req.responseURL) {
    return req.responseURL;
  }
  return url;
};
var logger = function logger2(source) {
  if (videojs.log.debug) {
    return videojs.log.debug.bind(videojs, "VHS:", source + " >");
  }
  return function() {
  };
};
var TIME_FUDGE_FACTOR = 1 / 30;
var SAFE_TIME_DELTA = TIME_FUDGE_FACTOR * 3;
var filterRanges = function filterRanges2(timeRanges, predicate) {
  var results = [];
  var i;
  if (timeRanges && timeRanges.length) {
    for (i = 0; i < timeRanges.length; i++) {
      if (predicate(timeRanges.start(i), timeRanges.end(i))) {
        results.push([timeRanges.start(i), timeRanges.end(i)]);
      }
    }
  }
  return videojs.createTimeRanges(results);
};
var findRange = function findRange2(buffered, time) {
  return filterRanges(buffered, function(start2, end3) {
    return start2 - SAFE_TIME_DELTA <= time && end3 + SAFE_TIME_DELTA >= time;
  });
};
var findNextRange = function findNextRange2(timeRanges, time) {
  return filterRanges(timeRanges, function(start2) {
    return start2 - TIME_FUDGE_FACTOR >= time;
  });
};
var findGaps = function findGaps2(buffered) {
  if (buffered.length < 2) {
    return videojs.createTimeRanges();
  }
  var ranges = [];
  for (var i = 1; i < buffered.length; i++) {
    var start2 = buffered.end(i - 1);
    var end3 = buffered.start(i);
    ranges.push([start2, end3]);
  }
  return videojs.createTimeRanges(ranges);
};
var bufferIntersection = function bufferIntersection2(bufferA, bufferB) {
  var start2 = null;
  var end3 = null;
  var arity = 0;
  var extents = [];
  var ranges = [];
  if (!bufferA || !bufferA.length || !bufferB || !bufferB.length) {
    return videojs.createTimeRange();
  }
  var count = bufferA.length;
  while (count--) {
    extents.push({
      time: bufferA.start(count),
      type: "start"
    });
    extents.push({
      time: bufferA.end(count),
      type: "end"
    });
  }
  count = bufferB.length;
  while (count--) {
    extents.push({
      time: bufferB.start(count),
      type: "start"
    });
    extents.push({
      time: bufferB.end(count),
      type: "end"
    });
  }
  extents.sort(function(a, b) {
    return a.time - b.time;
  });
  for (count = 0; count < extents.length; count++) {
    if (extents[count].type === "start") {
      arity++;
      if (arity === 2) {
        start2 = extents[count].time;
      }
    } else if (extents[count].type === "end") {
      arity--;
      if (arity === 1) {
        end3 = extents[count].time;
      }
    }
    if (start2 !== null && end3 !== null) {
      ranges.push([start2, end3]);
      start2 = null;
      end3 = null;
    }
  }
  return videojs.createTimeRanges(ranges);
};
var printableRange = function printableRange2(range3) {
  var strArr = [];
  if (!range3 || !range3.length) {
    return "";
  }
  for (var i = 0; i < range3.length; i++) {
    strArr.push(range3.start(i) + " => " + range3.end(i));
  }
  return strArr.join(", ");
};
var timeUntilRebuffer = function timeUntilRebuffer2(buffered, currentTime, playbackRate) {
  if (playbackRate === void 0) {
    playbackRate = 1;
  }
  var bufferedEnd = buffered.length ? buffered.end(buffered.length - 1) : 0;
  return (bufferedEnd - currentTime) / playbackRate;
};
var timeRangesToArray = function timeRangesToArray2(timeRanges) {
  var timeRangesList = [];
  for (var i = 0; i < timeRanges.length; i++) {
    timeRangesList.push({
      start: timeRanges.start(i),
      end: timeRanges.end(i)
    });
  }
  return timeRangesList;
};
var isRangeDifferent = function isRangeDifferent2(a, b) {
  if (a === b) {
    return false;
  }
  if (!a && b || !b && a) {
    return true;
  }
  if (a.length !== b.length) {
    return true;
  }
  for (var i = 0; i < a.length; i++) {
    if (a.start(i) !== b.start(i) || a.end(i) !== b.end(i)) {
      return true;
    }
  }
  return false;
};
var lastBufferedEnd = function lastBufferedEnd2(a) {
  if (!a || !a.length || !a.end) {
    return;
  }
  return a.end(a.length - 1);
};
var timeAheadOf = function timeAheadOf2(range3, startTime) {
  var time = 0;
  if (!range3 || !range3.length) {
    return time;
  }
  for (var i = 0; i < range3.length; i++) {
    var start2 = range3.start(i);
    var end3 = range3.end(i);
    if (startTime > end3) {
      continue;
    }
    if (startTime > start2 && startTime <= end3) {
      time += end3 - startTime;
      continue;
    }
    time += end3 - start2;
  }
  return time;
};
var createTimeRange = videojs.createTimeRange;
var segmentDurationWithParts = function segmentDurationWithParts2(playlist, segment) {
  if (!segment.preload) {
    return segment.duration;
  }
  var result2 = 0;
  (segment.parts || []).forEach(function(p2) {
    result2 += p2.duration;
  });
  (segment.preloadHints || []).forEach(function(p2) {
    if (p2.type === "PART") {
      result2 += playlist.partTargetDuration;
    }
  });
  return result2;
};
var getPartsAndSegments = function getPartsAndSegments2(playlist) {
  return (playlist.segments || []).reduce(function(acc, segment, si2) {
    if (segment.parts) {
      segment.parts.forEach(function(part, pi2) {
        acc.push({
          duration: part.duration,
          segmentIndex: si2,
          partIndex: pi2,
          part,
          segment
        });
      });
    } else {
      acc.push({
        duration: segment.duration,
        segmentIndex: si2,
        partIndex: null,
        segment,
        part: null
      });
    }
    return acc;
  }, []);
};
var getLastParts = function getLastParts2(media) {
  var lastSegment = media.segments && media.segments.length && media.segments[media.segments.length - 1];
  return lastSegment && lastSegment.parts || [];
};
var getKnownPartCount = function getKnownPartCount2(_ref2) {
  var preloadSegment = _ref2.preloadSegment;
  if (!preloadSegment) {
    return;
  }
  var parts = preloadSegment.parts, preloadHints = preloadSegment.preloadHints;
  var partCount = (preloadHints || []).reduce(function(count, hint) {
    return count + (hint.type === "PART" ? 1 : 0);
  }, 0);
  partCount += parts && parts.length ? parts.length : 0;
  return partCount;
};
var liveEdgeDelay = function liveEdgeDelay2(master, media) {
  if (media.endList) {
    return 0;
  }
  if (master && master.suggestedPresentationDelay) {
    return master.suggestedPresentationDelay;
  }
  var hasParts = getLastParts(media).length > 0;
  if (hasParts && media.serverControl && media.serverControl.partHoldBack) {
    return media.serverControl.partHoldBack;
  } else if (hasParts && media.partTargetDuration) {
    return media.partTargetDuration * 3;
  } else if (media.serverControl && media.serverControl.holdBack) {
    return media.serverControl.holdBack;
  } else if (media.targetDuration) {
    return media.targetDuration * 3;
  }
  return 0;
};
var backwardDuration = function backwardDuration2(playlist, endSequence) {
  var result2 = 0;
  var i = endSequence - playlist.mediaSequence;
  var segment = playlist.segments[i];
  if (segment) {
    if (typeof segment.start !== "undefined") {
      return {
        result: segment.start,
        precise: true
      };
    }
    if (typeof segment.end !== "undefined") {
      return {
        result: segment.end - segment.duration,
        precise: true
      };
    }
  }
  while (i--) {
    segment = playlist.segments[i];
    if (typeof segment.end !== "undefined") {
      return {
        result: result2 + segment.end,
        precise: true
      };
    }
    result2 += segmentDurationWithParts(playlist, segment);
    if (typeof segment.start !== "undefined") {
      return {
        result: result2 + segment.start,
        precise: true
      };
    }
  }
  return {
    result: result2,
    precise: false
  };
};
var forwardDuration = function forwardDuration2(playlist, endSequence) {
  var result2 = 0;
  var segment;
  var i = endSequence - playlist.mediaSequence;
  for (; i < playlist.segments.length; i++) {
    segment = playlist.segments[i];
    if (typeof segment.start !== "undefined") {
      return {
        result: segment.start - result2,
        precise: true
      };
    }
    result2 += segmentDurationWithParts(playlist, segment);
    if (typeof segment.end !== "undefined") {
      return {
        result: segment.end - result2,
        precise: true
      };
    }
  }
  return {
    result: -1,
    precise: false
  };
};
var intervalDuration = function intervalDuration2(playlist, endSequence, expired) {
  if (typeof endSequence === "undefined") {
    endSequence = playlist.mediaSequence + playlist.segments.length;
  }
  if (endSequence < playlist.mediaSequence) {
    return 0;
  }
  var backward = backwardDuration(playlist, endSequence);
  if (backward.precise) {
    return backward.result;
  }
  var forward = forwardDuration(playlist, endSequence);
  if (forward.precise) {
    return forward.result;
  }
  return backward.result + expired;
};
var duration2 = function duration3(playlist, endSequence, expired) {
  if (!playlist) {
    return 0;
  }
  if (typeof expired !== "number") {
    expired = 0;
  }
  if (typeof endSequence === "undefined") {
    if (playlist.totalDuration) {
      return playlist.totalDuration;
    }
    if (!playlist.endList) {
      return window_1.Infinity;
    }
  }
  return intervalDuration(playlist, endSequence, expired);
};
var sumDurations = function sumDurations2(_ref2) {
  var defaultDuration = _ref2.defaultDuration, durationList = _ref2.durationList, startIndex = _ref2.startIndex, endIndex = _ref2.endIndex;
  var durations = 0;
  if (startIndex > endIndex) {
    var _ref3 = [endIndex, startIndex];
    startIndex = _ref3[0];
    endIndex = _ref3[1];
  }
  if (startIndex < 0) {
    for (var i = startIndex; i < Math.min(0, endIndex); i++) {
      durations += defaultDuration;
    }
    startIndex = 0;
  }
  for (var _i = startIndex; _i < endIndex; _i++) {
    durations += durationList[_i].duration;
  }
  return durations;
};
var playlistEnd = function playlistEnd2(playlist, expired, useSafeLiveEnd, liveEdgePadding) {
  if (!playlist || !playlist.segments) {
    return null;
  }
  if (playlist.endList) {
    return duration2(playlist);
  }
  if (expired === null) {
    return null;
  }
  expired = expired || 0;
  var lastSegmentEndTime = intervalDuration(playlist, playlist.mediaSequence + playlist.segments.length, expired);
  if (useSafeLiveEnd) {
    liveEdgePadding = typeof liveEdgePadding === "number" ? liveEdgePadding : liveEdgeDelay(null, playlist);
    lastSegmentEndTime -= liveEdgePadding;
  }
  return Math.max(0, lastSegmentEndTime);
};
var seekable = function seekable2(playlist, expired, liveEdgePadding) {
  var useSafeLiveEnd = true;
  var seekableStart = expired || 0;
  var seekableEnd = playlistEnd(playlist, expired, useSafeLiveEnd, liveEdgePadding);
  if (seekableEnd === null) {
    return createTimeRange();
  }
  return createTimeRange(seekableStart, seekableEnd);
};
var getMediaInfoForTime = function getMediaInfoForTime2(_ref4) {
  var playlist = _ref4.playlist, currentTime = _ref4.currentTime, startingSegmentIndex = _ref4.startingSegmentIndex, startingPartIndex = _ref4.startingPartIndex, startTime = _ref4.startTime, experimentalExactManifestTimings = _ref4.experimentalExactManifestTimings;
  var time = currentTime - startTime;
  var partsAndSegments = getPartsAndSegments(playlist);
  var startIndex = 0;
  for (var i = 0; i < partsAndSegments.length; i++) {
    var partAndSegment = partsAndSegments[i];
    if (startingSegmentIndex !== partAndSegment.segmentIndex) {
      continue;
    }
    if (typeof startingPartIndex === "number" && typeof partAndSegment.partIndex === "number" && startingPartIndex !== partAndSegment.partIndex) {
      continue;
    }
    startIndex = i;
    break;
  }
  if (time < 0) {
    if (startIndex > 0) {
      for (var _i2 = startIndex - 1; _i2 >= 0; _i2--) {
        var _partAndSegment = partsAndSegments[_i2];
        time += _partAndSegment.duration;
        if (experimentalExactManifestTimings) {
          if (time < 0) {
            continue;
          }
        } else if (time + TIME_FUDGE_FACTOR <= 0) {
          continue;
        }
        return {
          partIndex: _partAndSegment.partIndex,
          segmentIndex: _partAndSegment.segmentIndex,
          startTime: startTime - sumDurations({
            defaultDuration: playlist.targetDuration,
            durationList: partsAndSegments,
            startIndex,
            endIndex: _i2
          })
        };
      }
    }
    return {
      partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
      segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
      startTime: currentTime
    };
  }
  if (startIndex < 0) {
    for (var _i3 = startIndex; _i3 < 0; _i3++) {
      time -= playlist.targetDuration;
      if (time < 0) {
        return {
          partIndex: partsAndSegments[0] && partsAndSegments[0].partIndex || null,
          segmentIndex: partsAndSegments[0] && partsAndSegments[0].segmentIndex || 0,
          startTime: currentTime
        };
      }
    }
    startIndex = 0;
  }
  for (var _i4 = startIndex; _i4 < partsAndSegments.length; _i4++) {
    var _partAndSegment2 = partsAndSegments[_i4];
    time -= _partAndSegment2.duration;
    if (experimentalExactManifestTimings) {
      if (time > 0) {
        continue;
      }
    } else if (time - TIME_FUDGE_FACTOR >= 0) {
      continue;
    }
    return {
      partIndex: _partAndSegment2.partIndex,
      segmentIndex: _partAndSegment2.segmentIndex,
      startTime: startTime + sumDurations({
        defaultDuration: playlist.targetDuration,
        durationList: partsAndSegments,
        startIndex,
        endIndex: _i4
      })
    };
  }
  return {
    segmentIndex: partsAndSegments[partsAndSegments.length - 1].segmentIndex,
    partIndex: partsAndSegments[partsAndSegments.length - 1].partIndex,
    startTime: currentTime
  };
};
var isBlacklisted = function isBlacklisted2(playlist) {
  return playlist.excludeUntil && playlist.excludeUntil > Date.now();
};
var isIncompatible = function isIncompatible2(playlist) {
  return playlist.excludeUntil && playlist.excludeUntil === Infinity;
};
var isEnabled = function isEnabled2(playlist) {
  var blacklisted = isBlacklisted(playlist);
  return !playlist.disabled && !blacklisted;
};
var isDisabled = function isDisabled2(playlist) {
  return playlist.disabled;
};
var isAes = function isAes2(media) {
  for (var i = 0; i < media.segments.length; i++) {
    if (media.segments[i].key) {
      return true;
    }
  }
  return false;
};
var hasAttribute = function hasAttribute2(attr, playlist) {
  return playlist.attributes && playlist.attributes[attr];
};
var estimateSegmentRequestTime = function estimateSegmentRequestTime2(segmentDuration, bandwidth2, playlist, bytesReceived) {
  if (bytesReceived === void 0) {
    bytesReceived = 0;
  }
  if (!hasAttribute("BANDWIDTH", playlist)) {
    return NaN;
  }
  var size = segmentDuration * playlist.attributes.BANDWIDTH;
  return (size - bytesReceived * 8) / bandwidth2;
};
var isLowestEnabledRendition = function isLowestEnabledRendition2(master, media) {
  if (master.playlists.length === 1) {
    return true;
  }
  var currentBandwidth = media.attributes.BANDWIDTH || Number.MAX_VALUE;
  return master.playlists.filter(function(playlist) {
    if (!isEnabled(playlist)) {
      return false;
    }
    return (playlist.attributes.BANDWIDTH || 0) < currentBandwidth;
  }).length === 0;
};
var playlistMatch = function playlistMatch2(a, b) {
  if (!a && !b || !a && b || a && !b) {
    return false;
  }
  if (a === b) {
    return true;
  }
  if (a.id && b.id && a.id === b.id) {
    return true;
  }
  if (a.resolvedUri && b.resolvedUri && a.resolvedUri === b.resolvedUri) {
    return true;
  }
  if (a.uri && b.uri && a.uri === b.uri) {
    return true;
  }
  return false;
};
var someAudioVariant = function someAudioVariant2(master, callback2) {
  var AUDIO5 = master && master.mediaGroups && master.mediaGroups.AUDIO || {};
  var found = false;
  for (var groupName in AUDIO5) {
    for (var label in AUDIO5[groupName]) {
      found = callback2(AUDIO5[groupName][label]);
      if (found) {
        break;
      }
    }
    if (found) {
      break;
    }
  }
  return !!found;
};
var isAudioOnly = function isAudioOnly2(master) {
  if (!master || !master.playlists || !master.playlists.length) {
    var found = someAudioVariant(master, function(variant) {
      return variant.playlists && variant.playlists.length || variant.uri;
    });
    return found;
  }
  var _loop = function _loop2(i2) {
    var playlist = master.playlists[i2];
    var CODECS = playlist.attributes && playlist.attributes.CODECS;
    if (CODECS && CODECS.split(",").every(function(c) {
      return isAudioCodec(c);
    })) {
      return "continue";
    }
    var found2 = someAudioVariant(master, function(variant) {
      return playlistMatch(playlist, variant);
    });
    if (found2) {
      return "continue";
    }
    return {
      v: false
    };
  };
  for (var i = 0; i < master.playlists.length; i++) {
    var _ret = _loop(i);
    if (_ret === "continue")
      continue;
    if (typeof _ret === "object")
      return _ret.v;
  }
  return true;
};
var Playlist = {
  liveEdgeDelay,
  duration: duration2,
  seekable,
  getMediaInfoForTime,
  isEnabled,
  isDisabled,
  isBlacklisted,
  isIncompatible,
  playlistEnd,
  isAes,
  hasAttribute,
  estimateSegmentRequestTime,
  isLowestEnabledRendition,
  isAudioOnly,
  playlistMatch,
  segmentDurationWithParts
};
var log$2 = videojs.log;
var createPlaylistID = function createPlaylistID2(index, uri) {
  return index + "-" + uri;
};
var groupID = function groupID2(type2, group, label) {
  return "placeholder-uri-" + type2 + "-" + group + "-" + label;
};
var parseManifest = function parseManifest2(_ref2) {
  var onwarn = _ref2.onwarn, oninfo = _ref2.oninfo, manifestString = _ref2.manifestString, _ref$customTagParsers = _ref2.customTagParsers, customTagParsers = _ref$customTagParsers === void 0 ? [] : _ref$customTagParsers, _ref$customTagMappers = _ref2.customTagMappers, customTagMappers = _ref$customTagMappers === void 0 ? [] : _ref$customTagMappers, experimentalLLHLS = _ref2.experimentalLLHLS;
  var parser2 = new Parser();
  if (onwarn) {
    parser2.on("warn", onwarn);
  }
  if (oninfo) {
    parser2.on("info", oninfo);
  }
  customTagParsers.forEach(function(customParser) {
    return parser2.addParser(customParser);
  });
  customTagMappers.forEach(function(mapper) {
    return parser2.addTagMapper(mapper);
  });
  parser2.push(manifestString);
  parser2.end();
  var manifest = parser2.manifest;
  if (!experimentalLLHLS) {
    ["preloadSegment", "skip", "serverControl", "renditionReports", "partInf", "partTargetDuration"].forEach(function(k) {
      if (manifest.hasOwnProperty(k)) {
        delete manifest[k];
      }
    });
    if (manifest.segments) {
      manifest.segments.forEach(function(segment) {
        ["parts", "preloadHints"].forEach(function(k) {
          if (segment.hasOwnProperty(k)) {
            delete segment[k];
          }
        });
      });
    }
  }
  if (!manifest.targetDuration) {
    var targetDuration = 10;
    if (manifest.segments && manifest.segments.length) {
      targetDuration = manifest.segments.reduce(function(acc, s) {
        return Math.max(acc, s.duration);
      }, 0);
    }
    if (onwarn) {
      onwarn("manifest has no targetDuration defaulting to " + targetDuration);
    }
    manifest.targetDuration = targetDuration;
  }
  var parts = getLastParts(manifest);
  if (parts.length && !manifest.partTargetDuration) {
    var partTargetDuration = parts.reduce(function(acc, p2) {
      return Math.max(acc, p2.duration);
    }, 0);
    if (onwarn) {
      onwarn("manifest has no partTargetDuration defaulting to " + partTargetDuration);
      log$2.error("LL-HLS manifest has parts but lacks required #EXT-X-PART-INF:PART-TARGET value. See https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis-09#section-4.4.3.7. Playback is not guaranteed.");
    }
    manifest.partTargetDuration = partTargetDuration;
  }
  return manifest;
};
var forEachMediaGroup2 = function forEachMediaGroup3(master, callback2) {
  if (!master.mediaGroups) {
    return;
  }
  ["AUDIO", "SUBTITLES"].forEach(function(mediaType) {
    if (!master.mediaGroups[mediaType]) {
      return;
    }
    for (var groupKey in master.mediaGroups[mediaType]) {
      for (var labelKey in master.mediaGroups[mediaType][groupKey]) {
        var mediaProperties = master.mediaGroups[mediaType][groupKey][labelKey];
        callback2(mediaProperties, mediaType, groupKey, labelKey);
      }
    }
  });
};
var setupMediaPlaylist = function setupMediaPlaylist2(_ref2) {
  var playlist = _ref2.playlist, uri = _ref2.uri, id2 = _ref2.id;
  playlist.id = id2;
  playlist.playlistErrors_ = 0;
  if (uri) {
    playlist.uri = uri;
  }
  playlist.attributes = playlist.attributes || {};
};
var setupMediaPlaylists = function setupMediaPlaylists2(master) {
  var i = master.playlists.length;
  while (i--) {
    var playlist = master.playlists[i];
    setupMediaPlaylist({
      playlist,
      id: createPlaylistID(i, playlist.uri)
    });
    playlist.resolvedUri = resolveUrl2(master.uri, playlist.uri);
    master.playlists[playlist.id] = playlist;
    master.playlists[playlist.uri] = playlist;
    if (!playlist.attributes.BANDWIDTH) {
      log$2.warn("Invalid playlist STREAM-INF detected. Missing BANDWIDTH attribute.");
    }
  }
};
var resolveMediaGroupUris = function resolveMediaGroupUris2(master) {
  forEachMediaGroup2(master, function(properties) {
    if (properties.uri) {
      properties.resolvedUri = resolveUrl2(master.uri, properties.uri);
    }
  });
};
var masterForMedia = function masterForMedia2(media, uri) {
  var id2 = createPlaylistID(0, uri);
  var master = {
    mediaGroups: {
      "AUDIO": {},
      "VIDEO": {},
      "CLOSED-CAPTIONS": {},
      "SUBTITLES": {}
    },
    uri: window_1.location.href,
    resolvedUri: window_1.location.href,
    playlists: [{
      uri,
      id: id2,
      resolvedUri: uri,
      attributes: {}
    }]
  };
  master.playlists[id2] = master.playlists[0];
  master.playlists[uri] = master.playlists[0];
  return master;
};
var addPropertiesToMaster = function addPropertiesToMaster2(master, uri, createGroupID) {
  if (createGroupID === void 0) {
    createGroupID = groupID;
  }
  master.uri = uri;
  for (var i = 0; i < master.playlists.length; i++) {
    if (!master.playlists[i].uri) {
      var phonyUri = "placeholder-uri-" + i;
      master.playlists[i].uri = phonyUri;
    }
  }
  var audioOnlyMaster = isAudioOnly(master);
  forEachMediaGroup2(master, function(properties, mediaType, groupKey, labelKey) {
    if (!properties.playlists || !properties.playlists.length) {
      if (audioOnlyMaster && mediaType === "AUDIO" && !properties.uri) {
        for (var _i = 0; _i < master.playlists.length; _i++) {
          var p2 = master.playlists[_i];
          if (p2.attributes && p2.attributes.AUDIO && p2.attributes.AUDIO === groupKey) {
            return;
          }
        }
      }
      properties.playlists = [_extends$2({}, properties)];
    }
    properties.playlists.forEach(function(p3, i2) {
      var groupId = createGroupID(mediaType, groupKey, labelKey, p3);
      var id2 = createPlaylistID(i2, groupId);
      if (p3.uri) {
        p3.resolvedUri = p3.resolvedUri || resolveUrl2(master.uri, p3.uri);
      } else {
        p3.uri = i2 === 0 ? groupId : id2;
        p3.resolvedUri = p3.uri;
      }
      p3.id = p3.id || id2;
      p3.attributes = p3.attributes || {};
      master.playlists[p3.id] = p3;
      master.playlists[p3.uri] = p3;
    });
  });
  setupMediaPlaylists(master);
  resolveMediaGroupUris(master);
};
var mergeOptions$2 = videojs.mergeOptions, EventTarget$1 = videojs.EventTarget;
var addLLHLSQueryDirectives = function addLLHLSQueryDirectives2(uri, media) {
  if (media.endList || !media.serverControl) {
    return uri;
  }
  var parameters = {};
  if (media.serverControl.canBlockReload) {
    var preloadSegment = media.preloadSegment;
    var nextMSN = media.mediaSequence + media.segments.length;
    if (preloadSegment) {
      var parts = preloadSegment.parts || [];
      var nextPart = getKnownPartCount(media) - 1;
      if (nextPart > -1 && nextPart !== parts.length - 1) {
        parameters._HLS_part = nextPart;
      }
      if (nextPart > -1 || parts.length) {
        nextMSN--;
      }
    }
    parameters._HLS_msn = nextMSN;
  }
  if (media.serverControl && media.serverControl.canSkipUntil) {
    parameters._HLS_skip = media.serverControl.canSkipDateranges ? "v2" : "YES";
  }
  if (Object.keys(parameters).length) {
    var parsedUri = new window_1.URL(uri);
    ["_HLS_skip", "_HLS_msn", "_HLS_part"].forEach(function(name) {
      if (!parameters.hasOwnProperty(name)) {
        return;
      }
      parsedUri.searchParams.set(name, parameters[name]);
    });
    uri = parsedUri.toString();
  }
  return uri;
};
var updateSegment = function updateSegment2(a, b) {
  if (!a) {
    return b;
  }
  var result2 = mergeOptions$2(a, b);
  if (a.preloadHints && !b.preloadHints) {
    delete result2.preloadHints;
  }
  if (a.parts && !b.parts) {
    delete result2.parts;
  } else if (a.parts && b.parts) {
    for (var i = 0; i < b.parts.length; i++) {
      if (a.parts && a.parts[i]) {
        result2.parts[i] = mergeOptions$2(a.parts[i], b.parts[i]);
      }
    }
  }
  if (!a.skipped && b.skipped) {
    result2.skipped = false;
  }
  if (a.preload && !b.preload) {
    result2.preload = false;
  }
  return result2;
};
var updateSegments = function updateSegments2(original, update2, offset2) {
  var oldSegments = original.slice();
  var newSegments = update2.slice();
  offset2 = offset2 || 0;
  var result2 = [];
  var currentMap;
  for (var newIndex = 0; newIndex < newSegments.length; newIndex++) {
    var oldSegment = oldSegments[newIndex + offset2];
    var newSegment = newSegments[newIndex];
    if (oldSegment) {
      currentMap = oldSegment.map || currentMap;
      result2.push(updateSegment(oldSegment, newSegment));
    } else {
      if (currentMap && !newSegment.map) {
        newSegment.map = currentMap;
      }
      result2.push(newSegment);
    }
  }
  return result2;
};
var resolveSegmentUris = function resolveSegmentUris2(segment, baseUri) {
  if (!segment.resolvedUri && segment.uri) {
    segment.resolvedUri = resolveUrl2(baseUri, segment.uri);
  }
  if (segment.key && !segment.key.resolvedUri) {
    segment.key.resolvedUri = resolveUrl2(baseUri, segment.key.uri);
  }
  if (segment.map && !segment.map.resolvedUri) {
    segment.map.resolvedUri = resolveUrl2(baseUri, segment.map.uri);
  }
  if (segment.map && segment.map.key && !segment.map.key.resolvedUri) {
    segment.map.key.resolvedUri = resolveUrl2(baseUri, segment.map.key.uri);
  }
  if (segment.parts && segment.parts.length) {
    segment.parts.forEach(function(p2) {
      if (p2.resolvedUri) {
        return;
      }
      p2.resolvedUri = resolveUrl2(baseUri, p2.uri);
    });
  }
  if (segment.preloadHints && segment.preloadHints.length) {
    segment.preloadHints.forEach(function(p2) {
      if (p2.resolvedUri) {
        return;
      }
      p2.resolvedUri = resolveUrl2(baseUri, p2.uri);
    });
  }
};
var getAllSegments = function getAllSegments2(media) {
  var segments = media.segments || [];
  var preloadSegment = media.preloadSegment;
  if (preloadSegment && preloadSegment.parts && preloadSegment.parts.length) {
    if (preloadSegment.preloadHints) {
      for (var i = 0; i < preloadSegment.preloadHints.length; i++) {
        if (preloadSegment.preloadHints[i].type === "MAP") {
          return segments;
        }
      }
    }
    preloadSegment.duration = media.targetDuration;
    preloadSegment.preload = true;
    segments.push(preloadSegment);
  }
  return segments;
};
var isPlaylistUnchanged = function isPlaylistUnchanged2(a, b) {
  return a === b || a.segments && b.segments && a.segments.length === b.segments.length && a.endList === b.endList && a.mediaSequence === b.mediaSequence && a.preloadSegment === b.preloadSegment;
};
var updateMaster$1 = function updateMaster(master, newMedia, unchangedCheck) {
  if (unchangedCheck === void 0) {
    unchangedCheck = isPlaylistUnchanged;
  }
  var result2 = mergeOptions$2(master, {});
  var oldMedia = result2.playlists[newMedia.id];
  if (!oldMedia) {
    return null;
  }
  if (unchangedCheck(oldMedia, newMedia)) {
    return null;
  }
  newMedia.segments = getAllSegments(newMedia);
  var mergedPlaylist = mergeOptions$2(oldMedia, newMedia);
  if (mergedPlaylist.preloadSegment && !newMedia.preloadSegment) {
    delete mergedPlaylist.preloadSegment;
  }
  if (oldMedia.segments) {
    if (newMedia.skip) {
      newMedia.segments = newMedia.segments || [];
      for (var i = 0; i < newMedia.skip.skippedSegments; i++) {
        newMedia.segments.unshift({
          skipped: true
        });
      }
    }
    mergedPlaylist.segments = updateSegments(oldMedia.segments, newMedia.segments, newMedia.mediaSequence - oldMedia.mediaSequence);
  }
  mergedPlaylist.segments.forEach(function(segment) {
    resolveSegmentUris(segment, mergedPlaylist.resolvedUri);
  });
  for (var _i = 0; _i < result2.playlists.length; _i++) {
    if (result2.playlists[_i].id === newMedia.id) {
      result2.playlists[_i] = mergedPlaylist;
    }
  }
  result2.playlists[newMedia.id] = mergedPlaylist;
  result2.playlists[newMedia.uri] = mergedPlaylist;
  forEachMediaGroup2(master, function(properties, mediaType, groupKey, labelKey) {
    if (!properties.playlists) {
      return;
    }
    for (var _i2 = 0; _i2 < properties.playlists.length; _i2++) {
      if (newMedia.id === properties.playlists[_i2].id) {
        properties.playlists[_i2] = mergedPlaylist;
      }
    }
  });
  return result2;
};
var refreshDelay = function refreshDelay2(media, update2) {
  var segments = media.segments || [];
  var lastSegment = segments[segments.length - 1];
  var lastPart = lastSegment && lastSegment.parts && lastSegment.parts[lastSegment.parts.length - 1];
  var lastDuration = lastPart && lastPart.duration || lastSegment && lastSegment.duration;
  if (update2 && lastDuration) {
    return lastDuration * 1e3;
  }
  return (media.partTargetDuration || media.targetDuration || 10) * 500;
};
var PlaylistLoader = /* @__PURE__ */ function(_EventTarget) {
  _inheritsLoose(PlaylistLoader2, _EventTarget);
  function PlaylistLoader2(src, vhs, options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _EventTarget.call(this) || this;
    if (!src) {
      throw new Error("A non-empty playlist URL or object is required");
    }
    _this.logger_ = logger("PlaylistLoader");
    var _options = options, _options$withCredenti = _options.withCredentials, withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti, _options$handleManife = _options.handleManifestRedirects, handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
    _this.src = src;
    _this.vhs_ = vhs;
    _this.withCredentials = withCredentials;
    _this.handleManifestRedirects = handleManifestRedirects;
    var vhsOptions = vhs.options_;
    _this.customTagParsers = vhsOptions && vhsOptions.customTagParsers || [];
    _this.customTagMappers = vhsOptions && vhsOptions.customTagMappers || [];
    _this.experimentalLLHLS = vhsOptions && vhsOptions.experimentalLLHLS || false;
    if (videojs.browser.IE_VERSION) {
      _this.experimentalLLHLS = false;
    }
    _this.state = "HAVE_NOTHING";
    _this.handleMediaupdatetimeout_ = _this.handleMediaupdatetimeout_.bind(_assertThisInitialized(_this));
    _this.on("mediaupdatetimeout", _this.handleMediaupdatetimeout_);
    return _this;
  }
  var _proto = PlaylistLoader2.prototype;
  _proto.handleMediaupdatetimeout_ = function handleMediaupdatetimeout_() {
    var _this2 = this;
    if (this.state !== "HAVE_METADATA") {
      return;
    }
    var media = this.media();
    var uri = resolveUrl2(this.master.uri, media.uri);
    if (this.experimentalLLHLS) {
      uri = addLLHLSQueryDirectives(uri, media);
    }
    this.state = "HAVE_CURRENT_METADATA";
    this.request = this.vhs_.xhr({
      uri,
      withCredentials: this.withCredentials
    }, function(error2, req) {
      if (!_this2.request) {
        return;
      }
      if (error2) {
        return _this2.playlistRequestError(_this2.request, _this2.media(), "HAVE_METADATA");
      }
      _this2.haveMetadata({
        playlistString: _this2.request.responseText,
        url: _this2.media().uri,
        id: _this2.media().id
      });
    });
  };
  _proto.playlistRequestError = function playlistRequestError(xhr, playlist, startingState) {
    var uri = playlist.uri, id2 = playlist.id;
    this.request = null;
    if (startingState) {
      this.state = startingState;
    }
    this.error = {
      playlist: this.master.playlists[id2],
      status: xhr.status,
      message: "HLS playlist request error at URL: " + uri + ".",
      responseText: xhr.responseText,
      code: xhr.status >= 500 ? 4 : 2
    };
    this.trigger("error");
  };
  _proto.parseManifest_ = function parseManifest_(_ref2) {
    var _this3 = this;
    var url = _ref2.url, manifestString = _ref2.manifestString;
    return parseManifest({
      onwarn: function onwarn(_ref22) {
        var message = _ref22.message;
        return _this3.logger_("m3u8-parser warn for " + url + ": " + message);
      },
      oninfo: function oninfo(_ref3) {
        var message = _ref3.message;
        return _this3.logger_("m3u8-parser info for " + url + ": " + message);
      },
      manifestString,
      customTagParsers: this.customTagParsers,
      customTagMappers: this.customTagMappers,
      experimentalLLHLS: this.experimentalLLHLS
    });
  };
  _proto.haveMetadata = function haveMetadata(_ref4) {
    var playlistString = _ref4.playlistString, playlistObject = _ref4.playlistObject, url = _ref4.url, id2 = _ref4.id;
    this.request = null;
    this.state = "HAVE_METADATA";
    var playlist = playlistObject || this.parseManifest_({
      url,
      manifestString: playlistString
    });
    playlist.lastRequest = Date.now();
    setupMediaPlaylist({
      playlist,
      uri: url,
      id: id2
    });
    var update2 = updateMaster$1(this.master, playlist);
    this.targetDuration = playlist.partTargetDuration || playlist.targetDuration;
    this.pendingMedia_ = null;
    if (update2) {
      this.master = update2;
      this.media_ = this.master.playlists[id2];
    } else {
      this.trigger("playlistunchanged");
    }
    this.updateMediaUpdateTimeout_(refreshDelay(this.media(), !!update2));
    this.trigger("loadedplaylist");
  };
  _proto.dispose = function dispose() {
    this.trigger("dispose");
    this.stopRequest();
    window_1.clearTimeout(this.mediaUpdateTimeout);
    window_1.clearTimeout(this.finalRenditionTimeout);
    this.off();
  };
  _proto.stopRequest = function stopRequest() {
    if (this.request) {
      var oldRequest = this.request;
      this.request = null;
      oldRequest.onreadystatechange = null;
      oldRequest.abort();
    }
  };
  _proto.media = function media(playlist, shouldDelay) {
    var _this4 = this;
    if (!playlist) {
      return this.media_;
    }
    if (this.state === "HAVE_NOTHING") {
      throw new Error("Cannot switch media playlist from " + this.state);
    }
    if (typeof playlist === "string") {
      if (!this.master.playlists[playlist]) {
        throw new Error("Unknown playlist URI: " + playlist);
      }
      playlist = this.master.playlists[playlist];
    }
    window_1.clearTimeout(this.finalRenditionTimeout);
    if (shouldDelay) {
      var delay = (playlist.partTargetDuration || playlist.targetDuration) / 2 * 1e3 || 5 * 1e3;
      this.finalRenditionTimeout = window_1.setTimeout(this.media.bind(this, playlist, false), delay);
      return;
    }
    var startingState = this.state;
    var mediaChange = !this.media_ || playlist.id !== this.media_.id;
    var masterPlaylistRef = this.master.playlists[playlist.id];
    if (masterPlaylistRef && masterPlaylistRef.endList || playlist.endList && playlist.segments.length) {
      if (this.request) {
        this.request.onreadystatechange = null;
        this.request.abort();
        this.request = null;
      }
      this.state = "HAVE_METADATA";
      this.media_ = playlist;
      if (mediaChange) {
        this.trigger("mediachanging");
        if (startingState === "HAVE_MASTER") {
          this.trigger("loadedmetadata");
        } else {
          this.trigger("mediachange");
        }
      }
      return;
    }
    this.updateMediaUpdateTimeout_(refreshDelay(playlist, true));
    if (!mediaChange) {
      return;
    }
    this.state = "SWITCHING_MEDIA";
    if (this.request) {
      if (playlist.resolvedUri === this.request.url) {
        return;
      }
      this.request.onreadystatechange = null;
      this.request.abort();
      this.request = null;
    }
    if (this.media_) {
      this.trigger("mediachanging");
    }
    this.pendingMedia_ = playlist;
    this.request = this.vhs_.xhr({
      uri: playlist.resolvedUri,
      withCredentials: this.withCredentials
    }, function(error2, req) {
      if (!_this4.request) {
        return;
      }
      playlist.lastRequest = Date.now();
      playlist.resolvedUri = resolveManifestRedirect(_this4.handleManifestRedirects, playlist.resolvedUri, req);
      if (error2) {
        return _this4.playlistRequestError(_this4.request, playlist, startingState);
      }
      _this4.haveMetadata({
        playlistString: req.responseText,
        url: playlist.uri,
        id: playlist.id
      });
      if (startingState === "HAVE_MASTER") {
        _this4.trigger("loadedmetadata");
      } else {
        _this4.trigger("mediachange");
      }
    });
  };
  _proto.pause = function pause() {
    if (this.mediaUpdateTimeout) {
      window_1.clearTimeout(this.mediaUpdateTimeout);
      this.mediaUpdateTimeout = null;
    }
    this.stopRequest();
    if (this.state === "HAVE_NOTHING") {
      this.started = false;
    }
    if (this.state === "SWITCHING_MEDIA") {
      if (this.media_) {
        this.state = "HAVE_METADATA";
      } else {
        this.state = "HAVE_MASTER";
      }
    } else if (this.state === "HAVE_CURRENT_METADATA") {
      this.state = "HAVE_METADATA";
    }
  };
  _proto.load = function load(shouldDelay) {
    var _this5 = this;
    if (this.mediaUpdateTimeout) {
      window_1.clearTimeout(this.mediaUpdateTimeout);
      this.mediaUpdateTimeout = null;
    }
    var media = this.media();
    if (shouldDelay) {
      var delay = media ? (media.partTargetDuration || media.targetDuration) / 2 * 1e3 : 5 * 1e3;
      this.mediaUpdateTimeout = window_1.setTimeout(function() {
        _this5.mediaUpdateTimeout = null;
        _this5.load();
      }, delay);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    if (media && !media.endList) {
      this.trigger("mediaupdatetimeout");
    } else {
      this.trigger("loadedplaylist");
    }
  };
  _proto.updateMediaUpdateTimeout_ = function updateMediaUpdateTimeout_(delay) {
    var _this6 = this;
    if (this.mediaUpdateTimeout) {
      window_1.clearTimeout(this.mediaUpdateTimeout);
      this.mediaUpdateTimeout = null;
    }
    if (!this.media() || this.media().endList) {
      return;
    }
    this.mediaUpdateTimeout = window_1.setTimeout(function() {
      _this6.mediaUpdateTimeout = null;
      _this6.trigger("mediaupdatetimeout");
      _this6.updateMediaUpdateTimeout_(delay);
    }, delay);
  };
  _proto.start = function start2() {
    var _this7 = this;
    this.started = true;
    if (typeof this.src === "object") {
      if (!this.src.uri) {
        this.src.uri = window_1.location.href;
      }
      this.src.resolvedUri = this.src.uri;
      setTimeout(function() {
        _this7.setupInitialPlaylist(_this7.src);
      }, 0);
      return;
    }
    this.request = this.vhs_.xhr({
      uri: this.src,
      withCredentials: this.withCredentials
    }, function(error2, req) {
      if (!_this7.request) {
        return;
      }
      _this7.request = null;
      if (error2) {
        _this7.error = {
          status: req.status,
          message: "HLS playlist request error at URL: " + _this7.src + ".",
          responseText: req.responseText,
          code: 2
        };
        if (_this7.state === "HAVE_NOTHING") {
          _this7.started = false;
        }
        return _this7.trigger("error");
      }
      _this7.src = resolveManifestRedirect(_this7.handleManifestRedirects, _this7.src, req);
      var manifest = _this7.parseManifest_({
        manifestString: req.responseText,
        url: _this7.src
      });
      _this7.setupInitialPlaylist(manifest);
    });
  };
  _proto.srcUri = function srcUri() {
    return typeof this.src === "string" ? this.src : this.src.uri;
  };
  _proto.setupInitialPlaylist = function setupInitialPlaylist(manifest) {
    this.state = "HAVE_MASTER";
    if (manifest.playlists) {
      this.master = manifest;
      addPropertiesToMaster(this.master, this.srcUri());
      manifest.playlists.forEach(function(playlist) {
        playlist.segments = getAllSegments(playlist);
        playlist.segments.forEach(function(segment) {
          resolveSegmentUris(segment, playlist.resolvedUri);
        });
      });
      this.trigger("loadedplaylist");
      if (!this.request) {
        this.media(this.master.playlists[0]);
      }
      return;
    }
    var uri = this.srcUri() || window_1.location.href;
    this.master = masterForMedia(manifest, uri);
    this.haveMetadata({
      playlistObject: manifest,
      url: uri,
      id: this.master.playlists[0].id
    });
    this.trigger("loadedmetadata");
  };
  return PlaylistLoader2;
}(EventTarget$1);
var videojsXHR = videojs.xhr, mergeOptions$1 = videojs.mergeOptions;
var callbackWrapper = function callbackWrapper2(request, error2, response, callback2) {
  var reqResponse = request.responseType === "arraybuffer" ? request.response : request.responseText;
  if (!error2 && reqResponse) {
    request.responseTime = Date.now();
    request.roundTripTime = request.responseTime - request.requestTime;
    request.bytesReceived = reqResponse.byteLength || reqResponse.length;
    if (!request.bandwidth) {
      request.bandwidth = Math.floor(request.bytesReceived / request.roundTripTime * 8 * 1e3);
    }
  }
  if (response.headers) {
    request.responseHeaders = response.headers;
  }
  if (error2 && error2.code === "ETIMEDOUT") {
    request.timedout = true;
  }
  if (!error2 && !request.aborted && response.statusCode !== 200 && response.statusCode !== 206 && response.statusCode !== 0) {
    error2 = new Error("XHR Failed with a response of: " + (request && (reqResponse || request.responseText)));
  }
  callback2(error2, request);
};
var xhrFactory = function xhrFactory2() {
  var xhr = function XhrFunction(options, callback2) {
    options = mergeOptions$1({
      timeout: 45e3
    }, options);
    var beforeRequest = XhrFunction.beforeRequest || videojs.Vhs.xhr.beforeRequest;
    if (beforeRequest && typeof beforeRequest === "function") {
      var newOptions = beforeRequest(options);
      if (newOptions) {
        options = newOptions;
      }
    }
    var xhrMethod = videojs.Vhs.xhr.original === true ? videojsXHR : videojs.Vhs.xhr;
    var request = xhrMethod(options, function(error2, response) {
      return callbackWrapper(request, error2, response, callback2);
    });
    var originalAbort = request.abort;
    request.abort = function() {
      request.aborted = true;
      return originalAbort.apply(request, arguments);
    };
    request.uri = options.uri;
    request.requestTime = Date.now();
    return request;
  };
  xhr.original = true;
  return xhr;
};
var byterangeStr = function byterangeStr2(byterange) {
  var byterangeEnd;
  var byterangeStart = byterange.offset;
  if (typeof byterange.offset === "bigint" || typeof byterange.length === "bigint") {
    byterangeEnd = window_1.BigInt(byterange.offset) + window_1.BigInt(byterange.length) - window_1.BigInt(1);
  } else {
    byterangeEnd = byterange.offset + byterange.length - 1;
  }
  return "bytes=" + byterangeStart + "-" + byterangeEnd;
};
var segmentXhrHeaders = function segmentXhrHeaders2(segment) {
  var headers = {};
  if (segment.byterange) {
    headers.Range = byterangeStr(segment.byterange);
  }
  return headers;
};
var textRange = function textRange2(range3, i) {
  return range3.start(i) + "-" + range3.end(i);
};
var formatHexString = function formatHexString2(e, i) {
  var value = e.toString(16);
  return "00".substring(0, 2 - value.length) + value + (i % 2 ? " " : "");
};
var formatAsciiString = function formatAsciiString2(e) {
  if (e >= 32 && e < 126) {
    return String.fromCharCode(e);
  }
  return ".";
};
var createTransferableMessage = function createTransferableMessage2(message) {
  var transferable = {};
  Object.keys(message).forEach(function(key) {
    var value = message[key];
    if (isArrayBufferView(value)) {
      transferable[key] = {
        bytes: value.buffer,
        byteOffset: value.byteOffset,
        byteLength: value.byteLength
      };
    } else {
      transferable[key] = value;
    }
  });
  return transferable;
};
var initSegmentId = function initSegmentId2(initSegment) {
  var byterange = initSegment.byterange || {
    length: Infinity,
    offset: 0
  };
  return [byterange.length, byterange.offset, initSegment.resolvedUri].join(",");
};
var segmentKeyId = function segmentKeyId2(key) {
  return key.resolvedUri;
};
var hexDump = function hexDump2(data) {
  var bytes = Array.prototype.slice.call(data);
  var step = 16;
  var result2 = "";
  var hex;
  var ascii;
  for (var j = 0; j < bytes.length / step; j++) {
    hex = bytes.slice(j * step, j * step + step).map(formatHexString).join("");
    ascii = bytes.slice(j * step, j * step + step).map(formatAsciiString).join("");
    result2 += hex + " " + ascii + "\n";
  }
  return result2;
};
var tagDump = function tagDump2(_ref2) {
  var bytes = _ref2.bytes;
  return hexDump(bytes);
};
var textRanges = function textRanges2(ranges) {
  var result2 = "";
  var i;
  for (i = 0; i < ranges.length; i++) {
    result2 += textRange(ranges, i) + " ";
  }
  return result2;
};
var utils = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  createTransferableMessage,
  initSegmentId,
  segmentKeyId,
  hexDump,
  tagDump,
  textRanges
});
var SEGMENT_END_FUDGE_PERCENT = 0.25;
var playerTimeToProgramTime = function playerTimeToProgramTime2(playerTime, segment) {
  if (!segment.dateTimeObject) {
    return null;
  }
  var transmuxerPrependedSeconds = segment.videoTimingInfo.transmuxerPrependedSeconds;
  var transmuxedStart = segment.videoTimingInfo.transmuxedPresentationStart;
  var startOfSegment = transmuxedStart + transmuxerPrependedSeconds;
  var offsetFromSegmentStart = playerTime - startOfSegment;
  return new Date(segment.dateTimeObject.getTime() + offsetFromSegmentStart * 1e3);
};
var originalSegmentVideoDuration = function originalSegmentVideoDuration2(videoTimingInfo) {
  return videoTimingInfo.transmuxedPresentationEnd - videoTimingInfo.transmuxedPresentationStart - videoTimingInfo.transmuxerPrependedSeconds;
};
var findSegmentForProgramTime = function findSegmentForProgramTime2(programTime, playlist) {
  var dateTimeObject;
  try {
    dateTimeObject = new Date(programTime);
  } catch (e) {
    return null;
  }
  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
    return null;
  }
  var segment = playlist.segments[0];
  if (dateTimeObject < segment.dateTimeObject) {
    return null;
  }
  for (var i = 0; i < playlist.segments.length - 1; i++) {
    segment = playlist.segments[i];
    var nextSegmentStart = playlist.segments[i + 1].dateTimeObject;
    if (dateTimeObject < nextSegmentStart) {
      break;
    }
  }
  var lastSegment = playlist.segments[playlist.segments.length - 1];
  var lastSegmentStart = lastSegment.dateTimeObject;
  var lastSegmentDuration = lastSegment.videoTimingInfo ? originalSegmentVideoDuration(lastSegment.videoTimingInfo) : lastSegment.duration + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT;
  var lastSegmentEnd = new Date(lastSegmentStart.getTime() + lastSegmentDuration * 1e3);
  if (dateTimeObject > lastSegmentEnd) {
    return null;
  }
  if (dateTimeObject > lastSegmentStart) {
    segment = lastSegment;
  }
  return {
    segment,
    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : Playlist.duration(playlist, playlist.mediaSequence + playlist.segments.indexOf(segment)),
    type: segment.videoTimingInfo ? "accurate" : "estimate"
  };
};
var findSegmentForPlayerTime = function findSegmentForPlayerTime2(time, playlist) {
  if (!playlist || !playlist.segments || playlist.segments.length === 0) {
    return null;
  }
  var segmentEnd = 0;
  var segment;
  for (var i = 0; i < playlist.segments.length; i++) {
    segment = playlist.segments[i];
    segmentEnd = segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationEnd : segmentEnd + segment.duration;
    if (time <= segmentEnd) {
      break;
    }
  }
  var lastSegment = playlist.segments[playlist.segments.length - 1];
  if (lastSegment.videoTimingInfo && lastSegment.videoTimingInfo.transmuxedPresentationEnd < time) {
    return null;
  }
  if (time > segmentEnd) {
    if (time > segmentEnd + lastSegment.duration * SEGMENT_END_FUDGE_PERCENT) {
      return null;
    }
    segment = lastSegment;
  }
  return {
    segment,
    estimatedStart: segment.videoTimingInfo ? segment.videoTimingInfo.transmuxedPresentationStart : segmentEnd - segment.duration,
    type: segment.videoTimingInfo ? "accurate" : "estimate"
  };
};
var getOffsetFromTimestamp = function getOffsetFromTimestamp2(comparisonTimeStamp, programTime) {
  var segmentDateTime;
  var programDateTime;
  try {
    segmentDateTime = new Date(comparisonTimeStamp);
    programDateTime = new Date(programTime);
  } catch (e) {
  }
  var segmentTimeEpoch = segmentDateTime.getTime();
  var programTimeEpoch = programDateTime.getTime();
  return (programTimeEpoch - segmentTimeEpoch) / 1e3;
};
var verifyProgramDateTimeTags = function verifyProgramDateTimeTags2(playlist) {
  if (!playlist.segments || playlist.segments.length === 0) {
    return false;
  }
  for (var i = 0; i < playlist.segments.length; i++) {
    var segment = playlist.segments[i];
    if (!segment.dateTimeObject) {
      return false;
    }
  }
  return true;
};
var getProgramTime = function getProgramTime2(_ref2) {
  var playlist = _ref2.playlist, _ref$time = _ref2.time, time = _ref$time === void 0 ? void 0 : _ref$time, callback2 = _ref2.callback;
  if (!callback2) {
    throw new Error("getProgramTime: callback must be provided");
  }
  if (!playlist || time === void 0) {
    return callback2({
      message: "getProgramTime: playlist and time must be provided"
    });
  }
  var matchedSegment = findSegmentForPlayerTime(time, playlist);
  if (!matchedSegment) {
    return callback2({
      message: "valid programTime was not found"
    });
  }
  if (matchedSegment.type === "estimate") {
    return callback2({
      message: "Accurate programTime could not be determined. Please seek to e.seekTime and try again",
      seekTime: matchedSegment.estimatedStart
    });
  }
  var programTimeObject = {
    mediaSeconds: time
  };
  var programTime = playerTimeToProgramTime(time, matchedSegment.segment);
  if (programTime) {
    programTimeObject.programDateTime = programTime.toISOString();
  }
  return callback2(null, programTimeObject);
};
var seekToProgramTime = function seekToProgramTime2(_ref2) {
  var programTime = _ref2.programTime, playlist = _ref2.playlist, _ref2$retryCount = _ref2.retryCount, retryCount = _ref2$retryCount === void 0 ? 2 : _ref2$retryCount, seekTo = _ref2.seekTo, _ref2$pauseAfterSeek = _ref2.pauseAfterSeek, pauseAfterSeek = _ref2$pauseAfterSeek === void 0 ? true : _ref2$pauseAfterSeek, tech = _ref2.tech, callback2 = _ref2.callback;
  if (!callback2) {
    throw new Error("seekToProgramTime: callback must be provided");
  }
  if (typeof programTime === "undefined" || !playlist || !seekTo) {
    return callback2({
      message: "seekToProgramTime: programTime, seekTo and playlist must be provided"
    });
  }
  if (!playlist.endList && !tech.hasStarted_) {
    return callback2({
      message: "player must be playing a live stream to start buffering"
    });
  }
  if (!verifyProgramDateTimeTags(playlist)) {
    return callback2({
      message: "programDateTime tags must be provided in the manifest " + playlist.resolvedUri
    });
  }
  var matchedSegment = findSegmentForProgramTime(programTime, playlist);
  if (!matchedSegment) {
    return callback2({
      message: programTime + " was not found in the stream"
    });
  }
  var segment = matchedSegment.segment;
  var mediaOffset = getOffsetFromTimestamp(segment.dateTimeObject, programTime);
  if (matchedSegment.type === "estimate") {
    if (retryCount === 0) {
      return callback2({
        message: programTime + " is not buffered yet. Try again"
      });
    }
    seekTo(matchedSegment.estimatedStart + mediaOffset);
    tech.one("seeked", function() {
      seekToProgramTime2({
        programTime,
        playlist,
        retryCount: retryCount - 1,
        seekTo,
        pauseAfterSeek,
        tech,
        callback: callback2
      });
    });
    return;
  }
  var seekToTime = segment.start + mediaOffset;
  var seekedCallback = function seekedCallback2() {
    return callback2(null, tech.currentTime());
  };
  tech.one("seeked", seekedCallback);
  if (pauseAfterSeek) {
    tech.pause();
  }
  seekTo(seekToTime);
};
var callbackOnCompleted = function callbackOnCompleted2(request, cb2) {
  if (request.readyState === 4) {
    return cb2();
  }
  return;
};
var containerRequest = function containerRequest2(uri, xhr, cb2) {
  var bytes = [];
  var id3Offset;
  var finished = false;
  var endRequestAndCallback = function endRequestAndCallback2(err, req, type2, _bytes) {
    req.abort();
    finished = true;
    return cb2(err, req, type2, _bytes);
  };
  var progressListener = function progressListener2(error2, request2) {
    if (finished) {
      return;
    }
    if (error2) {
      return endRequestAndCallback(error2, request2, "", bytes);
    }
    var newPart = request2.responseText.substring(bytes && bytes.byteLength || 0, request2.responseText.length);
    bytes = concatTypedArrays(bytes, stringToBytes(newPart, true));
    id3Offset = id3Offset || getId3Offset(bytes);
    if (bytes.length < 10 || id3Offset && bytes.length < id3Offset + 2) {
      return callbackOnCompleted(request2, function() {
        return endRequestAndCallback(error2, request2, "", bytes);
      });
    }
    var type2 = detectContainerForBytes(bytes);
    if (type2 === "ts" && bytes.length < 188) {
      return callbackOnCompleted(request2, function() {
        return endRequestAndCallback(error2, request2, "", bytes);
      });
    }
    if (!type2 && bytes.length < 376) {
      return callbackOnCompleted(request2, function() {
        return endRequestAndCallback(error2, request2, "", bytes);
      });
    }
    return endRequestAndCallback(null, request2, type2, bytes);
  };
  var options = {
    uri,
    beforeSend: function beforeSend(request2) {
      request2.overrideMimeType("text/plain; charset=x-user-defined");
      request2.addEventListener("progress", function(_ref2) {
        _ref2.total;
        _ref2.loaded;
        return callbackWrapper(request2, null, {
          statusCode: request2.status
        }, progressListener);
      });
    }
  };
  var request = xhr(options, function(error2, response) {
    return callbackWrapper(request, error2, response, progressListener);
  });
  return request;
};
var EventTarget2 = videojs.EventTarget, mergeOptions = videojs.mergeOptions;
var dashPlaylistUnchanged = function dashPlaylistUnchanged2(a, b) {
  if (!isPlaylistUnchanged(a, b)) {
    return false;
  }
  if (a.sidx && b.sidx && (a.sidx.offset !== b.sidx.offset || a.sidx.length !== b.sidx.length)) {
    return false;
  } else if (!a.sidx && b.sidx || a.sidx && !b.sidx) {
    return false;
  }
  if (a.segments && !b.segments || !a.segments && b.segments) {
    return false;
  }
  if (!a.segments && !b.segments) {
    return true;
  }
  for (var i = 0; i < a.segments.length; i++) {
    var aSegment = a.segments[i];
    var bSegment = b.segments[i];
    if (aSegment.uri !== bSegment.uri) {
      return false;
    }
    if (!aSegment.byterange && !bSegment.byterange) {
      continue;
    }
    var aByterange = aSegment.byterange;
    var bByterange = bSegment.byterange;
    if (aByterange && !bByterange || !aByterange && bByterange) {
      return false;
    }
    if (aByterange.offset !== bByterange.offset || aByterange.length !== bByterange.length) {
      return false;
    }
  }
  return true;
};
var dashGroupId = function dashGroupId2(type2, group, label, playlist) {
  var playlistId = playlist.attributes.NAME || label;
  return "placeholder-uri-" + type2 + "-" + group + "-" + playlistId;
};
var parseMasterXml = function parseMasterXml2(_ref2) {
  var masterXml = _ref2.masterXml, srcUrl = _ref2.srcUrl, clientOffset = _ref2.clientOffset, sidxMapping = _ref2.sidxMapping, previousManifest = _ref2.previousManifest;
  var manifest = parse$2(masterXml, {
    manifestUri: srcUrl,
    clientOffset,
    sidxMapping,
    previousManifest
  });
  addPropertiesToMaster(manifest, srcUrl, dashGroupId);
  return manifest;
};
var removeOldMediaGroupLabels = function removeOldMediaGroupLabels2(update2, newMaster) {
  forEachMediaGroup2(update2, function(properties, type2, group, label) {
    if (!(label in newMaster.mediaGroups[type2][group])) {
      delete update2.mediaGroups[type2][group][label];
    }
  });
};
var updateMaster2 = function updateMaster3(oldMaster, newMaster, sidxMapping) {
  var noChanges = true;
  var update2 = mergeOptions(oldMaster, {
    duration: newMaster.duration,
    minimumUpdatePeriod: newMaster.minimumUpdatePeriod,
    timelineStarts: newMaster.timelineStarts
  });
  for (var i = 0; i < newMaster.playlists.length; i++) {
    var playlist = newMaster.playlists[i];
    if (playlist.sidx) {
      var sidxKey = generateSidxKey(playlist.sidx);
      if (sidxMapping && sidxMapping[sidxKey] && sidxMapping[sidxKey].sidx) {
        addSidxSegmentsToPlaylist$1(playlist, sidxMapping[sidxKey].sidx, playlist.sidx.resolvedUri);
      }
    }
    var playlistUpdate = updateMaster$1(update2, playlist, dashPlaylistUnchanged);
    if (playlistUpdate) {
      update2 = playlistUpdate;
      noChanges = false;
    }
  }
  forEachMediaGroup2(newMaster, function(properties, type2, group, label) {
    if (properties.playlists && properties.playlists.length) {
      var id2 = properties.playlists[0].id;
      var _playlistUpdate = updateMaster$1(update2, properties.playlists[0], dashPlaylistUnchanged);
      if (_playlistUpdate) {
        update2 = _playlistUpdate;
        if (!(label in update2.mediaGroups[type2][group])) {
          update2.mediaGroups[type2][group][label] = properties;
        }
        update2.mediaGroups[type2][group][label].playlists[0] = update2.playlists[id2];
        noChanges = false;
      }
    }
  });
  removeOldMediaGroupLabels(update2, newMaster);
  if (newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
    noChanges = false;
  }
  if (noChanges) {
    return null;
  }
  return update2;
};
var equivalentSidx = function equivalentSidx2(a, b) {
  var neitherMap = Boolean(!a.map && !b.map);
  var equivalentMap = neitherMap || Boolean(a.map && b.map && a.map.byterange.offset === b.map.byterange.offset && a.map.byterange.length === b.map.byterange.length);
  return equivalentMap && a.uri === b.uri && a.byterange.offset === b.byterange.offset && a.byterange.length === b.byterange.length;
};
var compareSidxEntry = function compareSidxEntry2(playlists, oldSidxMapping) {
  var newSidxMapping = {};
  for (var id2 in playlists) {
    var playlist = playlists[id2];
    var currentSidxInfo = playlist.sidx;
    if (currentSidxInfo) {
      var key = generateSidxKey(currentSidxInfo);
      if (!oldSidxMapping[key]) {
        break;
      }
      var savedSidxInfo = oldSidxMapping[key].sidxInfo;
      if (equivalentSidx(savedSidxInfo, currentSidxInfo)) {
        newSidxMapping[key] = oldSidxMapping[key];
      }
    }
  }
  return newSidxMapping;
};
var filterChangedSidxMappings = function filterChangedSidxMappings2(master, oldSidxMapping) {
  var videoSidx = compareSidxEntry(master.playlists, oldSidxMapping);
  var mediaGroupSidx = videoSidx;
  forEachMediaGroup2(master, function(properties, mediaType, groupKey, labelKey) {
    if (properties.playlists && properties.playlists.length) {
      var playlists = properties.playlists;
      mediaGroupSidx = mergeOptions(mediaGroupSidx, compareSidxEntry(playlists, oldSidxMapping));
    }
  });
  return mediaGroupSidx;
};
var DashPlaylistLoader = /* @__PURE__ */ function(_EventTarget) {
  _inheritsLoose(DashPlaylistLoader2, _EventTarget);
  function DashPlaylistLoader2(srcUrlOrPlaylist, vhs, options, masterPlaylistLoader) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _EventTarget.call(this) || this;
    _this.masterPlaylistLoader_ = masterPlaylistLoader || _assertThisInitialized(_this);
    if (!masterPlaylistLoader) {
      _this.isMaster_ = true;
    }
    var _options = options, _options$withCredenti = _options.withCredentials, withCredentials = _options$withCredenti === void 0 ? false : _options$withCredenti, _options$handleManife = _options.handleManifestRedirects, handleManifestRedirects = _options$handleManife === void 0 ? false : _options$handleManife;
    _this.vhs_ = vhs;
    _this.withCredentials = withCredentials;
    _this.handleManifestRedirects = handleManifestRedirects;
    if (!srcUrlOrPlaylist) {
      throw new Error("A non-empty playlist URL or object is required");
    }
    _this.on("minimumUpdatePeriod", function() {
      _this.refreshXml_();
    });
    _this.on("mediaupdatetimeout", function() {
      _this.refreshMedia_(_this.media().id);
    });
    _this.state = "HAVE_NOTHING";
    _this.loadedPlaylists_ = {};
    _this.logger_ = logger("DashPlaylistLoader");
    if (_this.isMaster_) {
      _this.masterPlaylistLoader_.srcUrl = srcUrlOrPlaylist;
      _this.masterPlaylistLoader_.sidxMapping_ = {};
    } else {
      _this.childPlaylist_ = srcUrlOrPlaylist;
    }
    return _this;
  }
  var _proto = DashPlaylistLoader2.prototype;
  _proto.requestErrored_ = function requestErrored_(err, request, startingState) {
    if (!this.request) {
      return true;
    }
    this.request = null;
    if (err) {
      this.error = typeof err === "object" && !(err instanceof Error) ? err : {
        status: request.status,
        message: "DASH request error at URL: " + request.uri,
        response: request.response,
        code: 2
      };
      if (startingState) {
        this.state = startingState;
      }
      this.trigger("error");
      return true;
    }
  };
  _proto.addSidxSegments_ = function addSidxSegments_(playlist, startingState, cb2) {
    var _this2 = this;
    var sidxKey = playlist.sidx && generateSidxKey(playlist.sidx);
    if (!playlist.sidx || !sidxKey || this.masterPlaylistLoader_.sidxMapping_[sidxKey]) {
      this.mediaRequest_ = window_1.setTimeout(function() {
        return cb2(false);
      }, 0);
      return;
    }
    var uri = resolveManifestRedirect(this.handleManifestRedirects, playlist.sidx.resolvedUri);
    var fin = function fin2(err, request) {
      if (_this2.requestErrored_(err, request, startingState)) {
        return;
      }
      var sidxMapping = _this2.masterPlaylistLoader_.sidxMapping_;
      var sidx;
      try {
        sidx = parseSidx_1(toUint8(request.response).subarray(8));
      } catch (e) {
        _this2.requestErrored_(e, request, startingState);
        return;
      }
      sidxMapping[sidxKey] = {
        sidxInfo: playlist.sidx,
        sidx
      };
      addSidxSegmentsToPlaylist$1(playlist, sidx, playlist.sidx.resolvedUri);
      return cb2(true);
    };
    this.request = containerRequest(uri, this.vhs_.xhr, function(err, request, container2, bytes) {
      if (err) {
        return fin(err, request);
      }
      if (!container2 || container2 !== "mp4") {
        return fin({
          status: request.status,
          message: "Unsupported " + (container2 || "unknown") + " container type for sidx segment at URL: " + uri,
          response: "",
          playlist,
          internal: true,
          blacklistDuration: Infinity,
          code: 2
        }, request);
      }
      var _playlist$sidx$bytera = playlist.sidx.byterange, offset2 = _playlist$sidx$bytera.offset, length = _playlist$sidx$bytera.length;
      if (bytes.length >= length + offset2) {
        return fin(err, {
          response: bytes.subarray(offset2, offset2 + length),
          status: request.status,
          uri: request.uri
        });
      }
      _this2.request = _this2.vhs_.xhr({
        uri,
        responseType: "arraybuffer",
        headers: segmentXhrHeaders({
          byterange: playlist.sidx.byterange
        })
      }, fin);
    });
  };
  _proto.dispose = function dispose() {
    this.trigger("dispose");
    this.stopRequest();
    this.loadedPlaylists_ = {};
    window_1.clearTimeout(this.minimumUpdatePeriodTimeout_);
    window_1.clearTimeout(this.mediaRequest_);
    window_1.clearTimeout(this.mediaUpdateTimeout);
    this.mediaUpdateTimeout = null;
    this.mediaRequest_ = null;
    this.minimumUpdatePeriodTimeout_ = null;
    if (this.masterPlaylistLoader_.createMupOnMedia_) {
      this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_);
      this.masterPlaylistLoader_.createMupOnMedia_ = null;
    }
    this.off();
  };
  _proto.hasPendingRequest = function hasPendingRequest() {
    return this.request || this.mediaRequest_;
  };
  _proto.stopRequest = function stopRequest() {
    if (this.request) {
      var oldRequest = this.request;
      this.request = null;
      oldRequest.onreadystatechange = null;
      oldRequest.abort();
    }
  };
  _proto.media = function media(playlist) {
    var _this3 = this;
    if (!playlist) {
      return this.media_;
    }
    if (this.state === "HAVE_NOTHING") {
      throw new Error("Cannot switch media playlist from " + this.state);
    }
    var startingState = this.state;
    if (typeof playlist === "string") {
      if (!this.masterPlaylistLoader_.master.playlists[playlist]) {
        throw new Error("Unknown playlist URI: " + playlist);
      }
      playlist = this.masterPlaylistLoader_.master.playlists[playlist];
    }
    var mediaChange = !this.media_ || playlist.id !== this.media_.id;
    if (mediaChange && this.loadedPlaylists_[playlist.id] && this.loadedPlaylists_[playlist.id].endList) {
      this.state = "HAVE_METADATA";
      this.media_ = playlist;
      if (mediaChange) {
        this.trigger("mediachanging");
        this.trigger("mediachange");
      }
      return;
    }
    if (!mediaChange) {
      return;
    }
    if (this.media_) {
      this.trigger("mediachanging");
    }
    this.addSidxSegments_(playlist, startingState, function(sidxChanged) {
      _this3.haveMetadata({
        startingState,
        playlist
      });
    });
  };
  _proto.haveMetadata = function haveMetadata(_ref2) {
    var startingState = _ref2.startingState, playlist = _ref2.playlist;
    this.state = "HAVE_METADATA";
    this.loadedPlaylists_[playlist.id] = playlist;
    this.mediaRequest_ = null;
    this.refreshMedia_(playlist.id);
    if (startingState === "HAVE_MASTER") {
      this.trigger("loadedmetadata");
    } else {
      this.trigger("mediachange");
    }
  };
  _proto.pause = function pause() {
    if (this.masterPlaylistLoader_.createMupOnMedia_) {
      this.off("loadedmetadata", this.masterPlaylistLoader_.createMupOnMedia_);
      this.masterPlaylistLoader_.createMupOnMedia_ = null;
    }
    this.stopRequest();
    window_1.clearTimeout(this.mediaUpdateTimeout);
    this.mediaUpdateTimeout = null;
    if (this.isMaster_) {
      window_1.clearTimeout(this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_);
      this.masterPlaylistLoader_.minimumUpdatePeriodTimeout_ = null;
    }
    if (this.state === "HAVE_NOTHING") {
      this.started = false;
    }
  };
  _proto.load = function load(isFinalRendition) {
    var _this4 = this;
    window_1.clearTimeout(this.mediaUpdateTimeout);
    this.mediaUpdateTimeout = null;
    var media = this.media();
    if (isFinalRendition) {
      var delay = media ? media.targetDuration / 2 * 1e3 : 5 * 1e3;
      this.mediaUpdateTimeout = window_1.setTimeout(function() {
        return _this4.load();
      }, delay);
      return;
    }
    if (!this.started) {
      this.start();
      return;
    }
    if (media && !media.endList) {
      if (this.isMaster_ && !this.minimumUpdatePeriodTimeout_) {
        this.trigger("minimumUpdatePeriod");
        this.updateMinimumUpdatePeriodTimeout_();
      }
      this.trigger("mediaupdatetimeout");
    } else {
      this.trigger("loadedplaylist");
    }
  };
  _proto.start = function start2() {
    var _this5 = this;
    this.started = true;
    if (!this.isMaster_) {
      this.mediaRequest_ = window_1.setTimeout(function() {
        return _this5.haveMaster_();
      }, 0);
      return;
    }
    this.requestMaster_(function(req, masterChanged) {
      _this5.haveMaster_();
      if (!_this5.hasPendingRequest() && !_this5.media_) {
        _this5.media(_this5.masterPlaylistLoader_.master.playlists[0]);
      }
    });
  };
  _proto.requestMaster_ = function requestMaster_(cb2) {
    var _this6 = this;
    this.request = this.vhs_.xhr({
      uri: this.masterPlaylistLoader_.srcUrl,
      withCredentials: this.withCredentials
    }, function(error2, req) {
      if (_this6.requestErrored_(error2, req)) {
        if (_this6.state === "HAVE_NOTHING") {
          _this6.started = false;
        }
        return;
      }
      var masterChanged = req.responseText !== _this6.masterPlaylistLoader_.masterXml_;
      _this6.masterPlaylistLoader_.masterXml_ = req.responseText;
      if (req.responseHeaders && req.responseHeaders.date) {
        _this6.masterLoaded_ = Date.parse(req.responseHeaders.date);
      } else {
        _this6.masterLoaded_ = Date.now();
      }
      _this6.masterPlaylistLoader_.srcUrl = resolveManifestRedirect(_this6.handleManifestRedirects, _this6.masterPlaylistLoader_.srcUrl, req);
      if (masterChanged) {
        _this6.handleMaster_();
        _this6.syncClientServerClock_(function() {
          return cb2(req, masterChanged);
        });
        return;
      }
      return cb2(req, masterChanged);
    });
  };
  _proto.syncClientServerClock_ = function syncClientServerClock_(done) {
    var _this7 = this;
    var utcTiming = parseUTCTiming(this.masterPlaylistLoader_.masterXml_);
    if (utcTiming === null) {
      this.masterPlaylistLoader_.clientOffset_ = this.masterLoaded_ - Date.now();
      return done();
    }
    if (utcTiming.method === "DIRECT") {
      this.masterPlaylistLoader_.clientOffset_ = utcTiming.value - Date.now();
      return done();
    }
    this.request = this.vhs_.xhr({
      uri: resolveUrl2(this.masterPlaylistLoader_.srcUrl, utcTiming.value),
      method: utcTiming.method,
      withCredentials: this.withCredentials
    }, function(error2, req) {
      if (!_this7.request) {
        return;
      }
      if (error2) {
        _this7.masterPlaylistLoader_.clientOffset_ = _this7.masterLoaded_ - Date.now();
        return done();
      }
      var serverTime;
      if (utcTiming.method === "HEAD") {
        if (!req.responseHeaders || !req.responseHeaders.date) {
          serverTime = _this7.masterLoaded_;
        } else {
          serverTime = Date.parse(req.responseHeaders.date);
        }
      } else {
        serverTime = Date.parse(req.responseText);
      }
      _this7.masterPlaylistLoader_.clientOffset_ = serverTime - Date.now();
      done();
    });
  };
  _proto.haveMaster_ = function haveMaster_() {
    this.state = "HAVE_MASTER";
    if (this.isMaster_) {
      this.trigger("loadedplaylist");
    } else if (!this.media_) {
      this.media(this.childPlaylist_);
    }
  };
  _proto.handleMaster_ = function handleMaster_() {
    this.mediaRequest_ = null;
    var oldMaster = this.masterPlaylistLoader_.master;
    var newMaster = parseMasterXml({
      masterXml: this.masterPlaylistLoader_.masterXml_,
      srcUrl: this.masterPlaylistLoader_.srcUrl,
      clientOffset: this.masterPlaylistLoader_.clientOffset_,
      sidxMapping: this.masterPlaylistLoader_.sidxMapping_,
      previousManifest: oldMaster
    });
    if (oldMaster) {
      newMaster = updateMaster2(oldMaster, newMaster, this.masterPlaylistLoader_.sidxMapping_);
    }
    this.masterPlaylistLoader_.master = newMaster ? newMaster : oldMaster;
    var location2 = this.masterPlaylistLoader_.master.locations && this.masterPlaylistLoader_.master.locations[0];
    if (location2 && location2 !== this.masterPlaylistLoader_.srcUrl) {
      this.masterPlaylistLoader_.srcUrl = location2;
    }
    if (!oldMaster || newMaster && newMaster.minimumUpdatePeriod !== oldMaster.minimumUpdatePeriod) {
      this.updateMinimumUpdatePeriodTimeout_();
    }
    return Boolean(newMaster);
  };
  _proto.updateMinimumUpdatePeriodTimeout_ = function updateMinimumUpdatePeriodTimeout_() {
    var mpl = this.masterPlaylistLoader_;
    if (mpl.createMupOnMedia_) {
      mpl.off("loadedmetadata", mpl.createMupOnMedia_);
      mpl.createMupOnMedia_ = null;
    }
    if (mpl.minimumUpdatePeriodTimeout_) {
      window_1.clearTimeout(mpl.minimumUpdatePeriodTimeout_);
      mpl.minimumUpdatePeriodTimeout_ = null;
    }
    var mup = mpl.master && mpl.master.minimumUpdatePeriod;
    if (mup === 0) {
      if (mpl.media()) {
        mup = mpl.media().targetDuration * 1e3;
      } else {
        mpl.createMupOnMedia_ = mpl.updateMinimumUpdatePeriodTimeout_;
        mpl.one("loadedmetadata", mpl.createMupOnMedia_);
      }
    }
    if (typeof mup !== "number" || mup <= 0) {
      if (mup < 0) {
        this.logger_("found invalid minimumUpdatePeriod of " + mup + ", not setting a timeout");
      }
      return;
    }
    this.createMUPTimeout_(mup);
  };
  _proto.createMUPTimeout_ = function createMUPTimeout_(mup) {
    var mpl = this.masterPlaylistLoader_;
    mpl.minimumUpdatePeriodTimeout_ = window_1.setTimeout(function() {
      mpl.minimumUpdatePeriodTimeout_ = null;
      mpl.trigger("minimumUpdatePeriod");
      mpl.createMUPTimeout_(mup);
    }, mup);
  };
  _proto.refreshXml_ = function refreshXml_() {
    var _this8 = this;
    this.requestMaster_(function(req, masterChanged) {
      if (!masterChanged) {
        return;
      }
      if (_this8.media_) {
        _this8.media_ = _this8.masterPlaylistLoader_.master.playlists[_this8.media_.id];
      }
      _this8.masterPlaylistLoader_.sidxMapping_ = filterChangedSidxMappings(_this8.masterPlaylistLoader_.master, _this8.masterPlaylistLoader_.sidxMapping_);
      _this8.addSidxSegments_(_this8.media(), _this8.state, function(sidxChanged) {
        _this8.refreshMedia_(_this8.media().id);
      });
    });
  };
  _proto.refreshMedia_ = function refreshMedia_(mediaID) {
    var _this9 = this;
    if (!mediaID) {
      throw new Error("refreshMedia_ must take a media id");
    }
    if (this.media_ && this.isMaster_) {
      this.handleMaster_();
    }
    var playlists = this.masterPlaylistLoader_.master.playlists;
    var mediaChanged = !this.media_ || this.media_ !== playlists[mediaID];
    if (mediaChanged) {
      this.media_ = playlists[mediaID];
    } else {
      this.trigger("playlistunchanged");
    }
    if (!this.mediaUpdateTimeout) {
      var createMediaUpdateTimeout = function createMediaUpdateTimeout2() {
        if (_this9.media().endList) {
          return;
        }
        _this9.mediaUpdateTimeout = window_1.setTimeout(function() {
          _this9.trigger("mediaupdatetimeout");
          createMediaUpdateTimeout2();
        }, refreshDelay(_this9.media(), Boolean(mediaChanged)));
      };
      createMediaUpdateTimeout();
    }
    this.trigger("loadedplaylist");
  };
  return DashPlaylistLoader2;
}(EventTarget2);
var Config = {
  GOAL_BUFFER_LENGTH: 30,
  MAX_GOAL_BUFFER_LENGTH: 60,
  BACK_BUFFER_LENGTH: 30,
  GOAL_BUFFER_LENGTH_RATE: 1,
  INITIAL_BANDWIDTH: 4194304,
  BANDWIDTH_VARIANCE: 1.2,
  BUFFER_LOW_WATER_LINE: 0,
  MAX_BUFFER_LOW_WATER_LINE: 30,
  EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE: 16,
  BUFFER_LOW_WATER_LINE_RATE: 1,
  BUFFER_HIGH_WATER_LINE: 30
};
var stringToArrayBuffer = function stringToArrayBuffer2(string2) {
  var view = new Uint8Array(new ArrayBuffer(string2.length));
  for (var i = 0; i < string2.length; i++) {
    view[i] = string2.charCodeAt(i);
  }
  return view.buffer;
};
var browserWorkerPolyFill = function browserWorkerPolyFill2(workerObj) {
  workerObj.on = workerObj.addEventListener;
  workerObj.off = workerObj.removeEventListener;
  return workerObj;
};
var createObjectURL = function createObjectURL2(str) {
  try {
    return URL.createObjectURL(new Blob([str], {
      type: "application/javascript"
    }));
  } catch (e) {
    var blob = new BlobBuilder();
    blob.append(str);
    return URL.createObjectURL(blob.getBlob());
  }
};
var factory = function factory2(code) {
  return function() {
    var objectUrl = createObjectURL(code);
    var worker = browserWorkerPolyFill(new Worker(objectUrl));
    worker.objURL = objectUrl;
    var terminate = worker.terminate;
    worker.on = worker.addEventListener;
    worker.off = worker.removeEventListener;
    worker.terminate = function() {
      URL.revokeObjectURL(objectUrl);
      return terminate.call(this);
    };
    return worker;
  };
};
var transform = function transform2(code) {
  return "var browserWorkerPolyFill = " + browserWorkerPolyFill.toString() + ";\nbrowserWorkerPolyFill(self);\n" + code;
};
var getWorkerString = function getWorkerString2(fn) {
  return fn.toString().replace(/^function.+?{/, "").slice(0, -1);
};
var workerCode$1 = transform(getWorkerString(function() {
  var Stream2 = function Stream3() {
    this.init = function() {
      var listeners = {};
      this.on = function(type3, listener3) {
        if (!listeners[type3]) {
          listeners[type3] = [];
        }
        listeners[type3] = listeners[type3].concat(listener3);
      };
      this.off = function(type3, listener3) {
        var index;
        if (!listeners[type3]) {
          return false;
        }
        index = listeners[type3].indexOf(listener3);
        listeners[type3] = listeners[type3].slice();
        listeners[type3].splice(index, 1);
        return index > -1;
      };
      this.trigger = function(type3) {
        var callbacks, i, length, args;
        callbacks = listeners[type3];
        if (!callbacks) {
          return;
        }
        if (arguments.length === 2) {
          length = callbacks.length;
          for (i = 0; i < length; ++i) {
            callbacks[i].call(this, arguments[1]);
          }
        } else {
          args = [];
          i = arguments.length;
          for (i = 1; i < arguments.length; ++i) {
            args.push(arguments[i]);
          }
          length = callbacks.length;
          for (i = 0; i < length; ++i) {
            callbacks[i].apply(this, args);
          }
        }
      };
      this.dispose = function() {
        listeners = {};
      };
    };
  };
  Stream2.prototype.pipe = function(destination) {
    this.on("data", function(data) {
      destination.push(data);
    });
    this.on("done", function(flushSource) {
      destination.flush(flushSource);
    });
    this.on("partialdone", function(flushSource) {
      destination.partialFlush(flushSource);
    });
    this.on("endedtimeline", function(flushSource) {
      destination.endTimeline(flushSource);
    });
    this.on("reset", function(flushSource) {
      destination.reset(flushSource);
    });
    return destination;
  };
  Stream2.prototype.push = function(data) {
    this.trigger("data", data);
  };
  Stream2.prototype.flush = function(flushSource) {
    this.trigger("done", flushSource);
  };
  Stream2.prototype.partialFlush = function(flushSource) {
    this.trigger("partialdone", flushSource);
  };
  Stream2.prototype.endTimeline = function(flushSource) {
    this.trigger("endedtimeline", flushSource);
  };
  Stream2.prototype.reset = function(flushSource) {
    this.trigger("reset", flushSource);
  };
  var stream = Stream2;
  var MAX_UINT32$1 = Math.pow(2, 32);
  var getUint64$2 = function getUint643(uint8) {
    var dv = new DataView(uint8.buffer, uint8.byteOffset, uint8.byteLength);
    var value;
    if (dv.getBigUint64) {
      value = dv.getBigUint64(0);
      if (value < Number.MAX_SAFE_INTEGER) {
        return Number(value);
      }
      return value;
    }
    return dv.getUint32(0) * MAX_UINT32$1 + dv.getUint32(4);
  };
  var numbers2 = {
    getUint64: getUint64$2,
    MAX_UINT32: MAX_UINT32$1
  };
  var MAX_UINT322 = numbers2.MAX_UINT32;
  var box, dinf, esds, ftyp, mdat, mfhd, minf, moof, moov, mvex, mvhd, trak, tkhd, mdia, mdhd, hdlr, sdtp, stbl, stsd, traf, trex, trun$1, types, MAJOR_BRAND, MINOR_VERSION, AVC1_BRAND, VIDEO_HDLR, AUDIO_HDLR, HDLR_TYPES, VMHD, SMHD, DREF, STCO, STSC, STSZ, STTS;
  (function() {
    var i;
    types = {
      avc1: [],
      avcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      smhd: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      styp: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: []
    };
    if (typeof Uint8Array === "undefined") {
      return;
    }
    for (i in types) {
      if (types.hasOwnProperty(i)) {
        types[i] = [i.charCodeAt(0), i.charCodeAt(1), i.charCodeAt(2), i.charCodeAt(3)];
      }
    }
    MAJOR_BRAND = new Uint8Array(["i".charCodeAt(0), "s".charCodeAt(0), "o".charCodeAt(0), "m".charCodeAt(0)]);
    AVC1_BRAND = new Uint8Array(["a".charCodeAt(0), "v".charCodeAt(0), "c".charCodeAt(0), "1".charCodeAt(0)]);
    MINOR_VERSION = new Uint8Array([0, 0, 0, 1]);
    VIDEO_HDLR = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      118,
      105,
      100,
      101,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
    ]);
    AUDIO_HDLR = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      115,
      111,
      117,
      110,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
    ]);
    HDLR_TYPES = {
      video: VIDEO_HDLR,
      audio: AUDIO_HDLR
    };
    DREF = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      12,
      117,
      114,
      108,
      32,
      0,
      0,
      0,
      1
    ]);
    SMHD = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]);
    STCO = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]);
    STSC = STCO;
    STSZ = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]);
    STTS = STCO;
    VMHD = new Uint8Array([
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]);
  })();
  box = function box2(type3) {
    var payload = [], size = 0, i, result2, view;
    for (i = 1; i < arguments.length; i++) {
      payload.push(arguments[i]);
    }
    i = payload.length;
    while (i--) {
      size += payload[i].byteLength;
    }
    result2 = new Uint8Array(size + 8);
    view = new DataView(result2.buffer, result2.byteOffset, result2.byteLength);
    view.setUint32(0, result2.byteLength);
    result2.set(type3, 4);
    for (i = 0, size = 8; i < payload.length; i++) {
      result2.set(payload[i], size);
      size += payload[i].byteLength;
    }
    return result2;
  };
  dinf = function dinf2() {
    return box(types.dinf, box(types.dref, DREF));
  };
  esds = function esds2(track) {
    return box(types.esds, new Uint8Array([
      0,
      0,
      0,
      0,
      3,
      25,
      0,
      0,
      0,
      4,
      17,
      64,
      21,
      0,
      6,
      0,
      0,
      0,
      218,
      192,
      0,
      0,
      218,
      192,
      5,
      2,
      track.audioobjecttype << 3 | track.samplingfrequencyindex >>> 1,
      track.samplingfrequencyindex << 7 | track.channelcount << 3,
      6,
      1,
      2
    ]));
  };
  ftyp = function ftyp2() {
    return box(types.ftyp, MAJOR_BRAND, MINOR_VERSION, MAJOR_BRAND, AVC1_BRAND);
  };
  hdlr = function hdlr2(type3) {
    return box(types.hdlr, HDLR_TYPES[type3]);
  };
  mdat = function mdat2(data) {
    return box(types.mdat, data);
  };
  mdhd = function mdhd2(track) {
    var result2 = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      0,
      0,
      0,
      3,
      0,
      1,
      95,
      144,
      track.duration >>> 24 & 255,
      track.duration >>> 16 & 255,
      track.duration >>> 8 & 255,
      track.duration & 255,
      85,
      196,
      0,
      0
    ]);
    if (track.samplerate) {
      result2[12] = track.samplerate >>> 24 & 255;
      result2[13] = track.samplerate >>> 16 & 255;
      result2[14] = track.samplerate >>> 8 & 255;
      result2[15] = track.samplerate & 255;
    }
    return box(types.mdhd, result2);
  };
  mdia = function mdia2(track) {
    return box(types.mdia, mdhd(track), hdlr(track.type), minf(track));
  };
  mfhd = function mfhd2(sequenceNumber) {
    return box(types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      (sequenceNumber & 4278190080) >> 24,
      (sequenceNumber & 16711680) >> 16,
      (sequenceNumber & 65280) >> 8,
      sequenceNumber & 255
    ]));
  };
  minf = function minf2(track) {
    return box(types.minf, track.type === "video" ? box(types.vmhd, VMHD) : box(types.smhd, SMHD), dinf(), stbl(track));
  };
  moof = function moof2(sequenceNumber, tracks) {
    var trackFragments = [], i = tracks.length;
    while (i--) {
      trackFragments[i] = traf(tracks[i]);
    }
    return box.apply(null, [types.moof, mfhd(sequenceNumber)].concat(trackFragments));
  };
  moov = function moov2(tracks) {
    var i = tracks.length, boxes = [];
    while (i--) {
      boxes[i] = trak(tracks[i]);
    }
    return box.apply(null, [types.moov, mvhd(4294967295)].concat(boxes).concat(mvex(tracks)));
  };
  mvex = function mvex2(tracks) {
    var i = tracks.length, boxes = [];
    while (i--) {
      boxes[i] = trex(tracks[i]);
    }
    return box.apply(null, [types.mvex].concat(boxes));
  };
  mvhd = function mvhd2(duration5) {
    var bytes = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      2,
      0,
      1,
      95,
      144,
      (duration5 & 4278190080) >> 24,
      (duration5 & 16711680) >> 16,
      (duration5 & 65280) >> 8,
      duration5 & 255,
      0,
      1,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      255,
      255,
      255,
      255
    ]);
    return box(types.mvhd, bytes);
  };
  sdtp = function sdtp2(track) {
    var samples = track.samples || [], bytes = new Uint8Array(4 + samples.length), flags, i;
    for (i = 0; i < samples.length; i++) {
      flags = samples[i].flags;
      bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
    }
    return box(types.sdtp, bytes);
  };
  stbl = function stbl2(track) {
    return box(types.stbl, stsd(track), box(types.stts, STTS), box(types.stsc, STSC), box(types.stsz, STSZ), box(types.stco, STCO));
  };
  (function() {
    var videoSample, audioSample;
    stsd = function stsd2(track) {
      return box(types.stsd, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1
      ]), track.type === "video" ? videoSample(track) : audioSample(track));
    };
    videoSample = function videoSample2(track) {
      var sps = track.sps || [], pps = track.pps || [], sequenceParameterSets = [], pictureParameterSets = [], i, avc1Box;
      for (i = 0; i < sps.length; i++) {
        sequenceParameterSets.push((sps[i].byteLength & 65280) >>> 8);
        sequenceParameterSets.push(sps[i].byteLength & 255);
        sequenceParameterSets = sequenceParameterSets.concat(Array.prototype.slice.call(sps[i]));
      }
      for (i = 0; i < pps.length; i++) {
        pictureParameterSets.push((pps[i].byteLength & 65280) >>> 8);
        pictureParameterSets.push(pps[i].byteLength & 255);
        pictureParameterSets = pictureParameterSets.concat(Array.prototype.slice.call(pps[i]));
      }
      avc1Box = [types.avc1, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        (track.width & 65280) >> 8,
        track.width & 255,
        (track.height & 65280) >> 8,
        track.height & 255,
        0,
        72,
        0,
        0,
        0,
        72,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        19,
        118,
        105,
        100,
        101,
        111,
        106,
        115,
        45,
        99,
        111,
        110,
        116,
        114,
        105,
        98,
        45,
        104,
        108,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        24,
        17,
        17
      ]), box(types.avcC, new Uint8Array([
        1,
        track.profileIdc,
        track.profileCompatibility,
        track.levelIdc,
        255
      ].concat([sps.length], sequenceParameterSets, [pps.length], pictureParameterSets))), box(types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        0,
        45,
        198,
        192,
        0,
        45,
        198,
        192
      ]))];
      if (track.sarRatio) {
        var hSpacing = track.sarRatio[0], vSpacing = track.sarRatio[1];
        avc1Box.push(box(types.pasp, new Uint8Array([(hSpacing & 4278190080) >> 24, (hSpacing & 16711680) >> 16, (hSpacing & 65280) >> 8, hSpacing & 255, (vSpacing & 4278190080) >> 24, (vSpacing & 16711680) >> 16, (vSpacing & 65280) >> 8, vSpacing & 255])));
      }
      return box.apply(null, avc1Box);
    };
    audioSample = function audioSample2(track) {
      return box(types.mp4a, new Uint8Array([
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        (track.channelcount & 65280) >> 8,
        track.channelcount & 255,
        (track.samplesize & 65280) >> 8,
        track.samplesize & 255,
        0,
        0,
        0,
        0,
        (track.samplerate & 65280) >> 8,
        track.samplerate & 255,
        0,
        0
      ]), esds(track));
    };
  })();
  tkhd = function tkhd2(track) {
    var result2 = new Uint8Array([
      0,
      0,
      0,
      7,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      (track.id & 4278190080) >> 24,
      (track.id & 16711680) >> 16,
      (track.id & 65280) >> 8,
      track.id & 255,
      0,
      0,
      0,
      0,
      (track.duration & 4278190080) >> 24,
      (track.duration & 16711680) >> 16,
      (track.duration & 65280) >> 8,
      track.duration & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      (track.width & 65280) >> 8,
      track.width & 255,
      0,
      0,
      (track.height & 65280) >> 8,
      track.height & 255,
      0,
      0
    ]);
    return box(types.tkhd, result2);
  };
  traf = function traf2(track) {
    var trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable, dataOffset, upperWordBaseMediaDecodeTime, lowerWordBaseMediaDecodeTime;
    trackFragmentHeader = box(types.tfhd, new Uint8Array([
      0,
      0,
      0,
      58,
      (track.id & 4278190080) >> 24,
      (track.id & 16711680) >> 16,
      (track.id & 65280) >> 8,
      track.id & 255,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]));
    upperWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime / MAX_UINT322);
    lowerWordBaseMediaDecodeTime = Math.floor(track.baseMediaDecodeTime % MAX_UINT322);
    trackFragmentDecodeTime = box(types.tfdt, new Uint8Array([
      1,
      0,
      0,
      0,
      upperWordBaseMediaDecodeTime >>> 24 & 255,
      upperWordBaseMediaDecodeTime >>> 16 & 255,
      upperWordBaseMediaDecodeTime >>> 8 & 255,
      upperWordBaseMediaDecodeTime & 255,
      lowerWordBaseMediaDecodeTime >>> 24 & 255,
      lowerWordBaseMediaDecodeTime >>> 16 & 255,
      lowerWordBaseMediaDecodeTime >>> 8 & 255,
      lowerWordBaseMediaDecodeTime & 255
    ]));
    dataOffset = 32 + 20 + 8 + 16 + 8 + 8;
    if (track.type === "audio") {
      trackFragmentRun = trun$1(track, dataOffset);
      return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun);
    }
    sampleDependencyTable = sdtp(track);
    trackFragmentRun = trun$1(track, sampleDependencyTable.length + dataOffset);
    return box(types.traf, trackFragmentHeader, trackFragmentDecodeTime, trackFragmentRun, sampleDependencyTable);
  };
  trak = function trak2(track) {
    track.duration = track.duration || 4294967295;
    return box(types.trak, tkhd(track), mdia(track));
  };
  trex = function trex2(track) {
    var result2 = new Uint8Array([
      0,
      0,
      0,
      0,
      (track.id & 4278190080) >> 24,
      (track.id & 16711680) >> 16,
      (track.id & 65280) >> 8,
      track.id & 255,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      1
    ]);
    if (track.type !== "video") {
      result2[result2.length - 1] = 0;
    }
    return box(types.trex, result2);
  };
  (function() {
    var audioTrun, videoTrun, trunHeader;
    trunHeader = function trunHeader2(samples, offset2) {
      var durationPresent = 0, sizePresent = 0, flagsPresent = 0, compositionTimeOffset = 0;
      if (samples.length) {
        if (samples[0].duration !== void 0) {
          durationPresent = 1;
        }
        if (samples[0].size !== void 0) {
          sizePresent = 2;
        }
        if (samples[0].flags !== void 0) {
          flagsPresent = 4;
        }
        if (samples[0].compositionTimeOffset !== void 0) {
          compositionTimeOffset = 8;
        }
      }
      return [
        0,
        0,
        durationPresent | sizePresent | flagsPresent | compositionTimeOffset,
        1,
        (samples.length & 4278190080) >>> 24,
        (samples.length & 16711680) >>> 16,
        (samples.length & 65280) >>> 8,
        samples.length & 255,
        (offset2 & 4278190080) >>> 24,
        (offset2 & 16711680) >>> 16,
        (offset2 & 65280) >>> 8,
        offset2 & 255
      ];
    };
    videoTrun = function videoTrun2(track, offset2) {
      var bytesOffest, bytes, header2, samples, sample, i;
      samples = track.samples || [];
      offset2 += 8 + 12 + 16 * samples.length;
      header2 = trunHeader(samples, offset2);
      bytes = new Uint8Array(header2.length + samples.length * 16);
      bytes.set(header2);
      bytesOffest = header2.length;
      for (i = 0; i < samples.length; i++) {
        sample = samples[i];
        bytes[bytesOffest++] = (sample.duration & 4278190080) >>> 24;
        bytes[bytesOffest++] = (sample.duration & 16711680) >>> 16;
        bytes[bytesOffest++] = (sample.duration & 65280) >>> 8;
        bytes[bytesOffest++] = sample.duration & 255;
        bytes[bytesOffest++] = (sample.size & 4278190080) >>> 24;
        bytes[bytesOffest++] = (sample.size & 16711680) >>> 16;
        bytes[bytesOffest++] = (sample.size & 65280) >>> 8;
        bytes[bytesOffest++] = sample.size & 255;
        bytes[bytesOffest++] = sample.flags.isLeading << 2 | sample.flags.dependsOn;
        bytes[bytesOffest++] = sample.flags.isDependedOn << 6 | sample.flags.hasRedundancy << 4 | sample.flags.paddingValue << 1 | sample.flags.isNonSyncSample;
        bytes[bytesOffest++] = sample.flags.degradationPriority & 240 << 8;
        bytes[bytesOffest++] = sample.flags.degradationPriority & 15;
        bytes[bytesOffest++] = (sample.compositionTimeOffset & 4278190080) >>> 24;
        bytes[bytesOffest++] = (sample.compositionTimeOffset & 16711680) >>> 16;
        bytes[bytesOffest++] = (sample.compositionTimeOffset & 65280) >>> 8;
        bytes[bytesOffest++] = sample.compositionTimeOffset & 255;
      }
      return box(types.trun, bytes);
    };
    audioTrun = function audioTrun2(track, offset2) {
      var bytes, bytesOffest, header2, samples, sample, i;
      samples = track.samples || [];
      offset2 += 8 + 12 + 8 * samples.length;
      header2 = trunHeader(samples, offset2);
      bytes = new Uint8Array(header2.length + samples.length * 8);
      bytes.set(header2);
      bytesOffest = header2.length;
      for (i = 0; i < samples.length; i++) {
        sample = samples[i];
        bytes[bytesOffest++] = (sample.duration & 4278190080) >>> 24;
        bytes[bytesOffest++] = (sample.duration & 16711680) >>> 16;
        bytes[bytesOffest++] = (sample.duration & 65280) >>> 8;
        bytes[bytesOffest++] = sample.duration & 255;
        bytes[bytesOffest++] = (sample.size & 4278190080) >>> 24;
        bytes[bytesOffest++] = (sample.size & 16711680) >>> 16;
        bytes[bytesOffest++] = (sample.size & 65280) >>> 8;
        bytes[bytesOffest++] = sample.size & 255;
      }
      return box(types.trun, bytes);
    };
    trun$1 = function trun2(track, offset2) {
      if (track.type === "audio") {
        return audioTrun(track, offset2);
      }
      return videoTrun(track, offset2);
    };
  })();
  var mp4Generator = {
    ftyp,
    mdat,
    moof,
    moov,
    initSegment: function initSegment(tracks) {
      var fileType = ftyp(), movie = moov(tracks), result2;
      result2 = new Uint8Array(fileType.byteLength + movie.byteLength);
      result2.set(fileType);
      result2.set(movie, fileType.byteLength);
      return result2;
    }
  };
  var groupNalsIntoFrames = function groupNalsIntoFrames2(nalUnits) {
    var i, currentNal, currentFrame = [], frames = [];
    frames.byteLength = 0;
    frames.nalCount = 0;
    frames.duration = 0;
    currentFrame.byteLength = 0;
    for (i = 0; i < nalUnits.length; i++) {
      currentNal = nalUnits[i];
      if (currentNal.nalUnitType === "access_unit_delimiter_rbsp") {
        if (currentFrame.length) {
          currentFrame.duration = currentNal.dts - currentFrame.dts;
          frames.byteLength += currentFrame.byteLength;
          frames.nalCount += currentFrame.length;
          frames.duration += currentFrame.duration;
          frames.push(currentFrame);
        }
        currentFrame = [currentNal];
        currentFrame.byteLength = currentNal.data.byteLength;
        currentFrame.pts = currentNal.pts;
        currentFrame.dts = currentNal.dts;
      } else {
        if (currentNal.nalUnitType === "slice_layer_without_partitioning_rbsp_idr") {
          currentFrame.keyFrame = true;
        }
        currentFrame.duration = currentNal.dts - currentFrame.dts;
        currentFrame.byteLength += currentNal.data.byteLength;
        currentFrame.push(currentNal);
      }
    }
    if (frames.length && (!currentFrame.duration || currentFrame.duration <= 0)) {
      currentFrame.duration = frames[frames.length - 1].duration;
    }
    frames.byteLength += currentFrame.byteLength;
    frames.nalCount += currentFrame.length;
    frames.duration += currentFrame.duration;
    frames.push(currentFrame);
    return frames;
  };
  var groupFramesIntoGops = function groupFramesIntoGops2(frames) {
    var i, currentFrame, currentGop = [], gops = [];
    currentGop.byteLength = 0;
    currentGop.nalCount = 0;
    currentGop.duration = 0;
    currentGop.pts = frames[0].pts;
    currentGop.dts = frames[0].dts;
    gops.byteLength = 0;
    gops.nalCount = 0;
    gops.duration = 0;
    gops.pts = frames[0].pts;
    gops.dts = frames[0].dts;
    for (i = 0; i < frames.length; i++) {
      currentFrame = frames[i];
      if (currentFrame.keyFrame) {
        if (currentGop.length) {
          gops.push(currentGop);
          gops.byteLength += currentGop.byteLength;
          gops.nalCount += currentGop.nalCount;
          gops.duration += currentGop.duration;
        }
        currentGop = [currentFrame];
        currentGop.nalCount = currentFrame.length;
        currentGop.byteLength = currentFrame.byteLength;
        currentGop.pts = currentFrame.pts;
        currentGop.dts = currentFrame.dts;
        currentGop.duration = currentFrame.duration;
      } else {
        currentGop.duration += currentFrame.duration;
        currentGop.nalCount += currentFrame.length;
        currentGop.byteLength += currentFrame.byteLength;
        currentGop.push(currentFrame);
      }
    }
    if (gops.length && currentGop.duration <= 0) {
      currentGop.duration = gops[gops.length - 1].duration;
    }
    gops.byteLength += currentGop.byteLength;
    gops.nalCount += currentGop.nalCount;
    gops.duration += currentGop.duration;
    gops.push(currentGop);
    return gops;
  };
  var extendFirstKeyFrame = function extendFirstKeyFrame2(gops) {
    var currentGop;
    if (!gops[0][0].keyFrame && gops.length > 1) {
      currentGop = gops.shift();
      gops.byteLength -= currentGop.byteLength;
      gops.nalCount -= currentGop.nalCount;
      gops[0][0].dts = currentGop.dts;
      gops[0][0].pts = currentGop.pts;
      gops[0][0].duration += currentGop.duration;
    }
    return gops;
  };
  var createDefaultSample = function createDefaultSample2() {
    return {
      size: 0,
      flags: {
        isLeading: 0,
        dependsOn: 1,
        isDependedOn: 0,
        hasRedundancy: 0,
        degradationPriority: 0,
        isNonSyncSample: 1
      }
    };
  };
  var sampleForFrame = function sampleForFrame2(frame, dataOffset) {
    var sample = createDefaultSample();
    sample.dataOffset = dataOffset;
    sample.compositionTimeOffset = frame.pts - frame.dts;
    sample.duration = frame.duration;
    sample.size = 4 * frame.length;
    sample.size += frame.byteLength;
    if (frame.keyFrame) {
      sample.flags.dependsOn = 2;
      sample.flags.isNonSyncSample = 0;
    }
    return sample;
  };
  var generateSampleTable$1 = function generateSampleTable2(gops, baseDataOffset) {
    var h, i, sample, currentGop, currentFrame, dataOffset = baseDataOffset || 0, samples = [];
    for (h = 0; h < gops.length; h++) {
      currentGop = gops[h];
      for (i = 0; i < currentGop.length; i++) {
        currentFrame = currentGop[i];
        sample = sampleForFrame(currentFrame, dataOffset);
        dataOffset += sample.size;
        samples.push(sample);
      }
    }
    return samples;
  };
  var concatenateNalData = function concatenateNalData2(gops) {
    var h, i, j, currentGop, currentFrame, currentNal, dataOffset = 0, nalsByteLength = gops.byteLength, numberOfNals = gops.nalCount, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer);
    for (h = 0; h < gops.length; h++) {
      currentGop = gops[h];
      for (i = 0; i < currentGop.length; i++) {
        currentFrame = currentGop[i];
        for (j = 0; j < currentFrame.length; j++) {
          currentNal = currentFrame[j];
          view.setUint32(dataOffset, currentNal.data.byteLength);
          dataOffset += 4;
          data.set(currentNal.data, dataOffset);
          dataOffset += currentNal.data.byteLength;
        }
      }
    }
    return data;
  };
  var generateSampleTableForFrame = function generateSampleTableForFrame2(frame, baseDataOffset) {
    var sample, dataOffset = baseDataOffset || 0, samples = [];
    sample = sampleForFrame(frame, dataOffset);
    samples.push(sample);
    return samples;
  };
  var concatenateNalDataForFrame = function concatenateNalDataForFrame2(frame) {
    var i, currentNal, dataOffset = 0, nalsByteLength = frame.byteLength, numberOfNals = frame.length, totalByteLength = nalsByteLength + 4 * numberOfNals, data = new Uint8Array(totalByteLength), view = new DataView(data.buffer);
    for (i = 0; i < frame.length; i++) {
      currentNal = frame[i];
      view.setUint32(dataOffset, currentNal.data.byteLength);
      dataOffset += 4;
      data.set(currentNal.data, dataOffset);
      dataOffset += currentNal.data.byteLength;
    }
    return data;
  };
  var frameUtils = {
    groupNalsIntoFrames,
    groupFramesIntoGops,
    extendFirstKeyFrame,
    generateSampleTable: generateSampleTable$1,
    concatenateNalData,
    generateSampleTableForFrame,
    concatenateNalDataForFrame
  };
  var highPrefix = [33, 16, 5, 32, 164, 27];
  var lowPrefix = [33, 65, 108, 84, 1, 2, 4, 8, 168, 2, 4, 8, 17, 191, 252];
  var zeroFill = function zeroFill2(count) {
    var a = [];
    while (count--) {
      a.push(0);
    }
    return a;
  };
  var makeTable = function makeTable2(metaTable) {
    return Object.keys(metaTable).reduce(function(obj, key) {
      obj[key] = new Uint8Array(metaTable[key].reduce(function(arr, part) {
        return arr.concat(part);
      }, []));
      return obj;
    }, {});
  };
  var silence;
  var silence_1 = function silence_12() {
    if (!silence) {
      var coneOfSilence = {
        96e3: [highPrefix, [227, 64], zeroFill(154), [56]],
        88200: [highPrefix, [231], zeroFill(170), [56]],
        64e3: [highPrefix, [248, 192], zeroFill(240), [56]],
        48e3: [highPrefix, [255, 192], zeroFill(268), [55, 148, 128], zeroFill(54), [112]],
        44100: [highPrefix, [255, 192], zeroFill(268), [55, 163, 128], zeroFill(84), [112]],
        32e3: [highPrefix, [255, 192], zeroFill(268), [55, 234], zeroFill(226), [112]],
        24e3: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 112], zeroFill(126), [224]],
        16e3: [highPrefix, [255, 192], zeroFill(268), [55, 255, 128], zeroFill(268), [111, 255], zeroFill(269), [223, 108], zeroFill(195), [1, 192]],
        12e3: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 253, 128], zeroFill(259), [56]],
        11025: [lowPrefix, zeroFill(268), [3, 127, 248], zeroFill(268), [6, 255, 240], zeroFill(268), [13, 255, 224], zeroFill(268), [27, 255, 192], zeroFill(268), [55, 175, 128], zeroFill(108), [112]],
        8e3: [lowPrefix, zeroFill(268), [3, 121, 16], zeroFill(47), [7]]
      };
      silence = makeTable(coneOfSilence);
    }
    return silence;
  };
  var ONE_SECOND_IN_TS$4 = 9e4, secondsToVideoTs2, secondsToAudioTs2, videoTsToSeconds2, audioTsToSeconds2, audioTsToVideoTs2, videoTsToAudioTs2, metadataTsToSeconds2;
  secondsToVideoTs2 = function secondsToVideoTs3(seconds) {
    return seconds * ONE_SECOND_IN_TS$4;
  };
  secondsToAudioTs2 = function secondsToAudioTs3(seconds, sampleRate) {
    return seconds * sampleRate;
  };
  videoTsToSeconds2 = function videoTsToSeconds3(timestamp) {
    return timestamp / ONE_SECOND_IN_TS$4;
  };
  audioTsToSeconds2 = function audioTsToSeconds3(timestamp, sampleRate) {
    return timestamp / sampleRate;
  };
  audioTsToVideoTs2 = function audioTsToVideoTs3(timestamp, sampleRate) {
    return secondsToVideoTs2(audioTsToSeconds2(timestamp, sampleRate));
  };
  videoTsToAudioTs2 = function videoTsToAudioTs3(timestamp, sampleRate) {
    return secondsToAudioTs2(videoTsToSeconds2(timestamp), sampleRate);
  };
  metadataTsToSeconds2 = function metadataTsToSeconds3(timestamp, timelineStartPts, keepOriginalTimestamps) {
    return videoTsToSeconds2(keepOriginalTimestamps ? timestamp : timestamp - timelineStartPts);
  };
  var clock2 = {
    ONE_SECOND_IN_TS: ONE_SECOND_IN_TS$4,
    secondsToVideoTs: secondsToVideoTs2,
    secondsToAudioTs: secondsToAudioTs2,
    videoTsToSeconds: videoTsToSeconds2,
    audioTsToSeconds: audioTsToSeconds2,
    audioTsToVideoTs: audioTsToVideoTs2,
    videoTsToAudioTs: videoTsToAudioTs2,
    metadataTsToSeconds: metadataTsToSeconds2
  };
  var sumFrameByteLengths = function sumFrameByteLengths2(array2) {
    var i, currentObj, sum = 0;
    for (i = 0; i < array2.length; i++) {
      currentObj = array2[i];
      sum += currentObj.data.byteLength;
    }
    return sum;
  };
  var prefixWithSilence = function prefixWithSilence2(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime) {
    var baseMediaDecodeTimeTs, frameDuration = 0, audioGapDuration = 0, audioFillFrameCount = 0, audioFillDuration = 0, silentFrame, i, firstFrame;
    if (!frames.length) {
      return;
    }
    baseMediaDecodeTimeTs = clock2.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate);
    frameDuration = Math.ceil(clock2.ONE_SECOND_IN_TS / (track.samplerate / 1024));
    if (audioAppendStartTs && videoBaseMediaDecodeTime) {
      audioGapDuration = baseMediaDecodeTimeTs - Math.max(audioAppendStartTs, videoBaseMediaDecodeTime);
      audioFillFrameCount = Math.floor(audioGapDuration / frameDuration);
      audioFillDuration = audioFillFrameCount * frameDuration;
    }
    if (audioFillFrameCount < 1 || audioFillDuration > clock2.ONE_SECOND_IN_TS / 2) {
      return;
    }
    silentFrame = silence_1()[track.samplerate];
    if (!silentFrame) {
      silentFrame = frames[0].data;
    }
    for (i = 0; i < audioFillFrameCount; i++) {
      firstFrame = frames[0];
      frames.splice(0, 0, {
        data: silentFrame,
        dts: firstFrame.dts - frameDuration,
        pts: firstFrame.pts - frameDuration
      });
    }
    track.baseMediaDecodeTime -= Math.floor(clock2.videoTsToAudioTs(audioFillDuration, track.samplerate));
    return audioFillDuration;
  };
  var trimAdtsFramesByEarliestDts = function trimAdtsFramesByEarliestDts2(adtsFrames, track, earliestAllowedDts) {
    if (track.minSegmentDts >= earliestAllowedDts) {
      return adtsFrames;
    }
    track.minSegmentDts = Infinity;
    return adtsFrames.filter(function(currentFrame) {
      if (currentFrame.dts >= earliestAllowedDts) {
        track.minSegmentDts = Math.min(track.minSegmentDts, currentFrame.dts);
        track.minSegmentPts = track.minSegmentDts;
        return true;
      }
      return false;
    });
  };
  var generateSampleTable = function generateSampleTable2(frames) {
    var i, currentFrame, samples = [];
    for (i = 0; i < frames.length; i++) {
      currentFrame = frames[i];
      samples.push({
        size: currentFrame.data.byteLength,
        duration: 1024
      });
    }
    return samples;
  };
  var concatenateFrameData = function concatenateFrameData2(frames) {
    var i, currentFrame, dataOffset = 0, data = new Uint8Array(sumFrameByteLengths(frames));
    for (i = 0; i < frames.length; i++) {
      currentFrame = frames[i];
      data.set(currentFrame.data, dataOffset);
      dataOffset += currentFrame.data.byteLength;
    }
    return data;
  };
  var audioFrameUtils = {
    prefixWithSilence,
    trimAdtsFramesByEarliestDts,
    generateSampleTable,
    concatenateFrameData
  };
  var ONE_SECOND_IN_TS$3 = clock2.ONE_SECOND_IN_TS;
  var collectDtsInfo = function collectDtsInfo2(track, data) {
    if (typeof data.pts === "number") {
      if (track.timelineStartInfo.pts === void 0) {
        track.timelineStartInfo.pts = data.pts;
      }
      if (track.minSegmentPts === void 0) {
        track.minSegmentPts = data.pts;
      } else {
        track.minSegmentPts = Math.min(track.minSegmentPts, data.pts);
      }
      if (track.maxSegmentPts === void 0) {
        track.maxSegmentPts = data.pts;
      } else {
        track.maxSegmentPts = Math.max(track.maxSegmentPts, data.pts);
      }
    }
    if (typeof data.dts === "number") {
      if (track.timelineStartInfo.dts === void 0) {
        track.timelineStartInfo.dts = data.dts;
      }
      if (track.minSegmentDts === void 0) {
        track.minSegmentDts = data.dts;
      } else {
        track.minSegmentDts = Math.min(track.minSegmentDts, data.dts);
      }
      if (track.maxSegmentDts === void 0) {
        track.maxSegmentDts = data.dts;
      } else {
        track.maxSegmentDts = Math.max(track.maxSegmentDts, data.dts);
      }
    }
  };
  var clearDtsInfo = function clearDtsInfo2(track) {
    delete track.minSegmentDts;
    delete track.maxSegmentDts;
    delete track.minSegmentPts;
    delete track.maxSegmentPts;
  };
  var calculateTrackBaseMediaDecodeTime = function calculateTrackBaseMediaDecodeTime2(track, keepOriginalTimestamps) {
    var baseMediaDecodeTime, scale, minSegmentDts = track.minSegmentDts;
    if (!keepOriginalTimestamps) {
      minSegmentDts -= track.timelineStartInfo.dts;
    }
    baseMediaDecodeTime = track.timelineStartInfo.baseMediaDecodeTime;
    baseMediaDecodeTime += minSegmentDts;
    baseMediaDecodeTime = Math.max(0, baseMediaDecodeTime);
    if (track.type === "audio") {
      scale = track.samplerate / ONE_SECOND_IN_TS$3;
      baseMediaDecodeTime *= scale;
      baseMediaDecodeTime = Math.floor(baseMediaDecodeTime);
    }
    return baseMediaDecodeTime;
  };
  var trackDecodeInfo = {
    clearDtsInfo,
    calculateTrackBaseMediaDecodeTime,
    collectDtsInfo
  };
  var USER_DATA_REGISTERED_ITU_T_T35 = 4, RBSP_TRAILING_BITS = 128;
  var parseSei = function parseSei2(bytes) {
    var i = 0, result2 = {
      payloadType: -1,
      payloadSize: 0
    }, payloadType = 0, payloadSize = 0;
    while (i < bytes.byteLength) {
      if (bytes[i] === RBSP_TRAILING_BITS) {
        break;
      }
      while (bytes[i] === 255) {
        payloadType += 255;
        i++;
      }
      payloadType += bytes[i++];
      while (bytes[i] === 255) {
        payloadSize += 255;
        i++;
      }
      payloadSize += bytes[i++];
      if (!result2.payload && payloadType === USER_DATA_REGISTERED_ITU_T_T35) {
        var userIdentifier = String.fromCharCode(bytes[i + 3], bytes[i + 4], bytes[i + 5], bytes[i + 6]);
        if (userIdentifier === "GA94") {
          result2.payloadType = payloadType;
          result2.payloadSize = payloadSize;
          result2.payload = bytes.subarray(i, i + payloadSize);
          break;
        } else {
          result2.payload = void 0;
        }
      }
      i += payloadSize;
      payloadType = 0;
      payloadSize = 0;
    }
    return result2;
  };
  var parseUserData = function parseUserData2(sei) {
    if (sei.payload[0] !== 181) {
      return null;
    }
    if ((sei.payload[1] << 8 | sei.payload[2]) !== 49) {
      return null;
    }
    if (String.fromCharCode(sei.payload[3], sei.payload[4], sei.payload[5], sei.payload[6]) !== "GA94") {
      return null;
    }
    if (sei.payload[7] !== 3) {
      return null;
    }
    return sei.payload.subarray(8, sei.payload.length - 1);
  };
  var parseCaptionPackets = function parseCaptionPackets2(pts, userData) {
    var results = [], i, count, offset2, data;
    if (!(userData[0] & 64)) {
      return results;
    }
    count = userData[0] & 31;
    for (i = 0; i < count; i++) {
      offset2 = i * 3;
      data = {
        type: userData[offset2 + 2] & 3,
        pts
      };
      if (userData[offset2 + 2] & 4) {
        data.ccData = userData[offset2 + 3] << 8 | userData[offset2 + 4];
        results.push(data);
      }
    }
    return results;
  };
  var discardEmulationPreventionBytes$1 = function discardEmulationPreventionBytes4(data) {
    var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData;
    while (i < length - 2) {
      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 3) {
        emulationPreventionBytesPositions.push(i + 2);
        i += 2;
      } else {
        i++;
      }
    }
    if (emulationPreventionBytesPositions.length === 0) {
      return data;
    }
    newLength = length - emulationPreventionBytesPositions.length;
    newData = new Uint8Array(newLength);
    var sourceIndex = 0;
    for (i = 0; i < newLength; sourceIndex++, i++) {
      if (sourceIndex === emulationPreventionBytesPositions[0]) {
        sourceIndex++;
        emulationPreventionBytesPositions.shift();
      }
      newData[i] = data[sourceIndex];
    }
    return newData;
  };
  var captionPacketParser = {
    parseSei,
    parseUserData,
    parseCaptionPackets,
    discardEmulationPreventionBytes: discardEmulationPreventionBytes$1,
    USER_DATA_REGISTERED_ITU_T_T35
  };
  var CaptionStream$1 = function CaptionStream2(options) {
    options = options || {};
    CaptionStream2.prototype.init.call(this);
    this.parse708captions_ = typeof options.parse708captions === "boolean" ? options.parse708captions : true;
    this.captionPackets_ = [];
    this.ccStreams_ = [
      new Cea608Stream(0, 0),
      new Cea608Stream(0, 1),
      new Cea608Stream(1, 0),
      new Cea608Stream(1, 1)
    ];
    if (this.parse708captions_) {
      this.cc708Stream_ = new Cea708Stream({
        captionServices: options.captionServices
      });
    }
    this.reset();
    this.ccStreams_.forEach(function(cc2) {
      cc2.on("data", this.trigger.bind(this, "data"));
      cc2.on("partialdone", this.trigger.bind(this, "partialdone"));
      cc2.on("done", this.trigger.bind(this, "done"));
    }, this);
    if (this.parse708captions_) {
      this.cc708Stream_.on("data", this.trigger.bind(this, "data"));
      this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone"));
      this.cc708Stream_.on("done", this.trigger.bind(this, "done"));
    }
  };
  CaptionStream$1.prototype = new stream();
  CaptionStream$1.prototype.push = function(event) {
    var sei, userData, newCaptionPackets;
    if (event.nalUnitType !== "sei_rbsp") {
      return;
    }
    sei = captionPacketParser.parseSei(event.escapedRBSP);
    if (!sei.payload) {
      return;
    }
    if (sei.payloadType !== captionPacketParser.USER_DATA_REGISTERED_ITU_T_T35) {
      return;
    }
    userData = captionPacketParser.parseUserData(sei);
    if (!userData) {
      return;
    }
    if (event.dts < this.latestDts_) {
      this.ignoreNextEqualDts_ = true;
      return;
    } else if (event.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
      this.numSameDts_--;
      if (!this.numSameDts_) {
        this.ignoreNextEqualDts_ = false;
      }
      return;
    }
    newCaptionPackets = captionPacketParser.parseCaptionPackets(event.pts, userData);
    this.captionPackets_ = this.captionPackets_.concat(newCaptionPackets);
    if (this.latestDts_ !== event.dts) {
      this.numSameDts_ = 0;
    }
    this.numSameDts_++;
    this.latestDts_ = event.dts;
  };
  CaptionStream$1.prototype.flushCCStreams = function(flushType) {
    this.ccStreams_.forEach(function(cc2) {
      return flushType === "flush" ? cc2.flush() : cc2.partialFlush();
    }, this);
  };
  CaptionStream$1.prototype.flushStream = function(flushType) {
    if (!this.captionPackets_.length) {
      this.flushCCStreams(flushType);
      return;
    }
    this.captionPackets_.forEach(function(elem, idx) {
      elem.presortIndex = idx;
    });
    this.captionPackets_.sort(function(a, b) {
      if (a.pts === b.pts) {
        return a.presortIndex - b.presortIndex;
      }
      return a.pts - b.pts;
    });
    this.captionPackets_.forEach(function(packet) {
      if (packet.type < 2) {
        this.dispatchCea608Packet(packet);
      } else {
        this.dispatchCea708Packet(packet);
      }
    }, this);
    this.captionPackets_.length = 0;
    this.flushCCStreams(flushType);
  };
  CaptionStream$1.prototype.flush = function() {
    return this.flushStream("flush");
  };
  CaptionStream$1.prototype.partialFlush = function() {
    return this.flushStream("partialFlush");
  };
  CaptionStream$1.prototype.reset = function() {
    this.latestDts_ = null;
    this.ignoreNextEqualDts_ = false;
    this.numSameDts_ = 0;
    this.activeCea608Channel_ = [null, null];
    this.ccStreams_.forEach(function(ccStream) {
      ccStream.reset();
    });
  };
  CaptionStream$1.prototype.dispatchCea608Packet = function(packet) {
    if (this.setsTextOrXDSActive(packet)) {
      this.activeCea608Channel_[packet.type] = null;
    } else if (this.setsChannel1Active(packet)) {
      this.activeCea608Channel_[packet.type] = 0;
    } else if (this.setsChannel2Active(packet)) {
      this.activeCea608Channel_[packet.type] = 1;
    }
    if (this.activeCea608Channel_[packet.type] === null) {
      return;
    }
    this.ccStreams_[(packet.type << 1) + this.activeCea608Channel_[packet.type]].push(packet);
  };
  CaptionStream$1.prototype.setsChannel1Active = function(packet) {
    return (packet.ccData & 30720) === 4096;
  };
  CaptionStream$1.prototype.setsChannel2Active = function(packet) {
    return (packet.ccData & 30720) === 6144;
  };
  CaptionStream$1.prototype.setsTextOrXDSActive = function(packet) {
    return (packet.ccData & 28928) === 256 || (packet.ccData & 30974) === 4138 || (packet.ccData & 30974) === 6186;
  };
  CaptionStream$1.prototype.dispatchCea708Packet = function(packet) {
    if (this.parse708captions_) {
      this.cc708Stream_.push(packet);
    }
  };
  var CHARACTER_TRANSLATION_708 = {
    127: 9834,
    4128: 32,
    4129: 160,
    4133: 8230,
    4138: 352,
    4140: 338,
    4144: 9608,
    4145: 8216,
    4146: 8217,
    4147: 8220,
    4148: 8221,
    4149: 8226,
    4153: 8482,
    4154: 353,
    4156: 339,
    4157: 8480,
    4159: 376,
    4214: 8539,
    4215: 8540,
    4216: 8541,
    4217: 8542,
    4218: 9168,
    4219: 9124,
    4220: 9123,
    4221: 9135,
    4222: 9126,
    4223: 9121,
    4256: 12600
  };
  var get708CharFromCode = function get708CharFromCode2(code) {
    var newCode = CHARACTER_TRANSLATION_708[code] || code;
    if (code & 4096 && code === newCode) {
      return "";
    }
    return String.fromCharCode(newCode);
  };
  var within708TextBlock = function within708TextBlock2(b) {
    return 32 <= b && b <= 127 || 160 <= b && b <= 255;
  };
  var Cea708Window = function Cea708Window2(windowNum) {
    this.windowNum = windowNum;
    this.reset();
  };
  Cea708Window.prototype.reset = function() {
    this.clearText();
    this.pendingNewLine = false;
    this.winAttr = {};
    this.penAttr = {};
    this.penLoc = {};
    this.penColor = {};
    this.visible = 0;
    this.rowLock = 0;
    this.columnLock = 0;
    this.priority = 0;
    this.relativePositioning = 0;
    this.anchorVertical = 0;
    this.anchorHorizontal = 0;
    this.anchorPoint = 0;
    this.rowCount = 1;
    this.virtualRowCount = this.rowCount + 1;
    this.columnCount = 41;
    this.windowStyle = 0;
    this.penStyle = 0;
  };
  Cea708Window.prototype.getText = function() {
    return this.rows.join("\n");
  };
  Cea708Window.prototype.clearText = function() {
    this.rows = [""];
    this.rowIdx = 0;
  };
  Cea708Window.prototype.newLine = function(pts) {
    if (this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow === "function") {
      this.beforeRowOverflow(pts);
    }
    if (this.rows.length > 0) {
      this.rows.push("");
      this.rowIdx++;
    }
    while (this.rows.length > this.virtualRowCount) {
      this.rows.shift();
      this.rowIdx--;
    }
  };
  Cea708Window.prototype.isEmpty = function() {
    if (this.rows.length === 0) {
      return true;
    } else if (this.rows.length === 1) {
      return this.rows[0] === "";
    }
    return false;
  };
  Cea708Window.prototype.addText = function(text) {
    this.rows[this.rowIdx] += text;
  };
  Cea708Window.prototype.backspace = function() {
    if (!this.isEmpty()) {
      var row = this.rows[this.rowIdx];
      this.rows[this.rowIdx] = row.substr(0, row.length - 1);
    }
  };
  var Cea708Service = function Cea708Service2(serviceNum, encoding, stream2) {
    this.serviceNum = serviceNum;
    this.text = "";
    this.currentWindow = new Cea708Window(-1);
    this.windows = [];
    this.stream = stream2;
    if (typeof encoding === "string") {
      this.createTextDecoder(encoding);
    }
  };
  Cea708Service.prototype.init = function(pts, beforeRowOverflow) {
    this.startPts = pts;
    for (var win3 = 0; win3 < 8; win3++) {
      this.windows[win3] = new Cea708Window(win3);
      if (typeof beforeRowOverflow === "function") {
        this.windows[win3].beforeRowOverflow = beforeRowOverflow;
      }
    }
  };
  Cea708Service.prototype.setCurrentWindow = function(windowNum) {
    this.currentWindow = this.windows[windowNum];
  };
  Cea708Service.prototype.createTextDecoder = function(encoding) {
    if (typeof TextDecoder === "undefined") {
      this.stream.trigger("log", {
        level: "warn",
        message: "The `encoding` option is unsupported without TextDecoder support"
      });
    } else {
      try {
        this.textDecoder_ = new TextDecoder(encoding);
      } catch (error2) {
        this.stream.trigger("log", {
          level: "warn",
          message: "TextDecoder could not be created with " + encoding + " encoding. " + error2
        });
      }
    }
  };
  var Cea708Stream = function Cea708Stream2(options) {
    options = options || {};
    Cea708Stream2.prototype.init.call(this);
    var self2 = this;
    var captionServices = options.captionServices || {};
    var captionServiceEncodings = {};
    var serviceProps;
    Object.keys(captionServices).forEach(function(serviceName) {
      serviceProps = captionServices[serviceName];
      if (/^SERVICE/.test(serviceName)) {
        captionServiceEncodings[serviceName] = serviceProps.encoding;
      }
    });
    this.serviceEncodings = captionServiceEncodings;
    this.current708Packet = null;
    this.services = {};
    this.push = function(packet) {
      if (packet.type === 3) {
        self2.new708Packet();
        self2.add708Bytes(packet);
      } else {
        if (self2.current708Packet === null) {
          self2.new708Packet();
        }
        self2.add708Bytes(packet);
      }
    };
  };
  Cea708Stream.prototype = new stream();
  Cea708Stream.prototype.new708Packet = function() {
    if (this.current708Packet !== null) {
      this.push708Packet();
    }
    this.current708Packet = {
      data: [],
      ptsVals: []
    };
  };
  Cea708Stream.prototype.add708Bytes = function(packet) {
    var data = packet.ccData;
    var byte0 = data >>> 8;
    var byte1 = data & 255;
    this.current708Packet.ptsVals.push(packet.pts);
    this.current708Packet.data.push(byte0);
    this.current708Packet.data.push(byte1);
  };
  Cea708Stream.prototype.push708Packet = function() {
    var packet708 = this.current708Packet;
    var packetData = packet708.data;
    var serviceNum = null;
    var blockSize = null;
    var i = 0;
    var b = packetData[i++];
    packet708.seq = b >> 6;
    packet708.sizeCode = b & 63;
    for (; i < packetData.length; i++) {
      b = packetData[i++];
      serviceNum = b >> 5;
      blockSize = b & 31;
      if (serviceNum === 7 && blockSize > 0) {
        b = packetData[i++];
        serviceNum = b;
      }
      this.pushServiceBlock(serviceNum, i, blockSize);
      if (blockSize > 0) {
        i += blockSize - 1;
      }
    }
  };
  Cea708Stream.prototype.pushServiceBlock = function(serviceNum, start2, size) {
    var b;
    var i = start2;
    var packetData = this.current708Packet.data;
    var service = this.services[serviceNum];
    if (!service) {
      service = this.initService(serviceNum, i);
    }
    for (; i < start2 + size && i < packetData.length; i++) {
      b = packetData[i];
      if (within708TextBlock(b)) {
        i = this.handleText(i, service);
      } else if (b === 24) {
        i = this.multiByteCharacter(i, service);
      } else if (b === 16) {
        i = this.extendedCommands(i, service);
      } else if (128 <= b && b <= 135) {
        i = this.setCurrentWindow(i, service);
      } else if (152 <= b && b <= 159) {
        i = this.defineWindow(i, service);
      } else if (b === 136) {
        i = this.clearWindows(i, service);
      } else if (b === 140) {
        i = this.deleteWindows(i, service);
      } else if (b === 137) {
        i = this.displayWindows(i, service);
      } else if (b === 138) {
        i = this.hideWindows(i, service);
      } else if (b === 139) {
        i = this.toggleWindows(i, service);
      } else if (b === 151) {
        i = this.setWindowAttributes(i, service);
      } else if (b === 144) {
        i = this.setPenAttributes(i, service);
      } else if (b === 145) {
        i = this.setPenColor(i, service);
      } else if (b === 146) {
        i = this.setPenLocation(i, service);
      } else if (b === 143) {
        service = this.reset(i, service);
      } else if (b === 8) {
        service.currentWindow.backspace();
      } else if (b === 12) {
        service.currentWindow.clearText();
      } else if (b === 13) {
        service.currentWindow.pendingNewLine = true;
      } else if (b === 14) {
        service.currentWindow.clearText();
      } else if (b === 141) {
        i++;
      } else
        ;
    }
  };
  Cea708Stream.prototype.extendedCommands = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[++i];
    if (within708TextBlock(b)) {
      i = this.handleText(i, service, {
        isExtended: true
      });
    }
    return i;
  };
  Cea708Stream.prototype.getPts = function(byteIndex) {
    return this.current708Packet.ptsVals[Math.floor(byteIndex / 2)];
  };
  Cea708Stream.prototype.initService = function(serviceNum, i) {
    var serviceName = "SERVICE" + serviceNum;
    var self2 = this;
    var serviceName;
    var encoding;
    if (serviceName in this.serviceEncodings) {
      encoding = this.serviceEncodings[serviceName];
    }
    this.services[serviceNum] = new Cea708Service(serviceNum, encoding, self2);
    this.services[serviceNum].init(this.getPts(i), function(pts) {
      self2.flushDisplayed(pts, self2.services[serviceNum]);
    });
    return this.services[serviceNum];
  };
  Cea708Stream.prototype.handleText = function(i, service, options) {
    var isExtended = options && options.isExtended;
    var isMultiByte = options && options.isMultiByte;
    var packetData = this.current708Packet.data;
    var extended = isExtended ? 4096 : 0;
    var currentByte = packetData[i];
    var nextByte = packetData[i + 1];
    var win3 = service.currentWindow;
    var _char;
    var charCodeArray;
    if (service.textDecoder_ && !isExtended) {
      if (isMultiByte) {
        charCodeArray = [currentByte, nextByte];
        i++;
      } else {
        charCodeArray = [currentByte];
      }
      _char = service.textDecoder_.decode(new Uint8Array(charCodeArray));
    } else {
      _char = get708CharFromCode(extended | currentByte);
    }
    if (win3.pendingNewLine && !win3.isEmpty()) {
      win3.newLine(this.getPts(i));
    }
    win3.pendingNewLine = false;
    win3.addText(_char);
    return i;
  };
  Cea708Stream.prototype.multiByteCharacter = function(i, service) {
    var packetData = this.current708Packet.data;
    var firstByte = packetData[i + 1];
    var secondByte = packetData[i + 2];
    if (within708TextBlock(firstByte) && within708TextBlock(secondByte)) {
      i = this.handleText(++i, service, {
        isMultiByte: true
      });
    }
    return i;
  };
  Cea708Stream.prototype.setCurrentWindow = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[i];
    var windowNum = b & 7;
    service.setCurrentWindow(windowNum);
    return i;
  };
  Cea708Stream.prototype.defineWindow = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[i];
    var windowNum = b & 7;
    service.setCurrentWindow(windowNum);
    var win3 = service.currentWindow;
    b = packetData[++i];
    win3.visible = (b & 32) >> 5;
    win3.rowLock = (b & 16) >> 4;
    win3.columnLock = (b & 8) >> 3;
    win3.priority = b & 7;
    b = packetData[++i];
    win3.relativePositioning = (b & 128) >> 7;
    win3.anchorVertical = b & 127;
    b = packetData[++i];
    win3.anchorHorizontal = b;
    b = packetData[++i];
    win3.anchorPoint = (b & 240) >> 4;
    win3.rowCount = b & 15;
    b = packetData[++i];
    win3.columnCount = b & 63;
    b = packetData[++i];
    win3.windowStyle = (b & 56) >> 3;
    win3.penStyle = b & 7;
    win3.virtualRowCount = win3.rowCount + 1;
    return i;
  };
  Cea708Stream.prototype.setWindowAttributes = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[i];
    var winAttr = service.currentWindow.winAttr;
    b = packetData[++i];
    winAttr.fillOpacity = (b & 192) >> 6;
    winAttr.fillRed = (b & 48) >> 4;
    winAttr.fillGreen = (b & 12) >> 2;
    winAttr.fillBlue = b & 3;
    b = packetData[++i];
    winAttr.borderType = (b & 192) >> 6;
    winAttr.borderRed = (b & 48) >> 4;
    winAttr.borderGreen = (b & 12) >> 2;
    winAttr.borderBlue = b & 3;
    b = packetData[++i];
    winAttr.borderType += (b & 128) >> 5;
    winAttr.wordWrap = (b & 64) >> 6;
    winAttr.printDirection = (b & 48) >> 4;
    winAttr.scrollDirection = (b & 12) >> 2;
    winAttr.justify = b & 3;
    b = packetData[++i];
    winAttr.effectSpeed = (b & 240) >> 4;
    winAttr.effectDirection = (b & 12) >> 2;
    winAttr.displayEffect = b & 3;
    return i;
  };
  Cea708Stream.prototype.flushDisplayed = function(pts, service) {
    var displayedText = [];
    for (var winId = 0; winId < 8; winId++) {
      if (service.windows[winId].visible && !service.windows[winId].isEmpty()) {
        displayedText.push(service.windows[winId].getText());
      }
    }
    service.endPts = pts;
    service.text = displayedText.join("\n\n");
    this.pushCaption(service);
    service.startPts = pts;
  };
  Cea708Stream.prototype.pushCaption = function(service) {
    if (service.text !== "") {
      this.trigger("data", {
        startPts: service.startPts,
        endPts: service.endPts,
        text: service.text,
        stream: "cc708_" + service.serviceNum
      });
      service.text = "";
      service.startPts = service.endPts;
    }
  };
  Cea708Stream.prototype.displayWindows = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[++i];
    var pts = this.getPts(i);
    this.flushDisplayed(pts, service);
    for (var winId = 0; winId < 8; winId++) {
      if (b & 1 << winId) {
        service.windows[winId].visible = 1;
      }
    }
    return i;
  };
  Cea708Stream.prototype.hideWindows = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[++i];
    var pts = this.getPts(i);
    this.flushDisplayed(pts, service);
    for (var winId = 0; winId < 8; winId++) {
      if (b & 1 << winId) {
        service.windows[winId].visible = 0;
      }
    }
    return i;
  };
  Cea708Stream.prototype.toggleWindows = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[++i];
    var pts = this.getPts(i);
    this.flushDisplayed(pts, service);
    for (var winId = 0; winId < 8; winId++) {
      if (b & 1 << winId) {
        service.windows[winId].visible ^= 1;
      }
    }
    return i;
  };
  Cea708Stream.prototype.clearWindows = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[++i];
    var pts = this.getPts(i);
    this.flushDisplayed(pts, service);
    for (var winId = 0; winId < 8; winId++) {
      if (b & 1 << winId) {
        service.windows[winId].clearText();
      }
    }
    return i;
  };
  Cea708Stream.prototype.deleteWindows = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[++i];
    var pts = this.getPts(i);
    this.flushDisplayed(pts, service);
    for (var winId = 0; winId < 8; winId++) {
      if (b & 1 << winId) {
        service.windows[winId].reset();
      }
    }
    return i;
  };
  Cea708Stream.prototype.setPenAttributes = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[i];
    var penAttr = service.currentWindow.penAttr;
    b = packetData[++i];
    penAttr.textTag = (b & 240) >> 4;
    penAttr.offset = (b & 12) >> 2;
    penAttr.penSize = b & 3;
    b = packetData[++i];
    penAttr.italics = (b & 128) >> 7;
    penAttr.underline = (b & 64) >> 6;
    penAttr.edgeType = (b & 56) >> 3;
    penAttr.fontStyle = b & 7;
    return i;
  };
  Cea708Stream.prototype.setPenColor = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[i];
    var penColor = service.currentWindow.penColor;
    b = packetData[++i];
    penColor.fgOpacity = (b & 192) >> 6;
    penColor.fgRed = (b & 48) >> 4;
    penColor.fgGreen = (b & 12) >> 2;
    penColor.fgBlue = b & 3;
    b = packetData[++i];
    penColor.bgOpacity = (b & 192) >> 6;
    penColor.bgRed = (b & 48) >> 4;
    penColor.bgGreen = (b & 12) >> 2;
    penColor.bgBlue = b & 3;
    b = packetData[++i];
    penColor.edgeRed = (b & 48) >> 4;
    penColor.edgeGreen = (b & 12) >> 2;
    penColor.edgeBlue = b & 3;
    return i;
  };
  Cea708Stream.prototype.setPenLocation = function(i, service) {
    var packetData = this.current708Packet.data;
    var b = packetData[i];
    var penLoc = service.currentWindow.penLoc;
    service.currentWindow.pendingNewLine = true;
    b = packetData[++i];
    penLoc.row = b & 15;
    b = packetData[++i];
    penLoc.column = b & 63;
    return i;
  };
  Cea708Stream.prototype.reset = function(i, service) {
    var pts = this.getPts(i);
    this.flushDisplayed(pts, service);
    return this.initService(service.serviceNum, i);
  };
  var CHARACTER_TRANSLATION = {
    42: 225,
    92: 233,
    94: 237,
    95: 243,
    96: 250,
    123: 231,
    124: 247,
    125: 209,
    126: 241,
    127: 9608,
    304: 174,
    305: 176,
    306: 189,
    307: 191,
    308: 8482,
    309: 162,
    310: 163,
    311: 9834,
    312: 224,
    313: 160,
    314: 232,
    315: 226,
    316: 234,
    317: 238,
    318: 244,
    319: 251,
    544: 193,
    545: 201,
    546: 211,
    547: 218,
    548: 220,
    549: 252,
    550: 8216,
    551: 161,
    552: 42,
    553: 39,
    554: 8212,
    555: 169,
    556: 8480,
    557: 8226,
    558: 8220,
    559: 8221,
    560: 192,
    561: 194,
    562: 199,
    563: 200,
    564: 202,
    565: 203,
    566: 235,
    567: 206,
    568: 207,
    569: 239,
    570: 212,
    571: 217,
    572: 249,
    573: 219,
    574: 171,
    575: 187,
    800: 195,
    801: 227,
    802: 205,
    803: 204,
    804: 236,
    805: 210,
    806: 242,
    807: 213,
    808: 245,
    809: 123,
    810: 125,
    811: 92,
    812: 94,
    813: 95,
    814: 124,
    815: 126,
    816: 196,
    817: 228,
    818: 214,
    819: 246,
    820: 223,
    821: 165,
    822: 164,
    823: 9474,
    824: 197,
    825: 229,
    826: 216,
    827: 248,
    828: 9484,
    829: 9488,
    830: 9492,
    831: 9496
  };
  var getCharFromCode = function getCharFromCode2(code) {
    if (code === null) {
      return "";
    }
    code = CHARACTER_TRANSLATION[code] || code;
    return String.fromCharCode(code);
  };
  var BOTTOM_ROW = 14;
  var ROWS = [4352, 4384, 4608, 4640, 5376, 5408, 5632, 5664, 5888, 5920, 4096, 4864, 4896, 5120, 5152];
  var createDisplayBuffer = function createDisplayBuffer2() {
    var result2 = [], i = BOTTOM_ROW + 1;
    while (i--) {
      result2.push("");
    }
    return result2;
  };
  var Cea608Stream = function Cea608Stream2(field, dataChannel) {
    Cea608Stream2.prototype.init.call(this);
    this.field_ = field || 0;
    this.dataChannel_ = dataChannel || 0;
    this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1);
    this.setConstants();
    this.reset();
    this.push = function(packet) {
      var data, swap, char0, char1, text;
      data = packet.ccData & 32639;
      if (data === this.lastControlCode_) {
        this.lastControlCode_ = null;
        return;
      }
      if ((data & 61440) === 4096) {
        this.lastControlCode_ = data;
      } else if (data !== this.PADDING_) {
        this.lastControlCode_ = null;
      }
      char0 = data >>> 8;
      char1 = data & 255;
      if (data === this.PADDING_) {
        return;
      } else if (data === this.RESUME_CAPTION_LOADING_) {
        this.mode_ = "popOn";
      } else if (data === this.END_OF_CAPTION_) {
        this.mode_ = "popOn";
        this.clearFormatting(packet.pts);
        this.flushDisplayed(packet.pts);
        swap = this.displayed_;
        this.displayed_ = this.nonDisplayed_;
        this.nonDisplayed_ = swap;
        this.startPts_ = packet.pts;
      } else if (data === this.ROLL_UP_2_ROWS_) {
        this.rollUpRows_ = 2;
        this.setRollUp(packet.pts);
      } else if (data === this.ROLL_UP_3_ROWS_) {
        this.rollUpRows_ = 3;
        this.setRollUp(packet.pts);
      } else if (data === this.ROLL_UP_4_ROWS_) {
        this.rollUpRows_ = 4;
        this.setRollUp(packet.pts);
      } else if (data === this.CARRIAGE_RETURN_) {
        this.clearFormatting(packet.pts);
        this.flushDisplayed(packet.pts);
        this.shiftRowsUp_();
        this.startPts_ = packet.pts;
      } else if (data === this.BACKSPACE_) {
        if (this.mode_ === "popOn") {
          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
        } else {
          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
        }
      } else if (data === this.ERASE_DISPLAYED_MEMORY_) {
        this.flushDisplayed(packet.pts);
        this.displayed_ = createDisplayBuffer();
      } else if (data === this.ERASE_NON_DISPLAYED_MEMORY_) {
        this.nonDisplayed_ = createDisplayBuffer();
      } else if (data === this.RESUME_DIRECT_CAPTIONING_) {
        if (this.mode_ !== "paintOn") {
          this.flushDisplayed(packet.pts);
          this.displayed_ = createDisplayBuffer();
        }
        this.mode_ = "paintOn";
        this.startPts_ = packet.pts;
      } else if (this.isSpecialCharacter(char0, char1)) {
        char0 = (char0 & 3) << 8;
        text = getCharFromCode(char0 | char1);
        this[this.mode_](packet.pts, text);
        this.column_++;
      } else if (this.isExtCharacter(char0, char1)) {
        if (this.mode_ === "popOn") {
          this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1);
        } else {
          this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
        }
        char0 = (char0 & 3) << 8;
        text = getCharFromCode(char0 | char1);
        this[this.mode_](packet.pts, text);
        this.column_++;
      } else if (this.isMidRowCode(char0, char1)) {
        this.clearFormatting(packet.pts);
        this[this.mode_](packet.pts, " ");
        this.column_++;
        if ((char1 & 14) === 14) {
          this.addFormatting(packet.pts, ["i"]);
        }
        if ((char1 & 1) === 1) {
          this.addFormatting(packet.pts, ["u"]);
        }
      } else if (this.isOffsetControlCode(char0, char1)) {
        this.column_ += char1 & 3;
      } else if (this.isPAC(char0, char1)) {
        var row = ROWS.indexOf(data & 7968);
        if (this.mode_ === "rollUp") {
          if (row - this.rollUpRows_ + 1 < 0) {
            row = this.rollUpRows_ - 1;
          }
          this.setRollUp(packet.pts, row);
        }
        if (row !== this.row_) {
          this.clearFormatting(packet.pts);
          this.row_ = row;
        }
        if (char1 & 1 && this.formatting_.indexOf("u") === -1) {
          this.addFormatting(packet.pts, ["u"]);
        }
        if ((data & 16) === 16) {
          this.column_ = ((data & 14) >> 1) * 4;
        }
        if (this.isColorPAC(char1)) {
          if ((char1 & 14) === 14) {
            this.addFormatting(packet.pts, ["i"]);
          }
        }
      } else if (this.isNormalChar(char0)) {
        if (char1 === 0) {
          char1 = null;
        }
        text = getCharFromCode(char0);
        text += getCharFromCode(char1);
        this[this.mode_](packet.pts, text);
        this.column_ += text.length;
      }
    };
  };
  Cea608Stream.prototype = new stream();
  Cea608Stream.prototype.flushDisplayed = function(pts) {
    var content2 = this.displayed_.map(function(row, index) {
      try {
        return row.trim();
      } catch (e) {
        this.trigger("log", {
          level: "warn",
          message: "Skipping a malformed 608 caption at index " + index + "."
        });
        return "";
      }
    }, this).join("\n").replace(/^\n+|\n+$/g, "");
    if (content2.length) {
      this.trigger("data", {
        startPts: this.startPts_,
        endPts: pts,
        text: content2,
        stream: this.name_
      });
    }
  };
  Cea608Stream.prototype.reset = function() {
    this.mode_ = "popOn";
    this.topRow_ = 0;
    this.startPts_ = 0;
    this.displayed_ = createDisplayBuffer();
    this.nonDisplayed_ = createDisplayBuffer();
    this.lastControlCode_ = null;
    this.column_ = 0;
    this.row_ = BOTTOM_ROW;
    this.rollUpRows_ = 2;
    this.formatting_ = [];
  };
  Cea608Stream.prototype.setConstants = function() {
    if (this.dataChannel_ === 0) {
      this.BASE_ = 16;
      this.EXT_ = 17;
      this.CONTROL_ = (20 | this.field_) << 8;
      this.OFFSET_ = 23;
    } else if (this.dataChannel_ === 1) {
      this.BASE_ = 24;
      this.EXT_ = 25;
      this.CONTROL_ = (28 | this.field_) << 8;
      this.OFFSET_ = 31;
    }
    this.PADDING_ = 0;
    this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32;
    this.END_OF_CAPTION_ = this.CONTROL_ | 47;
    this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37;
    this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38;
    this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39;
    this.CARRIAGE_RETURN_ = this.CONTROL_ | 45;
    this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41;
    this.BACKSPACE_ = this.CONTROL_ | 33;
    this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44;
    this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
  };
  Cea608Stream.prototype.isSpecialCharacter = function(char0, char1) {
    return char0 === this.EXT_ && char1 >= 48 && char1 <= 63;
  };
  Cea608Stream.prototype.isExtCharacter = function(char0, char1) {
    return (char0 === this.EXT_ + 1 || char0 === this.EXT_ + 2) && char1 >= 32 && char1 <= 63;
  };
  Cea608Stream.prototype.isMidRowCode = function(char0, char1) {
    return char0 === this.EXT_ && char1 >= 32 && char1 <= 47;
  };
  Cea608Stream.prototype.isOffsetControlCode = function(char0, char1) {
    return char0 === this.OFFSET_ && char1 >= 33 && char1 <= 35;
  };
  Cea608Stream.prototype.isPAC = function(char0, char1) {
    return char0 >= this.BASE_ && char0 < this.BASE_ + 8 && char1 >= 64 && char1 <= 127;
  };
  Cea608Stream.prototype.isColorPAC = function(char1) {
    return char1 >= 64 && char1 <= 79 || char1 >= 96 && char1 <= 127;
  };
  Cea608Stream.prototype.isNormalChar = function(_char2) {
    return _char2 >= 32 && _char2 <= 127;
  };
  Cea608Stream.prototype.setRollUp = function(pts, newBaseRow) {
    if (this.mode_ !== "rollUp") {
      this.row_ = BOTTOM_ROW;
      this.mode_ = "rollUp";
      this.flushDisplayed(pts);
      this.nonDisplayed_ = createDisplayBuffer();
      this.displayed_ = createDisplayBuffer();
    }
    if (newBaseRow !== void 0 && newBaseRow !== this.row_) {
      for (var i = 0; i < this.rollUpRows_; i++) {
        this.displayed_[newBaseRow - i] = this.displayed_[this.row_ - i];
        this.displayed_[this.row_ - i] = "";
      }
    }
    if (newBaseRow === void 0) {
      newBaseRow = this.row_;
    }
    this.topRow_ = newBaseRow - this.rollUpRows_ + 1;
  };
  Cea608Stream.prototype.addFormatting = function(pts, format) {
    this.formatting_ = this.formatting_.concat(format);
    var text = format.reduce(function(text2, format2) {
      return text2 + "<" + format2 + ">";
    }, "");
    this[this.mode_](pts, text);
  };
  Cea608Stream.prototype.clearFormatting = function(pts) {
    if (!this.formatting_.length) {
      return;
    }
    var text = this.formatting_.reverse().reduce(function(text2, format) {
      return text2 + "</" + format + ">";
    }, "");
    this.formatting_ = [];
    this[this.mode_](pts, text);
  };
  Cea608Stream.prototype.popOn = function(pts, text) {
    var baseRow = this.nonDisplayed_[this.row_];
    baseRow += text;
    this.nonDisplayed_[this.row_] = baseRow;
  };
  Cea608Stream.prototype.rollUp = function(pts, text) {
    var baseRow = this.displayed_[this.row_];
    baseRow += text;
    this.displayed_[this.row_] = baseRow;
  };
  Cea608Stream.prototype.shiftRowsUp_ = function() {
    var i;
    for (i = 0; i < this.topRow_; i++) {
      this.displayed_[i] = "";
    }
    for (i = this.row_ + 1; i < BOTTOM_ROW + 1; i++) {
      this.displayed_[i] = "";
    }
    for (i = this.topRow_; i < this.row_; i++) {
      this.displayed_[i] = this.displayed_[i + 1];
    }
    this.displayed_[this.row_] = "";
  };
  Cea608Stream.prototype.paintOn = function(pts, text) {
    var baseRow = this.displayed_[this.row_];
    baseRow += text;
    this.displayed_[this.row_] = baseRow;
  };
  var captionStream = {
    CaptionStream: CaptionStream$1,
    Cea608Stream,
    Cea708Stream
  };
  var streamTypes = {
    H264_STREAM_TYPE: 27,
    ADTS_STREAM_TYPE: 15,
    METADATA_STREAM_TYPE: 21
  };
  var MAX_TS = 8589934592;
  var RO_THRESH = 4294967296;
  var TYPE_SHARED = "shared";
  var handleRollover$1 = function handleRollover2(value, reference) {
    var direction = 1;
    if (value > reference) {
      direction = -1;
    }
    while (Math.abs(reference - value) > RO_THRESH) {
      value += direction * MAX_TS;
    }
    return value;
  };
  var TimestampRolloverStream$1 = function TimestampRolloverStream2(type3) {
    var lastDTS, referenceDTS;
    TimestampRolloverStream2.prototype.init.call(this);
    this.type_ = type3 || TYPE_SHARED;
    this.push = function(data) {
      if (this.type_ !== TYPE_SHARED && data.type !== this.type_) {
        return;
      }
      if (referenceDTS === void 0) {
        referenceDTS = data.dts;
      }
      data.dts = handleRollover$1(data.dts, referenceDTS);
      data.pts = handleRollover$1(data.pts, referenceDTS);
      lastDTS = data.dts;
      this.trigger("data", data);
    };
    this.flush = function() {
      referenceDTS = lastDTS;
      this.trigger("done");
    };
    this.endTimeline = function() {
      this.flush();
      this.trigger("endedtimeline");
    };
    this.discontinuity = function() {
      referenceDTS = void 0;
      lastDTS = void 0;
    };
    this.reset = function() {
      this.discontinuity();
      this.trigger("reset");
    };
  };
  TimestampRolloverStream$1.prototype = new stream();
  var timestampRolloverStream = {
    TimestampRolloverStream: TimestampRolloverStream$1,
    handleRollover: handleRollover$1
  };
  var percentEncode$1 = function percentEncode2(bytes, start2, end3) {
    var i, result2 = "";
    for (i = start2; i < end3; i++) {
      result2 += "%" + ("00" + bytes[i].toString(16)).slice(-2);
    }
    return result2;
  }, parseUtf8 = function parseUtf82(bytes, start2, end3) {
    return decodeURIComponent(percentEncode$1(bytes, start2, end3));
  }, parseIso88591$1 = function parseIso885912(bytes, start2, end3) {
    return unescape(percentEncode$1(bytes, start2, end3));
  }, parseSyncSafeInteger$1 = function parseSyncSafeInteger2(data) {
    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
  }, tagParsers = {
    TXXX: function TXXX(tag) {
      var i;
      if (tag.data[0] !== 3) {
        return;
      }
      for (i = 1; i < tag.data.length; i++) {
        if (tag.data[i] === 0) {
          tag.description = parseUtf8(tag.data, 1, i);
          tag.value = parseUtf8(tag.data, i + 1, tag.data.length).replace(/\0*$/, "");
          break;
        }
      }
      tag.data = tag.value;
    },
    WXXX: function WXXX(tag) {
      var i;
      if (tag.data[0] !== 3) {
        return;
      }
      for (i = 1; i < tag.data.length; i++) {
        if (tag.data[i] === 0) {
          tag.description = parseUtf8(tag.data, 1, i);
          tag.url = parseUtf8(tag.data, i + 1, tag.data.length);
          break;
        }
      }
    },
    PRIV: function PRIV(tag) {
      var i;
      for (i = 0; i < tag.data.length; i++) {
        if (tag.data[i] === 0) {
          tag.owner = parseIso88591$1(tag.data, 0, i);
          break;
        }
      }
      tag.privateData = tag.data.subarray(i + 1);
      tag.data = tag.privateData;
    }
  }, _MetadataStream;
  _MetadataStream = function MetadataStream(options) {
    var settings = {
      descriptor: options && options.descriptor
    }, tagSize = 0, buffer = [], bufferSize = 0, i;
    _MetadataStream.prototype.init.call(this);
    this.dispatchType = streamTypes.METADATA_STREAM_TYPE.toString(16);
    if (settings.descriptor) {
      for (i = 0; i < settings.descriptor.length; i++) {
        this.dispatchType += ("00" + settings.descriptor[i].toString(16)).slice(-2);
      }
    }
    this.push = function(chunk) {
      var tag, frameStart, frameSize, frame, i2, frameHeader;
      if (chunk.type !== "timed-metadata") {
        return;
      }
      if (chunk.dataAlignmentIndicator) {
        bufferSize = 0;
        buffer.length = 0;
      }
      if (buffer.length === 0 && (chunk.data.length < 10 || chunk.data[0] !== "I".charCodeAt(0) || chunk.data[1] !== "D".charCodeAt(0) || chunk.data[2] !== "3".charCodeAt(0))) {
        this.trigger("log", {
          level: "warn",
          message: "Skipping unrecognized metadata packet"
        });
        return;
      }
      buffer.push(chunk);
      bufferSize += chunk.data.byteLength;
      if (buffer.length === 1) {
        tagSize = parseSyncSafeInteger$1(chunk.data.subarray(6, 10));
        tagSize += 10;
      }
      if (bufferSize < tagSize) {
        return;
      }
      tag = {
        data: new Uint8Array(tagSize),
        frames: [],
        pts: buffer[0].pts,
        dts: buffer[0].dts
      };
      for (i2 = 0; i2 < tagSize; ) {
        tag.data.set(buffer[0].data.subarray(0, tagSize - i2), i2);
        i2 += buffer[0].data.byteLength;
        bufferSize -= buffer[0].data.byteLength;
        buffer.shift();
      }
      frameStart = 10;
      if (tag.data[5] & 64) {
        frameStart += 4;
        frameStart += parseSyncSafeInteger$1(tag.data.subarray(10, 14));
        tagSize -= parseSyncSafeInteger$1(tag.data.subarray(16, 20));
      }
      do {
        frameSize = parseSyncSafeInteger$1(tag.data.subarray(frameStart + 4, frameStart + 8));
        if (frameSize < 1) {
          this.trigger("log", {
            level: "warn",
            message: "Malformed ID3 frame encountered. Skipping metadata parsing."
          });
          return;
        }
        frameHeader = String.fromCharCode(tag.data[frameStart], tag.data[frameStart + 1], tag.data[frameStart + 2], tag.data[frameStart + 3]);
        frame = {
          id: frameHeader,
          data: tag.data.subarray(frameStart + 10, frameStart + frameSize + 10)
        };
        frame.key = frame.id;
        if (tagParsers[frame.id]) {
          tagParsers[frame.id](frame);
          if (frame.owner === "com.apple.streaming.transportStreamTimestamp") {
            var d3 = frame.data, size = (d3[3] & 1) << 30 | d3[4] << 22 | d3[5] << 14 | d3[6] << 6 | d3[7] >>> 2;
            size *= 4;
            size += d3[7] & 3;
            frame.timeStamp = size;
            if (tag.pts === void 0 && tag.dts === void 0) {
              tag.pts = frame.timeStamp;
              tag.dts = frame.timeStamp;
            }
            this.trigger("timestamp", frame);
          }
        }
        tag.frames.push(frame);
        frameStart += 10;
        frameStart += frameSize;
      } while (frameStart < tagSize);
      this.trigger("data", tag);
    };
  };
  _MetadataStream.prototype = new stream();
  var metadataStream = _MetadataStream;
  var TimestampRolloverStream = timestampRolloverStream.TimestampRolloverStream;
  var _TransportPacketStream, _TransportParseStream, _ElementaryStream;
  var MP2T_PACKET_LENGTH$1 = 188, SYNC_BYTE$1 = 71;
  _TransportPacketStream = function TransportPacketStream() {
    var buffer = new Uint8Array(MP2T_PACKET_LENGTH$1), bytesInBuffer = 0;
    _TransportPacketStream.prototype.init.call(this);
    this.push = function(bytes) {
      var startIndex = 0, endIndex = MP2T_PACKET_LENGTH$1, everything;
      if (bytesInBuffer) {
        everything = new Uint8Array(bytes.byteLength + bytesInBuffer);
        everything.set(buffer.subarray(0, bytesInBuffer));
        everything.set(bytes, bytesInBuffer);
        bytesInBuffer = 0;
      } else {
        everything = bytes;
      }
      while (endIndex < everything.byteLength) {
        if (everything[startIndex] === SYNC_BYTE$1 && everything[endIndex] === SYNC_BYTE$1) {
          this.trigger("data", everything.subarray(startIndex, endIndex));
          startIndex += MP2T_PACKET_LENGTH$1;
          endIndex += MP2T_PACKET_LENGTH$1;
          continue;
        }
        startIndex++;
        endIndex++;
      }
      if (startIndex < everything.byteLength) {
        buffer.set(everything.subarray(startIndex), 0);
        bytesInBuffer = everything.byteLength - startIndex;
      }
    };
    this.flush = function() {
      if (bytesInBuffer === MP2T_PACKET_LENGTH$1 && buffer[0] === SYNC_BYTE$1) {
        this.trigger("data", buffer);
        bytesInBuffer = 0;
      }
      this.trigger("done");
    };
    this.endTimeline = function() {
      this.flush();
      this.trigger("endedtimeline");
    };
    this.reset = function() {
      bytesInBuffer = 0;
      this.trigger("reset");
    };
  };
  _TransportPacketStream.prototype = new stream();
  _TransportParseStream = function TransportParseStream() {
    var parsePsi, parsePat2, parsePmt2, self2;
    _TransportParseStream.prototype.init.call(this);
    self2 = this;
    this.packetsWaitingForPmt = [];
    this.programMapTable = void 0;
    parsePsi = function parsePsi2(payload, psi) {
      var offset2 = 0;
      if (psi.payloadUnitStartIndicator) {
        offset2 += payload[offset2] + 1;
      }
      if (psi.type === "pat") {
        parsePat2(payload.subarray(offset2), psi);
      } else {
        parsePmt2(payload.subarray(offset2), psi);
      }
    };
    parsePat2 = function parsePat3(payload, pat) {
      pat.section_number = payload[7];
      pat.last_section_number = payload[8];
      self2.pmtPid = (payload[10] & 31) << 8 | payload[11];
      pat.pmtPid = self2.pmtPid;
    };
    parsePmt2 = function parsePmt3(payload, pmt) {
      var sectionLength, tableEnd, programInfoLength, offset2;
      if (!(payload[5] & 1)) {
        return;
      }
      self2.programMapTable = {
        video: null,
        audio: null,
        "timed-metadata": {}
      };
      sectionLength = (payload[1] & 15) << 8 | payload[2];
      tableEnd = 3 + sectionLength - 4;
      programInfoLength = (payload[10] & 15) << 8 | payload[11];
      offset2 = 12 + programInfoLength;
      while (offset2 < tableEnd) {
        var streamType = payload[offset2];
        var pid = (payload[offset2 + 1] & 31) << 8 | payload[offset2 + 2];
        if (streamType === streamTypes.H264_STREAM_TYPE && self2.programMapTable.video === null) {
          self2.programMapTable.video = pid;
        } else if (streamType === streamTypes.ADTS_STREAM_TYPE && self2.programMapTable.audio === null) {
          self2.programMapTable.audio = pid;
        } else if (streamType === streamTypes.METADATA_STREAM_TYPE) {
          self2.programMapTable["timed-metadata"][pid] = streamType;
        }
        offset2 += ((payload[offset2 + 3] & 15) << 8 | payload[offset2 + 4]) + 5;
      }
      pmt.programMapTable = self2.programMapTable;
    };
    this.push = function(packet) {
      var result2 = {}, offset2 = 4;
      result2.payloadUnitStartIndicator = !!(packet[1] & 64);
      result2.pid = packet[1] & 31;
      result2.pid <<= 8;
      result2.pid |= packet[2];
      if ((packet[3] & 48) >>> 4 > 1) {
        offset2 += packet[offset2] + 1;
      }
      if (result2.pid === 0) {
        result2.type = "pat";
        parsePsi(packet.subarray(offset2), result2);
        this.trigger("data", result2);
      } else if (result2.pid === this.pmtPid) {
        result2.type = "pmt";
        parsePsi(packet.subarray(offset2), result2);
        this.trigger("data", result2);
        while (this.packetsWaitingForPmt.length) {
          this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
        }
      } else if (this.programMapTable === void 0) {
        this.packetsWaitingForPmt.push([packet, offset2, result2]);
      } else {
        this.processPes_(packet, offset2, result2);
      }
    };
    this.processPes_ = function(packet, offset2, result2) {
      if (result2.pid === this.programMapTable.video) {
        result2.streamType = streamTypes.H264_STREAM_TYPE;
      } else if (result2.pid === this.programMapTable.audio) {
        result2.streamType = streamTypes.ADTS_STREAM_TYPE;
      } else {
        result2.streamType = this.programMapTable["timed-metadata"][result2.pid];
      }
      result2.type = "pes";
      result2.data = packet.subarray(offset2);
      this.trigger("data", result2);
    };
  };
  _TransportParseStream.prototype = new stream();
  _TransportParseStream.STREAM_TYPES = {
    h264: 27,
    adts: 15
  };
  _ElementaryStream = function ElementaryStream() {
    var self2 = this, segmentHadPmt = false, video = {
      data: [],
      size: 0
    }, audio = {
      data: [],
      size: 0
    }, timedMetadata = {
      data: [],
      size: 0
    }, programMapTable, parsePes = function parsePes2(payload, pes) {
      var ptsDtsFlags;
      var startPrefix = payload[0] << 16 | payload[1] << 8 | payload[2];
      pes.data = new Uint8Array();
      if (startPrefix !== 1) {
        return;
      }
      pes.packetLength = 6 + (payload[4] << 8 | payload[5]);
      pes.dataAlignmentIndicator = (payload[6] & 4) !== 0;
      ptsDtsFlags = payload[7];
      if (ptsDtsFlags & 192) {
        pes.pts = (payload[9] & 14) << 27 | (payload[10] & 255) << 20 | (payload[11] & 254) << 12 | (payload[12] & 255) << 5 | (payload[13] & 254) >>> 3;
        pes.pts *= 4;
        pes.pts += (payload[13] & 6) >>> 1;
        pes.dts = pes.pts;
        if (ptsDtsFlags & 64) {
          pes.dts = (payload[14] & 14) << 27 | (payload[15] & 255) << 20 | (payload[16] & 254) << 12 | (payload[17] & 255) << 5 | (payload[18] & 254) >>> 3;
          pes.dts *= 4;
          pes.dts += (payload[18] & 6) >>> 1;
        }
      }
      pes.data = payload.subarray(9 + payload[8]);
    }, flushStream = function flushStream2(stream2, type3, forceFlush) {
      var packetData = new Uint8Array(stream2.size), event = {
        type: type3
      }, i = 0, offset2 = 0, packetFlushable = false, fragment;
      if (!stream2.data.length || stream2.size < 9) {
        return;
      }
      event.trackId = stream2.data[0].pid;
      for (i = 0; i < stream2.data.length; i++) {
        fragment = stream2.data[i];
        packetData.set(fragment.data, offset2);
        offset2 += fragment.data.byteLength;
      }
      parsePes(packetData, event);
      packetFlushable = type3 === "video" || event.packetLength <= stream2.size;
      if (forceFlush || packetFlushable) {
        stream2.size = 0;
        stream2.data.length = 0;
      }
      if (packetFlushable) {
        self2.trigger("data", event);
      }
    };
    _ElementaryStream.prototype.init.call(this);
    this.push = function(data) {
      ({
        pat: function pat() {
        },
        pes: function pes() {
          var stream2, streamType;
          switch (data.streamType) {
            case streamTypes.H264_STREAM_TYPE:
              stream2 = video;
              streamType = "video";
              break;
            case streamTypes.ADTS_STREAM_TYPE:
              stream2 = audio;
              streamType = "audio";
              break;
            case streamTypes.METADATA_STREAM_TYPE:
              stream2 = timedMetadata;
              streamType = "timed-metadata";
              break;
            default:
              return;
          }
          if (data.payloadUnitStartIndicator) {
            flushStream(stream2, streamType, true);
          }
          stream2.data.push(data);
          stream2.size += data.data.byteLength;
        },
        pmt: function pmt() {
          var event = {
            type: "metadata",
            tracks: []
          };
          programMapTable = data.programMapTable;
          if (programMapTable.video !== null) {
            event.tracks.push({
              timelineStartInfo: {
                baseMediaDecodeTime: 0
              },
              id: +programMapTable.video,
              codec: "avc",
              type: "video"
            });
          }
          if (programMapTable.audio !== null) {
            event.tracks.push({
              timelineStartInfo: {
                baseMediaDecodeTime: 0
              },
              id: +programMapTable.audio,
              codec: "adts",
              type: "audio"
            });
          }
          segmentHadPmt = true;
          self2.trigger("data", event);
        }
      })[data.type]();
    };
    this.reset = function() {
      video.size = 0;
      video.data.length = 0;
      audio.size = 0;
      audio.data.length = 0;
      this.trigger("reset");
    };
    this.flushStreams_ = function() {
      flushStream(video, "video");
      flushStream(audio, "audio");
      flushStream(timedMetadata, "timed-metadata");
    };
    this.flush = function() {
      if (!segmentHadPmt && programMapTable) {
        var pmt = {
          type: "metadata",
          tracks: []
        };
        if (programMapTable.video !== null) {
          pmt.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +programMapTable.video,
            codec: "avc",
            type: "video"
          });
        }
        if (programMapTable.audio !== null) {
          pmt.tracks.push({
            timelineStartInfo: {
              baseMediaDecodeTime: 0
            },
            id: +programMapTable.audio,
            codec: "adts",
            type: "audio"
          });
        }
        self2.trigger("data", pmt);
      }
      segmentHadPmt = false;
      this.flushStreams_();
      this.trigger("done");
    };
  };
  _ElementaryStream.prototype = new stream();
  var m2ts = {
    PAT_PID: 0,
    MP2T_PACKET_LENGTH: MP2T_PACKET_LENGTH$1,
    TransportPacketStream: _TransportPacketStream,
    TransportParseStream: _TransportParseStream,
    ElementaryStream: _ElementaryStream,
    TimestampRolloverStream,
    CaptionStream: captionStream.CaptionStream,
    Cea608Stream: captionStream.Cea608Stream,
    Cea708Stream: captionStream.Cea708Stream,
    MetadataStream: metadataStream
  };
  for (var type2 in streamTypes) {
    if (streamTypes.hasOwnProperty(type2)) {
      m2ts[type2] = streamTypes[type2];
    }
  }
  var m2ts_1 = m2ts;
  var ONE_SECOND_IN_TS$2 = clock2.ONE_SECOND_IN_TS;
  var _AdtsStream;
  var ADTS_SAMPLING_FREQUENCIES$1 = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  _AdtsStream = function AdtsStream(handlePartialSegments) {
    var buffer, frameNum = 0;
    _AdtsStream.prototype.init.call(this);
    this.skipWarn_ = function(start2, end3) {
      this.trigger("log", {
        level: "warn",
        message: "adts skiping bytes " + start2 + " to " + end3 + " in frame " + frameNum + " outside syncword"
      });
    };
    this.push = function(packet) {
      var i = 0, frameLength, protectionSkipBytes, oldBuffer, sampleCount, adtsFrameDuration;
      if (!handlePartialSegments) {
        frameNum = 0;
      }
      if (packet.type !== "audio") {
        return;
      }
      if (buffer && buffer.length) {
        oldBuffer = buffer;
        buffer = new Uint8Array(oldBuffer.byteLength + packet.data.byteLength);
        buffer.set(oldBuffer);
        buffer.set(packet.data, oldBuffer.byteLength);
      } else {
        buffer = packet.data;
      }
      var skip;
      while (i + 7 < buffer.length) {
        if (buffer[i] !== 255 || (buffer[i + 1] & 246) !== 240) {
          if (typeof skip !== "number") {
            skip = i;
          }
          i++;
          continue;
        }
        if (typeof skip === "number") {
          this.skipWarn_(skip, i);
          skip = null;
        }
        protectionSkipBytes = (~buffer[i + 1] & 1) * 2;
        frameLength = (buffer[i + 3] & 3) << 11 | buffer[i + 4] << 3 | (buffer[i + 5] & 224) >> 5;
        sampleCount = ((buffer[i + 6] & 3) + 1) * 1024;
        adtsFrameDuration = sampleCount * ONE_SECOND_IN_TS$2 / ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 60) >>> 2];
        if (buffer.byteLength - i < frameLength) {
          break;
        }
        this.trigger("data", {
          pts: packet.pts + frameNum * adtsFrameDuration,
          dts: packet.dts + frameNum * adtsFrameDuration,
          sampleCount,
          audioobjecttype: (buffer[i + 2] >>> 6 & 3) + 1,
          channelcount: (buffer[i + 2] & 1) << 2 | (buffer[i + 3] & 192) >>> 6,
          samplerate: ADTS_SAMPLING_FREQUENCIES$1[(buffer[i + 2] & 60) >>> 2],
          samplingfrequencyindex: (buffer[i + 2] & 60) >>> 2,
          samplesize: 16,
          data: buffer.subarray(i + 7 + protectionSkipBytes, i + frameLength)
        });
        frameNum++;
        i += frameLength;
      }
      if (typeof skip === "number") {
        this.skipWarn_(skip, i);
        skip = null;
      }
      buffer = buffer.subarray(i);
    };
    this.flush = function() {
      frameNum = 0;
      this.trigger("done");
    };
    this.reset = function() {
      buffer = void 0;
      this.trigger("reset");
    };
    this.endTimeline = function() {
      buffer = void 0;
      this.trigger("endedtimeline");
    };
  };
  _AdtsStream.prototype = new stream();
  var adts = _AdtsStream;
  var ExpGolomb;
  ExpGolomb = function ExpGolomb2(workingData) {
    var workingBytesAvailable = workingData.byteLength, workingWord = 0, workingBitsAvailable = 0;
    this.length = function() {
      return 8 * workingBytesAvailable;
    };
    this.bitsAvailable = function() {
      return 8 * workingBytesAvailable + workingBitsAvailable;
    };
    this.loadWord = function() {
      var position2 = workingData.byteLength - workingBytesAvailable, workingBytes = new Uint8Array(4), availableBytes = Math.min(4, workingBytesAvailable);
      if (availableBytes === 0) {
        throw new Error("no bytes available");
      }
      workingBytes.set(workingData.subarray(position2, position2 + availableBytes));
      workingWord = new DataView(workingBytes.buffer).getUint32(0);
      workingBitsAvailable = availableBytes * 8;
      workingBytesAvailable -= availableBytes;
    };
    this.skipBits = function(count) {
      var skipBytes;
      if (workingBitsAvailable > count) {
        workingWord <<= count;
        workingBitsAvailable -= count;
      } else {
        count -= workingBitsAvailable;
        skipBytes = Math.floor(count / 8);
        count -= skipBytes * 8;
        workingBytesAvailable -= skipBytes;
        this.loadWord();
        workingWord <<= count;
        workingBitsAvailable -= count;
      }
    };
    this.readBits = function(size) {
      var bits = Math.min(workingBitsAvailable, size), valu = workingWord >>> 32 - bits;
      workingBitsAvailable -= bits;
      if (workingBitsAvailable > 0) {
        workingWord <<= bits;
      } else if (workingBytesAvailable > 0) {
        this.loadWord();
      }
      bits = size - bits;
      if (bits > 0) {
        return valu << bits | this.readBits(bits);
      }
      return valu;
    };
    this.skipLeadingZeros = function() {
      var leadingZeroCount;
      for (leadingZeroCount = 0; leadingZeroCount < workingBitsAvailable; ++leadingZeroCount) {
        if ((workingWord & 2147483648 >>> leadingZeroCount) !== 0) {
          workingWord <<= leadingZeroCount;
          workingBitsAvailable -= leadingZeroCount;
          return leadingZeroCount;
        }
      }
      this.loadWord();
      return leadingZeroCount + this.skipLeadingZeros();
    };
    this.skipUnsignedExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    };
    this.skipExpGolomb = function() {
      this.skipBits(1 + this.skipLeadingZeros());
    };
    this.readUnsignedExpGolomb = function() {
      var clz = this.skipLeadingZeros();
      return this.readBits(clz + 1) - 1;
    };
    this.readExpGolomb = function() {
      var valu = this.readUnsignedExpGolomb();
      if (1 & valu) {
        return 1 + valu >>> 1;
      }
      return -1 * (valu >>> 1);
    };
    this.readBoolean = function() {
      return this.readBits(1) === 1;
    };
    this.readUnsignedByte = function() {
      return this.readBits(8);
    };
    this.loadWord();
  };
  var expGolomb = ExpGolomb;
  var _H264Stream, _NalByteStream;
  var PROFILES_WITH_OPTIONAL_SPS_DATA;
  _NalByteStream = function NalByteStream() {
    var syncPoint = 0, i, buffer;
    _NalByteStream.prototype.init.call(this);
    this.push = function(data) {
      var swapBuffer;
      if (!buffer) {
        buffer = data.data;
      } else {
        swapBuffer = new Uint8Array(buffer.byteLength + data.data.byteLength);
        swapBuffer.set(buffer);
        swapBuffer.set(data.data, buffer.byteLength);
        buffer = swapBuffer;
      }
      var len = buffer.byteLength;
      for (; syncPoint < len - 3; syncPoint++) {
        if (buffer[syncPoint + 2] === 1) {
          i = syncPoint + 5;
          break;
        }
      }
      while (i < len) {
        switch (buffer[i]) {
          case 0:
            if (buffer[i - 1] !== 0) {
              i += 2;
              break;
            } else if (buffer[i - 2] !== 0) {
              i++;
              break;
            }
            if (syncPoint + 3 !== i - 2) {
              this.trigger("data", buffer.subarray(syncPoint + 3, i - 2));
            }
            do {
              i++;
            } while (buffer[i] !== 1 && i < len);
            syncPoint = i - 2;
            i += 3;
            break;
          case 1:
            if (buffer[i - 1] !== 0 || buffer[i - 2] !== 0) {
              i += 3;
              break;
            }
            this.trigger("data", buffer.subarray(syncPoint + 3, i - 2));
            syncPoint = i - 2;
            i += 3;
            break;
          default:
            i += 3;
            break;
        }
      }
      buffer = buffer.subarray(syncPoint);
      i -= syncPoint;
      syncPoint = 0;
    };
    this.reset = function() {
      buffer = null;
      syncPoint = 0;
      this.trigger("reset");
    };
    this.flush = function() {
      if (buffer && buffer.byteLength > 3) {
        this.trigger("data", buffer.subarray(syncPoint + 3));
      }
      buffer = null;
      syncPoint = 0;
      this.trigger("done");
    };
    this.endTimeline = function() {
      this.flush();
      this.trigger("endedtimeline");
    };
  };
  _NalByteStream.prototype = new stream();
  PROFILES_WITH_OPTIONAL_SPS_DATA = {
    100: true,
    110: true,
    122: true,
    244: true,
    44: true,
    83: true,
    86: true,
    118: true,
    128: true,
    138: true,
    139: true,
    134: true
  };
  _H264Stream = function H264Stream2() {
    var nalByteStream = new _NalByteStream(), self2, trackId, currentPts, currentDts, discardEmulationPreventionBytes4, readSequenceParameterSet, skipScalingList;
    _H264Stream.prototype.init.call(this);
    self2 = this;
    this.push = function(packet) {
      if (packet.type !== "video") {
        return;
      }
      trackId = packet.trackId;
      currentPts = packet.pts;
      currentDts = packet.dts;
      nalByteStream.push(packet);
    };
    nalByteStream.on("data", function(data) {
      var event = {
        trackId,
        pts: currentPts,
        dts: currentDts,
        data,
        nalUnitTypeCode: data[0] & 31
      };
      switch (event.nalUnitTypeCode) {
        case 5:
          event.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
          break;
        case 6:
          event.nalUnitType = "sei_rbsp";
          event.escapedRBSP = discardEmulationPreventionBytes4(data.subarray(1));
          break;
        case 7:
          event.nalUnitType = "seq_parameter_set_rbsp";
          event.escapedRBSP = discardEmulationPreventionBytes4(data.subarray(1));
          event.config = readSequenceParameterSet(event.escapedRBSP);
          break;
        case 8:
          event.nalUnitType = "pic_parameter_set_rbsp";
          break;
        case 9:
          event.nalUnitType = "access_unit_delimiter_rbsp";
          break;
      }
      self2.trigger("data", event);
    });
    nalByteStream.on("done", function() {
      self2.trigger("done");
    });
    nalByteStream.on("partialdone", function() {
      self2.trigger("partialdone");
    });
    nalByteStream.on("reset", function() {
      self2.trigger("reset");
    });
    nalByteStream.on("endedtimeline", function() {
      self2.trigger("endedtimeline");
    });
    this.flush = function() {
      nalByteStream.flush();
    };
    this.partialFlush = function() {
      nalByteStream.partialFlush();
    };
    this.reset = function() {
      nalByteStream.reset();
    };
    this.endTimeline = function() {
      nalByteStream.endTimeline();
    };
    skipScalingList = function skipScalingList2(count, expGolombDecoder) {
      var lastScale = 8, nextScale = 8, j, deltaScale;
      for (j = 0; j < count; j++) {
        if (nextScale !== 0) {
          deltaScale = expGolombDecoder.readExpGolomb();
          nextScale = (lastScale + deltaScale + 256) % 256;
        }
        lastScale = nextScale === 0 ? lastScale : nextScale;
      }
    };
    discardEmulationPreventionBytes4 = function discardEmulationPreventionBytes5(data) {
      var length = data.byteLength, emulationPreventionBytesPositions = [], i = 1, newLength, newData;
      while (i < length - 2) {
        if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 3) {
          emulationPreventionBytesPositions.push(i + 2);
          i += 2;
        } else {
          i++;
        }
      }
      if (emulationPreventionBytesPositions.length === 0) {
        return data;
      }
      newLength = length - emulationPreventionBytesPositions.length;
      newData = new Uint8Array(newLength);
      var sourceIndex = 0;
      for (i = 0; i < newLength; sourceIndex++, i++) {
        if (sourceIndex === emulationPreventionBytesPositions[0]) {
          sourceIndex++;
          emulationPreventionBytesPositions.shift();
        }
        newData[i] = data[sourceIndex];
      }
      return newData;
    };
    readSequenceParameterSet = function readSequenceParameterSet2(data) {
      var frameCropLeftOffset = 0, frameCropRightOffset = 0, frameCropTopOffset = 0, frameCropBottomOffset = 0, expGolombDecoder, profileIdc, levelIdc, profileCompatibility, chromaFormatIdc, picOrderCntType, numRefFramesInPicOrderCntCycle, picWidthInMbsMinus1, picHeightInMapUnitsMinus1, frameMbsOnlyFlag, scalingListCount, sarRatio = [1, 1], aspectRatioIdc, i;
      expGolombDecoder = new expGolomb(data);
      profileIdc = expGolombDecoder.readUnsignedByte();
      profileCompatibility = expGolombDecoder.readUnsignedByte();
      levelIdc = expGolombDecoder.readUnsignedByte();
      expGolombDecoder.skipUnsignedExpGolomb();
      if (PROFILES_WITH_OPTIONAL_SPS_DATA[profileIdc]) {
        chromaFormatIdc = expGolombDecoder.readUnsignedExpGolomb();
        if (chromaFormatIdc === 3) {
          expGolombDecoder.skipBits(1);
        }
        expGolombDecoder.skipUnsignedExpGolomb();
        expGolombDecoder.skipUnsignedExpGolomb();
        expGolombDecoder.skipBits(1);
        if (expGolombDecoder.readBoolean()) {
          scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
          for (i = 0; i < scalingListCount; i++) {
            if (expGolombDecoder.readBoolean()) {
              if (i < 6) {
                skipScalingList(16, expGolombDecoder);
              } else {
                skipScalingList(64, expGolombDecoder);
              }
            }
          }
        }
      }
      expGolombDecoder.skipUnsignedExpGolomb();
      picOrderCntType = expGolombDecoder.readUnsignedExpGolomb();
      if (picOrderCntType === 0) {
        expGolombDecoder.readUnsignedExpGolomb();
      } else if (picOrderCntType === 1) {
        expGolombDecoder.skipBits(1);
        expGolombDecoder.skipExpGolomb();
        expGolombDecoder.skipExpGolomb();
        numRefFramesInPicOrderCntCycle = expGolombDecoder.readUnsignedExpGolomb();
        for (i = 0; i < numRefFramesInPicOrderCntCycle; i++) {
          expGolombDecoder.skipExpGolomb();
        }
      }
      expGolombDecoder.skipUnsignedExpGolomb();
      expGolombDecoder.skipBits(1);
      picWidthInMbsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
      picHeightInMapUnitsMinus1 = expGolombDecoder.readUnsignedExpGolomb();
      frameMbsOnlyFlag = expGolombDecoder.readBits(1);
      if (frameMbsOnlyFlag === 0) {
        expGolombDecoder.skipBits(1);
      }
      expGolombDecoder.skipBits(1);
      if (expGolombDecoder.readBoolean()) {
        frameCropLeftOffset = expGolombDecoder.readUnsignedExpGolomb();
        frameCropRightOffset = expGolombDecoder.readUnsignedExpGolomb();
        frameCropTopOffset = expGolombDecoder.readUnsignedExpGolomb();
        frameCropBottomOffset = expGolombDecoder.readUnsignedExpGolomb();
      }
      if (expGolombDecoder.readBoolean()) {
        if (expGolombDecoder.readBoolean()) {
          aspectRatioIdc = expGolombDecoder.readUnsignedByte();
          switch (aspectRatioIdc) {
            case 1:
              sarRatio = [1, 1];
              break;
            case 2:
              sarRatio = [12, 11];
              break;
            case 3:
              sarRatio = [10, 11];
              break;
            case 4:
              sarRatio = [16, 11];
              break;
            case 5:
              sarRatio = [40, 33];
              break;
            case 6:
              sarRatio = [24, 11];
              break;
            case 7:
              sarRatio = [20, 11];
              break;
            case 8:
              sarRatio = [32, 11];
              break;
            case 9:
              sarRatio = [80, 33];
              break;
            case 10:
              sarRatio = [18, 11];
              break;
            case 11:
              sarRatio = [15, 11];
              break;
            case 12:
              sarRatio = [64, 33];
              break;
            case 13:
              sarRatio = [160, 99];
              break;
            case 14:
              sarRatio = [4, 3];
              break;
            case 15:
              sarRatio = [3, 2];
              break;
            case 16:
              sarRatio = [2, 1];
              break;
            case 255: {
              sarRatio = [expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte(), expGolombDecoder.readUnsignedByte() << 8 | expGolombDecoder.readUnsignedByte()];
              break;
            }
          }
          if (sarRatio) {
            sarRatio[0] / sarRatio[1];
          }
        }
      }
      return {
        profileIdc,
        levelIdc,
        profileCompatibility,
        width: (picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2,
        height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - frameCropTopOffset * 2 - frameCropBottomOffset * 2,
        sarRatio
      };
    };
  };
  _H264Stream.prototype = new stream();
  var h2642 = {
    H264Stream: _H264Stream,
    NalByteStream: _NalByteStream
  };
  var ADTS_SAMPLING_FREQUENCIES = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350];
  var parseId3TagSize = function parseId3TagSize2(header2, byteIndex) {
    var returnSize = header2[byteIndex + 6] << 21 | header2[byteIndex + 7] << 14 | header2[byteIndex + 8] << 7 | header2[byteIndex + 9], flags = header2[byteIndex + 5], footerPresent = (flags & 16) >> 4;
    returnSize = returnSize >= 0 ? returnSize : 0;
    if (footerPresent) {
      return returnSize + 20;
    }
    return returnSize + 10;
  };
  var getId3Offset3 = function getId3Offset4(data, offset2) {
    if (data.length - offset2 < 10 || data[offset2] !== "I".charCodeAt(0) || data[offset2 + 1] !== "D".charCodeAt(0) || data[offset2 + 2] !== "3".charCodeAt(0)) {
      return offset2;
    }
    offset2 += parseId3TagSize(data, offset2);
    return getId3Offset4(data, offset2);
  };
  var isLikelyAacData$1 = function isLikelyAacData2(data) {
    var offset2 = getId3Offset3(data, 0);
    return data.length >= offset2 + 2 && (data[offset2] & 255) === 255 && (data[offset2 + 1] & 240) === 240 && (data[offset2 + 1] & 22) === 16;
  };
  var parseSyncSafeInteger = function parseSyncSafeInteger2(data) {
    return data[0] << 21 | data[1] << 14 | data[2] << 7 | data[3];
  };
  var percentEncode = function percentEncode2(bytes, start2, end3) {
    var i, result2 = "";
    for (i = start2; i < end3; i++) {
      result2 += "%" + ("00" + bytes[i].toString(16)).slice(-2);
    }
    return result2;
  };
  var parseIso88591 = function parseIso885912(bytes, start2, end3) {
    return unescape(percentEncode(bytes, start2, end3));
  };
  var parseAdtsSize = function parseAdtsSize2(header2, byteIndex) {
    var lowThree = (header2[byteIndex + 5] & 224) >> 5, middle = header2[byteIndex + 4] << 3, highTwo = header2[byteIndex + 3] & 3 << 11;
    return highTwo | middle | lowThree;
  };
  var parseType$2 = function parseType2(header2, byteIndex) {
    if (header2[byteIndex] === "I".charCodeAt(0) && header2[byteIndex + 1] === "D".charCodeAt(0) && header2[byteIndex + 2] === "3".charCodeAt(0)) {
      return "timed-metadata";
    } else if (header2[byteIndex] & true && (header2[byteIndex + 1] & 240) === 240) {
      return "audio";
    }
    return null;
  };
  var parseSampleRate = function parseSampleRate2(packet) {
    var i = 0;
    while (i + 5 < packet.length) {
      if (packet[i] !== 255 || (packet[i + 1] & 246) !== 240) {
        i++;
        continue;
      }
      return ADTS_SAMPLING_FREQUENCIES[(packet[i + 2] & 60) >>> 2];
    }
    return null;
  };
  var parseAacTimestamp = function parseAacTimestamp2(packet) {
    var frameStart, frameSize, frame, frameHeader;
    frameStart = 10;
    if (packet[5] & 64) {
      frameStart += 4;
      frameStart += parseSyncSafeInteger(packet.subarray(10, 14));
    }
    do {
      frameSize = parseSyncSafeInteger(packet.subarray(frameStart + 4, frameStart + 8));
      if (frameSize < 1) {
        return null;
      }
      frameHeader = String.fromCharCode(packet[frameStart], packet[frameStart + 1], packet[frameStart + 2], packet[frameStart + 3]);
      if (frameHeader === "PRIV") {
        frame = packet.subarray(frameStart + 10, frameStart + frameSize + 10);
        for (var i = 0; i < frame.byteLength; i++) {
          if (frame[i] === 0) {
            var owner = parseIso88591(frame, 0, i);
            if (owner === "com.apple.streaming.transportStreamTimestamp") {
              var d3 = frame.subarray(i + 1);
              var size = (d3[3] & 1) << 30 | d3[4] << 22 | d3[5] << 14 | d3[6] << 6 | d3[7] >>> 2;
              size *= 4;
              size += d3[7] & 3;
              return size;
            }
            break;
          }
        }
      }
      frameStart += 10;
      frameStart += frameSize;
    } while (frameStart < packet.byteLength);
    return null;
  };
  var utils2 = {
    isLikelyAacData: isLikelyAacData$1,
    parseId3TagSize,
    parseAdtsSize,
    parseType: parseType$2,
    parseSampleRate,
    parseAacTimestamp
  };
  var _AacStream;
  _AacStream = function AacStream() {
    var everything = new Uint8Array(), timeStamp = 0;
    _AacStream.prototype.init.call(this);
    this.setTimestamp = function(timestamp) {
      timeStamp = timestamp;
    };
    this.push = function(bytes) {
      var frameSize = 0, byteIndex = 0, bytesLeft, chunk, packet, tempLength;
      if (everything.length) {
        tempLength = everything.length;
        everything = new Uint8Array(bytes.byteLength + tempLength);
        everything.set(everything.subarray(0, tempLength));
        everything.set(bytes, tempLength);
      } else {
        everything = bytes;
      }
      while (everything.length - byteIndex >= 3) {
        if (everything[byteIndex] === "I".charCodeAt(0) && everything[byteIndex + 1] === "D".charCodeAt(0) && everything[byteIndex + 2] === "3".charCodeAt(0)) {
          if (everything.length - byteIndex < 10) {
            break;
          }
          frameSize = utils2.parseId3TagSize(everything, byteIndex);
          if (byteIndex + frameSize > everything.length) {
            break;
          }
          chunk = {
            type: "timed-metadata",
            data: everything.subarray(byteIndex, byteIndex + frameSize)
          };
          this.trigger("data", chunk);
          byteIndex += frameSize;
          continue;
        } else if ((everything[byteIndex] & 255) === 255 && (everything[byteIndex + 1] & 240) === 240) {
          if (everything.length - byteIndex < 7) {
            break;
          }
          frameSize = utils2.parseAdtsSize(everything, byteIndex);
          if (byteIndex + frameSize > everything.length) {
            break;
          }
          packet = {
            type: "audio",
            data: everything.subarray(byteIndex, byteIndex + frameSize),
            pts: timeStamp,
            dts: timeStamp
          };
          this.trigger("data", packet);
          byteIndex += frameSize;
          continue;
        }
        byteIndex++;
      }
      bytesLeft = everything.length - byteIndex;
      if (bytesLeft > 0) {
        everything = everything.subarray(byteIndex);
      } else {
        everything = new Uint8Array();
      }
    };
    this.reset = function() {
      everything = new Uint8Array();
      this.trigger("reset");
    };
    this.endTimeline = function() {
      everything = new Uint8Array();
      this.trigger("endedtimeline");
    };
  };
  _AacStream.prototype = new stream();
  var aac2 = _AacStream;
  var AUDIO_PROPERTIES = ["audioobjecttype", "channelcount", "samplerate", "samplingfrequencyindex", "samplesize"];
  var audioProperties = AUDIO_PROPERTIES;
  var VIDEO_PROPERTIES = ["width", "height", "profileIdc", "levelIdc", "profileCompatibility", "sarRatio"];
  var videoProperties = VIDEO_PROPERTIES;
  var H264Stream = h2642.H264Stream;
  var isLikelyAacData = utils2.isLikelyAacData;
  var ONE_SECOND_IN_TS$1 = clock2.ONE_SECOND_IN_TS;
  var _VideoSegmentStream, _AudioSegmentStream, _Transmuxer, _CoalesceStream;
  var retriggerForStream = function retriggerForStream2(key, event) {
    event.stream = key;
    this.trigger("log", event);
  };
  var addPipelineLogRetriggers = function addPipelineLogRetriggers2(transmuxer2, pipeline) {
    var keys3 = Object.keys(pipeline);
    for (var i = 0; i < keys3.length; i++) {
      var key = keys3[i];
      if (key === "headOfPipeline" || !pipeline[key].on) {
        continue;
      }
      pipeline[key].on("log", retriggerForStream.bind(transmuxer2, key));
    }
  };
  var arrayEquals = function arrayEquals2(a, b) {
    var i;
    if (a.length !== b.length) {
      return false;
    }
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) {
        return false;
      }
    }
    return true;
  };
  var generateSegmentTimingInfo = function generateSegmentTimingInfo2(baseMediaDecodeTime, startDts, startPts, endDts, endPts, prependedContentDuration) {
    var ptsOffsetFromDts = startPts - startDts, decodeDuration = endDts - startDts, presentationDuration = endPts - startPts;
    return {
      start: {
        dts: baseMediaDecodeTime,
        pts: baseMediaDecodeTime + ptsOffsetFromDts
      },
      end: {
        dts: baseMediaDecodeTime + decodeDuration,
        pts: baseMediaDecodeTime + presentationDuration
      },
      prependedContentDuration,
      baseMediaDecodeTime
    };
  };
  _AudioSegmentStream = function AudioSegmentStream(track, options) {
    var adtsFrames = [], sequenceNumber, earliestAllowedDts = 0, audioAppendStartTs = 0, videoBaseMediaDecodeTime = Infinity;
    options = options || {};
    sequenceNumber = options.firstSequenceNumber || 0;
    _AudioSegmentStream.prototype.init.call(this);
    this.push = function(data) {
      trackDecodeInfo.collectDtsInfo(track, data);
      if (track) {
        audioProperties.forEach(function(prop) {
          track[prop] = data[prop];
        });
      }
      adtsFrames.push(data);
    };
    this.setEarliestDts = function(earliestDts) {
      earliestAllowedDts = earliestDts;
    };
    this.setVideoBaseMediaDecodeTime = function(baseMediaDecodeTime) {
      videoBaseMediaDecodeTime = baseMediaDecodeTime;
    };
    this.setAudioAppendStart = function(timestamp) {
      audioAppendStartTs = timestamp;
    };
    this.flush = function() {
      var frames, moof2, mdat2, boxes, frameDuration, segmentDuration, videoClockCyclesOfSilencePrefixed;
      if (adtsFrames.length === 0) {
        this.trigger("done", "AudioSegmentStream");
        return;
      }
      frames = audioFrameUtils.trimAdtsFramesByEarliestDts(adtsFrames, track, earliestAllowedDts);
      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
      videoClockCyclesOfSilencePrefixed = audioFrameUtils.prefixWithSilence(track, frames, audioAppendStartTs, videoBaseMediaDecodeTime);
      track.samples = audioFrameUtils.generateSampleTable(frames);
      mdat2 = mp4Generator.mdat(audioFrameUtils.concatenateFrameData(frames));
      adtsFrames = [];
      moof2 = mp4Generator.moof(sequenceNumber, [track]);
      boxes = new Uint8Array(moof2.byteLength + mdat2.byteLength);
      sequenceNumber++;
      boxes.set(moof2);
      boxes.set(mdat2, moof2.byteLength);
      trackDecodeInfo.clearDtsInfo(track);
      frameDuration = Math.ceil(ONE_SECOND_IN_TS$1 * 1024 / track.samplerate);
      if (frames.length) {
        segmentDuration = frames.length * frameDuration;
        this.trigger("segmentTimingInfo", generateSegmentTimingInfo(clock2.audioTsToVideoTs(track.baseMediaDecodeTime, track.samplerate), frames[0].dts, frames[0].pts, frames[0].dts + segmentDuration, frames[0].pts + segmentDuration, videoClockCyclesOfSilencePrefixed || 0));
        this.trigger("timingInfo", {
          start: frames[0].pts,
          end: frames[0].pts + segmentDuration
        });
      }
      this.trigger("data", {
        track,
        boxes
      });
      this.trigger("done", "AudioSegmentStream");
    };
    this.reset = function() {
      trackDecodeInfo.clearDtsInfo(track);
      adtsFrames = [];
      this.trigger("reset");
    };
  };
  _AudioSegmentStream.prototype = new stream();
  _VideoSegmentStream = function VideoSegmentStream(track, options) {
    var sequenceNumber, nalUnits = [], gopsToAlignWith = [], config2, pps;
    options = options || {};
    sequenceNumber = options.firstSequenceNumber || 0;
    _VideoSegmentStream.prototype.init.call(this);
    delete track.minPTS;
    this.gopCache_ = [];
    this.push = function(nalUnit) {
      trackDecodeInfo.collectDtsInfo(track, nalUnit);
      if (nalUnit.nalUnitType === "seq_parameter_set_rbsp" && !config2) {
        config2 = nalUnit.config;
        track.sps = [nalUnit.data];
        videoProperties.forEach(function(prop) {
          track[prop] = config2[prop];
        }, this);
      }
      if (nalUnit.nalUnitType === "pic_parameter_set_rbsp" && !pps) {
        pps = nalUnit.data;
        track.pps = [nalUnit.data];
      }
      nalUnits.push(nalUnit);
    };
    this.flush = function() {
      var frames, gopForFusion, gops, moof2, mdat2, boxes, prependedContentDuration = 0, firstGop, lastGop;
      while (nalUnits.length) {
        if (nalUnits[0].nalUnitType === "access_unit_delimiter_rbsp") {
          break;
        }
        nalUnits.shift();
      }
      if (nalUnits.length === 0) {
        this.resetStream_();
        this.trigger("done", "VideoSegmentStream");
        return;
      }
      frames = frameUtils.groupNalsIntoFrames(nalUnits);
      gops = frameUtils.groupFramesIntoGops(frames);
      if (!gops[0][0].keyFrame) {
        gopForFusion = this.getGopForFusion_(nalUnits[0], track);
        if (gopForFusion) {
          prependedContentDuration = gopForFusion.duration;
          gops.unshift(gopForFusion);
          gops.byteLength += gopForFusion.byteLength;
          gops.nalCount += gopForFusion.nalCount;
          gops.pts = gopForFusion.pts;
          gops.dts = gopForFusion.dts;
          gops.duration += gopForFusion.duration;
        } else {
          gops = frameUtils.extendFirstKeyFrame(gops);
        }
      }
      if (gopsToAlignWith.length) {
        var alignedGops;
        if (options.alignGopsAtEnd) {
          alignedGops = this.alignGopsAtEnd_(gops);
        } else {
          alignedGops = this.alignGopsAtStart_(gops);
        }
        if (!alignedGops) {
          this.gopCache_.unshift({
            gop: gops.pop(),
            pps: track.pps,
            sps: track.sps
          });
          this.gopCache_.length = Math.min(6, this.gopCache_.length);
          nalUnits = [];
          this.resetStream_();
          this.trigger("done", "VideoSegmentStream");
          return;
        }
        trackDecodeInfo.clearDtsInfo(track);
        gops = alignedGops;
      }
      trackDecodeInfo.collectDtsInfo(track, gops);
      track.samples = frameUtils.generateSampleTable(gops);
      mdat2 = mp4Generator.mdat(frameUtils.concatenateNalData(gops));
      track.baseMediaDecodeTime = trackDecodeInfo.calculateTrackBaseMediaDecodeTime(track, options.keepOriginalTimestamps);
      this.trigger("processedGopsInfo", gops.map(function(gop) {
        return {
          pts: gop.pts,
          dts: gop.dts,
          byteLength: gop.byteLength
        };
      }));
      firstGop = gops[0];
      lastGop = gops[gops.length - 1];
      this.trigger("segmentTimingInfo", generateSegmentTimingInfo(track.baseMediaDecodeTime, firstGop.dts, firstGop.pts, lastGop.dts + lastGop.duration, lastGop.pts + lastGop.duration, prependedContentDuration));
      this.trigger("timingInfo", {
        start: gops[0].pts,
        end: gops[gops.length - 1].pts + gops[gops.length - 1].duration
      });
      this.gopCache_.unshift({
        gop: gops.pop(),
        pps: track.pps,
        sps: track.sps
      });
      this.gopCache_.length = Math.min(6, this.gopCache_.length);
      nalUnits = [];
      this.trigger("baseMediaDecodeTime", track.baseMediaDecodeTime);
      this.trigger("timelineStartInfo", track.timelineStartInfo);
      moof2 = mp4Generator.moof(sequenceNumber, [track]);
      boxes = new Uint8Array(moof2.byteLength + mdat2.byteLength);
      sequenceNumber++;
      boxes.set(moof2);
      boxes.set(mdat2, moof2.byteLength);
      this.trigger("data", {
        track,
        boxes
      });
      this.resetStream_();
      this.trigger("done", "VideoSegmentStream");
    };
    this.reset = function() {
      this.resetStream_();
      nalUnits = [];
      this.gopCache_.length = 0;
      gopsToAlignWith.length = 0;
      this.trigger("reset");
    };
    this.resetStream_ = function() {
      trackDecodeInfo.clearDtsInfo(track);
      config2 = void 0;
      pps = void 0;
    };
    this.getGopForFusion_ = function(nalUnit) {
      var halfSecond = 45e3, allowableOverlap = 1e4, nearestDistance = Infinity, dtsDistance, nearestGopObj, currentGop, currentGopObj, i;
      for (i = 0; i < this.gopCache_.length; i++) {
        currentGopObj = this.gopCache_[i];
        currentGop = currentGopObj.gop;
        if (!(track.pps && arrayEquals(track.pps[0], currentGopObj.pps[0])) || !(track.sps && arrayEquals(track.sps[0], currentGopObj.sps[0]))) {
          continue;
        }
        if (currentGop.dts < track.timelineStartInfo.dts) {
          continue;
        }
        dtsDistance = nalUnit.dts - currentGop.dts - currentGop.duration;
        if (dtsDistance >= -allowableOverlap && dtsDistance <= halfSecond) {
          if (!nearestGopObj || nearestDistance > dtsDistance) {
            nearestGopObj = currentGopObj;
            nearestDistance = dtsDistance;
          }
        }
      }
      if (nearestGopObj) {
        return nearestGopObj.gop;
      }
      return null;
    };
    this.alignGopsAtStart_ = function(gops) {
      var alignIndex, gopIndex, align, gop, byteLength, nalCount, duration5, alignedGops;
      byteLength = gops.byteLength;
      nalCount = gops.nalCount;
      duration5 = gops.duration;
      alignIndex = gopIndex = 0;
      while (alignIndex < gopsToAlignWith.length && gopIndex < gops.length) {
        align = gopsToAlignWith[alignIndex];
        gop = gops[gopIndex];
        if (align.pts === gop.pts) {
          break;
        }
        if (gop.pts > align.pts) {
          alignIndex++;
          continue;
        }
        gopIndex++;
        byteLength -= gop.byteLength;
        nalCount -= gop.nalCount;
        duration5 -= gop.duration;
      }
      if (gopIndex === 0) {
        return gops;
      }
      if (gopIndex === gops.length) {
        return null;
      }
      alignedGops = gops.slice(gopIndex);
      alignedGops.byteLength = byteLength;
      alignedGops.duration = duration5;
      alignedGops.nalCount = nalCount;
      alignedGops.pts = alignedGops[0].pts;
      alignedGops.dts = alignedGops[0].dts;
      return alignedGops;
    };
    this.alignGopsAtEnd_ = function(gops) {
      var alignIndex, gopIndex, align, gop, alignEndIndex, matchFound;
      alignIndex = gopsToAlignWith.length - 1;
      gopIndex = gops.length - 1;
      alignEndIndex = null;
      matchFound = false;
      while (alignIndex >= 0 && gopIndex >= 0) {
        align = gopsToAlignWith[alignIndex];
        gop = gops[gopIndex];
        if (align.pts === gop.pts) {
          matchFound = true;
          break;
        }
        if (align.pts > gop.pts) {
          alignIndex--;
          continue;
        }
        if (alignIndex === gopsToAlignWith.length - 1) {
          alignEndIndex = gopIndex;
        }
        gopIndex--;
      }
      if (!matchFound && alignEndIndex === null) {
        return null;
      }
      var trimIndex;
      if (matchFound) {
        trimIndex = gopIndex;
      } else {
        trimIndex = alignEndIndex;
      }
      if (trimIndex === 0) {
        return gops;
      }
      var alignedGops = gops.slice(trimIndex);
      var metadata = alignedGops.reduce(function(total, gop2) {
        total.byteLength += gop2.byteLength;
        total.duration += gop2.duration;
        total.nalCount += gop2.nalCount;
        return total;
      }, {
        byteLength: 0,
        duration: 0,
        nalCount: 0
      });
      alignedGops.byteLength = metadata.byteLength;
      alignedGops.duration = metadata.duration;
      alignedGops.nalCount = metadata.nalCount;
      alignedGops.pts = alignedGops[0].pts;
      alignedGops.dts = alignedGops[0].dts;
      return alignedGops;
    };
    this.alignGopsWith = function(newGopsToAlignWith) {
      gopsToAlignWith = newGopsToAlignWith;
    };
  };
  _VideoSegmentStream.prototype = new stream();
  _CoalesceStream = function CoalesceStream(options, metadataStream2) {
    this.numberOfTracks = 0;
    this.metadataStream = metadataStream2;
    options = options || {};
    if (typeof options.remux !== "undefined") {
      this.remuxTracks = !!options.remux;
    } else {
      this.remuxTracks = true;
    }
    if (typeof options.keepOriginalTimestamps === "boolean") {
      this.keepOriginalTimestamps = options.keepOriginalTimestamps;
    } else {
      this.keepOriginalTimestamps = false;
    }
    this.pendingTracks = [];
    this.videoTrack = null;
    this.pendingBoxes = [];
    this.pendingCaptions = [];
    this.pendingMetadata = [];
    this.pendingBytes = 0;
    this.emittedTracks = 0;
    _CoalesceStream.prototype.init.call(this);
    this.push = function(output) {
      if (output.text) {
        return this.pendingCaptions.push(output);
      }
      if (output.frames) {
        return this.pendingMetadata.push(output);
      }
      this.pendingTracks.push(output.track);
      this.pendingBytes += output.boxes.byteLength;
      if (output.track.type === "video") {
        this.videoTrack = output.track;
        this.pendingBoxes.push(output.boxes);
      }
      if (output.track.type === "audio") {
        this.audioTrack = output.track;
        this.pendingBoxes.unshift(output.boxes);
      }
    };
  };
  _CoalesceStream.prototype = new stream();
  _CoalesceStream.prototype.flush = function(flushSource) {
    var offset2 = 0, event = {
      captions: [],
      captionStreams: {},
      metadata: [],
      info: {}
    }, caption, id3, initSegment, timelineStartPts = 0, i;
    if (this.pendingTracks.length < this.numberOfTracks) {
      if (flushSource !== "VideoSegmentStream" && flushSource !== "AudioSegmentStream") {
        return;
      } else if (this.remuxTracks) {
        return;
      } else if (this.pendingTracks.length === 0) {
        this.emittedTracks++;
        if (this.emittedTracks >= this.numberOfTracks) {
          this.trigger("done");
          this.emittedTracks = 0;
        }
        return;
      }
    }
    if (this.videoTrack) {
      timelineStartPts = this.videoTrack.timelineStartInfo.pts;
      videoProperties.forEach(function(prop) {
        event.info[prop] = this.videoTrack[prop];
      }, this);
    } else if (this.audioTrack) {
      timelineStartPts = this.audioTrack.timelineStartInfo.pts;
      audioProperties.forEach(function(prop) {
        event.info[prop] = this.audioTrack[prop];
      }, this);
    }
    if (this.videoTrack || this.audioTrack) {
      if (this.pendingTracks.length === 1) {
        event.type = this.pendingTracks[0].type;
      } else {
        event.type = "combined";
      }
      this.emittedTracks += this.pendingTracks.length;
      initSegment = mp4Generator.initSegment(this.pendingTracks);
      event.initSegment = new Uint8Array(initSegment.byteLength);
      event.initSegment.set(initSegment);
      event.data = new Uint8Array(this.pendingBytes);
      for (i = 0; i < this.pendingBoxes.length; i++) {
        event.data.set(this.pendingBoxes[i], offset2);
        offset2 += this.pendingBoxes[i].byteLength;
      }
      for (i = 0; i < this.pendingCaptions.length; i++) {
        caption = this.pendingCaptions[i];
        caption.startTime = clock2.metadataTsToSeconds(caption.startPts, timelineStartPts, this.keepOriginalTimestamps);
        caption.endTime = clock2.metadataTsToSeconds(caption.endPts, timelineStartPts, this.keepOriginalTimestamps);
        event.captionStreams[caption.stream] = true;
        event.captions.push(caption);
      }
      for (i = 0; i < this.pendingMetadata.length; i++) {
        id3 = this.pendingMetadata[i];
        id3.cueTime = clock2.metadataTsToSeconds(id3.pts, timelineStartPts, this.keepOriginalTimestamps);
        event.metadata.push(id3);
      }
      event.metadata.dispatchType = this.metadataStream.dispatchType;
      this.pendingTracks.length = 0;
      this.videoTrack = null;
      this.pendingBoxes.length = 0;
      this.pendingCaptions.length = 0;
      this.pendingBytes = 0;
      this.pendingMetadata.length = 0;
      this.trigger("data", event);
      for (i = 0; i < event.captions.length; i++) {
        caption = event.captions[i];
        this.trigger("caption", caption);
      }
      for (i = 0; i < event.metadata.length; i++) {
        id3 = event.metadata[i];
        this.trigger("id3Frame", id3);
      }
    }
    if (this.emittedTracks >= this.numberOfTracks) {
      this.trigger("done");
      this.emittedTracks = 0;
    }
  };
  _CoalesceStream.prototype.setRemux = function(val) {
    this.remuxTracks = val;
  };
  _Transmuxer = function Transmuxer(options) {
    var self2 = this, hasFlushed = true, videoTrack, audioTrack;
    _Transmuxer.prototype.init.call(this);
    options = options || {};
    this.baseMediaDecodeTime = options.baseMediaDecodeTime || 0;
    this.transmuxPipeline_ = {};
    this.setupAacPipeline = function() {
      var pipeline = {};
      this.transmuxPipeline_ = pipeline;
      pipeline.type = "aac";
      pipeline.metadataStream = new m2ts_1.MetadataStream();
      pipeline.aacStream = new aac2();
      pipeline.audioTimestampRolloverStream = new m2ts_1.TimestampRolloverStream("audio");
      pipeline.timedMetadataTimestampRolloverStream = new m2ts_1.TimestampRolloverStream("timed-metadata");
      pipeline.adtsStream = new adts();
      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
      pipeline.headOfPipeline = pipeline.aacStream;
      pipeline.aacStream.pipe(pipeline.audioTimestampRolloverStream).pipe(pipeline.adtsStream);
      pipeline.aacStream.pipe(pipeline.timedMetadataTimestampRolloverStream).pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
      pipeline.metadataStream.on("timestamp", function(frame) {
        pipeline.aacStream.setTimestamp(frame.timeStamp);
      });
      pipeline.aacStream.on("data", function(data) {
        if (data.type !== "timed-metadata" && data.type !== "audio" || pipeline.audioSegmentStream) {
          return;
        }
        audioTrack = audioTrack || {
          timelineStartInfo: {
            baseMediaDecodeTime: self2.baseMediaDecodeTime
          },
          codec: "adts",
          type: "audio"
        };
        pipeline.coalesceStream.numberOfTracks++;
        pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
        pipeline.audioSegmentStream.on("log", self2.getLogTrigger_("audioSegmentStream"));
        pipeline.audioSegmentStream.on("timingInfo", self2.trigger.bind(self2, "audioTimingInfo"));
        pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
        self2.trigger("trackinfo", {
          hasAudio: !!audioTrack,
          hasVideo: !!videoTrack
        });
      });
      pipeline.coalesceStream.on("data", this.trigger.bind(this, "data"));
      pipeline.coalesceStream.on("done", this.trigger.bind(this, "done"));
      addPipelineLogRetriggers(this, pipeline);
    };
    this.setupTsPipeline = function() {
      var pipeline = {};
      this.transmuxPipeline_ = pipeline;
      pipeline.type = "ts";
      pipeline.metadataStream = new m2ts_1.MetadataStream();
      pipeline.packetStream = new m2ts_1.TransportPacketStream();
      pipeline.parseStream = new m2ts_1.TransportParseStream();
      pipeline.elementaryStream = new m2ts_1.ElementaryStream();
      pipeline.timestampRolloverStream = new m2ts_1.TimestampRolloverStream();
      pipeline.adtsStream = new adts();
      pipeline.h264Stream = new H264Stream();
      pipeline.captionStream = new m2ts_1.CaptionStream(options);
      pipeline.coalesceStream = new _CoalesceStream(options, pipeline.metadataStream);
      pipeline.headOfPipeline = pipeline.packetStream;
      pipeline.packetStream.pipe(pipeline.parseStream).pipe(pipeline.elementaryStream).pipe(pipeline.timestampRolloverStream);
      pipeline.timestampRolloverStream.pipe(pipeline.h264Stream);
      pipeline.timestampRolloverStream.pipe(pipeline.adtsStream);
      pipeline.timestampRolloverStream.pipe(pipeline.metadataStream).pipe(pipeline.coalesceStream);
      pipeline.h264Stream.pipe(pipeline.captionStream).pipe(pipeline.coalesceStream);
      pipeline.elementaryStream.on("data", function(data) {
        var i;
        if (data.type === "metadata") {
          i = data.tracks.length;
          while (i--) {
            if (!videoTrack && data.tracks[i].type === "video") {
              videoTrack = data.tracks[i];
              videoTrack.timelineStartInfo.baseMediaDecodeTime = self2.baseMediaDecodeTime;
            } else if (!audioTrack && data.tracks[i].type === "audio") {
              audioTrack = data.tracks[i];
              audioTrack.timelineStartInfo.baseMediaDecodeTime = self2.baseMediaDecodeTime;
            }
          }
          if (videoTrack && !pipeline.videoSegmentStream) {
            pipeline.coalesceStream.numberOfTracks++;
            pipeline.videoSegmentStream = new _VideoSegmentStream(videoTrack, options);
            pipeline.videoSegmentStream.on("log", self2.getLogTrigger_("videoSegmentStream"));
            pipeline.videoSegmentStream.on("timelineStartInfo", function(timelineStartInfo) {
              if (audioTrack && !options.keepOriginalTimestamps) {
                audioTrack.timelineStartInfo = timelineStartInfo;
                pipeline.audioSegmentStream.setEarliestDts(timelineStartInfo.dts - self2.baseMediaDecodeTime);
              }
            });
            pipeline.videoSegmentStream.on("processedGopsInfo", self2.trigger.bind(self2, "gopInfo"));
            pipeline.videoSegmentStream.on("segmentTimingInfo", self2.trigger.bind(self2, "videoSegmentTimingInfo"));
            pipeline.videoSegmentStream.on("baseMediaDecodeTime", function(baseMediaDecodeTime) {
              if (audioTrack) {
                pipeline.audioSegmentStream.setVideoBaseMediaDecodeTime(baseMediaDecodeTime);
              }
            });
            pipeline.videoSegmentStream.on("timingInfo", self2.trigger.bind(self2, "videoTimingInfo"));
            pipeline.h264Stream.pipe(pipeline.videoSegmentStream).pipe(pipeline.coalesceStream);
          }
          if (audioTrack && !pipeline.audioSegmentStream) {
            pipeline.coalesceStream.numberOfTracks++;
            pipeline.audioSegmentStream = new _AudioSegmentStream(audioTrack, options);
            pipeline.audioSegmentStream.on("log", self2.getLogTrigger_("audioSegmentStream"));
            pipeline.audioSegmentStream.on("timingInfo", self2.trigger.bind(self2, "audioTimingInfo"));
            pipeline.audioSegmentStream.on("segmentTimingInfo", self2.trigger.bind(self2, "audioSegmentTimingInfo"));
            pipeline.adtsStream.pipe(pipeline.audioSegmentStream).pipe(pipeline.coalesceStream);
          }
          self2.trigger("trackinfo", {
            hasAudio: !!audioTrack,
            hasVideo: !!videoTrack
          });
        }
      });
      pipeline.coalesceStream.on("data", this.trigger.bind(this, "data"));
      pipeline.coalesceStream.on("id3Frame", function(id3Frame) {
        id3Frame.dispatchType = pipeline.metadataStream.dispatchType;
        self2.trigger("id3Frame", id3Frame);
      });
      pipeline.coalesceStream.on("caption", this.trigger.bind(this, "caption"));
      pipeline.coalesceStream.on("done", this.trigger.bind(this, "done"));
      addPipelineLogRetriggers(this, pipeline);
    };
    this.setBaseMediaDecodeTime = function(baseMediaDecodeTime) {
      var pipeline = this.transmuxPipeline_;
      if (!options.keepOriginalTimestamps) {
        this.baseMediaDecodeTime = baseMediaDecodeTime;
      }
      if (audioTrack) {
        audioTrack.timelineStartInfo.dts = void 0;
        audioTrack.timelineStartInfo.pts = void 0;
        trackDecodeInfo.clearDtsInfo(audioTrack);
        if (pipeline.audioTimestampRolloverStream) {
          pipeline.audioTimestampRolloverStream.discontinuity();
        }
      }
      if (videoTrack) {
        if (pipeline.videoSegmentStream) {
          pipeline.videoSegmentStream.gopCache_ = [];
        }
        videoTrack.timelineStartInfo.dts = void 0;
        videoTrack.timelineStartInfo.pts = void 0;
        trackDecodeInfo.clearDtsInfo(videoTrack);
        pipeline.captionStream.reset();
      }
      if (pipeline.timestampRolloverStream) {
        pipeline.timestampRolloverStream.discontinuity();
      }
    };
    this.setAudioAppendStart = function(timestamp) {
      if (audioTrack) {
        this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(timestamp);
      }
    };
    this.setRemux = function(val) {
      var pipeline = this.transmuxPipeline_;
      options.remux = val;
      if (pipeline && pipeline.coalesceStream) {
        pipeline.coalesceStream.setRemux(val);
      }
    };
    this.alignGopsWith = function(gopsToAlignWith) {
      if (videoTrack && this.transmuxPipeline_.videoSegmentStream) {
        this.transmuxPipeline_.videoSegmentStream.alignGopsWith(gopsToAlignWith);
      }
    };
    this.getLogTrigger_ = function(key) {
      var self3 = this;
      return function(event) {
        event.stream = key;
        self3.trigger("log", event);
      };
    };
    this.push = function(data) {
      if (hasFlushed) {
        var isAac = isLikelyAacData(data);
        if (isAac && this.transmuxPipeline_.type !== "aac") {
          this.setupAacPipeline();
        } else if (!isAac && this.transmuxPipeline_.type !== "ts") {
          this.setupTsPipeline();
        }
        hasFlushed = false;
      }
      this.transmuxPipeline_.headOfPipeline.push(data);
    };
    this.flush = function() {
      hasFlushed = true;
      this.transmuxPipeline_.headOfPipeline.flush();
    };
    this.endTimeline = function() {
      this.transmuxPipeline_.headOfPipeline.endTimeline();
    };
    this.reset = function() {
      if (this.transmuxPipeline_.headOfPipeline) {
        this.transmuxPipeline_.headOfPipeline.reset();
      }
    };
    this.resetCaptions = function() {
      if (this.transmuxPipeline_.captionStream) {
        this.transmuxPipeline_.captionStream.reset();
      }
    };
  };
  _Transmuxer.prototype = new stream();
  var transmuxer = {
    Transmuxer: _Transmuxer,
    VideoSegmentStream: _VideoSegmentStream,
    AudioSegmentStream: _AudioSegmentStream,
    AUDIO_PROPERTIES: audioProperties,
    VIDEO_PROPERTIES: videoProperties,
    generateSegmentTimingInfo
  };
  var toUnsigned$3 = function toUnsigned2(value) {
    return value >>> 0;
  };
  var toHexString$1 = function toHexString2(value) {
    return ("00" + value.toString(16)).slice(-2);
  };
  var bin = {
    toUnsigned: toUnsigned$3,
    toHexString: toHexString$1
  };
  var parseType$1 = function parseType2(buffer) {
    var result2 = "";
    result2 += String.fromCharCode(buffer[0]);
    result2 += String.fromCharCode(buffer[1]);
    result2 += String.fromCharCode(buffer[2]);
    result2 += String.fromCharCode(buffer[3]);
    return result2;
  };
  var parseType_1 = parseType$1;
  var toUnsigned$2 = bin.toUnsigned;
  var findBox3 = function findBox4(data, path) {
    var results = [], i, size, type3, end3, subresults;
    if (!path.length) {
      return null;
    }
    for (i = 0; i < data.byteLength; ) {
      size = toUnsigned$2(data[i] << 24 | data[i + 1] << 16 | data[i + 2] << 8 | data[i + 3]);
      type3 = parseType_1(data.subarray(i + 4, i + 8));
      end3 = size > 1 ? i + size : data.byteLength;
      if (type3 === path[0]) {
        if (path.length === 1) {
          results.push(data.subarray(i + 8, end3));
        } else {
          subresults = findBox4(data.subarray(i + 8, end3), path.slice(1));
          if (subresults.length) {
            results = results.concat(subresults);
          }
        }
      }
      i = end3;
    }
    return results;
  };
  var findBox_1 = findBox3;
  var toUnsigned$1 = bin.toUnsigned;
  var getUint64$12 = numbers2.getUint64;
  var tfdt = function tfdt2(data) {
    var result2 = {
      version: data[0],
      flags: new Uint8Array(data.subarray(1, 4))
    };
    if (result2.version === 1) {
      result2.baseMediaDecodeTime = getUint64$12(data.subarray(4));
    } else {
      result2.baseMediaDecodeTime = toUnsigned$1(data[4] << 24 | data[5] << 16 | data[6] << 8 | data[7]);
    }
    return result2;
  };
  var parseTfdt = tfdt;
  var parseSampleFlags = function parseSampleFlags2(flags) {
    return {
      isLeading: (flags[0] & 12) >>> 2,
      dependsOn: flags[0] & 3,
      isDependedOn: (flags[1] & 192) >>> 6,
      hasRedundancy: (flags[1] & 48) >>> 4,
      paddingValue: (flags[1] & 14) >>> 1,
      isNonSyncSample: flags[1] & 1,
      degradationPriority: flags[2] << 8 | flags[3]
    };
  };
  var parseSampleFlags_1 = parseSampleFlags;
  var trun = function trun2(data) {
    var result2 = {
      version: data[0],
      flags: new Uint8Array(data.subarray(1, 4)),
      samples: []
    }, view = new DataView(data.buffer, data.byteOffset, data.byteLength), dataOffsetPresent = result2.flags[2] & 1, firstSampleFlagsPresent = result2.flags[2] & 4, sampleDurationPresent = result2.flags[1] & 1, sampleSizePresent = result2.flags[1] & 2, sampleFlagsPresent = result2.flags[1] & 4, sampleCompositionTimeOffsetPresent = result2.flags[1] & 8, sampleCount = view.getUint32(4), offset2 = 8, sample;
    if (dataOffsetPresent) {
      result2.dataOffset = view.getInt32(offset2);
      offset2 += 4;
    }
    if (firstSampleFlagsPresent && sampleCount) {
      sample = {
        flags: parseSampleFlags_1(data.subarray(offset2, offset2 + 4))
      };
      offset2 += 4;
      if (sampleDurationPresent) {
        sample.duration = view.getUint32(offset2);
        offset2 += 4;
      }
      if (sampleSizePresent) {
        sample.size = view.getUint32(offset2);
        offset2 += 4;
      }
      if (sampleCompositionTimeOffsetPresent) {
        if (result2.version === 1) {
          sample.compositionTimeOffset = view.getInt32(offset2);
        } else {
          sample.compositionTimeOffset = view.getUint32(offset2);
        }
        offset2 += 4;
      }
      result2.samples.push(sample);
      sampleCount--;
    }
    while (sampleCount--) {
      sample = {};
      if (sampleDurationPresent) {
        sample.duration = view.getUint32(offset2);
        offset2 += 4;
      }
      if (sampleSizePresent) {
        sample.size = view.getUint32(offset2);
        offset2 += 4;
      }
      if (sampleFlagsPresent) {
        sample.flags = parseSampleFlags_1(data.subarray(offset2, offset2 + 4));
        offset2 += 4;
      }
      if (sampleCompositionTimeOffsetPresent) {
        if (result2.version === 1) {
          sample.compositionTimeOffset = view.getInt32(offset2);
        } else {
          sample.compositionTimeOffset = view.getUint32(offset2);
        }
        offset2 += 4;
      }
      result2.samples.push(sample);
    }
    return result2;
  };
  var parseTrun = trun;
  var tfhd = function tfhd2(data) {
    var view = new DataView(data.buffer, data.byteOffset, data.byteLength), result2 = {
      version: data[0],
      flags: new Uint8Array(data.subarray(1, 4)),
      trackId: view.getUint32(4)
    }, baseDataOffsetPresent = result2.flags[2] & 1, sampleDescriptionIndexPresent = result2.flags[2] & 2, defaultSampleDurationPresent = result2.flags[2] & 8, defaultSampleSizePresent = result2.flags[2] & 16, defaultSampleFlagsPresent = result2.flags[2] & 32, durationIsEmpty = result2.flags[0] & 65536, defaultBaseIsMoof = result2.flags[0] & 131072, i;
    i = 8;
    if (baseDataOffsetPresent) {
      i += 4;
      result2.baseDataOffset = view.getUint32(12);
      i += 4;
    }
    if (sampleDescriptionIndexPresent) {
      result2.sampleDescriptionIndex = view.getUint32(i);
      i += 4;
    }
    if (defaultSampleDurationPresent) {
      result2.defaultSampleDuration = view.getUint32(i);
      i += 4;
    }
    if (defaultSampleSizePresent) {
      result2.defaultSampleSize = view.getUint32(i);
      i += 4;
    }
    if (defaultSampleFlagsPresent) {
      result2.defaultSampleFlags = view.getUint32(i);
    }
    if (durationIsEmpty) {
      result2.durationIsEmpty = true;
    }
    if (!baseDataOffsetPresent && defaultBaseIsMoof) {
      result2.baseDataOffsetIsMoof = true;
    }
    return result2;
  };
  var parseTfhd = tfhd;
  var commonjsGlobal2 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
  var win2;
  if (typeof window !== "undefined") {
    win2 = window;
  } else if (typeof commonjsGlobal2 !== "undefined") {
    win2 = commonjsGlobal2;
  } else if (typeof self !== "undefined") {
    win2 = self;
  } else {
    win2 = {};
  }
  var window_12 = win2;
  var discardEmulationPreventionBytes3 = captionPacketParser.discardEmulationPreventionBytes;
  var CaptionStream = captionStream.CaptionStream;
  var mapToSample = function mapToSample2(offset2, samples) {
    var approximateOffset = offset2;
    for (var i = 0; i < samples.length; i++) {
      var sample = samples[i];
      if (approximateOffset < sample.size) {
        return sample;
      }
      approximateOffset -= sample.size;
    }
    return null;
  };
  var findSeiNals = function findSeiNals2(avcStream, samples, trackId) {
    var avcView = new DataView(avcStream.buffer, avcStream.byteOffset, avcStream.byteLength), result2 = {
      logs: [],
      seiNals: []
    }, seiNal, i, length, lastMatchedSample;
    for (i = 0; i + 4 < avcStream.length; i += length) {
      length = avcView.getUint32(i);
      i += 4;
      if (length <= 0) {
        continue;
      }
      switch (avcStream[i] & 31) {
        case 6:
          var data = avcStream.subarray(i + 1, i + 1 + length);
          var matchingSample = mapToSample(i, samples);
          seiNal = {
            nalUnitType: "sei_rbsp",
            size: length,
            data,
            escapedRBSP: discardEmulationPreventionBytes3(data),
            trackId
          };
          if (matchingSample) {
            seiNal.pts = matchingSample.pts;
            seiNal.dts = matchingSample.dts;
            lastMatchedSample = matchingSample;
          } else if (lastMatchedSample) {
            seiNal.pts = lastMatchedSample.pts;
            seiNal.dts = lastMatchedSample.dts;
          } else {
            result2.logs.push({
              level: "warn",
              message: "We've encountered a nal unit without data at " + i + " for trackId " + trackId + ". See mux.js#223."
            });
            break;
          }
          result2.seiNals.push(seiNal);
          break;
      }
    }
    return result2;
  };
  var parseSamples = function parseSamples2(truns, baseMediaDecodeTime, tfhd2) {
    var currentDts = baseMediaDecodeTime;
    var defaultSampleDuration = tfhd2.defaultSampleDuration || 0;
    var defaultSampleSize = tfhd2.defaultSampleSize || 0;
    var trackId = tfhd2.trackId;
    var allSamples = [];
    truns.forEach(function(trun2) {
      var trackRun = parseTrun(trun2);
      var samples = trackRun.samples;
      samples.forEach(function(sample) {
        if (sample.duration === void 0) {
          sample.duration = defaultSampleDuration;
        }
        if (sample.size === void 0) {
          sample.size = defaultSampleSize;
        }
        sample.trackId = trackId;
        sample.dts = currentDts;
        if (sample.compositionTimeOffset === void 0) {
          sample.compositionTimeOffset = 0;
        }
        if (typeof currentDts === "bigint") {
          sample.pts = currentDts + window_12.BigInt(sample.compositionTimeOffset);
          currentDts += window_12.BigInt(sample.duration);
        } else {
          sample.pts = currentDts + sample.compositionTimeOffset;
          currentDts += sample.duration;
        }
      });
      allSamples = allSamples.concat(samples);
    });
    return allSamples;
  };
  var parseCaptionNals = function parseCaptionNals2(segment, videoTrackId) {
    var trafs = findBox_1(segment, ["moof", "traf"]);
    var mdats = findBox_1(segment, ["mdat"]);
    var captionNals = {};
    var mdatTrafPairs = [];
    mdats.forEach(function(mdat2, index) {
      var matchingTraf = trafs[index];
      mdatTrafPairs.push({
        mdat: mdat2,
        traf: matchingTraf
      });
    });
    mdatTrafPairs.forEach(function(pair) {
      var mdat2 = pair.mdat;
      var traf2 = pair.traf;
      var tfhd2 = findBox_1(traf2, ["tfhd"]);
      var headerInfo = parseTfhd(tfhd2[0]);
      var trackId = headerInfo.trackId;
      var tfdt2 = findBox_1(traf2, ["tfdt"]);
      var baseMediaDecodeTime = tfdt2.length > 0 ? parseTfdt(tfdt2[0]).baseMediaDecodeTime : 0;
      var truns = findBox_1(traf2, ["trun"]);
      var samples;
      var result2;
      if (videoTrackId === trackId && truns.length > 0) {
        samples = parseSamples(truns, baseMediaDecodeTime, headerInfo);
        result2 = findSeiNals(mdat2, samples, trackId);
        if (!captionNals[trackId]) {
          captionNals[trackId] = {
            seiNals: [],
            logs: []
          };
        }
        captionNals[trackId].seiNals = captionNals[trackId].seiNals.concat(result2.seiNals);
        captionNals[trackId].logs = captionNals[trackId].logs.concat(result2.logs);
      }
    });
    return captionNals;
  };
  var parseEmbeddedCaptions = function parseEmbeddedCaptions2(segment, trackId, timescale3) {
    var captionNals;
    if (trackId === null) {
      return null;
    }
    captionNals = parseCaptionNals(segment, trackId);
    var trackNals = captionNals[trackId] || {};
    return {
      seiNals: trackNals.seiNals,
      logs: trackNals.logs,
      timescale: timescale3
    };
  };
  var CaptionParser = function CaptionParser2() {
    var isInitialized = false;
    var captionStream2;
    var segmentCache;
    var trackId;
    var timescale3;
    var parsedCaptions;
    var parsingPartial;
    this.isInitialized = function() {
      return isInitialized;
    };
    this.init = function(options) {
      captionStream2 = new CaptionStream();
      isInitialized = true;
      parsingPartial = options ? options.isPartial : false;
      captionStream2.on("data", function(event) {
        event.startTime = event.startPts / timescale3;
        event.endTime = event.endPts / timescale3;
        parsedCaptions.captions.push(event);
        parsedCaptions.captionStreams[event.stream] = true;
      });
      captionStream2.on("log", function(log2) {
        parsedCaptions.logs.push(log2);
      });
    };
    this.isNewInit = function(videoTrackIds, timescales) {
      if (videoTrackIds && videoTrackIds.length === 0 || timescales && typeof timescales === "object" && Object.keys(timescales).length === 0) {
        return false;
      }
      return trackId !== videoTrackIds[0] || timescale3 !== timescales[trackId];
    };
    this.parse = function(segment, videoTrackIds, timescales) {
      var parsedData;
      if (!this.isInitialized()) {
        return null;
      } else if (!videoTrackIds || !timescales) {
        return null;
      } else if (this.isNewInit(videoTrackIds, timescales)) {
        trackId = videoTrackIds[0];
        timescale3 = timescales[trackId];
      } else if (trackId === null || !timescale3) {
        segmentCache.push(segment);
        return null;
      }
      while (segmentCache.length > 0) {
        var cachedSegment = segmentCache.shift();
        this.parse(cachedSegment, videoTrackIds, timescales);
      }
      parsedData = parseEmbeddedCaptions(segment, trackId, timescale3);
      if (parsedData && parsedData.logs) {
        parsedCaptions.logs = parsedCaptions.logs.concat(parsedData.logs);
      }
      if (parsedData === null || !parsedData.seiNals) {
        if (parsedCaptions.logs.length) {
          return {
            logs: parsedCaptions.logs,
            captions: [],
            captionStreams: []
          };
        }
        return null;
      }
      this.pushNals(parsedData.seiNals);
      this.flushStream();
      return parsedCaptions;
    };
    this.pushNals = function(nals) {
      if (!this.isInitialized() || !nals || nals.length === 0) {
        return null;
      }
      nals.forEach(function(nal) {
        captionStream2.push(nal);
      });
    };
    this.flushStream = function() {
      if (!this.isInitialized()) {
        return null;
      }
      if (!parsingPartial) {
        captionStream2.flush();
      } else {
        captionStream2.partialFlush();
      }
    };
    this.clearParsedCaptions = function() {
      parsedCaptions.captions = [];
      parsedCaptions.captionStreams = {};
      parsedCaptions.logs = [];
    };
    this.resetCaptionStream = function() {
      if (!this.isInitialized()) {
        return null;
      }
      captionStream2.reset();
    };
    this.clearAllCaptions = function() {
      this.clearParsedCaptions();
      this.resetCaptionStream();
    };
    this.reset = function() {
      segmentCache = [];
      trackId = null;
      timescale3 = null;
      if (!parsedCaptions) {
        parsedCaptions = {
          captions: [],
          captionStreams: {},
          logs: []
        };
      } else {
        this.clearParsedCaptions();
      }
      this.resetCaptionStream();
    };
    this.reset();
  };
  var captionParser = CaptionParser;
  var toUnsigned = bin.toUnsigned;
  var toHexString = bin.toHexString;
  var getUint642 = numbers2.getUint64;
  var timescale2, startTime, compositionStartTime, getVideoTrackIds, getTracks, getTimescaleFromMediaHeader;
  timescale2 = function timescale3(init) {
    var result2 = {}, traks = findBox_1(init, ["moov", "trak"]);
    return traks.reduce(function(result3, trak2) {
      var tkhd2, version2, index, id2, mdhd2;
      tkhd2 = findBox_1(trak2, ["tkhd"])[0];
      if (!tkhd2) {
        return null;
      }
      version2 = tkhd2[0];
      index = version2 === 0 ? 12 : 20;
      id2 = toUnsigned(tkhd2[index] << 24 | tkhd2[index + 1] << 16 | tkhd2[index + 2] << 8 | tkhd2[index + 3]);
      mdhd2 = findBox_1(trak2, ["mdia", "mdhd"])[0];
      if (!mdhd2) {
        return null;
      }
      version2 = mdhd2[0];
      index = version2 === 0 ? 12 : 20;
      result3[id2] = toUnsigned(mdhd2[index] << 24 | mdhd2[index + 1] << 16 | mdhd2[index + 2] << 8 | mdhd2[index + 3]);
      return result3;
    }, result2);
  };
  startTime = function startTime2(timescale3, fragment) {
    var trafs;
    trafs = findBox_1(fragment, ["moof", "traf"]);
    var lowestTime = trafs.reduce(function(acc, traf2) {
      var tfhd2 = findBox_1(traf2, ["tfhd"])[0];
      var id2 = toUnsigned(tfhd2[4] << 24 | tfhd2[5] << 16 | tfhd2[6] << 8 | tfhd2[7]);
      var scale = timescale3[id2] || 9e4;
      var tfdt2 = findBox_1(traf2, ["tfdt"])[0];
      var dv = new DataView(tfdt2.buffer, tfdt2.byteOffset, tfdt2.byteLength);
      var baseTime;
      if (tfdt2[0] === 1) {
        baseTime = getUint642(tfdt2.subarray(4, 12));
      } else {
        baseTime = dv.getUint32(4);
      }
      var seconds;
      if (typeof baseTime === "bigint") {
        seconds = baseTime / window_12.BigInt(scale);
      } else if (typeof baseTime === "number" && !isNaN(baseTime)) {
        seconds = baseTime / scale;
      }
      if (seconds < Number.MAX_SAFE_INTEGER) {
        seconds = Number(seconds);
      }
      if (seconds < acc) {
        acc = seconds;
      }
      return acc;
    }, Infinity);
    return typeof lowestTime === "bigint" || isFinite(lowestTime) ? lowestTime : 0;
  };
  compositionStartTime = function compositionStartTime2(timescales, fragment) {
    var trafBoxes = findBox_1(fragment, ["moof", "traf"]);
    var baseMediaDecodeTime = 0;
    var compositionTimeOffset = 0;
    var trackId;
    if (trafBoxes && trafBoxes.length) {
      var tfhd2 = findBox_1(trafBoxes[0], ["tfhd"])[0];
      var trun2 = findBox_1(trafBoxes[0], ["trun"])[0];
      var tfdt2 = findBox_1(trafBoxes[0], ["tfdt"])[0];
      if (tfhd2) {
        var parsedTfhd = parseTfhd(tfhd2);
        trackId = parsedTfhd.trackId;
      }
      if (tfdt2) {
        var parsedTfdt = parseTfdt(tfdt2);
        baseMediaDecodeTime = parsedTfdt.baseMediaDecodeTime;
      }
      if (trun2) {
        var parsedTrun = parseTrun(trun2);
        if (parsedTrun.samples && parsedTrun.samples.length) {
          compositionTimeOffset = parsedTrun.samples[0].compositionTimeOffset || 0;
        }
      }
    }
    var timescale3 = timescales[trackId] || 9e4;
    if (typeof baseMediaDecodeTime === "bigint") {
      compositionTimeOffset = window_12.BigInt(compositionTimeOffset);
      timescale3 = window_12.BigInt(timescale3);
    }
    var result2 = (baseMediaDecodeTime + compositionTimeOffset) / timescale3;
    if (typeof result2 === "bigint" && result2 < Number.MAX_SAFE_INTEGER) {
      result2 = Number(result2);
    }
    return result2;
  };
  getVideoTrackIds = function getVideoTrackIds2(init) {
    var traks = findBox_1(init, ["moov", "trak"]);
    var videoTrackIds = [];
    traks.forEach(function(trak2) {
      var hdlrs = findBox_1(trak2, ["mdia", "hdlr"]);
      var tkhds = findBox_1(trak2, ["tkhd"]);
      hdlrs.forEach(function(hdlr2, index) {
        var handlerType = parseType_1(hdlr2.subarray(8, 12));
        var tkhd2 = tkhds[index];
        var view;
        var version2;
        var trackId;
        if (handlerType === "vide") {
          view = new DataView(tkhd2.buffer, tkhd2.byteOffset, tkhd2.byteLength);
          version2 = view.getUint8(0);
          trackId = version2 === 0 ? view.getUint32(12) : view.getUint32(20);
          videoTrackIds.push(trackId);
        }
      });
    });
    return videoTrackIds;
  };
  getTimescaleFromMediaHeader = function getTimescaleFromMediaHeader2(mdhd2) {
    var version2 = mdhd2[0];
    var index = version2 === 0 ? 12 : 20;
    return toUnsigned(mdhd2[index] << 24 | mdhd2[index + 1] << 16 | mdhd2[index + 2] << 8 | mdhd2[index + 3]);
  };
  getTracks = function getTracks2(init) {
    var traks = findBox_1(init, ["moov", "trak"]);
    var tracks = [];
    traks.forEach(function(trak2) {
      var track = {};
      var tkhd2 = findBox_1(trak2, ["tkhd"])[0];
      var view, tkhdVersion;
      if (tkhd2) {
        view = new DataView(tkhd2.buffer, tkhd2.byteOffset, tkhd2.byteLength);
        tkhdVersion = view.getUint8(0);
        track.id = tkhdVersion === 0 ? view.getUint32(12) : view.getUint32(20);
      }
      var hdlr2 = findBox_1(trak2, ["mdia", "hdlr"])[0];
      if (hdlr2) {
        var type3 = parseType_1(hdlr2.subarray(8, 12));
        if (type3 === "vide") {
          track.type = "video";
        } else if (type3 === "soun") {
          track.type = "audio";
        } else {
          track.type = type3;
        }
      }
      var stsd2 = findBox_1(trak2, ["mdia", "minf", "stbl", "stsd"])[0];
      if (stsd2) {
        var sampleDescriptions = stsd2.subarray(8);
        track.codec = parseType_1(sampleDescriptions.subarray(4, 8));
        var codecBox = findBox_1(sampleDescriptions, [track.codec])[0];
        var codecConfig, codecConfigType;
        if (codecBox) {
          if (/^[asm]vc[1-9]$/i.test(track.codec)) {
            codecConfig = codecBox.subarray(78);
            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
            if (codecConfigType === "avcC" && codecConfig.length > 11) {
              track.codec += ".";
              track.codec += toHexString(codecConfig[9]);
              track.codec += toHexString(codecConfig[10]);
              track.codec += toHexString(codecConfig[11]);
            } else {
              track.codec = "avc1.4d400d";
            }
          } else if (/^mp4[a,v]$/i.test(track.codec)) {
            codecConfig = codecBox.subarray(28);
            codecConfigType = parseType_1(codecConfig.subarray(4, 8));
            if (codecConfigType === "esds" && codecConfig.length > 20 && codecConfig[19] !== 0) {
              track.codec += "." + toHexString(codecConfig[19]);
              track.codec += "." + toHexString(codecConfig[20] >>> 2 & 63).replace(/^0/, "");
            } else {
              track.codec = "mp4a.40.2";
            }
          } else {
            track.codec = track.codec.toLowerCase();
          }
        }
      }
      var mdhd2 = findBox_1(trak2, ["mdia", "mdhd"])[0];
      if (mdhd2) {
        track.timescale = getTimescaleFromMediaHeader(mdhd2);
      }
      tracks.push(track);
    });
    return tracks;
  };
  var probe$2 = {
    findBox: findBox_1,
    parseType: parseType_1,
    timescale: timescale2,
    startTime,
    compositionStartTime,
    videoTrackIds: getVideoTrackIds,
    tracks: getTracks,
    getTimescaleFromMediaHeader
  };
  var parsePid = function parsePid2(packet) {
    var pid = packet[1] & 31;
    pid <<= 8;
    pid |= packet[2];
    return pid;
  };
  var parsePayloadUnitStartIndicator = function parsePayloadUnitStartIndicator2(packet) {
    return !!(packet[1] & 64);
  };
  var parseAdaptionField = function parseAdaptionField2(packet) {
    var offset2 = 0;
    if ((packet[3] & 48) >>> 4 > 1) {
      offset2 += packet[4] + 1;
    }
    return offset2;
  };
  var parseType = function parseType2(packet, pmtPid) {
    var pid = parsePid(packet);
    if (pid === 0) {
      return "pat";
    } else if (pid === pmtPid) {
      return "pmt";
    } else if (pmtPid) {
      return "pes";
    }
    return null;
  };
  var parsePat = function parsePat2(packet) {
    var pusi = parsePayloadUnitStartIndicator(packet);
    var offset2 = 4 + parseAdaptionField(packet);
    if (pusi) {
      offset2 += packet[offset2] + 1;
    }
    return (packet[offset2 + 10] & 31) << 8 | packet[offset2 + 11];
  };
  var parsePmt = function parsePmt2(packet) {
    var programMapTable = {};
    var pusi = parsePayloadUnitStartIndicator(packet);
    var payloadOffset = 4 + parseAdaptionField(packet);
    if (pusi) {
      payloadOffset += packet[payloadOffset] + 1;
    }
    if (!(packet[payloadOffset + 5] & 1)) {
      return;
    }
    var sectionLength, tableEnd, programInfoLength;
    sectionLength = (packet[payloadOffset + 1] & 15) << 8 | packet[payloadOffset + 2];
    tableEnd = 3 + sectionLength - 4;
    programInfoLength = (packet[payloadOffset + 10] & 15) << 8 | packet[payloadOffset + 11];
    var offset2 = 12 + programInfoLength;
    while (offset2 < tableEnd) {
      var i = payloadOffset + offset2;
      programMapTable[(packet[i + 1] & 31) << 8 | packet[i + 2]] = packet[i];
      offset2 += ((packet[i + 3] & 15) << 8 | packet[i + 4]) + 5;
    }
    return programMapTable;
  };
  var parsePesType = function parsePesType2(packet, programMapTable) {
    var pid = parsePid(packet);
    var type3 = programMapTable[pid];
    switch (type3) {
      case streamTypes.H264_STREAM_TYPE:
        return "video";
      case streamTypes.ADTS_STREAM_TYPE:
        return "audio";
      case streamTypes.METADATA_STREAM_TYPE:
        return "timed-metadata";
      default:
        return null;
    }
  };
  var parsePesTime = function parsePesTime2(packet) {
    var pusi = parsePayloadUnitStartIndicator(packet);
    if (!pusi) {
      return null;
    }
    var offset2 = 4 + parseAdaptionField(packet);
    if (offset2 >= packet.byteLength) {
      return null;
    }
    var pes = null;
    var ptsDtsFlags;
    ptsDtsFlags = packet[offset2 + 7];
    if (ptsDtsFlags & 192) {
      pes = {};
      pes.pts = (packet[offset2 + 9] & 14) << 27 | (packet[offset2 + 10] & 255) << 20 | (packet[offset2 + 11] & 254) << 12 | (packet[offset2 + 12] & 255) << 5 | (packet[offset2 + 13] & 254) >>> 3;
      pes.pts *= 4;
      pes.pts += (packet[offset2 + 13] & 6) >>> 1;
      pes.dts = pes.pts;
      if (ptsDtsFlags & 64) {
        pes.dts = (packet[offset2 + 14] & 14) << 27 | (packet[offset2 + 15] & 255) << 20 | (packet[offset2 + 16] & 254) << 12 | (packet[offset2 + 17] & 255) << 5 | (packet[offset2 + 18] & 254) >>> 3;
        pes.dts *= 4;
        pes.dts += (packet[offset2 + 18] & 6) >>> 1;
      }
    }
    return pes;
  };
  var parseNalUnitType = function parseNalUnitType2(type3) {
    switch (type3) {
      case 5:
        return "slice_layer_without_partitioning_rbsp_idr";
      case 6:
        return "sei_rbsp";
      case 7:
        return "seq_parameter_set_rbsp";
      case 8:
        return "pic_parameter_set_rbsp";
      case 9:
        return "access_unit_delimiter_rbsp";
      default:
        return null;
    }
  };
  var videoPacketContainsKeyFrame = function videoPacketContainsKeyFrame2(packet) {
    var offset2 = 4 + parseAdaptionField(packet);
    var frameBuffer = packet.subarray(offset2);
    var frameI = 0;
    var frameSyncPoint = 0;
    var foundKeyFrame = false;
    var nalType;
    for (; frameSyncPoint < frameBuffer.byteLength - 3; frameSyncPoint++) {
      if (frameBuffer[frameSyncPoint + 2] === 1) {
        frameI = frameSyncPoint + 5;
        break;
      }
    }
    while (frameI < frameBuffer.byteLength) {
      switch (frameBuffer[frameI]) {
        case 0:
          if (frameBuffer[frameI - 1] !== 0) {
            frameI += 2;
            break;
          } else if (frameBuffer[frameI - 2] !== 0) {
            frameI++;
            break;
          }
          if (frameSyncPoint + 3 !== frameI - 2) {
            nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 31);
            if (nalType === "slice_layer_without_partitioning_rbsp_idr") {
              foundKeyFrame = true;
            }
          }
          do {
            frameI++;
          } while (frameBuffer[frameI] !== 1 && frameI < frameBuffer.length);
          frameSyncPoint = frameI - 2;
          frameI += 3;
          break;
        case 1:
          if (frameBuffer[frameI - 1] !== 0 || frameBuffer[frameI - 2] !== 0) {
            frameI += 3;
            break;
          }
          nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 31);
          if (nalType === "slice_layer_without_partitioning_rbsp_idr") {
            foundKeyFrame = true;
          }
          frameSyncPoint = frameI - 2;
          frameI += 3;
          break;
        default:
          frameI += 3;
          break;
      }
    }
    frameBuffer = frameBuffer.subarray(frameSyncPoint);
    frameI -= frameSyncPoint;
    frameSyncPoint = 0;
    if (frameBuffer && frameBuffer.byteLength > 3) {
      nalType = parseNalUnitType(frameBuffer[frameSyncPoint + 3] & 31);
      if (nalType === "slice_layer_without_partitioning_rbsp_idr") {
        foundKeyFrame = true;
      }
    }
    return foundKeyFrame;
  };
  var probe$1 = {
    parseType,
    parsePat,
    parsePmt,
    parsePayloadUnitStartIndicator,
    parsePesType,
    parsePesTime,
    videoPacketContainsKeyFrame
  };
  var handleRollover = timestampRolloverStream.handleRollover;
  var probe = {};
  probe.ts = probe$1;
  probe.aac = utils2;
  var ONE_SECOND_IN_TS2 = clock2.ONE_SECOND_IN_TS;
  var MP2T_PACKET_LENGTH = 188, SYNC_BYTE = 71;
  var parsePsi_ = function parsePsi_2(bytes, pmt) {
    var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type3;
    while (endIndex < bytes.byteLength) {
      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
        packet = bytes.subarray(startIndex, endIndex);
        type3 = probe.ts.parseType(packet, pmt.pid);
        switch (type3) {
          case "pat":
            pmt.pid = probe.ts.parsePat(packet);
            break;
          case "pmt":
            var table2 = probe.ts.parsePmt(packet);
            pmt.table = pmt.table || {};
            Object.keys(table2).forEach(function(key) {
              pmt.table[key] = table2[key];
            });
            break;
        }
        startIndex += MP2T_PACKET_LENGTH;
        endIndex += MP2T_PACKET_LENGTH;
        continue;
      }
      startIndex++;
      endIndex++;
    }
  };
  var parseAudioPes_ = function parseAudioPes_2(bytes, pmt, result2) {
    var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type3, pesType, pusi, parsed;
    var endLoop = false;
    while (endIndex <= bytes.byteLength) {
      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
        packet = bytes.subarray(startIndex, endIndex);
        type3 = probe.ts.parseType(packet, pmt.pid);
        switch (type3) {
          case "pes":
            pesType = probe.ts.parsePesType(packet, pmt.table);
            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
            if (pesType === "audio" && pusi) {
              parsed = probe.ts.parsePesTime(packet);
              if (parsed) {
                parsed.type = "audio";
                result2.audio.push(parsed);
                endLoop = true;
              }
            }
            break;
        }
        if (endLoop) {
          break;
        }
        startIndex += MP2T_PACKET_LENGTH;
        endIndex += MP2T_PACKET_LENGTH;
        continue;
      }
      startIndex++;
      endIndex++;
    }
    endIndex = bytes.byteLength;
    startIndex = endIndex - MP2T_PACKET_LENGTH;
    endLoop = false;
    while (startIndex >= 0) {
      if (bytes[startIndex] === SYNC_BYTE && (bytes[endIndex] === SYNC_BYTE || endIndex === bytes.byteLength)) {
        packet = bytes.subarray(startIndex, endIndex);
        type3 = probe.ts.parseType(packet, pmt.pid);
        switch (type3) {
          case "pes":
            pesType = probe.ts.parsePesType(packet, pmt.table);
            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
            if (pesType === "audio" && pusi) {
              parsed = probe.ts.parsePesTime(packet);
              if (parsed) {
                parsed.type = "audio";
                result2.audio.push(parsed);
                endLoop = true;
              }
            }
            break;
        }
        if (endLoop) {
          break;
        }
        startIndex -= MP2T_PACKET_LENGTH;
        endIndex -= MP2T_PACKET_LENGTH;
        continue;
      }
      startIndex--;
      endIndex--;
    }
  };
  var parseVideoPes_ = function parseVideoPes_2(bytes, pmt, result2) {
    var startIndex = 0, endIndex = MP2T_PACKET_LENGTH, packet, type3, pesType, pusi, parsed, frame, i, pes;
    var endLoop = false;
    var currentFrame = {
      data: [],
      size: 0
    };
    while (endIndex < bytes.byteLength) {
      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
        packet = bytes.subarray(startIndex, endIndex);
        type3 = probe.ts.parseType(packet, pmt.pid);
        switch (type3) {
          case "pes":
            pesType = probe.ts.parsePesType(packet, pmt.table);
            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
            if (pesType === "video") {
              if (pusi && !endLoop) {
                parsed = probe.ts.parsePesTime(packet);
                if (parsed) {
                  parsed.type = "video";
                  result2.video.push(parsed);
                  endLoop = true;
                }
              }
              if (!result2.firstKeyFrame) {
                if (pusi) {
                  if (currentFrame.size !== 0) {
                    frame = new Uint8Array(currentFrame.size);
                    i = 0;
                    while (currentFrame.data.length) {
                      pes = currentFrame.data.shift();
                      frame.set(pes, i);
                      i += pes.byteLength;
                    }
                    if (probe.ts.videoPacketContainsKeyFrame(frame)) {
                      var firstKeyFrame = probe.ts.parsePesTime(frame);
                      if (firstKeyFrame) {
                        result2.firstKeyFrame = firstKeyFrame;
                        result2.firstKeyFrame.type = "video";
                      } else {
                        console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                      }
                    }
                    currentFrame.size = 0;
                  }
                }
                currentFrame.data.push(packet);
                currentFrame.size += packet.byteLength;
              }
            }
            break;
        }
        if (endLoop && result2.firstKeyFrame) {
          break;
        }
        startIndex += MP2T_PACKET_LENGTH;
        endIndex += MP2T_PACKET_LENGTH;
        continue;
      }
      startIndex++;
      endIndex++;
    }
    endIndex = bytes.byteLength;
    startIndex = endIndex - MP2T_PACKET_LENGTH;
    endLoop = false;
    while (startIndex >= 0) {
      if (bytes[startIndex] === SYNC_BYTE && bytes[endIndex] === SYNC_BYTE) {
        packet = bytes.subarray(startIndex, endIndex);
        type3 = probe.ts.parseType(packet, pmt.pid);
        switch (type3) {
          case "pes":
            pesType = probe.ts.parsePesType(packet, pmt.table);
            pusi = probe.ts.parsePayloadUnitStartIndicator(packet);
            if (pesType === "video" && pusi) {
              parsed = probe.ts.parsePesTime(packet);
              if (parsed) {
                parsed.type = "video";
                result2.video.push(parsed);
                endLoop = true;
              }
            }
            break;
        }
        if (endLoop) {
          break;
        }
        startIndex -= MP2T_PACKET_LENGTH;
        endIndex -= MP2T_PACKET_LENGTH;
        continue;
      }
      startIndex--;
      endIndex--;
    }
  };
  var adjustTimestamp_ = function adjustTimestamp_2(segmentInfo, baseTimestamp) {
    if (segmentInfo.audio && segmentInfo.audio.length) {
      var audioBaseTimestamp = baseTimestamp;
      if (typeof audioBaseTimestamp === "undefined" || isNaN(audioBaseTimestamp)) {
        audioBaseTimestamp = segmentInfo.audio[0].dts;
      }
      segmentInfo.audio.forEach(function(info2) {
        info2.dts = handleRollover(info2.dts, audioBaseTimestamp);
        info2.pts = handleRollover(info2.pts, audioBaseTimestamp);
        info2.dtsTime = info2.dts / ONE_SECOND_IN_TS2;
        info2.ptsTime = info2.pts / ONE_SECOND_IN_TS2;
      });
    }
    if (segmentInfo.video && segmentInfo.video.length) {
      var videoBaseTimestamp = baseTimestamp;
      if (typeof videoBaseTimestamp === "undefined" || isNaN(videoBaseTimestamp)) {
        videoBaseTimestamp = segmentInfo.video[0].dts;
      }
      segmentInfo.video.forEach(function(info2) {
        info2.dts = handleRollover(info2.dts, videoBaseTimestamp);
        info2.pts = handleRollover(info2.pts, videoBaseTimestamp);
        info2.dtsTime = info2.dts / ONE_SECOND_IN_TS2;
        info2.ptsTime = info2.pts / ONE_SECOND_IN_TS2;
      });
      if (segmentInfo.firstKeyFrame) {
        var frame = segmentInfo.firstKeyFrame;
        frame.dts = handleRollover(frame.dts, videoBaseTimestamp);
        frame.pts = handleRollover(frame.pts, videoBaseTimestamp);
        frame.dtsTime = frame.dts / ONE_SECOND_IN_TS2;
        frame.ptsTime = frame.pts / ONE_SECOND_IN_TS2;
      }
    }
  };
  var inspectAac_ = function inspectAac_2(bytes) {
    var endLoop = false, audioCount = 0, sampleRate = null, timestamp = null, frameSize = 0, byteIndex = 0, packet;
    while (bytes.length - byteIndex >= 3) {
      var type3 = probe.aac.parseType(bytes, byteIndex);
      switch (type3) {
        case "timed-metadata":
          if (bytes.length - byteIndex < 10) {
            endLoop = true;
            break;
          }
          frameSize = probe.aac.parseId3TagSize(bytes, byteIndex);
          if (frameSize > bytes.length) {
            endLoop = true;
            break;
          }
          if (timestamp === null) {
            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
            timestamp = probe.aac.parseAacTimestamp(packet);
          }
          byteIndex += frameSize;
          break;
        case "audio":
          if (bytes.length - byteIndex < 7) {
            endLoop = true;
            break;
          }
          frameSize = probe.aac.parseAdtsSize(bytes, byteIndex);
          if (frameSize > bytes.length) {
            endLoop = true;
            break;
          }
          if (sampleRate === null) {
            packet = bytes.subarray(byteIndex, byteIndex + frameSize);
            sampleRate = probe.aac.parseSampleRate(packet);
          }
          audioCount++;
          byteIndex += frameSize;
          break;
        default:
          byteIndex++;
          break;
      }
      if (endLoop) {
        return null;
      }
    }
    if (sampleRate === null || timestamp === null) {
      return null;
    }
    var audioTimescale = ONE_SECOND_IN_TS2 / sampleRate;
    var result2 = {
      audio: [{
        type: "audio",
        dts: timestamp,
        pts: timestamp
      }, {
        type: "audio",
        dts: timestamp + audioCount * 1024 * audioTimescale,
        pts: timestamp + audioCount * 1024 * audioTimescale
      }]
    };
    return result2;
  };
  var inspectTs_ = function inspectTs_2(bytes) {
    var pmt = {
      pid: null,
      table: null
    };
    var result2 = {};
    parsePsi_(bytes, pmt);
    for (var pid in pmt.table) {
      if (pmt.table.hasOwnProperty(pid)) {
        var type3 = pmt.table[pid];
        switch (type3) {
          case streamTypes.H264_STREAM_TYPE:
            result2.video = [];
            parseVideoPes_(bytes, pmt, result2);
            if (result2.video.length === 0) {
              delete result2.video;
            }
            break;
          case streamTypes.ADTS_STREAM_TYPE:
            result2.audio = [];
            parseAudioPes_(bytes, pmt, result2);
            if (result2.audio.length === 0) {
              delete result2.audio;
            }
            break;
        }
      }
    }
    return result2;
  };
  var inspect = function inspect2(bytes, baseTimestamp) {
    var isAacData = probe.aac.isLikelyAacData(bytes);
    var result2;
    if (isAacData) {
      result2 = inspectAac_(bytes);
    } else {
      result2 = inspectTs_(bytes);
    }
    if (!result2 || !result2.audio && !result2.video) {
      return null;
    }
    adjustTimestamp_(result2, baseTimestamp);
    return result2;
  };
  var tsInspector = {
    inspect,
    parseAudioPes_
  };
  var wireTransmuxerEvents = function wireTransmuxerEvents2(self2, transmuxer2) {
    transmuxer2.on("data", function(segment) {
      var initArray = segment.initSegment;
      segment.initSegment = {
        data: initArray.buffer,
        byteOffset: initArray.byteOffset,
        byteLength: initArray.byteLength
      };
      var typedArray = segment.data;
      segment.data = typedArray.buffer;
      self2.postMessage({
        action: "data",
        segment,
        byteOffset: typedArray.byteOffset,
        byteLength: typedArray.byteLength
      }, [segment.data]);
    });
    transmuxer2.on("done", function(data) {
      self2.postMessage({
        action: "done"
      });
    });
    transmuxer2.on("gopInfo", function(gopInfo) {
      self2.postMessage({
        action: "gopInfo",
        gopInfo
      });
    });
    transmuxer2.on("videoSegmentTimingInfo", function(timingInfo) {
      var videoSegmentTimingInfo = {
        start: {
          decode: clock2.videoTsToSeconds(timingInfo.start.dts),
          presentation: clock2.videoTsToSeconds(timingInfo.start.pts)
        },
        end: {
          decode: clock2.videoTsToSeconds(timingInfo.end.dts),
          presentation: clock2.videoTsToSeconds(timingInfo.end.pts)
        },
        baseMediaDecodeTime: clock2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
      };
      if (timingInfo.prependedContentDuration) {
        videoSegmentTimingInfo.prependedContentDuration = clock2.videoTsToSeconds(timingInfo.prependedContentDuration);
      }
      self2.postMessage({
        action: "videoSegmentTimingInfo",
        videoSegmentTimingInfo
      });
    });
    transmuxer2.on("audioSegmentTimingInfo", function(timingInfo) {
      var audioSegmentTimingInfo = {
        start: {
          decode: clock2.videoTsToSeconds(timingInfo.start.dts),
          presentation: clock2.videoTsToSeconds(timingInfo.start.pts)
        },
        end: {
          decode: clock2.videoTsToSeconds(timingInfo.end.dts),
          presentation: clock2.videoTsToSeconds(timingInfo.end.pts)
        },
        baseMediaDecodeTime: clock2.videoTsToSeconds(timingInfo.baseMediaDecodeTime)
      };
      if (timingInfo.prependedContentDuration) {
        audioSegmentTimingInfo.prependedContentDuration = clock2.videoTsToSeconds(timingInfo.prependedContentDuration);
      }
      self2.postMessage({
        action: "audioSegmentTimingInfo",
        audioSegmentTimingInfo
      });
    });
    transmuxer2.on("id3Frame", function(id3Frame) {
      self2.postMessage({
        action: "id3Frame",
        id3Frame
      });
    });
    transmuxer2.on("caption", function(caption) {
      self2.postMessage({
        action: "caption",
        caption
      });
    });
    transmuxer2.on("trackinfo", function(trackInfo) {
      self2.postMessage({
        action: "trackinfo",
        trackInfo
      });
    });
    transmuxer2.on("audioTimingInfo", function(audioTimingInfo) {
      self2.postMessage({
        action: "audioTimingInfo",
        audioTimingInfo: {
          start: clock2.videoTsToSeconds(audioTimingInfo.start),
          end: clock2.videoTsToSeconds(audioTimingInfo.end)
        }
      });
    });
    transmuxer2.on("videoTimingInfo", function(videoTimingInfo) {
      self2.postMessage({
        action: "videoTimingInfo",
        videoTimingInfo: {
          start: clock2.videoTsToSeconds(videoTimingInfo.start),
          end: clock2.videoTsToSeconds(videoTimingInfo.end)
        }
      });
    });
    transmuxer2.on("log", function(log2) {
      self2.postMessage({
        action: "log",
        log: log2
      });
    });
  };
  var MessageHandlers = /* @__PURE__ */ function() {
    function MessageHandlers2(self2, options) {
      this.options = options || {};
      this.self = self2;
      this.init();
    }
    var _proto = MessageHandlers2.prototype;
    _proto.init = function init() {
      if (this.transmuxer) {
        this.transmuxer.dispose();
      }
      this.transmuxer = new transmuxer.Transmuxer(this.options);
      wireTransmuxerEvents(this.self, this.transmuxer);
    };
    _proto.pushMp4Captions = function pushMp4Captions(data) {
      if (!this.captionParser) {
        this.captionParser = new captionParser();
        this.captionParser.init();
      }
      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
      var parsed = this.captionParser.parse(segment, data.trackIds, data.timescales);
      this.self.postMessage({
        action: "mp4Captions",
        captions: parsed && parsed.captions || [],
        logs: parsed && parsed.logs || [],
        data: segment.buffer
      }, [segment.buffer]);
    };
    _proto.probeMp4StartTime = function probeMp4StartTime(_ref2) {
      var timescales = _ref2.timescales, data = _ref2.data;
      var startTime2 = probe$2.startTime(timescales, data);
      this.self.postMessage({
        action: "probeMp4StartTime",
        startTime: startTime2,
        data
      }, [data.buffer]);
    };
    _proto.probeMp4Tracks = function probeMp4Tracks(_ref2) {
      var data = _ref2.data;
      var tracks = probe$2.tracks(data);
      this.self.postMessage({
        action: "probeMp4Tracks",
        tracks,
        data
      }, [data.buffer]);
    };
    _proto.probeTs = function probeTs(_ref3) {
      var data = _ref3.data, baseStartTime = _ref3.baseStartTime;
      var tsStartTime = typeof baseStartTime === "number" && !isNaN(baseStartTime) ? baseStartTime * clock2.ONE_SECOND_IN_TS : void 0;
      var timeInfo = tsInspector.inspect(data, tsStartTime);
      var result2 = null;
      if (timeInfo) {
        result2 = {
          hasVideo: timeInfo.video && timeInfo.video.length === 2 || false,
          hasAudio: timeInfo.audio && timeInfo.audio.length === 2 || false
        };
        if (result2.hasVideo) {
          result2.videoStart = timeInfo.video[0].ptsTime;
        }
        if (result2.hasAudio) {
          result2.audioStart = timeInfo.audio[0].ptsTime;
        }
      }
      this.self.postMessage({
        action: "probeTs",
        result: result2,
        data
      }, [data.buffer]);
    };
    _proto.clearAllMp4Captions = function clearAllMp4Captions() {
      if (this.captionParser) {
        this.captionParser.clearAllCaptions();
      }
    };
    _proto.clearParsedMp4Captions = function clearParsedMp4Captions() {
      if (this.captionParser) {
        this.captionParser.clearParsedCaptions();
      }
    };
    _proto.push = function push(data) {
      var segment = new Uint8Array(data.data, data.byteOffset, data.byteLength);
      this.transmuxer.push(segment);
    };
    _proto.reset = function reset3() {
      this.transmuxer.reset();
    };
    _proto.setTimestampOffset = function setTimestampOffset(data) {
      var timestampOffset2 = data.timestampOffset || 0;
      this.transmuxer.setBaseMediaDecodeTime(Math.round(clock2.secondsToVideoTs(timestampOffset2)));
    };
    _proto.setAudioAppendStart = function setAudioAppendStart(data) {
      this.transmuxer.setAudioAppendStart(Math.ceil(clock2.secondsToVideoTs(data.appendStart)));
    };
    _proto.setRemux = function setRemux(data) {
      this.transmuxer.setRemux(data.remux);
    };
    _proto.flush = function flush(data) {
      this.transmuxer.flush();
      self.postMessage({
        action: "done",
        type: "transmuxed"
      });
    };
    _proto.endTimeline = function endTimeline3() {
      this.transmuxer.endTimeline();
      self.postMessage({
        action: "endedtimeline",
        type: "transmuxed"
      });
    };
    _proto.alignGopsWith = function alignGopsWith(data) {
      this.transmuxer.alignGopsWith(data.gopsToAlignWith.slice());
    };
    return MessageHandlers2;
  }();
  self.onmessage = function(event) {
    if (event.data.action === "init" && event.data.options) {
      this.messageHandlers = new MessageHandlers(self, event.data.options);
      return;
    }
    if (!this.messageHandlers) {
      this.messageHandlers = new MessageHandlers(self);
    }
    if (event.data && event.data.action && event.data.action !== "init") {
      if (this.messageHandlers[event.data.action]) {
        this.messageHandlers[event.data.action](event.data);
      }
    }
  };
}));
var TransmuxWorker = factory(workerCode$1);
var handleData_ = function handleData_2(event, transmuxedData, callback2) {
  var _event$data$segment = event.data.segment, type2 = _event$data$segment.type, initSegment = _event$data$segment.initSegment, captions = _event$data$segment.captions, captionStreams = _event$data$segment.captionStreams, metadata = _event$data$segment.metadata, videoFrameDtsTime = _event$data$segment.videoFrameDtsTime, videoFramePtsTime = _event$data$segment.videoFramePtsTime;
  transmuxedData.buffer.push({
    captions,
    captionStreams,
    metadata
  });
  var boxes = event.data.segment.boxes || {
    data: event.data.segment.data
  };
  var result2 = {
    type: type2,
    data: new Uint8Array(boxes.data, boxes.data.byteOffset, boxes.data.byteLength),
    initSegment: new Uint8Array(initSegment.data, initSegment.byteOffset, initSegment.byteLength)
  };
  if (typeof videoFrameDtsTime !== "undefined") {
    result2.videoFrameDtsTime = videoFrameDtsTime;
  }
  if (typeof videoFramePtsTime !== "undefined") {
    result2.videoFramePtsTime = videoFramePtsTime;
  }
  callback2(result2);
};
var handleDone_ = function handleDone_2(_ref2) {
  var transmuxedData = _ref2.transmuxedData, callback2 = _ref2.callback;
  transmuxedData.buffer = [];
  callback2(transmuxedData);
};
var handleGopInfo_ = function handleGopInfo_2(event, transmuxedData) {
  transmuxedData.gopInfo = event.data.gopInfo;
};
var processTransmux = function processTransmux2(options) {
  var transmuxer = options.transmuxer, bytes = options.bytes, audioAppendStart = options.audioAppendStart, gopsToAlignWith = options.gopsToAlignWith, remux = options.remux, onData = options.onData, onTrackInfo = options.onTrackInfo, onAudioTimingInfo = options.onAudioTimingInfo, onVideoTimingInfo = options.onVideoTimingInfo, onVideoSegmentTimingInfo = options.onVideoSegmentTimingInfo, onAudioSegmentTimingInfo = options.onAudioSegmentTimingInfo, onId3 = options.onId3, onCaptions = options.onCaptions, onDone = options.onDone, onEndedTimeline = options.onEndedTimeline, onTransmuxerLog = options.onTransmuxerLog, isEndOfTimeline = options.isEndOfTimeline;
  var transmuxedData = {
    buffer: []
  };
  var waitForEndedTimelineEvent = isEndOfTimeline;
  var handleMessage = function handleMessage2(event) {
    if (transmuxer.currentTransmux !== options) {
      return;
    }
    if (event.data.action === "data") {
      handleData_(event, transmuxedData, onData);
    }
    if (event.data.action === "trackinfo") {
      onTrackInfo(event.data.trackInfo);
    }
    if (event.data.action === "gopInfo") {
      handleGopInfo_(event, transmuxedData);
    }
    if (event.data.action === "audioTimingInfo") {
      onAudioTimingInfo(event.data.audioTimingInfo);
    }
    if (event.data.action === "videoTimingInfo") {
      onVideoTimingInfo(event.data.videoTimingInfo);
    }
    if (event.data.action === "videoSegmentTimingInfo") {
      onVideoSegmentTimingInfo(event.data.videoSegmentTimingInfo);
    }
    if (event.data.action === "audioSegmentTimingInfo") {
      onAudioSegmentTimingInfo(event.data.audioSegmentTimingInfo);
    }
    if (event.data.action === "id3Frame") {
      onId3([event.data.id3Frame], event.data.id3Frame.dispatchType);
    }
    if (event.data.action === "caption") {
      onCaptions(event.data.caption);
    }
    if (event.data.action === "endedtimeline") {
      waitForEndedTimelineEvent = false;
      onEndedTimeline();
    }
    if (event.data.action === "log") {
      onTransmuxerLog(event.data.log);
    }
    if (event.data.type !== "transmuxed") {
      return;
    }
    if (waitForEndedTimelineEvent) {
      return;
    }
    transmuxer.onmessage = null;
    handleDone_({
      transmuxedData,
      callback: onDone
    });
    dequeue(transmuxer);
  };
  transmuxer.onmessage = handleMessage;
  if (audioAppendStart) {
    transmuxer.postMessage({
      action: "setAudioAppendStart",
      appendStart: audioAppendStart
    });
  }
  if (Array.isArray(gopsToAlignWith)) {
    transmuxer.postMessage({
      action: "alignGopsWith",
      gopsToAlignWith
    });
  }
  if (typeof remux !== "undefined") {
    transmuxer.postMessage({
      action: "setRemux",
      remux
    });
  }
  if (bytes.byteLength) {
    var buffer = bytes instanceof ArrayBuffer ? bytes : bytes.buffer;
    var byteOffset = bytes instanceof ArrayBuffer ? 0 : bytes.byteOffset;
    transmuxer.postMessage({
      action: "push",
      data: buffer,
      byteOffset,
      byteLength: bytes.byteLength
    }, [buffer]);
  }
  if (isEndOfTimeline) {
    transmuxer.postMessage({
      action: "endTimeline"
    });
  }
  transmuxer.postMessage({
    action: "flush"
  });
};
var dequeue = function dequeue2(transmuxer) {
  transmuxer.currentTransmux = null;
  if (transmuxer.transmuxQueue.length) {
    transmuxer.currentTransmux = transmuxer.transmuxQueue.shift();
    if (typeof transmuxer.currentTransmux === "function") {
      transmuxer.currentTransmux();
    } else {
      processTransmux(transmuxer.currentTransmux);
    }
  }
};
var processAction = function processAction2(transmuxer, action) {
  transmuxer.postMessage({
    action
  });
  dequeue(transmuxer);
};
var enqueueAction = function enqueueAction2(action, transmuxer) {
  if (!transmuxer.currentTransmux) {
    transmuxer.currentTransmux = action;
    processAction(transmuxer, action);
    return;
  }
  transmuxer.transmuxQueue.push(processAction.bind(null, transmuxer, action));
};
var reset = function reset2(transmuxer) {
  enqueueAction("reset", transmuxer);
};
var endTimeline = function endTimeline2(transmuxer) {
  enqueueAction("endTimeline", transmuxer);
};
var transmux = function transmux2(options) {
  if (!options.transmuxer.currentTransmux) {
    options.transmuxer.currentTransmux = options;
    processTransmux(options);
    return;
  }
  options.transmuxer.transmuxQueue.push(options);
};
var createTransmuxer = function createTransmuxer2(options) {
  var transmuxer = new TransmuxWorker();
  transmuxer.currentTransmux = null;
  transmuxer.transmuxQueue = [];
  var term = transmuxer.terminate;
  transmuxer.terminate = function() {
    transmuxer.currentTransmux = null;
    transmuxer.transmuxQueue.length = 0;
    return term.call(transmuxer);
  };
  transmuxer.postMessage({
    action: "init",
    options
  });
  return transmuxer;
};
var segmentTransmuxer = {
  reset,
  endTimeline,
  transmux,
  createTransmuxer
};
var workerCallback = function workerCallback2(options) {
  var transmuxer = options.transmuxer;
  var endAction = options.endAction || options.action;
  var callback2 = options.callback;
  var message = _extends$2({}, options, {
    endAction: null,
    transmuxer: null,
    callback: null
  });
  var listenForEndEvent = function listenForEndEvent2(event) {
    if (event.data.action !== endAction) {
      return;
    }
    transmuxer.removeEventListener("message", listenForEndEvent2);
    if (event.data.data) {
      event.data.data = new Uint8Array(event.data.data, options.byteOffset || 0, options.byteLength || event.data.data.byteLength);
      if (options.data) {
        options.data = event.data.data;
      }
    }
    callback2(event.data);
  };
  transmuxer.addEventListener("message", listenForEndEvent);
  if (options.data) {
    var isArrayBuffer = options.data instanceof ArrayBuffer;
    message.byteOffset = isArrayBuffer ? 0 : options.data.byteOffset;
    message.byteLength = options.data.byteLength;
    var transfers = [isArrayBuffer ? options.data : options.data.buffer];
    transmuxer.postMessage(message, transfers);
  } else {
    transmuxer.postMessage(message);
  }
};
var REQUEST_ERRORS = {
  FAILURE: 2,
  TIMEOUT: -101,
  ABORTED: -102
};
var abortAll = function abortAll2(activeXhrs) {
  activeXhrs.forEach(function(xhr) {
    xhr.abort();
  });
};
var getRequestStats = function getRequestStats2(request) {
  return {
    bandwidth: request.bandwidth,
    bytesReceived: request.bytesReceived || 0,
    roundTripTime: request.roundTripTime || 0
  };
};
var getProgressStats = function getProgressStats2(progressEvent) {
  var request = progressEvent.target;
  var roundTripTime = Date.now() - request.requestTime;
  var stats = {
    bandwidth: Infinity,
    bytesReceived: 0,
    roundTripTime: roundTripTime || 0
  };
  stats.bytesReceived = progressEvent.loaded;
  stats.bandwidth = Math.floor(stats.bytesReceived / stats.roundTripTime * 8 * 1e3);
  return stats;
};
var handleErrors = function handleErrors2(error2, request) {
  if (request.timedout) {
    return {
      status: request.status,
      message: "HLS request timed-out at URL: " + request.uri,
      code: REQUEST_ERRORS.TIMEOUT,
      xhr: request
    };
  }
  if (request.aborted) {
    return {
      status: request.status,
      message: "HLS request aborted at URL: " + request.uri,
      code: REQUEST_ERRORS.ABORTED,
      xhr: request
    };
  }
  if (error2) {
    return {
      status: request.status,
      message: "HLS request errored at URL: " + request.uri,
      code: REQUEST_ERRORS.FAILURE,
      xhr: request
    };
  }
  if (request.responseType === "arraybuffer" && request.response.byteLength === 0) {
    return {
      status: request.status,
      message: "Empty HLS response at URL: " + request.uri,
      code: REQUEST_ERRORS.FAILURE,
      xhr: request
    };
  }
  return null;
};
var handleKeyResponse = function handleKeyResponse2(segment, objects, finishProcessingFn) {
  return function(error2, request) {
    var response = request.response;
    var errorObj = handleErrors(error2, request);
    if (errorObj) {
      return finishProcessingFn(errorObj, segment);
    }
    if (response.byteLength !== 16) {
      return finishProcessingFn({
        status: request.status,
        message: "Invalid HLS key at URL: " + request.uri,
        code: REQUEST_ERRORS.FAILURE,
        xhr: request
      }, segment);
    }
    var view = new DataView(response);
    var bytes = new Uint32Array([view.getUint32(0), view.getUint32(4), view.getUint32(8), view.getUint32(12)]);
    for (var i = 0; i < objects.length; i++) {
      objects[i].bytes = bytes;
    }
    return finishProcessingFn(null, segment);
  };
};
var parseInitSegment = function parseInitSegment2(segment, _callback) {
  var type2 = detectContainerForBytes(segment.map.bytes);
  if (type2 !== "mp4") {
    var uri = segment.map.resolvedUri || segment.map.uri;
    return _callback({
      internal: true,
      message: "Found unsupported " + (type2 || "unknown") + " container for initialization segment at URL: " + uri,
      code: REQUEST_ERRORS.FAILURE
    });
  }
  workerCallback({
    action: "probeMp4Tracks",
    data: segment.map.bytes,
    transmuxer: segment.transmuxer,
    callback: function callback2(_ref2) {
      var tracks = _ref2.tracks, data = _ref2.data;
      segment.map.bytes = data;
      tracks.forEach(function(track) {
        segment.map.tracks = segment.map.tracks || {};
        if (segment.map.tracks[track.type]) {
          return;
        }
        segment.map.tracks[track.type] = track;
        if (typeof track.id === "number" && track.timescale) {
          segment.map.timescales = segment.map.timescales || {};
          segment.map.timescales[track.id] = track.timescale;
        }
      });
      return _callback(null);
    }
  });
};
var handleInitSegmentResponse = function handleInitSegmentResponse2(_ref2) {
  var segment = _ref2.segment, finishProcessingFn = _ref2.finishProcessingFn;
  return function(error2, request) {
    var errorObj = handleErrors(error2, request);
    if (errorObj) {
      return finishProcessingFn(errorObj, segment);
    }
    var bytes = new Uint8Array(request.response);
    if (segment.map.key) {
      segment.map.encryptedBytes = bytes;
      return finishProcessingFn(null, segment);
    }
    segment.map.bytes = bytes;
    parseInitSegment(segment, function(parseError) {
      if (parseError) {
        parseError.xhr = request;
        parseError.status = request.status;
        return finishProcessingFn(parseError, segment);
      }
      finishProcessingFn(null, segment);
    });
  };
};
var handleSegmentResponse = function handleSegmentResponse2(_ref3) {
  var segment = _ref3.segment, finishProcessingFn = _ref3.finishProcessingFn, responseType = _ref3.responseType;
  return function(error2, request) {
    var errorObj = handleErrors(error2, request);
    if (errorObj) {
      return finishProcessingFn(errorObj, segment);
    }
    var newBytes = responseType === "arraybuffer" || !request.responseText ? request.response : stringToArrayBuffer(request.responseText.substring(segment.lastReachedChar || 0));
    segment.stats = getRequestStats(request);
    if (segment.key) {
      segment.encryptedBytes = new Uint8Array(newBytes);
    } else {
      segment.bytes = new Uint8Array(newBytes);
    }
    return finishProcessingFn(null, segment);
  };
};
var transmuxAndNotify = function transmuxAndNotify2(_ref4) {
  var segment = _ref4.segment, bytes = _ref4.bytes, trackInfoFn = _ref4.trackInfoFn, timingInfoFn = _ref4.timingInfoFn, videoSegmentTimingInfoFn = _ref4.videoSegmentTimingInfoFn, audioSegmentTimingInfoFn = _ref4.audioSegmentTimingInfoFn, id3Fn = _ref4.id3Fn, captionsFn = _ref4.captionsFn, isEndOfTimeline = _ref4.isEndOfTimeline, endedTimelineFn = _ref4.endedTimelineFn, dataFn = _ref4.dataFn, doneFn = _ref4.doneFn, onTransmuxerLog = _ref4.onTransmuxerLog;
  var fmp4Tracks = segment.map && segment.map.tracks || {};
  var isMuxed3 = Boolean(fmp4Tracks.audio && fmp4Tracks.video);
  var audioStartFn = timingInfoFn.bind(null, segment, "audio", "start");
  var audioEndFn = timingInfoFn.bind(null, segment, "audio", "end");
  var videoStartFn = timingInfoFn.bind(null, segment, "video", "start");
  var videoEndFn = timingInfoFn.bind(null, segment, "video", "end");
  var finish = function finish2() {
    return transmux({
      bytes,
      transmuxer: segment.transmuxer,
      audioAppendStart: segment.audioAppendStart,
      gopsToAlignWith: segment.gopsToAlignWith,
      remux: isMuxed3,
      onData: function onData(result2) {
        result2.type = result2.type === "combined" ? "video" : result2.type;
        dataFn(segment, result2);
      },
      onTrackInfo: function onTrackInfo(trackInfo) {
        if (trackInfoFn) {
          if (isMuxed3) {
            trackInfo.isMuxed = true;
          }
          trackInfoFn(segment, trackInfo);
        }
      },
      onAudioTimingInfo: function onAudioTimingInfo(audioTimingInfo) {
        if (audioStartFn && typeof audioTimingInfo.start !== "undefined") {
          audioStartFn(audioTimingInfo.start);
          audioStartFn = null;
        }
        if (audioEndFn && typeof audioTimingInfo.end !== "undefined") {
          audioEndFn(audioTimingInfo.end);
        }
      },
      onVideoTimingInfo: function onVideoTimingInfo(videoTimingInfo) {
        if (videoStartFn && typeof videoTimingInfo.start !== "undefined") {
          videoStartFn(videoTimingInfo.start);
          videoStartFn = null;
        }
        if (videoEndFn && typeof videoTimingInfo.end !== "undefined") {
          videoEndFn(videoTimingInfo.end);
        }
      },
      onVideoSegmentTimingInfo: function onVideoSegmentTimingInfo(videoSegmentTimingInfo) {
        videoSegmentTimingInfoFn(videoSegmentTimingInfo);
      },
      onAudioSegmentTimingInfo: function onAudioSegmentTimingInfo(audioSegmentTimingInfo) {
        audioSegmentTimingInfoFn(audioSegmentTimingInfo);
      },
      onId3: function onId3(id3Frames, dispatchType) {
        id3Fn(segment, id3Frames, dispatchType);
      },
      onCaptions: function onCaptions(captions) {
        captionsFn(segment, [captions]);
      },
      isEndOfTimeline,
      onEndedTimeline: function onEndedTimeline() {
        endedTimelineFn();
      },
      onTransmuxerLog,
      onDone: function onDone(result2) {
        if (!doneFn) {
          return;
        }
        result2.type = result2.type === "combined" ? "video" : result2.type;
        doneFn(null, segment, result2);
      }
    });
  };
  workerCallback({
    action: "probeTs",
    transmuxer: segment.transmuxer,
    data: bytes,
    baseStartTime: segment.baseStartTime,
    callback: function callback2(data) {
      segment.bytes = bytes = data.data;
      var probeResult = data.result;
      if (probeResult) {
        trackInfoFn(segment, {
          hasAudio: probeResult.hasAudio,
          hasVideo: probeResult.hasVideo,
          isMuxed: isMuxed3
        });
        trackInfoFn = null;
        if (probeResult.hasAudio && !isMuxed3) {
          audioStartFn(probeResult.audioStart);
        }
        if (probeResult.hasVideo) {
          videoStartFn(probeResult.videoStart);
        }
        audioStartFn = null;
        videoStartFn = null;
      }
      finish();
    }
  });
};
var handleSegmentBytes = function handleSegmentBytes2(_ref5) {
  var segment = _ref5.segment, bytes = _ref5.bytes, trackInfoFn = _ref5.trackInfoFn, timingInfoFn = _ref5.timingInfoFn, videoSegmentTimingInfoFn = _ref5.videoSegmentTimingInfoFn, audioSegmentTimingInfoFn = _ref5.audioSegmentTimingInfoFn, id3Fn = _ref5.id3Fn, captionsFn = _ref5.captionsFn, isEndOfTimeline = _ref5.isEndOfTimeline, endedTimelineFn = _ref5.endedTimelineFn, dataFn = _ref5.dataFn, doneFn = _ref5.doneFn, onTransmuxerLog = _ref5.onTransmuxerLog;
  var bytesAsUint8Array = new Uint8Array(bytes);
  if (isLikelyFmp4MediaSegment(bytesAsUint8Array)) {
    segment.isFmp4 = true;
    var tracks = segment.map.tracks;
    var trackInfo = {
      isFmp4: true,
      hasVideo: !!tracks.video,
      hasAudio: !!tracks.audio
    };
    if (tracks.audio && tracks.audio.codec && tracks.audio.codec !== "enca") {
      trackInfo.audioCodec = tracks.audio.codec;
    }
    if (tracks.video && tracks.video.codec && tracks.video.codec !== "encv") {
      trackInfo.videoCodec = tracks.video.codec;
    }
    if (tracks.video && tracks.audio) {
      trackInfo.isMuxed = true;
    }
    trackInfoFn(segment, trackInfo);
    var finishLoading = function finishLoading2(captions) {
      dataFn(segment, {
        data: bytesAsUint8Array,
        type: trackInfo.hasAudio && !trackInfo.isMuxed ? "audio" : "video"
      });
      if (captions && captions.length) {
        captionsFn(segment, captions);
      }
      doneFn(null, segment, {});
    };
    workerCallback({
      action: "probeMp4StartTime",
      timescales: segment.map.timescales,
      data: bytesAsUint8Array,
      transmuxer: segment.transmuxer,
      callback: function callback2(_ref6) {
        var data = _ref6.data, startTime = _ref6.startTime;
        bytes = data.buffer;
        segment.bytes = bytesAsUint8Array = data;
        if (trackInfo.hasAudio && !trackInfo.isMuxed) {
          timingInfoFn(segment, "audio", "start", startTime);
        }
        if (trackInfo.hasVideo) {
          timingInfoFn(segment, "video", "start", startTime);
        }
        if (!tracks.video || !data.byteLength || !segment.transmuxer) {
          finishLoading();
          return;
        }
        workerCallback({
          action: "pushMp4Captions",
          endAction: "mp4Captions",
          transmuxer: segment.transmuxer,
          data: bytesAsUint8Array,
          timescales: segment.map.timescales,
          trackIds: [tracks.video.id],
          callback: function callback3(message) {
            bytes = message.data.buffer;
            segment.bytes = bytesAsUint8Array = message.data;
            message.logs.forEach(function(log2) {
              onTransmuxerLog(videojs.mergeOptions(log2, {
                stream: "mp4CaptionParser"
              }));
            });
            finishLoading(message.captions);
          }
        });
      }
    });
    return;
  }
  if (!segment.transmuxer) {
    doneFn(null, segment, {});
    return;
  }
  if (typeof segment.container === "undefined") {
    segment.container = detectContainerForBytes(bytesAsUint8Array);
  }
  if (segment.container !== "ts" && segment.container !== "aac") {
    trackInfoFn(segment, {
      hasAudio: false,
      hasVideo: false
    });
    doneFn(null, segment, {});
    return;
  }
  transmuxAndNotify({
    segment,
    bytes,
    trackInfoFn,
    timingInfoFn,
    videoSegmentTimingInfoFn,
    audioSegmentTimingInfoFn,
    id3Fn,
    captionsFn,
    isEndOfTimeline,
    endedTimelineFn,
    dataFn,
    doneFn,
    onTransmuxerLog
  });
};
var decrypt = function decrypt2(_ref7, callback2) {
  var id2 = _ref7.id, key = _ref7.key, encryptedBytes = _ref7.encryptedBytes, decryptionWorker = _ref7.decryptionWorker;
  var decryptionHandler = function decryptionHandler2(event) {
    if (event.data.source === id2) {
      decryptionWorker.removeEventListener("message", decryptionHandler2);
      var decrypted = event.data.decrypted;
      callback2(new Uint8Array(decrypted.bytes, decrypted.byteOffset, decrypted.byteLength));
    }
  };
  decryptionWorker.addEventListener("message", decryptionHandler);
  var keyBytes;
  if (key.bytes.slice) {
    keyBytes = key.bytes.slice();
  } else {
    keyBytes = new Uint32Array(Array.prototype.slice.call(key.bytes));
  }
  decryptionWorker.postMessage(createTransferableMessage({
    source: id2,
    encrypted: encryptedBytes,
    key: keyBytes,
    iv: key.iv
  }), [encryptedBytes.buffer, keyBytes.buffer]);
};
var decryptSegment = function decryptSegment2(_ref8) {
  var decryptionWorker = _ref8.decryptionWorker, segment = _ref8.segment, trackInfoFn = _ref8.trackInfoFn, timingInfoFn = _ref8.timingInfoFn, videoSegmentTimingInfoFn = _ref8.videoSegmentTimingInfoFn, audioSegmentTimingInfoFn = _ref8.audioSegmentTimingInfoFn, id3Fn = _ref8.id3Fn, captionsFn = _ref8.captionsFn, isEndOfTimeline = _ref8.isEndOfTimeline, endedTimelineFn = _ref8.endedTimelineFn, dataFn = _ref8.dataFn, doneFn = _ref8.doneFn, onTransmuxerLog = _ref8.onTransmuxerLog;
  decrypt({
    id: segment.requestId,
    key: segment.key,
    encryptedBytes: segment.encryptedBytes,
    decryptionWorker
  }, function(decryptedBytes) {
    segment.bytes = decryptedBytes;
    handleSegmentBytes({
      segment,
      bytes: segment.bytes,
      trackInfoFn,
      timingInfoFn,
      videoSegmentTimingInfoFn,
      audioSegmentTimingInfoFn,
      id3Fn,
      captionsFn,
      isEndOfTimeline,
      endedTimelineFn,
      dataFn,
      doneFn,
      onTransmuxerLog
    });
  });
};
var waitForCompletion = function waitForCompletion2(_ref9) {
  var activeXhrs = _ref9.activeXhrs, decryptionWorker = _ref9.decryptionWorker, trackInfoFn = _ref9.trackInfoFn, timingInfoFn = _ref9.timingInfoFn, videoSegmentTimingInfoFn = _ref9.videoSegmentTimingInfoFn, audioSegmentTimingInfoFn = _ref9.audioSegmentTimingInfoFn, id3Fn = _ref9.id3Fn, captionsFn = _ref9.captionsFn, isEndOfTimeline = _ref9.isEndOfTimeline, endedTimelineFn = _ref9.endedTimelineFn, dataFn = _ref9.dataFn, doneFn = _ref9.doneFn, onTransmuxerLog = _ref9.onTransmuxerLog;
  var count = 0;
  var didError = false;
  return function(error2, segment) {
    if (didError) {
      return;
    }
    if (error2) {
      didError = true;
      abortAll(activeXhrs);
      return doneFn(error2, segment);
    }
    count += 1;
    if (count === activeXhrs.length) {
      var segmentFinish = function segmentFinish2() {
        if (segment.encryptedBytes) {
          return decryptSegment({
            decryptionWorker,
            segment,
            trackInfoFn,
            timingInfoFn,
            videoSegmentTimingInfoFn,
            audioSegmentTimingInfoFn,
            id3Fn,
            captionsFn,
            isEndOfTimeline,
            endedTimelineFn,
            dataFn,
            doneFn,
            onTransmuxerLog
          });
        }
        handleSegmentBytes({
          segment,
          bytes: segment.bytes,
          trackInfoFn,
          timingInfoFn,
          videoSegmentTimingInfoFn,
          audioSegmentTimingInfoFn,
          id3Fn,
          captionsFn,
          isEndOfTimeline,
          endedTimelineFn,
          dataFn,
          doneFn,
          onTransmuxerLog
        });
      };
      segment.endOfAllRequests = Date.now();
      if (segment.map && segment.map.encryptedBytes && !segment.map.bytes) {
        return decrypt({
          decryptionWorker,
          id: segment.requestId + "-init",
          encryptedBytes: segment.map.encryptedBytes,
          key: segment.map.key
        }, function(decryptedBytes) {
          segment.map.bytes = decryptedBytes;
          parseInitSegment(segment, function(parseError) {
            if (parseError) {
              abortAll(activeXhrs);
              return doneFn(parseError, segment);
            }
            segmentFinish();
          });
        });
      }
      segmentFinish();
    }
  };
};
var handleLoadEnd = function handleLoadEnd2(_ref10) {
  var loadendState = _ref10.loadendState, abortFn = _ref10.abortFn;
  return function(event) {
    var request = event.target;
    if (request.aborted && abortFn && !loadendState.calledAbortFn) {
      abortFn();
      loadendState.calledAbortFn = true;
    }
  };
};
var handleProgress = function handleProgress2(_ref11) {
  var segment = _ref11.segment, progressFn = _ref11.progressFn;
  _ref11.trackInfoFn;
  _ref11.timingInfoFn;
  _ref11.videoSegmentTimingInfoFn;
  _ref11.audioSegmentTimingInfoFn;
  _ref11.id3Fn;
  _ref11.captionsFn;
  _ref11.isEndOfTimeline;
  _ref11.endedTimelineFn;
  _ref11.dataFn;
  return function(event) {
    var request = event.target;
    if (request.aborted) {
      return;
    }
    segment.stats = videojs.mergeOptions(segment.stats, getProgressStats(event));
    if (!segment.stats.firstBytesReceivedAt && segment.stats.bytesReceived) {
      segment.stats.firstBytesReceivedAt = Date.now();
    }
    return progressFn(event, segment);
  };
};
var mediaSegmentRequest = function mediaSegmentRequest2(_ref12) {
  var xhr = _ref12.xhr, xhrOptions = _ref12.xhrOptions, decryptionWorker = _ref12.decryptionWorker, segment = _ref12.segment, abortFn = _ref12.abortFn, progressFn = _ref12.progressFn, trackInfoFn = _ref12.trackInfoFn, timingInfoFn = _ref12.timingInfoFn, videoSegmentTimingInfoFn = _ref12.videoSegmentTimingInfoFn, audioSegmentTimingInfoFn = _ref12.audioSegmentTimingInfoFn, id3Fn = _ref12.id3Fn, captionsFn = _ref12.captionsFn, isEndOfTimeline = _ref12.isEndOfTimeline, endedTimelineFn = _ref12.endedTimelineFn, dataFn = _ref12.dataFn, doneFn = _ref12.doneFn, onTransmuxerLog = _ref12.onTransmuxerLog;
  var activeXhrs = [];
  var finishProcessingFn = waitForCompletion({
    activeXhrs,
    decryptionWorker,
    trackInfoFn,
    timingInfoFn,
    videoSegmentTimingInfoFn,
    audioSegmentTimingInfoFn,
    id3Fn,
    captionsFn,
    isEndOfTimeline,
    endedTimelineFn,
    dataFn,
    doneFn,
    onTransmuxerLog
  });
  if (segment.key && !segment.key.bytes) {
    var objects = [segment.key];
    if (segment.map && !segment.map.bytes && segment.map.key && segment.map.key.resolvedUri === segment.key.resolvedUri) {
      objects.push(segment.map.key);
    }
    var keyRequestOptions = videojs.mergeOptions(xhrOptions, {
      uri: segment.key.resolvedUri,
      responseType: "arraybuffer"
    });
    var keyRequestCallback = handleKeyResponse(segment, objects, finishProcessingFn);
    var keyXhr = xhr(keyRequestOptions, keyRequestCallback);
    activeXhrs.push(keyXhr);
  }
  if (segment.map && !segment.map.bytes) {
    var differentMapKey = segment.map.key && (!segment.key || segment.key.resolvedUri !== segment.map.key.resolvedUri);
    if (differentMapKey) {
      var mapKeyRequestOptions = videojs.mergeOptions(xhrOptions, {
        uri: segment.map.key.resolvedUri,
        responseType: "arraybuffer"
      });
      var mapKeyRequestCallback = handleKeyResponse(segment, [segment.map.key], finishProcessingFn);
      var mapKeyXhr = xhr(mapKeyRequestOptions, mapKeyRequestCallback);
      activeXhrs.push(mapKeyXhr);
    }
    var initSegmentOptions = videojs.mergeOptions(xhrOptions, {
      uri: segment.map.resolvedUri,
      responseType: "arraybuffer",
      headers: segmentXhrHeaders(segment.map)
    });
    var initSegmentRequestCallback = handleInitSegmentResponse({
      segment,
      finishProcessingFn
    });
    var initSegmentXhr = xhr(initSegmentOptions, initSegmentRequestCallback);
    activeXhrs.push(initSegmentXhr);
  }
  var segmentRequestOptions = videojs.mergeOptions(xhrOptions, {
    uri: segment.part && segment.part.resolvedUri || segment.resolvedUri,
    responseType: "arraybuffer",
    headers: segmentXhrHeaders(segment)
  });
  var segmentRequestCallback = handleSegmentResponse({
    segment,
    finishProcessingFn,
    responseType: segmentRequestOptions.responseType
  });
  var segmentXhr = xhr(segmentRequestOptions, segmentRequestCallback);
  segmentXhr.addEventListener("progress", handleProgress({
    segment,
    progressFn,
    trackInfoFn,
    timingInfoFn,
    videoSegmentTimingInfoFn,
    audioSegmentTimingInfoFn,
    id3Fn,
    captionsFn,
    isEndOfTimeline,
    endedTimelineFn,
    dataFn
  }));
  activeXhrs.push(segmentXhr);
  var loadendState = {};
  activeXhrs.forEach(function(activeXhr) {
    activeXhr.addEventListener("loadend", handleLoadEnd({
      loadendState,
      abortFn
    }));
  });
  return function() {
    return abortAll(activeXhrs);
  };
};
var logFn$1 = logger("CodecUtils");
var getCodecs = function getCodecs2(media) {
  var mediaAttributes = media.attributes || {};
  if (mediaAttributes.CODECS) {
    return parseCodecs(mediaAttributes.CODECS);
  }
};
var isMaat = function isMaat2(master, media) {
  var mediaAttributes = media.attributes || {};
  return master && master.mediaGroups && master.mediaGroups.AUDIO && mediaAttributes.AUDIO && master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
};
var isMuxed = function isMuxed2(master, media) {
  if (!isMaat(master, media)) {
    return true;
  }
  var mediaAttributes = media.attributes || {};
  var audioGroup = master.mediaGroups.AUDIO[mediaAttributes.AUDIO];
  for (var groupId in audioGroup) {
    if (!audioGroup[groupId].uri && !audioGroup[groupId].playlists) {
      return true;
    }
  }
  return false;
};
var unwrapCodecList = function unwrapCodecList2(codecList) {
  var codecs = {};
  codecList.forEach(function(_ref2) {
    var mediaType = _ref2.mediaType, type2 = _ref2.type, details = _ref2.details;
    codecs[mediaType] = codecs[mediaType] || [];
    codecs[mediaType].push(translateLegacyCodec("" + type2 + details));
  });
  Object.keys(codecs).forEach(function(mediaType) {
    if (codecs[mediaType].length > 1) {
      logFn$1("multiple " + mediaType + " codecs found as attributes: " + codecs[mediaType].join(", ") + ". Setting playlist codecs to null so that we wait for mux.js to probe segments for real codecs.");
      codecs[mediaType] = null;
      return;
    }
    codecs[mediaType] = codecs[mediaType][0];
  });
  return codecs;
};
var codecCount = function codecCount2(codecObj) {
  var count = 0;
  if (codecObj.audio) {
    count++;
  }
  if (codecObj.video) {
    count++;
  }
  return count;
};
var codecsForPlaylist = function codecsForPlaylist2(master, media) {
  var mediaAttributes = media.attributes || {};
  var codecInfo = unwrapCodecList(getCodecs(media) || []);
  if (isMaat(master, media) && !codecInfo.audio) {
    if (!isMuxed(master, media)) {
      var defaultCodecs = unwrapCodecList(codecsFromDefault(master, mediaAttributes.AUDIO) || []);
      if (defaultCodecs.audio) {
        codecInfo.audio = defaultCodecs.audio;
      }
    }
  }
  return codecInfo;
};
var logFn = logger("PlaylistSelector");
var representationToString = function representationToString2(representation) {
  if (!representation || !representation.playlist) {
    return;
  }
  var playlist = representation.playlist;
  return JSON.stringify({
    id: playlist.id,
    bandwidth: representation.bandwidth,
    width: representation.width,
    height: representation.height,
    codecs: playlist.attributes && playlist.attributes.CODECS || ""
  });
};
var safeGetComputedStyle = function safeGetComputedStyle2(el, property) {
  if (!el) {
    return "";
  }
  var result2 = window_1.getComputedStyle(el);
  if (!result2) {
    return "";
  }
  return result2[property];
};
var stableSort = function stableSort2(array2, sortFn) {
  var newArray = array2.slice();
  array2.sort(function(left, right) {
    var cmp = sortFn(left, right);
    if (cmp === 0) {
      return newArray.indexOf(left) - newArray.indexOf(right);
    }
    return cmp;
  });
};
var comparePlaylistBandwidth = function comparePlaylistBandwidth2(left, right) {
  var leftBandwidth;
  var rightBandwidth;
  if (left.attributes.BANDWIDTH) {
    leftBandwidth = left.attributes.BANDWIDTH;
  }
  leftBandwidth = leftBandwidth || window_1.Number.MAX_VALUE;
  if (right.attributes.BANDWIDTH) {
    rightBandwidth = right.attributes.BANDWIDTH;
  }
  rightBandwidth = rightBandwidth || window_1.Number.MAX_VALUE;
  return leftBandwidth - rightBandwidth;
};
var comparePlaylistResolution = function comparePlaylistResolution2(left, right) {
  var leftWidth;
  var rightWidth;
  if (left.attributes.RESOLUTION && left.attributes.RESOLUTION.width) {
    leftWidth = left.attributes.RESOLUTION.width;
  }
  leftWidth = leftWidth || window_1.Number.MAX_VALUE;
  if (right.attributes.RESOLUTION && right.attributes.RESOLUTION.width) {
    rightWidth = right.attributes.RESOLUTION.width;
  }
  rightWidth = rightWidth || window_1.Number.MAX_VALUE;
  if (leftWidth === rightWidth && left.attributes.BANDWIDTH && right.attributes.BANDWIDTH) {
    return left.attributes.BANDWIDTH - right.attributes.BANDWIDTH;
  }
  return leftWidth - rightWidth;
};
var simpleSelector = function simpleSelector2(master, playerBandwidth, playerWidth, playerHeight, limitRenditionByPlayerDimensions, masterPlaylistController) {
  if (!master) {
    return;
  }
  var options = {
    bandwidth: playerBandwidth,
    width: playerWidth,
    height: playerHeight,
    limitRenditionByPlayerDimensions
  };
  var playlists = master.playlists;
  if (Playlist.isAudioOnly(master)) {
    playlists = masterPlaylistController.getAudioTrackPlaylists_();
    options.audioOnly = true;
  }
  var sortedPlaylistReps = playlists.map(function(playlist) {
    var bandwidth2;
    var width2 = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.width;
    var height2 = playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height;
    bandwidth2 = playlist.attributes && playlist.attributes.BANDWIDTH;
    bandwidth2 = bandwidth2 || window_1.Number.MAX_VALUE;
    return {
      bandwidth: bandwidth2,
      width: width2,
      height: height2,
      playlist
    };
  });
  stableSort(sortedPlaylistReps, function(left, right) {
    return left.bandwidth - right.bandwidth;
  });
  sortedPlaylistReps = sortedPlaylistReps.filter(function(rep) {
    return !Playlist.isIncompatible(rep.playlist);
  });
  var enabledPlaylistReps = sortedPlaylistReps.filter(function(rep) {
    return Playlist.isEnabled(rep.playlist);
  });
  if (!enabledPlaylistReps.length) {
    enabledPlaylistReps = sortedPlaylistReps.filter(function(rep) {
      return !Playlist.isDisabled(rep.playlist);
    });
  }
  var bandwidthPlaylistReps = enabledPlaylistReps.filter(function(rep) {
    return rep.bandwidth * Config.BANDWIDTH_VARIANCE < playerBandwidth;
  });
  var highestRemainingBandwidthRep = bandwidthPlaylistReps[bandwidthPlaylistReps.length - 1];
  var bandwidthBestRep = bandwidthPlaylistReps.filter(function(rep) {
    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
  })[0];
  if (limitRenditionByPlayerDimensions === false) {
    var _chosenRep = bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
    if (_chosenRep && _chosenRep.playlist) {
      var type2 = "sortedPlaylistReps";
      if (bandwidthBestRep) {
        type2 = "bandwidthBestRep";
      }
      if (enabledPlaylistReps[0]) {
        type2 = "enabledPlaylistReps";
      }
      logFn("choosing " + representationToString(_chosenRep) + " using " + type2 + " with options", options);
      return _chosenRep.playlist;
    }
    logFn("could not choose a playlist with options", options);
    return null;
  }
  var haveResolution = bandwidthPlaylistReps.filter(function(rep) {
    return rep.width && rep.height;
  });
  stableSort(haveResolution, function(left, right) {
    return left.width - right.width;
  });
  var resolutionBestRepList = haveResolution.filter(function(rep) {
    return rep.width === playerWidth && rep.height === playerHeight;
  });
  highestRemainingBandwidthRep = resolutionBestRepList[resolutionBestRepList.length - 1];
  var resolutionBestRep = resolutionBestRepList.filter(function(rep) {
    return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
  })[0];
  var resolutionPlusOneList;
  var resolutionPlusOneSmallest;
  var resolutionPlusOneRep;
  if (!resolutionBestRep) {
    resolutionPlusOneList = haveResolution.filter(function(rep) {
      return rep.width > playerWidth || rep.height > playerHeight;
    });
    resolutionPlusOneSmallest = resolutionPlusOneList.filter(function(rep) {
      return rep.width === resolutionPlusOneList[0].width && rep.height === resolutionPlusOneList[0].height;
    });
    highestRemainingBandwidthRep = resolutionPlusOneSmallest[resolutionPlusOneSmallest.length - 1];
    resolutionPlusOneRep = resolutionPlusOneSmallest.filter(function(rep) {
      return rep.bandwidth === highestRemainingBandwidthRep.bandwidth;
    })[0];
  }
  var leastPixelDiffRep;
  if (masterPlaylistController.experimentalLeastPixelDiffSelector) {
    var leastPixelDiffList = haveResolution.map(function(rep) {
      rep.pixelDiff = Math.abs(rep.width - playerWidth) + Math.abs(rep.height - playerHeight);
      return rep;
    });
    stableSort(leastPixelDiffList, function(left, right) {
      if (left.pixelDiff === right.pixelDiff) {
        return right.bandwidth - left.bandwidth;
      }
      return left.pixelDiff - right.pixelDiff;
    });
    leastPixelDiffRep = leastPixelDiffList[0];
  }
  var chosenRep = leastPixelDiffRep || resolutionPlusOneRep || resolutionBestRep || bandwidthBestRep || enabledPlaylistReps[0] || sortedPlaylistReps[0];
  if (chosenRep && chosenRep.playlist) {
    var _type = "sortedPlaylistReps";
    if (leastPixelDiffRep) {
      _type = "leastPixelDiffRep";
    } else if (resolutionPlusOneRep) {
      _type = "resolutionPlusOneRep";
    } else if (resolutionBestRep) {
      _type = "resolutionBestRep";
    } else if (bandwidthBestRep) {
      _type = "bandwidthBestRep";
    } else if (enabledPlaylistReps[0]) {
      _type = "enabledPlaylistReps";
    }
    logFn("choosing " + representationToString(chosenRep) + " using " + _type + " with options", options);
    return chosenRep.playlist;
  }
  logFn("could not choose a playlist with options", options);
  return null;
};
var lastBandwidthSelector = function lastBandwidthSelector2() {
  var pixelRatio = this.useDevicePixelRatio ? window_1.devicePixelRatio || 1 : 1;
  return simpleSelector(this.playlists.master, this.systemBandwidth, parseInt(safeGetComputedStyle(this.tech_.el(), "width"), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), "height"), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
};
var movingAverageBandwidthSelector = function movingAverageBandwidthSelector2(decay) {
  var average = -1;
  var lastSystemBandwidth = -1;
  if (decay < 0 || decay > 1) {
    throw new Error("Moving average bandwidth decay must be between 0 and 1.");
  }
  return function() {
    var pixelRatio = this.useDevicePixelRatio ? window_1.devicePixelRatio || 1 : 1;
    if (average < 0) {
      average = this.systemBandwidth;
      lastSystemBandwidth = this.systemBandwidth;
    }
    if (this.systemBandwidth > 0 && this.systemBandwidth !== lastSystemBandwidth) {
      average = decay * this.systemBandwidth + (1 - decay) * average;
      lastSystemBandwidth = this.systemBandwidth;
    }
    return simpleSelector(this.playlists.master, average, parseInt(safeGetComputedStyle(this.tech_.el(), "width"), 10) * pixelRatio, parseInt(safeGetComputedStyle(this.tech_.el(), "height"), 10) * pixelRatio, this.limitRenditionByPlayerDimensions, this.masterPlaylistController_);
  };
};
var minRebufferMaxBandwidthSelector = function minRebufferMaxBandwidthSelector2(settings) {
  var master = settings.master, currentTime = settings.currentTime, bandwidth2 = settings.bandwidth, duration5 = settings.duration, segmentDuration = settings.segmentDuration, timeUntilRebuffer3 = settings.timeUntilRebuffer, currentTimeline = settings.currentTimeline, syncController = settings.syncController;
  var compatiblePlaylists = master.playlists.filter(function(playlist) {
    return !Playlist.isIncompatible(playlist);
  });
  var enabledPlaylists = compatiblePlaylists.filter(Playlist.isEnabled);
  if (!enabledPlaylists.length) {
    enabledPlaylists = compatiblePlaylists.filter(function(playlist) {
      return !Playlist.isDisabled(playlist);
    });
  }
  var bandwidthPlaylists = enabledPlaylists.filter(Playlist.hasAttribute.bind(null, "BANDWIDTH"));
  var rebufferingEstimates = bandwidthPlaylists.map(function(playlist) {
    var syncPoint = syncController.getSyncPoint(playlist, duration5, currentTimeline, currentTime);
    var numRequests = syncPoint ? 1 : 2;
    var requestTimeEstimate = Playlist.estimateSegmentRequestTime(segmentDuration, bandwidth2, playlist);
    var rebufferingImpact = requestTimeEstimate * numRequests - timeUntilRebuffer3;
    return {
      playlist,
      rebufferingImpact
    };
  });
  var noRebufferingPlaylists = rebufferingEstimates.filter(function(estimate) {
    return estimate.rebufferingImpact <= 0;
  });
  stableSort(noRebufferingPlaylists, function(a, b) {
    return comparePlaylistBandwidth(b.playlist, a.playlist);
  });
  if (noRebufferingPlaylists.length) {
    return noRebufferingPlaylists[0];
  }
  stableSort(rebufferingEstimates, function(a, b) {
    return a.rebufferingImpact - b.rebufferingImpact;
  });
  return rebufferingEstimates[0] || null;
};
var lowestBitrateCompatibleVariantSelector = function lowestBitrateCompatibleVariantSelector2() {
  var _this = this;
  var playlists = this.playlists.master.playlists.filter(Playlist.isEnabled);
  stableSort(playlists, function(a, b) {
    return comparePlaylistBandwidth(a, b);
  });
  var playlistsWithVideo = playlists.filter(function(playlist) {
    return !!codecsForPlaylist(_this.playlists.master, playlist).video;
  });
  return playlistsWithVideo[0] || null;
};
var concatSegments = function concatSegments2(segmentObj) {
  var offset2 = 0;
  var tempBuffer;
  if (segmentObj.bytes) {
    tempBuffer = new Uint8Array(segmentObj.bytes);
    segmentObj.segments.forEach(function(segment) {
      tempBuffer.set(segment, offset2);
      offset2 += segment.byteLength;
    });
  }
  return tempBuffer;
};
var createCaptionsTrackIfNotExists = function createCaptionsTrackIfNotExists2(inbandTextTracks, tech, captionStream) {
  if (!inbandTextTracks[captionStream]) {
    tech.trigger({
      type: "usage",
      name: "vhs-608"
    });
    tech.trigger({
      type: "usage",
      name: "hls-608"
    });
    var instreamId = captionStream;
    if (/^cc708_/.test(captionStream)) {
      instreamId = "SERVICE" + captionStream.split("_")[1];
    }
    var track = tech.textTracks().getTrackById(instreamId);
    if (track) {
      inbandTextTracks[captionStream] = track;
    } else {
      var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
      var label = captionStream;
      var language = captionStream;
      var def = false;
      var captionService = captionServices[instreamId];
      if (captionService) {
        label = captionService.label;
        language = captionService.language;
        def = captionService["default"];
      }
      inbandTextTracks[captionStream] = tech.addRemoteTextTrack({
        kind: "captions",
        id: instreamId,
        "default": def,
        label,
        language
      }, false).track;
    }
  }
};
var addCaptionData = function addCaptionData2(_ref2) {
  var inbandTextTracks = _ref2.inbandTextTracks, captionArray = _ref2.captionArray, timestampOffset2 = _ref2.timestampOffset;
  if (!captionArray) {
    return;
  }
  var Cue = window_1.WebKitDataCue || window_1.VTTCue;
  captionArray.forEach(function(caption) {
    var track = caption.stream;
    inbandTextTracks[track].addCue(new Cue(caption.startTime + timestampOffset2, caption.endTime + timestampOffset2, caption.text));
  });
};
var deprecateOldCue = function deprecateOldCue2(cue) {
  Object.defineProperties(cue.frame, {
    id: {
      get: function get7() {
        videojs.log.warn("cue.frame.id is deprecated. Use cue.value.key instead.");
        return cue.value.key;
      }
    },
    value: {
      get: function get7() {
        videojs.log.warn("cue.frame.value is deprecated. Use cue.value.data instead.");
        return cue.value.data;
      }
    },
    privateData: {
      get: function get7() {
        videojs.log.warn("cue.frame.privateData is deprecated. Use cue.value.data instead.");
        return cue.value.data;
      }
    }
  });
};
var addMetadata = function addMetadata2(_ref2) {
  var inbandTextTracks = _ref2.inbandTextTracks, metadataArray = _ref2.metadataArray, timestampOffset2 = _ref2.timestampOffset, videoDuration = _ref2.videoDuration;
  if (!metadataArray) {
    return;
  }
  var Cue = window_1.WebKitDataCue || window_1.VTTCue;
  var metadataTrack = inbandTextTracks.metadataTrack_;
  if (!metadataTrack) {
    return;
  }
  metadataArray.forEach(function(metadata) {
    var time = metadata.cueTime + timestampOffset2;
    if (typeof time !== "number" || window_1.isNaN(time) || time < 0 || !(time < Infinity)) {
      return;
    }
    metadata.frames.forEach(function(frame) {
      var cue = new Cue(time, time, frame.value || frame.url || frame.data || "");
      cue.frame = frame;
      cue.value = frame;
      deprecateOldCue(cue);
      metadataTrack.addCue(cue);
    });
  });
  if (!metadataTrack.cues || !metadataTrack.cues.length) {
    return;
  }
  var cues = metadataTrack.cues;
  var cuesArray = [];
  for (var i = 0; i < cues.length; i++) {
    if (cues[i]) {
      cuesArray.push(cues[i]);
    }
  }
  var cuesGroupedByStartTime = cuesArray.reduce(function(obj, cue) {
    var timeSlot = obj[cue.startTime] || [];
    timeSlot.push(cue);
    obj[cue.startTime] = timeSlot;
    return obj;
  }, {});
  var sortedStartTimes = Object.keys(cuesGroupedByStartTime).sort(function(a, b) {
    return Number(a) - Number(b);
  });
  sortedStartTimes.forEach(function(startTime, idx) {
    var cueGroup = cuesGroupedByStartTime[startTime];
    var nextTime = Number(sortedStartTimes[idx + 1]) || videoDuration;
    cueGroup.forEach(function(cue) {
      cue.endTime = nextTime;
    });
  });
};
var createMetadataTrackIfNotExists = function createMetadataTrackIfNotExists2(inbandTextTracks, dispatchType, tech) {
  if (inbandTextTracks.metadataTrack_) {
    return;
  }
  inbandTextTracks.metadataTrack_ = tech.addRemoteTextTrack({
    kind: "metadata",
    label: "Timed Metadata"
  }, false).track;
  inbandTextTracks.metadataTrack_.inBandMetadataTrackDispatchType = dispatchType;
};
var removeCuesFromTrack = function removeCuesFromTrack2(start2, end3, track) {
  var i;
  var cue;
  if (!track) {
    return;
  }
  if (!track.cues) {
    return;
  }
  i = track.cues.length;
  while (i--) {
    cue = track.cues[i];
    if (cue.startTime >= start2 && cue.endTime <= end3) {
      track.removeCue(cue);
    }
  }
};
var removeDuplicateCuesFromTrack = function removeDuplicateCuesFromTrack2(track) {
  var cues = track.cues;
  if (!cues) {
    return;
  }
  for (var i = 0; i < cues.length; i++) {
    var duplicates = [];
    var occurrences = 0;
    for (var j = 0; j < cues.length; j++) {
      if (cues[i].startTime === cues[j].startTime && cues[i].endTime === cues[j].endTime && cues[i].text === cues[j].text) {
        occurrences++;
        if (occurrences > 1) {
          duplicates.push(cues[j]);
        }
      }
    }
    if (duplicates.length) {
      duplicates.forEach(function(dupe) {
        return track.removeCue(dupe);
      });
    }
  }
};
var gopsSafeToAlignWith = function gopsSafeToAlignWith2(buffer, currentTime, mapping) {
  if (typeof currentTime === "undefined" || currentTime === null || !buffer.length) {
    return [];
  }
  var currentTimePts = Math.ceil((currentTime - mapping + 3) * clock.ONE_SECOND_IN_TS);
  var i;
  for (i = 0; i < buffer.length; i++) {
    if (buffer[i].pts > currentTimePts) {
      break;
    }
  }
  return buffer.slice(i);
};
var updateGopBuffer = function updateGopBuffer2(buffer, gops, replace3) {
  if (!gops.length) {
    return buffer;
  }
  if (replace3) {
    return gops.slice();
  }
  var start2 = gops[0].pts;
  var i = 0;
  for (i; i < buffer.length; i++) {
    if (buffer[i].pts >= start2) {
      break;
    }
  }
  return buffer.slice(0, i).concat(gops);
};
var removeGopBuffer = function removeGopBuffer2(buffer, start2, end3, mapping) {
  var startPts = Math.ceil((start2 - mapping) * clock.ONE_SECOND_IN_TS);
  var endPts = Math.ceil((end3 - mapping) * clock.ONE_SECOND_IN_TS);
  var updatedBuffer = buffer.slice();
  var i = buffer.length;
  while (i--) {
    if (buffer[i].pts <= endPts) {
      break;
    }
  }
  if (i === -1) {
    return updatedBuffer;
  }
  var j = i + 1;
  while (j--) {
    if (buffer[j].pts <= startPts) {
      break;
    }
  }
  j = Math.max(j, 0);
  updatedBuffer.splice(j, i - j + 1);
  return updatedBuffer;
};
var shallowEqual = function shallowEqual2(a, b) {
  if (!a && !b || !a && b || a && !b) {
    return false;
  }
  if (a === b) {
    return true;
  }
  var akeys = Object.keys(a).sort();
  var bkeys = Object.keys(b).sort();
  if (akeys.length !== bkeys.length) {
    return false;
  }
  for (var i = 0; i < akeys.length; i++) {
    var key = akeys[i];
    if (key !== bkeys[i]) {
      return false;
    }
    if (a[key] !== b[key]) {
      return false;
    }
  }
  return true;
};
var QUOTA_EXCEEDED_ERR = 22;
var getSyncSegmentCandidate = function getSyncSegmentCandidate2(currentTimeline, segments, targetTime) {
  segments = segments || [];
  var timelineSegments = [];
  var time = 0;
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (currentTimeline === segment.timeline) {
      timelineSegments.push(i);
      time += segment.duration;
      if (time > targetTime) {
        return i;
      }
    }
  }
  if (timelineSegments.length === 0) {
    return 0;
  }
  return timelineSegments[timelineSegments.length - 1];
};
var MIN_BACK_BUFFER = 1;
var CHECK_BUFFER_DELAY = 500;
var finite = function finite2(num) {
  return typeof num === "number" && isFinite(num);
};
var MIN_SEGMENT_DURATION_TO_SAVE_STATS = 1 / 60;
var illegalMediaSwitch = function illegalMediaSwitch2(loaderType, startingMedia, trackInfo) {
  if (loaderType !== "main" || !startingMedia || !trackInfo) {
    return null;
  }
  if (!trackInfo.hasAudio && !trackInfo.hasVideo) {
    return "Neither audio nor video found in segment.";
  }
  if (startingMedia.hasVideo && !trackInfo.hasVideo) {
    return "Only audio found in segment when we expected video. We can't switch to audio only from a stream that had video. To get rid of this message, please add codec information to the manifest.";
  }
  if (!startingMedia.hasVideo && trackInfo.hasVideo) {
    return "Video found in segment when we expected only audio. We can't switch to a stream with video from an audio only stream. To get rid of this message, please add codec information to the manifest.";
  }
  return null;
};
var safeBackBufferTrimTime = function safeBackBufferTrimTime2(seekable3, currentTime, targetDuration) {
  var trimTime = currentTime - Config.BACK_BUFFER_LENGTH;
  if (seekable3.length) {
    trimTime = Math.max(trimTime, seekable3.start(0));
  }
  var maxTrimTime = currentTime - targetDuration;
  return Math.min(maxTrimTime, trimTime);
};
var segmentInfoString = function segmentInfoString2(segmentInfo) {
  var startOfSegment = segmentInfo.startOfSegment, duration5 = segmentInfo.duration, segment = segmentInfo.segment, part = segmentInfo.part, _segmentInfo$playlist = segmentInfo.playlist, seq = _segmentInfo$playlist.mediaSequence, id2 = _segmentInfo$playlist.id, _segmentInfo$playlist2 = _segmentInfo$playlist.segments, segments = _segmentInfo$playlist2 === void 0 ? [] : _segmentInfo$playlist2, index = segmentInfo.mediaIndex, partIndex = segmentInfo.partIndex, timeline = segmentInfo.timeline;
  var segmentLen = segments.length - 1;
  var selection = "mediaIndex/partIndex increment";
  if (segmentInfo.getMediaInfoForTime) {
    selection = "getMediaInfoForTime (" + segmentInfo.getMediaInfoForTime + ")";
  } else if (segmentInfo.isSyncRequest) {
    selection = "getSyncSegmentCandidate (isSyncRequest)";
  }
  if (segmentInfo.independent) {
    selection += " with independent " + segmentInfo.independent;
  }
  var hasPartIndex = typeof partIndex === "number";
  var name = segmentInfo.segment.uri ? "segment" : "pre-segment";
  var zeroBasedPartCount = hasPartIndex ? getKnownPartCount({
    preloadSegment: segment
  }) - 1 : 0;
  return name + " [" + (seq + index) + "/" + (seq + segmentLen) + "]" + (hasPartIndex ? " part [" + partIndex + "/" + zeroBasedPartCount + "]" : "") + (" segment start/end [" + segment.start + " => " + segment.end + "]") + (hasPartIndex ? " part start/end [" + part.start + " => " + part.end + "]" : "") + (" startOfSegment [" + startOfSegment + "]") + (" duration [" + duration5 + "]") + (" timeline [" + timeline + "]") + (" selected by [" + selection + "]") + (" playlist [" + id2 + "]");
};
var timingInfoPropertyForMedia = function timingInfoPropertyForMedia2(mediaType) {
  return mediaType + "TimingInfo";
};
var timestampOffsetForSegment = function timestampOffsetForSegment2(_ref2) {
  var segmentTimeline = _ref2.segmentTimeline, currentTimeline = _ref2.currentTimeline, startOfSegment = _ref2.startOfSegment, buffered = _ref2.buffered, overrideCheck = _ref2.overrideCheck;
  if (!overrideCheck && segmentTimeline === currentTimeline) {
    return null;
  }
  if (segmentTimeline < currentTimeline) {
    return startOfSegment;
  }
  return buffered.length ? buffered.end(buffered.length - 1) : startOfSegment;
};
var shouldWaitForTimelineChange = function shouldWaitForTimelineChange2(_ref2) {
  var timelineChangeController = _ref2.timelineChangeController, currentTimeline = _ref2.currentTimeline, segmentTimeline = _ref2.segmentTimeline, loaderType = _ref2.loaderType, audioDisabled = _ref2.audioDisabled;
  if (currentTimeline === segmentTimeline) {
    return false;
  }
  if (loaderType === "audio") {
    var lastMainTimelineChange = timelineChangeController.lastTimelineChange({
      type: "main"
    });
    return !lastMainTimelineChange || lastMainTimelineChange.to !== segmentTimeline;
  }
  if (loaderType === "main" && audioDisabled) {
    var pendingAudioTimelineChange = timelineChangeController.pendingTimelineChange({
      type: "audio"
    });
    if (pendingAudioTimelineChange && pendingAudioTimelineChange.to === segmentTimeline) {
      return false;
    }
    return true;
  }
  return false;
};
var mediaDuration = function mediaDuration2(timingInfos) {
  var maxDuration = 0;
  ["video", "audio"].forEach(function(type2) {
    var typeTimingInfo = timingInfos[type2 + "TimingInfo"];
    if (!typeTimingInfo) {
      return;
    }
    var start2 = typeTimingInfo.start, end3 = typeTimingInfo.end;
    var duration5;
    if (typeof start2 === "bigint" || typeof end3 === "bigint") {
      duration5 = window_1.BigInt(end3) - window_1.BigInt(start2);
    } else if (typeof start2 === "number" && typeof end3 === "number") {
      duration5 = end3 - start2;
    }
    if (typeof duration5 !== "undefined" && duration5 > maxDuration) {
      maxDuration = duration5;
    }
  });
  if (typeof maxDuration === "bigint" && maxDuration < Number.MAX_SAFE_INTEGER) {
    maxDuration = Number(maxDuration);
  }
  return maxDuration;
};
var segmentTooLong = function segmentTooLong2(_ref3) {
  var segmentDuration = _ref3.segmentDuration, maxDuration = _ref3.maxDuration;
  if (!segmentDuration) {
    return false;
  }
  return Math.round(segmentDuration) > maxDuration + TIME_FUDGE_FACTOR;
};
var getTroublesomeSegmentDurationMessage = function getTroublesomeSegmentDurationMessage2(segmentInfo, sourceType) {
  if (sourceType !== "hls") {
    return null;
  }
  var segmentDuration = mediaDuration({
    audioTimingInfo: segmentInfo.audioTimingInfo,
    videoTimingInfo: segmentInfo.videoTimingInfo
  });
  if (!segmentDuration) {
    return null;
  }
  var targetDuration = segmentInfo.playlist.targetDuration;
  var isSegmentWayTooLong = segmentTooLong({
    segmentDuration,
    maxDuration: targetDuration * 2
  });
  var isSegmentSlightlyTooLong = segmentTooLong({
    segmentDuration,
    maxDuration: targetDuration
  });
  var segmentTooLongMessage = "Segment with index " + segmentInfo.mediaIndex + " " + ("from playlist " + segmentInfo.playlist.id + " ") + ("has a duration of " + segmentDuration + " ") + ("when the reported duration is " + segmentInfo.duration + " ") + ("and the target duration is " + targetDuration + ". ") + "For HLS content, a duration in excess of the target duration may result in playback issues. See the HLS specification section on EXT-X-TARGETDURATION for more details: https://tools.ietf.org/html/draft-pantos-http-live-streaming-23#section-4.3.3.1";
  if (isSegmentWayTooLong || isSegmentSlightlyTooLong) {
    return {
      severity: isSegmentWayTooLong ? "warn" : "info",
      message: segmentTooLongMessage
    };
  }
  return null;
};
var SegmentLoader = /* @__PURE__ */ function(_videojs$EventTarget) {
  _inheritsLoose(SegmentLoader2, _videojs$EventTarget);
  function SegmentLoader2(settings, options) {
    var _this;
    _this = _videojs$EventTarget.call(this) || this;
    if (!settings) {
      throw new TypeError("Initialization settings are required");
    }
    if (typeof settings.currentTime !== "function") {
      throw new TypeError("No currentTime getter specified");
    }
    if (!settings.mediaSource) {
      throw new TypeError("No MediaSource specified");
    }
    _this.bandwidth = settings.bandwidth;
    _this.throughput = {
      rate: 0,
      count: 0
    };
    _this.roundTrip = NaN;
    _this.resetStats_();
    _this.mediaIndex = null;
    _this.partIndex = null;
    _this.hasPlayed_ = settings.hasPlayed;
    _this.currentTime_ = settings.currentTime;
    _this.seekable_ = settings.seekable;
    _this.seeking_ = settings.seeking;
    _this.duration_ = settings.duration;
    _this.mediaSource_ = settings.mediaSource;
    _this.vhs_ = settings.vhs;
    _this.loaderType_ = settings.loaderType;
    _this.currentMediaInfo_ = void 0;
    _this.startingMediaInfo_ = void 0;
    _this.segmentMetadataTrack_ = settings.segmentMetadataTrack;
    _this.goalBufferLength_ = settings.goalBufferLength;
    _this.sourceType_ = settings.sourceType;
    _this.sourceUpdater_ = settings.sourceUpdater;
    _this.inbandTextTracks_ = settings.inbandTextTracks;
    _this.state_ = "INIT";
    _this.timelineChangeController_ = settings.timelineChangeController;
    _this.shouldSaveSegmentTimingInfo_ = true;
    _this.parse708captions_ = settings.parse708captions;
    _this.useDtsForTimestampOffset_ = settings.useDtsForTimestampOffset;
    _this.captionServices_ = settings.captionServices;
    _this.experimentalExactManifestTimings = settings.experimentalExactManifestTimings;
    _this.checkBufferTimeout_ = null;
    _this.error_ = void 0;
    _this.currentTimeline_ = -1;
    _this.pendingSegment_ = null;
    _this.xhrOptions_ = null;
    _this.pendingSegments_ = [];
    _this.audioDisabled_ = false;
    _this.isPendingTimestampOffset_ = false;
    _this.gopBuffer_ = [];
    _this.timeMapping_ = 0;
    _this.safeAppend_ = videojs.browser.IE_VERSION >= 11;
    _this.appendInitSegment_ = {
      audio: true,
      video: true
    };
    _this.playlistOfLastInitSegment_ = {
      audio: null,
      video: null
    };
    _this.callQueue_ = [];
    _this.loadQueue_ = [];
    _this.metadataQueue_ = {
      id3: [],
      caption: []
    };
    _this.waitingOnRemove_ = false;
    _this.quotaExceededErrorRetryTimeout_ = null;
    _this.activeInitSegmentId_ = null;
    _this.initSegments_ = {};
    _this.cacheEncryptionKeys_ = settings.cacheEncryptionKeys;
    _this.keyCache_ = {};
    _this.decrypter_ = settings.decrypter;
    _this.syncController_ = settings.syncController;
    _this.syncPoint_ = {
      segmentIndex: 0,
      time: 0
    };
    _this.transmuxer_ = _this.createTransmuxer_();
    _this.triggerSyncInfoUpdate_ = function() {
      return _this.trigger("syncinfoupdate");
    };
    _this.syncController_.on("syncinfoupdate", _this.triggerSyncInfoUpdate_);
    _this.mediaSource_.addEventListener("sourceopen", function() {
      if (!_this.isEndOfStream_()) {
        _this.ended_ = false;
      }
    });
    _this.fetchAtBuffer_ = false;
    _this.logger_ = logger("SegmentLoader[" + _this.loaderType_ + "]");
    Object.defineProperty(_assertThisInitialized(_this), "state", {
      get: function get7() {
        return this.state_;
      },
      set: function set4(newState) {
        if (newState !== this.state_) {
          this.logger_(this.state_ + " -> " + newState);
          this.state_ = newState;
          this.trigger("statechange");
        }
      }
    });
    _this.sourceUpdater_.on("ready", function() {
      if (_this.hasEnoughInfoToAppend_()) {
        _this.processCallQueue_();
      }
    });
    if (_this.loaderType_ === "main") {
      _this.timelineChangeController_.on("pendingtimelinechange", function() {
        if (_this.hasEnoughInfoToAppend_()) {
          _this.processCallQueue_();
        }
      });
    }
    if (_this.loaderType_ === "audio") {
      _this.timelineChangeController_.on("timelinechange", function() {
        if (_this.hasEnoughInfoToLoad_()) {
          _this.processLoadQueue_();
        }
        if (_this.hasEnoughInfoToAppend_()) {
          _this.processCallQueue_();
        }
      });
    }
    return _this;
  }
  var _proto = SegmentLoader2.prototype;
  _proto.createTransmuxer_ = function createTransmuxer_() {
    return segmentTransmuxer.createTransmuxer({
      remux: false,
      alignGopsAtEnd: this.safeAppend_,
      keepOriginalTimestamps: true,
      parse708captions: this.parse708captions_,
      captionServices: this.captionServices_
    });
  };
  _proto.resetStats_ = function resetStats_() {
    this.mediaBytesTransferred = 0;
    this.mediaRequests = 0;
    this.mediaRequestsAborted = 0;
    this.mediaRequestsTimedout = 0;
    this.mediaRequestsErrored = 0;
    this.mediaTransferDuration = 0;
    this.mediaSecondsLoaded = 0;
    this.mediaAppends = 0;
  };
  _proto.dispose = function dispose() {
    this.trigger("dispose");
    this.state = "DISPOSED";
    this.pause();
    this.abort_();
    if (this.transmuxer_) {
      this.transmuxer_.terminate();
    }
    this.resetStats_();
    if (this.checkBufferTimeout_) {
      window_1.clearTimeout(this.checkBufferTimeout_);
    }
    if (this.syncController_ && this.triggerSyncInfoUpdate_) {
      this.syncController_.off("syncinfoupdate", this.triggerSyncInfoUpdate_);
    }
    this.off();
  };
  _proto.setAudio = function setAudio(enable) {
    this.audioDisabled_ = !enable;
    if (enable) {
      this.appendInitSegment_.audio = true;
    } else {
      this.sourceUpdater_.removeAudio(0, this.duration_());
    }
  };
  _proto.abort = function abort2() {
    if (this.state !== "WAITING") {
      if (this.pendingSegment_) {
        this.pendingSegment_ = null;
      }
      return;
    }
    this.abort_();
    this.state = "READY";
    if (!this.paused()) {
      this.monitorBuffer_();
    }
  };
  _proto.abort_ = function abort_() {
    if (this.pendingSegment_ && this.pendingSegment_.abortRequests) {
      this.pendingSegment_.abortRequests();
    }
    this.pendingSegment_ = null;
    this.callQueue_ = [];
    this.loadQueue_ = [];
    this.metadataQueue_.id3 = [];
    this.metadataQueue_.caption = [];
    this.timelineChangeController_.clearPendingTimelineChange(this.loaderType_);
    this.waitingOnRemove_ = false;
    window_1.clearTimeout(this.quotaExceededErrorRetryTimeout_);
    this.quotaExceededErrorRetryTimeout_ = null;
  };
  _proto.checkForAbort_ = function checkForAbort_(requestId) {
    if (this.state === "APPENDING" && !this.pendingSegment_) {
      this.state = "READY";
      return true;
    }
    if (!this.pendingSegment_ || this.pendingSegment_.requestId !== requestId) {
      return true;
    }
    return false;
  };
  _proto.error = function error2(_error) {
    if (typeof _error !== "undefined") {
      this.logger_("error occurred:", _error);
      this.error_ = _error;
    }
    this.pendingSegment_ = null;
    return this.error_;
  };
  _proto.endOfStream = function endOfStream2() {
    this.ended_ = true;
    if (this.transmuxer_) {
      segmentTransmuxer.reset(this.transmuxer_);
    }
    this.gopBuffer_.length = 0;
    this.pause();
    this.trigger("ended");
  };
  _proto.buffered_ = function buffered_() {
    var trackInfo = this.getMediaInfo_();
    if (!this.sourceUpdater_ || !trackInfo) {
      return videojs.createTimeRanges();
    }
    if (this.loaderType_ === "main") {
      var hasAudio = trackInfo.hasAudio, hasVideo = trackInfo.hasVideo, isMuxed3 = trackInfo.isMuxed;
      if (hasVideo && hasAudio && !this.audioDisabled_ && !isMuxed3) {
        return this.sourceUpdater_.buffered();
      }
      if (hasVideo) {
        return this.sourceUpdater_.videoBuffered();
      }
    }
    return this.sourceUpdater_.audioBuffered();
  };
  _proto.initSegmentForMap = function initSegmentForMap(map, set4) {
    if (set4 === void 0) {
      set4 = false;
    }
    if (!map) {
      return null;
    }
    var id2 = initSegmentId(map);
    var storedMap = this.initSegments_[id2];
    if (set4 && !storedMap && map.bytes) {
      this.initSegments_[id2] = storedMap = {
        resolvedUri: map.resolvedUri,
        byterange: map.byterange,
        bytes: map.bytes,
        tracks: map.tracks,
        timescales: map.timescales
      };
    }
    return storedMap || map;
  };
  _proto.segmentKey = function segmentKey(key, set4) {
    if (set4 === void 0) {
      set4 = false;
    }
    if (!key) {
      return null;
    }
    var id2 = segmentKeyId(key);
    var storedKey = this.keyCache_[id2];
    if (this.cacheEncryptionKeys_ && set4 && !storedKey && key.bytes) {
      this.keyCache_[id2] = storedKey = {
        resolvedUri: key.resolvedUri,
        bytes: key.bytes
      };
    }
    var result2 = {
      resolvedUri: (storedKey || key).resolvedUri
    };
    if (storedKey) {
      result2.bytes = storedKey.bytes;
    }
    return result2;
  };
  _proto.couldBeginLoading_ = function couldBeginLoading_() {
    return this.playlist_ && !this.paused();
  };
  _proto.load = function load() {
    this.monitorBuffer_();
    if (!this.playlist_) {
      return;
    }
    if (this.state === "INIT" && this.couldBeginLoading_()) {
      return this.init_();
    }
    if (!this.couldBeginLoading_() || this.state !== "READY" && this.state !== "INIT") {
      return;
    }
    this.state = "READY";
  };
  _proto.init_ = function init_() {
    this.state = "READY";
    this.resetEverything();
    return this.monitorBuffer_();
  };
  _proto.playlist = function playlist(newPlaylist, options) {
    if (options === void 0) {
      options = {};
    }
    if (!newPlaylist) {
      return;
    }
    var oldPlaylist = this.playlist_;
    var segmentInfo = this.pendingSegment_;
    this.playlist_ = newPlaylist;
    this.xhrOptions_ = options;
    if (this.state === "INIT") {
      newPlaylist.syncInfo = {
        mediaSequence: newPlaylist.mediaSequence,
        time: 0
      };
      if (this.loaderType_ === "main") {
        this.syncController_.setDateTimeMappingForStart(newPlaylist);
      }
    }
    var oldId = null;
    if (oldPlaylist) {
      if (oldPlaylist.id) {
        oldId = oldPlaylist.id;
      } else if (oldPlaylist.uri) {
        oldId = oldPlaylist.uri;
      }
    }
    this.logger_("playlist update [" + oldId + " => " + (newPlaylist.id || newPlaylist.uri) + "]");
    this.trigger("syncinfoupdate");
    if (this.state === "INIT" && this.couldBeginLoading_()) {
      return this.init_();
    }
    if (!oldPlaylist || oldPlaylist.uri !== newPlaylist.uri) {
      if (this.mediaIndex !== null) {
        if (!newPlaylist.endList) {
          this.resetLoader();
        } else {
          this.resyncLoader();
        }
      }
      this.currentMediaInfo_ = void 0;
      this.trigger("playlistupdate");
      return;
    }
    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
    this.logger_("live window shift [" + mediaSequenceDiff + "]");
    if (this.mediaIndex !== null) {
      this.mediaIndex -= mediaSequenceDiff;
      if (this.mediaIndex < 0) {
        this.mediaIndex = null;
        this.partIndex = null;
      } else {
        var segment = this.playlist_.segments[this.mediaIndex];
        if (this.partIndex && (!segment.parts || !segment.parts.length || !segment.parts[this.partIndex])) {
          var mediaIndex = this.mediaIndex;
          this.logger_("currently processing part (index " + this.partIndex + ") no longer exists.");
          this.resetLoader();
          this.mediaIndex = mediaIndex;
        }
      }
    }
    if (segmentInfo) {
      segmentInfo.mediaIndex -= mediaSequenceDiff;
      if (segmentInfo.mediaIndex < 0) {
        segmentInfo.mediaIndex = null;
        segmentInfo.partIndex = null;
      } else {
        if (segmentInfo.mediaIndex >= 0) {
          segmentInfo.segment = newPlaylist.segments[segmentInfo.mediaIndex];
        }
        if (segmentInfo.partIndex >= 0 && segmentInfo.segment.parts) {
          segmentInfo.part = segmentInfo.segment.parts[segmentInfo.partIndex];
        }
      }
    }
    this.syncController_.saveExpiredSegmentInfo(oldPlaylist, newPlaylist);
  };
  _proto.pause = function pause() {
    if (this.checkBufferTimeout_) {
      window_1.clearTimeout(this.checkBufferTimeout_);
      this.checkBufferTimeout_ = null;
    }
  };
  _proto.paused = function paused() {
    return this.checkBufferTimeout_ === null;
  };
  _proto.resetEverything = function resetEverything(done) {
    this.ended_ = false;
    this.activeInitSegmentId_ = null;
    this.appendInitSegment_ = {
      audio: true,
      video: true
    };
    this.resetLoader();
    this.remove(0, Infinity, done);
    if (this.transmuxer_) {
      this.transmuxer_.postMessage({
        action: "clearAllMp4Captions"
      });
      this.transmuxer_.postMessage({
        action: "reset"
      });
    }
  };
  _proto.resetLoader = function resetLoader() {
    this.fetchAtBuffer_ = false;
    this.resyncLoader();
  };
  _proto.resyncLoader = function resyncLoader() {
    if (this.transmuxer_) {
      segmentTransmuxer.reset(this.transmuxer_);
    }
    this.mediaIndex = null;
    this.partIndex = null;
    this.syncPoint_ = null;
    this.isPendingTimestampOffset_ = false;
    this.callQueue_ = [];
    this.loadQueue_ = [];
    this.metadataQueue_.id3 = [];
    this.metadataQueue_.caption = [];
    this.abort();
    if (this.transmuxer_) {
      this.transmuxer_.postMessage({
        action: "clearParsedMp4Captions"
      });
    }
  };
  _proto.remove = function remove3(start2, end3, done, force) {
    if (done === void 0) {
      done = function done2() {
      };
    }
    if (force === void 0) {
      force = false;
    }
    if (end3 === Infinity) {
      end3 = this.duration_();
    }
    if (end3 <= start2) {
      this.logger_("skipping remove because end ${end} is <= start ${start}");
      return;
    }
    if (!this.sourceUpdater_ || !this.getMediaInfo_()) {
      this.logger_("skipping remove because no source updater or starting media info");
      return;
    }
    var removesRemaining = 1;
    var removeFinished = function removeFinished2() {
      removesRemaining--;
      if (removesRemaining === 0) {
        done();
      }
    };
    if (force || !this.audioDisabled_) {
      removesRemaining++;
      this.sourceUpdater_.removeAudio(start2, end3, removeFinished);
    }
    if (force || this.loaderType_ === "main") {
      this.gopBuffer_ = removeGopBuffer(this.gopBuffer_, start2, end3, this.timeMapping_);
      removesRemaining++;
      this.sourceUpdater_.removeVideo(start2, end3, removeFinished);
    }
    for (var track in this.inbandTextTracks_) {
      removeCuesFromTrack(start2, end3, this.inbandTextTracks_[track]);
    }
    removeCuesFromTrack(start2, end3, this.segmentMetadataTrack_);
    removeFinished();
  };
  _proto.monitorBuffer_ = function monitorBuffer_() {
    if (this.checkBufferTimeout_) {
      window_1.clearTimeout(this.checkBufferTimeout_);
    }
    this.checkBufferTimeout_ = window_1.setTimeout(this.monitorBufferTick_.bind(this), 1);
  };
  _proto.monitorBufferTick_ = function monitorBufferTick_() {
    if (this.state === "READY") {
      this.fillBuffer_();
    }
    if (this.checkBufferTimeout_) {
      window_1.clearTimeout(this.checkBufferTimeout_);
    }
    this.checkBufferTimeout_ = window_1.setTimeout(this.monitorBufferTick_.bind(this), CHECK_BUFFER_DELAY);
  };
  _proto.fillBuffer_ = function fillBuffer_() {
    if (this.sourceUpdater_.updating()) {
      return;
    }
    var segmentInfo = this.chooseNextRequest_();
    if (!segmentInfo) {
      return;
    }
    if (typeof segmentInfo.timestampOffset === "number") {
      this.isPendingTimestampOffset_ = false;
      this.timelineChangeController_.pendingTimelineChange({
        type: this.loaderType_,
        from: this.currentTimeline_,
        to: segmentInfo.timeline
      });
    }
    this.loadSegment_(segmentInfo);
  };
  _proto.isEndOfStream_ = function isEndOfStream_(mediaIndex, playlist, partIndex) {
    if (mediaIndex === void 0) {
      mediaIndex = this.mediaIndex;
    }
    if (playlist === void 0) {
      playlist = this.playlist_;
    }
    if (partIndex === void 0) {
      partIndex = this.partIndex;
    }
    if (!playlist || !this.mediaSource_) {
      return false;
    }
    var segment = typeof mediaIndex === "number" && playlist.segments[mediaIndex];
    var appendedLastSegment = mediaIndex + 1 === playlist.segments.length;
    var appendedLastPart = !segment || !segment.parts || partIndex + 1 === segment.parts.length;
    return playlist.endList && this.mediaSource_.readyState === "open" && appendedLastSegment && appendedLastPart;
  };
  _proto.chooseNextRequest_ = function chooseNextRequest_() {
    var buffered = this.buffered_();
    var bufferedEnd = lastBufferedEnd(buffered) || 0;
    var bufferedTime = timeAheadOf(buffered, this.currentTime_());
    var preloaded = !this.hasPlayed_() && bufferedTime >= 1;
    var haveEnoughBuffer = bufferedTime >= this.goalBufferLength_();
    var segments = this.playlist_.segments;
    if (!segments.length || preloaded || haveEnoughBuffer) {
      return null;
    }
    this.syncPoint_ = this.syncPoint_ || this.syncController_.getSyncPoint(this.playlist_, this.duration_(), this.currentTimeline_, this.currentTime_());
    var next = {
      partIndex: null,
      mediaIndex: null,
      startOfSegment: null,
      playlist: this.playlist_,
      isSyncRequest: Boolean(!this.syncPoint_)
    };
    if (next.isSyncRequest) {
      next.mediaIndex = getSyncSegmentCandidate(this.currentTimeline_, segments, bufferedEnd);
    } else if (this.mediaIndex !== null) {
      var segment = segments[this.mediaIndex];
      var partIndex = typeof this.partIndex === "number" ? this.partIndex : -1;
      next.startOfSegment = segment.end ? segment.end : bufferedEnd;
      if (segment.parts && segment.parts[partIndex + 1]) {
        next.mediaIndex = this.mediaIndex;
        next.partIndex = partIndex + 1;
      } else {
        next.mediaIndex = this.mediaIndex + 1;
      }
    } else {
      var _Playlist$getMediaInf = Playlist.getMediaInfoForTime({
        experimentalExactManifestTimings: this.experimentalExactManifestTimings,
        playlist: this.playlist_,
        currentTime: this.fetchAtBuffer_ ? bufferedEnd : this.currentTime_(),
        startingPartIndex: this.syncPoint_.partIndex,
        startingSegmentIndex: this.syncPoint_.segmentIndex,
        startTime: this.syncPoint_.time
      }), segmentIndex = _Playlist$getMediaInf.segmentIndex, startTime = _Playlist$getMediaInf.startTime, _partIndex = _Playlist$getMediaInf.partIndex;
      next.getMediaInfoForTime = this.fetchAtBuffer_ ? "bufferedEnd " + bufferedEnd : "currentTime " + this.currentTime_();
      next.mediaIndex = segmentIndex;
      next.startOfSegment = startTime;
      next.partIndex = _partIndex;
    }
    var nextSegment = segments[next.mediaIndex];
    var nextPart = nextSegment && typeof next.partIndex === "number" && nextSegment.parts && nextSegment.parts[next.partIndex];
    if (!nextSegment || typeof next.partIndex === "number" && !nextPart) {
      return null;
    }
    if (typeof next.partIndex !== "number" && nextSegment.parts) {
      next.partIndex = 0;
      nextPart = nextSegment.parts[0];
    }
    if (!bufferedTime && nextPart && !nextPart.independent) {
      if (next.partIndex === 0) {
        var lastSegment = segments[next.mediaIndex - 1];
        var lastSegmentLastPart = lastSegment.parts && lastSegment.parts.length && lastSegment.parts[lastSegment.parts.length - 1];
        if (lastSegmentLastPart && lastSegmentLastPart.independent) {
          next.mediaIndex -= 1;
          next.partIndex = lastSegment.parts.length - 1;
          next.independent = "previous segment";
        }
      } else if (nextSegment.parts[next.partIndex - 1].independent) {
        next.partIndex -= 1;
        next.independent = "previous part";
      }
    }
    var ended = this.mediaSource_ && this.mediaSource_.readyState === "ended";
    if (next.mediaIndex >= segments.length - 1 && ended && !this.seeking_()) {
      return null;
    }
    return this.generateSegmentInfo_(next);
  };
  _proto.generateSegmentInfo_ = function generateSegmentInfo_(options) {
    var independent = options.independent, playlist = options.playlist, mediaIndex = options.mediaIndex, startOfSegment = options.startOfSegment, isSyncRequest = options.isSyncRequest, partIndex = options.partIndex, forceTimestampOffset = options.forceTimestampOffset, getMediaInfoForTime3 = options.getMediaInfoForTime;
    var segment = playlist.segments[mediaIndex];
    var part = typeof partIndex === "number" && segment.parts[partIndex];
    var segmentInfo = {
      requestId: "segment-loader-" + Math.random(),
      uri: part && part.resolvedUri || segment.resolvedUri,
      mediaIndex,
      partIndex: part ? partIndex : null,
      isSyncRequest,
      startOfSegment,
      playlist,
      bytes: null,
      encryptedBytes: null,
      timestampOffset: null,
      timeline: segment.timeline,
      duration: part && part.duration || segment.duration,
      segment,
      part,
      byteLength: 0,
      transmuxer: this.transmuxer_,
      getMediaInfoForTime: getMediaInfoForTime3,
      independent
    };
    var overrideCheck = typeof forceTimestampOffset !== "undefined" ? forceTimestampOffset : this.isPendingTimestampOffset_;
    segmentInfo.timestampOffset = this.timestampOffsetForSegment_({
      segmentTimeline: segment.timeline,
      currentTimeline: this.currentTimeline_,
      startOfSegment,
      buffered: this.buffered_(),
      overrideCheck
    });
    var audioBufferedEnd = lastBufferedEnd(this.sourceUpdater_.audioBuffered());
    if (typeof audioBufferedEnd === "number") {
      segmentInfo.audioAppendStart = audioBufferedEnd - this.sourceUpdater_.audioTimestampOffset();
    }
    if (this.sourceUpdater_.videoBuffered().length) {
      segmentInfo.gopsToAlignWith = gopsSafeToAlignWith(this.gopBuffer_, this.currentTime_() - this.sourceUpdater_.videoTimestampOffset(), this.timeMapping_);
    }
    return segmentInfo;
  };
  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_(options) {
    return timestampOffsetForSegment(options);
  };
  _proto.earlyAbortWhenNeeded_ = function earlyAbortWhenNeeded_(stats) {
    if (this.vhs_.tech_.paused() || !this.xhrOptions_.timeout || !this.playlist_.attributes.BANDWIDTH) {
      return;
    }
    if (Date.now() - (stats.firstBytesReceivedAt || Date.now()) < 1e3) {
      return;
    }
    var currentTime = this.currentTime_();
    var measuredBandwidth = stats.bandwidth;
    var segmentDuration = this.pendingSegment_.duration;
    var requestTimeRemaining = Playlist.estimateSegmentRequestTime(segmentDuration, measuredBandwidth, this.playlist_, stats.bytesReceived);
    var timeUntilRebuffer$1 = timeUntilRebuffer(this.buffered_(), currentTime, this.vhs_.tech_.playbackRate()) - 1;
    if (requestTimeRemaining <= timeUntilRebuffer$1) {
      return;
    }
    var switchCandidate = minRebufferMaxBandwidthSelector({
      master: this.vhs_.playlists.master,
      currentTime,
      bandwidth: measuredBandwidth,
      duration: this.duration_(),
      segmentDuration,
      timeUntilRebuffer: timeUntilRebuffer$1,
      currentTimeline: this.currentTimeline_,
      syncController: this.syncController_
    });
    if (!switchCandidate) {
      return;
    }
    var rebufferingImpact = requestTimeRemaining - timeUntilRebuffer$1;
    var timeSavedBySwitching = rebufferingImpact - switchCandidate.rebufferingImpact;
    var minimumTimeSaving = 0.5;
    if (timeUntilRebuffer$1 <= TIME_FUDGE_FACTOR) {
      minimumTimeSaving = 1;
    }
    if (!switchCandidate.playlist || switchCandidate.playlist.uri === this.playlist_.uri || timeSavedBySwitching < minimumTimeSaving) {
      return;
    }
    this.bandwidth = switchCandidate.playlist.attributes.BANDWIDTH * Config.BANDWIDTH_VARIANCE + 1;
    this.trigger("earlyabort");
  };
  _proto.handleAbort_ = function handleAbort_(segmentInfo) {
    this.logger_("Aborting " + segmentInfoString(segmentInfo));
    this.mediaRequestsAborted += 1;
  };
  _proto.handleProgress_ = function handleProgress_(event, simpleSegment) {
    this.earlyAbortWhenNeeded_(simpleSegment.stats);
    if (this.checkForAbort_(simpleSegment.requestId)) {
      return;
    }
    this.trigger("progress");
  };
  _proto.handleTrackInfo_ = function handleTrackInfo_(simpleSegment, trackInfo) {
    this.earlyAbortWhenNeeded_(simpleSegment.stats);
    if (this.checkForAbort_(simpleSegment.requestId)) {
      return;
    }
    if (this.checkForIllegalMediaSwitch(trackInfo)) {
      return;
    }
    trackInfo = trackInfo || {};
    if (!shallowEqual(this.currentMediaInfo_, trackInfo)) {
      this.appendInitSegment_ = {
        audio: true,
        video: true
      };
      this.startingMediaInfo_ = trackInfo;
      this.currentMediaInfo_ = trackInfo;
      this.logger_("trackinfo update", trackInfo);
      this.trigger("trackinfo");
    }
    if (this.checkForAbort_(simpleSegment.requestId)) {
      return;
    }
    this.pendingSegment_.trackInfo = trackInfo;
    if (this.hasEnoughInfoToAppend_()) {
      this.processCallQueue_();
    }
  };
  _proto.handleTimingInfo_ = function handleTimingInfo_(simpleSegment, mediaType, timeType, time) {
    this.earlyAbortWhenNeeded_(simpleSegment.stats);
    if (this.checkForAbort_(simpleSegment.requestId)) {
      return;
    }
    var segmentInfo = this.pendingSegment_;
    var timingInfoProperty = timingInfoPropertyForMedia(mediaType);
    segmentInfo[timingInfoProperty] = segmentInfo[timingInfoProperty] || {};
    segmentInfo[timingInfoProperty][timeType] = time;
    this.logger_("timinginfo: " + mediaType + " - " + timeType + " - " + time);
    if (this.hasEnoughInfoToAppend_()) {
      this.processCallQueue_();
    }
  };
  _proto.handleCaptions_ = function handleCaptions_(simpleSegment, captionData) {
    var _this2 = this;
    this.earlyAbortWhenNeeded_(simpleSegment.stats);
    if (this.checkForAbort_(simpleSegment.requestId)) {
      return;
    }
    if (captionData.length === 0) {
      this.logger_("SegmentLoader received no captions from a caption event");
      return;
    }
    var segmentInfo = this.pendingSegment_;
    if (!segmentInfo.hasAppendedData_) {
      this.metadataQueue_.caption.push(this.handleCaptions_.bind(this, simpleSegment, captionData));
      return;
    }
    var timestampOffset2 = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
    var captionTracks = {};
    captionData.forEach(function(caption) {
      captionTracks[caption.stream] = captionTracks[caption.stream] || {
        startTime: Infinity,
        captions: [],
        endTime: 0
      };
      var captionTrack = captionTracks[caption.stream];
      captionTrack.startTime = Math.min(captionTrack.startTime, caption.startTime + timestampOffset2);
      captionTrack.endTime = Math.max(captionTrack.endTime, caption.endTime + timestampOffset2);
      captionTrack.captions.push(caption);
    });
    Object.keys(captionTracks).forEach(function(trackName) {
      var _captionTracks$trackN = captionTracks[trackName], startTime = _captionTracks$trackN.startTime, endTime = _captionTracks$trackN.endTime, captions = _captionTracks$trackN.captions;
      var inbandTextTracks = _this2.inbandTextTracks_;
      _this2.logger_("adding cues from " + startTime + " -> " + endTime + " for " + trackName);
      createCaptionsTrackIfNotExists(inbandTextTracks, _this2.vhs_.tech_, trackName);
      removeCuesFromTrack(startTime, endTime, inbandTextTracks[trackName]);
      addCaptionData({
        captionArray: captions,
        inbandTextTracks,
        timestampOffset: timestampOffset2
      });
    });
    if (this.transmuxer_) {
      this.transmuxer_.postMessage({
        action: "clearParsedMp4Captions"
      });
    }
  };
  _proto.handleId3_ = function handleId3_(simpleSegment, id3Frames, dispatchType) {
    this.earlyAbortWhenNeeded_(simpleSegment.stats);
    if (this.checkForAbort_(simpleSegment.requestId)) {
      return;
    }
    var segmentInfo = this.pendingSegment_;
    if (!segmentInfo.hasAppendedData_) {
      this.metadataQueue_.id3.push(this.handleId3_.bind(this, simpleSegment, id3Frames, dispatchType));
      return;
    }
    var timestampOffset2 = this.sourceUpdater_.videoTimestampOffset() === null ? this.sourceUpdater_.audioTimestampOffset() : this.sourceUpdater_.videoTimestampOffset();
    createMetadataTrackIfNotExists(this.inbandTextTracks_, dispatchType, this.vhs_.tech_);
    addMetadata({
      inbandTextTracks: this.inbandTextTracks_,
      metadataArray: id3Frames,
      timestampOffset: timestampOffset2,
      videoDuration: this.duration_()
    });
  };
  _proto.processMetadataQueue_ = function processMetadataQueue_() {
    this.metadataQueue_.id3.forEach(function(fn) {
      return fn();
    });
    this.metadataQueue_.caption.forEach(function(fn) {
      return fn();
    });
    this.metadataQueue_.id3 = [];
    this.metadataQueue_.caption = [];
  };
  _proto.processCallQueue_ = function processCallQueue_() {
    var callQueue = this.callQueue_;
    this.callQueue_ = [];
    callQueue.forEach(function(fun) {
      return fun();
    });
  };
  _proto.processLoadQueue_ = function processLoadQueue_() {
    var loadQueue = this.loadQueue_;
    this.loadQueue_ = [];
    loadQueue.forEach(function(fun) {
      return fun();
    });
  };
  _proto.hasEnoughInfoToLoad_ = function hasEnoughInfoToLoad_() {
    if (this.loaderType_ !== "audio") {
      return true;
    }
    var segmentInfo = this.pendingSegment_;
    if (!segmentInfo) {
      return false;
    }
    if (!this.getCurrentMediaInfo_()) {
      return true;
    }
    if (shouldWaitForTimelineChange({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: segmentInfo.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    })) {
      return false;
    }
    return true;
  };
  _proto.getCurrentMediaInfo_ = function getCurrentMediaInfo_(segmentInfo) {
    if (segmentInfo === void 0) {
      segmentInfo = this.pendingSegment_;
    }
    return segmentInfo && segmentInfo.trackInfo || this.currentMediaInfo_;
  };
  _proto.getMediaInfo_ = function getMediaInfo_(segmentInfo) {
    if (segmentInfo === void 0) {
      segmentInfo = this.pendingSegment_;
    }
    return this.getCurrentMediaInfo_(segmentInfo) || this.startingMediaInfo_;
  };
  _proto.getPendingSegmentPlaylist = function getPendingSegmentPlaylist() {
    return this.pendingSegment_ ? this.pendingSegment_.playlist : null;
  };
  _proto.hasEnoughInfoToAppend_ = function hasEnoughInfoToAppend_() {
    if (!this.sourceUpdater_.ready()) {
      return false;
    }
    if (this.waitingOnRemove_ || this.quotaExceededErrorRetryTimeout_) {
      return false;
    }
    var segmentInfo = this.pendingSegment_;
    var trackInfo = this.getCurrentMediaInfo_();
    if (!segmentInfo || !trackInfo) {
      return false;
    }
    var hasAudio = trackInfo.hasAudio, hasVideo = trackInfo.hasVideo, isMuxed3 = trackInfo.isMuxed;
    if (hasVideo && !segmentInfo.videoTimingInfo) {
      return false;
    }
    if (hasAudio && !this.audioDisabled_ && !isMuxed3 && !segmentInfo.audioTimingInfo) {
      return false;
    }
    if (shouldWaitForTimelineChange({
      timelineChangeController: this.timelineChangeController_,
      currentTimeline: this.currentTimeline_,
      segmentTimeline: segmentInfo.timeline,
      loaderType: this.loaderType_,
      audioDisabled: this.audioDisabled_
    })) {
      return false;
    }
    return true;
  };
  _proto.handleData_ = function handleData_3(simpleSegment, result2) {
    this.earlyAbortWhenNeeded_(simpleSegment.stats);
    if (this.checkForAbort_(simpleSegment.requestId)) {
      return;
    }
    if (this.callQueue_.length || !this.hasEnoughInfoToAppend_()) {
      this.callQueue_.push(this.handleData_.bind(this, simpleSegment, result2));
      return;
    }
    var segmentInfo = this.pendingSegment_;
    this.setTimeMapping_(segmentInfo.timeline);
    this.updateMediaSecondsLoaded_(segmentInfo.part || segmentInfo.segment);
    if (this.mediaSource_.readyState === "closed") {
      return;
    }
    if (simpleSegment.map) {
      simpleSegment.map = this.initSegmentForMap(simpleSegment.map, true);
      segmentInfo.segment.map = simpleSegment.map;
    }
    if (simpleSegment.key) {
      this.segmentKey(simpleSegment.key, true);
    }
    segmentInfo.isFmp4 = simpleSegment.isFmp4;
    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
    if (segmentInfo.isFmp4) {
      this.trigger("fmp4");
      segmentInfo.timingInfo.start = segmentInfo[timingInfoPropertyForMedia(result2.type)].start;
    } else {
      var trackInfo = this.getCurrentMediaInfo_();
      var useVideoTimingInfo = this.loaderType_ === "main" && trackInfo && trackInfo.hasVideo;
      var firstVideoFrameTimeForData;
      if (useVideoTimingInfo) {
        firstVideoFrameTimeForData = segmentInfo.videoTimingInfo.start;
      }
      segmentInfo.timingInfo.start = this.trueSegmentStart_({
        currentStart: segmentInfo.timingInfo.start,
        playlist: segmentInfo.playlist,
        mediaIndex: segmentInfo.mediaIndex,
        currentVideoTimestampOffset: this.sourceUpdater_.videoTimestampOffset(),
        useVideoTimingInfo,
        firstVideoFrameTimeForData,
        videoTimingInfo: segmentInfo.videoTimingInfo,
        audioTimingInfo: segmentInfo.audioTimingInfo
      });
    }
    this.updateAppendInitSegmentStatus(segmentInfo, result2.type);
    this.updateSourceBufferTimestampOffset_(segmentInfo);
    if (segmentInfo.isSyncRequest) {
      this.updateTimingInfoEnd_(segmentInfo);
      this.syncController_.saveSegmentTimingInfo({
        segmentInfo,
        shouldSaveTimelineMapping: this.loaderType_ === "main"
      });
      var next = this.chooseNextRequest_();
      if (next.mediaIndex !== segmentInfo.mediaIndex || next.partIndex !== segmentInfo.partIndex) {
        this.logger_("sync segment was incorrect, not appending");
        return;
      }
      this.logger_("sync segment was correct, appending");
    }
    segmentInfo.hasAppendedData_ = true;
    this.processMetadataQueue_();
    this.appendData_(segmentInfo, result2);
  };
  _proto.updateAppendInitSegmentStatus = function updateAppendInitSegmentStatus(segmentInfo, type2) {
    if (this.loaderType_ === "main" && typeof segmentInfo.timestampOffset === "number" && !segmentInfo.changedTimestampOffset) {
      this.appendInitSegment_ = {
        audio: true,
        video: true
      };
    }
    if (this.playlistOfLastInitSegment_[type2] !== segmentInfo.playlist) {
      this.appendInitSegment_[type2] = true;
    }
  };
  _proto.getInitSegmentAndUpdateState_ = function getInitSegmentAndUpdateState_(_ref4) {
    var type2 = _ref4.type, initSegment = _ref4.initSegment, map = _ref4.map, playlist = _ref4.playlist;
    if (map) {
      var id2 = initSegmentId(map);
      if (this.activeInitSegmentId_ === id2) {
        return null;
      }
      initSegment = this.initSegmentForMap(map, true).bytes;
      this.activeInitSegmentId_ = id2;
    }
    if (initSegment && this.appendInitSegment_[type2]) {
      this.playlistOfLastInitSegment_[type2] = playlist;
      this.appendInitSegment_[type2] = false;
      this.activeInitSegmentId_ = null;
      return initSegment;
    }
    return null;
  };
  _proto.handleQuotaExceededError_ = function handleQuotaExceededError_(_ref5, error2) {
    var _this3 = this;
    var segmentInfo = _ref5.segmentInfo, type2 = _ref5.type, bytes = _ref5.bytes;
    var audioBuffered = this.sourceUpdater_.audioBuffered();
    var videoBuffered = this.sourceUpdater_.videoBuffered();
    if (audioBuffered.length > 1) {
      this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the audio buffer: " + timeRangesToArray(audioBuffered).join(", "));
    }
    if (videoBuffered.length > 1) {
      this.logger_("On QUOTA_EXCEEDED_ERR, found gaps in the video buffer: " + timeRangesToArray(videoBuffered).join(", "));
    }
    var audioBufferStart = audioBuffered.length ? audioBuffered.start(0) : 0;
    var audioBufferEnd = audioBuffered.length ? audioBuffered.end(audioBuffered.length - 1) : 0;
    var videoBufferStart = videoBuffered.length ? videoBuffered.start(0) : 0;
    var videoBufferEnd = videoBuffered.length ? videoBuffered.end(videoBuffered.length - 1) : 0;
    if (audioBufferEnd - audioBufferStart <= MIN_BACK_BUFFER && videoBufferEnd - videoBufferStart <= MIN_BACK_BUFFER) {
      this.logger_("On QUOTA_EXCEEDED_ERR, single segment too large to append to buffer, triggering an error. " + ("Appended byte length: " + bytes.byteLength + ", ") + ("audio buffer: " + timeRangesToArray(audioBuffered).join(", ") + ", ") + ("video buffer: " + timeRangesToArray(videoBuffered).join(", ") + ", "));
      this.error({
        message: "Quota exceeded error with append of a single segment of content",
        excludeUntil: Infinity
      });
      this.trigger("error");
      return;
    }
    this.waitingOnRemove_ = true;
    this.callQueue_.push(this.appendToSourceBuffer_.bind(this, {
      segmentInfo,
      type: type2,
      bytes
    }));
    var currentTime = this.currentTime_();
    var timeToRemoveUntil = currentTime - MIN_BACK_BUFFER;
    this.logger_("On QUOTA_EXCEEDED_ERR, removing audio/video from 0 to " + timeToRemoveUntil);
    this.remove(0, timeToRemoveUntil, function() {
      _this3.logger_("On QUOTA_EXCEEDED_ERR, retrying append in " + MIN_BACK_BUFFER + "s");
      _this3.waitingOnRemove_ = false;
      _this3.quotaExceededErrorRetryTimeout_ = window_1.setTimeout(function() {
        _this3.logger_("On QUOTA_EXCEEDED_ERR, re-processing call queue");
        _this3.quotaExceededErrorRetryTimeout_ = null;
        _this3.processCallQueue_();
      }, MIN_BACK_BUFFER * 1e3);
    }, true);
  };
  _proto.handleAppendError_ = function handleAppendError_(_ref6, error2) {
    var segmentInfo = _ref6.segmentInfo, type2 = _ref6.type, bytes = _ref6.bytes;
    if (!error2) {
      return;
    }
    if (error2.code === QUOTA_EXCEEDED_ERR) {
      this.handleQuotaExceededError_({
        segmentInfo,
        type: type2,
        bytes
      });
      return;
    }
    this.logger_("Received non QUOTA_EXCEEDED_ERR on append", error2);
    this.error(type2 + " append of " + bytes.length + "b failed for segment " + ("#" + segmentInfo.mediaIndex + " in playlist " + segmentInfo.playlist.id));
    this.trigger("appenderror");
  };
  _proto.appendToSourceBuffer_ = function appendToSourceBuffer_(_ref7) {
    var segmentInfo = _ref7.segmentInfo, type2 = _ref7.type, initSegment = _ref7.initSegment, data = _ref7.data, bytes = _ref7.bytes;
    if (!bytes) {
      var segments = [data];
      var byteLength = data.byteLength;
      if (initSegment) {
        segments.unshift(initSegment);
        byteLength += initSegment.byteLength;
      }
      bytes = concatSegments({
        bytes: byteLength,
        segments
      });
    }
    this.sourceUpdater_.appendBuffer({
      segmentInfo,
      type: type2,
      bytes
    }, this.handleAppendError_.bind(this, {
      segmentInfo,
      type: type2,
      bytes
    }));
  };
  _proto.handleSegmentTimingInfo_ = function handleSegmentTimingInfo_(type2, requestId, segmentTimingInfo) {
    if (!this.pendingSegment_ || requestId !== this.pendingSegment_.requestId) {
      return;
    }
    var segment = this.pendingSegment_.segment;
    var timingInfoProperty = type2 + "TimingInfo";
    if (!segment[timingInfoProperty]) {
      segment[timingInfoProperty] = {};
    }
    segment[timingInfoProperty].transmuxerPrependedSeconds = segmentTimingInfo.prependedContentDuration || 0;
    segment[timingInfoProperty].transmuxedPresentationStart = segmentTimingInfo.start.presentation;
    segment[timingInfoProperty].transmuxedDecodeStart = segmentTimingInfo.start.decode;
    segment[timingInfoProperty].transmuxedPresentationEnd = segmentTimingInfo.end.presentation;
    segment[timingInfoProperty].transmuxedDecodeEnd = segmentTimingInfo.end.decode;
    segment[timingInfoProperty].baseMediaDecodeTime = segmentTimingInfo.baseMediaDecodeTime;
  };
  _proto.appendData_ = function appendData_(segmentInfo, result2) {
    var type2 = result2.type, data = result2.data;
    if (!data || !data.byteLength) {
      return;
    }
    if (type2 === "audio" && this.audioDisabled_) {
      return;
    }
    var initSegment = this.getInitSegmentAndUpdateState_({
      type: type2,
      initSegment: result2.initSegment,
      playlist: segmentInfo.playlist,
      map: segmentInfo.isFmp4 ? segmentInfo.segment.map : null
    });
    this.appendToSourceBuffer_({
      segmentInfo,
      type: type2,
      initSegment,
      data
    });
  };
  _proto.loadSegment_ = function loadSegment_(segmentInfo) {
    var _this4 = this;
    this.state = "WAITING";
    this.pendingSegment_ = segmentInfo;
    this.trimBackBuffer_(segmentInfo);
    if (typeof segmentInfo.timestampOffset === "number") {
      if (this.transmuxer_) {
        this.transmuxer_.postMessage({
          action: "clearAllMp4Captions"
        });
      }
    }
    if (!this.hasEnoughInfoToLoad_()) {
      this.loadQueue_.push(function() {
        var options = _extends$2({}, segmentInfo, {
          forceTimestampOffset: true
        });
        _extends$2(segmentInfo, _this4.generateSegmentInfo_(options));
        _this4.isPendingTimestampOffset_ = false;
        _this4.updateTransmuxerAndRequestSegment_(segmentInfo);
      });
      return;
    }
    this.updateTransmuxerAndRequestSegment_(segmentInfo);
  };
  _proto.updateTransmuxerAndRequestSegment_ = function updateTransmuxerAndRequestSegment_(segmentInfo) {
    var _this5 = this;
    if (this.shouldUpdateTransmuxerTimestampOffset_(segmentInfo.timestampOffset)) {
      this.gopBuffer_.length = 0;
      segmentInfo.gopsToAlignWith = [];
      this.timeMapping_ = 0;
      this.transmuxer_.postMessage({
        action: "reset"
      });
      this.transmuxer_.postMessage({
        action: "setTimestampOffset",
        timestampOffset: segmentInfo.timestampOffset
      });
    }
    var simpleSegment = this.createSimplifiedSegmentObj_(segmentInfo);
    var isEndOfStream = this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex);
    var isWalkingForward = this.mediaIndex !== null;
    var isDiscontinuity = segmentInfo.timeline !== this.currentTimeline_ && segmentInfo.timeline > 0;
    var isEndOfTimeline = isEndOfStream || isWalkingForward && isDiscontinuity;
    this.logger_("Requesting " + segmentInfoString(segmentInfo));
    if (simpleSegment.map && !simpleSegment.map.bytes) {
      this.logger_("going to request init segment.");
      this.appendInitSegment_ = {
        video: true,
        audio: true
      };
    }
    segmentInfo.abortRequests = mediaSegmentRequest({
      xhr: this.vhs_.xhr,
      xhrOptions: this.xhrOptions_,
      decryptionWorker: this.decrypter_,
      segment: simpleSegment,
      abortFn: this.handleAbort_.bind(this, segmentInfo),
      progressFn: this.handleProgress_.bind(this),
      trackInfoFn: this.handleTrackInfo_.bind(this),
      timingInfoFn: this.handleTimingInfo_.bind(this),
      videoSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "video", segmentInfo.requestId),
      audioSegmentTimingInfoFn: this.handleSegmentTimingInfo_.bind(this, "audio", segmentInfo.requestId),
      captionsFn: this.handleCaptions_.bind(this),
      isEndOfTimeline,
      endedTimelineFn: function endedTimelineFn() {
        _this5.logger_("received endedtimeline callback");
      },
      id3Fn: this.handleId3_.bind(this),
      dataFn: this.handleData_.bind(this),
      doneFn: this.segmentRequestFinished_.bind(this),
      onTransmuxerLog: function onTransmuxerLog(_ref8) {
        var message = _ref8.message, level = _ref8.level, stream = _ref8.stream;
        _this5.logger_(segmentInfoString(segmentInfo) + " logged from transmuxer stream " + stream + " as a " + level + ": " + message);
      }
    });
  };
  _proto.trimBackBuffer_ = function trimBackBuffer_(segmentInfo) {
    var removeToTime = safeBackBufferTrimTime(this.seekable_(), this.currentTime_(), this.playlist_.targetDuration || 10);
    if (removeToTime > 0) {
      this.remove(0, removeToTime);
    }
  };
  _proto.createSimplifiedSegmentObj_ = function createSimplifiedSegmentObj_(segmentInfo) {
    var segment = segmentInfo.segment;
    var part = segmentInfo.part;
    var simpleSegment = {
      resolvedUri: part ? part.resolvedUri : segment.resolvedUri,
      byterange: part ? part.byterange : segment.byterange,
      requestId: segmentInfo.requestId,
      transmuxer: segmentInfo.transmuxer,
      audioAppendStart: segmentInfo.audioAppendStart,
      gopsToAlignWith: segmentInfo.gopsToAlignWith,
      part: segmentInfo.part
    };
    var previousSegment = segmentInfo.playlist.segments[segmentInfo.mediaIndex - 1];
    if (previousSegment && previousSegment.timeline === segment.timeline) {
      if (previousSegment.videoTimingInfo) {
        simpleSegment.baseStartTime = previousSegment.videoTimingInfo.transmuxedDecodeEnd;
      } else if (previousSegment.audioTimingInfo) {
        simpleSegment.baseStartTime = previousSegment.audioTimingInfo.transmuxedDecodeEnd;
      }
    }
    if (segment.key) {
      var iv = segment.key.iv || new Uint32Array([0, 0, 0, segmentInfo.mediaIndex + segmentInfo.playlist.mediaSequence]);
      simpleSegment.key = this.segmentKey(segment.key);
      simpleSegment.key.iv = iv;
    }
    if (segment.map) {
      simpleSegment.map = this.initSegmentForMap(segment.map);
    }
    return simpleSegment;
  };
  _proto.saveTransferStats_ = function saveTransferStats_(stats) {
    this.mediaRequests += 1;
    if (stats) {
      this.mediaBytesTransferred += stats.bytesReceived;
      this.mediaTransferDuration += stats.roundTripTime;
    }
  };
  _proto.saveBandwidthRelatedStats_ = function saveBandwidthRelatedStats_(duration5, stats) {
    this.pendingSegment_.byteLength = stats.bytesReceived;
    if (duration5 < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
      this.logger_("Ignoring segment's bandwidth because its duration of " + duration5 + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
      return;
    }
    this.bandwidth = stats.bandwidth;
    this.roundTrip = stats.roundTripTime;
  };
  _proto.handleTimeout_ = function handleTimeout_() {
    this.mediaRequestsTimedout += 1;
    this.bandwidth = 1;
    this.roundTrip = NaN;
    this.trigger("bandwidthupdate");
    this.trigger("timeout");
  };
  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error2, simpleSegment, result2) {
    if (this.callQueue_.length) {
      this.callQueue_.push(this.segmentRequestFinished_.bind(this, error2, simpleSegment, result2));
      return;
    }
    this.saveTransferStats_(simpleSegment.stats);
    if (!this.pendingSegment_) {
      return;
    }
    if (simpleSegment.requestId !== this.pendingSegment_.requestId) {
      return;
    }
    if (error2) {
      this.pendingSegment_ = null;
      this.state = "READY";
      if (error2.code === REQUEST_ERRORS.ABORTED) {
        return;
      }
      this.pause();
      if (error2.code === REQUEST_ERRORS.TIMEOUT) {
        this.handleTimeout_();
        return;
      }
      this.mediaRequestsErrored += 1;
      this.error(error2);
      this.trigger("error");
      return;
    }
    var segmentInfo = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
    segmentInfo.endOfAllRequests = simpleSegment.endOfAllRequests;
    if (result2.gopInfo) {
      this.gopBuffer_ = updateGopBuffer(this.gopBuffer_, result2.gopInfo, this.safeAppend_);
    }
    this.state = "APPENDING";
    this.trigger("appending");
    this.waitForAppendsToComplete_(segmentInfo);
  };
  _proto.setTimeMapping_ = function setTimeMapping_(timeline) {
    var timelineMapping = this.syncController_.mappingForTimeline(timeline);
    if (timelineMapping !== null) {
      this.timeMapping_ = timelineMapping;
    }
  };
  _proto.updateMediaSecondsLoaded_ = function updateMediaSecondsLoaded_(segment) {
    if (typeof segment.start === "number" && typeof segment.end === "number") {
      this.mediaSecondsLoaded += segment.end - segment.start;
    } else {
      this.mediaSecondsLoaded += segment.duration;
    }
  };
  _proto.shouldUpdateTransmuxerTimestampOffset_ = function shouldUpdateTransmuxerTimestampOffset_(timestampOffset2) {
    if (timestampOffset2 === null) {
      return false;
    }
    if (this.loaderType_ === "main" && timestampOffset2 !== this.sourceUpdater_.videoTimestampOffset()) {
      return true;
    }
    if (!this.audioDisabled_ && timestampOffset2 !== this.sourceUpdater_.audioTimestampOffset()) {
      return true;
    }
    return false;
  };
  _proto.trueSegmentStart_ = function trueSegmentStart_(_ref9) {
    var currentStart = _ref9.currentStart, playlist = _ref9.playlist, mediaIndex = _ref9.mediaIndex, firstVideoFrameTimeForData = _ref9.firstVideoFrameTimeForData, currentVideoTimestampOffset = _ref9.currentVideoTimestampOffset, useVideoTimingInfo = _ref9.useVideoTimingInfo, videoTimingInfo = _ref9.videoTimingInfo, audioTimingInfo = _ref9.audioTimingInfo;
    if (typeof currentStart !== "undefined") {
      return currentStart;
    }
    if (!useVideoTimingInfo) {
      return audioTimingInfo.start;
    }
    var previousSegment = playlist.segments[mediaIndex - 1];
    if (mediaIndex === 0 || !previousSegment || typeof previousSegment.start === "undefined" || previousSegment.end !== firstVideoFrameTimeForData + currentVideoTimestampOffset) {
      return firstVideoFrameTimeForData;
    }
    return videoTimingInfo.start;
  };
  _proto.waitForAppendsToComplete_ = function waitForAppendsToComplete_(segmentInfo) {
    var trackInfo = this.getCurrentMediaInfo_(segmentInfo);
    if (!trackInfo) {
      this.error({
        message: "No starting media returned, likely due to an unsupported media format.",
        blacklistDuration: Infinity
      });
      this.trigger("error");
      return;
    }
    var hasAudio = trackInfo.hasAudio, hasVideo = trackInfo.hasVideo, isMuxed3 = trackInfo.isMuxed;
    var waitForVideo = this.loaderType_ === "main" && hasVideo;
    var waitForAudio = !this.audioDisabled_ && hasAudio && !isMuxed3;
    segmentInfo.waitingOnAppends = 0;
    if (!segmentInfo.hasAppendedData_) {
      if (!segmentInfo.timingInfo && typeof segmentInfo.timestampOffset === "number") {
        this.isPendingTimestampOffset_ = true;
      }
      segmentInfo.timingInfo = {
        start: 0
      };
      segmentInfo.waitingOnAppends++;
      if (!this.isPendingTimestampOffset_) {
        this.updateSourceBufferTimestampOffset_(segmentInfo);
        this.processMetadataQueue_();
      }
      this.checkAppendsDone_(segmentInfo);
      return;
    }
    if (waitForVideo) {
      segmentInfo.waitingOnAppends++;
    }
    if (waitForAudio) {
      segmentInfo.waitingOnAppends++;
    }
    if (waitForVideo) {
      this.sourceUpdater_.videoQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
    }
    if (waitForAudio) {
      this.sourceUpdater_.audioQueueCallback(this.checkAppendsDone_.bind(this, segmentInfo));
    }
  };
  _proto.checkAppendsDone_ = function checkAppendsDone_(segmentInfo) {
    if (this.checkForAbort_(segmentInfo.requestId)) {
      return;
    }
    segmentInfo.waitingOnAppends--;
    if (segmentInfo.waitingOnAppends === 0) {
      this.handleAppendsDone_();
    }
  };
  _proto.checkForIllegalMediaSwitch = function checkForIllegalMediaSwitch(trackInfo) {
    var illegalMediaSwitchError = illegalMediaSwitch(this.loaderType_, this.getCurrentMediaInfo_(), trackInfo);
    if (illegalMediaSwitchError) {
      this.error({
        message: illegalMediaSwitchError,
        blacklistDuration: Infinity
      });
      this.trigger("error");
      return true;
    }
    return false;
  };
  _proto.updateSourceBufferTimestampOffset_ = function updateSourceBufferTimestampOffset_(segmentInfo) {
    if (segmentInfo.timestampOffset === null || typeof segmentInfo.timingInfo.start !== "number" || segmentInfo.changedTimestampOffset || this.loaderType_ !== "main") {
      return;
    }
    var didChange = false;
    segmentInfo.timestampOffset -= this.getSegmentStartTimeForTimestampOffsetCalculation_({
      videoTimingInfo: segmentInfo.segment.videoTimingInfo,
      audioTimingInfo: segmentInfo.segment.audioTimingInfo,
      timingInfo: segmentInfo.timingInfo
    });
    segmentInfo.changedTimestampOffset = true;
    if (segmentInfo.timestampOffset !== this.sourceUpdater_.videoTimestampOffset()) {
      this.sourceUpdater_.videoTimestampOffset(segmentInfo.timestampOffset);
      didChange = true;
    }
    if (segmentInfo.timestampOffset !== this.sourceUpdater_.audioTimestampOffset()) {
      this.sourceUpdater_.audioTimestampOffset(segmentInfo.timestampOffset);
      didChange = true;
    }
    if (didChange) {
      this.trigger("timestampoffset");
    }
  };
  _proto.getSegmentStartTimeForTimestampOffsetCalculation_ = function getSegmentStartTimeForTimestampOffsetCalculation_(_ref10) {
    var videoTimingInfo = _ref10.videoTimingInfo, audioTimingInfo = _ref10.audioTimingInfo, timingInfo = _ref10.timingInfo;
    if (!this.useDtsForTimestampOffset_) {
      return timingInfo.start;
    }
    if (videoTimingInfo && typeof videoTimingInfo.transmuxedDecodeStart === "number") {
      return videoTimingInfo.transmuxedDecodeStart;
    }
    if (audioTimingInfo && typeof audioTimingInfo.transmuxedDecodeStart === "number") {
      return audioTimingInfo.transmuxedDecodeStart;
    }
    return timingInfo.start;
  };
  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_(segmentInfo) {
    segmentInfo.timingInfo = segmentInfo.timingInfo || {};
    var trackInfo = this.getMediaInfo_();
    var useVideoTimingInfo = this.loaderType_ === "main" && trackInfo && trackInfo.hasVideo;
    var prioritizedTimingInfo = useVideoTimingInfo && segmentInfo.videoTimingInfo ? segmentInfo.videoTimingInfo : segmentInfo.audioTimingInfo;
    if (!prioritizedTimingInfo) {
      return;
    }
    segmentInfo.timingInfo.end = typeof prioritizedTimingInfo.end === "number" ? prioritizedTimingInfo.end : prioritizedTimingInfo.start + segmentInfo.duration;
  };
  _proto.handleAppendsDone_ = function handleAppendsDone_() {
    if (this.pendingSegment_) {
      this.trigger("appendsdone");
    }
    if (!this.pendingSegment_) {
      this.state = "READY";
      if (!this.paused()) {
        this.monitorBuffer_();
      }
      return;
    }
    var segmentInfo = this.pendingSegment_;
    this.updateTimingInfoEnd_(segmentInfo);
    if (this.shouldSaveSegmentTimingInfo_) {
      this.syncController_.saveSegmentTimingInfo({
        segmentInfo,
        shouldSaveTimelineMapping: this.loaderType_ === "main"
      });
    }
    var segmentDurationMessage = getTroublesomeSegmentDurationMessage(segmentInfo, this.sourceType_);
    if (segmentDurationMessage) {
      if (segmentDurationMessage.severity === "warn") {
        videojs.log.warn(segmentDurationMessage.message);
      } else {
        this.logger_(segmentDurationMessage.message);
      }
    }
    this.recordThroughput_(segmentInfo);
    this.pendingSegment_ = null;
    this.state = "READY";
    if (segmentInfo.isSyncRequest) {
      this.trigger("syncinfoupdate");
      if (!segmentInfo.hasAppendedData_) {
        this.logger_("Throwing away un-appended sync request " + segmentInfoString(segmentInfo));
        return;
      }
    }
    this.logger_("Appended " + segmentInfoString(segmentInfo));
    this.addSegmentMetadataCue_(segmentInfo);
    this.fetchAtBuffer_ = true;
    if (this.currentTimeline_ !== segmentInfo.timeline) {
      this.timelineChangeController_.lastTimelineChange({
        type: this.loaderType_,
        from: this.currentTimeline_,
        to: segmentInfo.timeline
      });
      if (this.loaderType_ === "main" && !this.audioDisabled_) {
        this.timelineChangeController_.lastTimelineChange({
          type: "audio",
          from: this.currentTimeline_,
          to: segmentInfo.timeline
        });
      }
    }
    this.currentTimeline_ = segmentInfo.timeline;
    this.trigger("syncinfoupdate");
    var segment = segmentInfo.segment;
    var part = segmentInfo.part;
    var badSegmentGuess = segment.end && this.currentTime_() - segment.end > segmentInfo.playlist.targetDuration * 3;
    var badPartGuess = part && part.end && this.currentTime_() - part.end > segmentInfo.playlist.partTargetDuration * 3;
    if (badSegmentGuess || badPartGuess) {
      this.logger_("bad " + (badSegmentGuess ? "segment" : "part") + " " + segmentInfoString(segmentInfo));
      this.resetEverything();
      return;
    }
    var isWalkingForward = this.mediaIndex !== null;
    if (isWalkingForward) {
      this.trigger("bandwidthupdate");
    }
    this.trigger("progress");
    this.mediaIndex = segmentInfo.mediaIndex;
    this.partIndex = segmentInfo.partIndex;
    if (this.isEndOfStream_(segmentInfo.mediaIndex, segmentInfo.playlist, segmentInfo.partIndex)) {
      this.endOfStream();
    }
    this.trigger("appended");
    if (segmentInfo.hasAppendedData_) {
      this.mediaAppends++;
    }
    if (!this.paused()) {
      this.monitorBuffer_();
    }
  };
  _proto.recordThroughput_ = function recordThroughput_(segmentInfo) {
    if (segmentInfo.duration < MIN_SEGMENT_DURATION_TO_SAVE_STATS) {
      this.logger_("Ignoring segment's throughput because its duration of " + segmentInfo.duration + (" is less than the min to record " + MIN_SEGMENT_DURATION_TO_SAVE_STATS));
      return;
    }
    var rate = this.throughput.rate;
    var segmentProcessingTime = Date.now() - segmentInfo.endOfAllRequests + 1;
    var segmentProcessingThroughput = Math.floor(segmentInfo.byteLength / segmentProcessingTime * 8 * 1e3);
    this.throughput.rate += (segmentProcessingThroughput - rate) / ++this.throughput.count;
  };
  _proto.addSegmentMetadataCue_ = function addSegmentMetadataCue_(segmentInfo) {
    if (!this.segmentMetadataTrack_) {
      return;
    }
    var segment = segmentInfo.segment;
    var start2 = segment.start;
    var end3 = segment.end;
    if (!finite(start2) || !finite(end3)) {
      return;
    }
    removeCuesFromTrack(start2, end3, this.segmentMetadataTrack_);
    var Cue = window_1.WebKitDataCue || window_1.VTTCue;
    var value = {
      custom: segment.custom,
      dateTimeObject: segment.dateTimeObject,
      dateTimeString: segment.dateTimeString,
      bandwidth: segmentInfo.playlist.attributes.BANDWIDTH,
      resolution: segmentInfo.playlist.attributes.RESOLUTION,
      codecs: segmentInfo.playlist.attributes.CODECS,
      byteLength: segmentInfo.byteLength,
      uri: segmentInfo.uri,
      timeline: segmentInfo.timeline,
      playlist: segmentInfo.playlist.id,
      start: start2,
      end: end3
    };
    var data = JSON.stringify(value);
    var cue = new Cue(start2, end3, data);
    cue.value = value;
    this.segmentMetadataTrack_.addCue(cue);
  };
  return SegmentLoader2;
}(videojs.EventTarget);
function noop$3() {
}
var toTitleCase2 = function toTitleCase3(string2) {
  if (typeof string2 !== "string") {
    return string2;
  }
  return string2.replace(/./, function(w2) {
    return w2.toUpperCase();
  });
};
var bufferTypes = ["video", "audio"];
var _updating = function updating(type2, sourceUpdater) {
  var sourceBuffer = sourceUpdater[type2 + "Buffer"];
  return sourceBuffer && sourceBuffer.updating || sourceUpdater.queuePending[type2];
};
var nextQueueIndexOfType = function nextQueueIndexOfType2(type2, queue) {
  for (var i = 0; i < queue.length; i++) {
    var queueEntry = queue[i];
    if (queueEntry.type === "mediaSource") {
      return null;
    }
    if (queueEntry.type === type2) {
      return i;
    }
  }
  return null;
};
var shiftQueue = function shiftQueue2(type2, sourceUpdater) {
  if (sourceUpdater.queue.length === 0) {
    return;
  }
  var queueIndex = 0;
  var queueEntry = sourceUpdater.queue[queueIndex];
  if (queueEntry.type === "mediaSource") {
    if (!sourceUpdater.updating() && sourceUpdater.mediaSource.readyState !== "closed") {
      sourceUpdater.queue.shift();
      queueEntry.action(sourceUpdater);
      if (queueEntry.doneFn) {
        queueEntry.doneFn();
      }
      shiftQueue2("audio", sourceUpdater);
      shiftQueue2("video", sourceUpdater);
    }
    return;
  }
  if (type2 === "mediaSource") {
    return;
  }
  if (!sourceUpdater.ready() || sourceUpdater.mediaSource.readyState === "closed" || _updating(type2, sourceUpdater)) {
    return;
  }
  if (queueEntry.type !== type2) {
    queueIndex = nextQueueIndexOfType(type2, sourceUpdater.queue);
    if (queueIndex === null) {
      return;
    }
    queueEntry = sourceUpdater.queue[queueIndex];
  }
  sourceUpdater.queue.splice(queueIndex, 1);
  sourceUpdater.queuePending[type2] = queueEntry;
  queueEntry.action(type2, sourceUpdater);
  if (!queueEntry.doneFn) {
    sourceUpdater.queuePending[type2] = null;
    shiftQueue2(type2, sourceUpdater);
    return;
  }
};
var cleanupBuffer = function cleanupBuffer2(type2, sourceUpdater) {
  var buffer = sourceUpdater[type2 + "Buffer"];
  var titleType = toTitleCase2(type2);
  if (!buffer) {
    return;
  }
  buffer.removeEventListener("updateend", sourceUpdater["on" + titleType + "UpdateEnd_"]);
  buffer.removeEventListener("error", sourceUpdater["on" + titleType + "Error_"]);
  sourceUpdater.codecs[type2] = null;
  sourceUpdater[type2 + "Buffer"] = null;
};
var inSourceBuffers = function inSourceBuffers2(mediaSource, sourceBuffer) {
  return mediaSource && sourceBuffer && Array.prototype.indexOf.call(mediaSource.sourceBuffers, sourceBuffer) !== -1;
};
var actions = {
  appendBuffer: function appendBuffer(bytes, segmentInfo, onError2) {
    return function(type2, sourceUpdater) {
      var sourceBuffer = sourceUpdater[type2 + "Buffer"];
      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
        return;
      }
      sourceUpdater.logger_("Appending segment " + segmentInfo.mediaIndex + "'s " + bytes.length + " bytes to " + type2 + "Buffer");
      try {
        sourceBuffer.appendBuffer(bytes);
      } catch (e) {
        sourceUpdater.logger_("Error with code " + e.code + " " + (e.code === QUOTA_EXCEEDED_ERR ? "(QUOTA_EXCEEDED_ERR) " : "") + ("when appending segment " + segmentInfo.mediaIndex + " to " + type2 + "Buffer"));
        sourceUpdater.queuePending[type2] = null;
        onError2(e);
      }
    };
  },
  remove: function remove2(start2, end3) {
    return function(type2, sourceUpdater) {
      var sourceBuffer = sourceUpdater[type2 + "Buffer"];
      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
        return;
      }
      sourceUpdater.logger_("Removing " + start2 + " to " + end3 + " from " + type2 + "Buffer");
      try {
        sourceBuffer.remove(start2, end3);
      } catch (e) {
        sourceUpdater.logger_("Remove " + start2 + " to " + end3 + " from " + type2 + "Buffer failed");
      }
    };
  },
  timestampOffset: function timestampOffset(offset2) {
    return function(type2, sourceUpdater) {
      var sourceBuffer = sourceUpdater[type2 + "Buffer"];
      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
        return;
      }
      sourceUpdater.logger_("Setting " + type2 + "timestampOffset to " + offset2);
      sourceBuffer.timestampOffset = offset2;
    };
  },
  callback: function callback(_callback) {
    return function(type2, sourceUpdater) {
      _callback();
    };
  },
  endOfStream: function endOfStream(error2) {
    return function(sourceUpdater) {
      if (sourceUpdater.mediaSource.readyState !== "open") {
        return;
      }
      sourceUpdater.logger_("Calling mediaSource endOfStream(" + (error2 || "") + ")");
      try {
        sourceUpdater.mediaSource.endOfStream(error2);
      } catch (e) {
        videojs.log.warn("Failed to call media source endOfStream", e);
      }
    };
  },
  duration: function duration4(_duration) {
    return function(sourceUpdater) {
      sourceUpdater.logger_("Setting mediaSource duration to " + _duration);
      try {
        sourceUpdater.mediaSource.duration = _duration;
      } catch (e) {
        videojs.log.warn("Failed to set media source duration", e);
      }
    };
  },
  abort: function abort() {
    return function(type2, sourceUpdater) {
      if (sourceUpdater.mediaSource.readyState !== "open") {
        return;
      }
      var sourceBuffer = sourceUpdater[type2 + "Buffer"];
      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
        return;
      }
      sourceUpdater.logger_("calling abort on " + type2 + "Buffer");
      try {
        sourceBuffer.abort();
      } catch (e) {
        videojs.log.warn("Failed to abort on " + type2 + "Buffer", e);
      }
    };
  },
  addSourceBuffer: function addSourceBuffer(type2, codec) {
    return function(sourceUpdater) {
      var titleType = toTitleCase2(type2);
      var mime = getMimeForCodec(codec);
      sourceUpdater.logger_("Adding " + type2 + "Buffer with codec " + codec + " to mediaSource");
      var sourceBuffer = sourceUpdater.mediaSource.addSourceBuffer(mime);
      sourceBuffer.addEventListener("updateend", sourceUpdater["on" + titleType + "UpdateEnd_"]);
      sourceBuffer.addEventListener("error", sourceUpdater["on" + titleType + "Error_"]);
      sourceUpdater.codecs[type2] = codec;
      sourceUpdater[type2 + "Buffer"] = sourceBuffer;
    };
  },
  removeSourceBuffer: function removeSourceBuffer(type2) {
    return function(sourceUpdater) {
      var sourceBuffer = sourceUpdater[type2 + "Buffer"];
      cleanupBuffer(type2, sourceUpdater);
      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
        return;
      }
      sourceUpdater.logger_("Removing " + type2 + "Buffer with codec " + sourceUpdater.codecs[type2] + " from mediaSource");
      try {
        sourceUpdater.mediaSource.removeSourceBuffer(sourceBuffer);
      } catch (e) {
        videojs.log.warn("Failed to removeSourceBuffer " + type2 + "Buffer", e);
      }
    };
  },
  changeType: function changeType(codec) {
    return function(type2, sourceUpdater) {
      var sourceBuffer = sourceUpdater[type2 + "Buffer"];
      var mime = getMimeForCodec(codec);
      if (!inSourceBuffers(sourceUpdater.mediaSource, sourceBuffer)) {
        return;
      }
      if (sourceUpdater.codecs[type2] === codec) {
        return;
      }
      sourceUpdater.logger_("changing " + type2 + "Buffer codec from " + sourceUpdater.codecs[type2] + " to " + codec);
      sourceBuffer.changeType(mime);
      sourceUpdater.codecs[type2] = codec;
    };
  }
};
var pushQueue = function pushQueue2(_ref2) {
  var type2 = _ref2.type, sourceUpdater = _ref2.sourceUpdater, action = _ref2.action, doneFn = _ref2.doneFn, name = _ref2.name;
  sourceUpdater.queue.push({
    type: type2,
    action,
    doneFn,
    name
  });
  shiftQueue(type2, sourceUpdater);
};
var onUpdateend = function onUpdateend2(type2, sourceUpdater) {
  return function(e) {
    if (sourceUpdater.queuePending[type2]) {
      var doneFn = sourceUpdater.queuePending[type2].doneFn;
      sourceUpdater.queuePending[type2] = null;
      if (doneFn) {
        doneFn(sourceUpdater[type2 + "Error_"]);
      }
    }
    shiftQueue(type2, sourceUpdater);
  };
};
var SourceUpdater = /* @__PURE__ */ function(_videojs$EventTarget) {
  _inheritsLoose(SourceUpdater2, _videojs$EventTarget);
  function SourceUpdater2(mediaSource) {
    var _this;
    _this = _videojs$EventTarget.call(this) || this;
    _this.mediaSource = mediaSource;
    _this.sourceopenListener_ = function() {
      return shiftQueue("mediaSource", _assertThisInitialized(_this));
    };
    _this.mediaSource.addEventListener("sourceopen", _this.sourceopenListener_);
    _this.logger_ = logger("SourceUpdater");
    _this.audioTimestampOffset_ = 0;
    _this.videoTimestampOffset_ = 0;
    _this.queue = [];
    _this.queuePending = {
      audio: null,
      video: null
    };
    _this.delayedAudioAppendQueue_ = [];
    _this.videoAppendQueued_ = false;
    _this.codecs = {};
    _this.onVideoUpdateEnd_ = onUpdateend("video", _assertThisInitialized(_this));
    _this.onAudioUpdateEnd_ = onUpdateend("audio", _assertThisInitialized(_this));
    _this.onVideoError_ = function(e) {
      _this.videoError_ = e;
    };
    _this.onAudioError_ = function(e) {
      _this.audioError_ = e;
    };
    _this.createdSourceBuffers_ = false;
    _this.initializedEme_ = false;
    _this.triggeredReady_ = false;
    return _this;
  }
  var _proto = SourceUpdater2.prototype;
  _proto.initializedEme = function initializedEme() {
    this.initializedEme_ = true;
    this.triggerReady();
  };
  _proto.hasCreatedSourceBuffers = function hasCreatedSourceBuffers() {
    return this.createdSourceBuffers_;
  };
  _proto.hasInitializedAnyEme = function hasInitializedAnyEme() {
    return this.initializedEme_;
  };
  _proto.ready = function ready() {
    return this.hasCreatedSourceBuffers() && this.hasInitializedAnyEme();
  };
  _proto.createSourceBuffers = function createSourceBuffers(codecs) {
    if (this.hasCreatedSourceBuffers()) {
      return;
    }
    this.addOrChangeSourceBuffers(codecs);
    this.createdSourceBuffers_ = true;
    this.trigger("createdsourcebuffers");
    this.triggerReady();
  };
  _proto.triggerReady = function triggerReady() {
    if (this.ready() && !this.triggeredReady_) {
      this.triggeredReady_ = true;
      this.trigger("ready");
    }
  };
  _proto.addSourceBuffer = function addSourceBuffer2(type2, codec) {
    pushQueue({
      type: "mediaSource",
      sourceUpdater: this,
      action: actions.addSourceBuffer(type2, codec),
      name: "addSourceBuffer"
    });
  };
  _proto.abort = function abort2(type2) {
    pushQueue({
      type: type2,
      sourceUpdater: this,
      action: actions.abort(type2),
      name: "abort"
    });
  };
  _proto.removeSourceBuffer = function removeSourceBuffer2(type2) {
    if (!this.canRemoveSourceBuffer()) {
      videojs.log.error("removeSourceBuffer is not supported!");
      return;
    }
    pushQueue({
      type: "mediaSource",
      sourceUpdater: this,
      action: actions.removeSourceBuffer(type2),
      name: "removeSourceBuffer"
    });
  };
  _proto.canRemoveSourceBuffer = function canRemoveSourceBuffer() {
    return !videojs.browser.IE_VERSION && !videojs.browser.IS_FIREFOX && window_1.MediaSource && window_1.MediaSource.prototype && typeof window_1.MediaSource.prototype.removeSourceBuffer === "function";
  };
  SourceUpdater2.canChangeType = function canChangeType() {
    return window_1.SourceBuffer && window_1.SourceBuffer.prototype && typeof window_1.SourceBuffer.prototype.changeType === "function";
  };
  _proto.canChangeType = function canChangeType() {
    return this.constructor.canChangeType();
  };
  _proto.changeType = function changeType2(type2, codec) {
    if (!this.canChangeType()) {
      videojs.log.error("changeType is not supported!");
      return;
    }
    pushQueue({
      type: type2,
      sourceUpdater: this,
      action: actions.changeType(codec),
      name: "changeType"
    });
  };
  _proto.addOrChangeSourceBuffers = function addOrChangeSourceBuffers(codecs) {
    var _this2 = this;
    if (!codecs || typeof codecs !== "object" || Object.keys(codecs).length === 0) {
      throw new Error("Cannot addOrChangeSourceBuffers to undefined codecs");
    }
    Object.keys(codecs).forEach(function(type2) {
      var codec = codecs[type2];
      if (!_this2.hasCreatedSourceBuffers()) {
        return _this2.addSourceBuffer(type2, codec);
      }
      if (_this2.canChangeType()) {
        _this2.changeType(type2, codec);
      }
    });
  };
  _proto.appendBuffer = function appendBuffer2(options, doneFn) {
    var _this3 = this;
    var segmentInfo = options.segmentInfo, type2 = options.type, bytes = options.bytes;
    this.processedAppend_ = true;
    if (type2 === "audio" && this.videoBuffer && !this.videoAppendQueued_) {
      this.delayedAudioAppendQueue_.push([options, doneFn]);
      this.logger_("delayed audio append of " + bytes.length + " until video append");
      return;
    }
    var onError2 = doneFn;
    pushQueue({
      type: type2,
      sourceUpdater: this,
      action: actions.appendBuffer(bytes, segmentInfo || {
        mediaIndex: -1
      }, onError2),
      doneFn,
      name: "appendBuffer"
    });
    if (type2 === "video") {
      this.videoAppendQueued_ = true;
      if (!this.delayedAudioAppendQueue_.length) {
        return;
      }
      var queue = this.delayedAudioAppendQueue_.slice();
      this.logger_("queuing delayed audio " + queue.length + " appendBuffers");
      this.delayedAudioAppendQueue_.length = 0;
      queue.forEach(function(que) {
        _this3.appendBuffer.apply(_this3, que);
      });
    }
  };
  _proto.audioBuffered = function audioBuffered() {
    if (!inSourceBuffers(this.mediaSource, this.audioBuffer)) {
      return videojs.createTimeRange();
    }
    return this.audioBuffer.buffered ? this.audioBuffer.buffered : videojs.createTimeRange();
  };
  _proto.videoBuffered = function videoBuffered() {
    if (!inSourceBuffers(this.mediaSource, this.videoBuffer)) {
      return videojs.createTimeRange();
    }
    return this.videoBuffer.buffered ? this.videoBuffer.buffered : videojs.createTimeRange();
  };
  _proto.buffered = function buffered() {
    var video = inSourceBuffers(this.mediaSource, this.videoBuffer) ? this.videoBuffer : null;
    var audio = inSourceBuffers(this.mediaSource, this.audioBuffer) ? this.audioBuffer : null;
    if (audio && !video) {
      return this.audioBuffered();
    }
    if (video && !audio) {
      return this.videoBuffered();
    }
    return bufferIntersection(this.audioBuffered(), this.videoBuffered());
  };
  _proto.setDuration = function setDuration(duration5, doneFn) {
    if (doneFn === void 0) {
      doneFn = noop$3;
    }
    pushQueue({
      type: "mediaSource",
      sourceUpdater: this,
      action: actions.duration(duration5),
      name: "duration",
      doneFn
    });
  };
  _proto.endOfStream = function endOfStream2(error2, doneFn) {
    if (error2 === void 0) {
      error2 = null;
    }
    if (doneFn === void 0) {
      doneFn = noop$3;
    }
    if (typeof error2 !== "string") {
      error2 = void 0;
    }
    pushQueue({
      type: "mediaSource",
      sourceUpdater: this,
      action: actions.endOfStream(error2),
      name: "endOfStream",
      doneFn
    });
  };
  _proto.removeAudio = function removeAudio(start2, end3, done) {
    if (done === void 0) {
      done = noop$3;
    }
    if (!this.audioBuffered().length || this.audioBuffered().end(0) === 0) {
      done();
      return;
    }
    pushQueue({
      type: "audio",
      sourceUpdater: this,
      action: actions.remove(start2, end3),
      doneFn: done,
      name: "remove"
    });
  };
  _proto.removeVideo = function removeVideo(start2, end3, done) {
    if (done === void 0) {
      done = noop$3;
    }
    if (!this.videoBuffered().length || this.videoBuffered().end(0) === 0) {
      done();
      return;
    }
    pushQueue({
      type: "video",
      sourceUpdater: this,
      action: actions.remove(start2, end3),
      doneFn: done,
      name: "remove"
    });
  };
  _proto.updating = function updating2() {
    if (_updating("audio", this) || _updating("video", this)) {
      return true;
    }
    return false;
  };
  _proto.audioTimestampOffset = function audioTimestampOffset(offset2) {
    if (typeof offset2 !== "undefined" && this.audioBuffer && this.audioTimestampOffset_ !== offset2) {
      pushQueue({
        type: "audio",
        sourceUpdater: this,
        action: actions.timestampOffset(offset2),
        name: "timestampOffset"
      });
      this.audioTimestampOffset_ = offset2;
    }
    return this.audioTimestampOffset_;
  };
  _proto.videoTimestampOffset = function videoTimestampOffset(offset2) {
    if (typeof offset2 !== "undefined" && this.videoBuffer && this.videoTimestampOffset !== offset2) {
      pushQueue({
        type: "video",
        sourceUpdater: this,
        action: actions.timestampOffset(offset2),
        name: "timestampOffset"
      });
      this.videoTimestampOffset_ = offset2;
    }
    return this.videoTimestampOffset_;
  };
  _proto.audioQueueCallback = function audioQueueCallback(callback2) {
    if (!this.audioBuffer) {
      return;
    }
    pushQueue({
      type: "audio",
      sourceUpdater: this,
      action: actions.callback(callback2),
      name: "callback"
    });
  };
  _proto.videoQueueCallback = function videoQueueCallback(callback2) {
    if (!this.videoBuffer) {
      return;
    }
    pushQueue({
      type: "video",
      sourceUpdater: this,
      action: actions.callback(callback2),
      name: "callback"
    });
  };
  _proto.dispose = function dispose() {
    var _this4 = this;
    this.trigger("dispose");
    bufferTypes.forEach(function(type2) {
      _this4.abort(type2);
      if (_this4.canRemoveSourceBuffer()) {
        _this4.removeSourceBuffer(type2);
      } else {
        _this4[type2 + "QueueCallback"](function() {
          return cleanupBuffer(type2, _this4);
        });
      }
    });
    this.videoAppendQueued_ = false;
    this.delayedAudioAppendQueue_.length = 0;
    if (this.sourceopenListener_) {
      this.mediaSource.removeEventListener("sourceopen", this.sourceopenListener_);
    }
    this.off();
  };
  return SourceUpdater2;
}(videojs.EventTarget);
var uint8ToUtf8 = function uint8ToUtf82(uintArray) {
  return decodeURIComponent(escape(String.fromCharCode.apply(null, uintArray)));
};
var VTT_LINE_TERMINATORS = new Uint8Array("\n\n".split("").map(function(_char3) {
  return _char3.charCodeAt(0);
}));
var NoVttJsError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(NoVttJsError2, _Error);
  function NoVttJsError2() {
    return _Error.call(this, "Trying to parse received VTT cues, but there is no WebVTT. Make sure vtt.js is loaded.") || this;
  }
  return NoVttJsError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var VTTSegmentLoader = /* @__PURE__ */ function(_SegmentLoader) {
  _inheritsLoose(VTTSegmentLoader2, _SegmentLoader);
  function VTTSegmentLoader2(settings, options) {
    var _this;
    if (options === void 0) {
      options = {};
    }
    _this = _SegmentLoader.call(this, settings, options) || this;
    _this.mediaSource_ = null;
    _this.subtitlesTrack_ = null;
    _this.loaderType_ = "subtitle";
    _this.featuresNativeTextTracks_ = settings.featuresNativeTextTracks;
    _this.loadVttJs = settings.loadVttJs;
    _this.shouldSaveSegmentTimingInfo_ = false;
    return _this;
  }
  var _proto = VTTSegmentLoader2.prototype;
  _proto.createTransmuxer_ = function createTransmuxer_() {
    return null;
  };
  _proto.buffered_ = function buffered_() {
    if (!this.subtitlesTrack_ || !this.subtitlesTrack_.cues || !this.subtitlesTrack_.cues.length) {
      return videojs.createTimeRanges();
    }
    var cues = this.subtitlesTrack_.cues;
    var start2 = cues[0].startTime;
    var end3 = cues[cues.length - 1].startTime;
    return videojs.createTimeRanges([[start2, end3]]);
  };
  _proto.initSegmentForMap = function initSegmentForMap(map, set4) {
    if (set4 === void 0) {
      set4 = false;
    }
    if (!map) {
      return null;
    }
    var id2 = initSegmentId(map);
    var storedMap = this.initSegments_[id2];
    if (set4 && !storedMap && map.bytes) {
      var combinedByteLength = VTT_LINE_TERMINATORS.byteLength + map.bytes.byteLength;
      var combinedSegment = new Uint8Array(combinedByteLength);
      combinedSegment.set(map.bytes);
      combinedSegment.set(VTT_LINE_TERMINATORS, map.bytes.byteLength);
      this.initSegments_[id2] = storedMap = {
        resolvedUri: map.resolvedUri,
        byterange: map.byterange,
        bytes: combinedSegment
      };
    }
    return storedMap || map;
  };
  _proto.couldBeginLoading_ = function couldBeginLoading_() {
    return this.playlist_ && this.subtitlesTrack_ && !this.paused();
  };
  _proto.init_ = function init_() {
    this.state = "READY";
    this.resetEverything();
    return this.monitorBuffer_();
  };
  _proto.track = function track(_track) {
    if (typeof _track === "undefined") {
      return this.subtitlesTrack_;
    }
    this.subtitlesTrack_ = _track;
    if (this.state === "INIT" && this.couldBeginLoading_()) {
      this.init_();
    }
    return this.subtitlesTrack_;
  };
  _proto.remove = function remove3(start2, end3) {
    removeCuesFromTrack(start2, end3, this.subtitlesTrack_);
  };
  _proto.fillBuffer_ = function fillBuffer_() {
    var _this2 = this;
    var segmentInfo = this.chooseNextRequest_();
    if (!segmentInfo) {
      return;
    }
    if (this.syncController_.timestampOffsetForTimeline(segmentInfo.timeline) === null) {
      var checkTimestampOffset = function checkTimestampOffset2() {
        _this2.state = "READY";
        if (!_this2.paused()) {
          _this2.monitorBuffer_();
        }
      };
      this.syncController_.one("timestampoffset", checkTimestampOffset);
      this.state = "WAITING_ON_TIMELINE";
      return;
    }
    this.loadSegment_(segmentInfo);
  };
  _proto.timestampOffsetForSegment_ = function timestampOffsetForSegment_() {
    return null;
  };
  _proto.chooseNextRequest_ = function chooseNextRequest_() {
    return this.skipEmptySegments_(_SegmentLoader.prototype.chooseNextRequest_.call(this));
  };
  _proto.skipEmptySegments_ = function skipEmptySegments_(segmentInfo) {
    while (segmentInfo && segmentInfo.segment.empty) {
      if (segmentInfo.mediaIndex + 1 >= segmentInfo.playlist.segments.length) {
        segmentInfo = null;
        break;
      }
      segmentInfo = this.generateSegmentInfo_({
        playlist: segmentInfo.playlist,
        mediaIndex: segmentInfo.mediaIndex + 1,
        startOfSegment: segmentInfo.startOfSegment + segmentInfo.duration,
        isSyncRequest: segmentInfo.isSyncRequest
      });
    }
    return segmentInfo;
  };
  _proto.stopForError = function stopForError(error2) {
    this.error(error2);
    this.state = "READY";
    this.pause();
    this.trigger("error");
  };
  _proto.segmentRequestFinished_ = function segmentRequestFinished_(error2, simpleSegment, result2) {
    var _this3 = this;
    if (!this.subtitlesTrack_) {
      this.state = "READY";
      return;
    }
    this.saveTransferStats_(simpleSegment.stats);
    if (!this.pendingSegment_) {
      this.state = "READY";
      this.mediaRequestsAborted += 1;
      return;
    }
    if (error2) {
      if (error2.code === REQUEST_ERRORS.TIMEOUT) {
        this.handleTimeout_();
      }
      if (error2.code === REQUEST_ERRORS.ABORTED) {
        this.mediaRequestsAborted += 1;
      } else {
        this.mediaRequestsErrored += 1;
      }
      this.stopForError(error2);
      return;
    }
    var segmentInfo = this.pendingSegment_;
    this.saveBandwidthRelatedStats_(segmentInfo.duration, simpleSegment.stats);
    if (simpleSegment.key) {
      this.segmentKey(simpleSegment.key, true);
    }
    this.state = "APPENDING";
    this.trigger("appending");
    var segment = segmentInfo.segment;
    if (segment.map) {
      segment.map.bytes = simpleSegment.map.bytes;
    }
    segmentInfo.bytes = simpleSegment.bytes;
    if (typeof window_1.WebVTT !== "function" && typeof this.loadVttJs === "function") {
      this.state = "WAITING_ON_VTTJS";
      this.loadVttJs().then(function() {
        return _this3.segmentRequestFinished_(error2, simpleSegment, result2);
      }, function() {
        return _this3.stopForError({
          message: "Error loading vtt.js"
        });
      });
      return;
    }
    segment.requested = true;
    try {
      this.parseVTTCues_(segmentInfo);
    } catch (e) {
      this.stopForError({
        message: e.message
      });
      return;
    }
    this.updateTimeMapping_(segmentInfo, this.syncController_.timelines[segmentInfo.timeline], this.playlist_);
    if (segmentInfo.cues.length) {
      segmentInfo.timingInfo = {
        start: segmentInfo.cues[0].startTime,
        end: segmentInfo.cues[segmentInfo.cues.length - 1].endTime
      };
    } else {
      segmentInfo.timingInfo = {
        start: segmentInfo.startOfSegment,
        end: segmentInfo.startOfSegment + segmentInfo.duration
      };
    }
    if (segmentInfo.isSyncRequest) {
      this.trigger("syncinfoupdate");
      this.pendingSegment_ = null;
      this.state = "READY";
      return;
    }
    segmentInfo.byteLength = segmentInfo.bytes.byteLength;
    this.mediaSecondsLoaded += segment.duration;
    segmentInfo.cues.forEach(function(cue) {
      _this3.subtitlesTrack_.addCue(_this3.featuresNativeTextTracks_ ? new window_1.VTTCue(cue.startTime, cue.endTime, cue.text) : cue);
    });
    removeDuplicateCuesFromTrack(this.subtitlesTrack_);
    this.handleAppendsDone_();
  };
  _proto.handleData_ = function handleData_3() {
  };
  _proto.updateTimingInfoEnd_ = function updateTimingInfoEnd_() {
  };
  _proto.parseVTTCues_ = function parseVTTCues_(segmentInfo) {
    var decoder;
    var decodeBytesToString = false;
    if (typeof window_1.WebVTT !== "function") {
      throw new NoVttJsError();
    }
    if (typeof window_1.TextDecoder === "function") {
      decoder = new window_1.TextDecoder("utf8");
    } else {
      decoder = window_1.WebVTT.StringDecoder();
      decodeBytesToString = true;
    }
    var parser2 = new window_1.WebVTT.Parser(window_1, window_1.vttjs, decoder);
    segmentInfo.cues = [];
    segmentInfo.timestampmap = {
      MPEGTS: 0,
      LOCAL: 0
    };
    parser2.oncue = segmentInfo.cues.push.bind(segmentInfo.cues);
    parser2.ontimestampmap = function(map) {
      segmentInfo.timestampmap = map;
    };
    parser2.onparsingerror = function(error2) {
      videojs.log.warn("Error encountered when parsing cues: " + error2.message);
    };
    if (segmentInfo.segment.map) {
      var mapData = segmentInfo.segment.map.bytes;
      if (decodeBytesToString) {
        mapData = uint8ToUtf8(mapData);
      }
      parser2.parse(mapData);
    }
    var segmentData = segmentInfo.bytes;
    if (decodeBytesToString) {
      segmentData = uint8ToUtf8(segmentData);
    }
    parser2.parse(segmentData);
    parser2.flush();
  };
  _proto.updateTimeMapping_ = function updateTimeMapping_(segmentInfo, mappingObj, playlist) {
    var segment = segmentInfo.segment;
    if (!mappingObj) {
      return;
    }
    if (!segmentInfo.cues.length) {
      segment.empty = true;
      return;
    }
    var timestampmap = segmentInfo.timestampmap;
    var diff = timestampmap.MPEGTS / clock.ONE_SECOND_IN_TS - timestampmap.LOCAL + mappingObj.mapping;
    segmentInfo.cues.forEach(function(cue) {
      cue.startTime += diff;
      cue.endTime += diff;
    });
    if (!playlist.syncInfo) {
      var firstStart = segmentInfo.cues[0].startTime;
      var lastStart = segmentInfo.cues[segmentInfo.cues.length - 1].startTime;
      playlist.syncInfo = {
        mediaSequence: playlist.mediaSequence + segmentInfo.mediaIndex,
        time: Math.min(firstStart, lastStart - segment.duration)
      };
    }
  };
  return VTTSegmentLoader2;
}(SegmentLoader);
var findAdCue = function findAdCue2(track, mediaTime) {
  var cues = track.cues;
  for (var i = 0; i < cues.length; i++) {
    var cue = cues[i];
    if (mediaTime >= cue.adStartTime && mediaTime <= cue.adEndTime) {
      return cue;
    }
  }
  return null;
};
var updateAdCues = function updateAdCues2(media, track, offset2) {
  if (offset2 === void 0) {
    offset2 = 0;
  }
  if (!media.segments) {
    return;
  }
  var mediaTime = offset2;
  var cue;
  for (var i = 0; i < media.segments.length; i++) {
    var segment = media.segments[i];
    if (!cue) {
      cue = findAdCue(track, mediaTime + segment.duration / 2);
    }
    if (cue) {
      if ("cueIn" in segment) {
        cue.endTime = mediaTime;
        cue.adEndTime = mediaTime;
        mediaTime += segment.duration;
        cue = null;
        continue;
      }
      if (mediaTime < cue.endTime) {
        mediaTime += segment.duration;
        continue;
      }
      cue.endTime += segment.duration;
    } else {
      if ("cueOut" in segment) {
        cue = new window_1.VTTCue(mediaTime, mediaTime + segment.duration, segment.cueOut);
        cue.adStartTime = mediaTime;
        cue.adEndTime = mediaTime + parseFloat(segment.cueOut);
        track.addCue(cue);
      }
      if ("cueOutCont" in segment) {
        var _segment$cueOutCont$s = segment.cueOutCont.split("/").map(parseFloat), adOffset = _segment$cueOutCont$s[0], adTotal = _segment$cueOutCont$s[1];
        cue = new window_1.VTTCue(mediaTime, mediaTime + segment.duration, "");
        cue.adStartTime = mediaTime - adOffset;
        cue.adEndTime = cue.adStartTime + adTotal;
        track.addCue(cue);
      }
    }
    mediaTime += segment.duration;
  }
};
var MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC = 86400;
var syncPointStrategies = [
  {
    name: "VOD",
    run: function run(syncController, playlist, duration5, currentTimeline, currentTime) {
      if (duration5 !== Infinity) {
        var syncPoint = {
          time: 0,
          segmentIndex: 0,
          partIndex: null
        };
        return syncPoint;
      }
      return null;
    }
  },
  {
    name: "ProgramDateTime",
    run: function run2(syncController, playlist, duration5, currentTimeline, currentTime) {
      if (!Object.keys(syncController.timelineToDatetimeMappings).length) {
        return null;
      }
      var syncPoint = null;
      var lastDistance = null;
      var partsAndSegments = getPartsAndSegments(playlist);
      currentTime = currentTime || 0;
      for (var i = 0; i < partsAndSegments.length; i++) {
        var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
        var partAndSegment = partsAndSegments[index];
        var segment = partAndSegment.segment;
        var datetimeMapping = syncController.timelineToDatetimeMappings[segment.timeline];
        if (!datetimeMapping || !segment.dateTimeObject) {
          continue;
        }
        var segmentTime = segment.dateTimeObject.getTime() / 1e3;
        var start2 = segmentTime + datetimeMapping;
        if (segment.parts && typeof partAndSegment.partIndex === "number") {
          for (var z = 0; z < partAndSegment.partIndex; z++) {
            start2 += segment.parts[z].duration;
          }
        }
        var distance = Math.abs(currentTime - start2);
        if (lastDistance !== null && (distance === 0 || lastDistance < distance)) {
          break;
        }
        lastDistance = distance;
        syncPoint = {
          time: start2,
          segmentIndex: partAndSegment.segmentIndex,
          partIndex: partAndSegment.partIndex
        };
      }
      return syncPoint;
    }
  },
  {
    name: "Segment",
    run: function run3(syncController, playlist, duration5, currentTimeline, currentTime) {
      var syncPoint = null;
      var lastDistance = null;
      currentTime = currentTime || 0;
      var partsAndSegments = getPartsAndSegments(playlist);
      for (var i = 0; i < partsAndSegments.length; i++) {
        var index = playlist.endList || currentTime === 0 ? i : partsAndSegments.length - (i + 1);
        var partAndSegment = partsAndSegments[index];
        var segment = partAndSegment.segment;
        var start2 = partAndSegment.part && partAndSegment.part.start || segment && segment.start;
        if (segment.timeline === currentTimeline && typeof start2 !== "undefined") {
          var distance = Math.abs(currentTime - start2);
          if (lastDistance !== null && lastDistance < distance) {
            break;
          }
          if (!syncPoint || lastDistance === null || lastDistance >= distance) {
            lastDistance = distance;
            syncPoint = {
              time: start2,
              segmentIndex: partAndSegment.segmentIndex,
              partIndex: partAndSegment.partIndex
            };
          }
        }
      }
      return syncPoint;
    }
  },
  {
    name: "Discontinuity",
    run: function run4(syncController, playlist, duration5, currentTimeline, currentTime) {
      var syncPoint = null;
      currentTime = currentTime || 0;
      if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
        var lastDistance = null;
        for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
          var segmentIndex = playlist.discontinuityStarts[i];
          var discontinuity = playlist.discontinuitySequence + i + 1;
          var discontinuitySync = syncController.discontinuities[discontinuity];
          if (discontinuitySync) {
            var distance = Math.abs(currentTime - discontinuitySync.time);
            if (lastDistance !== null && lastDistance < distance) {
              break;
            }
            if (!syncPoint || lastDistance === null || lastDistance >= distance) {
              lastDistance = distance;
              syncPoint = {
                time: discontinuitySync.time,
                segmentIndex,
                partIndex: null
              };
            }
          }
        }
      }
      return syncPoint;
    }
  },
  {
    name: "Playlist",
    run: function run5(syncController, playlist, duration5, currentTimeline, currentTime) {
      if (playlist.syncInfo) {
        var syncPoint = {
          time: playlist.syncInfo.time,
          segmentIndex: playlist.syncInfo.mediaSequence - playlist.mediaSequence,
          partIndex: null
        };
        return syncPoint;
      }
      return null;
    }
  }
];
var SyncController = /* @__PURE__ */ function(_videojs$EventTarget) {
  _inheritsLoose(SyncController2, _videojs$EventTarget);
  function SyncController2(options) {
    var _this;
    _this = _videojs$EventTarget.call(this) || this;
    _this.timelines = [];
    _this.discontinuities = [];
    _this.timelineToDatetimeMappings = {};
    _this.logger_ = logger("SyncController");
    return _this;
  }
  var _proto = SyncController2.prototype;
  _proto.getSyncPoint = function getSyncPoint(playlist, duration5, currentTimeline, currentTime) {
    var syncPoints = this.runStrategies_(playlist, duration5, currentTimeline, currentTime);
    if (!syncPoints.length) {
      return null;
    }
    return this.selectSyncPoint_(syncPoints, {
      key: "time",
      value: currentTime
    });
  };
  _proto.getExpiredTime = function getExpiredTime(playlist, duration5) {
    if (!playlist || !playlist.segments) {
      return null;
    }
    var syncPoints = this.runStrategies_(playlist, duration5, playlist.discontinuitySequence, 0);
    if (!syncPoints.length) {
      return null;
    }
    var syncPoint = this.selectSyncPoint_(syncPoints, {
      key: "segmentIndex",
      value: 0
    });
    if (syncPoint.segmentIndex > 0) {
      syncPoint.time *= -1;
    }
    return Math.abs(syncPoint.time + sumDurations({
      defaultDuration: playlist.targetDuration,
      durationList: playlist.segments,
      startIndex: syncPoint.segmentIndex,
      endIndex: 0
    }));
  };
  _proto.runStrategies_ = function runStrategies_(playlist, duration5, currentTimeline, currentTime) {
    var syncPoints = [];
    for (var i = 0; i < syncPointStrategies.length; i++) {
      var strategy = syncPointStrategies[i];
      var syncPoint = strategy.run(this, playlist, duration5, currentTimeline, currentTime);
      if (syncPoint) {
        syncPoint.strategy = strategy.name;
        syncPoints.push({
          strategy: strategy.name,
          syncPoint
        });
      }
    }
    return syncPoints;
  };
  _proto.selectSyncPoint_ = function selectSyncPoint_(syncPoints, target) {
    var bestSyncPoint = syncPoints[0].syncPoint;
    var bestDistance = Math.abs(syncPoints[0].syncPoint[target.key] - target.value);
    var bestStrategy = syncPoints[0].strategy;
    for (var i = 1; i < syncPoints.length; i++) {
      var newDistance = Math.abs(syncPoints[i].syncPoint[target.key] - target.value);
      if (newDistance < bestDistance) {
        bestDistance = newDistance;
        bestSyncPoint = syncPoints[i].syncPoint;
        bestStrategy = syncPoints[i].strategy;
      }
    }
    this.logger_("syncPoint for [" + target.key + ": " + target.value + "] chosen with strategy" + (" [" + bestStrategy + "]: [time:" + bestSyncPoint.time + ",") + (" segmentIndex:" + bestSyncPoint.segmentIndex) + (typeof bestSyncPoint.partIndex === "number" ? ",partIndex:" + bestSyncPoint.partIndex : "") + "]");
    return bestSyncPoint;
  };
  _proto.saveExpiredSegmentInfo = function saveExpiredSegmentInfo(oldPlaylist, newPlaylist) {
    var mediaSequenceDiff = newPlaylist.mediaSequence - oldPlaylist.mediaSequence;
    if (mediaSequenceDiff > MAX_MEDIA_SEQUENCE_DIFF_FOR_SYNC) {
      videojs.log.warn("Not saving expired segment info. Media sequence gap " + mediaSequenceDiff + " is too large.");
      return;
    }
    for (var i = mediaSequenceDiff - 1; i >= 0; i--) {
      var lastRemovedSegment = oldPlaylist.segments[i];
      if (lastRemovedSegment && typeof lastRemovedSegment.start !== "undefined") {
        newPlaylist.syncInfo = {
          mediaSequence: oldPlaylist.mediaSequence + i,
          time: lastRemovedSegment.start
        };
        this.logger_("playlist refresh sync: [time:" + newPlaylist.syncInfo.time + "," + (" mediaSequence: " + newPlaylist.syncInfo.mediaSequence + "]"));
        this.trigger("syncinfoupdate");
        break;
      }
    }
  };
  _proto.setDateTimeMappingForStart = function setDateTimeMappingForStart(playlist) {
    this.timelineToDatetimeMappings = {};
    if (playlist.segments && playlist.segments.length && playlist.segments[0].dateTimeObject) {
      var firstSegment = playlist.segments[0];
      var playlistTimestamp = firstSegment.dateTimeObject.getTime() / 1e3;
      this.timelineToDatetimeMappings[firstSegment.timeline] = -playlistTimestamp;
    }
  };
  _proto.saveSegmentTimingInfo = function saveSegmentTimingInfo(_ref2) {
    var segmentInfo = _ref2.segmentInfo, shouldSaveTimelineMapping = _ref2.shouldSaveTimelineMapping;
    var didCalculateSegmentTimeMapping = this.calculateSegmentTimeMapping_(segmentInfo, segmentInfo.timingInfo, shouldSaveTimelineMapping);
    var segment = segmentInfo.segment;
    if (didCalculateSegmentTimeMapping) {
      this.saveDiscontinuitySyncInfo_(segmentInfo);
      if (!segmentInfo.playlist.syncInfo) {
        segmentInfo.playlist.syncInfo = {
          mediaSequence: segmentInfo.playlist.mediaSequence + segmentInfo.mediaIndex,
          time: segment.start
        };
      }
    }
    var dateTime = segment.dateTimeObject;
    if (segment.discontinuity && shouldSaveTimelineMapping && dateTime) {
      this.timelineToDatetimeMappings[segment.timeline] = -(dateTime.getTime() / 1e3);
    }
  };
  _proto.timestampOffsetForTimeline = function timestampOffsetForTimeline(timeline) {
    if (typeof this.timelines[timeline] === "undefined") {
      return null;
    }
    return this.timelines[timeline].time;
  };
  _proto.mappingForTimeline = function mappingForTimeline(timeline) {
    if (typeof this.timelines[timeline] === "undefined") {
      return null;
    }
    return this.timelines[timeline].mapping;
  };
  _proto.calculateSegmentTimeMapping_ = function calculateSegmentTimeMapping_(segmentInfo, timingInfo, shouldSaveTimelineMapping) {
    var segment = segmentInfo.segment;
    var part = segmentInfo.part;
    var mappingObj = this.timelines[segmentInfo.timeline];
    var start2;
    var end3;
    if (typeof segmentInfo.timestampOffset === "number") {
      mappingObj = {
        time: segmentInfo.startOfSegment,
        mapping: segmentInfo.startOfSegment - timingInfo.start
      };
      if (shouldSaveTimelineMapping) {
        this.timelines[segmentInfo.timeline] = mappingObj;
        this.trigger("timestampoffset");
        this.logger_("time mapping for timeline " + segmentInfo.timeline + ": " + ("[time: " + mappingObj.time + "] [mapping: " + mappingObj.mapping + "]"));
      }
      start2 = segmentInfo.startOfSegment;
      end3 = timingInfo.end + mappingObj.mapping;
    } else if (mappingObj) {
      start2 = timingInfo.start + mappingObj.mapping;
      end3 = timingInfo.end + mappingObj.mapping;
    } else {
      return false;
    }
    if (part) {
      part.start = start2;
      part.end = end3;
    }
    if (!segment.start || start2 < segment.start) {
      segment.start = start2;
    }
    segment.end = end3;
    return true;
  };
  _proto.saveDiscontinuitySyncInfo_ = function saveDiscontinuitySyncInfo_(segmentInfo) {
    var playlist = segmentInfo.playlist;
    var segment = segmentInfo.segment;
    if (segment.discontinuity) {
      this.discontinuities[segment.timeline] = {
        time: segment.start,
        accuracy: 0
      };
    } else if (playlist.discontinuityStarts && playlist.discontinuityStarts.length) {
      for (var i = 0; i < playlist.discontinuityStarts.length; i++) {
        var segmentIndex = playlist.discontinuityStarts[i];
        var discontinuity = playlist.discontinuitySequence + i + 1;
        var mediaIndexDiff = segmentIndex - segmentInfo.mediaIndex;
        var accuracy = Math.abs(mediaIndexDiff);
        if (!this.discontinuities[discontinuity] || this.discontinuities[discontinuity].accuracy > accuracy) {
          var time = void 0;
          if (mediaIndexDiff < 0) {
            time = segment.start - sumDurations({
              defaultDuration: playlist.targetDuration,
              durationList: playlist.segments,
              startIndex: segmentInfo.mediaIndex,
              endIndex: segmentIndex
            });
          } else {
            time = segment.end + sumDurations({
              defaultDuration: playlist.targetDuration,
              durationList: playlist.segments,
              startIndex: segmentInfo.mediaIndex + 1,
              endIndex: segmentIndex
            });
          }
          this.discontinuities[discontinuity] = {
            time,
            accuracy
          };
        }
      }
    }
  };
  _proto.dispose = function dispose() {
    this.trigger("dispose");
    this.off();
  };
  return SyncController2;
}(videojs.EventTarget);
var TimelineChangeController = /* @__PURE__ */ function(_videojs$EventTarget) {
  _inheritsLoose(TimelineChangeController2, _videojs$EventTarget);
  function TimelineChangeController2() {
    var _this;
    _this = _videojs$EventTarget.call(this) || this;
    _this.pendingTimelineChanges_ = {};
    _this.lastTimelineChanges_ = {};
    return _this;
  }
  var _proto = TimelineChangeController2.prototype;
  _proto.clearPendingTimelineChange = function clearPendingTimelineChange(type2) {
    this.pendingTimelineChanges_[type2] = null;
    this.trigger("pendingtimelinechange");
  };
  _proto.pendingTimelineChange = function pendingTimelineChange(_ref2) {
    var type2 = _ref2.type, from3 = _ref2.from, to = _ref2.to;
    if (typeof from3 === "number" && typeof to === "number") {
      this.pendingTimelineChanges_[type2] = {
        type: type2,
        from: from3,
        to
      };
      this.trigger("pendingtimelinechange");
    }
    return this.pendingTimelineChanges_[type2];
  };
  _proto.lastTimelineChange = function lastTimelineChange(_ref2) {
    var type2 = _ref2.type, from3 = _ref2.from, to = _ref2.to;
    if (typeof from3 === "number" && typeof to === "number") {
      this.lastTimelineChanges_[type2] = {
        type: type2,
        from: from3,
        to
      };
      delete this.pendingTimelineChanges_[type2];
      this.trigger("timelinechange");
    }
    return this.lastTimelineChanges_[type2];
  };
  _proto.dispose = function dispose() {
    this.trigger("dispose");
    this.pendingTimelineChanges_ = {};
    this.lastTimelineChanges_ = {};
    this.off();
  };
  return TimelineChangeController2;
}(videojs.EventTarget);
var workerCode = transform(getWorkerString(function() {
  var commonjsGlobal2 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
  function createCommonjsModule(fn, basedir, module) {
    return module = {
      path: basedir,
      exports: {},
      require: function require2(path, base) {
        return commonjsRequire(path, base === void 0 || base === null ? module.path : base);
      }
    }, fn(module, module.exports), module.exports;
  }
  function commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }
  var createClass2 = createCommonjsModule(function(module) {
    function _defineProperties2(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    function _createClass2(Constructor, protoProps, staticProps) {
      if (protoProps)
        _defineProperties2(Constructor.prototype, protoProps);
      if (staticProps)
        _defineProperties2(Constructor, staticProps);
      return Constructor;
    }
    module.exports = _createClass2;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  });
  var setPrototypeOf = createCommonjsModule(function(module) {
    function _setPrototypeOf2(o, p2) {
      module.exports = _setPrototypeOf2 = Object.setPrototypeOf || function _setPrototypeOf3(o2, p3) {
        o2.__proto__ = p3;
        return o2;
      };
      module.exports["default"] = module.exports, module.exports.__esModule = true;
      return _setPrototypeOf2(o, p2);
    }
    module.exports = _setPrototypeOf2;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  });
  var inheritsLoose = createCommonjsModule(function(module) {
    function _inheritsLoose2(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      setPrototypeOf(subClass, superClass);
    }
    module.exports = _inheritsLoose2;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  });
  var Stream2 = /* @__PURE__ */ function() {
    function Stream3() {
      this.listeners = {};
    }
    var _proto = Stream3.prototype;
    _proto.on = function on3(type2, listener3) {
      if (!this.listeners[type2]) {
        this.listeners[type2] = [];
      }
      this.listeners[type2].push(listener3);
    };
    _proto.off = function off2(type2, listener3) {
      if (!this.listeners[type2]) {
        return false;
      }
      var index = this.listeners[type2].indexOf(listener3);
      this.listeners[type2] = this.listeners[type2].slice(0);
      this.listeners[type2].splice(index, 1);
      return index > -1;
    };
    _proto.trigger = function trigger2(type2) {
      var callbacks = this.listeners[type2];
      if (!callbacks) {
        return;
      }
      if (arguments.length === 2) {
        var length = callbacks.length;
        for (var i = 0; i < length; ++i) {
          callbacks[i].call(this, arguments[1]);
        }
      } else {
        var args = Array.prototype.slice.call(arguments, 1);
        var _length = callbacks.length;
        for (var _i = 0; _i < _length; ++_i) {
          callbacks[_i].apply(this, args);
        }
      }
    };
    _proto.dispose = function dispose() {
      this.listeners = {};
    };
    _proto.pipe = function pipe(destination) {
      this.on("data", function(data) {
        destination.push(data);
      });
    };
    return Stream3;
  }();
  /*! @name pkcs7 @version 1.0.4 @license Apache-2.0 */
  function unpad(padded) {
    return padded.subarray(0, padded.byteLength - padded[padded.byteLength - 1]);
  }
  /*! @name aes-decrypter @version 3.1.3 @license Apache-2.0 */
  var precompute = function precompute2() {
    var tables = [[[], [], [], [], []], [[], [], [], [], []]];
    var encTable = tables[0];
    var decTable = tables[1];
    var sbox = encTable[4];
    var sboxInv = decTable[4];
    var i;
    var x;
    var xInv;
    var d3 = [];
    var th2 = [];
    var x2;
    var x4;
    var x8;
    var s;
    var tEnc;
    var tDec;
    for (i = 0; i < 256; i++) {
      th2[(d3[i] = i << 1 ^ (i >> 7) * 283) ^ i] = i;
    }
    for (x = xInv = 0; !sbox[x]; x ^= x2 || 1, xInv = th2[xInv] || 1) {
      s = xInv ^ xInv << 1 ^ xInv << 2 ^ xInv << 3 ^ xInv << 4;
      s = s >> 8 ^ s & 255 ^ 99;
      sbox[x] = s;
      sboxInv[s] = x;
      x8 = d3[x4 = d3[x2 = d3[x]]];
      tDec = x8 * 16843009 ^ x4 * 65537 ^ x2 * 257 ^ x * 16843008;
      tEnc = d3[s] * 257 ^ s * 16843008;
      for (i = 0; i < 4; i++) {
        encTable[i][x] = tEnc = tEnc << 24 ^ tEnc >>> 8;
        decTable[i][s] = tDec = tDec << 24 ^ tDec >>> 8;
      }
    }
    for (i = 0; i < 5; i++) {
      encTable[i] = encTable[i].slice(0);
      decTable[i] = decTable[i].slice(0);
    }
    return tables;
  };
  var aesTables = null;
  var AES = /* @__PURE__ */ function() {
    function AES2(key) {
      if (!aesTables) {
        aesTables = precompute();
      }
      this._tables = [[aesTables[0][0].slice(), aesTables[0][1].slice(), aesTables[0][2].slice(), aesTables[0][3].slice(), aesTables[0][4].slice()], [aesTables[1][0].slice(), aesTables[1][1].slice(), aesTables[1][2].slice(), aesTables[1][3].slice(), aesTables[1][4].slice()]];
      var i;
      var j;
      var tmp;
      var sbox = this._tables[0][4];
      var decTable = this._tables[1];
      var keyLen = key.length;
      var rcon = 1;
      if (keyLen !== 4 && keyLen !== 6 && keyLen !== 8) {
        throw new Error("Invalid aes key size");
      }
      var encKey = key.slice(0);
      var decKey = [];
      this._key = [encKey, decKey];
      for (i = keyLen; i < 4 * keyLen + 28; i++) {
        tmp = encKey[i - 1];
        if (i % keyLen === 0 || keyLen === 8 && i % keyLen === 4) {
          tmp = sbox[tmp >>> 24] << 24 ^ sbox[tmp >> 16 & 255] << 16 ^ sbox[tmp >> 8 & 255] << 8 ^ sbox[tmp & 255];
          if (i % keyLen === 0) {
            tmp = tmp << 8 ^ tmp >>> 24 ^ rcon << 24;
            rcon = rcon << 1 ^ (rcon >> 7) * 283;
          }
        }
        encKey[i] = encKey[i - keyLen] ^ tmp;
      }
      for (j = 0; i; j++, i--) {
        tmp = encKey[j & 3 ? i : i - 4];
        if (i <= 4 || j < 4) {
          decKey[j] = tmp;
        } else {
          decKey[j] = decTable[0][sbox[tmp >>> 24]] ^ decTable[1][sbox[tmp >> 16 & 255]] ^ decTable[2][sbox[tmp >> 8 & 255]] ^ decTable[3][sbox[tmp & 255]];
        }
      }
    }
    var _proto = AES2.prototype;
    _proto.decrypt = function decrypt4(encrypted0, encrypted1, encrypted2, encrypted3, out, offset2) {
      var key = this._key[1];
      var a = encrypted0 ^ key[0];
      var b = encrypted3 ^ key[1];
      var c = encrypted2 ^ key[2];
      var d3 = encrypted1 ^ key[3];
      var a2;
      var b2;
      var c2;
      var nInnerRounds = key.length / 4 - 2;
      var i;
      var kIndex = 4;
      var table2 = this._tables[1];
      var table0 = table2[0];
      var table1 = table2[1];
      var table22 = table2[2];
      var table3 = table2[3];
      var sbox = table2[4];
      for (i = 0; i < nInnerRounds; i++) {
        a2 = table0[a >>> 24] ^ table1[b >> 16 & 255] ^ table22[c >> 8 & 255] ^ table3[d3 & 255] ^ key[kIndex];
        b2 = table0[b >>> 24] ^ table1[c >> 16 & 255] ^ table22[d3 >> 8 & 255] ^ table3[a & 255] ^ key[kIndex + 1];
        c2 = table0[c >>> 24] ^ table1[d3 >> 16 & 255] ^ table22[a >> 8 & 255] ^ table3[b & 255] ^ key[kIndex + 2];
        d3 = table0[d3 >>> 24] ^ table1[a >> 16 & 255] ^ table22[b >> 8 & 255] ^ table3[c & 255] ^ key[kIndex + 3];
        kIndex += 4;
        a = a2;
        b = b2;
        c = c2;
      }
      for (i = 0; i < 4; i++) {
        out[(3 & -i) + offset2] = sbox[a >>> 24] << 24 ^ sbox[b >> 16 & 255] << 16 ^ sbox[c >> 8 & 255] << 8 ^ sbox[d3 & 255] ^ key[kIndex++];
        a2 = a;
        a = b;
        b = c;
        c = d3;
        d3 = a2;
      }
    };
    return AES2;
  }();
  var AsyncStream = /* @__PURE__ */ function(_Stream) {
    inheritsLoose(AsyncStream2, _Stream);
    function AsyncStream2() {
      var _this;
      _this = _Stream.call(this, Stream2) || this;
      _this.jobs = [];
      _this.delay = 1;
      _this.timeout_ = null;
      return _this;
    }
    var _proto = AsyncStream2.prototype;
    _proto.processJob_ = function processJob_() {
      this.jobs.shift()();
      if (this.jobs.length) {
        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
      } else {
        this.timeout_ = null;
      }
    };
    _proto.push = function push(job) {
      this.jobs.push(job);
      if (!this.timeout_) {
        this.timeout_ = setTimeout(this.processJob_.bind(this), this.delay);
      }
    };
    return AsyncStream2;
  }(Stream2);
  var ntoh = function ntoh2(word) {
    return word << 24 | (word & 65280) << 8 | (word & 16711680) >> 8 | word >>> 24;
  };
  var decrypt3 = function decrypt4(encrypted, key, initVector) {
    var encrypted32 = new Int32Array(encrypted.buffer, encrypted.byteOffset, encrypted.byteLength >> 2);
    var decipher = new AES(Array.prototype.slice.call(key));
    var decrypted = new Uint8Array(encrypted.byteLength);
    var decrypted32 = new Int32Array(decrypted.buffer);
    var init0;
    var init1;
    var init2;
    var init3;
    var encrypted0;
    var encrypted1;
    var encrypted2;
    var encrypted3;
    var wordIx;
    init0 = initVector[0];
    init1 = initVector[1];
    init2 = initVector[2];
    init3 = initVector[3];
    for (wordIx = 0; wordIx < encrypted32.length; wordIx += 4) {
      encrypted0 = ntoh(encrypted32[wordIx]);
      encrypted1 = ntoh(encrypted32[wordIx + 1]);
      encrypted2 = ntoh(encrypted32[wordIx + 2]);
      encrypted3 = ntoh(encrypted32[wordIx + 3]);
      decipher.decrypt(encrypted0, encrypted1, encrypted2, encrypted3, decrypted32, wordIx);
      decrypted32[wordIx] = ntoh(decrypted32[wordIx] ^ init0);
      decrypted32[wordIx + 1] = ntoh(decrypted32[wordIx + 1] ^ init1);
      decrypted32[wordIx + 2] = ntoh(decrypted32[wordIx + 2] ^ init2);
      decrypted32[wordIx + 3] = ntoh(decrypted32[wordIx + 3] ^ init3);
      init0 = encrypted0;
      init1 = encrypted1;
      init2 = encrypted2;
      init3 = encrypted3;
    }
    return decrypted;
  };
  var Decrypter2 = /* @__PURE__ */ function() {
    function Decrypter3(encrypted, key, initVector, done) {
      var step = Decrypter3.STEP;
      var encrypted32 = new Int32Array(encrypted.buffer);
      var decrypted = new Uint8Array(encrypted.byteLength);
      var i = 0;
      this.asyncStream_ = new AsyncStream();
      this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
      for (i = step; i < encrypted32.length; i += step) {
        initVector = new Uint32Array([ntoh(encrypted32[i - 4]), ntoh(encrypted32[i - 3]), ntoh(encrypted32[i - 2]), ntoh(encrypted32[i - 1])]);
        this.asyncStream_.push(this.decryptChunk_(encrypted32.subarray(i, i + step), key, initVector, decrypted));
      }
      this.asyncStream_.push(function() {
        done(null, unpad(decrypted));
      });
    }
    var _proto = Decrypter3.prototype;
    _proto.decryptChunk_ = function decryptChunk_(encrypted, key, initVector, decrypted) {
      return function() {
        var bytes = decrypt3(encrypted, key, initVector);
        decrypted.set(bytes, encrypted.byteOffset);
      };
    };
    createClass2(Decrypter3, null, [{
      key: "STEP",
      get: function get7() {
        return 32e3;
      }
    }]);
    return Decrypter3;
  }();
  var win2;
  if (typeof window !== "undefined") {
    win2 = window;
  } else if (typeof commonjsGlobal2 !== "undefined") {
    win2 = commonjsGlobal2;
  } else if (typeof self !== "undefined") {
    win2 = self;
  } else {
    win2 = {};
  }
  var window_12 = win2;
  var isArrayBufferView3 = function isArrayBufferView4(obj) {
    if (ArrayBuffer.isView === "function") {
      return ArrayBuffer.isView(obj);
    }
    return obj && obj.buffer instanceof ArrayBuffer;
  };
  var BigInt2 = window_12.BigInt || Number;
  [BigInt2("0x1"), BigInt2("0x100"), BigInt2("0x10000"), BigInt2("0x1000000"), BigInt2("0x100000000"), BigInt2("0x10000000000"), BigInt2("0x1000000000000"), BigInt2("0x100000000000000"), BigInt2("0x10000000000000000")];
  var createTransferableMessage3 = function createTransferableMessage4(message) {
    var transferable = {};
    Object.keys(message).forEach(function(key) {
      var value = message[key];
      if (isArrayBufferView3(value)) {
        transferable[key] = {
          bytes: value.buffer,
          byteOffset: value.byteOffset,
          byteLength: value.byteLength
        };
      } else {
        transferable[key] = value;
      }
    });
    return transferable;
  };
  self.onmessage = function(event) {
    var data = event.data;
    var encrypted = new Uint8Array(data.encrypted.bytes, data.encrypted.byteOffset, data.encrypted.byteLength);
    var key = new Uint32Array(data.key.bytes, data.key.byteOffset, data.key.byteLength / 4);
    var iv = new Uint32Array(data.iv.bytes, data.iv.byteOffset, data.iv.byteLength / 4);
    new Decrypter2(encrypted, key, iv, function(err, bytes) {
      self.postMessage(createTransferableMessage3({
        source: data.source,
        decrypted: bytes
      }), [bytes.buffer]);
    });
  };
}));
var Decrypter = factory(workerCode);
var audioTrackKind_ = function audioTrackKind_2(properties) {
  var kind = properties["default"] ? "main" : "alternative";
  if (properties.characteristics && properties.characteristics.indexOf("public.accessibility.describes-video") >= 0) {
    kind = "main-desc";
  }
  return kind;
};
var stopLoaders = function stopLoaders2(segmentLoader, mediaType) {
  segmentLoader.abort();
  segmentLoader.pause();
  if (mediaType && mediaType.activePlaylistLoader) {
    mediaType.activePlaylistLoader.pause();
    mediaType.activePlaylistLoader = null;
  }
};
var startLoaders = function startLoaders2(playlistLoader, mediaType) {
  mediaType.activePlaylistLoader = playlistLoader;
  playlistLoader.load();
};
var onGroupChanged = function onGroupChanged2(type2, settings) {
  return function() {
    var _settings$segmentLoad = settings.segmentLoaders, segmentLoader = _settings$segmentLoad[type2], mainSegmentLoader = _settings$segmentLoad.main, mediaType = settings.mediaTypes[type2];
    var activeTrack2 = mediaType.activeTrack();
    var activeGroup3 = mediaType.getActiveGroup();
    var previousActiveLoader = mediaType.activePlaylistLoader;
    var lastGroup = mediaType.lastGroup_;
    if (activeGroup3 && lastGroup && activeGroup3.id === lastGroup.id) {
      return;
    }
    mediaType.lastGroup_ = activeGroup3;
    mediaType.lastTrack_ = activeTrack2;
    stopLoaders(segmentLoader, mediaType);
    if (!activeGroup3 || activeGroup3.isMasterPlaylist) {
      return;
    }
    if (!activeGroup3.playlistLoader) {
      if (previousActiveLoader) {
        mainSegmentLoader.resetEverything();
      }
      return;
    }
    segmentLoader.resyncLoader();
    startLoaders(activeGroup3.playlistLoader, mediaType);
  };
};
var onGroupChanging = function onGroupChanging2(type2, settings) {
  return function() {
    var segmentLoader = settings.segmentLoaders[type2], mediaType = settings.mediaTypes[type2];
    mediaType.lastGroup_ = null;
    segmentLoader.abort();
    segmentLoader.pause();
  };
};
var onTrackChanged = function onTrackChanged2(type2, settings) {
  return function() {
    var masterPlaylistLoader = settings.masterPlaylistLoader, _settings$segmentLoad2 = settings.segmentLoaders, segmentLoader = _settings$segmentLoad2[type2], mainSegmentLoader = _settings$segmentLoad2.main, mediaType = settings.mediaTypes[type2];
    var activeTrack2 = mediaType.activeTrack();
    var activeGroup3 = mediaType.getActiveGroup();
    var previousActiveLoader = mediaType.activePlaylistLoader;
    var lastTrack = mediaType.lastTrack_;
    if (lastTrack && activeTrack2 && lastTrack.id === activeTrack2.id) {
      return;
    }
    mediaType.lastGroup_ = activeGroup3;
    mediaType.lastTrack_ = activeTrack2;
    stopLoaders(segmentLoader, mediaType);
    if (!activeGroup3) {
      return;
    }
    if (activeGroup3.isMasterPlaylist) {
      if (!activeTrack2 || !lastTrack || activeTrack2.id === lastTrack.id) {
        return;
      }
      var mpc = settings.vhs.masterPlaylistController_;
      var newPlaylist = mpc.selectPlaylist();
      if (mpc.media() === newPlaylist) {
        return;
      }
      mediaType.logger_("track change. Switching master audio from " + lastTrack.id + " to " + activeTrack2.id);
      masterPlaylistLoader.pause();
      mainSegmentLoader.resetEverything();
      mpc.fastQualityChange_(newPlaylist);
      return;
    }
    if (type2 === "AUDIO") {
      if (!activeGroup3.playlistLoader) {
        mainSegmentLoader.setAudio(true);
        mainSegmentLoader.resetEverything();
        return;
      }
      segmentLoader.setAudio(true);
      mainSegmentLoader.setAudio(false);
    }
    if (previousActiveLoader === activeGroup3.playlistLoader) {
      startLoaders(activeGroup3.playlistLoader, mediaType);
      return;
    }
    if (segmentLoader.track) {
      segmentLoader.track(activeTrack2);
    }
    segmentLoader.resetEverything();
    startLoaders(activeGroup3.playlistLoader, mediaType);
  };
};
var onError = {
  AUDIO: function AUDIO(type2, settings) {
    return function() {
      var segmentLoader = settings.segmentLoaders[type2], mediaType = settings.mediaTypes[type2], blacklistCurrentPlaylist = settings.blacklistCurrentPlaylist;
      stopLoaders(segmentLoader, mediaType);
      var activeTrack2 = mediaType.activeTrack();
      var activeGroup3 = mediaType.activeGroup();
      var id2 = (activeGroup3.filter(function(group) {
        return group["default"];
      })[0] || activeGroup3[0]).id;
      var defaultTrack = mediaType.tracks[id2];
      if (activeTrack2 === defaultTrack) {
        blacklistCurrentPlaylist({
          message: "Problem encountered loading the default audio track."
        });
        return;
      }
      videojs.log.warn("Problem encountered loading the alternate audio track.Switching back to default.");
      for (var trackId in mediaType.tracks) {
        mediaType.tracks[trackId].enabled = mediaType.tracks[trackId] === defaultTrack;
      }
      mediaType.onTrackChanged();
    };
  },
  SUBTITLES: function SUBTITLES(type2, settings) {
    return function() {
      var segmentLoader = settings.segmentLoaders[type2], mediaType = settings.mediaTypes[type2];
      videojs.log.warn("Problem encountered loading the subtitle track.Disabling subtitle track.");
      stopLoaders(segmentLoader, mediaType);
      var track = mediaType.activeTrack();
      if (track) {
        track.mode = "disabled";
      }
      mediaType.onTrackChanged();
    };
  }
};
var setupListeners = {
  AUDIO: function AUDIO2(type2, playlistLoader, settings) {
    if (!playlistLoader) {
      return;
    }
    var tech = settings.tech, requestOptions = settings.requestOptions, segmentLoader = settings.segmentLoaders[type2];
    playlistLoader.on("loadedmetadata", function() {
      var media = playlistLoader.media();
      segmentLoader.playlist(media, requestOptions);
      if (!tech.paused() || media.endList && tech.preload() !== "none") {
        segmentLoader.load();
      }
    });
    playlistLoader.on("loadedplaylist", function() {
      segmentLoader.playlist(playlistLoader.media(), requestOptions);
      if (!tech.paused()) {
        segmentLoader.load();
      }
    });
    playlistLoader.on("error", onError[type2](type2, settings));
  },
  SUBTITLES: function SUBTITLES2(type2, playlistLoader, settings) {
    var tech = settings.tech, requestOptions = settings.requestOptions, segmentLoader = settings.segmentLoaders[type2], mediaType = settings.mediaTypes[type2];
    playlistLoader.on("loadedmetadata", function() {
      var media = playlistLoader.media();
      segmentLoader.playlist(media, requestOptions);
      segmentLoader.track(mediaType.activeTrack());
      if (!tech.paused() || media.endList && tech.preload() !== "none") {
        segmentLoader.load();
      }
    });
    playlistLoader.on("loadedplaylist", function() {
      segmentLoader.playlist(playlistLoader.media(), requestOptions);
      if (!tech.paused()) {
        segmentLoader.load();
      }
    });
    playlistLoader.on("error", onError[type2](type2, settings));
  }
};
var initialize = {
  "AUDIO": function AUDIO3(type2, settings) {
    var vhs = settings.vhs, sourceType = settings.sourceType, segmentLoader = settings.segmentLoaders[type2], requestOptions = settings.requestOptions, mediaGroups = settings.master.mediaGroups, _settings$mediaTypes$ = settings.mediaTypes[type2], groups = _settings$mediaTypes$.groups, tracks = _settings$mediaTypes$.tracks, logger_ = _settings$mediaTypes$.logger_, masterPlaylistLoader = settings.masterPlaylistLoader;
    var audioOnlyMaster = isAudioOnly(masterPlaylistLoader.master);
    if (!mediaGroups[type2] || Object.keys(mediaGroups[type2]).length === 0) {
      mediaGroups[type2] = {
        main: {
          "default": {
            "default": true
          }
        }
      };
      if (audioOnlyMaster) {
        mediaGroups[type2].main["default"].playlists = masterPlaylistLoader.master.playlists;
      }
    }
    for (var groupId in mediaGroups[type2]) {
      if (!groups[groupId]) {
        groups[groupId] = [];
      }
      for (var variantLabel in mediaGroups[type2][groupId]) {
        var properties = mediaGroups[type2][groupId][variantLabel];
        var playlistLoader = void 0;
        if (audioOnlyMaster) {
          logger_("AUDIO group '" + groupId + "' label '" + variantLabel + "' is a master playlist");
          properties.isMasterPlaylist = true;
          playlistLoader = null;
        } else if (sourceType === "vhs-json" && properties.playlists) {
          playlistLoader = new PlaylistLoader(properties.playlists[0], vhs, requestOptions);
        } else if (properties.resolvedUri) {
          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
        } else if (properties.playlists && sourceType === "dash") {
          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
        } else {
          playlistLoader = null;
        }
        properties = videojs.mergeOptions({
          id: variantLabel,
          playlistLoader
        }, properties);
        setupListeners[type2](type2, properties.playlistLoader, settings);
        groups[groupId].push(properties);
        if (typeof tracks[variantLabel] === "undefined") {
          var track = new videojs.AudioTrack({
            id: variantLabel,
            kind: audioTrackKind_(properties),
            enabled: false,
            language: properties.language,
            "default": properties["default"],
            label: variantLabel
          });
          tracks[variantLabel] = track;
        }
      }
    }
    segmentLoader.on("error", onError[type2](type2, settings));
  },
  "SUBTITLES": function SUBTITLES3(type2, settings) {
    var tech = settings.tech, vhs = settings.vhs, sourceType = settings.sourceType, segmentLoader = settings.segmentLoaders[type2], requestOptions = settings.requestOptions, mediaGroups = settings.master.mediaGroups, _settings$mediaTypes$2 = settings.mediaTypes[type2], groups = _settings$mediaTypes$2.groups, tracks = _settings$mediaTypes$2.tracks, masterPlaylistLoader = settings.masterPlaylistLoader;
    for (var groupId in mediaGroups[type2]) {
      if (!groups[groupId]) {
        groups[groupId] = [];
      }
      for (var variantLabel in mediaGroups[type2][groupId]) {
        if (mediaGroups[type2][groupId][variantLabel].forced) {
          continue;
        }
        var properties = mediaGroups[type2][groupId][variantLabel];
        var playlistLoader = void 0;
        if (sourceType === "hls") {
          playlistLoader = new PlaylistLoader(properties.resolvedUri, vhs, requestOptions);
        } else if (sourceType === "dash") {
          var playlists = properties.playlists.filter(function(p2) {
            return p2.excludeUntil !== Infinity;
          });
          if (!playlists.length) {
            return;
          }
          playlistLoader = new DashPlaylistLoader(properties.playlists[0], vhs, requestOptions, masterPlaylistLoader);
        } else if (sourceType === "vhs-json") {
          playlistLoader = new PlaylistLoader(properties.playlists ? properties.playlists[0] : properties.resolvedUri, vhs, requestOptions);
        }
        properties = videojs.mergeOptions({
          id: variantLabel,
          playlistLoader
        }, properties);
        setupListeners[type2](type2, properties.playlistLoader, settings);
        groups[groupId].push(properties);
        if (typeof tracks[variantLabel] === "undefined") {
          var track = tech.addRemoteTextTrack({
            id: variantLabel,
            kind: "subtitles",
            "default": properties["default"] && properties.autoselect,
            language: properties.language,
            label: variantLabel
          }, false).track;
          tracks[variantLabel] = track;
        }
      }
    }
    segmentLoader.on("error", onError[type2](type2, settings));
  },
  "CLOSED-CAPTIONS": function CLOSEDCAPTIONS(type2, settings) {
    var tech = settings.tech, mediaGroups = settings.master.mediaGroups, _settings$mediaTypes$3 = settings.mediaTypes[type2], groups = _settings$mediaTypes$3.groups, tracks = _settings$mediaTypes$3.tracks;
    for (var groupId in mediaGroups[type2]) {
      if (!groups[groupId]) {
        groups[groupId] = [];
      }
      for (var variantLabel in mediaGroups[type2][groupId]) {
        var properties = mediaGroups[type2][groupId][variantLabel];
        if (!/^(?:CC|SERVICE)/.test(properties.instreamId)) {
          continue;
        }
        var captionServices = tech.options_.vhs && tech.options_.vhs.captionServices || {};
        var newProps = {
          label: variantLabel,
          language: properties.language,
          instreamId: properties.instreamId,
          "default": properties["default"] && properties.autoselect
        };
        if (captionServices[newProps.instreamId]) {
          newProps = videojs.mergeOptions(newProps, captionServices[newProps.instreamId]);
        }
        if (newProps["default"] === void 0) {
          delete newProps["default"];
        }
        groups[groupId].push(videojs.mergeOptions({
          id: variantLabel
        }, properties));
        if (typeof tracks[variantLabel] === "undefined") {
          var track = tech.addRemoteTextTrack({
            id: newProps.instreamId,
            kind: "captions",
            "default": newProps["default"],
            language: newProps.language,
            label: newProps.label
          }, false).track;
          tracks[variantLabel] = track;
        }
      }
    }
  }
};
var groupMatch = function groupMatch2(list, media) {
  for (var i = 0; i < list.length; i++) {
    if (playlistMatch(media, list[i])) {
      return true;
    }
    if (list[i].playlists && groupMatch2(list[i].playlists, media)) {
      return true;
    }
  }
  return false;
};
var activeGroup = function activeGroup2(type2, settings) {
  return function(track) {
    var masterPlaylistLoader = settings.masterPlaylistLoader, groups = settings.mediaTypes[type2].groups;
    var media = masterPlaylistLoader.media();
    if (!media) {
      return null;
    }
    var variants = null;
    if (media.attributes[type2]) {
      variants = groups[media.attributes[type2]];
    }
    var groupKeys = Object.keys(groups);
    if (!variants) {
      if (type2 === "AUDIO" && groupKeys.length > 1 && isAudioOnly(settings.master)) {
        for (var i = 0; i < groupKeys.length; i++) {
          var groupPropertyList = groups[groupKeys[i]];
          if (groupMatch(groupPropertyList, media)) {
            variants = groupPropertyList;
            break;
          }
        }
      } else if (groups.main) {
        variants = groups.main;
      } else if (groupKeys.length === 1) {
        variants = groups[groupKeys[0]];
      }
    }
    if (typeof track === "undefined") {
      return variants;
    }
    if (track === null || !variants) {
      return null;
    }
    return variants.filter(function(props) {
      return props.id === track.id;
    })[0] || null;
  };
};
var activeTrack = {
  AUDIO: function AUDIO4(type2, settings) {
    return function() {
      var tracks = settings.mediaTypes[type2].tracks;
      for (var id2 in tracks) {
        if (tracks[id2].enabled) {
          return tracks[id2];
        }
      }
      return null;
    };
  },
  SUBTITLES: function SUBTITLES4(type2, settings) {
    return function() {
      var tracks = settings.mediaTypes[type2].tracks;
      for (var id2 in tracks) {
        if (tracks[id2].mode === "showing" || tracks[id2].mode === "hidden") {
          return tracks[id2];
        }
      }
      return null;
    };
  }
};
var getActiveGroup = function getActiveGroup2(type2, _ref2) {
  var mediaTypes2 = _ref2.mediaTypes;
  return function() {
    var activeTrack_ = mediaTypes2[type2].activeTrack();
    if (!activeTrack_) {
      return null;
    }
    return mediaTypes2[type2].activeGroup(activeTrack_);
  };
};
var setupMediaGroups = function setupMediaGroups2(settings) {
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(type2) {
    initialize[type2](type2, settings);
  });
  var mediaTypes2 = settings.mediaTypes, masterPlaylistLoader = settings.masterPlaylistLoader, tech = settings.tech, vhs = settings.vhs, _settings$segmentLoad3 = settings.segmentLoaders, audioSegmentLoader = _settings$segmentLoad3["AUDIO"], mainSegmentLoader = _settings$segmentLoad3.main;
  ["AUDIO", "SUBTITLES"].forEach(function(type2) {
    mediaTypes2[type2].activeGroup = activeGroup(type2, settings);
    mediaTypes2[type2].activeTrack = activeTrack[type2](type2, settings);
    mediaTypes2[type2].onGroupChanged = onGroupChanged(type2, settings);
    mediaTypes2[type2].onGroupChanging = onGroupChanging(type2, settings);
    mediaTypes2[type2].onTrackChanged = onTrackChanged(type2, settings);
    mediaTypes2[type2].getActiveGroup = getActiveGroup(type2, settings);
  });
  var audioGroup = mediaTypes2.AUDIO.activeGroup();
  if (audioGroup) {
    var groupId = (audioGroup.filter(function(group) {
      return group["default"];
    })[0] || audioGroup[0]).id;
    mediaTypes2.AUDIO.tracks[groupId].enabled = true;
    mediaTypes2.AUDIO.onGroupChanged();
    mediaTypes2.AUDIO.onTrackChanged();
    var activeAudioGroup = mediaTypes2.AUDIO.getActiveGroup();
    if (!activeAudioGroup.playlistLoader) {
      mainSegmentLoader.setAudio(true);
    } else {
      mainSegmentLoader.setAudio(false);
      audioSegmentLoader.setAudio(true);
    }
  }
  masterPlaylistLoader.on("mediachange", function() {
    ["AUDIO", "SUBTITLES"].forEach(function(type2) {
      return mediaTypes2[type2].onGroupChanged();
    });
  });
  masterPlaylistLoader.on("mediachanging", function() {
    ["AUDIO", "SUBTITLES"].forEach(function(type2) {
      return mediaTypes2[type2].onGroupChanging();
    });
  });
  var onAudioTrackChanged = function onAudioTrackChanged2() {
    mediaTypes2.AUDIO.onTrackChanged();
    tech.trigger({
      type: "usage",
      name: "vhs-audio-change"
    });
    tech.trigger({
      type: "usage",
      name: "hls-audio-change"
    });
  };
  tech.audioTracks().addEventListener("change", onAudioTrackChanged);
  tech.remoteTextTracks().addEventListener("change", mediaTypes2.SUBTITLES.onTrackChanged);
  vhs.on("dispose", function() {
    tech.audioTracks().removeEventListener("change", onAudioTrackChanged);
    tech.remoteTextTracks().removeEventListener("change", mediaTypes2.SUBTITLES.onTrackChanged);
  });
  tech.clearTracks("audio");
  for (var id2 in mediaTypes2.AUDIO.tracks) {
    tech.audioTracks().addTrack(mediaTypes2.AUDIO.tracks[id2]);
  }
};
var createMediaTypes = function createMediaTypes2() {
  var mediaTypes2 = {};
  ["AUDIO", "SUBTITLES", "CLOSED-CAPTIONS"].forEach(function(type2) {
    mediaTypes2[type2] = {
      groups: {},
      tracks: {},
      activePlaylistLoader: null,
      activeGroup: noop$3,
      activeTrack: noop$3,
      getActiveGroup: noop$3,
      onGroupChanged: noop$3,
      onTrackChanged: noop$3,
      lastTrack_: null,
      logger_: logger("MediaGroups[" + type2 + "]")
    };
  });
  return mediaTypes2;
};
var ABORT_EARLY_BLACKLIST_SECONDS = 60 * 2;
var Vhs$1;
var loaderStats = ["mediaRequests", "mediaRequestsAborted", "mediaRequestsTimedout", "mediaRequestsErrored", "mediaTransferDuration", "mediaBytesTransferred", "mediaAppends"];
var sumLoaderStat = function sumLoaderStat2(stat) {
  return this.audioSegmentLoader_[stat] + this.mainSegmentLoader_[stat];
};
var shouldSwitchToMedia = function shouldSwitchToMedia2(_ref2) {
  var currentPlaylist = _ref2.currentPlaylist, buffered = _ref2.buffered, currentTime = _ref2.currentTime, nextPlaylist = _ref2.nextPlaylist, bufferLowWaterLine = _ref2.bufferLowWaterLine, bufferHighWaterLine = _ref2.bufferHighWaterLine, duration5 = _ref2.duration, experimentalBufferBasedABR = _ref2.experimentalBufferBasedABR, log2 = _ref2.log;
  if (!nextPlaylist) {
    videojs.log.warn("We received no playlist to switch to. Please check your stream.");
    return false;
  }
  var sharedLogLine = "allowing switch " + (currentPlaylist && currentPlaylist.id || "null") + " -> " + nextPlaylist.id;
  if (!currentPlaylist) {
    log2(sharedLogLine + " as current playlist is not set");
    return true;
  }
  if (nextPlaylist.id === currentPlaylist.id) {
    return false;
  }
  var isBuffered = Boolean(findRange(buffered, currentTime).length);
  if (!currentPlaylist.endList) {
    if (!isBuffered && typeof currentPlaylist.partTargetDuration === "number") {
      log2("not " + sharedLogLine + " as current playlist is live llhls, but currentTime isn't in buffered.");
      return false;
    }
    log2(sharedLogLine + " as current playlist is live");
    return true;
  }
  var forwardBuffer = timeAheadOf(buffered, currentTime);
  var maxBufferLowWaterLine = experimentalBufferBasedABR ? Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE : Config.MAX_BUFFER_LOW_WATER_LINE;
  if (duration5 < maxBufferLowWaterLine) {
    log2(sharedLogLine + " as duration < max low water line (" + duration5 + " < " + maxBufferLowWaterLine + ")");
    return true;
  }
  var nextBandwidth = nextPlaylist.attributes.BANDWIDTH;
  var currBandwidth = currentPlaylist.attributes.BANDWIDTH;
  if (nextBandwidth < currBandwidth && (!experimentalBufferBasedABR || forwardBuffer < bufferHighWaterLine)) {
    var logLine = sharedLogLine + " as next bandwidth < current bandwidth (" + nextBandwidth + " < " + currBandwidth + ")";
    if (experimentalBufferBasedABR) {
      logLine += " and forwardBuffer < bufferHighWaterLine (" + forwardBuffer + " < " + bufferHighWaterLine + ")";
    }
    log2(logLine);
    return true;
  }
  if ((!experimentalBufferBasedABR || nextBandwidth > currBandwidth) && forwardBuffer >= bufferLowWaterLine) {
    var _logLine = sharedLogLine + " as forwardBuffer >= bufferLowWaterLine (" + forwardBuffer + " >= " + bufferLowWaterLine + ")";
    if (experimentalBufferBasedABR) {
      _logLine += " and next bandwidth > current bandwidth (" + nextBandwidth + " > " + currBandwidth + ")";
    }
    log2(_logLine);
    return true;
  }
  log2("not " + sharedLogLine + " as no switching criteria met");
  return false;
};
var MasterPlaylistController = /* @__PURE__ */ function(_videojs$EventTarget) {
  _inheritsLoose(MasterPlaylistController2, _videojs$EventTarget);
  function MasterPlaylistController2(options) {
    var _this;
    _this = _videojs$EventTarget.call(this) || this;
    var src = options.src, handleManifestRedirects = options.handleManifestRedirects, withCredentials = options.withCredentials, tech = options.tech, bandwidth2 = options.bandwidth, externVhs = options.externVhs, useCueTags = options.useCueTags, blacklistDuration = options.blacklistDuration, enableLowInitialPlaylist = options.enableLowInitialPlaylist, sourceType = options.sourceType, cacheEncryptionKeys = options.cacheEncryptionKeys, experimentalBufferBasedABR = options.experimentalBufferBasedABR, experimentalLeastPixelDiffSelector = options.experimentalLeastPixelDiffSelector, captionServices = options.captionServices;
    if (!src) {
      throw new Error("A non-empty playlist URL or JSON manifest string is required");
    }
    var maxPlaylistRetries = options.maxPlaylistRetries;
    if (maxPlaylistRetries === null || typeof maxPlaylistRetries === "undefined") {
      maxPlaylistRetries = Infinity;
    }
    Vhs$1 = externVhs;
    _this.experimentalBufferBasedABR = Boolean(experimentalBufferBasedABR);
    _this.experimentalLeastPixelDiffSelector = Boolean(experimentalLeastPixelDiffSelector);
    _this.withCredentials = withCredentials;
    _this.tech_ = tech;
    _this.vhs_ = tech.vhs;
    _this.sourceType_ = sourceType;
    _this.useCueTags_ = useCueTags;
    _this.blacklistDuration = blacklistDuration;
    _this.maxPlaylistRetries = maxPlaylistRetries;
    _this.enableLowInitialPlaylist = enableLowInitialPlaylist;
    if (_this.useCueTags_) {
      _this.cueTagsTrack_ = _this.tech_.addTextTrack("metadata", "ad-cues");
      _this.cueTagsTrack_.inBandMetadataTrackDispatchType = "";
    }
    _this.requestOptions_ = {
      withCredentials,
      handleManifestRedirects,
      maxPlaylistRetries,
      timeout: null
    };
    _this.on("error", _this.pauseLoading);
    _this.mediaTypes_ = createMediaTypes();
    _this.mediaSource = new window_1.MediaSource();
    _this.handleDurationChange_ = _this.handleDurationChange_.bind(_assertThisInitialized(_this));
    _this.handleSourceOpen_ = _this.handleSourceOpen_.bind(_assertThisInitialized(_this));
    _this.handleSourceEnded_ = _this.handleSourceEnded_.bind(_assertThisInitialized(_this));
    _this.mediaSource.addEventListener("durationchange", _this.handleDurationChange_);
    _this.mediaSource.addEventListener("sourceopen", _this.handleSourceOpen_);
    _this.mediaSource.addEventListener("sourceended", _this.handleSourceEnded_);
    _this.seekable_ = videojs.createTimeRanges();
    _this.hasPlayed_ = false;
    _this.syncController_ = new SyncController(options);
    _this.segmentMetadataTrack_ = tech.addRemoteTextTrack({
      kind: "metadata",
      label: "segment-metadata"
    }, false).track;
    _this.decrypter_ = new Decrypter();
    _this.sourceUpdater_ = new SourceUpdater(_this.mediaSource);
    _this.inbandTextTracks_ = {};
    _this.timelineChangeController_ = new TimelineChangeController();
    var segmentLoaderSettings = {
      vhs: _this.vhs_,
      parse708captions: options.parse708captions,
      useDtsForTimestampOffset: options.useDtsForTimestampOffset,
      captionServices,
      mediaSource: _this.mediaSource,
      currentTime: _this.tech_.currentTime.bind(_this.tech_),
      seekable: function seekable3() {
        return _this.seekable();
      },
      seeking: function seeking() {
        return _this.tech_.seeking();
      },
      duration: function duration5() {
        return _this.duration();
      },
      hasPlayed: function hasPlayed() {
        return _this.hasPlayed_;
      },
      goalBufferLength: function goalBufferLength() {
        return _this.goalBufferLength();
      },
      bandwidth: bandwidth2,
      syncController: _this.syncController_,
      decrypter: _this.decrypter_,
      sourceType: _this.sourceType_,
      inbandTextTracks: _this.inbandTextTracks_,
      cacheEncryptionKeys,
      sourceUpdater: _this.sourceUpdater_,
      timelineChangeController: _this.timelineChangeController_,
      experimentalExactManifestTimings: options.experimentalExactManifestTimings
    };
    _this.masterPlaylistLoader_ = _this.sourceType_ === "dash" ? new DashPlaylistLoader(src, _this.vhs_, _this.requestOptions_) : new PlaylistLoader(src, _this.vhs_, _this.requestOptions_);
    _this.setupMasterPlaylistLoaderListeners_();
    _this.mainSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
      segmentMetadataTrack: _this.segmentMetadataTrack_,
      loaderType: "main"
    }), options);
    _this.audioSegmentLoader_ = new SegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
      loaderType: "audio"
    }), options);
    _this.subtitleSegmentLoader_ = new VTTSegmentLoader(videojs.mergeOptions(segmentLoaderSettings, {
      loaderType: "vtt",
      featuresNativeTextTracks: _this.tech_.featuresNativeTextTracks,
      loadVttJs: function loadVttJs() {
        return new Promise(function(resolve, reject) {
          function onLoad() {
            tech.off("vttjserror", onError2);
            resolve();
          }
          function onError2() {
            tech.off("vttjsloaded", onLoad);
            reject();
          }
          tech.one("vttjsloaded", onLoad);
          tech.one("vttjserror", onError2);
          tech.addWebVttScript_();
        });
      }
    }), options);
    _this.setupSegmentLoaderListeners_();
    if (_this.experimentalBufferBasedABR) {
      _this.masterPlaylistLoader_.one("loadedplaylist", function() {
        return _this.startABRTimer_();
      });
      _this.tech_.on("pause", function() {
        return _this.stopABRTimer_();
      });
      _this.tech_.on("play", function() {
        return _this.startABRTimer_();
      });
    }
    loaderStats.forEach(function(stat) {
      _this[stat + "_"] = sumLoaderStat.bind(_assertThisInitialized(_this), stat);
    });
    _this.logger_ = logger("MPC");
    _this.triggeredFmp4Usage = false;
    if (_this.tech_.preload() === "none") {
      _this.loadOnPlay_ = function() {
        _this.loadOnPlay_ = null;
        _this.masterPlaylistLoader_.load();
      };
      _this.tech_.one("play", _this.loadOnPlay_);
    } else {
      _this.masterPlaylistLoader_.load();
    }
    _this.timeToLoadedData__ = -1;
    _this.mainAppendsToLoadedData__ = -1;
    _this.audioAppendsToLoadedData__ = -1;
    var event = _this.tech_.preload() === "none" ? "play" : "loadstart";
    _this.tech_.one(event, function() {
      var timeToLoadedDataStart = Date.now();
      _this.tech_.one("loadeddata", function() {
        _this.timeToLoadedData__ = Date.now() - timeToLoadedDataStart;
        _this.mainAppendsToLoadedData__ = _this.mainSegmentLoader_.mediaAppends;
        _this.audioAppendsToLoadedData__ = _this.audioSegmentLoader_.mediaAppends;
      });
    });
    return _this;
  }
  var _proto = MasterPlaylistController2.prototype;
  _proto.mainAppendsToLoadedData_ = function mainAppendsToLoadedData_() {
    return this.mainAppendsToLoadedData__;
  };
  _proto.audioAppendsToLoadedData_ = function audioAppendsToLoadedData_() {
    return this.audioAppendsToLoadedData__;
  };
  _proto.appendsToLoadedData_ = function appendsToLoadedData_() {
    var main = this.mainAppendsToLoadedData_();
    var audio = this.audioAppendsToLoadedData_();
    if (main === -1 || audio === -1) {
      return -1;
    }
    return main + audio;
  };
  _proto.timeToLoadedData_ = function timeToLoadedData_() {
    return this.timeToLoadedData__;
  };
  _proto.checkABR_ = function checkABR_(reason) {
    if (reason === void 0) {
      reason = "abr";
    }
    var nextPlaylist = this.selectPlaylist();
    if (nextPlaylist && this.shouldSwitchToMedia_(nextPlaylist)) {
      this.switchMedia_(nextPlaylist, reason);
    }
  };
  _proto.switchMedia_ = function switchMedia_(playlist, cause, delay) {
    var oldMedia = this.media();
    var oldId = oldMedia && (oldMedia.id || oldMedia.uri);
    var newId = playlist.id || playlist.uri;
    if (oldId && oldId !== newId) {
      this.logger_("switch media " + oldId + " -> " + newId + " from " + cause);
      this.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-change-" + cause
      });
    }
    this.masterPlaylistLoader_.media(playlist, delay);
  };
  _proto.startABRTimer_ = function startABRTimer_() {
    var _this2 = this;
    this.stopABRTimer_();
    this.abrTimer_ = window_1.setInterval(function() {
      return _this2.checkABR_();
    }, 250);
  };
  _proto.stopABRTimer_ = function stopABRTimer_() {
    if (this.tech_.scrubbing && this.tech_.scrubbing()) {
      return;
    }
    window_1.clearInterval(this.abrTimer_);
    this.abrTimer_ = null;
  };
  _proto.getAudioTrackPlaylists_ = function getAudioTrackPlaylists_() {
    var master = this.master();
    var defaultPlaylists = master && master.playlists || [];
    if (!master || !master.mediaGroups || !master.mediaGroups.AUDIO) {
      return defaultPlaylists;
    }
    var AUDIO5 = master.mediaGroups.AUDIO;
    var groupKeys = Object.keys(AUDIO5);
    var track;
    if (Object.keys(this.mediaTypes_.AUDIO.groups).length) {
      track = this.mediaTypes_.AUDIO.activeTrack();
    } else {
      var defaultGroup = AUDIO5.main || groupKeys.length && AUDIO5[groupKeys[0]];
      for (var label in defaultGroup) {
        if (defaultGroup[label]["default"]) {
          track = {
            label
          };
          break;
        }
      }
    }
    if (!track) {
      return defaultPlaylists;
    }
    var playlists = [];
    for (var group in AUDIO5) {
      if (AUDIO5[group][track.label]) {
        var properties = AUDIO5[group][track.label];
        if (properties.playlists && properties.playlists.length) {
          playlists.push.apply(playlists, properties.playlists);
        } else if (properties.uri) {
          playlists.push(properties);
        } else if (master.playlists.length) {
          for (var i = 0; i < master.playlists.length; i++) {
            var playlist = master.playlists[i];
            if (playlist.attributes && playlist.attributes.AUDIO && playlist.attributes.AUDIO === group) {
              playlists.push(playlist);
            }
          }
        }
      }
    }
    if (!playlists.length) {
      return defaultPlaylists;
    }
    return playlists;
  };
  _proto.setupMasterPlaylistLoaderListeners_ = function setupMasterPlaylistLoaderListeners_() {
    var _this3 = this;
    this.masterPlaylistLoader_.on("loadedmetadata", function() {
      var media = _this3.masterPlaylistLoader_.media();
      var requestTimeout = media.targetDuration * 1.5 * 1e3;
      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
        _this3.requestOptions_.timeout = 0;
      } else {
        _this3.requestOptions_.timeout = requestTimeout;
      }
      if (media.endList && _this3.tech_.preload() !== "none") {
        _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
        _this3.mainSegmentLoader_.load();
      }
      setupMediaGroups({
        sourceType: _this3.sourceType_,
        segmentLoaders: {
          AUDIO: _this3.audioSegmentLoader_,
          SUBTITLES: _this3.subtitleSegmentLoader_,
          main: _this3.mainSegmentLoader_
        },
        tech: _this3.tech_,
        requestOptions: _this3.requestOptions_,
        masterPlaylistLoader: _this3.masterPlaylistLoader_,
        vhs: _this3.vhs_,
        master: _this3.master(),
        mediaTypes: _this3.mediaTypes_,
        blacklistCurrentPlaylist: _this3.blacklistCurrentPlaylist.bind(_this3)
      });
      _this3.triggerPresenceUsage_(_this3.master(), media);
      _this3.setupFirstPlay();
      if (!_this3.mediaTypes_.AUDIO.activePlaylistLoader || _this3.mediaTypes_.AUDIO.activePlaylistLoader.media()) {
        _this3.trigger("selectedinitialmedia");
      } else {
        _this3.mediaTypes_.AUDIO.activePlaylistLoader.one("loadedmetadata", function() {
          _this3.trigger("selectedinitialmedia");
        });
      }
    });
    this.masterPlaylistLoader_.on("loadedplaylist", function() {
      if (_this3.loadOnPlay_) {
        _this3.tech_.off("play", _this3.loadOnPlay_);
      }
      var updatedPlaylist = _this3.masterPlaylistLoader_.media();
      if (!updatedPlaylist) {
        _this3.excludeUnsupportedVariants_();
        var selectedMedia;
        if (_this3.enableLowInitialPlaylist) {
          selectedMedia = _this3.selectInitialPlaylist();
        }
        if (!selectedMedia) {
          selectedMedia = _this3.selectPlaylist();
        }
        if (!selectedMedia || !_this3.shouldSwitchToMedia_(selectedMedia)) {
          return;
        }
        _this3.initialMedia_ = selectedMedia;
        _this3.switchMedia_(_this3.initialMedia_, "initial");
        var haveJsonSource = _this3.sourceType_ === "vhs-json" && _this3.initialMedia_.segments;
        if (!haveJsonSource) {
          return;
        }
        updatedPlaylist = _this3.initialMedia_;
      }
      _this3.handleUpdatedMediaPlaylist(updatedPlaylist);
    });
    this.masterPlaylistLoader_.on("error", function() {
      _this3.blacklistCurrentPlaylist(_this3.masterPlaylistLoader_.error);
    });
    this.masterPlaylistLoader_.on("mediachanging", function() {
      _this3.mainSegmentLoader_.abort();
      _this3.mainSegmentLoader_.pause();
    });
    this.masterPlaylistLoader_.on("mediachange", function() {
      var media = _this3.masterPlaylistLoader_.media();
      var requestTimeout = media.targetDuration * 1.5 * 1e3;
      if (isLowestEnabledRendition(_this3.masterPlaylistLoader_.master, _this3.masterPlaylistLoader_.media())) {
        _this3.requestOptions_.timeout = 0;
      } else {
        _this3.requestOptions_.timeout = requestTimeout;
      }
      _this3.masterPlaylistLoader_.load();
      _this3.mainSegmentLoader_.playlist(media, _this3.requestOptions_);
      _this3.mainSegmentLoader_.load();
      _this3.tech_.trigger({
        type: "mediachange",
        bubbles: true
      });
    });
    this.masterPlaylistLoader_.on("playlistunchanged", function() {
      var updatedPlaylist = _this3.masterPlaylistLoader_.media();
      if (updatedPlaylist.lastExcludeReason_ === "playlist-unchanged") {
        return;
      }
      var playlistOutdated = _this3.stuckAtPlaylistEnd_(updatedPlaylist);
      if (playlistOutdated) {
        _this3.blacklistCurrentPlaylist({
          message: "Playlist no longer updating.",
          reason: "playlist-unchanged"
        });
        _this3.tech_.trigger("playliststuck");
      }
    });
    this.masterPlaylistLoader_.on("renditiondisabled", function() {
      _this3.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-disabled"
      });
      _this3.tech_.trigger({
        type: "usage",
        name: "hls-rendition-disabled"
      });
    });
    this.masterPlaylistLoader_.on("renditionenabled", function() {
      _this3.tech_.trigger({
        type: "usage",
        name: "vhs-rendition-enabled"
      });
      _this3.tech_.trigger({
        type: "usage",
        name: "hls-rendition-enabled"
      });
    });
  };
  _proto.handleUpdatedMediaPlaylist = function handleUpdatedMediaPlaylist(updatedPlaylist) {
    if (this.useCueTags_) {
      this.updateAdCues_(updatedPlaylist);
    }
    this.mainSegmentLoader_.playlist(updatedPlaylist, this.requestOptions_);
    this.updateDuration(!updatedPlaylist.endList);
    if (!this.tech_.paused()) {
      this.mainSegmentLoader_.load();
      if (this.audioSegmentLoader_) {
        this.audioSegmentLoader_.load();
      }
    }
  };
  _proto.triggerPresenceUsage_ = function triggerPresenceUsage_(master, media) {
    var mediaGroups = master.mediaGroups || {};
    var defaultDemuxed = true;
    var audioGroupKeys = Object.keys(mediaGroups.AUDIO);
    for (var mediaGroup in mediaGroups.AUDIO) {
      for (var label in mediaGroups.AUDIO[mediaGroup]) {
        var properties = mediaGroups.AUDIO[mediaGroup][label];
        if (!properties.uri) {
          defaultDemuxed = false;
        }
      }
    }
    if (defaultDemuxed) {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-demuxed"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-demuxed"
      });
    }
    if (Object.keys(mediaGroups.SUBTITLES).length) {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-webvtt"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-webvtt"
      });
    }
    if (Vhs$1.Playlist.isAes(media)) {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-aes"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-aes"
      });
    }
    if (audioGroupKeys.length && Object.keys(mediaGroups.AUDIO[audioGroupKeys[0]]).length > 1) {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-alternate-audio"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-alternate-audio"
      });
    }
    if (this.useCueTags_) {
      this.tech_.trigger({
        type: "usage",
        name: "vhs-playlist-cue-tags"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-playlist-cue-tags"
      });
    }
  };
  _proto.shouldSwitchToMedia_ = function shouldSwitchToMedia_(nextPlaylist) {
    var currentPlaylist = this.masterPlaylistLoader_.media() || this.masterPlaylistLoader_.pendingMedia_;
    var currentTime = this.tech_.currentTime();
    var bufferLowWaterLine = this.bufferLowWaterLine();
    var bufferHighWaterLine = this.bufferHighWaterLine();
    var buffered = this.tech_.buffered();
    return shouldSwitchToMedia({
      buffered,
      currentTime,
      currentPlaylist,
      nextPlaylist,
      bufferLowWaterLine,
      bufferHighWaterLine,
      duration: this.duration(),
      experimentalBufferBasedABR: this.experimentalBufferBasedABR,
      log: this.logger_
    });
  };
  _proto.setupSegmentLoaderListeners_ = function setupSegmentLoaderListeners_() {
    var _this4 = this;
    this.mainSegmentLoader_.on("bandwidthupdate", function() {
      _this4.checkABR_("bandwidthupdate");
      _this4.tech_.trigger("bandwidthupdate");
    });
    this.mainSegmentLoader_.on("timeout", function() {
      if (_this4.experimentalBufferBasedABR) {
        _this4.mainSegmentLoader_.load();
      }
    });
    if (!this.experimentalBufferBasedABR) {
      this.mainSegmentLoader_.on("progress", function() {
        _this4.trigger("progress");
      });
    }
    this.mainSegmentLoader_.on("error", function() {
      _this4.blacklistCurrentPlaylist(_this4.mainSegmentLoader_.error());
    });
    this.mainSegmentLoader_.on("appenderror", function() {
      _this4.error = _this4.mainSegmentLoader_.error_;
      _this4.trigger("error");
    });
    this.mainSegmentLoader_.on("syncinfoupdate", function() {
      _this4.onSyncInfoUpdate_();
    });
    this.mainSegmentLoader_.on("timestampoffset", function() {
      _this4.tech_.trigger({
        type: "usage",
        name: "vhs-timestamp-offset"
      });
      _this4.tech_.trigger({
        type: "usage",
        name: "hls-timestamp-offset"
      });
    });
    this.audioSegmentLoader_.on("syncinfoupdate", function() {
      _this4.onSyncInfoUpdate_();
    });
    this.audioSegmentLoader_.on("appenderror", function() {
      _this4.error = _this4.audioSegmentLoader_.error_;
      _this4.trigger("error");
    });
    this.mainSegmentLoader_.on("ended", function() {
      _this4.logger_("main segment loader ended");
      _this4.onEndOfStream();
    });
    this.mainSegmentLoader_.on("earlyabort", function(event) {
      if (_this4.experimentalBufferBasedABR) {
        return;
      }
      _this4.delegateLoaders_("all", ["abort"]);
      _this4.blacklistCurrentPlaylist({
        message: "Aborted early because there isn't enough bandwidth to complete the request without rebuffering."
      }, ABORT_EARLY_BLACKLIST_SECONDS);
    });
    var updateCodecs = function updateCodecs2() {
      if (!_this4.sourceUpdater_.hasCreatedSourceBuffers()) {
        return _this4.tryToCreateSourceBuffers_();
      }
      var codecs = _this4.getCodecsOrExclude_();
      if (!codecs) {
        return;
      }
      _this4.sourceUpdater_.addOrChangeSourceBuffers(codecs);
    };
    this.mainSegmentLoader_.on("trackinfo", updateCodecs);
    this.audioSegmentLoader_.on("trackinfo", updateCodecs);
    this.mainSegmentLoader_.on("fmp4", function() {
      if (!_this4.triggeredFmp4Usage) {
        _this4.tech_.trigger({
          type: "usage",
          name: "vhs-fmp4"
        });
        _this4.tech_.trigger({
          type: "usage",
          name: "hls-fmp4"
        });
        _this4.triggeredFmp4Usage = true;
      }
    });
    this.audioSegmentLoader_.on("fmp4", function() {
      if (!_this4.triggeredFmp4Usage) {
        _this4.tech_.trigger({
          type: "usage",
          name: "vhs-fmp4"
        });
        _this4.tech_.trigger({
          type: "usage",
          name: "hls-fmp4"
        });
        _this4.triggeredFmp4Usage = true;
      }
    });
    this.audioSegmentLoader_.on("ended", function() {
      _this4.logger_("audioSegmentLoader ended");
      _this4.onEndOfStream();
    });
  };
  _proto.mediaSecondsLoaded_ = function mediaSecondsLoaded_() {
    return Math.max(this.audioSegmentLoader_.mediaSecondsLoaded + this.mainSegmentLoader_.mediaSecondsLoaded);
  };
  _proto.load = function load() {
    this.mainSegmentLoader_.load();
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      this.audioSegmentLoader_.load();
    }
    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
      this.subtitleSegmentLoader_.load();
    }
  };
  _proto.smoothQualityChange_ = function smoothQualityChange_(media) {
    if (media === void 0) {
      media = this.selectPlaylist();
    }
    this.fastQualityChange_(media);
  };
  _proto.fastQualityChange_ = function fastQualityChange_(media) {
    var _this5 = this;
    if (media === void 0) {
      media = this.selectPlaylist();
    }
    if (media === this.masterPlaylistLoader_.media()) {
      this.logger_("skipping fastQualityChange because new media is same as old");
      return;
    }
    this.switchMedia_(media, "fast-quality");
    this.mainSegmentLoader_.resetEverything(function() {
      if (videojs.browser.IE_VERSION || videojs.browser.IS_EDGE) {
        _this5.tech_.setCurrentTime(_this5.tech_.currentTime() + 0.04);
      } else {
        _this5.tech_.setCurrentTime(_this5.tech_.currentTime());
      }
    });
  };
  _proto.play = function play() {
    if (this.setupFirstPlay()) {
      return;
    }
    if (this.tech_.ended()) {
      this.tech_.setCurrentTime(0);
    }
    if (this.hasPlayed_) {
      this.load();
    }
    var seekable3 = this.tech_.seekable();
    if (this.tech_.duration() === Infinity) {
      if (this.tech_.currentTime() < seekable3.start(0)) {
        return this.tech_.setCurrentTime(seekable3.end(seekable3.length - 1));
      }
    }
  };
  _proto.setupFirstPlay = function setupFirstPlay() {
    var _this6 = this;
    var media = this.masterPlaylistLoader_.media();
    if (!media || this.tech_.paused() || this.hasPlayed_) {
      return false;
    }
    if (!media.endList) {
      var seekable3 = this.seekable();
      if (!seekable3.length) {
        return false;
      }
      if (videojs.browser.IE_VERSION && this.tech_.readyState() === 0) {
        this.tech_.one("loadedmetadata", function() {
          _this6.trigger("firstplay");
          _this6.tech_.setCurrentTime(seekable3.end(0));
          _this6.hasPlayed_ = true;
        });
        return false;
      }
      this.trigger("firstplay");
      this.tech_.setCurrentTime(seekable3.end(0));
    }
    this.hasPlayed_ = true;
    this.load();
    return true;
  };
  _proto.handleSourceOpen_ = function handleSourceOpen_() {
    this.tryToCreateSourceBuffers_();
    if (this.tech_.autoplay()) {
      var playPromise = this.tech_.play();
      if (typeof playPromise !== "undefined" && typeof playPromise.then === "function") {
        playPromise.then(null, function(e) {
        });
      }
    }
    this.trigger("sourceopen");
  };
  _proto.handleSourceEnded_ = function handleSourceEnded_() {
    if (!this.inbandTextTracks_.metadataTrack_) {
      return;
    }
    var cues = this.inbandTextTracks_.metadataTrack_.cues;
    if (!cues || !cues.length) {
      return;
    }
    var duration5 = this.duration();
    cues[cues.length - 1].endTime = isNaN(duration5) || Math.abs(duration5) === Infinity ? Number.MAX_VALUE : duration5;
  };
  _proto.handleDurationChange_ = function handleDurationChange_() {
    this.tech_.trigger("durationchange");
  };
  _proto.onEndOfStream = function onEndOfStream() {
    var isEndOfStream = this.mainSegmentLoader_.ended_;
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      var mainMediaInfo = this.mainSegmentLoader_.getCurrentMediaInfo_();
      if (!mainMediaInfo || mainMediaInfo.hasVideo) {
        isEndOfStream = isEndOfStream && this.audioSegmentLoader_.ended_;
      } else {
        isEndOfStream = this.audioSegmentLoader_.ended_;
      }
    }
    if (!isEndOfStream) {
      return;
    }
    this.stopABRTimer_();
    this.sourceUpdater_.endOfStream();
  };
  _proto.stuckAtPlaylistEnd_ = function stuckAtPlaylistEnd_(playlist) {
    var seekable3 = this.seekable();
    if (!seekable3.length) {
      return false;
    }
    var expired = this.syncController_.getExpiredTime(playlist, this.duration());
    if (expired === null) {
      return false;
    }
    var absolutePlaylistEnd = Vhs$1.Playlist.playlistEnd(playlist, expired);
    var currentTime = this.tech_.currentTime();
    var buffered = this.tech_.buffered();
    if (!buffered.length) {
      return absolutePlaylistEnd - currentTime <= SAFE_TIME_DELTA;
    }
    var bufferedEnd = buffered.end(buffered.length - 1);
    return bufferedEnd - currentTime <= SAFE_TIME_DELTA && absolutePlaylistEnd - bufferedEnd <= SAFE_TIME_DELTA;
  };
  _proto.blacklistCurrentPlaylist = function blacklistCurrentPlaylist(error2, blacklistDuration) {
    if (error2 === void 0) {
      error2 = {};
    }
    var currentPlaylist = error2.playlist || this.masterPlaylistLoader_.media();
    blacklistDuration = blacklistDuration || error2.blacklistDuration || this.blacklistDuration;
    if (!currentPlaylist) {
      this.error = error2;
      if (this.mediaSource.readyState !== "open") {
        this.trigger("error");
      } else {
        this.sourceUpdater_.endOfStream("network");
      }
      return;
    }
    currentPlaylist.playlistErrors_++;
    var playlists = this.masterPlaylistLoader_.master.playlists;
    var enabledPlaylists = playlists.filter(isEnabled);
    var isFinalRendition = enabledPlaylists.length === 1 && enabledPlaylists[0] === currentPlaylist;
    if (playlists.length === 1 && blacklistDuration !== Infinity) {
      videojs.log.warn("Problem encountered with playlist " + currentPlaylist.id + ". Trying again since it is the only playlist.");
      this.tech_.trigger("retryplaylist");
      return this.masterPlaylistLoader_.load(isFinalRendition);
    }
    if (isFinalRendition) {
      var reincluded = false;
      playlists.forEach(function(playlist) {
        if (playlist === currentPlaylist) {
          return;
        }
        var excludeUntil2 = playlist.excludeUntil;
        if (typeof excludeUntil2 !== "undefined" && excludeUntil2 !== Infinity) {
          reincluded = true;
          delete playlist.excludeUntil;
        }
      });
      if (reincluded) {
        videojs.log.warn("Removing other playlists from the exclusion list because the last rendition is about to be excluded.");
        this.tech_.trigger("retryplaylist");
      }
    }
    var excludeUntil;
    if (currentPlaylist.playlistErrors_ > this.maxPlaylistRetries) {
      excludeUntil = Infinity;
    } else {
      excludeUntil = Date.now() + blacklistDuration * 1e3;
    }
    currentPlaylist.excludeUntil = excludeUntil;
    if (error2.reason) {
      currentPlaylist.lastExcludeReason_ = error2.reason;
    }
    this.tech_.trigger("blacklistplaylist");
    this.tech_.trigger({
      type: "usage",
      name: "vhs-rendition-blacklisted"
    });
    this.tech_.trigger({
      type: "usage",
      name: "hls-rendition-blacklisted"
    });
    var nextPlaylist = this.selectPlaylist();
    if (!nextPlaylist) {
      this.error = "Playback cannot continue. No available working or supported playlists.";
      this.trigger("error");
      return;
    }
    var logFn2 = error2.internal ? this.logger_ : videojs.log.warn;
    var errorMessage = error2.message ? " " + error2.message : "";
    logFn2((error2.internal ? "Internal problem" : "Problem") + " encountered with playlist " + currentPlaylist.id + "." + (errorMessage + " Switching to playlist " + nextPlaylist.id + "."));
    if (nextPlaylist.attributes.AUDIO !== currentPlaylist.attributes.AUDIO) {
      this.delegateLoaders_("audio", ["abort", "pause"]);
    }
    if (nextPlaylist.attributes.SUBTITLES !== currentPlaylist.attributes.SUBTITLES) {
      this.delegateLoaders_("subtitle", ["abort", "pause"]);
    }
    this.delegateLoaders_("main", ["abort", "pause"]);
    var delayDuration = nextPlaylist.targetDuration / 2 * 1e3 || 5 * 1e3;
    var shouldDelay = typeof nextPlaylist.lastRequest === "number" && Date.now() - nextPlaylist.lastRequest <= delayDuration;
    return this.switchMedia_(nextPlaylist, "exclude", isFinalRendition || shouldDelay);
  };
  _proto.pauseLoading = function pauseLoading() {
    this.delegateLoaders_("all", ["abort", "pause"]);
    this.stopABRTimer_();
  };
  _proto.delegateLoaders_ = function delegateLoaders_(filter2, fnNames) {
    var _this7 = this;
    var loaders = [];
    var dontFilterPlaylist = filter2 === "all";
    if (dontFilterPlaylist || filter2 === "main") {
      loaders.push(this.masterPlaylistLoader_);
    }
    var mediaTypes2 = [];
    if (dontFilterPlaylist || filter2 === "audio") {
      mediaTypes2.push("AUDIO");
    }
    if (dontFilterPlaylist || filter2 === "subtitle") {
      mediaTypes2.push("CLOSED-CAPTIONS");
      mediaTypes2.push("SUBTITLES");
    }
    mediaTypes2.forEach(function(mediaType) {
      var loader = _this7.mediaTypes_[mediaType] && _this7.mediaTypes_[mediaType].activePlaylistLoader;
      if (loader) {
        loaders.push(loader);
      }
    });
    ["main", "audio", "subtitle"].forEach(function(name) {
      var loader = _this7[name + "SegmentLoader_"];
      if (loader && (filter2 === name || filter2 === "all")) {
        loaders.push(loader);
      }
    });
    loaders.forEach(function(loader) {
      return fnNames.forEach(function(fnName) {
        if (typeof loader[fnName] === "function") {
          loader[fnName]();
        }
      });
    });
  };
  _proto.setCurrentTime = function setCurrentTime(currentTime) {
    var buffered = findRange(this.tech_.buffered(), currentTime);
    if (!(this.masterPlaylistLoader_ && this.masterPlaylistLoader_.media())) {
      return 0;
    }
    if (!this.masterPlaylistLoader_.media().segments) {
      return 0;
    }
    if (buffered && buffered.length) {
      return currentTime;
    }
    this.mainSegmentLoader_.resetEverything();
    this.mainSegmentLoader_.abort();
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      this.audioSegmentLoader_.resetEverything();
      this.audioSegmentLoader_.abort();
    }
    if (this.mediaTypes_.SUBTITLES.activePlaylistLoader) {
      this.subtitleSegmentLoader_.resetEverything();
      this.subtitleSegmentLoader_.abort();
    }
    this.load();
  };
  _proto.duration = function duration5() {
    if (!this.masterPlaylistLoader_) {
      return 0;
    }
    var media = this.masterPlaylistLoader_.media();
    if (!media) {
      return 0;
    }
    if (!media.endList) {
      return Infinity;
    }
    if (this.mediaSource) {
      return this.mediaSource.duration;
    }
    return Vhs$1.Playlist.duration(media);
  };
  _proto.seekable = function seekable3() {
    return this.seekable_;
  };
  _proto.onSyncInfoUpdate_ = function onSyncInfoUpdate_() {
    var audioSeekable;
    if (!this.masterPlaylistLoader_) {
      return;
    }
    var media = this.masterPlaylistLoader_.media();
    if (!media) {
      return;
    }
    var expired = this.syncController_.getExpiredTime(media, this.duration());
    if (expired === null) {
      return;
    }
    var master = this.masterPlaylistLoader_.master;
    var mainSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
    if (mainSeekable.length === 0) {
      return;
    }
    if (this.mediaTypes_.AUDIO.activePlaylistLoader) {
      media = this.mediaTypes_.AUDIO.activePlaylistLoader.media();
      expired = this.syncController_.getExpiredTime(media, this.duration());
      if (expired === null) {
        return;
      }
      audioSeekable = Vhs$1.Playlist.seekable(media, expired, Vhs$1.Playlist.liveEdgeDelay(master, media));
      if (audioSeekable.length === 0) {
        return;
      }
    }
    var oldEnd;
    var oldStart;
    if (this.seekable_ && this.seekable_.length) {
      oldEnd = this.seekable_.end(0);
      oldStart = this.seekable_.start(0);
    }
    if (!audioSeekable) {
      this.seekable_ = mainSeekable;
    } else if (audioSeekable.start(0) > mainSeekable.end(0) || mainSeekable.start(0) > audioSeekable.end(0)) {
      this.seekable_ = mainSeekable;
    } else {
      this.seekable_ = videojs.createTimeRanges([[audioSeekable.start(0) > mainSeekable.start(0) ? audioSeekable.start(0) : mainSeekable.start(0), audioSeekable.end(0) < mainSeekable.end(0) ? audioSeekable.end(0) : mainSeekable.end(0)]]);
    }
    if (this.seekable_ && this.seekable_.length) {
      if (this.seekable_.end(0) === oldEnd && this.seekable_.start(0) === oldStart) {
        return;
      }
    }
    this.logger_("seekable updated [" + printableRange(this.seekable_) + "]");
    this.tech_.trigger("seekablechanged");
  };
  _proto.updateDuration = function updateDuration(isLive) {
    if (this.updateDuration_) {
      this.mediaSource.removeEventListener("sourceopen", this.updateDuration_);
      this.updateDuration_ = null;
    }
    if (this.mediaSource.readyState !== "open") {
      this.updateDuration_ = this.updateDuration.bind(this, isLive);
      this.mediaSource.addEventListener("sourceopen", this.updateDuration_);
      return;
    }
    if (isLive) {
      var seekable3 = this.seekable();
      if (!seekable3.length) {
        return;
      }
      if (isNaN(this.mediaSource.duration) || this.mediaSource.duration < seekable3.end(seekable3.length - 1)) {
        this.sourceUpdater_.setDuration(seekable3.end(seekable3.length - 1));
      }
      return;
    }
    var buffered = this.tech_.buffered();
    var duration5 = Vhs$1.Playlist.duration(this.masterPlaylistLoader_.media());
    if (buffered.length > 0) {
      duration5 = Math.max(duration5, buffered.end(buffered.length - 1));
    }
    if (this.mediaSource.duration !== duration5) {
      this.sourceUpdater_.setDuration(duration5);
    }
  };
  _proto.dispose = function dispose() {
    var _this8 = this;
    this.trigger("dispose");
    this.decrypter_.terminate();
    this.masterPlaylistLoader_.dispose();
    this.mainSegmentLoader_.dispose();
    if (this.loadOnPlay_) {
      this.tech_.off("play", this.loadOnPlay_);
    }
    ["AUDIO", "SUBTITLES"].forEach(function(type2) {
      var groups = _this8.mediaTypes_[type2].groups;
      for (var id2 in groups) {
        groups[id2].forEach(function(group) {
          if (group.playlistLoader) {
            group.playlistLoader.dispose();
          }
        });
      }
    });
    this.audioSegmentLoader_.dispose();
    this.subtitleSegmentLoader_.dispose();
    this.sourceUpdater_.dispose();
    this.timelineChangeController_.dispose();
    this.stopABRTimer_();
    if (this.updateDuration_) {
      this.mediaSource.removeEventListener("sourceopen", this.updateDuration_);
    }
    this.mediaSource.removeEventListener("durationchange", this.handleDurationChange_);
    this.mediaSource.removeEventListener("sourceopen", this.handleSourceOpen_);
    this.mediaSource.removeEventListener("sourceended", this.handleSourceEnded_);
    this.off();
  };
  _proto.master = function master() {
    return this.masterPlaylistLoader_.master;
  };
  _proto.media = function media() {
    return this.masterPlaylistLoader_.media() || this.initialMedia_;
  };
  _proto.areMediaTypesKnown_ = function areMediaTypesKnown_() {
    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    var hasMainMediaInfo = !!this.mainSegmentLoader_.getCurrentMediaInfo_();
    var hasAudioMediaInfo = !usingAudioLoader ? true : !!this.audioSegmentLoader_.getCurrentMediaInfo_();
    if (!hasMainMediaInfo || !hasAudioMediaInfo) {
      return false;
    }
    return true;
  };
  _proto.getCodecsOrExclude_ = function getCodecsOrExclude_() {
    var _this9 = this;
    var media = {
      main: this.mainSegmentLoader_.getCurrentMediaInfo_() || {},
      audio: this.audioSegmentLoader_.getCurrentMediaInfo_() || {}
    };
    var playlist = this.mainSegmentLoader_.getPendingSegmentPlaylist() || this.media();
    media.video = media.main;
    var playlistCodecs = codecsForPlaylist(this.master(), playlist);
    var codecs = {};
    var usingAudioLoader = !!this.mediaTypes_.AUDIO.activePlaylistLoader;
    if (media.main.hasVideo) {
      codecs.video = playlistCodecs.video || media.main.videoCodec || DEFAULT_VIDEO_CODEC;
    }
    if (media.main.isMuxed) {
      codecs.video += "," + (playlistCodecs.audio || media.main.audioCodec || DEFAULT_AUDIO_CODEC);
    }
    if (media.main.hasAudio && !media.main.isMuxed || media.audio.hasAudio || usingAudioLoader) {
      codecs.audio = playlistCodecs.audio || media.main.audioCodec || media.audio.audioCodec || DEFAULT_AUDIO_CODEC;
      media.audio.isFmp4 = media.main.hasAudio && !media.main.isMuxed ? media.main.isFmp4 : media.audio.isFmp4;
    }
    if (!codecs.audio && !codecs.video) {
      this.blacklistCurrentPlaylist({
        playlist,
        message: "Could not determine codecs for playlist.",
        blacklistDuration: Infinity
      });
      return;
    }
    var supportFunction = function supportFunction2(isFmp4, codec) {
      return isFmp4 ? browserSupportsCodec(codec) : muxerSupportsCodec(codec);
    };
    var unsupportedCodecs = {};
    var unsupportedAudio;
    ["video", "audio"].forEach(function(type2) {
      if (codecs.hasOwnProperty(type2) && !supportFunction(media[type2].isFmp4, codecs[type2])) {
        var supporter = media[type2].isFmp4 ? "browser" : "muxer";
        unsupportedCodecs[supporter] = unsupportedCodecs[supporter] || [];
        unsupportedCodecs[supporter].push(codecs[type2]);
        if (type2 === "audio") {
          unsupportedAudio = supporter;
        }
      }
    });
    if (usingAudioLoader && unsupportedAudio && playlist.attributes.AUDIO) {
      var audioGroup = playlist.attributes.AUDIO;
      this.master().playlists.forEach(function(variant) {
        var variantAudioGroup = variant.attributes && variant.attributes.AUDIO;
        if (variantAudioGroup === audioGroup && variant !== playlist) {
          variant.excludeUntil = Infinity;
        }
      });
      this.logger_("excluding audio group " + audioGroup + " as " + unsupportedAudio + ' does not support codec(s): "' + codecs.audio + '"');
    }
    if (Object.keys(unsupportedCodecs).length) {
      var message = Object.keys(unsupportedCodecs).reduce(function(acc, supporter) {
        if (acc) {
          acc += ", ";
        }
        acc += supporter + ' does not support codec(s): "' + unsupportedCodecs[supporter].join(",") + '"';
        return acc;
      }, "") + ".";
      this.blacklistCurrentPlaylist({
        playlist,
        internal: true,
        message,
        blacklistDuration: Infinity
      });
      return;
    }
    if (this.sourceUpdater_.hasCreatedSourceBuffers() && !this.sourceUpdater_.canChangeType()) {
      var switchMessages = [];
      ["video", "audio"].forEach(function(type2) {
        var newCodec = (parseCodecs(_this9.sourceUpdater_.codecs[type2] || "")[0] || {}).type;
        var oldCodec = (parseCodecs(codecs[type2] || "")[0] || {}).type;
        if (newCodec && oldCodec && newCodec.toLowerCase() !== oldCodec.toLowerCase()) {
          switchMessages.push('"' + _this9.sourceUpdater_.codecs[type2] + '" -> "' + codecs[type2] + '"');
        }
      });
      if (switchMessages.length) {
        this.blacklistCurrentPlaylist({
          playlist,
          message: "Codec switching not supported: " + switchMessages.join(", ") + ".",
          blacklistDuration: Infinity,
          internal: true
        });
        return;
      }
    }
    return codecs;
  };
  _proto.tryToCreateSourceBuffers_ = function tryToCreateSourceBuffers_() {
    if (this.mediaSource.readyState !== "open" || this.sourceUpdater_.hasCreatedSourceBuffers()) {
      return;
    }
    if (!this.areMediaTypesKnown_()) {
      return;
    }
    var codecs = this.getCodecsOrExclude_();
    if (!codecs) {
      return;
    }
    this.sourceUpdater_.createSourceBuffers(codecs);
    var codecString = [codecs.video, codecs.audio].filter(Boolean).join(",");
    this.excludeIncompatibleVariants_(codecString);
  };
  _proto.excludeUnsupportedVariants_ = function excludeUnsupportedVariants_() {
    var _this10 = this;
    var playlists = this.master().playlists;
    var ids = [];
    Object.keys(playlists).forEach(function(key) {
      var variant = playlists[key];
      if (ids.indexOf(variant.id) !== -1) {
        return;
      }
      ids.push(variant.id);
      var codecs = codecsForPlaylist(_this10.master, variant);
      var unsupported = [];
      if (codecs.audio && !muxerSupportsCodec(codecs.audio) && !browserSupportsCodec(codecs.audio)) {
        unsupported.push("audio codec " + codecs.audio);
      }
      if (codecs.video && !muxerSupportsCodec(codecs.video) && !browserSupportsCodec(codecs.video)) {
        unsupported.push("video codec " + codecs.video);
      }
      if (codecs.text && codecs.text === "stpp.ttml.im1t") {
        unsupported.push("text codec " + codecs.text);
      }
      if (unsupported.length) {
        variant.excludeUntil = Infinity;
        _this10.logger_("excluding " + variant.id + " for unsupported: " + unsupported.join(", "));
      }
    });
  };
  _proto.excludeIncompatibleVariants_ = function excludeIncompatibleVariants_(codecString) {
    var _this11 = this;
    var ids = [];
    var playlists = this.master().playlists;
    var codecs = unwrapCodecList(parseCodecs(codecString));
    var codecCount_ = codecCount(codecs);
    var videoDetails = codecs.video && parseCodecs(codecs.video)[0] || null;
    var audioDetails = codecs.audio && parseCodecs(codecs.audio)[0] || null;
    Object.keys(playlists).forEach(function(key) {
      var variant = playlists[key];
      if (ids.indexOf(variant.id) !== -1 || variant.excludeUntil === Infinity) {
        return;
      }
      ids.push(variant.id);
      var blacklistReasons = [];
      var variantCodecs = codecsForPlaylist(_this11.masterPlaylistLoader_.master, variant);
      var variantCodecCount = codecCount(variantCodecs);
      if (!variantCodecs.audio && !variantCodecs.video) {
        return;
      }
      if (variantCodecCount !== codecCount_) {
        blacklistReasons.push('codec count "' + variantCodecCount + '" !== "' + codecCount_ + '"');
      }
      if (!_this11.sourceUpdater_.canChangeType()) {
        var variantVideoDetails = variantCodecs.video && parseCodecs(variantCodecs.video)[0] || null;
        var variantAudioDetails = variantCodecs.audio && parseCodecs(variantCodecs.audio)[0] || null;
        if (variantVideoDetails && videoDetails && variantVideoDetails.type.toLowerCase() !== videoDetails.type.toLowerCase()) {
          blacklistReasons.push('video codec "' + variantVideoDetails.type + '" !== "' + videoDetails.type + '"');
        }
        if (variantAudioDetails && audioDetails && variantAudioDetails.type.toLowerCase() !== audioDetails.type.toLowerCase()) {
          blacklistReasons.push('audio codec "' + variantAudioDetails.type + '" !== "' + audioDetails.type + '"');
        }
      }
      if (blacklistReasons.length) {
        variant.excludeUntil = Infinity;
        _this11.logger_("blacklisting " + variant.id + ": " + blacklistReasons.join(" && "));
      }
    });
  };
  _proto.updateAdCues_ = function updateAdCues_(media) {
    var offset2 = 0;
    var seekable3 = this.seekable();
    if (seekable3.length) {
      offset2 = seekable3.start(0);
    }
    updateAdCues(media, this.cueTagsTrack_, offset2);
  };
  _proto.goalBufferLength = function goalBufferLength() {
    var currentTime = this.tech_.currentTime();
    var initial2 = Config.GOAL_BUFFER_LENGTH;
    var rate = Config.GOAL_BUFFER_LENGTH_RATE;
    var max = Math.max(initial2, Config.MAX_GOAL_BUFFER_LENGTH);
    return Math.min(initial2 + currentTime * rate, max);
  };
  _proto.bufferLowWaterLine = function bufferLowWaterLine() {
    var currentTime = this.tech_.currentTime();
    var initial2 = Config.BUFFER_LOW_WATER_LINE;
    var rate = Config.BUFFER_LOW_WATER_LINE_RATE;
    var max = Math.max(initial2, Config.MAX_BUFFER_LOW_WATER_LINE);
    var newMax = Math.max(initial2, Config.EXPERIMENTAL_MAX_BUFFER_LOW_WATER_LINE);
    return Math.min(initial2 + currentTime * rate, this.experimentalBufferBasedABR ? newMax : max);
  };
  _proto.bufferHighWaterLine = function bufferHighWaterLine() {
    return Config.BUFFER_HIGH_WATER_LINE;
  };
  return MasterPlaylistController2;
}(videojs.EventTarget);
var enableFunction = function enableFunction2(loader, playlistID, changePlaylistFn) {
  return function(enable) {
    var playlist = loader.master.playlists[playlistID];
    var incompatible = isIncompatible(playlist);
    var currentlyEnabled = isEnabled(playlist);
    if (typeof enable === "undefined") {
      return currentlyEnabled;
    }
    if (enable) {
      delete playlist.disabled;
    } else {
      playlist.disabled = true;
    }
    if (enable !== currentlyEnabled && !incompatible) {
      changePlaylistFn();
      if (enable) {
        loader.trigger("renditionenabled");
      } else {
        loader.trigger("renditiondisabled");
      }
    }
    return enable;
  };
};
var Representation = function Representation2(vhsHandler, playlist, id2) {
  var mpc = vhsHandler.masterPlaylistController_, smoothQualityChange = vhsHandler.options_.smoothQualityChange;
  var changeType2 = smoothQualityChange ? "smooth" : "fast";
  var qualityChangeFunction = mpc[changeType2 + "QualityChange_"].bind(mpc);
  if (playlist.attributes) {
    var resolution = playlist.attributes.RESOLUTION;
    this.width = resolution && resolution.width;
    this.height = resolution && resolution.height;
    this.bandwidth = playlist.attributes.BANDWIDTH;
    this.frameRate = playlist.attributes["FRAME-RATE"];
  }
  this.codecs = codecsForPlaylist(mpc.master(), playlist);
  this.playlist = playlist;
  this.id = id2;
  this.enabled = enableFunction(vhsHandler.playlists, playlist.id, qualityChangeFunction);
};
var renditionSelectionMixin = function renditionSelectionMixin2(vhsHandler) {
  vhsHandler.representations = function() {
    var master = vhsHandler.masterPlaylistController_.master();
    var playlists = isAudioOnly(master) ? vhsHandler.masterPlaylistController_.getAudioTrackPlaylists_() : master.playlists;
    if (!playlists) {
      return [];
    }
    return playlists.filter(function(media) {
      return !isIncompatible(media);
    }).map(function(e, i) {
      return new Representation(vhsHandler, e, e.id);
    });
  };
};
var timerCancelEvents = ["seeking", "seeked", "pause", "playing", "error"];
var PlaybackWatcher = /* @__PURE__ */ function() {
  function PlaybackWatcher2(options) {
    var _this = this;
    this.masterPlaylistController_ = options.masterPlaylistController;
    this.tech_ = options.tech;
    this.seekable = options.seekable;
    this.allowSeeksWithinUnsafeLiveWindow = options.allowSeeksWithinUnsafeLiveWindow;
    this.liveRangeSafeTimeDelta = options.liveRangeSafeTimeDelta;
    this.media = options.media;
    this.consecutiveUpdates = 0;
    this.lastRecordedTime = null;
    this.timer_ = null;
    this.checkCurrentTimeTimeout_ = null;
    this.logger_ = logger("PlaybackWatcher");
    this.logger_("initialize");
    var playHandler = function playHandler2() {
      return _this.monitorCurrentTime_();
    };
    var canPlayHandler = function canPlayHandler2() {
      return _this.monitorCurrentTime_();
    };
    var waitingHandler = function waitingHandler2() {
      return _this.techWaiting_();
    };
    var cancelTimerHandler = function cancelTimerHandler2() {
      return _this.cancelTimer_();
    };
    var mpc = this.masterPlaylistController_;
    var loaderTypes = ["main", "subtitle", "audio"];
    var loaderChecks = {};
    loaderTypes.forEach(function(type2) {
      loaderChecks[type2] = {
        reset: function reset3() {
          return _this.resetSegmentDownloads_(type2);
        },
        updateend: function updateend() {
          return _this.checkSegmentDownloads_(type2);
        }
      };
      mpc[type2 + "SegmentLoader_"].on("appendsdone", loaderChecks[type2].updateend);
      mpc[type2 + "SegmentLoader_"].on("playlistupdate", loaderChecks[type2].reset);
      _this.tech_.on(["seeked", "seeking"], loaderChecks[type2].reset);
    });
    var setSeekingHandlers = function setSeekingHandlers2(fn) {
      ["main", "audio"].forEach(function(type2) {
        mpc[type2 + "SegmentLoader_"][fn]("appended", _this.seekingAppendCheck_);
      });
    };
    this.seekingAppendCheck_ = function() {
      if (_this.fixesBadSeeks_()) {
        _this.consecutiveUpdates = 0;
        _this.lastRecordedTime = _this.tech_.currentTime();
        setSeekingHandlers("off");
      }
    };
    this.clearSeekingAppendCheck_ = function() {
      return setSeekingHandlers("off");
    };
    this.watchForBadSeeking_ = function() {
      _this.clearSeekingAppendCheck_();
      setSeekingHandlers("on");
    };
    this.tech_.on("seeked", this.clearSeekingAppendCheck_);
    this.tech_.on("seeking", this.watchForBadSeeking_);
    this.tech_.on("waiting", waitingHandler);
    this.tech_.on(timerCancelEvents, cancelTimerHandler);
    this.tech_.on("canplay", canPlayHandler);
    this.tech_.one("play", playHandler);
    this.dispose = function() {
      _this.clearSeekingAppendCheck_();
      _this.logger_("dispose");
      _this.tech_.off("waiting", waitingHandler);
      _this.tech_.off(timerCancelEvents, cancelTimerHandler);
      _this.tech_.off("canplay", canPlayHandler);
      _this.tech_.off("play", playHandler);
      _this.tech_.off("seeking", _this.watchForBadSeeking_);
      _this.tech_.off("seeked", _this.clearSeekingAppendCheck_);
      loaderTypes.forEach(function(type2) {
        mpc[type2 + "SegmentLoader_"].off("appendsdone", loaderChecks[type2].updateend);
        mpc[type2 + "SegmentLoader_"].off("playlistupdate", loaderChecks[type2].reset);
        _this.tech_.off(["seeked", "seeking"], loaderChecks[type2].reset);
      });
      if (_this.checkCurrentTimeTimeout_) {
        window_1.clearTimeout(_this.checkCurrentTimeTimeout_);
      }
      _this.cancelTimer_();
    };
  }
  var _proto = PlaybackWatcher2.prototype;
  _proto.monitorCurrentTime_ = function monitorCurrentTime_() {
    this.checkCurrentTime_();
    if (this.checkCurrentTimeTimeout_) {
      window_1.clearTimeout(this.checkCurrentTimeTimeout_);
    }
    this.checkCurrentTimeTimeout_ = window_1.setTimeout(this.monitorCurrentTime_.bind(this), 250);
  };
  _proto.resetSegmentDownloads_ = function resetSegmentDownloads_(type2) {
    var loader = this.masterPlaylistController_[type2 + "SegmentLoader_"];
    if (this[type2 + "StalledDownloads_"] > 0) {
      this.logger_("resetting possible stalled download count for " + type2 + " loader");
    }
    this[type2 + "StalledDownloads_"] = 0;
    this[type2 + "Buffered_"] = loader.buffered_();
  };
  _proto.checkSegmentDownloads_ = function checkSegmentDownloads_(type2) {
    var mpc = this.masterPlaylistController_;
    var loader = mpc[type2 + "SegmentLoader_"];
    var buffered = loader.buffered_();
    var isBufferedDifferent = isRangeDifferent(this[type2 + "Buffered_"], buffered);
    this[type2 + "Buffered_"] = buffered;
    if (isBufferedDifferent) {
      this.resetSegmentDownloads_(type2);
      return;
    }
    this[type2 + "StalledDownloads_"]++;
    this.logger_("found #" + this[type2 + "StalledDownloads_"] + " " + type2 + " appends that did not increase buffer (possible stalled download)", {
      playlistId: loader.playlist_ && loader.playlist_.id,
      buffered: timeRangesToArray(buffered)
    });
    if (this[type2 + "StalledDownloads_"] < 10) {
      return;
    }
    this.logger_(type2 + " loader stalled download exclusion");
    this.resetSegmentDownloads_(type2);
    this.tech_.trigger({
      type: "usage",
      name: "vhs-" + type2 + "-download-exclusion"
    });
    if (type2 === "subtitle") {
      return;
    }
    mpc.blacklistCurrentPlaylist({
      message: "Excessive " + type2 + " segment downloading detected."
    }, Infinity);
  };
  _proto.checkCurrentTime_ = function checkCurrentTime_() {
    if (this.tech_.paused() || this.tech_.seeking()) {
      return;
    }
    var currentTime = this.tech_.currentTime();
    var buffered = this.tech_.buffered();
    if (this.lastRecordedTime === currentTime && (!buffered.length || currentTime + SAFE_TIME_DELTA >= buffered.end(buffered.length - 1))) {
      return this.techWaiting_();
    }
    if (this.consecutiveUpdates >= 5 && currentTime === this.lastRecordedTime) {
      this.consecutiveUpdates++;
      this.waiting_();
    } else if (currentTime === this.lastRecordedTime) {
      this.consecutiveUpdates++;
    } else {
      this.consecutiveUpdates = 0;
      this.lastRecordedTime = currentTime;
    }
  };
  _proto.cancelTimer_ = function cancelTimer_() {
    this.consecutiveUpdates = 0;
    if (this.timer_) {
      this.logger_("cancelTimer_");
      clearTimeout(this.timer_);
    }
    this.timer_ = null;
  };
  _proto.fixesBadSeeks_ = function fixesBadSeeks_() {
    var seeking = this.tech_.seeking();
    if (!seeking) {
      return false;
    }
    var seekable3 = this.seekable();
    var currentTime = this.tech_.currentTime();
    var isAfterSeekableRange = this.afterSeekableWindow_(seekable3, currentTime, this.media(), this.allowSeeksWithinUnsafeLiveWindow);
    var seekTo;
    if (isAfterSeekableRange) {
      var seekableEnd = seekable3.end(seekable3.length - 1);
      seekTo = seekableEnd;
    }
    if (this.beforeSeekableWindow_(seekable3, currentTime)) {
      var seekableStart = seekable3.start(0);
      seekTo = seekableStart + (seekableStart === seekable3.end(0) ? 0 : SAFE_TIME_DELTA);
    }
    if (typeof seekTo !== "undefined") {
      this.logger_("Trying to seek outside of seekable at time " + currentTime + " with " + ("seekable range " + printableRange(seekable3) + ". Seeking to ") + (seekTo + "."));
      this.tech_.setCurrentTime(seekTo);
      return true;
    }
    var sourceUpdater = this.masterPlaylistController_.sourceUpdater_;
    var buffered = this.tech_.buffered();
    var audioBuffered = sourceUpdater.audioBuffer ? sourceUpdater.audioBuffered() : null;
    var videoBuffered = sourceUpdater.videoBuffer ? sourceUpdater.videoBuffered() : null;
    var media = this.media();
    var minAppendedDuration = media.partTargetDuration ? media.partTargetDuration : (media.targetDuration - TIME_FUDGE_FACTOR) * 2;
    var bufferedToCheck = [audioBuffered, videoBuffered];
    for (var i = 0; i < bufferedToCheck.length; i++) {
      if (!bufferedToCheck[i]) {
        continue;
      }
      var timeAhead = timeAheadOf(bufferedToCheck[i], currentTime);
      if (timeAhead < minAppendedDuration) {
        return false;
      }
    }
    var nextRange = findNextRange(buffered, currentTime);
    if (nextRange.length === 0) {
      return false;
    }
    seekTo = nextRange.start(0) + SAFE_TIME_DELTA;
    this.logger_("Buffered region starts (" + nextRange.start(0) + ") " + (" just beyond seek point (" + currentTime + "). Seeking to " + seekTo + "."));
    this.tech_.setCurrentTime(seekTo);
    return true;
  };
  _proto.waiting_ = function waiting_() {
    if (this.techWaiting_()) {
      return;
    }
    var currentTime = this.tech_.currentTime();
    var buffered = this.tech_.buffered();
    var currentRange = findRange(buffered, currentTime);
    if (currentRange.length && currentTime + 3 <= currentRange.end(0)) {
      this.cancelTimer_();
      this.tech_.setCurrentTime(currentTime);
      this.logger_("Stopped at " + currentTime + " while inside a buffered region " + ("[" + currentRange.start(0) + " -> " + currentRange.end(0) + "]. Attempting to resume ") + "playback by seeking to the current time.");
      this.tech_.trigger({
        type: "usage",
        name: "vhs-unknown-waiting"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-unknown-waiting"
      });
      return;
    }
  };
  _proto.techWaiting_ = function techWaiting_() {
    var seekable3 = this.seekable();
    var currentTime = this.tech_.currentTime();
    if (this.tech_.seeking() || this.timer_ !== null) {
      return true;
    }
    if (this.beforeSeekableWindow_(seekable3, currentTime)) {
      var livePoint = seekable3.end(seekable3.length - 1);
      this.logger_("Fell out of live window at time " + currentTime + ". Seeking to " + ("live point (seekable end) " + livePoint));
      this.cancelTimer_();
      this.tech_.setCurrentTime(livePoint);
      this.tech_.trigger({
        type: "usage",
        name: "vhs-live-resync"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-live-resync"
      });
      return true;
    }
    var sourceUpdater = this.tech_.vhs.masterPlaylistController_.sourceUpdater_;
    var buffered = this.tech_.buffered();
    var videoUnderflow = this.videoUnderflow_({
      audioBuffered: sourceUpdater.audioBuffered(),
      videoBuffered: sourceUpdater.videoBuffered(),
      currentTime
    });
    if (videoUnderflow) {
      this.cancelTimer_();
      this.tech_.setCurrentTime(currentTime);
      this.tech_.trigger({
        type: "usage",
        name: "vhs-video-underflow"
      });
      this.tech_.trigger({
        type: "usage",
        name: "hls-video-underflow"
      });
      return true;
    }
    var nextRange = findNextRange(buffered, currentTime);
    if (nextRange.length > 0) {
      var difference = nextRange.start(0) - currentTime;
      this.logger_("Stopped at " + currentTime + ", setting timer for " + difference + ", seeking " + ("to " + nextRange.start(0)));
      this.cancelTimer_();
      this.timer_ = setTimeout(this.skipTheGap_.bind(this), difference * 1e3, currentTime);
      return true;
    }
    return false;
  };
  _proto.afterSeekableWindow_ = function afterSeekableWindow_(seekable3, currentTime, playlist, allowSeeksWithinUnsafeLiveWindow) {
    if (allowSeeksWithinUnsafeLiveWindow === void 0) {
      allowSeeksWithinUnsafeLiveWindow = false;
    }
    if (!seekable3.length) {
      return false;
    }
    var allowedEnd = seekable3.end(seekable3.length - 1) + SAFE_TIME_DELTA;
    var isLive = !playlist.endList;
    if (isLive && allowSeeksWithinUnsafeLiveWindow) {
      allowedEnd = seekable3.end(seekable3.length - 1) + playlist.targetDuration * 3;
    }
    if (currentTime > allowedEnd) {
      return true;
    }
    return false;
  };
  _proto.beforeSeekableWindow_ = function beforeSeekableWindow_(seekable3, currentTime) {
    if (seekable3.length && seekable3.start(0) > 0 && currentTime < seekable3.start(0) - this.liveRangeSafeTimeDelta) {
      return true;
    }
    return false;
  };
  _proto.videoUnderflow_ = function videoUnderflow_(_ref2) {
    var videoBuffered = _ref2.videoBuffered, audioBuffered = _ref2.audioBuffered, currentTime = _ref2.currentTime;
    if (!videoBuffered) {
      return;
    }
    var gap;
    if (videoBuffered.length && audioBuffered.length) {
      var lastVideoRange = findRange(videoBuffered, currentTime - 3);
      var videoRange = findRange(videoBuffered, currentTime);
      var audioRange = findRange(audioBuffered, currentTime);
      if (audioRange.length && !videoRange.length && lastVideoRange.length) {
        gap = {
          start: lastVideoRange.end(0),
          end: audioRange.end(0)
        };
      }
    } else {
      var nextRange = findNextRange(videoBuffered, currentTime);
      if (!nextRange.length) {
        gap = this.gapFromVideoUnderflow_(videoBuffered, currentTime);
      }
    }
    if (gap) {
      this.logger_("Encountered a gap in video from " + gap.start + " to " + gap.end + ". " + ("Seeking to current time " + currentTime));
      return true;
    }
    return false;
  };
  _proto.skipTheGap_ = function skipTheGap_(scheduledCurrentTime) {
    var buffered = this.tech_.buffered();
    var currentTime = this.tech_.currentTime();
    var nextRange = findNextRange(buffered, currentTime);
    this.cancelTimer_();
    if (nextRange.length === 0 || currentTime !== scheduledCurrentTime) {
      return;
    }
    this.logger_("skipTheGap_:", "currentTime:", currentTime, "scheduled currentTime:", scheduledCurrentTime, "nextRange start:", nextRange.start(0));
    this.tech_.setCurrentTime(nextRange.start(0) + TIME_FUDGE_FACTOR);
    this.tech_.trigger({
      type: "usage",
      name: "vhs-gap-skip"
    });
    this.tech_.trigger({
      type: "usage",
      name: "hls-gap-skip"
    });
  };
  _proto.gapFromVideoUnderflow_ = function gapFromVideoUnderflow_(buffered, currentTime) {
    var gaps = findGaps(buffered);
    for (var i = 0; i < gaps.length; i++) {
      var start2 = gaps.start(i);
      var end3 = gaps.end(i);
      if (currentTime - start2 < 4 && currentTime - start2 > 2) {
        return {
          start: start2,
          end: end3
        };
      }
    }
    return null;
  };
  return PlaybackWatcher2;
}();
var defaultOptions = {
  errorInterval: 30,
  getSource: function getSource(next) {
    var tech = this.tech({
      IWillNotUseThisInPlugins: true
    });
    var sourceObj = tech.currentSource_ || this.currentSource();
    return next(sourceObj);
  }
};
var initPlugin = function initPlugin2(player, options) {
  var lastCalled = 0;
  var seekTo = 0;
  var localOptions = videojs.mergeOptions(defaultOptions, options);
  player.ready(function() {
    player.trigger({
      type: "usage",
      name: "vhs-error-reload-initialized"
    });
    player.trigger({
      type: "usage",
      name: "hls-error-reload-initialized"
    });
  });
  var loadedMetadataHandler = function loadedMetadataHandler2() {
    if (seekTo) {
      player.currentTime(seekTo);
    }
  };
  var setSource2 = function setSource3(sourceObj) {
    if (sourceObj === null || sourceObj === void 0) {
      return;
    }
    seekTo = player.duration() !== Infinity && player.currentTime() || 0;
    player.one("loadedmetadata", loadedMetadataHandler);
    player.src(sourceObj);
    player.trigger({
      type: "usage",
      name: "vhs-error-reload"
    });
    player.trigger({
      type: "usage",
      name: "hls-error-reload"
    });
    player.play();
  };
  var errorHandler = function errorHandler2() {
    if (Date.now() - lastCalled < localOptions.errorInterval * 1e3) {
      player.trigger({
        type: "usage",
        name: "vhs-error-reload-canceled"
      });
      player.trigger({
        type: "usage",
        name: "hls-error-reload-canceled"
      });
      return;
    }
    if (!localOptions.getSource || typeof localOptions.getSource !== "function") {
      videojs.log.error("ERROR: reloadSourceOnError - The option getSource must be a function!");
      return;
    }
    lastCalled = Date.now();
    return localOptions.getSource.call(player, setSource2);
  };
  var cleanupEvents = function cleanupEvents2() {
    player.off("loadedmetadata", loadedMetadataHandler);
    player.off("error", errorHandler);
    player.off("dispose", cleanupEvents2);
  };
  var reinitPlugin = function reinitPlugin2(newOptions) {
    cleanupEvents();
    initPlugin2(player, newOptions);
  };
  player.on("error", errorHandler);
  player.on("dispose", cleanupEvents);
  player.reloadSourceOnError = reinitPlugin;
};
var reloadSourceOnError = function reloadSourceOnError2(options) {
  initPlugin(this, options);
};
var version$4 = "2.16.2";
var version$3 = "6.0.1";
var version$2 = "0.22.1";
var version$1 = "4.8.0";
var version = "3.1.3";
var Vhs = {
  PlaylistLoader,
  Playlist,
  utils,
  STANDARD_PLAYLIST_SELECTOR: lastBandwidthSelector,
  INITIAL_PLAYLIST_SELECTOR: lowestBitrateCompatibleVariantSelector,
  lastBandwidthSelector,
  movingAverageBandwidthSelector,
  comparePlaylistBandwidth,
  comparePlaylistResolution,
  xhr: xhrFactory()
};
Object.keys(Config).forEach(function(prop) {
  Object.defineProperty(Vhs, prop, {
    get: function get7() {
      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
      return Config[prop];
    },
    set: function set4(value) {
      videojs.log.warn("using Vhs." + prop + " is UNSAFE be sure you know what you are doing");
      if (typeof value !== "number" || value < 0) {
        videojs.log.warn("value of Vhs." + prop + " must be greater than or equal to 0");
        return;
      }
      Config[prop] = value;
    }
  });
});
var LOCAL_STORAGE_KEY = "videojs-vhs";
var handleVhsMediaChange = function handleVhsMediaChange2(qualityLevels, playlistLoader) {
  var newPlaylist = playlistLoader.media();
  var selectedIndex = -1;
  for (var i = 0; i < qualityLevels.length; i++) {
    if (qualityLevels[i].id === newPlaylist.id) {
      selectedIndex = i;
      break;
    }
  }
  qualityLevels.selectedIndex_ = selectedIndex;
  qualityLevels.trigger({
    selectedIndex,
    type: "change"
  });
};
var handleVhsLoadedMetadata = function handleVhsLoadedMetadata2(qualityLevels, vhs) {
  vhs.representations().forEach(function(rep) {
    qualityLevels.addQualityLevel(rep);
  });
  handleVhsMediaChange(qualityLevels, vhs.playlists);
};
Vhs.canPlaySource = function() {
  return videojs.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var emeKeySystems = function emeKeySystems2(keySystemOptions, mainPlaylist, audioPlaylist) {
  if (!keySystemOptions) {
    return keySystemOptions;
  }
  var codecs = {};
  if (mainPlaylist && mainPlaylist.attributes && mainPlaylist.attributes.CODECS) {
    codecs = unwrapCodecList(parseCodecs(mainPlaylist.attributes.CODECS));
  }
  if (audioPlaylist && audioPlaylist.attributes && audioPlaylist.attributes.CODECS) {
    codecs.audio = audioPlaylist.attributes.CODECS;
  }
  var videoContentType = getMimeForCodec(codecs.video);
  var audioContentType = getMimeForCodec(codecs.audio);
  var keySystemContentTypes = {};
  for (var keySystem in keySystemOptions) {
    keySystemContentTypes[keySystem] = {};
    if (audioContentType) {
      keySystemContentTypes[keySystem].audioContentType = audioContentType;
    }
    if (videoContentType) {
      keySystemContentTypes[keySystem].videoContentType = videoContentType;
    }
    if (mainPlaylist.contentProtection && mainPlaylist.contentProtection[keySystem] && mainPlaylist.contentProtection[keySystem].pssh) {
      keySystemContentTypes[keySystem].pssh = mainPlaylist.contentProtection[keySystem].pssh;
    }
    if (typeof keySystemOptions[keySystem] === "string") {
      keySystemContentTypes[keySystem].url = keySystemOptions[keySystem];
    }
  }
  return videojs.mergeOptions(keySystemOptions, keySystemContentTypes);
};
var getAllPsshKeySystemsOptions = function getAllPsshKeySystemsOptions2(playlists, keySystems) {
  return playlists.reduce(function(keySystemsArr, playlist) {
    if (!playlist.contentProtection) {
      return keySystemsArr;
    }
    var keySystemsOptions = keySystems.reduce(function(keySystemsObj, keySystem) {
      var keySystemOptions = playlist.contentProtection[keySystem];
      if (keySystemOptions && keySystemOptions.pssh) {
        keySystemsObj[keySystem] = {
          pssh: keySystemOptions.pssh
        };
      }
      return keySystemsObj;
    }, {});
    if (Object.keys(keySystemsOptions).length) {
      keySystemsArr.push(keySystemsOptions);
    }
    return keySystemsArr;
  }, []);
};
var waitForKeySessionCreation = function waitForKeySessionCreation2(_ref2) {
  var player = _ref2.player, sourceKeySystems = _ref2.sourceKeySystems, audioMedia = _ref2.audioMedia, mainPlaylists = _ref2.mainPlaylists;
  if (!player.eme.initializeMediaKeys) {
    return Promise.resolve();
  }
  var playlists = audioMedia ? mainPlaylists.concat([audioMedia]) : mainPlaylists;
  var keySystemsOptionsArr = getAllPsshKeySystemsOptions(playlists, Object.keys(sourceKeySystems));
  var initializationFinishedPromises = [];
  var keySessionCreatedPromises = [];
  keySystemsOptionsArr.forEach(function(keySystemsOptions) {
    keySessionCreatedPromises.push(new Promise(function(resolve, reject) {
      player.tech_.one("keysessioncreated", resolve);
    }));
    initializationFinishedPromises.push(new Promise(function(resolve, reject) {
      player.eme.initializeMediaKeys({
        keySystems: keySystemsOptions
      }, function(err) {
        if (err) {
          reject(err);
          return;
        }
        resolve();
      });
    }));
  });
  return Promise.race([
    Promise.all(initializationFinishedPromises),
    Promise.race(keySessionCreatedPromises)
  ]);
};
var setupEmeOptions = function setupEmeOptions2(_ref2) {
  var player = _ref2.player, sourceKeySystems = _ref2.sourceKeySystems, media = _ref2.media, audioMedia = _ref2.audioMedia;
  var sourceOptions = emeKeySystems(sourceKeySystems, media, audioMedia);
  if (!sourceOptions) {
    return false;
  }
  player.currentSource().keySystems = sourceOptions;
  if (sourceOptions && !player.eme) {
    videojs.log.warn("DRM encrypted source cannot be decrypted without a DRM plugin");
    return false;
  }
  return true;
};
var getVhsLocalStorage = function getVhsLocalStorage2() {
  if (!window_1.localStorage) {
    return null;
  }
  var storedObject = window_1.localStorage.getItem(LOCAL_STORAGE_KEY);
  if (!storedObject) {
    return null;
  }
  try {
    return JSON.parse(storedObject);
  } catch (e) {
    return null;
  }
};
var updateVhsLocalStorage = function updateVhsLocalStorage2(options) {
  if (!window_1.localStorage) {
    return false;
  }
  var objectToStore = getVhsLocalStorage();
  objectToStore = objectToStore ? videojs.mergeOptions(objectToStore, options) : options;
  try {
    window_1.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(objectToStore));
  } catch (e) {
    return false;
  }
  return objectToStore;
};
var expandDataUri = function expandDataUri2(dataUri) {
  if (dataUri.toLowerCase().indexOf("data:application/vnd.videojs.vhs+json,") === 0) {
    return JSON.parse(dataUri.substring(dataUri.indexOf(",") + 1));
  }
  return dataUri;
};
Vhs.supportsNativeHls = function() {
  if (!document_1 || !document_1.createElement) {
    return false;
  }
  var video = document_1.createElement("video");
  if (!videojs.getTech("Html5").isSupported()) {
    return false;
  }
  var canPlay = [
    "application/vnd.apple.mpegurl",
    "audio/mpegurl",
    "audio/x-mpegurl",
    "application/x-mpegurl",
    "video/x-mpegurl",
    "video/mpegurl",
    "application/mpegurl"
  ];
  return canPlay.some(function(canItPlay) {
    return /maybe|probably/i.test(video.canPlayType(canItPlay));
  });
}();
Vhs.supportsNativeDash = function() {
  if (!document_1 || !document_1.createElement || !videojs.getTech("Html5").isSupported()) {
    return false;
  }
  return /maybe|probably/i.test(document_1.createElement("video").canPlayType("application/dash+xml"));
}();
Vhs.supportsTypeNatively = function(type2) {
  if (type2 === "hls") {
    return Vhs.supportsNativeHls;
  }
  if (type2 === "dash") {
    return Vhs.supportsNativeDash;
  }
  return false;
};
Vhs.isSupported = function() {
  return videojs.log.warn("HLS is no longer a tech. Please remove it from your player's techOrder.");
};
var Component = videojs.getComponent("Component");
var VhsHandler = /* @__PURE__ */ function(_Component) {
  _inheritsLoose(VhsHandler2, _Component);
  function VhsHandler2(source, tech, options) {
    var _this;
    _this = _Component.call(this, tech, videojs.mergeOptions(options.hls, options.vhs)) || this;
    if (options.hls && Object.keys(options.hls).length) {
      videojs.log.warn("Using hls options is deprecated. Please rename `hls` to `vhs` in your options object.");
    }
    if (typeof options.initialBandwidth === "number") {
      _this.options_.bandwidth = options.initialBandwidth;
    }
    _this.logger_ = logger("VhsHandler");
    if (tech.options_ && tech.options_.playerId) {
      var _player = videojs(tech.options_.playerId);
      if (!_player.hasOwnProperty("hls")) {
        Object.defineProperty(_player, "hls", {
          get: function get7() {
            videojs.log.warn("player.hls is deprecated. Use player.tech().vhs instead.");
            tech.trigger({
              type: "usage",
              name: "hls-player-access"
            });
            return _assertThisInitialized(_this);
          },
          configurable: true
        });
      }
      if (!_player.hasOwnProperty("vhs")) {
        Object.defineProperty(_player, "vhs", {
          get: function get7() {
            videojs.log.warn("player.vhs is deprecated. Use player.tech().vhs instead.");
            tech.trigger({
              type: "usage",
              name: "vhs-player-access"
            });
            return _assertThisInitialized(_this);
          },
          configurable: true
        });
      }
      if (!_player.hasOwnProperty("dash")) {
        Object.defineProperty(_player, "dash", {
          get: function get7() {
            videojs.log.warn("player.dash is deprecated. Use player.tech().vhs instead.");
            return _assertThisInitialized(_this);
          },
          configurable: true
        });
      }
      _this.player_ = _player;
    }
    _this.tech_ = tech;
    _this.source_ = source;
    _this.stats = {};
    _this.ignoreNextSeekingEvent_ = false;
    _this.setOptions_();
    if (_this.options_.overrideNative && tech.overrideNativeAudioTracks && tech.overrideNativeVideoTracks) {
      tech.overrideNativeAudioTracks(true);
      tech.overrideNativeVideoTracks(true);
    } else if (_this.options_.overrideNative && (tech.featuresNativeVideoTracks || tech.featuresNativeAudioTracks)) {
      throw new Error("Overriding native HLS requires emulated tracks. See https://git.io/vMpjB");
    }
    _this.on(document_1, ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "MSFullscreenChange"], function(event) {
      var fullscreenElement = document_1.fullscreenElement || document_1.webkitFullscreenElement || document_1.mozFullScreenElement || document_1.msFullscreenElement;
      if (fullscreenElement && fullscreenElement.contains(_this.tech_.el())) {
        _this.masterPlaylistController_.fastQualityChange_();
      } else {
        _this.masterPlaylistController_.checkABR_();
      }
    });
    _this.on(_this.tech_, "seeking", function() {
      if (this.ignoreNextSeekingEvent_) {
        this.ignoreNextSeekingEvent_ = false;
        return;
      }
      this.setCurrentTime(this.tech_.currentTime());
    });
    _this.on(_this.tech_, "error", function() {
      if (this.tech_.error() && this.masterPlaylistController_) {
        this.masterPlaylistController_.pauseLoading();
      }
    });
    _this.on(_this.tech_, "play", _this.play);
    return _this;
  }
  var _proto = VhsHandler2.prototype;
  _proto.setOptions_ = function setOptions_() {
    var _this2 = this;
    this.options_.withCredentials = this.options_.withCredentials || false;
    this.options_.handleManifestRedirects = this.options_.handleManifestRedirects === false ? false : true;
    this.options_.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions === false ? false : true;
    this.options_.useDevicePixelRatio = this.options_.useDevicePixelRatio || false;
    this.options_.smoothQualityChange = this.options_.smoothQualityChange || false;
    this.options_.useBandwidthFromLocalStorage = typeof this.source_.useBandwidthFromLocalStorage !== "undefined" ? this.source_.useBandwidthFromLocalStorage : this.options_.useBandwidthFromLocalStorage || false;
    this.options_.useNetworkInformationApi = this.options_.useNetworkInformationApi || false;
    this.options_.useDtsForTimestampOffset = this.options_.useDtsForTimestampOffset || false;
    this.options_.customTagParsers = this.options_.customTagParsers || [];
    this.options_.customTagMappers = this.options_.customTagMappers || [];
    this.options_.cacheEncryptionKeys = this.options_.cacheEncryptionKeys || false;
    if (typeof this.options_.blacklistDuration !== "number") {
      this.options_.blacklistDuration = 5 * 60;
    }
    if (typeof this.options_.bandwidth !== "number") {
      if (this.options_.useBandwidthFromLocalStorage) {
        var storedObject = getVhsLocalStorage();
        if (storedObject && storedObject.bandwidth) {
          this.options_.bandwidth = storedObject.bandwidth;
          this.tech_.trigger({
            type: "usage",
            name: "vhs-bandwidth-from-local-storage"
          });
          this.tech_.trigger({
            type: "usage",
            name: "hls-bandwidth-from-local-storage"
          });
        }
        if (storedObject && storedObject.throughput) {
          this.options_.throughput = storedObject.throughput;
          this.tech_.trigger({
            type: "usage",
            name: "vhs-throughput-from-local-storage"
          });
          this.tech_.trigger({
            type: "usage",
            name: "hls-throughput-from-local-storage"
          });
        }
      }
    }
    if (typeof this.options_.bandwidth !== "number") {
      this.options_.bandwidth = Config.INITIAL_BANDWIDTH;
    }
    this.options_.enableLowInitialPlaylist = this.options_.enableLowInitialPlaylist && this.options_.bandwidth === Config.INITIAL_BANDWIDTH;
    ["withCredentials", "useDevicePixelRatio", "limitRenditionByPlayerDimensions", "bandwidth", "smoothQualityChange", "customTagParsers", "customTagMappers", "handleManifestRedirects", "cacheEncryptionKeys", "playlistSelector", "initialPlaylistSelector", "experimentalBufferBasedABR", "liveRangeSafeTimeDelta", "experimentalLLHLS", "useNetworkInformationApi", "useDtsForTimestampOffset", "experimentalExactManifestTimings", "experimentalLeastPixelDiffSelector"].forEach(function(option) {
      if (typeof _this2.source_[option] !== "undefined") {
        _this2.options_[option] = _this2.source_[option];
      }
    });
    this.limitRenditionByPlayerDimensions = this.options_.limitRenditionByPlayerDimensions;
    this.useDevicePixelRatio = this.options_.useDevicePixelRatio;
  };
  _proto.src = function src(_src, type2) {
    var _this3 = this;
    if (!_src) {
      return;
    }
    this.setOptions_();
    this.options_.src = expandDataUri(this.source_.src);
    this.options_.tech = this.tech_;
    this.options_.externVhs = Vhs;
    this.options_.sourceType = simpleTypeFromSourceType(type2);
    this.options_.seekTo = function(time) {
      _this3.tech_.setCurrentTime(time);
    };
    if (this.options_.smoothQualityChange) {
      videojs.log.warn("smoothQualityChange is deprecated and will be removed in the next major version");
    }
    this.masterPlaylistController_ = new MasterPlaylistController(this.options_);
    var playbackWatcherOptions = videojs.mergeOptions({
      liveRangeSafeTimeDelta: SAFE_TIME_DELTA
    }, this.options_, {
      seekable: function seekable3() {
        return _this3.seekable();
      },
      media: function media() {
        return _this3.masterPlaylistController_.media();
      },
      masterPlaylistController: this.masterPlaylistController_
    });
    this.playbackWatcher_ = new PlaybackWatcher(playbackWatcherOptions);
    this.masterPlaylistController_.on("error", function() {
      var player = videojs.players[_this3.tech_.options_.playerId];
      var error2 = _this3.masterPlaylistController_.error;
      if (typeof error2 === "object" && !error2.code) {
        error2.code = 3;
      } else if (typeof error2 === "string") {
        error2 = {
          message: error2,
          code: 3
        };
      }
      player.error(error2);
    });
    var defaultSelector = this.options_.experimentalBufferBasedABR ? Vhs.movingAverageBandwidthSelector(0.55) : Vhs.STANDARD_PLAYLIST_SELECTOR;
    this.masterPlaylistController_.selectPlaylist = this.selectPlaylist ? this.selectPlaylist.bind(this) : defaultSelector.bind(this);
    this.masterPlaylistController_.selectInitialPlaylist = Vhs.INITIAL_PLAYLIST_SELECTOR.bind(this);
    this.playlists = this.masterPlaylistController_.masterPlaylistLoader_;
    this.mediaSource = this.masterPlaylistController_.mediaSource;
    Object.defineProperties(this, {
      selectPlaylist: {
        get: function get7() {
          return this.masterPlaylistController_.selectPlaylist;
        },
        set: function set4(selectPlaylist) {
          this.masterPlaylistController_.selectPlaylist = selectPlaylist.bind(this);
        }
      },
      throughput: {
        get: function get7() {
          return this.masterPlaylistController_.mainSegmentLoader_.throughput.rate;
        },
        set: function set4(throughput) {
          this.masterPlaylistController_.mainSegmentLoader_.throughput.rate = throughput;
          this.masterPlaylistController_.mainSegmentLoader_.throughput.count = 1;
        }
      },
      bandwidth: {
        get: function get7() {
          var playerBandwidthEst = this.masterPlaylistController_.mainSegmentLoader_.bandwidth;
          var networkInformation = window_1.navigator.connection || window_1.navigator.mozConnection || window_1.navigator.webkitConnection;
          var tenMbpsAsBitsPerSecond = 1e7;
          if (this.options_.useNetworkInformationApi && networkInformation) {
            var networkInfoBandwidthEstBitsPerSec = networkInformation.downlink * 1e3 * 1e3;
            if (networkInfoBandwidthEstBitsPerSec >= tenMbpsAsBitsPerSecond && playerBandwidthEst >= tenMbpsAsBitsPerSecond) {
              playerBandwidthEst = Math.max(playerBandwidthEst, networkInfoBandwidthEstBitsPerSec);
            } else {
              playerBandwidthEst = networkInfoBandwidthEstBitsPerSec;
            }
          }
          return playerBandwidthEst;
        },
        set: function set4(bandwidth2) {
          this.masterPlaylistController_.mainSegmentLoader_.bandwidth = bandwidth2;
          this.masterPlaylistController_.mainSegmentLoader_.throughput = {
            rate: 0,
            count: 0
          };
        }
      },
      systemBandwidth: {
        get: function get7() {
          var invBandwidth = 1 / (this.bandwidth || 1);
          var invThroughput;
          if (this.throughput > 0) {
            invThroughput = 1 / this.throughput;
          } else {
            invThroughput = 0;
          }
          var systemBitrate = Math.floor(1 / (invBandwidth + invThroughput));
          return systemBitrate;
        },
        set: function set4() {
          videojs.log.error('The "systemBandwidth" property is read-only');
        }
      }
    });
    if (this.options_.bandwidth) {
      this.bandwidth = this.options_.bandwidth;
    }
    if (this.options_.throughput) {
      this.throughput = this.options_.throughput;
    }
    Object.defineProperties(this.stats, {
      bandwidth: {
        get: function get7() {
          return _this3.bandwidth || 0;
        },
        enumerable: true
      },
      mediaRequests: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaRequests_() || 0;
        },
        enumerable: true
      },
      mediaRequestsAborted: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaRequestsAborted_() || 0;
        },
        enumerable: true
      },
      mediaRequestsTimedout: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaRequestsTimedout_() || 0;
        },
        enumerable: true
      },
      mediaRequestsErrored: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaRequestsErrored_() || 0;
        },
        enumerable: true
      },
      mediaTransferDuration: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaTransferDuration_() || 0;
        },
        enumerable: true
      },
      mediaBytesTransferred: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaBytesTransferred_() || 0;
        },
        enumerable: true
      },
      mediaSecondsLoaded: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaSecondsLoaded_() || 0;
        },
        enumerable: true
      },
      mediaAppends: {
        get: function get7() {
          return _this3.masterPlaylistController_.mediaAppends_() || 0;
        },
        enumerable: true
      },
      mainAppendsToLoadedData: {
        get: function get7() {
          return _this3.masterPlaylistController_.mainAppendsToLoadedData_() || 0;
        },
        enumerable: true
      },
      audioAppendsToLoadedData: {
        get: function get7() {
          return _this3.masterPlaylistController_.audioAppendsToLoadedData_() || 0;
        },
        enumerable: true
      },
      appendsToLoadedData: {
        get: function get7() {
          return _this3.masterPlaylistController_.appendsToLoadedData_() || 0;
        },
        enumerable: true
      },
      timeToLoadedData: {
        get: function get7() {
          return _this3.masterPlaylistController_.timeToLoadedData_() || 0;
        },
        enumerable: true
      },
      buffered: {
        get: function get7() {
          return timeRangesToArray(_this3.tech_.buffered());
        },
        enumerable: true
      },
      currentTime: {
        get: function get7() {
          return _this3.tech_.currentTime();
        },
        enumerable: true
      },
      currentSource: {
        get: function get7() {
          return _this3.tech_.currentSource_;
        },
        enumerable: true
      },
      currentTech: {
        get: function get7() {
          return _this3.tech_.name_;
        },
        enumerable: true
      },
      duration: {
        get: function get7() {
          return _this3.tech_.duration();
        },
        enumerable: true
      },
      master: {
        get: function get7() {
          return _this3.playlists.master;
        },
        enumerable: true
      },
      playerDimensions: {
        get: function get7() {
          return _this3.tech_.currentDimensions();
        },
        enumerable: true
      },
      seekable: {
        get: function get7() {
          return timeRangesToArray(_this3.tech_.seekable());
        },
        enumerable: true
      },
      timestamp: {
        get: function get7() {
          return Date.now();
        },
        enumerable: true
      },
      videoPlaybackQuality: {
        get: function get7() {
          return _this3.tech_.getVideoPlaybackQuality();
        },
        enumerable: true
      }
    });
    this.tech_.one("canplay", this.masterPlaylistController_.setupFirstPlay.bind(this.masterPlaylistController_));
    this.tech_.on("bandwidthupdate", function() {
      if (_this3.options_.useBandwidthFromLocalStorage) {
        updateVhsLocalStorage({
          bandwidth: _this3.bandwidth,
          throughput: Math.round(_this3.throughput)
        });
      }
    });
    this.masterPlaylistController_.on("selectedinitialmedia", function() {
      renditionSelectionMixin(_this3);
    });
    this.masterPlaylistController_.sourceUpdater_.on("createdsourcebuffers", function() {
      _this3.setupEme_();
    });
    this.on(this.masterPlaylistController_, "progress", function() {
      this.tech_.trigger("progress");
    });
    this.on(this.masterPlaylistController_, "firstplay", function() {
      this.ignoreNextSeekingEvent_ = true;
    });
    this.setupQualityLevels_();
    if (!this.tech_.el()) {
      return;
    }
    this.mediaSourceUrl_ = window_1.URL.createObjectURL(this.masterPlaylistController_.mediaSource);
    this.tech_.src(this.mediaSourceUrl_);
  };
  _proto.createKeySessions_ = function createKeySessions_() {
    var _this4 = this;
    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    this.logger_("waiting for EME key session creation");
    waitForKeySessionCreation({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media(),
      mainPlaylists: this.playlists.master.playlists
    }).then(function() {
      _this4.logger_("created EME key session");
      _this4.masterPlaylistController_.sourceUpdater_.initializedEme();
    })["catch"](function(err) {
      _this4.logger_("error while creating EME key session", err);
      _this4.player_.error({
        message: "Failed to initialize media keys for EME",
        code: 3
      });
    });
  };
  _proto.handleWaitingForKey_ = function handleWaitingForKey_() {
    this.logger_("waitingforkey fired, attempting to create any new key sessions");
    this.createKeySessions_();
  };
  _proto.setupEme_ = function setupEme_() {
    var _this5 = this;
    var audioPlaylistLoader = this.masterPlaylistController_.mediaTypes_.AUDIO.activePlaylistLoader;
    var didSetupEmeOptions = setupEmeOptions({
      player: this.player_,
      sourceKeySystems: this.source_.keySystems,
      media: this.playlists.media(),
      audioMedia: audioPlaylistLoader && audioPlaylistLoader.media()
    });
    this.player_.tech_.on("keystatuschange", function(e) {
      if (e.status !== "output-restricted") {
        return;
      }
      var masterPlaylist = _this5.masterPlaylistController_.master();
      if (!masterPlaylist || !masterPlaylist.playlists) {
        return;
      }
      var excludedHDPlaylists = [];
      masterPlaylist.playlists.forEach(function(playlist) {
        if (playlist && playlist.attributes && playlist.attributes.RESOLUTION && playlist.attributes.RESOLUTION.height >= 720) {
          if (!playlist.excludeUntil || playlist.excludeUntil < Infinity) {
            playlist.excludeUntil = Infinity;
            excludedHDPlaylists.push(playlist);
          }
        }
      });
      if (excludedHDPlaylists.length) {
        var _videojs$log;
        (_videojs$log = videojs.log).warn.apply(_videojs$log, ['DRM keystatus changed to "output-restricted." Removing the following HD playlists that will most likely fail to play and clearing the buffer. This may be due to HDCP restrictions on the stream and the capabilities of the current device.'].concat(excludedHDPlaylists));
        _this5.masterPlaylistController_.fastQualityChange_();
      }
    });
    this.handleWaitingForKey_ = this.handleWaitingForKey_.bind(this);
    this.player_.tech_.on("waitingforkey", this.handleWaitingForKey_);
    if (videojs.browser.IE_VERSION === 11 || !didSetupEmeOptions) {
      this.masterPlaylistController_.sourceUpdater_.initializedEme();
      return;
    }
    this.createKeySessions_();
  };
  _proto.setupQualityLevels_ = function setupQualityLevels_() {
    var _this6 = this;
    var player = videojs.players[this.tech_.options_.playerId];
    if (!player || !player.qualityLevels || this.qualityLevels_) {
      return;
    }
    this.qualityLevels_ = player.qualityLevels();
    this.masterPlaylistController_.on("selectedinitialmedia", function() {
      handleVhsLoadedMetadata(_this6.qualityLevels_, _this6);
    });
    this.playlists.on("mediachange", function() {
      handleVhsMediaChange(_this6.qualityLevels_, _this6.playlists);
    });
  };
  VhsHandler2.version = function version$52() {
    return {
      "@videojs/http-streaming": version$4,
      "mux.js": version$3,
      "mpd-parser": version$2,
      "m3u8-parser": version$1,
      "aes-decrypter": version
    };
  };
  _proto.version = function version2() {
    return this.constructor.version();
  };
  _proto.canChangeType = function canChangeType() {
    return SourceUpdater.canChangeType();
  };
  _proto.play = function play() {
    this.masterPlaylistController_.play();
  };
  _proto.setCurrentTime = function setCurrentTime(currentTime) {
    this.masterPlaylistController_.setCurrentTime(currentTime);
  };
  _proto.duration = function duration5() {
    return this.masterPlaylistController_.duration();
  };
  _proto.seekable = function seekable3() {
    return this.masterPlaylistController_.seekable();
  };
  _proto.dispose = function dispose() {
    if (this.playbackWatcher_) {
      this.playbackWatcher_.dispose();
    }
    if (this.masterPlaylistController_) {
      this.masterPlaylistController_.dispose();
    }
    if (this.qualityLevels_) {
      this.qualityLevels_.dispose();
    }
    if (this.player_) {
      delete this.player_.vhs;
      delete this.player_.dash;
      delete this.player_.hls;
    }
    if (this.tech_ && this.tech_.vhs) {
      delete this.tech_.vhs;
    }
    if (this.tech_) {
      delete this.tech_.hls;
    }
    if (this.mediaSourceUrl_ && window_1.URL.revokeObjectURL) {
      window_1.URL.revokeObjectURL(this.mediaSourceUrl_);
      this.mediaSourceUrl_ = null;
    }
    if (this.tech_) {
      this.tech_.off("waitingforkey", this.handleWaitingForKey_);
    }
    _Component.prototype.dispose.call(this);
  };
  _proto.convertToProgramTime = function convertToProgramTime(time, callback2) {
    return getProgramTime({
      playlist: this.masterPlaylistController_.media(),
      time,
      callback: callback2
    });
  };
  _proto.seekToProgramTime = function seekToProgramTime$1(programTime, callback2, pauseAfterSeek, retryCount) {
    if (pauseAfterSeek === void 0) {
      pauseAfterSeek = true;
    }
    if (retryCount === void 0) {
      retryCount = 2;
    }
    return seekToProgramTime({
      programTime,
      playlist: this.masterPlaylistController_.media(),
      retryCount,
      pauseAfterSeek,
      seekTo: this.options_.seekTo,
      tech: this.options_.tech,
      callback: callback2
    });
  };
  return VhsHandler2;
}(Component);
var VhsSourceHandler = {
  name: "videojs-http-streaming",
  VERSION: version$4,
  canHandleSource: function canHandleSource(srcObj, options) {
    if (options === void 0) {
      options = {};
    }
    var localOptions = videojs.mergeOptions(videojs.options, options);
    return VhsSourceHandler.canPlayType(srcObj.type, localOptions);
  },
  handleSource: function handleSource(source, tech, options) {
    if (options === void 0) {
      options = {};
    }
    var localOptions = videojs.mergeOptions(videojs.options, options);
    tech.vhs = new VhsHandler(source, tech, localOptions);
    if (!videojs.hasOwnProperty("hls")) {
      Object.defineProperty(tech, "hls", {
        get: function get7() {
          videojs.log.warn("player.tech().hls is deprecated. Use player.tech().vhs instead.");
          return tech.vhs;
        },
        configurable: true
      });
    }
    tech.vhs.xhr = xhrFactory();
    tech.vhs.src(source.src, source.type);
    return tech.vhs;
  },
  canPlayType: function canPlayType2(type2, options) {
    var simpleType = simpleTypeFromSourceType(type2);
    if (!simpleType) {
      return "";
    }
    var overrideNative = VhsSourceHandler.getOverrideNative(options);
    var supportsTypeNatively = Vhs.supportsTypeNatively(simpleType);
    var canUseMsePlayback = !supportsTypeNatively || overrideNative;
    return canUseMsePlayback ? "maybe" : "";
  },
  getOverrideNative: function getOverrideNative(options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options, _options$vhs = _options.vhs, vhs = _options$vhs === void 0 ? {} : _options$vhs, _options$hls = _options.hls, hls = _options$hls === void 0 ? {} : _options$hls;
    var defaultOverrideNative = !(videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_IOS);
    var _vhs$overrideNative = vhs.overrideNative, overrideNative = _vhs$overrideNative === void 0 ? defaultOverrideNative : _vhs$overrideNative;
    var _hls$overrideNative = hls.overrideNative, legacyOverrideNative = _hls$overrideNative === void 0 ? false : _hls$overrideNative;
    return legacyOverrideNative || overrideNative;
  }
};
var supportsNativeMediaSources = function supportsNativeMediaSources2() {
  return browserSupportsCodec("avc1.4d400d,mp4a.40.2");
};
if (supportsNativeMediaSources()) {
  videojs.getTech("Html5").registerSourceHandler(VhsSourceHandler, 0);
}
videojs.VhsHandler = VhsHandler;
Object.defineProperty(videojs, "HlsHandler", {
  get: function get4() {
    videojs.log.warn("videojs.HlsHandler is deprecated. Use videojs.VhsHandler instead.");
    return VhsHandler;
  },
  configurable: true
});
videojs.VhsSourceHandler = VhsSourceHandler;
Object.defineProperty(videojs, "HlsSourceHandler", {
  get: function get5() {
    videojs.log.warn("videojs.HlsSourceHandler is deprecated. Use videojs.VhsSourceHandler instead.");
    return VhsSourceHandler;
  },
  configurable: true
});
videojs.Vhs = Vhs;
Object.defineProperty(videojs, "Hls", {
  get: function get6() {
    videojs.log.warn("videojs.Hls is deprecated. Use videojs.Vhs instead.");
    return Vhs;
  },
  configurable: true
});
if (!videojs.use) {
  videojs.registerComponent("Hls", Vhs);
  videojs.registerComponent("Vhs", Vhs);
}
videojs.options.vhs = videojs.options.vhs || {};
videojs.options.hls = videojs.options.hls || {};
if (!videojs.getPlugin || !videojs.getPlugin("reloadSourceOnError")) {
  var registerPlugin = videojs.registerPlugin || videojs.plugin;
  registerPlugin("reloadSourceOnError", reloadSourceOnError);
}
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
function ownKeys$1(object, enumerableOnly) {
  var keys3 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest();
}
function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1();
}
function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray$1(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray$1(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var noop = function noop2() {
};
var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER = null;
var _PERFORMANCE = {
  mark: noop,
  measure: noop
};
try {
  if (typeof window !== "undefined")
    _WINDOW = window;
  if (typeof document !== "undefined")
    _DOCUMENT = document;
  if (typeof MutationObserver !== "undefined")
    _MUTATION_OBSERVER = MutationObserver;
  if (typeof performance !== "undefined")
    _PERFORMANCE = performance;
} catch (e) {
}
var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER;
var PERFORMANCE = _PERFORMANCE;
!!WINDOW.document;
var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = "fa";
var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
var DATA_FA_I2SVG = "data-fa-i2svg";
var DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
var DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
var DATA_PREFIX = "data-prefix";
var DATA_ICON = "data-icon";
var HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
var MUTATION_APPROACH_ASYNC = "async";
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ["HTML", "HEAD", "STYLE", "SCRIPT"];
var PRODUCTION$1 = function() {
  try {
    return true;
  } catch (e) {
    return false;
  }
}();
var PREFIX_TO_STYLE = {
  "fas": "solid",
  "fa-solid": "solid",
  "far": "regular",
  "fa-regular": "regular",
  "fal": "light",
  "fa-light": "light",
  "fat": "thin",
  "fa-thin": "thin",
  "fad": "duotone",
  "fa-duotone": "duotone",
  "fab": "brands",
  "fa-brands": "brands",
  "fak": "kit",
  "fa-kit": "kit",
  "fa": "solid"
};
var STYLE_TO_PREFIX = {
  "solid": "fas",
  "regular": "far",
  "light": "fal",
  "thin": "fat",
  "duotone": "fad",
  "brands": "fab",
  "kit": "fak"
};
var PREFIX_TO_LONG_STYLE = {
  "fab": "fa-brands",
  "fad": "fa-duotone",
  "fak": "fa-kit",
  "fal": "fa-light",
  "far": "fa-regular",
  "fas": "fa-solid",
  "fat": "fa-thin"
};
var LONG_STYLE_TO_PREFIX = {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
};
var ICON_SELECTION_SYNTAX_PATTERN = /fa[srltdbk\-\ ]/;
var LAYERS_TEXT_CLASSNAME = "fa-layers-text";
var FONT_FAMILY_PATTERN = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Kit)?.*/i;
var FONT_WEIGHT_TO_PREFIX = {
  "900": "fas",
  "400": "far",
  "normal": "far",
  "300": "fal",
  "100": "fat"
};
var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
var ATTRIBUTES_WATCHED_FOR_MUTATION = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"];
var DUOTONE_CLASSES = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
};
var RESERVED_CLASSES = [].concat(_toConsumableArray$1(Object.keys(STYLE_TO_PREFIX)), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function(n2) {
  return "".concat(n2, "x");
})).concat(oneToTwenty.map(function(n2) {
  return "w-".concat(n2);
}));
var initial = WINDOW.FontAwesomeConfig || {};
function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector("script[" + attr + "]");
  if (element) {
    return element.getAttribute(attr);
  }
}
function coerce(val) {
  if (val === "")
    return true;
  if (val === "false")
    return false;
  if (val === "true")
    return true;
  return val;
}
if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
  var attrs = [["data-family-prefix", "familyPrefix"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  attrs.forEach(function(_ref2) {
    var _ref22 = _slicedToArray(_ref2, 2), attr = _ref22[0], key = _ref22[1];
    var val = coerce(getAttrConfig(attr));
    if (val !== void 0 && val !== null) {
      initial[key] = val;
    }
  });
}
var _default = {
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  styleDefault: "solid",
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  mutateApproach: "async",
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
};
var _config = _objectSpread2$1(_objectSpread2$1({}, _default), initial);
if (!_config.autoReplaceSvg)
  _config.observeMutations = false;
var config = {};
Object.keys(_config).forEach(function(key) {
  Object.defineProperty(config, key, {
    enumerable: true,
    set: function set4(val) {
      _config[key] = val;
      _onChangeCb.forEach(function(cb2) {
        return cb2(config);
      });
    },
    get: function get7() {
      return _config[key];
    }
  });
});
WINDOW.FontAwesomeConfig = config;
var _onChangeCb = [];
function onChange(cb2) {
  _onChangeCb.push(cb2);
  return function() {
    _onChangeCb.splice(_onChangeCb.indexOf(cb2), 1);
  };
}
var d2 = UNITS_IN_GRID;
var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};
function insertCss(css2) {
  if (!css2 || !IS_DOM) {
    return;
  }
  var style = DOCUMENT.createElement("style");
  style.setAttribute("type", "text/css");
  style.innerHTML = css2;
  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;
  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || "").toUpperCase();
    if (["STYLE", "LINK"].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }
  DOCUMENT.head.insertBefore(style, beforeChild);
  return css2;
}
var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function nextUniqueId() {
  var size = 12;
  var id2 = "";
  while (size-- > 0) {
    id2 += idPool[Math.random() * 62 | 0];
  }
  return id2;
}
function toArray(obj) {
  var array2 = [];
  for (var i = (obj || []).length >>> 0; i--; ) {
    array2[i] = obj[i];
  }
  return array2;
}
function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute("class") || "").split(" ").filter(function(i) {
      return i;
    });
  }
}
function htmlEscape(str) {
  return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
    return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
  }, "").trim();
}
function joinStyles(styles2) {
  return Object.keys(styles2 || {}).reduce(function(acc, styleName) {
    return acc + "".concat(styleName, ": ").concat(styles2[styleName].trim(), ";");
  }, "");
}
function transformIsMeaningful(transform3) {
  return transform3.size !== meaninglessTransform.size || transform3.x !== meaninglessTransform.x || transform3.y !== meaninglessTransform.y || transform3.rotate !== meaninglessTransform.rotate || transform3.flipX || transform3.flipY;
}
function transformForSvg(_ref2) {
  var transform3 = _ref2.transform, containerWidth = _ref2.containerWidth, iconWidth = _ref2.iconWidth;
  var outer = {
    transform: "translate(".concat(containerWidth / 2, " 256)")
  };
  var innerTranslate = "translate(".concat(transform3.x * 32, ", ").concat(transform3.y * 32, ") ");
  var innerScale = "scale(".concat(transform3.size / 16 * (transform3.flipX ? -1 : 1), ", ").concat(transform3.size / 16 * (transform3.flipY ? -1 : 1), ") ");
  var innerRotate = "rotate(".concat(transform3.rotate, " 0 0)");
  var inner2 = {
    transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
  };
  var path = {
    transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
  };
  return {
    outer,
    inner: inner2,
    path
  };
}
function transformForCss(_ref2) {
  var transform3 = _ref2.transform, _ref2$width = _ref2.width, width2 = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height2 = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
  var val = "";
  if (startCentered && IS_IE) {
    val += "translate(".concat(transform3.x / d2 - width2 / 2, "em, ").concat(transform3.y / d2 - height2 / 2, "em) ");
  } else if (startCentered) {
    val += "translate(calc(-50% + ".concat(transform3.x / d2, "em), calc(-50% + ").concat(transform3.y / d2, "em)) ");
  } else {
    val += "translate(".concat(transform3.x / d2, "em, ").concat(transform3.y / d2, "em) ");
  }
  val += "scale(".concat(transform3.size / d2 * (transform3.flipX ? -1 : 1), ", ").concat(transform3.size / d2 * (transform3.flipY ? -1 : 1), ") ");
  val += "rotate(".concat(transform3.rotate, "deg) ");
  return val;
}
var baseStyles = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0);\n          animation-delay: var(--fa-animation-delay, 0);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
function css() {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc2 = config.replacementClass;
  var s = baseStyles;
  if (fp !== dfp || rc2 !== drc) {
    var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
    var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
    var rPatt = new RegExp("\\.".concat(drc), "g");
    s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc2));
  }
  return s;
}
var _cssInserted = false;
function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}
var InjectCSS = {
  mixout: function mixout() {
    return {
      dom: {
        css,
        insertCss: ensureCss
      }
    };
  },
  hooks: function hooks3() {
    return {
      beforeDOMElementCreation: function beforeDOMElementCreation() {
        ensureCss();
      },
      beforeI2svg: function beforeI2svg() {
        ensureCss();
      }
    };
  }
};
var w = WINDOW || {};
if (!w[NAMESPACE_IDENTIFIER])
  w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles)
  w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks)
  w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims)
  w[NAMESPACE_IDENTIFIER].shims = [];
var namespace = w[NAMESPACE_IDENTIFIER];
var functions = [];
var listener = function listener2() {
  DOCUMENT.removeEventListener("DOMContentLoaded", listener2);
  loaded = 1;
  functions.map(function(fn) {
    return fn();
  });
};
var loaded = false;
if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
  if (!loaded)
    DOCUMENT.addEventListener("DOMContentLoaded", listener);
}
function domready(fn) {
  if (!IS_DOM)
    return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
}
function toHtml(abstractNodes) {
  var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
  if (typeof abstractNodes === "string") {
    return htmlEscape(abstractNodes);
  } else {
    return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
  }
}
function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix,
      iconName,
      icon: mapping[prefix][iconName]
    };
  }
}
var bindInternal4 = function bindInternal42(func2, thisContext) {
  return function(a, b, c, d3) {
    return func2.call(thisContext, a, b, c, d3);
  };
};
var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
  var keys3 = Object.keys(subject), length = keys3.length, iterator = thisContext !== void 0 ? bindInternal4(fn, thisContext) : fn, i, key, result2;
  if (initialValue === void 0) {
    i = 1;
    result2 = subject[keys3[0]];
  } else {
    i = 0;
    result2 = initialValue;
  }
  for (; i < length; i++) {
    key = keys3[i];
    result2 = iterator(result2, subject[key], key, subject);
  }
  return result2;
};
function ucs2decode(string2) {
  var output = [];
  var counter = 0;
  var length = string2.length;
  while (counter < length) {
    var value = string2.charCodeAt(counter++);
    if (value >= 55296 && value <= 56319 && counter < length) {
      var extra = string2.charCodeAt(counter++);
      if ((extra & 64512) == 56320) {
        output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
      } else {
        output.push(value);
        counter--;
      }
    } else {
      output.push(value);
    }
  }
  return output;
}
function toHex(unicode) {
  var decoded = ucs2decode(unicode);
  return decoded.length === 1 ? decoded[0].toString(16) : null;
}
function codePointAt(string2, index) {
  var size = string2.length;
  var first = string2.charCodeAt(index);
  var second;
  if (first >= 55296 && first <= 56319 && size > index + 1) {
    second = string2.charCodeAt(index + 1);
    if (second >= 56320 && second <= 57343) {
      return (first - 55296) * 1024 + second - 56320 + 65536;
    }
  }
  return first;
}
function normalizeIcons(icons) {
  return Object.keys(icons).reduce(function(acc, iconName) {
    var icon3 = icons[iconName];
    var expanded = !!icon3.icon;
    if (expanded) {
      acc[icon3.iconName] = icon3.icon;
    } else {
      acc[iconName] = icon3;
    }
    return acc;
  }, {});
}
function defineIcons(prefix, icons) {
  var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
  var normalized = normalizeIcons(icons);
  if (typeof namespace.hooks.addPack === "function" && !skipHooks) {
    namespace.hooks.addPack(prefix, normalizeIcons(icons));
  } else {
    namespace.styles[prefix] = _objectSpread2$1(_objectSpread2$1({}, namespace.styles[prefix] || {}), normalized);
  }
  if (prefix === "fas") {
    defineIcons("fa", icons);
  }
}
var styles$h = namespace.styles, shims = namespace.shims;
var LONG_STYLE = Object.values(PREFIX_TO_LONG_STYLE);
var _defaultUsablePrefix = null;
var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};
var _byOldUnicode = {};
var _byAlias = {};
var PREFIXES = Object.keys(PREFIX_TO_STYLE);
function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}
function getIconName(familyPrefix, cls) {
  var parts = cls.split("-");
  var prefix = parts[0];
  var iconName = parts.slice(1).join("-");
  if (prefix === familyPrefix && iconName !== "" && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}
var build = function build2() {
  var lookup = function lookup2(reducer) {
    return reduce(styles$h, function(o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };
  _byUnicode = lookup(function(acc, icon3, iconName) {
    if (icon3[3]) {
      acc[icon3[3]] = iconName;
    }
    if (icon3[2]) {
      var aliases = icon3[2].filter(function(a) {
        return typeof a === "number";
      });
      aliases.forEach(function(alias) {
        acc[alias.toString(16)] = iconName;
      });
    }
    return acc;
  });
  _byLigature = lookup(function(acc, icon3, iconName) {
    acc[iconName] = iconName;
    if (icon3[2]) {
      var aliases = icon3[2].filter(function(a) {
        return typeof a === "string";
      });
      aliases.forEach(function(alias) {
        acc[alias] = iconName;
      });
    }
    return acc;
  });
  _byAlias = lookup(function(acc, icon3, iconName) {
    var aliases = icon3[2];
    acc[iconName] = iconName;
    aliases.forEach(function(alias) {
      acc[alias] = iconName;
    });
    return acc;
  });
  var hasRegular = "far" in styles$h || config.autoFetchSvg;
  var shimLookups = reduce(shims, function(acc, shim) {
    var maybeNameMaybeUnicode = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];
    if (prefix === "far" && !hasRegular) {
      prefix = "fas";
    }
    if (typeof maybeNameMaybeUnicode === "string") {
      acc.names[maybeNameMaybeUnicode] = {
        prefix,
        iconName
      };
    }
    if (typeof maybeNameMaybeUnicode === "number") {
      acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
        prefix,
        iconName
      };
    }
    return acc;
  }, {
    names: {},
    unicodes: {}
  });
  _byOldName = shimLookups.names;
  _byOldUnicode = shimLookups.unicodes;
  _defaultUsablePrefix = getCanonicalPrefix(config.styleDefault);
};
onChange(function(c) {
  _defaultUsablePrefix = getCanonicalPrefix(c.styleDefault);
});
build();
function byUnicode(prefix, unicode) {
  return (_byUnicode[prefix] || {})[unicode];
}
function byLigature(prefix, ligature) {
  return (_byLigature[prefix] || {})[ligature];
}
function byAlias(prefix, alias) {
  return (_byAlias[prefix] || {})[alias];
}
function byOldName(name) {
  return _byOldName[name] || {
    prefix: null,
    iconName: null
  };
}
function byOldUnicode(unicode) {
  var oldUnicode = _byOldUnicode[unicode];
  var newUnicode = byUnicode("fas", unicode);
  return oldUnicode || (newUnicode ? {
    prefix: "fas",
    iconName: newUnicode
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function getDefaultUsablePrefix() {
  return _defaultUsablePrefix;
}
var emptyCanonicalIcon = function emptyCanonicalIcon2() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function getCanonicalPrefix(styleOrPrefix) {
  var style = PREFIX_TO_STYLE[styleOrPrefix];
  var prefix = STYLE_TO_PREFIX[styleOrPrefix] || STYLE_TO_PREFIX[style];
  var defined = styleOrPrefix in namespace.styles ? styleOrPrefix : null;
  return prefix || defined || null;
}
function getCanonicalIcon(values3) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
  var givenPrefix = null;
  var canonical = values3.reduce(function(acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);
    if (styles$h[cls]) {
      cls = LONG_STYLE.includes(cls) ? LONG_STYLE_TO_PREFIX[cls] : cls;
      givenPrefix = cls;
      acc.prefix = cls;
    } else if (PREFIXES.indexOf(cls) > -1) {
      givenPrefix = cls;
      acc.prefix = getCanonicalPrefix(cls);
    } else if (iconName) {
      acc.iconName = iconName;
    } else if (cls !== config.replacementClass) {
      acc.rest.push(cls);
    }
    if (!skipLookups && acc.prefix && acc.iconName) {
      var shim = givenPrefix === "fa" ? byOldName(acc.iconName) : {};
      var aliasIconName = byAlias(acc.prefix, acc.iconName);
      if (shim.prefix) {
        givenPrefix = null;
      }
      acc.iconName = shim.iconName || aliasIconName || acc.iconName;
      acc.prefix = shim.prefix || acc.prefix;
      if (acc.prefix === "far" && !styles$h["far"] && styles$h["fas"] && !config.autoFetchSvg) {
        acc.prefix = "fas";
      }
    }
    return acc;
  }, emptyCanonicalIcon());
  if (canonical.prefix === "fa" || givenPrefix === "fa") {
    canonical.prefix = getDefaultUsablePrefix() || "fas";
  }
  return canonical;
}
var Library = /* @__PURE__ */ function() {
  function Library2() {
    _classCallCheck(this, Library2);
    this.definitions = {};
  }
  _createClass(Library2, [{
    key: "add",
    value: function add2() {
      var _this = this;
      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }
      var additions = definitions.reduce(this._pullDefinitions, {});
      Object.keys(additions).forEach(function(key) {
        _this.definitions[key] = _objectSpread2$1(_objectSpread2$1({}, _this.definitions[key] || {}), additions[key]);
        defineIcons(key, additions[key]);
        var longPrefix = PREFIX_TO_LONG_STYLE[key];
        if (longPrefix)
          defineIcons(longPrefix, additions[key]);
        build();
      });
    }
  }, {
    key: "reset",
    value: function reset3() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? {
        0: definition
      } : definition;
      Object.keys(normalized).map(function(key) {
        var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon3 = _normalized$key.icon;
        var aliases = icon3[2];
        if (!additions[prefix])
          additions[prefix] = {};
        if (aliases.length > 0) {
          aliases.forEach(function(alias) {
            if (typeof alias === "string") {
              additions[prefix][alias] = icon3;
            }
          });
        }
        additions[prefix][iconName] = icon3;
      });
      return additions;
    }
  }]);
  return Library2;
}();
var _plugins = [];
var _hooks = {};
var providers = {};
var defaultProviderKeys = Object.keys(providers);
function registerPlugins(nextPlugins, _ref2) {
  var obj = _ref2.mixoutsTo;
  _plugins = nextPlugins;
  _hooks = {};
  Object.keys(providers).forEach(function(k) {
    if (defaultProviderKeys.indexOf(k) === -1) {
      delete providers[k];
    }
  });
  _plugins.forEach(function(plugin) {
    var mixout8 = plugin.mixout ? plugin.mixout() : {};
    Object.keys(mixout8).forEach(function(tk) {
      if (typeof mixout8[tk] === "function") {
        obj[tk] = mixout8[tk];
      }
      if (_typeof$1(mixout8[tk]) === "object") {
        Object.keys(mixout8[tk]).forEach(function(sk) {
          if (!obj[tk]) {
            obj[tk] = {};
          }
          obj[tk][sk] = mixout8[tk][sk];
        });
      }
    });
    if (plugin.hooks) {
      var hooks10 = plugin.hooks();
      Object.keys(hooks10).forEach(function(hook3) {
        if (!_hooks[hook3]) {
          _hooks[hook3] = [];
        }
        _hooks[hook3].push(hooks10[hook3]);
      });
    }
    if (plugin.provides) {
      plugin.provides(providers);
    }
  });
  return obj;
}
function chainHooks(hook3, accumulator) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  var hookFns = _hooks[hook3] || [];
  hookFns.forEach(function(hookFn) {
    accumulator = hookFn.apply(null, [accumulator].concat(args));
  });
  return accumulator;
}
function callHooks(hook3) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }
  var hookFns = _hooks[hook3] || [];
  hookFns.forEach(function(hookFn) {
    hookFn.apply(null, args);
  });
  return void 0;
}
function callProvided() {
  var hook3 = arguments[0];
  var args = Array.prototype.slice.call(arguments, 1);
  return providers[hook3] ? providers[hook3].apply(null, args) : void 0;
}
function findIconDefinition(iconLookup) {
  if (iconLookup.prefix === "fa") {
    iconLookup.prefix = "fas";
  }
  var iconName = iconLookup.iconName;
  var prefix = iconLookup.prefix || getDefaultUsablePrefix();
  if (!iconName)
    return;
  iconName = byAlias(prefix, iconName) || iconName;
  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}
var library = new Library();
var noAuto = function noAuto2() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;
  callHooks("noAuto");
};
var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (IS_DOM) {
      callHooks("beforeI2svg", params);
      callProvided("pseudoElements2svg", params);
      return callProvided("i2svg", params);
    } else {
      return Promise.reject("Operation requires a DOM of some kind.");
    }
  },
  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }
    config.observeMutations = true;
    domready(function() {
      autoReplace({
        autoReplaceSvgRoot
      });
      callHooks("watch", params);
    });
  }
};
var parse2 = {
  icon: function icon(_icon) {
    if (_icon === null) {
      return null;
    }
    if (_typeof$1(_icon) === "object" && _icon.prefix && _icon.iconName) {
      return {
        prefix: _icon.prefix,
        iconName: byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
      };
    }
    if (Array.isArray(_icon) && _icon.length === 2) {
      var iconName = _icon[1].indexOf("fa-") === 0 ? _icon[1].slice(3) : _icon[1];
      var prefix = getCanonicalPrefix(_icon[0]);
      return {
        prefix,
        iconName: byAlias(prefix, iconName) || iconName
      };
    }
    if (typeof _icon === "string" && (_icon.indexOf("".concat(config.familyPrefix, "-")) > -1 || _icon.match(ICON_SELECTION_SYNTAX_PATTERN))) {
      var canonicalIcon = getCanonicalIcon(_icon.split(" "), {
        skipLookups: true
      });
      return {
        prefix: canonicalIcon.prefix || getDefaultUsablePrefix(),
        iconName: byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
      };
    }
    if (typeof _icon === "string") {
      var _prefix = getDefaultUsablePrefix();
      return {
        prefix: _prefix,
        iconName: byAlias(_prefix, _icon) || _icon
      };
    }
  }
};
var api = {
  noAuto,
  config,
  dom,
  parse: parse2,
  library,
  findIconDefinition,
  toHtml
};
var autoReplace = function autoReplace2() {
  var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
  if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg)
    api.dom.i2svg({
      node: autoReplaceSvgRoot
    });
};
function domVariants(val, abstractCreator) {
  Object.defineProperty(val, "abstract", {
    get: abstractCreator
  });
  Object.defineProperty(val, "html", {
    get: function get7() {
      return val.abstract.map(function(a) {
        return toHtml(a);
      });
    }
  });
  Object.defineProperty(val, "node", {
    get: function get7() {
      if (!IS_DOM)
        return;
      var container2 = DOCUMENT.createElement("div");
      container2.innerHTML = val.html;
      return container2.children;
    }
  });
  return val;
}
function asIcon(_ref2) {
  var children = _ref2.children, main = _ref2.main, mask = _ref2.mask, attributes = _ref2.attributes, styles2 = _ref2.styles, transform3 = _ref2.transform;
  if (transformIsMeaningful(transform3) && main.found && !mask.found) {
    var width2 = main.width, height2 = main.height;
    var offset2 = {
      x: width2 / height2 / 2,
      y: 0.5
    };
    attributes["style"] = joinStyles(_objectSpread2$1(_objectSpread2$1({}, styles2), {}, {
      "transform-origin": "".concat(offset2.x + transform3.x / 16, "em ").concat(offset2.y + transform3.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes,
    children
  }];
}
function asSymbol(_ref2) {
  var prefix = _ref2.prefix, iconName = _ref2.iconName, children = _ref2.children, attributes = _ref2.attributes, symbol = _ref2.symbol;
  var id2 = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: _objectSpread2$1(_objectSpread2$1({}, attributes), {}, {
        id: id2
      }),
      children
    }]
  }];
}
function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform3 = params.transform, symbol = params.symbol, title2 = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
  var _ref2 = mask.found ? mask : main, width2 = _ref2.width, height2 = _ref2.height;
  var isUploadedIcon = prefix === "fak";
  var attrClass = [config.replacementClass, iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : ""].filter(function(c) {
    return extra.classes.indexOf(c) === -1;
  }).filter(function(c) {
    return c !== "" || !!c;
  }).concat(extra.classes).join(" ");
  var content2 = {
    children: [],
    attributes: _objectSpread2$1(_objectSpread2$1({}, extra.attributes), {}, {
      "data-prefix": prefix,
      "data-icon": iconName,
      "class": attrClass,
      "role": extra.attributes.role || "img",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 ".concat(width2, " ").concat(height2)
    })
  };
  var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
    width: "".concat(width2 / height2 * 16 * 0.0625, "em")
  } : {};
  if (watchable) {
    content2.attributes[DATA_FA_I2SVG] = "";
  }
  if (title2) {
    content2.children.push({
      tag: "title",
      attributes: {
        id: content2.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
      },
      children: [title2]
    });
    delete content2.attributes.title;
  }
  var args = _objectSpread2$1(_objectSpread2$1({}, content2), {}, {
    prefix,
    iconName,
    main,
    mask,
    maskId,
    transform: transform3,
    symbol,
    styles: _objectSpread2$1(_objectSpread2$1({}, uploadedIconWidthStyle), extra.styles)
  });
  var _ref22 = mask.found && main.found ? callProvided("generateAbstractMask", args) || {
    children: [],
    attributes: {}
  } : callProvided("generateAbstractIcon", args) || {
    children: [],
    attributes: {}
  }, children = _ref22.children, attributes = _ref22.attributes;
  args.children = children;
  args.attributes = attributes;
  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}
function makeLayersTextAbstract(params) {
  var content2 = params.content, width2 = params.width, height2 = params.height, transform3 = params.transform, title2 = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title2 ? {
    "title": title2
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  if (watchable) {
    attributes[DATA_FA_I2SVG] = "";
  }
  var styles2 = _objectSpread2$1({}, extra.styles);
  if (transformIsMeaningful(transform3)) {
    styles2["transform"] = transformForCss({
      transform: transform3,
      startCentered: true,
      width: width2,
      height: height2
    });
    styles2["-webkit-transform"] = styles2["transform"];
  }
  var styleString = joinStyles(styles2);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content2]
  });
  if (title2) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title2]
    });
  }
  return val;
}
function makeLayersCounterAbstract(params) {
  var content2 = params.content, title2 = params.title, extra = params.extra;
  var attributes = _objectSpread2$1(_objectSpread2$1(_objectSpread2$1({}, extra.attributes), title2 ? {
    "title": title2
  } : {}), {}, {
    "class": extra.classes.join(" ")
  });
  var styleString = joinStyles(extra.styles);
  if (styleString.length > 0) {
    attributes["style"] = styleString;
  }
  var val = [];
  val.push({
    tag: "span",
    attributes,
    children: [content2]
  });
  if (title2) {
    val.push({
      tag: "span",
      attributes: {
        class: "sr-only"
      },
      children: [title2]
    });
  }
  return val;
}
var styles$1$1 = namespace.styles;
function asFoundIcon(icon3) {
  var width2 = icon3[0];
  var height2 = icon3[1];
  var _icon$slice = icon3.slice(4), _icon$slice2 = _slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
  var element = null;
  if (Array.isArray(vectorData)) {
    element = {
      tag: "g",
      attributes: {
        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
      },
      children: [{
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
          fill: "currentColor",
          d: vectorData[0]
        }
      }, {
        tag: "path",
        attributes: {
          class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
          fill: "currentColor",
          d: vectorData[1]
        }
      }]
    };
  } else {
    element = {
      tag: "path",
      attributes: {
        fill: "currentColor",
        d: vectorData
      }
    };
  }
  return {
    found: true,
    width: width2,
    height: height2,
    icon: element
  };
}
var missingIconResolutionMixin = {
  found: false,
  width: 512,
  height: 512
};
function maybeNotifyMissing(iconName, prefix) {
  if (!PRODUCTION$1 && !config.showMissingIcons && iconName) {
    console.error('Icon with name "'.concat(iconName, '" and prefix "').concat(prefix, '" is missing.'));
  }
}
function findIcon(iconName, prefix) {
  var givenPrefix = prefix;
  if (prefix === "fa" && config.styleDefault !== null) {
    prefix = getDefaultUsablePrefix();
  }
  return new Promise(function(resolve, reject) {
    ({
      found: false,
      width: 512,
      height: 512,
      icon: callProvided("missingIconAbstract") || {}
    });
    if (givenPrefix === "fa") {
      var shim = byOldName(iconName) || {};
      iconName = shim.iconName || iconName;
      prefix = shim.prefix || prefix;
    }
    if (iconName && prefix && styles$1$1[prefix] && styles$1$1[prefix][iconName]) {
      var icon3 = styles$1$1[prefix][iconName];
      return resolve(asFoundIcon(icon3));
    }
    maybeNotifyMissing(iconName, prefix);
    resolve(_objectSpread2$1(_objectSpread2$1({}, missingIconResolutionMixin), {}, {
      icon: config.showMissingIcons && iconName ? callProvided("missingIconAbstract") || {} : {}
    }));
  });
}
var noop$1 = function noop3() {
};
var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
  mark: noop$1,
  measure: noop$1
};
var preamble = 'FA "6.1.1"';
var begin = function begin2(name) {
  p.mark("".concat(preamble, " ").concat(name, " begins"));
  return function() {
    return end(name);
  };
};
var end = function end2(name) {
  p.mark("".concat(preamble, " ").concat(name, " ends"));
  p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
};
var perf = {
  begin,
  end
};
var noop$2 = function noop4() {
};
function isWatched(node) {
  var i2svg2 = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
  return typeof i2svg2 === "string";
}
function hasPrefixAndIcon(node) {
  var prefix = node.getAttribute ? node.getAttribute(DATA_PREFIX) : null;
  var icon3 = node.getAttribute ? node.getAttribute(DATA_ICON) : null;
  return prefix && icon3;
}
function hasBeenReplaced(node) {
  return node && node.classList && node.classList.contains && node.classList.contains(config.replacementClass);
}
function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }
  var mutator = mutators[config.autoReplaceSvg];
  return mutator || mutators.replace;
}
function createElementNS(tag) {
  return DOCUMENT.createElementNS("http://www.w3.org/2000/svg", tag);
}
function createElement(tag) {
  return DOCUMENT.createElement(tag);
}
function convertSVG(abstractObj) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === "svg" ? createElementNS : createElement : _params$ceFn;
  if (typeof abstractObj === "string") {
    return DOCUMENT.createTextNode(abstractObj);
  }
  var tag = ceFn(abstractObj.tag);
  Object.keys(abstractObj.attributes || []).forEach(function(key) {
    tag.setAttribute(key, abstractObj.attributes[key]);
  });
  var children = abstractObj.children || [];
  children.forEach(function(child) {
    tag.appendChild(convertSVG(child, {
      ceFn
    }));
  });
  return tag;
}
function nodeAsComment(node) {
  var comment = " ".concat(node.outerHTML, " ");
  comment = "".concat(comment, "Font Awesome fontawesome.com ");
  return comment;
}
var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];
    if (node.parentNode) {
      mutation[1].forEach(function(abstract) {
        node.parentNode.insertBefore(convertSVG(abstract), node);
      });
      if (node.getAttribute(DATA_FA_I2SVG) === null && config.keepOriginalSource) {
        var comment = DOCUMENT.createComment(nodeAsComment(node));
        node.parentNode.replaceChild(comment, node);
      } else {
        node.remove();
      }
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];
    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }
    var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
    delete abstract[0].attributes.id;
    if (abstract[0].attributes.class) {
      var splitClasses = abstract[0].attributes.class.split(" ").reduce(function(acc, cls) {
        if (cls === config.replacementClass || cls.match(forSvg)) {
          acc.toSvg.push(cls);
        } else {
          acc.toNode.push(cls);
        }
        return acc;
      }, {
        toNode: [],
        toSvg: []
      });
      abstract[0].attributes.class = splitClasses.toSvg.join(" ");
      if (splitClasses.toNode.length === 0) {
        node.removeAttribute("class");
      } else {
        node.setAttribute("class", splitClasses.toNode.join(" "));
      }
    }
    var newInnerHTML = abstract.map(function(a) {
      return toHtml(a);
    }).join("\n");
    node.setAttribute(DATA_FA_I2SVG, "");
    node.innerHTML = newInnerHTML;
  }
};
function performOperationSync(op) {
  op();
}
function perform(mutations, callback2) {
  var callbackFunction = typeof callback2 === "function" ? callback2 : noop$2;
  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = performOperationSync;
    if (config.mutateApproach === MUTATION_APPROACH_ASYNC) {
      frame = WINDOW.requestAnimationFrame || performOperationSync;
    }
    frame(function() {
      var mutator = getMutator();
      var mark = perf.begin("mutate");
      mutations.map(mutator);
      mark();
      callbackFunction();
    });
  }
}
var disabled$2 = false;
function disableObservation() {
  disabled$2 = true;
}
function enableObservation() {
  disabled$2 = false;
}
var mo = null;
function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }
  if (!config.observeMutations) {
    return;
  }
  var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
  mo = new MUTATION_OBSERVER(function(objects) {
    if (disabled$2)
      return;
    var defaultPrefix = getDefaultUsablePrefix();
    toArray(objects).forEach(function(mutationRecord) {
      if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }
        treeCallback(mutationRecord.target);
      }
      if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }
      if (mutationRecord.type === "attributes" && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === "class" && hasPrefixAndIcon(mutationRecord.target)) {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
          mutationRecord.target.setAttribute(DATA_PREFIX, prefix || defaultPrefix);
          if (iconName)
            mutationRecord.target.setAttribute(DATA_ICON, iconName);
        } else if (hasBeenReplaced(mutationRecord.target)) {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });
  if (!IS_DOM)
    return;
  mo.observe(observeMutationsRoot, {
    childList: true,
    attributes: true,
    characterData: true,
    subtree: true
  });
}
function disconnect() {
  if (!mo)
    return;
  mo.disconnect();
}
function styleParser(node) {
  var style = node.getAttribute("style");
  var val = [];
  if (style) {
    val = style.split(";").reduce(function(acc, style2) {
      var styles2 = style2.split(":");
      var prop = styles2[0];
      var value = styles2.slice(1);
      if (prop && value.length > 0) {
        acc[prop] = value.join(":").trim();
      }
      return acc;
    }, {});
  }
  return val;
}
function classParser(node) {
  var existingPrefix = node.getAttribute("data-prefix");
  var existingIconName = node.getAttribute("data-icon");
  var innerText = node.innerText !== void 0 ? node.innerText.trim() : "";
  var val = getCanonicalIcon(classArray(node));
  if (!val.prefix) {
    val.prefix = getDefaultUsablePrefix();
  }
  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }
  if (val.iconName && val.prefix) {
    return val;
  }
  if (val.prefix && innerText.length > 0) {
    val.iconName = byLigature(val.prefix, node.innerText) || byUnicode(val.prefix, toHex(node.innerText));
  }
  return val;
}
function attributesParser(node) {
  var extraAttributes = toArray(node.attributes).reduce(function(acc, attr) {
    if (acc.name !== "class" && acc.name !== "style") {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});
  var title2 = node.getAttribute("title");
  var titleId = node.getAttribute("data-fa-title-id");
  if (config.autoA11y) {
    if (title2) {
      extraAttributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
    } else {
      extraAttributes["aria-hidden"] = "true";
      extraAttributes["focusable"] = "false";
    }
  }
  return extraAttributes;
}
function blankMeta() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: meaninglessTransform,
    symbol: false,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function parseMeta(node) {
  var parser2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: true
  };
  var _classParser = classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
  var extraAttributes = attributesParser(node);
  var pluginMeta = chainHooks("parseNodeAttributes", {}, node);
  var extraStyles = parser2.styleParser ? styleParser(node) : [];
  return _objectSpread2$1({
    iconName,
    title: node.getAttribute("title"),
    titleId: node.getAttribute("data-fa-title-id"),
    prefix,
    transform: meaninglessTransform,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: false,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  }, pluginMeta);
}
var styles$2$1 = namespace.styles;
function generateMutation(node) {
  var nodeMeta = config.autoReplaceSvg === "nest" ? parseMeta(node, {
    styleParser: false
  }) : parseMeta(node);
  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return callProvided("generateLayersText", node, nodeMeta);
  } else {
    return callProvided("generateSvgReplacementMutation", node, nodeMeta);
  }
}
function onTree(root) {
  var callback2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!IS_DOM)
    return Promise.resolve();
  var htmlClassList2 = DOCUMENT.documentElement.classList;
  var hclAdd = function hclAdd2(suffix) {
    return htmlClassList2.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var hclRemove = function hclRemove2(suffix) {
    return htmlClassList2.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
  };
  var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$2$1);
  var prefixesDomQuery = [".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")].concat(prefixes.map(function(p2) {
    return ".".concat(p2, ":not([").concat(DATA_FA_I2SVG, "])");
  })).join(", ");
  if (prefixesDomQuery.length === 0) {
    return Promise.resolve();
  }
  var candidates = [];
  try {
    candidates = toArray(root.querySelectorAll(prefixesDomQuery));
  } catch (e) {
  }
  if (candidates.length > 0) {
    hclAdd("pending");
    hclRemove("complete");
  } else {
    return Promise.resolve();
  }
  var mark = perf.begin("onTree");
  var mutations = candidates.reduce(function(acc, node) {
    try {
      var mutation = generateMutation(node);
      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION$1) {
        if (e.name === "MissingIcon") {
          console.error(e);
        }
      }
    }
    return acc;
  }, []);
  return new Promise(function(resolve, reject) {
    Promise.all(mutations).then(function(resolvedMutations) {
      perform(resolvedMutations, function() {
        hclAdd("active");
        hclAdd("complete");
        hclRemove("pending");
        if (typeof callback2 === "function")
          callback2();
        mark();
        resolve();
      });
    }).catch(function(e) {
      mark();
      reject(e);
    });
  });
}
function onNode(node) {
  var callback2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  generateMutation(node).then(function(mutation) {
    if (mutation) {
      perform([mutation], callback2);
    }
  });
}
function resolveIcons(next) {
  return function(maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
    var mask = params.mask;
    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }
    return next(iconDefinition, _objectSpread2$1(_objectSpread2$1({}, params), {}, {
      mask
    }));
  };
}
var render = function render2(iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _params$transform = params.transform, transform3 = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title2 = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
  if (!iconDefinition)
    return;
  var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon3 = iconDefinition.icon;
  return domVariants(_objectSpread2$1({
    type: "icon"
  }, iconDefinition), function() {
    callHooks("beforeDOMElementCreation", {
      iconDefinition,
      params
    });
    if (config.autoA11y) {
      if (title2) {
        attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
      } else {
        attributes["aria-hidden"] = "true";
        attributes["focusable"] = "false";
      }
    }
    return makeInlineSvgAbstract({
      icons: {
        main: asFoundIcon(icon3),
        mask: mask ? asFoundIcon(mask.icon) : {
          found: false,
          width: null,
          height: null,
          icon: {}
        }
      },
      prefix,
      iconName,
      transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform3),
      symbol,
      title: title2,
      maskId,
      titleId,
      extra: {
        attributes,
        styles: styles2,
        classes
      }
    });
  });
};
var ReplaceElements = {
  mixout: function mixout2() {
    return {
      icon: resolveIcons(render)
    };
  },
  hooks: function hooks4() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.treeCallback = onTree;
        accumulator.nodeCallback = onNode;
        return accumulator;
      }
    };
  },
  provides: function provides(providers$$1) {
    providers$$1.i2svg = function(params) {
      var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node, _params$callback = params.callback, callback2 = _params$callback === void 0 ? function() {
      } : _params$callback;
      return onTree(node, callback2);
    };
    providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
      var iconName = nodeMeta.iconName, title2 = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform3 = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
      return new Promise(function(resolve, reject) {
        Promise.all([findIcon(iconName, prefix), mask.iconName ? findIcon(mask.iconName, mask.prefix) : Promise.resolve({
          found: false,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(_ref2) {
          var _ref22 = _slicedToArray(_ref2, 2), main = _ref22[0], mask2 = _ref22[1];
          resolve([node, makeInlineSvgAbstract({
            icons: {
              main,
              mask: mask2
            },
            prefix,
            iconName,
            transform: transform3,
            symbol,
            maskId,
            title: title2,
            titleId,
            extra,
            watchable: true
          })]);
        }).catch(reject);
      });
    };
    providers$$1.generateAbstractIcon = function(_ref3) {
      var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform3 = _ref3.transform, styles2 = _ref3.styles;
      var styleString = joinStyles(styles2);
      if (styleString.length > 0) {
        attributes["style"] = styleString;
      }
      var nextChild;
      if (transformIsMeaningful(transform3)) {
        nextChild = callProvided("generateAbstractTransformGrouping", {
          main,
          transform: transform3,
          containerWidth: main.width,
          iconWidth: main.width
        });
      }
      children.push(nextChild || main.icon);
      return {
        children,
        attributes
      };
    };
  }
};
var Layers = {
  mixout: function mixout3() {
    return {
      layer: function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
        return domVariants({
          type: "layer"
        }, function() {
          callHooks("beforeDOMElementCreation", {
            assembler,
            params
          });
          var children = [];
          assembler(function(args) {
            Array.isArray(args) ? args.map(function(a) {
              children = children.concat(a.abstract);
            }) : children = children.concat(args.abstract);
          });
          return [{
            tag: "span",
            attributes: {
              class: ["".concat(config.familyPrefix, "-layers")].concat(_toConsumableArray$1(classes)).join(" ")
            },
            children
          }];
        });
      }
    };
  }
};
var LayersCounter = {
  mixout: function mixout4() {
    return {
      counter: function counter(content2) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$title = params.title, title2 = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "counter",
          content: content2
        }, function() {
          callHooks("beforeDOMElementCreation", {
            content: content2,
            params
          });
          return makeLayersCounterAbstract({
            content: content2.toString(),
            title: title2,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.familyPrefix, "-layers-counter")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  }
};
var LayersText = {
  mixout: function mixout5() {
    return {
      text: function text(content2) {
        var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _params$transform = params.transform, transform3 = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$title = params.title, title2 = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles2 = _params$styles === void 0 ? {} : _params$styles;
        return domVariants({
          type: "text",
          content: content2
        }, function() {
          callHooks("beforeDOMElementCreation", {
            content: content2,
            params
          });
          return makeLayersTextAbstract({
            content: content2,
            transform: _objectSpread2$1(_objectSpread2$1({}, meaninglessTransform), transform3),
            title: title2,
            extra: {
              attributes,
              styles: styles2,
              classes: ["".concat(config.familyPrefix, "-layers-text")].concat(_toConsumableArray$1(classes))
            }
          });
        });
      }
    };
  },
  provides: function provides2(providers$$1) {
    providers$$1.generateLayersText = function(node, nodeMeta) {
      var title2 = nodeMeta.title, transform3 = nodeMeta.transform, extra = nodeMeta.extra;
      var width2 = null;
      var height2 = null;
      if (IS_IE) {
        var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
        var boundingClientRect = node.getBoundingClientRect();
        width2 = boundingClientRect.width / computedFontSize;
        height2 = boundingClientRect.height / computedFontSize;
      }
      if (config.autoA11y && !title2) {
        extra.attributes["aria-hidden"] = "true";
      }
      return Promise.resolve([node, makeLayersTextAbstract({
        content: node.innerHTML,
        width: width2,
        height: height2,
        transform: transform3,
        title: title2,
        extra,
        watchable: true
      })]);
    };
  }
};
var CLEAN_CONTENT_PATTERN = new RegExp('"', "ug");
var SECONDARY_UNICODE_RANGE = [1105920, 1112319];
function hexValueFromContent(content2) {
  var cleaned = content2.replace(CLEAN_CONTENT_PATTERN, "");
  var codePoint = codePointAt(cleaned, 0);
  var isPrependTen = codePoint >= SECONDARY_UNICODE_RANGE[0] && codePoint <= SECONDARY_UNICODE_RANGE[1];
  var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
  return {
    value: isDoubled ? toHex(cleaned[0]) : toHex(cleaned),
    isSecondary: isPrependTen || isDoubled
  };
}
function replaceForPosition(node, position2) {
  var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position2.replace(":", "-"));
  return new Promise(function(resolve, reject) {
    if (node.getAttribute(pendingAttribute) !== null) {
      return resolve();
    }
    var children = toArray(node.children);
    var alreadyProcessedPseudoElement = children.filter(function(c) {
      return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position2;
    })[0];
    var styles2 = WINDOW.getComputedStyle(node, position2);
    var fontFamily = styles2.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN);
    var fontWeight = styles2.getPropertyValue("font-weight");
    var content2 = styles2.getPropertyValue("content");
    if (alreadyProcessedPseudoElement && !fontFamily) {
      node.removeChild(alreadyProcessedPseudoElement);
      return resolve();
    } else if (fontFamily && content2 !== "none" && content2 !== "") {
      var _content = styles2.getPropertyValue("content");
      var prefix = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
      var _hexValueFromContent = hexValueFromContent(_content), hexValue = _hexValueFromContent.value, isSecondary = _hexValueFromContent.isSecondary;
      var isV4 = fontFamily[0].startsWith("FontAwesome");
      var iconName = byUnicode(prefix, hexValue);
      var iconIdentifier = iconName;
      if (isV4) {
        var iconName4 = byOldUnicode(hexValue);
        if (iconName4.iconName && iconName4.prefix) {
          iconName = iconName4.iconName;
          prefix = iconName4.prefix;
        }
      }
      if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
        node.setAttribute(pendingAttribute, iconIdentifier);
        if (alreadyProcessedPseudoElement) {
          node.removeChild(alreadyProcessedPseudoElement);
        }
        var meta = blankMeta();
        var extra = meta.extra;
        extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position2;
        findIcon(iconName, prefix).then(function(main) {
          var abstract = makeInlineSvgAbstract(_objectSpread2$1(_objectSpread2$1({}, meta), {}, {
            icons: {
              main,
              mask: emptyCanonicalIcon()
            },
            prefix,
            iconName: iconIdentifier,
            extra,
            watchable: true
          }));
          var element = DOCUMENT.createElement("svg");
          if (position2 === "::before") {
            node.insertBefore(element, node.firstChild);
          } else {
            node.appendChild(element);
          }
          element.outerHTML = abstract.map(function(a) {
            return toHtml(a);
          }).join("\n");
          node.removeAttribute(pendingAttribute);
          resolve();
        }).catch(reject);
      } else {
        resolve();
      }
    } else {
      resolve();
    }
  });
}
function replace2(node) {
  return Promise.all([replaceForPosition(node, "::before"), replaceForPosition(node, "::after")]);
}
function processable(node) {
  return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
}
function searchPseudoElements(root) {
  if (!IS_DOM)
    return;
  return new Promise(function(resolve, reject) {
    var operations = toArray(root.querySelectorAll("*")).filter(processable).map(replace2);
    var end3 = perf.begin("searchPseudoElements");
    disableObservation();
    Promise.all(operations).then(function() {
      end3();
      enableObservation();
      resolve();
    }).catch(function() {
      end3();
      enableObservation();
      reject();
    });
  });
}
var PseudoElements = {
  hooks: function hooks5() {
    return {
      mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
        accumulator.pseudoElementsCallback = searchPseudoElements;
        return accumulator;
      }
    };
  },
  provides: function provides3(providers$$1) {
    providers$$1.pseudoElements2svg = function(params) {
      var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node;
      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }
    };
  }
};
var _unwatched = false;
var MutationObserver$1 = {
  mixout: function mixout6() {
    return {
      dom: {
        unwatch: function unwatch() {
          disableObservation();
          _unwatched = true;
        }
      }
    };
  },
  hooks: function hooks6() {
    return {
      bootstrap: function bootstrap() {
        observe(chainHooks("mutationObserverCallbacks", {}));
      },
      noAuto: function noAuto3() {
        disconnect();
      },
      watch: function watch2(params) {
        var observeMutationsRoot = params.observeMutationsRoot;
        if (_unwatched) {
          enableObservation();
        } else {
          observe(chainHooks("mutationObserverCallbacks", {
            observeMutationsRoot
          }));
        }
      }
    };
  }
};
var parseTransformString = function parseTransformString2(transformString) {
  var transform3 = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };
  return transformString.toLowerCase().split(" ").reduce(function(acc, n2) {
    var parts = n2.toLowerCase().split("-");
    var first = parts[0];
    var rest = parts.slice(1).join("-");
    if (first && rest === "h") {
      acc.flipX = true;
      return acc;
    }
    if (first && rest === "v") {
      acc.flipY = true;
      return acc;
    }
    rest = parseFloat(rest);
    if (isNaN(rest)) {
      return acc;
    }
    switch (first) {
      case "grow":
        acc.size = acc.size + rest;
        break;
      case "shrink":
        acc.size = acc.size - rest;
        break;
      case "left":
        acc.x = acc.x - rest;
        break;
      case "right":
        acc.x = acc.x + rest;
        break;
      case "up":
        acc.y = acc.y - rest;
        break;
      case "down":
        acc.y = acc.y + rest;
        break;
      case "rotate":
        acc.rotate = acc.rotate + rest;
        break;
    }
    return acc;
  }, transform3);
};
var PowerTransforms = {
  mixout: function mixout7() {
    return {
      parse: {
        transform: function transform3(transformString) {
          return parseTransformString(transformString);
        }
      }
    };
  },
  hooks: function hooks7() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var transformString = node.getAttribute("data-fa-transform");
        if (transformString) {
          accumulator.transform = parseTransformString(transformString);
        }
        return accumulator;
      }
    };
  },
  provides: function provides4(providers2) {
    providers2.generateAbstractTransformGrouping = function(_ref2) {
      var main = _ref2.main, transform3 = _ref2.transform, containerWidth = _ref2.containerWidth, iconWidth = _ref2.iconWidth;
      var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
      };
      var innerTranslate = "translate(".concat(transform3.x * 32, ", ").concat(transform3.y * 32, ") ");
      var innerScale = "scale(".concat(transform3.size / 16 * (transform3.flipX ? -1 : 1), ", ").concat(transform3.size / 16 * (transform3.flipY ? -1 : 1), ") ");
      var innerRotate = "rotate(".concat(transform3.rotate, " 0 0)");
      var inner2 = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
      };
      var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
      };
      var operations = {
        outer,
        inner: inner2,
        path
      };
      return {
        tag: "g",
        attributes: _objectSpread2$1({}, operations.outer),
        children: [{
          tag: "g",
          attributes: _objectSpread2$1({}, operations.inner),
          children: [{
            tag: main.icon.tag,
            children: main.icon.children,
            attributes: _objectSpread2$1(_objectSpread2$1({}, main.icon.attributes), operations.path)
          }]
        }]
      };
    };
  }
};
var ALL_SPACE = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function fillBlack(abstract) {
  var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (abstract.attributes && (abstract.attributes.fill || force)) {
    abstract.attributes.fill = "black";
  }
  return abstract;
}
function deGroup(abstract) {
  if (abstract.tag === "g") {
    return abstract.children;
  } else {
    return [abstract];
  }
}
var Masks = {
  hooks: function hooks8() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var maskData = node.getAttribute("data-fa-mask");
        var mask = !maskData ? emptyCanonicalIcon() : getCanonicalIcon(maskData.split(" ").map(function(i) {
          return i.trim();
        }));
        if (!mask.prefix) {
          mask.prefix = getDefaultUsablePrefix();
        }
        accumulator.mask = mask;
        accumulator.maskId = node.getAttribute("data-fa-mask-id");
        return accumulator;
      }
    };
  },
  provides: function provides5(providers2) {
    providers2.generateAbstractMask = function(_ref2) {
      var children = _ref2.children, attributes = _ref2.attributes, main = _ref2.main, mask = _ref2.mask, explicitMaskId = _ref2.maskId, transform3 = _ref2.transform;
      var mainWidth = main.width, mainPath = main.icon;
      var maskWidth = mask.width, maskPath = mask.icon;
      var trans = transformForSvg({
        transform: transform3,
        containerWidth: maskWidth,
        iconWidth: mainWidth
      });
      var maskRect = {
        tag: "rect",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          fill: "white"
        })
      };
      var maskInnerGroupChildrenMixin = mainPath.children ? {
        children: mainPath.children.map(fillBlack)
      } : {};
      var maskInnerGroup = {
        tag: "g",
        attributes: _objectSpread2$1({}, trans.inner),
        children: [fillBlack(_objectSpread2$1({
          tag: mainPath.tag,
          attributes: _objectSpread2$1(_objectSpread2$1({}, mainPath.attributes), trans.path)
        }, maskInnerGroupChildrenMixin))]
      };
      var maskOuterGroup = {
        tag: "g",
        attributes: _objectSpread2$1({}, trans.outer),
        children: [maskInnerGroup]
      };
      var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
      var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
      var maskTag = {
        tag: "mask",
        attributes: _objectSpread2$1(_objectSpread2$1({}, ALL_SPACE), {}, {
          id: maskId,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [maskRect, maskOuterGroup]
      };
      var defs = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: clipId
          },
          children: deGroup(maskPath)
        }, maskTag]
      };
      children.push(defs, {
        tag: "rect",
        attributes: _objectSpread2$1({
          fill: "currentColor",
          "clip-path": "url(#".concat(clipId, ")"),
          mask: "url(#".concat(maskId, ")")
        }, ALL_SPACE)
      });
      return {
        children,
        attributes
      };
    };
  }
};
var MissingIconIndicator = {
  provides: function provides6(providers2) {
    var reduceMotion = false;
    if (WINDOW.matchMedia) {
      reduceMotion = WINDOW.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }
    providers2.missingIconAbstract = function() {
      var gChildren = [];
      var FILL = {
        fill: "currentColor"
      };
      var ANIMATION_BASE = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var OPACITY_ANIMATE = _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
        attributeName: "opacity"
      });
      var dot = {
        tag: "circle",
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      if (!reduceMotion) {
        dot.children.push({
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, ANIMATION_BASE), {}, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: "1;0;1;1;0;1;"
          })
        });
      }
      gChildren.push(dot);
      gChildren.push({
        tag: "path",
        attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: reduceMotion ? [] : [{
          tag: "animate",
          attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      });
      if (!reduceMotion) {
        gChildren.push({
          tag: "path",
          attributes: _objectSpread2$1(_objectSpread2$1({}, FILL), {}, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: _objectSpread2$1(_objectSpread2$1({}, OPACITY_ANIMATE), {}, {
              values: "0;0;1;1;0;0;"
            })
          }]
        });
      }
      return {
        tag: "g",
        attributes: {
          "class": "missing"
        },
        children: gChildren
      };
    };
  }
};
var SvgSymbols = {
  hooks: function hooks9() {
    return {
      parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
        var symbolData = node.getAttribute("data-fa-symbol");
        var symbol = symbolData === null ? false : symbolData === "" ? true : symbolData;
        accumulator["symbol"] = symbol;
        return accumulator;
      }
    };
  }
};
var plugins = [InjectCSS, ReplaceElements, Layers, LayersCounter, LayersText, PseudoElements, MutationObserver$1, PowerTransforms, Masks, MissingIconIndicator, SvgSymbols];
registerPlugins(plugins, {
  mixoutsTo: api
});
api.noAuto;
api.config;
api.library;
api.dom;
var parse$1 = api.parse;
api.findIconDefinition;
api.toHtml;
var icon2 = api.icon;
api.layer;
api.text;
api.counter;
function ownKeys(object, enumerableOnly) {
  var keys3 = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys3.push.apply(keys3, symbols);
  }
  return keys3;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && typeof Symbol == "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor)
    n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set")
    return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function classList(props) {
  var _classes;
  var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, flash = props.flash, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, listItem = props.listItem, flip2 = props.flip, size = props.size, rotation = props.rotation, pull = props.pull;
  var classes = (_classes = {
    "fa-beat": beat,
    "fa-fade": fade,
    "fa-beat-fade": beatFade,
    "fa-bounce": bounce,
    "fa-shake": shake,
    "fa-flash": flash,
    "fa-spin": spin,
    "fa-spin-reverse": spinReverse,
    "fa-spin-pulse": spinPulse,
    "fa-pulse": pulse,
    "fa-fw": fixedWidth,
    "fa-inverse": inverse,
    "fa-border": border,
    "fa-li": listItem,
    "fa-flip-horizontal": flip2 === "horizontal" || flip2 === "both",
    "fa-flip-vertical": flip2 === "vertical" || flip2 === "both"
  }, _defineProperty(_classes, "fa-".concat(size), typeof size !== "undefined" && size !== null), _defineProperty(_classes, "fa-rotate-".concat(rotation), typeof rotation !== "undefined" && rotation !== null && rotation !== 0), _defineProperty(_classes, "fa-pull-".concat(pull), typeof pull !== "undefined" && pull !== null), _defineProperty(_classes, "fa-swap-opacity", props.swapOpacity), _classes);
  return Object.keys(classes).map(function(key) {
    return classes[key] ? key : null;
  }).filter(function(key) {
    return key;
  });
}
function _isNumerical(obj) {
  obj = obj - 0;
  return obj === obj;
}
function camelize(string2) {
  if (_isNumerical(string2)) {
    return string2;
  }
  string2 = string2.replace(/[\-_\s]+(.)?/g, function(match, chr) {
    return chr ? chr.toUpperCase() : "";
  });
  return string2.substr(0, 1).toLowerCase() + string2.substr(1);
}
var _excluded$1 = ["style"];
function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}
function styleToObject(style) {
  return style.split(";").map(function(s) {
    return s.trim();
  }).filter(function(s) {
    return s;
  }).reduce(function(acc, pair) {
    var i = pair.indexOf(":");
    var prop = camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();
    prop.startsWith("webkit") ? acc[capitalize(prop)] = value : acc[prop] = value;
    return acc;
  }, {});
}
function convert(createElement2, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof element === "string") {
    return element;
  }
  var children = (element.children || []).map(function(child) {
    return convert(createElement2, child);
  });
  var mixins = Object.keys(element.attributes || {}).reduce(function(acc, key) {
    var val = element.attributes[key];
    switch (key) {
      case "class":
        acc.attrs["className"] = val;
        delete element.attributes["class"];
        break;
      case "style":
        acc.attrs["style"] = styleToObject(val);
        break;
      default:
        if (key.indexOf("aria-") === 0 || key.indexOf("data-") === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[camelize(key)] = val;
        }
    }
    return acc;
  }, {
    attrs: {}
  });
  var _extraProps$style = extraProps.style, existingStyle = _extraProps$style === void 0 ? {} : _extraProps$style, remaining = _objectWithoutProperties(extraProps, _excluded$1);
  mixins.attrs["style"] = _objectSpread2(_objectSpread2({}, mixins.attrs["style"]), existingStyle);
  return createElement2.apply(void 0, [element.tag, _objectSpread2(_objectSpread2({}, mixins.attrs), remaining)].concat(_toConsumableArray(children)));
}
var PRODUCTION = false;
try {
  PRODUCTION = true;
} catch (e) {
}
function log() {
  if (!PRODUCTION && console && typeof console.error === "function") {
    var _console;
    (_console = console).error.apply(_console, arguments);
  }
}
function normalizeIconArgs(icon3) {
  if (icon3 && _typeof(icon3) === "object" && icon3.prefix && icon3.iconName && icon3.icon) {
    return icon3;
  }
  if (parse$1.icon) {
    return parse$1.icon(icon3);
  }
  if (icon3 === null) {
    return null;
  }
  if (icon3 && _typeof(icon3) === "object" && icon3.prefix && icon3.iconName) {
    return icon3;
  }
  if (Array.isArray(icon3) && icon3.length === 2) {
    return {
      prefix: icon3[0],
      iconName: icon3[1]
    };
  }
  if (typeof icon3 === "string") {
    return {
      prefix: "fas",
      iconName: icon3
    };
  }
}
function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? _defineProperty({}, key, value) : {};
}
var _excluded = ["forwardedRef"];
function FontAwesomeIcon(_ref2) {
  var forwardedRef = _ref2.forwardedRef, props = _objectWithoutProperties(_ref2, _excluded);
  var iconArgs = props.icon, maskArgs = props.mask, symbol = props.symbol, className = props.className, title2 = props.title, titleId = props.titleId, maskId = props.maskId;
  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey("classes", [].concat(_toConsumableArray(classList(props)), _toConsumableArray(className.split(" "))));
  var transform3 = objectWithKey("transform", typeof props.transform === "string" ? parse$1.transform(props.transform) : props.transform);
  var mask = objectWithKey("mask", normalizeIconArgs(maskArgs));
  var renderedIcon = icon2(iconLookup, _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, classes), transform3), mask), {}, {
    symbol,
    title: title2,
    titleId,
    maskId
  }));
  if (!renderedIcon) {
    log("Could not find icon", iconLookup);
    return null;
  }
  var abstract = renderedIcon.abstract;
  var extraProps = {
    ref: forwardedRef
  };
  Object.keys(props).forEach(function(key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });
  return convertCurry(abstract[0], extraProps);
}
FontAwesomeIcon.displayName = "FontAwesomeIcon";
FontAwesomeIcon.propTypes = {
  beat: PropTypes.bool,
  border: PropTypes.bool,
  bounce: PropTypes.bool,
  className: PropTypes.string,
  fade: PropTypes.bool,
  flash: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  maskId: PropTypes.string,
  fixedWidth: PropTypes.bool,
  inverse: PropTypes.bool,
  flip: PropTypes.oneOf(["horizontal", "vertical", "both"]),
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
  listItem: PropTypes.bool,
  pull: PropTypes.oneOf(["right", "left"]),
  pulse: PropTypes.bool,
  rotation: PropTypes.oneOf([0, 90, 180, 270]),
  shake: PropTypes.bool,
  size: PropTypes.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: PropTypes.bool,
  spinPulse: PropTypes.bool,
  spinReverse: PropTypes.bool,
  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  title: PropTypes.string,
  titleId: PropTypes.string,
  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  swapOpacity: PropTypes.bool
};
FontAwesomeIcon.defaultProps = {
  border: false,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  beat: false,
  fade: false,
  beatFade: false,
  bounce: false,
  shake: false,
  symbol: false,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: false
};
var convertCurry = convert.bind(null, require$$0$1.createElement);
/*!
 * Font Awesome Free 6.1.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2022 Fonticons, Inc.
 */
var faCheck = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10004, 10003], "f00c", "M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"]
};
var faExclamation = {
  prefix: "fas",
  iconName: "exclamation",
  icon: [128, 512, [10069, 10071, 61738], "21", "M64 352c17.69 0 32-14.32 32-31.1V64.01c0-17.67-14.31-32.01-32-32.01S32 46.34 32 64.01v255.1C32 337.7 46.31 352 64 352zM64 400c-22.09 0-40 17.91-40 40s17.91 39.1 40 39.1s40-17.9 40-39.1S86.09 400 64 400z"]
};
var faInfo = {
  prefix: "fas",
  iconName: "info",
  icon: [192, 512, [], "f129", "M160 448h-32V224c0-17.69-14.33-32-32-32L32 192c-17.67 0-32 14.31-32 32s14.33 31.1 32 31.1h32v192H32c-17.67 0-32 14.31-32 32s14.33 32 32 32h128c17.67 0 32-14.31 32-32S177.7 448 160 448zM96 128c26.51 0 48-21.49 48-48S122.5 32.01 96 32.01s-48 21.49-48 48S69.49 128 96 128z"]
};
var faSpinner = {
  prefix: "fas",
  iconName: "spinner",
  icon: [512, 512, [], "f110", "M304 48C304 74.51 282.5 96 256 96C229.5 96 208 74.51 208 48C208 21.49 229.5 0 256 0C282.5 0 304 21.49 304 48zM304 464C304 490.5 282.5 512 256 512C229.5 512 208 490.5 208 464C208 437.5 229.5 416 256 416C282.5 416 304 437.5 304 464zM0 256C0 229.5 21.49 208 48 208C74.51 208 96 229.5 96 256C96 282.5 74.51 304 48 304C21.49 304 0 282.5 0 256zM512 256C512 282.5 490.5 304 464 304C437.5 304 416 282.5 416 256C416 229.5 437.5 208 464 208C490.5 208 512 229.5 512 256zM74.98 437C56.23 418.3 56.23 387.9 74.98 369.1C93.73 350.4 124.1 350.4 142.9 369.1C161.6 387.9 161.6 418.3 142.9 437C124.1 455.8 93.73 455.8 74.98 437V437zM142.9 142.9C124.1 161.6 93.73 161.6 74.98 142.9C56.24 124.1 56.24 93.73 74.98 74.98C93.73 56.23 124.1 56.23 142.9 74.98C161.6 93.73 161.6 124.1 142.9 142.9zM369.1 369.1C387.9 350.4 418.3 350.4 437 369.1C455.8 387.9 455.8 418.3 437 437C418.3 455.8 387.9 455.8 369.1 437C350.4 418.3 350.4 387.9 369.1 369.1V369.1z"]
};
var faTriangleExclamation = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M506.3 417l-213.3-364c-16.33-28-57.54-28-73.98 0l-213.2 364C-10.59 444.9 9.849 480 42.74 480h426.6C502.1 480 522.6 445 506.3 417zM232 168c0-13.25 10.75-24 24-24S280 154.8 280 168v128c0 13.25-10.75 24-23.1 24S232 309.3 232 296V168zM256 416c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 401.9 273.4 416 256 416z"]
};
var faExclamationTriangle = faTriangleExclamation;
const loading$4 = "_loading_1xnqc_1";
const modalContent$1 = "_modalContent_1xnqc_11";
const titleBar$1 = "_titleBar_1xnqc_18";
const closeIcon$1 = "_closeIcon_1xnqc_25";
const title$1 = "_title_1xnqc_18";
const content$2 = "_content_1xnqc_43";
const bottomBar$1 = "_bottomBar_1xnqc_53";
var styles$g = {
  loading: loading$4,
  modalContent: modalContent$1,
  titleBar: titleBar$1,
  closeIcon: closeIcon$1,
  title: title$1,
  content: content$2,
  bottomBar: bottomBar$1
};
var CloseIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwLjI4IDJMMiAzMC4yNzQ3IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuMjYyNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yIDJMMzAuMjggMzAuMjc0NyIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjI2MjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
const VideoPlayer = ({
  visibility,
  onClose,
  videoInfo,
  showPublish,
  onPublish,
  onUnpublish,
  TciVideoPlayer
}) => {
  const [videoDisplayProps, setVideoDisplayProps] = useState();
  const [player, setPlayer] = useState();
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    if (videoInfo == null ? void 0 : videoInfo.id) {
      setIsLoading(true);
      getVideoDisplayProps(videoInfo.id).then(({
        data: {
          video
        }
      }) => {
        setVideoDisplayProps(video.display_props);
        setIsLoading(false);
      });
    }
  }, [videoInfo == null ? void 0 : videoInfo.id]);
  useCallback((videoRef) => {
    if (!videoRef || !videoInfo) {
      return;
    }
    const playerOptions = {
      sources: [{
        src: videoInfo.url
      }],
      poster: videoInfo.poster_url,
      fluid: true,
      fill: true,
      bigPlayButton: true,
      autoplay: true,
      controls: true
    };
    const tracks = [];
    if (videoInfo.caption_en_url || videoInfo.caption_es_url) {
      if (videoInfo.caption_en_url) {
        tracks.push({
          kind: "captions",
          src: videoInfo.caption_en_url,
          label: "English"
        });
      }
      if (videoInfo.caption_es_url) {
        tracks.push({
          kind: "captions",
          src: videoInfo.caption_es_url,
          label: "Espa\xF1ol"
        });
      }
    } else if (videoInfo.caption_url) {
      tracks.push({
        kind: "captions",
        src: videoInfo.caption_url,
        label: "English"
      });
    }
    playerOptions.tracks = tracks;
    setPlayer(videojs(videoRef, playerOptions));
  }, [videoInfo]);
  const handleClose = () => {
    player == null ? void 0 : player.pause();
    setVideoDisplayProps(void 0);
    onClose();
  };
  const handlePublishClick = () => {
    if (!videoInfo) {
      return;
    }
    if (videoInfo == null ? void 0 : videoInfo.published) {
      onUnpublish(videoInfo.id, videoInfo.title);
    } else {
      onPublish(videoInfo.id, videoInfo.title);
    }
  };
  const videoWithDisplayProps = {
    ...videoInfo,
    ...videoDisplayProps
  };
  return /* @__PURE__ */ jsx(ReactModal, {
    overlayClassName: "ReactModal__Overlay_Library",
    className: "ReactModal__Content_Library",
    isOpen: visibility,
    style: {
      content: {
        padding: 0
      }
    },
    shouldReturnFocusAfterClose: true,
    preventScroll: true,
    onRequestClose: handleClose,
    shouldCloseOnEsc: true,
    shouldFocusAfterRender: true,
    children: isLoading && !videoDisplayProps ? /* @__PURE__ */ jsx("div", {
      className: styles$g.loading,
      children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true
      })
    }) : /* @__PURE__ */ jsxs("div", {
      className: styles$g.modalContent,
      children: [/* @__PURE__ */ jsxs("div", {
        className: styles$g.titleBar,
        children: [/* @__PURE__ */ jsx("h1", {
          className: styles$g.title,
          children: videoInfo == null ? void 0 : videoInfo.title_en
        }), /* @__PURE__ */ jsx("div", {
          className: styles$g.closeIcon,
          style: {
            backgroundImage: `url(${CloseIcon})`
          },
          onClick: handleClose
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: styles$g.content,
        children: videoInfo && /* @__PURE__ */ jsx(TciVideoPlayer, {
          video: videoWithDisplayProps,
          width: "100%"
        })
      }), /* @__PURE__ */ jsxs("div", {
        className: styles$g.bottomBar,
        children: [/* @__PURE__ */ jsx("button", {
          className: "btn btn--link-purple btn--lg",
          onClick: handleClose,
          children: "Cancel"
        }), showPublish && /* @__PURE__ */ jsx("button", {
          className: "btn btn--outline-purple",
          onClick: handlePublishClick,
          children: (videoInfo == null ? void 0 : videoInfo.published) ? /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx(Status, {
              borderColor: Color.GREEN,
              checked: true
            }), " Published"]
          }) : /* @__PURE__ */ jsxs(Fragment, {
            children: [/* @__PURE__ */ jsx(Status, {}), " Publish"]
          })
        })]
      })]
    })
  });
};
const bar$2 = "_bar_njduj_1";
const barTitle$2 = "_barTitle_njduj_18";
const clearButton$2 = "_clearButton_njduj_24";
const categoryTitle$2 = "_categoryTitle_njduj_30";
const innerFilter$2 = "_innerFilter_njduj_37";
var styles$f = {
  bar: bar$2,
  barTitle: barTitle$2,
  clearButton: clearButton$2,
  categoryTitle: categoryTitle$2,
  innerFilter: innerFilter$2
};
const container$3 = "_container_18msi_1";
const checkbox = "_checkbox_18msi_11";
var styles$e = {
  container: container$3,
  checkbox
};
const Checkbox = ({
  label,
  extraClassName,
  indeterminate = false,
  shouldCover,
  ...otherProps
}) => {
  const checkboxRef = useRef(null);
  const TagName = shouldCover ? "label" : "div";
  const handleClick = (e) => {
    e.stopPropagation();
  };
  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);
  return /* @__PURE__ */ jsxs(TagName, {
    className: `${styles$e.container} ${extraClassName}`,
    children: [/* @__PURE__ */ jsx("input", {
      ref: checkboxRef,
      type: "checkbox",
      className: styles$e.checkbox,
      onClick: handleClick,
      ...otherProps
    }), /* @__PURE__ */ jsx("span", {
      children: label
    })]
  });
};
const collapsable = "_collapsable_1qkqf_1";
const collapsed = "_collapsed_1qkqf_8";
const collapseContainer = "_collapseContainer_1qkqf_13";
const collapseIcon = "_collapseIcon_1qkqf_19";
var styles$d = {
  collapsable,
  collapsed,
  collapseContainer,
  collapseIcon
};
var CollapseIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDExIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjM3NDggNi4xNDUxM0w1LjQ5OTggMi4yODcyOEw5LjYyNDggNi4xNDUxM0wxMC40NDk4IDUuMzczNTZMNS40OTk4IDAuNzQ0MTQxTDAuNTQ5ODA1IDUuMzczNTZMMS4zNzQ4IDYuMTQ1MTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
var ExpandIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDExIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05LjYyNTIgMC4xODM5NzJMNS41MDAyIDQuMDQxODJMMS4zNzUyIDAuMTgzOTcyTDAuNTUwMTk2IDAuOTU1NTQyTDUuNTAwMiA1LjU4NDk2TDEwLjQ1MDIgMC45NTU1NDJMOS42MjUyIDAuMTgzOTcyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==";
const Collapse = ({
  triggerElement,
  children,
  shouldCollapse
}) => {
  const [expanded, setExpanded] = useState(!shouldCollapse);
  useEffect(() => {
    setExpanded(!shouldCollapse);
  }, [shouldCollapse]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("div", {
      role: "button",
      tabIndex: 0,
      className: styles$d.collapseContainer,
      onClick: () => setExpanded(!expanded),
      onKeyDown: (e) => {
        if (e.key === "Enter")
          setExpanded(!expanded);
      },
      children: [triggerElement, /* @__PURE__ */ jsx("div", {
        className: styles$d.collapseIcon,
        children: /* @__PURE__ */ jsx("img", {
          src: expanded ? CollapseIcon : ExpandIcon,
          alt: ""
        })
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: `${styles$d.collapsable} ${expanded ? "" : styles$d.collapsed}`,
      children
    })]
  });
};
const filter = "_filter_ehq3g_1";
const divider = "_divider_ehq3g_5";
var styles$c = {
  filter,
  divider
};
const Divider = () => {
  return /* @__PURE__ */ jsx("div", {
    className: styles$c.divider
  });
};
const Filter = ({
  label,
  value,
  checked,
  className,
  onChange: onChange2
}) => {
  const handleChange = () => {
    onChange2(value, !checked);
  };
  return /* @__PURE__ */ jsx("div", {
    className: className ? `${styles$c.filter} ${className}` : styles$c.filter,
    children: /* @__PURE__ */ jsx(Checkbox, {
      label,
      checked,
      onChange: handleChange,
      shouldCover: true
    })
  });
};
const FilterBar$2 = ({
  filters,
  onFilterChange
}) => {
  var _a, _b;
  const isStudent = !userInfo.staffer;
  const handleLessonChange = (value, checked) => {
    var _a2, _b2;
    const newFilters = {
      ...filters
    };
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      const lesson = unitFilter.lessons.find((lesson2) => lesson2.value === value);
      if (lesson) {
        lesson.checked = checked;
      }
    });
    (_b2 = newFilters.lesson) == null ? void 0 : _b2.forEach((lessonFilter) => {
      if (lessonFilter.value === value) {
        lessonFilter.checked = checked;
      }
    });
    newFilters.page = 1;
    onFilterChange(newFilters);
  };
  const handleUnitChange = (oldUnit, checked) => {
    var _a2;
    const newFilters = {
      ...filters
    };
    const newLessons = oldUnit.lessons.map((lesson) => ({
      ...lesson,
      checked
    }));
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      if (unitFilter.label === oldUnit.label) {
        unitFilter.lessons = newLessons;
      }
    });
    newFilters.page = 1;
    onFilterChange(newFilters);
  };
  const handleIncludedChange = (value, checked) => {
    const newFilters = {
      ...filters
    };
    const newIncluded = newFilters.included_in.find((includedFilter) => includedFilter.value === value);
    if (newIncluded) {
      newIncluded.checked = checked;
    }
    newFilters.page = 1;
    onFilterChange(newFilters);
  };
  const handleCategoryChange = (value, checked) => {
    const newFilters = {
      ...filters
    };
    const newCategory = newFilters.category.find((categoryFilter) => categoryFilter.value === value);
    if (newCategory) {
      newCategory.checked = checked;
    }
    newFilters.page = 1;
    onFilterChange(newFilters);
  };
  const handleStatusChange = (value, checked) => {
    const newFilters = {
      ...filters
    };
    const newStatus = newFilters.status.find((statusFilter) => statusFilter.value === value);
    if (newStatus) {
      newStatus.checked = checked;
    }
    newFilters.page = 1;
    onFilterChange(newFilters);
  };
  const handleFilterClear = () => {
    var _a2, _b2;
    const newFilters = {
      ...filters
    };
    const setUnchecked = (filter2) => {
      filter2.checked = false;
    };
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      unitFilter.lessons.forEach(setUnchecked);
    });
    (_b2 = newFilters.lesson) == null ? void 0 : _b2.forEach(setUnchecked);
    newFilters.category.forEach(setUnchecked);
    newFilters.included_in.forEach(setUnchecked);
    newFilters.status.forEach(setUnchecked);
    newFilters.keyword = "";
    newFilters.page = 1;
    onFilterChange(newFilters);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `${styles$f.bar} card`,
    children: [/* @__PURE__ */ jsx("div", {
      className: styles$f.barTitle,
      children: "Filters"
    }), /* @__PURE__ */ jsx("button", {
      className: `btn btn--link-purple ${styles$f.clearButton}`,
      onClick: handleFilterClear,
      children: "Clear"
    }), /* @__PURE__ */ jsx(Divider, {}), !!((_a = filters.unit) == null ? void 0 : _a.length) && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$f.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$f.categoryTitle,
            children: "Unit"
          }),
          children: filters.unit.map((unitFilter) => /* @__PURE__ */ jsx("div", {
            children: /* @__PURE__ */ jsx(Collapse, {
              triggerElement: /* @__PURE__ */ jsx(Checkbox, {
                extraClassName: "mb10",
                label: unitFilter.label,
                checked: unitFilter.lessons.every((lesson) => lesson.checked),
                onChange: (event) => {
                  handleUnitChange(unitFilter, event.target.checked);
                }
              }),
              shouldCollapse: true,
              children: unitFilter.lessons.map((lesson) => {
                var _a2;
                return /* @__PURE__ */ jsx(Filter, {
                  className: styles$f.innerFilter,
                  label: lesson.label,
                  value: lesson.value,
                  checked: (_a2 = lesson.checked) != null ? _a2 : false,
                  onChange: handleLessonChange
                }, lesson.value);
              })
            })
          }, unitFilter.label))
        })
      })
    }), !!((_b = filters.lesson) == null ? void 0 : _b.length) && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$f.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$f.categoryTitle,
            children: "Lesson"
          }),
          children: filters.lesson.map((lessonFilter) => {
            var _a2;
            return /* @__PURE__ */ jsx(Filter, {
              label: lessonFilter.label,
              value: lessonFilter.value,
              checked: (_a2 = lessonFilter.checked) != null ? _a2 : false,
              onChange: handleLessonChange
            }, lessonFilter.value);
          })
        })
      })
    }), !isStudent && filters.included_in && /* @__PURE__ */ jsx("div", {
      className: styles$f.category,
      children: /* @__PURE__ */ jsx(Collapse, {
        triggerElement: /* @__PURE__ */ jsx("div", {
          className: styles$f.categoryTitle,
          children: "Included In"
        }),
        shouldCollapse: true,
        children: filters.included_in.map((includedFilter) => {
          var _a2;
          return /* @__PURE__ */ jsx(Filter, {
            label: includedFilter.label,
            value: includedFilter.value,
            checked: (_a2 = includedFilter.checked) != null ? _a2 : false,
            onChange: handleIncludedChange
          }, includedFilter.value);
        })
      })
    }), !!filters.category.length && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$f.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$f.categoryTitle,
            children: "Category"
          }),
          shouldCollapse: true,
          children: filters.category.map((categoryFilter) => {
            var _a2;
            return /* @__PURE__ */ jsx(Filter, {
              label: categoryFilter.label,
              value: categoryFilter.value,
              checked: (_a2 = categoryFilter.checked) != null ? _a2 : false,
              onChange: handleCategoryChange
            }, categoryFilter.value);
          })
        })
      })
    }), !isStudent && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$f.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$f.categoryTitle,
            children: "Status"
          }),
          shouldCollapse: true,
          children: filters.status.map((statusFilter) => {
            var _a2;
            return /* @__PURE__ */ jsx(Filter, {
              label: statusFilter.label,
              value: statusFilter.value,
              checked: (_a2 = statusFilter.checked) != null ? _a2 : false,
              onChange: handleStatusChange
            }, statusFilter.value);
          })
        })
      })
    })]
  });
};
const toastBody = "_toastBody_sp3hp_27";
const iconBox = "_iconBox_sp3hp_31";
const success = "_success_sp3hp_42";
const info = "_info_sp3hp_46";
const warning = "_warning_sp3hp_50";
const error = "_error_sp3hp_54";
const toastTitle = "_toastTitle_sp3hp_58";
const closeButton = "_closeButton_sp3hp_73";
var styles$b = {
  "toast-container-main": "_toast-container-main_sp3hp_1",
  "slide-in": "_slide-in_sp3hp_1",
  toastBody,
  iconBox,
  success,
  info,
  warning,
  error,
  toastTitle,
  closeButton
};
const Toast = ({
  destroy: destroy2,
  content: content2,
  title: title2,
  duration: duration5 = 0,
  type: type2,
  showIcon
}) => {
  const toastIcon = useMemo(() => {
    let icon3 = faCheck;
    switch (type2) {
      case ToastTypes.Informative: {
        icon3 = faInfo;
        break;
      }
      case ToastTypes.WARNING: {
        icon3 = faExclamationTriangle;
        break;
      }
      case ToastTypes.ERROR: {
        icon3 = faExclamation;
        break;
      }
    }
    return /* @__PURE__ */ jsx(FontAwesomeIcon, {
      fontWeight: 900,
      icon: icon3
    });
  }, [type2]);
  useEffect(() => {
    if (!duration5)
      return;
    const timer = setTimeout(() => {
      destroy2();
    }, duration5);
    return () => clearTimeout(timer);
  }, [destroy2, duration5]);
  return /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsx("div", {
      className: `${styles$b[type2]} ${styles$b.iconBox}`,
      children: showIcon && toastIcon
    }), /* @__PURE__ */ jsx("button", {
      className: styles$b.closeButton,
      onClick: destroy2,
      children: "X"
    }), /* @__PURE__ */ jsxs("div", {
      className: styles$b.toastBody,
      children: [/* @__PURE__ */ jsx("div", {
        className: styles$b.toastTitle,
        children: title2
      }), /* @__PURE__ */ jsx("div", {
        className: styles$b.toastContent,
        children: content2
      })]
    })]
  });
};
const shouldRerender = (prevProps, nextProps) => {
  return prevProps.id === nextProps.id;
};
var Toast$1 = require$$0$1.memo(Toast, shouldRerender);
var ToastTypes = /* @__PURE__ */ ((ToastTypes2) => {
  ToastTypes2["SUCCESS"] = "success";
  ToastTypes2["Informative"] = "info";
  ToastTypes2["WARNING"] = "warning";
  ToastTypes2["ERROR"] = "error";
  return ToastTypes2;
})(ToastTypes || {});
class ToastManager {
  constructor() {
    __publicField(this, "containerRef");
    __publicField(this, "toasts", []);
    const body = document.getElementsByTagName("body")[0];
    const toastContainer = document.createElement("div");
    toastContainer.id = styles$b["toast-container-main"];
    body.insertAdjacentElement("beforeend", toastContainer);
    this.containerRef = toastContainer;
  }
  show(options) {
    const toastId = Math.random().toString(36).substring(2, 9);
    const toast2 = {
      id: toastId,
      type: "success",
      ...options,
      destroy: () => {
        var _a;
        return this.destroy((_a = options.id) != null ? _a : toastId);
      }
    };
    this.toasts = [toast2, ...this.toasts];
    this.render();
  }
  destroy(id2) {
    this.toasts = this.toasts.filter((toast2) => toast2.id !== id2);
    this.render();
  }
  render() {
    const toastsList = this.toasts.map((toastProps) => /* @__PURE__ */ jsx(Toast$1, {
      ...toastProps
    }, toastProps.id));
    ReactDOM.render(toastsList, this.containerRef);
  }
}
const toast = new ToastManager();
var _application = /* @__PURE__ */ (() => '@charset "UTF-8";.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-modal-dialog,.vjs-button>.vjs-icon-placeholder:before,.vjs-modal-dialog .vjs-modal-dialog-content{position:absolute;top:0;left:0;width:100%;height:100%}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.vjs-button>.vjs-icon-placeholder:before{text-align:center}@font-face{font-family:VideoJS;src:url(data:application/font-woff;charset=utf-8;base64,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) format("woff");font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder,.vjs-icon-play{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder:before,.vjs-icon-play:before{content:"\\f101"}.vjs-icon-play-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-play-circle:before{content:"\\f102"}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder,.vjs-icon-pause{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before,.vjs-icon-pause:before{content:"\\f103"}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder,.vjs-icon-volume-mute{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before,.vjs-icon-volume-mute:before{content:"\\f104"}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder,.vjs-icon-volume-low{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before,.vjs-icon-volume-low:before{content:"\\f105"}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder,.vjs-icon-volume-mid{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before,.vjs-icon-volume-mid:before{content:"\\f106"}.video-js .vjs-mute-control .vjs-icon-placeholder,.vjs-icon-volume-high{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control .vjs-icon-placeholder:before,.vjs-icon-volume-high:before{content:"\\f107"}.video-js .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-enter{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-enter:before{content:"\\f108"}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-exit{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-exit:before{content:"\\f109"}.vjs-icon-square{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-square:before{content:"\\f10a"}.vjs-icon-spinner{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-spinner:before{content:"\\f10b"}.video-js .vjs-subs-caps-button .vjs-icon-placeholder,.video-js .vjs-subtitles-button .vjs-icon-placeholder,.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder,.vjs-icon-subtitles{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js .vjs-subtitles-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before,.vjs-icon-subtitles:before{content:"\\f10c"}.video-js .vjs-captions-button .vjs-icon-placeholder,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder,.vjs-icon-captions{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-captions-button .vjs-icon-placeholder:before,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before,.vjs-icon-captions:before{content:"\\f10d"}.video-js .vjs-chapters-button .vjs-icon-placeholder,.vjs-icon-chapters{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-chapters-button .vjs-icon-placeholder:before,.vjs-icon-chapters:before{content:"\\f10e"}.vjs-icon-share{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-share:before{content:"\\f10f"}.vjs-icon-cog{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-cog:before{content:"\\f110"}.video-js .vjs-play-progress,.video-js .vjs-volume-level,.vjs-icon-circle,.vjs-seek-to-live-control .vjs-icon-placeholder{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-progress:before,.video-js .vjs-volume-level:before,.vjs-icon-circle:before,.vjs-seek-to-live-control .vjs-icon-placeholder:before{content:"\\f111"}.vjs-icon-circle-outline{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-outline:before{content:"\\f112"}.vjs-icon-circle-inner-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-inner-circle:before{content:"\\f113"}.vjs-icon-hd{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-hd:before{content:"\\f114"}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder,.vjs-icon-cancel{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before,.vjs-icon-cancel:before{content:"\\f115"}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder,.vjs-icon-replay{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before,.vjs-icon-replay:before{content:"\\f116"}.vjs-icon-facebook{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-facebook:before{content:"\\f117"}.vjs-icon-gplus{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-gplus:before{content:"\\f118"}.vjs-icon-linkedin{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-linkedin:before{content:"\\f119"}.vjs-icon-twitter{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-twitter:before{content:"\\f11a"}.vjs-icon-tumblr{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-tumblr:before{content:"\\f11b"}.vjs-icon-pinterest{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-pinterest:before{content:"\\f11c"}.video-js .vjs-descriptions-button .vjs-icon-placeholder,.vjs-icon-audio-description{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-descriptions-button .vjs-icon-placeholder:before,.vjs-icon-audio-description:before{content:"\\f11d"}.video-js .vjs-audio-button .vjs-icon-placeholder,.vjs-icon-audio{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-audio-button .vjs-icon-placeholder:before,.vjs-icon-audio:before{content:"\\f11e"}.vjs-icon-next-item{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-next-item:before{content:"\\f11f"}.vjs-icon-previous-item{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-previous-item:before{content:"\\f120"}.video-js .vjs-picture-in-picture-control .vjs-icon-placeholder,.vjs-icon-picture-in-picture-enter{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before,.vjs-icon-picture-in-picture-enter:before{content:"\\f121"}.video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder,.vjs-icon-picture-in-picture-exit{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder:before,.vjs-icon-picture-in-picture-exit:before{content:"\\f122"}.video-js{display:block;vertical-align:top;box-sizing:border-box;color:#fff;background-color:#000;position:relative;padding:0;font-size:10px;line-height:1;font-weight:400;font-style:normal;font-family:Arial,Helvetica,sans-serif;word-break:initial}.video-js:-moz-full-screen{position:absolute}.video-js:-webkit-full-screen{width:100%!important;height:100%!important}.video-js[tabindex="-1"]{outline:0}.video-js *,.video-js :after,.video-js :before{box-sizing:inherit}.video-js ul{font-family:inherit;font-size:inherit;line-height:inherit;list-style-position:outside;margin:0}.video-js.vjs-1-1,.video-js.vjs-16-9,.video-js.vjs-4-3,.video-js.vjs-9-16,.video-js.vjs-fluid{width:100%;max-width:100%}.video-js.vjs-1-1:not(.vjs-audio-only-mode),.video-js.vjs-16-9:not(.vjs-audio-only-mode),.video-js.vjs-4-3:not(.vjs-audio-only-mode),.video-js.vjs-9-16:not(.vjs-audio-only-mode),.video-js.vjs-fluid:not(.vjs-audio-only-mode){height:0}.video-js.vjs-16-9:not(.vjs-audio-only-mode){padding-top:56.25%}.video-js.vjs-4-3:not(.vjs-audio-only-mode){padding-top:75%}.video-js.vjs-9-16:not(.vjs-audio-only-mode){padding-top:177.7777777778%}.video-js.vjs-1-1:not(.vjs-audio-only-mode){padding-top:100%}.video-js.vjs-fill:not(.vjs-audio-only-mode){width:100%;height:100%}.video-js .vjs-tech{position:absolute;top:0;left:0;width:100%;height:100%}.video-js.vjs-audio-only-mode .vjs-tech{display:none}body.vjs-full-window{padding:0;margin:0;height:100%}.vjs-full-window .video-js.vjs-fullscreen{position:fixed;overflow:hidden;z-index:1000;left:0;top:0;bottom:0;right:0}.video-js.vjs-fullscreen:not(.vjs-ios-native-fs){width:100%!important;height:100%!important;padding-top:0!important}.video-js.vjs-fullscreen.vjs-user-inactive{cursor:none}.vjs-hidden{display:none!important}.vjs-disabled{opacity:.5;cursor:default}.video-js .vjs-offscreen{height:1px;left:-9999px;position:absolute;top:0;width:1px}.vjs-lock-showing{display:block!important;opacity:1!important;visibility:visible!important}.vjs-no-js{padding:20px;color:#fff;background-color:#000;font-size:18px;font-family:Arial,Helvetica,sans-serif;text-align:center;width:300px;height:150px;margin:0 auto}.vjs-no-js a,.vjs-no-js a:visited{color:#66a8cc}.video-js .vjs-big-play-button{font-size:3em;line-height:1.5em;height:1.63332em;width:3em;display:block;position:absolute;top:10px;left:10px;padding:0;cursor:pointer;opacity:1;border:.06666em solid #fff;background-color:#2b333f;background-color:#2b333fb3;border-radius:.3em;transition:all .4s}.vjs-big-play-centered .vjs-big-play-button{top:50%;left:50%;margin-top:-.81666em;margin-left:-1.5em}.video-js .vjs-big-play-button:focus,.video-js:hover .vjs-big-play-button{border-color:#fff;background-color:#73859f;background-color:#73859f80;transition:all 0s}.vjs-controls-disabled .vjs-big-play-button,.vjs-error .vjs-big-play-button,.vjs-has-started .vjs-big-play-button,.vjs-using-native-controls .vjs-big-play-button{display:none}.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause .vjs-big-play-button{display:block}.video-js button{background:0 0;border:none;color:inherit;display:inline-block;font-size:inherit;line-height:inherit;text-transform:none;text-decoration:none;transition:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.vjs-control .vjs-button{width:100%;height:100%}.video-js .vjs-control.vjs-close-button{cursor:pointer;height:3em;position:absolute;right:0;top:.5em;z-index:2}.video-js .vjs-modal-dialog{background:rgba(0,0,0,.8);background:linear-gradient(180deg,rgba(0,0,0,.8),rgba(255,255,255,0));overflow:auto}.video-js .vjs-modal-dialog>*{box-sizing:border-box}.vjs-modal-dialog .vjs-modal-dialog-content{font-size:1.2em;line-height:1.5;padding:20px 24px;z-index:1}.vjs-menu-button{cursor:pointer}.vjs-menu-button.vjs-disabled{cursor:default}.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu{display:none}.vjs-menu .vjs-menu-content{display:block;padding:0;margin:0;font-family:Arial,Helvetica,sans-serif;overflow:auto}.vjs-menu .vjs-menu-content>*{box-sizing:border-box}.vjs-scrubbing .vjs-control.vjs-menu-button:hover .vjs-menu{display:none}.vjs-menu li{list-style:none;margin:0;padding:.2em 0;line-height:1.4em;font-size:1.2em;text-align:center;text-transform:lowercase}.js-focus-visible .vjs-menu li.vjs-menu-item:hover,.vjs-menu li.vjs-menu-item:focus,.vjs-menu li.vjs-menu-item:hover{background-color:#73859f;background-color:#73859f80}.js-focus-visible .vjs-menu li.vjs-selected:hover,.vjs-menu li.vjs-selected,.vjs-menu li.vjs-selected:focus,.vjs-menu li.vjs-selected:hover{background-color:#fff;color:#2b333f}.js-focus-visible .vjs-menu :not(.vjs-selected):focus:not(.focus-visible),.video-js .vjs-menu :not(.vjs-selected):focus:not(:focus-visible){background:0 0}.vjs-menu li.vjs-menu-title{text-align:center;text-transform:uppercase;font-size:1em;line-height:2em;padding:0;margin:0 0 .3em;font-weight:700;cursor:default}.vjs-menu-button-popup .vjs-menu{display:none;position:absolute;bottom:0;width:10em;left:-3em;height:0;margin-bottom:1.5em;border-top-color:#2b333fb3}.vjs-menu-button-popup .vjs-menu .vjs-menu-content{background-color:#2b333f;background-color:#2b333fb3;position:absolute;width:100%;bottom:1.5em;max-height:15em}.vjs-layout-tiny .vjs-menu-button-popup .vjs-menu .vjs-menu-content,.vjs-layout-x-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:5em}.vjs-layout-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:10em}.vjs-layout-medium .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:14em}.vjs-layout-huge .vjs-menu-button-popup .vjs-menu .vjs-menu-content,.vjs-layout-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content,.vjs-layout-x-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:25em}.vjs-menu-button-popup .vjs-menu.vjs-lock-showing,.vjs-workinghover .vjs-menu-button-popup.vjs-hover .vjs-menu{display:block}.video-js .vjs-menu-button-inline{transition:all .4s;overflow:hidden}.video-js .vjs-menu-button-inline:before{width:2.222222222em}.video-js .vjs-menu-button-inline.vjs-slider-active,.video-js .vjs-menu-button-inline:focus,.video-js .vjs-menu-button-inline:hover,.video-js.vjs-no-flex .vjs-menu-button-inline{width:12em}.vjs-menu-button-inline .vjs-menu{opacity:0;height:100%;width:auto;position:absolute;left:4em;top:0;padding:0;margin:0;transition:all .4s}.vjs-menu-button-inline.vjs-slider-active .vjs-menu,.vjs-menu-button-inline:focus .vjs-menu,.vjs-menu-button-inline:hover .vjs-menu{display:block;opacity:1}.vjs-no-flex .vjs-menu-button-inline .vjs-menu{display:block;opacity:1;position:relative;width:auto}.vjs-no-flex .vjs-menu-button-inline.vjs-slider-active .vjs-menu,.vjs-no-flex .vjs-menu-button-inline:focus .vjs-menu,.vjs-no-flex .vjs-menu-button-inline:hover .vjs-menu{width:auto}.vjs-menu-button-inline .vjs-menu-content{width:auto;height:100%;margin:0;overflow:hidden}.video-js .vjs-control-bar{display:none;width:100%;position:absolute;bottom:0;left:0;right:0;height:3em;background-color:#2b333f;background-color:#2b333fb3}.vjs-audio-only-mode .vjs-control-bar,.vjs-has-started .vjs-control-bar{display:flex;visibility:visible;opacity:1;transition:visibility .1s,opacity .1s}.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{visibility:visible;opacity:0;pointer-events:none;transition:visibility 1s,opacity 1s}.vjs-controls-disabled .vjs-control-bar,.vjs-error .vjs-control-bar,.vjs-using-native-controls .vjs-control-bar{display:none!important}.vjs-audio-only-mode.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar,.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{opacity:1;visibility:visible;pointer-events:auto}.vjs-has-started.vjs-no-flex .vjs-control-bar{display:table}.video-js .vjs-control{position:relative;text-align:center;margin:0;padding:0;height:100%;width:4em;flex:none}.video-js .vjs-control.vjs-visible-text{width:auto;padding-left:1em;padding-right:1em}.vjs-button>.vjs-icon-placeholder:before{font-size:1.8em;line-height:1.67}.vjs-button>.vjs-icon-placeholder{display:block}.video-js .vjs-control:focus,.video-js .vjs-control:focus:before,.video-js .vjs-control:hover:before{text-shadow:0 0 1em #fff}.video-js :not(.vjs-visible-text)>.vjs-control-text{border:0;clip:rect(0 0 0 0);height:1px;overflow:hidden;padding:0;position:absolute;width:1px}.vjs-no-flex .vjs-control{display:table-cell;vertical-align:middle}.video-js .vjs-custom-control-spacer{display:none}.video-js .vjs-progress-control{cursor:pointer;flex:auto;display:flex;align-items:center;min-width:4em;touch-action:none}.video-js .vjs-progress-control.disabled{cursor:default}.vjs-live .vjs-progress-control{display:none}.vjs-liveui .vjs-progress-control{display:flex;align-items:center}.vjs-no-flex .vjs-progress-control{width:auto}.video-js .vjs-progress-holder{flex:auto;transition:all .2s;height:.3em}.video-js .vjs-progress-control .vjs-progress-holder{margin:0 10px}.video-js .vjs-progress-control:hover .vjs-progress-holder{font-size:1.6666666667em}.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled{font-size:1em}.video-js .vjs-progress-holder .vjs-load-progress,.video-js .vjs-progress-holder .vjs-load-progress div,.video-js .vjs-progress-holder .vjs-play-progress{position:absolute;display:block;height:100%;margin:0;padding:0;width:0}.video-js .vjs-play-progress{background-color:#fff}.video-js .vjs-play-progress:before{font-size:.9em;position:absolute;right:-.5em;top:-.3333333333em;z-index:1}.video-js .vjs-load-progress{background:rgba(115,133,159,.5)}.video-js .vjs-load-progress div{background:rgba(115,133,159,.75)}.video-js .vjs-time-tooltip{background-color:#fff;background-color:#fffc;border-radius:.3em;color:#000;float:right;font-family:Arial,Helvetica,sans-serif;font-size:1em;padding:6px 8px 8px;pointer-events:none;position:absolute;top:-3.4em;visibility:hidden;z-index:1}.video-js .vjs-progress-holder:focus .vjs-time-tooltip{display:none}.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip,.video-js .vjs-progress-control:hover .vjs-time-tooltip{display:block;font-size:.6em;visibility:visible}.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip{font-size:1em}.video-js .vjs-progress-control .vjs-mouse-display{display:none;position:absolute;width:1px;height:100%;background-color:#000;z-index:1}.vjs-no-flex .vjs-progress-control .vjs-mouse-display{z-index:0}.video-js .vjs-progress-control:hover .vjs-mouse-display{display:block}.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display{visibility:hidden;opacity:0;transition:visibility 1s,opacity 1s}.video-js.vjs-user-inactive.vjs-no-flex .vjs-progress-control .vjs-mouse-display{display:none}.vjs-mouse-display .vjs-time-tooltip{color:#fff;background-color:#000;background-color:#000c}.video-js .vjs-slider{position:relative;cursor:pointer;padding:0;margin:0 .45em;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;background-color:#73859f;background-color:#73859f80}.video-js .vjs-slider.disabled{cursor:default}.video-js .vjs-slider:focus{text-shadow:0 0 1em #fff;box-shadow:0 0 1em #fff}.video-js .vjs-mute-control{cursor:pointer;flex:none}.video-js .vjs-volume-control{cursor:pointer;margin-right:1em;display:flex}.video-js .vjs-volume-control.vjs-volume-horizontal{width:5em}.video-js .vjs-volume-panel .vjs-volume-control{visibility:visible;opacity:0;width:1px;height:1px;margin-left:-1px}.video-js .vjs-volume-panel{transition:width 1s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active,.video-js .vjs-volume-panel .vjs-volume-control:active,.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control,.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control,.video-js .vjs-volume-panel:active .vjs-volume-control,.video-js .vjs-volume-panel:focus .vjs-volume-control{visibility:visible;opacity:1;position:relative;transition:visibility .1s,opacity .1s,height .1s,width .1s,left 0s,top 0s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal{width:5em;height:3em;margin-right:0}.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical,.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical{left:-3.5em;transition:left 0s}.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active{width:10em;transition:width .1s}.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-mute-toggle-only{width:4em}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical{height:8em;width:3em;left:-3000em;transition:visibility 1s,opacity 1s,height 1s 1s,width 1s 1s,left 1s 1s,top 1s 1s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal{transition:visibility 1s,opacity 1s,height 1s 1s,width 1s,left 1s 1s,top 1s 1s}.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal{width:5em;height:3em;visibility:visible;opacity:1;position:relative;transition:none}.video-js.vjs-no-flex .vjs-volume-control.vjs-volume-vertical,.video-js.vjs-no-flex .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical{position:absolute;bottom:3em;left:.5em}.video-js .vjs-volume-panel{display:flex}.video-js .vjs-volume-bar{margin:1.35em .45em}.vjs-volume-bar.vjs-slider-horizontal{width:5em;height:.3em}.vjs-volume-bar.vjs-slider-vertical{width:.3em;height:5em;margin:1.35em auto}.video-js .vjs-volume-level{position:absolute;bottom:0;left:0;background-color:#fff}.video-js .vjs-volume-level:before{position:absolute;font-size:.9em;z-index:1}.vjs-slider-vertical .vjs-volume-level{width:.3em}.vjs-slider-vertical .vjs-volume-level:before{top:-.5em;left:-.3em;z-index:1}.vjs-slider-horizontal .vjs-volume-level{height:.3em}.vjs-slider-horizontal .vjs-volume-level:before{top:-.3em;right:-.5em}.video-js .vjs-volume-panel.vjs-volume-panel-vertical{width:4em}.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level{height:100%}.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level{width:100%}.video-js .vjs-volume-vertical{width:3em;height:8em;bottom:8em;background-color:#2b333f;background-color:#2b333fb3}.video-js .vjs-volume-horizontal .vjs-menu{left:-2em}.video-js .vjs-volume-tooltip{background-color:#fff;background-color:#fffc;border-radius:.3em;color:#000;float:right;font-family:Arial,Helvetica,sans-serif;font-size:1em;padding:6px 8px 8px;pointer-events:none;position:absolute;top:-3.4em;visibility:hidden;z-index:1}.video-js .vjs-volume-control:hover .vjs-progress-holder:focus .vjs-volume-tooltip,.video-js .vjs-volume-control:hover .vjs-volume-tooltip{display:block;font-size:1em;visibility:visible}.video-js .vjs-volume-vertical:hover .vjs-progress-holder:focus .vjs-volume-tooltip,.video-js .vjs-volume-vertical:hover .vjs-volume-tooltip{left:1em;top:-12px}.video-js .vjs-volume-control.disabled:hover .vjs-volume-tooltip{font-size:1em}.video-js .vjs-volume-control .vjs-mouse-display{display:none;position:absolute;width:100%;height:1px;background-color:#000;z-index:1}.video-js .vjs-volume-horizontal .vjs-mouse-display{width:1px;height:100%}.vjs-no-flex .vjs-volume-control .vjs-mouse-display{z-index:0}.video-js .vjs-volume-control:hover .vjs-mouse-display{display:block}.video-js.vjs-user-inactive .vjs-volume-control .vjs-mouse-display{visibility:hidden;opacity:0;transition:visibility 1s,opacity 1s}.video-js.vjs-user-inactive.vjs-no-flex .vjs-volume-control .vjs-mouse-display{display:none}.vjs-mouse-display .vjs-volume-tooltip{color:#fff;background-color:#000;background-color:#000c}.vjs-poster{display:inline-block;vertical-align:middle;background-repeat:no-repeat;background-position:50% 50%;background-size:contain;background-color:#000;cursor:pointer;margin:0;padding:0;position:absolute;top:0;right:0;bottom:0;left:0;height:100%}.vjs-has-started .vjs-poster,.vjs-using-native-controls .vjs-poster{display:none}.vjs-audio.vjs-has-started .vjs-poster,.vjs-has-started.vjs-audio-poster-mode .vjs-poster{display:block}.video-js .vjs-live-control{display:flex;align-items:flex-start;flex:auto;font-size:1em;line-height:3em}.vjs-no-flex .vjs-live-control{display:table-cell;width:auto;text-align:left}.video-js.vjs-liveui .vjs-live-control,.video-js:not(.vjs-live) .vjs-live-control{display:none}.video-js .vjs-seek-to-live-control{align-items:center;cursor:pointer;flex:none;display:inline-flex;height:100%;padding-left:.5em;padding-right:.5em;font-size:1em;line-height:3em;width:auto;min-width:4em}.vjs-no-flex .vjs-seek-to-live-control{display:table-cell;width:auto;text-align:left}.video-js.vjs-live:not(.vjs-liveui) .vjs-seek-to-live-control,.video-js:not(.vjs-live) .vjs-seek-to-live-control{display:none}.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge{cursor:auto}.vjs-seek-to-live-control .vjs-icon-placeholder{margin-right:.5em;color:#888}.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-icon-placeholder{color:red}.video-js .vjs-time-control{flex:none;font-size:1em;line-height:3em;min-width:2em;width:auto;padding-left:1em;padding-right:1em}.vjs-live .vjs-time-control,.video-js .vjs-current-time,.vjs-no-flex .vjs-current-time,.video-js .vjs-duration,.vjs-no-flex .vjs-duration{display:none}.vjs-time-divider{display:none;line-height:3em}.vjs-live .vjs-time-divider{display:none}.video-js .vjs-play-control{cursor:pointer}.video-js .vjs-play-control .vjs-icon-placeholder{flex:none}.vjs-text-track-display{position:absolute;bottom:3em;left:0;right:0;top:0;pointer-events:none}.video-js.vjs-controls-disabled .vjs-text-track-display,.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display{bottom:1em}.video-js .vjs-text-track{font-size:1.4em;text-align:center;margin-bottom:.1em}.vjs-subtitles{color:#fff}.vjs-captions{color:#fc6}.vjs-tt-cue{display:block}video::-webkit-media-text-track-display{transform:translateY(-3em)}.video-js.vjs-controls-disabled video::-webkit-media-text-track-display,.video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display{transform:translateY(-1.5em)}.video-js .vjs-picture-in-picture-control{cursor:pointer;flex:none}.video-js.vjs-audio-only-mode .vjs-picture-in-picture-control{display:none}.video-js .vjs-fullscreen-control{cursor:pointer;flex:none}.video-js.vjs-audio-only-mode .vjs-fullscreen-control{display:none}.vjs-playback-rate .vjs-playback-rate-value,.vjs-playback-rate>.vjs-menu-button{position:absolute;top:0;left:0;width:100%;height:100%}.vjs-playback-rate .vjs-playback-rate-value{pointer-events:none;font-size:1.5em;line-height:2;text-align:center}.vjs-playback-rate .vjs-menu{width:4em;left:0}.vjs-error .vjs-error-display .vjs-modal-dialog-content{font-size:1.4em;text-align:center}.vjs-error .vjs-error-display:before{color:#fff;content:"X";font-family:Arial,Helvetica,sans-serif;font-size:4em;left:0;line-height:1;margin-top:-.5em;position:absolute;text-shadow:.05em .05em .1em #000;text-align:center;top:50%;vertical-align:middle;width:100%}.vjs-loading-spinner{display:none;position:absolute;top:50%;left:50%;margin:-25px 0 0 -25px;opacity:.85;text-align:left;border:6px solid rgba(43,51,63,.7);box-sizing:border-box;background-clip:padding-box;width:50px;height:50px;border-radius:25px;visibility:hidden}.vjs-seeking .vjs-loading-spinner,.vjs-waiting .vjs-loading-spinner{display:block;-webkit-animation:vjs-spinner-show 0s linear .3s forwards;animation:vjs-spinner-show 0s linear .3s forwards}.vjs-loading-spinner:after,.vjs-loading-spinner:before{content:"";position:absolute;margin:-6px;box-sizing:inherit;width:inherit;height:inherit;border-radius:inherit;opacity:1;border:inherit;border-color:transparent;border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:before{-webkit-animation:vjs-spinner-spin 1.1s cubic-bezier(.6,.2,0,.8) infinite,vjs-spinner-fade 1.1s linear infinite;animation:vjs-spinner-spin 1.1s cubic-bezier(.6,.2,0,.8) infinite,vjs-spinner-fade 1.1s linear infinite}.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:before{border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:after{border-top-color:#fff;-webkit-animation-delay:.44s;animation-delay:.44s}@keyframes vjs-spinner-show{to{visibility:visible}}@-webkit-keyframes vjs-spinner-show{to{visibility:visible}}@keyframes vjs-spinner-spin{to{transform:rotate(360deg)}}@-webkit-keyframes vjs-spinner-spin{to{-webkit-transform:rotate(360deg)}}@keyframes vjs-spinner-fade{0%{border-top-color:#73859f}20%{border-top-color:#73859f}35%{border-top-color:#fff}60%{border-top-color:#73859f}to{border-top-color:#73859f}}@-webkit-keyframes vjs-spinner-fade{0%{border-top-color:#73859f}20%{border-top-color:#73859f}35%{border-top-color:#fff}60%{border-top-color:#73859f}to{border-top-color:#73859f}}.video-js.vjs-audio-only-mode .vjs-captions-button{display:none}.vjs-chapters-button .vjs-menu ul{width:24em}.video-js.vjs-audio-only-mode .vjs-descriptions-button{display:none}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder{vertical-align:middle;display:inline-block;margin-bottom:-.1em}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before{font-family:VideoJS;content:"\\f10d";font-size:1.5em;line-height:inherit}.video-js.vjs-audio-only-mode .vjs-subs-caps-button{display:none}.video-js .vjs-audio-button+.vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder{vertical-align:middle;display:inline-block;margin-bottom:-.1em}.video-js .vjs-audio-button+.vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before{font-family:VideoJS;content:" \\f11d";font-size:1.5em;line-height:inherit}.video-js.vjs-layout-small .vjs-current-time,.video-js.vjs-layout-small .vjs-duration,.video-js.vjs-layout-small .vjs-playback-rate,.video-js.vjs-layout-small .vjs-remaining-time,.video-js.vjs-layout-small .vjs-time-divider,.video-js.vjs-layout-small .vjs-volume-control,.video-js.vjs-layout-tiny .vjs-current-time,.video-js.vjs-layout-tiny .vjs-duration,.video-js.vjs-layout-tiny .vjs-playback-rate,.video-js.vjs-layout-tiny .vjs-remaining-time,.video-js.vjs-layout-tiny .vjs-time-divider,.video-js.vjs-layout-tiny .vjs-volume-control,.video-js.vjs-layout-x-small .vjs-current-time,.video-js.vjs-layout-x-small .vjs-duration,.video-js.vjs-layout-x-small .vjs-playback-rate,.video-js.vjs-layout-x-small .vjs-remaining-time,.video-js.vjs-layout-x-small .vjs-time-divider,.video-js.vjs-layout-x-small .vjs-volume-control{display:none}.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:hover,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover{width:auto;width:initial}.video-js.vjs-layout-tiny .vjs-progress-control,.video-js.vjs-layout-x-small .vjs-progress-control{display:none}.video-js.vjs-layout-x-small .vjs-custom-control-spacer{flex:auto;display:block}.video-js.vjs-layout-x-small.vjs-no-flex .vjs-custom-control-spacer{width:auto}.vjs-modal-dialog.vjs-text-track-settings{background-color:#2b333f;background-color:#2b333fbf;color:#fff;height:70%}.vjs-text-track-settings .vjs-modal-dialog-content{display:table}.vjs-text-track-settings .vjs-track-settings-colors,.vjs-text-track-settings .vjs-track-settings-controls,.vjs-text-track-settings .vjs-track-settings-font{display:table-cell}.vjs-text-track-settings .vjs-track-settings-controls{text-align:right;vertical-align:bottom}@supports (display:grid){.vjs-text-track-settings .vjs-modal-dialog-content{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr;padding:20px 24px 0}.vjs-track-settings-controls .vjs-default-button{margin-bottom:20px}.vjs-text-track-settings .vjs-track-settings-controls{grid-column:1/-1}.vjs-layout-small .vjs-text-track-settings .vjs-modal-dialog-content,.vjs-layout-tiny .vjs-text-track-settings .vjs-modal-dialog-content,.vjs-layout-x-small .vjs-text-track-settings .vjs-modal-dialog-content{grid-template-columns:1fr}}.vjs-track-setting>select{margin-right:1em;margin-bottom:.5em}.vjs-text-track-settings fieldset{margin:5px;padding:3px;border:none}.vjs-text-track-settings fieldset span{display:inline-block}.vjs-text-track-settings fieldset span>select{max-width:7.3em}.vjs-text-track-settings legend{color:#fff;margin:0 0 5px}.vjs-text-track-settings .vjs-label{position:absolute;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);display:block;margin:0 0 5px;padding:0;border:0;height:1px;width:1px;overflow:hidden}.vjs-track-settings-controls button:active,.vjs-track-settings-controls button:focus{outline-style:solid;outline-width:medium;background-image:linear-gradient(0deg,#fff 88%,#73859f 100%)}.vjs-track-settings-controls button:hover{color:#2b333fbf}.vjs-track-settings-controls button{background-color:#fff;background-image:linear-gradient(-180deg,#fff 88%,#73859f 100%);color:#2b333f;cursor:pointer;border-radius:2px}.vjs-track-settings-controls .vjs-default-button{margin-right:1em}@media print{.video-js>:not(.vjs-tech):not(.vjs-poster){visibility:hidden}}.vjs-resize-manager{position:absolute;top:0;left:0;width:100%;height:100%;border:none;z-index:-1000}.js-focus-visible .video-js :focus:not(.focus-visible){outline:0}.video-js :focus:not(:focus-visible){outline:0}.border-red{border:1px solid #d2232a}.border-orange{border:1px solid #f69c05}.border-green{border:1px solid #97ab2c}.border-blue{border:1px solid #2b9ab8}.border-purple{border:1px solid #522e91}.border-white{border:1px solid #fff}.border-light-grey{border:1px solid #eee}.border-med-grey{border:1px solid #ccc}.border-dark-grey{border:1px solid #777770}.border-very-dark-grey{border:1px solid #555}.border-dark{border:1px solid #333}.border-black{border:1px solid #000}.vjs-paused .vjs-big-play-button{display:block}.ReactModal__Overlay_Library{position:fixed;inset:0px;z-index:1040;background-color:#000000bf!important}.ReactModal__Content_Library{position:absolute;left:50%!important;top:50%!important;padding:0;border:1px solid #eee;background:#fff;overflow:auto;border-radius:.25rem;outline:none;transform:translate(-50%,-50%)}.w-fit{width:fit-content}\n')();
const container$2 = "_container_irzen_1";
const active$1 = "_active_irzen_17";
const disabled$1 = "_disabled_irzen_22";
const nextPrev = "_nextPrev_irzen_26";
var styles$a = {
  container: container$2,
  active: active$1,
  disabled: disabled$1,
  nextPrev
};
const DOTS = "...";
const range2 = (start2, end3) => {
  const length = end3 - start2 + 1;
  return Array.from({
    length
  }, (_, idx) => idx + start2);
};
const usePagination = ({
  totalCount,
  pageSize,
  siblingCount = 1,
  currentPage
}) => {
  const paginationRange = useMemo(() => {
    const totalPageCount = Math.ceil(totalCount / pageSize);
    const totalPageNumbers = siblingCount + 5;
    if (totalPageNumbers >= totalPageCount) {
      return range2(1, totalPageCount);
    }
    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;
    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = 3 + 2 * siblingCount;
      const leftRange = range2(1, leftItemCount);
      return [...leftRange, DOTS, totalPageCount];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = 3 + 2 * siblingCount;
      const rightRange = range2(totalPageCount - rightItemCount + 1, totalPageCount);
      return [firstPageIndex, DOTS, ...rightRange];
    }
    if (shouldShowLeftDots && shouldShowRightDots) {
      const middleRange = range2(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
    }
    return [];
  }, [totalCount, pageSize, siblingCount, currentPage]);
  return paginationRange;
};
const Pagination = ({
  currentPage,
  pageSize,
  totalCount,
  siblingCount = 1,
  onPageChange
}) => {
  if (totalCount < 1 || pageSize < 1 || totalCount <= pageSize) {
    return /* @__PURE__ */ jsx(Fragment, {});
  }
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize
  });
  const lastPage = Math.ceil(totalCount / pageSize);
  const onNext = () => {
    onPageChange(currentPage + 1);
  };
  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };
  return /* @__PURE__ */ jsxs("ul", {
    className: styles$a.container,
    children: [/* @__PURE__ */ jsx("li", {
      className: currentPage === 1 ? `${styles$a.nextPrev} ${styles$a.disabled}` : styles$a.nextPrev,
      onClick: onPrevious,
      children: "<"
    }), paginationRange.map((pageNumber, index) => {
      if (typeof pageNumber === "string") {
        return /* @__PURE__ */ jsx("li", {
          children: "\u2026"
        }, pageNumber + index);
      }
      return /* @__PURE__ */ jsx("li", {
        className: pageNumber === currentPage ? styles$a.active : "",
        onClick: () => onPageChange(pageNumber),
        children: pageNumber
      }, pageNumber);
    }), /* @__PURE__ */ jsx("li", {
      className: currentPage === lastPage ? `${styles$a.nextPrev} ${styles$a.disabled}` : styles$a.nextPrev,
      onClick: onNext,
      children: ">"
    })]
  });
};
ReactModal.setAppElement("body");
const VideoLibrary = ({
  programId,
  VideoPlayer: TciVideoPlayer
}) => {
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [videos, setVideos] = useState([]);
  const [filters, setFilters] = useState(initialFilters$2);
  const [playerState, setPlayerState] = useState({
    visibility: false,
    videoInfo: void 0
  });
  const isStudent = !userInfo.staffer;
  useEffect(() => {
    getFilters$2(programId).then((res) => {
      setFilters({
        ...res
      });
    });
  }, [programId]);
  useEffect(() => {
    if (!compareObjects(filters, initialFilters$2)) {
      localStorage.setItem("video-filters", JSON.stringify(filters));
    }
    setIsLoading(true);
    getFilteredVideos(filters, programId).then(({
      data,
      count
    }) => {
      setVideos(data);
      setTotalCount(count);
      setIsLoading(false);
    });
  }, [filters, userInfo, programId]);
  const handleFilterChange = (newFilters, keepTotal) => {
    if (!keepTotal) {
      setTotalCount(0);
    }
    setFilters(newFilters);
  };
  const handlePlayVideo = (videoInfo) => {
    setPlayerState({
      visibility: true,
      videoInfo
    });
  };
  const handleClosePlayer = () => {
    setPlayerState({
      visibility: false,
      videoInfo: void 0
    });
  };
  const handlePublishVideo = (id2, title2) => {
    if (!id2)
      return;
    publishVideo(id2).then(() => {
      var _a;
      const newVideos = videos.map((videoInfo) => {
        if (videoInfo.id === id2) {
          videoInfo.published = true;
        }
        return videoInfo;
      });
      setVideos(newVideos);
      if (((_a = playerState.videoInfo) == null ? void 0 : _a.id) === id2) {
        setPlayerState({
          ...playerState,
          videoInfo: {
            ...playerState.videoInfo,
            published: true
          }
        });
      }
      toast.show({
        type: ToastTypes.SUCCESS,
        title: /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx(Status, {
            borderColor: Color.GREEN,
            checked: true
          }), "Video Published!"]
        }),
        content: `Your students have access to ${title2} on their Videos page.`,
        duration: 5e3,
        showIcon: true
      });
    });
  };
  const handleUnpublishVideo = (id2, title2) => {
    if (!id2)
      return;
    unpublishVideo(id2).then(() => {
      var _a;
      const newVideos = videos.map((videoInfo) => {
        if (videoInfo.id === id2) {
          videoInfo.published = false;
        }
        return videoInfo;
      });
      setVideos(newVideos);
      if (((_a = playerState.videoInfo) == null ? void 0 : _a.id) === id2) {
        setPlayerState({
          ...playerState,
          videoInfo: {
            ...playerState.videoInfo,
            published: false
          }
        });
      }
      toast.show({
        type: ToastTypes.SUCCESS,
        title: /* @__PURE__ */ jsxs(Fragment, {
          children: [/* @__PURE__ */ jsx(Status, {
            borderColor: Color.GREEN
          }), "Video Unpublished!"]
        }),
        content: `Your students no longer have access to ${title2} on their Videos page.`,
        duration: 5e3
      });
    });
  };
  const handlePageChange = (curPage) => {
    handleFilterChange({
      ...filters,
      page: curPage
    }, true);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: styles$j.page,
    children: [/* @__PURE__ */ jsx("div", {
      className: styles$j.description,
      children: !isStudent && "See all the videos in your program and choose which ones to publish to your students."
    }), /* @__PURE__ */ jsx("div", {
      className: styles$j.topPagination,
      children: /* @__PURE__ */ jsx(Pagination, {
        currentPage: filters.page,
        totalCount,
        pageSize: filters.per_page,
        onPageChange: handlePageChange
      })
    }), /* @__PURE__ */ jsxs("div", {
      className: styles$j.container,
      children: [/* @__PURE__ */ jsx(FilterBar$2, {
        filters,
        onFilterChange: handleFilterChange
      }), !isLoading && videos.length > 0 ? /* @__PURE__ */ jsxs("div", {
        className: styles$j.paginationWrapper,
        children: [/* @__PURE__ */ jsx("div", {
          className: styles$j.cardContainer,
          children: videos.map((videoData) => /* @__PURE__ */ jsx(Card, {
            data: videoData,
            onPlayVideo: handlePlayVideo,
            onPublish: handlePublishVideo,
            onUnpublish: handleUnpublishVideo,
            showPublish: !isStudent
          }, `${videoData.id}-${btoa(videoData.lesson_title)}`))
        }), /* @__PURE__ */ jsx("div", {
          className: styles$j.bottomPagination,
          children: /* @__PURE__ */ jsx(Pagination, {
            currentPage: filters.page,
            totalCount,
            pageSize: filters.per_page,
            onPageChange: handlePageChange
          })
        })]
      }) : isLoading ? /* @__PURE__ */ jsx("div", {
        className: styles$j.loading,
        children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
          icon: faSpinner,
          spin: true
        })
      }) : /* @__PURE__ */ jsxs("div", {
        className: styles$j.noResult,
        children: [/* @__PURE__ */ jsx("div", {
          className: styles$j.noResultTitle,
          children: isStudent ? "No Videos Published" : "No Videos Found"
        }), /* @__PURE__ */ jsx("div", {
          className: styles$j.noResultDescription,
          children: isStudent ? "Your teacher has not published any videos. Please check back again later." : "Please modify your filters to explore different results."
        })]
      })]
    }), /* @__PURE__ */ jsx(VideoPlayer, {
      visibility: playerState.visibility,
      onClose: handleClosePlayer,
      videoInfo: playerState.videoInfo,
      onPublish: handlePublishVideo,
      onUnpublish: handleUnpublishVideo,
      showPublish: !isStudent,
      TciVideoPlayer
    })]
  });
};
const bar$1 = "_bar_njduj_1";
const barTitle$1 = "_barTitle_njduj_18";
const clearButton$1 = "_clearButton_njduj_24";
const categoryTitle$1 = "_categoryTitle_njduj_30";
const innerFilter$1 = "_innerFilter_njduj_37";
var styles$9 = {
  bar: bar$1,
  barTitle: barTitle$1,
  clearButton: clearButton$1,
  categoryTitle: categoryTitle$1,
  innerFilter: innerFilter$1
};
const FilterBar$1 = ({
  filters,
  onFilterChange
}) => {
  var _a, _b;
  const handleLessonChange = (value, checked) => {
    var _a2, _b2;
    const newFilters = {
      ...filters
    };
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      const lesson = unitFilter.lessons.find((lesson2) => lesson2.value === value);
      if (lesson) {
        lesson.checked = checked;
      }
    });
    (_b2 = newFilters.lesson) == null ? void 0 : _b2.forEach((lessonFilter) => {
      if (lessonFilter.value === value) {
        lessonFilter.checked = checked;
      }
    });
    onFilterChange(newFilters);
  };
  const handleUnitChange = (oldUnit, checked) => {
    var _a2;
    const newFilters = {
      ...filters
    };
    const newLessons = oldUnit.lessons.map((lesson) => ({
      ...lesson,
      checked
    }));
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      if (unitFilter.label === oldUnit.label) {
        unitFilter.lessons = newLessons;
      }
    });
    onFilterChange(newFilters);
  };
  const handleCategoryChange = (value, checked) => {
    const newFilters = {
      ...filters
    };
    const newCategory = newFilters.category.find((categoryFilter) => categoryFilter.value === value);
    if (newCategory) {
      newCategory.checked = checked;
    }
    onFilterChange(newFilters);
  };
  const handleStatusChange = (value, checked) => {
    const newFilters = {
      ...filters
    };
    const newStatus = newFilters.status.find((statusFilter) => statusFilter.value === value);
    if (newStatus) {
      newStatus.checked = checked;
    }
    onFilterChange(newFilters);
  };
  const handleFilterClear = () => {
    var _a2, _b2;
    const newFilters = {
      ...filters
    };
    const setUnchecked = (filter2) => {
      filter2.checked = false;
    };
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      unitFilter.lessons.forEach(setUnchecked);
    });
    (_b2 = newFilters.lesson) == null ? void 0 : _b2.forEach(setUnchecked);
    newFilters.category.forEach(setUnchecked);
    newFilters.status.forEach(setUnchecked);
    onFilterChange(newFilters);
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `${styles$9.bar} card`,
    children: [/* @__PURE__ */ jsx("div", {
      className: styles$9.barTitle,
      children: "Filters"
    }), /* @__PURE__ */ jsx("button", {
      className: `btn btn--link-purple ${styles$9.clearButton}`,
      onClick: handleFilterClear,
      children: "Clear"
    }), /* @__PURE__ */ jsx(Divider, {}), !!((_a = filters.unit) == null ? void 0 : _a.length) && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$9.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$9.categoryTitle,
            children: "Unit"
          }),
          children: filters.unit.map((unitFilter) => {
            const allLessonsChecked = unitFilter.lessons.every((lesson) => lesson.checked);
            const someLessonsChecked = unitFilter.lessons.some((lesson) => lesson.checked);
            return /* @__PURE__ */ jsx("div", {
              className: styles$9.filter,
              children: /* @__PURE__ */ jsx(Collapse, {
                triggerElement: /* @__PURE__ */ jsx(Checkbox, {
                  extraClassName: "mb5",
                  indeterminate: someLessonsChecked && !allLessonsChecked,
                  label: unitFilter.label,
                  checked: allLessonsChecked,
                  shouldCover: true,
                  onChange: (event) => {
                    handleUnitChange(unitFilter, event.target.checked);
                  }
                }),
                shouldCollapse: true,
                children: unitFilter.lessons.map((lesson) => {
                  var _a2;
                  return /* @__PURE__ */ jsx(Filter, {
                    className: styles$9.innerFilter,
                    label: lesson.label,
                    value: lesson.value,
                    checked: (_a2 = lesson.checked) != null ? _a2 : false,
                    onChange: handleLessonChange
                  }, lesson.value);
                })
              })
            }, unitFilter.label);
          })
        })
      })
    }), !!((_b = filters.lesson) == null ? void 0 : _b.length) && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$9.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$9.categoryTitle,
            children: "Lesson"
          }),
          children: filters.lesson.map((lessonFilter) => {
            var _a2;
            return /* @__PURE__ */ jsx(Filter, {
              label: lessonFilter.label,
              value: lessonFilter.value,
              checked: (_a2 = lessonFilter.checked) != null ? _a2 : false,
              onChange: handleLessonChange
            }, lessonFilter.value);
          })
        })
      })
    }), !!filters.category.length && /* @__PURE__ */ jsx("div", {
      className: styles$9.category,
      children: /* @__PURE__ */ jsx(Collapse, {
        triggerElement: /* @__PURE__ */ jsx("div", {
          className: styles$9.categoryTitle,
          children: "Category"
        }),
        children: filters.category.map((categoryFilter) => {
          var _a2;
          return /* @__PURE__ */ jsx(Filter, {
            label: categoryFilter.label,
            value: categoryFilter.value,
            checked: (_a2 = categoryFilter.checked) != null ? _a2 : false,
            onChange: handleCategoryChange
          }, categoryFilter.value);
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: styles$9.category,
      children: /* @__PURE__ */ jsx(Collapse, {
        triggerElement: /* @__PURE__ */ jsx("div", {
          className: styles$9.categoryTitle,
          children: "Status"
        }),
        children: filters.status.map((statusFilter) => {
          var _a2;
          return /* @__PURE__ */ jsx(Filter, {
            label: statusFilter.label,
            value: statusFilter.value,
            checked: (_a2 = statusFilter.checked) != null ? _a2 : false,
            onChange: handleStatusChange
          }, statusFilter.value);
        })
      })
    })]
  });
};
const gameCard = "_gameCard_ti5vc_1";
const cardImg = "_cardImg_ti5vc_10";
const blackImg = "_blackImg_ti5vc_21";
const questionCount = "_questionCount_ti5vc_29";
const cardTitle = "_cardTitle_ti5vc_37";
const badge = "_badge_ti5vc_46";
const cardContent = "_cardContent_ti5vc_50";
const cardSubtitle = "_cardSubtitle_ti5vc_54";
const titleBox = "_titleBox_ti5vc_61";
const gameType = "_gameType_ti5vc_67";
const actionBar = "_actionBar_ti5vc_75";
const disabled = "_disabled_ti5vc_94";
const assignedIcon = "_assignedIcon_ti5vc_100";
var styles$8 = {
  gameCard,
  cardImg,
  blackImg,
  questionCount,
  cardTitle,
  badge,
  cardContent,
  cardSubtitle,
  titleBox,
  gameType,
  actionBar,
  disabled,
  assignedIcon
};
const HARDCODED_THUMBNAIL_URL = {
  "powered by pizza": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_powered-by-pizza_banner.png",
  "desarrollado por pizza": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_powered-by-pizza_banner.png",
  "adventures in the sky": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_adventures-in-the-sky_banner.png",
  "aventuras en el cielo": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_adventures-in-the-sky_banner.png",
  "the museum of parts": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_museum-of-parts_banner.png",
  "el museo de las piezas": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_museum-of-parts_banner.png",
  "community cleanup": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_community-cleanup_banner.png",
  "limpieza de la comunidad": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/games-library_community-cleanup_banner.png",
  "state capitals game": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/State_Capitals_Game_Thumbnail.png",
  "juego de capitales de estado": "https://s3.amazonaws.com/platoproduction20160712/system/games/ui/State_Capitals_Game_Thumbnail.png"
};
const GameCard = ({
  data,
  onAssignClick,
  onGradeClick
}) => {
  const isStudent = !userInfo.staffer;
  const handleLinkGame = () => {
    if (data.link) {
      location.href = data.link;
    }
  };
  const handleAssignClick = () => {
    onAssignClick(data.lesson_id, data.assignment_modal_initial_value);
  };
  const handleGradeClick = () => {
    onGradeClick(data.lesson_id);
  };
  const AssignedTooltip = /* @__PURE__ */ jsxs("div", {
    className: "center pad10",
    children: [/* @__PURE__ */ jsx("div", {
      className: "bold bbs pad5",
      children: "Create Assignment"
    }), /* @__PURE__ */ jsx("div", {
      children: "An assignment has been made for the game. "
    })]
  });
  const isStateCapitalsGame = () => data.name === "State Capitals" || data.name === "Juego de Capitales de Estado";
  const needHardcodedThumbnailImageUrl = () => Object.keys(HARDCODED_THUMBNAIL_URL).includes(data.name.toLowerCase());
  return /* @__PURE__ */ jsxs("div", {
    className: `card ${styles$8.gameCard}`,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles$8.cardImg + (!needHardcodedThumbnailImageUrl() && (!data.background_url || data.background_url === "/missing.png") ? ` ${styles$8.blackImg}` : ""),
      onClick: handleLinkGame,
      children: [/* @__PURE__ */ jsx("img", {
        src: needHardcodedThumbnailImageUrl() ? HARDCODED_THUMBNAIL_URL[data.name.toLowerCase()] : data.background_url,
        alt: data.name
      }), data.question_count && /* @__PURE__ */ jsx("div", {
        className: `${styles$8.questionCount} pos_bottom_right`,
        children: data.question_count + (data.question_count > 1 ? " questions" : " question")
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: styles$8.cardContent,
      children: [/* @__PURE__ */ jsxs("div", {
        className: styles$8.titleBox,
        children: [/* @__PURE__ */ jsxs("a", {
          href: data.link,
          className: styles$8.cardTitle,
          children: [isStateCapitalsGame() && /* @__PURE__ */ jsx("span", {
            className: styles$8.badge,
            children: "New!\xA0"
          }), data.name]
        }), /* @__PURE__ */ jsx("div", {
          className: styles$8.gameType,
          children: data.game_type
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: styles$8.cardSubtitle,
        children: data.unit_title
      }), /* @__PURE__ */ jsx("div", {
        className: styles$8.cardSubtitle,
        children: data.lesson_title
      }), isStudent ? data.assigned && /* @__PURE__ */ jsx("div", {
        className: styles$8.actionBar,
        children: /* @__PURE__ */ jsx(Tooltip, {
          content: "An assignment has been made for this game.",
          shouldDisplay: true,
          interactive: false,
          children: /* @__PURE__ */ jsx("i", {
            className: `fa fa-calendar-check-o ${styles$8.assignedIcon}`
          })
        })
      }) : /* @__PURE__ */ jsxs("div", {
        className: styles$8.actionBar,
        children: [data.assigned ? /* @__PURE__ */ jsx(Tooltip, {
          content: AssignedTooltip,
          shouldDisplay: true,
          interactive: false,
          children: /* @__PURE__ */ jsx("button", {
            onClick: handleAssignClick,
            children: /* @__PURE__ */ jsx("i", {
              className: `fa fa-calendar-check-o ${styles$8.assignedIcon}`
            })
          })
        }) : /* @__PURE__ */ jsx(Tooltip, {
          content: "Create Assignment",
          shouldDisplay: true,
          interactive: false,
          children: /* @__PURE__ */ jsx("button", {
            onClick: handleAssignClick,
            children: /* @__PURE__ */ jsx("i", {
              className: "fa fa-calendar"
            })
          })
        }), /* @__PURE__ */ jsx(Tooltip, {
          content: "Grade",
          shouldDisplay: true,
          interactive: false,
          children: /* @__PURE__ */ jsx("button", {
            onClick: handleGradeClick,
            children: /* @__PURE__ */ jsx("i", {
              className: "fa fa-bar-chart"
            })
          })
        })]
      })]
    })]
  });
};
const initialFilters$1 = {
  category: [{
    label: "Lesson Review Game",
    value: "lesson_review_game",
    checked: true
  }, {
    label: "Vocabulary Game",
    value: "vocabulary_game",
    checked: true
  }],
  status: [{
    label: "Assigned",
    value: "Assigned",
    checked: false
  }, {
    label: "Unassigned",
    value: "Unassigned",
    checked: false
  }]
};
let filterCancelToken$1;
const getFilteredGames = (filters, programId) => {
  var _a, _b;
  if (filterCancelToken$1 !== void 0) {
    filterCancelToken$1.cancel("Operation canceled due to new request.");
  }
  filterCancelToken$1 = axios.CancelToken.source();
  const params = {
    "search[lesson_ids_in]": [],
    "search[category_in]": [],
    "search[program_id_eq]": programId
  };
  (_a = filters.unit) == null ? void 0 : _a.forEach((unitFilters) => {
    const checkedLessons = unitFilters.lessons.filter((lessonFilter) => lessonFilter.checked).map((lessonFilter) => lessonFilter.value);
    params["search[lesson_ids_in]"].push(...checkedLessons);
  });
  (_b = filters.lesson) == null ? void 0 : _b.forEach((lessonFilter) => {
    if (lessonFilter.checked) {
      params["search[lesson_ids_in]"].push(lessonFilter.value);
    }
  });
  filters.category.forEach((categoryFilter) => {
    if (categoryFilter.checked) {
      params["search[category_in]"].push(categoryFilter.value);
    }
  });
  if (filters.status.some((statusFilter) => statusFilter.checked && statusFilter.value === "Assigned")) {
    params["search[assigned_eq]"] = true;
  }
  if (filters.status.some((statusFilter) => statusFilter.checked && statusFilter.value === "Unassigned")) {
    if (params["search[assigned_eq]"] === true) {
      params["search[assigned_eq]"] = void 0;
    } else {
      params["search[assigned_eq]"] = false;
    }
  }
  return axios({
    method: "get",
    url: `${ENDPOINT}/games?page=1&per_page=50&column=title_en&order=asc`,
    params,
    cancelToken: filterCancelToken$1.token
  }).then((res) => res.data.data);
};
const getFilters$1 = (programId, lessonId, unitId) => {
  var _a;
  const filters = {
    ...initialFilters$1
  };
  const savedFilters = lessonId || unitId ? initialFilters$1 : JSON.parse((_a = localStorage.getItem("game-filters")) != null ? _a : JSON.stringify(initialFilters$1));
  const lessonQueryParam = lessonId ? `&lesson_id=${lessonId}` : "";
  const unitQueryParam = unitId ? `&unit_id=${unitId}` : "";
  const lessonIsChecked = (lessonFilter, savedFilters2) => {
    var _a2;
    return ((_a2 = savedFilters2.unit) == null ? void 0 : _a2.some((unitFilter) => unitFilter.lessons.find((savedLesson) => lessonFilter.checked || savedLesson.value === lessonFilter.value && savedLesson.checked))) || lessonFilter.checked;
  };
  const getUnitFilters = (filterData) => {
    var _a2;
    return (_a2 = filterData.unit) == null ? void 0 : _a2.map((unit) => {
      const label = Object.keys(unit)[0];
      const lessons = Object.values(unit)[0].map((lessonFilter) => ({
        ...lessonFilter,
        checked: lessonIsChecked(lessonFilter, savedFilters)
      }));
      return {
        label,
        lessons
      };
    });
  };
  const getLessonFilters = (filterData) => {
    var _a2;
    return (_a2 = filterData.lesson) == null ? void 0 : _a2.map((lessonFilter) => {
      var _a3;
      const checked = ((_a3 = savedFilters.lesson) == null ? void 0 : _a3.some((savedLesson) => lessonFilter.checked || savedLesson.value === lessonFilter.value && savedLesson.checked)) || lessonFilter.checked;
      return {
        ...lessonFilter,
        checked
      };
    });
  };
  return axios.get(`${ENDPOINT}/games/filter_categories?program_id=${programId}${lessonQueryParam}${unitQueryParam}`).then((res) => {
    const filterData = res.data;
    filters.unit = getUnitFilters(filterData);
    filters.lesson = getLessonFilters(filterData);
    filters.category = filterData.category.map((categoryFilter) => {
      var _a2;
      const checked = (_a2 = savedFilters.category) == null ? void 0 : _a2.some((savedCategory) => savedCategory.value === categoryFilter.value && savedCategory.checked);
      return {
        ...categoryFilter,
        checked
      };
    });
    filters.status = filters.status.map((statusFilter) => {
      var _a2;
      const checked = (_a2 = savedFilters.status) == null ? void 0 : _a2.some((savedStatus) => savedStatus.value === statusFilter.value && savedStatus.checked);
      return {
        ...statusFilter,
        checked
      };
    });
    return filters;
  });
};
const alignLeft = "_alignLeft_254ka_1";
const container$1 = "_container_254ka_5";
const description$1 = "_description_254ka_9";
const cardContainer = "_cardContainer_254ka_14";
const loading$3 = "_loading_254ka_22";
const noResult$1 = "_noResult_254ka_29";
const noResultTitle$1 = "_noResultTitle_254ka_33";
const noResultDescription$1 = "_noResultDescription_254ka_41";
var styles$7 = {
  alignLeft,
  container: container$1,
  description: description$1,
  cardContainer,
  loading: loading$3,
  noResult: noResult$1,
  noResultTitle: noResultTitle$1,
  noResultDescription: noResultDescription$1
};
const GameLibrary = ({
  program,
  lesson,
  unit,
  AsyncAssignmentModal,
  gradeUri
}) => {
  var _a;
  const isStudent = !userInfo.staffer;
  const [isLoading, setIsLoading] = useState(true);
  const [games, setGames] = useState([]);
  const [filters, setFilters] = useState({
    ...initialFilters$1
  });
  const [assignModalSetting, setAssignModalSetting] = useState({
    show: false,
    lessonId: 0,
    initialValues: {
      modelType: "lessonGame",
      modelsToAssign: ""
    }
  });
  useEffect(() => {
    getFilters$1(program.id, lesson == null ? void 0 : lesson.id, unit == null ? void 0 : unit.id).then((res) => {
      setFilters({
        ...res,
        category: res.category.filter((category) => category.value !== "classroom_game")
      });
    });
  }, [program.id]);
  useEffect(() => {
    if (!compareObjects(filters, initialFilters$1) && !lesson) {
      localStorage.setItem("game-filters", JSON.stringify(filters));
    }
    setIsLoading(true);
    getFilteredGames(filters, program.id).then((res) => {
      setGames([...res].sort((infoA, infoB) => {
        var _a2, _b;
        const unitA = ((_a2 = infoA.unit_title) == null ? void 0 : _a2.split(" ")[0]) || "";
        const unitB = ((_b = infoB.unit_title) == null ? void 0 : _b.split(" ")[0]) || "";
        if (unitA !== unitB)
          return unitA < unitB ? -1 : 1;
        if (infoA.lesson_id !== infoB.lesson_id)
          return infoA.lesson_id - infoB.lesson_id;
        return infoA.game_type === "Vocabulary Game" ? 1 : -1;
      }));
      setIsLoading(false);
    });
  }, [filters, program.id]);
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };
  const handleAssignClick = (lessonId, initialValues) => {
    setAssignModalSetting({
      show: true,
      lessonId,
      initialValues
    });
  };
  const handleGradeClick = (lessonId) => {
    const uri = new URL(window.location.protocol + "//" + window.location.host + "/" + gradeUri);
    if (lessonId) {
      uri.searchParams.set("lesson_id", lessonId.toString());
    }
    uri.searchParams.set("program_id", program.id);
    location.href = uri.toString();
  };
  const handleCloseAssignModal = () => {
    setAssignModalSetting({
      show: false,
      lessonId: 0,
      initialValues: {
        modelType: "lessonGame",
        modelsToAssign: ""
      }
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className: styles$7.alignLeft,
    children: [/* @__PURE__ */ jsx("div", {
      className: styles$7.description,
      children: isStudent ? "See all the games in your program." : "See all the games in your program and assign them as a review or as an assessment."
    }), /* @__PURE__ */ jsx(AsyncAssignmentModal, {
      closeModal: handleCloseAssignModal,
      handlePostSave: () => {
      },
      modalIsOpen: assignModalSetting.show,
      stafferId: (_a = userInfo == null ? void 0 : userInfo.staffer) == null ? void 0 : _a.id,
      initialLessonId: assignModalSetting.lessonId,
      initialValues: assignModalSetting.initialValues,
      program: {
        ...program,
        id: Number.parseInt(program.id)
      }
    }), /* @__PURE__ */ jsxs("div", {
      className: styles$7.container,
      children: [/* @__PURE__ */ jsx(FilterBar$1, {
        filters,
        onFilterChange: handleFilterChange
      }), !isLoading && games.length > 0 ? /* @__PURE__ */ jsx("div", {
        className: styles$7.cardContainer,
        children: games.map((gameData) => {
          return /* @__PURE__ */ jsx(GameCard, {
            data: gameData,
            onAssignClick: handleAssignClick,
            onGradeClick: handleGradeClick
          }, gameData.id);
        })
      }) : isLoading ? /* @__PURE__ */ jsx("div", {
        className: styles$7.loading,
        children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
          icon: faSpinner,
          spin: true
        })
      }) : /* @__PURE__ */ jsxs("div", {
        className: styles$7.noResult,
        children: [/* @__PURE__ */ jsx("div", {
          className: styles$7.noResultTitle,
          children: "No Games Found"
        }), /* @__PURE__ */ jsx("div", {
          className: styles$7.noResultDescription,
          children: "Please modify your filters to explore different results."
        })]
      })]
    })]
  });
};
const bar = "_bar_1r7wp_1";
const barTitle = "_barTitle_1r7wp_18";
const clearButton = "_clearButton_1r7wp_24";
const categoryTitle = "_categoryTitle_1r7wp_30";
const innerFilter = "_innerFilter_1r7wp_37";
const sourceFilter = "_sourceFilter_1r7wp_42";
const sourceFilterLabel = "_sourceFilterLabel_1r7wp_47";
var styles$6 = {
  bar,
  barTitle,
  clearButton,
  categoryTitle,
  innerFilter,
  sourceFilter,
  sourceFilterLabel
};
const initialName = "_initialName_ssber_1";
var styles$5 = {
  initialName
};
const ASSESSMENT_SOURCE_MY_TESTS = "My Tests";
const sourceIsMyTests = (source) => {
  return (source == null ? void 0 : source.toUpperCase()) === ASSESSMENT_SOURCE_MY_TESTS.toUpperCase();
};
var TciIcon = "data:image/svg+xml;base64,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";
var DistrictIcon = "data:image/svg+xml;base64,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";
var OtherTeachersIcon = "data:image/svg+xml;base64,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";
const SOURCE_URLS = {
  TCI: TciIcon,
  "MY DISTRICT": DistrictIcon,
  "OTHER TEACHERS' TESTS": OtherTeachersIcon
};
const SOURCE_ALT_TAGS = {
  TCI: "TCI",
  "MY DISTRICT": "My District",
  "OTHER TEACHERS' TESTS": "Other Teachers"
};
const SourceIcon = ({
  source = "",
  size = 24,
  firstName,
  lastName
}) => {
  source = source || "";
  const upperSource = source.toUpperCase();
  if (!Object.keys(SOURCE_URLS).includes(upperSource) && !sourceIsMyTests(upperSource)) {
    return null;
  }
  const url = useMemo(() => SOURCE_URLS[upperSource], [source]);
  const initialName2 = firstName && lastName ? firstName.charAt(0) + lastName.charAt(0) : "";
  return url ? /* @__PURE__ */ jsx("img", {
    src: url,
    width: size,
    alt: SOURCE_ALT_TAGS[upperSource]
  }) : initialName2 ? /* @__PURE__ */ jsx("div", {
    className: styles$5.initialName,
    style: {
      width: size,
      height: size,
      fontSize: size / 2
    },
    children: initialName2
  }) : null;
};
const FilterBar = ({
  filters,
  onFilterChange,
  openedUnitValue = void 0
}) => {
  var _a, _b;
  const [openUnitVal, setOpenUnitVal] = useState(-1);
  const isStudent = !userInfo.staffer;
  useEffect(() => {
    setOpenUnitVal(openedUnitValue || -1);
  }, [openedUnitValue]);
  const handleLessonChange = (value, checked) => {
    var _a2, _b2;
    let unitValToKeep;
    const newFilters = {
      ...filters
    };
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      const lesson = unitFilter.lessons.find((lesson2) => lesson2.value === value);
      if (lesson) {
        lesson.checked = checked;
        unitValToKeep = unitFilter.value;
      }
    });
    (_b2 = newFilters.lesson) == null ? void 0 : _b2.forEach((lessonFilter) => {
      if (lessonFilter.value === value) {
        lessonFilter.checked = checked;
      }
    });
    onFilterChange({
      newFilters,
      unitValFromFilterBar: unitValToKeep
    });
  };
  const handleUnitChange = (oldUnit, checked) => {
    var _a2;
    const newFilters = {
      ...filters
    };
    const newLessons = oldUnit.lessons.map((lesson) => ({
      ...lesson,
      checked
    }));
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      if (unitFilter.label === oldUnit.label) {
        unitFilter.lessons = newLessons;
      }
    });
    onFilterChange({
      newFilters,
      unitValFromFilterBar: oldUnit.value
    });
  };
  const handleCategoryChange = (value, checked) => {
    const newFilters = {
      ...filters
    };
    const newCategory = newFilters.category.find((categoryFilter) => categoryFilter.value === value);
    if (newCategory) {
      newCategory.checked = checked;
    }
    newFilters.page = 1;
    onFilterChange({
      newFilters
    });
  };
  const handleSourceChange = (value, checked) => {
    const newFilters = {
      ...filters
    };
    const newIncluded = newFilters.source.find((sourceFilter2) => sourceFilter2.value === value);
    if (newIncluded) {
      newIncluded.checked = checked;
    }
    newFilters.page = 1;
    onFilterChange({
      newFilters
    });
  };
  const handleFilterClear = () => {
    var _a2, _b2;
    const newFilters = {
      ...filters
    };
    const setUnchecked = (filter2) => {
      filter2.checked = false;
    };
    (_a2 = newFilters.unit) == null ? void 0 : _a2.forEach((unitFilter) => {
      unitFilter.lessons.forEach(setUnchecked);
    });
    (_b2 = newFilters.lesson) == null ? void 0 : _b2.forEach(setUnchecked);
    newFilters.category.forEach(setUnchecked);
    newFilters.source.forEach(setUnchecked);
    onFilterChange({
      newFilters
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className: `${styles$6.bar} card`,
    children: [/* @__PURE__ */ jsx("div", {
      className: styles$6.barTitle,
      children: "Filters"
    }), /* @__PURE__ */ jsx("button", {
      className: `btn btn--link-purple ${styles$6.clearButton}`,
      onClick: handleFilterClear,
      children: "Clear"
    }), /* @__PURE__ */ jsx(Divider, {}), !!((_a = filters.unit) == null ? void 0 : _a.length) && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$6.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$6.categoryTitle,
            children: "Unit"
          }),
          children: filters.unit.map((unitFilter) => /* @__PURE__ */ jsx("div", {
            className: styles$6.filter,
            children: /* @__PURE__ */ jsx(Collapse, {
              triggerElement: /* @__PURE__ */ jsx(Checkbox, {
                extraClassName: "mb5",
                label: unitFilter.label,
                shouldCover: true,
                checked: unitFilter.lessons.every((lesson) => lesson.checked),
                onChange: (event) => {
                  handleUnitChange(unitFilter, event.target.checked);
                }
              }),
              shouldCollapse: openUnitVal !== unitFilter.value && unitFilter.lessons.every((l) => !l.checked),
              children: unitFilter.lessons.map((lesson) => {
                var _a2;
                return /* @__PURE__ */ jsx(Filter, {
                  className: styles$6.innerFilter,
                  label: lesson.label,
                  value: lesson.value,
                  checked: (_a2 = lesson.checked) != null ? _a2 : false,
                  onChange: handleLessonChange
                }, lesson.value);
              })
            })
          }, unitFilter.label))
        })
      })
    }), !!((_b = filters.lesson) == null ? void 0 : _b.length) && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$6.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$6.categoryTitle,
            children: "Lesson"
          }),
          children: filters.lesson.map((lessonFilter) => {
            var _a2;
            return /* @__PURE__ */ jsx(Filter, {
              label: lessonFilter.label,
              value: lessonFilter.value,
              checked: (_a2 = lessonFilter.checked) != null ? _a2 : false,
              onChange: handleLessonChange
            }, lessonFilter.value);
          })
        })
      })
    }), !!filters.category.length && /* @__PURE__ */ jsx(Fragment, {
      children: /* @__PURE__ */ jsx("div", {
        className: styles$6.category,
        children: /* @__PURE__ */ jsx(Collapse, {
          triggerElement: /* @__PURE__ */ jsx("div", {
            className: styles$6.categoryTitle,
            children: "Category"
          }),
          children: filters.category.map((categoryFilter) => {
            var _a2;
            return /* @__PURE__ */ jsx(Filter, {
              label: categoryFilter.label,
              value: categoryFilter.value,
              checked: (_a2 = categoryFilter.checked) != null ? _a2 : false,
              onChange: handleCategoryChange
            }, categoryFilter.value);
          })
        })
      })
    }), filters.source.length > 0 && !isStudent && /* @__PURE__ */ jsx("div", {
      className: styles$6.category,
      children: /* @__PURE__ */ jsx(Collapse, {
        triggerElement: /* @__PURE__ */ jsx("div", {
          className: styles$6.categoryTitle,
          children: "Source"
        }),
        children: filters.source.map((sourceFilter2) => {
          var _a2, _b2, _c;
          return /* @__PURE__ */ jsx(Filter, {
            label: /* @__PURE__ */ jsxs("div", {
              className: styles$6.sourceFilter,
              children: [/* @__PURE__ */ jsx("span", {
                className: styles$6.sourceFilterLabel,
                children: sourceFilter2.label
              }), /* @__PURE__ */ jsx(SourceIcon, {
                source: sourceFilter2.label,
                size: 18,
                firstName: (_a2 = userInfo.staffer) == null ? void 0 : _a2.first_name,
                lastName: (_b2 = userInfo.staffer) == null ? void 0 : _b2.last_name
              })]
            }),
            value: sourceFilter2.value,
            checked: (_c = sourceFilter2.checked) != null ? _c : false,
            onChange: handleSourceChange
          }, sourceFilter2.value);
        })
      })
    })]
  });
};
const initialFilters = {
  category: [],
  source: [],
  page: 1,
  per_page: 15
};
const DEFAULT_SOURCE_FILTER_VALUES = ["tci", "my_tests"];
const getFilters = (programId, lessonId) => {
  const filters = {
    ...initialFilters
  };
  return axios.get(`${ENDPOINT}/assessments/filter_categories?program_id=${programId}`).then((res) => {
    var _a, _b;
    const filterData = res.data;
    filters.unit = (_a = filterData.unit) == null ? void 0 : _a.map((unit) => {
      const label = Object.keys(unit)[0];
      const unitData = Object.values(unit)[0];
      const lessons = unitData.lessons.map((lessonFilter) => {
        return {
          ...lessonFilter,
          checked: lessonFilter.value === lessonId
        };
      });
      return {
        label,
        lessons,
        value: unitData.value
      };
    });
    filters.lesson = (_b = filterData.lesson) == null ? void 0 : _b.map((lessonFilter) => {
      return {
        ...lessonFilter,
        checked: lessonFilter.value === lessonId
      };
    });
    filters.category = res.data.category.map((categoryFilter) => {
      return {
        ...categoryFilter,
        checked: false
      };
    }).sort((categoryA, categoryB) => categoryA.label.toLocaleLowerCase() > categoryB.label.toLocaleLowerCase() ? 1 : -1);
    filters.source = res.data.source.map((sourceFilter2) => {
      return {
        ...sourceFilter2,
        checked: DEFAULT_SOURCE_FILTER_VALUES.includes(sourceFilter2.value)
      };
    });
    return filters;
  });
};
let filterCancelToken;
const getFilteredAssessments = (filters, programId) => {
  var _a, _b;
  if (filterCancelToken !== void 0) {
    filterCancelToken.cancel("Operation canceled due to new request.");
  }
  filterCancelToken = axios.CancelToken.source();
  const params = {
    "search[program_id_eq]": programId,
    "search[lesson_ids_in]": [],
    "search[category_in]": [],
    "search[source_in]": [],
    page: filters.page,
    per_page: filters.per_page,
    column: "name",
    order: "asc"
  };
  (_a = filters.unit) == null ? void 0 : _a.forEach((unitFilers) => {
    const checkedLessons = unitFilers.lessons.filter((lessonFilter) => lessonFilter.checked).map((lessonFilter) => lessonFilter.value);
    params["search[lesson_ids_in]"].push(...checkedLessons);
  });
  (_b = filters.lesson) == null ? void 0 : _b.forEach((lessonFilter) => {
    if (lessonFilter.checked) {
      params["search[lesson_ids_in]"].push(lessonFilter.value);
    }
  });
  filters.category.filter((categoryFilter) => categoryFilter.checked).forEach((categoryFilter) => {
    params["search[category_in]"].push(categoryFilter.value);
  });
  filters.source.forEach((sourceFilter2) => {
    if (sourceFilter2.checked) {
      params["search[source_in]"].push(sourceFilter2.value);
    }
  });
  return axios({
    method: "get",
    url: `${ENDPOINT}/assessments`,
    params,
    cancelToken: filterCancelToken.token
  }).then((res) => ({
    data: res.data.data,
    count: res.data.meta.count
  }));
};
const content$1 = "_content_vp2ho_1";
const loading$2 = "_loading_vp2ho_7";
const noResult = "_noResult_vp2ho_14";
const noResultTitle = "_noResultTitle_vp2ho_18";
const noResultDescription = "_noResultDescription_vp2ho_26";
const container = "_container_vp2ho_31";
const description = "_description_vp2ho_35";
const unitLessonSelect = "_unitLessonSelect_vp2ho_41";
const topBar = "_topBar_vp2ho_45";
const createButton = "_createButton_vp2ho_54";
const table$2 = "_table_vp2ho_59";
const tableHeader$2 = "_tableHeader_vp2ho_64";
const categoryColumn$1 = "_categoryColumn_vp2ho_82";
const sourceColumn$1 = "_sourceColumn_vp2ho_86";
const locationColumn$2 = "_locationColumn_vp2ho_91";
const titleColumn$1 = "_titleColumn_vp2ho_95";
const questionColumn$2 = "_questionColumn_vp2ho_99";
const actionColumn$1 = "_actionColumn_vp2ho_104";
const paginationWrapper = "_paginationWrapper_vp2ho_108";
const bottomPagination = "_bottomPagination_vp2ho_115";
var styles$4 = {
  content: content$1,
  loading: loading$2,
  noResult,
  noResultTitle,
  noResultDescription,
  container,
  description,
  unitLessonSelect,
  topBar,
  createButton,
  table: table$2,
  tableHeader: tableHeader$2,
  categoryColumn: categoryColumn$1,
  sourceColumn: sourceColumn$1,
  locationColumn: locationColumn$2,
  titleColumn: titleColumn$1,
  questionColumn: questionColumn$2,
  actionColumn: actionColumn$1,
  paginationWrapper,
  bottomPagination
};
const tableRow$1 = "_tableRow_168x3_1";
const categoryColumn = "_categoryColumn_168x3_12";
const sourceColumn = "_sourceColumn_168x3_19";
const sourceImage = "_sourceImage_168x3_23";
const locationColumn$1 = "_locationColumn_168x3_27";
const titleColumn = "_titleColumn_168x3_34";
const questionColumn$1 = "_questionColumn_168x3_45";
const actionColumn = "_actionColumn_168x3_53";
const active = "_active_168x3_65";
const assignButton = "_assignButton_168x3_68";
const green = "_green_168x3_71";
const moreMenu = "_moreMenu_168x3_75";
const assignmentTooltip = "_assignmentTooltip_168x3_111";
const header = "_header_168x3_111";
var styles$3 = {
  tableRow: tableRow$1,
  categoryColumn,
  sourceColumn,
  sourceImage,
  locationColumn: locationColumn$1,
  titleColumn,
  questionColumn: questionColumn$1,
  actionColumn,
  active,
  assignButton,
  green,
  moreMenu,
  assignmentTooltip,
  header
};
const CopyButton = ({
  assessment,
  CopyModal,
  iconClass,
  programId,
  routes,
  label = "Make a Copy",
  showLabel = false,
  withTooltip = true
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => setIsOpen(false);
  const statusPath = routes.assessmentPath(":assessment_id");
  const copyPath = routes.copyAssessmentPath({
    assessment_id: assessment.id,
    lesson_id: assessment.lesson_id,
    program_id: programId
  });
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(Tooltip, {
      content: label,
      shouldDisplay: withTooltip,
      children: /* @__PURE__ */ jsxs("button", {
        onClick: () => setIsOpen(true),
        className: styles$3.active,
        "aria-label": label,
        "aria-haspopup": "dialog",
        "aria-controls": "copyButton",
        children: [/* @__PURE__ */ jsx("i", {
          className: `fa ${iconClass}`
        }), showLabel && label]
      })
    }), /* @__PURE__ */ jsx(CopyModal, {
      ajaxPath: copyPath,
      closeModal,
      modalIsOpen: isOpen,
      statusPath,
      testName: assessment.name
    })]
  });
};
const EditButton = ({
  assessment,
  CopyModal,
  programId,
  routes
}) => {
  useState(false);
  routes.assessmentPath(":assessment_id");
  routes.copyAssessmentPath({
    assessment_id: assessment.id,
    lesson_id: assessment.lesson_id,
    program_id: programId
  });
  if (sourceIsMyTests(assessment.source))
    return /* @__PURE__ */ jsx(Tooltip, {
      content: "Edit",
      shouldDisplay: true,
      children: /* @__PURE__ */ jsx("a", {
        href: routes.editAssessmentPath(assessment.id, {
          program_id: programId
        }),
        className: styles$3.active,
        children: /* @__PURE__ */ jsx("i", {
          className: "fa fa-pencil-square-o"
        })
      })
    });
  return /* @__PURE__ */ jsx(CopyButton, {
    assessment,
    CopyModal,
    iconClass: "fa-clone",
    programId,
    routes
  });
};
const PrintAssessmentOption = ({
  assessment,
  iconClass,
  PrintModal,
  programId,
  text,
  url
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsxs("button", {
      onClick: () => setModalIsOpen(true),
      children: [/* @__PURE__ */ jsx("i", {
        className: `fa ${iconClass}`
      }), text]
    }), /* @__PURE__ */ jsx(PrintModal, {
      closeModal: () => setModalIsOpen(false),
      headerText: text,
      modalIsOpen,
      url
    })]
  });
};
var GoogleDriveIcon = "data:image/svg+xml;base64,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";
const SaveToGoogleDriveOption = ({
  answerKey,
  assessment,
  SaveToGoogleDrive,
  url
}) => {
  const linkText = `<img src="${GoogleDriveIcon}" /> Save ${answerKey ? "answer key" : "assessment"} to drive`;
  return /* @__PURE__ */ jsx(SaveToGoogleDrive, {
    fileUrl: url,
    button: false,
    fileName: assessment.name,
    linkText,
    assessmentLibrary: true
  });
};
const MAX_ASSESSMENT_NAME_LENGTH = 24;
const AssessmentRow = ({
  assessment,
  CopyModal,
  currentLessonOrUnitPayload,
  ShareLink,
  DeleteAssessmentButton,
  onAssignClick,
  programId,
  PrintModal,
  routes,
  SaveToGoogleDrive,
  UnShareButton
}) => {
  var _a, _b, _c;
  const [showMoreMenu, setShowMoreMenu] = useState(false);
  const [isCopyModalOpen, setIsCopyModalOpen] = useState(false);
  const moreMenu2 = useRef(null);
  const hasAssignment = assessment.assigned_by_staffer;
  const handleMoreClick = () => {
    setShowMoreMenu(!showMoreMenu);
  };
  const handleAssignClick = () => {
    if (hasAssignment)
      return;
    let assessments;
    if (!sourceIsMyTests(assessment.source)) {
      const {
        id: id2,
        name,
        lesson_id
      } = assessment;
      assessments = [{
        id: id2,
        name,
        lessonId: lesson_id
      }];
    }
    onAssignClick(assessment.lesson_id, assessment.assignment_modal_initial_value, assessments);
  };
  const handleBlur2 = (event) => {
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setShowMoreMenu(false);
    }
  };
  const assignmentTooltipContent = () => {
    if (!hasAssignment)
      return "Create Assignment";
    const assignmentsLink = routes.assignmentsPath(programId, {
      lesson_id: assessment.lesson_id
    });
    return /* @__PURE__ */ jsxs("div", {
      className: styles$3.assignmentTooltip,
      id: "assignPopup",
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": "Create Assignment",
      children: [/* @__PURE__ */ jsx("div", {
        className: styles$3.header,
        children: "Create Assignment"
      }), /* @__PURE__ */ jsx("hr", {}), /* @__PURE__ */ jsxs("div", {
        children: ["An assignment has been made for this test.", " ", /* @__PURE__ */ jsx("a", {
          href: assignmentsLink,
          children: "View Details"
        })]
      })]
    });
  };
  useEffect(() => {
    var _a2;
    if (showMoreMenu) {
      (_a2 = moreMenu2.current) == null ? void 0 : _a2.focus();
    }
  }, [showMoreMenu]);
  const previewLink = routes.previewAssessmentPath(assessment.id, {
    program_id: programId,
    lesson_id: assessment.lesson_id
  });
  const assignmentIconClasses = hasAssignment ? `fa fa-calendar-check-o ${styles$3.green}` : "fa fa-calendar";
  return /* @__PURE__ */ jsxs("div", {
    className: styles$3.tableRow,
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles$3.titleColumn,
      children: [/* @__PURE__ */ jsx(Tooltip, {
        content: assessment.name,
        shouldDisplay: assessment.name.length > MAX_ASSESSMENT_NAME_LENGTH,
        children: /* @__PURE__ */ jsx("a", {
          href: sourceIsMyTests(assessment.source) ? routes.editAssessmentPath(assessment.id, {
            program_id: programId
          }) : "#",
          onClick: () => !sourceIsMyTests(assessment.source) && setIsCopyModalOpen(true),
          children: truncate(assessment.name, MAX_ASSESSMENT_NAME_LENGTH)
        })
      }), /* @__PURE__ */ jsx(CopyModal, {
        ajaxPath: routes.copyAssessmentPath({
          assessment_id: assessment.id,
          lesson_id: assessment.lesson_id,
          program_id: programId
        }),
        closeModal: () => setIsCopyModalOpen(false),
        modalIsOpen: isCopyModalOpen,
        statusPath: routes.assessmentPath(":assessment_id"),
        testName: assessment.name
      })]
    }), /* @__PURE__ */ jsx("div", {
      className: styles$3.locationColumn,
      children: /* @__PURE__ */ jsx(Tooltip, {
        content: assessment.unit_lesson_title,
        shouldDisplay: true,
        children: /* @__PURE__ */ jsx("span", {
          children: assessment.location
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: styles$3.categoryColumn,
      children: assessment.category
    }), /* @__PURE__ */ jsx("div", {
      className: styles$3.sourceColumn,
      children: /* @__PURE__ */ jsx(Tooltip, {
        content: (_a = assessment.source) != null ? _a : "",
        shouldDisplay: !!assessment.source,
        children: /* @__PURE__ */ jsx("div", {
          className: `w-fit ${styles$3.sourceImage}`,
          children: /* @__PURE__ */ jsx(SourceIcon, {
            source: assessment.source,
            firstName: (_b = userInfo.staffer) == null ? void 0 : _b.first_name,
            lastName: (_c = userInfo.staffer) == null ? void 0 : _c.last_name
          })
        })
      })
    }), /* @__PURE__ */ jsx("div", {
      className: styles$3.questionColumn,
      children: assessment.question_count
    }), /* @__PURE__ */ jsxs("div", {
      className: styles$3.actionColumn,
      children: [/* @__PURE__ */ jsx(EditButton, {
        assessment,
        CopyModal,
        programId,
        routes
      }), /* @__PURE__ */ jsx(Tooltip, {
        content: "Preview",
        shouldDisplay: true,
        children: /* @__PURE__ */ jsx("a", {
          href: previewLink,
          className: styles$3.active,
          children: /* @__PURE__ */ jsx("i", {
            className: "fa fa-eye"
          })
        })
      }), /* @__PURE__ */ jsx(Tooltip, {
        content: assignmentTooltipContent(),
        interactive: hasAssignment,
        shouldDisplay: true,
        children: /* @__PURE__ */ jsx("button", {
          className: styles$3.assignButton,
          onClick: handleAssignClick,
          "aria-haspopup": "dialog",
          "aria-controls": "assignPopup",
          children: /* @__PURE__ */ jsx("i", {
            className: assignmentIconClasses
          })
        })
      }), /* @__PURE__ */ jsx(Tooltip, {
        content: "More",
        shouldDisplay: true,
        children: /* @__PURE__ */ jsx("button", {
          onMouseDown: handleMoreClick,
          "aria-expanded": showMoreMenu ? "true" : "false",
          "aria-controls": "moreMenu",
          children: /* @__PURE__ */ jsx("i", {
            className: "fa fa-ellipsis-h"
          })
        })
      })]
    }), /* @__PURE__ */ jsxs("div", {
      ref: moreMenu2,
      id: "moreMenu",
      className: showMoreMenu ? `card ${styles$3.moreMenu}` : "hide",
      tabIndex: 0,
      onBlur: handleBlur2,
      children: [/* @__PURE__ */ jsx(PrintAssessmentOption, {
        assessment,
        iconClass: "fa-print",
        PrintModal,
        programId,
        text: "Print Assessment",
        url: routes.printAssessmentPath(assessment.id, {
          program_id: programId
        })
      }, `${assessment.id}-print`), /* @__PURE__ */ jsx(PrintAssessmentOption, {
        assessment,
        iconClass: "fa-check-square-o",
        PrintModal,
        programId,
        text: "Print Answer Key",
        url: routes.printAssessmentPath(assessment.id, {
          program_id: programId,
          answer_key: true
        })
      }, `${assessment.id}-answer-key`), /* @__PURE__ */ jsx(SaveToGoogleDriveOption, {
        assessment,
        SaveToGoogleDrive,
        url: routes.printAssessmentPath(assessment.id, {
          program_id: programId
        })
      }, `${assessment.id}-save`), /* @__PURE__ */ jsx(SaveToGoogleDriveOption, {
        answerKey: true,
        assessment,
        SaveToGoogleDrive,
        url: routes.printAssessmentPath(assessment.id, {
          program_id: programId,
          answer_key: true
        })
      }, `${assessment.id}-save-answer-key`), sourceIsMyTests(assessment.source) && /* @__PURE__ */ jsx(CopyButton, {
        assessment,
        CopyModal,
        iconClass: "fa-clone",
        programId,
        routes,
        label: "Copy",
        withTooltip: false,
        showLabel: true
      }, `copy-button-${assessment.id}`), assessment.owned_by_current_staffer && /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx("div", {
          children: /* @__PURE__ */ jsxs("a", {
            href: routes.gradesPath(programId, {
              lesson_id: assessment.lesson_id
            }),
            children: [/* @__PURE__ */ jsx("i", {
              className: "fa fa-bar-chart"
            }), "Grades"]
          })
        }), assessment.has_been_shared && routes.unShareAssessmentPath ? /* @__PURE__ */ jsx(UnShareButton, {
          assessment,
          shared: assessment.has_been_shared,
          ajaxPath: routes.unShareAssessmentPath(assessment.id, {
            lesson_id: assessment.lesson_id,
            program_id: programId
          }),
          fallbackPath: routes.assessmentsLibraryPath(programId, currentLessonOrUnitPayload)
        }) : /* @__PURE__ */ jsx(ShareLink, {
          button: false,
          model: "Test",
          paramName: "assessment",
          linkText: "Share",
          shared: assessment.has_been_shared,
          sharedToDistrict: assessment.district_only,
          sharable: assessment.answerable_questions,
          ajaxPath: routes.shareAssessmentPath(assessment.id, {
            lesson_id: assessment.lesson_id,
            program_id: programId
          }),
          fallbackPath: routes.assessmentsLibraryPath(programId, currentLessonOrUnitPayload)
        }), /* @__PURE__ */ jsx(DeleteAssessmentButton, {
          disabled: assessment.answered_and_assigned,
          shared: assessment.has_been_shared,
          deleteAssessmentPath: routes.deleteAssessmentPath(assessment, {
            program_id: programId,
            lesson_id: assessment.lesson_id
          })
        })]
      })]
    })]
  });
};
const AssessmentLibrary = ({
  AsyncAssignmentModal,
  CopyModal,
  PrintModal,
  ShareLink,
  DeleteAssessmentButton,
  CreateNewTestButton,
  UnitLessonSelect,
  programId,
  lessonId,
  unitId,
  routes,
  SaveToGoogleDrive,
  UnShareButton
}) => {
  var _a;
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [initialDataIsLoaded, setInitialDataIsLoaded] = useState(false);
  const [openedUnitValue, setOpenedUnitValue] = useState(-1);
  const [filters, setFilters] = useState(initialFilters);
  const [assessments, setAssessments] = useState([]);
  const [assignmentModalSettings, setAssignmentModalSettings] = useState({
    show: false,
    lessonId: 0,
    assessments: void 0,
    initialValues: {
      modelType: "assessment",
      modelsToAssign: ""
    }
  });
  const [currentLesson, setCurrentLesson] = useState(void 0);
  const [currentUnit, setCurrentUnit] = useState(void 0);
  const [currentDropdownLesson, setCurrentDropdownLesson] = useState(void 0);
  const currentLessonOrUnitPayload = currentLesson ? {
    lesson_id: currentLesson.value
  } : currentUnit ? {
    unit_id: currentUnit.value
  } : {};
  const findInitialCurrentLesson = (fetchedFilters) => {
    var _a2;
    if (!lessonId)
      return;
    let lesson;
    (fetchedFilters.unit || []).find((unit) => {
      lesson || (lesson = unit.lessons.find((l) => l.value === lessonId));
    });
    lesson || (lesson = (_a2 = fetchedFilters.lesson) == null ? void 0 : _a2.find((l) => l.value === lessonId));
    return lesson;
  };
  const findInitialCurrentUnit = (fetchedFilters) => {
    if (!unitId)
      return;
    return (fetchedFilters.unit || []).find((unit) => {
      if (unit.value === unitId) {
        unit.lessons.forEach((l) => l.checked = true);
        return true;
      }
    });
  };
  useEffect(() => {
    getFilters(programId, lessonId).then((res) => {
      if (new URLSearchParams(window.location.search).get("unit_id")) {
        setCurrentUnit(findInitialCurrentUnit(res));
      } else {
        const lesson = findInitialCurrentLesson(res);
        setCurrentLesson(lesson);
        setCurrentDropdownLesson(lesson);
      }
      setFilters({
        ...res
      });
      setInitialDataIsLoaded(true);
    });
  }, [programId]);
  useEffect(() => {
    fetchFilteredAssessments();
  }, [filters, programId]);
  const fetchFilteredAssessments = () => {
    setLoading(true);
    getFilteredAssessments(filters, programId).then(({
      data,
      count
    }) => {
      setTotalCount(count);
      setAssessments(data);
      setLoading(false);
    });
  };
  const handleFilterChange = ({
    newFilters,
    keepTotal,
    unitValFromFilterBar
  }) => {
    if (!keepTotal)
      setTotalCount(0);
    setOpenedUnitValue(unitValFromFilterBar || -1);
    if (unitValFromFilterBar) {
      setCurrentUnit(void 0);
      setCurrentLesson(void 0);
    }
    setFilters(newFilters);
  };
  const handlePageChange = (curPage) => {
    handleFilterChange({
      newFilters: {
        ...filters,
        page: curPage
      },
      keepTotal: true
    });
  };
  const paginationResult = totalCount <= filters.per_page ? `${totalCount} result${totalCount == 1 ? "" : "s"}` : `${filters.per_page * (filters.page - 1) + 1} - ${Math.min(filters.per_page * filters.page, totalCount)} of ${totalCount} results`;
  const closeAssignmentModal = () => {
    setAssignmentModalSettings({
      show: false,
      lessonId: 0,
      assessments: void 0,
      initialValues: {
        modelType: "assessment",
        modelsToAssign: ""
      }
    });
  };
  const handleAssignClick = (lessonId2, initialValues, assessments2) => {
    setAssignmentModalSettings({
      show: true,
      lessonId: lessonId2,
      initialValues,
      assessments: assessments2
    });
  };
  return /* @__PURE__ */ jsxs("div", {
    className: styles$4.content,
    children: [/* @__PURE__ */ jsx("div", {
      className: styles$4.description,
      children: "See all the assessments in this program. You can create your own!"
    }), /* @__PURE__ */ jsx("div", {
      className: styles$4.unitLessonSelect,
      children: initialDataIsLoaded && /* @__PURE__ */ jsx(UnitLessonSelect, {
        resourceUrl: routes.assessmentsLibraryPath(programId, {
          lesson_id: "select_id"
        }),
        parentResourceUrl: routes.assessmentsLibraryPath(programId, {
          unit_id: "select_id"
        }),
        programId,
        initialOption: currentLesson ? {
          label: currentLesson.label,
          value: currentLesson.value
        } : currentUnit ? {
          label: currentUnit.label,
          value: currentUnit.value
        } : {
          label: "Select one",
          value: void 0
        }
      })
    }), /* @__PURE__ */ jsx(AsyncAssignmentModal, {
      closeModal: closeAssignmentModal,
      CopyModal,
      assessments: assignmentModalSettings.assessments,
      handlePostSave: fetchFilteredAssessments,
      modalIsOpen: assignmentModalSettings.show,
      stafferId: (_a = userInfo == null ? void 0 : userInfo.staffer) == null ? void 0 : _a.id,
      initialLessonId: assignmentModalSettings.lessonId,
      initialValues: assignmentModalSettings.initialValues,
      program: {
        id: programId
      }
    }), /* @__PURE__ */ jsxs("div", {
      className: styles$4.container,
      children: [/* @__PURE__ */ jsx(FilterBar, {
        filters,
        onFilterChange: handleFilterChange,
        openedUnitValue
      }), /* @__PURE__ */ jsxs("div", {
        className: styles$4.paginationWrapper,
        children: [/* @__PURE__ */ jsxs("div", {
          className: styles$4.topBar,
          children: [/* @__PURE__ */ jsx(Tooltip, {
            content: "Creating a test for a unit is not available yet.",
            shouldDisplay: !currentDropdownLesson,
            children: /* @__PURE__ */ jsx("div", {
              children: /* @__PURE__ */ jsx(CreateNewTestButton, {
                lessonTitle: currentDropdownLesson == null ? void 0 : currentDropdownLesson.title,
                ajaxPath: routes.stafferAssessmentsPath({
                  program_id: programId,
                  lesson_id: (currentDropdownLesson == null ? void 0 : currentDropdownLesson.value) || 0
                }),
                disabled: !currentDropdownLesson
              })
            })
          }), !isLoading && /* @__PURE__ */ jsx("div", {
            children: paginationResult
          })]
        }), !isLoading && assessments.length > 0 ? /* @__PURE__ */ jsxs("div", {
          className: styles$4.table,
          children: [/* @__PURE__ */ jsxs("div", {
            className: styles$4.tableHeader,
            children: [/* @__PURE__ */ jsx("div", {
              className: styles$4.titleColumn,
              children: "assessment title"
            }), /* @__PURE__ */ jsx("div", {
              className: styles$4.locationColumn,
              children: "location"
            }), /* @__PURE__ */ jsx("div", {
              className: styles$4.categoryColumn,
              children: "category"
            }), /* @__PURE__ */ jsx("div", {
              className: styles$4.sourceColumn,
              children: "source"
            }), /* @__PURE__ */ jsx("div", {
              className: styles$4.questionColumn,
              children: "# of questions"
            }), /* @__PURE__ */ jsx("div", {
              className: styles$4.actionColumn
            })]
          }), assessments.map((assessment) => /* @__PURE__ */ jsx(AssessmentRow, {
            assessment,
            CopyModal,
            currentLessonOrUnitPayload,
            ShareLink,
            DeleteAssessmentButton,
            onAssignClick: handleAssignClick,
            PrintModal,
            programId,
            routes,
            SaveToGoogleDrive,
            UnShareButton
          }, assessment.id))]
        }) : isLoading ? /* @__PURE__ */ jsx("div", {
          className: styles$4.loading,
          children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
            icon: faSpinner,
            spin: true
          })
        }) : /* @__PURE__ */ jsxs("div", {
          className: styles$4.noResult,
          children: [/* @__PURE__ */ jsx("div", {
            className: styles$4.noResultTitle,
            children: "No Assessments Found"
          }), /* @__PURE__ */ jsx("div", {
            className: styles$4.noResultDescription,
            children: "Please modify your filters to explore different results."
          })]
        }), /* @__PURE__ */ jsx("div", {
          className: styles$4.bottomPagination,
          children: /* @__PURE__ */ jsx(Pagination, {
            currentPage: filters.page,
            totalCount,
            pageSize: filters.per_page,
            onPageChange: handlePageChange
          })
        })]
      })]
    })]
  });
};
const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const isJsons = (array2) => Array.isArray(array2) && array2.every((row) => typeof row === "object" && !(row instanceof Array));
const isArrays = (array2) => Array.isArray(array2) && array2.every((row) => Array.isArray(row));
const jsonsHeaders = (array2) => Array.from(array2.map((json) => Object.keys(json)).reduce((a, b) => /* @__PURE__ */ new Set([...a, ...b]), []));
const jsons2arrays = (jsons, headers) => {
  headers = headers || jsonsHeaders(jsons);
  let headerLabels = headers;
  let headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map((header2) => header2.label);
    headerKeys = headers.map((header2) => header2.key);
  }
  const data = jsons.map((object) => headerKeys.map((header2) => getHeaderValue(header2, object)));
  return [headerLabels, ...data];
};
const getHeaderValue = (property, obj) => {
  const foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function(o, p2, i, arr) {
    const value = o[p2];
    if (value === void 0 || value === null) {
      arr.splice(1);
    } else {
      return value;
    }
  }, obj);
  return foundValue === void 0 ? property in obj ? obj[property] : "" : foundValue;
};
const elementOrEmpty = (element) => typeof element === "undefined" || element === null ? "" : element;
const joiner = (data, separator = ",", enclosingCharacter = '"') => {
  return data.filter((e) => e).map((row) => row.map((element) => elementOrEmpty(element)).map((column) => `${enclosingCharacter}${column}${enclosingCharacter}`).join(separator)).join(`
`);
};
const arrays2csv = (data, headers, separator, enclosingCharacter) => joiner(headers ? [headers, ...data] : data, separator, enclosingCharacter);
const jsons2csv = (data, headers, separator, enclosingCharacter) => joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
const string2csv = (data, headers, separator, enclosingCharacter) => headers ? `${headers.join(separator)}
${data}` : data.replace(/"/g, '""');
const toCSV = (data, headers, separator, enclosingCharacter) => {
  if (isJsons(data))
    return jsons2csv(data, headers, separator, enclosingCharacter);
  if (isArrays(data))
    return arrays2csv(data, headers, separator, enclosingCharacter);
  if (typeof data === "string")
    return string2csv(data, headers, separator);
  throw new TypeError(`Data should be a "String", "Array of arrays" OR "Array of objects" `);
};
const buildURI = (data, uFEFF, headers, separator, enclosingCharacter) => {
  const csv = toCSV(data, headers, separator, enclosingCharacter);
  const type2 = isSafari() ? "application/csv" : "text/csv";
  const blob = new Blob([uFEFF ? "\uFEFF" : "", csv], { type: type2 });
  const dataURI = `data:${type2};charset=utf-8,${uFEFF ? "\uFEFF" : ""}${csv}`;
  const URL2 = window.URL || window.webkitURL;
  return typeof URL2.createObjectURL === "undefined" ? dataURI : URL2.createObjectURL(blob);
};
const propTypes = {
  data: oneOfType([string, array, func]).isRequired,
  headers: array,
  target: string,
  separator: string,
  filename: string,
  uFEFF: bool,
  onClick: func,
  asyncOnClick: bool,
  enclosingCharacter: string
};
const defaultProps$1 = {
  separator: ",",
  filename: "generatedBy_react-csv.csv",
  uFEFF: true,
  asyncOnClick: false,
  enclosingCharacter: '"'
};
const defaultProps = {
  target: "_blank"
};
class CSVDownload extends require$$0$1.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  buildURI() {
    return buildURI(...arguments);
  }
  componentDidMount() {
    const { data, headers, separator, enclosingCharacter, uFEFF, target, specs, replace: replace3 } = this.props;
    this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace3);
  }
  getWindow() {
    return this.state.page;
  }
  render() {
    return null;
  }
}
__publicField(CSVDownload, "defaultProps", Object.assign(defaultProps$1, defaultProps));
__publicField(CSVDownload, "propTypes", propTypes);
class CSVLink$1 extends require$$0$1.Component {
  constructor(props) {
    super(props);
    this.buildURI = this.buildURI.bind(this);
  }
  buildURI() {
    return buildURI(...arguments);
  }
  handleLegacy(event, isAsync = false) {
    if (window.navigator.msSaveOrOpenBlob) {
      event.preventDefault();
      const {
        data,
        headers,
        separator,
        filename,
        enclosingCharacter,
        uFEFF
      } = this.props;
      const csvData = isAsync && typeof data === "function" ? data() : data;
      let blob = new Blob([uFEFF ? "\uFEFF" : "", toCSV(csvData, headers, separator, enclosingCharacter)]);
      window.navigator.msSaveBlob(blob, filename);
      return false;
    }
  }
  handleAsyncClick(event) {
    const done = (proceed) => {
      if (proceed === false) {
        event.preventDefault();
        return;
      }
      this.handleLegacy(event, true);
    };
    this.props.onClick(event, done);
  }
  handleSyncClick(event) {
    const stopEvent = this.props.onClick(event) === false;
    if (stopEvent) {
      event.preventDefault();
      return;
    }
    this.handleLegacy(event);
  }
  handleClick() {
    return (event) => {
      if (typeof this.props.onClick === "function") {
        return this.props.asyncOnClick ? this.handleAsyncClick(event) : this.handleSyncClick(event);
      }
      this.handleLegacy(event);
    };
  }
  render() {
    const {
      data,
      headers,
      separator,
      filename,
      uFEFF,
      children,
      onClick,
      asyncOnClick,
      enclosingCharacter,
      ...rest
    } = this.props;
    const isNodeEnvironment = typeof window === "undefined";
    const href = isNodeEnvironment ? "" : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
    return /* @__PURE__ */ jsx("a", {
      download: filename,
      ...rest,
      ref: (link) => this.link = link,
      target: "_self",
      href,
      onClick: this.handleClick(),
      children
    });
  }
}
__publicField(CSVLink$1, "defaultProps", defaultProps$1);
__publicField(CSVLink$1, "propTypes", propTypes);
const CSVLink = CSVLink$1;
const wrapper = "_wrapper_1167k_1";
const colorBox = "_colorBox_1167k_8";
var styles$2 = {
  wrapper,
  colorBox
};
const RangeLabel = ({
  from: from3,
  to,
  color
}) => {
  return /* @__PURE__ */ jsxs("div", {
    className: styles$2.wrapper,
    children: [/* @__PURE__ */ jsx("span", {
      className: styles$2.colorBox,
      style: {
        backgroundColor: color
      }
    }), `${from3}%-${to}%`]
  });
};
const loading$1 = "_loading_8sc4d_1";
const rangeWrapper = "_rangeWrapper_8sc4d_7";
const table$1 = "_table_8sc4d_14";
const tableWithoutStudents = "_tableWithoutStudents_8sc4d_19";
const tableHeader$1 = "_tableHeader_8sc4d_24";
const tableHeaderWithoutStudents = "_tableHeaderWithoutStudents_8sc4d_24";
const mainCell = "_mainCell_8sc4d_41";
const mainCellWithoutStudents = "_mainCellWithoutStudents_8sc4d_41";
const headerCell = "_headerCell_8sc4d_61";
const tagDescription$1 = "_tagDescription_8sc4d_72";
const scoreRow = "_scoreRow_8sc4d_77";
const mainColumn = "_mainColumn_8sc4d_86";
const scoreCell = "_scoreCell_8sc4d_101";
const noStudentsRow = "_noStudentsRow_8sc4d_110";
var styles$1 = {
  loading: loading$1,
  rangeWrapper,
  table: table$1,
  tableWithoutStudents,
  tableHeader: tableHeader$1,
  tableHeaderWithoutStudents,
  mainCell,
  mainCellWithoutStudents,
  headerCell,
  tagDescription: tagDescription$1,
  scoreRow,
  mainColumn,
  scoreCell,
  noStudentsRow
};
const DEFAULT_COLOR = "#EEEEEE";
const COLOR_RANGES = [{
  from: 80,
  to: 100,
  color: "#2A880680"
}, {
  from: 60,
  to: 79,
  color: "#F69C0580"
}, {
  from: 0,
  to: 59,
  color: "#D2232A80"
}];
const getColorByScore = (score2) => {
  var _a;
  if (score2 === null) {
    return DEFAULT_COLOR;
  }
  return (_a = COLOR_RANGES.find((range3) => score2 >= range3.from && score2 <= range3.to)) == null ? void 0 : _a.color;
};
const getData = (classId) => {
  return axios.get("/api/v2/tags/student_benchmarks", {
    params: {
      classroom_id: classId
    }
  }).then((res) => {
    const tags = Object.values(res.data.tags);
    const students = Object.values(res.data.students).map((student) => {
      const scores = tags.map((tag) => {
        let totalScore = 0;
        let totalPoint = 0;
        tag.questions.forEach((question) => {
          var _a, _b;
          const score2 = (_b = (_a = student.question_answers) == null ? void 0 : _a.find((answer) => answer.question_id === question.id)) == null ? void 0 : _b.score;
          if (score2 !== null && score2 !== void 0) {
            totalPoint += question.points;
            totalScore += Number(score2);
          }
        });
        return totalPoint ? Math.round(totalScore * 100 / totalPoint) : null;
      });
      return {
        id: student.id,
        name: `${student.first_name} ${student.last_name}`,
        scores
      };
    });
    tags.forEach((tag) => {
      if (tag.description_en.startsWith(tag.alias)) {
        tag.description_en = tag.description_en.slice(tag.alias.length + 1);
      }
      tag.questions = [];
    });
    return {
      tags,
      students
    };
  });
};
const getQuestionScores = (classId, studentId, tagId) => {
  return axios.get("/api/v2/tags/student_benchmarks_for_tag", {
    params: {
      classroom_id: classId,
      student_id: studentId,
      tag_id: tagId
    }
  }).then((res) => {
    return res.data.filter((qus) => {
      var _a;
      return (_a = qus == null ? void 0 : qus.question_answer) == null ? void 0 : _a.score;
    });
  });
};
const modalContent = "_modalContent_10ck6_1";
const titleBar = "_titleBar_10ck6_7";
const title = "_title_10ck6_7";
const closeIcon = "_closeIcon_10ck6_20";
const content = "_content_10ck6_30";
const tagWrapper = "_tagWrapper_10ck6_35";
const tagDescription = "_tagDescription_10ck6_42";
const result = "_result_10ck6_48";
const score = "_score_10ck6_55";
const loading = "_loading_10ck6_61";
const table = "_table_10ck6_67";
const tableHeader = "_tableHeader_10ck6_73";
const tableRow = "_tableRow_10ck6_79";
const questionColumn = "_questionColumn_10ck6_90";
const assessmentColumn = "_assessmentColumn_10ck6_94";
const locationColumn = "_locationColumn_10ck6_98";
const scoreColumn = "_scoreColumn_10ck6_102";
const bottomBar = "_bottomBar_10ck6_106";
var styles = {
  modalContent,
  titleBar,
  title,
  closeIcon,
  content,
  tagWrapper,
  tagDescription,
  result,
  score,
  loading,
  table,
  tableHeader,
  tableRow,
  questionColumn,
  assessmentColumn,
  locationColumn,
  scoreColumn,
  bottomBar
};
const PerformanceModal = ({
  isOpen,
  programId,
  classId,
  student,
  tag,
  score: score2,
  onClose
}) => {
  const [isLoading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const truncate2 = (text) => {
    return text.length <= 32 ? text : text.substring(0, 31) + "...";
  };
  useEffect(() => {
    if (!(student == null ? void 0 : student.id) || !(tag == null ? void 0 : tag.id)) {
      return;
    }
    setLoading(true);
    getQuestionScores(classId, student.id, tag.id).then((res) => {
      setQuestions(res);
      setLoading(false);
    });
  }, [classId, student == null ? void 0 : student.id, tag == null ? void 0 : tag.id]);
  return /* @__PURE__ */ jsx(ReactModal, {
    overlayClassName: "ReactModal__Overlay_Library",
    style: {
      content: {
        padding: 0
      }
    },
    isOpen,
    shouldCloseOnEsc: true,
    shouldFocusAfterRender: true,
    shouldReturnFocusAfterClose: true,
    onRequestClose: onClose,
    preventScroll: true,
    children: /* @__PURE__ */ jsxs("div", {
      className: styles.modalContent,
      children: [/* @__PURE__ */ jsxs("div", {
        className: styles.titleBar,
        children: [/* @__PURE__ */ jsxs("h1", {
          className: styles.title,
          children: ["Student Performance: ", student == null ? void 0 : student.name]
        }), /* @__PURE__ */ jsx("div", {
          className: styles.closeIcon,
          style: {
            backgroundImage: `url(${CloseIcon})`
          },
          onClick: onClose
        })]
      }), /* @__PURE__ */ jsxs("div", {
        className: styles.content,
        children: [/* @__PURE__ */ jsxs("div", {
          className: styles.tagWrapper,
          children: [/* @__PURE__ */ jsxs("div", {
            className: styles.tagDescription,
            children: [/* @__PURE__ */ jsxs("div", {
              className: "mb10",
              children: [/* @__PURE__ */ jsx("b", {
                children: tag == null ? void 0 : tag.alias
              }), " ", tag == null ? void 0 : tag.description_en]
            }), /* @__PURE__ */ jsxs("a", {
              href: `/shared/programs/${programId}/correlations/state#${tag == null ? void 0 : tag.alias}`,
              target: "_blank",
              rel: "noreferrer",
              children: ["See benchmarks review options \xA0", /* @__PURE__ */ jsx("img", {
                src: FullscreenIcon
              })]
            })]
          }), /* @__PURE__ */ jsxs("div", {
            className: styles.result,
            children: ["Result: \xA0", /* @__PURE__ */ jsxs("span", {
              className: styles.score,
              style: {
                background: getColorByScore(score2)
              },
              children: [score2, "%"]
            })]
          })]
        }), /* @__PURE__ */ jsxs("div", {
          className: styles.table,
          children: [/* @__PURE__ */ jsxs("div", {
            className: `${styles.tableHeader} ${styles.tableRow}`,
            children: [/* @__PURE__ */ jsx("div", {
              className: styles.questionColumn,
              children: "Question"
            }), /* @__PURE__ */ jsx("div", {
              className: styles.assessmentColumn,
              children: "Assessment"
            }), /* @__PURE__ */ jsx("div", {
              className: styles.locationColumn,
              children: "Location"
            }), /* @__PURE__ */ jsx("div", {
              className: styles.scoreColumn,
              children: "Score"
            })]
          }), isLoading ? /* @__PURE__ */ jsx("div", {
            className: styles.loading,
            children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
              icon: faSpinner,
              spin: true
            })
          }) : questions.map((question) => /* @__PURE__ */ jsxs("div", {
            className: styles.tableRow,
            children: [/* @__PURE__ */ jsx("div", {
              className: styles.questionColumn,
              children: truncate2(question.body)
            }), /* @__PURE__ */ jsx("div", {
              className: styles.assessmentColumn,
              children: /* @__PURE__ */ jsxs("a", {
                href: question.assessment.href,
                target: "_blank",
                rel: "noreferrer",
                children: [question.assessment.name, " \xA0", /* @__PURE__ */ jsx("img", {
                  src: FullscreenIcon
                })]
              })
            }), /* @__PURE__ */ jsx("div", {
              className: styles.locationColumn,
              children: question.location
            }), /* @__PURE__ */ jsxs("div", {
              className: styles.scoreColumn,
              children: [question.question_answer.score.split(".")[0], "/", question.points]
            })]
          }, question.id))]
        })]
      }), /* @__PURE__ */ jsx("div", {
        className: styles.bottomBar,
        children: /* @__PURE__ */ jsx("button", {
          className: "btn btn--purple btn--lg",
          autoFocus: true,
          onClick: onClose,
          children: "Close"
        })
      })]
    })
  });
};
const NO_STUDENTS_TEXT = {
  en: "You have a studentless classroom! Click Add Students to finish creating your class.",
  es: "\xA1Tienes un sal\xF3n de clases sin estudiantes! Haga clic en Agregar estudiantes para terminar de crear su clase."
};
const ADD_STUDENTS_TEXT = {
  en: "Add Students",
  es: "Agregar Estudiantes"
};
const Benchmark = ({
  addStudentsPath,
  classId,
  locale,
  programId
}) => {
  const [tags, setTags] = useState([]);
  const [students, setStudents] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [performanceSettings, setPerformanceSettings] = useState({
    isOpen: false,
    score: 0
  });
  const csvData = useMemo(() => {
    const headers = ["Student", ...tags.map((tag) => tag.alias)];
    const data = students.map((student) => [student.name, ...student.scores.map((score2) => score2 ? score2 : "-")]);
    return {
      headers,
      data
    };
  }, [tags, students]);
  const hasStudents = () => students && students.length > 0;
  useEffect(() => {
    setLoading(true);
    getData(classId).then((res) => {
      setTags(res.tags);
      setStudents(res.students);
      setLoading(false);
    });
  }, [classId]);
  const closePerformanceModal = () => {
    setPerformanceSettings({
      isOpen: false,
      student: void 0,
      tag: void 0,
      score: 0
    });
  };
  const openPerformanceModal = (student, tagIndex) => {
    if (student.scores[tagIndex] === null) {
      return;
    }
    setPerformanceSettings({
      isOpen: true,
      student,
      tag: tags[tagIndex],
      score: student.scores[tagIndex]
    });
  };
  return isLoading ? /* @__PURE__ */ jsx("div", {
    className: styles$1.loading,
    children: /* @__PURE__ */ jsx(FontAwesomeIcon, {
      icon: faSpinner,
      spin: true
    })
  }) : /* @__PURE__ */ jsxs("div", {
    children: [/* @__PURE__ */ jsxs("div", {
      className: styles$1.rangeWrapper,
      children: [COLOR_RANGES.map((colorRange) => /* @__PURE__ */ jsx(RangeLabel, {
        from: colorRange.from,
        to: colorRange.to,
        color: colorRange.color
      }, colorRange.color)), /* @__PURE__ */ jsx(CSVLink, {
        className: "btn btn--outline-purple btn--md ml8",
        filename: "benchmarks.csv",
        headers: csvData.headers,
        data: csvData.data,
        children: "Export to CSV"
      })]
    }), /* @__PURE__ */ jsxs("div", {
      className: `${hasStudents() ? styles$1.table : styles$1.tableWithoutStudents}`,
      children: [/* @__PURE__ */ jsxs("div", {
        className: hasStudents() ? styles$1.tableHeader : styles$1.tableHeaderWithoutStudents,
        children: [/* @__PURE__ */ jsx("div", {
          className: hasStudents() ? styles$1.mainCell : styles$1.mainCellWithoutStudents,
          children: "Students"
        }), tags.map((tag) => /* @__PURE__ */ jsx("div", {
          className: styles$1.headerCell,
          children: /* @__PURE__ */ jsx(Tooltip, {
            content: /* @__PURE__ */ jsxs("div", {
              className: styles$1.tagDescription,
              children: [/* @__PURE__ */ jsx("b", {
                children: tag.alias
              }), " ", tag.description_en]
            }),
            shouldDisplay: true,
            placement: "top",
            boundary: "window",
            maxWidth: 250,
            children: /* @__PURE__ */ jsx("div", {
              children: tag.alias
            })
          })
        }, tag.id))]
      }), !hasStudents() && /* @__PURE__ */ jsxs("div", {
        className: styles$1.noStudentsRow,
        children: [/* @__PURE__ */ jsx("span", {
          children: NO_STUDENTS_TEXT[locale]
        }), /* @__PURE__ */ jsx("a", {
          className: "btn btn--green",
          href: addStudentsPath,
          children: ADD_STUDENTS_TEXT[locale]
        })]
      }), hasStudents() && students.map((student) => /* @__PURE__ */ jsxs("div", {
        className: styles$1.scoreRow,
        children: [/* @__PURE__ */ jsx("div", {
          className: styles$1.mainColumn,
          children: student.name
        }), student.scores.map((score2, index) => /* @__PURE__ */ jsx("div", {
          className: styles$1.scoreCell,
          style: {
            background: getColorByScore(score2)
          },
          onClick: () => openPerformanceModal(student, index),
          children: score2 !== null ? `${score2}%` : "-"
        }, index))]
      }, student.id))]
    }), /* @__PURE__ */ jsx(PerformanceModal, {
      isOpen: performanceSettings.isOpen,
      programId,
      classId,
      score: performanceSettings.score,
      student: performanceSettings.student,
      tag: performanceSettings.tag,
      onClose: closePerformanceModal
    })]
  });
};
export { AssessmentLibrary, Benchmark, GameLibrary, VideoLibrary };
